/**
 * Atlas — the GENERATED regional pack (produced by tools/geo-locations v2).
 *
 * DO NOT EDIT BY HAND. Regenerate with:  pnpm geo-locations regional
 *
 * Coverage-sampled, difficulty-tiered locations for the World / Continent /
 * Country / US-State scopes. Each carries a `difficulty` and NO `blurb` (the
 * light reveal shows only the real place name, e.g. "Near Cody, Wyoming").
 *
 * Engine: TOWN-ANCHORED sampler + local GeoNames (fully free, self-contained).
 * For each scope we walk a curated ANCHOR list of distinct real towns (GeoNames
 * cities5000/1000/500 — admin seats always in, suburbs of big metros dropped),
 * probe the FREE Google Street View metadata endpoint (source=outdoor) NEAR each
 * anchor, enrich locally with GeoNames (nearest populated place → name + admin1 +
 * population + distance), and auto-assign difficulty from those cheap signals.
 * HARD SPREAD CAPS (per-admin1 + per-metro, per tier; ≤3/town; ≥1 km spacing)
 * keep any one province/state or metro from dominating — anchoring on TOWNS, not
 * random area darts, is what makes every scope span its sub-regions instead of
 * piling into the densest metro. We ship only FACTS (coordinates, panoIds, names)
 * — never cached panorama imagery. Place facts © GeoNames (CC-BY 4.0); see
 * DATA-LICENSES.md.
 *
 * Stats: 9621 locations — 4420 classic, 4477 explorer, 724 adventurer.
 */
import type { GeoLocation, LocationPack } from './schema';

// The corpus is emitted as annotated GeoLocation[] chunks (see emitRegional.ts):
// one ~10k-element array literal makes TypeScript infer a union of every element
// shape and bail with TS2590, so we split it. Order is preserved exactly.
const CHUNK_0: GeoLocation[] = [
  {
    id: "us-al-000",
    lat: 34.730399,
    lng: -86.585992,
    panoId: "xcpWpeK6_ObLvK7k0HuUWQ",
    place: "Near Huntsville, Alabama",
    shortName: "Huntsville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AL",
    state: "Alabama",
    difficulty: "classic",
    pools: ["world","North America","US","US-AL"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-al-001",
    lat: 33.405371,
    lng: -86.811487,
    panoId: "glMzx_2uAfVCzHaOFdUTAQ",
    place: "Near Hoover, Alabama",
    shortName: "Hoover",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AL",
    state: "Alabama",
    difficulty: "classic",
    pools: ["world","North America","US","US-AL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-al-002",
    lat: 32.366777,
    lng: -86.30003,
    panoId: "LebGdeFpEC-Ppri2mwt5Pw",
    place: "Near Montgomery, Alabama",
    shortName: "Montgomery",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AL",
    state: "Alabama",
    difficulty: "classic",
    pools: ["world","North America","US","US-AL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-al-003",
    lat: 33.209819,
    lng: -87.569206,
    panoId: "ugdwQ9TIpo7VyHVyiR6SMA",
    place: "Near Tuscaloosa, Alabama",
    shortName: "Tuscaloosa",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AL",
    state: "Alabama",
    difficulty: "classic",
    pools: ["world","North America","US","US-AL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-al-004",
    lat: 30.694344,
    lng: -88.043042,
    panoId: "CkeeuGSOBoNmgV0mHV7ntA",
    place: "Near Mobile, Alabama",
    shortName: "Mobile",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AL",
    state: "Alabama",
    difficulty: "classic",
    pools: ["world","North America","US","US-AL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-al-005",
    lat: 32.609498,
    lng: -85.481135,
    panoId: "nnl8JFQ3SwVdQwLqiMFgSQ",
    place: "Near Auburn, Alabama",
    shortName: "Auburn",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AL",
    state: "Alabama",
    difficulty: "classic",
    pools: ["world","North America","US","US-AL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-al-006",
    lat: 31.223189,
    lng: -85.390319,
    panoId: "4lVpdLuRitl5aXvVjEHiMA",
    place: "Near Dothan, Alabama",
    shortName: "Dothan",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AL",
    state: "Alabama",
    difficulty: "classic",
    pools: ["world","North America","US","US-AL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-al-007",
    lat: 34.699286,
    lng: -86.748397,
    panoId: "2cge7UlGtuHHMdwjAfdONw",
    place: "Near Madison, Alabama",
    shortName: "Madison",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AL",
    state: "Alabama",
    difficulty: "classic",
    pools: ["world","North America","US","US-AL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-al-008",
    lat: 34.799775,
    lng: -87.677308,
    panoId: "wW2O3abNa4fMXKbFDJIpSw",
    place: "Near Florence, Alabama",
    shortName: "Florence",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AL",
    state: "Alabama",
    difficulty: "classic",
    pools: ["world","North America","US","US-AL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-al-009",
    lat: 34.605767,
    lng: -86.983481,
    panoId: "kyVAS4chK3qh6wjPUqy0Xw",
    place: "Near Decatur, Alabama",
    shortName: "Decatur",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AL",
    state: "Alabama",
    difficulty: "classic",
    pools: ["world","North America","US","US-AL"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-al-010",
    lat: 32.464264,
    lng: -86.45972,
    panoId: "msPW8UDNPZESCPLO2mlp_Q",
    place: "Near Prattville, Alabama",
    shortName: "Prattville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AL",
    state: "Alabama",
    difficulty: "classic",
    pools: ["world","North America","US","US-AL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-al-011",
    lat: 33.471555,
    lng: -86.800733,
    panoId: "SOVqCsPgA5po0jrnT5zS7Q",
    place: "Near Homewood, Alabama",
    shortName: "Homewood",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AL",
    state: "Alabama",
    difficulty: "classic",
    pools: ["world","North America","US","US-AL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-al-012",
    lat: 33.449103,
    lng: -86.787702,
    panoId: "VBkRz_AQq86hTmi4w4UZcw",
    place: "Near Vestavia Hills, Alabama",
    shortName: "Vestavia Hills",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AL",
    state: "Alabama",
    difficulty: "classic",
    pools: ["world","North America","US","US-AL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-al-013",
    lat: 34.0143,
    lng: -86.006404,
    panoId: "__kjHQbHjZ0xPF8L2HLWCQ",
    place: "Near Gadsden, Alabama",
    shortName: "Gadsden",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AL",
    state: "Alabama",
    difficulty: "classic",
    pools: ["world","North America","US","US-AL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-al-014",
    lat: 34.802419,
    lng: -86.972175,
    panoId: "oXHaIFtLXEepBocQyOAjYA",
    place: "Near Athens, Alabama",
    shortName: "Athens",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AL",
    state: "Alabama",
    difficulty: "classic",
    pools: ["world","North America","US","US-AL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-al-015",
    lat: 33.244212,
    lng: -86.816103,
    panoId: "oBv8Oj6M3zunnp_Q0B5uAg",
    place: "Near Alabaster, Alabama",
    shortName: "Alabaster",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AL",
    state: "Alabama",
    difficulty: "classic",
    pools: ["world","North America","US","US-AL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-al-016",
    lat: 33.285692,
    lng: -86.810035,
    panoId: "veZy5arg0VQqJsmI6p7WAg",
    place: "Near Pelham, Alabama",
    shortName: "Pelham",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AL",
    state: "Alabama",
    difficulty: "classic",
    pools: ["world","North America","US","US-AL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-al-017",
    lat: 30.739205,
    lng: -88.07887,
    panoId: "8WXR9UYt8n6zoIZwrXueAA",
    place: "Near Prichard, Alabama",
    shortName: "Prichard",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AL",
    state: "Alabama",
    difficulty: "classic",
    pools: ["world","North America","US","US-AL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-al-018",
    lat: 30.603617,
    lng: -87.903633,
    panoId: "VwFvHaCa4ZgKopIsEcu11w",
    place: "Near Daphne, Alabama",
    shortName: "Daphne",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AL",
    state: "Alabama",
    difficulty: "classic",
    pools: ["world","North America","US","US-AL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-al-019",
    lat: 32.645434,
    lng: -85.378267,
    panoId: "rcsBE6t1ebikVi7Tn5cP1g",
    place: "Near Opelika, Alabama",
    shortName: "Opelika",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AL",
    state: "Alabama",
    difficulty: "classic",
    pools: ["world","North America","US","US-AL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-al-020",
    lat: 33.614155,
    lng: -85.834952,
    panoId: "xGkJcSP4mWGczGCy0-ChvQ",
    place: "Near Oxford, Alabama",
    shortName: "Oxford",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AL",
    state: "Alabama",
    difficulty: "classic",
    pools: ["world","North America","US","US-AL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-al-021",
    lat: 34.809539,
    lng: -87.649482,
    panoId: "CP1bMfdVahZulEwJ7c3A2Q",
    place: "Near East Florence, Alabama",
    shortName: "East Florence",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AL",
    state: "Alabama",
    difficulty: "classic",
    pools: ["world","North America","US","US-AL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-al-022",
    lat: 33.659728,
    lng: -85.831615,
    panoId: "ND5Hu0krb9bQSdvN0NesXg",
    place: "Near Anniston, Alabama",
    shortName: "Anniston",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AL",
    state: "Alabama",
    difficulty: "classic",
    pools: ["world","North America","US","US-AL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-al-023",
    lat: 33.40173,
    lng: -86.954261,
    panoId: "PK9dkqMSkvslYrzIuAIRTQ",
    place: "Near Bessemer, Alabama",
    shortName: "Bessemer",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AL",
    state: "Alabama",
    difficulty: "classic",
    pools: ["world","North America","US","US-AL"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-al-024",
    lat: 33.500936,
    lng: -86.752187,
    panoId: "eSSvrZ7GwcYOQZBaWMwNag",
    place: "Near Mountain Brook, Alabama",
    shortName: "Mountain Brook",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AL",
    state: "Alabama",
    difficulty: "classic",
    pools: ["world","North America","US","US-AL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-al-025",
    lat: 32.407299,
    lng: -87.021079,
    panoId: "vh-ahKk6WPdK0zQTp2vR6w",
    place: "Near Selma, Alabama",
    shortName: "Selma",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AL",
    state: "Alabama",
    difficulty: "classic",
    pools: ["world","North America","US","US-AL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-al-026",
    lat: 31.3151,
    lng: -85.855132,
    panoId: "HOZwzdgoai4LIHK38z1E5A",
    place: "Near Enterprise, Alabama",
    shortName: "Enterprise",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AL",
    state: "Alabama",
    difficulty: "classic",
    pools: ["world","North America","US","US-AL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-al-027",
    lat: 33.619893,
    lng: -86.608556,
    panoId: "GNk5Fj-2x00tkPKw0vOgxQ",
    place: "Near Trussville, Alabama",
    shortName: "Trussville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AL",
    state: "Alabama",
    difficulty: "classic",
    pools: ["world","North America","US","US-AL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-al-028",
    lat: 34.267881,
    lng: -86.208789,
    panoId: "KuPzGL9778-1ceeAnPHbLA",
    place: "Near Albertville, Alabama",
    shortName: "Albertville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AL",
    state: "Alabama",
    difficulty: "classic",
    pools: ["world","North America","US","US-AL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-al-029",
    lat: 33.739963,
    lng: -86.648603,
    panoId: "msewo2nP1A6sYCiadl7Gew",
    place: "Near Dixiana, Alabama",
    shortName: "Dixiana",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AL",
    state: "Alabama",
    difficulty: "classic",
    pools: ["world","North America","US","US-AL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-al-030",
    lat: 31.808736,
    lng: -85.970083,
    panoId: "V7DQTE-Tt9oS-eG2xaLdiQ",
    place: "Near Troy, Alabama",
    shortName: "Troy",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AL",
    state: "Alabama",
    difficulty: "classic",
    pools: ["world","North America","US","US-AL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-al-031",
    lat: 32.471019,
    lng: -85.000805,
    panoId: "48OQy947KKimFl9gmjS2rA",
    place: "Near Phenix City, Alabama",
    shortName: "Phenix City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AL",
    state: "Alabama",
    difficulty: "classic",
    pools: ["world","North America","US","US-AL"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-al-032",
    lat: 33.296201,
    lng: -86.843596,
    panoId: "a9muIJ90CF6AUSsbgPfV-A",
    place: "Near Helena, Alabama",
    shortName: "Helena",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AL",
    state: "Alabama",
    difficulty: "classic",
    pools: ["world","North America","US","US-AL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-al-033",
    lat: 30.523028,
    lng: -87.903307,
    panoId: "CRu9D1-dUSat_Zsdh6XQEA",
    place: "Near Fairhope, Alabama",
    shortName: "Fairhope",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AL",
    state: "Alabama",
    difficulty: "classic",
    pools: ["world","North America","US","US-AL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-al-034",
    lat: 30.590223,
    lng: -88.170793,
    panoId: "rSGWVnSd8M8UQWbET7dk_A",
    place: "Near Tillmans Corner, Alabama",
    shortName: "Tillmans Corner",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AL",
    state: "Alabama",
    difficulty: "classic",
    pools: ["world","North America","US","US-AL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-al-035",
    lat: 33.520657,
    lng: -86.802592,
    panoId: "VDKZP80N25HalkvSRjxUjQ",
    place: "Near Birmingham, Alabama",
    shortName: "Birmingham",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AL",
    state: "Alabama",
    difficulty: "classic",
    pools: ["world","North America","US","US-AL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-al-036",
    lat: 33.228997,
    lng: -87.577502,
    panoId: "8rviv9mYIT8UbuJAhIeNkw",
    place: "Near Northport, Alabama",
    shortName: "Northport",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AL",
    state: "Alabama",
    difficulty: "classic",
    pools: ["world","North America","US","US-AL"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-al-037",
    lat: 33.451219,
    lng: -86.996548,
    panoId: "4JnMsselp_SNNFPMZfbyog",
    place: "Near Hueytown, Alabama",
    shortName: "Hueytown",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AL",
    state: "Alabama",
    difficulty: "classic",
    pools: ["world","North America","US","US-AL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-al-038",
    lat: 30.406418,
    lng: -87.683553,
    panoId: "L7u-aw0vGZjGoWppBM50EA",
    place: "Near Foley, Alabama",
    shortName: "Foley",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AL",
    state: "Alabama",
    difficulty: "classic",
    pools: ["world","North America","US","US-AL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-al-039",
    lat: 33.645729,
    lng: -86.683632,
    panoId: "qgih2EEF0tV6CsAphWCcrw",
    place: "Near Center Point, Alabama",
    shortName: "Center Point",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AL",
    state: "Alabama",
    difficulty: "classic",
    pools: ["world","North America","US","US-AL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-al-040",
    lat: 31.332126,
    lng: -85.841514,
    panoId: "5PKT-jyiiznG1KkmdJopZA",
    place: "Near Enterprise, Alabama",
    shortName: "Enterprise",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AL",
    state: "Alabama",
    difficulty: "classic",
    pools: ["world","North America","US","US-AL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-al-041",
    lat: 33.515083,
    lng: -86.73663,
    panoId: "ZWNEWNE3lw0yxoIB3raeow",
    place: "Near Mountain Brook, Alabama",
    shortName: "Mountain Brook",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AL",
    state: "Alabama",
    difficulty: "classic",
    pools: ["world","North America","US","US-AL"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-al-042",
    lat: 31.801851,
    lng: -85.949381,
    panoId: "fuQXf_ucA0pnHp86SN-Z7w",
    place: "Near Troy, Alabama",
    shortName: "Troy",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AL",
    state: "Alabama",
    difficulty: "classic",
    pools: ["world","North America","US","US-AL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-al-043",
    lat: 32.460935,
    lng: -84.979969,
    panoId: "P3oZVBvbMZnPgJEu7iT9iQ",
    place: "Near Columbus, Alabama",
    shortName: "Columbus",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AL",
    state: "Alabama",
    difficulty: "classic",
    pools: ["world","North America","US","US-AL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-al-044",
    lat: 33.286609,
    lng: -86.834016,
    panoId: "TVP2B5yi0vjttL0vOLD6Uw",
    place: "Near Helena, Alabama",
    shortName: "Helena",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AL",
    state: "Alabama",
    difficulty: "classic",
    pools: ["world","North America","US","US-AL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-al-045",
    lat: 32.61524,
    lng: -85.472871,
    panoId: "zQUDik9cEgslLiDrGci8ag",
    place: "Near Auburn, Alabama",
    shortName: "Auburn",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AL",
    state: "Alabama",
    difficulty: "classic",
    pools: ["world","North America","US","US-AL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-al-046",
    lat: 30.611637,
    lng: -88.173095,
    panoId: "nQ-jHT1GAEAYKCX2t74Iww",
    place: "Near Tillmans Corner, Alabama",
    shortName: "Tillmans Corner",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AL",
    state: "Alabama",
    difficulty: "classic",
    pools: ["world","North America","US","US-AL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-al-047",
    lat: 30.732309,
    lng: -88.095733,
    panoId: "2XEjV-Kk4Qy-Rd_I6VdvXQ",
    place: "Near Prichard, Alabama",
    shortName: "Prichard",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AL",
    state: "Alabama",
    difficulty: "classic",
    pools: ["world","North America","US","US-AL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-al-048",
    lat: 33.412695,
    lng: -86.824015,
    panoId: "S6F9pSpszt7nLqUX5q8-gQ",
    place: "Near Hoover, Alabama",
    shortName: "Hoover",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AL",
    state: "Alabama",
    difficulty: "classic",
    pools: ["world","North America","US","US-AL"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "us-al-049",
    lat: 33.46789,
    lng: -86.77662,
    panoId: "ypm898iu_jD2UY4AEvxrYw",
    place: "Near Homewood, Alabama",
    shortName: "Homewood",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AL",
    state: "Alabama",
    difficulty: "classic",
    pools: ["world","North America","US","US-AL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-al-050",
    lat: 34.71631,
    lng: -86.627411,
    panoId: "sKkMlt-gkKhy5-Ea4qjdaw",
    place: "Near Redstone Arsenal, Alabama",
    shortName: "Redstone Arsenal",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AL",
    state: "Alabama",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-al-051",
    lat: 33.23482,
    lng: -86.774143,
    panoId: "s2vMiWlR-HzFKlgaaP8sTw",
    place: "Near Alabaster, Alabama",
    shortName: "Alabaster",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AL",
    state: "Alabama",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-al-052",
    lat: 33.470815,
    lng: -86.839427,
    panoId: "NiDHJI6ZbfD_GCB5zbtFGQ",
    place: "Near Homewood, Alabama",
    shortName: "Homewood",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AL",
    state: "Alabama",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-al-053",
    lat: 34.214951,
    lng: -86.232264,
    panoId: "QngsDmpcsDYATti3LW08_w",
    place: "Near Horton, Alabama",
    shortName: "Horton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AL",
    state: "Alabama",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-al-054",
    lat: 33.965024,
    lng: -85.985154,
    panoId: "iH5AVmNaN6s7Dg-UffPlzg",
    place: "Near Glencoe, Alabama",
    shortName: "Glencoe",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AL",
    state: "Alabama",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-al-055",
    lat: 30.371972,
    lng: -87.668917,
    panoId: "1yvlSpe5wpHEse-GxjNM_A",
    place: "Near Foley, Alabama",
    shortName: "Foley",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AL",
    state: "Alabama",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-al-056",
    lat: 33.688105,
    lng: -86.744338,
    panoId: "_a5dS-Yl3meBoDF86gbHUg",
    place: "Near Pinson, Alabama",
    shortName: "Pinson",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AL",
    state: "Alabama",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-al-057",
    lat: 31.230754,
    lng: -85.31309,
    panoId: "41AjXPysMLkJX90boSd-yg",
    place: "Near Cowarts, Alabama",
    shortName: "Cowarts",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AL",
    state: "Alabama",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-al-058",
    lat: 32.333309,
    lng: -86.369497,
    panoId: "qeAfhzlGqp0u1mH04--u4A",
    place: "Near Montgomery, Alabama",
    shortName: "Montgomery",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AL",
    state: "Alabama",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-al-059",
    lat: 33.587902,
    lng: -85.850949,
    panoId: "OwrhatWF5zg1KYwlBYmevQ",
    place: "Near Oxford, Alabama",
    shortName: "Oxford",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AL",
    state: "Alabama",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-al-060",
    lat: 34.843821,
    lng: -87.651002,
    panoId: "01k6Z_UdfvVx4bhc8Ngy1A",
    place: "Near East Florence, Alabama",
    shortName: "East Florence",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AL",
    state: "Alabama",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-al-061",
    lat: 33.156039,
    lng: -87.552177,
    panoId: "FPqJKSFI49_RBCXARyeccQ",
    place: "Near Tuscaloosa, Alabama",
    shortName: "Tuscaloosa",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AL",
    state: "Alabama",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-al-062",
    lat: 34.726236,
    lng: -86.787562,
    panoId: "d0iCMSftgkH30ayVEu_hyA",
    place: "Near Madison, Alabama",
    shortName: "Madison",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AL",
    state: "Alabama",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-al-063",
    lat: 33.420957,
    lng: -86.184094,
    panoId: "xYODqXN6OXdToY6hkEtVCA",
    place: "Near Talladega, Alabama",
    shortName: "Talladega",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AL",
    state: "Alabama",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-al-064",
    lat: 32.472761,
    lng: -85.060359,
    panoId: "4rqmvC7Ab19qFf5BroWYYw",
    place: "Near Ladonia, Alabama",
    shortName: "Ladonia",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AL",
    state: "Alabama",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-al-065",
    lat: 34.85593,
    lng: -87.010367,
    panoId: "EobbIKSONF3q1EmZeEnBmA",
    place: "Near Washington Street Courthouse Annex, Alabama",
    shortName: "Washington Street Courthouse Annex",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AL",
    state: "Alabama",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-al-066",
    lat: 34.767613,
    lng: -86.553663,
    panoId: "hr6CdyYzRoHggZV2XrdTFw",
    place: "Near Huntsville, Alabama",
    shortName: "Huntsville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AL",
    state: "Alabama",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-al-067",
    lat: 33.474515,
    lng: -86.86034,
    panoId: "qhU4EGuO5igPqwDbrjqv_Q",
    place: "Near Midfield, Alabama",
    shortName: "Midfield",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AL",
    state: "Alabama",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-al-068",
    lat: 32.453396,
    lng: -87.004491,
    panoId: "6OPMOVATWkXbYlwQtesQ3Q",
    place: "Near Selma, Alabama",
    shortName: "Selma",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AL",
    state: "Alabama",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-al-069",
    lat: 34.548954,
    lng: -86.939091,
    panoId: "DZqrKiKmPxYcDXtupmiZjA",
    place: "Near Flint City, Alabama",
    shortName: "Flint City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AL",
    state: "Alabama",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-al-070",
    lat: 34.250856,
    lng: -86.294303,
    panoId: "uOTqDuz3NO1uuPqFMvbkdw",
    place: "Near Horton, Alabama",
    shortName: "Horton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AL",
    state: "Alabama",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-al-071",
    lat: 30.479805,
    lng: -87.891972,
    panoId: "fKZt0WtjSeEhGrCbCHxDTA",
    place: "Near Point Clear, Alabama",
    shortName: "Point Clear",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AL",
    state: "Alabama",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-al-072",
    lat: 31.762594,
    lng: -86.021147,
    panoId: "IkpuB8VlUFJcq7aXk4ScuA",
    place: "Near Troy, Alabama",
    shortName: "Troy",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AL",
    state: "Alabama",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-al-073",
    lat: 32.393665,
    lng: -86.364721,
    panoId: "RWb8bKi2ORFo_9anSSaDOA",
    place: "Near Montgomery, Alabama",
    shortName: "Montgomery",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AL",
    state: "Alabama",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-al-074",
    lat: 33.587405,
    lng: -86.658076,
    panoId: "S9hBpHz3BK9RFjoIuzNDQQ",
    place: "Near Trussville, Alabama",
    shortName: "Trussville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AL",
    state: "Alabama",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-al-075",
    lat: 30.598748,
    lng: -88.101632,
    panoId: "CI6nXhTtM9gfJhBBqI3lmA",
    place: "Near Tillmans Corner, Alabama",
    shortName: "Tillmans Corner",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AL",
    state: "Alabama",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-al-076",
    lat: 32.58382,
    lng: -85.45109,
    panoId: "07pwl2REr_0rAGnofsR9SA",
    place: "Near Auburn, Alabama",
    shortName: "Auburn",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AL",
    state: "Alabama",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-al-077",
    lat: 31.290958,
    lng: -85.77892,
    panoId: "Vrb0HL3P2_lPcxTmK6hXag",
    place: "Near Level Plains, Alabama",
    shortName: "Level Plains",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AL",
    state: "Alabama",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-al-078",
    lat: 32.689262,
    lng: -85.441122,
    panoId: "0iGwWY6lUNfbT3m460pacA",
    place: "Near Opelika, Alabama",
    shortName: "Opelika",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AL",
    state: "Alabama",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-al-079",
    lat: 30.338818,
    lng: -87.706503,
    panoId: "Z-8kXdgyAiyhsur35N9AiA",
    place: "Near Foley, Alabama",
    shortName: "Foley",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AL",
    state: "Alabama",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-al-080",
    lat: 33.354365,
    lng: -86.852998,
    panoId: "8YWtSWDYMWotBHjDEzCprA",
    place: "Near Helena, Alabama",
    shortName: "Helena",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AL",
    state: "Alabama",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-al-081",
    lat: 33.711044,
    lng: -86.725199,
    panoId: "kv0ahGA-fCz8A7VdppQxdw",
    place: "Near Pinson, Alabama",
    shortName: "Pinson",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AL",
    state: "Alabama",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-al-082",
    lat: 33.360986,
    lng: -86.944715,
    panoId: "oUg9DPtDWcTqx9nRwUBXWQ",
    place: "Near Bessemer, Alabama",
    shortName: "Bessemer",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AL",
    state: "Alabama",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-al-083",
    lat: 33.625097,
    lng: -85.798657,
    panoId: "9zwcePSabtjnMVi9XMD4PA",
    place: "Near Oxford, Alabama",
    shortName: "Oxford",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AL",
    state: "Alabama",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AL"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-al-084",
    lat: 33.254034,
    lng: -86.777345,
    panoId: "skhe2-wGA0M9lIMaDsiyog",
    place: "Near Alabaster, Alabama",
    shortName: "Alabaster",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AL",
    state: "Alabama",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-al-085",
    lat: 31.285644,
    lng: -85.415908,
    panoId: "xWqugXU9LfWPf9ngoEco5Q",
    place: "Near Kinsey, Alabama",
    shortName: "Kinsey",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AL",
    state: "Alabama",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-al-086",
    lat: 32.398629,
    lng: -86.411009,
    panoId: "xb0lw3ICltRX-NdSHv5tmA",
    place: "Near Prattville, Alabama",
    shortName: "Prattville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AL",
    state: "Alabama",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-al-087",
    lat: 33.611735,
    lng: -86.640959,
    panoId: "LvsGmVKqhDZ9-Q94m3Kn9A",
    place: "Near Trussville, Alabama",
    shortName: "Trussville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AL",
    state: "Alabama",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-al-088",
    lat: 34.84798,
    lng: -87.621237,
    panoId: "vNr6SDu-MKilf_Ta0EouwQ",
    place: "Near East Florence, Alabama",
    shortName: "East Florence",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AL",
    state: "Alabama",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-al-089",
    lat: 33.173165,
    lng: -87.578475,
    panoId: "EPk5DeVLupbePtHAyolLUA",
    place: "Near Tuscaloosa, Alabama",
    shortName: "Tuscaloosa",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AL",
    state: "Alabama",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-al-090",
    lat: 32.377245,
    lng: -86.231324,
    panoId: "f0DZbHpxMVlF_hho8LNPiw",
    place: "Near Montgomery, Alabama",
    shortName: "Montgomery",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AL",
    state: "Alabama",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-al-091",
    lat: 34.025297,
    lng: -86.710517,
    panoId: "h-egvbYuJaCtUmbJHCBG9A",
    place: "Near Hanceville, Alabama",
    shortName: "Hanceville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AL",
    state: "Alabama",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-al-092",
    lat: 33.521303,
    lng: -86.573716,
    panoId: "y01uEqssUSdVHJAL7PWzLw",
    place: "Near Leeds, Alabama",
    shortName: "Leeds",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AL",
    state: "Alabama",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-al-093",
    lat: 32.66497,
    lng: -85.496568,
    panoId: "4FOIdpzvHy669yepRg9qHA",
    place: "Near Auburn, Alabama",
    shortName: "Auburn",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AL",
    state: "Alabama",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-al-094",
    lat: 34.496717,
    lng: -85.69545,
    panoId: "asYs9CyrlaTi2uxxbV4F7g",
    place: "Near Fort Payne, Alabama",
    shortName: "Fort Payne",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AL",
    state: "Alabama",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-al-095",
    lat: 33.678612,
    lng: -86.484492,
    panoId: "5pu99qSc8XJmulvRLi3K_g",
    place: "Near Margaret, Alabama",
    shortName: "Margaret",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AL",
    state: "Alabama",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-al-096",
    lat: 33.309307,
    lng: -86.763024,
    panoId: "HlJTl-mcDRPOCyamOpKQTw",
    place: "Near Pelham, Alabama",
    shortName: "Pelham",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AL",
    state: "Alabama",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-al-097",
    lat: 34.811557,
    lng: -86.648486,
    panoId: "WA_gcDBoJD44ezimodcF0w",
    place: "Near Meridianville, Alabama",
    shortName: "Meridianville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AL",
    state: "Alabama",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-al-098",
    lat: 31.774769,
    lng: -85.154676,
    panoId: "qXLWRmxiqv5musLvRWzhPQ",
    place: "Near Eufaula, Alabama",
    shortName: "Eufaula",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AL",
    state: "Alabama",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-al-099",
    lat: 34.596487,
    lng: -87.057187,
    panoId: "3IwLAskxg2deBqeKDSq9dw",
    place: "Near Trinity, Alabama",
    shortName: "Trinity",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AL",
    state: "Alabama",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-al-100",
    lat: 31.584436,
    lng: -85.492262,
    panoId: "tMvyyqVBKqLADhIr5gBAqA",
    place: "Near Clio, Alabama",
    shortName: "Clio",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AL",
    state: "Alabama",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-AL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-al-101",
    lat: 32.790555,
    lng: -85.940679,
    panoId: "vrusIj34boysYqYuJ1ZezA",
    place: "Near Alexander City, Alabama",
    shortName: "Alexander City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AL",
    state: "Alabama",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-AL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-al-102",
    lat: 34.475338,
    lng: -86.757597,
    panoId: "EHp4Iz7uyhB6hAmUnTG5UA",
    place: "Near Priceville, Alabama",
    shortName: "Priceville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AL",
    state: "Alabama",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-AL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-al-103",
    lat: 30.361394,
    lng: -87.832972,
    panoId: "ZrGaYrOLq2SJQ-btsA4CKA",
    place: "Near Point Clear, Alabama",
    shortName: "Point Clear",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AL",
    state: "Alabama",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-AL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-al-104",
    lat: 32.37726,
    lng: -86.796345,
    panoId: "SjGK04LH7CQ1X9_5d_w6nQ",
    place: "Near Selmont-West Selmont, Alabama",
    shortName: "Selmont-West Selmont",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AL",
    state: "Alabama",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-AL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-al-105",
    lat: 31.560254,
    lng: -85.800859,
    panoId: "DxvzPyBhv-qMB7igQej2rQ",
    place: "Near Brundidge, Alabama",
    shortName: "Brundidge",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AL",
    state: "Alabama",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-AL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-al-106",
    lat: 32.797947,
    lng: -85.878376,
    panoId: "BoOBJNSwziHrbucjqTdXQA",
    place: "Near Dadeville, Alabama",
    shortName: "Dadeville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AL",
    state: "Alabama",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-AL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-al-107",
    lat: 32.046915,
    lng: -85.229356,
    panoId: "AT3qOIK-q8pL1sJ9gKF-Dg",
    place: "Near Eufaula, Alabama",
    shortName: "Eufaula",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AL",
    state: "Alabama",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-AL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ak-000",
    lat: 60.418199,
    lng: -151.287127,
    panoId: "1Z4ge1jrIL9WFXWVacc4gg",
    place: "Near Kalifornsky, Alaska",
    shortName: "Kalifornsky",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AK",
    state: "Alaska",
    difficulty: "classic",
    pools: ["world","North America","US","US-AK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ak-001",
    lat: 64.856927,
    lng: -147.802671,
    panoId: "x74fIbe8dsSG6pZTCHfN6w",
    place: "Near College, Alaska",
    shortName: "College",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AK",
    state: "Alaska",
    difficulty: "classic",
    pools: ["world","North America","US","US-AK"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-ak-002",
    lat: 61.32156,
    lng: -149.567738,
    panoId: "G3fAyI0Og-h-hmSXnEMtxA",
    place: "Near Eagle River, Alaska",
    shortName: "Eagle River",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AK",
    state: "Alaska",
    difficulty: "classic",
    pools: ["world","North America","US","US-AK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ak-003",
    lat: 59.642731,
    lng: -151.550486,
    panoId: "hVDEHYmbZfCDDIEHXAQEbw",
    place: "Near Homer, Alaska",
    shortName: "Homer",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AK",
    state: "Alaska",
    difficulty: "classic",
    pools: ["world","North America","US","US-AK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ak-004",
    lat: 61.261011,
    lng: -149.643786,
    panoId: "k7gkw3Ww7cPEQv1prIjCoQ",
    place: "Near Elmendorf Air Force Base, Alaska",
    shortName: "Elmendorf Air Force Base",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AK",
    state: "Alaska",
    difficulty: "classic",
    pools: ["world","North America","US","US-AK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ak-005",
    lat: 61.62708,
    lng: -149.428303,
    panoId: "5t8brGKlFzTpLCt-ilsuiA",
    place: "Near Tanaina, Alaska",
    shortName: "Tanaina",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AK",
    state: "Alaska",
    difficulty: "classic",
    pools: ["world","North America","US","US-AK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ak-006",
    lat: 64.838063,
    lng: -147.716472,
    panoId: "g5b3Xfz1wAtZG1HEGx1azw",
    place: "Near Fairbanks, Alaska",
    shortName: "Fairbanks",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AK",
    state: "Alaska",
    difficulty: "classic",
    pools: ["world","North America","US","US-AK"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-ak-007",
    lat: 60.554279,
    lng: -151.258252,
    panoId: "M27am2l6_y3grlJucAgRiA",
    place: "Near Kenai, Alaska",
    shortName: "Kenai",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AK",
    state: "Alaska",
    difficulty: "classic",
    pools: ["world","North America","US","US-AK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ak-008",
    lat: 61.218023,
    lng: -149.899634,
    panoId: "8adbjBQOrmHCo4ISuzsthg",
    place: "Near Anchorage, Alaska",
    shortName: "Anchorage",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AK",
    state: "Alaska",
    difficulty: "classic",
    pools: ["world","North America","US","US-AK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ak-009",
    lat: 61.269621,
    lng: -149.633978,
    panoId: "4QFsdIeqGbhSFvjYI1VoLg",
    place: "Near Elmendorf Air Force Base, Alaska",
    shortName: "Elmendorf Air Force Base",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AK",
    state: "Alaska",
    difficulty: "classic",
    pools: ["world","North America","US","US-AK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ak-010",
    lat: 59.634643,
    lng: -151.52882,
    panoId: "IkbN8XPmdyAJU3ZISjKnBQ",
    place: "Near Homer, Alaska",
    shortName: "Homer",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AK",
    state: "Alaska",
    difficulty: "classic",
    pools: ["world","North America","US","US-AK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ak-011",
    lat: 60.436314,
    lng: -151.28409,
    panoId: "91xm0S3VT0TBljE2DaxZDw",
    place: "Near Kalifornsky, Alaska",
    shortName: "Kalifornsky",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AK",
    state: "Alaska",
    difficulty: "classic",
    pools: ["world","North America","US","US-AK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ak-012",
    lat: 64.810833,
    lng: -147.572457,
    panoId: "v3pz_DKGY_lnq_HmRqkgZw",
    place: "Near Badger, Alaska",
    shortName: "Badger",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AK",
    state: "Alaska",
    difficulty: "classic",
    pools: ["world","North America","US","US-AK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ak-013",
    lat: 61.585251,
    lng: -149.257259,
    panoId: "YKpOdT11E0mNbn0l6eYD2A",
    place: "Near Gateway, Alaska",
    shortName: "Gateway",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AK",
    state: "Alaska",
    difficulty: "classic",
    pools: ["world","North America","US","US-AK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ak-014",
    lat: 60.54395,
    lng: -151.21876,
    panoId: "Y17gqLZg4yqcCb1wHgYTug",
    place: "Near Kenai, Alaska",
    shortName: "Kenai",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AK",
    state: "Alaska",
    difficulty: "classic",
    pools: ["world","North America","US","US-AK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ak-015",
    lat: 59.648408,
    lng: -151.521795,
    panoId: "KfVoQNMrwgqBPegH6eRgXA",
    place: "Near Homer, Alaska",
    shortName: "Homer",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AK",
    state: "Alaska",
    difficulty: "classic",
    pools: ["world","North America","US","US-AK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ak-016",
    lat: 64.805732,
    lng: -147.495142,
    panoId: "fKTqWDyFWoP1UkJ4SLujhw",
    place: "Near Badger, Alaska",
    shortName: "Badger",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AK",
    state: "Alaska",
    difficulty: "classic",
    pools: ["world","North America","US","US-AK"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-ak-017",
    lat: 60.531896,
    lng: -151.26286,
    panoId: "Eklgyr66iJXXXS1SjS46PA",
    place: "Near Kenai, Alaska",
    shortName: "Kenai",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AK",
    state: "Alaska",
    difficulty: "classic",
    pools: ["world","North America","US","US-AK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ak-018",
    lat: 61.515574,
    lng: -149.562173,
    panoId: "7jv69JtrK_c3KyrAvP3KFQ",
    place: "Near Knik-Fairview, Alaska",
    shortName: "Knik-Fairview",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AK",
    state: "Alaska",
    difficulty: "classic",
    pools: ["world","North America","US","US-AK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ak-019",
    lat: 61.297487,
    lng: -149.590056,
    panoId: "R1qP7CUA3A5huzLQN9BX0g",
    place: "Near Eagle River, Alaska",
    shortName: "Eagle River",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AK",
    state: "Alaska",
    difficulty: "classic",
    pools: ["world","North America","US","US-AK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ak-020",
    lat: 61.589938,
    lng: -149.290265,
    panoId: "Cb1BukFWqLvNukNvBq4m_Q",
    place: "Near Lakes, Alaska",
    shortName: "Lakes",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AK",
    state: "Alaska",
    difficulty: "classic",
    pools: ["world","North America","US","US-AK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ak-021",
    lat: 61.575548,
    lng: -149.232862,
    panoId: "pW97kiX1whtZoqDXiOHnfA",
    place: "Near Gateway, Alaska",
    shortName: "Gateway",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AK",
    state: "Alaska",
    difficulty: "classic",
    pools: ["world","North America","US","US-AK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ak-022",
    lat: 61.635497,
    lng: -149.45089,
    panoId: "qHB4RMKrR0q3snGRZmcyQw",
    place: "Near Tanaina, Alaska",
    shortName: "Tanaina",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AK",
    state: "Alaska",
    difficulty: "classic",
    pools: ["world","North America","US","US-AK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ak-023",
    lat: 58.286394,
    lng: -134.435716,
    panoId: "lVM1CP8mXx_covmaYCqVPQ",
    place: "Near Juneau, Alaska",
    shortName: "Juneau",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AK",
    state: "Alaska",
    difficulty: "classic",
    pools: ["world","North America","US","US-AK"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "us-ak-024",
    lat: 61.58121,
    lng: -149.279416,
    panoId: "iKpfLfrnBMGG_Uti9OsHFw",
    place: "Near Gateway, Alaska",
    shortName: "Gateway",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AK",
    state: "Alaska",
    difficulty: "classic",
    pools: ["world","North America","US","US-AK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ak-025",
    lat: 64.856634,
    lng: -147.75461,
    panoId: "GUenVAGt-YQ1HgyO65DZQg",
    place: "Near College, Alaska",
    shortName: "College",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AK",
    state: "Alaska",
    difficulty: "classic",
    pools: ["world","North America","US","US-AK"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-ak-026",
    lat: 61.52451,
    lng: -149.583934,
    panoId: "Z75BDZwDjpgWmoTh3VCwUg",
    place: "Near Knik-Fairview, Alaska",
    shortName: "Knik-Fairview",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AK",
    state: "Alaska",
    difficulty: "classic",
    pools: ["world","North America","US","US-AK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ak-027",
    lat: 64.501231,
    lng: -165.406283,
    panoId: "UR273kgPpR6ciwxucZy0tg",
    place: "Near Nome, Alaska",
    shortName: "Nome",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AK",
    state: "Alaska",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AK"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "us-ak-028",
    lat: 64.907798,
    lng: -147.692829,
    panoId: "hMwriAI0oHPE6Mbx1f9rPg",
    place: "Near Farmers Loop, Alaska",
    shortName: "Farmers Loop",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AK",
    state: "Alaska",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ak-029",
    lat: 61.744708,
    lng: -149.232309,
    panoId: "M18v8wV3aUtG_Owc_tZMzw",
    place: "Near Fishhook, Alaska",
    shortName: "Fishhook",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AK",
    state: "Alaska",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ak-030",
    lat: 61.514669,
    lng: -149.917214,
    panoId: "YErA6ACRRXlvQYgE4AdIkA",
    place: "Near Big Lake, Alaska",
    shortName: "Big Lake",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AK",
    state: "Alaska",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ak-031",
    lat: 56.810519,
    lng: -132.976755,
    panoId: "Oie8KbRGkfnD5-qWStmFbw",
    place: "Near Petersburg, Alaska",
    shortName: "Petersburg",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AK",
    state: "Alaska",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AK"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-ak-032",
    lat: 64.596252,
    lng: -147.06002,
    panoId: "YMeufEgs404uAgDEuHU94g",
    place: "Near Eielson Air Force Base, Alaska",
    shortName: "Eielson Air Force Base",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AK",
    state: "Alaska",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ak-033",
    lat: 61.719657,
    lng: -149.118625,
    panoId: "ctY-owN5tO4X1Z-adJrAAA",
    place: "Near Fishhook, Alaska",
    shortName: "Fishhook",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AK",
    state: "Alaska",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ak-034",
    lat: 61.191663,
    lng: -149.763106,
    panoId: "sP1x5FMinjzD3bLO90NGfA",
    place: "Near Anchorage, Alaska",
    shortName: "Anchorage",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AK",
    state: "Alaska",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ak-035",
    lat: 60.941585,
    lng: -149.16726,
    panoId: "fCyGI_uyMlAPbkwqTirYRw",
    place: "Near Girdwood, Alaska",
    shortName: "Girdwood",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AK",
    state: "Alaska",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ak-036",
    lat: 55.305264,
    lng: -131.581716,
    panoId: "uGKzg_6eVoZFUVVSOyYuAA",
    place: "Near Ketchikan, Alaska",
    shortName: "Ketchikan",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AK",
    state: "Alaska",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AK"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-ak-037",
    lat: 61.660806,
    lng: -149.467948,
    panoId: "rhJF-TObbsOt-mEpXsxbcg",
    place: "Near Tanaina, Alaska",
    shortName: "Tanaina",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AK",
    state: "Alaska",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ak-038",
    lat: 64.892739,
    lng: -147.68988,
    panoId: "E_98uzyuXvQafx7_ePP0pw",
    place: "Near Farmers Loop, Alaska",
    shortName: "Farmers Loop",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AK",
    state: "Alaska",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AK"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-ak-039",
    lat: 61.541658,
    lng: -149.434515,
    panoId: "kAUDTE_BmxckQboVx01Jwg",
    place: "Near Wasilla, Alaska",
    shortName: "Wasilla",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AK",
    state: "Alaska",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ak-040",
    lat: 61.241008,
    lng: -149.680869,
    panoId: "2Xp-qF98sQSHw-SSHHAjdQ",
    place: "Near Elmendorf Air Force Base, Alaska",
    shortName: "Elmendorf Air Force Base",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AK",
    state: "Alaska",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ak-041",
    lat: 61.5482,
    lng: -149.324236,
    panoId: "eo-Sq13bg4OUpo69POqsyw",
    place: "Near Gateway, Alaska",
    shortName: "Gateway",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AK",
    state: "Alaska",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ak-042",
    lat: 60.924632,
    lng: -149.143416,
    panoId: "tJUox1MojZETWLW6ffTMVw",
    place: "Near Girdwood, Alaska",
    shortName: "Girdwood",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AK",
    state: "Alaska",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ak-043",
    lat: 56.750296,
    lng: -132.959051,
    panoId: "UXIzxleeck6q0PxwVFCNrA",
    place: "Near Petersburg, Alaska",
    shortName: "Petersburg",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AK",
    state: "Alaska",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AK"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-ak-044",
    lat: 61.61483,
    lng: -149.503343,
    panoId: "y6otMqgQ7HiU2m-9rIhP_Q",
    place: "Near Tanaina, Alaska",
    shortName: "Tanaina",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AK",
    state: "Alaska",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ak-045",
    lat: 61.209455,
    lng: -149.827442,
    panoId: "C7Vz-4I4FmDdT4dk5XiGQQ",
    place: "Near Anchorage, Alaska",
    shortName: "Anchorage",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AK",
    state: "Alaska",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ak-046",
    lat: 64.526835,
    lng: -146.991941,
    panoId: "l8esHcKJkJorlkg0ch2Qaw",
    place: "Near Salcha, Alaska",
    shortName: "Salcha",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AK",
    state: "Alaska",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ak-047",
    lat: 61.656019,
    lng: -149.202545,
    panoId: "jr-4r8xBmYCsAOUvt0sYBA",
    place: "Near Farm Loop, Alaska",
    shortName: "Farm Loop",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AK",
    state: "Alaska",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ak-048",
    lat: 64.789373,
    lng: -147.959537,
    panoId: "4KOsuw-ApIlYCqFVg0AkQA",
    place: "Near Ester, Alaska",
    shortName: "Ester",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AK",
    state: "Alaska",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AK"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "us-ak-049",
    lat: 59.776415,
    lng: -151.83133,
    panoId: "QLuBRuBoECL07tpX1By1bw",
    place: "Near Anchor Point, Alaska",
    shortName: "Anchor Point",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AK",
    state: "Alaska",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ak-050",
    lat: 60.284421,
    lng: -151.290156,
    panoId: "DIIV2iKWq4rgp1v4q7ZH5Q",
    place: "Near Cohoe, Alaska",
    shortName: "Cohoe",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AK",
    state: "Alaska",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ak-051",
    lat: 60.454474,
    lng: -151.100791,
    panoId: "xJn9a9VHhsLF3gOlhAUHmw",
    place: "Near Soldotna, Alaska",
    shortName: "Soldotna",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AK",
    state: "Alaska",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ak-052",
    lat: 60.372118,
    lng: -151.30745,
    panoId: "xI_KnjHmpjWuPylXMNkBHg",
    place: "Near Cohoe, Alaska",
    shortName: "Cohoe",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AK",
    state: "Alaska",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ak-053",
    lat: 59.734411,
    lng: -151.317212,
    panoId: "Ghc8V5KMaPL6sCrWd0PLUQ",
    place: "Near Fritz Creek, Alaska",
    shortName: "Fritz Creek",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AK",
    state: "Alaska",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ak-054",
    lat: 60.529557,
    lng: -151.080792,
    panoId: "ps9ZFSUGRVag_ubGFVLjrg",
    place: "Near Ridgeway, Alaska",
    shortName: "Ridgeway",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AK",
    state: "Alaska",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ak-055",
    lat: 61.605988,
    lng: -149.484714,
    panoId: "x99YO4eyKe0w8_smA8EKoQ",
    place: "Near Wasilla, Alaska",
    shortName: "Wasilla",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AK",
    state: "Alaska",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ak-056",
    lat: 57.097467,
    lng: -135.407838,
    panoId: "fK8cVZjsBwnSMLbxw8P-cQ",
    place: "Near Sitka, Alaska",
    shortName: "Sitka",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AK",
    state: "Alaska",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AK"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-ak-057",
    lat: 60.355837,
    lng: -151.319541,
    panoId: "iz01Y8VrzcJyLM7bnrNPzg",
    place: "Near Cohoe, Alaska",
    shortName: "Cohoe",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AK",
    state: "Alaska",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ak-058",
    lat: 61.541658,
    lng: -149.524572,
    panoId: "S0_7FlUi8WPvZTJ9f5YZWg",
    place: "Near Knik-Fairview, Alaska",
    shortName: "Knik-Fairview",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AK",
    state: "Alaska",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ak-059",
    lat: 61.643895,
    lng: -149.481741,
    panoId: "IQLfBHXp7ZdAEQFAzMPqyg",
    place: "Near Tanaina, Alaska",
    shortName: "Tanaina",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AK",
    state: "Alaska",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ak-060",
    lat: 64.762438,
    lng: -147.342959,
    panoId: "qMuRW427Gaw9OG9VZMdkAg",
    place: "Near North Pole, Alaska",
    shortName: "North Pole",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AK",
    state: "Alaska",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AK"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-ak-061",
    lat: 64.963867,
    lng: -147.745206,
    panoId: "e05fJjNm-CfwYufTAi4t1Q",
    place: "Near Farmers Loop, Alaska",
    shortName: "Farmers Loop",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AK",
    state: "Alaska",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ak-062",
    lat: 59.672783,
    lng: -151.554663,
    panoId: "XERk9skMOwEY--rphWrn_g",
    place: "Near Diamond Ridge, Alaska",
    shortName: "Diamond Ridge",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AK",
    state: "Alaska",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ak-063",
    lat: 60.372101,
    lng: -151.336504,
    panoId: "kOG3pPsygmB2SuhndTwyYw",
    place: "Near Cohoe, Alaska",
    shortName: "Cohoe",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AK",
    state: "Alaska",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ak-064",
    lat: 56.880402,
    lng: -132.944934,
    panoId: "VSUxT8uYXz2_gds68WuJEg",
    place: "Near Petersburg, Alaska",
    shortName: "Petersburg",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AK",
    state: "Alaska",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AK"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-ak-065",
    lat: 59.73428,
    lng: -151.271174,
    panoId: "b3wMS41m_JENuwSwwgTW3A",
    place: "Near Fritz Creek, Alaska",
    shortName: "Fritz Creek",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AK",
    state: "Alaska",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ak-066",
    lat: 61.584962,
    lng: -149.759281,
    panoId: "EcTBvHt1RjBLgvODq55oKw",
    place: "Near Houston, Alaska",
    shortName: "Houston",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AK",
    state: "Alaska",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ak-067",
    lat: 64.65269,
    lng: -147.141109,
    panoId: "0MWpKlMbizGX7ULAXBJCIA",
    place: "Near Eielson Air Force Base, Alaska",
    shortName: "Eielson Air Force Base",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AK",
    state: "Alaska",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ak-068",
    lat: 61.63903,
    lng: -149.142002,
    panoId: "VAeQT3z3vvRRJZBdrqzmhw",
    place: "Near Farm Loop, Alaska",
    shortName: "Farm Loop",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AK",
    state: "Alaska",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ak-069",
    lat: 59.76116,
    lng: -151.817301,
    panoId: "97jC7K8ppre73yPK66UOrg",
    place: "Near Anchor Point, Alaska",
    shortName: "Anchor Point",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AK",
    state: "Alaska",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ak-070",
    lat: 64.546708,
    lng: -146.920977,
    panoId: "zgHyFvNk53Yd2Ln6rK_zkg",
    place: "Near Salcha, Alaska",
    shortName: "Salcha",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AK",
    state: "Alaska",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ak-071",
    lat: 59.664861,
    lng: -151.583064,
    panoId: "w3hK0gFW7EcKRpOMlq2_4g",
    place: "Near Diamond Ridge, Alaska",
    shortName: "Diamond Ridge",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AK",
    state: "Alaska",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ak-072",
    lat: 60.508766,
    lng: -151.136137,
    panoId: "ynI9Xy_RoelAgMB_pwZQZA",
    place: "Near Ridgeway, Alaska",
    shortName: "Ridgeway",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AK",
    state: "Alaska",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ak-073",
    lat: 61.472844,
    lng: -149.206653,
    panoId: "RLAnDMIxZuIasF1T5etGnQ",
    place: "Near Gateway, Alaska",
    shortName: "Gateway",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AK",
    state: "Alaska",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ak-074",
    lat: 64.85261,
    lng: -147.931444,
    panoId: "29vy9XTM9zQypsxSm_CRkQ",
    place: "Near Ester, Alaska",
    shortName: "Ester",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AK",
    state: "Alaska",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AK"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-ak-075",
    lat: 59.738109,
    lng: -151.74931,
    panoId: "8808BiNCv2fqhN-wWHHZQQ",
    place: "Near Anchor Point, Alaska",
    shortName: "Anchor Point",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AK",
    state: "Alaska",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ak-076",
    lat: 61.65593,
    lng: -149.14242,
    panoId: "SWJFHyFx18Mxu23UHVsOAA",
    place: "Near Farm Loop, Alaska",
    shortName: "Farm Loop",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AK",
    state: "Alaska",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ak-077",
    lat: 61.41818,
    lng: -149.195638,
    panoId: "TruqbHHoMlcT4iGBPytXAQ",
    place: "Near Butte, Alaska",
    shortName: "Butte",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AK",
    state: "Alaska",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-AK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ak-078",
    lat: 60.046983,
    lng: -151.664665,
    panoId: "-G0MzX8fay5Qv4jFsZkyKw",
    place: "Near Anchor Point, Alaska",
    shortName: "Anchor Point",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AK",
    state: "Alaska",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-AK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ak-079",
    lat: 60.036079,
    lng: -151.685047,
    panoId: "Rko-sGQHfpbA4KdaoPqMqQ",
    place: "Near Anchor Point, Alaska",
    shortName: "Anchor Point",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AK",
    state: "Alaska",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-AK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ak-080",
    lat: 64.870743,
    lng: -147.036629,
    panoId: "iYtDTCwgcyUoxH52KH9PfA",
    place: "Near North Pole, Alaska",
    shortName: "North Pole",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AK",
    state: "Alaska",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-AK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ak-081",
    lat: 64.882134,
    lng: -146.869238,
    panoId: "f9MIneD4edFoxw50-gjJoQ",
    place: "Near Eielson Air Force Base, Alaska",
    shortName: "Eielson Air Force Base",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AK",
    state: "Alaska",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-AK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ak-082",
    lat: 60.092739,
    lng: -151.608832,
    panoId: "d9wRuW4oJ5Y4QIvCz-0OmA",
    place: "Near Cohoe, Alaska",
    shortName: "Cohoe",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AK",
    state: "Alaska",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-AK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ak-083",
    lat: 59.947347,
    lng: -151.733302,
    panoId: "gTPMQPzz85YgxZs65e3igg",
    place: "Near Anchor Point, Alaska",
    shortName: "Anchor Point",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AK",
    state: "Alaska",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-AK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ak-084",
    lat: 64.877083,
    lng: -147.004865,
    panoId: "uVVxm7lcLZIb19pWPf1XuQ",
    place: "Near North Pole, Alaska",
    shortName: "North Pole",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AK",
    state: "Alaska",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-AK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ak-085",
    lat: 59.927066,
    lng: -151.740938,
    panoId: "oWXPTiADWN-3vbsreDgKVw",
    place: "Near Anchor Point, Alaska",
    shortName: "Anchor Point",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AK",
    state: "Alaska",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-AK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ak-086",
    lat: 64.877149,
    lng: -146.814393,
    panoId: "0WgbF0_1rKYzJt7YGQ6EhQ",
    place: "Near Eielson Air Force Base, Alaska",
    shortName: "Eielson Air Force Base",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AK",
    state: "Alaska",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-AK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ak-087",
    lat: 59.888666,
    lng: -151.782712,
    panoId: "gtZG3qO3_fZgZ3cZ4toJjA",
    place: "Near Anchor Point, Alaska",
    shortName: "Anchor Point",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AK",
    state: "Alaska",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-AK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ak-088",
    lat: 64.886006,
    lng: -146.716202,
    panoId: "v0Eprt9iEVJRurqR3ywByg",
    place: "Near Eielson Air Force Base, Alaska",
    shortName: "Eielson Air Force Base",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AK",
    state: "Alaska",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-AK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-az-000",
    lat: 33.415188,
    lng: -111.549811,
    panoId: "A7bc5dozkO7_8K2uj49nfw",
    place: "Near Apache Junction, Arizona",
    shortName: "Apache Junction",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AZ",
    state: "Arizona",
    difficulty: "classic",
    pools: ["world","North America","US","US-AZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-az-001",
    lat: 32.725339,
    lng: -114.624498,
    panoId: "E1Rmg_D_l03yyxee1BMVWQ",
    place: "Near Yuma, Arizona",
    shortName: "Yuma",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AZ",
    state: "Arizona",
    difficulty: "classic",
    pools: ["world","North America","US","US-AZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-az-002",
    lat: 34.483831,
    lng: -114.322551,
    panoId: "0M58s8IPVJ3JH9h3VYAZrw",
    place: "Near Lake Havasu City, Arizona",
    shortName: "Lake Havasu City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AZ",
    state: "Arizona",
    difficulty: "classic",
    pools: ["world","North America","US","US-AZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-az-003",
    lat: 33.031474,
    lng: -111.38747,
    panoId: "VmkyXlr7xpXfbOvCW4Ek8A",
    place: "Near Florence, Arizona",
    shortName: "Florence",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AZ",
    state: "Arizona",
    difficulty: "classic",
    pools: ["world","North America","US","US-AZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-az-004",
    lat: 35.147728,
    lng: -114.568288,
    panoId: "dvVaGaHNVl5jpBN6B2Lu6Q",
    place: "Near Bullhead City, Arizona",
    shortName: "Bullhead City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AZ",
    state: "Arizona",
    difficulty: "classic",
    pools: ["world","North America","US","US-AZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-az-005",
    lat: 33.448217,
    lng: -112.074043,
    panoId: "zk4hgj7xXM5hvtAs2j-qyw",
    place: "Near Phoenix, Arizona",
    shortName: "Phoenix",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AZ",
    state: "Arizona",
    difficulty: "classic",
    pools: ["world","North America","US","US-AZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-az-006",
    lat: 31.471922,
    lng: -110.976096,
    panoId: "HwG8rqvwqKnrXGtfCysSSA",
    place: "Near Rio Rico, Arizona",
    shortName: "Rio Rico",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AZ",
    state: "Arizona",
    difficulty: "classic",
    pools: ["world","North America","US","US-AZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-az-007",
    lat: 33.05819,
    lng: -112.04724,
    panoId: "M0TKG0annFROkjPDkJb22Q",
    place: "Near Maricopa, Arizona",
    shortName: "Maricopa",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AZ",
    state: "Arizona",
    difficulty: "classic",
    pools: ["world","North America","US","US-AZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-az-008",
    lat: 32.221726,
    lng: -110.926553,
    panoId: "jiHEuevoWIaR3noasZbQ2w",
    place: "Near Tucson, Arizona",
    shortName: "Tucson",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AZ",
    state: "Arizona",
    difficulty: "classic",
    pools: ["world","North America","US","US-AZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-az-009",
    lat: 32.879502,
    lng: -111.757346,
    panoId: "FNS31hj0PpcwU7_r6sbaBA",
    place: "Near Casa Grande, Arizona",
    shortName: "Casa Grande",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AZ",
    state: "Arizona",
    difficulty: "classic",
    pools: ["world","North America","US","US-AZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-az-010",
    lat: 33.370492,
    lng: -112.583773,
    panoId: "kHj_uPni__DkdMuank1RXQ",
    place: "Near Buckeye, Arizona",
    shortName: "Buckeye",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AZ",
    state: "Arizona",
    difficulty: "classic",
    pools: ["world","North America","US","US-AZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-az-011",
    lat: 34.540065,
    lng: -112.468466,
    panoId: "-b1tEyai35gpygn8FpHyug",
    place: "Near Prescott, Arizona",
    shortName: "Prescott",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AZ",
    state: "Arizona",
    difficulty: "classic",
    pools: ["world","North America","US","US-AZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-az-012",
    lat: 34.230856,
    lng: -111.32506,
    panoId: "zYeLYzjO52zo6XDRuEgaFQ",
    place: "Near Payson, Arizona",
    shortName: "Payson",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AZ",
    state: "Arizona",
    difficulty: "classic",
    pools: ["world","North America","US","US-AZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-az-013",
    lat: 32.65752,
    lng: -114.411967,
    panoId: "mt3OHieC09XGN2yIIMemjQ",
    place: "Near Fortuna Foothills, Arizona",
    shortName: "Fortuna Foothills",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AZ",
    state: "Arizona",
    difficulty: "classic",
    pools: ["world","North America","US","US-AZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-az-014",
    lat: 34.609671,
    lng: -112.315752,
    panoId: "3Hu30Z0imm6tNtJsf3gn6A",
    place: "Near Prescott Valley, Arizona",
    shortName: "Prescott Valley",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AZ",
    state: "Arizona",
    difficulty: "classic",
    pools: ["world","North America","US","US-AZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-az-015",
    lat: 33.918332,
    lng: -112.136009,
    panoId: "KU3YV16RUSK6GrcSxlHF4w",
    place: "Near New River, Arizona",
    shortName: "New River",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AZ",
    state: "Arizona",
    difficulty: "classic",
    pools: ["world","North America","US","US-AZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-az-016",
    lat: 31.34447,
    lng: -109.545361,
    panoId: "sBhtjS6xbMssQXzFSWGdpw",
    place: "Near Douglas, Arizona",
    shortName: "Douglas",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AZ",
    state: "Arizona",
    difficulty: "classic",
    pools: ["world","North America","US","US-AZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-az-017",
    lat: 31.554572,
    lng: -110.303714,
    panoId: "E2vQ6ck80YWQoh7CkgdKIw",
    place: "Near Sierra Vista, Arizona",
    shortName: "Sierra Vista",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AZ",
    state: "Arizona",
    difficulty: "classic",
    pools: ["world","North America","US","US-AZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-az-018",
    lat: 34.710561,
    lng: -112.011558,
    panoId: "Uh9lPfWZwLJZr2EtfCDHEg",
    place: "Near Verde Village, Arizona",
    shortName: "Verde Village",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AZ",
    state: "Arizona",
    difficulty: "classic",
    pools: ["world","North America","US","US-AZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-az-019",
    lat: 31.453875,
    lng: -110.215161,
    panoId: "0K08ZZC71doDkPaN5RnXhQ",
    place: "Near Sierra Vista Southeast, Arizona",
    shortName: "Sierra Vista Southeast",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AZ",
    state: "Arizona",
    difficulty: "classic",
    pools: ["world","North America","US","US-AZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-az-020",
    lat: 32.755899,
    lng: -111.554859,
    panoId: "8IfIYGA3u46cBzyIYsdECA",
    place: "Near Eloy, Arizona",
    shortName: "Eloy",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AZ",
    state: "Arizona",
    difficulty: "classic",
    pools: ["world","North America","US","US-AZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-az-021",
    lat: 34.73918,
    lng: -112.009766,
    panoId: "MuV7fot4HxPpfvF8kgtXBA",
    place: "Near Cottonwood, Arizona",
    shortName: "Cottonwood",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AZ",
    state: "Arizona",
    difficulty: "classic",
    pools: ["world","North America","US","US-AZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-az-022",
    lat: 33.191036,
    lng: -111.528018,
    panoId: "Ml-vnsvFDGv6v4riXw7mGg",
    place: "Near San Tan Valley, Arizona",
    shortName: "San Tan Valley",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AZ",
    state: "Arizona",
    difficulty: "classic",
    pools: ["world","North America","US","US-AZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-az-023",
    lat: 32.977681,
    lng: -111.51766,
    panoId: "gdo0xn5-Li1ZeA9b6Djtjw",
    place: "Near Coolidge, Arizona",
    shortName: "Coolidge",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AZ",
    state: "Arizona",
    difficulty: "classic",
    pools: ["world","North America","US","US-AZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-az-024",
    lat: 31.340311,
    lng: -110.934395,
    panoId: "huwRam1WltHNxeF7CGTYjQ",
    place: "Near Nogales, Arizona",
    shortName: "Nogales",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AZ",
    state: "Arizona",
    difficulty: "classic",
    pools: ["world","North America","US","US-AZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-az-025",
    lat: 34.563666,
    lng: -111.854328,
    panoId: "wwQ1k2QxFVymbCtvJJ1mRA",
    place: "Near Camp Verde, Arizona",
    shortName: "Camp Verde",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AZ",
    state: "Arizona",
    difficulty: "classic",
    pools: ["world","North America","US","US-AZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-az-026",
    lat: 35.265039,
    lng: -114.032144,
    panoId: "MtKUOvckQp0oUn5BGAYoWg",
    place: "Near New Kingman-Butler, Arizona",
    shortName: "New Kingman-Butler",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AZ",
    state: "Arizona",
    difficulty: "classic",
    pools: ["world","North America","US","US-AZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-az-027",
    lat: 34.25413,
    lng: -110.029735,
    panoId: "31oXMfDZk3-Q_gWCQaTUuQ",
    place: "Near Show Low, Arizona",
    shortName: "Show Low",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AZ",
    state: "Arizona",
    difficulty: "classic",
    pools: ["world","North America","US","US-AZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-az-028",
    lat: 32.596476,
    lng: -114.709744,
    panoId: "JNjJMmE-5S3oD5v_F17t9w",
    place: "Near Somerton, Arizona",
    shortName: "Somerton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AZ",
    state: "Arizona",
    difficulty: "classic",
    pools: ["world","North America","US","US-AZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-az-029",
    lat: 32.486997,
    lng: -114.782194,
    panoId: "lx5fsgcAycYEoKXWoUvURg",
    place: "Near San Luis, Arizona",
    shortName: "San Luis",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AZ",
    state: "Arizona",
    difficulty: "classic",
    pools: ["world","North America","US","US-AZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-az-030",
    lat: 35.189412,
    lng: -114.052965,
    panoId: "b0AmK8zGmYJyRjy0DQMl1A",
    place: "Near Kingman, Arizona",
    shortName: "Kingman",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AZ",
    state: "Arizona",
    difficulty: "classic",
    pools: ["world","North America","US","US-AZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-az-031",
    lat: 34.86722,
    lng: -111.805817,
    panoId: "NzLp8w1Ke_7gkwxQF5L3VQ",
    place: "Near West Sedona, Arizona",
    shortName: "West Sedona",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AZ",
    state: "Arizona",
    difficulty: "classic",
    pools: ["world","North America","US","US-AZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-az-032",
    lat: 34.757572,
    lng: -112.453849,
    panoId: "wSAg4uxAppS90lAwugM3VQ",
    place: "Near Chino Valley, Arizona",
    shortName: "Chino Valley",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AZ",
    state: "Arizona",
    difficulty: "classic",
    pools: ["world","North America","US","US-AZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-az-033",
    lat: 33.248605,
    lng: -111.6343,
    panoId: "j4u-qfL1vrBiQuiYxO73eg",
    place: "Near Queen Creek, Arizona",
    shortName: "Queen Creek",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AZ",
    state: "Arizona",
    difficulty: "classic",
    pools: ["world","North America","US","US-AZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-az-034",
    lat: 35.198114,
    lng: -111.651201,
    panoId: "ve0Go4kHcloJ7hmg2AVRkA",
    place: "Near Flagstaff, Arizona",
    shortName: "Flagstaff",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AZ",
    state: "Arizona",
    difficulty: "classic",
    pools: ["world","North America","US","US-AZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-az-035",
    lat: 31.854317,
    lng: -110.993837,
    panoId: "eduIKwBfq-wCNcpyuczzAQ",
    place: "Near Green Valley, Arizona",
    shortName: "Green Valley",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AZ",
    state: "Arizona",
    difficulty: "classic",
    pools: ["world","North America","US","US-AZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-az-036",
    lat: 32.755856,
    lng: -111.671116,
    panoId: "IfEMcwoNMBASKCqEpXc6Tg",
    place: "Near Arizona City, Arizona",
    shortName: "Arizona City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AZ",
    state: "Arizona",
    difficulty: "classic",
    pools: ["world","North America","US","US-AZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-az-037",
    lat: 34.869708,
    lng: -111.761041,
    panoId: "zp6DBbskKxdtkJwUk88wxw",
    place: "Near Sedona, Arizona",
    shortName: "Sedona",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AZ",
    state: "Arizona",
    difficulty: "classic",
    pools: ["world","North America","US","US-AZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-az-038",
    lat: 33.371358,
    lng: -111.436673,
    panoId: "AmOG_nQWx23pUYw65H_PoA",
    place: "Near Gold Canyon, Arizona",
    shortName: "Gold Canyon",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AZ",
    state: "Arizona",
    difficulty: "classic",
    pools: ["world","North America","US","US-AZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-az-039",
    lat: 33.293682,
    lng: -111.304269,
    panoId: "hMOohh5PlrmgASZFzu-Dtg",
    place: "Near Gold Camp, Arizona",
    shortName: "Gold Camp",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AZ",
    state: "Arizona",
    difficulty: "classic",
    pools: ["world","North America","US","US-AZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-az-040",
    lat: 33.451874,
    lng: -112.088436,
    panoId: "GIQTrfc648trnKwdjy6rQw",
    place: "Near Phoenix, Arizona",
    shortName: "Phoenix",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AZ",
    state: "Arizona",
    difficulty: "classic",
    pools: ["world","North America","US","US-AZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-az-041",
    lat: 35.136324,
    lng: -114.581106,
    panoId: "-_6oFmlmKxiaWXLE3IVKXw",
    place: "Near Bullhead City, Arizona",
    shortName: "Bullhead City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AZ",
    state: "Arizona",
    difficulty: "classic",
    pools: ["world","North America","US","US-AZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-az-042",
    lat: 35.20187,
    lng: -114.057199,
    panoId: "zA9NGfdTwLg5Ui-y443s2w",
    place: "Near Kingman, Arizona",
    shortName: "Kingman",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AZ",
    state: "Arizona",
    difficulty: "classic",
    pools: ["world","North America","US","US-AZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-az-043",
    lat: 33.363156,
    lng: -112.566466,
    panoId: "FnxNml_DRSKxt3zkt_SGEQ",
    place: "Near Buckeye, Arizona",
    shortName: "Buckeye",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AZ",
    state: "Arizona",
    difficulty: "classic",
    pools: ["world","North America","US","US-AZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-az-044",
    lat: 31.459766,
    lng: -110.997809,
    panoId: "r2YUvFHhv2Ti6-3bZ85zTg",
    place: "Near Rio Rico, Arizona",
    shortName: "Rio Rico",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AZ",
    state: "Arizona",
    difficulty: "classic",
    pools: ["world","North America","US","US-AZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-az-045",
    lat: 33.40058,
    lng: -111.549608,
    panoId: "LmGfuWAsZiQAGAPT1d9YZQ",
    place: "Near Apache Junction, Arizona",
    shortName: "Apache Junction",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AZ",
    state: "Arizona",
    difficulty: "classic",
    pools: ["world","North America","US","US-AZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-az-046",
    lat: 32.656314,
    lng: -114.43625,
    panoId: "onQdREg6RGHlDGp2eQB7tQ",
    place: "Near Fortuna Foothills, Arizona",
    shortName: "Fortuna Foothills",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AZ",
    state: "Arizona",
    difficulty: "classic",
    pools: ["world","North America","US","US-AZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-az-047",
    lat: 34.725513,
    lng: -112.006137,
    panoId: "k2TQdiL4M_fA7_Xf7sYaPQ",
    place: "Near Cottonwood, Arizona",
    shortName: "Cottonwood",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AZ",
    state: "Arizona",
    difficulty: "classic",
    pools: ["world","North America","US","US-AZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-az-048",
    lat: 32.721012,
    lng: -114.611135,
    panoId: "JaKeZwaShppAjHxfIxTv3A",
    place: "Near Yuma, Arizona",
    shortName: "Yuma",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AZ",
    state: "Arizona",
    difficulty: "classic",
    pools: ["world","North America","US","US-AZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-az-049",
    lat: 31.348868,
    lng: -109.522466,
    panoId: "PnQsqzsRWjh6Jajh2g5EGg",
    place: "Near Douglas, Arizona",
    shortName: "Douglas",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AZ",
    state: "Arizona",
    difficulty: "classic",
    pools: ["world","North America","US","US-AZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-az-050",
    lat: 34.29516,
    lng: -111.352494,
    panoId: "_h4sxHJJdZIm32f6xcmFMg",
    place: "Near Payson, Arizona",
    shortName: "Payson",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AZ",
    state: "Arizona",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-az-051",
    lat: 34.300906,
    lng: -109.981486,
    panoId: "vvML1_Jj-AIp3R2LJWkBtQ",
    place: "Near White Mountain Lake, Arizona",
    shortName: "White Mountain Lake",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AZ",
    state: "Arizona",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-az-052",
    lat: 31.359042,
    lng: -109.613541,
    panoId: "IrssiLZGSbL2RxkEeS9SrA",
    place: "Near Pirtleville, Arizona",
    shortName: "Pirtleville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AZ",
    state: "Arizona",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-az-053",
    lat: 32.205556,
    lng: -110.885226,
    panoId: "lRqHHBB8Sdk669_nKs7IPQ",
    place: "Near Tucson, Arizona",
    shortName: "Tucson",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AZ",
    state: "Arizona",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-az-054",
    lat: 34.44513,
    lng: -114.315858,
    panoId: "NQDycOWr6rpHApZUlxOIfw",
    place: "Near Lake Havasu City, Arizona",
    shortName: "Lake Havasu City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AZ",
    state: "Arizona",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-az-055",
    lat: 32.704983,
    lng: -111.578236,
    panoId: "s1sbVkXvA2GBgnIm7FRVww",
    place: "Near Eloy, Arizona",
    shortName: "Eloy",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AZ",
    state: "Arizona",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-az-056",
    lat: 32.736972,
    lng: -111.585467,
    panoId: "rZgQKX8GkDNcdUKHzxotDA",
    place: "Near Eloy, Arizona",
    shortName: "Eloy",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AZ",
    state: "Arizona",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-az-057",
    lat: 33.303578,
    lng: -111.583419,
    panoId: "kwtTdgUcZ929vH3b0qCNBw",
    place: "Near Queen Creek, Arizona",
    shortName: "Queen Creek",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AZ",
    state: "Arizona",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-az-058",
    lat: 31.503652,
    lng: -110.182342,
    panoId: "cicpkVgV34HAGCjmGDGMyA",
    place: "Near Sierra Vista Southeast, Arizona",
    shortName: "Sierra Vista Southeast",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AZ",
    state: "Arizona",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-az-059",
    lat: 31.350673,
    lng: -110.967804,
    panoId: "x6AgczHKvUkyPpC7LSiO_g",
    place: "Near Nogales, Arizona",
    shortName: "Nogales",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AZ",
    state: "Arizona",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AZ"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-az-060",
    lat: 32.426531,
    lng: -114.826654,
    panoId: "6_L3w9ulgpJlx2vR9mV7sA",
    place: "Near Islita, Arizona",
    shortName: "Islita",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AZ",
    state: "Arizona",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-az-061",
    lat: 35.254983,
    lng: -113.974773,
    panoId: "Dc4tnz-PBaW3UhViaGOsDA",
    place: "Near New Kingman-Butler, Arizona",
    shortName: "New Kingman-Butler",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AZ",
    state: "Arizona",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-az-062",
    lat: 33.171105,
    lng: -111.595654,
    panoId: "FxZnsLy3LcJYtqUlgn_7wQ",
    place: "Near San Tan Valley, Arizona",
    shortName: "San Tan Valley",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AZ",
    state: "Arizona",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-az-063",
    lat: 35.214941,
    lng: -114.042207,
    panoId: "xwPwiM-DnRmGimE-DTCVxw",
    place: "Near Kingman, Arizona",
    shortName: "Kingman",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AZ",
    state: "Arizona",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-az-064",
    lat: 34.594381,
    lng: -112.45404,
    panoId: "l-V6tAdqKGNsXQoeGQZEaw",
    place: "Near Prescott, Arizona",
    shortName: "Prescott",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AZ",
    state: "Arizona",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-az-065",
    lat: 34.817329,
    lng: -111.768635,
    panoId: "AEFrPIu-K6KxOIfmhFm-QQ",
    place: "Near Village of Oak Creek (Big Park), Arizona",
    shortName: "Village of Oak Creek (Big Park)",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AZ",
    state: "Arizona",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-az-066",
    lat: 32.9281,
    lng: -111.515029,
    panoId: "Pdx4ooTCxoiVDowE6eSO7g",
    place: "Near Coolidge, Arizona",
    shortName: "Coolidge",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AZ",
    state: "Arizona",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-az-067",
    lat: 31.576587,
    lng: -110.254574,
    panoId: "v-K2CUsn03V5bUbn27JkcA",
    place: "Near Sierra Vista, Arizona",
    shortName: "Sierra Vista",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AZ",
    state: "Arizona",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-az-068",
    lat: 33.261576,
    lng: -111.345196,
    panoId: "h_cQFtOakKihzdJcWOq2kQ",
    place: "Near Gold Camp, Arizona",
    shortName: "Gold Camp",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AZ",
    state: "Arizona",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-az-069",
    lat: 32.80236,
    lng: -109.697192,
    panoId: "dVZrKMXDjcfOCcs2aIJrxw",
    place: "Near Safford, Arizona",
    shortName: "Safford",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AZ",
    state: "Arizona",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-az-070",
    lat: 34.571762,
    lng: -112.38055,
    panoId: "4lBg0crRL-qB-oHgMwipEg",
    place: "Near Prescott Valley, Arizona",
    shortName: "Prescott Valley",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AZ",
    state: "Arizona",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-az-071",
    lat: 34.183278,
    lng: -111.348712,
    panoId: "3pZI1xZ5O761FzC-RmDdtg",
    place: "Near Payson, Arizona",
    shortName: "Payson",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AZ",
    state: "Arizona",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-az-072",
    lat: 32.792338,
    lng: -111.537938,
    panoId: "qyBhJt36CqCeFEPNkirBVg",
    place: "Near Eloy, Arizona",
    shortName: "Eloy",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AZ",
    state: "Arizona",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-az-073",
    lat: 35.21449,
    lng: -113.984032,
    panoId: "EhUqonVPjvuPUOL_mpLopA",
    place: "Near Kingman, Arizona",
    shortName: "Kingman",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AZ",
    state: "Arizona",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-az-074",
    lat: 32.869937,
    lng: -111.808875,
    panoId: "CqjwXiksWQC2bDy33evZ-A",
    place: "Near Casa Grande, Arizona",
    shortName: "Casa Grande",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AZ",
    state: "Arizona",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-az-075",
    lat: 32.785937,
    lng: -111.739944,
    panoId: "idvS1xgjn6MQqEjrf0lq4w",
    place: "Near Arizona City, Arizona",
    shortName: "Arizona City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AZ",
    state: "Arizona",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-az-076",
    lat: 34.73748,
    lng: -112.501365,
    panoId: "WYR9pgy6W5yFrujwz-_98A",
    place: "Near Chino Valley, Arizona",
    shortName: "Chino Valley",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AZ",
    state: "Arizona",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-az-077",
    lat: 32.705944,
    lng: -114.581692,
    panoId: "esCU-8AxiBU_DDi8EGBcvA",
    place: "Near Yuma, Arizona",
    shortName: "Yuma",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AZ",
    state: "Arizona",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-az-078",
    lat: 33.112136,
    lng: -111.995598,
    panoId: "MlGGmdXipe_NxPsxaZujpg",
    place: "Near Maricopa, Arizona",
    shortName: "Maricopa",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AZ",
    state: "Arizona",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AZ"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-az-079",
    lat: 34.290098,
    lng: -110.030957,
    panoId: "kvpdRcF0SQSiIPRPyjYd_g",
    place: "Near Show Low, Arizona",
    shortName: "Show Low",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AZ",
    state: "Arizona",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-az-080",
    lat: 31.27455,
    lng: -110.912953,
    panoId: "Xgg1PorGzoRojsMPjKCW2Q",
    place: "Near Nogales, Arizona",
    shortName: "Nogales",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AZ",
    state: "Arizona",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-az-081",
    lat: 33.259469,
    lng: -111.669971,
    panoId: "LSCewazl8aapc97MJU13mw",
    place: "Near Queen Creek, Arizona",
    shortName: "Queen Creek",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AZ",
    state: "Arizona",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-az-082",
    lat: 31.441826,
    lng: -110.178493,
    panoId: "rzepEGA9jEXHHvxIDfIqjA",
    place: "Near Sierra Vista Southeast, Arizona",
    shortName: "Sierra Vista Southeast",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AZ",
    state: "Arizona",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-az-083",
    lat: 35.011623,
    lng: -110.739344,
    panoId: "jnYFUTaYwvh_tqMc7VvBdw",
    place: "Near LeChee, Arizona",
    shortName: "LeChee",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AZ",
    state: "Arizona",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-az-084",
    lat: 33.055886,
    lng: -111.423896,
    panoId: "vvB_GMTDyEPn5QlIHnBfpg",
    place: "Near Florence, Arizona",
    shortName: "Florence",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AZ",
    state: "Arizona",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-az-085",
    lat: 33.43242,
    lng: -112.555619,
    panoId: "CO8_4XcLOwFndUrtGk8NNg",
    place: "Near Buckeye, Arizona",
    shortName: "Buckeye",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AZ",
    state: "Arizona",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-az-086",
    lat: 34.749745,
    lng: -111.962105,
    panoId: "rkQ2v2YSvf3_GLYRTXi7Sg",
    place: "Near Cottonwood, Arizona",
    shortName: "Cottonwood",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AZ",
    state: "Arizona",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-az-087",
    lat: 34.617216,
    lng: -112.363231,
    panoId: "jYHlbbfJ8kcuN_TqPwe9Ow",
    place: "Near Prescott Valley, Arizona",
    shortName: "Prescott Valley",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AZ",
    state: "Arizona",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-az-088",
    lat: 31.513312,
    lng: -111.033788,
    panoId: "8KG2l9rNX5DnKglO6A_LJA",
    place: "Near Rio Rico, Arizona",
    shortName: "Rio Rico",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AZ",
    state: "Arizona",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-az-089",
    lat: 31.583394,
    lng: -110.319586,
    panoId: "neBthbPZZvkf5C2poftRqA",
    place: "Near Sierra Vista, Arizona",
    shortName: "Sierra Vista",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AZ",
    state: "Arizona",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-az-090",
    lat: 34.673398,
    lng: -111.774367,
    panoId: "6Iu-7A3pD481VKd9Ijah6A",
    place: "Near Lake Montezuma, Arizona",
    shortName: "Lake Montezuma",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AZ",
    state: "Arizona",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-az-091",
    lat: 33.118281,
    lng: -111.490329,
    panoId: "RFggDeV9lEgAVH7_YWIeyg",
    place: "Near San Tan Valley, Arizona",
    shortName: "San Tan Valley",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AZ",
    state: "Arizona",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-az-092",
    lat: 33.278063,
    lng: -111.542649,
    panoId: "lYzdA57XQPytkVr4mlXAig",
    place: "Near Queen Creek, Arizona",
    shortName: "Queen Creek",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AZ",
    state: "Arizona",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-az-093",
    lat: 32.778303,
    lng: -114.347543,
    panoId: "h3JSHWNwMhW5OQaaKzn9Ig",
    place: "Near Fortuna Foothills, Arizona",
    shortName: "Fortuna Foothills",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AZ",
    state: "Arizona",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-az-094",
    lat: 34.116152,
    lng: -109.294337,
    panoId: "9Dd-WULC8JsMpJ5vP95N4A",
    place: "Near Eagar, Arizona",
    shortName: "Eagar",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AZ",
    state: "Arizona",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-az-095",
    lat: 32.494611,
    lng: -114.818009,
    panoId: "aslplOjWzzr_7HGpnOX-NA",
    place: "Near San Luis, Arizona",
    shortName: "San Luis",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AZ",
    state: "Arizona",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-az-096",
    lat: 35.226291,
    lng: -111.62714,
    panoId: "nuog2xXCvdZWC85L9R7Guw",
    place: "Near Flagstaff, Arizona",
    shortName: "Flagstaff",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AZ",
    state: "Arizona",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-az-097",
    lat: 35.117267,
    lng: -114.263155,
    panoId: "LjoOp2nEDNAq3C1P6Chrgw",
    place: "Near Golden Valley, Arizona",
    shortName: "Golden Valley",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AZ",
    state: "Arizona",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-az-098",
    lat: 31.913963,
    lng: -110.214494,
    panoId: "ZtHqddHkCH1UpIvsHjoquw",
    place: "Near Saint David, Arizona",
    shortName: "Saint David",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AZ",
    state: "Arizona",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-az-099",
    lat: 36.146471,
    lng: -111.145184,
    panoId: "Kdx2WfDfBtzrOnzPQXT5Fw",
    place: "Near Tuba City, Arizona",
    shortName: "Tuba City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AZ",
    state: "Arizona",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-az-100",
    lat: 31.989209,
    lng: -111.114488,
    panoId: "Qy9i6Rcb0H5RY95BlqRv_A",
    place: "Near Sahuarita, Arizona",
    shortName: "Sahuarita",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AZ",
    state: "Arizona",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-AZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-az-101",
    lat: 35.113693,
    lng: -110.517811,
    panoId: "oevWsqDZEXpzavtQwMxRgg",
    place: "Near Winslow, Arizona",
    shortName: "Winslow",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AZ",
    state: "Arizona",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-AZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-az-102",
    lat: 34.087948,
    lng: -109.403406,
    panoId: "5cwHjNuJYr5AKbLkNXRwSg",
    place: "Near Eagar, Arizona",
    shortName: "Eagar",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AZ",
    state: "Arizona",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-AZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-az-103",
    lat: 34.506467,
    lng: -111.660884,
    panoId: "8RHOrRrhvxILyGjDIsIx6w",
    place: "Near Lake Montezuma, Arizona",
    shortName: "Lake Montezuma",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AZ",
    state: "Arizona",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-AZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-az-104",
    lat: 33.323814,
    lng: -110.332336,
    panoId: "DkK8t_SMAu_59VIQMEIrVQ",
    place: "Near Peridot, Arizona",
    shortName: "Peridot",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AZ",
    state: "Arizona",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-AZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-az-105",
    lat: 35.518803,
    lng: -108.910995,
    panoId: "GRqhcr90kOEKCxCgaQhcHA",
    place: "Near Gallup, Arizona",
    shortName: "Gallup",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AZ",
    state: "Arizona",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-AZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-az-106",
    lat: 34.775627,
    lng: -111.525684,
    panoId: "FYzPyE7IF9ZRkf1BzV8Rvw",
    place: "Near Village of Oak Creek (Big Park), Arizona",
    shortName: "Village of Oak Creek (Big Park)",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AZ",
    state: "Arizona",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-AZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-az-107",
    lat: 34.152166,
    lng: -109.157574,
    panoId: "5NCAhO070B9aImFbGENimg",
    place: "Near Springerville, Arizona",
    shortName: "Springerville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AZ",
    state: "Arizona",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-AZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ar-000",
    lat: 36.062543,
    lng: -94.157411,
    panoId: "jg7o40wdYkDdJQ6Ja7A-MA",
    place: "Near Fayetteville, Arkansas",
    shortName: "Fayetteville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "classic",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ar-001",
    lat: 34.769531,
    lng: -92.267169,
    panoId: "UjcF_6EYIlxqNkYjN1mcTw",
    place: "Near North Little Rock, Arkansas",
    shortName: "North Little Rock",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "classic",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ar-002",
    lat: 36.188104,
    lng: -94.540594,
    panoId: "5GU_zxkQQAtvnOGgCg5agQ",
    place: "Near Siloam Springs, Arkansas",
    shortName: "Siloam Springs",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "classic",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ar-003",
    lat: 36.332169,
    lng: -94.118562,
    panoId: "A0d3CHRBhl7JCr6zRkauzQ",
    place: "Near Rogers, Arkansas",
    shortName: "Rogers",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "classic",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ar-004",
    lat: 35.088824,
    lng: -92.442151,
    panoId: "MNayCea761iM_acV08WxSg",
    place: "Near Conway, Arkansas",
    shortName: "Conway",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "classic",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ar-005",
    lat: 35.214455,
    lng: -90.196508,
    panoId: "lREr3QtN3X0oO3zDQeEjZQ",
    place: "Near Marion, Arkansas",
    shortName: "Marion",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "classic",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ar-006",
    lat: 34.529119,
    lng: -90.589994,
    panoId: "yEkhT724NPhfeCu10mYSfg",
    place: "Near Helena-West Helena, Arkansas",
    shortName: "Helena-West Helena",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "classic",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ar-007",
    lat: 34.56457,
    lng: -92.586828,
    panoId: "njTL3xIQHXpaVPCAXoU6HA",
    place: "Near Benton, Arkansas",
    shortName: "Benton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "classic",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ar-008",
    lat: 36.372819,
    lng: -94.208829,
    panoId: "aPLmk27kY97GauhUk6d_yA",
    place: "Near Bentonville, Arkansas",
    shortName: "Bentonville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "classic",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ar-009",
    lat: 35.927405,
    lng: -89.918986,
    panoId: "FhbjcDyfKvxPzgGCjS4eqA",
    place: "Near Blytheville, Arkansas",
    shortName: "Blytheville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "classic",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ar-010",
    lat: 34.746445,
    lng: -92.289607,
    panoId: "MfiWxJs1hzheC_FwJQs7ew",
    place: "Near Little Rock, Arkansas",
    shortName: "Little Rock",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "classic",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-ar-011",
    lat: 35.385925,
    lng: -94.398553,
    panoId: "c1DlxwvabmZ18xOyFpS8rA",
    place: "Near Fort Smith, Arkansas",
    shortName: "Fort Smith",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "classic",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ar-012",
    lat: 35.278397,
    lng: -93.133696,
    panoId: "oYBr3Efowzx2uwGorzQsCA",
    place: "Near Russellville, Arkansas",
    shortName: "Russellville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "classic",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ar-013",
    lat: 34.595965,
    lng: -92.489103,
    panoId: "I3Evp7PVrUyDKFKZXQNxgA",
    place: "Near Bryant, Arkansas",
    shortName: "Bryant",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "classic",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ar-014",
    lat: 34.974579,
    lng: -92.016639,
    panoId: "oHh2Wb7jPvoTMEG2DnmqfA",
    place: "Near Cabot, Arkansas",
    shortName: "Cabot",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "classic",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ar-015",
    lat: 35.250618,
    lng: -91.736288,
    panoId: "caCtcodJAQIHBSl-jMMxpg",
    place: "Near Searcy, Arkansas",
    shortName: "Searcy",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "classic",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ar-016",
    lat: 34.866276,
    lng: -92.110235,
    panoId: "9WMmZVUHjrGbZbe-lTv8Wg",
    place: "Near Jacksonville, Arkansas",
    shortName: "Jacksonville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "classic",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ar-017",
    lat: 34.678344,
    lng: -92.994569,
    panoId: "0oIhx5-tC3m1MtWlecUCuA",
    place: "Near Hot Springs Village, Arkansas",
    shortName: "Hot Springs Village",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "classic",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ar-018",
    lat: 36.186738,
    lng: -94.128533,
    panoId: "QNmrA9snUnqCoihCdbIM-g",
    place: "Near Springdale, Arkansas",
    shortName: "Springdale",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "classic",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-ar-019",
    lat: 34.866587,
    lng: -92.404438,
    panoId: "d0E6vnkikp95yJ7NYyoZtw",
    place: "Near Maumelle, Arkansas",
    shortName: "Maumelle",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "classic",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ar-020",
    lat: 34.503706,
    lng: -93.055165,
    panoId: "659iXllDn5pFIz46lGJTBA",
    place: "Near Hot Springs, Arkansas",
    shortName: "Hot Springs",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "classic",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ar-021",
    lat: 34.228466,
    lng: -92.00333,
    panoId: "2ZAtB5T8pNk0YEME0EsaSw",
    place: "Near Pine Bluff, Arkansas",
    shortName: "Pine Bluff",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "classic",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ar-022",
    lat: 33.584608,
    lng: -92.83431,
    panoId: "TwAa8P3kEGOccB3eVxqMZg",
    place: "Near Camden, Arkansas",
    shortName: "Camden",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "classic",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ar-023",
    lat: 35.842086,
    lng: -90.704268,
    panoId: "o6nO_IxHBD6NThtyBWsmiQ",
    place: "Near Jonesboro, Arkansas",
    shortName: "Jonesboro",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "classic",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ar-024",
    lat: 36.481072,
    lng: -94.271237,
    panoId: "-x5bUMne62Zk4YTzzwfv6w",
    place: "Near Bella Vista, Arkansas",
    shortName: "Bella Vista",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "classic",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ar-025",
    lat: 33.441949,
    lng: -94.037636,
    panoId: "yR1FK-bL_AdJeWaTeK1aEQ",
    place: "Near Texarkana, Arkansas",
    shortName: "Texarkana",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "classic",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ar-026",
    lat: 36.359819,
    lng: -94.285242,
    panoId: "GUyWSSeDzhSHOK6lJtX_Bw",
    place: "Near Centerton, Arkansas",
    shortName: "Centerton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "classic",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ar-027",
    lat: 34.362116,
    lng: -92.81282,
    panoId: "lhV5-087RQK6uhZtGJBUlg",
    place: "Near Malvern, Arkansas",
    shortName: "Malvern",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "classic",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ar-028",
    lat: 33.267071,
    lng: -93.23933,
    panoId: "llY6RdMGHnBmA_4NCgnhTw",
    place: "Near Magnolia, Arkansas",
    shortName: "Magnolia",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "classic",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ar-029",
    lat: 35.43677,
    lng: -94.348309,
    panoId: "BEp5HFxaRfSlfU6O6L3lcQ",
    place: "Near Van Buren, Arkansas",
    shortName: "Van Buren",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "classic",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ar-030",
    lat: 36.229789,
    lng: -93.107686,
    panoId: "i-FgLo_VmxDnS4pg9ooQ3w",
    place: "Near Harrison, Arkansas",
    shortName: "Harrison",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "classic",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ar-031",
    lat: 36.058456,
    lng: -90.497412,
    panoId: "5J62Um9DCFOXkOuXYmV6wg",
    place: "Near Paragould, Arkansas",
    shortName: "Paragould",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "classic",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ar-032",
    lat: 35.008138,
    lng: -90.789817,
    panoId: "pyzvWSXZz_reG98I94bk6A",
    place: "Near Forrest City, Arkansas",
    shortName: "Forrest City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "classic",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ar-033",
    lat: 33.207664,
    lng: -92.666467,
    panoId: "Madjl3DRSCIpRefmgYp1jA",
    place: "Near El Dorado, Arkansas",
    shortName: "El Dorado",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "classic",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ar-034",
    lat: 36.33538,
    lng: -92.385113,
    panoId: "j49Ggkjr9iG_rR2JYL4gMQ",
    place: "Near Mountain Home, Arkansas",
    shortName: "Mountain Home",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "classic",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ar-035",
    lat: 33.629024,
    lng: -91.791011,
    panoId: "ZBar02gLU4t8YnSoL3TEXA",
    place: "Near Monticello, Arkansas",
    shortName: "Monticello",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "classic",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ar-036",
    lat: 34.120969,
    lng: -93.053753,
    panoId: "luKCzevYNvtpVuHapUAY6g",
    place: "Near Arkadelphia, Arkansas",
    shortName: "Arkadelphia",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "classic",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ar-037",
    lat: 35.769798,
    lng: -91.640974,
    panoId: "mwv1qu-8-0Zyo2JOrowy0g",
    place: "Near Batesville, Arkansas",
    shortName: "Batesville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "classic",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ar-038",
    lat: 35.22446,
    lng: -90.184809,
    panoId: "ku2igzwDC7BSS5PCA4kEUw",
    place: "Near Marion, Arkansas",
    shortName: "Marion",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "classic",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ar-039",
    lat: 34.510436,
    lng: -93.076561,
    panoId: "5GOuwqq2A5OLnIBsZpnMtw",
    place: "Near Hot Springs, Arkansas",
    shortName: "Hot Springs",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "classic",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ar-040",
    lat: 34.751437,
    lng: -92.268811,
    panoId: "nBUeGn1vOqlVaeAlZoZhbw",
    place: "Near Little Rock, Arkansas",
    shortName: "Little Rock",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "classic",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ar-041",
    lat: 34.658987,
    lng: -93.014673,
    panoId: "Xf56eLBOW4JzReY-jjQ_Pw",
    place: "Near Hot Springs Village, Arkansas",
    shortName: "Hot Springs Village",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "classic",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ar-042",
    lat: 36.197454,
    lng: -94.555142,
    panoId: "Nf7s7QQk94PDApikdY1kkw",
    place: "Near Siloam Springs, Arkansas",
    shortName: "Siloam Springs",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "classic",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ar-043",
    lat: 34.879365,
    lng: -92.411216,
    panoId: "F4GpElNZLFiH3GwzXNJiFw",
    place: "Near Maumelle, Arkansas",
    shortName: "Maumelle",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "classic",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ar-044",
    lat: 36.364139,
    lng: -94.201944,
    panoId: "v-wdISTvZ-CpXFrM6XXjuQ",
    place: "Near Bentonville, Arkansas",
    shortName: "Bentonville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "classic",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ar-045",
    lat: 33.667035,
    lng: -93.591609,
    panoId: "-Kw9QUyJh2NOhpyzF11iuA",
    place: "Near Hope, Arkansas",
    shortName: "Hope",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "classic",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ar-046",
    lat: 35.298476,
    lng: -93.123719,
    panoId: "kF-0knHlM-MobBZDwWl5hA",
    place: "Near Russellville, Arkansas",
    shortName: "Russellville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "classic",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ar-047",
    lat: 34.821963,
    lng: -92.237574,
    panoId: "wZf728U_X2YjPZ5TjTuL8w",
    place: "Near Sherwood, Arkansas",
    shortName: "Sherwood",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "classic",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ar-048",
    lat: 34.209107,
    lng: -92.003582,
    panoId: "km-nrKPhxAwr0zJC6_0BOg",
    place: "Near Pine Bluff, Arkansas",
    shortName: "Pine Bluff",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "classic",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ar-049",
    lat: 34.977961,
    lng: -92.029413,
    panoId: "wwa_S6M1qrhRdhoU4PPOCw",
    place: "Near Cabot, Arkansas",
    shortName: "Cabot",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "classic",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ar-050",
    lat: 34.574455,
    lng: -92.420411,
    panoId: "nVRdXq8Viy3h_fICzkf47w",
    place: "Near Shannon Hills, Arkansas",
    shortName: "Shannon Hills",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ar-051",
    lat: 34.585379,
    lng: -92.642095,
    panoId: "tngLJK_DiP5Z0XzXWr5w7w",
    place: "Near Benton, Arkansas",
    shortName: "Benton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ar-052",
    lat: 36.340513,
    lng: -94.222266,
    panoId: "AzMZPMFvvIXdy_zTdRoavg",
    place: "Near Bentonville, Arkansas",
    shortName: "Bentonville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ar-053",
    lat: 35.879274,
    lng: -89.89169,
    panoId: "694rMfsqrWD6p5Gdsnwvcw",
    place: "Near Blytheville, Arkansas",
    shortName: "Blytheville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ar-054",
    lat: 36.478907,
    lng: -94.352825,
    panoId: "3d_-1OpB4pMflexkKCPzkQ",
    place: "Near Bella Vista, Arkansas",
    shortName: "Bella Vista",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ar-055",
    lat: 33.25361,
    lng: -93.323175,
    panoId: "X0Xp6lzW1ZvCo0CATqtC7Q",
    place: "Near Magnolia, Arkansas",
    shortName: "Magnolia",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ar-056",
    lat: 33.585565,
    lng: -91.83609,
    panoId: "_6MjAkJdm3ueCilVgbKxCw",
    place: "Near Monticello, Arkansas",
    shortName: "Monticello",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ar-057",
    lat: 36.219436,
    lng: -94.139395,
    panoId: "0lVvCjPDh_QJQ4KDBkoPWw",
    place: "Near Bethel Heights, Arkansas",
    shortName: "Bethel Heights",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ar-058",
    lat: 36.122109,
    lng: -90.510721,
    panoId: "PH3Aq3qpq8RzhIUV7NvNfw",
    place: "Near Paragould, Arkansas",
    shortName: "Paragould",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ar-059",
    lat: 33.228314,
    lng: -92.744788,
    panoId: "soyqPSHsk-IGCqkhm8ZEWw",
    place: "Near El Dorado, Arkansas",
    shortName: "El Dorado",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ar-060",
    lat: 35.070479,
    lng: -92.470967,
    panoId: "u_wk2fIjtgUsSY6OEFNz2A",
    place: "Near Conway, Arkansas",
    shortName: "Conway",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ar-061",
    lat: 34.890728,
    lng: -92.081601,
    panoId: "36-EE7S5hV4DMQsoIM0skg",
    place: "Near Jacksonville, Arkansas",
    shortName: "Jacksonville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ar-062",
    lat: 34.158787,
    lng: -93.064862,
    panoId: "6lP_F04X4I3OB--4y8SlSw",
    place: "Near Arkadelphia, Arkansas",
    shortName: "Arkadelphia",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ar-063",
    lat: 35.836592,
    lng: -90.667823,
    panoId: "HC4Jree0GPKDhndzUm_gcA",
    place: "Near Jonesboro, Arkansas",
    shortName: "Jonesboro",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ar-064",
    lat: 35.2836,
    lng: -91.770403,
    panoId: "6wzMq_0zekEbKBiuR1XUDQ",
    place: "Near Searcy, Arkansas",
    shortName: "Searcy",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-ar-065",
    lat: 35.209156,
    lng: -90.254677,
    panoId: "ip4zwdbv5oCh07eUXYH1sw",
    place: "Near Marion, Arkansas",
    shortName: "Marion",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ar-066",
    lat: 33.635637,
    lng: -93.54747,
    panoId: "Nj3VzYYXNkxcBnXKRtIJtA",
    place: "Near Hope, Arkansas",
    shortName: "Hope",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ar-067",
    lat: 34.678758,
    lng: -92.267936,
    panoId: "3WwRBPNJM-XuoncuvN2cMw",
    place: "Near Little Rock, Arkansas",
    shortName: "Little Rock",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ar-068",
    lat: 34.303911,
    lng: -92.846321,
    panoId: "QN4rCrnhxZR6UxBocO_v0w",
    place: "Near Malvern, Arkansas",
    shortName: "Malvern",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ar-069",
    lat: 34.206639,
    lng: -91.960216,
    panoId: "pz-VVqH6pDbJYxncm_PYQQ",
    place: "Near Pine Bluff, Arkansas",
    shortName: "Pine Bluff",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ar-070",
    lat: 36.223623,
    lng: -94.495295,
    panoId: "LpUdnm4ZfRRKKc3ZZAj3Bg",
    place: "Near Gentry, Arkansas",
    shortName: "Gentry",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ar-071",
    lat: 36.406743,
    lng: -94.335735,
    panoId: "lpnLSWec6uDdLLxwRavNog",
    place: "Near Centerton, Arkansas",
    shortName: "Centerton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ar-072",
    lat: 36.270789,
    lng: -93.160779,
    panoId: "vlsZ-CVVWBP6BFIzL0WTsQ",
    place: "Near Harrison, Arkansas",
    shortName: "Harrison",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-ar-073",
    lat: 35.798793,
    lng: -91.717814,
    panoId: "wiQqUKcCkg3Sszom9uxArw",
    place: "Near Batesville, Arkansas",
    shortName: "Batesville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ar-074",
    lat: 34.494662,
    lng: -90.619988,
    panoId: "KLKo-btDKNoP9LM0B9kMAQ",
    place: "Near Helena, Arkansas",
    shortName: "Helena",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ar-075",
    lat: 33.596963,
    lng: -91.849986,
    panoId: "bVizZCQwsh42YByTzC8r5Q",
    place: "Near Monticello, Arkansas",
    shortName: "Monticello",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ar-076",
    lat: 34.801084,
    lng: -92.42421,
    panoId: "5pzT-z9X2FSCtbXlM0Psbg",
    place: "Near Maumelle, Arkansas",
    shortName: "Maumelle",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ar-077",
    lat: 34.988972,
    lng: -90.736027,
    panoId: "_tibyKHEkwHACSQKnS-V9w",
    place: "Near Forrest City, Arkansas",
    shortName: "Forrest City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ar-078",
    lat: 33.566194,
    lng: -92.907555,
    panoId: "kRuDGozk90UXFyQl-iYn2Q",
    place: "Near Camden, Arkansas",
    shortName: "Camden",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ar-079",
    lat: 33.253031,
    lng: -93.179466,
    panoId: "zXuIcH6lOJBfZyMypMzGNQ",
    place: "Near Magnolia, Arkansas",
    shortName: "Magnolia",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ar-080",
    lat: 36.035443,
    lng: -90.581398,
    panoId: "MA4Y2sZVM0gMvbWXS_2Mqg",
    place: "Near Paragould, Arkansas",
    shortName: "Paragould",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ar-081",
    lat: 34.622485,
    lng: -92.607453,
    panoId: "2HqVwsFJkAuPkSySgctPiQ",
    place: "Near Salem, Arkansas",
    shortName: "Salem",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ar-082",
    lat: 36.015432,
    lng: -94.180391,
    panoId: "oKH5qjp7lWkGGVjxR0YESw",
    place: "Near Greenland, Arkansas",
    shortName: "Greenland",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ar-083",
    lat: 34.474659,
    lng: -93.095314,
    panoId: "3Gv_oUNIkWKh5NeJlN9XnQ",
    place: "Near Rockwell, Arkansas",
    shortName: "Rockwell",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ar-084",
    lat: 34.616062,
    lng: -92.96553,
    panoId: "g-8hW-wyIkN9KSH5nphO5A",
    place: "Near Hot Springs Village, Arkansas",
    shortName: "Hot Springs Village",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ar-085",
    lat: 35.429633,
    lng: -94.438387,
    panoId: "WKry9ycqtBizv4rbCyJspg",
    place: "Near Fort Smith, Arkansas",
    shortName: "Fort Smith",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ar-086",
    lat: 33.443829,
    lng: -93.998244,
    panoId: "lm5Z_zmXj9TktpswD4AKNg",
    place: "Near Texarkana, Arkansas",
    shortName: "Texarkana",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ar-087",
    lat: 35.406341,
    lng: -94.286034,
    panoId: "vHO6aqWMmu9Jr2vqMSeY4w",
    place: "Near Van Buren, Arkansas",
    shortName: "Van Buren",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ar-088",
    lat: 34.626096,
    lng: -92.513889,
    panoId: "TCso2Ddsv58nkhdn5jX4Vg",
    place: "Near Bryant, Arkansas",
    shortName: "Bryant",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ar-089",
    lat: 36.396308,
    lng: -94.132448,
    panoId: "wl82yEUHoVU78UdQthb2uA",
    place: "Near Little Flock, Arkansas",
    shortName: "Little Flock",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ar-090",
    lat: 35.147146,
    lng: -92.415514,
    panoId: "SMpT4DSGu_3ZlLcRKBVJrw",
    place: "Near Conway, Arkansas",
    shortName: "Conway",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ar-091",
    lat: 35.464364,
    lng: -93.146035,
    panoId: "9pIjOEy-qxMUGlhZucY02g",
    place: "Near Dover, Arkansas",
    shortName: "Dover",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ar-092",
    lat: 35.14352,
    lng: -94.326289,
    panoId: "sMk5G4etWY_-q-4Q5b6PEw",
    place: "Near Greenwood, Arkansas",
    shortName: "Greenwood",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ar-093",
    lat: 36.449036,
    lng: -94.360551,
    panoId: "7lNnEGOlOxgIpn42VEcpiQ",
    place: "Near Bella Vista, Arkansas",
    shortName: "Bella Vista",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ar-094",
    lat: 33.357315,
    lng: -92.69547,
    panoId: "zK3N1hu7nHw-x7WsRZXZxw",
    place: "Near Smackover, Arkansas",
    shortName: "Smackover",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ar-095",
    lat: 33.780861,
    lng: -93.4636,
    panoId: "SCEtQpGRVQbqxb_cJd-eOw",
    place: "Near Prescott, Arkansas",
    shortName: "Prescott",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ar-096",
    lat: 35.544883,
    lng: -90.538288,
    panoId: "7RUuJxa52ID4gyCGJS1fcw",
    place: "Near Marked Tree, Arkansas",
    shortName: "Marked Tree",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ar-097",
    lat: 34.815609,
    lng: -92.442918,
    panoId: "X0YSVql9P1mBziJQcxwPpg",
    place: "Near Maumelle, Arkansas",
    shortName: "Maumelle",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ar-098",
    lat: 36.134162,
    lng: -94.149005,
    panoId: "OHsqmdmf6-KRrbZ9-KL-EQ",
    place: "Near Johnson, Arkansas",
    shortName: "Johnson",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ar-099",
    lat: 35.080151,
    lng: -91.75256,
    panoId: "bcCD94aYm23gj-l4IuOwWQ",
    place: "Near Beebe, Arkansas",
    shortName: "Beebe",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ar-100",
    lat: 35.835641,
    lng: -90.900824,
    panoId: "8bHdS_b5EG5ZWuQ0XGwwfg",
    place: "Near Bono, Arkansas",
    shortName: "Bono",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ar-101",
    lat: 35.146848,
    lng: -91.591462,
    panoId: "B5smIHyYb3vGhHDA-35rUA",
    place: "Near Kensett, Arkansas",
    shortName: "Kensett",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ar-102",
    lat: 34.185668,
    lng: -93.230789,
    panoId: "DlaftXJBw5d-qUnEw_2Vfw",
    place: "Near Arkadelphia, Arkansas",
    shortName: "Arkadelphia",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ar-103",
    lat: 36.520557,
    lng: -92.410555,
    panoId: "3sUL216n_f-fl4y4LA5-GA",
    place: "Near Gainesville, Arkansas",
    shortName: "Gainesville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ar-104",
    lat: 36.336339,
    lng: -90.810263,
    panoId: "z2vf7aLVdZh1LVufYlvJ3A",
    place: "Near Pocahontas, Arkansas",
    shortName: "Pocahontas",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ar-105",
    lat: 35.402142,
    lng: -90.809153,
    panoId: "EQ0uV9q3iCtbECWE-MayXw",
    place: "Near Wynne, Arkansas",
    shortName: "Wynne",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ar-106",
    lat: 35.500932,
    lng: -92.232582,
    panoId: "cv4sB8DG9x0Y2nJTXaDxwA",
    place: "Near Fairfield Bay, Arkansas",
    shortName: "Fairfield Bay",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ar-107",
    lat: 33.52069,
    lng: -92.187616,
    panoId: "ewJ0tHYALt4qkjuLOrh2Ww",
    place: "Near Warren, Arkansas",
    shortName: "Warren",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ar-108",
    lat: 35.241262,
    lng: -92.2203,
    panoId: "4wHfE-NkHzXDQnhYFGIrnQ",
    place: "Near Greenbrier, Arkansas",
    shortName: "Greenbrier",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ar-109",
    lat: 35.619715,
    lng: -93.57723,
    panoId: "IsP0YAsMxF8_76umYZgX1g",
    place: "Near Clarksville, Arkansas",
    shortName: "Clarksville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ar-110",
    lat: 34.533747,
    lng: -91.330373,
    panoId: "ql9mn7QZru-kOh7Dbt-rtA",
    place: "Near Clarendon, Arkansas",
    shortName: "Clarendon",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ar-111",
    lat: 34.432062,
    lng: -93.27701,
    panoId: "2SNbxFjkmoOSM3RDDK2oMA",
    place: "Near Rockwell, Arkansas",
    shortName: "Rockwell",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ar-112",
    lat: 36.211012,
    lng: -93.547207,
    panoId: "R0LG64Mnq9Ka2LfxKYKlGQ",
    place: "Near Green Forest, Arkansas",
    shortName: "Green Forest",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ar-113",
    lat: 35.667889,
    lng: -92.094353,
    panoId: "r54zF1waIHVW26H2WU_A_g",
    place: "Near Fairfield Bay, Arkansas",
    shortName: "Fairfield Bay",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "AR",
    state: "Arkansas",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ca-000",
    lat: 36.747737,
    lng: -119.7723,
    panoId: "4Yi8XJTmwWAkNTP5rBI4nw",
    place: "Near Fresno, California",
    shortName: "Fresno",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CA",
    state: "California",
    difficulty: "classic",
    pools: ["world","North America","US","US-CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ca-001",
    lat: 33.669465,
    lng: -117.82311,
    panoId: "kaz-7rewVGa7kHoKEPf4qA",
    place: "Near Irvine, California",
    shortName: "Irvine",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CA",
    state: "California",
    difficulty: "classic",
    pools: ["world","North America","US","US-CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ca-002",
    lat: 37.957657,
    lng: -121.290728,
    panoId: "FOKZ-QH8xqzsmIkf-EWsCA",
    place: "Near Stockton, California",
    shortName: "Stockton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CA",
    state: "California",
    difficulty: "classic",
    pools: ["world","North America","US","US-CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ca-003",
    lat: 38.581585,
    lng: -121.494412,
    panoId: "KheYeb5263_HFg2PCk8R7g",
    place: "Near Sacramento, California",
    shortName: "Sacramento",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CA",
    state: "California",
    difficulty: "classic",
    pools: ["world","North America","US","US-CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ca-004",
    lat: 32.715717,
    lng: -117.164727,
    panoId: "sI4N1Fkr0P4q9i1_WmvCew",
    place: "Near San Diego, California",
    shortName: "San Diego",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CA",
    state: "California",
    difficulty: "classic",
    pools: ["world","North America","US","US-CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ca-005",
    lat: 33.195855,
    lng: -117.37945,
    panoId: "8KHu_QGDtdnMOiFtUY-DPQ",
    place: "Near Oceanside, California",
    shortName: "Oceanside",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CA",
    state: "California",
    difficulty: "classic",
    pools: ["world","North America","US","US-CA"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-ca-006",
    lat: 33.119259,
    lng: -117.086411,
    panoId: "iLCASyyNOph6g4pU-LrT-Q",
    place: "Near Escondido, California",
    shortName: "Escondido",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CA",
    state: "California",
    difficulty: "classic",
    pools: ["world","North America","US","US-CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ca-007",
    lat: 34.052347,
    lng: -118.243573,
    panoId: "nmLECTTs4iqWaY84Vw_hUA",
    place: "Near Los Angeles, California",
    shortName: "Los Angeles",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CA",
    state: "California",
    difficulty: "classic",
    pools: ["world","North America","US","US-CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ca-008",
    lat: 34.108314,
    lng: -117.289797,
    panoId: "V5egn3GcCCup_q1mk0cOPQ",
    place: "Near San Bernardino, California",
    shortName: "San Bernardino",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CA",
    state: "California",
    difficulty: "classic",
    pools: ["world","North America","US","US-CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ca-009",
    lat: 34.443611,
    lng: -118.609576,
    panoId: "nxozceXbFieC9G-ejqWsbg",
    place: "Near Valencia, California",
    shortName: "Valencia",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CA",
    state: "California",
    difficulty: "classic",
    pools: ["world","North America","US","US-CA"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-ca-010",
    lat: 34.055288,
    lng: -117.752253,
    panoId: "ZpAQlvDZ9ZWBgRMVMfthng",
    place: "Near Pomona, California",
    shortName: "Pomona",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CA",
    state: "California",
    difficulty: "classic",
    pools: ["world","North America","US","US-CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ca-011",
    lat: 34.092149,
    lng: -117.435097,
    panoId: "w7D5RDjtumRXOHy_pBn0zg",
    place: "Near Fontana, California",
    shortName: "Fontana",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CA",
    state: "California",
    difficulty: "classic",
    pools: ["world","North America","US","US-CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ca-012",
    lat: 33.745536,
    lng: -117.867826,
    panoId: "XrKL3nOye5wjNwgOVmuDOw",
    place: "Near Santa Ana, California",
    shortName: "Santa Ana",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CA",
    state: "California",
    difficulty: "classic",
    pools: ["world","North America","US","US-CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ca-013",
    lat: 33.77382,
    lng: -117.94145,
    panoId: "rZPtJ-XYwe9t9n17L32ZKw",
    place: "Near Garden Grove, California",
    shortName: "Garden Grove",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CA",
    state: "California",
    difficulty: "classic",
    pools: ["world","North America","US","US-CA"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-ca-014",
    lat: 37.978018,
    lng: -122.03108,
    panoId: "793yofvc6EESGOTy7lSTQA",
    place: "Near Concord, California",
    shortName: "Concord",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CA",
    state: "California",
    difficulty: "classic",
    pools: ["world","North America","US","US-CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ca-015",
    lat: 34.06333,
    lng: -117.650828,
    panoId: "59RvYV9qS6ceadUG7Xq3jg",
    place: "Near Ontario, California",
    shortName: "Ontario",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CA",
    state: "California",
    difficulty: "classic",
    pools: ["world","North America","US","US-CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ca-016",
    lat: 34.269482,
    lng: -118.781262,
    panoId: "SKcYnVPzCLcmpketTedQBg",
    place: "Near Simi Valley, California",
    shortName: "Simi Valley",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CA",
    state: "California",
    difficulty: "classic",
    pools: ["world","North America","US","US-CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ca-017",
    lat: 33.660299,
    lng: -117.999506,
    panoId: "XO5dhLf5q0Hwkw4iTZhcBw",
    place: "Near Huntington Beach, California",
    shortName: "Huntington Beach",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CA",
    state: "California",
    difficulty: "classic",
    pools: ["world","North America","US","US-CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ca-018",
    lat: 37.774953,
    lng: -122.419428,
    panoId: "Uh_TXPyo-tHtuDFiI3VHCw",
    place: "Near San Francisco, California",
    shortName: "San Francisco",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CA",
    state: "California",
    difficulty: "classic",
    pools: ["world","North America","US","US-CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ca-019",
    lat: 33.787666,
    lng: -117.853075,
    panoId: "s_KokpVCWoCviCKhY2P0QQ",
    place: "Near Orange, California",
    shortName: "Orange",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CA",
    state: "California",
    difficulty: "classic",
    pools: ["world","North America","US","US-CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ca-020",
    lat: 34.39121,
    lng: -118.542079,
    panoId: "cUjnuE0N8Io693aJqPVjdw",
    place: "Near Santa Clarita, California",
    shortName: "Santa Clarita",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CA",
    state: "California",
    difficulty: "classic",
    pools: ["world","North America","US","US-CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ca-021",
    lat: 33.937265,
    lng: -117.230551,
    panoId: "08CRE4l9FfGRdV6YK_mOLg",
    place: "Near Moreno Valley, California",
    shortName: "Moreno Valley",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CA",
    state: "California",
    difficulty: "classic",
    pools: ["world","North America","US","US-CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ca-022",
    lat: 37.639113,
    lng: -120.996845,
    panoId: "nq0eJL7YJ2QNiFHg-KdCdA",
    place: "Near Modesto, California",
    shortName: "Modesto",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CA",
    state: "California",
    difficulty: "classic",
    pools: ["world","North America","US","US-CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ca-023",
    lat: 35.373316,
    lng: -119.018755,
    panoId: "tQLUE5Qj7KvmHe1PjlAS1g",
    place: "Near Bakersfield, California",
    shortName: "Bakersfield",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CA",
    state: "California",
    difficulty: "classic",
    pools: ["world","North America","US","US-CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ca-024",
    lat: 34.197674,
    lng: -119.176994,
    panoId: "qjcpoHDfDBSl7b5vZQ0Z0A",
    place: "Near Oxnard, California",
    shortName: "Oxnard",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CA",
    state: "California",
    difficulty: "classic",
    pools: ["world","North America","US","US-CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ca-025",
    lat: 34.698041,
    lng: -118.13688,
    panoId: "jgpHGFDLbjsoW6lE6MTPEw",
    place: "Near Lancaster, California",
    shortName: "Lancaster",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CA",
    state: "California",
    difficulty: "classic",
    pools: ["world","North America","US","US-CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ca-026",
    lat: 37.339365,
    lng: -121.894954,
    panoId: "L7tpJqVlBUmwb2ArXdhIHg",
    place: "Near San Jose, California",
    shortName: "San Jose",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CA",
    state: "California",
    difficulty: "classic",
    pools: ["world","North America","US","US-CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ca-027",
    lat: 36.677573,
    lng: -121.655449,
    panoId: "P5pui0uar1eWq0gAxIyAIg",
    place: "Near Salinas, California",
    shortName: "Salinas",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CA",
    state: "California",
    difficulty: "classic",
    pools: ["world","North America","US","US-CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ca-028",
    lat: 33.953255,
    lng: -117.396114,
    panoId: "qqsa5wdSx-2TtV49cMu3jA",
    place: "Near Riverside, California",
    shortName: "Riverside",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CA",
    state: "California",
    difficulty: "classic",
    pools: ["world","North America","US","US-CA"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-ca-029",
    lat: 34.170456,
    lng: -118.837766,
    panoId: "Q2_k4cfy6RB_nC8EnujGVA",
    place: "Near Thousand Oaks, California",
    shortName: "Thousand Oaks",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CA",
    state: "California",
    difficulty: "classic",
    pools: ["world","North America","US","US-CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ca-030",
    lat: 33.875348,
    lng: -117.566417,
    panoId: "wuwZl9A8AH9L_BO58WS0lQ",
    place: "Near Corona, California",
    shortName: "Corona",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CA",
    state: "California",
    difficulty: "classic",
    pools: ["world","North America","US","US-CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ca-031",
    lat: 34.579457,
    lng: -118.116411,
    panoId: "PGmxAzkU2oUC2V9Oefv1pA",
    place: "Near Palmdale, California",
    shortName: "Palmdale",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CA",
    state: "California",
    difficulty: "classic",
    pools: ["world","North America","US","US-CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ca-032",
    lat: 37.804228,
    lng: -122.270951,
    panoId: "5BEPtWkRkPAFoeV2ua_8bA",
    place: "Near Oakland, California",
    shortName: "Oakland",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CA",
    state: "California",
    difficulty: "classic",
    pools: ["world","North America","US","US-CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ca-033",
    lat: 38.440371,
    lng: -122.714288,
    panoId: "22n6humHn9DZf8d0vQgclQ",
    place: "Near Santa Rosa, California",
    shortName: "Santa Rosa",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CA",
    state: "California",
    difficulty: "classic",
    pools: ["world","North America","US","US-CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ca-034",
    lat: 34.106425,
    lng: -117.593174,
    panoId: "kO1rdlS04izoD1Pd-JjKxw",
    place: "Near Rancho Cucamonga, California",
    shortName: "Rancho Cucamonga",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CA",
    state: "California",
    difficulty: "classic",
    pools: ["world","North America","US","US-CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ca-035",
    lat: 36.33017,
    lng: -119.292076,
    panoId: "xDQZQGj9PPcrQ15pT86zMA",
    place: "Near Visalia, California",
    shortName: "Visalia",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CA",
    state: "California",
    difficulty: "classic",
    pools: ["world","North America","US","US-CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ca-036",
    lat: 39.728576,
    lng: -121.83756,
    panoId: "oltNFQyK_n-SyWOsvydemA",
    place: "Near Chico, California",
    shortName: "Chico",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CA",
    state: "California",
    difficulty: "classic",
    pools: ["world","North America","US","US-CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ca-037",
    lat: 33.641101,
    lng: -117.918664,
    panoId: "pCIEZo_EJDQAU_MkXUngjw",
    place: "Near Costa Mesa, California",
    shortName: "Costa Mesa",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CA",
    state: "California",
    difficulty: "classic",
    pools: ["world","North America","US","US-CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ca-038",
    lat: 33.158025,
    lng: -117.350816,
    panoId: "qvPr2hBOqmQyEmJLfdbGGA",
    place: "Near Carlsbad, California",
    shortName: "Carlsbad",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CA",
    state: "California",
    difficulty: "classic",
    pools: ["world","North America","US","US-CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ca-039",
    lat: 34.535533,
    lng: -117.291814,
    panoId: "4aGAGNqpdho6PnNfP_MZOw",
    place: "Near Victorville, California",
    shortName: "Victorville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CA",
    state: "California",
    difficulty: "classic",
    pools: ["world","North America","US","US-CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ca-040",
    lat: 37.9653,
    lng: -122.030101,
    panoId: "isfrIr40C-5tP8Cp2AOZBQ",
    place: "Near Concord, California",
    shortName: "Concord",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CA",
    state: "California",
    difficulty: "classic",
    pools: ["world","North America","US","US-CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ca-041",
    lat: 32.704373,
    lng: -117.152324,
    panoId: "_4UOVyQUE4snQ_cBlilQgQ",
    place: "Near San Diego, California",
    shortName: "San Diego",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CA",
    state: "California",
    difficulty: "classic",
    pools: ["world","North America","US","US-CA"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "us-ca-042",
    lat: 34.402893,
    lng: -118.527492,
    panoId: "6ZKWXcmGM8ZdEwr7BTWECA",
    place: "Near Santa Clarita, California",
    shortName: "Santa Clarita",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CA",
    state: "California",
    difficulty: "classic",
    pools: ["world","North America","US","US-CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ca-043",
    lat: 34.103881,
    lng: -117.432164,
    panoId: "70cm6d2fzyoejYigjh-YCA",
    place: "Near Fontana, California",
    shortName: "Fontana",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CA",
    state: "California",
    difficulty: "classic",
    pools: ["world","North America","US","US-CA"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-ca-044",
    lat: 33.760986,
    lng: -117.878574,
    panoId: "w1htWZNEQY8L0r9xTZcAPw",
    place: "Near Santa Ana, California",
    shortName: "Santa Ana",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CA",
    state: "California",
    difficulty: "classic",
    pools: ["world","North America","US","US-CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ca-045",
    lat: 34.107393,
    lng: -117.264289,
    panoId: "9fU1v_KLY1TiX9OKIhRsow",
    place: "Near San Bernardino, California",
    shortName: "San Bernardino",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CA",
    state: "California",
    difficulty: "classic",
    pools: ["world","North America","US","US-CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ca-046",
    lat: 34.066682,
    lng: -118.227873,
    panoId: "jf7-EtHavdYFaKxsFkW9kw",
    place: "Near Los Angeles, California",
    shortName: "Los Angeles",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CA",
    state: "California",
    difficulty: "classic",
    pools: ["world","North America","US","US-CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ca-047",
    lat: 34.567336,
    lng: -118.111646,
    panoId: "8pnF7xhRjhLEcELUsh1tMA",
    place: "Near Palmdale, California",
    shortName: "Palmdale",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CA",
    state: "California",
    difficulty: "classic",
    pools: ["world","North America","US","US-CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ca-048",
    lat: 38.426679,
    lng: -122.728547,
    panoId: "fIPT693Uj0eSaYuUuMBwhg",
    place: "Near Roseland, California",
    shortName: "Roseland",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CA",
    state: "California",
    difficulty: "classic",
    pools: ["world","North America","US","US-CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ca-049",
    lat: 34.256085,
    lng: -118.766674,
    panoId: "c0jtiE9vF_05xJ17au3c_Q",
    place: "Near Simi Valley, California",
    shortName: "Simi Valley",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CA",
    state: "California",
    difficulty: "classic",
    pools: ["world","North America","US","US-CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ca-050",
    lat: 37.744223,
    lng: -122.236995,
    panoId: "XKdcPtwLKrBHuZnADo_TNQ",
    place: "Near Alameda, California",
    shortName: "Alameda",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CA",
    state: "California",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ca-051",
    lat: 33.94641,
    lng: -117.148004,
    panoId: "GkUscscygUtSEquu_NyF7w",
    place: "Near Moreno Valley, California",
    shortName: "Moreno Valley",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CA",
    state: "California",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ca-052",
    lat: 34.718697,
    lng: -118.161255,
    panoId: "SbTYtZl6lwy6UxFsdb8BmQ",
    place: "Near Lancaster, California",
    shortName: "Lancaster",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CA",
    state: "California",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ca-053",
    lat: 37.92869,
    lng: -121.214669,
    panoId: "bU5k7GGFGaPKoodYLhDDaw",
    place: "Near Kennedy, California",
    shortName: "Kennedy",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CA",
    state: "California",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ca-054",
    lat: 34.138615,
    lng: -117.653029,
    panoId: "Nb7eDYtbarH2GSNbTroomg",
    place: "Near San Antonio Heights, California",
    shortName: "San Antonio Heights",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CA",
    state: "California",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ca-055",
    lat: 33.806451,
    lng: -117.93373,
    panoId: "3TPTiyl_1S9LxZ8XHQ6gpQ",
    place: "Near Anaheim, California",
    shortName: "Anaheim",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CA",
    state: "California",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ca-056",
    lat: 36.269823,
    lng: -119.252692,
    panoId: "g0XBlrcxxtNMGiQn4cm2mw",
    place: "Near Farmersville, California",
    shortName: "Farmersville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CA",
    state: "California",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ca-057",
    lat: 37.657468,
    lng: -120.922873,
    panoId: "NJS7MqbJrrO_irwsBQnPyw",
    place: "Near Empire, California",
    shortName: "Empire",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CA",
    state: "California",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ca-058",
    lat: 34.231919,
    lng: -118.816787,
    panoId: "03BDK1pUgZravIdQnl12iA",
    place: "Near Simi Valley, California",
    shortName: "Simi Valley",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CA",
    state: "California",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ca-059",
    lat: 33.843323,
    lng: -117.558988,
    panoId: "y4FLnK_Z3kW13BgVAZniXw",
    place: "Near El Cerrito Corona, California",
    shortName: "El Cerrito Corona",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CA",
    state: "California",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ca-060",
    lat: 39.782657,
    lng: -121.883292,
    panoId: "EwqOkBnRPXpGXrgK5PfApQ",
    place: "Near Chico, California",
    shortName: "Chico",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CA",
    state: "California",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ca-061",
    lat: 35.357864,
    lng: -118.936476,
    panoId: "xU0lWeSyRRGejj3fSlFikg",
    place: "Near Bakersfield, California",
    shortName: "Bakersfield",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CA",
    state: "California",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ca-062",
    lat: 36.706847,
    lng: -119.752923,
    panoId: "rZBcW2F5MDCL9HnLV18m6A",
    place: "Near Fresno, California",
    shortName: "Fresno",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CA",
    state: "California",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ca-063",
    lat: 34.484513,
    lng: -117.301085,
    panoId: "ljjTy-vJiclE1H93kHoyWA",
    place: "Near Spring Valley Lake, California",
    shortName: "Spring Valley Lake",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CA",
    state: "California",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ca-064",
    lat: 34.148685,
    lng: -118.921182,
    panoId: "uO7L3S5im6kTxkFBRm9ErQ",
    place: "Near Casa Conejo, California",
    shortName: "Casa Conejo",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CA",
    state: "California",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ca-065",
    lat: 37.390514,
    lng: -121.871239,
    panoId: "_C9Yti2S237lt5I5aNLqJA",
    place: "Near Alum Rock, California",
    shortName: "Alum Rock",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CA",
    state: "California",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CA"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-ca-066",
    lat: 36.678711,
    lng: -121.725229,
    panoId: "2e4tD1v4OMT2COsayxhdAA",
    place: "Near Boronda, California",
    shortName: "Boronda",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CA",
    state: "California",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ca-067",
    lat: 34.188348,
    lng: -119.242707,
    panoId: "HTmrSZipa6kFPNmr4Vk85g",
    place: "Near Channel Islands Beach, California",
    shortName: "Channel Islands Beach",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CA",
    state: "California",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CA"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-ca-068",
    lat: 34.015073,
    lng: -117.589241,
    panoId: "NEmd46rjeAcs0EnaoKlCcg",
    place: "Near Eastvale, California",
    shortName: "Eastvale",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CA",
    state: "California",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ca-069",
    lat: 37.583127,
    lng: -121.048445,
    panoId: "iN8BcxJ4wGp61eYTmhti9w",
    place: "Near Riverdale Park, California",
    shortName: "Riverdale Park",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CA",
    state: "California",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ca-070",
    lat: 36.767547,
    lng: -119.716949,
    panoId: "XVFyndBIDmnonBlCGkeMBA",
    place: "Near Tarpey Village, California",
    shortName: "Tarpey Village",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CA",
    state: "California",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CA"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-ca-071",
    lat: 33.615896,
    lng: -117.864878,
    panoId: "BtDRLdr1ucCufTToU30aYA",
    place: "Near San Joaquin Hills, California",
    shortName: "San Joaquin Hills",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CA",
    state: "California",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ca-072",
    lat: 34.154652,
    lng: -117.577125,
    panoId: "MFABfkCGtIYpDJg4ZUtKiA",
    place: "Near Rancho Cucamonga, California",
    shortName: "Rancho Cucamonga",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CA",
    state: "California",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ca-073",
    lat: 34.586395,
    lng: -118.061708,
    panoId: "Cs3qa721l8_wNL8WVKalZA",
    place: "Near Palmdale, California",
    shortName: "Palmdale",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CA",
    state: "California",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ca-074",
    lat: 38.401976,
    lng: -122.777017,
    panoId: "dSEYUQ7Ud8qh5iLcRq8vbg",
    place: "Near Sebastopol, California",
    shortName: "Sebastopol",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CA",
    state: "California",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ca-075",
    lat: 38.007203,
    lng: -122.092683,
    panoId: "v8i4c8nGEcnUQwF59ij4aw",
    place: "Near Vine Hill, California",
    shortName: "Vine Hill",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CA",
    state: "California",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ca-076",
    lat: 39.735783,
    lng: -121.756067,
    panoId: "kHocRfZXxj--4nIC0mT7hA",
    place: "Near Chico, California",
    shortName: "Chico",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CA",
    state: "California",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ca-077",
    lat: 34.733073,
    lng: -118.195547,
    panoId: "tsM-GXITKYC9u_tNVJnJrw",
    place: "Near Lancaster, California",
    shortName: "Lancaster",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CA",
    state: "California",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ca-078",
    lat: 33.112627,
    lng: -117.120232,
    panoId: "qRkmMzC0Q-kKdVERZLO0LA",
    place: "Near Escondido, California",
    shortName: "Escondido",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CA",
    state: "California",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ca-079",
    lat: 35.297368,
    lng: -119.018526,
    panoId: "bl5A8KhiyrzdDXuLwaLi5g",
    place: "Near Greenfield, California",
    shortName: "Greenfield",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CA",
    state: "California",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ca-080",
    lat: 33.997781,
    lng: -117.371359,
    panoId: "xR5a8hMjsKpWoktexUFqhQ",
    place: "Near Rubidoux, California",
    shortName: "Rubidoux",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CA",
    state: "California",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ca-081",
    lat: 33.295846,
    lng: -117.220211,
    panoId: "85y14wwJziMCFC8ag-z5nA",
    place: "Near Bonsall, California",
    shortName: "Bonsall",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CA",
    state: "California",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ca-082",
    lat: 38.444964,
    lng: -121.38985,
    panoId: "xJIvPKf_NP7CQcArWygTNg",
    place: "Near Laguna, California",
    shortName: "Laguna",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CA",
    state: "California",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ca-083",
    lat: 33.536781,
    lng: -117.113071,
    panoId: "MwLaNENlPpK7MX-iSgW1qg",
    place: "Near Murrieta Hot Springs, California",
    shortName: "Murrieta Hot Springs",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CA",
    state: "California",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ca-084",
    lat: 37.825589,
    lng: -121.167163,
    panoId: "miNOXKC_vwwqzX2G1Xc2eA",
    place: "Near Manteca, California",
    shortName: "Manteca",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CA",
    state: "California",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ca-085",
    lat: 34.514184,
    lng: -117.477471,
    panoId: "XFZuLylxMINSLZyzvoAqlg",
    place: "Near Adelanto, California",
    shortName: "Adelanto",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CA",
    state: "California",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ca-086",
    lat: 34.209558,
    lng: -117.362575,
    panoId: "KAm5Vjd7CpYHztX7gr5BxQ",
    place: "Near Muscoy, California",
    shortName: "Muscoy",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CA",
    state: "California",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ca-087",
    lat: 33.190095,
    lng: -117.116942,
    panoId: "5Np41UjNG5fE7rC5GuCygA",
    place: "Near Hidden Meadows, California",
    shortName: "Hidden Meadows",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CA",
    state: "California",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ca-088",
    lat: 37.842284,
    lng: -121.467672,
    panoId: "7cH_mBCaG8yjZg1vdwb1jQ",
    place: "Near Mountain House, California",
    shortName: "Mountain House",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CA",
    state: "California",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ca-089",
    lat: 33.452552,
    lng: -117.269159,
    panoId: "EdoEzTz0tyOqbIpreGQscQ",
    place: "Near Fallbrook, California",
    shortName: "Fallbrook",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CA",
    state: "California",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ca-090",
    lat: 40.51699,
    lng: -122.456235,
    panoId: "Z-PNiU_0pLXqStrxFu049A",
    place: "Near Redding, California",
    shortName: "Redding",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CA",
    state: "California",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ca-091",
    lat: 33.577919,
    lng: -117.251714,
    panoId: "62twZDN6hUeYf8F7N0nKRA",
    place: "Near Wildomar, California",
    shortName: "Wildomar",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CA",
    state: "California",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ca-092",
    lat: 37.501646,
    lng: -122.335479,
    panoId: "wmu5K9feWbvztBa5MFBO8A",
    place: "Near Highlands-Baywood Park, California",
    shortName: "Highlands-Baywood Park",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CA",
    state: "California",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ca-093",
    lat: 34.880094,
    lng: -120.347424,
    panoId: "FmLhpvpC9aND91A4sk8drg",
    place: "Near Orcutt, California",
    shortName: "Orcutt",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CA",
    state: "California",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ca-094",
    lat: 34.348583,
    lng: -119.146838,
    panoId: "u8mQ8hqDIApPhxgSrzmX_g",
    place: "Near Saticoy, California",
    shortName: "Saticoy",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CA",
    state: "California",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ca-095",
    lat: 33.923966,
    lng: -117.802974,
    panoId: "5GrGAwIAU6FKlHG9nSDegg",
    place: "Near Yorba Linda, California",
    shortName: "Yorba Linda",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CA",
    state: "California",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ca-096",
    lat: 33.206653,
    lng: -117.160184,
    panoId: "ol05UuOvvugRjmPgsXtfsQ",
    place: "Near Hidden Meadows, California",
    shortName: "Hidden Meadows",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CA",
    state: "California",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ca-097",
    lat: 33.919143,
    lng: -117.701737,
    panoId: "1q-4FabHpDky8NC9JbAdkw",
    place: "Near Los Serranos, California",
    shortName: "Los Serranos",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CA",
    state: "California",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CA"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-ca-098",
    lat: 34.140672,
    lng: -117.578306,
    panoId: "oF9fX7mc8ZEi1oZe-wmQRw",
    place: "Near Rancho Cucamonga, California",
    shortName: "Rancho Cucamonga",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CA",
    state: "California",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ca-099",
    lat: 33.650597,
    lng: -117.156311,
    panoId: "jxeEZQrUPfe3O2mJ9O1lxA",
    place: "Near Sun City, California",
    shortName: "Sun City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CA",
    state: "California",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ca-100",
    lat: 36.389133,
    lng: -119.206642,
    panoId: "fm5SUb7LzgIXb5dHNfnY6A",
    place: "Near Ivanhoe, California",
    shortName: "Ivanhoe",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CA",
    state: "California",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ca-101",
    lat: 37.229254,
    lng: -120.345511,
    panoId: "b7V7z5Koa5fRZq5V34-96g",
    place: "Near Planada, California",
    shortName: "Planada",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CA",
    state: "California",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ca-102",
    lat: 38.456231,
    lng: -122.181355,
    panoId: "WGkMfQ0mbjqmNtdcBR_lMQ",
    place: "Near Yountville, California",
    shortName: "Yountville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CA",
    state: "California",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ca-103",
    lat: 33.277149,
    lng: -117.138308,
    panoId: "s1NQaTiCNDw6vEGBuG6vUA",
    place: "Near Hidden Meadows, California",
    shortName: "Hidden Meadows",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CA",
    state: "California",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ca-104",
    lat: 33.381671,
    lng: -117.124905,
    panoId: "Wcu_aB6F0VN25vNW1o5W4Q",
    place: "Near Rainbow, California",
    shortName: "Rainbow",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CA",
    state: "California",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ca-105",
    lat: 38.314801,
    lng: -121.75885,
    panoId: "Z0GHjAJHzUjmNasw_r8QLQ",
    place: "Near Dixon, California",
    shortName: "Dixon",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CA",
    state: "California",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-CA"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-co-000",
    lat: 40.09954,
    lng: -104.9372,
    panoId: "wG-7nxJBv53157dYeNnMXA",
    place: "Near Frederick, Colorado",
    shortName: "Frederick",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CO",
    state: "Colorado",
    difficulty: "classic",
    pools: ["world","North America","US","US-CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-co-001",
    lat: 40.625825,
    lng: -103.207574,
    panoId: "dHp-nYFeu7mi-DWGdELUrw",
    place: "Near Sterling, Colorado",
    shortName: "Sterling",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CO",
    state: "Colorado",
    difficulty: "classic",
    pools: ["world","North America","US","US-CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-co-002",
    lat: 39.739236,
    lng: -104.985316,
    panoId: "PkME6kJPCQi3m55NIqs6aw",
    place: "Near Denver, Colorado",
    shortName: "Denver",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CO",
    state: "Colorado",
    difficulty: "classic",
    pools: ["world","North America","US","US-CO"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "us-co-003",
    lat: 40.477199,
    lng: -104.901243,
    panoId: "ad7XiI8VmLzD0Yakf0Ssbg",
    place: "Near Windsor, Colorado",
    shortName: "Windsor",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CO",
    state: "Colorado",
    difficulty: "classic",
    pools: ["world","North America","US","US-CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-co-004",
    lat: 40.397566,
    lng: -105.075028,
    panoId: "vNLGtof30LeJ71YWAeQwEA",
    place: "Near Loveland, Colorado",
    shortName: "Loveland",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CO",
    state: "Colorado",
    difficulty: "classic",
    pools: ["world","North America","US","US-CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-co-005",
    lat: 38.478401,
    lng: -107.876222,
    panoId: "uVmgHL_CMCxkd9Vng41Ukw",
    place: "Near Montrose, Colorado",
    shortName: "Montrose",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CO",
    state: "Colorado",
    difficulty: "classic",
    pools: ["world","North America","US","US-CO"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-co-006",
    lat: 38.254229,
    lng: -104.608688,
    panoId: "TjpZnHnOQXVYrAjBjGNYJg",
    place: "Near Pueblo, Colorado",
    shortName: "Pueblo",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CO",
    state: "Colorado",
    difficulty: "classic",
    pools: ["world","North America","US","US-CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-co-007",
    lat: 39.75553,
    lng: -105.22114,
    panoId: "Yr-6JjmDQDEvJuv0LGY9_A",
    place: "Near Golden, Colorado",
    shortName: "Golden",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CO",
    state: "Colorado",
    difficulty: "classic",
    pools: ["world","North America","US","US-CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-co-008",
    lat: 40.485243,
    lng: -106.832107,
    panoId: "NmFIW90Ky-Sq5rNxVNqe0g",
    place: "Near Steamboat Springs, Colorado",
    shortName: "Steamboat Springs",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CO",
    state: "Colorado",
    difficulty: "classic",
    pools: ["world","North America","US","US-CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-co-009",
    lat: 38.747281,
    lng: -104.718992,
    panoId: "Mj8mcRsYw8H2PztUgshnKg",
    place: "Near Security-Widefield, Colorado",
    shortName: "Security-Widefield",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CO",
    state: "Colorado",
    difficulty: "classic",
    pools: ["world","North America","US","US-CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-co-010",
    lat: 40.423303,
    lng: -104.709128,
    panoId: "lfsSbFzVMB95mQjbFzMU4A",
    place: "Near Greeley, Colorado",
    shortName: "Greeley",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CO",
    state: "Colorado",
    difficulty: "classic",
    pools: ["world","North America","US","US-CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-co-011",
    lat: 39.985252,
    lng: -104.820482,
    panoId: "7x1cV7wphAVhtHw-fSsrTg",
    place: "Near Brighton, Colorado",
    shortName: "Brighton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CO",
    state: "Colorado",
    difficulty: "classic",
    pools: ["world","North America","US","US-CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-co-012",
    lat: 38.83392,
    lng: -104.821333,
    panoId: "HIp7Rd0JmTFpTrYutNklrQ",
    place: "Near Colorado Springs, Colorado",
    shortName: "Colorado Springs",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CO",
    state: "Colorado",
    difficulty: "classic",
    pools: ["world","North America","US","US-CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-co-013",
    lat: 39.920366,
    lng: -105.086771,
    panoId: "EOBZyxs9ZlUsxvykzqA9XQ",
    place: "Near Broomfield, Colorado",
    shortName: "Broomfield",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CO",
    state: "Colorado",
    difficulty: "classic",
    pools: ["world","North America","US","US-CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-co-014",
    lat: 39.091823,
    lng: -108.448981,
    panoId: "wlAjJAEp_LspAGX_2Hz2CQ",
    place: "Near Clifton, Colorado",
    shortName: "Clifton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CO",
    state: "Colorado",
    difficulty: "classic",
    pools: ["world","North America","US","US-CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-co-015",
    lat: 39.534727,
    lng: -107.783308,
    panoId: "pEBECaD6MZeZP5Hu0tBaYQ",
    place: "Near Rifle, Colorado",
    shortName: "Rifle",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CO",
    state: "Colorado",
    difficulty: "classic",
    pools: ["world","North America","US","US-CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-co-016",
    lat: 39.013062,
    lng: -104.700538,
    panoId: "ReshKcAcs1GGesFgbSm_ow",
    place: "Near Black Forest, Colorado",
    shortName: "Black Forest",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CO",
    state: "Colorado",
    difficulty: "classic",
    pools: ["world","North America","US","US-CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-co-017",
    lat: 40.515286,
    lng: -107.546042,
    panoId: "NFTeMT0K5X3TLEM0uo4dww",
    place: "Near Craig, Colorado",
    shortName: "Craig",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CO",
    state: "Colorado",
    difficulty: "classic",
    pools: ["world","North America","US","US-CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-co-018",
    lat: 37.469431,
    lng: -105.870151,
    panoId: "cCxvaeouaSDTAy2Jnd9f4g",
    place: "Near Alamosa, Colorado",
    shortName: "Alamosa",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CO",
    state: "Colorado",
    difficulty: "classic",
    pools: ["world","North America","US","US-CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-co-019",
    lat: 39.644972,
    lng: -106.593965,
    panoId: "W1Lgd-un8N7CbDfGJsl_Kg",
    place: "Near Edwards, Colorado",
    shortName: "Edwards",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CO",
    state: "Colorado",
    difficulty: "classic",
    pools: ["world","North America","US","US-CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-co-020",
    lat: 40.014961,
    lng: -105.270239,
    panoId: "51qaSaw9DwR1_0ExlPyTXg",
    place: "Near Boulder, Colorado",
    shortName: "Boulder",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CO",
    state: "Colorado",
    difficulty: "classic",
    pools: ["world","North America","US","US-CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-co-021",
    lat: 40.250251,
    lng: -103.800206,
    panoId: "RpY2EZNf_LD3D2RWCzzivw",
    place: "Near Fort Morgan, Colorado",
    shortName: "Fort Morgan",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CO",
    state: "Colorado",
    difficulty: "classic",
    pools: ["world","North America","US","US-CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-co-022",
    lat: 39.064381,
    lng: -108.550675,
    panoId: "Gy-VEsEDrZlJ3f3HDJxT9Q",
    place: "Near Grand Junction, Colorado",
    shortName: "Grand Junction",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CO",
    state: "Colorado",
    difficulty: "classic",
    pools: ["world","North America","US","US-CO"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-co-023",
    lat: 39.158921,
    lng: -108.728992,
    panoId: "0RaGaD4ha4045Crrh7Voxw",
    place: "Near Fruita, Colorado",
    shortName: "Fruita",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CO",
    state: "Colorado",
    difficulty: "classic",
    pools: ["world","North America","US","US-CO"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-co-024",
    lat: 37.275323,
    lng: -107.880086,
    panoId: "Bw5UXU_jU_oX6erjlYCYjg",
    place: "Near Durango, Colorado",
    shortName: "Durango",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CO",
    state: "Colorado",
    difficulty: "classic",
    pools: ["world","North America","US","US-CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-co-025",
    lat: 40.585232,
    lng: -105.084298,
    panoId: "q4B3OZ9pfPvuGTW6MKpEqQ",
    place: "Near Fort Collins, Colorado",
    shortName: "Fort Collins",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CO",
    state: "Colorado",
    difficulty: "classic",
    pools: ["world","North America","US","US-CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-co-026",
    lat: 39.372178,
    lng: -104.856324,
    panoId: "mipCz8tcfXe5muS8S0WvsA",
    place: "Near Castle Rock, Colorado",
    shortName: "Castle Rock",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CO",
    state: "Colorado",
    difficulty: "classic",
    pools: ["world","North America","US","US-CO"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-co-027",
    lat: 39.550538,
    lng: -107.32492,
    panoId: "UKu4jNqXSHIIwt3LQGI-fA",
    place: "Near Glenwood Springs, Colorado",
    shortName: "Glenwood Springs",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CO",
    state: "Colorado",
    difficulty: "classic",
    pools: ["world","North America","US","US-CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-co-028",
    lat: 40.376541,
    lng: -104.692613,
    panoId: "gCWR2USbYsdmF-8i3i3iAQ",
    place: "Near Evans, Colorado",
    shortName: "Evans",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CO",
    state: "Colorado",
    difficulty: "classic",
    pools: ["world","North America","US","US-CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-co-029",
    lat: 39.613225,
    lng: -105.016684,
    panoId: "gb13Y2kPHeYv3BPfA-lUaQ",
    place: "Near Littleton, Colorado",
    shortName: "Littleton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CO",
    state: "Colorado",
    difficulty: "classic",
    pools: ["world","North America","US","US-CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-co-030",
    lat: 38.682222,
    lng: -104.700669,
    panoId: "8zuDD7t59VFBQhmjZkDuvA",
    place: "Near Fountain, Colorado",
    shortName: "Fountain",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CO",
    state: "Colorado",
    difficulty: "classic",
    pools: ["world","North America","US","US-CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-co-031",
    lat: 40.167171,
    lng: -105.101861,
    panoId: "Je-bTgA5tXTtS6u-TaKnnA",
    place: "Near Longmont, Colorado",
    shortName: "Longmont",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CO",
    state: "Colorado",
    difficulty: "classic",
    pools: ["world","North America","US","US-CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-co-032",
    lat: 40.112272,
    lng: -104.936694,
    panoId: "KcsVk3g9HRmiqwyfk5Cc3Q",
    place: "Near Firestone, Colorado",
    shortName: "Firestone",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CO",
    state: "Colorado",
    difficulty: "classic",
    pools: ["world","North America","US","US-CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-co-033",
    lat: 37.348612,
    lng: -108.585959,
    panoId: "MDYkrQR_NzxfkktgQBJJTg",
    place: "Near Cortez, Colorado",
    shortName: "Cortez",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CO",
    state: "Colorado",
    difficulty: "classic",
    pools: ["world","North America","US","US-CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-co-034",
    lat: 38.742195,
    lng: -108.068754,
    panoId: "AQfw9fJrexG3vDHlmWZ-mQ",
    place: "Near Delta, Colorado",
    shortName: "Delta",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CO",
    state: "Colorado",
    difficulty: "classic",
    pools: ["world","North America","US","US-CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-co-035",
    lat: 38.440875,
    lng: -105.242355,
    panoId: "hZtWPW2QCFsb0dtMySf34g",
    place: "Near Cañon City, Colorado",
    shortName: "Cañon City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CO",
    state: "Colorado",
    difficulty: "classic",
    pools: ["world","North America","US","US-CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-co-036",
    lat: 38.337174,
    lng: -104.72763,
    panoId: "GSg91le1jBEiHvnhnDL5PQ",
    place: "Near Pueblo West, Colorado",
    shortName: "Pueblo West",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CO",
    state: "Colorado",
    difficulty: "classic",
    pools: ["world","North America","US","US-CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-co-037",
    lat: 37.266507,
    lng: -107.877812,
    panoId: "dbKeGbRp334tA3iXFIEqqg",
    place: "Near Durango, Colorado",
    shortName: "Durango",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CO",
    state: "Colorado",
    difficulty: "classic",
    pools: ["world","North America","US","US-CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-co-038",
    lat: 39.101684,
    lng: -104.84809,
    panoId: "Vu5nFkmKpmLE7KUPwWFFNA",
    place: "Near Woodmoor, Colorado",
    shortName: "Woodmoor",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CO",
    state: "Colorado",
    difficulty: "classic",
    pools: ["world","North America","US","US-CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-co-039",
    lat: 40.491727,
    lng: -104.926526,
    panoId: "zNj_33EbL80zt5B-k_-klA",
    place: "Near Windsor, Colorado",
    shortName: "Windsor",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CO",
    state: "Colorado",
    difficulty: "classic",
    pools: ["world","North America","US","US-CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-co-040",
    lat: 38.741303,
    lng: -104.808522,
    panoId: "b7T5NO38zznhdbEg_avuDg",
    place: "Near Fort Carson, Colorado",
    shortName: "Fort Carson",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CO",
    state: "Colorado",
    difficulty: "classic",
    pools: ["world","North America","US","US-CO"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-co-041",
    lat: 39.094616,
    lng: -108.472917,
    panoId: "IQB9tFrCp9ZmLWagwlj_Qg",
    place: "Near Clifton, Colorado",
    shortName: "Clifton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CO",
    state: "Colorado",
    difficulty: "classic",
    pools: ["world","North America","US","US-CO"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-co-042",
    lat: 38.496511,
    lng: -107.877821,
    panoId: "N0ERHdVCAzKn0rKPVS6OFA",
    place: "Near Montrose, Colorado",
    shortName: "Montrose",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CO",
    state: "Colorado",
    difficulty: "classic",
    pools: ["world","North America","US","US-CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-co-043",
    lat: 39.764766,
    lng: -105.196596,
    panoId: "82T4Z2u0gS_6Nt87SvgF0w",
    place: "Near Golden, Colorado",
    shortName: "Golden",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CO",
    state: "Colorado",
    difficulty: "classic",
    pools: ["world","North America","US","US-CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-co-044",
    lat: 38.235744,
    lng: -104.618014,
    panoId: "SU2jvyy9TnbbPAPfLv9N1w",
    place: "Near Pueblo, Colorado",
    shortName: "Pueblo",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CO",
    state: "Colorado",
    difficulty: "classic",
    pools: ["world","North America","US","US-CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-co-045",
    lat: 37.461313,
    lng: -105.880877,
    panoId: "JNt55CsDE8FmCLRim5rpeA",
    place: "Near Alamosa, Colorado",
    shortName: "Alamosa",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CO",
    state: "Colorado",
    difficulty: "classic",
    pools: ["world","North America","US","US-CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-co-046",
    lat: 40.358669,
    lng: -104.701103,
    panoId: "oT0E4PThstvyDWN8BmJprw",
    place: "Near La Salle, Colorado",
    shortName: "La Salle",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CO",
    state: "Colorado",
    difficulty: "classic",
    pools: ["world","North America","US","US-CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-co-047",
    lat: 39.563395,
    lng: -107.328335,
    panoId: "rC1mIOVghmkDI6WOs2an6g",
    place: "Near Glenwood Springs, Colorado",
    shortName: "Glenwood Springs",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CO",
    state: "Colorado",
    difficulty: "classic",
    pools: ["world","North America","US","US-CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-co-048",
    lat: 40.532556,
    lng: -107.553187,
    panoId: "ApShSB9USSkGOZ_cyLNKzg",
    place: "Near Craig, Colorado",
    shortName: "Craig",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CO",
    state: "Colorado",
    difficulty: "classic",
    pools: ["world","North America","US","US-CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-co-049",
    lat: 39.602063,
    lng: -104.995327,
    panoId: "aZfRxi0Zmn4Mjp-9OFfXvg",
    place: "Near Littleton, Colorado",
    shortName: "Littleton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CO",
    state: "Colorado",
    difficulty: "classic",
    pools: ["world","North America","US","US-CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-co-050",
    lat: 39.038746,
    lng: -108.592673,
    panoId: "BNZMTBrkK-ebgzmiNZa9OA",
    place: "Near Grand Junction, Colorado",
    shortName: "Grand Junction",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CO",
    state: "Colorado",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-co-051",
    lat: 40.390838,
    lng: -104.932712,
    panoId: "pq3gfWz3ETqzWwmiYOGxbg",
    place: "Near Johnstown, Colorado",
    shortName: "Johnstown",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CO",
    state: "Colorado",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-co-052",
    lat: 39.069148,
    lng: -104.744614,
    panoId: "WQNAg8_7e1dksEm3V4PT4g",
    place: "Near Black Forest, Colorado",
    shortName: "Black Forest",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CO",
    state: "Colorado",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-co-053",
    lat: 38.729543,
    lng: -104.671729,
    panoId: "OR6F1X4TekT-kZvxWEieOw",
    place: "Near Security-Widefield, Colorado",
    shortName: "Security-Widefield",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CO",
    state: "Colorado",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-co-054",
    lat: 38.858386,
    lng: -104.783815,
    panoId: "j1sD_I9D-UJUnu_BTaFlTg",
    place: "Near Colorado Springs, Colorado",
    shortName: "Colorado Springs",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CO",
    state: "Colorado",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-co-055",
    lat: 39.350917,
    lng: -104.833941,
    panoId: "JEQ0ed1bd6VL0WlAqtt8dQ",
    place: "Near Castle Rock, Colorado",
    shortName: "Castle Rock",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CO",
    state: "Colorado",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-co-056",
    lat: 40.209565,
    lng: -105.083612,
    panoId: "M40ZaFk9ZHYDRjq_Y_DCAA",
    place: "Near Longmont, Colorado",
    shortName: "Longmont",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CO",
    state: "Colorado",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-co-057",
    lat: 38.759428,
    lng: -108.014633,
    panoId: "GK0SzMQNuHwgPJT1K3JbBg",
    place: "Near Delta, Colorado",
    shortName: "Delta",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CO",
    state: "Colorado",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-co-058",
    lat: 39.893345,
    lng: -105.04187,
    panoId: "XecknT_BXyml4EyDZPpDzw",
    place: "Near Shaw Heights, Colorado",
    shortName: "Shaw Heights",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CO",
    state: "Colorado",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-co-059",
    lat: 39.955837,
    lng: -104.750698,
    panoId: "_-ol_Jd2sss1bMMFJ8lIcA",
    place: "Near Lochbuie, Colorado",
    shortName: "Lochbuie",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CO",
    state: "Colorado",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CO"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-co-060",
    lat: 39.74806,
    lng: -104.898714,
    panoId: "VOm2mG-EwH09_CK41k3G_w",
    place: "Near Glendale, Colorado",
    shortName: "Glendale",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CO",
    state: "Colorado",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-co-061",
    lat: 38.708201,
    lng: -104.714471,
    panoId: "EoG9ZNc-XqEdl2bUJMFqvA",
    place: "Near Fountain, Colorado",
    shortName: "Fountain",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CO",
    state: "Colorado",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-co-062",
    lat: 39.163718,
    lng: -108.779928,
    panoId: "sePYYwVsxMN2t1zI3aw5Dg",
    place: "Near Fruita, Colorado",
    shortName: "Fruita",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CO",
    state: "Colorado",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-co-063",
    lat: 40.270769,
    lng: -104.904991,
    panoId: "u7TFxRYgKyT-PRf4noQnVQ",
    place: "Near Johnstown, Colorado",
    shortName: "Johnstown",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CO",
    state: "Colorado",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CO"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-co-064",
    lat: 38.746958,
    lng: -104.755502,
    panoId: "CWLa5DRs5vA1ch7SqBBm3A",
    place: "Near Fort Carson, Colorado",
    shortName: "Fort Carson",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CO",
    state: "Colorado",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-co-065",
    lat: 38.483632,
    lng: -107.93499,
    panoId: "oORfSJWpx-uceNZou7b5Og",
    place: "Near Montrose, Colorado",
    shortName: "Montrose",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CO",
    state: "Colorado",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-co-066",
    lat: 40.383772,
    lng: -104.741346,
    panoId: "UWRCetMF2A8mNlCuOrrUBQ",
    place: "Near Evans, Colorado",
    shortName: "Evans",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CO",
    state: "Colorado",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-co-067",
    lat: 39.09674,
    lng: -108.578843,
    panoId: "2_Xfyk1jubwtZ8j-LImbnQ",
    place: "Near Grand Junction, Colorado",
    shortName: "Grand Junction",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CO",
    state: "Colorado",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-co-068",
    lat: 40.433961,
    lng: -104.74669,
    panoId: "XmyxNg4unIDLTRsor3-dkg",
    place: "Near Greeley, Colorado",
    shortName: "Greeley",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CO",
    state: "Colorado",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-co-069",
    lat: 38.791797,
    lng: -104.883649,
    panoId: "j844-Ft-e-PXXrH-7rwQYw",
    place: "Near Colorado Springs, Colorado",
    shortName: "Colorado Springs",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CO",
    state: "Colorado",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-co-070",
    lat: 39.09088,
    lng: -104.769597,
    panoId: "noBzFJAa0GnbJhwZ1h0BHQ",
    place: "Near Woodmoor, Colorado",
    shortName: "Woodmoor",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CO",
    state: "Colorado",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-co-071",
    lat: 39.044068,
    lng: -108.478157,
    panoId: "4-C2LKlMvyWSc67e-v0QRg",
    place: "Near Orchard Mesa, Colorado",
    shortName: "Orchard Mesa",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CO",
    state: "Colorado",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-co-072",
    lat: 39.719384,
    lng: -105.242671,
    panoId: "jJydUh7uRUwVFTTWrFy0hw",
    place: "Near Golden, Colorado",
    shortName: "Golden",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CO",
    state: "Colorado",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-co-073",
    lat: 40.651898,
    lng: -103.184861,
    panoId: "Izdgzq5JAs72R6aPtIjAjA",
    place: "Near Sterling, Colorado",
    shortName: "Sterling",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CO",
    state: "Colorado",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-co-074",
    lat: 38.254384,
    lng: -104.519622,
    panoId: "blMX0yUuuvnoJzLJJCkInw",
    place: "Near Pueblo, Colorado",
    shortName: "Pueblo",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CO",
    state: "Colorado",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-co-075",
    lat: 40.304678,
    lng: -103.761674,
    panoId: "5Dp5S_4-T87uPyvX76-7yA",
    place: "Near Fort Morgan, Colorado",
    shortName: "Fort Morgan",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CO",
    state: "Colorado",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-co-076",
    lat: 39.911548,
    lng: -105.041087,
    panoId: "K6via2Df-benZe4kXFJfyQ",
    place: "Near Broomfield, Colorado",
    shortName: "Broomfield",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CO",
    state: "Colorado",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-co-077",
    lat: 39.563848,
    lng: -107.732491,
    panoId: "R6r9p3Nx43FkLYHZLWcP9w",
    place: "Near Rifle, Colorado",
    shortName: "Rifle",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CO",
    state: "Colorado",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-co-078",
    lat: 40.116415,
    lng: -104.869893,
    panoId: "m9CdBy_Se6W2mXbO_IQkPQ",
    place: "Near Firestone, Colorado",
    shortName: "Firestone",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CO",
    state: "Colorado",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-co-079",
    lat: 38.971389,
    lng: -104.644544,
    panoId: "7ax5XkRAJwWhUsI5gYPUng",
    place: "Near Black Forest, Colorado",
    shortName: "Black Forest",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CO",
    state: "Colorado",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-co-080",
    lat: 40.426552,
    lng: -106.825285,
    panoId: "ygPZSan9-fDMmyy-J0s0vw",
    place: "Near Steamboat Springs, Colorado",
    shortName: "Steamboat Springs",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CO",
    state: "Colorado",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-co-081",
    lat: 40.436528,
    lng: -105.136396,
    panoId: "hpu1s15MynKNRbEef8XJ0Q",
    place: "Near Loveland, Colorado",
    shortName: "Loveland",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CO",
    state: "Colorado",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-co-082",
    lat: 39.331231,
    lng: -104.810848,
    panoId: "tJvB9gFRpux35TPZKDrQqQ",
    place: "Near Castle Rock, Colorado",
    shortName: "Castle Rock",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CO",
    state: "Colorado",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-co-083",
    lat: 39.97653,
    lng: -104.745635,
    panoId: "-ZYZiEuEu3irYjjMD93rzw",
    place: "Near Lochbuie, Colorado",
    shortName: "Lochbuie",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CO",
    state: "Colorado",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-co-084",
    lat: 37.231873,
    lng: -107.869544,
    panoId: "_19k19BjjGL0EQi5wL49fg",
    place: "Near Durango, Colorado",
    shortName: "Durango",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CO",
    state: "Colorado",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-co-085",
    lat: 40.464475,
    lng: -107.608427,
    panoId: "Qq-cTsoYFghtjObi34PTQA",
    place: "Near Craig, Colorado",
    shortName: "Craig",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CO",
    state: "Colorado",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-co-086",
    lat: 38.736949,
    lng: -108.142087,
    panoId: "cbyxJIK972Ohr0Sr60HU0w",
    place: "Near Delta, Colorado",
    shortName: "Delta",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CO",
    state: "Colorado",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-co-087",
    lat: 40.437806,
    lng: -104.941754,
    panoId: "u366LTegYie1KCTRfDFQ5Q",
    place: "Near Windsor, Colorado",
    shortName: "Windsor",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CO",
    state: "Colorado",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-co-088",
    lat: 38.66309,
    lng: -104.735178,
    panoId: "qqk3jKGKsyY4hPHyWGpjog",
    place: "Near Fountain, Colorado",
    shortName: "Fountain",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CO",
    state: "Colorado",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-co-089",
    lat: 39.482936,
    lng: -107.895903,
    panoId: "VD6yEe6-6_PNDAdXPvVMmg",
    place: "Near Rifle, Colorado",
    shortName: "Rifle",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CO",
    state: "Colorado",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-co-090",
    lat: 39.430005,
    lng: -107.147549,
    panoId: "8FJRzskPrzPrnTWfgdB4aQ",
    place: "Near El Jebel, Colorado",
    shortName: "El Jebel",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CO",
    state: "Colorado",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-co-091",
    lat: 40.290653,
    lng: -104.682498,
    panoId: "zZ_PlmCH02QuAyEUH_MOKg",
    place: "Near La Salle, Colorado",
    shortName: "La Salle",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CO",
    state: "Colorado",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-co-092",
    lat: 39.148422,
    lng: -105.025112,
    panoId: "YuomkSXDKbz_eXpOJIb7yw",
    place: "Near Palmer Lake, Colorado",
    shortName: "Palmer Lake",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CO",
    state: "Colorado",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-co-093",
    lat: 37.158602,
    lng: -104.604174,
    panoId: "y9fst7wIPSy4p0RQGNK1MA",
    place: "Near Trinidad, Colorado",
    shortName: "Trinidad",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CO",
    state: "Colorado",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-co-094",
    lat: 39.037859,
    lng: -104.746636,
    panoId: "35mLnYEPdNceissUPMCM7g",
    place: "Near Black Forest, Colorado",
    shortName: "Black Forest",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CO",
    state: "Colorado",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-co-095",
    lat: 38.975926,
    lng: -104.706905,
    panoId: "0aO1jm7It5iFkj68PafL1w",
    place: "Near Black Forest, Colorado",
    shortName: "Black Forest",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CO",
    state: "Colorado",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-co-096",
    lat: 39.247027,
    lng: -108.831428,
    panoId: "CWrCsNf20tGQHPcczWfBXw",
    place: "Near Loma, Colorado",
    shortName: "Loma",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CO",
    state: "Colorado",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-co-097",
    lat: 40.262164,
    lng: -104.89298,
    panoId: "IP3Yd-frbSVz7TWNJvq0IQ",
    place: "Near Platteville, Colorado",
    shortName: "Platteville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CO",
    state: "Colorado",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-co-098",
    lat: 39.029008,
    lng: -105.009743,
    panoId: "buDhOEg_L02nZ_n4TFgd8Q",
    place: "Near Woodland Park, Colorado",
    shortName: "Woodland Park",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CO",
    state: "Colorado",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-co-099",
    lat: 38.484944,
    lng: -105.384284,
    panoId: "ok4aIVoyD00IAI1zmMhoWA",
    place: "Near Cañon City, Colorado",
    shortName: "Cañon City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CO",
    state: "Colorado",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-co-100",
    lat: 38.202715,
    lng: -102.724237,
    panoId: "RSPpdr-BTwMkPcQ_LOBSRQ",
    place: "Near Lamar, Colorado",
    shortName: "Lamar",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CO",
    state: "Colorado",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-co-101",
    lat: 39.332133,
    lng: -105.248523,
    panoId: "M8jjScGsrInYQJUu7RUlaw",
    place: "Near Bailey, Colorado",
    shortName: "Bailey",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CO",
    state: "Colorado",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-co-102",
    lat: 40.742692,
    lng: -103.113272,
    panoId: "ND0T0Cp38esraSPGVzlo7Q",
    place: "Near Sterling, Colorado",
    shortName: "Sterling",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CO",
    state: "Colorado",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-co-103",
    lat: 38.963735,
    lng: -108.346795,
    panoId: "XX41LNKmAy8lbmz598y0Gw",
    place: "Near Palisade, Colorado",
    shortName: "Palisade",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CO",
    state: "Colorado",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-co-104",
    lat: 38.680113,
    lng: -106.100335,
    panoId: "OlNPv9FoM5ZFcgdxxaSPnA",
    place: "Near Buena Vista, Colorado",
    shortName: "Buena Vista",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CO",
    state: "Colorado",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-co-105",
    lat: 39.382694,
    lng: -106.190571,
    panoId: "JKs3f5Dzua_AQD8MYd5BAg",
    place: "Near Leadville North, Colorado",
    shortName: "Leadville North",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CO",
    state: "Colorado",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-co-106",
    lat: 38.143556,
    lng: -102.819146,
    panoId: "q0eRZzBfyXoCqNySV1IegQ",
    place: "Near Lamar, Colorado",
    shortName: "Lamar",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CO",
    state: "Colorado",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-co-107",
    lat: 39.650825,
    lng: -107.617086,
    panoId: "by3fenIycFbocUt2iPlEUw",
    place: "Near New Castle, Colorado",
    shortName: "New Castle",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CO",
    state: "Colorado",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ct-000",
    lat: 41.308106,
    lng: -72.928081,
    panoId: "I285i_3nnW1eqmYeUd_sxA",
    place: "Near New Haven, Connecticut",
    shortName: "New Haven",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CT",
    state: "Connecticut",
    difficulty: "classic",
    pools: ["world","North America","US","US-CT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ct-001",
    lat: 41.818463,
    lng: -73.143828,
    panoId: "Jzk-h2RhY7lFhpi3cSUaHA",
    place: "Near West Torrington, Connecticut",
    shortName: "West Torrington",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CT",
    state: "Connecticut",
    difficulty: "classic",
    pools: ["world","North America","US","US-CT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ct-002",
    lat: 41.763677,
    lng: -72.685286,
    panoId: "x52QjcnQbMLaaP_-xtE8KQ",
    place: "Near Hartford, Connecticut",
    shortName: "Hartford",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CT",
    state: "Connecticut",
    difficulty: "classic",
    pools: ["world","North America","US","US-CT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ct-003",
    lat: 41.524277,
    lng: -72.075917,
    panoId: "DnY3X0yR5BWMytMxA1BaUg",
    place: "Near Norwich, Connecticut",
    shortName: "Norwich",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CT",
    state: "Connecticut",
    difficulty: "classic",
    pools: ["world","North America","US","US-CT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ct-004",
    lat: 41.270597,
    lng: -72.947184,
    panoId: "ratyVfUXEXPRPXhd6AkDLQ",
    place: "Near West Haven, Connecticut",
    shortName: "West Haven",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CT",
    state: "Connecticut",
    difficulty: "classic",
    pools: ["world","North America","US","US-CT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ct-005",
    lat: 41.558179,
    lng: -73.051528,
    panoId: "upq1dd_bYENd5nmPaZFYlQ",
    place: "Near Waterbury, Connecticut",
    shortName: "Waterbury",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CT",
    state: "Connecticut",
    difficulty: "classic",
    pools: ["world","North America","US","US-CT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ct-006",
    lat: 41.562396,
    lng: -72.650749,
    panoId: "c8z0KB3DtdUqETaFpZelFQ",
    place: "Near Middletown, Connecticut",
    shortName: "Middletown",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CT",
    state: "Connecticut",
    difficulty: "classic",
    pools: ["world","North America","US","US-CT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ct-007",
    lat: 41.762075,
    lng: -72.742066,
    panoId: "V10cD0eObjsUN-Oyp9kTNw",
    place: "Near West Hartford, Connecticut",
    shortName: "West Hartford",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CT",
    state: "Connecticut",
    difficulty: "classic",
    pools: ["world","North America","US","US-CT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ct-008",
    lat: 41.222246,
    lng: -73.056586,
    panoId: "tlG7AIbJupk-bctmecDqag",
    place: "Near Milford, Connecticut",
    shortName: "Milford",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CT",
    state: "Connecticut",
    difficulty: "classic",
    pools: ["world","North America","US","US-CT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ct-009",
    lat: 41.782194,
    lng: -72.611917,
    panoId: "Y-an9zxaxou8Koeta1i4nQ",
    place: "Near East Hartford, Connecticut",
    shortName: "East Hartford",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CT",
    state: "Connecticut",
    difficulty: "classic",
    pools: ["world","North America","US","US-CT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ct-010",
    lat: 41.184695,
    lng: -73.133201,
    panoId: "T_kDsiywKr6gof_YJ4pnWA",
    place: "Near Stratford, Connecticut",
    shortName: "Stratford",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CT",
    state: "Connecticut",
    difficulty: "classic",
    pools: ["world","North America","US","US-CT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ct-011",
    lat: 41.596561,
    lng: -72.877518,
    panoId: "4oxNh_XS-jB7qZa7e-GpiQ",
    place: "Near Southington, Connecticut",
    shortName: "Southington",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CT",
    state: "Connecticut",
    difficulty: "classic",
    pools: ["world","North America","US","US-CT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ct-012",
    lat: 41.141173,
    lng: -73.263728,
    panoId: "v9GwhnrDC4fDqqHMCcgh4A",
    place: "Near Fairfield, Connecticut",
    shortName: "Fairfield",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CT",
    state: "Connecticut",
    difficulty: "classic",
    pools: ["world","North America","US","US-CT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ct-013",
    lat: 41.498628,
    lng: -72.900918,
    panoId: "3R2TMnl-5J7J96zD5WxluA",
    place: "Near Cheshire, Connecticut",
    shortName: "Cheshire",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CT",
    state: "Connecticut",
    difficulty: "classic",
    pools: ["world","North America","US","US-CT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ct-014",
    lat: 41.671878,
    lng: -72.949254,
    panoId: "YpLoH14K6s4PPvtgmcjJow",
    place: "Near Bristol, Connecticut",
    shortName: "Bristol",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CT",
    state: "Connecticut",
    difficulty: "classic",
    pools: ["world","North America","US","US-CT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ct-015",
    lat: 41.105506,
    lng: -73.398302,
    panoId: "kWqcQdBQztBgDloaBwMZiQ",
    place: "Near East Norwalk, Connecticut",
    shortName: "East Norwalk",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CT",
    state: "Connecticut",
    difficulty: "classic",
    pools: ["world","North America","US","US-CT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ct-016",
    lat: 41.395928,
    lng: -72.896876,
    panoId: "qX1W_jmY2wvExA2AfHk_sA",
    place: "Near Hamden, Connecticut",
    shortName: "Hamden",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CT",
    state: "Connecticut",
    difficulty: "classic",
    pools: ["world","North America","US","US-CT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ct-017",
    lat: 41.71249,
    lng: -72.608235,
    panoId: "4RtW3d5OvlkJEK3olq13gw",
    place: "Near Glastonbury, Connecticut",
    shortName: "Glastonbury",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CT",
    state: "Connecticut",
    difficulty: "classic",
    pools: ["world","North America","US","US-CT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ct-018",
    lat: 41.697826,
    lng: -72.72377,
    panoId: "4yAn022apepEtz84TRsI9g",
    place: "Near Newington, Connecticut",
    shortName: "Newington",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CT",
    state: "Connecticut",
    difficulty: "classic",
    pools: ["world","North America","US","US-CT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ct-019",
    lat: 41.117657,
    lng: -73.40805,
    panoId: "Fd2awb3KTZSwzDxfodQ9Wg",
    place: "Near Norwalk, Connecticut",
    shortName: "Norwalk",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CT",
    state: "Connecticut",
    difficulty: "classic",
    pools: ["world","North America","US","US-CT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ct-020",
    lat: 41.279545,
    lng: -72.815128,
    panoId: "2PMtTWk_wo_fhQd_tm8rBg",
    place: "Near Branford, Connecticut",
    shortName: "Branford",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CT",
    state: "Connecticut",
    difficulty: "classic",
    pools: ["world","North America","US","US-CT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ct-021",
    lat: 41.394956,
    lng: -73.454186,
    panoId: "KtfQZV9tgIUKZ4exBJcrUQ",
    place: "Near Danbury, Connecticut",
    shortName: "Danbury",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CT",
    state: "Connecticut",
    difficulty: "classic",
    pools: ["world","North America","US","US-CT"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "us-ct-022",
    lat: 41.242755,
    lng: -73.201001,
    panoId: "dqI9kEB6tZWaErLSrUPPHg",
    place: "Near Trumbull, Connecticut",
    shortName: "Trumbull",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CT",
    state: "Connecticut",
    difficulty: "classic",
    pools: ["world","North America","US","US-CT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ct-023",
    lat: 41.276133,
    lng: -72.86829,
    panoId: "p2Da1rnRSWmwHF-A_3oTyA",
    place: "Near East Haven, Connecticut",
    shortName: "East Haven",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CT",
    state: "Connecticut",
    difficulty: "classic",
    pools: ["world","North America","US","US-CT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ct-024",
    lat: 41.775969,
    lng: -72.521492,
    panoId: "BtJdaQk-fkJ332ZfTZJbLA",
    place: "Near Manchester, Connecticut",
    shortName: "Manchester",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CT",
    state: "Connecticut",
    difficulty: "classic",
    pools: ["world","North America","US","US-CT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ct-025",
    lat: 41.179213,
    lng: -73.1895,
    panoId: "taYH8ebUKlvnbIh30bQmQA",
    place: "Near Bridgeport, Connecticut",
    shortName: "Bridgeport",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CT",
    state: "Connecticut",
    difficulty: "classic",
    pools: ["world","North America","US","US-CT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ct-026",
    lat: 41.800683,
    lng: -73.121152,
    panoId: "LXllPzm-dJgLE2P56Z114Q",
    place: "Near Torrington, Connecticut",
    shortName: "Torrington",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CT",
    state: "Connecticut",
    difficulty: "classic",
    pools: ["world","North America","US","US-CT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ct-027",
    lat: 41.355622,
    lng: -72.099572,
    panoId: "o_f5zXqqInDWsUVsxknj9w",
    place: "Near New London, Connecticut",
    shortName: "New London",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CT",
    state: "Connecticut",
    difficulty: "classic",
    pools: ["world","North America","US","US-CT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ct-028",
    lat: 41.485921,
    lng: -73.050647,
    panoId: "eCRZuAJ4_XRF4SL0s-ksSQ",
    place: "Near Naugatuck, Connecticut",
    shortName: "Naugatuck",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CT",
    state: "Connecticut",
    difficulty: "classic",
    pools: ["world","North America","US","US-CT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ct-029",
    lat: 41.538169,
    lng: -72.807061,
    panoId: "RMfY864CaGIWHfutFnW9Kw",
    place: "Near Meriden, Connecticut",
    shortName: "Meriden",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CT",
    state: "Connecticut",
    difficulty: "classic",
    pools: ["world","North America","US","US-CT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ct-030",
    lat: 41.852738,
    lng: -72.643617,
    panoId: "SkTr1q6aI-VJ1SNMmG2lxQ",
    place: "Near Windsor, Connecticut",
    shortName: "Windsor",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CT",
    state: "Connecticut",
    difficulty: "classic",
    pools: ["world","North America","US","US-CT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ct-031",
    lat: 41.976257,
    lng: -72.592012,
    panoId: "mPo5mHYAbTSEiGbtKR7-eQ",
    place: "Near Enfield, Connecticut",
    shortName: "Enfield",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CT",
    state: "Connecticut",
    difficulty: "classic",
    pools: ["world","North America","US","US-CT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ct-032",
    lat: 41.138125,
    lng: -73.543362,
    panoId: "7v1G3btyMwzsHQLZEixaVw",
    place: "Near North Stamford, Connecticut",
    shortName: "North Stamford",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CT",
    state: "Connecticut",
    difficulty: "classic",
    pools: ["world","North America","US","US-CT"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-ct-033",
    lat: 41.66122,
    lng: -72.779479,
    panoId: "xnUWxOo8DdHW8pHEI3-5aA",
    place: "Near New Britain, Connecticut",
    shortName: "New Britain",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CT",
    state: "Connecticut",
    difficulty: "classic",
    pools: ["world","North America","US","US-CT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ct-034",
    lat: 41.316635,
    lng: -73.093273,
    panoId: "0D0TyB2-se04OFnZhkEQhA",
    place: "Near Shelton, Connecticut",
    shortName: "Shelton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CT",
    state: "Connecticut",
    difficulty: "classic",
    pools: ["world","North America","US","US-CT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ct-035",
    lat: 41.714276,
    lng: -72.652665,
    panoId: "HW8TPMsLIUlpe14x_c60aw",
    place: "Near Wethersfield, Connecticut",
    shortName: "Wethersfield",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CT",
    state: "Connecticut",
    difficulty: "classic",
    pools: ["world","North America","US","US-CT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ct-036",
    lat: 41.141409,
    lng: -73.357975,
    panoId: "0ouPnD0ksbRBlwInINOoqA",
    place: "Near Westport, Connecticut",
    shortName: "Westport",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CT",
    state: "Connecticut",
    difficulty: "classic",
    pools: ["world","North America","US","US-CT"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-ct-037",
    lat: 41.719759,
    lng: -72.831918,
    panoId: "vwuHFtoYbkWwexyaSbEH8Q",
    place: "Near Farmington, Connecticut",
    shortName: "Farmington",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CT",
    state: "Connecticut",
    difficulty: "classic",
    pools: ["world","North America","US","US-CT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ct-038",
    lat: 41.801746,
    lng: -73.157937,
    panoId: "cQ8QhmlYqrtMS0a43a8a2A",
    place: "Near West Torrington, Connecticut",
    shortName: "West Torrington",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CT",
    state: "Connecticut",
    difficulty: "classic",
    pools: ["world","North America","US","US-CT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ct-039",
    lat: 41.283537,
    lng: -72.940819,
    panoId: "flVLVlNn1dXYTrpHXcZYAg",
    place: "Near West Haven, Connecticut",
    shortName: "West Haven",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CT",
    state: "Connecticut",
    difficulty: "classic",
    pools: ["world","North America","US","US-CT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ct-040",
    lat: 41.588551,
    lng: -72.88681,
    panoId: "WaB99xY-_EtuZ-5l3Eo4OQ",
    place: "Near Southington, Connecticut",
    shortName: "Southington",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CT",
    state: "Connecticut",
    difficulty: "classic",
    pools: ["world","North America","US","US-CT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ct-041",
    lat: 41.262996,
    lng: -72.862222,
    panoId: "95V6vbFP-iD8oZyhxnxBKg",
    place: "Near East Haven, Connecticut",
    shortName: "East Haven",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CT",
    state: "Connecticut",
    difficulty: "classic",
    pools: ["world","North America","US","US-CT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ct-042",
    lat: 41.126203,
    lng: -73.388851,
    panoId: "A5UJtGqSKOwsNAaOdfzYDQ",
    place: "Near Norwalk, Connecticut",
    shortName: "Norwalk",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CT",
    state: "Connecticut",
    difficulty: "classic",
    pools: ["world","North America","US","US-CT"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "us-ct-043",
    lat: 41.227222,
    lng: -73.085047,
    panoId: "MyV4-iajDSA8ztOkkH9G4A",
    place: "Near City of Milford (balance), Connecticut",
    shortName: "City of Milford (balance)",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CT",
    state: "Connecticut",
    difficulty: "classic",
    pools: ["world","North America","US","US-CT"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-ct-044",
    lat: 41.765887,
    lng: -72.233685,
    panoId: "kEi_8WQTVHsEIAkA5JFIiQ",
    place: "Near Mansfield City, Connecticut",
    shortName: "Mansfield City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CT",
    state: "Connecticut",
    difficulty: "classic",
    pools: ["world","North America","US","US-CT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ct-045",
    lat: 41.789588,
    lng: -73.113199,
    panoId: "zNnV1iqg0ApU2HHzaHxg-Q",
    place: "Near Torrington, Connecticut",
    shortName: "Torrington",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CT",
    state: "Connecticut",
    difficulty: "classic",
    pools: ["world","North America","US","US-CT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ct-046",
    lat: 41.140969,
    lng: -73.251614,
    panoId: "-_oCjF11saGk1wlCrhM_zQ",
    place: "Near Fairfield, Connecticut",
    shortName: "Fairfield",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CT",
    state: "Connecticut",
    difficulty: "classic",
    pools: ["world","North America","US","US-CT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ct-047",
    lat: 41.300272,
    lng: -72.917285,
    panoId: "VeiLEmrNsYG7QRnKlV_1Hw",
    place: "Near New Haven, Connecticut",
    shortName: "New Haven",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CT",
    state: "Connecticut",
    difficulty: "classic",
    pools: ["world","North America","US","US-CT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ct-048",
    lat: 41.524285,
    lng: -72.809783,
    panoId: "719GLkT53ZR--FUUX8X-jQ",
    place: "Near Meriden, Connecticut",
    shortName: "Meriden",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CT",
    state: "Connecticut",
    difficulty: "classic",
    pools: ["world","North America","US","US-CT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ct-049",
    lat: 41.103544,
    lng: -73.384053,
    panoId: "TbRqbLInpN-pDhfqxazR_A",
    place: "Near East Norwalk, Connecticut",
    shortName: "East Norwalk",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CT",
    state: "Connecticut",
    difficulty: "classic",
    pools: ["world","North America","US","US-CT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ct-050",
    lat: 41.343595,
    lng: -72.853133,
    panoId: "yytTKyuNMMciD6pbAryEbw",
    place: "Near North Haven, Connecticut",
    shortName: "North Haven",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CT",
    state: "Connecticut",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ct-051",
    lat: 41.668448,
    lng: -72.699906,
    panoId: "wGWCdZjLg-0DV3oRVEl73A",
    place: "Near Newington, Connecticut",
    shortName: "Newington",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CT",
    state: "Connecticut",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ct-052",
    lat: 41.768444,
    lng: -72.443421,
    panoId: "9pQM_D2OgErfG60FGOAZSw",
    place: "Near Manchester, Connecticut",
    shortName: "Manchester",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CT",
    state: "Connecticut",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ct-053",
    lat: 41.221324,
    lng: -73.124818,
    panoId: "byTds0XipXzHgalN43IuwA",
    place: "Near Stratford, Connecticut",
    shortName: "Stratford",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CT",
    state: "Connecticut",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CT"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "us-ct-054",
    lat: 41.433314,
    lng: -73.06701,
    panoId: "hR6thclVZ6X84pVS5VEk1g",
    place: "Near Seymour, Connecticut",
    shortName: "Seymour",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CT",
    state: "Connecticut",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ct-055",
    lat: 41.687682,
    lng: -72.540231,
    panoId: "D73ncBCCgV2emeEwSxq3BQ",
    place: "Near Glastonbury Center, Connecticut",
    shortName: "Glastonbury Center",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CT",
    state: "Connecticut",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ct-056",
    lat: 41.658249,
    lng: -72.68778,
    panoId: "qhtdOtsc6oa779DkoPApcA",
    place: "Near Newington, Connecticut",
    shortName: "Newington",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CT",
    state: "Connecticut",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ct-057",
    lat: 41.358049,
    lng: -73.160316,
    panoId: "DgyqW8Hs0XQq1TNgE43h2w",
    place: "Near Ansonia, Connecticut",
    shortName: "Ansonia",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CT",
    state: "Connecticut",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ct-058",
    lat: 41.764374,
    lng: -72.828257,
    panoId: "vSJKhnw7EuvDJPaqcTdUtA",
    place: "Near Farmington, Connecticut",
    shortName: "Farmington",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CT",
    state: "Connecticut",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ct-059",
    lat: 41.912152,
    lng: -72.561418,
    panoId: "Y4FQ30COjOLoaZNjJLgYng",
    place: "Near East Windsor, Connecticut",
    shortName: "East Windsor",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CT",
    state: "Connecticut",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ct-060",
    lat: 41.259543,
    lng: -72.748623,
    panoId: "maZe4ETGGLySfXDPm9OQVA",
    place: "Near Branford Center, Connecticut",
    shortName: "Branford Center",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CT",
    state: "Connecticut",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ct-061",
    lat: 41.692124,
    lng: -72.898352,
    panoId: "t5yiOtEyb8A_goYr5lEdvQ",
    place: "Near Plainville, Connecticut",
    shortName: "Plainville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CT",
    state: "Connecticut",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ct-062",
    lat: 41.719224,
    lng: -72.249525,
    panoId: "g3CifLPSHgb9IKEb8KQz5g",
    place: "Near Willimantic, Connecticut",
    shortName: "Willimantic",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CT",
    state: "Connecticut",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ct-063",
    lat: 41.665186,
    lng: -72.911449,
    panoId: "FFzbIY6ygt8oKsdjOklZXQ",
    place: "Near Bristol, Connecticut",
    shortName: "Bristol",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CT",
    state: "Connecticut",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ct-064",
    lat: 41.28385,
    lng: -73.11284,
    panoId: "zoLpo-wqtkQqFKpTzmPPJA",
    place: "Near Shelton, Connecticut",
    shortName: "Shelton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CT",
    state: "Connecticut",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ct-065",
    lat: 41.359,
    lng: -72.870961,
    panoId: "rOsJ7zxp9rbqfE7x33YAgg",
    place: "Near North Haven, Connecticut",
    shortName: "North Haven",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CT",
    state: "Connecticut",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CT"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-ct-066",
    lat: 41.247682,
    lng: -73.158964,
    panoId: "R47cvT78VxoafkevxiEUqQ",
    place: "Near Trumbull, Connecticut",
    shortName: "Trumbull",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CT",
    state: "Connecticut",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ct-067",
    lat: 41.709914,
    lng: -72.530606,
    panoId: "zcRcux-jm_WuD5AO0R-KXw",
    place: "Near Glastonbury Center, Connecticut",
    shortName: "Glastonbury Center",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CT",
    state: "Connecticut",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ct-068",
    lat: 41.392569,
    lng: -73.387688,
    panoId: "cwEFADrEd3rIaBpL_EuneA",
    place: "Near Bethel, Connecticut",
    shortName: "Bethel",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CT",
    state: "Connecticut",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ct-069",
    lat: 41.825826,
    lng: -73.089296,
    panoId: "xfBBMpsyg75KFvlsP7CiYQ",
    place: "Near Torrington, Connecticut",
    shortName: "Torrington",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CT",
    state: "Connecticut",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ct-070",
    lat: 41.515288,
    lng: -72.695904,
    panoId: "2322oT8po5b3aFpF6XPyEg",
    place: "Near Durham, Connecticut",
    shortName: "Durham",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CT",
    state: "Connecticut",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ct-071",
    lat: 41.152432,
    lng: -73.401367,
    panoId: "FFI11WSN9gwIEdK5RGhXKA",
    place: "Near Westport, Connecticut",
    shortName: "Westport",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CT",
    state: "Connecticut",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ct-072",
    lat: 41.856274,
    lng: -72.578523,
    panoId: "2idO9CrXUopIg7LKR_yHnQ",
    place: "Near South Windsor, Connecticut",
    shortName: "South Windsor",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CT",
    state: "Connecticut",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ct-073",
    lat: 41.804576,
    lng: -72.754834,
    panoId: "LM-_lFPQ1dW8zibXvJ89Cw",
    place: "Near Bloomfield, Connecticut",
    shortName: "Bloomfield",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CT",
    state: "Connecticut",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ct-074",
    lat: 41.578955,
    lng: -72.966895,
    panoId: "Uuc8aX4gvY4QX_6lZzJB8A",
    place: "Near Wolcott, Connecticut",
    shortName: "Wolcott",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CT",
    state: "Connecticut",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ct-075",
    lat: 41.456584,
    lng: -73.092906,
    panoId: "_gahudpH8lA8Re17TveWDQ",
    place: "Near Oxford, Connecticut",
    shortName: "Oxford",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CT",
    state: "Connecticut",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CT"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-ct-076",
    lat: 41.26193,
    lng: -73.078825,
    panoId: "oK_lA1HHOPa7psz50HuRZw",
    place: "Near City of Milford (balance), Connecticut",
    shortName: "City of Milford (balance)",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CT",
    state: "Connecticut",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ct-077",
    lat: 41.867727,
    lng: -72.699845,
    panoId: "ag-ffL-FrMUSvr-H-uqeGA",
    place: "Near Windsor, Connecticut",
    shortName: "Windsor",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CT",
    state: "Connecticut",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ct-078",
    lat: 41.112939,
    lng: -73.617478,
    panoId: "e_Cu6OjEEzFVVolZRtQ5DA",
    place: "Near North Castle, Connecticut",
    shortName: "North Castle",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CT",
    state: "Connecticut",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ct-079",
    lat: 41.636102,
    lng: -72.597634,
    panoId: "UvXb1PY0YOzh5G9luT6BBw",
    place: "Near Cromwell, Connecticut",
    shortName: "Cromwell",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CT",
    state: "Connecticut",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ct-080",
    lat: 41.679443,
    lng: -72.033286,
    panoId: "P9RKWD7cwr5agGAG41DUIQ",
    place: "Near Baltic, Connecticut",
    shortName: "Baltic",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CT",
    state: "Connecticut",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ct-081",
    lat: 41.449926,
    lng: -73.446124,
    panoId: "ZL2zYLhULOJP7vBlwE1hig",
    place: "Near New Fairfield, Connecticut",
    shortName: "New Fairfield",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CT",
    state: "Connecticut",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ct-082",
    lat: 41.103635,
    lng: -73.67893,
    panoId: "e8nMbbMwUGxpZuqjDTxsPA",
    place: "Near Armonk, Connecticut",
    shortName: "Armonk",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CT",
    state: "Connecticut",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ct-083",
    lat: 41.944526,
    lng: -72.824175,
    panoId: "JfVyOUmQwovo_W62qnX9bQ",
    place: "Near Salmon Brook, Connecticut",
    shortName: "Salmon Brook",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CT",
    state: "Connecticut",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ct-084",
    lat: 41.726876,
    lng: -72.463783,
    panoId: "NKZOGA1SWlcLvz7XIJcA2Q",
    place: "Near Manchester, Connecticut",
    shortName: "Manchester",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CT",
    state: "Connecticut",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ct-085",
    lat: 41.422666,
    lng: -72.611588,
    panoId: "ZZFmSMibeaIbwkoC0rEJuA",
    place: "Near Killingworth, Connecticut",
    shortName: "Killingworth",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CT",
    state: "Connecticut",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ct-086",
    lat: 41.330598,
    lng: -73.250912,
    panoId: "6oKCHxXDgnEsdkBM7UxXqw",
    place: "Near Easton, Connecticut",
    shortName: "Easton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CT",
    state: "Connecticut",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CT"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-ct-087",
    lat: 41.537771,
    lng: -71.832273,
    panoId: "eJxJ4JlS9-aQi1rF4Qveng",
    place: "Near Hopkinton, Connecticut",
    shortName: "Hopkinton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CT",
    state: "Connecticut",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ct-088",
    lat: 41.443608,
    lng: -72.757106,
    panoId: "_5506AjABU4BLV4iKCpEjQ",
    place: "Near Wallingford Center, Connecticut",
    shortName: "Wallingford Center",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CT",
    state: "Connecticut",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ct-089",
    lat: 41.503255,
    lng: -72.80536,
    panoId: "bMJQGmQGRpmcl6WPM8QQtA",
    place: "Near Meriden, Connecticut",
    shortName: "Meriden",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CT",
    state: "Connecticut",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ct-090",
    lat: 41.34624,
    lng: -73.318872,
    panoId: "eBieZ46FeN_4vJ0VJXYnjg",
    place: "Near Newtown, Connecticut",
    shortName: "Newtown",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CT",
    state: "Connecticut",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CT"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-ct-091",
    lat: 41.708498,
    lng: -72.907497,
    panoId: "61qdwjYL34Z9QAvTgsqj7w",
    place: "Near Bristol, Connecticut",
    shortName: "Bristol",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CT",
    state: "Connecticut",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ct-092",
    lat: 41.786628,
    lng: -72.192275,
    panoId: "svDElB8TROBIa53wIQGbJg",
    place: "Near Mansfield City, Connecticut",
    shortName: "Mansfield City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CT",
    state: "Connecticut",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ct-093",
    lat: 41.622958,
    lng: -72.656023,
    panoId: "H6Z56M--32HkLhUrELAf9A",
    place: "Near Cromwell, Connecticut",
    shortName: "Cromwell",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CT",
    state: "Connecticut",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ct-094",
    lat: 41.766304,
    lng: -72.333474,
    panoId: "1Ndrm-cnUCXz8U9m-99kqg",
    place: "Near Coventry Lake, Connecticut",
    shortName: "Coventry Lake",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CT",
    state: "Connecticut",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ct-095",
    lat: 41.758729,
    lng: -72.97597,
    panoId: "QWmitHWvldRv1SnaKh_G2A",
    place: "Near Collinsville, Connecticut",
    shortName: "Collinsville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CT",
    state: "Connecticut",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ct-096",
    lat: 41.240946,
    lng: -73.495846,
    panoId: "UMZs4rSX0RTTF3ZxwsuwKw",
    place: "Near Ridgefield, Connecticut",
    shortName: "Ridgefield",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CT",
    state: "Connecticut",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CT"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-ct-097",
    lat: 41.680831,
    lng: -72.204306,
    panoId: "D7yJeedSBQjzyL1Xf4uIRQ",
    place: "Near South Windham, Connecticut",
    shortName: "South Windham",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CT",
    state: "Connecticut",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ct-098",
    lat: 41.89452,
    lng: -72.600117,
    panoId: "dS1gLX69Xd3FMY7yrNJ0AA",
    place: "Near Windsor Locks, Connecticut",
    shortName: "Windsor Locks",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CT",
    state: "Connecticut",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ct-099",
    lat: 41.800144,
    lng: -71.937735,
    panoId: "IugJAewt2s6k48mKiGQqvQ",
    place: "Near East Brooklyn, Connecticut",
    shortName: "East Brooklyn",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CT",
    state: "Connecticut",
    difficulty: "explorer",
    pools: ["world","North America","US","US-CT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ct-100",
    lat: 41.452556,
    lng: -72.283426,
    panoId: "9Acuubb7dKix2KO-t3ad-Q",
    place: "Near Salem, Connecticut",
    shortName: "Salem",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CT",
    state: "Connecticut",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-CT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ct-101",
    lat: 41.78046,
    lng: -72.977368,
    panoId: "auTfC36GYgwW9ULAgDCnNA",
    place: "Near Collinsville, Connecticut",
    shortName: "Collinsville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CT",
    state: "Connecticut",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-CT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ct-102",
    lat: 41.89874,
    lng: -72.181642,
    panoId: "ujl8MGeug9Qj65RwAeja1w",
    place: "Near Storrs, Connecticut",
    shortName: "Storrs",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CT",
    state: "Connecticut",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-CT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ct-103",
    lat: 41.371312,
    lng: -73.26551,
    panoId: "jbvjkTin7wwIF-n8fPphTw",
    place: "Near Newtown, Connecticut",
    shortName: "Newtown",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CT",
    state: "Connecticut",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-CT"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-ct-104",
    lat: 41.622355,
    lng: -72.249265,
    panoId: "ecpbkvCNdfUegPiybec_pg",
    place: "Near Colchester, Connecticut",
    shortName: "Colchester",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CT",
    state: "Connecticut",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-CT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ct-105",
    lat: 41.410499,
    lng: -72.67391,
    panoId: "ztpV8MdHXCn7kw-IYZ9Elg",
    place: "Near Durham, Connecticut",
    shortName: "Durham",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "CT",
    state: "Connecticut",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-CT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-de-000",
    lat: 38.912615,
    lng: -75.428055,
    panoId: "iC-TTo5YzUVAsf4PNpJRdA",
    place: "Near Milford, Delaware",
    shortName: "Milford",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "DE",
    state: "Delaware",
    difficulty: "classic",
    pools: ["world","North America","US","US-DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-de-001",
    lat: 39.604855,
    lng: -75.745277,
    panoId: "QrgsprjM6aWe79q-9wpDNQ",
    place: "Near Glasgow, Delaware",
    shortName: "Glasgow",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "DE",
    state: "Delaware",
    difficulty: "classic",
    pools: ["world","North America","US","US-DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-de-002",
    lat: 39.686778,
    lng: -75.584399,
    panoId: "YJkos6iDY1uOaLfvheI0DQ",
    place: "Near Wilmington Manor, Delaware",
    shortName: "Wilmington Manor",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "DE",
    state: "Delaware",
    difficulty: "classic",
    pools: ["world","North America","US","US-DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-de-003",
    lat: 39.730852,
    lng: -75.704157,
    panoId: "_k0yJRObzaya3jHgiOrXFA",
    place: "Near Pike Creek, Delaware",
    shortName: "Pike Creek",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "DE",
    state: "Delaware",
    difficulty: "classic",
    pools: ["world","North America","US","US-DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-de-004",
    lat: 39.629378,
    lng: -75.658401,
    panoId: "dI-nCgq0BSH0bOUHCtSgmA",
    place: "Near Bear, Delaware",
    shortName: "Bear",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "DE",
    state: "Delaware",
    difficulty: "classic",
    pools: ["world","North America","US","US-DE"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-de-005",
    lat: 39.760906,
    lng: -75.718976,
    panoId: "gWIxdM-JZiSQEzzTfARcBA",
    place: "Near North Star, Delaware",
    shortName: "North Star",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "DE",
    state: "Delaware",
    difficulty: "classic",
    pools: ["world","North America","US","US-DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-de-006",
    lat: 39.15819,
    lng: -75.524472,
    panoId: "iOMAarx0ncq8Srpi74G7Vw",
    place: "Near Dover, Delaware",
    shortName: "Dover",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "DE",
    state: "Delaware",
    difficulty: "classic",
    pools: ["world","North America","US","US-DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-de-007",
    lat: 39.299856,
    lng: -75.604767,
    panoId: "xeYVffqjssi5ytvLTwLNvQ",
    place: "Near Smyrna, Delaware",
    shortName: "Smyrna",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "DE",
    state: "Delaware",
    difficulty: "classic",
    pools: ["world","North America","US","US-DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-de-008",
    lat: 38.64124,
    lng: -75.610946,
    panoId: "8zEE70QA1nW6IRo916BpOg",
    place: "Near Seaford, Delaware",
    shortName: "Seaford",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "DE",
    state: "Delaware",
    difficulty: "classic",
    pools: ["world","North America","US","US-DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-de-009",
    lat: 39.667003,
    lng: -75.726842,
    panoId: "xtX8WrF824u1f5hy-jnRqw",
    place: "Near Brookside, Delaware",
    shortName: "Brookside",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "DE",
    state: "Delaware",
    difficulty: "classic",
    pools: ["world","North America","US","US-DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-de-010",
    lat: 39.78767,
    lng: -75.6965,
    panoId: "gkCqbG8PaXHuS6MwYtXY6g",
    place: "Near Hockessin, Delaware",
    shortName: "Hockessin",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "DE",
    state: "Delaware",
    difficulty: "classic",
    pools: ["world","North America","US","US-DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-de-011",
    lat: 39.449717,
    lng: -75.71626,
    panoId: "6Uh7zAL9oUTyyPFIJ4tRYA",
    place: "Near Middletown, Delaware",
    shortName: "Middletown",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "DE",
    state: "Delaware",
    difficulty: "classic",
    pools: ["world","North America","US","US-DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-de-012",
    lat: 39.739347,
    lng: -75.598008,
    panoId: "DyQSP_a6S89sjOS4CTyVDg",
    place: "Near Elsmere, Delaware",
    shortName: "Elsmere",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "DE",
    state: "Delaware",
    difficulty: "classic",
    pools: ["world","North America","US","US-DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-de-013",
    lat: 39.745873,
    lng: -75.546483,
    panoId: "2VEcvFjGj5ugK9-B5sSjQg",
    place: "Near Wilmington, Delaware",
    shortName: "Wilmington",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "DE",
    state: "Delaware",
    difficulty: "classic",
    pools: ["world","North America","US","US-DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-de-014",
    lat: 39.683314,
    lng: -75.749622,
    panoId: "Pfilzu5Kuso9cGurxEvQtQ",
    place: "Near Newark, Delaware",
    shortName: "Newark",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "DE",
    state: "Delaware",
    difficulty: "classic",
    pools: ["world","North America","US","US-DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-de-015",
    lat: 39.290675,
    lng: -75.634383,
    panoId: "sGu3J0KqciDMWuD88swi7w",
    place: "Near Clayton, Delaware",
    shortName: "Clayton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "DE",
    state: "Delaware",
    difficulty: "classic",
    pools: ["world","North America","US","US-DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-de-016",
    lat: 39.659493,
    lng: -75.563628,
    panoId: "FN0GIXz4NWCBkZGVgibQlg",
    place: "Near New Castle, Delaware",
    shortName: "New Castle",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "DE",
    state: "Delaware",
    difficulty: "classic",
    pools: ["world","North America","US","US-DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-de-017",
    lat: 38.690119,
    lng: -75.385501,
    panoId: "0L0QwRq5w1mwqIG_64yf1g",
    place: "Near Georgetown, Delaware",
    shortName: "Georgetown",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "DE",
    state: "Delaware",
    difficulty: "classic",
    pools: ["world","North America","US","US-DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-de-018",
    lat: 39.131672,
    lng: -75.524859,
    panoId: "PF4TjmHgP1PnQBNsoRBG9g",
    place: "Near Kent Acres, Delaware",
    shortName: "Kent Acres",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "DE",
    state: "Delaware",
    difficulty: "classic",
    pools: ["world","North America","US","US-DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-de-019",
    lat: 39.669462,
    lng: -75.738842,
    panoId: "Ywzh1eOVllOf1QaaWRfUKg",
    place: "Near Brookside, Delaware",
    shortName: "Brookside",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "DE",
    state: "Delaware",
    difficulty: "classic",
    pools: ["world","North America","US","US-DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-de-020",
    lat: 39.742711,
    lng: -75.719162,
    panoId: "ZPuMtmAtn1vON3pkSVHNfg",
    place: "Near Pike Creek, Delaware",
    shortName: "Pike Creek",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "DE",
    state: "Delaware",
    difficulty: "classic",
    pools: ["world","North America","US","US-DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-de-021",
    lat: 38.913952,
    lng: -75.451489,
    panoId: "qCvBGMUDjVWZrnZ5cu3aXw",
    place: "Near Milford, Delaware",
    shortName: "Milford",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "DE",
    state: "Delaware",
    difficulty: "classic",
    pools: ["world","North America","US","US-DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-de-022",
    lat: 39.617812,
    lng: -75.749029,
    panoId: "BEzqJWzIa2Swzi_SV62yuw",
    place: "Near Glasgow, Delaware",
    shortName: "Glasgow",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "DE",
    state: "Delaware",
    difficulty: "classic",
    pools: ["world","North America","US","US-DE"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-de-023",
    lat: 39.725199,
    lng: -75.555345,
    panoId: "hKm5zxsVYfKYHXX8J1T16g",
    place: "Near Wilmington, Delaware",
    shortName: "Wilmington",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "DE",
    state: "Delaware",
    difficulty: "classic",
    pools: ["world","North America","US","US-DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-de-024",
    lat: 39.278988,
    lng: -75.615433,
    panoId: "_1TYSpD1daGuUYmeR_tzYg",
    place: "Near Clayton, Delaware",
    shortName: "Clayton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "DE",
    state: "Delaware",
    difficulty: "classic",
    pools: ["world","North America","US","US-DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-de-025",
    lat: 39.754963,
    lng: -75.594798,
    panoId: "hw7YIT_Vm3uqCAxXfa3uRQ",
    place: "Near Elsmere, Delaware",
    shortName: "Elsmere",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "DE",
    state: "Delaware",
    difficulty: "classic",
    pools: ["world","North America","US","US-DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-de-026",
    lat: 39.677082,
    lng: -75.593691,
    panoId: "pVKWPWbw684LdrV4Bv5lgA",
    place: "Near Wilmington Manor, Delaware",
    shortName: "Wilmington Manor",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "DE",
    state: "Delaware",
    difficulty: "classic",
    pools: ["world","North America","US","US-DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-de-027",
    lat: 39.639808,
    lng: -75.546259,
    panoId: "sQG9cQU5-wXrh4e0m_JEpg",
    place: "Near New Castle, Delaware",
    shortName: "New Castle",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "DE",
    state: "Delaware",
    difficulty: "classic",
    pools: ["world","North America","US","US-DE"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-de-028",
    lat: 39.682857,
    lng: -75.609632,
    panoId: "8jcDc12Hqik7x3nIFfRUCA",
    place: "Near Wilmington Manor, Delaware",
    shortName: "Wilmington Manor",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "DE",
    state: "Delaware",
    difficulty: "classic",
    pools: ["world","North America","US","US-DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-de-029",
    lat: 39.73359,
    lng: -75.607606,
    panoId: "KkHxaZc7QqAPiMfd_MBmVg",
    place: "Near Elsmere, Delaware",
    shortName: "Elsmere",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "DE",
    state: "Delaware",
    difficulty: "classic",
    pools: ["world","North America","US","US-DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-de-030",
    lat: 39.766189,
    lng: -75.510219,
    panoId: "P2o5ffSHaPdcpd9YFIPovA",
    place: "Near Bellefonte, Delaware",
    shortName: "Bellefonte",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "DE",
    state: "Delaware",
    difficulty: "classic",
    pools: ["world","North America","US","US-DE"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-de-031",
    lat: 39.615849,
    lng: -75.713757,
    panoId: "wl8QdqzSyBNHLC5XDIBbJQ",
    place: "Near Glasgow, Delaware",
    shortName: "Glasgow",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "DE",
    state: "Delaware",
    difficulty: "classic",
    pools: ["world","North America","US","US-DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-de-032",
    lat: 39.776307,
    lng: -75.760108,
    panoId: "zfqt5QiYsKAPDFqJ-ss1ng",
    place: "Near Landenberg, Delaware",
    shortName: "Landenberg",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "DE",
    state: "Delaware",
    difficulty: "classic",
    pools: ["world","North America","US","US-DE"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-de-033",
    lat: 39.306936,
    lng: -75.581439,
    panoId: "t14ahaMhe05kW_A9OiRNWQ",
    place: "Near Smyrna, Delaware",
    shortName: "Smyrna",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "DE",
    state: "Delaware",
    difficulty: "classic",
    pools: ["world","North America","US","US-DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-de-034",
    lat: 39.796226,
    lng: -75.703845,
    panoId: "FYZjQhva87ETkfW-wusPMw",
    place: "Near Hockessin, Delaware",
    shortName: "Hockessin",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "DE",
    state: "Delaware",
    difficulty: "classic",
    pools: ["world","North America","US","US-DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-de-035",
    lat: 39.760397,
    lng: -75.742335,
    panoId: "7jVl3DTUmPb78_NmvYXPnQ",
    place: "Near North Star, Delaware",
    shortName: "North Star",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "DE",
    state: "Delaware",
    difficulty: "classic",
    pools: ["world","North America","US","US-DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-de-036",
    lat: 39.752035,
    lng: -75.57483,
    panoId: "0CXZnRB43y5IHJ5R0FKqQQ",
    place: "Near Elsmere, Delaware",
    shortName: "Elsmere",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "DE",
    state: "Delaware",
    difficulty: "classic",
    pools: ["world","North America","US","US-DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-de-037",
    lat: 39.826579,
    lng: -75.733362,
    panoId: "sxhpqCtUPY9UcJW_a_0UGg",
    place: "Near Toughkenamon, Delaware",
    shortName: "Toughkenamon",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "DE",
    state: "Delaware",
    difficulty: "classic",
    pools: ["world","North America","US","US-DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-de-038",
    lat: 39.16887,
    lng: -75.509902,
    panoId: "dIjptgRvqql1UzI5Y8qOUA",
    place: "Near Dover, Delaware",
    shortName: "Dover",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "DE",
    state: "Delaware",
    difficulty: "classic",
    pools: ["world","North America","US","US-DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-de-039",
    lat: 38.774424,
    lng: -75.139513,
    panoId: "7O82DRppbSQtBc9aLe9Q2Q",
    place: "Near Lewes, Delaware",
    shortName: "Lewes",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "DE",
    state: "Delaware",
    difficulty: "explorer",
    pools: ["world","North America","US","US-DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-de-040",
    lat: 38.742706,
    lng: -75.604449,
    panoId: "rG55GAQq798V2gYiWGuhqQ",
    place: "Near Bridgeville, Delaware",
    shortName: "Bridgeville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "DE",
    state: "Delaware",
    difficulty: "explorer",
    pools: ["world","North America","US","US-DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-de-041",
    lat: 39.11972,
    lng: -75.481716,
    panoId: "iUe_D4yccyZKTiMefziyfg",
    place: "Near Dover Base Housing, Delaware",
    shortName: "Dover Base Housing",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "DE",
    state: "Delaware",
    difficulty: "explorer",
    pools: ["world","North America","US","US-DE"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-de-042",
    lat: 38.591488,
    lng: -75.291399,
    panoId: "8ZTUnjuXtBr1oBRhugHaAA",
    place: "Near Millsboro, Delaware",
    shortName: "Millsboro",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "DE",
    state: "Delaware",
    difficulty: "explorer",
    pools: ["world","North America","US","US-DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-de-043",
    lat: 38.460542,
    lng: -75.220828,
    panoId: "rS5VSmgZHpB822xPRx_4rA",
    place: "Near Selbyville, Delaware",
    shortName: "Selbyville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "DE",
    state: "Delaware",
    difficulty: "explorer",
    pools: ["world","North America","US","US-DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-de-044",
    lat: 38.752057,
    lng: -75.187667,
    panoId: "5DLK-Oe2zSrVcje2RjPUIg",
    place: "Near Nassau, Delaware",
    shortName: "Nassau",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "DE",
    state: "Delaware",
    difficulty: "explorer",
    pools: ["world","North America","US","US-DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-de-045",
    lat: 38.777608,
    lng: -75.30986,
    panoId: "EGXf656M2fMzdBsqMqUFEg",
    place: "Near Milton, Delaware",
    shortName: "Milton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "DE",
    state: "Delaware",
    difficulty: "explorer",
    pools: ["world","North America","US","US-DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-de-046",
    lat: 39.395014,
    lng: -75.691835,
    panoId: "jN2I__7sfwkhItBHGHPL6Q",
    place: "Near Townsend, Delaware",
    shortName: "Townsend",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "DE",
    state: "Delaware",
    difficulty: "explorer",
    pools: ["world","North America","US","US-DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-de-047",
    lat: 38.923681,
    lng: -75.577616,
    panoId: "U1xo2q9rukh-ctU20KUhXA",
    place: "Near Harrington, Delaware",
    shortName: "Harrington",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "DE",
    state: "Delaware",
    difficulty: "explorer",
    pools: ["world","North America","US","US-DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-de-048",
    lat: 38.545317,
    lng: -75.088969,
    panoId: "pa9PN-hbQ8YAHi_2YUJrbA",
    place: "Near Ocean View, Delaware",
    shortName: "Ocean View",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "DE",
    state: "Delaware",
    difficulty: "explorer",
    pools: ["world","North America","US","US-DE"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-de-049",
    lat: 38.62006,
    lng: -75.150693,
    panoId: "BsmGAOMcke0A1OLJo7X1MQ",
    place: "Near Long Neck, Delaware",
    shortName: "Long Neck",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "DE",
    state: "Delaware",
    difficulty: "explorer",
    pools: ["world","North America","US","US-DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-de-050",
    lat: 39.121083,
    lng: -75.521786,
    panoId: "AFH5ywvCLwY52-cA6bZVgA",
    place: "Near Highland Acres, Delaware",
    shortName: "Highland Acres",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "DE",
    state: "Delaware",
    difficulty: "explorer",
    pools: ["world","North America","US","US-DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-de-051",
    lat: 39.026567,
    lng: -75.510835,
    panoId: "GWQqWKjmUPap1OjGYsy0jw",
    place: "Near Riverview, Delaware",
    shortName: "Riverview",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "DE",
    state: "Delaware",
    difficulty: "explorer",
    pools: ["world","North America","US","US-DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-de-052",
    lat: 39.778994,
    lng: -75.598277,
    panoId: "WpizlkTYz3VBGOzOBbJPeA",
    place: "Near Greenville, Delaware",
    shortName: "Greenville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "DE",
    state: "Delaware",
    difficulty: "explorer",
    pools: ["world","North America","US","US-DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-de-053",
    lat: 39.097265,
    lng: -75.5023,
    panoId: "AfhgdiTtuWvjtJDnWISVjQ",
    place: "Near Rising Sun-Lebanon, Delaware",
    shortName: "Rising Sun-Lebanon",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "DE",
    state: "Delaware",
    difficulty: "explorer",
    pools: ["world","North America","US","US-DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-de-054",
    lat: 38.55649,
    lng: -75.571174,
    panoId: "M5gS1laegl2mvDXOyl2oUg",
    place: "Near Laurel, Delaware",
    shortName: "Laurel",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "DE",
    state: "Delaware",
    difficulty: "explorer",
    pools: ["world","North America","US","US-DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-de-055",
    lat: 39.067374,
    lng: -75.536946,
    panoId: "OyjhwgftHWWiFQE-NmtKqw",
    place: "Near Woodside East, Delaware",
    shortName: "Woodside East",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "DE",
    state: "Delaware",
    difficulty: "explorer",
    pools: ["world","North America","US","US-DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-de-056",
    lat: 39.113479,
    lng: -75.541891,
    panoId: "_HX0rLIZWekvKkKixhGeRQ",
    place: "Near Camden, Delaware",
    shortName: "Camden",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "DE",
    state: "Delaware",
    difficulty: "explorer",
    pools: ["world","North America","US","US-DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-de-057",
    lat: 38.45652,
    lng: -75.576763,
    panoId: "CRH5E6Tv_ZIBki9lu6_3Yw",
    place: "Near Delmar, Delaware",
    shortName: "Delmar",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "DE",
    state: "Delaware",
    difficulty: "explorer",
    pools: ["world","North America","US","US-DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-de-058",
    lat: 39.57778,
    lng: -75.589482,
    panoId: "345NZhPEAY0C8mYumkB3mA",
    place: "Near Delaware City, Delaware",
    shortName: "Delaware City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "DE",
    state: "Delaware",
    difficulty: "explorer",
    pools: ["world","North America","US","US-DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-de-059",
    lat: 39.136468,
    lng: -75.470968,
    panoId: "O_C0ibspHI9aGuxwOs3DYA",
    place: "Near Dover Base Housing, Delaware",
    shortName: "Dover Base Housing",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "DE",
    state: "Delaware",
    difficulty: "explorer",
    pools: ["world","North America","US","US-DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-de-060",
    lat: 38.758343,
    lng: -75.585542,
    panoId: "LsWClskTbYMqUjXXEwq04A",
    place: "Near Bridgeville, Delaware",
    shortName: "Bridgeville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "DE",
    state: "Delaware",
    difficulty: "explorer",
    pools: ["world","North America","US","US-DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-de-061",
    lat: 38.460267,
    lng: -75.23812,
    panoId: "rapifi8f7ljnHCwC1Aa_dQ",
    place: "Near Selbyville, Delaware",
    shortName: "Selbyville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "DE",
    state: "Delaware",
    difficulty: "explorer",
    pools: ["world","North America","US","US-DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-de-062",
    lat: 38.796144,
    lng: -75.209175,
    panoId: "lerrJWiKTMJKvpHK5-n3SQ",
    place: "Near Nassau, Delaware",
    shortName: "Nassau",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "DE",
    state: "Delaware",
    difficulty: "explorer",
    pools: ["world","North America","US","US-DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-de-063",
    lat: 39.400971,
    lng: -75.602714,
    panoId: "yUSQkqiCixl9p7Uyg10vCQ",
    place: "Near Townsend, Delaware",
    shortName: "Townsend",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "DE",
    state: "Delaware",
    difficulty: "explorer",
    pools: ["world","North America","US","US-DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-de-064",
    lat: 39.223978,
    lng: -75.497387,
    panoId: "R9Q5BENLLrilQhU6NUE-Tg",
    place: "Near Cheswold, Delaware",
    shortName: "Cheswold",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "DE",
    state: "Delaware",
    difficulty: "explorer",
    pools: ["world","North America","US","US-DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-de-065",
    lat: 38.635592,
    lng: -75.326091,
    panoId: "pd3jYzipsoKLSfxa68dXDw",
    place: "Near Millsboro, Delaware",
    shortName: "Millsboro",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "DE",
    state: "Delaware",
    difficulty: "explorer",
    pools: ["world","North America","US","US-DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-de-066",
    lat: 38.793958,
    lng: -75.319038,
    panoId: "6CsErbWRorODTY4Y8h_Csw",
    place: "Near Milton, Delaware",
    shortName: "Milton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "DE",
    state: "Delaware",
    difficulty: "explorer",
    pools: ["world","North America","US","US-DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-de-067",
    lat: 38.712044,
    lng: -75.211525,
    panoId: "2ThIkb_XiCEGP56Efcs3UA",
    place: "Near Nassau, Delaware",
    shortName: "Nassau",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "DE",
    state: "Delaware",
    difficulty: "explorer",
    pools: ["world","North America","US","US-DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-de-068",
    lat: 38.443759,
    lng: -75.521961,
    panoId: "_LHoVYCeprvCPRSDsEoUQQ",
    place: "Near Delmar, Delaware",
    shortName: "Delmar",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "DE",
    state: "Delaware",
    difficulty: "explorer",
    pools: ["world","North America","US","US-DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-de-069",
    lat: 39.258729,
    lng: -75.696631,
    panoId: "RkbsIW79fqPMizOwXbfGEg",
    place: "Near Clayton, Delaware",
    shortName: "Clayton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "DE",
    state: "Delaware",
    difficulty: "explorer",
    pools: ["world","North America","US","US-DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-de-070",
    lat: 39.112883,
    lng: -75.590922,
    panoId: "GUojugf_cv87mYDKmzJeZg",
    place: "Near Wyoming, Delaware",
    shortName: "Wyoming",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "DE",
    state: "Delaware",
    difficulty: "explorer",
    pools: ["world","North America","US","US-DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-de-071",
    lat: 38.608341,
    lng: -75.672388,
    panoId: "DXLYByBMFrnBMsKS4rt1vQ",
    place: "Near Blades, Delaware",
    shortName: "Blades",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "DE",
    state: "Delaware",
    difficulty: "explorer",
    pools: ["world","North America","US","US-DE"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-de-072",
    lat: 38.488589,
    lng: -75.118336,
    panoId: "j3-X_VUDS23vkyJg1HEbVg",
    place: "Near Ocean View, Delaware",
    shortName: "Ocean View",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "DE",
    state: "Delaware",
    difficulty: "explorer",
    pools: ["world","North America","US","US-DE"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-de-073",
    lat: 38.907943,
    lng: -75.644703,
    panoId: "8UZfs9TjjX_8UZkGd4GnMw",
    place: "Near Harrington, Delaware",
    shortName: "Harrington",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "DE",
    state: "Delaware",
    difficulty: "explorer",
    pools: ["world","North America","US","US-DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-de-074",
    lat: 38.563685,
    lng: -75.550557,
    panoId: "3hLG9piDmqQfKaILl8tuIA",
    place: "Near Laurel, Delaware",
    shortName: "Laurel",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "DE",
    state: "Delaware",
    difficulty: "explorer",
    pools: ["world","North America","US","US-DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-de-075",
    lat: 39.01931,
    lng: -75.584215,
    panoId: "kkU8lzkLlVDne_vg1JAW7g",
    place: "Near Felton, Delaware",
    shortName: "Felton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "DE",
    state: "Delaware",
    difficulty: "explorer",
    pools: ["world","North America","US","US-DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-de-076",
    lat: 39.787809,
    lng: -75.653186,
    panoId: "lKKs-HK_0uwGq-ZWOhN2LA",
    place: "Near Hockessin, Delaware",
    shortName: "Hockessin",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "DE",
    state: "Delaware",
    difficulty: "explorer",
    pools: ["world","North America","US","US-DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-de-077",
    lat: 38.684831,
    lng: -75.160213,
    panoId: "SVLs5xYoe1m5MiAHYLcv2A",
    place: "Near Long Neck, Delaware",
    shortName: "Long Neck",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "DE",
    state: "Delaware",
    difficulty: "explorer",
    pools: ["world","North America","US","US-DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-de-078",
    lat: 38.782621,
    lng: -75.671737,
    panoId: "u6BJZrxOC4fu9mhs_NgHtA",
    place: "Near Bridgeville, Delaware",
    shortName: "Bridgeville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "DE",
    state: "Delaware",
    difficulty: "explorer",
    pools: ["world","North America","US","US-DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-de-079",
    lat: 39.771784,
    lng: -75.664281,
    panoId: "fjs8CUEVYjxuAJ_SSyTPKw",
    place: "Near Hockessin, Delaware",
    shortName: "Hockessin",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "DE",
    state: "Delaware",
    difficulty: "explorer",
    pools: ["world","North America","US","US-DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-de-080",
    lat: 38.445564,
    lng: -75.27386,
    panoId: "HVBZvPDRUq8Xhy8V95W-VQ",
    place: "Near Selbyville, Delaware",
    shortName: "Selbyville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "DE",
    state: "Delaware",
    difficulty: "explorer",
    pools: ["world","North America","US","US-DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-de-081",
    lat: 39.685283,
    lng: -75.507102,
    panoId: "GNwvnDBhnmbu5Oc4nABsdg",
    place: "Near Pennsville, Delaware",
    shortName: "Pennsville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "DE",
    state: "Delaware",
    difficulty: "explorer",
    pools: ["world","North America","US","US-DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-de-082",
    lat: 39.718087,
    lng: -75.66912,
    panoId: "Xj05LYuS7mFCiHVAunMkEw",
    place: "Near Pike Creek Valley, Delaware",
    shortName: "Pike Creek Valley",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "DE",
    state: "Delaware",
    difficulty: "explorer",
    pools: ["world","North America","US","US-DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-de-083",
    lat: 39.09256,
    lng: -75.589251,
    panoId: "u8VfJMj1B_ix-I4JmTpgjg",
    place: "Near Wyoming, Delaware",
    shortName: "Wyoming",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "DE",
    state: "Delaware",
    difficulty: "explorer",
    pools: ["world","North America","US","US-DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-de-084",
    lat: 38.916267,
    lng: -75.483167,
    panoId: "nxlIgWVqy2pt7LlPNG2t2A",
    place: "Near Milford, Delaware",
    shortName: "Milford",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "DE",
    state: "Delaware",
    difficulty: "explorer",
    pools: ["world","North America","US","US-DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-de-085",
    lat: 38.721727,
    lng: -75.144889,
    panoId: "243zffb7bPgXm-6uJDOqDA",
    place: "Near Nassau, Delaware",
    shortName: "Nassau",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "DE",
    state: "Delaware",
    difficulty: "explorer",
    pools: ["world","North America","US","US-DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-de-086",
    lat: 39.68372,
    lng: -75.809493,
    panoId: "PaCV5hhXnF8W_PmPrMoh5A",
    place: "Near Newark, Delaware",
    shortName: "Newark",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "DE",
    state: "Delaware",
    difficulty: "explorer",
    pools: ["world","North America","US","US-DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-de-087",
    lat: 38.75998,
    lng: -75.116912,
    panoId: "QCo_R0XW1hhB3kXcCfjRQA",
    place: "Near Lewes, Delaware",
    shortName: "Lewes",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "DE",
    state: "Delaware",
    difficulty: "explorer",
    pools: ["world","North America","US","US-DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-de-088",
    lat: 38.799149,
    lng: -75.3422,
    panoId: "DOXjrdJN0CVobybJd1xf4w",
    place: "Near Milton, Delaware",
    shortName: "Milton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "DE",
    state: "Delaware",
    difficulty: "explorer",
    pools: ["world","North America","US","US-DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-de-089",
    lat: 38.915555,
    lng: -75.763922,
    panoId: "BdckxEULi4v2Kd9a_3rxiQ",
    place: "Near Denton, Delaware",
    shortName: "Denton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "DE",
    state: "Delaware",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-de-090",
    lat: 39.074594,
    lng: -75.681501,
    panoId: "sJ_tlAZG2F1PffiBspkj5w",
    place: "Near Felton, Delaware",
    shortName: "Felton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "DE",
    state: "Delaware",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-de-091",
    lat: 39.148515,
    lng: -75.707289,
    panoId: "rv6gfhW92U1-1nLvqBgVVQ",
    place: "Near Cheswold, Delaware",
    shortName: "Cheswold",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "DE",
    state: "Delaware",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-de-092",
    lat: 39.041974,
    lng: -75.69402,
    panoId: "kPKn-KCanVyGfjX0K_1X_w",
    place: "Near Felton, Delaware",
    shortName: "Felton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "DE",
    state: "Delaware",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-de-093",
    lat: 39.308848,
    lng: -75.87977,
    panoId: "mlPCDMfYlDjAppy37uQgNw",
    place: "Near Kingstown, Delaware",
    shortName: "Kingstown",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "DE",
    state: "Delaware",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-de-094",
    lat: 38.732946,
    lng: -75.084339,
    panoId: "oxEm9hcVS4p2GqmciVzEeQ",
    place: "Near Rehoboth Beach, Delaware",
    shortName: "Rehoboth Beach",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "DE",
    state: "Delaware",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-fl-000",
    lat: 26.011302,
    lng: -80.149498,
    panoId: "D1gqMDBKAAiRIWOjBW_xgw",
    place: "Near Hollywood, Florida",
    shortName: "Hollywood",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "FL",
    state: "Florida",
    difficulty: "classic",
    pools: ["world","North America","US","US-FL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-fl-001",
    lat: 25.94202,
    lng: -80.245446,
    panoId: "6o9qGbTIAsDlWvL18v4Jsg",
    place: "Near Miami Gardens, Florida",
    shortName: "Miami Gardens",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "FL",
    state: "Florida",
    difficulty: "classic",
    pools: ["world","North America","US","US-FL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-fl-002",
    lat: 30.332128,
    lng: -81.655669,
    panoId: "ztJOrKoZbdVKvdlzq9jFfQ",
    place: "Near Jacksonville, Florida",
    shortName: "Jacksonville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "FL",
    state: "Florida",
    difficulty: "classic",
    pools: ["world","North America","US","US-FL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-fl-003",
    lat: 29.651603,
    lng: -82.325003,
    panoId: "QyIx6xdxbdoJpz8o3i_NXA",
    place: "Near Gainesville, Florida",
    shortName: "Gainesville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "FL",
    state: "Florida",
    difficulty: "classic",
    pools: ["world","North America","US","US-FL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-fl-004",
    lat: 27.937767,
    lng: -82.285926,
    panoId: "DhYJYrhYkOgRKcvkm7HmGw",
    place: "Near Brandon, Florida",
    shortName: "Brandon",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "FL",
    state: "Florida",
    difficulty: "classic",
    pools: ["world","North America","US","US-FL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-fl-005",
    lat: 26.271209,
    lng: -80.270991,
    panoId: "-77Crxp565ZWKNMsC_NdAg",
    place: "Near Coral Springs, Florida",
    shortName: "Coral Springs",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "FL",
    state: "Florida",
    difficulty: "classic",
    pools: ["world","North America","US","US-FL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-fl-006",
    lat: 30.438241,
    lng: -84.28063,
    panoId: "PFwoN1t8RKEU-PtEiNQMhw",
    place: "Near Tallahassee, Florida",
    shortName: "Tallahassee",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "FL",
    state: "Florida",
    difficulty: "classic",
    pools: ["world","North America","US","US-FL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-fl-007",
    lat: 27.947527,
    lng: -82.458421,
    panoId: "b2B2YynKkc40aVuKC8lqOw",
    place: "Near Tampa, Florida",
    shortName: "Tampa",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "FL",
    state: "Florida",
    difficulty: "classic",
    pools: ["world","North America","US","US-FL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-fl-008",
    lat: 27.77082,
    lng: -82.679361,
    panoId: "gFuvoufDyq3svXkQyzCefw",
    place: "Near St. Petersburg, Florida",
    shortName: "St. Petersburg",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "FL",
    state: "Florida",
    difficulty: "classic",
    pools: ["world","North America","US","US-FL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-fl-009",
    lat: 27.294387,
    lng: -80.350292,
    panoId: "Mf7j10zoRG-kQeuNT0fLqQ",
    place: "Near Port Saint Lucie, Florida",
    shortName: "Port Saint Lucie",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "FL",
    state: "Florida",
    difficulty: "classic",
    pools: ["world","North America","US","US-FL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-fl-010",
    lat: 28.083662,
    lng: -80.608194,
    panoId: "NYvO7k0Qvsgx59ttCdFPbQ",
    place: "Near Melbourne, Florida",
    shortName: "Melbourne",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "FL",
    state: "Florida",
    difficulty: "classic",
    pools: ["world","North America","US","US-FL"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-fl-011",
    lat: 28.90055,
    lng: -81.263374,
    panoId: "Mlks1xl-DPTH8P03vBzlxQ",
    place: "Near Deltona, Florida",
    shortName: "Deltona",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "FL",
    state: "Florida",
    difficulty: "classic",
    pools: ["world","North America","US","US-FL"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-fl-012",
    lat: 27.909843,
    lng: -82.788399,
    panoId: "TpTcgJjkR9YDkctwEU4icQ",
    place: "Near Largo, Florida",
    shortName: "Largo",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "FL",
    state: "Florida",
    difficulty: "classic",
    pools: ["world","North America","US","US-FL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-fl-013",
    lat: 26.135283,
    lng: -80.112872,
    panoId: "ivbG543MM-EU3m1QvQZOjA",
    place: "Near Sunrise, Florida",
    shortName: "Sunrise",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "FL",
    state: "Florida",
    difficulty: "classic",
    pools: ["world","North America","US","US-FL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-fl-014",
    lat: 25.857767,
    lng: -80.27815,
    panoId: "PSL7BbrnxnaBPTBenlQLpg",
    place: "Near Hialeah, Florida",
    shortName: "Hialeah",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "FL",
    state: "Florida",
    difficulty: "classic",
    pools: ["world","North America","US","US-FL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-fl-015",
    lat: 28.47689,
    lng: -82.52551,
    panoId: "eYCOKkib4yle4_7bkHXukQ",
    place: "Near Spring Hill, Florida",
    shortName: "Spring Hill",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "FL",
    state: "Florida",
    difficulty: "classic",
    pools: ["world","North America","US","US-FL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-fl-016",
    lat: 26.063002,
    lng: -80.23319,
    panoId: "IW9252LOAncW1gHimHGpbA",
    place: "Near Davie, Florida",
    shortName: "Davie",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "FL",
    state: "Florida",
    difficulty: "classic",
    pools: ["world","North America","US","US-FL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-fl-017",
    lat: 28.03968,
    lng: -81.949792,
    panoId: "wdu2V48oOxaJ-ThtESGuGQ",
    place: "Near Lakeland, Florida",
    shortName: "Lakeland",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "FL",
    state: "Florida",
    difficulty: "classic",
    pools: ["world","North America","US","US-FL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-fl-018",
    lat: 25.790681,
    lng: -80.130086,
    panoId: "xDT_aWP2Cg0AFrlFSYXtFA",
    place: "Near Miami Beach, Florida",
    shortName: "Miami Beach",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "FL",
    state: "Florida",
    difficulty: "classic",
    pools: ["world","North America","US","US-FL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-fl-019",
    lat: 27.96583,
    lng: -82.799963,
    panoId: "JM8wFTwVLP9CCdoMruW5Yg",
    place: "Near Clearwater, Florida",
    shortName: "Clearwater",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "FL",
    state: "Florida",
    difficulty: "classic",
    pools: ["world","North America","US","US-FL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-fl-020",
    lat: 25.679269,
    lng: -80.317276,
    panoId: "s-4HhHtEPavtgG7hKv9TyQ",
    place: "Near Kendall, Florida",
    shortName: "Kendall",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "FL",
    state: "Florida",
    difficulty: "classic",
    pools: ["world","North America","US","US-FL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-fl-021",
    lat: 26.358306,
    lng: -80.082837,
    panoId: "b_xMl12q5pQ32gfmduphGg",
    place: "Near Boca Raton, Florida",
    shortName: "Boca Raton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "FL",
    state: "Florida",
    difficulty: "classic",
    pools: ["world","North America","US","US-FL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-fl-022",
    lat: 26.715328,
    lng: -80.053507,
    panoId: "RRmpqMf2T8jLIPniwVrbbA",
    place: "Near West Palm Beach, Florida",
    shortName: "West Palm Beach",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "FL",
    state: "Florida",
    difficulty: "classic",
    pools: ["world","North America","US","US-FL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-fl-023",
    lat: 28.538332,
    lng: -81.37929,
    panoId: "VVXGu78kBbvW6QsCJRq0PQ",
    place: "Near Orlando, Florida",
    shortName: "Orlando",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "FL",
    state: "Florida",
    difficulty: "classic",
    pools: ["world","North America","US","US-FL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-fl-024",
    lat: 26.122359,
    lng: -80.143367,
    panoId: "fIXRmWv0SQnLHcZTrgG70A",
    place: "Near Fort Lauderdale, Florida",
    shortName: "Fort Lauderdale",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "FL",
    state: "Florida",
    difficulty: "classic",
    pools: ["world","North America","US","US-FL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-fl-025",
    lat: 26.625394,
    lng: -81.625076,
    panoId: "pqtMRbLirL4q8hs-SHdbaQ",
    place: "Near Lehigh Acres, Florida",
    shortName: "Lehigh Acres",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "FL",
    state: "Florida",
    difficulty: "classic",
    pools: ["world","North America","US","US-FL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-fl-026",
    lat: 28.034445,
    lng: -80.58863,
    panoId: "coWTeHE7gO4L8tWL7PQO8g",
    place: "Near Palm Bay, Florida",
    shortName: "Palm Bay",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "FL",
    state: "Florida",
    difficulty: "classic",
    pools: ["world","North America","US","US-FL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-fl-027",
    lat: 26.318388,
    lng: -80.099756,
    panoId: "muPwFs-F6WTXo_yP1k_vbA",
    place: "Near Deerfield Beach, Florida",
    shortName: "Deerfield Beach",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "FL",
    state: "Florida",
    difficulty: "classic",
    pools: ["world","North America","US","US-FL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-fl-028",
    lat: 26.003152,
    lng: -80.223965,
    panoId: "spM9oK9F1gD6bY3r35O_fg",
    place: "Near Pembroke Pines, Florida",
    shortName: "Pembroke Pines",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "FL",
    state: "Florida",
    difficulty: "classic",
    pools: ["world","North America","US","US-FL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-fl-029",
    lat: 26.134245,
    lng: -80.232118,
    panoId: "wR4FR87AUB1EIcpoxCp19A",
    place: "Near Plantation, Florida",
    shortName: "Plantation",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "FL",
    state: "Florida",
    difficulty: "classic",
    pools: ["world","North America","US","US-FL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-fl-030",
    lat: 26.237811,
    lng: -80.124409,
    panoId: "CDZ3vEDyAG0CWUD29J1lGA",
    place: "Near Pompano Beach, Florida",
    shortName: "Pompano Beach",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "FL",
    state: "Florida",
    difficulty: "classic",
    pools: ["world","North America","US","US-FL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-fl-031",
    lat: 29.585068,
    lng: -81.20787,
    panoId: "6zMTi40NHKQmVosFwuLv5g",
    place: "Near Palm Coast, Florida",
    shortName: "Palm Coast",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "FL",
    state: "Florida",
    difficulty: "classic",
    pools: ["world","North America","US","US-FL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-fl-032",
    lat: 26.562871,
    lng: -81.949513,
    panoId: "Xow_QgTTr6PsGvmwzk4KFQ",
    place: "Near Cape Coral, Florida",
    shortName: "Cape Coral",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "FL",
    state: "Florida",
    difficulty: "classic",
    pools: ["world","North America","US","US-FL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-fl-033",
    lat: 25.987327,
    lng: -80.232402,
    panoId: "26zTso0OkunFzXkW6acBfQ",
    place: "Near Miramar, Florida",
    shortName: "Miramar",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "FL",
    state: "Florida",
    difficulty: "classic",
    pools: ["world","North America","US","US-FL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-fl-034",
    lat: 28.564077,
    lng: -81.211733,
    panoId: "NI9uwFSvRlINlW5FuNZprw",
    place: "Near Alafaya, Florida",
    shortName: "Alafaya",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "FL",
    state: "Florida",
    difficulty: "classic",
    pools: ["world","North America","US","US-FL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-fl-035",
    lat: 28.010707,
    lng: -82.577343,
    panoId: "GM-uRCRW2dycbpl79LL7Yg",
    place: "Near Town 'n' Country, Florida",
    shortName: "Town 'n' Country",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "FL",
    state: "Florida",
    difficulty: "classic",
    pools: ["world","North America","US","US-FL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-fl-036",
    lat: 25.820814,
    lng: -80.355103,
    panoId: "caIdTDGfxYQAw2alpcSRSA",
    place: "Near Doral, Florida",
    shortName: "Doral",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "FL",
    state: "Florida",
    difficulty: "classic",
    pools: ["world","North America","US","US-FL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-fl-037",
    lat: 30.428633,
    lng: -84.274551,
    panoId: "N6zCk1anMbVGl3lZkBx_NQ",
    place: "Near Tallahassee, Florida",
    shortName: "Tallahassee",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "FL",
    state: "Florida",
    difficulty: "classic",
    pools: ["world","North America","US","US-FL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-fl-038",
    lat: 26.552481,
    lng: -81.946082,
    panoId: "gdXOm93guGIvyEq6ygPk5Q",
    place: "Near Cape Coral, Florida",
    shortName: "Cape Coral",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "FL",
    state: "Florida",
    difficulty: "classic",
    pools: ["world","North America","US","US-FL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-fl-039",
    lat: 26.128316,
    lng: -80.119404,
    panoId: "rr1vVJn3VLpTuDVee0Zorg",
    place: "Near Sunrise, Florida",
    shortName: "Sunrise",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "FL",
    state: "Florida",
    difficulty: "classic",
    pools: ["world","North America","US","US-FL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-fl-040",
    lat: 26.02364,
    lng: -80.2262,
    panoId: "dZ-4ig52koeRizIiFLuXQQ",
    place: "Near Pembroke Pines, Florida",
    shortName: "Pembroke Pines",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "FL",
    state: "Florida",
    difficulty: "classic",
    pools: ["world","North America","US","US-FL"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-fl-041",
    lat: 28.911049,
    lng: -81.263547,
    panoId: "UjesitsGqLialKj1JyybHA",
    place: "Near Deltona, Florida",
    shortName: "Deltona",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "FL",
    state: "Florida",
    difficulty: "classic",
    pools: ["world","North America","US","US-FL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-fl-042",
    lat: 26.370991,
    lng: -80.068501,
    panoId: "4p6T6w2ewKFQGgKEAxAYyg",
    place: "Near Boca Raton, Florida",
    shortName: "Boca Raton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "FL",
    state: "Florida",
    difficulty: "classic",
    pools: ["world","North America","US","US-FL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-fl-043",
    lat: 27.946859,
    lng: -82.281277,
    panoId: "ZyfO4opy_0Aq2D6b2WuYCQ",
    place: "Near Brandon, Florida",
    shortName: "Brandon",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "FL",
    state: "Florida",
    difficulty: "classic",
    pools: ["world","North America","US","US-FL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-fl-044",
    lat: 27.918613,
    lng: -82.806882,
    panoId: "RMW8nq-6JqM2uBk0Evu4uA",
    place: "Near Belleair Bluffs, Florida",
    shortName: "Belleair Bluffs",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "FL",
    state: "Florida",
    difficulty: "classic",
    pools: ["world","North America","US","US-FL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-fl-045",
    lat: 28.494419,
    lng: -82.535744,
    panoId: "t1PNoFiMwpbKrhu8Ze-KPA",
    place: "Near Spring Hill, Florida",
    shortName: "Spring Hill",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "FL",
    state: "Florida",
    difficulty: "classic",
    pools: ["world","North America","US","US-FL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-fl-046",
    lat: 25.855938,
    lng: -80.260777,
    panoId: "3A32JtyfcWe-kgUML0FjNg",
    place: "Near Hialeah, Florida",
    shortName: "Hialeah",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "FL",
    state: "Florida",
    difficulty: "classic",
    pools: ["world","North America","US","US-FL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-fl-047",
    lat: 26.010979,
    lng: -80.125478,
    panoId: "KaQPTtvpLVGvyApDGHDjyw",
    place: "Near Hollywood, Florida",
    shortName: "Hollywood",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "FL",
    state: "Florida",
    difficulty: "classic",
    pools: ["world","North America","US","US-FL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-fl-048",
    lat: 29.657591,
    lng: -82.304771,
    panoId: "7LN8rWwWefQQX01GTzfLwA",
    place: "Near Gainesville, Florida",
    shortName: "Gainesville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "FL",
    state: "Florida",
    difficulty: "classic",
    pools: ["world","North America","US","US-FL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-fl-049",
    lat: 25.778474,
    lng: -80.202896,
    panoId: "s45qvZqqP4MD9ULojGbJeA",
    place: "Near Miami, Florida",
    shortName: "Miami",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "FL",
    state: "Florida",
    difficulty: "classic",
    pools: ["world","North America","US","US-FL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-fl-050",
    lat: 25.787544,
    lng: -80.257732,
    panoId: "S7sHlQLEfYI3AcCWAK3NxQ",
    place: "Near Little Havana, Florida",
    shortName: "Little Havana",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "FL",
    state: "Florida",
    difficulty: "explorer",
    pools: ["world","North America","US","US-FL"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-fl-051",
    lat: 26.369341,
    lng: -80.115641,
    panoId: "-3UUjJJxLiOxAQIqvOhZyQ",
    place: "Near Boca Raton, Florida",
    shortName: "Boca Raton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "FL",
    state: "Florida",
    difficulty: "explorer",
    pools: ["world","North America","US","US-FL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-fl-052",
    lat: 26.675511,
    lng: -80.042199,
    panoId: "HnW2vPO7SZAY8aDK4u6izg",
    place: "Near Palm Beach, Florida",
    shortName: "Palm Beach",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "FL",
    state: "Florida",
    difficulty: "explorer",
    pools: ["world","North America","US","US-FL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-fl-053",
    lat: 27.96506,
    lng: -80.572094,
    panoId: "KzCtMAXEj-fRPL0DpoQk0g",
    place: "Near Grant-Valkaria, Florida",
    shortName: "Grant-Valkaria",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "FL",
    state: "Florida",
    difficulty: "explorer",
    pools: ["world","North America","US","US-FL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-fl-054",
    lat: 26.2399,
    lng: -80.25953,
    panoId: "5SAqiJAsOElPSNe8SiXseQ",
    place: "Near Tamarac, Florida",
    shortName: "Tamarac",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "FL",
    state: "Florida",
    difficulty: "explorer",
    pools: ["world","North America","US","US-FL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-fl-055",
    lat: 27.346775,
    lng: -80.352074,
    panoId: "IRavQI1uPKSYisp054NEMQ",
    place: "Near White City, Florida",
    shortName: "White City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "FL",
    state: "Florida",
    difficulty: "explorer",
    pools: ["world","North America","US","US-FL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-fl-056",
    lat: 30.361238,
    lng: -81.661751,
    panoId: "xfaX6FO3zCHs2l9apRgogA",
    place: "Near Jacksonville, Florida",
    shortName: "Jacksonville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "FL",
    state: "Florida",
    difficulty: "explorer",
    pools: ["world","North America","US","US-FL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-fl-057",
    lat: 30.505148,
    lng: -84.271091,
    panoId: "imtHFR7JnyEIcqiVn1omxg",
    place: "Near Tallahassee, Florida",
    shortName: "Tallahassee",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "FL",
    state: "Florida",
    difficulty: "explorer",
    pools: ["world","North America","US","US-FL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-fl-058",
    lat: 29.530192,
    lng: -81.202028,
    panoId: "U4B-RBo7sIWYSbSjIq7aCQ",
    place: "Near Palm Coast, Florida",
    shortName: "Palm Coast",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "FL",
    state: "Florida",
    difficulty: "explorer",
    pools: ["world","North America","US","US-FL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-fl-059",
    lat: 26.607399,
    lng: -81.910059,
    panoId: "PxQIngXaJpO73c5hsfMW8w",
    place: "Near Lochmoor Waterway Estates, Florida",
    shortName: "Lochmoor Waterway Estates",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "FL",
    state: "Florida",
    difficulty: "explorer",
    pools: ["world","North America","US","US-FL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-fl-060",
    lat: 28.042748,
    lng: -82.573326,
    panoId: "6NXfjV7zZJK2vRQhFeyivA",
    place: "Near Town 'n' Country, Florida",
    shortName: "Town 'n' Country",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "FL",
    state: "Florida",
    difficulty: "explorer",
    pools: ["world","North America","US","US-FL"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-fl-061",
    lat: 27.948502,
    lng: -82.397635,
    panoId: "jm143PmzMV12v4iPg-NSlg",
    place: "Near Palm River-Clair Mel, Florida",
    shortName: "Palm River-Clair Mel",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "FL",
    state: "Florida",
    difficulty: "explorer",
    pools: ["world","North America","US","US-FL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-fl-062",
    lat: 26.299052,
    lng: -80.177346,
    panoId: "8i2izZHulR3kPWbC2sXMbg",
    place: "Near Boca Pointe, Florida",
    shortName: "Boca Pointe",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "FL",
    state: "Florida",
    difficulty: "explorer",
    pools: ["world","North America","US","US-FL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-fl-063",
    lat: 26.602656,
    lng: -82.001718,
    panoId: "vhPuyirwiz73Cmpp_-cscg",
    place: "Near Cape Coral, Florida",
    shortName: "Cape Coral",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "FL",
    state: "Florida",
    difficulty: "explorer",
    pools: ["world","North America","US","US-FL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-fl-064",
    lat: 28.069648,
    lng: -82.003011,
    panoId: "3Qy8cbAob3-g8DubCrmUfw",
    place: "Near Winston, Florida",
    shortName: "Winston",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "FL",
    state: "Florida",
    difficulty: "explorer",
    pools: ["world","North America","US","US-FL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-fl-065",
    lat: 29.671403,
    lng: -82.37345,
    panoId: "lrfCbWgIoJrzi4QwdDTFFw",
    place: "Near Gainesville, Florida",
    shortName: "Gainesville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "FL",
    state: "Florida",
    difficulty: "explorer",
    pools: ["world","North America","US","US-FL"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "us-fl-066",
    lat: 28.026916,
    lng: -80.666496,
    panoId: "wN6gXL5bpixDvMfzgSvWXg",
    place: "Near West Melbourne, Florida",
    shortName: "West Melbourne",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "FL",
    state: "Florida",
    difficulty: "explorer",
    pools: ["world","North America","US","US-FL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-fl-067",
    lat: 30.282144,
    lng: -81.708748,
    panoId: "mUwBd-sbQqhzRc_Ng3PHeQ",
    place: "Near Jacksonville, Florida",
    shortName: "Jacksonville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "FL",
    state: "Florida",
    difficulty: "explorer",
    pools: ["world","North America","US","US-FL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-fl-068",
    lat: 26.725823,
    lng: -81.89311,
    panoId: "KOcuTENTH-o1l-3rZ0vjCg",
    place: "Near Suncoast Estates, Florida",
    shortName: "Suncoast Estates",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "FL",
    state: "Florida",
    difficulty: "explorer",
    pools: ["world","North America","US","US-FL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-fl-069",
    lat: 27.76993,
    lng: -82.240613,
    panoId: "X_zeZnssm1ci3eCQFlJJAQ",
    place: "Near Balm, Florida",
    shortName: "Balm",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "FL",
    state: "Florida",
    difficulty: "explorer",
    pools: ["world","North America","US","US-FL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-fl-070",
    lat: 27.870101,
    lng: -82.686804,
    panoId: "kiWd3ig2_nRzZrgLNIqubw",
    place: "Near Pinellas Park, Florida",
    shortName: "Pinellas Park",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "FL",
    state: "Florida",
    difficulty: "explorer",
    pools: ["world","North America","US","US-FL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-fl-071",
    lat: 25.979668,
    lng: -80.353219,
    panoId: "CmGLlZ40U2kexIao22LyQA",
    place: "Near Country Club, Florida",
    shortName: "Country Club",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "FL",
    state: "Florida",
    difficulty: "explorer",
    pools: ["world","North America","US","US-FL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-fl-072",
    lat: 27.967371,
    lng: -82.564379,
    panoId: "E4Qi8Wx6kdsOTWhrnuiZkg",
    place: "Near Town 'n' Country, Florida",
    shortName: "Town 'n' Country",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "FL",
    state: "Florida",
    difficulty: "explorer",
    pools: ["world","North America","US","US-FL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-fl-073",
    lat: 26.120761,
    lng: -80.31973,
    panoId: "8sx8ITWkDkVExzsdM8mkUw",
    place: "Near Pine Island Ridge, Florida",
    shortName: "Pine Island Ridge",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "FL",
    state: "Florida",
    difficulty: "explorer",
    pools: ["world","North America","US","US-FL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-fl-074",
    lat: 26.891934,
    lng: -80.120434,
    panoId: "qe9U4-h_nPsMfju6Hpt5Ew",
    place: "Near Jupiter, Florida",
    shortName: "Jupiter",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "FL",
    state: "Florida",
    difficulty: "explorer",
    pools: ["world","North America","US","US-FL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-fl-075",
    lat: 28.456921,
    lng: -81.452232,
    panoId: "v9Fy3pmC7Je6E5UtXQAsqQ",
    place: "Near Tangelo Park, Florida",
    shortName: "Tangelo Park",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "FL",
    state: "Florida",
    difficulty: "explorer",
    pools: ["world","North America","US","US-FL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-fl-076",
    lat: 26.42379,
    lng: -80.095928,
    panoId: "8h_8KOUVhKYdVB5yGmiSfg",
    place: "Near Highland Beach, Florida",
    shortName: "Highland Beach",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "FL",
    state: "Florida",
    difficulty: "explorer",
    pools: ["world","North America","US","US-FL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-fl-077",
    lat: 26.032954,
    lng: -80.230937,
    panoId: "U_S0Yb9ORguP9_jaDVctig",
    place: "Near Davie, Florida",
    shortName: "Davie",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "FL",
    state: "Florida",
    difficulty: "explorer",
    pools: ["world","North America","US","US-FL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-fl-078",
    lat: 26.133536,
    lng: -80.294238,
    panoId: "vrqWyJqn9MHH07zKPEibYw",
    place: "Near Pine Island Ridge, Florida",
    shortName: "Pine Island Ridge",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "FL",
    state: "Florida",
    difficulty: "explorer",
    pools: ["world","North America","US","US-FL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-fl-079",
    lat: 25.633333,
    lng: -80.50795,
    panoId: "CUqQT6oxMxH-Y19ULuK8mw",
    place: "Near Country Walk, Florida",
    shortName: "Country Walk",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "FL",
    state: "Florida",
    difficulty: "explorer",
    pools: ["world","North America","US","US-FL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-fl-080",
    lat: 29.177526,
    lng: -82.244322,
    panoId: "95ffkQPLnRTXw7TqISRrpg",
    place: "Near On Top of the World, Florida",
    shortName: "On Top of the World",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "FL",
    state: "Florida",
    difficulty: "explorer",
    pools: ["world","North America","US","US-FL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-fl-081",
    lat: 28.09371,
    lng: -80.706181,
    panoId: "GwAMyOMpGXE6iH4a2JCkMA",
    place: "Near June Park, Florida",
    shortName: "June Park",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "FL",
    state: "Florida",
    difficulty: "explorer",
    pools: ["world","North America","US","US-FL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-fl-082",
    lat: 26.622005,
    lng: -81.749165,
    panoId: "gQIC7iYwi7EZrN6VtQpalg",
    place: "Near Gateway, Florida",
    shortName: "Gateway",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "FL",
    state: "Florida",
    difficulty: "explorer",
    pools: ["world","North America","US","US-FL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-fl-083",
    lat: 28.412373,
    lng: -81.558922,
    panoId: "6f4Y5FtQO7VKYoJp9XVOqw",
    place: "Near Horizon West, Florida",
    shortName: "Horizon West",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "FL",
    state: "Florida",
    difficulty: "explorer",
    pools: ["world","North America","US","US-FL"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-fl-084",
    lat: 28.627338,
    lng: -81.409296,
    panoId: "ef0DQXm13aX8JiIPsQSLpA",
    place: "Near Eatonville, Florida",
    shortName: "Eatonville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "FL",
    state: "Florida",
    difficulty: "explorer",
    pools: ["world","North America","US","US-FL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-fl-085",
    lat: 26.683873,
    lng: -80.266798,
    panoId: "XqgOZ81HcMv5fHbmmnTiBQ",
    place: "Near Loxahatchee Groves, Florida",
    shortName: "Loxahatchee Groves",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "FL",
    state: "Florida",
    difficulty: "explorer",
    pools: ["world","North America","US","US-FL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-fl-086",
    lat: 27.396355,
    lng: -82.549322,
    panoId: "LkIqoB6epemTQqbHEJoQxg",
    place: "Near Whitfield, Florida",
    shortName: "Whitfield",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "FL",
    state: "Florida",
    difficulty: "explorer",
    pools: ["world","North America","US","US-FL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-fl-087",
    lat: 29.237306,
    lng: -81.083094,
    panoId: "N3ovdK73oXwzSxvOLXP5BQ",
    place: "Near Holly Hill, Florida",
    shortName: "Holly Hill",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "FL",
    state: "Florida",
    difficulty: "explorer",
    pools: ["world","North America","US","US-FL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-fl-088",
    lat: 26.628438,
    lng: -81.811275,
    panoId: "hzoX1s7FoI7fu6OyltS0Fg",
    place: "Near Fort Myers, Florida",
    shortName: "Fort Myers",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "FL",
    state: "Florida",
    difficulty: "explorer",
    pools: ["world","North America","US","US-FL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-fl-089",
    lat: 30.594296,
    lng: -87.255648,
    panoId: "LibbB7S05Py8-I0R2olzOA",
    place: "Near Gonzalez, Florida",
    shortName: "Gonzalez",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "FL",
    state: "Florida",
    difficulty: "explorer",
    pools: ["world","North America","US","US-FL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-fl-090",
    lat: 26.293223,
    lng: -80.297271,
    panoId: "EWjVc1f_Aan0BN5XKIy9mQ",
    place: "Near Coral Springs, Florida",
    shortName: "Coral Springs",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "FL",
    state: "Florida",
    difficulty: "explorer",
    pools: ["world","North America","US","US-FL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-fl-091",
    lat: 25.811641,
    lng: -80.406407,
    panoId: "l8MWD2gmcaOTJGkA4SNPXg",
    place: "Near Doral, Florida",
    shortName: "Doral",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "FL",
    state: "Florida",
    difficulty: "explorer",
    pools: ["world","North America","US","US-FL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-fl-092",
    lat: 26.016914,
    lng: -80.257254,
    panoId: "1g-rdUlfbv6DJUcR-gVQRQ",
    place: "Near Pembroke Pines, Florida",
    shortName: "Pembroke Pines",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "FL",
    state: "Florida",
    difficulty: "explorer",
    pools: ["world","North America","US","US-FL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-fl-093",
    lat: 29.678632,
    lng: -81.220018,
    panoId: "HmBZLpehqoP8gySQF8oA0g",
    place: "Near Palm Coast, Florida",
    shortName: "Palm Coast",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "FL",
    state: "Florida",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-FL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-fl-094",
    lat: 25.76098,
    lng: -80.54384,
    panoId: "n1dFgRovEwIcehKMbOVBTA",
    place: "Near Kendall West, Florida",
    shortName: "Kendall West",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "FL",
    state: "Florida",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-FL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-fl-095",
    lat: 28.709367,
    lng: -81.127142,
    panoId: "QRr8J9i0SV03R9Nu7xYRcA",
    place: "Near Geneva, Florida",
    shortName: "Geneva",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "FL",
    state: "Florida",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-FL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-fl-096",
    lat: 26.023338,
    lng: -80.432815,
    panoId: "x7e3hnLspI441kbhmLt8bg",
    place: "Near Weston, Florida",
    shortName: "Weston",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "FL",
    state: "Florida",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-FL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-fl-097",
    lat: 26.883246,
    lng: -82.183772,
    panoId: "BdivLY8wMqbiyvrIoBh76g",
    place: "Near Rotonda West, Florida",
    shortName: "Rotonda West",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "FL",
    state: "Florida",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-FL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-fl-098",
    lat: 27.06691,
    lng: -80.252095,
    panoId: "tDkda7oQKIfdhaBmMjwsBw",
    place: "Near Port Salerno, Florida",
    shortName: "Port Salerno",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "FL",
    state: "Florida",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-FL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ga-000",
    lat: 33.748881,
    lng: -84.387513,
    panoId: "IjuLaHDNrLSVsfmzqYckuw",
    place: "Near Atlanta, Georgia",
    shortName: "Atlanta",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "classic",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ga-001",
    lat: 31.578461,
    lng: -84.155786,
    panoId: "fW7iXKbBmzNnoq4swASEWQ",
    place: "Near Albany, Georgia",
    shortName: "Albany",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "classic",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ga-002",
    lat: 33.960911,
    lng: -83.377964,
    panoId: "IxGj93X-a9RzjdGtCW4Uqw",
    place: "Near Athens, Georgia",
    shortName: "Athens",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "classic",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ga-003",
    lat: 34.10634,
    lng: -84.033617,
    panoId: "007Wmh52ZwvJw7eycRU8SQ",
    place: "Near Sugar Hill, Georgia",
    shortName: "Sugar Hill",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "classic",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ga-004",
    lat: 32.460959,
    lng: -84.987704,
    panoId: "NoWCCGk8J7GGMUQquZqwqw",
    place: "Near Columbus, Georgia",
    shortName: "Columbus",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "classic",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ga-005",
    lat: 33.580245,
    lng: -85.076631,
    panoId: "hLhQywKC_bPMtai3WGbb5Q",
    place: "Near Carrollton, Georgia",
    shortName: "Carrollton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "classic",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ga-006",
    lat: 34.29788,
    lng: -83.824067,
    panoId: "kqOqcTXxtQv0_cDQB0HNww",
    place: "Near Gainesville, Georgia",
    shortName: "Gainesville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "classic",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-ga-007",
    lat: 34.051296,
    lng: -84.070936,
    panoId: "sqjXop8KYwvYOQDOKnbqnQ",
    place: "Near Suwanee, Georgia",
    shortName: "Suwanee",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "classic",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ga-008",
    lat: 30.836698,
    lng: -83.978827,
    panoId: "qUa1pGI7vHfXX86jp7e3sg",
    place: "Near Thomasville, Georgia",
    shortName: "Thomasville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "classic",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ga-009",
    lat: 33.039277,
    lng: -85.03113,
    panoId: "lji24pWgL82mWnG0p8PEiw",
    place: "Near LaGrange, Georgia",
    shortName: "LaGrange",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "classic",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ga-010",
    lat: 34.10147,
    lng: -84.519337,
    panoId: "xTSnM6riJtHbDrBSpCBwCg",
    place: "Near Woodstock, Georgia",
    shortName: "Woodstock",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "classic",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ga-011",
    lat: 32.448915,
    lng: -81.783168,
    panoId: "f4C2aOl6uat9Nz4--tm41A",
    place: "Near Statesboro, Georgia",
    shortName: "Statesboro",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "classic",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ga-012",
    lat: 33.080127,
    lng: -83.232065,
    panoId: "CQCGpDVrH2mYGsDRAKNN0Q",
    place: "Near Milledgeville, Georgia",
    shortName: "Milledgeville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "classic",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ga-013",
    lat: 34.066421,
    lng: -84.678314,
    panoId: "Oe_J8oVLDpa8u6Qj3ZFJjw",
    place: "Near Acworth, Georgia",
    shortName: "Acworth",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "classic",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ga-014",
    lat: 34.134048,
    lng: -84.300474,
    panoId: "2OnR_tTv8s1FFy5N8uogEg",
    place: "Near Milton, Georgia",
    shortName: "Milton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "classic",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ga-015",
    lat: 32.840669,
    lng: -83.632378,
    panoId: "lFvheHa7kOX-y5TQCddwcw",
    place: "Near Macon, Georgia",
    shortName: "Macon",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "classic",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ga-016",
    lat: 34.257046,
    lng: -85.164814,
    panoId: "hsXTmWSH0T2lggv9UAuXWw",
    place: "Near Rome, Georgia",
    shortName: "Rome",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "classic",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ga-017",
    lat: 34.769855,
    lng: -84.970191,
    panoId: "P31DZ0km9lpzdif-qB8nxQ",
    place: "Near Dalton, Georgia",
    shortName: "Dalton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "classic",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ga-018",
    lat: 33.396843,
    lng: -84.595739,
    panoId: "kZ5WoF3fSO1kMB41uXPJ2w",
    place: "Near Peachtree City, Georgia",
    shortName: "Peachtree City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "classic",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ga-019",
    lat: 33.380541,
    lng: -84.79985,
    panoId: "l150ACdZo9XU0i2UDtQTBw",
    place: "Near Newnan, Georgia",
    shortName: "Newnan",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "classic",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ga-020",
    lat: 33.517239,
    lng: -82.07575,
    panoId: "RV77_0cLb2IMbC-5B4F3Vw",
    place: "Near Martinez, Georgia",
    shortName: "Martinez",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "classic",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ga-021",
    lat: 34.236839,
    lng: -84.490748,
    panoId: "uoH5mB6riRurQYa4Gerq8g",
    place: "Near Canton, Georgia",
    shortName: "Canton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "classic",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ga-022",
    lat: 34.165305,
    lng: -84.802344,
    panoId: "ciIlEtFGIikPo9WslsRDVg",
    place: "Near Cartersville, Georgia",
    shortName: "Cartersville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "classic",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ga-023",
    lat: 33.956378,
    lng: -83.987969,
    panoId: "SDlnfxvQZ9BGNCpDAsuyOg",
    place: "Near Lawrenceville, Georgia",
    shortName: "Lawrenceville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "classic",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ga-024",
    lat: 32.615683,
    lng: -83.62641,
    panoId: "ZlbBnDlDjaaAtZEnFt149g",
    place: "Near Warner Robins, Georgia",
    shortName: "Warner Robins",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "classic",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ga-025",
    lat: 32.115517,
    lng: -81.247055,
    panoId: "tR_E1HWo-Fn3eHkXmsLbBw",
    place: "Near Pooler, Georgia",
    shortName: "Pooler",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "classic",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ga-026",
    lat: 33.470466,
    lng: -81.975125,
    panoId: "B7ZnqTQsBLILgZdOJRNkiQ",
    place: "Near Augusta, Georgia",
    shortName: "Augusta",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "classic",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ga-027",
    lat: 33.751549,
    lng: -84.747767,
    panoId: "MXt5OAsDtDp0xCi78sgLNA",
    place: "Near Douglasville, Georgia",
    shortName: "Douglasville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "classic",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ga-028",
    lat: 33.447385,
    lng: -84.147248,
    panoId: "lfsk4x_1PAJSfI_HZW7kSw",
    place: "Near McDonough, Georgia",
    shortName: "McDonough",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "classic",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ga-029",
    lat: 33.246759,
    lng: -84.263934,
    panoId: "pHn1EBjosbG08fSxZhvr1w",
    place: "Near Griffin, Georgia",
    shortName: "Griffin",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "classic",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ga-030",
    lat: 32.083443,
    lng: -81.099834,
    panoId: "Tz5khY20NHLV0rKMPh4sNA",
    place: "Near Savannah, Georgia",
    shortName: "Savannah",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "classic",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-ga-031",
    lat: 33.774934,
    lng: -84.29604,
    panoId: "-0LIwF-OHnJIHYbBft8XOA",
    place: "Near Decatur, Georgia",
    shortName: "Decatur",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "classic",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ga-032",
    lat: 33.533572,
    lng: -82.130726,
    panoId: "C3kx3lXkXIYuB0u87Uq8-A",
    place: "Near Evans, Georgia",
    shortName: "Evans",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "classic",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ga-033",
    lat: 30.833244,
    lng: -83.280263,
    panoId: "lheir3hS_2EOjCylvaTnng",
    place: "Near Valdosta, Georgia",
    shortName: "Valdosta",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "classic",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ga-034",
    lat: 31.846908,
    lng: -81.59598,
    panoId: "SeWFP0E6d9PxkngnC6U4cQ",
    place: "Near Hinesville, Georgia",
    shortName: "Hinesville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "classic",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ga-035",
    lat: 33.952575,
    lng: -84.550157,
    panoId: "W2t-kDRhoORBE_NKz3DiEQ",
    place: "Near Marietta, Georgia",
    shortName: "Marietta",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "classic",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ga-036",
    lat: 30.800052,
    lng: -81.689829,
    panoId: "jikMi18Bm-35SO1JaabOsw",
    place: "Near Kingsland, Georgia",
    shortName: "Kingsland",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "classic",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ga-037",
    lat: 33.448646,
    lng: -84.45498,
    panoId: "ml2DWYczvWKls9ouO_8Img",
    place: "Near Fayetteville, Georgia",
    shortName: "Fayetteville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "classic",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ga-038",
    lat: 30.730485,
    lng: -81.546463,
    panoId: "aawIgNbAfmAfPM7mQ6pEhA",
    place: "Near St. Marys, Georgia",
    shortName: "St. Marys",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "classic",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ga-039",
    lat: 31.450614,
    lng: -83.508536,
    panoId: "5N8bowF3D8K67QotGfZjpQ",
    place: "Near Tifton, Georgia",
    shortName: "Tifton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "classic",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ga-040",
    lat: 34.226058,
    lng: -84.475809,
    panoId: "ypRA3R-oJrG-1quH7GuKQw",
    place: "Near Canton, Georgia",
    shortName: "Canton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "classic",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ga-041",
    lat: 33.081239,
    lng: -83.259243,
    panoId: "neU55mTBjuKkeZw0KeOwGw",
    place: "Near Milledgeville, Georgia",
    shortName: "Milledgeville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "classic",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ga-042",
    lat: 32.066234,
    lng: -81.103858,
    panoId: "FBsYLBSqkUrmTXTivHUNSw",
    place: "Near Savannah, Georgia",
    shortName: "Savannah",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "classic",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-ga-043",
    lat: 34.154521,
    lng: -84.806963,
    panoId: "3diNTrpfjRiPnaa_SB1BCw",
    place: "Near Cartersville, Georgia",
    shortName: "Cartersville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "classic",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ga-044",
    lat: 33.76417,
    lng: -84.380183,
    panoId: "j1SkFPxcFyTJN0sWuZAfzw",
    place: "Near Atlanta, Georgia",
    shortName: "Atlanta",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "classic",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ga-045",
    lat: 33.945412,
    lng: -83.374763,
    panoId: "CbRtNUfoux-BKrLlUow_fg",
    place: "Near Athens, Georgia",
    shortName: "Athens",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "classic",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ga-046",
    lat: 32.452402,
    lng: -81.803364,
    panoId: "1k8Xb_gdNFweE3ttwY04kw",
    place: "Near Statesboro, Georgia",
    shortName: "Statesboro",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "classic",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ga-047",
    lat: 33.032552,
    lng: -85.045602,
    panoId: "0v4X06hNQrQ8eieulkbOlw",
    place: "Near LaGrange, Georgia",
    shortName: "LaGrange",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "classic",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ga-048",
    lat: 33.482225,
    lng: -81.978598,
    panoId: "QKWqfGLLajNg3ghcnBWBGA",
    place: "Near Augusta, Georgia",
    shortName: "Augusta",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "classic",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ga-049",
    lat: 33.431959,
    lng: -84.163066,
    panoId: "H1xEkZAixposxjMi7uA-Hg",
    place: "Near McDonough, Georgia",
    shortName: "McDonough",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "classic",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ga-050",
    lat: 33.725639,
    lng: -84.680173,
    panoId: "dGXGfMxz2fO2IThrz_3gNA",
    place: "Near Douglasville, Georgia",
    shortName: "Douglasville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ga-051",
    lat: 33.555696,
    lng: -85.02976,
    panoId: "5DKkTb9VGp4WrkbTHAnibw",
    place: "Near Carrollton, Georgia",
    shortName: "Carrollton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ga-052",
    lat: 33.465805,
    lng: -84.075484,
    panoId: "dxpkG4ik0UE3lv317Na_PA",
    place: "Near McDonough, Georgia",
    shortName: "McDonough",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ga-053",
    lat: 30.798136,
    lng: -83.238533,
    panoId: "1EzMB5ml3KYL4GXlBA35wA",
    place: "Near Valdosta, Georgia",
    shortName: "Valdosta",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ga-054",
    lat: 33.349485,
    lng: -84.77845,
    panoId: "y71b7ux0KAxNWkkebVZ-ww",
    place: "Near East Newnan, Georgia",
    shortName: "East Newnan",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ga-055",
    lat: 34.26425,
    lng: -83.875701,
    panoId: "sy2i6q0u0rUP234Be5_vZw",
    place: "Near Oakwood, Georgia",
    shortName: "Oakwood",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ga-056",
    lat: 32.570905,
    lng: -83.68361,
    panoId: "e50vnL-lOZUGqWqItnm6ew",
    place: "Near Centerville, Georgia",
    shortName: "Centerville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ga-057",
    lat: 32.155895,
    lng: -81.274603,
    panoId: "LfJa5rr-vnm6glqXj9MxQg",
    place: "Near Bloomingdale, Georgia",
    shortName: "Bloomingdale",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ga-058",
    lat: 33.539303,
    lng: -82.189365,
    panoId: "cooKm1vJ2ILMpdzFHG4DSg",
    place: "Near Evans, Georgia",
    shortName: "Evans",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ga-059",
    lat: 34.197786,
    lng: -85.185741,
    panoId: "0i3ro2mCXujqCkxnjMsLcw",
    place: "Near Lindale, Georgia",
    shortName: "Lindale",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ga-060",
    lat: 34.07331,
    lng: -84.463062,
    panoId: "yB_gsrn4o8W5bINCIc08eg",
    place: "Near Woodstock, Georgia",
    shortName: "Woodstock",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ga-061",
    lat: 34.103912,
    lng: -84.711428,
    panoId: "64AKfxxKZ14PgGo-9dZekA",
    place: "Near Emerson, Georgia",
    shortName: "Emerson",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ga-062",
    lat: 32.512169,
    lng: -85.024202,
    panoId: "A7NXRWamG7rz8wESW3EgiA",
    place: "Near Phenix City, Georgia",
    shortName: "Phenix City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ga-063",
    lat: 31.466032,
    lng: -83.465919,
    panoId: "irvoC0t4FHNWOaFMqRvcxg",
    place: "Near Tifton, Georgia",
    shortName: "Tifton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ga-064",
    lat: 32.80325,
    lng: -83.673376,
    panoId: "LnfyuGd5TqkiYFG8_oXtLg",
    place: "Near Macon, Georgia",
    shortName: "Macon",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ga-065",
    lat: 33.29997,
    lng: -84.286302,
    panoId: "lgwf6G0_QWUHnI0_5TLu2Q",
    place: "Near Experiment, Georgia",
    shortName: "Experiment",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ga-066",
    lat: 33.71142,
    lng: -84.349541,
    panoId: "rrb67_0MMRdGW4oVL2M39Q",
    place: "Near Gresham Park, Georgia",
    shortName: "Gresham Park",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 4,
    verified: true,
  },
];

const CHUNK_1: GeoLocation[] = [
  {
    id: "us-ga-067",
    lat: 33.022033,
    lng: -83.205511,
    panoId: "I6jGDqX1wss3UVnqehelFg",
    place: "Near Hardwick, Georgia",
    shortName: "Hardwick",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ga-068",
    lat: 33.360539,
    lng: -84.669245,
    panoId: "-_bxB--OGZXA-12NFLjjqQ",
    place: "Near Peachtree City, Georgia",
    shortName: "Peachtree City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ga-069",
    lat: 31.851049,
    lng: -81.658098,
    panoId: "yqF6iMoDIQLRAQAQ2elDrA",
    place: "Near Fort Stewart, Georgia",
    shortName: "Fort Stewart",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ga-070",
    lat: 34.07129,
    lng: -84.000453,
    panoId: "omKXCI3KsTsJnpC94Pj5CQ",
    place: "Near Sugar Hill, Georgia",
    shortName: "Sugar Hill",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ga-071",
    lat: 32.508332,
    lng: -81.721412,
    panoId: "c68DGP-J5NGNYq2o0onFNA",
    place: "Near Statesboro, Georgia",
    shortName: "Statesboro",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ga-072",
    lat: 32.555033,
    lng: -83.656977,
    panoId: "VNaK-E7o2z4PsX0ZE4lAzQ",
    place: "Near Warner Robins, Georgia",
    shortName: "Warner Robins",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ga-073",
    lat: 34.550106,
    lng: -84.894926,
    panoId: "-eo8p9U87SGp0qgjWDgT2g",
    place: "Near Calhoun, Georgia",
    shortName: "Calhoun",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ga-074",
    lat: 34.360859,
    lng: -83.820786,
    panoId: "l--u_ze3E698vangUE1skw",
    place: "Near Gainesville, Georgia",
    shortName: "Gainesville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ga-075",
    lat: 33.703553,
    lng: -84.747961,
    panoId: "UobonpJMVpxc2H4UCpKmTA",
    place: "Near Douglasville, Georgia",
    shortName: "Douglasville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ga-076",
    lat: 33.011664,
    lng: -85.091111,
    panoId: "Y48Twt5fXi9E9yW3-4HeoA",
    place: "Near LaGrange, Georgia",
    shortName: "LaGrange",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ga-077",
    lat: 34.184913,
    lng: -84.765552,
    panoId: "3LAc4sJd4kwIWUN0uF8OzA",
    place: "Near Cartersville, Georgia",
    shortName: "Cartersville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ga-078",
    lat: 33.637065,
    lng: -85.071435,
    panoId: "E8kRxJbXqgMRsH2HtYUf3g",
    place: "Near Carrollton, Georgia",
    shortName: "Carrollton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ga-079",
    lat: 33.408471,
    lng: -84.84352,
    panoId: "qMiaQlIZW0KI_oYNRDj3dA",
    place: "Near Newnan, Georgia",
    shortName: "Newnan",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ga-080",
    lat: 30.830559,
    lng: -81.646066,
    panoId: "xWxg1AOjVr-hkohT73AU1g",
    place: "Near Kingsland, Georgia",
    shortName: "Kingsland",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ga-081",
    lat: 34.101463,
    lng: -83.947182,
    panoId: "NSMjF0aO8PnO3ytkKXqtng",
    place: "Near Buford, Georgia",
    shortName: "Buford",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ga-082",
    lat: 34.085254,
    lng: -84.578922,
    panoId: "uUG8_9lKbqeQyNAOnyPvSA",
    place: "Near Woodstock, Georgia",
    shortName: "Woodstock",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ga-083",
    lat: 33.46694,
    lng: -81.924396,
    panoId: "IaCNk50yQpZKpe4v-qXCyA",
    place: "Near Clearwater, Georgia",
    shortName: "Clearwater",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ga-084",
    lat: 32.064481,
    lng: -81.227068,
    panoId: "mm2P79diNqahI8wwyq10MQ",
    place: "Near Pooler, Georgia",
    shortName: "Pooler",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ga-085",
    lat: 31.59994,
    lng: -84.230875,
    panoId: "eYim5rqr6oy3PJ7WOs1sDQ",
    place: "Near Albany, Georgia",
    shortName: "Albany",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ga-086",
    lat: 30.775183,
    lng: -83.991658,
    panoId: "04r_gCkZgC0lqHvrzgev9A",
    place: "Near Thomasville, Georgia",
    shortName: "Thomasville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ga-087",
    lat: 33.471274,
    lng: -82.163344,
    panoId: "6Qd9ZtKYPo3w8H0TJxkciA",
    place: "Near Grovetown, Georgia",
    shortName: "Grovetown",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ga-088",
    lat: 30.756173,
    lng: -81.607769,
    panoId: "RJt6YznNVbKgf2xNKlmOtw",
    place: "Near St Marys, Georgia",
    shortName: "St Marys",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ga-089",
    lat: 32.936066,
    lng: -83.646868,
    panoId: "67iSfxy-9XqiT7EQNilmGQ",
    place: "Near Macon, Georgia",
    shortName: "Macon",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ga-090",
    lat: 34.390417,
    lng: -84.995446,
    panoId: "IN9ZHAZm3kuDIbEXCXMtgw",
    place: "Near Adairsville, Georgia",
    shortName: "Adairsville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ga-091",
    lat: 33.623395,
    lng: -84.173237,
    panoId: "-E-yeogIBtrQzgO6myqGig",
    place: "Near Pine Mountain, Georgia",
    shortName: "Pine Mountain",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-ga-092",
    lat: 34.065562,
    lng: -84.503811,
    panoId: "m1WOVUfvQYpzN0biGV50Xg",
    place: "Near Woodstock, Georgia",
    shortName: "Woodstock",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ga-093",
    lat: 33.08677,
    lng: -84.334428,
    panoId: "y3dEVmryDvMw45pD_OA7RQ",
    place: "Near Zebulon, Georgia",
    shortName: "Zebulon",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ga-094",
    lat: 33.437911,
    lng: -84.797621,
    panoId: "yIAANbpEZs6LJSKIC8LJfA",
    place: "Near Newnan, Georgia",
    shortName: "Newnan",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ga-095",
    lat: 33.835929,
    lng: -83.633018,
    panoId: "lF6Wb-02aGdXfIqtRBKqfQ",
    place: "Near Monroe, Georgia",
    shortName: "Monroe",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ga-096",
    lat: 31.172121,
    lng: -81.45776,
    panoId: "oLHHQuraJR_vtCs0F47teQ",
    place: "Near Brunswick, Georgia",
    shortName: "Brunswick",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ga-097",
    lat: 33.997047,
    lng: -84.602824,
    panoId: "wO653W0nPcr6y7md1h-hyQ",
    place: "Near Kennesaw, Georgia",
    shortName: "Kennesaw",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ga-098",
    lat: 33.788624,
    lng: -84.116348,
    panoId: "RD_womfT6bf3BfCzH58W_g",
    place: "Near Redan, Georgia",
    shortName: "Redan",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ga-099",
    lat: 32.159364,
    lng: -84.281769,
    panoId: "SwwdRrYrZrBtPtHGkjHG7A",
    place: "Near Ellaville, Georgia",
    shortName: "Ellaville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ga-100",
    lat: 32.537629,
    lng: -84.815083,
    panoId: "5WoqDfcq9WH8XlkgSTOt0Q",
    place: "Near Columbus, Georgia",
    shortName: "Columbus",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-ga-101",
    lat: 30.673061,
    lng: -83.175375,
    panoId: "JBIqa_LYg27Bi3-gsCpBHQ",
    place: "Near Statenville, Georgia",
    shortName: "Statenville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ga-102",
    lat: 32.618935,
    lng: -83.086847,
    panoId: "Qt9IX8KaiSLD_zOOJJZCdg",
    place: "Near Dublin, Georgia",
    shortName: "Dublin",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ga-103",
    lat: 31.08831,
    lng: -83.640074,
    panoId: "GyWWHuxUzZWP6HOxhI1U8g",
    place: "Near Moultrie, Georgia",
    shortName: "Moultrie",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ga-104",
    lat: 34.621709,
    lng: -84.820748,
    panoId: "WsWLt0sgEjGh9_uxso3SRQ",
    place: "Near Chatsworth, Georgia",
    shortName: "Chatsworth",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ga-105",
    lat: 30.72228,
    lng: -84.145772,
    panoId: "2uskr6iYL0HW6k-Gh7m7Jw",
    place: "Near Cairo, Georgia",
    shortName: "Cairo",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ga-106",
    lat: 32.174892,
    lng: -82.217515,
    panoId: "PMKK6PF55uT0NbLNdx4A1Q",
    place: "Near Lyons, Georgia",
    shortName: "Lyons",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ga-107",
    lat: 31.682202,
    lng: -81.62315,
    panoId: "y9P9BQwV9M1L_B0cSf4vaw",
    place: "Near Walthourville, Georgia",
    shortName: "Walthourville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ga-108",
    lat: 32.423909,
    lng: -83.016976,
    panoId: "lbzrV0tb_zzHeTKsAhR7wg",
    place: "Near Chester, Georgia",
    shortName: "Chester",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ga-109",
    lat: 30.769807,
    lng: -84.433469,
    panoId: "y8hRFTSE_VFD7d4f7nfeQA",
    place: "Near Havana, Georgia",
    shortName: "Havana",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ga-110",
    lat: 34.6072,
    lng: -84.747444,
    panoId: "d2wRTB3v6ZACI_8dlqaZDw",
    place: "Near Chatsworth, Georgia",
    shortName: "Chatsworth",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ga-111",
    lat: 33.675685,
    lng: -83.595281,
    panoId: "MdhCL3spGINSTvEhgP5rtQ",
    place: "Near Social Circle, Georgia",
    shortName: "Social Circle",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ga-112",
    lat: 31.156748,
    lng: -83.984573,
    panoId: "Oqv1DHM3fcAzOqbpYWhsQw",
    place: "Near Meigs, Georgia",
    shortName: "Meigs",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "GA",
    state: "Georgia",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-GA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-hi-000",
    lat: 21.315532,
    lng: -158.007164,
    panoId: "7rzS0Z95vtqtEvnXI2F_Lw",
    place: "Near ‘Ewa Beach, Hawaii",
    shortName: "‘Ewa Beach",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "HI",
    state: "Hawaii",
    difficulty: "classic",
    pools: ["world","North America","US","US-HI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-hi-001",
    lat: 21.292224,
    lng: -157.740907,
    panoId: "5LigHRpX8GQSm21tk3KYSQ",
    place: "Near Kuli‘ou‘ou, Hawaii",
    shortName: "Kuli‘ou‘ou",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "HI",
    state: "Hawaii",
    difficulty: "classic",
    pools: ["world","North America","US","US-HI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-hi-002",
    lat: 21.45029,
    lng: -158.014978,
    panoId: "dJpoRIeE41ar-G4yyV--Cw",
    place: "Near Mililani Town, Hawaii",
    shortName: "Mililani Town",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "HI",
    state: "Hawaii",
    difficulty: "classic",
    pools: ["world","North America","US","US-HI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-hi-003",
    lat: 21.289509,
    lng: -157.717189,
    panoId: "L92lDkDgZYSglvFdEbEYxw",
    place: "Near East Honolulu, Hawaii",
    shortName: "East Honolulu",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "HI",
    state: "Hawaii",
    difficulty: "classic",
    pools: ["world","North America","US","US-HI"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-hi-004",
    lat: 21.316285,
    lng: -157.804052,
    panoId: "Ll2bj1Rrg4xTcleeJBxaog",
    place: "Near Manoa, Hawaii",
    shortName: "Manoa",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "HI",
    state: "Hawaii",
    difficulty: "classic",
    pools: ["world","North America","US","US-HI"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-hi-005",
    lat: 19.640893,
    lng: -156.000779,
    panoId: "r0HBR9Qf6Cz_R8vA0kticA",
    place: "Near Kailua-Kona, Hawaii",
    shortName: "Kailua-Kona",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "HI",
    state: "Hawaii",
    difficulty: "classic",
    pools: ["world","North America","US","US-HI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-hi-006",
    lat: 19.730341,
    lng: -155.090811,
    panoId: "5LSAjsLF-IlCmI44Q7JWmA",
    place: "Near Hilo, Hawaii",
    shortName: "Hilo",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "HI",
    state: "Hawaii",
    difficulty: "classic",
    pools: ["world","North America","US","US-HI"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-hi-007",
    lat: 21.402404,
    lng: -157.740505,
    panoId: "0PcAJ5cmbKNwgZoG9fxxTA",
    place: "Near Kailua, Hawaii",
    shortName: "Kailua",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "HI",
    state: "Hawaii",
    difficulty: "classic",
    pools: ["world","North America","US","US-HI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-hi-008",
    lat: 21.387239,
    lng: -158.009246,
    panoId: "pFb1fY7rvIoZTim5IGbWtg",
    place: "Near Waipahu, Hawaii",
    shortName: "Waipahu",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "HI",
    state: "Hawaii",
    difficulty: "classic",
    pools: ["world","North America","US","US-HI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-hi-009",
    lat: 21.317452,
    lng: -157.831344,
    panoId: "YN26p1E3Svk1InJPFV4gFw",
    place: "Near Makiki / Lower Punchbowl / Tantalus, Hawaii",
    shortName: "Makiki / Lower Punchbowl / Tantalus",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "HI",
    state: "Hawaii",
    difficulty: "classic",
    pools: ["world","North America","US","US-HI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-hi-010",
    lat: 21.347073,
    lng: -157.943684,
    panoId: "QI5XJM6UitJa-4Mz1Z9gkQ",
    place: "Near Joint Base Pearl Harbor Hickam, Hawaii",
    shortName: "Joint Base Pearl Harbor Hickam",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "HI",
    state: "Hawaii",
    difficulty: "classic",
    pools: ["world","North America","US","US-HI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-hi-011",
    lat: 21.276954,
    lng: -157.811224,
    panoId: "4Q4x5gtGRAzKwBKZc6q1lg",
    place: "Near Diamond Head / Kapahulu / Saint Louis Heights, Hawaii",
    shortName: "Diamond Head / Kapahulu / Saint Louis Heights",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "HI",
    state: "Hawaii",
    difficulty: "classic",
    pools: ["world","North America","US","US-HI"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-hi-012",
    lat: 21.388191,
    lng: -157.939405,
    panoId: "iELHppssCbJOc5a04Vlt5g",
    place: "Near Waimalu, Hawaii",
    shortName: "Waimalu",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "HI",
    state: "Hawaii",
    difficulty: "classic",
    pools: ["world","North America","US","US-HI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-hi-013",
    lat: 21.285473,
    lng: -157.835641,
    panoId: "_3XXVdPuoegqpQDIBtbuXA",
    place: "Near Waikīkī, Hawaii",
    shortName: "Waikīkī",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "HI",
    state: "Hawaii",
    difficulty: "classic",
    pools: ["world","North America","US","US-HI"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-hi-014",
    lat: 21.397444,
    lng: -157.975207,
    panoId: "Octj_Bn-9kquck-IBzbJ_g",
    place: "Near Pearl City, Hawaii",
    shortName: "Pearl City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "HI",
    state: "Hawaii",
    difficulty: "classic",
    pools: ["world","North America","US","US-HI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-hi-015",
    lat: 21.393642,
    lng: -158.15426,
    panoId: "2tWE6ZRjZrgpkBRfuq3DFA",
    place: "Near Nānākuli, Hawaii",
    shortName: "Nānākuli",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "HI",
    state: "Hawaii",
    difficulty: "classic",
    pools: ["world","North America","US","US-HI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-hi-016",
    lat: 21.362761,
    lng: -157.920802,
    panoId: "dfVSddEE_3ISElA19mlWAA",
    place: "Near Aliamanu / Salt Lakes / Foster Village, Hawaii",
    shortName: "Aliamanu / Salt Lakes / Foster Village",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "HI",
    state: "Hawaii",
    difficulty: "classic",
    pools: ["world","North America","US","US-HI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-hi-017",
    lat: 21.437857,
    lng: -158.185539,
    panoId: "OYFxGAxriF2nfzmpBqtzIA",
    place: "Near Waianae, Hawaii",
    shortName: "Waianae",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "HI",
    state: "Hawaii",
    difficulty: "classic",
    pools: ["world","North America","US","US-HI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-hi-018",
    lat: 21.502856,
    lng: -158.024455,
    panoId: "7YTSzw6FEAVqIBbZSYM2sg",
    place: "Near Wahiawā, Hawaii",
    shortName: "Wahiawā",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "HI",
    state: "Hawaii",
    difficulty: "classic",
    pools: ["world","North America","US","US-HI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-hi-019",
    lat: 20.875241,
    lng: -156.679805,
    panoId: "V1YAzw-scA_NcirLnj7sZA",
    place: "Near Lahaina, Hawaii",
    shortName: "Lahaina",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "HI",
    state: "Hawaii",
    difficulty: "classic",
    pools: ["world","North America","US","US-HI"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-hi-020",
    lat: 20.889272,
    lng: -156.472931,
    panoId: "KtbDBR2EibxtKW6AIzNPRA",
    place: "Near Kahului, Hawaii",
    shortName: "Kahului",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "HI",
    state: "Hawaii",
    difficulty: "classic",
    pools: ["world","North America","US","US-HI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-hi-021",
    lat: 20.763944,
    lng: -156.445846,
    panoId: "JP38K8OGLQh3xRYlBlRKrA",
    place: "Near Kīhei, Hawaii",
    shortName: "Kīhei",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "HI",
    state: "Hawaii",
    difficulty: "classic",
    pools: ["world","North America","US","US-HI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-hi-022",
    lat: 21.271971,
    lng: -157.787741,
    panoId: "tgiwm_RoMK2xyI3mijcLjQ",
    place: "Near Waialae - Kahala, Hawaii",
    shortName: "Waialae - Kahala",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "HI",
    state: "Hawaii",
    difficulty: "classic",
    pools: ["world","North America","US","US-HI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-hi-023",
    lat: 20.767678,
    lng: -156.458623,
    panoId: "c4TvjjwyCAPi1VAqodxF6w",
    place: "Near Kīhei, Hawaii",
    shortName: "Kīhei",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "HI",
    state: "Hawaii",
    difficulty: "classic",
    pools: ["world","North America","US","US-HI"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-hi-024",
    lat: 19.646997,
    lng: -156.015441,
    panoId: "T2obkgqrBoT8_Fvsu0EZag",
    place: "Near Kailua-Kona, Hawaii",
    shortName: "Kailua-Kona",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "HI",
    state: "Hawaii",
    difficulty: "classic",
    pools: ["world","North America","US","US-HI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-hi-025",
    lat: 20.882039,
    lng: -156.510218,
    panoId: "RIrqqEg4HQj-5F_AzclEWg",
    place: "Near Wailuku, Hawaii",
    shortName: "Wailuku",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "HI",
    state: "Hawaii",
    difficulty: "classic",
    pools: ["world","North America","US","US-HI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-hi-026",
    lat: 21.319245,
    lng: -157.783291,
    panoId: "afJBaRJIly3JaZq61vvqRQ",
    place: "Near Palolo, Hawaii",
    shortName: "Palolo",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "HI",
    state: "Hawaii",
    difficulty: "classic",
    pools: ["world","North America","US","US-HI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-hi-027",
    lat: 21.33951,
    lng: -158.101167,
    panoId: "hvqkY7xN8clAbNRUeN_1VQ",
    place: "Near Makakilo / Kapolei / Honokai Hale, Hawaii",
    shortName: "Makakilo / Kapolei / Honokai Hale",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "HI",
    state: "Hawaii",
    difficulty: "classic",
    pools: ["world","North America","US","US-HI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-hi-028",
    lat: 21.507602,
    lng: -158.012362,
    panoId: "lPHD4pBiGHK5lMIZaFceuQ",
    place: "Near Wahiawā, Hawaii",
    shortName: "Wahiawā",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "HI",
    state: "Hawaii",
    difficulty: "classic",
    pools: ["world","North America","US","US-HI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-hi-029",
    lat: 21.304307,
    lng: -157.871905,
    panoId: "7r-xYY5s_f2LpSov_PLNfg",
    place: "Near Iwilei-Anuenue, Hawaii",
    shortName: "Iwilei-Anuenue",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "HI",
    state: "Hawaii",
    difficulty: "classic",
    pools: ["world","North America","US","US-HI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-hi-030",
    lat: 21.38188,
    lng: -157.765273,
    panoId: "aIjc0l39h8efSCQE-4IJcg",
    place: "Near Olomana, Hawaii",
    shortName: "Olomana",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "HI",
    state: "Hawaii",
    difficulty: "classic",
    pools: ["world","North America","US","US-HI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-hi-031",
    lat: 21.356623,
    lng: -157.883012,
    panoId: "g3IihdVNLKrDxN4xtVaInQ",
    place: "Near Moanalua Valley, Hawaii",
    shortName: "Moanalua Valley",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "HI",
    state: "Hawaii",
    difficulty: "classic",
    pools: ["world","North America","US","US-HI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-hi-032",
    lat: 21.369814,
    lng: -157.83106,
    panoId: "yEG0R9pxTC6BsN-6JlcvbQ",
    place: "Near Kalihi Valley, Hawaii",
    shortName: "Kalihi Valley",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "HI",
    state: "Hawaii",
    difficulty: "classic",
    pools: ["world","North America","US","US-HI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-hi-033",
    lat: 21.329695,
    lng: -158.016633,
    panoId: "q_n7OPb7uZdHcIXJX0TRyA",
    place: "Near ‘Ewa Gentry, Hawaii",
    shortName: "‘Ewa Gentry",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "HI",
    state: "Hawaii",
    difficulty: "classic",
    pools: ["world","North America","US","US-HI"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-hi-034",
    lat: 21.26303,
    lng: -157.817776,
    panoId: "apAvihqZeFMZGaoATW3PBQ",
    place: "Near Diamond Head / Kapahulu / Saint Louis Heights, Hawaii",
    shortName: "Diamond Head / Kapahulu / Saint Louis Heights",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "HI",
    state: "Hawaii",
    difficulty: "classic",
    pools: ["world","North America","US","US-HI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-hi-035",
    lat: 21.367008,
    lng: -158.084928,
    panoId: "OvJ-5qns-9QeMliv2pbhdg",
    place: "Near Makakilo, Hawaii",
    shortName: "Makakilo",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "HI",
    state: "Hawaii",
    difficulty: "classic",
    pools: ["world","North America","US","US-HI"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-hi-036",
    lat: 21.32995,
    lng: -157.915896,
    panoId: "XSND7h-6snXn2jjWqMmfZg",
    place: "Near Airport, Hawaii",
    shortName: "Airport",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "HI",
    state: "Hawaii",
    difficulty: "classic",
    pools: ["world","North America","US","US-HI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-hi-037",
    lat: 19.594834,
    lng: -154.971626,
    panoId: "o_bL-CfDNM06ofkn8kFamA",
    place: "Near Hawaiian Paradise Park, Hawaii",
    shortName: "Hawaiian Paradise Park",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "HI",
    state: "Hawaii",
    difficulty: "classic",
    pools: ["world","North America","US","US-HI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-hi-038",
    lat: 20.883748,
    lng: -156.460626,
    panoId: "Xzk1NNYTgIBTdlfgcGvV2Q",
    place: "Near Kahului, Hawaii",
    shortName: "Kahului",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "HI",
    state: "Hawaii",
    difficulty: "classic",
    pools: ["world","North America","US","US-HI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-hi-039",
    lat: 21.436275,
    lng: -157.85213,
    panoId: "Na0hZO6bczLrQJ4-ce9h8w",
    place: "Near ‘Āhuimanu, Hawaii",
    shortName: "‘Āhuimanu",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "HI",
    state: "Hawaii",
    difficulty: "classic",
    pools: ["world","North America","US","US-HI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-hi-040",
    lat: 20.921834,
    lng: -156.492906,
    panoId: "f7HCQYtNmdtGir9rmtEjqA",
    place: "Near Waihee-Waiehu, Hawaii",
    shortName: "Waihee-Waiehu",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "HI",
    state: "Hawaii",
    difficulty: "classic",
    pools: ["world","North America","US","US-HI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-hi-041",
    lat: 19.609059,
    lng: -154.973818,
    panoId: "ZYxbo6l15w_gKkg9Ebf4oA",
    place: "Near Hawaiian Paradise Park, Hawaii",
    shortName: "Hawaiian Paradise Park",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "HI",
    state: "Hawaii",
    difficulty: "classic",
    pools: ["world","North America","US","US-HI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-hi-042",
    lat: 21.451792,
    lng: -158.171304,
    panoId: "t6vATb4dgR3jFSyOtzlzdg",
    place: "Near Waianae, Hawaii",
    shortName: "Waianae",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "HI",
    state: "Hawaii",
    difficulty: "classic",
    pools: ["world","North America","US","US-HI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-hi-043",
    lat: 21.418623,
    lng: -157.993612,
    panoId: "nignPa-GI5fjTUhoF--fbA",
    place: "Near Waipio, Hawaii",
    shortName: "Waipio",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "HI",
    state: "Hawaii",
    difficulty: "classic",
    pools: ["world","North America","US","US-HI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-hi-044",
    lat: 19.619774,
    lng: -155.956509,
    panoId: "2BK9nAcgQ2-ROWzibwcFTQ",
    place: "Near Hōlualoa, Hawaii",
    shortName: "Hōlualoa",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "HI",
    state: "Hawaii",
    difficulty: "classic",
    pools: ["world","North America","US","US-HI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-hi-045",
    lat: 21.311962,
    lng: -157.684451,
    panoId: "4vLY71JqUIGRBxVbqY4sjA",
    place: "Near Kalama Valley, Hawaii",
    shortName: "Kalama Valley",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "HI",
    state: "Hawaii",
    difficulty: "classic",
    pools: ["world","North America","US","US-HI"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-hi-046",
    lat: 21.418651,
    lng: -157.806106,
    panoId: "uWGjQIxxEjFXbXm0mU8Zzg",
    place: "Near Pū‘ōhala Village, Hawaii",
    shortName: "Pū‘ōhala Village",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "HI",
    state: "Hawaii",
    difficulty: "classic",
    pools: ["world","North America","US","US-HI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-hi-047",
    lat: 21.306577,
    lng: -158.032282,
    panoId: "SQw_rYzWXjwAizDkDNweSA",
    place: "Near Ocean Pointe, Hawaii",
    shortName: "Ocean Pointe",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "HI",
    state: "Hawaii",
    difficulty: "classic",
    pools: ["world","North America","US","US-HI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-hi-048",
    lat: 21.424931,
    lng: -157.739358,
    panoId: "8R5eH08xKoSX2iPgJJIXMg",
    place: "Near Kalaheo Hillside, Hawaii",
    shortName: "Kalaheo Hillside",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "HI",
    state: "Hawaii",
    difficulty: "classic",
    pools: ["world","North America","US","US-HI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-hi-049",
    lat: 22.075311,
    lng: -159.318938,
    panoId: "25cINbelpMVl10tpIHpPSg",
    place: "Near Kapa‘a, Hawaii",
    shortName: "Kapa‘a",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "HI",
    state: "Hawaii",
    difficulty: "classic",
    pools: ["world","North America","US","US-HI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-hi-050",
    lat: 21.304885,
    lng: -158.098038,
    panoId: "WKFwAA_aBDWJZZB3oe4P1w",
    place: "Near Makakilo / Kapolei / Honokai Hale, Hawaii",
    shortName: "Makakilo / Kapolei / Honokai Hale",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "HI",
    state: "Hawaii",
    difficulty: "explorer",
    pools: ["world","North America","US","US-HI"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-hi-051",
    lat: 21.459764,
    lng: -158.057229,
    panoId: "mdrEwCWbhslYyO9prrVHYw",
    place: "Near Wheeler Army Airfield, Hawaii",
    shortName: "Wheeler Army Airfield",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "HI",
    state: "Hawaii",
    difficulty: "explorer",
    pools: ["world","North America","US","US-HI"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-hi-052",
    lat: 21.555186,
    lng: -158.060579,
    panoId: "btLU4_VciIlbht_SBk2jog",
    place: "Near Helemano, Hawaii",
    shortName: "Helemano",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "HI",
    state: "Hawaii",
    difficulty: "explorer",
    pools: ["world","North America","US","US-HI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-hi-053",
    lat: 21.406314,
    lng: -157.863958,
    panoId: "v4Xa7VoOmMrTnECEh1j7LQ",
    place: "Near ‘Āhuimanu, Hawaii",
    shortName: "‘Āhuimanu",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "HI",
    state: "Hawaii",
    difficulty: "explorer",
    pools: ["world","North America","US","US-HI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-hi-054",
    lat: 21.316244,
    lng: -157.667783,
    panoId: "n00zST3WwRfQ2al4uzjGbw",
    place: "Near Kalama Valley, Hawaii",
    shortName: "Kalama Valley",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "HI",
    state: "Hawaii",
    difficulty: "explorer",
    pools: ["world","North America","US","US-HI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-hi-055",
    lat: 21.57092,
    lng: -158.141374,
    panoId: "uf50DMSAx3vikGJz8bZBVg",
    place: "Near Waialua, Hawaii",
    shortName: "Waialua",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "HI",
    state: "Hawaii",
    difficulty: "explorer",
    pools: ["world","North America","US","US-HI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-hi-056",
    lat: 21.550969,
    lng: -158.049544,
    panoId: "izlnOGKkl_fCNIOuYatOBQ",
    place: "Near Helemano, Hawaii",
    shortName: "Helemano",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "HI",
    state: "Hawaii",
    difficulty: "explorer",
    pools: ["world","North America","US","US-HI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-hi-057",
    lat: 20.935093,
    lng: -156.687268,
    panoId: "yZjLhjApZXH0MuJQYKsDrA",
    place: "Near Kaanapali Landing, Hawaii",
    shortName: "Kaanapali Landing",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "HI",
    state: "Hawaii",
    difficulty: "explorer",
    pools: ["world","North America","US","US-HI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-hi-058",
    lat: 20.812119,
    lng: -156.354747,
    panoId: "JrHkkEvpoKZouXA7BgLnTA",
    place: "Near Pukalani, Hawaii",
    shortName: "Pukalani",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "HI",
    state: "Hawaii",
    difficulty: "explorer",
    pools: ["world","North America","US","US-HI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-hi-059",
    lat: 21.52499,
    lng: -158.075847,
    panoId: "ZjzNZ0Ngk5dNZzfS7cAzOw",
    place: "Near Schofield Barracks, Hawaii",
    shortName: "Schofield Barracks",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "HI",
    state: "Hawaii",
    difficulty: "explorer",
    pools: ["world","North America","US","US-HI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-hi-060",
    lat: 19.793096,
    lng: -155.135703,
    panoId: "hRXO776y-8oBr5P8kjqinQ",
    place: "Near Pāpa‘ikou, Hawaii",
    shortName: "Pāpa‘ikou",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "HI",
    state: "Hawaii",
    difficulty: "explorer",
    pools: ["world","North America","US","US-HI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-hi-061",
    lat: 19.939059,
    lng: -155.789619,
    panoId: "_vBhZJxBZGuzLQrLbbmcSA",
    place: "Near Waikoloa, Hawaii",
    shortName: "Waikoloa",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "HI",
    state: "Hawaii",
    difficulty: "explorer",
    pools: ["world","North America","US","US-HI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-hi-062",
    lat: 21.923888,
    lng: -159.526848,
    panoId: "U6D9nNFrYcbR09qeFZQwaw",
    place: "Near Kalāheo, Hawaii",
    shortName: "Kalāheo",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "HI",
    state: "Hawaii",
    difficulty: "explorer",
    pools: ["world","North America","US","US-HI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-hi-063",
    lat: 19.542425,
    lng: -154.914866,
    panoId: "6D5SgBdXz6uu3-5Bw0KeHA",
    place: "Near Hawaiian Beaches, Hawaii",
    shortName: "Hawaiian Beaches",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "HI",
    state: "Hawaii",
    difficulty: "explorer",
    pools: ["world","North America","US","US-HI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-hi-064",
    lat: 19.556,
    lng: -155.105267,
    panoId: "NpYlE50hj6vL0DOgMRM4MA",
    place: "Near Mountain View, Hawaii",
    shortName: "Mountain View",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "HI",
    state: "Hawaii",
    difficulty: "explorer",
    pools: ["world","North America","US","US-HI"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-hi-065",
    lat: 21.09668,
    lng: -156.759391,
    panoId: "cs6zSbg2yxfNafT8Rcvpjw",
    place: "Near Waialua, Hawaii",
    shortName: "Waialua",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "HI",
    state: "Hawaii",
    difficulty: "explorer",
    pools: ["world","North America","US","US-HI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-hi-066",
    lat: 21.923772,
    lng: -159.54287,
    panoId: "V89lClU4pc2_kpjdvIcAFQ",
    place: "Near Kaumakani-Hanapepe, Hawaii",
    shortName: "Kaumakani-Hanapepe",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "HI",
    state: "Hawaii",
    difficulty: "explorer",
    pools: ["world","North America","US","US-HI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-hi-067",
    lat: 19.571937,
    lng: -155.961536,
    panoId: "KByfDvdXZg7L14CZsusOxA",
    place: "Near Kahaluu-Keauhou, Hawaii",
    shortName: "Kahaluu-Keauhou",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "HI",
    state: "Hawaii",
    difficulty: "explorer",
    pools: ["world","North America","US","US-HI"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-hi-068",
    lat: 20.836427,
    lng: -156.402664,
    panoId: "ktutoqaMe2dI8Bl1NZ57AA",
    place: "Near Spreckelsville, Hawaii",
    shortName: "Spreckelsville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "HI",
    state: "Hawaii",
    difficulty: "explorer",
    pools: ["world","North America","US","US-HI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-hi-069",
    lat: 19.552317,
    lng: -155.005035,
    panoId: "3Pe0_Dcm7BCPe3NqJELevw",
    place: "Near Orchidlands Estates, Hawaii",
    shortName: "Orchidlands Estates",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "HI",
    state: "Hawaii",
    difficulty: "explorer",
    pools: ["world","North America","US","US-HI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-hi-070",
    lat: 20.80799,
    lng: -156.932727,
    panoId: "a1hmzjCWn2Rz1UUtnRwAtA",
    place: "Near Lanai City, Hawaii",
    shortName: "Lanai City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "HI",
    state: "Hawaii",
    difficulty: "explorer",
    pools: ["world","North America","US","US-HI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-hi-071",
    lat: 19.925005,
    lng: -155.795748,
    panoId: "26ahZzHxXczqDCEpdXWtgQ",
    place: "Near Waikoloa, Hawaii",
    shortName: "Waikoloa",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "HI",
    state: "Hawaii",
    difficulty: "explorer",
    pools: ["world","North America","US","US-HI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-hi-072",
    lat: 22.146653,
    lng: -159.321648,
    panoId: "fBI6PLAjYCHWvfz5Kst2Cg",
    place: "Near Anahola, Hawaii",
    shortName: "Anahola",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "HI",
    state: "Hawaii",
    difficulty: "explorer",
    pools: ["world","North America","US","US-HI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-hi-073",
    lat: 19.473267,
    lng: -154.953368,
    panoId: "92vvjVkvMeyBkKSknjexIg",
    place: "Near Leilani Estates, Hawaii",
    shortName: "Leilani Estates",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "HI",
    state: "Hawaii",
    difficulty: "explorer",
    pools: ["world","North America","US","US-HI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-hi-074",
    lat: 20.608815,
    lng: -156.428356,
    panoId: "wfTe0-vmQ7q0Z8fpU4zCgg",
    place: "Near Wailea-Makena, Hawaii",
    shortName: "Wailea-Makena",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "HI",
    state: "Hawaii",
    difficulty: "explorer",
    pools: ["world","North America","US","US-HI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-hi-075",
    lat: 20.753481,
    lng: -156.277331,
    panoId: "IJR2FLb0lT-m8g6ri1IhEQ",
    place: "Near Kula, Hawaii",
    shortName: "Kula",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "HI",
    state: "Hawaii",
    difficulty: "explorer",
    pools: ["world","North America","US","US-HI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-hi-076",
    lat: 19.591326,
    lng: -155.149344,
    panoId: "1tDlCQ9oxrtY0cWPE9PrOw",
    place: "Near Mountain View, Hawaii",
    shortName: "Mountain View",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "HI",
    state: "Hawaii",
    difficulty: "explorer",
    pools: ["world","North America","US","US-HI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-hi-077",
    lat: 19.616421,
    lng: -155.98299,
    panoId: "8gwaYECEHaH2oJuq-YjFyQ",
    place: "Near Kailua-Kona, Hawaii",
    shortName: "Kailua-Kona",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "HI",
    state: "Hawaii",
    difficulty: "explorer",
    pools: ["world","North America","US","US-HI"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-hi-078",
    lat: 20.022213,
    lng: -155.748543,
    panoId: "dnV2UFAtfpaJjlbF9dO34w",
    place: "Near Waimea, Hawaii",
    shortName: "Waimea",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "HI",
    state: "Hawaii",
    difficulty: "explorer",
    pools: ["world","North America","US","US-HI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-hi-079",
    lat: 22.209602,
    lng: -159.370809,
    panoId: "sbN6ozQCwor1-Bc2kkBr8Q",
    place: "Near Kīlauea, Hawaii",
    shortName: "Kīlauea",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "HI",
    state: "Hawaii",
    difficulty: "explorer",
    pools: ["world","North America","US","US-HI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-hi-080",
    lat: 19.674711,
    lng: -156.011638,
    panoId: "Ql0NoQRd4mW93awZcN4kkg",
    place: "Near Kailua-Kona, Hawaii",
    shortName: "Kailua-Kona",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "HI",
    state: "Hawaii",
    difficulty: "explorer",
    pools: ["world","North America","US","US-HI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-hi-081",
    lat: 19.518976,
    lng: -155.00775,
    panoId: "PjL-rc_-CO2pTa8xkNCrXg",
    place: "Near Ainaloa, Hawaii",
    shortName: "Ainaloa",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "HI",
    state: "Hawaii",
    difficulty: "explorer",
    pools: ["world","North America","US","US-HI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-hi-082",
    lat: 21.962022,
    lng: -159.442912,
    panoId: "E6SvNZqAbT3STCiZf2D5_Q",
    place: "Near Puhi, Hawaii",
    shortName: "Puhi",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "HI",
    state: "Hawaii",
    difficulty: "explorer",
    pools: ["world","North America","US","US-HI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-hi-083",
    lat: 20.920668,
    lng: -156.26548,
    panoId: "viYTEb8Ki1hGEKyQpxQToQ",
    place: "Near Haiku-Pauwela, Hawaii",
    shortName: "Haiku-Pauwela",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "HI",
    state: "Hawaii",
    difficulty: "explorer",
    pools: ["world","North America","US","US-HI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-hi-084",
    lat: 21.900747,
    lng: -159.50569,
    panoId: "UZk8muyqm0zd9xddo3Snvg",
    place: "Near Omao-Kukuiula, Hawaii",
    shortName: "Omao-Kukuiula",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "HI",
    state: "Hawaii",
    difficulty: "explorer",
    pools: ["world","North America","US","US-HI"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-hi-085",
    lat: 19.524754,
    lng: -154.930293,
    panoId: "PbDZragRZolgjhQC3u1pdw",
    place: "Near Hawaiian Beaches, Hawaii",
    shortName: "Hawaiian Beaches",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "HI",
    state: "Hawaii",
    difficulty: "explorer",
    pools: ["world","North America","US","US-HI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-hi-086",
    lat: 21.887228,
    lng: -159.41933,
    panoId: "tm3IKQ81X6sgRxLSKR2KIA",
    place: "Near Po‘ipū, Hawaii",
    shortName: "Po‘ipū",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "HI",
    state: "Hawaii",
    difficulty: "explorer",
    pools: ["world","North America","US","US-HI"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-hi-087",
    lat: 21.067843,
    lng: -156.960687,
    panoId: "9SX8_Buz0x4Ih39qOLehmA",
    place: "Near Kaunakakai, Hawaii",
    shortName: "Kaunakakai",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "HI",
    state: "Hawaii",
    difficulty: "explorer",
    pools: ["world","North America","US","US-HI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-hi-088",
    lat: 21.904216,
    lng: -159.456037,
    panoId: "0AO5RhWu0KIETxuPmSzdQw",
    place: "Near Koloa, Hawaii",
    shortName: "Koloa",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "HI",
    state: "Hawaii",
    difficulty: "explorer",
    pools: ["world","North America","US","US-HI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-hi-089",
    lat: 20.762742,
    lng: -156.897651,
    panoId: "Rk2VA-RwdfrlzYCeB_ipDQ",
    place: "Near Lanai City, Hawaii",
    shortName: "Lanai City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "HI",
    state: "Hawaii",
    difficulty: "explorer",
    pools: ["world","North America","US","US-HI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-hi-090",
    lat: 21.882428,
    lng: -159.482178,
    panoId: "UhgHHdkJn8t57iIYIR4PsQ",
    place: "Near Omao-Kukuiula, Hawaii",
    shortName: "Omao-Kukuiula",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "HI",
    state: "Hawaii",
    difficulty: "explorer",
    pools: ["world","North America","US","US-HI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-hi-091",
    lat: 19.699695,
    lng: -156.017825,
    panoId: "mcJzkUhutGpDs-lFBt3hfQ",
    place: "Near Kalaoa, Hawaii",
    shortName: "Kalaoa",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "HI",
    state: "Hawaii",
    difficulty: "explorer",
    pools: ["world","North America","US","US-HI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-hi-092",
    lat: 21.944186,
    lng: -159.519196,
    panoId: "O2lk3oo0MUBLj1Qa414ZOQ",
    place: "Near Kalāheo, Hawaii",
    shortName: "Kalāheo",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "HI",
    state: "Hawaii",
    difficulty: "explorer",
    pools: ["world","North America","US","US-HI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-hi-093",
    lat: 19.466764,
    lng: -155.165729,
    panoId: "YQ7HLEvltq2SRnfpBb1Smw",
    place: "Near Fern Forest, Hawaii",
    shortName: "Fern Forest",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "HI",
    state: "Hawaii",
    difficulty: "explorer",
    pools: ["world","North America","US","US-HI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-hi-094",
    lat: 19.639611,
    lng: -155.081503,
    panoId: "InYjHVNwzw9xiPy3KMc5SQ",
    place: "Near Kurtistown, Hawaii",
    shortName: "Kurtistown",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "HI",
    state: "Hawaii",
    difficulty: "explorer",
    pools: ["world","North America","US","US-HI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-hi-095",
    lat: 19.445917,
    lng: -155.185658,
    panoId: "4e70UQ4aN5gVSsjCsD3Itg",
    place: "Near Volcano, Hawaii",
    shortName: "Volcano",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "HI",
    state: "Hawaii",
    difficulty: "explorer",
    pools: ["world","North America","US","US-HI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-hi-096",
    lat: 21.963611,
    lng: -159.417426,
    panoId: "t2v42X9KqgpTWBhcODkunA",
    place: "Near Puhi, Hawaii",
    shortName: "Puhi",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "HI",
    state: "Hawaii",
    difficulty: "explorer",
    pools: ["world","North America","US","US-HI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-hi-097",
    lat: 20.612368,
    lng: -156.298998,
    panoId: "_xay2HIF16SjVQq-6l0H_w",
    place: "Near Kēōkea, Hawaii",
    shortName: "Kēōkea",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "HI",
    state: "Hawaii",
    difficulty: "explorer",
    pools: ["world","North America","US","US-HI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-hi-098",
    lat: 20.906182,
    lng: -156.224731,
    panoId: "eSCtAQsLrKL5sgNbLPo02Q",
    place: "Near Huelo, Hawaii",
    shortName: "Huelo",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "HI",
    state: "Hawaii",
    difficulty: "explorer",
    pools: ["world","North America","US","US-HI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-hi-099",
    lat: 20.85391,
    lng: -156.460566,
    panoId: "ZouxWk87xYbi_ZGBtqVvxg",
    place: "Near Kahului, Hawaii",
    shortName: "Kahului",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "HI",
    state: "Hawaii",
    difficulty: "explorer",
    pools: ["world","North America","US","US-HI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-hi-100",
    lat: 19.563931,
    lng: -155.246141,
    panoId: "DlwAjbIcEFnd6PGfjUz-Cg",
    place: "Near Volcano, Hawaii",
    shortName: "Volcano",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "HI",
    state: "Hawaii",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-HI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-hi-101",
    lat: 20.132982,
    lng: -155.79543,
    panoId: "97YgJje73iD_uFzEZeKVJw",
    place: "Near Kapaau, Hawaii",
    shortName: "Kapaau",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "HI",
    state: "Hawaii",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-HI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-hi-102",
    lat: 19.470235,
    lng: -155.260327,
    panoId: "mX4HI150ExBtWokoHa2dDA",
    place: "Near Volcano, Hawaii",
    shortName: "Volcano",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "HI",
    state: "Hawaii",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-HI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-hi-103",
    lat: 20.794037,
    lng: -156.014915,
    panoId: "EI8Cr2zqEQKe8Xye7XkVuw",
    place: "Near Hana, Hawaii",
    shortName: "Hana",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "HI",
    state: "Hawaii",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-HI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-hi-104",
    lat: 19.362504,
    lng: -154.965949,
    panoId: "NfBySFebv4_cFMPUmDX_Pg",
    place: "Near Leilani Estates, Hawaii",
    shortName: "Leilani Estates",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "HI",
    state: "Hawaii",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-HI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-hi-105",
    lat: 19.47319,
    lng: -155.357215,
    panoId: "JZBJ6cvmt1psljmLKQg_iQ",
    place: "Near Volcano, Hawaii",
    shortName: "Volcano",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "HI",
    state: "Hawaii",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-HI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-id-000",
    lat: 42.920702,
    lng: -112.466333,
    panoId: "GnYSvO5AuEPaMZUOVhChOg",
    place: "Near Chubbuck, Idaho",
    shortName: "Chubbuck",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ID",
    state: "Idaho",
    difficulty: "classic",
    pools: ["world","North America","US","US-ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-id-001",
    lat: 43.695485,
    lng: -116.354033,
    panoId: "O9K0DhVmERbQqqwaXwBluQ",
    place: "Near Eagle, Idaho",
    shortName: "Eagle",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ID",
    state: "Idaho",
    difficulty: "classic",
    pools: ["world","North America","US","US-ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-id-002",
    lat: 46.380435,
    lng: -116.975626,
    panoId: "gTc717csix2aMgZDOcRjmQ",
    place: "Near Lewiston Orchards, Idaho",
    shortName: "Lewiston Orchards",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ID",
    state: "Idaho",
    difficulty: "classic",
    pools: ["world","North America","US","US-ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-id-003",
    lat: 42.562902,
    lng: -114.460662,
    panoId: "_VjS0Jdvz-Xdz3DRXry8iA",
    place: "Near Twin Falls, Idaho",
    shortName: "Twin Falls",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ID",
    state: "Idaho",
    difficulty: "classic",
    pools: ["world","North America","US","US-ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-id-004",
    lat: 47.718002,
    lng: -116.951563,
    panoId: "ORHNVIL5mQ88jD4rmdbPAw",
    place: "Near Post Falls, Idaho",
    shortName: "Post Falls",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ID",
    state: "Idaho",
    difficulty: "classic",
    pools: ["world","North America","US","US-ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-id-005",
    lat: 43.613384,
    lng: -116.203594,
    panoId: "wv0_9sVJnFNc1Td7PtFVQA",
    place: "Near Boise, Idaho",
    shortName: "Boise",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ID",
    state: "Idaho",
    difficulty: "classic",
    pools: ["world","North America","US","US-ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-id-006",
    lat: 48.276698,
    lng: -116.553128,
    panoId: "WYb7MnsXVRznYcPOsQnjTg",
    place: "Near Sandpoint, Idaho",
    shortName: "Sandpoint",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ID",
    state: "Idaho",
    difficulty: "classic",
    pools: ["world","North America","US","US-ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-id-007",
    lat: 43.46964,
    lng: -111.966613,
    panoId: "fHur8ptF4HgVOLq_6o6kvA",
    place: "Near Ammon, Idaho",
    shortName: "Ammon",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ID",
    state: "Idaho",
    difficulty: "classic",
    pools: ["world","North America","US","US-ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-id-008",
    lat: 42.096291,
    lng: -111.876562,
    panoId: "u7dGtijMmSff_QytZbfBlA",
    place: "Near Preston, Idaho",
    shortName: "Preston",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ID",
    state: "Idaho",
    difficulty: "classic",
    pools: ["world","North America","US","US-ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-id-009",
    lat: 42.535492,
    lng: -113.792851,
    panoId: "PBUgmWQwL9pohMbPO6V8AQ",
    place: "Near Burley, Idaho",
    shortName: "Burley",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ID",
    state: "Idaho",
    difficulty: "classic",
    pools: ["world","North America","US","US-ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-id-010",
    lat: 43.190437,
    lng: -112.344829,
    panoId: "_-o0wWwcBJL0TVp6LvbiyQ",
    place: "Near Blackfoot, Idaho",
    shortName: "Blackfoot",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ID",
    state: "Idaho",
    difficulty: "classic",
    pools: ["world","North America","US","US-ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-id-011",
    lat: 46.416513,
    lng: -117.017412,
    panoId: "1CtikXnpwdillGMBb55vtQ",
    place: "Near Lewiston, Idaho",
    shortName: "Lewiston",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ID",
    state: "Idaho",
    difficulty: "classic",
    pools: ["world","North America","US","US-ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-id-012",
    lat: 43.692022,
    lng: -116.493453,
    panoId: "TcSkaTWtSBDm0zwOnmmamA",
    place: "Near Star, Idaho",
    shortName: "Star",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ID",
    state: "Idaho",
    difficulty: "classic",
    pools: ["world","North America","US","US-ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-id-013",
    lat: 42.871318,
    lng: -112.445533,
    panoId: "4y0OAdKYFDNcOa3LU47eEw",
    place: "Near Pocatello, Idaho",
    shortName: "Pocatello",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ID",
    state: "Idaho",
    difficulty: "classic",
    pools: ["world","North America","US","US-ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-id-014",
    lat: 44.251317,
    lng: -116.969332,
    panoId: "yKrswg7exruULlu9OKIQgA",
    place: "Near Weiser, Idaho",
    shortName: "Weiser",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ID",
    state: "Idaho",
    difficulty: "classic",
    pools: ["world","North America","US","US-ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-id-015",
    lat: 43.622117,
    lng: -116.238097,
    panoId: "nwJ8c4vP3NoE-zcwmkJrzQ",
    place: "Near Garden City, Idaho",
    shortName: "Garden City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ID",
    state: "Idaho",
    difficulty: "classic",
    pools: ["world","North America","US","US-ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-id-016",
    lat: 43.612092,
    lng: -116.391607,
    panoId: "ZEsLN1rSbQG36Fw3ke8nxQ",
    place: "Near Meridian, Idaho",
    shortName: "Meridian",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ID",
    state: "Idaho",
    difficulty: "classic",
    pools: ["world","North America","US","US-ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-id-017",
    lat: 43.70685,
    lng: -116.619653,
    panoId: "6-VFhniseYUyqcbxweN6tQ",
    place: "Near Middleton, Idaho",
    shortName: "Middleton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ID",
    state: "Idaho",
    difficulty: "classic",
    pools: ["world","North America","US","US-ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-id-018",
    lat: 47.812414,
    lng: -116.896613,
    panoId: "R4WUXuM5an8YVKFMHjQDpw",
    place: "Near Rathdrum, Idaho",
    shortName: "Rathdrum",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ID",
    state: "Idaho",
    difficulty: "classic",
    pools: ["world","North America","US","US-ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-id-019",
    lat: 42.724139,
    lng: -114.5187,
    panoId: "46F0KT_5k1HUzeRspH4RjA",
    place: "Near Jerome, Idaho",
    shortName: "Jerome",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ID",
    state: "Idaho",
    difficulty: "classic",
    pools: ["world","North America","US","US-ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-id-020",
    lat: 43.519613,
    lng: -114.31536,
    panoId: "ERC4i4dnYegeluZpyy37iA",
    place: "Near Hailey, Idaho",
    shortName: "Hailey",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ID",
    state: "Idaho",
    difficulty: "classic",
    pools: ["world","North America","US","US-ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-id-021",
    lat: 42.619127,
    lng: -113.677834,
    panoId: "NHEQKdHH1j1SLPigkSszzw",
    place: "Near Rupert, Idaho",
    shortName: "Rupert",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ID",
    state: "Idaho",
    difficulty: "classic",
    pools: ["world","North America","US","US-ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-id-022",
    lat: 43.466628,
    lng: -112.034472,
    panoId: "z0rjsQnPrUqNgjC1Ciy3jA",
    place: "Near Idaho Falls, Idaho",
    shortName: "Idaho Falls",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ID",
    state: "Idaho",
    difficulty: "classic",
    pools: ["world","North America","US","US-ID"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "us-id-023",
    lat: 43.541017,
    lng: -116.563564,
    panoId: "ez_G239MKh26jacTpxPgww",
    place: "Near Nampa, Idaho",
    shortName: "Nampa",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ID",
    state: "Idaho",
    difficulty: "classic",
    pools: ["world","North America","US","US-ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-id-024",
    lat: 43.663002,
    lng: -116.687415,
    panoId: "HGDMxNz2nqxbMHsEsT9lCQ",
    place: "Near Caldwell, Idaho",
    shortName: "Caldwell",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ID",
    state: "Idaho",
    difficulty: "classic",
    pools: ["world","North America","US","US-ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-id-025",
    lat: 43.873537,
    lng: -116.499331,
    panoId: "FIuJ5obWOmKUVRvPO79q7Q",
    place: "Near Emmett, Idaho",
    shortName: "Emmett",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ID",
    state: "Idaho",
    difficulty: "classic",
    pools: ["world","North America","US","US-ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-id-026",
    lat: 43.826074,
    lng: -111.789647,
    panoId: "flVP0u4_1u-FNUbQPUg-KQ",
    place: "Near Rexburg, Idaho",
    shortName: "Rexburg",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ID",
    state: "Idaho",
    difficulty: "classic",
    pools: ["world","North America","US","US-ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-id-027",
    lat: 47.766001,
    lng: -116.786532,
    panoId: "zVGJ-3FcdE2Xb6W4gXRu3g",
    place: "Near Hayden, Idaho",
    shortName: "Hayden",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ID",
    state: "Idaho",
    difficulty: "classic",
    pools: ["world","North America","US","US-ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-id-028",
    lat: 46.73236,
    lng: -117.000125,
    panoId: "bxOe-mifNrJONMbkUp0XvQ",
    place: "Near Moscow, Idaho",
    shortName: "Moscow",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ID",
    state: "Idaho",
    difficulty: "classic",
    pools: ["world","North America","US","US-ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-id-029",
    lat: 43.133056,
    lng: -115.691243,
    panoId: "EzYaoMuIwMHHdZdAMkdE4w",
    place: "Near Mountain Home, Idaho",
    shortName: "Mountain Home",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ID",
    state: "Idaho",
    difficulty: "classic",
    pools: ["world","North America","US","US-ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-id-030",
    lat: 43.491773,
    lng: -116.420087,
    panoId: "VnU6qui_qtTRNMr0pHRrig",
    place: "Near Kuna, Idaho",
    shortName: "Kuna",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ID",
    state: "Idaho",
    difficulty: "classic",
    pools: ["world","North America","US","US-ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-id-031",
    lat: 44.078138,
    lng: -116.933774,
    panoId: "sCglyfmIxHt61S4iXW8qHQ",
    place: "Near Payette, Idaho",
    shortName: "Payette",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ID",
    state: "Idaho",
    difficulty: "classic",
    pools: ["world","North America","US","US-ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-id-032",
    lat: 44.007678,
    lng: -116.91656,
    panoId: "P_7kqQYlf3dYdkHYt_vsIA",
    place: "Near Fruitland, Idaho",
    shortName: "Fruitland",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ID",
    state: "Idaho",
    difficulty: "classic",
    pools: ["world","North America","US","US-ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-id-033",
    lat: 47.677576,
    lng: -116.78043,
    panoId: "vGqbzvWFCuFNIp2KatC18Q",
    place: "Near Coeur d'Alene, Idaho",
    shortName: "Coeur d'Alene",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ID",
    state: "Idaho",
    difficulty: "classic",
    pools: ["world","North America","US","US-ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-id-034",
    lat: 43.621787,
    lng: -116.371123,
    panoId: "oKGumD8tSEJLVL7koCekhw",
    place: "Near Meridian, Idaho",
    shortName: "Meridian",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ID",
    state: "Idaho",
    difficulty: "classic",
    pools: ["world","North America","US","US-ID"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-id-035",
    lat: 43.67874,
    lng: -116.698662,
    panoId: "SaKsJC4Mr8BK6QIxq1zm1g",
    place: "Near Caldwell, Idaho",
    shortName: "Caldwell",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ID",
    state: "Idaho",
    difficulty: "classic",
    pools: ["world","North America","US","US-ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-id-036",
    lat: 43.835811,
    lng: -111.798193,
    panoId: "bo7OTPPHgcowcWrBY9m43A",
    place: "Near Rexburg, Idaho",
    shortName: "Rexburg",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ID",
    state: "Idaho",
    difficulty: "classic",
    pools: ["world","North America","US","US-ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-id-037",
    lat: 43.703309,
    lng: -116.592622,
    panoId: "0Ow4JxACyUyLVse_doIPKA",
    place: "Near Middleton, Idaho",
    shortName: "Middleton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ID",
    state: "Idaho",
    difficulty: "classic",
    pools: ["world","North America","US","US-ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-id-038",
    lat: 42.703133,
    lng: -114.52569,
    panoId: "CT9qdDluHQNw7oSPIZkItQ",
    place: "Near Jerome, Idaho",
    shortName: "Jerome",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ID",
    state: "Idaho",
    difficulty: "classic",
    pools: ["world","North America","US","US-ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-id-039",
    lat: 43.695932,
    lng: -116.473349,
    panoId: "MWHQ0eMkXiQm7lAmCL11aA",
    place: "Near Star, Idaho",
    shortName: "Star",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ID",
    state: "Idaho",
    difficulty: "classic",
    pools: ["world","North America","US","US-ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-id-040",
    lat: 47.790584,
    lng: -116.903109,
    panoId: "C-69GzONk1AvEcmbl26KHg",
    place: "Near Rathdrum, Idaho",
    shortName: "Rathdrum",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ID",
    state: "Idaho",
    difficulty: "classic",
    pools: ["world","North America","US","US-ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-id-041",
    lat: 46.429362,
    lng: -117.023599,
    panoId: "w4NXN47Xm57Lgs8BSIo4kw",
    place: "Near Lewiston, Idaho",
    shortName: "Lewiston",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ID",
    state: "Idaho",
    difficulty: "classic",
    pools: ["world","North America","US","US-ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-id-042",
    lat: 43.61621,
    lng: -116.268773,
    panoId: "VSoF7rllFfeO8ROSWHm9WA",
    place: "Near Garden City, Idaho",
    shortName: "Garden City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ID",
    state: "Idaho",
    difficulty: "classic",
    pools: ["world","North America","US","US-ID"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-id-043",
    lat: 43.883105,
    lng: -116.472882,
    panoId: "PLS22YY994m873Jn1idsWA",
    place: "Near Emmett, Idaho",
    shortName: "Emmett",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ID",
    state: "Idaho",
    difficulty: "classic",
    pools: ["world","North America","US","US-ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-id-044",
    lat: 44.017091,
    lng: -116.893478,
    panoId: "cdXS7G2jAAGY0YpkvFirNw",
    place: "Near Fruitland, Idaho",
    shortName: "Fruitland",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ID",
    state: "Idaho",
    difficulty: "classic",
    pools: ["world","North America","US","US-ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-id-045",
    lat: 47.662039,
    lng: -116.75003,
    panoId: "2a2qps8zqgNstvxcL_G4bA",
    place: "Near Coeur d'Alene, Idaho",
    shortName: "Coeur d'Alene",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ID",
    state: "Idaho",
    difficulty: "classic",
    pools: ["world","North America","US","US-ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-id-046",
    lat: 47.751761,
    lng: -116.799608,
    panoId: "uhCkbu8E4LSOuuMl4pHTGw",
    place: "Near Hayden, Idaho",
    shortName: "Hayden",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ID",
    state: "Idaho",
    difficulty: "classic",
    pools: ["world","North America","US","US-ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-id-047",
    lat: 44.034842,
    lng: -116.969256,
    panoId: "BvXeNMHAQqpFNIpXvh7PeQ",
    place: "Near Ontario, Idaho",
    shortName: "Ontario",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ID",
    state: "Idaho",
    difficulty: "classic",
    pools: ["world","North America","US","US-ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-id-048",
    lat: 42.096322,
    lng: -111.842061,
    panoId: "R3r_-u-FERoyYJ9rxgDITg",
    place: "Near Preston, Idaho",
    shortName: "Preston",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ID",
    state: "Idaho",
    difficulty: "classic",
    pools: ["world","North America","US","US-ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-id-049",
    lat: 43.449163,
    lng: -111.97689,
    panoId: "ubLogkkkgztLhVrK90K04g",
    place: "Near Ammon, Idaho",
    shortName: "Ammon",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ID",
    state: "Idaho",
    difficulty: "classic",
    pools: ["world","North America","US","US-ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-id-050",
    lat: 43.381407,
    lng: -112.123259,
    panoId: "hUVBOdjNj7i1JtoGbwh-YQ",
    place: "Near Shelley, Idaho",
    shortName: "Shelley",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ID",
    state: "Idaho",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-id-051",
    lat: 43.672406,
    lng: -111.914883,
    panoId: "GzFdnMOma2cqREG-Q40e9g",
    place: "Near Rigby, Idaho",
    shortName: "Rigby",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ID",
    state: "Idaho",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-id-052",
    lat: 43.513003,
    lng: -111.96417,
    panoId: "lRYPvDlCPHMHEaFYuZGOxA",
    place: "Near Lincoln, Idaho",
    shortName: "Lincoln",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ID",
    state: "Idaho",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-id-053",
    lat: 43.333009,
    lng: -112.1401,
    panoId: "6HqapaKg7dgsshSwNbc7GA",
    place: "Near Shelley, Idaho",
    shortName: "Shelley",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ID",
    state: "Idaho",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-id-054",
    lat: 43.647919,
    lng: -116.304813,
    panoId: "MkZ31p0_A4FDxfUy4Byxqw",
    place: "Near Garden City, Idaho",
    shortName: "Garden City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ID",
    state: "Idaho",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-id-055",
    lat: 43.163463,
    lng: -115.73473,
    panoId: "fdyXFhsVmcQiVNbXQtFb2w",
    place: "Near Mountain Home, Idaho",
    shortName: "Mountain Home",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ID",
    state: "Idaho",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-id-056",
    lat: 42.613932,
    lng: -113.597481,
    panoId: "8zb5VEDlpFr2CGCa59Jxew",
    place: "Near Rupert, Idaho",
    shortName: "Rupert",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ID",
    state: "Idaho",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-id-057",
    lat: 48.252941,
    lng: -116.471145,
    panoId: "aP51AH3ZLX4J6zE8agcKsg",
    place: "Near Sandpoint, Idaho",
    shortName: "Sandpoint",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ID",
    state: "Idaho",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-id-058",
    lat: 42.935024,
    lng: -112.518956,
    panoId: "hT2BNNOEAWCpZhV_GV5lWQ",
    place: "Near Chubbuck, Idaho",
    shortName: "Chubbuck",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ID",
    state: "Idaho",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-id-059",
    lat: 43.627413,
    lng: -116.281722,
    panoId: "2QJg_TgCrF1-4G9A6Mrc-w",
    place: "Near Garden City, Idaho",
    shortName: "Garden City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ID",
    state: "Idaho",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-id-060",
    lat: 43.531171,
    lng: -116.453641,
    panoId: "xfHkvtfhlPHjBYWAtem3rQ",
    place: "Near Kuna, Idaho",
    shortName: "Kuna",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ID",
    state: "Idaho",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-id-061",
    lat: 47.669521,
    lng: -117.001462,
    panoId: "EGOIOAXZb-LiwfW-y1a_-A",
    place: "Near Post Falls, Idaho",
    shortName: "Post Falls",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ID",
    state: "Idaho",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-id-062",
    lat: 44.061064,
    lng: -116.968521,
    panoId: "0VNVM_f81N6fwNRUaxLNDQ",
    place: "Near Payette, Idaho",
    shortName: "Payette",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ID",
    state: "Idaho",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-id-063",
    lat: 42.575978,
    lng: -113.792539,
    panoId: "z-ARiz4caAFigeisg2JOKA",
    place: "Near Heyburn, Idaho",
    shortName: "Heyburn",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ID",
    state: "Idaho",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-id-064",
    lat: 43.518853,
    lng: -111.939652,
    panoId: "wLadEPSYNFUNDcfNALFGRA",
    place: "Near Iona, Idaho",
    shortName: "Iona",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ID",
    state: "Idaho",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-id-065",
    lat: 43.590803,
    lng: -114.306038,
    panoId: "dJFHBzaaKvBJzY0CHM_S3g",
    place: "Near Hailey, Idaho",
    shortName: "Hailey",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ID",
    state: "Idaho",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-id-066",
    lat: 42.709845,
    lng: -114.581862,
    panoId: "rHvNsHiHyjQZVwcbyuWuYQ",
    place: "Near Jerome, Idaho",
    shortName: "Jerome",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ID",
    state: "Idaho",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-id-067",
    lat: 42.605168,
    lng: -113.636652,
    panoId: "yeB46cT0pDu5Sr2fhCTDqw",
    place: "Near Rupert, Idaho",
    shortName: "Rupert",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ID",
    state: "Idaho",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-id-068",
    lat: 46.77378,
    lng: -117.000589,
    panoId: "09HRXM0Xya1QxYvn9A72cA",
    place: "Near Moscow, Idaho",
    shortName: "Moscow",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ID",
    state: "Idaho",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-id-069",
    lat: 46.342443,
    lng: -117.02292,
    panoId: "N0oKhTi1UbZ2XFz4UiF7Dw",
    place: "Near Asotin, Idaho",
    shortName: "Asotin",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ID",
    state: "Idaho",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-id-070",
    lat: 44.140592,
    lng: -116.934519,
    panoId: "zCchaFnscWR45h3rkm2PFQ",
    place: "Near Payette, Idaho",
    shortName: "Payette",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ID",
    state: "Idaho",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-id-071",
    lat: 43.604577,
    lng: -116.658093,
    panoId: "wVgyCOC6hRjmh27MsoWnpw",
    place: "Near Caldwell, Idaho",
    shortName: "Caldwell",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ID",
    state: "Idaho",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-id-072",
    lat: 43.431135,
    lng: -112.131316,
    panoId: "BOlwBs3HbKv3QGg2XAOCAw",
    place: "Near Shelley, Idaho",
    shortName: "Shelley",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ID",
    state: "Idaho",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-id-073",
    lat: 43.718228,
    lng: -116.401059,
    panoId: "vJUzyWjpWCoVQtgqmSUUuA",
    place: "Near Eagle, Idaho",
    shortName: "Eagle",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ID",
    state: "Idaho",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-id-074",
    lat: 43.66822,
    lng: -116.563518,
    panoId: "voAo7EbO95i7nK9QCx22-A",
    place: "Near Star, Idaho",
    shortName: "Star",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ID",
    state: "Idaho",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-id-075",
    lat: 43.430086,
    lng: -111.964053,
    panoId: "T2deX4J3VAWiGQSOYYTyEg",
    place: "Near Ammon, Idaho",
    shortName: "Ammon",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ID",
    state: "Idaho",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-id-076",
    lat: 48.337915,
    lng: -116.595004,
    panoId: "YGEAt1eiMAEpohdKonjuKQ",
    place: "Near Ponderay, Idaho",
    shortName: "Ponderay",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ID",
    state: "Idaho",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-id-077",
    lat: 47.734027,
    lng: -116.991108,
    panoId: "oJHMpcTNfcZUJvtwrgiHMw",
    place: "Near Post Falls, Idaho",
    shortName: "Post Falls",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ID",
    state: "Idaho",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-id-078",
    lat: 43.860692,
    lng: -111.698009,
    panoId: "V7Z9aT6SlVdI-KGHemk8Dg",
    place: "Near Sugar City, Idaho",
    shortName: "Sugar City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ID",
    state: "Idaho",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-id-079",
    lat: 43.661592,
    lng: -116.373295,
    panoId: "Dlp08vnpXnSYKtR_5dvkNA",
    place: "Near Eagle, Idaho",
    shortName: "Eagle",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ID",
    state: "Idaho",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-id-080",
    lat: 42.622441,
    lng: -114.706292,
    panoId: "73P70Imn2xGXHuwbWiT3uA",
    place: "Near Buhl, Idaho",
    shortName: "Buhl",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ID",
    state: "Idaho",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-id-081",
    lat: 43.627021,
    lng: -116.447732,
    panoId: "qyg7Xw4jOWQaQ2L17eSQPg",
    place: "Near Meridian, Idaho",
    shortName: "Meridian",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ID",
    state: "Idaho",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-id-082",
    lat: 47.807866,
    lng: -116.702925,
    panoId: "ARVRIZRK_69k_fLEl_pZzQ",
    place: "Near Hayden, Idaho",
    shortName: "Hayden",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ID",
    state: "Idaho",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-id-083",
    lat: 43.576801,
    lng: -116.274423,
    panoId: "68gLysdBlwpqi9rmUNHFFg",
    place: "Near Garden City, Idaho",
    shortName: "Garden City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ID",
    state: "Idaho",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ID"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-id-084",
    lat: 43.569358,
    lng: -116.167852,
    panoId: "aemFfcrOlayAs9lW9hqiug",
    place: "Near Boise, Idaho",
    shortName: "Boise",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ID",
    state: "Idaho",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-id-085",
    lat: 43.53972,
    lng: -111.958135,
    panoId: "v4ImgMTSiyQzr6-jfFhbeQ",
    place: "Near Iona, Idaho",
    shortName: "Iona",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ID",
    state: "Idaho",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-id-086",
    lat: 43.486681,
    lng: -111.889564,
    panoId: "IjtdUA-G-rPSYRKCHolsbg",
    place: "Near Iona, Idaho",
    shortName: "Iona",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ID",
    state: "Idaho",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-id-087",
    lat: 47.747248,
    lng: -116.894228,
    panoId: "JLGOmtfIz8VIVkFzmlLANw",
    place: "Near Post Falls, Idaho",
    shortName: "Post Falls",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ID",
    state: "Idaho",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-id-088",
    lat: 47.715804,
    lng: -116.855325,
    panoId: "AC2JBy19fuDZ2Y9KekpDtA",
    place: "Near Dalton Gardens, Idaho",
    shortName: "Dalton Gardens",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ID",
    state: "Idaho",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-id-089",
    lat: 42.062951,
    lng: -111.90906,
    panoId: "6LlMP4WlvK4EKbo9MevmhQ",
    place: "Near Preston, Idaho",
    shortName: "Preston",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ID",
    state: "Idaho",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-id-090",
    lat: 42.654769,
    lng: -111.612798,
    panoId: "Q-W12v-14Iv8nkesjcObxA",
    place: "Near Soda Springs, Idaho",
    shortName: "Soda Springs",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ID",
    state: "Idaho",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-id-091",
    lat: 42.786446,
    lng: -112.854289,
    panoId: "0xcp6ITB_RZHmn8umKi6dg",
    place: "Near American Falls, Idaho",
    shortName: "American Falls",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ID",
    state: "Idaho",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-id-092",
    lat: 42.59913,
    lng: -114.759534,
    panoId: "xU99-yPH0p_wAnzV9xKM6Q",
    place: "Near Buhl, Idaho",
    shortName: "Buhl",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ID",
    state: "Idaho",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-id-093",
    lat: 42.563993,
    lng: -114.721247,
    panoId: "D3dn3ClCosh7jQz-ihOJyA",
    place: "Near Buhl, Idaho",
    shortName: "Buhl",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ID",
    state: "Idaho",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-id-094",
    lat: 42.773417,
    lng: -112.852418,
    panoId: "oQR7TSk9eNQdgVvlCKFzEg",
    place: "Near American Falls, Idaho",
    shortName: "American Falls",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ID",
    state: "Idaho",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-id-095",
    lat: 43.646235,
    lng: -111.888218,
    panoId: "3ri8t6xzHM1MyfNatqpIkA",
    place: "Near Rigby, Idaho",
    shortName: "Rigby",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ID",
    state: "Idaho",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-id-096",
    lat: 42.770151,
    lng: -112.934452,
    panoId: "b5Wo0Qaxgfi1Nd8veeprxg",
    place: "Near American Falls, Idaho",
    shortName: "American Falls",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ID",
    state: "Idaho",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-il-000",
    lat: 42.271083,
    lng: -89.094098,
    panoId: "0XEyoWyToPPeGVyGDZ783w",
    place: "Near Rockford, Illinois",
    shortName: "Rockford",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IL",
    state: "Illinois",
    difficulty: "classic",
    pools: ["world","North America","US","US-IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-il-001",
    lat: 40.693772,
    lng: -89.589055,
    panoId: "hYa2CHD2B6ENf0X6HrbjEA",
    place: "Near Peoria, Illinois",
    shortName: "Peoria",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IL",
    state: "Illinois",
    difficulty: "classic",
    pools: ["world","North America","US","US-IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-il-002",
    lat: 41.76054,
    lng: -88.320154,
    panoId: "H9t6x0NrBeaq4M5UErdiFg",
    place: "Near Aurora, Illinois",
    shortName: "Aurora",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IL",
    state: "Illinois",
    difficulty: "classic",
    pools: ["world","North America","US","US-IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-il-003",
    lat: 42.363601,
    lng: -87.844705,
    panoId: "aZV3W8UF0HuuG72iMAncjA",
    place: "Near Waukegan, Illinois",
    shortName: "Waukegan",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IL",
    state: "Illinois",
    difficulty: "classic",
    pools: ["world","North America","US","US-IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-il-004",
    lat: 41.929623,
    lng: -88.750309,
    panoId: "3OaDCR6joZUSDYXZrjW5Mg",
    place: "Near DeKalb, Illinois",
    shortName: "DeKalb",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IL",
    state: "Illinois",
    difficulty: "classic",
    pools: ["world","North America","US","US-IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-il-005",
    lat: 41.912455,
    lng: -88.134788,
    panoId: "NrGFH0yT85cGVGOcqj87tg",
    place: "Near Carol Stream, Illinois",
    shortName: "Carol Stream",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IL",
    state: "Illinois",
    difficulty: "classic",
    pools: ["world","North America","US","US-IL"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-il-006",
    lat: 40.116308,
    lng: -88.243388,
    panoId: "EZQF5FMi3K-3aMt_4XAwTg",
    place: "Near Champaign, Illinois",
    shortName: "Champaign",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IL",
    state: "Illinois",
    difficulty: "classic",
    pools: ["world","North America","US","US-IL"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-il-007",
    lat: 39.840333,
    lng: -88.954807,
    panoId: "cibc_Z48JFCa296BQLtfWA",
    place: "Near Decatur, Illinois",
    shortName: "Decatur",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IL",
    state: "Illinois",
    difficulty: "classic",
    pools: ["world","North America","US","US-IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-il-008",
    lat: 41.506641,
    lng: -90.515036,
    panoId: "37oMV0bGj91Chm4tSLdp9Q",
    place: "Near Moline, Illinois",
    shortName: "Moline",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IL",
    state: "Illinois",
    difficulty: "classic",
    pools: ["world","North America","US","US-IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-il-009",
    lat: 42.033341,
    lng: -88.082587,
    panoId: "lILADCdU54SgcUL5cPA30g",
    place: "Near Schaumburg, Illinois",
    shortName: "Schaumburg",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IL",
    state: "Illinois",
    difficulty: "classic",
    pools: ["world","North America","US","US-IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-il-010",
    lat: 41.850013,
    lng: -87.650101,
    panoId: "9DorDrenkvFbG5dwLxMIMw",
    place: "Near Chicago, Illinois",
    shortName: "Chicago",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IL",
    state: "Illinois",
    difficulty: "classic",
    pools: ["world","North America","US","US-IL"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-il-011",
    lat: 42.241185,
    lng: -88.316199,
    panoId: "WCBMwWv13lvRTx5_g9LR_Q",
    place: "Near Crystal Lake, Illinois",
    shortName: "Crystal Lake",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IL",
    state: "Illinois",
    difficulty: "classic",
    pools: ["world","North America","US","US-IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-il-012",
    lat: 41.785904,
    lng: -88.147302,
    panoId: "uqYhIfWQwc_nw1FlZsbgHA",
    place: "Near Naperville, Illinois",
    shortName: "Naperville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IL",
    state: "Illinois",
    difficulty: "classic",
    pools: ["world","North America","US","US-IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-il-013",
    lat: 41.627059,
    lng: -88.20394,
    panoId: "Y1Jzr8FhHCmh96tWLfAHnA",
    place: "Near Plainfield, Illinois",
    shortName: "Plainfield",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IL",
    state: "Illinois",
    difficulty: "classic",
    pools: ["world","North America","US","US-IL"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-il-014",
    lat: 42.151446,
    lng: -87.959763,
    panoId: "MIiL26Tlix-7pXnlbYhRfQ",
    place: "Near Buffalo Grove, Illinois",
    shortName: "Buffalo Grove",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IL",
    state: "Illinois",
    difficulty: "classic",
    pools: ["world","North America","US","US-IL"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-il-015",
    lat: 40.514197,
    lng: -88.990609,
    panoId: "YEIJe5SWxCG739dodGypLQ",
    place: "Near Normal, Illinois",
    shortName: "Normal",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IL",
    state: "Illinois",
    difficulty: "classic",
    pools: ["world","North America","US","US-IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-il-016",
    lat: 38.519954,
    lng: -89.984002,
    panoId: "zx1c9yH6Mxg6eBdUX0kTmw",
    place: "Near Belleville, Illinois",
    shortName: "Belleville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IL",
    state: "Illinois",
    difficulty: "classic",
    pools: ["world","North America","US","US-IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-il-017",
    lat: 39.935578,
    lng: -91.409895,
    panoId: "ATilOQeckKMxM3E-Bba7nQ",
    place: "Near Quincy, Illinois",
    shortName: "Quincy",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IL",
    state: "Illinois",
    difficulty: "classic",
    pools: ["world","North America","US","US-IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-il-018",
    lat: 42.037241,
    lng: -88.281203,
    panoId: "WzRslk4Ux3CMk2kEx4pDXQ",
    place: "Near Elgin, Illinois",
    shortName: "Elgin",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IL",
    state: "Illinois",
    difficulty: "classic",
    pools: ["world","North America","US","US-IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-il-019",
    lat: 41.994985,
    lng: -88.185556,
    panoId: "yLWnbf-KfTg6A1pYCWld8Q",
    place: "Near Bartlett, Illinois",
    shortName: "Bartlett",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IL",
    state: "Illinois",
    difficulty: "classic",
    pools: ["world","North America","US","US-IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-il-020",
    lat: 41.524948,
    lng: -88.083344,
    panoId: "4mJSU3vgDX1qyKBH0E8iGQ",
    place: "Near Joliet, Illinois",
    shortName: "Joliet",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IL",
    state: "Illinois",
    difficulty: "classic",
    pools: ["world","North America","US","US-IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-il-021",
    lat: 40.567538,
    lng: -89.640803,
    panoId: "hzA0EmVo6xQc3TqlodXzXA",
    place: "Near Pekin, Illinois",
    shortName: "Pekin",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IL",
    state: "Illinois",
    difficulty: "classic",
    pools: ["world","North America","US","US-IL"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-il-022",
    lat: 42.110339,
    lng: -88.034254,
    panoId: "Z9beE3SCupwjROJMTaKZNw",
    place: "Near Palatine, Illinois",
    shortName: "Palatine",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IL",
    state: "Illinois",
    difficulty: "classic",
    pools: ["world","North America","US","US-IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-il-023",
    lat: 40.484209,
    lng: -88.993744,
    panoId: "Y0TS7HuLMwmAJAWP8HmLQg",
    place: "Near Bloomington, Illinois",
    shortName: "Bloomington",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IL",
    state: "Illinois",
    difficulty: "classic",
    pools: ["world","North America","US","US-IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-il-024",
    lat: 42.02577,
    lng: -88.178399,
    panoId: "o4oHmomfW-CAIZaU-7nxoA",
    place: "Near Streamwood, Illinois",
    shortName: "Streamwood",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IL",
    state: "Illinois",
    difficulty: "classic",
    pools: ["world","North America","US","US-IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-il-025",
    lat: 42.121178,
    lng: -88.257818,
    panoId: "8A0o_Oynos3CY_ys4rFuQA",
    place: "Near Carpentersville, Illinois",
    shortName: "Carpentersville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IL",
    state: "Illinois",
    difficulty: "classic",
    pools: ["world","North America","US","US-IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-il-026",
    lat: 41.999479,
    lng: -88.145074,
    panoId: "fQpHX-Ift9Vl_UyF5n6cvg",
    place: "Near Hanover Park, Illinois",
    shortName: "Hanover Park",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IL",
    state: "Illinois",
    difficulty: "classic",
    pools: ["world","North America","US","US-IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-il-027",
    lat: 41.647488,
    lng: -88.089581,
    panoId: "4AONIKs6a_N39f19ipoB0g",
    place: "Near Romeoville, Illinois",
    shortName: "Romeoville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IL",
    state: "Illinois",
    difficulty: "classic",
    pools: ["world","North America","US","US-IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-il-028",
    lat: 41.914234,
    lng: -88.308676,
    panoId: "RiIwj79Y_KOK6_FJv8tV_g",
    place: "Near St. Charles, Illinois",
    shortName: "St. Charles",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IL",
    state: "Illinois",
    difficulty: "classic",
    pools: ["world","North America","US","US-IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-il-029",
    lat: 41.86614,
    lng: -88.107,
    panoId: "UwvRCeDCrx67t4RkM5j7MQ",
    place: "Near Wheaton, Illinois",
    shortName: "Wheaton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IL",
    state: "Illinois",
    difficulty: "classic",
    pools: ["world","North America","US","US-IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-il-030",
    lat: 40.110188,
    lng: -88.207939,
    panoId: "NVrMdNzlTTcsGIs53EBLdw",
    place: "Near Urbana, Illinois",
    shortName: "Urbana",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IL",
    state: "Illinois",
    difficulty: "classic",
    pools: ["world","North America","US","US-IL"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-il-031",
    lat: 40.124445,
    lng: -87.630036,
    panoId: "A6JD0h0m0Bj3iOnMctUnDw",
    place: "Near Danville, Illinois",
    shortName: "Danville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IL",
    state: "Illinois",
    difficulty: "classic",
    pools: ["world","North America","US","US-IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-il-032",
    lat: 41.509495,
    lng: -90.57881,
    panoId: "d7yHuROPs2aVgVaw6KJ1NQ",
    place: "Near Rock Island, Illinois",
    shortName: "Rock Island",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IL",
    state: "Illinois",
    difficulty: "classic",
    pools: ["world","North America","US","US-IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-il-033",
    lat: 40.717531,
    lng: -89.584296,
    panoId: "iHpsTWq8NYMojWAfFmFtRQ",
    place: "Near North Peoria, Illinois",
    shortName: "North Peoria",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IL",
    state: "Illinois",
    difficulty: "classic",
    pools: ["world","North America","US","US-IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-il-034",
    lat: 41.682884,
    lng: -88.351423,
    panoId: "ofLcAKzjKEWo9Gw0A0gPAA",
    place: "Near Oswego, Illinois",
    shortName: "Oswego",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IL",
    state: "Illinois",
    difficulty: "classic",
    pools: ["world","North America","US","US-IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-il-035",
    lat: 42.263082,
    lng: -88.003951,
    panoId: "lcdJ8p1G8IP30MV4dm3qJg",
    place: "Near Mundelein, Illinois",
    shortName: "Mundelein",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IL",
    state: "Illinois",
    difficulty: "classic",
    pools: ["world","North America","US","US-IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-il-036",
    lat: 40.947863,
    lng: -90.371267,
    panoId: "qVKUjC2ZJ6KvjD-aHDZfTQ",
    place: "Near Galesburg, Illinois",
    shortName: "Galesburg",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IL",
    state: "Illinois",
    difficulty: "classic",
    pools: ["world","North America","US","US-IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-il-037",
    lat: 42.370316,
    lng: -87.902193,
    panoId: "JP4j7WSErW4JmMeZ-huMBA",
    place: "Near Gurnee, Illinois",
    shortName: "Gurnee",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IL",
    state: "Illinois",
    difficulty: "classic",
    pools: ["world","North America","US","US-IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-il-038",
    lat: 41.654825,
    lng: -88.070028,
    panoId: "H0dCFpNLvi2O8MJx2s5QLA",
    place: "Near Romeoville, Illinois",
    shortName: "Romeoville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IL",
    state: "Illinois",
    difficulty: "classic",
    pools: ["world","North America","US","US-IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-il-039",
    lat: 40.584478,
    lng: -89.645248,
    panoId: "1WWlZbpVpjAzyaVUTyuxRg",
    place: "Near Pekin, Illinois",
    shortName: "Pekin",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IL",
    state: "Illinois",
    difficulty: "classic",
    pools: ["world","North America","US","US-IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-il-040",
    lat: 39.920984,
    lng: -91.397408,
    panoId: "VxkxKjZt_b9NWb-68yJ2Hg",
    place: "Near Quincy, Illinois",
    shortName: "Quincy",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IL",
    state: "Illinois",
    difficulty: "classic",
    pools: ["world","North America","US","US-IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-il-041",
    lat: 40.486964,
    lng: -89.011658,
    panoId: "-PbJXcK3Vz0ru14Lly8pOg",
    place: "Near Bloomington, Illinois",
    shortName: "Bloomington",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IL",
    state: "Illinois",
    difficulty: "classic",
    pools: ["world","North America","US","US-IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-il-042",
    lat: 40.099893,
    lng: -88.226955,
    panoId: "ZfkNvAzZd-vu2XY0NhSKtA",
    place: "Near Urbana, Illinois",
    shortName: "Urbana",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IL",
    state: "Illinois",
    difficulty: "classic",
    pools: ["world","North America","US","US-IL"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-il-043",
    lat: 39.783693,
    lng: -89.644051,
    panoId: "Nn_58UTJBooujiLiwm1bFA",
    place: "Near Springfield, Illinois",
    shortName: "Springfield",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IL",
    state: "Illinois",
    difficulty: "classic",
    pools: ["world","North America","US","US-IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-il-044",
    lat: 42.361803,
    lng: -87.832591,
    panoId: "0F3h0E4loDjzszwbGEYVBw",
    place: "Near Waukegan, Illinois",
    shortName: "Waukegan",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IL",
    state: "Illinois",
    difficulty: "classic",
    pools: ["world","North America","US","US-IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-il-045",
    lat: 41.759685,
    lng: -88.342524,
    panoId: "iMvoxgo2xwT0W-_ZT2GUnw",
    place: "Near Aurora, Illinois",
    shortName: "Aurora",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IL",
    state: "Illinois",
    difficulty: "classic",
    pools: ["world","North America","US","US-IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-il-046",
    lat: 42.229693,
    lng: -88.305442,
    panoId: "lIGug_UljjCvfi_2X5lBeg",
    place: "Near Crystal Lake, Illinois",
    shortName: "Crystal Lake",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IL",
    state: "Illinois",
    difficulty: "classic",
    pools: ["world","North America","US","US-IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-il-047",
    lat: 40.701347,
    lng: -89.582257,
    panoId: "7IQcIHZj93aYZkXYroDGGg",
    place: "Near Peoria, Illinois",
    shortName: "Peoria",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IL",
    state: "Illinois",
    difficulty: "classic",
    pools: ["world","North America","US","US-IL"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-il-048",
    lat: 41.869908,
    lng: -87.638624,
    panoId: "QaZgYNrzqpmAzTOMzkY7tg",
    place: "Near Chicago Loop, Illinois",
    shortName: "Chicago Loop",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IL",
    state: "Illinois",
    difficulty: "classic",
    pools: ["world","North America","US","US-IL"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-il-049",
    lat: 38.535901,
    lng: -89.986631,
    panoId: "bez4DmARUCLjmJnTHQEdTQ",
    place: "Near Swansea, Illinois",
    shortName: "Swansea",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IL",
    state: "Illinois",
    difficulty: "classic",
    pools: ["world","North America","US","US-IL"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-il-050",
    lat: 40.558923,
    lng: -88.997491,
    panoId: "rL_UEV0GtoRUKok86jpiow",
    place: "Near Normal, Illinois",
    shortName: "Normal",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IL",
    state: "Illinois",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-il-051",
    lat: 42.165113,
    lng: -88.047558,
    panoId: "l6yk6BRfdI1Mn3LRZSawqA",
    place: "Near Kildeer, Illinois",
    shortName: "Kildeer",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IL",
    state: "Illinois",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-il-052",
    lat: 41.629821,
    lng: -88.268551,
    panoId: "JyIB8H-pFSLwh-HC6XpPXQ",
    place: "Near Plainfield, Illinois",
    shortName: "Plainfield",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IL",
    state: "Illinois",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-il-053",
    lat: 41.547919,
    lng: -90.495159,
    panoId: "b-FIprrsi7-57UygU8YyRA",
    place: "Near Bettendorf, Illinois",
    shortName: "Bettendorf",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IL",
    state: "Illinois",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-il-054",
    lat: 41.968287,
    lng: -88.738702,
    panoId: "y9KvGh-x39iWXSD0DcN-mw",
    place: "Near DeKalb, Illinois",
    shortName: "DeKalb",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IL",
    state: "Illinois",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-il-055",
    lat: 38.504874,
    lng: -89.941379,
    panoId: "H-KICApzSxAJJ8yKFEdCVw",
    place: "Near Belleville, Illinois",
    shortName: "Belleville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IL",
    state: "Illinois",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-il-056",
    lat: 41.508212,
    lng: -90.633187,
    panoId: "b1EzInyzwmEnnCeTSUTzGA",
    place: "Near Rock Island, Illinois",
    shortName: "Rock Island",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IL",
    state: "Illinois",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-il-057",
    lat: 41.659211,
    lng: -88.269496,
    panoId: "ashc56affgaTBHCWMkzOFA",
    place: "Near Plainfield, Illinois",
    shortName: "Plainfield",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IL",
    state: "Illinois",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-il-058",
    lat: 39.878405,
    lng: -88.898128,
    panoId: "vyTDVxtV3SAvolAibqHFEg",
    place: "Near Decatur, Illinois",
    shortName: "Decatur",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IL",
    state: "Illinois",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-il-059",
    lat: 41.955839,
    lng: -88.148586,
    panoId: "d7mBCTyUi-7Ave5vr8hSDQ",
    place: "Near Hanover Park, Illinois",
    shortName: "Hanover Park",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IL",
    state: "Illinois",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-il-060",
    lat: 40.632361,
    lng: -89.547832,
    panoId: "X_EVHNGRdZR_FhzevkOM_A",
    place: "Near Creve Coeur, Illinois",
    shortName: "Creve Coeur",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IL",
    state: "Illinois",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-il-061",
    lat: 40.926719,
    lng: -90.299006,
    panoId: "u60VFvNz32zhakFc4HbLwg",
    place: "Near Knoxville, Illinois",
    shortName: "Knoxville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IL",
    state: "Illinois",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-il-062",
    lat: 40.128508,
    lng: -87.686189,
    panoId: "cvTqPyauIX7NVjYB6BSW0w",
    place: "Near Danville, Illinois",
    shortName: "Danville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IL",
    state: "Illinois",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-il-063",
    lat: 41.983646,
    lng: -88.737407,
    panoId: "BAGdV-yAZgsrbO_dsM7izA",
    place: "Near Sycamore, Illinois",
    shortName: "Sycamore",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IL",
    state: "Illinois",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-il-064",
    lat: 42.014543,
    lng: -88.011182,
    panoId: "5iOpSMfDKuQK2mERmDvj_w",
    place: "Near Elk Grove Village, Illinois",
    shortName: "Elk Grove Village",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IL",
    state: "Illinois",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-il-065",
    lat: 39.759927,
    lng: -89.60008,
    panoId: "V4SYLehjn_p90y2KOzagsw",
    place: "Near Southern View, Illinois",
    shortName: "Southern View",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IL",
    state: "Illinois",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-il-066",
    lat: 39.988003,
    lng: -91.449682,
    panoId: "ybGNtjIL506P6b6BP5nBvg",
    place: "Near Quincy, Illinois",
    shortName: "Quincy",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IL",
    state: "Illinois",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IL"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "us-il-067",
    lat: 41.560452,
    lng: -88.207702,
    panoId: "sQnK2RS1nZBvj4pRYeUXsw",
    place: "Near Crystal Lawns, Illinois",
    shortName: "Crystal Lawns",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IL",
    state: "Illinois",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-il-068",
    lat: 41.866002,
    lng: -88.256021,
    panoId: "AQihLvqSAQhgq7ckul8GZQ",
    place: "Near Geneva, Illinois",
    shortName: "Geneva",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IL",
    state: "Illinois",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-il-069",
    lat: 40.461717,
    lng: -88.966901,
    panoId: "Y0v43x8tGkOIVTHHISZa0A",
    place: "Near Bloomington, Illinois",
    shortName: "Bloomington",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IL",
    state: "Illinois",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IL"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-il-070",
    lat: 39.87385,
    lng: -88.96416,
    panoId: "cnlT4O22GOwF4b0FBw70Jg",
    place: "Near Decatur, Illinois",
    shortName: "Decatur",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IL",
    state: "Illinois",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-il-071",
    lat: 41.621657,
    lng: -88.30458,
    panoId: "LHxaneboMH6t-5po01lbAw",
    place: "Near Oswego, Illinois",
    shortName: "Oswego",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IL",
    state: "Illinois",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-il-072",
    lat: 41.788221,
    lng: -88.254947,
    panoId: "rG8AqvFONDXrpLnc153sjw",
    place: "Near Aurora, Illinois",
    shortName: "Aurora",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IL",
    state: "Illinois",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-il-073",
    lat: 40.645527,
    lng: -89.522981,
    panoId: "Tc8Qc9_dH04VPYHKT9vaKg",
    place: "Near East Peoria, Illinois",
    shortName: "East Peoria",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IL",
    state: "Illinois",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-il-074",
    lat: 41.999301,
    lng: -88.02667,
    panoId: "zFeuZ8iy6uwVeHIw9vJZuw",
    place: "Near Medinah, Illinois",
    shortName: "Medinah",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IL",
    state: "Illinois",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IL"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-il-075",
    lat: 42.22131,
    lng: -89.079151,
    panoId: "PvZX7BeqPWYPrVewrfRXhQ",
    place: "Near Rockford, Illinois",
    shortName: "Rockford",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IL",
    state: "Illinois",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-il-076",
    lat: 41.501934,
    lng: -88.059217,
    panoId: "kLDxpgJByBfYYoEDw9FOqQ",
    place: "Near Preston Heights, Illinois",
    shortName: "Preston Heights",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IL",
    state: "Illinois",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-il-077",
    lat: 39.009324,
    lng: -90.044622,
    panoId: "F0sHSVN-VRhCVtvQBWq0cg",
    place: "Near Bunker Hill, Illinois",
    shortName: "Bunker Hill",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IL",
    state: "Illinois",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-il-078",
    lat: 42.310932,
    lng: -88.028734,
    panoId: "VTcil20SYo4BCEtyY0Mmdw",
    place: "Near Grayslake, Illinois",
    shortName: "Grayslake",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IL",
    state: "Illinois",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-il-079",
    lat: 41.716136,
    lng: -87.536488,
    panoId: "Z8y9qiXME-fBoXY-X94eXw",
    place: "Near South Chicago, Illinois",
    shortName: "South Chicago",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IL",
    state: "Illinois",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-il-080",
    lat: 40.52279,
    lng: -89.747114,
    panoId: "i7TtuXxZJrn3MLF-XgFfbQ",
    place: "Near Glasford, Illinois",
    shortName: "Glasford",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IL",
    state: "Illinois",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-il-081",
    lat: 38.827916,
    lng: -90.092366,
    panoId: "ff5AAJdZQAGOrk0BowHYyQ",
    place: "Near Hartford, Illinois",
    shortName: "Hartford",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IL",
    state: "Illinois",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IL"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-il-082",
    lat: 42.44396,
    lng: -88.289257,
    panoId: "MW3nXBr5xPiABMX_VCNmhQ",
    place: "Near Richmond, Illinois",
    shortName: "Richmond",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IL",
    state: "Illinois",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-il-083",
    lat: 42.20445,
    lng: -88.135102,
    panoId: "uuUEkcRghe8Lt09i_uUviA",
    place: "Near North Barrington, Illinois",
    shortName: "North Barrington",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IL",
    state: "Illinois",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-il-084",
    lat: 42.244493,
    lng: -88.259684,
    panoId: "FBJ-aa-MezR1lcl2LYvOwQ",
    place: "Near Oakwood Hills, Illinois",
    shortName: "Oakwood Hills",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IL",
    state: "Illinois",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-il-085",
    lat: 42.403906,
    lng: -88.779062,
    panoId: "04IwU9OdGIydPazT-GWXkw",
    place: "Near Capron, Illinois",
    shortName: "Capron",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IL",
    state: "Illinois",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-il-086",
    lat: 39.043153,
    lng: -90.18051,
    panoId: "4jjqH_7OqdJoB3J-8uzNQA",
    place: "Near Brighton, Illinois",
    shortName: "Brighton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IL",
    state: "Illinois",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IL"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "us-il-087",
    lat: 40.010951,
    lng: -88.442064,
    panoId: "LEvlmL73HIPFRBlfXFeb_A",
    place: "Near Monticello, Illinois",
    shortName: "Monticello",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IL",
    state: "Illinois",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-il-088",
    lat: 42.067062,
    lng: -88.097102,
    panoId: "1SA13HMJPeSMVvlcP1YCPg",
    place: "Near Hoffman Estates, Illinois",
    shortName: "Hoffman Estates",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IL",
    state: "Illinois",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-il-089",
    lat: 41.849879,
    lng: -88.047231,
    panoId: "NGwVxm2m9cQeJA8SFCRo3w",
    place: "Near Glen Ellyn, Illinois",
    shortName: "Glen Ellyn",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IL",
    state: "Illinois",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IL"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-il-090",
    lat: 39.886432,
    lng: -89.671001,
    panoId: "hu5SYb6NVHrnV82g0ZoGsw",
    place: "Near Sherman, Illinois",
    shortName: "Sherman",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IL",
    state: "Illinois",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-il-091",
    lat: 38.494055,
    lng: -90.010688,
    panoId: "ejeMzErlzIO1b9mfyZc9Ng",
    place: "Near Belleville, Illinois",
    shortName: "Belleville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IL",
    state: "Illinois",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-il-092",
    lat: 40.691932,
    lng: -89.773236,
    panoId: "D6KcU1Pe09BnPWsX7A6F-w",
    place: "Near Hanna City, Illinois",
    shortName: "Hanna City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IL",
    state: "Illinois",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-il-093",
    lat: 41.910295,
    lng: -88.172915,
    panoId: "2l-1fK-l3wxwnq59IgDHFg",
    place: "Near Carol Stream, Illinois",
    shortName: "Carol Stream",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IL",
    state: "Illinois",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-il-094",
    lat: 41.367449,
    lng: -87.872765,
    panoId: "I7mS22Q3cmFoxjDWifBoaw",
    place: "Near Peotone, Illinois",
    shortName: "Peotone",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IL",
    state: "Illinois",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-il-095",
    lat: 41.798433,
    lng: -88.483852,
    panoId: "myQaCZgm0fMq0S57COKf3A",
    place: "Near Sugar Grove, Illinois",
    shortName: "Sugar Grove",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IL",
    state: "Illinois",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-il-096",
    lat: 38.467132,
    lng: -90.135318,
    panoId: "_bv9worpH5cEB4Jcuoehkg",
    place: "Near Millstadt, Illinois",
    shortName: "Millstadt",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IL",
    state: "Illinois",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-il-097",
    lat: 42.179084,
    lng: -88.181747,
    panoId: "0RRvEuyLSPapt1fXvF5twA",
    place: "Near Cuba, Illinois",
    shortName: "Cuba",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IL",
    state: "Illinois",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-il-098",
    lat: 42.4585,
    lng: -88.860438,
    panoId: "a80cGJEwhsPkdXzvPgb_KQ",
    place: "Near Poplar Grove, Illinois",
    shortName: "Poplar Grove",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IL",
    state: "Illinois",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-il-099",
    lat: 42.317993,
    lng: -88.900559,
    panoId: "7ORhaQ0DYV3nSy0oBsDrSg",
    place: "Near Belvidere, Illinois",
    shortName: "Belvidere",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IL",
    state: "Illinois",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-il-100",
    lat: 38.862858,
    lng: -89.776832,
    panoId: "aHnDzI3-O0WmYrXqIuSedQ",
    place: "Near Worden, Illinois",
    shortName: "Worden",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IL",
    state: "Illinois",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-il-101",
    lat: 40.838099,
    lng: -90.255265,
    panoId: "I_oZFrQSdmsOpEBX1rUpjA",
    place: "Near Knoxville, Illinois",
    shortName: "Knoxville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IL",
    state: "Illinois",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-il-102",
    lat: 41.120841,
    lng: -87.602601,
    panoId: "Z3e9r2nc9xTzrMn3WdzrKQ",
    place: "Near Momence, Illinois",
    shortName: "Momence",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IL",
    state: "Illinois",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-il-103",
    lat: 39.977537,
    lng: -87.569695,
    panoId: "uaifJpSPiKMsMFWdHYG1FQ",
    place: "Near Georgetown, Illinois",
    shortName: "Georgetown",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IL",
    state: "Illinois",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-il-104",
    lat: 39.094097,
    lng: -90.183076,
    panoId: "aElmdTiFILrbtnmYKfrtdA",
    place: "Near Brighton, Illinois",
    shortName: "Brighton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IL",
    state: "Illinois",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-il-105",
    lat: 37.620479,
    lng: -89.394109,
    panoId: "TuaNBz8IUWJQPA9PFjNhXw",
    place: "Near Cobden, Illinois",
    shortName: "Cobden",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IL",
    state: "Illinois",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-in-000",
    lat: 40.105112,
    lng: -85.68028,
    panoId: "nUn_Nx3dHHBpHBz-l21RRg",
    place: "Near Anderson, Indiana",
    shortName: "Anderson",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IN",
    state: "Indiana",
    difficulty: "classic",
    pools: ["world","North America","US","US-IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-in-001",
    lat: 37.975439,
    lng: -87.555783,
    panoId: "jBhV-47qbGr6avt0Ss1dsA",
    place: "Near Evansville, Indiana",
    shortName: "Evansville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IN",
    state: "Indiana",
    difficulty: "classic",
    pools: ["world","North America","US","US-IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-in-002",
    lat: 41.582266,
    lng: -85.834419,
    panoId: "iPxYjVb14rsBxW8I1KXNpw",
    place: "Near Goshen, Indiana",
    shortName: "Goshen",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IN",
    state: "Indiana",
    difficulty: "classic",
    pools: ["world","North America","US","US-IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-in-003",
    lat: 41.66213,
    lng: -86.158645,
    panoId: "e2WPTTYfkWuF6TD7bMcREw",
    place: "Near Mishawaka, Indiana",
    shortName: "Mishawaka",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IN",
    state: "Indiana",
    difficulty: "classic",
    pools: ["world","North America","US","US-IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-in-004",
    lat: 39.767958,
    lng: -86.158005,
    panoId: "03E3gzIeKBrJyD2ZzBc8dA",
    place: "Near Indianapolis, Indiana",
    shortName: "Indianapolis",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IN",
    state: "Indiana",
    difficulty: "classic",
    pools: ["world","North America","US","US-IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-in-005",
    lat: 38.285615,
    lng: -85.824067,
    panoId: "zHytwJ1wsYdbeYB7kN2-CA",
    place: "Near New Albany, Indiana",
    shortName: "New Albany",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IN",
    state: "Indiana",
    difficulty: "classic",
    pools: ["world","North America","US","US-IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-in-006",
    lat: 40.486452,
    lng: -86.133551,
    panoId: "eaUbtdOlIssubcnhI8tgGw",
    place: "Near Kokomo, Indiana",
    shortName: "Kokomo",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IN",
    state: "Indiana",
    difficulty: "classic",
    pools: ["world","North America","US","US-IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-in-007",
    lat: 40.558802,
    lng: -85.659126,
    panoId: "NParPQZcg7uhFvP_0pHa2g",
    place: "Near Marion, Indiana",
    shortName: "Marion",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IN",
    state: "Indiana",
    difficulty: "classic",
    pools: ["world","North America","US","US-IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-in-008",
    lat: 41.753385,
    lng: -86.111,
    panoId: "i7tN-0OoSYJdQX3myN3GeA",
    place: "Near Granger, Indiana",
    shortName: "Granger",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IN",
    state: "Indiana",
    difficulty: "classic",
    pools: ["world","North America","US","US-IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-in-009",
    lat: 41.130537,
    lng: -85.129344,
    panoId: "sTneOeHDPftmv8cLSDG1-g",
    place: "Near Fort Wayne, Indiana",
    shortName: "Fort Wayne",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IN",
    state: "Indiana",
    difficulty: "classic",
    pools: ["world","North America","US","US-IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-in-010",
    lat: 39.480563,
    lng: -86.054943,
    panoId: "qLpmVCeHfCjUBn9_EQ1JqQ",
    place: "Near Franklin, Indiana",
    shortName: "Franklin",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IN",
    state: "Indiana",
    difficulty: "classic",
    pools: ["world","North America","US","US-IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-in-011",
    lat: 38.959193,
    lng: -85.89027,
    panoId: "usn8-WhtertRjv8Agze8wQ",
    place: "Near Seymour, Indiana",
    shortName: "Seymour",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IN",
    state: "Indiana",
    difficulty: "classic",
    pools: ["world","North America","US","US-IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-in-012",
    lat: 39.828988,
    lng: -84.890213,
    panoId: "YElRELqvhlhlrmidx2SlFg",
    place: "Near Richmond, Indiana",
    shortName: "Richmond",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IN",
    state: "Indiana",
    difficulty: "classic",
    pools: ["world","North America","US","US-IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-in-013",
    lat: 40.045602,
    lng: -86.008655,
    panoId: "Apv3siZBNb2EIoS0Cm_OhQ",
    place: "Near Noblesville, Indiana",
    shortName: "Noblesville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IN",
    state: "Indiana",
    difficulty: "classic",
    pools: ["world","North America","US","US-IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-in-014",
    lat: 41.473106,
    lng: -87.061166,
    panoId: "Aegy128mdyJUnvtYRVu_HA",
    place: "Near Valparaiso, Indiana",
    shortName: "Valparaiso",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IN",
    state: "Indiana",
    difficulty: "classic",
    pools: ["world","North America","US","US-IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-in-015",
    lat: 41.68317,
    lng: -86.249989,
    panoId: "WMZgg25xL4XERwuiyC9m7w",
    place: "Near South Bend, Indiana",
    shortName: "South Bend",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IN",
    state: "Indiana",
    difficulty: "classic",
    pools: ["world","North America","US","US-IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-in-016",
    lat: 40.416924,
    lng: -86.875002,
    panoId: "DnDIK-Ih-VeECFnqJNP2qQ",
    place: "Near Lafayette, Indiana",
    shortName: "Lafayette",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IN",
    state: "Indiana",
    difficulty: "classic",
    pools: ["world","North America","US","US-IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-in-017",
    lat: 39.165582,
    lng: -86.526573,
    panoId: "A-_X3vSMHol0lNrIZd1BOA",
    place: "Near Bloomington, Indiana",
    shortName: "Bloomington",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IN",
    state: "Indiana",
    difficulty: "classic",
    pools: ["world","North America","US","US-IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-in-018",
    lat: 40.754387,
    lng: -86.356672,
    panoId: "X_-P2sidT0me6CFKPq_MfA",
    place: "Near Logansport, Indiana",
    shortName: "Logansport",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IN",
    state: "Indiana",
    difficulty: "classic",
    pools: ["world","North America","US","US-IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-in-019",
    lat: 41.532262,
    lng: -87.255011,
    panoId: "oxI2zvetkzPMDZm_6jBYoA",
    place: "Near Hobart, Indiana",
    shortName: "Hobart",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IN",
    state: "Indiana",
    difficulty: "classic",
    pools: ["world","North America","US","US-IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-in-020",
    lat: 41.478931,
    lng: -87.454746,
    panoId: "tvHc2G1ahEye5qVjyXzjLA",
    place: "Near Schererville, Indiana",
    shortName: "Schererville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IN",
    state: "Indiana",
    difficulty: "classic",
    pools: ["world","North America","US","US-IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-in-021",
    lat: 40.425855,
    lng: -86.908098,
    panoId: "NIv5vMG-BSXbEbaTAVuuAg",
    place: "Near West Lafayette, Indiana",
    shortName: "West Lafayette",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IN",
    state: "Indiana",
    difficulty: "classic",
    pools: ["world","North America","US","US-IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-in-022",
    lat: 38.277272,
    lng: -85.737807,
    panoId: "n5-ytlzbE-xaoZaFDskqpg",
    place: "Near Jeffersonville, Indiana",
    shortName: "Jeffersonville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IN",
    state: "Indiana",
    difficulty: "classic",
    pools: ["world","North America","US","US-IN"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-in-023",
    lat: 41.482535,
    lng: -87.332903,
    panoId: "otjP4FoRdExPk0DvyWlGfw",
    place: "Near Merrillville, Indiana",
    shortName: "Merrillville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IN",
    state: "Indiana",
    difficulty: "classic",
    pools: ["world","North America","US","US-IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-in-024",
    lat: 39.521479,
    lng: -85.777009,
    panoId: "dVITXCCRaj74UOSHA4KLoA",
    place: "Near Shelbyville, Indiana",
    shortName: "Shelbyville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IN",
    state: "Indiana",
    difficulty: "classic",
    pools: ["world","North America","US","US-IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-in-025",
    lat: 39.20138,
    lng: -85.921416,
    panoId: "b8g3IFovlNf0zPsDSl9OQg",
    place: "Near Columbus, Indiana",
    shortName: "Columbus",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IN",
    state: "Indiana",
    difficulty: "classic",
    pools: ["world","North America","US","US-IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-in-026",
    lat: 41.416941,
    lng: -87.365448,
    panoId: "s17BS4DHGSBg9lzC5-tQxg",
    place: "Near Crown Point, Indiana",
    shortName: "Crown Point",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IN",
    state: "Indiana",
    difficulty: "classic",
    pools: ["world","North America","US","US-IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-in-027",
    lat: 39.928903,
    lng: -85.370277,
    panoId: "FQSQTioNYwEK2urZaxUKrw",
    place: "Near New Castle, Indiana",
    shortName: "New Castle",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IN",
    state: "Indiana",
    difficulty: "classic",
    pools: ["world","North America","US","US-IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-in-028",
    lat: 41.707541,
    lng: -86.895101,
    panoId: "VYwVkEbFFDZz1UghQtiMrQ",
    place: "Near Michigan City, Indiana",
    shortName: "Michigan City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IN",
    state: "Indiana",
    difficulty: "classic",
    pools: ["world","North America","US","US-IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-in-029",
    lat: 41.575889,
    lng: -87.176198,
    panoId: "QPTZoaN8cwyZ6tDB2nb5sw",
    place: "Near Portage, Indiana",
    shortName: "Portage",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IN",
    state: "Indiana",
    difficulty: "classic",
    pools: ["world","North America","US","US-IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-in-030",
    lat: 39.466731,
    lng: -87.413842,
    panoId: "hQT3jm7w6afqw3e7R321fg",
    place: "Near Terre Haute, Indiana",
    shortName: "Terre Haute",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IN",
    state: "Indiana",
    difficulty: "classic",
    pools: ["world","North America","US","US-IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-in-031",
    lat: 40.193345,
    lng: -85.386517,
    panoId: "bv0-8GF3FaUizxDmMEARdQ",
    place: "Near Muncie, Indiana",
    shortName: "Muncie",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IN",
    state: "Indiana",
    difficulty: "classic",
    pools: ["world","North America","US","US-IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-in-032",
    lat: 38.67723,
    lng: -87.52861,
    panoId: "lPNzvy3iwl3hYaxiK2q1Dw",
    place: "Near Vincennes, Indiana",
    shortName: "Vincennes",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IN",
    state: "Indiana",
    difficulty: "classic",
    pools: ["world","North America","US","US-IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-in-033",
    lat: 41.607788,
    lng: -86.714171,
    panoId: "w4qPdwX6oc2q9k1SvLZ7sw",
    place: "Near La Porte, Indiana",
    shortName: "La Porte",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IN",
    state: "Indiana",
    difficulty: "classic",
    pools: ["world","North America","US","US-IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-in-034",
    lat: 39.785064,
    lng: -85.769294,
    panoId: "mhb9wUNEHscZU5pFVPUsQQ",
    place: "Near Greenfield, Indiana",
    shortName: "Greenfield",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IN",
    state: "Indiana",
    difficulty: "classic",
    pools: ["world","North America","US","US-IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-in-035",
    lat: 41.681668,
    lng: -85.976513,
    panoId: "fmuxX_MpLDTMyiBYW9_4uQ",
    place: "Near Elkhart, Indiana",
    shortName: "Elkhart",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IN",
    state: "Indiana",
    difficulty: "classic",
    pools: ["world","North America","US","US-IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-in-036",
    lat: 41.494174,
    lng: -87.521756,
    panoId: "lLAohbxdaErjt6f2NVj-2g",
    place: "Near Dyer, Indiana",
    shortName: "Dyer",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IN",
    state: "Indiana",
    difficulty: "classic",
    pools: ["world","North America","US","US-IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-in-037",
    lat: 40.279496,
    lng: -86.510683,
    panoId: "64vzS0ZPPbhpJPJ3_wfzmA",
    place: "Near Frankfort, Indiana",
    shortName: "Frankfort",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IN",
    state: "Indiana",
    difficulty: "classic",
    pools: ["world","North America","US","US-IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-in-038",
    lat: 41.528211,
    lng: -87.423624,
    panoId: "CQ8K0asTeA2NFmHNE1_peg",
    place: "Near Griffith, Indiana",
    shortName: "Griffith",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IN",
    state: "Indiana",
    difficulty: "classic",
    pools: ["world","North America","US","US-IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-in-039",
    lat: 40.883011,
    lng: -85.49754,
    panoId: "F0CVdUwfhVznhx5cDBsa-g",
    place: "Near Huntington, Indiana",
    shortName: "Huntington",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IN",
    state: "Indiana",
    difficulty: "classic",
    pools: ["world","North America","US","US-IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-in-040",
    lat: 38.277684,
    lng: -85.841745,
    panoId: "MftrWAWsfqS5ALR-pwfN1A",
    place: "Near New Albany, Indiana",
    shortName: "New Albany",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IN",
    state: "Indiana",
    difficulty: "classic",
    pools: ["world","North America","US","US-IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-in-041",
    lat: 39.179857,
    lng: -86.514652,
    panoId: "iygQWT29V369YEmtI8WudQ",
    place: "Near Bloomington, Indiana",
    shortName: "Bloomington",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IN",
    state: "Indiana",
    difficulty: "classic",
    pools: ["world","North America","US","US-IN"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "us-in-042",
    lat: 39.482677,
    lng: -87.41204,
    panoId: "cQp7skHdu-dzIK5gjtof0g",
    place: "Near Terre Haute, Indiana",
    shortName: "Terre Haute",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IN",
    state: "Indiana",
    difficulty: "classic",
    pools: ["world","North America","US","US-IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-in-043",
    lat: 41.485778,
    lng: -87.471555,
    panoId: "vt0jLy74Os59NzfQ9Rc4sQ",
    place: "Near Schererville, Indiana",
    shortName: "Schererville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IN",
    state: "Indiana",
    difficulty: "classic",
    pools: ["world","North America","US","US-IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-in-044",
    lat: 38.960607,
    lng: -85.865453,
    panoId: "e5xRfsWy1OR3R41v7HnVew",
    place: "Near Seymour, Indiana",
    shortName: "Seymour",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IN",
    state: "Indiana",
    difficulty: "classic",
    pools: ["world","North America","US","US-IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-in-045",
    lat: 41.463299,
    lng: -87.324497,
    panoId: "bh7q2vClO4sVR5cZguX0DQ",
    place: "Near Merrillville, Indiana",
    shortName: "Merrillville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IN",
    state: "Indiana",
    difficulty: "classic",
    pools: ["world","North America","US","US-IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-in-046",
    lat: 41.671672,
    lng: -85.965574,
    panoId: "18--TxrciTOT49-eqpqqhw",
    place: "Near Elkhart, Indiana",
    shortName: "Elkhart",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IN",
    state: "Indiana",
    difficulty: "classic",
    pools: ["world","North America","US","US-IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-in-047",
    lat: 39.816209,
    lng: -84.909504,
    panoId: "2YcTiK1j4o87YjaMOYiLeg",
    place: "Near Richmond, Indiana",
    shortName: "Richmond",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IN",
    state: "Indiana",
    difficulty: "classic",
    pools: ["world","North America","US","US-IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-in-048",
    lat: 39.467116,
    lng: -86.039205,
    panoId: "iKKPDIDx6hkLpscwHgLZ8w",
    place: "Near Franklin, Indiana",
    shortName: "Franklin",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IN",
    state: "Indiana",
    difficulty: "classic",
    pools: ["world","North America","US","US-IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-in-049",
    lat: 41.405688,
    lng: -87.357269,
    panoId: "bRjVlnH5K0riP9V_LykKSA",
    place: "Near Crown Point, Indiana",
    shortName: "Crown Point",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IN",
    state: "Indiana",
    difficulty: "classic",
    pools: ["world","North America","US","US-IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-in-050",
    lat: 41.46834,
    lng: -87.105746,
    panoId: "_pPDG6zNg_GMmm5xurSgYw",
    place: "Near Shorewood Forest, Indiana",
    shortName: "Shorewood Forest",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IN",
    state: "Indiana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-in-051",
    lat: 40.144329,
    lng: -85.661016,
    panoId: "kUNflyu-i7gpXFjuuZwLpg",
    place: "Near Anderson, Indiana",
    shortName: "Anderson",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IN",
    state: "Indiana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-in-052",
    lat: 40.322676,
    lng: -86.436961,
    panoId: "3ltnV4bJoYD39dPi3bzaYg",
    place: "Near Frankfort, Indiana",
    shortName: "Frankfort",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IN",
    state: "Indiana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-in-053",
    lat: 39.570693,
    lng: -85.761901,
    panoId: "-NBtqbfKLIvaGutoCdt_vA",
    place: "Near Shelbyville, Indiana",
    shortName: "Shelbyville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IN",
    state: "Indiana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-in-054",
    lat: 39.982459,
    lng: -85.328663,
    panoId: "HI75sqfIHcReXHYLV_Pitw",
    place: "Near New Castle, Indiana",
    shortName: "New Castle",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IN",
    state: "Indiana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-in-055",
    lat: 41.633422,
    lng: -86.202159,
    panoId: "lcqj-zzbJRPlkinKDQOwBA",
    place: "Near Gulivoire Park, Indiana",
    shortName: "Gulivoire Park",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IN",
    state: "Indiana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-in-056",
    lat: 40.019088,
    lng: -85.957478,
    panoId: "7UCiAXaTVJ_je1hjaPYH-g",
    place: "Near Noblesville, Indiana",
    shortName: "Noblesville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IN",
    state: "Indiana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-in-057",
    lat: 40.561323,
    lng: -85.578022,
    panoId: "ZFglQ5h-jwliTaugMQpplA",
    place: "Near Marion, Indiana",
    shortName: "Marion",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IN",
    state: "Indiana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-in-058",
    lat: 41.611486,
    lng: -85.89198,
    panoId: "bgL1IR4hzPb3vYBtLIh8Rg",
    place: "Near Dunlap, Indiana",
    shortName: "Dunlap",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IN",
    state: "Indiana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-in-059",
    lat: 40.51248,
    lng: -86.150989,
    panoId: "42uTFj6dDwRcLiGL3X2a6A",
    place: "Near Kokomo, Indiana",
    shortName: "Kokomo",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IN",
    state: "Indiana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IN"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-in-060",
    lat: 41.709772,
    lng: -86.14407,
    panoId: "80O-gfUtaz8KjdD_k2KiJw",
    place: "Near Mishawaka, Indiana",
    shortName: "Mishawaka",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IN",
    state: "Indiana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-in-061",
    lat: 39.243829,
    lng: -85.960094,
    panoId: "AhECkD6GLBOThm-7p1pNDQ",
    place: "Near Columbus, Indiana",
    shortName: "Columbus",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IN",
    state: "Indiana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-in-062",
    lat: 41.665677,
    lng: -86.847851,
    panoId: "ap46JRI3UjhKFbmIv_pPUg",
    place: "Near Trail Creek, Indiana",
    shortName: "Trail Creek",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IN",
    state: "Indiana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-in-063",
    lat: 41.174086,
    lng: -85.112558,
    panoId: "qEHohbiOArDcGLBOqK9iDw",
    place: "Near Fort Wayne, Indiana",
    shortName: "Fort Wayne",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IN",
    state: "Indiana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-in-064",
    lat: 41.663565,
    lng: -86.665517,
    panoId: "qB-L-o3eGKP2Xumuuu_8uA",
    place: "Near La Porte, Indiana",
    shortName: "La Porte",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IN",
    state: "Indiana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-in-065",
    lat: 41.43862,
    lng: -87.540959,
    panoId: "RsQkN-MEaKV2p9h6V6CVQQ",
    place: "Near Willowbrook, Indiana",
    shortName: "Willowbrook",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IN",
    state: "Indiana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-in-066",
    lat: 39.767878,
    lng: -86.089409,
    panoId: "WxJT4THAFg1TotjvIhn54A",
    place: "Near Warren Park, Indiana",
    shortName: "Warren Park",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IN",
    state: "Indiana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-in-067",
    lat: 40.361001,
    lng: -86.827234,
    panoId: "iewDt5qlJ6FGuzL99h8cgw",
    place: "Near Dayton, Indiana",
    shortName: "Dayton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IN",
    state: "Indiana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-in-068",
    lat: 39.492694,
    lng: -87.363782,
    panoId: "n52nqsb4tryATx17leUC9w",
    place: "Near North Terre Haute, Indiana",
    shortName: "North Terre Haute",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IN",
    state: "Indiana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-in-069",
    lat: 39.772068,
    lng: -85.811309,
    panoId: "GRoU0UiLo5f9fldkFY5ozg",
    place: "Near Greenfield, Indiana",
    shortName: "Greenfield",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IN",
    state: "Indiana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-in-070",
    lat: 41.499271,
    lng: -87.009383,
    panoId: "y-KcwbfYv7SSegciKu4EfQ",
    place: "Near Valparaiso, Indiana",
    shortName: "Valparaiso",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IN",
    state: "Indiana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-in-071",
    lat: 39.2129,
    lng: -86.491153,
    panoId: "DtVvJNbR-NwowMQccfHIIg",
    place: "Near Bloomington, Indiana",
    shortName: "Bloomington",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IN",
    state: "Indiana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-in-072",
    lat: 40.798456,
    lng: -86.314163,
    panoId: "OUA9Q79R42TqxfCFK8N8uw",
    place: "Near Logansport, Indiana",
    shortName: "Logansport",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IN",
    state: "Indiana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-in-073",
    lat: 41.635747,
    lng: -86.146051,
    panoId: "rzPnC45NCkwUCOLRwygSYQ",
    place: "Near Mishawaka, Indiana",
    shortName: "Mishawaka",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IN",
    state: "Indiana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-in-074",
    lat: 39.960544,
    lng: -85.296346,
    panoId: "i2j6r2Bd8m4CYlhvwb60fw",
    place: "Near New Castle, Indiana",
    shortName: "New Castle",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IN",
    state: "Indiana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-in-075",
    lat: 40.461997,
    lng: -86.980642,
    panoId: "24nBPUGyKpL_lg5zHks_5A",
    place: "Near West Lafayette, Indiana",
    shortName: "West Lafayette",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IN",
    state: "Indiana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-in-076",
    lat: 41.668662,
    lng: -86.860401,
    panoId: "3nlCNfKJ5U2URCzLGsJC-A",
    place: "Near Trail Creek, Indiana",
    shortName: "Trail Creek",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IN",
    state: "Indiana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-in-077",
    lat: 39.491737,
    lng: -85.773985,
    panoId: "PkBB9reLburI3BdJoBESCQ",
    place: "Near Shelbyville, Indiana",
    shortName: "Shelbyville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IN",
    state: "Indiana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-in-078",
    lat: 41.515034,
    lng: -87.18933,
    panoId: "6STuBD5-F2noEsmjq7x0Dg",
    place: "Near South Haven, Indiana",
    shortName: "South Haven",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IN",
    state: "Indiana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-in-079",
    lat: 40.840189,
    lng: -85.527595,
    panoId: "XOnGrVeIrbP0ixhAO9O3rg",
    place: "Near Huntington, Indiana",
    shortName: "Huntington",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IN",
    state: "Indiana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-in-080",
    lat: 40.332142,
    lng: -86.561426,
    panoId: "CIi0uS_ISlT5jh-mNLb-eA",
    place: "Near Frankfort, Indiana",
    shortName: "Frankfort",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IN",
    state: "Indiana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-in-081",
    lat: 41.095715,
    lng: -85.193548,
    panoId: "xKge2gXKBDdL1Gr4224YSA",
    place: "Near Fort Wayne, Indiana",
    shortName: "Fort Wayne",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IN",
    state: "Indiana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-in-082",
    lat: 41.435939,
    lng: -87.558481,
    panoId: "-U_Qxyi_xV-xUCRncduv7Q",
    place: "Near Willowbrook, Indiana",
    shortName: "Willowbrook",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IN",
    state: "Indiana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-in-083",
    lat: 39.199701,
    lng: -85.972334,
    panoId: "-MD21jRbuui_uQZeLbqC2Q",
    place: "Near Columbus, Indiana",
    shortName: "Columbus",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IN",
    state: "Indiana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-in-084",
    lat: 39.025616,
    lng: -85.904402,
    panoId: "Z4iZQZvYZ8u_housLeZx0w",
    place: "Near Seymour, Indiana",
    shortName: "Seymour",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IN",
    state: "Indiana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-in-085",
    lat: 39.457463,
    lng: -86.004075,
    panoId: "-JhmoaP5QtKzoT6x-cu7oA",
    place: "Near Franklin, Indiana",
    shortName: "Franklin",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IN",
    state: "Indiana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-in-086",
    lat: 41.807907,
    lng: -86.164534,
    panoId: "0aEI-8Rx6lufZO30WLJCBA",
    place: "Near Edwardsburg, Indiana",
    shortName: "Edwardsburg",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IN",
    state: "Indiana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-in-087",
    lat: 40.145084,
    lng: -85.442574,
    panoId: "UGZ6EDqGKaLwColY4yfnng",
    place: "Near Yorktown, Indiana",
    shortName: "Yorktown",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IN",
    state: "Indiana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-in-088",
    lat: 41.53616,
    lng: -87.362917,
    panoId: "04mZot5o8IWkH4tQ_1awKA",
    place: "Near Griffith, Indiana",
    shortName: "Griffith",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IN",
    state: "Indiana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-in-089",
    lat: 41.54827,
    lng: -85.866775,
    panoId: "uuK1RE8-UxjIY7PQgv3RTw",
    place: "Near Goshen, Indiana",
    shortName: "Goshen",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IN",
    state: "Indiana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IN"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-in-090",
    lat: 41.326716,
    lng: -87.565772,
    panoId: "_JKgA4C7QeqMzYoE1EMubQ",
    place: "Near Beecher, Indiana",
    shortName: "Beecher",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IN",
    state: "Indiana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-in-091",
    lat: 40.6552,
    lng: -86.042792,
    panoId: "b68fiwRrFFDOCN9_GkwELA",
    place: "Near Grissom Air Force Base, Indiana",
    shortName: "Grissom Air Force Base",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IN",
    state: "Indiana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-in-092",
    lat: 40.658675,
    lng: -85.657786,
    panoId: "IMzEFxRUHnvYucJDDlP3AQ",
    place: "Near Marion, Indiana",
    shortName: "Marion",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IN",
    state: "Indiana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-in-093",
    lat: 40.785772,
    lng: -85.911279,
    panoId: "BkNA8ND18B0ydvUjoltcRg",
    place: "Near Wabash, Indiana",
    shortName: "Wabash",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IN",
    state: "Indiana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-in-094",
    lat: 40.070427,
    lng: -86.871054,
    panoId: "brzP2nM46qegYQEQ6zUb5A",
    place: "Near Crawfordsville, Indiana",
    shortName: "Crawfordsville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IN",
    state: "Indiana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-in-095",
    lat: 40.317106,
    lng: -86.745079,
    panoId: "2Y2xHnkHXJbOUkbnkI7u5w",
    place: "Near Dayton, Indiana",
    shortName: "Dayton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IN",
    state: "Indiana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-in-096",
    lat: 40.692144,
    lng: -86.442558,
    panoId: "jN5KZ11BCeecjCiwPWQ-nA",
    place: "Near Georgetown, Indiana",
    shortName: "Georgetown",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IN",
    state: "Indiana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-in-097",
    lat: 39.742104,
    lng: -86.330854,
    panoId: "SHgj42Do8YxJkgYfaMDeNg",
    place: "Near Avon, Indiana",
    shortName: "Avon",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IN",
    state: "Indiana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-in-098",
    lat: 38.421539,
    lng: -86.824104,
    panoId: "xx8ASR6LVCIsnKl-PYGRvw",
    place: "Near Jasper, Indiana",
    shortName: "Jasper",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IN",
    state: "Indiana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-in-099",
    lat: 41.593831,
    lng: -86.041117,
    panoId: "F7sWzUS4eafkhYefoTRO6A",
    place: "Near Wakarusa, Indiana",
    shortName: "Wakarusa",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IN",
    state: "Indiana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IN"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-in-100",
    lat: 38.751782,
    lng: -85.156606,
    panoId: "Btp5yNJK8XGeBj2psyQqhA",
    place: "Near Vevay, Indiana",
    shortName: "Vevay",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IN",
    state: "Indiana",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-in-101",
    lat: 38.849695,
    lng: -87.437733,
    panoId: "Bihxi6_e-TteAOEY6u6flA",
    place: "Near Bicknell, Indiana",
    shortName: "Bicknell",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IN",
    state: "Indiana",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-in-102",
    lat: 40.989219,
    lng: -85.171563,
    panoId: "lYvz5dV8phEuLXShTm5-3w",
    place: "Near Ossian, Indiana",
    shortName: "Ossian",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IN",
    state: "Indiana",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-IN"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-in-103",
    lat: 38.771461,
    lng: -86.280725,
    panoId: "5xBMdZ8emGIxZWfc84sckg",
    place: "Near Mitchell, Indiana",
    shortName: "Mitchell",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IN",
    state: "Indiana",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-in-104",
    lat: 39.89391,
    lng: -86.764291,
    panoId: "teMeuDn9VPZ49XJms-vMwA",
    place: "Near Crawfordsville, Indiana",
    shortName: "Crawfordsville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IN",
    state: "Indiana",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-in-105",
    lat: 39.345317,
    lng: -87.196544,
    panoId: "FRU1el7ZurNcf_wfXgcf4Q",
    place: "Near Middlebury, Indiana",
    shortName: "Middlebury",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IN",
    state: "Indiana",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ia-000",
    lat: 41.577309,
    lng: -93.711288,
    panoId: "gkGNnIHDAH-3EqCByA1kpg",
    place: "Near West Des Moines, Iowa",
    shortName: "West Des Moines",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IA",
    state: "Iowa",
    difficulty: "classic",
    pools: ["world","North America","US","US-IA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ia-001",
    lat: 42.059631,
    lng: -93.880186,
    panoId: "8Zw4-5evwYhoWD_uFCPw6w",
    place: "Near Boone, Iowa",
    shortName: "Boone",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IA",
    state: "Iowa",
    difficulty: "classic",
    pools: ["world","North America","US","US-IA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ia-002",
    lat: 41.729625,
    lng: -93.605813,
    panoId: "L3zl0dlL2T0GUMqsNMM1Yw",
    place: "Near Ankeny, Iowa",
    shortName: "Ankeny",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IA",
    state: "Iowa",
    difficulty: "classic",
    pools: ["world","North America","US","US-IA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ia-003",
    lat: 41.523534,
    lng: -90.577694,
    panoId: "TfPwCETv14uFJTfUszL7rg",
    place: "Near Davenport, Iowa",
    shortName: "Davenport",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IA",
    state: "Iowa",
    difficulty: "classic",
    pools: ["world","North America","US","US-IA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ia-004",
    lat: 42.5277,
    lng: -92.44549,
    panoId: "l87FRnkb8Mv2qXpqSVI60Q",
    place: "Near Cedar Falls, Iowa",
    shortName: "Cedar Falls",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IA",
    state: "Iowa",
    difficulty: "classic",
    pools: ["world","North America","US","US-IA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ia-005",
    lat: 42.008313,
    lng: -91.643974,
    panoId: "4922WQQBUoy2QdCd-BqxIg",
    place: "Near Cedar Rapids, Iowa",
    shortName: "Cedar Rapids",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IA",
    state: "Iowa",
    difficulty: "classic",
    pools: ["world","North America","US","US-IA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ia-006",
    lat: 41.603043,
    lng: -93.724249,
    panoId: "ynMV0jWveiU5XXdIK1-SMQ",
    place: "Near Clive, Iowa",
    shortName: "Clive",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IA",
    state: "Iowa",
    difficulty: "classic",
    pools: ["world","North America","US","US-IA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ia-007",
    lat: 41.673091,
    lng: -93.69769,
    panoId: "0rInLRWznfcppWs3gfW6Tg",
    place: "Near Johnston, Iowa",
    shortName: "Johnston",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IA",
    state: "Iowa",
    difficulty: "classic",
    pools: ["world","North America","US","US-IA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ia-008",
    lat: 41.611765,
    lng: -93.885164,
    panoId: "7GPhubIT64JrHH2YNl-HMw",
    place: "Near Waukee, Iowa",
    shortName: "Waukee",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IA",
    state: "Iowa",
    difficulty: "classic",
    pools: ["world","North America","US","US-IA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ia-009",
    lat: 42.500194,
    lng: -96.400372,
    panoId: "58QQvF2Zy7SFsd2FplMT6Q",
    place: "Near Sioux City, Iowa",
    shortName: "Sioux City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IA",
    state: "Iowa",
    difficulty: "classic",
    pools: ["world","North America","US","US-IA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ia-010",
    lat: 42.500544,
    lng: -90.66459,
    panoId: "NTiMppYK8qqZX-r-8T1jMw",
    place: "Near Dubuque, Iowa",
    shortName: "Dubuque",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IA",
    state: "Iowa",
    difficulty: "classic",
    pools: ["world","North America","US","US-IA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ia-011",
    lat: 41.296246,
    lng: -92.644409,
    panoId: "FESdqRs0RFz7hTdD44U7lQ",
    place: "Near Oskaloosa, Iowa",
    shortName: "Oskaloosa",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IA",
    state: "Iowa",
    difficulty: "classic",
    pools: ["world","North America","US","US-IA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ia-012",
    lat: 41.600437,
    lng: -93.609173,
    panoId: "l7HfQ49R5dz5pvAhXBEV1g",
    place: "Near Des Moines, Iowa",
    shortName: "Des Moines",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IA",
    state: "Iowa",
    difficulty: "classic",
    pools: ["world","North America","US","US-IA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ia-013",
    lat: 41.844498,
    lng: -90.188694,
    panoId: "qWjYG3OOmGWzS_3EbL-HhQ",
    place: "Near Clinton, Iowa",
    shortName: "Clinton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IA",
    state: "Iowa",
    difficulty: "classic",
    pools: ["world","North America","US","US-IA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ia-014",
    lat: 41.749178,
    lng: -91.597913,
    panoId: "r3mxUPYT2FDeqDPyChPmnw",
    place: "Near North Liberty, Iowa",
    shortName: "North Liberty",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IA",
    state: "Iowa",
    difficulty: "classic",
    pools: ["world","North America","US","US-IA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ia-015",
    lat: 41.261925,
    lng: -95.860828,
    panoId: "KHeHjwCtmd-w8FKFXrJYCw",
    place: "Near Council Bluffs, Iowa",
    shortName: "Council Bluffs",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IA",
    state: "Iowa",
    difficulty: "classic",
    pools: ["world","North America","US","US-IA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ia-016",
    lat: 41.644111,
    lng: -93.464599,
    panoId: "TF7TeAzfREmGCY8SmOZa7Q",
    place: "Near Altoona, Iowa",
    shortName: "Altoona",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IA",
    state: "Iowa",
    difficulty: "classic",
    pools: ["world","North America","US","US-IA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ia-017",
    lat: 41.42423,
    lng: -91.043597,
    panoId: "SGVtWSbSPQSyN54lDnNmYw",
    place: "Near Muscatine, Iowa",
    shortName: "Muscatine",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IA",
    state: "Iowa",
    difficulty: "classic",
    pools: ["world","North America","US","US-IA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ia-018",
    lat: 41.019999,
    lng: -92.411244,
    panoId: "8ZnMeYKQAFxQU5DFf4qQcQ",
    place: "Near Ottumwa, Iowa",
    shortName: "Ottumwa",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IA",
    state: "Iowa",
    difficulty: "classic",
    pools: ["world","North America","US","US-IA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ia-019",
    lat: 40.807569,
    lng: -91.112922,
    panoId: "CCdviIgweb9w42fASbr1QQ",
    place: "Near Burlington, Iowa",
    shortName: "Burlington",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IA",
    state: "Iowa",
    difficulty: "classic",
    pools: ["world","North America","US","US-IA"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-ia-020",
    lat: 42.034192,
    lng: -91.597718,
    panoId: "oYjlAT_MYa01kGbswKXBAQ",
    place: "Near Marion, Iowa",
    shortName: "Marion",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IA",
    state: "Iowa",
    difficulty: "classic",
    pools: ["world","North America","US","US-IA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ia-021",
    lat: 41.524425,
    lng: -90.515758,
    panoId: "qY2ZdV-pB2-s0JUngl1xZg",
    place: "Near Bettendorf, Iowa",
    shortName: "Bettendorf",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IA",
    state: "Iowa",
    difficulty: "classic",
    pools: ["world","North America","US","US-IA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ia-022",
    lat: 43.14135,
    lng: -95.144483,
    panoId: "hFj9RjTNv8FNy4IWNBlWrA",
    place: "Near Spencer, Iowa",
    shortName: "Spencer",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IA",
    state: "Iowa",
    difficulty: "classic",
    pools: ["world","North America","US","US-IA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ia-023",
    lat: 41.661143,
    lng: -91.530166,
    panoId: "C9QBADtjhV5kXfSKMYluMA",
    place: "Near Iowa City, Iowa",
    shortName: "Iowa City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IA",
    state: "Iowa",
    difficulty: "classic",
    pools: ["world","North America","US","US-IA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ia-024",
    lat: 41.676437,
    lng: -91.58043,
    panoId: "Wt5fNqnQCkyg7nD5i8nJ2Q",
    place: "Near Coralville, Iowa",
    shortName: "Coralville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IA",
    state: "Iowa",
    difficulty: "classic",
    pools: ["world","North America","US","US-IA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ia-025",
    lat: 42.49752,
    lng: -94.168033,
    panoId: "aZ7Z1j0Cn77Ffz5aXpMb7w",
    place: "Near Fort Dodge, Iowa",
    shortName: "Fort Dodge",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IA",
    state: "Iowa",
    difficulty: "classic",
    pools: ["world","North America","US","US-IA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ia-026",
    lat: 42.049449,
    lng: -92.908036,
    panoId: "zZ1DvHBrgH7Y7MN167K99Q",
    place: "Near Marshalltown, Iowa",
    shortName: "Marshalltown",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IA",
    state: "Iowa",
    difficulty: "classic",
    pools: ["world","North America","US","US-IA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ia-027",
    lat: 41.358273,
    lng: -93.557377,
    panoId: "MXm8n9joGzfYww9cFR-o-g",
    place: "Near Indianola, Iowa",
    shortName: "Indianola",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IA",
    state: "Iowa",
    difficulty: "classic",
    pools: ["world","North America","US","US-IA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ia-028",
    lat: 43.153534,
    lng: -93.20108,
    panoId: "ya2Qfk1ipZJHIglGp9HPxA",
    place: "Near Mason City, Iowa",
    shortName: "Mason City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IA",
    state: "Iowa",
    difficulty: "classic",
    pools: ["world","North America","US","US-IA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ia-029",
    lat: 41.688312,
    lng: -93.791057,
    panoId: "RA4qbas9SyUDg7RIe134Jw",
    place: "Near Grimes, Iowa",
    shortName: "Grimes",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IA",
    state: "Iowa",
    difficulty: "classic",
    pools: ["world","North America","US","US-IA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ia-030",
    lat: 41.699584,
    lng: -93.047964,
    panoId: "qKcCGMPzO8rMr5Osm26v7A",
    place: "Near Newton, Iowa",
    shortName: "Newton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IA",
    state: "Iowa",
    difficulty: "classic",
    pools: ["world","North America","US","US-IA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ia-031",
    lat: 42.641112,
    lng: -95.209927,
    panoId: "XYIrYp8LqKsxIpOCYnDxnA",
    place: "Near Storm Lake, Iowa",
    shortName: "Storm Lake",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IA",
    state: "Iowa",
    difficulty: "classic",
    pools: ["world","North America","US","US-IA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ia-032",
    lat: 41.626692,
    lng: -93.712214,
    panoId: "bP-SnsCTulpgeV-U5fPi_g",
    place: "Near Urbandale, Iowa",
    shortName: "Urbandale",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IA",
    state: "Iowa",
    difficulty: "classic",
    pools: ["world","North America","US","US-IA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ia-033",
    lat: 42.492903,
    lng: -92.342773,
    panoId: "syYIhMia6X71DFrklakm2Q",
    place: "Near Waterloo, Iowa",
    shortName: "Waterloo",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IA",
    state: "Iowa",
    difficulty: "classic",
    pools: ["world","North America","US","US-IA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ia-034",
    lat: 40.629718,
    lng: -91.315383,
    panoId: "W1wSm35Ztzr5VCwiMTO6CQ",
    place: "Near Fort Madison, Iowa",
    shortName: "Fort Madison",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IA",
    state: "Iowa",
    difficulty: "classic",
    pools: ["world","North America","US","US-IA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ia-035",
    lat: 40.397269,
    lng: -91.384903,
    panoId: "-Y0PLWiEbEI96RoFXgKVGQ",
    place: "Near Keokuk, Iowa",
    shortName: "Keokuk",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IA",
    state: "Iowa",
    difficulty: "classic",
    pools: ["world","North America","US","US-IA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ia-036",
    lat: 41.475575,
    lng: -93.678853,
    panoId: "B5z_gjtgyV5Sx2d8WWulvA",
    place: "Near Norwalk, Iowa",
    shortName: "Norwalk",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IA",
    state: "Iowa",
    difficulty: "classic",
    pools: ["world","North America","US","US-IA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ia-037",
    lat: 42.725741,
    lng: -92.475499,
    panoId: "zlPCq5ZfLD58iIDAGUrXdQ",
    place: "Near Waverly, Iowa",
    shortName: "Waverly",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IA",
    state: "Iowa",
    difficulty: "classic",
    pools: ["world","North America","US","US-IA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ia-038",
    lat: 41.038323,
    lng: -92.4071,
    panoId: "gENhGiL_wmt7h6zqn9YLog",
    place: "Near Ottumwa, Iowa",
    shortName: "Ottumwa",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IA",
    state: "Iowa",
    difficulty: "classic",
    pools: ["world","North America","US","US-IA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ia-039",
    lat: 42.034512,
    lng: -93.619935,
    panoId: "IXQQWqdovddiJt-7Ei8w7A",
    place: "Near Ames, Iowa",
    shortName: "Ames",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IA",
    state: "Iowa",
    difficulty: "classic",
    pools: ["world","North America","US","US-IA"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-ia-040",
    lat: 41.408058,
    lng: -92.916349,
    panoId: "7qHonV6T4W_UWKHAkCdbbA",
    place: "Near Pella, Iowa",
    shortName: "Pella",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IA",
    state: "Iowa",
    difficulty: "classic",
    pools: ["world","North America","US","US-IA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ia-041",
    lat: 40.818377,
    lng: -91.115601,
    panoId: "jvXzJAZfMgYT_dFt-q5yxA",
    place: "Near Burlington, Iowa",
    shortName: "Burlington",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IA",
    state: "Iowa",
    difficulty: "classic",
    pools: ["world","North America","US","US-IA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ia-042",
    lat: 41.652758,
    lng: -93.699123,
    panoId: "rtSt8UgbqI7iMhJlAYG1DA",
    place: "Near Johnston, Iowa",
    shortName: "Johnston",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IA",
    state: "Iowa",
    difficulty: "classic",
    pools: ["world","North America","US","US-IA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ia-043",
    lat: 41.533959,
    lng: -90.497561,
    panoId: "uEOr4RdpXnFmC1OiVflBtQ",
    place: "Near Bettendorf, Iowa",
    shortName: "Bettendorf",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IA",
    state: "Iowa",
    difficulty: "classic",
    pools: ["world","North America","US","US-IA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ia-044",
    lat: 43.159564,
    lng: -95.142898,
    panoId: "p5PV_OD8RzMCPHrcN6wGgw",
    place: "Near Spencer, Iowa",
    shortName: "Spencer",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IA",
    state: "Iowa",
    difficulty: "classic",
    pools: ["world","North America","US","US-IA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ia-045",
    lat: 42.000273,
    lng: -91.651418,
    panoId: "TYpT86JoOaYi5-4CXZGBJA",
    place: "Near Cedar Rapids, Iowa",
    shortName: "Cedar Rapids",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IA",
    state: "Iowa",
    difficulty: "classic",
    pools: ["world","North America","US","US-IA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ia-046",
    lat: 42.065857,
    lng: -93.856576,
    panoId: "C85uMUA36466sGEaVvs96Q",
    place: "Near Boone, Iowa",
    shortName: "Boone",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IA",
    state: "Iowa",
    difficulty: "classic",
    pools: ["world","North America","US","US-IA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ia-047",
    lat: 41.590933,
    lng: -93.698499,
    panoId: "9fvQTfs6cQWQ7Dv7FkBhAQ",
    place: "Near Windsor Heights, Iowa",
    shortName: "Windsor Heights",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IA",
    state: "Iowa",
    difficulty: "classic",
    pools: ["world","North America","US","US-IA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ia-048",
    lat: 41.609909,
    lng: -93.746909,
    panoId: "H6CPz7ViQcdQkCRT_plANQ",
    place: "Near Clive, Iowa",
    shortName: "Clive",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IA",
    state: "Iowa",
    difficulty: "classic",
    pools: ["world","North America","US","US-IA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ia-049",
    lat: 41.61808,
    lng: -93.606527,
    panoId: "PaBGO0ONFyvvZZ3yl-b_7w",
    place: "Near Des Moines, Iowa",
    shortName: "Des Moines",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IA",
    state: "Iowa",
    difficulty: "classic",
    pools: ["world","North America","US","US-IA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ia-050",
    lat: 41.292866,
    lng: -95.87688,
    panoId: "1ZlhjmAj7SU5ajcEnJ1XDg",
    place: "Near Carter Lake, Iowa",
    shortName: "Carter Lake",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IA",
    state: "Iowa",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ia-051",
    lat: 41.651991,
    lng: -93.746991,
    panoId: "lO_UywpdRJQf4p_pm9fapA",
    place: "Near Urbandale, Iowa",
    shortName: "Urbandale",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IA",
    state: "Iowa",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ia-052",
    lat: 42.473207,
    lng: -96.321893,
    panoId: "ITiMEq1yMFHcgAFNEOqzjQ",
    place: "Near Sioux City, Iowa",
    shortName: "Sioux City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IA",
    state: "Iowa",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ia-053",
    lat: 43.133273,
    lng: -93.122313,
    panoId: "hqul97veVHBeSWd_co2l1g",
    place: "Near Mason City, Iowa",
    shortName: "Mason City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IA",
    state: "Iowa",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ia-054",
    lat: 41.419954,
    lng: -93.558515,
    panoId: "cfU0WIf4lGyjiW0B2OLOCA",
    place: "Near Indianola, Iowa",
    shortName: "Indianola",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IA",
    state: "Iowa",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ia-055",
    lat: 42.530188,
    lng: -94.135725,
    panoId: "f1hBCv8x0Lrrd8m052kjXw",
    place: "Near Fort Dodge, Iowa",
    shortName: "Fort Dodge",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IA",
    state: "Iowa",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ia-056",
    lat: 41.619339,
    lng: -93.419429,
    panoId: "PBqyuO--FeXty4sBxx843g",
    place: "Near Altoona, Iowa",
    shortName: "Altoona",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IA",
    state: "Iowa",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ia-057",
    lat: 41.579613,
    lng: -90.546357,
    panoId: "rFcQCBiwkakRHpyHz8QqTQ",
    place: "Near Bettendorf, Iowa",
    shortName: "Bettendorf",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IA",
    state: "Iowa",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ia-058",
    lat: 41.721139,
    lng: -93.774793,
    panoId: "bnZQVT8m-H5yOe0PtZuAXg",
    place: "Near Grimes, Iowa",
    shortName: "Grimes",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IA",
    state: "Iowa",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ia-059",
    lat: 42.617326,
    lng: -95.269782,
    panoId: "WlMCzeD4FayORI2h5PnR4g",
    place: "Near Storm Lake, Iowa",
    shortName: "Storm Lake",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IA",
    state: "Iowa",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ia-060",
    lat: 41.621745,
    lng: -91.544955,
    panoId: "O9vKSt9rHDIVuC4B8zUQfw",
    place: "Near University Heights, Iowa",
    shortName: "University Heights",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IA",
    state: "Iowa",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ia-061",
    lat: 40.579969,
    lng: -91.245021,
    panoId: "TEwT-8XtmXTSKVy3Jt18Fg",
    place: "Near Fort Madison, Iowa",
    shortName: "Fort Madison",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IA",
    state: "Iowa",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ia-062",
    lat: 42.456936,
    lng: -92.420316,
    panoId: "lnMnA2mVKnLKVw9Z0J9ELg",
    place: "Near Hudson, Iowa",
    shortName: "Hudson",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IA",
    state: "Iowa",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ia-063",
    lat: 40.354959,
    lng: -91.373418,
    panoId: "2xI5JQhJ0uNLUl3GhmvTFg",
    place: "Near Keokuk, Iowa",
    shortName: "Keokuk",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IA",
    state: "Iowa",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ia-064",
    lat: 42.080328,
    lng: -91.619046,
    panoId: "2lzcLtV5k1Qw96xELI9Ggw",
    place: "Near Robins, Iowa",
    shortName: "Robins",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IA",
    state: "Iowa",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ia-065",
    lat: 41.640252,
    lng: -93.035204,
    panoId: "Y1zoedPBxxo7RpkJwvOCww",
    place: "Near Newton, Iowa",
    shortName: "Newton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IA",
    state: "Iowa",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ia-066",
    lat: 42.45917,
    lng: -90.66566,
    panoId: "99Wjy_k1BDvg7aSTqmPnGw",
    place: "Near East Dubuque, Iowa",
    shortName: "East Dubuque",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IA",
    state: "Iowa",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ia-067",
    lat: 41.560574,
    lng: -93.880683,
    panoId: "LPRh6tAFwsJ5FBNNLy6DLQ",
    place: "Near Waukee, Iowa",
    shortName: "Waukee",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IA",
    state: "Iowa",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ia-068",
    lat: 42.003544,
    lng: -92.940633,
    panoId: "r5hZGm4VeeVtfScU6JfpeQ",
    place: "Near Marshalltown, Iowa",
    shortName: "Marshalltown",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IA",
    state: "Iowa",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ia-069",
    lat: 41.77096,
    lng: -93.653853,
    panoId: "lyyjNyzcoBLVSKWPUffe-w",
    place: "Near Polk City, Iowa",
    shortName: "Polk City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IA",
    state: "Iowa",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ia-070",
    lat: 41.072452,
    lng: -92.362699,
    panoId: "dgsJnb5c4dyDLPdnCzkESw",
    place: "Near Ottumwa, Iowa",
    shortName: "Ottumwa",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IA",
    state: "Iowa",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ia-071",
    lat: 41.231339,
    lng: -92.597607,
    panoId: "P_7TYAZJzKEO2WYnijN5ZQ",
    place: "Near Oskaloosa, Iowa",
    shortName: "Oskaloosa",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IA",
    state: "Iowa",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ia-072",
    lat: 42.708497,
    lng: -92.534427,
    panoId: "HCEcYplwkqT-4H2WIGkJ4Q",
    place: "Near Shell Rock, Iowa",
    shortName: "Shell Rock",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IA",
    state: "Iowa",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ia-073",
    lat: 42.046488,
    lng: -93.581523,
    panoId: "8BCA2Z4if3IH_Sdp744TLA",
    place: "Near Ames, Iowa",
    shortName: "Ames",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IA",
    state: "Iowa",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ia-074",
    lat: 41.821584,
    lng: -90.217474,
    panoId: "bxbZSdqBmEEBA-1RfyAQ_w",
    place: "Near Clinton, Iowa",
    shortName: "Clinton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IA",
    state: "Iowa",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ia-075",
    lat: 41.588868,
    lng: -93.762264,
    panoId: "vIJNz4vvxLTN8sVN17KfQA",
    place: "Near Clive, Iowa",
    shortName: "Clive",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IA",
    state: "Iowa",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ia-076",
    lat: 42.058341,
    lng: -93.919202,
    panoId: "e9yUc3J8dd5Ye221zV41_Q",
    place: "Near Boone, Iowa",
    shortName: "Boone",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IA",
    state: "Iowa",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ia-077",
    lat: 41.745513,
    lng: -91.670701,
    panoId: "1cFHHMIH-CNEP-tDM5Vidw",
    place: "Near Tiffin, Iowa",
    shortName: "Tiffin",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IA",
    state: "Iowa",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ia-078",
    lat: 43.183967,
    lng: -95.165732,
    panoId: "VWijNZHUCsoQSATRpRINLg",
    place: "Near Spencer, Iowa",
    shortName: "Spencer",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IA",
    state: "Iowa",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ia-079",
    lat: 41.612576,
    lng: -93.5386,
    panoId: "yweQhso3pCZG2K6euOsJHw",
    place: "Near Pleasant Hill, Iowa",
    shortName: "Pleasant Hill",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IA",
    state: "Iowa",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ia-080",
    lat: 43.145174,
    lng: -93.132338,
    panoId: "CC20CFf4SiMGE8sOaa0pTQ",
    place: "Near Mason City, Iowa",
    shortName: "Mason City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IA",
    state: "Iowa",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ia-081",
    lat: 41.664094,
    lng: -93.607635,
    panoId: "D1NKk7FLCLE5bAkD3kQQNA",
    place: "Near Saylorville, Iowa",
    shortName: "Saylorville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IA",
    state: "Iowa",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ia-082",
    lat: 41.364247,
    lng: -91.016643,
    panoId: "Fx7vzcVn5Cuv-EQIWc_mow",
    place: "Near Muscatine, Iowa",
    shortName: "Muscatine",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IA",
    state: "Iowa",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ia-083",
    lat: 41.279448,
    lng: -95.912679,
    panoId: "bqLv1RVZ7BcWuH9To5zoNw",
    place: "Near Carter Lake, Iowa",
    shortName: "Carter Lake",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IA",
    state: "Iowa",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ia-084",
    lat: 40.793593,
    lng: -91.051276,
    panoId: "4fHXgUJKziwQVy1XL-RBUQ",
    place: "Near Burlington, Iowa",
    shortName: "Burlington",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IA",
    state: "Iowa",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ia-085",
    lat: 41.57054,
    lng: -90.502316,
    panoId: "aJ9RPp437zwuFi6yVFPetg",
    place: "Near Bettendorf, Iowa",
    shortName: "Bettendorf",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IA",
    state: "Iowa",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ia-086",
    lat: 42.074041,
    lng: -91.667837,
    panoId: "Usn4Iv11Rli2cv7Xwv20Bg",
    place: "Near Robins, Iowa",
    shortName: "Robins",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IA",
    state: "Iowa",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ia-087",
    lat: 41.628425,
    lng: -93.797363,
    panoId: "dUZEsKlNtvXpbDp9h3YLNg",
    place: "Near Grimes, Iowa",
    shortName: "Grimes",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IA",
    state: "Iowa",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IA"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-ia-088",
    lat: 41.632765,
    lng: -93.565368,
    panoId: "Pek_3epwM83EqYfBzylixg",
    place: "Near Des Moines, Iowa",
    shortName: "Des Moines",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IA",
    state: "Iowa",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ia-089",
    lat: 42.449081,
    lng: -94.240513,
    panoId: "PZuo2jjXz9M-OXE3i6bZxg",
    place: "Near Fort Dodge, Iowa",
    shortName: "Fort Dodge",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IA",
    state: "Iowa",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ia-090",
    lat: 41.703927,
    lng: -91.518223,
    panoId: "8FbrWw_neWSqAV_Vr1OsBA",
    place: "Near Iowa City, Iowa",
    shortName: "Iowa City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IA",
    state: "Iowa",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ia-091",
    lat: 41.659844,
    lng: -93.930988,
    panoId: "KebTxq_MoaAVcLuKMTjBkQ",
    place: "Near Dallas Center, Iowa",
    shortName: "Dallas Center",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IA",
    state: "Iowa",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ia-092",
    lat: 41.44527,
    lng: -93.019602,
    panoId: "RIvNswzAYzQrCs4JiBFSWA",
    place: "Near Pella, Iowa",
    shortName: "Pella",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IA",
    state: "Iowa",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ia-093",
    lat: 41.589594,
    lng: -93.851759,
    panoId: "u3x5fB8NSSaushj9pUUuHw",
    place: "Near Waukee, Iowa",
    shortName: "Waukee",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IA",
    state: "Iowa",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ia-094",
    lat: 42.485477,
    lng: -92.218817,
    panoId: "rTQArVKiyEdUOX6lSA2nnw",
    place: "Near Elk Run Heights, Iowa",
    shortName: "Elk Run Heights",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IA",
    state: "Iowa",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ia-095",
    lat: 42.009683,
    lng: -90.183649,
    panoId: "Gff574CVKXjkCsxVc9UqWQ",
    place: "Near Savanna, Iowa",
    shortName: "Savanna",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IA",
    state: "Iowa",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ia-096",
    lat: 42.468181,
    lng: -92.09573,
    panoId: "eRuxGnx1MRTZwyBWRa0YIQ",
    place: "Near Jesup, Iowa",
    shortName: "Jesup",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IA",
    state: "Iowa",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ia-097",
    lat: 41.985163,
    lng: -92.804366,
    panoId: "UUfOD4p8bu8oeBMZDsOlWA",
    place: "Near Marshalltown, Iowa",
    shortName: "Marshalltown",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IA",
    state: "Iowa",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ia-098",
    lat: 41.50832,
    lng: -93.5393,
    panoId: "RlgiAXGfWmqVBpb53y2d9Q",
    place: "Near Carlisle, Iowa",
    shortName: "Carlisle",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IA",
    state: "Iowa",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ia-099",
    lat: 41.582428,
    lng: -91.210745,
    panoId: "amBAGAut2wrc0ZXIYqbDaQ",
    place: "Near West Liberty, Iowa",
    shortName: "West Liberty",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IA",
    state: "Iowa",
    difficulty: "explorer",
    pools: ["world","North America","US","US-IA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ia-100",
    lat: 41.234378,
    lng: -92.420181,
    panoId: "AlYoZgAQxtNfPu8125BQSA",
    place: "Near Oskaloosa, Iowa",
    shortName: "Oskaloosa",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IA",
    state: "Iowa",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-IA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ia-101",
    lat: 40.332774,
    lng: -91.63634,
    panoId: "QzTI3d6Rp2YQ0j2rBN74vQ",
    place: "Near Kahoka, Iowa",
    shortName: "Kahoka",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IA",
    state: "Iowa",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-IA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ia-102",
    lat: 40.830412,
    lng: -91.622269,
    panoId: "fOVVs42LMU4u1Pv-ROicIA",
    place: "Near Mount Pleasant, Iowa",
    shortName: "Mount Pleasant",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IA",
    state: "Iowa",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-IA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ia-103",
    lat: 41.848588,
    lng: -94.349201,
    panoId: "OO-OxTkdmCe3cNLrqy4P_g",
    place: "Near Lake Panorama, Iowa",
    shortName: "Lake Panorama",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IA",
    state: "Iowa",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-IA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ia-104",
    lat: 43.489779,
    lng: -94.598834,
    panoId: "aUxpR0_qzTRvM-NAepujKQ",
    place: "Near Sherburn, Iowa",
    shortName: "Sherburn",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IA",
    state: "Iowa",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-IA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ia-105",
    lat: 42.894507,
    lng: -96.343698,
    panoId: "1i-AKOWGGFjTpUPdHiVm0g",
    place: "Near Hawarden, Iowa",
    shortName: "Hawarden",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IA",
    state: "Iowa",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-IA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ia-106",
    lat: 40.681566,
    lng: -93.03858,
    panoId: "h0JMCRyuMSxjm_rfNV-CIQ",
    place: "Near Centerville, Iowa",
    shortName: "Centerville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IA",
    state: "Iowa",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-IA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ia-107",
    lat: 41.335735,
    lng: -93.807113,
    panoId: "ZBW7SE0WbKOKWe7xMXt1FQ",
    place: "Near Buffalo (historical), Iowa",
    shortName: "Buffalo (historical)",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "IA",
    state: "Iowa",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-IA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ks-000",
    lat: 38.953319,
    lng: -94.733538,
    panoId: "TyEcR2-Yr0IWLY_ImQ1DMA",
    place: "Near Lenexa, Kansas",
    shortName: "Lenexa",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "classic",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-ks-001",
    lat: 38.971658,
    lng: -95.235288,
    panoId: "MC5Hwb6Mmwj2zdW_r0T7nQ",
    place: "Near Lawrence, Kansas",
    shortName: "Lawrence",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "classic",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ks-002",
    lat: 37.752792,
    lng: -100.016975,
    panoId: "KzT3DnsGyMu8mAPvgA42xQ",
    place: "Near Dodge City, Kansas",
    shortName: "Dodge City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "classic",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-ks-003",
    lat: 39.023928,
    lng: -94.693531,
    panoId: "Z253FGNkMaw-wXDi_00_vw",
    place: "Near Merriam, Kansas",
    shortName: "Merriam",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "classic",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ks-004",
    lat: 38.046648,
    lng: -97.345109,
    panoId: "0sclGrO6J0r-zxKbvhYY5Q",
    place: "Near Newton, Kansas",
    shortName: "Newton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "classic",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ks-005",
    lat: 38.615554,
    lng: -95.267902,
    panoId: "SVNjZaqtOa0qJlSxFU0Q2g",
    place: "Near Ottawa, Kansas",
    shortName: "Ottawa",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "classic",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-ks-006",
    lat: 37.692242,
    lng: -97.336892,
    panoId: "QolIKiZhOTRCNeYdnFc11A",
    place: "Near Wichita, Kansas",
    shortName: "Wichita",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "classic",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ks-007",
    lat: 37.043109,
    lng: -100.921028,
    panoId: "PRZIN8hvi8Wc_1qBaG-5aA",
    place: "Near Liberal, Kansas",
    shortName: "Liberal",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "classic",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ks-008",
    lat: 37.340509,
    lng: -95.261067,
    panoId: "1htTyxrpwBTGcKcalgk0ZA",
    place: "Near Parsons, Kansas",
    shortName: "Parsons",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "classic",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ks-009",
    lat: 38.840259,
    lng: -97.611471,
    panoId: "4dkUEcTS4xh0yW7Hawi7UQ",
    place: "Near Salina, Kansas",
    shortName: "Salina",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "classic",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ks-010",
    lat: 37.41087,
    lng: -94.704843,
    panoId: "CLST5quKirp5A_HKRZidrQ",
    place: "Near Pittsburg, Kansas",
    shortName: "Pittsburg",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "classic",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ks-011",
    lat: 39.028642,
    lng: -96.831434,
    panoId: "SHJqHI9nBY1XfTv95RbEPg",
    place: "Near Junction City, Kansas",
    shortName: "Junction City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "classic",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ks-012",
    lat: 39.562977,
    lng: -95.121667,
    panoId: "ppkaAIKPSrx5LCmWRTf7sg",
    place: "Near Atchison, Kansas",
    shortName: "Atchison",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "classic",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ks-013",
    lat: 39.311095,
    lng: -94.922026,
    panoId: "c6pdEs6M9oVPDWCqMB0XXw",
    place: "Near Leavenworth, Kansas",
    shortName: "Leavenworth",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "classic",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-ks-014",
    lat: 37.062311,
    lng: -97.038402,
    panoId: "7Qwk4wesbDVNvdIfPsrCPg",
    place: "Near Arkansas City, Kansas",
    shortName: "Arkansas City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "classic",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ks-015",
    lat: 38.992366,
    lng: -94.632927,
    panoId: "dwC1OTFWMskAiM5rJes0BA",
    place: "Near Prairie Village, Kansas",
    shortName: "Prairie Village",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "classic",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-ks-016",
    lat: 38.403807,
    lng: -96.181665,
    panoId: "w7v49EL8TNE8-2kGpW3l1Q",
    place: "Near Emporia, Kansas",
    shortName: "Emporia",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "classic",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ks-017",
    lat: 38.36446,
    lng: -98.764869,
    panoId: "P-NSCpr_OPza3ERrLZLC6A",
    place: "Near Great Bend, Kansas",
    shortName: "Great Bend",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "classic",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ks-018",
    lat: 37.54555,
    lng: -97.26876,
    panoId: "SESZQePmUdvkQZWdcWnjzw",
    place: "Near Derby, Kansas",
    shortName: "Derby",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "classic",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ks-019",
    lat: 39.248597,
    lng: -94.900142,
    panoId: "qaCk95GWP7RVqQYd8meQwQ",
    place: "Near Lansing, Kansas",
    shortName: "Lansing",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "classic",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ks-020",
    lat: 37.971768,
    lng: -100.872684,
    panoId: "qyYK4rxyj-DuGZQA2kUj7Q",
    place: "Near Garden City, Kansas",
    shortName: "Garden City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "classic",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ks-021",
    lat: 38.966793,
    lng: -94.616916,
    panoId: "QhcdjtOxHkxnXCxXcnjojg",
    place: "Near Leawood, Kansas",
    shortName: "Leawood",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "classic",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ks-022",
    lat: 37.817226,
    lng: -96.862314,
    panoId: "v7GVklhW2odTRMSMyElAjg",
    place: "Near El Dorado, Kansas",
    shortName: "El Dorado",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "classic",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ks-023",
    lat: 37.239826,
    lng: -96.99558,
    panoId: "sN0eQGnYkY8I2BPlK8boEw",
    place: "Near Winfield, Kansas",
    shortName: "Winfield",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "classic",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ks-024",
    lat: 39.114573,
    lng: -94.627409,
    panoId: "TSTKrHcHmBZFFNWV_BSxVQ",
    place: "Near Kansas City, Kansas",
    shortName: "Kansas City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "classic",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ks-025",
    lat: 38.881513,
    lng: -94.81919,
    panoId: "cX-6cybhYoCUxviAI4VHUA",
    place: "Near Olathe, Kansas",
    shortName: "Olathe",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "classic",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-ks-026",
    lat: 38.87888,
    lng: -99.326987,
    panoId: "Q9DH_f4rA-iBJ2wZ6TMLHg",
    place: "Near Hays, Kansas",
    shortName: "Hays",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "classic",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ks-027",
    lat: 38.810999,
    lng: -94.927189,
    panoId: "WzBvMJ-yxKdrExyzNS4_QA",
    place: "Near Gardner, Kansas",
    shortName: "Gardner",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "classic",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ks-028",
    lat: 39.183611,
    lng: -96.571687,
    panoId: "vMeXT91hR-HRwLDyQmNnVQ",
    place: "Near Manhattan, Kansas",
    shortName: "Manhattan",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "classic",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ks-029",
    lat: 39.041647,
    lng: -94.719793,
    panoId: "lsJP6z4yIWOAgsBlerOT6g",
    place: "Near Shawnee, Kansas",
    shortName: "Shawnee",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "classic",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ks-030",
    lat: 38.06074,
    lng: -97.929795,
    panoId: "soB8id61gXoPIxPqQbf_qg",
    place: "Near Hutchinson, Kansas",
    shortName: "Hutchinson",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "classic",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ks-031",
    lat: 38.370875,
    lng: -97.664207,
    panoId: "jPUXQT4f-B6Qj02OjSG9lA",
    place: "Near McPherson, Kansas",
    shortName: "McPherson",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "classic",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ks-032",
    lat: 39.049025,
    lng: -95.677725,
    panoId: "ptqDAKVr2KQ_Z1usm6T6bA",
    place: "Near Topeka, Kansas",
    shortName: "Topeka",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "classic",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ks-033",
    lat: 37.564453,
    lng: -97.352229,
    panoId: "o6nDYoXLRGsmD_FF1NsIPA",
    place: "Near Haysville, Kansas",
    shortName: "Haysville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "classic",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ks-034",
    lat: 37.713914,
    lng: -97.136332,
    panoId: "AjwkF97LiQwGTUGYjynDsA",
    place: "Near Andover, Kansas",
    shortName: "Andover",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "classic",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ks-035",
    lat: 38.982326,
    lng: -94.670958,
    panoId: "bGgdG2na-vAITDasJtcDNA",
    place: "Near Overland Park, Kansas",
    shortName: "Overland Park",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "classic",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-ks-036",
    lat: 37.68659,
    lng: -96.976751,
    panoId: "LfIxr9rPKNuFTRCyfv5PFw",
    place: "Near Augusta, Kansas",
    shortName: "Augusta",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "classic",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ks-037",
    lat: 37.03713,
    lng: -95.616387,
    panoId: "ynRdvyvHvJizZOEbki77SA",
    place: "Near Coffeyville, Kansas",
    shortName: "Coffeyville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "classic",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ks-038",
    lat: 39.027687,
    lng: -94.655804,
    panoId: "97NolAb-M8_T7eOShpv_hg",
    place: "Near Mission, Kansas",
    shortName: "Mission",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "classic",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ks-039",
    lat: 37.956323,
    lng: -100.887616,
    panoId: "ziNf1E2zc25HXy0H-pPVrw",
    place: "Near Garden City, Kansas",
    shortName: "Garden City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "classic",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ks-040",
    lat: 38.63091,
    lng: -95.286448,
    panoId: "T3vb5YWQwKOhwEYxqOJrcQ",
    place: "Near Ottawa, Kansas",
    shortName: "Ottawa",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "classic",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ks-041",
    lat: 38.961152,
    lng: -94.743456,
    panoId: "PFn6um31V6iPZiuCzK0YmA",
    place: "Near Lenexa, Kansas",
    shortName: "Lenexa",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "classic",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-ks-042",
    lat: 39.245465,
    lng: -94.919098,
    panoId: "cPqC3oXn2jf5yaXYEyzpBA",
    place: "Near Lansing, Kansas",
    shortName: "Lansing",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "classic",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ks-043",
    lat: 38.953589,
    lng: -94.59316,
    panoId: "Tm4nO6LhJPJkF1XQCfX0GQ",
    place: "Near Leawood, Kansas",
    shortName: "Leawood",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "classic",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ks-044",
    lat: 37.560042,
    lng: -97.271671,
    panoId: "mWGwzqGhhN-CRWCjtWJ4ow",
    place: "Near Derby, Kansas",
    shortName: "Derby",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "classic",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-ks-045",
    lat: 38.804726,
    lng: -94.936622,
    panoId: "v_wDEmPZCA40NMletf6EMQ",
    place: "Near Gardner, Kansas",
    shortName: "Gardner",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "classic",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ks-046",
    lat: 37.224479,
    lng: -97.014091,
    panoId: "Oo2Q4MOSyg0uEWu9XR-H1A",
    place: "Near Winfield, Kansas",
    shortName: "Winfield",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "classic",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ks-047",
    lat: 39.550372,
    lng: -95.138146,
    panoId: "Hdje_l-eQ5fGkq4toPN75Q",
    place: "Near Atchison, Kansas",
    shortName: "Atchison",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "classic",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ks-048",
    lat: 37.815,
    lng: -96.839309,
    panoId: "khhTKSoyFxP1yiLGX4FgAg",
    place: "Near El Dorado, Kansas",
    shortName: "El Dorado",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "classic",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ks-049",
    lat: 37.671811,
    lng: -97.346133,
    panoId: "26zBQQIRzC1b93Mip8TPiw",
    place: "Near Wichita, Kansas",
    shortName: "Wichita",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "classic",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ks-050",
    lat: 38.391328,
    lng: -97.715352,
    panoId: "JX1TVA_2yfZ8_8uFmy-QuQ",
    place: "Near McPherson, Kansas",
    shortName: "McPherson",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ks-051",
    lat: 37.72154,
    lng: -99.996691,
    panoId: "IJRjbMcKz0dPNlHOJdUDsg",
    place: "Near Dodge City, Kansas",
    shortName: "Dodge City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ks-052",
    lat: 37.73785,
    lng: -97.345981,
    panoId: "bpxPhH_UX9fb2PpIS6WGnA",
    place: "Near Wichita, Kansas",
    shortName: "Wichita",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ks-053",
    lat: 37.06874,
    lng: -100.957003,
    panoId: "pWZ2kb7MT5ssonlLs-psIg",
    place: "Near Liberal, Kansas",
    shortName: "Liberal",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-ks-054",
    lat: 38.913589,
    lng: -94.798911,
    panoId: "QlFnRQvjk2LfzNgHaGbsMA",
    place: "Near Olathe, Kansas",
    shortName: "Olathe",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ks-055",
    lat: 39.345985,
    lng: -94.864087,
    panoId: "GBxLxW3vj5p_dAfr0mWQng",
    place: "Near Leavenworth, Kansas",
    shortName: "Leavenworth",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ks-056",
    lat: 39.007677,
    lng: -95.179146,
    panoId: "gp-csCHDT09cZtQM8_1qNA",
    place: "Near Lawrence, Kansas",
    shortName: "Lawrence",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ks-057",
    lat: 39.046726,
    lng: -94.599484,
    panoId: "rzrEW38wy0gRYELBgHEf-A",
    place: "Near Westwood, Kansas",
    shortName: "Westwood",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ks-058",
    lat: 39.010101,
    lng: -95.637573,
    panoId: "BqRQmmq433eTgQjtNeW1Hg",
    place: "Near Topeka, Kansas",
    shortName: "Topeka",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ks-059",
    lat: 38.021245,
    lng: -97.885313,
    panoId: "pGBd1tSUpxOHn0Bw6QQKZA",
    place: "Near South Hutchinson, Kansas",
    shortName: "South Hutchinson",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ks-060",
    lat: 39.094939,
    lng: -94.693344,
    panoId: "p5AzpF8bmqI1DGdBtMj64Q",
    place: "Near Kansas City, Kansas",
    shortName: "Kansas City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ks-061",
    lat: 37.563659,
    lng: -97.435219,
    panoId: "OHnWjZ5lmCdC4RoAXMQraw",
    place: "Near Haysville, Kansas",
    shortName: "Haysville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ks-062",
    lat: 39.192868,
    lng: -96.5254,
    panoId: "fhJzwq_KpHOKZX345NVAUw",
    place: "Near Manhattan, Kansas",
    shortName: "Manhattan",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ks-063",
    lat: 37.006889,
    lng: -97.048669,
    panoId: "DG_WwxJSQiK6SKfP1TjphA",
    place: "Near Arkansas City, Kansas",
    shortName: "Arkansas City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ks-064",
    lat: 38.886304,
    lng: -99.287731,
    panoId: "fy96pZQHrzY3oPvAhwj-vA",
    place: "Near Hays, Kansas",
    shortName: "Hays",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ks-065",
    lat: 37.66674,
    lng: -95.507478,
    panoId: "NN0Qk_1C_0ECUYZozDjowg",
    place: "Near Chanute, Kansas",
    shortName: "Chanute",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ks-066",
    lat: 37.055197,
    lng: -95.647345,
    panoId: "5s_yqoie7VAI3TXKFtmTzg",
    place: "Near Coffeyville, Kansas",
    shortName: "Coffeyville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ks-067",
    lat: 39.048116,
    lng: -96.791831,
    panoId: "JnAViHqGPg80EeXnv0tkIQ",
    place: "Near Grandview Plaza, Kansas",
    shortName: "Grandview Plaza",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ks-068",
    lat: 38.988952,
    lng: -94.705079,
    panoId: "3tDwlMbgOd_g88TXrnGzoQ",
    place: "Near Overland Park, Kansas",
    shortName: "Overland Park",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-ks-069",
    lat: 38.685361,
    lng: -95.248898,
    panoId: "WeFfVYW9q8VYauRwQFNrVw",
    place: "Near Ottawa, Kansas",
    shortName: "Ottawa",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ks-070",
    lat: 38.900835,
    lng: -94.742279,
    panoId: "A_GWkCz6aXfBLda5XO-8vQ",
    place: "Near Lenexa, Kansas",
    shortName: "Lenexa",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ks-071",
    lat: 37.995822,
    lng: -100.822345,
    panoId: "8lwuNgRAxlU5kZ4RjuW1IQ",
    place: "Near Garden City, Kansas",
    shortName: "Garden City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ks-072",
    lat: 37.207509,
    lng: -97.015541,
    panoId: "Z-iZtKYT_W9zccU9F8urkg",
    place: "Near Winfield, Kansas",
    shortName: "Winfield",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ks-073",
    lat: 37.365424,
    lng: -94.705128,
    panoId: "u_qmDP1KYhWNnnpShKBOhQ",
    place: "Near Pittsburg, Kansas",
    shortName: "Pittsburg",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ks-074",
    lat: 38.34777,
    lng: -97.597725,
    panoId: "AT_cEobteDdNH5Sc2xGfWw",
    place: "Near McPherson, Kansas",
    shortName: "McPherson",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ks-075",
    lat: 37.730713,
    lng: -99.939135,
    panoId: "Qvl1mAu3JDqoj0cglphsKA",
    place: "Near Dodge City, Kansas",
    shortName: "Dodge City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ks-076",
    lat: 38.346857,
    lng: -96.161366,
    panoId: "-t9CTeP3CeTZ3PdLfe15hA",
    place: "Near Emporia, Kansas",
    shortName: "Emporia",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ks-077",
    lat: 37.886931,
    lng: -96.877251,
    panoId: "uZMjgEZegoMgz9lkSsE9zw",
    place: "Near El Dorado, Kansas",
    shortName: "El Dorado",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ks-078",
    lat: 37.767013,
    lng: -97.110635,
    panoId: "rH62swPS_1CTZ7P1PZNbbg",
    place: "Near Andover, Kansas",
    shortName: "Andover",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ks-079",
    lat: 38.965339,
    lng: -94.574464,
    panoId: "vO2K6XWS5wCdJhYiCz3xxA",
    place: "Near Leawood, Kansas",
    shortName: "Leawood",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ks-080",
    lat: 39.185232,
    lng: -96.49474,
    panoId: "cSkxFdAzPK7UMrHsuwPc_g",
    place: "Near Manhattan, Kansas",
    shortName: "Manhattan",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ks-081",
    lat: 38.835371,
    lng: -97.557593,
    panoId: "sXY9mBfIi38WzWqR0ZwlSg",
    place: "Near Salina, Kansas",
    shortName: "Salina",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ks-082",
    lat: 37.063624,
    lng: -95.674433,
    panoId: "U5cgRrz8nrhRlW8EZmVlFA",
    place: "Near Coffeyville, Kansas",
    shortName: "Coffeyville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ks-083",
    lat: 36.99349,
    lng: -100.891739,
    panoId: "-BCfhbgE6c1vcbcdEaWxQQ",
    place: "Near Liberal, Kansas",
    shortName: "Liberal",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-ks-084",
    lat: 38.883642,
    lng: -94.897225,
    panoId: "N0w1Ip-lxG-dGDjZQr8BWA",
    place: "Near Olathe, Kansas",
    shortName: "Olathe",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ks-085",
    lat: 37.196122,
    lng: -95.679363,
    panoId: "GX8BQ1kHE4QA6YX6ek77ew",
    place: "Near Independence, Kansas",
    shortName: "Independence",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ks-086",
    lat: 37.491696,
    lng: -97.362779,
    panoId: "KUchiCDa0RipIXlzzlvCtA",
    place: "Near Haysville, Kansas",
    shortName: "Haysville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ks-087",
    lat: 38.333422,
    lng: -98.740021,
    panoId: "_FVXJ9LstjNzpqU461fDlQ",
    place: "Near Great Bend, Kansas",
    shortName: "Great Bend",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ks-088",
    lat: 38.767558,
    lng: -94.95842,
    panoId: "AGtsTxc2k70xKnaZHfe0fQ",
    place: "Near Edgerton, Kansas",
    shortName: "Edgerton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ks-089",
    lat: 37.013075,
    lng: -97.089082,
    panoId: "puxhhcB46av53PDG75s0lw",
    place: "Near Arkansas City, Kansas",
    shortName: "Arkansas City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ks-090",
    lat: 37.209379,
    lng: -97.420577,
    panoId: "aHPGx_gRERQPPWTEODIpUw",
    place: "Near Wellington, Kansas",
    shortName: "Wellington",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ks-091",
    lat: 38.835465,
    lng: -99.262624,
    panoId: "3k-3GToRiebNUi6u3kfcLQ",
    place: "Near Hays, Kansas",
    shortName: "Hays",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ks-092",
    lat: 39.017996,
    lng: -96.891143,
    panoId: "1Lu4pARmxRmY2Vj2ywy4Eg",
    place: "Near Junction City, Kansas",
    shortName: "Junction City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ks-093",
    lat: 39.078439,
    lng: -95.675546,
    panoId: "shd3XwlUA_qbA79xvU8Wfg",
    place: "Near Topeka, Kansas",
    shortName: "Topeka",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ks-094",
    lat: 39.321604,
    lng: -94.975612,
    panoId: "AatsLtSlSVlgbWmKTQc5Lg",
    place: "Near Leavenworth, Kansas",
    shortName: "Leavenworth",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ks-095",
    lat: 37.94126,
    lng: -97.380806,
    panoId: "Yk0F5IcP9nHLsSc1mhHWzQ",
    place: "Near Sedgwick, Kansas",
    shortName: "Sedgwick",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ks-096",
    lat: 39.169404,
    lng: -94.648024,
    panoId: "WGnD00RXqQ7t9QdOec75Eg",
    place: "Near Riverside, Kansas",
    shortName: "Riverside",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ks-097",
    lat: 39.696141,
    lng: -95.143382,
    panoId: "DTxyUKPWXeCUb-zbMh1aLg",
    place: "Near Troy, Kansas",
    shortName: "Troy",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ks-098",
    lat: 39.208649,
    lng: -94.919074,
    panoId: "Aosku8ElZYnZY3tMB7NrHw",
    place: "Near Lansing, Kansas",
    shortName: "Lansing",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ks-099",
    lat: 38.909643,
    lng: -94.56854,
    panoId: "1SQ0mI5pZyYW9BDqgOc8qA",
    place: "Near Grandview, Kansas",
    shortName: "Grandview",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ks-100",
    lat: 38.310974,
    lng: -96.004214,
    panoId: "tnTvXJojTC55Rkg9ZyjCgA",
    place: "Near Emporia, Kansas",
    shortName: "Emporia",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ks-101",
    lat: 37.718214,
    lng: -94.876693,
    panoId: "L3-Mt_dES08qqoECvH2RrA",
    place: "Near Fort Scott, Kansas",
    shortName: "Fort Scott",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ks-102",
    lat: 37.92722,
    lng: -97.15639,
    panoId: "5U_m_BnnCsfZ_Q29x0_tpg",
    place: "Near Kechi, Kansas",
    shortName: "Kechi",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ks-103",
    lat: 39.15576,
    lng: -96.979795,
    panoId: "5GcGbI4v2bzBrh1qf2GQRw",
    place: "Near Fort Riley North, Kansas",
    shortName: "Fort Riley North",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ks-104",
    lat: 37.897683,
    lng: -97.055764,
    panoId: "dHTNtJEiyMFDkfX68IYOXw",
    place: "Near Towanda, Kansas",
    shortName: "Towanda",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ks-105",
    lat: 37.693458,
    lng: -101.253439,
    panoId: "bWZA89Dv5eDHW2-6zHSw3w",
    place: "Near Ulysses, Kansas",
    shortName: "Ulysses",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ks-106",
    lat: 38.861263,
    lng: -95.400059,
    panoId: "iCtUoURxzT-XIONnuFmp3g",
    place: "Near Overbrook, Kansas",
    shortName: "Overbrook",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ks-107",
    lat: 37.113668,
    lng: -97.49297,
    panoId: "xEdrgq5wfUz8ro7d9hdX7A",
    place: "Near Caldwell, Kansas",
    shortName: "Caldwell",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ks-108",
    lat: 39.353884,
    lng: -96.296413,
    panoId: "ZvSMF2zUr5vSU6mfXeeEdw",
    place: "Near Westmoreland, Kansas",
    shortName: "Westmoreland",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ks-109",
    lat: 37.549122,
    lng: -96.600834,
    panoId: "lWv78A20n7AkDn7AFdXGHw",
    place: "Near Clay Center, Kansas",
    shortName: "Clay Center",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ks-110",
    lat: 38.937771,
    lng: -99.039336,
    panoId: "Us0zkIw4Tpl03vWdMDAjZA",
    place: "Near Victoria, Kansas",
    shortName: "Victoria",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ks-111",
    lat: 39.347959,
    lng: -97.294585,
    panoId: "wIsJafQz_q9J9cEDTsFUmA",
    place: "Near Clay Center, Kansas",
    shortName: "Clay Center",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ks-112",
    lat: 38.449538,
    lng: -94.613377,
    panoId: "cO23GOUzbkw45sINodkMOg",
    place: "Near La Cygne, Kansas",
    shortName: "La Cygne",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KS",
    state: "Kansas",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-KS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ky-000",
    lat: 37.880609,
    lng: -84.572925,
    panoId: "AWmmBPxFlYXWSVCI-IZRjw",
    place: "Near Nicholasville, Kentucky",
    shortName: "Nicholasville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KY",
    state: "Kentucky",
    difficulty: "classic",
    pools: ["world","North America","US","US-KY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ky-001",
    lat: 38.200907,
    lng: -84.873318,
    panoId: "RjXUvFKGe6K-yK9ohLMHEw",
    place: "Near Frankfort, Kentucky",
    shortName: "Frankfort",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KY",
    state: "Kentucky",
    difficulty: "classic",
    pools: ["world","North America","US","US-KY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ky-002",
    lat: 38.478389,
    lng: -82.638006,
    panoId: "r79hOdds4xOktU1HMGh8Vw",
    place: "Near Ashland, Kentucky",
    shortName: "Ashland",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KY",
    state: "Kentucky",
    difficulty: "classic",
    pools: ["world","North America","US","US-KY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ky-003",
    lat: 38.049791,
    lng: -84.45871,
    panoId: "RSG94unfnA2ff3GipTTHlA",
    place: "Near Lexington-Fayette, Kentucky",
    shortName: "Lexington-Fayette",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KY",
    state: "Kentucky",
    difficulty: "classic",
    pools: ["world","North America","US","US-KY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ky-004",
    lat: 37.98862,
    lng: -84.477478,
    panoId: "_-ZLXK4uhtGeX2TMRJMrBw",
    place: "Near Lexington, Kentucky",
    shortName: "Lexington",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KY",
    state: "Kentucky",
    difficulty: "classic",
    pools: ["world","North America","US","US-KY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ky-005",
    lat: 38.99896,
    lng: -84.626612,
    panoId: "vIRd2QIPVdb6mzyUrFfR1A",
    place: "Near Florence, Kentucky",
    shortName: "Florence",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KY",
    state: "Kentucky",
    difficulty: "classic",
    pools: ["world","North America","US","US-KY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ky-006",
    lat: 37.809374,
    lng: -85.466982,
    panoId: "0ev6U05oFosi5jiFZOMlaQ",
    place: "Near Bardstown, Kentucky",
    shortName: "Bardstown",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KY",
    state: "Kentucky",
    difficulty: "classic",
    pools: ["world","North America","US","US-KY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ky-007",
    lat: 39.075031,
    lng: -84.447186,
    panoId: "NKjXSuIuyufzqE5eW55vVg",
    place: "Near Fort Thomas, Kentucky",
    shortName: "Fort Thomas",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KY",
    state: "Kentucky",
    difficulty: "classic",
    pools: ["world","North America","US","US-KY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ky-008",
    lat: 37.083349,
    lng: -88.600015,
    panoId: "4Ls76MIkvNGnv0usc7GXZg",
    place: "Near Paducah, Kentucky",
    shortName: "Paducah",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KY",
    state: "Kentucky",
    difficulty: "classic",
    pools: ["world","North America","US","US-KY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ky-009",
    lat: 36.86528,
    lng: -87.490322,
    panoId: "FKlC20mctIPf4nRwsk45Sw",
    place: "Near Hopkinsville, Kentucky",
    shortName: "Hopkinsville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KY",
    state: "Kentucky",
    difficulty: "classic",
    pools: ["world","North America","US","US-KY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ky-010",
    lat: 38.254111,
    lng: -85.759483,
    panoId: "IM1Ikz0NmkvRTj9M60pggA",
    place: "Near Louisville, Kentucky",
    shortName: "Louisville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KY",
    state: "Kentucky",
    difficulty: "classic",
    pools: ["world","North America","US","US-KY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ky-011",
    lat: 36.990648,
    lng: -86.443912,
    panoId: "ocOoe9iHQ1yHEWwjYeum8w",
    place: "Near Bowling Green, Kentucky",
    shortName: "Bowling Green",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KY",
    state: "Kentucky",
    difficulty: "classic",
    pools: ["world","North America","US","US-KY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ky-012",
    lat: 39.027571,
    lng: -84.724221,
    panoId: "CKjMhph5cCFNhHS4VwFhyA",
    place: "Near Burlington, Kentucky",
    shortName: "Burlington",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KY",
    state: "Kentucky",
    difficulty: "classic",
    pools: ["world","North America","US","US-KY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ky-013",
    lat: 37.328104,
    lng: -87.49888,
    panoId: "No7MD3SVi_SKyroIunVoCQ",
    place: "Near Madisonville, Kentucky",
    shortName: "Madisonville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KY",
    state: "Kentucky",
    difficulty: "classic",
    pools: ["world","North America","US","US-KY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ky-014",
    lat: 37.568676,
    lng: -84.296337,
    panoId: "NCgEVPQYu3xQikIPFEZVsw",
    place: "Near Berea, Kentucky",
    shortName: "Berea",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KY",
    state: "Kentucky",
    difficulty: "classic",
    pools: ["world","North America","US","US-KY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ky-015",
    lat: 37.343412,
    lng: -85.341889,
    panoId: "Se-sMGXMMCvY8eoQ9tc6ZA",
    place: "Near Campbellsville, Kentucky",
    shortName: "Campbellsville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KY",
    state: "Kentucky",
    difficulty: "classic",
    pools: ["world","North America","US","US-KY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ky-016",
    lat: 37.645822,
    lng: -84.772185,
    panoId: "3PzMdma6DgAHvHdF4nlGHg",
    place: "Near Danville, Kentucky",
    shortName: "Danville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KY",
    state: "Kentucky",
    difficulty: "classic",
    pools: ["world","North America","US","US-KY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ky-017",
    lat: 38.943128,
    lng: -84.54441,
    panoId: "J_IK2MiplLwH8DPrxxWNYQ",
    place: "Near Independence, Kentucky",
    shortName: "Independence",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KY",
    state: "Kentucky",
    difficulty: "classic",
    pools: ["world","North America","US","US-KY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ky-018",
    lat: 36.995907,
    lng: -85.911919,
    panoId: "Pao-I7ktR1bncS4nuZExvQ",
    place: "Near Glasgow, Kentucky",
    shortName: "Glasgow",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KY",
    state: "Kentucky",
    difficulty: "classic",
    pools: ["world","North America","US","US-KY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ky-019",
    lat: 38.212011,
    lng: -85.22345,
    panoId: "iBkFtUVHpOsqmI6xEMpi9g",
    place: "Near Shelbyville, Kentucky",
    shortName: "Shelbyville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KY",
    state: "Kentucky",
    difficulty: "classic",
    pools: ["world","North America","US","US-KY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ky-020",
    lat: 38.209802,
    lng: -84.558942,
    panoId: "HMCGFGf-vozEiS2OESsK2Q",
    place: "Near Georgetown, Kentucky",
    shortName: "Georgetown",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KY",
    state: "Kentucky",
    difficulty: "classic",
    pools: ["world","North America","US","US-KY"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-ky-021",
    lat: 37.774228,
    lng: -87.113498,
    panoId: "VI2zXlFRYhB7pkylMAW7Dg",
    place: "Near Owensboro, Kentucky",
    shortName: "Owensboro",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KY",
    state: "Kentucky",
    difficulty: "classic",
    pools: ["world","North America","US","US-KY"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-ky-022",
    lat: 39.091527,
    lng: -84.495812,
    panoId: "WMHm1pOXJOQcEdeVO8kRQg",
    place: "Near Newport, Kentucky",
    shortName: "Newport",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KY",
    state: "Kentucky",
    difficulty: "classic",
    pools: ["world","North America","US","US-KY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ky-023",
    lat: 39.016664,
    lng: -84.600737,
    panoId: "gGdhvofHbCintgk7Mb7KsA",
    place: "Near Erlanger, Kentucky",
    shortName: "Erlanger",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KY",
    state: "Kentucky",
    difficulty: "classic",
    pools: ["world","North America","US","US-KY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ky-024",
    lat: 36.610595,
    lng: -88.314788,
    panoId: "6_PlswM4bD1qzCSTIdwjvg",
    place: "Near Murray, Kentucky",
    shortName: "Murray",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KY",
    state: "Kentucky",
    difficulty: "classic",
    pools: ["world","North America","US","US-KY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ky-025",
    lat: 37.694026,
    lng: -85.859321,
    panoId: "WWiyc581RD1HFgiymjh9Bw",
    place: "Near Elizabethtown, Kentucky",
    shortName: "Elizabethtown",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KY",
    state: "Kentucky",
    difficulty: "classic",
    pools: ["world","North America","US","US-KY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ky-026",
    lat: 36.608395,
    lng: -83.71659,
    panoId: "4eqz-gzb4nNuk4JSqByXXA",
    place: "Near Middlesboro, Kentucky",
    shortName: "Middlesboro",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KY",
    state: "Kentucky",
    difficulty: "classic",
    pools: ["world","North America","US","US-KY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ky-027",
    lat: 37.988364,
    lng: -85.715853,
    panoId: "njOMvtSgKLTHlmyV6_Rz9w",
    place: "Near Shepherdsville, Kentucky",
    shortName: "Shepherdsville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KY",
    state: "Kentucky",
    difficulty: "classic",
    pools: ["world","North America","US","US-KY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ky-028",
    lat: 37.092038,
    lng: -84.604227,
    panoId: "whXqH6Y2o6zf146qllHhyw",
    place: "Near Somerset, Kentucky",
    shortName: "Somerset",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KY",
    state: "Kentucky",
    difficulty: "classic",
    pools: ["world","North America","US","US-KY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ky-029",
    lat: 37.990067,
    lng: -84.179677,
    panoId: "b0YRb-lMU-41tlUjPvI8Mg",
    place: "Near Winchester, Kentucky",
    shortName: "Winchester",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KY",
    state: "Kentucky",
    difficulty: "classic",
    pools: ["world","North America","US","US-KY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ky-030",
    lat: 38.037386,
    lng: -84.896379,
    panoId: "ybq8LkSrKJ2ZYtn6oRejsg",
    place: "Near Lawrenceburg, Kentucky",
    shortName: "Lawrenceburg",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KY",
    state: "Kentucky",
    difficulty: "classic",
    pools: ["world","North America","US","US-KY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ky-031",
    lat: 37.885594,
    lng: -85.960867,
    panoId: "VcNzowWm4Z62TJIlvTaqQQ",
    place: "Near Fort Knox, Kentucky",
    shortName: "Fort Knox",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KY",
    state: "Kentucky",
    difficulty: "classic",
    pools: ["world","North America","US","US-KY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ky-032",
    lat: 37.840441,
    lng: -85.94916,
    panoId: "xBNBHtb-RAqJ8JSff4ImhQ",
    place: "Near Radcliff, Kentucky",
    shortName: "Radcliff",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KY",
    state: "Kentucky",
    difficulty: "classic",
    pools: ["world","North America","US","US-KY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ky-033",
    lat: 39.083687,
    lng: -84.508495,
    panoId: "COnmdvg5ENIm6CpYC6nC7Q",
    place: "Near Covington, Kentucky",
    shortName: "Covington",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KY",
    state: "Kentucky",
    difficulty: "classic",
    pools: ["world","North America","US","US-KY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ky-034",
    lat: 37.748017,
    lng: -84.294897,
    panoId: "lGX14l1_dSTHSP1X6_amTw",
    place: "Near Richmond, Kentucky",
    shortName: "Richmond",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KY",
    state: "Kentucky",
    difficulty: "classic",
    pools: ["world","North America","US","US-KY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ky-035",
    lat: 36.741645,
    lng: -88.636692,
    panoId: "PIVGWm2xShjZNTNwqAnDfw",
    place: "Near Mayfield, Kentucky",
    shortName: "Mayfield",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KY",
    state: "Kentucky",
    difficulty: "classic",
    pools: ["world","North America","US","US-KY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ky-036",
    lat: 38.20987,
    lng: -84.252947,
    panoId: "lEYxeyaEnPyki973O7Q-jQ",
    place: "Near Paris, Kentucky",
    shortName: "Paris",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KY",
    state: "Kentucky",
    difficulty: "classic",
    pools: ["world","North America","US","US-KY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ky-037",
    lat: 38.964665,
    lng: -84.551273,
    panoId: "BTwiSLzWjBXZuCUC8LN_TA",
    place: "Near Independence, Kentucky",
    shortName: "Independence",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KY",
    state: "Kentucky",
    difficulty: "classic",
    pools: ["world","North America","US","US-KY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ky-038",
    lat: 36.623367,
    lng: -83.711741,
    panoId: "UUUy5yejIB6WfhwIeTcz-w",
    place: "Near Middlesboro, Kentucky",
    shortName: "Middlesboro",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KY",
    state: "Kentucky",
    difficulty: "classic",
    pools: ["world","North America","US","US-KY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ky-039",
    lat: 36.876941,
    lng: -87.472766,
    panoId: "BUPxyd3rgmaBMkPzUhpRcw",
    place: "Near Hopkinsville, Kentucky",
    shortName: "Hopkinsville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KY",
    state: "Kentucky",
    difficulty: "classic",
    pools: ["world","North America","US","US-KY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ky-040",
    lat: 38.004056,
    lng: -84.200956,
    panoId: "ygS8ltzvJ0LV8ti1DW7GPg",
    place: "Near Winchester, Kentucky",
    shortName: "Winchester",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KY",
    state: "Kentucky",
    difficulty: "classic",
    pools: ["world","North America","US","US-KY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ky-041",
    lat: 39.105886,
    lng: -84.517507,
    panoId: "pL1Y3Z6neOxdsoXjYYDxCQ",
    place: "Near Cincinnati, Kentucky",
    shortName: "Cincinnati",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KY",
    state: "Kentucky",
    difficulty: "classic",
    pools: ["world","North America","US","US-KY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ky-042",
    lat: 37.892987,
    lng: -84.562747,
    panoId: "E6IQBKJ8yFz-sd2Icis-pw",
    place: "Near Nicholasville, Kentucky",
    shortName: "Nicholasville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KY",
    state: "Kentucky",
    difficulty: "classic",
    pools: ["world","North America","US","US-KY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ky-043",
    lat: 37.979835,
    lng: -85.736996,
    panoId: "FU2PgJw5X6nsY7dw4Ya62A",
    place: "Near Shepherdsville, Kentucky",
    shortName: "Shepherdsville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KY",
    state: "Kentucky",
    difficulty: "classic",
    pools: ["world","North America","US","US-KY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ky-044",
    lat: 37.766078,
    lng: -87.095567,
    panoId: "9f0Bkw92irLQQ75W3VmPYw",
    place: "Near Owensboro, Kentucky",
    shortName: "Owensboro",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KY",
    state: "Kentucky",
    difficulty: "classic",
    pools: ["world","North America","US","US-KY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ky-045",
    lat: 38.035183,
    lng: -84.883263,
    panoId: "YtyWzQ0h7NJ0gbYPZwEutg",
    place: "Near Lawrenceburg, Kentucky",
    shortName: "Lawrenceburg",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KY",
    state: "Kentucky",
    difficulty: "classic",
    pools: ["world","North America","US","US-KY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ky-046",
    lat: 37.322231,
    lng: -85.353441,
    panoId: "UTjGiWR-rYMqzePp1L9I5A",
    place: "Near Campbellsville, Kentucky",
    shortName: "Campbellsville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KY",
    state: "Kentucky",
    difficulty: "classic",
    pools: ["world","North America","US","US-KY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ky-047",
    lat: 36.979931,
    lng: -86.441886,
    panoId: "WctRVmKjsMLcmmfc2NhPPg",
    place: "Near Bowling Green, Kentucky",
    shortName: "Bowling Green",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KY",
    state: "Kentucky",
    difficulty: "classic",
    pools: ["world","North America","US","US-KY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ky-048",
    lat: 39.015284,
    lng: -84.612848,
    panoId: "1d-b7lMumRTr9Fn1RJeLaQ",
    place: "Near Elsmere, Kentucky",
    shortName: "Elsmere",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KY",
    state: "Kentucky",
    difficulty: "classic",
    pools: ["world","North America","US","US-KY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ky-049",
    lat: 39.012598,
    lng: -84.6335,
    panoId: "qVAMR8dy29DATyj7M0oGNg",
    place: "Near Florence, Kentucky",
    shortName: "Florence",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KY",
    state: "Kentucky",
    difficulty: "classic",
    pools: ["world","North America","US","US-KY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ky-050",
    lat: 37.796117,
    lng: -85.886907,
    panoId: "345WV-zfBZeX0DDm03LfMg",
    place: "Near Radcliff, Kentucky",
    shortName: "Radcliff",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KY",
    state: "Kentucky",
    difficulty: "explorer",
    pools: ["world","North America","US","US-KY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ky-051",
    lat: 36.566322,
    lng: -88.332137,
    panoId: "0IK0DDdy48cEeqHtdWplgQ",
    place: "Near Murray, Kentucky",
    shortName: "Murray",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KY",
    state: "Kentucky",
    difficulty: "explorer",
    pools: ["world","North America","US","US-KY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ky-052",
    lat: 38.442907,
    lng: -82.716135,
    panoId: "ErPWPNc_npVww2iKHR7zsg",
    place: "Near Meads, Kentucky",
    shortName: "Meads",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KY",
    state: "Kentucky",
    difficulty: "explorer",
    pools: ["world","North America","US","US-KY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ky-053",
    lat: 37.770402,
    lng: -84.363807,
    panoId: "jTevooarcdMK7lM_MgfuMg",
    place: "Near Richmond, Kentucky",
    shortName: "Richmond",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KY",
    state: "Kentucky",
    difficulty: "explorer",
    pools: ["world","North America","US","US-KY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ky-054",
    lat: 38.244994,
    lng: -85.814993,
    panoId: "jiq3u80zCATm3Iqou6VMKw",
    place: "Near New Albany, Kentucky",
    shortName: "New Albany",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KY",
    state: "Kentucky",
    difficulty: "explorer",
    pools: ["world","North America","US","US-KY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ky-055",
    lat: 36.711959,
    lng: -88.677935,
    panoId: "lAeAf0oLG_l-3XaXI3BaPQ",
    place: "Near Mayfield, Kentucky",
    shortName: "Mayfield",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KY",
    state: "Kentucky",
    difficulty: "explorer",
    pools: ["world","North America","US","US-KY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ky-056",
    lat: 38.463897,
    lng: -82.561034,
    panoId: "MYJ0rLCy-TaNrThFBKgPkA",
    place: "Near South Point, Kentucky",
    shortName: "South Point",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KY",
    state: "Kentucky",
    difficulty: "explorer",
    pools: ["world","North America","US","US-KY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ky-057",
    lat: 38.944511,
    lng: -84.604252,
    panoId: "T48TzzB0-53ai3ntaCvlrw",
    place: "Near Independence, Kentucky",
    shortName: "Independence",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KY",
    state: "Kentucky",
    difficulty: "explorer",
    pools: ["world","North America","US","US-KY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ky-058",
    lat: 39.020984,
    lng: -84.790841,
    panoId: "X0ik47x-dYWxMP1BUsE56w",
    place: "Near Burlington, Kentucky",
    shortName: "Burlington",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KY",
    state: "Kentucky",
    difficulty: "explorer",
    pools: ["world","North America","US","US-KY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ky-059",
    lat: 38.002743,
    lng: -84.547058,
    panoId: "zGv8kB2c89_g9o5YhnVf2Q",
    place: "Near Mount Vernon, Kentucky",
    shortName: "Mount Vernon",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KY",
    state: "Kentucky",
    difficulty: "explorer",
    pools: ["world","North America","US","US-KY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ky-060",
    lat: 37.719354,
    lng: -85.920369,
    panoId: "bDpdYjWHcnQCgwpAwjhm3g",
    place: "Near Elizabethtown, Kentucky",
    shortName: "Elizabethtown",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KY",
    state: "Kentucky",
    difficulty: "explorer",
    pools: ["world","North America","US","US-KY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ky-061",
    lat: 38.195781,
    lng: -84.19275,
    panoId: "oUTLoT3u5PAECYEwTPY2WA",
    place: "Near Paris, Kentucky",
    shortName: "Paris",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KY",
    state: "Kentucky",
    difficulty: "explorer",
    pools: ["world","North America","US","US-KY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ky-062",
    lat: 37.874381,
    lng: -87.557511,
    panoId: "pDLgxM9Cx9WbTJylS3qJkA",
    place: "Near Henderson, Kentucky",
    shortName: "Henderson",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KY",
    state: "Kentucky",
    difficulty: "explorer",
    pools: ["world","North America","US","US-KY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ky-063",
    lat: 37.653649,
    lng: -84.862072,
    panoId: "Ma6Jlw5KtQ91hvj9aMTi5w",
    place: "Near Danville, Kentucky",
    shortName: "Danville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KY",
    state: "Kentucky",
    difficulty: "explorer",
    pools: ["world","North America","US","US-KY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ky-064",
    lat: 38.230955,
    lng: -85.188606,
    panoId: "fA9ejJF-0WBup9i11xpKdA",
    place: "Near Shelbyville, Kentucky",
    shortName: "Shelbyville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KY",
    state: "Kentucky",
    difficulty: "explorer",
    pools: ["world","North America","US","US-KY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ky-065",
    lat: 38.243872,
    lng: -84.623333,
    panoId: "Z439j1ycHXL-Z6dOXWII7g",
    place: "Near Georgetown, Kentucky",
    shortName: "Georgetown",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KY",
    state: "Kentucky",
    difficulty: "explorer",
    pools: ["world","North America","US","US-KY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ky-066",
    lat: 36.574827,
    lng: -83.638945,
    panoId: "p1rQ81Vhkt3EqyLEr-3JWA",
    place: "Near Harrogate, Kentucky",
    shortName: "Harrogate",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KY",
    state: "Kentucky",
    difficulty: "explorer",
    pools: ["world","North America","US","US-KY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ky-067",
    lat: 38.24859,
    lng: -84.901119,
    panoId: "yVB3NFYqvz_DvYFDAZBcqQ",
    place: "Near Frankfort, Kentucky",
    shortName: "Frankfort",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KY",
    state: "Kentucky",
    difficulty: "explorer",
    pools: ["world","North America","US","US-KY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ky-068",
    lat: 36.65153,
    lng: -87.401758,
    panoId: "u4vvY3VMYeDAJvNVlrDZlg",
    place: "Near Oak Grove, Kentucky",
    shortName: "Oak Grove",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KY",
    state: "Kentucky",
    difficulty: "explorer",
    pools: ["world","North America","US","US-KY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ky-069",
    lat: 37.833776,
    lng: -84.545805,
    panoId: "lPq96ecCdpPo14zDP_DZaA",
    place: "Near Nicholasville, Kentucky",
    shortName: "Nicholasville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KY",
    state: "Kentucky",
    difficulty: "explorer",
    pools: ["world","North America","US","US-KY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ky-070",
    lat: 38.958097,
    lng: -84.598996,
    panoId: "W81qjsxG0UVnkEw3V_duaA",
    place: "Near Independence, Kentucky",
    shortName: "Independence",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KY",
    state: "Kentucky",
    difficulty: "explorer",
    pools: ["world","North America","US","US-KY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ky-071",
    lat: 37.127725,
    lng: -88.591949,
    panoId: "zN2reuvU9pU8NbsfMhPvMA",
    place: "Near Paducah, Kentucky",
    shortName: "Paducah",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KY",
    state: "Kentucky",
    difficulty: "explorer",
    pools: ["world","North America","US","US-KY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ky-072",
    lat: 38.039918,
    lng: -84.853598,
    panoId: "yjXnwxdhbkRCoYI-KufebQ",
    place: "Near Lawrenceburg, Kentucky",
    shortName: "Lawrenceburg",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KY",
    state: "Kentucky",
    difficulty: "explorer",
    pools: ["world","North America","US","US-KY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ky-073",
    lat: 36.866494,
    lng: -87.442336,
    panoId: "dwS4rHq6vxkYZZq2jUHs7A",
    place: "Near Hopkinsville, Kentucky",
    shortName: "Hopkinsville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KY",
    state: "Kentucky",
    difficulty: "explorer",
    pools: ["world","North America","US","US-KY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ky-074",
    lat: 37.75665,
    lng: -84.232327,
    panoId: "h2fRIeQeZzT2XGCf4VfuUQ",
    place: "Near Richmond, Kentucky",
    shortName: "Richmond",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KY",
    state: "Kentucky",
    difficulty: "explorer",
    pools: ["world","North America","US","US-KY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ky-075",
    lat: 37.985408,
    lng: -84.109974,
    panoId: "vNDzhOt4KV0VehDk8uYeVA",
    place: "Near Winchester, Kentucky",
    shortName: "Winchester",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KY",
    state: "Kentucky",
    difficulty: "explorer",
    pools: ["world","North America","US","US-KY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ky-076",
    lat: 37.041481,
    lng: -86.438382,
    panoId: "mLkpGUBOgxFJDGeXJ1mCyg",
    place: "Near Bowling Green, Kentucky",
    shortName: "Bowling Green",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KY",
    state: "Kentucky",
    difficulty: "explorer",
    pools: ["world","North America","US","US-KY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ky-077",
    lat: 37.963334,
    lng: -85.646121,
    panoId: "2eYB5o1Bm3-zFWazWtSXAA",
    place: "Near Shepherdsville, Kentucky",
    shortName: "Shepherdsville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KY",
    state: "Kentucky",
    difficulty: "explorer",
    pools: ["world","North America","US","US-KY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ky-078",
    lat: 39.028398,
    lng: -84.504681,
    panoId: "QRKxVxaH5asUWwbQszdeAg",
    place: "Near Wilder, Kentucky",
    shortName: "Wilder",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KY",
    state: "Kentucky",
    difficulty: "explorer",
    pools: ["world","North America","US","US-KY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ky-079",
    lat: 37.380585,
    lng: -87.515238,
    panoId: "2xkpRxpw3GY2O45Nvu9Lhw",
    place: "Near Madisonville, Kentucky",
    shortName: "Madisonville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KY",
    state: "Kentucky",
    difficulty: "explorer",
    pools: ["world","North America","US","US-KY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ky-080",
    lat: 38.40888,
    lng: -82.774992,
    panoId: "EGyjc9kHpfLPjMjjdxudcg",
    place: "Near Meads, Kentucky",
    shortName: "Meads",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KY",
    state: "Kentucky",
    difficulty: "explorer",
    pools: ["world","North America","US","US-KY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ky-081",
    lat: 37.364478,
    lng: -85.368577,
    panoId: "OgA4wHwz2C5efDR1hRHuEg",
    place: "Near Campbellsville, Kentucky",
    shortName: "Campbellsville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KY",
    state: "Kentucky",
    difficulty: "explorer",
    pools: ["world","North America","US","US-KY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ky-082",
    lat: 36.924642,
    lng: -85.90628,
    panoId: "xETPVsVSTICQ2oEtcJ1-sQ",
    place: "Near Glasgow, Kentucky",
    shortName: "Glasgow",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KY",
    state: "Kentucky",
    difficulty: "explorer",
    pools: ["world","North America","US","US-KY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ky-083",
    lat: 37.992626,
    lng: -84.687424,
    panoId: "wqOQRoKjKR1RUrzWAwndVw",
    place: "Near Versailles, Kentucky",
    shortName: "Versailles",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KY",
    state: "Kentucky",
    difficulty: "explorer",
    pools: ["world","North America","US","US-KY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ky-084",
    lat: 36.775167,
    lng: -88.596925,
    panoId: "-yBcVetgvwQzJCi879o91A",
    place: "Near Mayfield, Kentucky",
    shortName: "Mayfield",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KY",
    state: "Kentucky",
    difficulty: "explorer",
    pools: ["world","North America","US","US-KY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ky-085",
    lat: 38.058105,
    lng: -84.370987,
    panoId: "3_DJIFnmOZSTq2DYI844QQ",
    place: "Near Lexington-Fayette, Kentucky",
    shortName: "Lexington-Fayette",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KY",
    state: "Kentucky",
    difficulty: "explorer",
    pools: ["world","North America","US","US-KY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ky-086",
    lat: 37.702704,
    lng: -85.945184,
    panoId: "Cbv-O8qpPb3Ty5ya-0ZHYA",
    place: "Near Elizabethtown, Kentucky",
    shortName: "Elizabethtown",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KY",
    state: "Kentucky",
    difficulty: "explorer",
    pools: ["world","North America","US","US-KY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ky-087",
    lat: 38.20023,
    lng: -84.324162,
    panoId: "1dAjtNsCx339lZMHEuWjBw",
    place: "Near Paris, Kentucky",
    shortName: "Paris",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KY",
    state: "Kentucky",
    difficulty: "explorer",
    pools: ["world","North America","US","US-KY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ky-088",
    lat: 37.945097,
    lng: -84.45079,
    panoId: "J6SVjAX3hVzMxfpG5j3Bug",
    place: "Near Lexington, Kentucky",
    shortName: "Lexington",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KY",
    state: "Kentucky",
    difficulty: "explorer",
    pools: ["world","North America","US","US-KY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ky-089",
    lat: 38.983394,
    lng: -84.547259,
    panoId: "wngTqgDco6NSq_6tFDkd2Q",
    place: "Near Independence, Kentucky",
    shortName: "Independence",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KY",
    state: "Kentucky",
    difficulty: "explorer",
    pools: ["world","North America","US","US-KY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ky-090",
    lat: 37.726601,
    lng: -87.059246,
    panoId: "ChvqL6CkVClRk1Uxk33s8w",
    place: "Near Masonville, Kentucky",
    shortName: "Masonville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KY",
    state: "Kentucky",
    difficulty: "explorer",
    pools: ["world","North America","US","US-KY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ky-091",
    lat: 38.009408,
    lng: -85.900216,
    panoId: "lI3wJwET8SH526nSWIIZ6g",
    place: "Near Valley Station, Kentucky",
    shortName: "Valley Station",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KY",
    state: "Kentucky",
    difficulty: "explorer",
    pools: ["world","North America","US","US-KY"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-ky-092",
    lat: 37.459243,
    lng: -84.395695,
    panoId: "V2mt-cWf-ZDiFM8AikSRrA",
    place: "Near Brodhead, Kentucky",
    shortName: "Brodhead",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KY",
    state: "Kentucky",
    difficulty: "explorer",
    pools: ["world","North America","US","US-KY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ky-093",
    lat: 36.593878,
    lng: -87.565198,
    panoId: "vZ6YA1dEJIRCfDO_seTBlg",
    place: "Near Fort Campbell North, Kentucky",
    shortName: "Fort Campbell North",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KY",
    state: "Kentucky",
    difficulty: "explorer",
    pools: ["world","North America","US","US-KY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ky-094",
    lat: 37.009245,
    lng: -88.699637,
    panoId: "BoJnzsdWxGsIsvywajur0g",
    place: "Near Massac, Kentucky",
    shortName: "Massac",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KY",
    state: "Kentucky",
    difficulty: "explorer",
    pools: ["world","North America","US","US-KY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ky-095",
    lat: 37.048718,
    lng: -84.720372,
    panoId: "BhcMp_jqdK4dcroAVJnzgg",
    place: "Near Somerset, Kentucky",
    shortName: "Somerset",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KY",
    state: "Kentucky",
    difficulty: "explorer",
    pools: ["world","North America","US","US-KY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ky-096",
    lat: 38.358428,
    lng: -84.417149,
    panoId: "qb8YMKD9EMm5yosPyEhP9Q",
    place: "Near Cynthiana, Kentucky",
    shortName: "Cynthiana",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KY",
    state: "Kentucky",
    difficulty: "explorer",
    pools: ["world","North America","US","US-KY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ky-097",
    lat: 37.996095,
    lng: -84.725831,
    panoId: "r7SZHfje2HycZwee7l2HHg",
    place: "Near Versailles, Kentucky",
    shortName: "Versailles",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KY",
    state: "Kentucky",
    difficulty: "explorer",
    pools: ["world","North America","US","US-KY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ky-098",
    lat: 37.719328,
    lng: -84.756002,
    panoId: "Z4MJ7HsezjRCMEnYoPTVyg",
    place: "Near Danville, Kentucky",
    shortName: "Danville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KY",
    state: "Kentucky",
    difficulty: "explorer",
    pools: ["world","North America","US","US-KY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ky-099",
    lat: 36.780748,
    lng: -87.497416,
    panoId: "SOsVSLTZl-plc7cPAnVWuQ",
    place: "Near Hopkinsville, Kentucky",
    shortName: "Hopkinsville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KY",
    state: "Kentucky",
    difficulty: "explorer",
    pools: ["world","North America","US","US-KY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ky-100",
    lat: 38.326636,
    lng: -83.285611,
    panoId: "tepZhXNI3aEkvSms9ZKFwg",
    place: "Near Olive Hill, Kentucky",
    shortName: "Olive Hill",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KY",
    state: "Kentucky",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-KY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ky-101",
    lat: 38.29303,
    lng: -82.625424,
    panoId: "p3OvIujkZ_NXkxJN2BDaKg",
    place: "Near Kenova, Kentucky",
    shortName: "Kenova",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KY",
    state: "Kentucky",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-KY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ky-102",
    lat: 38.609097,
    lng: -83.537443,
    panoId: "E3r4oA6FfuqgyUSUHctTwQ",
    place: "Near Manchester, Kentucky",
    shortName: "Manchester",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KY",
    state: "Kentucky",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-KY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ky-103",
    lat: 38.681556,
    lng: -82.677939,
    panoId: "t6OXXFmMp6t697dHy0IS6Q",
    place: "Near Worthington, Kentucky",
    shortName: "Worthington",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KY",
    state: "Kentucky",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-KY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ky-104",
    lat: 38.630133,
    lng: -83.505447,
    panoId: "MO4-z62uzn34XmfWO4QXig",
    place: "Near Manchester, Kentucky",
    shortName: "Manchester",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KY",
    state: "Kentucky",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-KY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ky-105",
    lat: 37.054272,
    lng: -87.689409,
    panoId: "coPdskqMRTQe2QSlkJJ2bw",
    place: "Near Dawson Springs, Kentucky",
    shortName: "Dawson Springs",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KY",
    state: "Kentucky",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-KY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ky-106",
    lat: 38.012585,
    lng: -83.441751,
    panoId: "eHy2qCZPAFYWNLYKV2IEnQ",
    place: "Near Frenchburg, Kentucky",
    shortName: "Frenchburg",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "KY",
    state: "Kentucky",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-KY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-la-000",
    lat: 30.224123,
    lng: -92.019793,
    panoId: "nBsan9cMNFjL3LUPhwB4PA",
    place: "Near Lafayette, Louisiana",
    shortName: "Lafayette",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "LA",
    state: "Louisiana",
    difficulty: "classic",
    pools: ["world","North America","US","US-LA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-la-001",
    lat: 29.984109,
    lng: -90.152913,
    panoId: "7jmaK433McG-IPetBWONnw",
    place: "Near Metairie, Louisiana",
    shortName: "Metairie",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "LA",
    state: "Louisiana",
    difficulty: "classic",
    pools: ["world","North America","US","US-LA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-la-002",
    lat: 30.213095,
    lng: -93.204396,
    panoId: "7AblXSBTYnohg9aTVB0vrg",
    place: "Near Lake Charles, Louisiana",
    shortName: "Lake Charles",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "LA",
    state: "Louisiana",
    difficulty: "classic",
    pools: ["world","North America","US","US-LA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-la-003",
    lat: 29.954624,
    lng: -90.075044,
    panoId: "HIO20Tuj0SlCLHtu74Bviw",
    place: "Near New Orleans, Louisiana",
    shortName: "New Orleans",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "LA",
    state: "Louisiana",
    difficulty: "classic",
    pools: ["world","North America","US","US-LA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-la-004",
    lat: 30.648495,
    lng: -91.156477,
    panoId: "4W3Ve827OHjRLEOWqm6PAg",
    place: "Near Zachary, Louisiana",
    shortName: "Zachary",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "LA",
    state: "Louisiana",
    difficulty: "classic",
    pools: ["world","North America","US","US-LA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-la-005",
    lat: 29.907867,
    lng: -90.777086,
    panoId: "Bj4c2n1DmOuwLy-X0U3HKA",
    place: "Near Grand Bayou Mobile Home Park, Louisiana",
    shortName: "Grand Bayou Mobile Home Park",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "LA",
    state: "Louisiana",
    difficulty: "classic",
    pools: ["world","North America","US","US-LA"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-la-006",
    lat: 30.554364,
    lng: -91.036725,
    panoId: "byfOO2Zdw6ngMirSTlRIsw",
    place: "Near Central, Louisiana",
    shortName: "Central",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "LA",
    state: "Louisiana",
    difficulty: "classic",
    pools: ["world","North America","US","US-LA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-la-007",
    lat: 30.400966,
    lng: -91.000594,
    panoId: "6DhlisL-tz-Duyjc6hwX4A",
    place: "Near Shenandoah, Louisiana",
    shortName: "Shenandoah",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "LA",
    state: "Louisiana",
    difficulty: "classic",
    pools: ["world","North America","US","US-LA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-la-008",
    lat: 32.523654,
    lng: -92.637944,
    panoId: "SsHo9g_cUxpmMVbCZNAi0A",
    place: "Near Ruston, Louisiana",
    shortName: "Ruston",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "LA",
    state: "Louisiana",
    difficulty: "classic",
    pools: ["world","North America","US","US-LA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-la-009",
    lat: 29.943099,
    lng: -89.965297,
    panoId: "NzmwKMaFsmdze6hB-t8zaA",
    place: "Near Chalmette, Louisiana",
    shortName: "Chalmette",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "LA",
    state: "Louisiana",
    difficulty: "classic",
    pools: ["world","North America","US","US-LA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-la-010",
    lat: 31.322365,
    lng: -92.434313,
    panoId: "hm0PmPiaTBLqa2Vg_4UNxQ",
    place: "Near Pineville, Louisiana",
    shortName: "Pineville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "LA",
    state: "Louisiana",
    difficulty: "classic",
    pools: ["world","North America","US","US-LA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-la-011",
    lat: 29.910133,
    lng: -90.032585,
    panoId: "bTkYWH96Ry2R-5pwQ4x6xQ",
    place: "Near Terrytown, Louisiana",
    shortName: "Terrytown",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "LA",
    state: "Louisiana",
    difficulty: "classic",
    pools: ["world","North America","US","US-LA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-la-012",
    lat: 30.066998,
    lng: -90.481495,
    panoId: "YWF40IpPtFkoVvBfxqOd1Q",
    place: "Near Laplace, Louisiana",
    shortName: "Laplace",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "LA",
    state: "Louisiana",
    difficulty: "classic",
    pools: ["world","North America","US","US-LA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-la-013",
    lat: 30.236623,
    lng: -93.377355,
    panoId: "BL8UU5N9cZoJMPpQB1EuDA",
    place: "Near Sulphur, Louisiana",
    shortName: "Sulphur",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "LA",
    state: "Louisiana",
    difficulty: "classic",
    pools: ["world","North America","US","US-LA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-la-014",
    lat: 29.795756,
    lng: -90.822862,
    panoId: "ozFpgWks5Ioy9ndWTsaqhg",
    place: "Near Thibodaux, Louisiana",
    shortName: "Thibodaux",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "LA",
    state: "Louisiana",
    difficulty: "classic",
    pools: ["world","North America","US","US-LA"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-la-015",
    lat: 29.994073,
    lng: -90.241761,
    panoId: "bX2dtjfAyzPI5z-0vDrXPQ",
    place: "Near Kenner, Louisiana",
    shortName: "Kenner",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "LA",
    state: "Louisiana",
    difficulty: "classic",
    pools: ["world","North America","US","US-LA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-la-016",
    lat: 29.84577,
    lng: -90.106785,
    panoId: "7FJSrXa_WhNmGVU3f3IyRA",
    place: "Near Estelle, Louisiana",
    shortName: "Estelle",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "LA",
    state: "Louisiana",
    difficulty: "classic",
    pools: ["world","North America","US","US-LA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-la-017",
    lat: 32.509425,
    lng: -92.119371,
    panoId: "W2V3UKRPtQEjNY8vELrBrw",
    place: "Near Monroe, Louisiana",
    shortName: "Monroe",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "LA",
    state: "Louisiana",
    difficulty: "classic",
    pools: ["world","North America","US","US-LA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-la-018",
    lat: 30.003713,
    lng: -91.818924,
    panoId: "gaaRS9vvNN4JjYixWc2yTg",
    place: "Near New Iberia, Louisiana",
    shortName: "New Iberia",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "LA",
    state: "Louisiana",
    difficulty: "classic",
    pools: ["world","North America","US","US-LA"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-la-019",
    lat: 29.624008,
    lng: -90.751258,
    panoId: "tzO-3FzHikDfFgZ7OqgAwQ",
    place: "Near Bayou Cane, Louisiana",
    shortName: "Bayou Cane",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "LA",
    state: "Louisiana",
    difficulty: "classic",
    pools: ["world","North America","US","US-LA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-la-020",
    lat: 31.76067,
    lng: -93.086131,
    panoId: "rng_QIu1Nax2R-HUbzUiww",
    place: "Near Natchitoches, Louisiana",
    shortName: "Natchitoches",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "LA",
    state: "Louisiana",
    difficulty: "classic",
    pools: ["world","North America","US","US-LA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-la-021",
    lat: 30.533559,
    lng: -92.081647,
    panoId: "cMdbb-yPgSYFKodoUOyY8A",
    place: "Near Opelousas, Louisiana",
    shortName: "Opelousas",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "LA",
    state: "Louisiana",
    difficulty: "classic",
    pools: ["world","North America","US","US-LA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-la-022",
    lat: 29.595863,
    lng: -90.719523,
    panoId: "NeYpsuiUJj3MKIzMa45g3Q",
    place: "Near Houma, Louisiana",
    shortName: "Houma",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "LA",
    state: "Louisiana",
    difficulty: "classic",
    pools: ["world","North America","US","US-LA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-la-023",
    lat: 30.443314,
    lng: -91.187492,
    panoId: "OWj85L7PRMJl5niQar0_jg",
    place: "Near Baton Rouge, Louisiana",
    shortName: "Baton Rouge",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "LA",
    state: "Louisiana",
    difficulty: "classic",
    pools: ["world","North America","US","US-LA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-la-024",
    lat: 29.899378,
    lng: -90.100433,
    panoId: "mG1ll4R-aFniEdA1AKl6_A",
    place: "Near Marrero, Louisiana",
    shortName: "Marrero",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "LA",
    state: "Louisiana",
    difficulty: "classic",
    pools: ["world","North America","US","US-LA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-la-025",
    lat: 29.914892,
    lng: -90.053559,
    panoId: "TQ-djaFXsK-3Vd_SWQB3pQ",
    place: "Near Gretna, Louisiana",
    shortName: "Gretna",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "LA",
    state: "Louisiana",
    difficulty: "classic",
    pools: ["world","North America","US","US-LA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-la-026",
    lat: 31.311185,
    lng: -92.444972,
    panoId: "t59EtRmFK-QwWIw-uSOw4g",
    place: "Near Alexandria, Louisiana",
    shortName: "Alexandria",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "LA",
    state: "Louisiana",
    difficulty: "classic",
    pools: ["world","North America","US","US-LA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-la-027",
    lat: 30.588275,
    lng: -91.168125,
    panoId: "nWBvCv1bpazqIH_leSIGrw",
    place: "Near Baker, Louisiana",
    shortName: "Baker",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "LA",
    state: "Louisiana",
    difficulty: "classic",
    pools: ["world","North America","US","US-LA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-la-028",
    lat: 30.302998,
    lng: -90.972057,
    panoId: "IZFE3ceQBtKiZML7KSQXVg",
    place: "Near Prairieville, Louisiana",
    shortName: "Prairieville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "LA",
    state: "Louisiana",
    difficulty: "classic",
    pools: ["world","North America","US","US-LA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-la-029",
    lat: 32.615434,
    lng: -93.286824,
    panoId: "MKFUCUez_Qngkyehj1ezfQ",
    place: "Near Minden, Louisiana",
    shortName: "Minden",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "LA",
    state: "Louisiana",
    difficulty: "classic",
    pools: ["world","North America","US","US-LA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-la-030",
    lat: 29.9033,
    lng: -90.077247,
    panoId: "ZBoFoN8ttm5p1Bs4n58DwA",
    place: "Near Harvey, Louisiana",
    shortName: "Harvey",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "LA",
    state: "Louisiana",
    difficulty: "classic",
    pools: ["world","North America","US","US-LA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-la-031",
    lat: 29.869649,
    lng: -90.596715,
    panoId: "lVqG1FfMTeaO2_P91CWbBg",
    place: "Near Bayou Boeuf, Louisiana",
    shortName: "Bayou Boeuf",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "LA",
    state: "Louisiana",
    difficulty: "classic",
    pools: ["world","North America","US","US-LA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-la-032",
    lat: 32.524988,
    lng: -93.750905,
    panoId: "ah7xrHkkKz9kKEv3JNRWTg",
    place: "Near Shreveport, Louisiana",
    shortName: "Shreveport",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "LA",
    state: "Louisiana",
    difficulty: "classic",
    pools: ["world","North America","US","US-LA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-la-033",
    lat: 32.518525,
    lng: -92.14769,
    panoId: "ByDa4zWBNReGbCrh27loEA",
    place: "Near West Monroe, Louisiana",
    shortName: "West Monroe",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "LA",
    state: "Louisiana",
    difficulty: "classic",
    pools: ["world","North America","US","US-LA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-la-034",
    lat: 30.214139,
    lng: -92.374652,
    panoId: "INR2ksyeK9KuOYZRQxLTQg",
    place: "Near Crowley, Louisiana",
    shortName: "Crowley",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "LA",
    state: "Louisiana",
    difficulty: "classic",
    pools: ["world","North America","US","US-LA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-la-035",
    lat: 32.516032,
    lng: -93.732223,
    panoId: "Cfx1rC2EBvGRwjcrn0B03A",
    place: "Near Bossier City, Louisiana",
    shortName: "Bossier City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "LA",
    state: "Louisiana",
    difficulty: "classic",
    pools: ["world","North America","US","US-LA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-la-036",
    lat: 29.854838,
    lng: -89.990366,
    panoId: "xrmQAb2aFZ3_uaYR01RXaw",
    place: "Near Belle Chasse, Louisiana",
    shortName: "Belle Chasse",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "LA",
    state: "Louisiana",
    difficulty: "classic",
    pools: ["world","North America","US","US-LA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-la-037",
    lat: 30.504722,
    lng: -90.462902,
    panoId: "J4vKmqrRruG1b3iTfR_-xw",
    place: "Near Hammond, Louisiana",
    shortName: "Hammond",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "LA",
    state: "Louisiana",
    difficulty: "classic",
    pools: ["world","North America","US","US-LA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-la-038",
    lat: 30.275199,
    lng: -89.781208,
    panoId: "IYRJkGtUe2g_w-XxeQ5_wQ",
    place: "Near Slidell, Louisiana",
    shortName: "Slidell",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "LA",
    state: "Louisiana",
    difficulty: "classic",
    pools: ["world","North America","US","US-LA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-la-039",
    lat: 29.610678,
    lng: -90.757941,
    panoId: "uGa9C1iAof_ilGyZxowS5g",
    place: "Near Bayou Cane, Louisiana",
    shortName: "Bayou Cane",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "LA",
    state: "Louisiana",
    difficulty: "classic",
    pools: ["world","North America","US","US-LA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-la-040",
    lat: 29.583694,
    lng: -90.723153,
    panoId: "B3jT9bbrR97yD5diwxHDdA",
    place: "Near Houma, Louisiana",
    shortName: "Houma",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "LA",
    state: "Louisiana",
    difficulty: "classic",
    pools: ["world","North America","US","US-LA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-la-041",
    lat: 30.640052,
    lng: -91.143549,
    panoId: "DHzjUyv4Jwr8Ye2Dc9QyIQ",
    place: "Near Zachary, Louisiana",
    shortName: "Zachary",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "LA",
    state: "Louisiana",
    difficulty: "classic",
    pools: ["world","North America","US","US-LA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-la-042",
    lat: 32.514042,
    lng: -92.635078,
    panoId: "U8YmFdiXhMEjIQjo74gLmw",
    place: "Near Ruston, Louisiana",
    shortName: "Ruston",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "LA",
    state: "Louisiana",
    difficulty: "classic",
    pools: ["world","North America","US","US-LA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-la-043",
    lat: 32.533213,
    lng: -93.765272,
    panoId: "ITfuSX9JYwIs2RSaFkzSeA",
    place: "Near Shreveport, Louisiana",
    shortName: "Shreveport",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "LA",
    state: "Louisiana",
    difficulty: "classic",
    pools: ["world","North America","US","US-LA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-la-044",
    lat: 30.239176,
    lng: -92.034057,
    panoId: "08h9j8h0czlRJe-0_MXfnw",
    place: "Near Lafayette, Louisiana",
    shortName: "Lafayette",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "LA",
    state: "Louisiana",
    difficulty: "classic",
    pools: ["world","North America","US","US-LA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-la-045",
    lat: 29.829441,
    lng: -90.108792,
    panoId: "YZvOrG3w-OaHlIYIRDMnlA",
    place: "Near Estelle, Louisiana",
    shortName: "Estelle",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "LA",
    state: "Louisiana",
    difficulty: "classic",
    pools: ["world","North America","US","US-LA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-la-046",
    lat: 30.54304,
    lng: -92.093092,
    panoId: "aiStc4Py0NDjKffpt-OieQ",
    place: "Near Opelousas, Louisiana",
    shortName: "Opelousas",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "LA",
    state: "Louisiana",
    difficulty: "classic",
    pools: ["world","North America","US","US-LA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-la-047",
    lat: 30.016145,
    lng: -91.833503,
    panoId: "Uco96nFLaaQJhYcwWZCwEw",
    place: "Near New Iberia, Louisiana",
    shortName: "New Iberia",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "LA",
    state: "Louisiana",
    difficulty: "classic",
    pools: ["world","North America","US","US-LA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-la-048",
    lat: 29.914181,
    lng: -90.066968,
    panoId: "PmLzzyyVO74YvJiUHz_PSg",
    place: "Near Gretna, Louisiana",
    shortName: "Gretna",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "LA",
    state: "Louisiana",
    difficulty: "classic",
    pools: ["world","North America","US","US-LA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-la-049",
    lat: 29.961282,
    lng: -90.198523,
    panoId: "ldb8aee9ShXNZm0eCd-pYQ",
    place: "Near Elmwood, Louisiana",
    shortName: "Elmwood",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "LA",
    state: "Louisiana",
    difficulty: "classic",
    pools: ["world","North America","US","US-LA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-la-050",
    lat: 32.66398,
    lng: -93.232897,
    panoId: "gz5ODbWMrNls3qzCxPCg0g",
    place: "Near Minden, Louisiana",
    shortName: "Minden",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "LA",
    state: "Louisiana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-LA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-la-051",
    lat: 30.422484,
    lng: -90.949971,
    panoId: "_0Y76DhHGe900CEur9waYQ",
    place: "Near Shenandoah, Louisiana",
    shortName: "Shenandoah",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "LA",
    state: "Louisiana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-LA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-la-052",
    lat: 30.205669,
    lng: -92.321166,
    panoId: "njaPftyOvPfeu-DplpJvCw",
    place: "Near Crowley, Louisiana",
    shortName: "Crowley",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "LA",
    state: "Louisiana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-LA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-la-053",
    lat: 29.794693,
    lng: -90.867397,
    panoId: "QYoqib08sfV00-Xi8101lQ",
    place: "Near Thibodaux, Louisiana",
    shortName: "Thibodaux",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "LA",
    state: "Louisiana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-LA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-la-054",
    lat: 30.027666,
    lng: -90.196165,
    panoId: "0gl4p5hYu7_yRcpZ59S05A",
    place: "Near Kenner, Louisiana",
    shortName: "Kenner",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "LA",
    state: "Louisiana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-LA"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "us-la-055",
    lat: 31.271321,
    lng: -92.422454,
    panoId: "TrpuaweCK8VhPgPzI5oiSA",
    place: "Near Alexandria, Louisiana",
    shortName: "Alexandria",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "LA",
    state: "Louisiana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-LA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-la-056",
    lat: 32.471597,
    lng: -92.185067,
    panoId: "XkH3jmmYSDoQQEUgS4gIuw",
    place: "Near Bawcomville, Louisiana",
    shortName: "Bawcomville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "LA",
    state: "Louisiana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-LA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-la-057",
    lat: 32.4624,
    lng: -93.741471,
    panoId: "EZEJ9gyqBGJcnWnJaOZljQ",
    place: "Near Bossier City, Louisiana",
    shortName: "Bossier City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "LA",
    state: "Louisiana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-LA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-la-058",
    lat: 30.111179,
    lng: -90.548436,
    panoId: "P10a_aH2fBXv5DPIkOq9Bg",
    place: "Near Montegut, Louisiana",
    shortName: "Montegut",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "LA",
    state: "Louisiana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-LA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-la-059",
    lat: 30.016096,
    lng: -90.271703,
    panoId: "L6wdmjojDvOVH3gwwfpp5w",
    place: "Near Kenner, Louisiana",
    shortName: "Kenner",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "LA",
    state: "Louisiana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-LA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-la-060",
    lat: 30.185291,
    lng: -93.216255,
    panoId: "9dhD1xUsyGlO3kjt563qKg",
    place: "Near Lake Charles, Louisiana",
    shortName: "Lake Charles",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "LA",
    state: "Louisiana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-LA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-la-061",
    lat: 29.885015,
    lng: -89.986929,
    panoId: "DjOI34ELO2dzVGTG9-Wqvw",
    place: "Near Belle Chasse, Louisiana",
    shortName: "Belle Chasse",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "LA",
    state: "Louisiana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-LA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-la-062",
    lat: 32.669553,
    lng: -93.321766,
    panoId: "o71M0rEZmDoufvK3AV8qLg",
    place: "Near Minden, Louisiana",
    shortName: "Minden",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "LA",
    state: "Louisiana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-LA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-la-063",
    lat: 30.554336,
    lng: -91.208221,
    panoId: "xjuJVIimvEyEhJzGtStxhA",
    place: "Near Baker, Louisiana",
    shortName: "Baker",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "LA",
    state: "Louisiana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-LA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-la-064",
    lat: 29.626296,
    lng: -90.670627,
    panoId: "7hyhxvVQXsnPIbm923eHlw",
    place: "Near Houma, Louisiana",
    shortName: "Houma",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "LA",
    state: "Louisiana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-LA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-la-065",
    lat: 30.2968,
    lng: -89.715224,
    panoId: "uE-ilY7SoBNL1MUvn4L4wA",
    place: "Near Slidell, Louisiana",
    shortName: "Slidell",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "LA",
    state: "Louisiana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-LA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-la-066",
    lat: 29.959686,
    lng: -90.033154,
    panoId: "jasXOSy6ByR6AWSzRkHkpw",
    place: "Near Arabi, Louisiana",
    shortName: "Arabi",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "LA",
    state: "Louisiana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-LA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-la-067",
    lat: 30.539677,
    lng: -92.163488,
    panoId: "cgOJytBbWvNCBiaBObgFgQ",
    place: "Near Lawtell, Louisiana",
    shortName: "Lawtell",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "LA",
    state: "Louisiana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-LA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-la-068",
    lat: 32.482181,
    lng: -92.678493,
    panoId: "v1uJV8iAGDamopL8_AOIxA",
    place: "Near Ruston, Louisiana",
    shortName: "Ruston",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "LA",
    state: "Louisiana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-LA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-la-069",
    lat: 31.281318,
    lng: -92.461834,
    panoId: "T8s2_qU2Fsk9lu1mT8d4Lw",
    place: "Near Alexandria, Louisiana",
    shortName: "Alexandria",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "LA",
    state: "Louisiana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-LA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-la-070",
    lat: 32.473534,
    lng: -92.103866,
    panoId: "b_e_ZbxAyIaGLDcPDsW4EA",
    place: "Near Richwood, Louisiana",
    shortName: "Richwood",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "LA",
    state: "Louisiana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-LA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-la-071",
    lat: 30.019062,
    lng: -90.132767,
    panoId: "J4dzC6dGDNDoKy5eQ80-fQ",
    place: "Near Metairie, Louisiana",
    shortName: "Metairie",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "LA",
    state: "Louisiana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-LA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-la-072",
    lat: 32.552931,
    lng: -93.696657,
    panoId: "22cz4JyEefMm8Kci_JKhPA",
    place: "Near Bossier City, Louisiana",
    shortName: "Bossier City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "LA",
    state: "Louisiana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-LA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-la-073",
    lat: 30.423416,
    lng: -91.036312,
    panoId: "623-MMVdoUYBRbrJg74w0Q",
    place: "Near Shenandoah, Louisiana",
    shortName: "Shenandoah",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "LA",
    state: "Louisiana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-LA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-la-074",
    lat: 32.575236,
    lng: -93.73128,
    panoId: "s82GC-S4pL_70-R_advjaQ",
    place: "Near Shreveport, Louisiana",
    shortName: "Shreveport",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "LA",
    state: "Louisiana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-LA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-la-075",
    lat: 30.164973,
    lng: -92.034607,
    panoId: "qoRMlbes0G1Pqb--JoqP0Q",
    place: "Near Lafayette, Louisiana",
    shortName: "Lafayette",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "LA",
    state: "Louisiana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-LA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-la-076",
    lat: 30.036701,
    lng: -90.492845,
    panoId: "vxKSCsiLSBhUuzPTzhfLbg",
    place: "Near Laplace, Louisiana",
    shortName: "Laplace",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "LA",
    state: "Louisiana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-LA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-la-077",
    lat: 29.936868,
    lng: -92.1265,
    panoId: "VQeDvsrfcK0woamVsFQnIQ",
    place: "Near Abbeville, Louisiana",
    shortName: "Abbeville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "LA",
    state: "Louisiana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-LA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-la-078",
    lat: 31.27626,
    lng: -92.40565,
    panoId: "W0XSHggyj7PbtT_D269BcQ",
    place: "Near Alexandria, Louisiana",
    shortName: "Alexandria",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "LA",
    state: "Louisiana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-LA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-la-079",
    lat: 32.47033,
    lng: -92.057718,
    panoId: "lAT2QcJNNL5nXhgvy2rFQw",
    place: "Near Richwood, Louisiana",
    shortName: "Richwood",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "LA",
    state: "Louisiana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-LA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-la-080",
    lat: 30.152768,
    lng: -93.228472,
    panoId: "SC9udIm02kUMjBTOr5IF0w",
    place: "Near Prien, Louisiana",
    shortName: "Prien",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "LA",
    state: "Louisiana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-LA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-la-081",
    lat: 30.285747,
    lng: -93.392083,
    panoId: "78f1xR30eT-rQcstqobIDw",
    place: "Near Sulphur, Louisiana",
    shortName: "Sulphur",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "LA",
    state: "Louisiana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-LA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-la-082",
    lat: 31.717361,
    lng: -93.224286,
    panoId: "Yq1hTsgjTh2zugmmy-XHEw",
    place: "Near Natchitoches, Louisiana",
    shortName: "Natchitoches",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "LA",
    state: "Louisiana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-LA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-la-083",
    lat: 29.808117,
    lng: -90.900029,
    panoId: "RfnQjUxHVDI4cpqHiDBI5Q",
    place: "Near Labadieville, Louisiana",
    shortName: "Labadieville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "LA",
    state: "Louisiana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-LA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-la-084",
    lat: 30.276273,
    lng: -89.883335,
    panoId: "XS8-_pAAYlau6PrMmAQSOw",
    place: "Near Lacombe, Louisiana",
    shortName: "Lacombe",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "LA",
    state: "Louisiana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-LA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-la-085",
    lat: 30.686245,
    lng: -91.069579,
    panoId: "qcGA2_W67Xc6kHi7PlVPYQ",
    place: "Near Zachary, Louisiana",
    shortName: "Zachary",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "LA",
    state: "Louisiana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-LA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-la-086",
    lat: 30.763143,
    lng: -91.209468,
    panoId: "PyYD-H1nsENqnhcB-GEiYg",
    place: "Near Jackson, Louisiana",
    shortName: "Jackson",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "LA",
    state: "Louisiana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-LA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-la-087",
    lat: 29.819598,
    lng: -90.04756,
    panoId: "2U80xZICStYjygMxi3hHdQ",
    place: "Near Woodmere, Louisiana",
    shortName: "Woodmere",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "LA",
    state: "Louisiana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-LA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-la-088",
    lat: 29.726249,
    lng: -90.693247,
    panoId: "C_ui2O9Dk07t72U_Yy5Y6g",
    place: "Near Raceland, Louisiana",
    shortName: "Raceland",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "LA",
    state: "Louisiana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-LA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-la-089",
    lat: 30.461692,
    lng: -90.133972,
    panoId: "AWxvh7DNXn9RUPoS4q1c8w",
    place: "Near Covington, Louisiana",
    shortName: "Covington",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "LA",
    state: "Louisiana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-LA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-la-090",
    lat: 29.963565,
    lng: -90.745323,
    panoId: "QAjhuzbRmOAhAr4A0kXgiQ",
    place: "Near North Vacherie, Louisiana",
    shortName: "North Vacherie",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "LA",
    state: "Louisiana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-LA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-la-091",
    lat: 30.046259,
    lng: -90.247583,
    panoId: "BGfT0YA4g1LdQ18hWkc-sg",
    place: "Near Kenner, Louisiana",
    shortName: "Kenner",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "LA",
    state: "Louisiana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-LA"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "us-la-092",
    lat: 30.232608,
    lng: -91.873308,
    panoId: "Zb_CNcCdJMKBSryeZAkUnA",
    place: "Near Breaux Bridge, Louisiana",
    shortName: "Breaux Bridge",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "LA",
    state: "Louisiana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-LA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-la-093",
    lat: 30.311588,
    lng: -93.295106,
    panoId: "dCTU2dq0ErTiWOO4ZlXpJQ",
    place: "Near Westlake, Louisiana",
    shortName: "Westlake",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "LA",
    state: "Louisiana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-LA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-la-094",
    lat: 30.531433,
    lng: -90.486729,
    panoId: "e7lpuhUaKtYapRtwRo1cmg",
    place: "Near Natalbany, Louisiana",
    shortName: "Natalbany",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "LA",
    state: "Louisiana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-LA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-la-095",
    lat: 30.041567,
    lng: -90.278149,
    panoId: "AYaRalxNmI9GjKaOMgzbDA",
    place: "Near Kenner, Louisiana",
    shortName: "Kenner",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "LA",
    state: "Louisiana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-LA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-la-096",
    lat: 30.334169,
    lng: -92.206291,
    panoId: "EPp_0rXJRUMuYOmXAdbDHQ",
    place: "Near Church Point, Louisiana",
    shortName: "Church Point",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "LA",
    state: "Louisiana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-LA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-la-097",
    lat: 32.596843,
    lng: -92.067369,
    panoId: "iD6jdYLVIOu-n9mLd5C3fA",
    place: "Near Lakeshore, Louisiana",
    shortName: "Lakeshore",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "LA",
    state: "Louisiana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-LA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-la-098",
    lat: 29.993113,
    lng: -91.92062,
    panoId: "Vri-fKsjUYTTpx7ba7670A",
    place: "Near Delcambre, Louisiana",
    shortName: "Delcambre",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "LA",
    state: "Louisiana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-LA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-la-099",
    lat: 30.860468,
    lng: -89.745192,
    panoId: "AsOuzxWSG3xzgoWtFp3LCg",
    place: "Near Bogalusa, Louisiana",
    shortName: "Bogalusa",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "LA",
    state: "Louisiana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-LA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-la-100",
    lat: 32.798782,
    lng: -92.138222,
    panoId: "rRpa7vhmERGTuuXALuSRRg",
    place: "Near Sterlington, Louisiana",
    shortName: "Sterlington",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "LA",
    state: "Louisiana",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-LA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-la-101",
    lat: 30.88905,
    lng: -93.084915,
    panoId: "GOOsNZ57BJa-O6wNCC_EaA",
    place: "Near Rosepine, Louisiana",
    shortName: "Rosepine",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "LA",
    state: "Louisiana",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-LA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-la-102",
    lat: 31.134018,
    lng: -93.029182,
    panoId: "IijMR5r9HtaqZCBbzbrbBA",
    place: "Near Fort Polk North, Louisiana",
    shortName: "Fort Polk North",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "LA",
    state: "Louisiana",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-LA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-la-103",
    lat: 30.045531,
    lng: -92.623613,
    panoId: "7nX1Nhjgn6XkJuHbanjjqw",
    place: "Near Lake Arthur, Louisiana",
    shortName: "Lake Arthur",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "LA",
    state: "Louisiana",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-LA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-la-104",
    lat: 30.481109,
    lng: -90.267778,
    panoId: "mLjgSJD7pSZNtAEFVCPetQ",
    place: "Near Covington, Louisiana",
    shortName: "Covington",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "LA",
    state: "Louisiana",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-LA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-la-105",
    lat: 30.89032,
    lng: -93.487157,
    panoId: "2tb30t5l-_AjKsMZaBBYCw",
    place: "Near Merryville, Louisiana",
    shortName: "Merryville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "LA",
    state: "Louisiana",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-LA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-me-000",
    lat: 44.798843,
    lng: -68.772639,
    panoId: "1HfeVOVQ3O99Pkt1AzpstQ",
    place: "Near Bangor, Maine",
    shortName: "Bangor",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ME",
    state: "Maine",
    difficulty: "classic",
    pools: ["world","North America","US","US-ME"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-me-001",
    lat: 43.910602,
    lng: -69.820555,
    panoId: "zJcTQJQIms1RR4_ZCZBO-A",
    place: "Near Bath, Maine",
    shortName: "Bath",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ME",
    state: "Maine",
    difficulty: "classic",
    pools: ["world","North America","US","US-ME"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-me-002",
    lat: 46.860625,
    lng: -68.011928,
    panoId: "2ro6GfdfquKH14ZZ7rc8sg",
    place: "Near Caribou, Maine",
    shortName: "Caribou",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ME",
    state: "Maine",
    difficulty: "classic",
    pools: ["world","North America","US","US-ME"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-me-003",
    lat: 44.100378,
    lng: -70.214783,
    panoId: "3PtAmhZYedaidkdEWh1kdA",
    place: "Near Lewiston, Maine",
    shortName: "Lewiston",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ME",
    state: "Maine",
    difficulty: "classic",
    pools: ["world","North America","US","US-ME"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-me-004",
    lat: 43.637669,
    lng: -70.519152,
    panoId: "GHVHP0dLKvBXCb3nT0HfcA",
    place: "Near Buxton, Maine",
    shortName: "Buxton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ME",
    state: "Maine",
    difficulty: "classic",
    pools: ["world","North America","US","US-ME"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-me-005",
    lat: 43.492567,
    lng: -70.453366,
    panoId: "O0pHzKiUAmv70OCRs0-csA",
    place: "Near Biddeford, Maine",
    shortName: "Biddeford",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ME",
    state: "Maine",
    difficulty: "classic",
    pools: ["world","North America","US","US-ME"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-me-006",
    lat: 44.55199,
    lng: -69.63175,
    panoId: "qkVb2_Rtvd-4R5wltVMVoQ",
    place: "Near Waterville, Maine",
    shortName: "Waterville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ME",
    state: "Maine",
    difficulty: "classic",
    pools: ["world","North America","US","US-ME"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-me-007",
    lat: 43.570449,
    lng: -70.38801,
    panoId: "kD8i1kOyMorfbyNl941NJw",
    place: "Near West Scarborough, Maine",
    shortName: "West Scarborough",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ME",
    state: "Maine",
    difficulty: "classic",
    pools: ["world","North America","US","US-ME"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-me-008",
    lat: 43.171422,
    lng: -70.608921,
    panoId: "CKV14LbWkz90Y3ynYnTChA",
    place: "Near York Beach, Maine",
    shortName: "York Beach",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ME",
    state: "Maine",
    difficulty: "classic",
    pools: ["world","North America","US","US-ME"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-me-009",
    lat: 44.88295,
    lng: -68.67183,
    panoId: "1VWdnM0sMU1Gm4JSC91Q5w",
    place: "Near Orono, Maine",
    shortName: "Orono",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ME",
    state: "Maine",
    difficulty: "classic",
    pools: ["world","North America","US","US-ME"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-me-010",
    lat: 43.657509,
    lng: -70.259022,
    panoId: "JvHCNYOp2GEmophx5a_PrA",
    place: "Near Portland, Maine",
    shortName: "Portland",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ME",
    state: "Maine",
    difficulty: "classic",
    pools: ["world","North America","US","US-ME"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-me-011",
    lat: 43.152885,
    lng: -70.799458,
    panoId: "ixg7aC3lnWliiFJSFHLIgA",
    place: "Near Eliot, Maine",
    shortName: "Eliot",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ME",
    state: "Maine",
    difficulty: "classic",
    pools: ["world","North America","US","US-ME"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-me-012",
    lat: 44.934178,
    lng: -68.645431,
    panoId: "4RJA_JDXcj_5XCK0FgCaiA",
    place: "Near Old Town, Maine",
    shortName: "Old Town",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ME",
    state: "Maine",
    difficulty: "classic",
    pools: ["world","North America","US","US-ME"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-me-013",
    lat: 46.681256,
    lng: -68.015852,
    panoId: "4L1lqHi6uQBCF5Sg-3iOFA",
    place: "Near Presque Isle, Maine",
    shortName: "Presque Isle",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ME",
    state: "Maine",
    difficulty: "classic",
    pools: ["world","North America","US","US-ME"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-me-014",
    lat: 44.426013,
    lng: -69.0064,
    panoId: "1nBm1tsnCDbvdX-d3rkktQ",
    place: "Near Belfast, Maine",
    shortName: "Belfast",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ME",
    state: "Maine",
    difficulty: "classic",
    pools: ["world","North America","US","US-ME"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-me-015",
    lat: 44.103691,
    lng: -69.109134,
    panoId: "mRWjsGvnR43RmCkrvAlkAA",
    place: "Near Rockland, Maine",
    shortName: "Rockland",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ME",
    state: "Maine",
    difficulty: "classic",
    pools: ["world","North America","US","US-ME"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-me-016",
    lat: 43.934968,
    lng: -69.815977,
    panoId: "xNkOGGzoXZEaUPGMP4buCg",
    place: "Near North Bath, Maine",
    shortName: "North Bath",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ME",
    state: "Maine",
    difficulty: "classic",
    pools: ["world","North America","US","US-ME"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-me-017",
    lat: 43.51736,
    lng: -70.377566,
    panoId: "m8fY2YTB9wC2dOT29SM7Pg",
    place: "Near Old Orchard Beach, Maine",
    shortName: "Old Orchard Beach",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ME",
    state: "Maine",
    difficulty: "classic",
    pools: ["world","North America","US","US-ME"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-me-018",
    lat: 44.546993,
    lng: -69.6209,
    panoId: "AkrIDsGUfprdVK-Ctfq9dA",
    place: "Near Winslow, Maine",
    shortName: "Winslow",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ME",
    state: "Maine",
    difficulty: "classic",
    pools: ["world","North America","US","US-ME"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-me-019",
    lat: 44.543275,
    lng: -68.419336,
    panoId: "v6lJg2IikSkwxet2GomDxg",
    place: "Near Ellsworth, Maine",
    shortName: "Ellsworth",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ME",
    state: "Maine",
    difficulty: "classic",
    pools: ["world","North America","US","US-ME"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-me-020",
    lat: 43.234663,
    lng: -70.80921,
    panoId: "olbCjMCJO4E30qvJIKK6XA",
    place: "Near South Berwick, Maine",
    shortName: "South Berwick",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ME",
    state: "Maine",
    difficulty: "classic",
    pools: ["world","North America","US","US-ME"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-me-021",
    lat: 44.310728,
    lng: -69.779621,
    panoId: "kq1dfqrz3wZyr_HzB9m3lA",
    place: "Near Augusta, Maine",
    shortName: "Augusta",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ME",
    state: "Maine",
    difficulty: "classic",
    pools: ["world","North America","US","US-ME"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-me-022",
    lat: 43.679107,
    lng: -70.443909,
    panoId: "Cuu0vy2r4ibGNOzFrfo3Yw",
    place: "Near Gorham, Maine",
    shortName: "Gorham",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ME",
    state: "Maine",
    difficulty: "classic",
    pools: ["world","North America","US","US-ME"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-me-023",
    lat: 43.535604,
    lng: -70.714845,
    panoId: "B1ZGTykiGpLHLeRPwU5eTg",
    place: "Near Waterboro, Maine",
    shortName: "Waterboro",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ME",
    state: "Maine",
    difficulty: "classic",
    pools: ["world","North America","US","US-ME"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-me-024",
    lat: 43.677101,
    lng: -70.37118,
    panoId: "YqW9MFbf78drbwLQocPR8w",
    place: "Near Westbrook, Maine",
    shortName: "Westbrook",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ME",
    state: "Maine",
    difficulty: "classic",
    pools: ["world","North America","US","US-ME"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-me-025",
    lat: 43.800604,
    lng: -70.18672,
    panoId: "4DCrBUm6_sWgk3ErlXmLMQ",
    place: "Near Yarmouth, Maine",
    shortName: "Yarmouth",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ME",
    state: "Maine",
    difficulty: "classic",
    pools: ["world","North America","US","US-ME"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-me-026",
    lat: 43.641449,
    lng: -70.240977,
    panoId: "Hpdh6og5WVI4oV_EGNaI3A",
    place: "Near South Portland, Maine",
    shortName: "South Portland",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ME",
    state: "Maine",
    difficulty: "classic",
    pools: ["world","North America","US","US-ME"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-me-027",
    lat: 43.914509,
    lng: -69.965375,
    panoId: "8xzsGVKIFw-SWdSp9JyTSQ",
    place: "Near Brunswick, Maine",
    shortName: "Brunswick",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ME",
    state: "Maine",
    difficulty: "classic",
    pools: ["world","North America","US","US-ME"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-me-028",
    lat: 44.765095,
    lng: -69.719226,
    panoId: "XkCHV33ZNMfQO2o3mzotkg",
    place: "Near Skowhegan, Maine",
    shortName: "Skowhegan",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ME",
    state: "Maine",
    difficulty: "classic",
    pools: ["world","North America","US","US-ME"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-me-029",
    lat: 43.639053,
    lng: -70.315206,
    panoId: "ZcXjA0C_z4WZ-ankYStHTg",
    place: "Near South Portland Gardens, Maine",
    shortName: "South Portland Gardens",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ME",
    state: "Maine",
    difficulty: "classic",
    pools: ["world","North America","US","US-ME"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-me-030",
    lat: 44.031512,
    lng: -70.104522,
    panoId: "N2m-a-0pt_36D7euZvzcrA",
    place: "Near Lisbon, Maine",
    shortName: "Lisbon",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ME",
    state: "Maine",
    difficulty: "classic",
    pools: ["world","North America","US","US-ME"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-me-031",
    lat: 43.324006,
    lng: -70.591419,
    panoId: "_WcUU5TdP0aL4fbLOlAVPw",
    place: "Near Wells Beach Station, Maine",
    shortName: "Wells Beach Station",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ME",
    state: "Maine",
    difficulty: "classic",
    pools: ["world","North America","US","US-ME"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-me-032",
    lat: 43.500955,
    lng: -70.442848,
    panoId: "Okwjkystbkga4sLIE0mVwQ",
    place: "Near Saco, Maine",
    shortName: "Saco",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ME",
    state: "Maine",
    difficulty: "classic",
    pools: ["world","North America","US","US-ME"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-me-033",
    lat: 43.927676,
    lng: -69.975916,
    panoId: "SZtEzNPVNVsChrU-HJrBDw",
    place: "Near Topsham, Maine",
    shortName: "Topsham",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ME",
    state: "Maine",
    difficulty: "classic",
    pools: ["world","North America","US","US-ME"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-me-034",
    lat: 44.230041,
    lng: -69.775266,
    panoId: "GNLAC-NZYuImg0Y8q0fYfQ",
    place: "Near Gardiner, Maine",
    shortName: "Gardiner",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ME",
    state: "Maine",
    difficulty: "classic",
    pools: ["world","North America","US","US-ME"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-me-035",
    lat: 44.097804,
    lng: -70.23117,
    panoId: "7-abDj0yIDNxojiXK2GSvA",
    place: "Near Auburn, Maine",
    shortName: "Auburn",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ME",
    state: "Maine",
    difficulty: "classic",
    pools: ["world","North America","US","US-ME"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-me-036",
    lat: 44.256424,
    lng: -70.256239,
    panoId: "aaPYgIPDwJEaDgxKaOouew",
    place: "Near Turner, Maine",
    shortName: "Turner",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ME",
    state: "Maine",
    difficulty: "classic",
    pools: ["world","North America","US","US-ME"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-me-037",
    lat: 43.899828,
    lng: -69.795982,
    panoId: "lxf_Sve1qnsoXkvEDd82AA",
    place: "Near Woolwich, Maine",
    shortName: "Woolwich",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ME",
    state: "Maine",
    difficulty: "classic",
    pools: ["world","North America","US","US-ME"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-me-038",
    lat: 43.3948,
    lng: -70.851472,
    panoId: "Ous6iDbRyFBec4qkrlLQHQ",
    place: "Near Lebanon, Maine",
    shortName: "Lebanon",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ME",
    state: "Maine",
    difficulty: "classic",
    pools: ["world","North America","US","US-ME"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-me-039",
    lat: 43.662747,
    lng: -70.366454,
    panoId: "kmgUCiryQGk3HpMH9Koytw",
    place: "Near Westbrook, Maine",
    shortName: "Westbrook",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ME",
    state: "Maine",
    difficulty: "classic",
    pools: ["world","North America","US","US-ME"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-me-040",
    lat: 43.51383,
    lng: -70.458788,
    panoId: "VtcUrLP4H_1EaSt2oFbHCw",
    place: "Near Saco, Maine",
    shortName: "Saco",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ME",
    state: "Maine",
    difficulty: "classic",
    pools: ["world","North America","US","US-ME"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-me-041",
    lat: 44.552941,
    lng: -68.429652,
    panoId: "XlVuhAPvFE3V-z9ulhP0YQ",
    place: "Near Ellsworth, Maine",
    shortName: "Ellsworth",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ME",
    state: "Maine",
    difficulty: "classic",
    pools: ["world","North America","US","US-ME"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-me-042",
    lat: 44.117869,
    lng: -69.103569,
    panoId: "xE4qTL8L9h2D9n63_hOUPg",
    place: "Near Rockland, Maine",
    shortName: "Rockland",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ME",
    state: "Maine",
    difficulty: "classic",
    pools: ["world","North America","US","US-ME"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-me-043",
    lat: 44.772778,
    lng: -69.70396,
    panoId: "2X_mEYCNQSqPFt8mss4ihQ",
    place: "Near Skowhegan, Maine",
    shortName: "Skowhegan",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ME",
    state: "Maine",
    difficulty: "classic",
    pools: ["world","North America","US","US-ME"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-me-044",
    lat: 43.667329,
    lng: -70.437571,
    panoId: "r40Twh-8oZ01rr_5H__Dzg",
    place: "Near Gorham, Maine",
    shortName: "Gorham",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ME",
    state: "Maine",
    difficulty: "classic",
    pools: ["world","North America","US","US-ME"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-me-045",
    lat: 46.688734,
    lng: -68.004967,
    panoId: "Zq0A0Ur-DWDCQy1iGAYplA",
    place: "Near Presque Isle, Maine",
    shortName: "Presque Isle",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ME",
    state: "Maine",
    difficulty: "classic",
    pools: ["world","North America","US","US-ME"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-me-046",
    lat: 43.529666,
    lng: -70.689897,
    panoId: "RBJuJkxlQFBq8709Rd09pA",
    place: "Near Waterboro, Maine",
    shortName: "Waterboro",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ME",
    state: "Maine",
    difficulty: "classic",
    pools: ["world","North America","US","US-ME"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-me-047",
    lat: 44.555,
    lng: -69.646296,
    panoId: "9sB3344FPHZ8wWcdCL7sYg",
    place: "Near Waterville, Maine",
    shortName: "Waterville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ME",
    state: "Maine",
    difficulty: "classic",
    pools: ["world","North America","US","US-ME"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-me-048",
    lat: 43.162494,
    lng: -70.619736,
    panoId: "-9Yqq2PGy69rY_ekqxiDGQ",
    place: "Near York Beach, Maine",
    shortName: "York Beach",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ME",
    state: "Maine",
    difficulty: "classic",
    pools: ["world","North America","US","US-ME"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-me-049",
    lat: 43.637028,
    lng: -70.339221,
    panoId: "LBHBgnqL0C1xusey3vGm7A",
    place: "Near South Portland Gardens, Maine",
    shortName: "South Portland Gardens",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ME",
    state: "Maine",
    difficulty: "classic",
    pools: ["world","North America","US","US-ME"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-me-050",
    lat: 44.500599,
    lng: -69.587611,
    panoId: "jMw3Rjyonp_yAaC2y7W6Ag",
    place: "Near Winslow, Maine",
    shortName: "Winslow",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ME",
    state: "Maine",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ME"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-me-051",
    lat: 43.666246,
    lng: -70.503326,
    panoId: "u_pRxsQgHwvwpUKSUZKmOg",
    place: "Near Buxton, Maine",
    shortName: "Buxton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ME",
    state: "Maine",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ME"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-me-052",
    lat: 44.278946,
    lng: -69.714501,
    panoId: "epFT06GgdVaS1Tut3NjEhA",
    place: "Near Chelsea, Maine",
    shortName: "Chelsea",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ME",
    state: "Maine",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ME"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-me-053",
    lat: 44.064425,
    lng: -70.172725,
    panoId: "mCZPZDh_wGpcKNGWiqxnQQ",
    place: "Near Lewiston, Maine",
    shortName: "Lewiston",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ME",
    state: "Maine",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ME"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-me-054",
    lat: 44.813411,
    lng: -68.715189,
    panoId: "ODtcTcgj8TP6SkYzfU164A",
    place: "Near Eddington, Maine",
    shortName: "Eddington",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ME",
    state: "Maine",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ME"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-me-055",
    lat: 43.768831,
    lng: -70.270583,
    panoId: "U3eh-gJYpI1h0E39iGw8Cg",
    place: "Near Cumberland Center, Maine",
    shortName: "Cumberland Center",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ME",
    state: "Maine",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ME"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-me-056",
    lat: 44.102904,
    lng: -70.268302,
    panoId: "0TTETOjgi2-A-tRZcYUgbw",
    place: "Near Auburn, Maine",
    shortName: "Auburn",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ME",
    state: "Maine",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ME"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-me-057",
    lat: 44.291087,
    lng: -70.187541,
    panoId: "gsqPtKq3Jy4qr-aTHsHy8A",
    place: "Near Leeds, Maine",
    shortName: "Leeds",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ME",
    state: "Maine",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ME"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-me-058",
    lat: 44.250304,
    lng: -69.700596,
    panoId: "u-U58PP9oOFCyPxmBIRdsw",
    place: "Near Chelsea, Maine",
    shortName: "Chelsea",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ME",
    state: "Maine",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ME"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-me-059",
    lat: 43.562815,
    lng: -70.48786,
    panoId: "SUi0b5-04OHREFevMTwCxQ",
    place: "Near Dayton, Maine",
    shortName: "Dayton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ME",
    state: "Maine",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ME"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-me-060",
    lat: 44.861495,
    lng: -68.727642,
    panoId: "NDVfEHh6BwrRuqGPkdFDaQ",
    place: "Near Veazie, Maine",
    shortName: "Veazie",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ME",
    state: "Maine",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ME"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-me-061",
    lat: 44.140221,
    lng: -69.120251,
    panoId: "W3QLCUMXTc5NV_IN4LbgWg",
    place: "Near Rockland, Maine",
    shortName: "Rockland",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ME",
    state: "Maine",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ME"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-me-062",
    lat: 43.605189,
    lng: -70.2873,
    panoId: "GETTJ0YCKzpgTWf5qGyXvw",
    place: "Near Scarborough, Maine",
    shortName: "Scarborough",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ME",
    state: "Maine",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ME"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-me-063",
    lat: 43.84802,
    lng: -69.952128,
    panoId: "e-4U-Ybu800atshV3dflyA",
    place: "Near Harpswell Center, Maine",
    shortName: "Harpswell Center",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ME",
    state: "Maine",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ME"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-me-064",
    lat: 44.74181,
    lng: -68.813339,
    panoId: "Xp9t0lr7yX4uzSrkaB4EpA",
    place: "Near Orrington, Maine",
    shortName: "Orrington",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ME",
    state: "Maine",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ME"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-me-065",
    lat: 44.05892,
    lng: -70.269809,
    panoId: "flwNeGd786bJmjlOke69bA",
    place: "Near Minot, Maine",
    shortName: "Minot",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ME",
    state: "Maine",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ME"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-me-066",
    lat: 43.271734,
    lng: -70.654172,
    panoId: "TvmCZMFjWjk7a7f6KDLkeA",
    place: "Near Ogunquit, Maine",
    shortName: "Ogunquit",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ME",
    state: "Maine",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ME"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-me-067",
    lat: 44.328845,
    lng: -69.735795,
    panoId: "X2sV1uSccPMe5MbUi5FFIA",
    place: "Near Augusta, Maine",
    shortName: "Augusta",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ME",
    state: "Maine",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ME"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-me-068",
    lat: 44.554008,
    lng: -68.372889,
    panoId: "Am8xIFvdINo6zRDtL0Kk5Q",
    place: "Near Ellsworth, Maine",
    shortName: "Ellsworth",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ME",
    state: "Maine",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ME"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-me-069",
    lat: 43.725907,
    lng: -70.405387,
    panoId: "i9Exn-pwbLIpSQs58ws1Iw",
    place: "Near South Windham, Maine",
    shortName: "South Windham",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ME",
    state: "Maine",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ME"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-me-070",
    lat: 43.675154,
    lng: -70.516405,
    panoId: "sLXnu2Lgxrd2R3t5sSetww",
    place: "Near Buxton, Maine",
    shortName: "Buxton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ME",
    state: "Maine",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ME"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-me-071",
    lat: 44.59161,
    lng: -69.600265,
    panoId: "pXvqoBxb8IIROJ36A4cWUQ",
    place: "Near Fairfield, Maine",
    shortName: "Fairfield",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ME",
    state: "Maine",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ME"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-me-072",
    lat: 44.766863,
    lng: -69.808727,
    panoId: "6D7dOVPwZYx2pgCojo1KPQ",
    place: "Near Norridgewock, Maine",
    shortName: "Norridgewock",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ME",
    state: "Maine",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ME"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-me-073",
    lat: 43.766071,
    lng: -70.238757,
    panoId: "bU6J6Vb36fNsoAB4XOqq1A",
    place: "Near Cumberland Center, Maine",
    shortName: "Cumberland Center",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ME",
    state: "Maine",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ME"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-me-074",
    lat: 44.567278,
    lng: -69.564917,
    panoId: "VYX7BLGGLF9jTTkIKjKw-A",
    place: "Near Benton, Maine",
    shortName: "Benton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ME",
    state: "Maine",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ME"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-me-075",
    lat: 43.429336,
    lng: -70.422757,
    panoId: "LLCu9q4JSwx3v-WFIB9m8w",
    place: "Near Arundel, Maine",
    shortName: "Arundel",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ME",
    state: "Maine",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ME"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-me-076",
    lat: 43.330682,
    lng: -70.890285,
    panoId: "G11R2SDYKgewomK1qU-pLw",
    place: "Near Rochester, Maine",
    shortName: "Rochester",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ME",
    state: "Maine",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ME"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-me-077",
    lat: 43.850897,
    lng: -69.812663,
    panoId: "-fixzwDYUm0HUyYNzfuIkQ",
    place: "Near Phippsburg, Maine",
    shortName: "Phippsburg",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ME",
    state: "Maine",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ME"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-me-078",
    lat: 46.889745,
    lng: -67.96498,
    panoId: "uF5Qbg63lKAa4kTaLBl1Uw",
    place: "Near Madawaska, Maine",
    shortName: "Madawaska",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ME",
    state: "Maine",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ME"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-me-079",
    lat: 44.175945,
    lng: -69.802648,
    panoId: "nkZqr6fWB1s5NXgO14LxAA",
    place: "Near Pittston, Maine",
    shortName: "Pittston",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ME",
    state: "Maine",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ME"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-me-080",
    lat: 46.63794,
    lng: -67.951984,
    panoId: "Z0bdVLFyjeXy2qf7lIY9MQ",
    place: "Near Easton, Maine",
    shortName: "Easton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ME",
    state: "Maine",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ME"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-me-081",
    lat: 44.050605,
    lng: -69.81891,
    panoId: "PpfXOtrP1G6PxQXxSD0YjA",
    place: "Near Richmond, Maine",
    shortName: "Richmond",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ME",
    state: "Maine",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ME"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-me-082",
    lat: 44.251876,
    lng: -70.33228,
    panoId: "tv0Ajkc3R36WQwhSmfql4A",
    place: "Near Buckfield, Maine",
    shortName: "Buckfield",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ME",
    state: "Maine",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ME"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-me-083",
    lat: 43.691417,
    lng: -70.328446,
    panoId: "q4a76N2G6zG5Pw40NgbTxg",
    place: "Near Westbrook, Maine",
    shortName: "Westbrook",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ME",
    state: "Maine",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ME"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-me-084",
    lat: 43.865704,
    lng: -70.023717,
    panoId: "24M_lQrqgjvk7bOHcjnrQQ",
    place: "Near Freeport, Maine",
    shortName: "Freeport",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ME",
    state: "Maine",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ME"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-me-085",
    lat: 44.141135,
    lng: -70.188914,
    panoId: "6-HBg1PqiomttbZYPgZC3A",
    place: "Near Lewiston, Maine",
    shortName: "Lewiston",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ME",
    state: "Maine",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ME"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-me-086",
    lat: 44.826536,
    lng: -68.898297,
    panoId: "laS2AovzGzdF6j9uyMxIgA",
    place: "Near Hermon, Maine",
    shortName: "Hermon",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ME",
    state: "Maine",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ME"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-me-087",
    lat: 44.745035,
    lng: -68.659627,
    panoId: "hD7QGoV_p498ZL-3G2y_EA",
    place: "Near Holden, Maine",
    shortName: "Holden",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ME",
    state: "Maine",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ME"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-me-088",
    lat: 44.135739,
    lng: -69.882067,
    panoId: "2bEaMTbC5YFYTc5URuXOCQ",
    place: "Near Richmond, Maine",
    shortName: "Richmond",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ME",
    state: "Maine",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ME"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-me-089",
    lat: 43.297521,
    lng: -70.875789,
    panoId: "uFqh8x4LQ-5VxDcJMuUO8w",
    place: "Near Berwick, Maine",
    shortName: "Berwick",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ME",
    state: "Maine",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ME"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-me-090",
    lat: 44.986481,
    lng: -68.703849,
    panoId: "-XRNDbcNKP05Qsndmw-OMA",
    place: "Near Milford, Maine",
    shortName: "Milford",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ME",
    state: "Maine",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ME"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-me-091",
    lat: 43.82852,
    lng: -70.216551,
    panoId: "KteulSH00uXZADJ8wHc94w",
    place: "Near Yarmouth, Maine",
    shortName: "Yarmouth",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ME",
    state: "Maine",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ME"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-me-092",
    lat: 44.164023,
    lng: -70.46528,
    panoId: "dBbKoG3IlHz--ASbkqdEeQ",
    place: "Near Oxford, Maine",
    shortName: "Oxford",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ME",
    state: "Maine",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ME"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-me-093",
    lat: 43.783562,
    lng: -70.314176,
    panoId: "QkNKKNapoyw2kqVYojUSdA",
    place: "Near Cumberland Center, Maine",
    shortName: "Cumberland Center",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ME",
    state: "Maine",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ME"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-me-094",
    lat: 43.717482,
    lng: -70.77979,
    panoId: "hc4WRCsqNH2JQ3PyTamEyw",
    place: "Near Limerick, Maine",
    shortName: "Limerick",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ME",
    state: "Maine",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ME"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-me-095",
    lat: 44.685027,
    lng: -68.710278,
    panoId: "hkrth5WP-2rlEJEZbVkKZw",
    place: "Near Dedham, Maine",
    shortName: "Dedham",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ME",
    state: "Maine",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ME"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-me-096",
    lat: 44.048503,
    lng: -70.272849,
    panoId: "rRryyn1hnq4sR-qVL1KPOQ",
    place: "Near Minot, Maine",
    shortName: "Minot",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ME",
    state: "Maine",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ME"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-me-097",
    lat: 43.555061,
    lng: -70.514714,
    panoId: "qB_ESuMTRd2630vXGsqSHQ",
    place: "Near Dayton, Maine",
    shortName: "Dayton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ME",
    state: "Maine",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ME"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-me-098",
    lat: 43.928142,
    lng: -70.40551,
    panoId: "lgSwRWydMlQsrJpV4wQwxg",
    place: "Near Raymond, Maine",
    shortName: "Raymond",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ME",
    state: "Maine",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ME"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-me-099",
    lat: 44.166032,
    lng: -70.449474,
    panoId: "RxjFFS23oS7QsO-NoWZgdg",
    place: "Near Hebron, Maine",
    shortName: "Hebron",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ME",
    state: "Maine",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ME"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-me-100",
    lat: 44.293566,
    lng: -69.314035,
    panoId: "ESYnF4f1QpZ1WYL1I4UYdA",
    place: "Near Washington, Maine",
    shortName: "Washington",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ME",
    state: "Maine",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-ME"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-me-101",
    lat: 44.444193,
    lng: -70.11436,
    panoId: "ZfCH6vtVa1fddPyTiJBKKQ",
    place: "Near Livermore Falls, Maine",
    shortName: "Livermore Falls",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ME",
    state: "Maine",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-ME"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-me-102",
    lat: 44.614933,
    lng: -70.185222,
    panoId: "DiWAL6YdvdWdue_LMciaBA",
    place: "Near Wilton, Maine",
    shortName: "Wilton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ME",
    state: "Maine",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-ME"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-me-103",
    lat: 44.813652,
    lng: -68.508636,
    panoId: "R-OEGY9UK3nHxqiYrVyoKw",
    place: "Near Eddington, Maine",
    shortName: "Eddington",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ME",
    state: "Maine",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-ME"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-me-104",
    lat: 44.746471,
    lng: -69.06696,
    panoId: "UN6jARuvGivySYU9K9zVuw",
    place: "Near Carmel, Maine",
    shortName: "Carmel",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ME",
    state: "Maine",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-ME"],
    qualityTier: 4,
    verified: true,
  },
];

const CHUNK_2: GeoLocation[] = [
  {
    id: "us-me-105",
    lat: 44.741791,
    lng: -69.09952,
    panoId: "NOUWpVUX8WRVebax0nZjoQ",
    place: "Near Carmel, Maine",
    shortName: "Carmel",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ME",
    state: "Maine",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-ME"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-md-000",
    lat: 39.288427,
    lng: -77.203762,
    panoId: "UX3YsKec7z7i3dTFIlWIug",
    place: "Near Damascus, Maryland",
    shortName: "Damascus",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MD",
    state: "Maryland",
    difficulty: "classic",
    pools: ["world","North America","US","US-MD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-md-001",
    lat: 39.290449,
    lng: -76.612206,
    panoId: "-n6h12HuHAFYpNLXXG7t5Q",
    place: "Near Baltimore, Maryland",
    shortName: "Baltimore",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MD",
    state: "Maryland",
    difficulty: "classic",
    pools: ["world","North America","US","US-MD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-md-002",
    lat: 39.653038,
    lng: -78.762624,
    panoId: "ECFXKy12dRHn1w0rUQ-pUw",
    place: "Near Cumberland, Maryland",
    shortName: "Cumberland",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MD",
    state: "Maryland",
    difficulty: "classic",
    pools: ["world","North America","US","US-MD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-md-003",
    lat: 39.083989,
    lng: -77.152897,
    panoId: "J5tFBGZ1XMWanL3Ks072Mg",
    place: "Near Rockville, Maryland",
    shortName: "Rockville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MD",
    state: "Maryland",
    difficulty: "classic",
    pools: ["world","North America","US","US-MD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-md-004",
    lat: 39.401255,
    lng: -76.601903,
    panoId: "hFd3fe-of1uon8u21QqdjQ",
    place: "Near Towson, Maryland",
    shortName: "Towson",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MD",
    state: "Maryland",
    difficulty: "classic",
    pools: ["world","North America","US","US-MD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-md-005",
    lat: 39.267291,
    lng: -76.798317,
    panoId: "Hz8JcV2YtCwkagIGdc8ADw",
    place: "Near Ellicott City, Maryland",
    shortName: "Ellicott City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MD",
    state: "Maryland",
    difficulty: "classic",
    pools: ["world","North America","US","US-MD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-md-006",
    lat: 38.9805,
    lng: -76.314193,
    panoId: "glvpiBkAmHNRnB6DqzRUrA",
    place: "Near Stevensville, Maryland",
    shortName: "Stevensville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MD",
    state: "Maryland",
    difficulty: "classic",
    pools: ["world","North America","US","US-MD"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-md-007",
    lat: 39.509543,
    lng: -76.164155,
    panoId: "H5_A0iMtHOSUQ_zOdPb5Lw",
    place: "Near Aberdeen, Maryland",
    shortName: "Aberdeen",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MD",
    state: "Maryland",
    difficulty: "classic",
    pools: ["world","North America","US","US-MD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-md-008",
    lat: 39.309388,
    lng: -77.297111,
    panoId: "w4SwziZUprt6y1f5wqaXqQ",
    place: "Near Green Valley, Maryland",
    shortName: "Green Valley",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MD",
    state: "Maryland",
    difficulty: "classic",
    pools: ["world","North America","US","US-MD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-md-009",
    lat: 39.37279,
    lng: -77.435174,
    panoId: "jxgTF-49aM7lG3ehPtaEeg",
    place: "Near Ballenger Creek, Maryland",
    shortName: "Ballenger Creek",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MD",
    state: "Maryland",
    difficulty: "classic",
    pools: ["world","North America","US","US-MD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-md-010",
    lat: 38.887625,
    lng: -76.511728,
    panoId: "kCqHE9zKHzcTHmUDVJuyCQ",
    place: "Near Mayo, Maryland",
    shortName: "Mayo",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MD",
    state: "Maryland",
    difficulty: "classic",
    pools: ["world","North America","US","US-MD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-md-011",
    lat: 38.5293,
    lng: -76.97527,
    panoId: "Xy2-zO-Bh4rcZXuuk2MDQg",
    place: "Near La Plata, Maryland",
    shortName: "La Plata",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MD",
    state: "Maryland",
    difficulty: "classic",
    pools: ["world","North America","US","US-MD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-md-012",
    lat: 38.563136,
    lng: -76.078588,
    panoId: "zOecs9FCUFxI7UkCyMMK7A",
    place: "Near Cambridge, Maryland",
    shortName: "Cambridge",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MD",
    state: "Maryland",
    difficulty: "classic",
    pools: ["world","North America","US","US-MD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-md-013",
    lat: 39.549244,
    lng: -76.09168,
    panoId: "osKhZ-LZlL2inPtmsny2AQ",
    place: "Near Havre de Grace, Maryland",
    shortName: "Havre de Grace",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MD",
    state: "Maryland",
    difficulty: "classic",
    pools: ["world","North America","US","US-MD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-md-014",
    lat: 39.535863,
    lng: -76.348181,
    panoId: "Y-e-Zzzucm7oJeous5Tn8g",
    place: "Near Bel Air, Maryland",
    shortName: "Bel Air",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MD",
    state: "Maryland",
    difficulty: "classic",
    pools: ["world","North America","US","US-MD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-md-015",
    lat: 38.350019,
    lng: -76.419374,
    panoId: "ZA8j--wjJ_4ZAjyH9beocw",
    place: "Near Chesapeake Ranch Estates-Drum Point, Maryland",
    shortName: "Chesapeake Ranch Estates-Drum Point",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MD",
    state: "Maryland",
    difficulty: "classic",
    pools: ["world","North America","US","US-MD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-md-016",
    lat: 39.658096,
    lng: -78.92838,
    panoId: "lHcQxI-ql2cga_8EZkaI9A",
    place: "Near Frostburg, Maryland",
    shortName: "Frostburg",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MD",
    state: "Maryland",
    difficulty: "classic",
    pools: ["world","North America","US","US-MD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-md-017",
    lat: 38.395269,
    lng: -75.155417,
    panoId: "ZRDvG4Wvm1tTD8A3I5GG1w",
    place: "Near Ocean Pines, Maryland",
    shortName: "Ocean Pines",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MD",
    state: "Maryland",
    difficulty: "classic",
    pools: ["world","North America","US","US-MD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-md-018",
    lat: 39.410709,
    lng: -77.301274,
    panoId: "mhrajoEzi0cxAkYFL1bFeg",
    place: "Near Linganore, Maryland",
    shortName: "Linganore",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MD",
    state: "Maryland",
    difficulty: "classic",
    pools: ["world","North America","US","US-MD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-md-019",
    lat: 39.620532,
    lng: -77.759034,
    panoId: "SbXoNcSZzvH2doX6vi_EQg",
    place: "Near Halfway, Maryland",
    shortName: "Halfway",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MD",
    state: "Maryland",
    difficulty: "classic",
    pools: ["world","North America","US","US-MD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-md-020",
    lat: 39.575313,
    lng: -76.995722,
    panoId: "C67HXKbKNB5chxy81KDGaw",
    place: "Near Westminster, Maryland",
    shortName: "Westminster",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MD",
    state: "Maryland",
    difficulty: "classic",
    pools: ["world","North America","US","US-MD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-md-021",
    lat: 39.325965,
    lng: -77.351413,
    panoId: "kIAmxgnq2D4TFSq1401uFw",
    place: "Near Urbana, Maryland",
    shortName: "Urbana",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MD",
    state: "Maryland",
    difficulty: "classic",
    pools: ["world","North America","US","US-MD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-md-022",
    lat: 38.266643,
    lng: -76.453897,
    panoId: "M8ITlIz3M2hkOHKXJmXgGQ",
    place: "Near Lexington Park, Maryland",
    shortName: "Lexington Park",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MD",
    state: "Maryland",
    difficulty: "classic",
    pools: ["world","North America","US","US-MD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-md-023",
    lat: 39.414152,
    lng: -77.410576,
    panoId: "zryAWYKM1a6tRHdSBGj1gA",
    place: "Near Frederick, Maryland",
    shortName: "Frederick",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MD",
    state: "Maryland",
    difficulty: "classic",
    pools: ["world","North America","US","US-MD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-md-024",
    lat: 39.376176,
    lng: -77.154613,
    panoId: "RO0VuTXTnHMCjCE5diJ-pw",
    place: "Near Mount Airy, Maryland",
    shortName: "Mount Airy",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MD",
    state: "Maryland",
    difficulty: "classic",
    pools: ["world","North America","US","US-MD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-md-025",
    lat: 39.606753,
    lng: -75.833231,
    panoId: "Erd9DYXHIUNVCa-WwQxP9Q",
    place: "Near Elkton, Maryland",
    shortName: "Elkton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MD",
    state: "Maryland",
    difficulty: "classic",
    pools: ["world","North America","US","US-MD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-md-026",
    lat: 39.641825,
    lng: -77.719893,
    panoId: "kSKa3unFGBSsC8Ab1BZoDQ",
    place: "Near Hagerstown, Maryland",
    shortName: "Hagerstown",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MD",
    state: "Maryland",
    difficulty: "classic",
    pools: ["world","North America","US","US-MD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-md-027",
    lat: 38.774278,
    lng: -76.076259,
    panoId: "HcYedlMXtkn7E2D9EYhOrA",
    place: "Near Easton, Maryland",
    shortName: "Easton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MD",
    state: "Maryland",
    difficulty: "classic",
    pools: ["world","North America","US","US-MD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-md-028",
    lat: 38.336503,
    lng: -75.084914,
    panoId: "zL5wc8DxTShZj0U--tYE2Q",
    place: "Near Ocean City, Maryland",
    shortName: "Ocean City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MD",
    state: "Maryland",
    difficulty: "classic",
    pools: ["world","North America","US","US-MD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-md-029",
    lat: 38.933561,
    lng: -76.549213,
    panoId: "VjGZfsiU6SSYWG00fGv-Gg",
    place: "Near Londontowne, Maryland",
    shortName: "Londontowne",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MD",
    state: "Maryland",
    difficulty: "classic",
    pools: ["world","North America","US","US-MD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-md-030",
    lat: 39.636972,
    lng: -77.656795,
    panoId: "T9u_G2kzrn1soSf_mIP3ZA",
    place: "Near Robinwood, Maryland",
    shortName: "Robinwood",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MD",
    state: "Maryland",
    difficulty: "classic",
    pools: ["world","North America","US","US-MD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-md-031",
    lat: 38.978581,
    lng: -76.491812,
    panoId: "2K0tsGwP_SKWGKpWzz-FgA",
    place: "Near Annapolis, Maryland",
    shortName: "Annapolis",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MD",
    state: "Maryland",
    difficulty: "classic",
    pools: ["world","North America","US","US-MD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-md-032",
    lat: 39.238785,
    lng: -77.279413,
    panoId: "kosvmhgKtBxFm7MBw7P8qg",
    place: "Near Clarksburg, Maryland",
    shortName: "Clarksburg",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MD",
    state: "Maryland",
    difficulty: "classic",
    pools: ["world","North America","US","US-MD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-md-033",
    lat: 38.300389,
    lng: -76.507463,
    panoId: "rY62QBhCd2W5an3Zn-Uz3A",
    place: "Near California, Maryland",
    shortName: "California",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MD",
    state: "Maryland",
    difficulty: "classic",
    pools: ["world","North America","US","US-MD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-md-034",
    lat: 39.604902,
    lng: -76.850004,
    panoId: "SbnZVeVa46h3mDHh1Yfptg",
    place: "Near Hampstead, Maryland",
    shortName: "Hampstead",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MD",
    state: "Maryland",
    difficulty: "classic",
    pools: ["world","North America","US","US-MD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-md-035",
    lat: 39.623523,
    lng: -77.410914,
    panoId: "dqQ_FO6SqmozvDa-jlK4cA",
    place: "Near Thurmont, Maryland",
    shortName: "Thurmont",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MD",
    state: "Maryland",
    difficulty: "classic",
    pools: ["world","North America","US","US-MD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-md-036",
    lat: 39.657919,
    lng: -77.174438,
    panoId: "puT_bSHQJwuze9PE75YTcg",
    place: "Near Taneytown, Maryland",
    shortName: "Taneytown",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MD",
    state: "Maryland",
    difficulty: "classic",
    pools: ["world","North America","US","US-MD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-md-037",
    lat: 39.314266,
    lng: -77.627713,
    panoId: "W4O61w80DF8xvgnJh3AywQ",
    place: "Near Brunswick, Maryland",
    shortName: "Brunswick",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MD",
    state: "Maryland",
    difficulty: "classic",
    pools: ["world","North America","US","US-MD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-md-038",
    lat: 39.484916,
    lng: -76.161538,
    panoId: "bR8BH6ul66A_l-N_tBT6uA",
    place: "Near Aberdeen, Maryland",
    shortName: "Aberdeen",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MD",
    state: "Maryland",
    difficulty: "classic",
    pools: ["world","North America","US","US-MD"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-md-039",
    lat: 38.54049,
    lng: -76.971898,
    panoId: "DsRWgqLhiwoxZtVpuSaKLw",
    place: "Near La Plata, Maryland",
    shortName: "La Plata",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MD",
    state: "Maryland",
    difficulty: "classic",
    pools: ["world","North America","US","US-MD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-md-040",
    lat: 38.93661,
    lng: -76.536506,
    panoId: "vbMjK-89zf1PkRl5bYdrAw",
    place: "Near Londontowne, Maryland",
    shortName: "Londontowne",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MD",
    state: "Maryland",
    difficulty: "classic",
    pools: ["world","North America","US","US-MD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-md-041",
    lat: 39.379512,
    lng: -77.460533,
    panoId: "LjRPvzqjPwsgUu7tAEwqgg",
    place: "Near Ballenger Creek, Maryland",
    shortName: "Ballenger Creek",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MD",
    state: "Maryland",
    difficulty: "classic",
    pools: ["world","North America","US","US-MD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-md-042",
    lat: 38.97794,
    lng: -76.290709,
    panoId: "uT3vjzDLq9eWVEZ7HAy0Kw",
    place: "Near Chester, Maryland",
    shortName: "Chester",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MD",
    state: "Maryland",
    difficulty: "classic",
    pools: ["world","North America","US","US-MD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-md-043",
    lat: 39.557441,
    lng: -77.008938,
    panoId: "pM6_9-pTsBq34TI-_YQu0g",
    place: "Near Westminster, Maryland",
    shortName: "Westminster",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MD",
    state: "Maryland",
    difficulty: "classic",
    pools: ["world","North America","US","US-MD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-md-044",
    lat: 39.591354,
    lng: -75.827178,
    panoId: "pxHmdSkOnIRV3zYFh6Euew",
    place: "Near Elkton, Maryland",
    shortName: "Elkton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MD",
    state: "Maryland",
    difficulty: "classic",
    pools: ["world","North America","US","US-MD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-md-045",
    lat: 39.090142,
    lng: -77.128844,
    panoId: "mombqrhMrSQUe1_YrWni1A",
    place: "Near Rockville, Maryland",
    shortName: "Rockville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MD",
    state: "Maryland",
    difficulty: "classic",
    pools: ["world","North America","US","US-MD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-md-046",
    lat: 39.417374,
    lng: -76.59921,
    panoId: "hZNah6VuAGlRmm6m3ngYGA",
    place: "Near Hampton, Maryland",
    shortName: "Hampton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MD",
    state: "Maryland",
    difficulty: "classic",
    pools: ["world","North America","US","US-MD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-md-047",
    lat: 39.55234,
    lng: -76.113416,
    panoId: "cZukriZ5vG_KR8ZChXFhNw",
    place: "Near Havre de Grace, Maryland",
    shortName: "Havre de Grace",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MD",
    state: "Maryland",
    difficulty: "classic",
    pools: ["world","North America","US","US-MD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-md-048",
    lat: 39.219097,
    lng: -77.295034,
    panoId: "I4a11Q0jbS37YSKSNIVQAw",
    place: "Near Clarksburg, Maryland",
    shortName: "Clarksburg",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MD",
    state: "Maryland",
    difficulty: "classic",
    pools: ["world","North America","US","US-MD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-md-049",
    lat: 38.345844,
    lng: -76.436085,
    panoId: "c6Y0PJMGThQVFvWHgYVFWA",
    place: "Near Lusby, Maryland",
    shortName: "Lusby",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MD",
    state: "Maryland",
    difficulty: "classic",
    pools: ["world","North America","US","US-MD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-md-050",
    lat: 39.433934,
    lng: -77.341442,
    panoId: "vRWEDQ-5UPkOQDxiCDKdxQ",
    place: "Near Spring Ridge, Maryland",
    shortName: "Spring Ridge",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MD",
    state: "Maryland",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-md-051",
    lat: 39.265103,
    lng: -77.37082,
    panoId: "-OLn5wGn8kGRzPQDzk8kYQ",
    place: "Near Urbana, Maryland",
    shortName: "Urbana",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MD",
    state: "Maryland",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-md-052",
    lat: 39.586867,
    lng: -77.460381,
    panoId: "QqolFJ4FpQzcB9kCXtlsLw",
    place: "Near Thurmont, Maryland",
    shortName: "Thurmont",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MD",
    state: "Maryland",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-md-053",
    lat: 39.637416,
    lng: -78.704908,
    panoId: "uO6ZzQJHCd7OY_XgXuowtg",
    place: "Near Cumberland, Maryland",
    shortName: "Cumberland",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MD",
    state: "Maryland",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-md-054",
    lat: 38.267202,
    lng: -76.537817,
    panoId: "7uUYSKXjUHdP_VE-aYEGXw",
    place: "Near California, Maryland",
    shortName: "California",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MD",
    state: "Maryland",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-md-055",
    lat: 38.322337,
    lng: -76.481488,
    panoId: "RkE_n3gZpc9jMJZEv5f3NQ",
    place: "Near Solomons, Maryland",
    shortName: "Solomons",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MD",
    state: "Maryland",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-md-056",
    lat: 39.656485,
    lng: -77.269789,
    panoId: "V5Z32TowfamN6FMPG9XFVA",
    place: "Near Emmitsburg, Maryland",
    shortName: "Emmitsburg",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MD",
    state: "Maryland",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-md-057",
    lat: 38.40161,
    lng: -75.629388,
    panoId: "8i1K2F7MyWtH_lEzw3EdRA",
    place: "Near Salisbury, Maryland",
    shortName: "Salisbury",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MD",
    state: "Maryland",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-md-058",
    lat: 38.966841,
    lng: -76.580805,
    panoId: "Ok4VhF6cKKjg2gnQUZhYbw",
    place: "Near Riva, Maryland",
    shortName: "Riva",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MD",
    state: "Maryland",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-md-059",
    lat: 39.381788,
    lng: -77.272038,
    panoId: "SRUbpmnWGh2ifYSo_hHYDQ",
    place: "Near New Market, Maryland",
    shortName: "New Market",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MD",
    state: "Maryland",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-md-060",
    lat: 38.321466,
    lng: -75.147161,
    panoId: "H2bVjL10z29z_F9s4pPA3Q",
    place: "Near West Ocean City, Maryland",
    shortName: "West Ocean City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MD",
    state: "Maryland",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MD"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-md-061",
    lat: 38.609073,
    lng: -76.020681,
    panoId: "t069aZ7RC7Wy_jqF_jdAvQ",
    place: "Near Trappe, Maryland",
    shortName: "Trappe",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MD",
    state: "Maryland",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-md-062",
    lat: 39.348684,
    lng: -77.201167,
    panoId: "JD_yYh9hoHgWccRr3TlPnA",
    place: "Near Mount Airy, Maryland",
    shortName: "Mount Airy",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MD",
    state: "Maryland",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-md-063",
    lat: 39.519015,
    lng: -76.241175,
    panoId: "2N_ZLHv5e1fW_EXQ4wU7gA",
    place: "Near Riverside, Maryland",
    shortName: "Riverside",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MD",
    state: "Maryland",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-md-064",
    lat: 39.470999,
    lng: -77.38148,
    panoId: "jzA20t5dfiB83qP_n66buw",
    place: "Near Walkersville, Maryland",
    shortName: "Walkersville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MD",
    state: "Maryland",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-md-065",
    lat: 39.65613,
    lng: -78.834141,
    panoId: "Jib_2rrxkN4PbgdAVDNv3Q",
    place: "Near La Vale, Maryland",
    shortName: "La Vale",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MD",
    state: "Maryland",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-md-066",
    lat: 39.492465,
    lng: -77.297451,
    panoId: "r9JQSrqq8VMRy2x7uAJocQ",
    place: "Near Walkersville, Maryland",
    shortName: "Walkersville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MD",
    state: "Maryland",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-md-067",
    lat: 39.662388,
    lng: -76.849528,
    panoId: "bTJrlLgZVHriPMcNnkfACw",
    place: "Near Manchester, Maryland",
    shortName: "Manchester",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MD",
    state: "Maryland",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-md-068",
    lat: 39.66873,
    lng: -75.803973,
    panoId: "u27-zl392AaOrlQH5uabCw",
    place: "Near Newark, Maryland",
    shortName: "Newark",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MD",
    state: "Maryland",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-md-069",
    lat: 39.349765,
    lng: -77.410649,
    panoId: "Muxy2pcK2og-hbWNnE8kLA",
    place: "Near Buckeystown, Maryland",
    shortName: "Buckeystown",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MD",
    state: "Maryland",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MD"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-md-070",
    lat: 39.276414,
    lng: -76.869531,
    panoId: "LeIv2n-yBS2VsySQgDo1GA",
    place: "Near Columbia, Maryland",
    shortName: "Columbia",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MD",
    state: "Maryland",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MD"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-md-071",
    lat: 39.617729,
    lng: -77.005724,
    panoId: "rLLJwKfU7ftK4P6PQyJwKg",
    place: "Near Westminster, Maryland",
    shortName: "Westminster",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MD",
    state: "Maryland",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-md-072",
    lat: 39.080062,
    lng: -77.115872,
    panoId: "uRQaLvLGaWqFMCtAoQU-bw",
    place: "Near Rockville, Maryland",
    shortName: "Rockville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MD",
    state: "Maryland",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-md-073",
    lat: 38.758745,
    lng: -76.132354,
    panoId: "BDZdbzlgUiFYzj9nCOVvlQ",
    place: "Near Easton, Maryland",
    shortName: "Easton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MD",
    state: "Maryland",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-md-074",
    lat: 38.349731,
    lng: -75.150025,
    panoId: "sNz1K9Jx3yhJuF6HxwkKcQ",
    place: "Near West Ocean City, Maryland",
    shortName: "West Ocean City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MD",
    state: "Maryland",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-md-075",
    lat: 38.981082,
    lng: -76.27036,
    panoId: "CporvFuVNghb_L2PD9ydWg",
    place: "Near Chester, Maryland",
    shortName: "Chester",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MD",
    state: "Maryland",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-md-076",
    lat: 39.673864,
    lng: -77.475068,
    panoId: "tXqniSr-fFcMPRu6bA19lg",
    place: "Near Highfield-Cascade, Maryland",
    shortName: "Highfield-Cascade",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MD",
    state: "Maryland",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-md-077",
    lat: 38.24861,
    lng: -76.505977,
    panoId: "1HldKud1663FUg2cTi-nSA",
    place: "Near Lexington Park, Maryland",
    shortName: "Lexington Park",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MD",
    state: "Maryland",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-md-078",
    lat: 39.667745,
    lng: -77.66076,
    panoId: "dNZKgtAyCUqWtt-SXNfk3Q",
    place: "Near Paramount-Long Meadow, Maryland",
    shortName: "Paramount-Long Meadow",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MD",
    state: "Maryland",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-md-079",
    lat: 39.444352,
    lng: -77.28708,
    panoId: "WE-v4UlAj9bpYvAstYGRNQ",
    place: "Near Linganore, Maryland",
    shortName: "Linganore",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MD",
    state: "Maryland",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-md-080",
    lat: 39.657467,
    lng: -78.70423,
    panoId: "7PdRtfI6gii4m-A_QZaL6Q",
    place: "Near Cumberland, Maryland",
    shortName: "Cumberland",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MD",
    state: "Maryland",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-md-081",
    lat: 38.338743,
    lng: -75.530846,
    panoId: "gurVHXd6cznhm03BGSXNyg",
    place: "Near Salisbury, Maryland",
    shortName: "Salisbury",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MD",
    state: "Maryland",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-md-082",
    lat: 39.210068,
    lng: -77.365503,
    panoId: "S0uRqPeEM6wwh-PGVo66Bw",
    place: "Near Clarksburg, Maryland",
    shortName: "Clarksburg",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MD",
    state: "Maryland",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-md-083",
    lat: 38.371226,
    lng: -76.481982,
    panoId: "KV5H2NmPyVD94X2hF_c3yw",
    place: "Near Lusby, Maryland",
    shortName: "Lusby",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MD",
    state: "Maryland",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-md-084",
    lat: 39.312842,
    lng: -77.254273,
    panoId: "3PWwnThTVdpm89uFiGHFgQ",
    place: "Near Green Valley, Maryland",
    shortName: "Green Valley",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MD",
    state: "Maryland",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-md-085",
    lat: 39.71385,
    lng: -77.226632,
    panoId: "JOaDbIwW9IYeaECAxY8jLA",
    place: "Near Taneytown, Maryland",
    shortName: "Taneytown",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MD",
    state: "Maryland",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-md-086",
    lat: 38.22368,
    lng: -76.620658,
    panoId: "LKqLHnbPkXBgdbW6RVZ16A",
    place: "Near Leonardtown, Maryland",
    shortName: "Leonardtown",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MD",
    state: "Maryland",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MD"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-md-087",
    lat: 39.457902,
    lng: -77.266289,
    panoId: "Ut4H4j3f28QwhNAxNJKeyg",
    place: "Near Linganore, Maryland",
    shortName: "Linganore",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MD",
    state: "Maryland",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-md-088",
    lat: 39.323387,
    lng: -77.388936,
    panoId: "S1HsBz97Ssz2g7mTci9XXw",
    place: "Near Urbana, Maryland",
    shortName: "Urbana",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MD",
    state: "Maryland",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-md-089",
    lat: 38.300374,
    lng: -75.374476,
    panoId: "aq7vD51Lv3nxGJiaaidLHw",
    place: "Near Pittsville, Maryland",
    shortName: "Pittsville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MD",
    state: "Maryland",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-md-090",
    lat: 39.703731,
    lng: -77.001202,
    panoId: "OePQy5e6VT6x8bbO1-4cQw",
    place: "Near Mount Pleasant, Maryland",
    shortName: "Mount Pleasant",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MD",
    state: "Maryland",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-md-091",
    lat: 38.353478,
    lng: -75.456161,
    panoId: "fqdvkxTZWI5hpuQEpd6YTg",
    place: "Near Pittsville, Maryland",
    shortName: "Pittsville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MD",
    state: "Maryland",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-md-092",
    lat: 39.334993,
    lng: -76.087779,
    panoId: "JNY9gJOZDCVRdmeR-vD-vQ",
    place: "Near Chestertown, Maryland",
    shortName: "Chestertown",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MD",
    state: "Maryland",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-md-093",
    lat: 39.756762,
    lng: -78.801655,
    panoId: "WMsGWt346ojqV7ToSXfPOA",
    place: "Near La Vale, Maryland",
    shortName: "La Vale",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MD",
    state: "Maryland",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-md-094",
    lat: 39.619728,
    lng: -79.023852,
    panoId: "SP4gRV4H3EYaclitmTFTww",
    place: "Near Lonaconing, Maryland",
    shortName: "Lonaconing",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MD",
    state: "Maryland",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-md-095",
    lat: 38.445471,
    lng: -76.141101,
    panoId: "YQev55SF6sFV_chO6i10IA",
    place: "Near Cambridge, Maryland",
    shortName: "Cambridge",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MD",
    state: "Maryland",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-md-096",
    lat: 38.866809,
    lng: -76.676515,
    panoId: "Tcgd6kk3tsub7TinBeQbjQ",
    place: "Near Queen Anne, Maryland",
    shortName: "Queen Anne",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MD",
    state: "Maryland",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-md-097",
    lat: 39.218019,
    lng: -77.503727,
    panoId: "dw7K7hR1LUadjShHCvLmKA",
    place: "Near Point of Rocks, Maryland",
    shortName: "Point of Rocks",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MD",
    state: "Maryland",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-md-098",
    lat: 39.791017,
    lng: -77.622824,
    panoId: "IO3uETAZHvIxRvML9BMnMg",
    place: "Near Waynesboro, Maryland",
    shortName: "Waynesboro",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MD",
    state: "Maryland",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-md-099",
    lat: 38.1955,
    lng: -76.528761,
    panoId: "zcMIFwFQzAWR0ydhBH1suQ",
    place: "Near Lexington Park, Maryland",
    shortName: "Lexington Park",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MD",
    state: "Maryland",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-md-100",
    lat: 39.752311,
    lng: -77.914268,
    panoId: "-lYxqm4a_mol0bjAJxZxCw",
    place: "Near Mercersburg, Maryland",
    shortName: "Mercersburg",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MD",
    state: "Maryland",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-MD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-md-101",
    lat: 39.709424,
    lng: -76.677498,
    panoId: "an_1MhF8DmK2OD32rICUFA",
    place: "Near New Freedom, Maryland",
    shortName: "New Freedom",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MD",
    state: "Maryland",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-MD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-md-102",
    lat: 39.720154,
    lng: -76.19203,
    panoId: "qOJ7dm5pLLLiZnxgIf7ARA",
    place: "Near Rising Sun, Maryland",
    shortName: "Rising Sun",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MD",
    state: "Maryland",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-MD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-md-103",
    lat: 38.223774,
    lng: -75.464885,
    panoId: "zrrbj68VJnuCagi13ZKd0w",
    place: "Near Snow Hill, Maryland",
    shortName: "Snow Hill",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MD",
    state: "Maryland",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-MD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-md-104",
    lat: 38.438078,
    lng: -76.719476,
    panoId: "5Hvi6ESYo8GOHpmpkrBpFg",
    place: "Near Mechanicsville, Maryland",
    shortName: "Mechanicsville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MD",
    state: "Maryland",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-MD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-md-105",
    lat: 39.253889,
    lng: -75.869742,
    panoId: "sicrM6tKXUPHdeQf9edbnw",
    place: "Near Kingstown, Maryland",
    shortName: "Kingstown",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MD",
    state: "Maryland",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-MD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ma-000",
    lat: 42.324938,
    lng: -72.640926,
    panoId: "D5kUBGqVgSoKzt5k5teSdQ",
    place: "Near Northampton, Massachusetts",
    shortName: "Northampton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MA",
    state: "Massachusetts",
    difficulty: "classic",
    pools: ["world","North America","US","US-MA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ma-001",
    lat: 42.375423,
    lng: -72.518991,
    panoId: "PnZZaHuPjBly3fgWnQE_8A",
    place: "Near Amherst Center, Massachusetts",
    shortName: "Amherst Center",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MA",
    state: "Massachusetts",
    difficulty: "classic",
    pools: ["world","North America","US","US-MA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ma-002",
    lat: 42.583726,
    lng: -71.802182,
    panoId: "OOiMQpwfDoC0Q4eeSnjKag",
    place: "Near Fitchburg, Massachusetts",
    shortName: "Fitchburg",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MA",
    state: "Massachusetts",
    difficulty: "classic",
    pools: ["world","North America","US","US-MA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ma-003",
    lat: 41.893045,
    lng: -70.911146,
    panoId: "-SEMKA9TEoSea4bs6xRx0Q",
    place: "Near Middleborough, Massachusetts",
    shortName: "Middleborough",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MA",
    state: "Massachusetts",
    difficulty: "classic",
    pools: ["world","North America","US","US-MA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ma-004",
    lat: 42.139696,
    lng: -71.516161,
    panoId: "4zHRwqWs6q6sxphfrJzksg",
    place: "Near Milford, Massachusetts",
    shortName: "Milford",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MA",
    state: "Massachusetts",
    difficulty: "classic",
    pools: ["world","North America","US","US-MA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ma-005",
    lat: 41.70573,
    lng: -70.228607,
    panoId: "m0rL7xmj4X9tY8TyKy-cIw",
    place: "Near Yarmouth, Massachusetts",
    shortName: "Yarmouth",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MA",
    state: "Massachusetts",
    difficulty: "classic",
    pools: ["world","North America","US","US-MA"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-ma-006",
    lat: 42.241716,
    lng: -71.166322,
    panoId: "J8_ZJXORCbHfivAJkf2YLA",
    place: "Near Dedham, Massachusetts",
    shortName: "Dedham",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MA",
    state: "Massachusetts",
    difficulty: "classic",
    pools: ["world","North America","US","US-MA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ma-007",
    lat: 42.587768,
    lng: -72.599505,
    panoId: "iY3CiX-R6jVlBFxAdt5KaA",
    place: "Near Greenfield, Massachusetts",
    shortName: "Greenfield",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MA",
    state: "Massachusetts",
    difficulty: "classic",
    pools: ["world","North America","US","US-MA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ma-008",
    lat: 41.70142,
    lng: -71.155087,
    panoId: "dObvXArCFGvadpCoUmg8iA",
    place: "Near Fall River, Massachusetts",
    shortName: "Fall River",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MA",
    state: "Massachusetts",
    difficulty: "classic",
    pools: ["world","North America","US","US-MA"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-ma-009",
    lat: 42.296152,
    lng: -71.712845,
    panoId: "KFAMTutox4DfY4pOBa51eA",
    place: "Near Shrewsbury, Massachusetts",
    shortName: "Shrewsbury",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MA",
    state: "Massachusetts",
    difficulty: "classic",
    pools: ["world","North America","US","US-MA"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-ma-010",
    lat: 42.10157,
    lng: -72.589699,
    panoId: "9rsJzQRu0uocixr6J4naKQ",
    place: "Near Springfield, Massachusetts",
    shortName: "Springfield",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MA",
    state: "Massachusetts",
    difficulty: "classic",
    pools: ["world","North America","US","US-MA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ma-011",
    lat: 42.18356,
    lng: -72.599427,
    panoId: "Qqldr7BhhJS5xVO2GlRrFQ",
    place: "Near North Chicopee, Massachusetts",
    shortName: "North Chicopee",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MA",
    state: "Massachusetts",
    difficulty: "classic",
    pools: ["world","North America","US","US-MA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ma-012",
    lat: 42.107409,
    lng: -72.619621,
    panoId: "JtLLA-Ljy6IzZVHPFjD3Zg",
    place: "Near West Springfield, Massachusetts",
    shortName: "West Springfield",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MA",
    state: "Massachusetts",
    difficulty: "classic",
    pools: ["world","North America","US","US-MA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ma-013",
    lat: 41.944589,
    lng: -71.284962,
    panoId: "b8xg9Yedr76f7Yn7_xahkg",
    place: "Near Attleboro, Massachusetts",
    shortName: "Attleboro",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MA",
    state: "Massachusetts",
    difficulty: "classic",
    pools: ["world","North America","US","US-MA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ma-014",
    lat: 42.14889,
    lng: -72.607854,
    panoId: "M6F7w_9MiD-SQCvCfrmD5g",
    place: "Near Chicopee, Massachusetts",
    shortName: "Chicopee",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MA",
    state: "Massachusetts",
    difficulty: "classic",
    pools: ["world","North America","US","US-MA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ma-015",
    lat: 42.776226,
    lng: -71.077145,
    panoId: "3l2uwYBQXDC0KFec2UWxgw",
    place: "Near Haverhill, Massachusetts",
    shortName: "Haverhill",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MA",
    state: "Massachusetts",
    difficulty: "classic",
    pools: ["world","North America","US","US-MA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ma-016",
    lat: 42.34585,
    lng: -71.552328,
    panoId: "y7Gia7kri99FTBR33yC4KA",
    place: "Near Marlborough, Massachusetts",
    shortName: "Marlborough",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MA",
    state: "Massachusetts",
    difficulty: "classic",
    pools: ["world","North America","US","US-MA"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-ma-017",
    lat: 42.858369,
    lng: -70.929911,
    panoId: "xbcQ37ylx7jL9xYoLIHdPQ",
    place: "Near Amesbury, Massachusetts",
    shortName: "Amesbury",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MA",
    state: "Massachusetts",
    difficulty: "classic",
    pools: ["world","North America","US","US-MA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ma-018",
    lat: 42.204135,
    lng: -72.615916,
    panoId: "dbkMWauZ_ucoDGAnfFiazw",
    place: "Near Holyoke, Massachusetts",
    shortName: "Holyoke",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MA",
    state: "Massachusetts",
    difficulty: "classic",
    pools: ["world","North America","US","US-MA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ma-019",
    lat: 42.614094,
    lng: -70.663154,
    panoId: "xF693irYkKlHTOrVVUzBjQ",
    place: "Near Gloucester, Massachusetts",
    shortName: "Gloucester",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MA",
    state: "Massachusetts",
    difficulty: "classic",
    pools: ["world","North America","US","US-MA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ma-020",
    lat: 42.074915,
    lng: -72.033592,
    panoId: "-RaVCOfa_lcnI-rDLVcJOg",
    place: "Near Southbridge, Massachusetts",
    shortName: "Southbridge",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MA",
    state: "Massachusetts",
    difficulty: "classic",
    pools: ["world","North America","US","US-MA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ma-021",
    lat: 42.358363,
    lng: -71.060074,
    panoId: "76ijjBAizR4kPyJoQr5wmw",
    place: "Near Boston, Massachusetts",
    shortName: "Boston",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MA",
    state: "Massachusetts",
    difficulty: "classic",
    pools: ["world","North America","US","US-MA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ma-022",
    lat: 42.15833,
    lng: -72.328859,
    panoId: "8Ix4qid6JJzzJ3CQJcyJog",
    place: "Near Palmer, Massachusetts",
    shortName: "Palmer",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MA",
    state: "Massachusetts",
    difficulty: "classic",
    pools: ["world","North America","US","US-MA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ma-023",
    lat: 42.069572,
    lng: -72.614815,
    panoId: "wVqHAqwFT3XrN4MItsZnjg",
    place: "Near Agawam, Massachusetts",
    shortName: "Agawam",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MA",
    state: "Massachusetts",
    difficulty: "classic",
    pools: ["world","North America","US","US-MA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ma-024",
    lat: 42.525065,
    lng: -71.759938,
    panoId: "puyGgUhC_458O-idU_xOxw",
    place: "Near Leominster, Massachusetts",
    shortName: "Leominster",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MA",
    state: "Massachusetts",
    difficulty: "classic",
    pools: ["world","North America","US","US-MA"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-ma-025",
    lat: 41.700383,
    lng: -70.299511,
    panoId: "osn0GrR7xTZrresCpK-Xwg",
    place: "Near Barnstable, Massachusetts",
    shortName: "Barnstable",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MA",
    state: "Massachusetts",
    difficulty: "classic",
    pools: ["world","North America","US","US-MA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ma-026",
    lat: 42.575039,
    lng: -71.9985,
    panoId: "rsNArKbkCkRkWeoLXDKE0g",
    place: "Near Gardner, Massachusetts",
    shortName: "Gardner",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MA",
    state: "Massachusetts",
    difficulty: "classic",
    pools: ["world","North America","US","US-MA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ma-027",
    lat: 41.635296,
    lng: -70.926999,
    panoId: "fI2MhtH2Ih0TueQCVJJWVw",
    place: "Near New Bedford, Massachusetts",
    shortName: "New Bedford",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MA",
    state: "Massachusetts",
    difficulty: "classic",
    pools: ["world","North America","US","US-MA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ma-028",
    lat: 42.262652,
    lng: -71.802521,
    panoId: "0E7-RFCurqXalcP1TWb6vw",
    place: "Near Worcester, Massachusetts",
    shortName: "Worcester",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MA",
    state: "Massachusetts",
    difficulty: "classic",
    pools: ["world","North America","US","US-MA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ma-029",
    lat: 42.72616,
    lng: -71.1909,
    panoId: "WWERfWvVwhoE115PEjuZgg",
    place: "Near Methuen, Massachusetts",
    shortName: "Methuen",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MA",
    state: "Massachusetts",
    difficulty: "classic",
    pools: ["world","North America","US","US-MA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ma-030",
    lat: 42.125009,
    lng: -72.749237,
    panoId: "_XYYVmfzf2HpCT9tTD0xNw",
    place: "Near Westfield, Massachusetts",
    shortName: "Westfield",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MA",
    state: "Massachusetts",
    difficulty: "classic",
    pools: ["world","North America","US","US-MA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ma-031",
    lat: 41.966855,
    lng: -71.187073,
    panoId: "0YPhf5dUTY2jRXCVVVsZ3g",
    place: "Near Norton, Massachusetts",
    shortName: "Norton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MA",
    state: "Massachusetts",
    difficulty: "classic",
    pools: ["world","North America","US","US-MA"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-ma-032",
    lat: 41.900122,
    lng: -71.089726,
    panoId: "aNXhRR3Gcq3CMdpKGWAqVg",
    place: "Near Taunton, Massachusetts",
    shortName: "Taunton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MA",
    state: "Massachusetts",
    difficulty: "classic",
    pools: ["world","North America","US","US-MA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ma-033",
    lat: 42.258327,
    lng: -72.574562,
    panoId: "8TWrM9s5vW6DMJvU4N8tvg",
    place: "Near South Hadley, Massachusetts",
    shortName: "South Hadley",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MA",
    state: "Massachusetts",
    difficulty: "classic",
    pools: ["world","North America","US","US-MA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ma-034",
    lat: 42.351108,
    lng: -71.863744,
    panoId: "Yl9L-Hr0L9p5Zbbl6h-kIg",
    place: "Near Holden, Massachusetts",
    shortName: "Holden",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MA",
    state: "Massachusetts",
    difficulty: "classic",
    pools: ["world","North America","US","US-MA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ma-035",
    lat: 42.812312,
    lng: -70.877494,
    panoId: "vChbNuIqKwapLLQmZocbeQ",
    place: "Near Newburyport, Massachusetts",
    shortName: "Newburyport",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MA",
    state: "Massachusetts",
    difficulty: "classic",
    pools: ["world","North America","US","US-MA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ma-036",
    lat: 41.769372,
    lng: -71.127993,
    panoId: "kOtvZofRv4CmLaTblgV8lw",
    place: "Near Somerset, Massachusetts",
    shortName: "Somerset",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MA",
    state: "Massachusetts",
    difficulty: "classic",
    pools: ["world","North America","US","US-MA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ma-037",
    lat: 42.166691,
    lng: -72.346325,
    panoId: "_yNDWZ1hQM9bp78g562DSw",
    place: "Near Palmer, Massachusetts",
    shortName: "Palmer",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MA",
    state: "Massachusetts",
    difficulty: "classic",
    pools: ["world","North America","US","US-MA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ma-038",
    lat: 42.58728,
    lng: -72.587191,
    panoId: "lip9iwlZRaXLFSFipfx-Mw",
    place: "Near Greenfield, Massachusetts",
    shortName: "Greenfield",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MA",
    state: "Massachusetts",
    difficulty: "classic",
    pools: ["world","North America","US","US-MA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ma-039",
    lat: 42.251992,
    lng: -71.140182,
    panoId: "HoQVKEWULxKETQuxIkKKKQ",
    place: "Near Readville, Massachusetts",
    shortName: "Readville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MA",
    state: "Massachusetts",
    difficulty: "classic",
    pools: ["world","North America","US","US-MA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ma-040",
    lat: 42.448112,
    lng: -73.246629,
    panoId: "x2dVFGtEHiOhEwXiuBSFRg",
    place: "Near Pittsfield, Massachusetts",
    shortName: "Pittsfield",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MA",
    state: "Massachusetts",
    difficulty: "classic",
    pools: ["world","North America","US","US-MA"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-ma-041",
    lat: 42.344714,
    lng: -71.582076,
    panoId: "SPe9SC7oPwLuV7lyPpXW2Q",
    place: "Near Marlborough, Massachusetts",
    shortName: "Marlborough",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MA",
    state: "Massachusetts",
    difficulty: "classic",
    pools: ["world","North America","US","US-MA"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-ma-042",
    lat: 42.590653,
    lng: -71.999434,
    panoId: "dtN9xwqWXYcm77GY28oy8g",
    place: "Near Gardner, Massachusetts",
    shortName: "Gardner",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MA",
    state: "Massachusetts",
    difficulty: "classic",
    pools: ["world","North America","US","US-MA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ma-043",
    lat: 41.689587,
    lng: -70.32514,
    panoId: "Ktt5KMcPT977p8PkcrT0iw",
    place: "Near Barnstable, Massachusetts",
    shortName: "Barnstable",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MA",
    state: "Massachusetts",
    difficulty: "classic",
    pools: ["world","North America","US","US-MA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ma-044",
    lat: 42.578277,
    lng: -71.784823,
    panoId: "VNaPTZVeBfeKCjeorNy8IQ",
    place: "Near Fitchburg, Massachusetts",
    shortName: "Fitchburg",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MA",
    state: "Massachusetts",
    difficulty: "classic",
    pools: ["world","North America","US","US-MA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ma-045",
    lat: 42.375203,
    lng: -71.040022,
    panoId: "0uy3sABtR4Hz2uWVunydcw",
    place: "Near East Boston, Massachusetts",
    shortName: "East Boston",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MA",
    state: "Massachusetts",
    difficulty: "classic",
    pools: ["world","North America","US","US-MA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ma-046",
    lat: 42.376575,
    lng: -72.491291,
    panoId: "LeyTvz2gn-QhB_zGc30s_g",
    place: "Near Amherst Center, Massachusetts",
    shortName: "Amherst Center",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MA",
    state: "Massachusetts",
    difficulty: "classic",
    pools: ["world","North America","US","US-MA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ma-047",
    lat: 42.068347,
    lng: -72.601468,
    panoId: "E6kOmHZDLqdRC46hKmrzAA",
    place: "Near Agawam, Massachusetts",
    shortName: "Agawam",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MA",
    state: "Massachusetts",
    difficulty: "classic",
    pools: ["world","North America","US","US-MA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ma-048",
    lat: 42.533151,
    lng: -71.784551,
    panoId: "eo7V0mEsZwhMIc3jjJscJQ",
    place: "Near Leominster, Massachusetts",
    shortName: "Leominster",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MA",
    state: "Massachusetts",
    difficulty: "classic",
    pools: ["world","North America","US","US-MA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ma-049",
    lat: 42.254908,
    lng: -71.779424,
    panoId: "TI2tjAkySbxqqp0aK1zTUg",
    place: "Near Hamilton Worcester, Massachusetts",
    shortName: "Hamilton Worcester",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MA",
    state: "Massachusetts",
    difficulty: "classic",
    pools: ["world","North America","US","US-MA"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-ma-050",
    lat: 42.108816,
    lng: -72.848349,
    panoId: "D1G3-LcGXZLwbI_X_nPt5Q",
    place: "Near Granville, Massachusetts",
    shortName: "Granville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MA",
    state: "Massachusetts",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ma-051",
    lat: 42.329827,
    lng: -71.835007,
    panoId: "H020Fe8N_5ecO3xPg9scWg",
    place: "Near Holden, Massachusetts",
    shortName: "Holden",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MA",
    state: "Massachusetts",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ma-052",
    lat: 42.114415,
    lng: -72.490912,
    panoId: "2jzd5XXBDRJLVvxEGbAwtg",
    place: "Near Wilbraham, Massachusetts",
    shortName: "Wilbraham",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MA",
    state: "Massachusetts",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ma-053",
    lat: 41.909563,
    lng: -70.96692,
    panoId: "Bv4xvCncpAeLUaJAwm4XzA",
    place: "Near Middleborough Center, Massachusetts",
    shortName: "Middleborough Center",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MA",
    state: "Massachusetts",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ma-054",
    lat: 42.809989,
    lng: -70.950447,
    panoId: "udgL4j18JJ26k-NBhxqfjg",
    place: "Near West Newbury, Massachusetts",
    shortName: "West Newbury",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MA",
    state: "Massachusetts",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ma-055",
    lat: 41.888402,
    lng: -71.050953,
    panoId: "plxpE4F5bhAFQJmxHh2rCg",
    place: "Near Taunton, Massachusetts",
    shortName: "Taunton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MA",
    state: "Massachusetts",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ma-056",
    lat: 42.108476,
    lng: -71.955415,
    panoId: "xO6b2tT-8i-fUdFFWCXbIQ",
    place: "Near Charlton, Massachusetts",
    shortName: "Charlton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MA",
    state: "Massachusetts",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ma-057",
    lat: 42.161721,
    lng: -71.431371,
    panoId: "mTXYe0vv5pHfQ3g9DAQdbQ",
    place: "Near Medway, Massachusetts",
    shortName: "Medway",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MA",
    state: "Massachusetts",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MA"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-ma-058",
    lat: 41.6739,
    lng: -71.083184,
    panoId: "GkKWCef3Obxl3vZyWNrXXA",
    place: "Near North Westport, Massachusetts",
    shortName: "North Westport",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MA",
    state: "Massachusetts",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ma-059",
    lat: 42.234159,
    lng: -72.526375,
    panoId: "ED3b3lG0GL2A0WRttizCYg",
    place: "Near Granby, Massachusetts",
    shortName: "Granby",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MA",
    state: "Massachusetts",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ma-060",
    lat: 42.64135,
    lng: -70.717035,
    panoId: "loZKlc14MDB2bcmpgc7ziA",
    place: "Near Gloucester, Massachusetts",
    shortName: "Gloucester",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MA",
    state: "Massachusetts",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ma-061",
    lat: 42.401696,
    lng: -73.173181,
    panoId: "FbdkGcUwvWWuHQExYiitPg",
    place: "Near Hinsdale, Massachusetts",
    shortName: "Hinsdale",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MA",
    state: "Massachusetts",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ma-062",
    lat: 41.892853,
    lng: -71.299493,
    panoId: "D2ZhDZRnw12OG4Pp7vVcag",
    place: "Near North Seekonk, Massachusetts",
    shortName: "North Seekonk",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MA",
    state: "Massachusetts",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ma-063",
    lat: 42.133487,
    lng: -72.380804,
    panoId: "cny_mTC6cnjd3XPmvnxQbg",
    place: "Near Wilbraham, Massachusetts",
    shortName: "Wilbraham",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MA",
    state: "Massachusetts",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ma-064",
    lat: 42.277654,
    lng: -71.526309,
    panoId: "CjOKjMlMO7i_lfgSTI3GOg",
    place: "Near Cordaville, Massachusetts",
    shortName: "Cordaville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MA",
    state: "Massachusetts",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ma-065",
    lat: 42.392231,
    lng: -72.449088,
    panoId: "no_KTLGOWpRJ-cAQ2-BKCw",
    place: "Near Pelham, Massachusetts",
    shortName: "Pelham",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MA",
    state: "Massachusetts",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ma-066",
    lat: 42.134234,
    lng: -72.669092,
    panoId: "hEUIQWD8kfN_e8btxRNYfg",
    place: "Near West Springfield, Massachusetts",
    shortName: "West Springfield",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MA",
    state: "Massachusetts",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ma-067",
    lat: 42.345294,
    lng: -71.693573,
    panoId: "yOoKPAJIVq0_-2WJ7J3GmQ",
    place: "Near Northborough, Massachusetts",
    shortName: "Northborough",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MA",
    state: "Massachusetts",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ma-068",
    lat: 42.409653,
    lng: -71.838103,
    panoId: "6RtO-7xm1vjeOuybV2A9eA",
    place: "Near Princeton, Massachusetts",
    shortName: "Princeton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MA",
    state: "Massachusetts",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ma-069",
    lat: 42.366979,
    lng: -72.564474,
    panoId: "u386QbTghVvQZ6fl_qVT3A",
    place: "Near Hatfield, Massachusetts",
    shortName: "Hatfield",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MA",
    state: "Massachusetts",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ma-070",
    lat: 42.146524,
    lng: -71.466856,
    panoId: "5xS_BUVn5c_D3WX1AjNm3Q",
    place: "Near Milford, Massachusetts",
    shortName: "Milford",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MA",
    state: "Massachusetts",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ma-071",
    lat: 42.098105,
    lng: -72.472028,
    panoId: "bDstZ1utVAefMK7JhjL3dw",
    place: "Near Wilbraham, Massachusetts",
    shortName: "Wilbraham",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MA",
    state: "Massachusetts",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ma-072",
    lat: 42.245364,
    lng: -72.534257,
    panoId: "CN9SSumnTri4Z7SMby3Lrw",
    place: "Near Granby, Massachusetts",
    shortName: "Granby",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MA",
    state: "Massachusetts",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ma-073",
    lat: 42.02734,
    lng: -71.170636,
    panoId: "i_w6L-05i7_maDitkNoFwg",
    place: "Near Easton, Massachusetts",
    shortName: "Easton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MA",
    state: "Massachusetts",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ma-074",
    lat: 41.863606,
    lng: -70.956399,
    panoId: "QFiHGSizYeXvyqvWSVHQ6Q",
    place: "Near North Lakeville, Massachusetts",
    shortName: "North Lakeville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MA",
    state: "Massachusetts",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ma-075",
    lat: 41.692797,
    lng: -71.094116,
    panoId: "lV1eYhe5Kk7wNC7cdT8n4A",
    place: "Near North Westport, Massachusetts",
    shortName: "North Westport",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MA",
    state: "Massachusetts",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ma-076",
    lat: 42.208012,
    lng: -72.655915,
    panoId: "DcrfqQoOMk7V7l7UFkZ7cA",
    place: "Near Holyoke, Massachusetts",
    shortName: "Holyoke",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MA",
    state: "Massachusetts",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MA"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "us-ma-077",
    lat: 41.680194,
    lng: -70.337816,
    panoId: "VFpy1mvGNBWfc_804gUetA",
    place: "Near Centerville, Massachusetts",
    shortName: "Centerville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MA",
    state: "Massachusetts",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ma-078",
    lat: 41.596798,
    lng: -71.188797,
    panoId: "4-nGflJOlRu8tXfN0cJaOw",
    place: "Near Tiverton, Massachusetts",
    shortName: "Tiverton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MA",
    state: "Massachusetts",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ma-079",
    lat: 41.868396,
    lng: -71.175045,
    panoId: "RvdEaQwpqlwZ1AwMv8s6Vw",
    place: "Near Rehoboth, Massachusetts",
    shortName: "Rehoboth",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MA",
    state: "Massachusetts",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ma-080",
    lat: 41.975476,
    lng: -72.468781,
    panoId: "ZoAlO9HESmLdgdgFF7XJ4A",
    place: "Near Somers, Massachusetts",
    shortName: "Somers",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MA",
    state: "Massachusetts",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ma-081",
    lat: 42.094201,
    lng: -72.693578,
    panoId: "o6fsFLTdZFLz-Vz32KWuVA",
    place: "Near Westfield, Massachusetts",
    shortName: "Westfield",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MA",
    state: "Massachusetts",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ma-082",
    lat: 42.153458,
    lng: -72.571842,
    panoId: "gOpYBbPa-3NMqIPkpKhqxw",
    place: "Near Chicopee, Massachusetts",
    shortName: "Chicopee",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MA",
    state: "Massachusetts",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ma-083",
    lat: 42.362302,
    lng: -72.671584,
    panoId: "HgxLVbnzWMQwhtPOxM7YrA",
    place: "Near Northampton, Massachusetts",
    shortName: "Northampton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MA",
    state: "Massachusetts",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ma-084",
    lat: 42.238425,
    lng: -72.511009,
    panoId: "WDS54Ca8y1LfpvbZh9Ll2Q",
    place: "Near Granby, Massachusetts",
    shortName: "Granby",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MA",
    state: "Massachusetts",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ma-085",
    lat: 41.843235,
    lng: -70.835384,
    panoId: "EQbrjj7WiyRojYe77diw3A",
    place: "Near Carver, Massachusetts",
    shortName: "Carver",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MA",
    state: "Massachusetts",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ma-086",
    lat: 41.905606,
    lng: -72.696261,
    panoId: "sttUs-nxKzuq5qCneijH7A",
    place: "Near Tariffville, Massachusetts",
    shortName: "Tariffville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MA",
    state: "Massachusetts",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ma-087",
    lat: 42.105507,
    lng: -72.659885,
    panoId: "zOKO1STCgyS3QE41sN7YYw",
    place: "Near West Springfield, Massachusetts",
    shortName: "West Springfield",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MA",
    state: "Massachusetts",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ma-088",
    lat: 41.963724,
    lng: -72.437345,
    panoId: "cj9MoLxLaLHj2V7mFrXPHg",
    place: "Near Somers, Massachusetts",
    shortName: "Somers",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MA",
    state: "Massachusetts",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ma-089",
    lat: 41.672136,
    lng: -71.147771,
    panoId: "JxsC3xM5E0jN3csFxxkHKQ",
    place: "Near Fall River, Massachusetts",
    shortName: "Fall River",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MA",
    state: "Massachusetts",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ma-090",
    lat: 41.731751,
    lng: -70.789026,
    panoId: "BcdGAlUAZcdadnsSC8zntA",
    place: "Near Rochester, Massachusetts",
    shortName: "Rochester",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MA",
    state: "Massachusetts",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ma-091",
    lat: 42.102625,
    lng: -70.758333,
    panoId: "OOnYZ5XCTHCvhWeptD2UZQ",
    place: "Near North Pembroke, Massachusetts",
    shortName: "North Pembroke",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MA",
    state: "Massachusetts",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ma-092",
    lat: 42.320322,
    lng: -71.834032,
    panoId: "5t1xKd2iWX66RjZNi4hX0w",
    place: "Near Holden, Massachusetts",
    shortName: "Holden",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MA",
    state: "Massachusetts",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ma-093",
    lat: 42.00575,
    lng: -71.58165,
    panoId: "1biUezhqOtm9h7MZsTWf0w",
    place: "Near Millville, Massachusetts",
    shortName: "Millville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MA",
    state: "Massachusetts",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ma-094",
    lat: 41.903468,
    lng: -71.473074,
    panoId: "Hluc_8MeEpYZlEovP0Ed9Q",
    place: "Near Lincoln, Massachusetts",
    shortName: "Lincoln",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MA",
    state: "Massachusetts",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ma-095",
    lat: 42.634725,
    lng: -70.958578,
    panoId: "j-d8FHFwSAmXlLQPMxXFgg",
    place: "Near Topsfield, Massachusetts",
    shortName: "Topsfield",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MA",
    state: "Massachusetts",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MA"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "us-ma-096",
    lat: 42.39039,
    lng: -73.236538,
    panoId: "PD5rI5exZlBkWIpnfDG6Kw",
    place: "Near Lenox, Massachusetts",
    shortName: "Lenox",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MA",
    state: "Massachusetts",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ma-097",
    lat: 42.713721,
    lng: -73.185141,
    panoId: "OHhIfcsvVTSYHheCNJpE4Q",
    place: "Near Williamstown, Massachusetts",
    shortName: "Williamstown",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MA",
    state: "Massachusetts",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ma-098",
    lat: 42.108637,
    lng: -72.207061,
    panoId: "WxhEWggH4luA1lnt5Suh1Q",
    place: "Near Brimfield, Massachusetts",
    shortName: "Brimfield",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MA",
    state: "Massachusetts",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MA"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-ma-099",
    lat: 42.566009,
    lng: -70.813699,
    panoId: "Yu4eq-FPViEQeHT5YOWUsw",
    place: "Near Beverly Cove, Massachusetts",
    shortName: "Beverly Cove",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MA",
    state: "Massachusetts",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ma-100",
    lat: 42.58439,
    lng: -71.625339,
    panoId: "Nps0p30uw_WKu8K7GaQjNw",
    place: "Near Ayer, Massachusetts",
    shortName: "Ayer",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MA",
    state: "Massachusetts",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-MA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ma-101",
    lat: 42.01923,
    lng: -72.950879,
    panoId: "TUqDJYUcRIkxx5Ix6mMB9g",
    place: "Near Granville, Massachusetts",
    shortName: "Granville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MA",
    state: "Massachusetts",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-MA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ma-102",
    lat: 42.388402,
    lng: -72.756509,
    panoId: "JuOiEjEOyUpcq1itMTHqrw",
    place: "Near Williamsburg, Massachusetts",
    shortName: "Williamsburg",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MA",
    state: "Massachusetts",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-MA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ma-103",
    lat: 42.408023,
    lng: -71.990603,
    panoId: "wUVNXOXmvsgcSur2QLuxvQ",
    place: "Near Rutland, Massachusetts",
    shortName: "Rutland",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MA",
    state: "Massachusetts",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-MA"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-ma-104",
    lat: 42.336238,
    lng: -72.778916,
    panoId: "JUcx7u5lPpFeNHqNPT2C6Q",
    place: "Near Westhampton, Massachusetts",
    shortName: "Westhampton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MA",
    state: "Massachusetts",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-MA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ma-105",
    lat: 41.971426,
    lng: -72.083253,
    panoId: "Z1jXeAPdgL85C8wXngihJQ",
    place: "Near South Woodstock, Massachusetts",
    shortName: "South Woodstock",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MA",
    state: "Massachusetts",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-MA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mi-000",
    lat: 42.736952,
    lng: -84.483778,
    panoId: "YFEpvoxTpRcA7IeGlshnpw",
    place: "Near East Lansing, Michigan",
    shortName: "East Lansing",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MI",
    state: "Michigan",
    difficulty: "classic",
    pools: ["world","North America","US","US-MI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mi-001",
    lat: 42.277571,
    lng: -83.740759,
    panoId: "7pvgUC5gzrgMM_zjTOhQ9w",
    place: "Near Ann Arbor, Michigan",
    shortName: "Ann Arbor",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MI",
    state: "Michigan",
    difficulty: "classic",
    pools: ["world","North America","US","US-MI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mi-002",
    lat: 42.913319,
    lng: -85.705258,
    panoId: "sp-3d88RpkCz2SPhGXysnw",
    place: "Near Wyoming, Michigan",
    shortName: "Wyoming",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MI",
    state: "Michigan",
    difficulty: "classic",
    pools: ["world","North America","US","US-MI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mi-003",
    lat: 42.200991,
    lng: -85.580059,
    panoId: "cZNgoYi_uzdWwjjLT0oo1g",
    place: "Near Portage, Michigan",
    shortName: "Portage",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MI",
    state: "Michigan",
    difficulty: "classic",
    pools: ["world","North America","US","US-MI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mi-004",
    lat: 42.732533,
    lng: -84.555463,
    panoId: "_HGA3dd56tQTfPVKuDyFNQ",
    place: "Near Lansing, Michigan",
    shortName: "Lansing",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MI",
    state: "Michigan",
    difficulty: "classic",
    pools: ["world","North America","US","US-MI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mi-005",
    lat: 42.640465,
    lng: -84.515508,
    panoId: "xPaLBLsszZuW3flUE9A2qw",
    place: "Near Holt, Michigan",
    shortName: "Holt",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MI",
    state: "Michigan",
    difficulty: "classic",
    pools: ["world","North America","US","US-MI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mi-006",
    lat: 42.999472,
    lng: -83.617129,
    panoId: "D8u-JveyzZL-kFjVt-fbrg",
    place: "Near Burton, Michigan",
    shortName: "Burton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MI",
    state: "Michigan",
    difficulty: "classic",
    pools: ["world","North America","US","US-MI"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-mi-007",
    lat: 42.687189,
    lng: -83.234101,
    panoId: "sXA4iV3Uu9Z0GaCVONB-Nw",
    place: "Near Auburn Hills, Michigan",
    shortName: "Auburn Hills",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MI",
    state: "Michigan",
    difficulty: "classic",
    pools: ["world","North America","US","US-MI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mi-008",
    lat: 42.746886,
    lng: -84.401041,
    panoId: "KEskqNd7VcIQ_F0wsF11jA",
    place: "Near Haslett, Michigan",
    shortName: "Haslett",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MI",
    state: "Michigan",
    difficulty: "classic",
    pools: ["world","North America","US","US-MI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mi-009",
    lat: 42.245658,
    lng: -84.401384,
    panoId: "DmNxKkYY-n3jadY49V0vpA",
    place: "Near Jackson, Michigan",
    shortName: "Jackson",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MI",
    state: "Michigan",
    difficulty: "classic",
    pools: ["world","North America","US","US-MI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mi-010",
    lat: 43.001603,
    lng: -85.767907,
    panoId: "NI5B9ARZo5xUVXOxsg9vNg",
    place: "Near Walker, Michigan",
    shortName: "Walker",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MI",
    state: "Michigan",
    difficulty: "classic",
    pools: ["world","North America","US","US-MI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mi-011",
    lat: 43.168903,
    lng: -86.263944,
    panoId: "v2U-WhG94NJ36wFC2AaZzQ",
    place: "Near Norton Shores, Michigan",
    shortName: "Norton Shores",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MI",
    state: "Michigan",
    difficulty: "classic",
    pools: ["world","North America","US","US-MI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mi-012",
    lat: 42.291727,
    lng: -85.587288,
    panoId: "6Fys0IVqL-dt4Kq6mb-pCQ",
    place: "Near Kalamazoo, Michigan",
    shortName: "Kalamazoo",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MI",
    state: "Michigan",
    difficulty: "classic",
    pools: ["world","North America","US","US-MI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mi-013",
    lat: 42.331386,
    lng: -83.045731,
    panoId: "LvGKyDGPi7rr8yplAyZm5g",
    place: "Near Detroit, Michigan",
    shortName: "Detroit",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MI",
    state: "Michigan",
    difficulty: "classic",
    pools: ["world","North America","US","US-MI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mi-014",
    lat: 43.460004,
    lng: -84.006669,
    panoId: "Fi_HuLngwuIuuce6rcfv7w",
    place: "Near Saginaw Township North, Michigan",
    shortName: "Saginaw Township North",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MI",
    state: "Michigan",
    difficulty: "classic",
    pools: ["world","North America","US","US-MI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mi-015",
    lat: 42.963375,
    lng: -85.667892,
    panoId: "mlfe7Iknv8FUkJzkXHu4kw",
    place: "Near Grand Rapids, Michigan",
    shortName: "Grand Rapids",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MI",
    state: "Michigan",
    difficulty: "classic",
    pools: ["world","North America","US","US-MI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mi-016",
    lat: 42.692624,
    lng: -83.412124,
    panoId: "AZW5ISwYoHrRkKpp2boJYA",
    place: "Near Waterford, Michigan",
    shortName: "Waterford",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MI",
    state: "Michigan",
    difficulty: "classic",
    pools: ["world","North America","US","US-MI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mi-017",
    lat: 42.722258,
    lng: -84.427533,
    panoId: "3roQnBEEJd0hdC8kqXyytQ",
    place: "Near Okemos, Michigan",
    shortName: "Okemos",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MI",
    state: "Michigan",
    difficulty: "classic",
    pools: ["world","North America","US","US-MI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mi-018",
    lat: 41.89746,
    lng: -84.037164,
    panoId: "mA7_LK4ZUQYgFe8M6W0U-w",
    place: "Near Adrian, Michigan",
    shortName: "Adrian",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MI",
    state: "Michigan",
    difficulty: "classic",
    pools: ["world","North America","US","US-MI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mi-019",
    lat: 43.597785,
    lng: -84.767568,
    panoId: "es6tXWTmKOXbMm8pjSp1qw",
    place: "Near Mount Pleasant, Michigan",
    shortName: "Mount Pleasant",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MI",
    state: "Michigan",
    difficulty: "classic",
    pools: ["world","North America","US","US-MI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mi-020",
    lat: 46.543542,
    lng: -87.395394,
    panoId: "DubcPZbEyU_SgHJIOL9X2Q",
    place: "Near Marquette, Michigan",
    shortName: "Marquette",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MI",
    state: "Michigan",
    difficulty: "classic",
    pools: ["world","North America","US","US-MI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mi-021",
    lat: 42.241081,
    lng: -83.612988,
    panoId: "rQbEdHCPNE41Wo9g5C5fqQ",
    place: "Near Ypsilanti, Michigan",
    shortName: "Ypsilanti",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MI",
    state: "Michigan",
    difficulty: "classic",
    pools: ["world","North America","US","US-MI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mi-022",
    lat: 42.972337,
    lng: -85.953697,
    panoId: "vTanE5wVy3mf9W14qs86kg",
    place: "Near Allendale, Michigan",
    shortName: "Allendale",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MI",
    state: "Michigan",
    difficulty: "classic",
    pools: ["world","North America","US","US-MI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mi-023",
    lat: 42.787493,
    lng: -86.10898,
    panoId: "OnZvJlNM6aceSri08-IpNA",
    place: "Near Holland, Michigan",
    shortName: "Holland",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MI",
    state: "Michigan",
    difficulty: "classic",
    pools: ["world","North America","US","US-MI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mi-024",
    lat: 43.420235,
    lng: -83.950196,
    panoId: "UaLGwnA_yoSmqjZhsDDZZQ",
    place: "Near Saginaw, Michigan",
    shortName: "Saginaw",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MI",
    state: "Michigan",
    difficulty: "classic",
    pools: ["world","North America","US","US-MI"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-mi-025",
    lat: 43.594088,
    lng: -83.888876,
    panoId: "61yhhXKD8AXnLI_HtMuEjA",
    place: "Near Bay City, Michigan",
    shortName: "Bay City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MI",
    state: "Michigan",
    difficulty: "classic",
    pools: ["world","North America","US","US-MI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mi-026",
    lat: 42.638898,
    lng: -83.29126,
    panoId: "H4kMUC1SuF47nuyfvObtOA",
    place: "Near Pontiac, Michigan",
    shortName: "Pontiac",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MI",
    state: "Michigan",
    difficulty: "classic",
    pools: ["world","North America","US","US-MI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mi-027",
    lat: 41.916443,
    lng: -83.397673,
    panoId: "WJCCo-zQH1dWvAbHx97Izg",
    place: "Near Monroe, Michigan",
    shortName: "Monroe",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MI",
    state: "Michigan",
    difficulty: "classic",
    pools: ["world","North America","US","US-MI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mi-028",
    lat: 43.012691,
    lng: -83.687593,
    panoId: "nZsnPRZl0LXxotBte0Eo0g",
    place: "Near Flint, Michigan",
    shortName: "Flint",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MI",
    state: "Michigan",
    difficulty: "classic",
    pools: ["world","North America","US","US-MI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mi-029",
    lat: 42.970854,
    lng: -82.424632,
    panoId: "st1bOq07vwLtuxA1ARJPgw",
    place: "Near Port Huron, Michigan",
    shortName: "Port Huron",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MI",
    state: "Michigan",
    difficulty: "classic",
    pools: ["world","North America","US","US-MI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mi-030",
    lat: 42.958107,
    lng: -85.489542,
    panoId: "WE7krrvC_S53Z7o75-v0cQ",
    place: "Near Forest Hills, Michigan",
    shortName: "Forest Hills",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MI",
    state: "Michigan",
    difficulty: "classic",
    pools: ["world","North America","US","US-MI"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-mi-031",
    lat: 43.23424,
    lng: -86.248402,
    panoId: "JKdf0uSiGl9X6_XuVxMgrg",
    place: "Near Muskegon, Michigan",
    shortName: "Muskegon",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MI",
    state: "Michigan",
    difficulty: "classic",
    pools: ["world","North America","US","US-MI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mi-032",
    lat: 43.61556,
    lng: -84.247236,
    panoId: "yd71sIHlzH7WyhEng12Wvw",
    place: "Near Midland, Michigan",
    shortName: "Midland",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MI",
    state: "Michigan",
    difficulty: "classic",
    pools: ["world","North America","US","US-MI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mi-033",
    lat: 42.739162,
    lng: -84.62077,
    panoId: "SCSZXF07QU1fwHQHj9s12A",
    place: "Near Waverly, Michigan",
    shortName: "Waverly",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MI",
    state: "Michigan",
    difficulty: "classic",
    pools: ["world","North America","US","US-MI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mi-034",
    lat: 42.317109,
    lng: -85.178205,
    panoId: "fjTtOt_z41BncF7viH-wzA",
    place: "Near Battle Creek, Michigan",
    shortName: "Battle Creek",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MI",
    state: "Michigan",
    difficulty: "classic",
    pools: ["world","North America","US","US-MI"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "us-mi-035",
    lat: 42.597243,
    lng: -82.877951,
    panoId: "r-_RzFj7XQnOI7hlOpKK_Q",
    place: "Near Mount Clemens, Michigan",
    shortName: "Mount Clemens",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MI",
    state: "Michigan",
    difficulty: "classic",
    pools: ["world","North America","US","US-MI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mi-036",
    lat: 42.907232,
    lng: -85.791941,
    panoId: "Oq3BzYdwhE2-9ATnhiFvMQ",
    place: "Near Jenison, Michigan",
    shortName: "Jenison",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MI",
    state: "Michigan",
    difficulty: "classic",
    pools: ["world","North America","US","US-MI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mi-037",
    lat: 42.909794,
    lng: -85.763106,
    panoId: "lFUkuHLtafsuvwUkYgqubg",
    place: "Near Grandville, Michigan",
    shortName: "Grandville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MI",
    state: "Michigan",
    difficulty: "classic",
    pools: ["world","North America","US","US-MI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mi-038",
    lat: 44.763078,
    lng: -85.620616,
    panoId: "CF7EqMdO-gROjtpkcbiBdA",
    place: "Near Traverse City, Michigan",
    shortName: "Traverse City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MI",
    state: "Michigan",
    difficulty: "classic",
    pools: ["world","North America","US","US-MI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mi-039",
    lat: 42.685877,
    lng: -83.205533,
    panoId: "hQFBl8MBaVoJJEUAxYVJ2Q",
    place: "Near Auburn Hills, Michigan",
    shortName: "Auburn Hills",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MI",
    state: "Michigan",
    difficulty: "classic",
    pools: ["world","North America","US","US-MI"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-mi-040",
    lat: 42.707672,
    lng: -83.409374,
    panoId: "WUlVY0K72iXBAH5ZbQzrJA",
    place: "Near Waterford, Michigan",
    shortName: "Waterford",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MI",
    state: "Michigan",
    difficulty: "classic",
    pools: ["world","North America","US","US-MI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mi-041",
    lat: 42.185179,
    lng: -85.598401,
    panoId: "pS0oZhcSuaNPduG1V8zfPA",
    place: "Near Portage, Michigan",
    shortName: "Portage",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MI",
    state: "Michigan",
    difficulty: "classic",
    pools: ["world","North America","US","US-MI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mi-042",
    lat: 43.42138,
    lng: -83.973951,
    panoId: "pgdZUMItIcbx6JMcdeW4AQ",
    place: "Near Saginaw, Michigan",
    shortName: "Saginaw",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MI",
    state: "Michigan",
    difficulty: "classic",
    pools: ["world","North America","US","US-MI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mi-043",
    lat: 42.729892,
    lng: -84.40481,
    panoId: "8-ApQ8LR4K72aswwjMl_MQ",
    place: "Near Haslett, Michigan",
    shortName: "Haslett",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MI",
    state: "Michigan",
    difficulty: "classic",
    pools: ["world","North America","US","US-MI"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-mi-044",
    lat: 42.291435,
    lng: -83.728176,
    panoId: "NNnBvl_X7va31RzJeJocsg",
    place: "Near Ann Arbor, Michigan",
    shortName: "Ann Arbor",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MI",
    state: "Michigan",
    difficulty: "classic",
    pools: ["world","North America","US","US-MI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mi-045",
    lat: 42.324654,
    lng: -83.021122,
    panoId: "_XYOQHZilUm_C6_SSZZOXw",
    place: "Near Detroit, Michigan",
    shortName: "Detroit",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MI",
    state: "Michigan",
    difficulty: "classic",
    pools: ["world","North America","US","US-MI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mi-046",
    lat: 43.572702,
    lng: -83.892611,
    panoId: "HDQYOX2dD4QuQ7EEXLPg_Q",
    place: "Near Bay City, Michigan",
    shortName: "Bay City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MI",
    state: "Michigan",
    difficulty: "classic",
    pools: ["world","North America","US","US-MI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mi-047",
    lat: 43.588106,
    lng: -84.767142,
    panoId: "Jz0Eh82J_nHsuGY6uEHo7g",
    place: "Near Mount Pleasant, Michigan",
    shortName: "Mount Pleasant",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MI",
    state: "Michigan",
    difficulty: "classic",
    pools: ["world","North America","US","US-MI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mi-048",
    lat: 42.996073,
    lng: -85.752337,
    panoId: "sO6GQQs1EVNgY1IBizQPwg",
    place: "Near Walker, Michigan",
    shortName: "Walker",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MI",
    state: "Michigan",
    difficulty: "classic",
    pools: ["world","North America","US","US-MI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mi-049",
    lat: 42.97327,
    lng: -85.484833,
    panoId: "9seQfWoyypvvutzj3VFUXg",
    place: "Near Forest Hills, Michigan",
    shortName: "Forest Hills",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MI",
    state: "Michigan",
    difficulty: "classic",
    pools: ["world","North America","US","US-MI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mi-050",
    lat: 42.259537,
    lng: -85.539258,
    panoId: "XRKgiLfGJMbph3zyec9Ygw",
    place: "Near Eastwood, Michigan",
    shortName: "Eastwood",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MI",
    state: "Michigan",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mi-051",
    lat: 41.93865,
    lng: -83.472459,
    panoId: "al3zaHzUf6xkUVtffK3Kcw",
    place: "Near West Monroe, Michigan",
    shortName: "West Monroe",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MI",
    state: "Michigan",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MI"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-mi-052",
    lat: 42.351546,
    lng: -85.21025,
    panoId: "dRBvhYyLrIbGvgkVjqjHnA",
    place: "Near Springfield, Michigan",
    shortName: "Springfield",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MI",
    state: "Michigan",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mi-053",
    lat: 42.993459,
    lng: -85.441104,
    panoId: "x7CQpxWmTUyPPFYY_Lnilg",
    place: "Near Forest Hills, Michigan",
    shortName: "Forest Hills",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MI",
    state: "Michigan",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mi-054",
    lat: 42.798783,
    lng: -84.59024,
    panoId: "MOyGKBYInr7D2biIvr2biQ",
    place: "Near DeWitt, Michigan",
    shortName: "DeWitt",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MI",
    state: "Michigan",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mi-055",
    lat: 43.278568,
    lng: -86.294569,
    panoId: "sGUGFCnHlyaaZPpulHMXVA",
    place: "Near North Muskegon, Michigan",
    shortName: "North Muskegon",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MI",
    state: "Michigan",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mi-056",
    lat: 42.265689,
    lng: -83.524322,
    panoId: "ptXxDN5j10rFoeTGPEIehw",
    place: "Near Canton, Michigan",
    shortName: "Canton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MI",
    state: "Michigan",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mi-057",
    lat: 42.673516,
    lng: -83.301836,
    panoId: "oKfL5xFPMhhgKrXRRNkqmw",
    place: "Near Pontiac, Michigan",
    shortName: "Pontiac",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MI",
    state: "Michigan",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mi-058",
    lat: 42.93135,
    lng: -85.737255,
    panoId: "xYWaBuYPifg_BzOHdIDfAg",
    place: "Near Grandville, Michigan",
    shortName: "Grandville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MI",
    state: "Michigan",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mi-059",
    lat: 42.913178,
    lng: -85.569911,
    panoId: "yPLo2DAncIOdWuyaRdX6Ew",
    place: "Near East Grand Rapids, Michigan",
    shortName: "East Grand Rapids",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MI",
    state: "Michigan",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MI"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-mi-060",
    lat: 43.003226,
    lng: -83.577771,
    panoId: "A80qC5lMaIC4DuKSmSEVDA",
    place: "Near Burton, Michigan",
    shortName: "Burton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MI",
    state: "Michigan",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mi-061",
    lat: 42.780595,
    lng: -84.43856,
    panoId: "J7UIQO1oIa38fyrpJV4N7w",
    place: "Near Bath, Michigan",
    shortName: "Bath",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MI",
    state: "Michigan",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MI"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-mi-062",
    lat: 42.972589,
    lng: -85.769263,
    panoId: "yUXNbocK2j8o_EvhwRrWFQ",
    place: "Near Walker, Michigan",
    shortName: "Walker",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MI",
    state: "Michigan",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MI"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "us-mi-063",
    lat: 42.275249,
    lng: -84.447969,
    panoId: "6SK2gi2xv4eZmgju2lGOJQ",
    place: "Near Jackson, Michigan",
    shortName: "Jackson",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MI",
    state: "Michigan",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mi-064",
    lat: 43.583312,
    lng: -84.239056,
    panoId: "hcFSuHgoMKcKdTay-h9nSQ",
    place: "Near Midland, Michigan",
    shortName: "Midland",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MI",
    state: "Michigan",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mi-065",
    lat: 42.914314,
    lng: -85.959148,
    panoId: "iGyI_xgw0YC7r6XwrTBOTQ",
    place: "Near Allendale, Michigan",
    shortName: "Allendale",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MI",
    state: "Michigan",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mi-066",
    lat: 41.906705,
    lng: -83.949009,
    panoId: "8IuZ2BSajn3mmRnm6GNiXA",
    place: "Near Adrian, Michigan",
    shortName: "Adrian",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MI",
    state: "Michigan",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mi-067",
    lat: 42.939656,
    lng: -85.794604,
    panoId: "BD33Fyb475jEYeTUs-XAkw",
    place: "Near Jenison, Michigan",
    shortName: "Jenison",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MI",
    state: "Michigan",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mi-068",
    lat: 42.760865,
    lng: -83.412044,
    panoId: "QW4W5RBVoRBJ_9JqTIFbtg",
    place: "Near Clarkston, Michigan",
    shortName: "Clarkston",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MI",
    state: "Michigan",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mi-069",
    lat: 41.98609,
    lng: -83.42452,
    panoId: "8gaGx-yYFlbcDj_0dYmRCA",
    place: "Near West Monroe, Michigan",
    shortName: "West Monroe",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MI",
    state: "Michigan",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MI"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-mi-070",
    lat: 46.564803,
    lng: -87.444208,
    panoId: "z4-FIywAoxGVK6hCHleSEQ",
    place: "Near Trowbridge Park, Michigan",
    shortName: "Trowbridge Park",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MI",
    state: "Michigan",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mi-071",
    lat: 42.715455,
    lng: -84.337358,
    panoId: "mB-lKV2RFPXFr2LE5qZARg",
    place: "Near Williamston, Michigan",
    shortName: "Williamston",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MI",
    state: "Michigan",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MI"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-mi-072",
    lat: 43.48859,
    lng: -84.014901,
    panoId: "LRwKFU_5IJhJYyVCiGLilg",
    place: "Near Saginaw Township North, Michigan",
    shortName: "Saginaw Township North",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MI",
    state: "Michigan",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MI"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-mi-073",
    lat: 43.546021,
    lng: -83.944764,
    panoId: "cdclW8bbO8-n4ciqn7QB6A",
    place: "Near Bay City, Michigan",
    shortName: "Bay City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MI",
    state: "Michigan",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mi-074",
    lat: 42.699598,
    lng: -84.601658,
    panoId: "uVn3Ewb4dewelapUfK3zCw",
    place: "Near Waverly, Michigan",
    shortName: "Waverly",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MI",
    state: "Michigan",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mi-075",
    lat: 42.731366,
    lng: -83.21668,
    panoId: "mP2gjqXEyfFQMT3ROOdXhg",
    place: "Near Auburn Hills, Michigan",
    shortName: "Auburn Hills",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MI",
    state: "Michigan",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mi-076",
    lat: 43.038007,
    lng: -83.710996,
    panoId: "abXMOw5OdNXnlkfzZY1ILA",
    place: "Near Flint, Michigan",
    shortName: "Flint",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MI",
    state: "Michigan",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mi-077",
    lat: 43.132802,
    lng: -86.249346,
    panoId: "xrlBC4d7EAC4L7teOB1S1Q",
    place: "Near Norton Shores, Michigan",
    shortName: "Norton Shores",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MI",
    state: "Michigan",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mi-078",
    lat: 42.178093,
    lng: -83.611275,
    panoId: "0dE6Eewnhl_xRh4KfTPQCw",
    place: "Near Ypsilanti, Michigan",
    shortName: "Ypsilanti",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MI",
    state: "Michigan",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mi-079",
    lat: 43.04074,
    lng: -84.167048,
    panoId: "nOCNgogI4drzSt5NTaGy8Q",
    place: "Near Owosso, Michigan",
    shortName: "Owosso",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MI",
    state: "Michigan",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mi-080",
    lat: 42.350001,
    lng: -85.568955,
    panoId: "e0lMCgf7Dlsv4OxuzWfX7A",
    place: "Near Parchment, Michigan",
    shortName: "Parchment",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MI",
    state: "Michigan",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mi-081",
    lat: 42.769684,
    lng: -84.547054,
    panoId: "ZYcSvM3SHnVAaPBOMTkKhw",
    place: "Near Lansing, Michigan",
    shortName: "Lansing",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MI",
    state: "Michigan",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mi-082",
    lat: 43.044185,
    lng: -83.611159,
    panoId: "ckl5LklAh1ixEHtmbenpAA",
    place: "Near Burton, Michigan",
    shortName: "Burton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MI",
    state: "Michigan",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mi-083",
    lat: 43.63753,
    lng: -84.84859,
    panoId: "ovwytIjQb6rFacS6Ahot4A",
    place: "Near Mount Pleasant, Michigan",
    shortName: "Mount Pleasant",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MI",
    state: "Michigan",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mi-084",
    lat: 42.998198,
    lng: -85.666923,
    panoId: "_P0e9fB3tYxhOvHuHwOtZw",
    place: "Near Grand Rapids, Michigan",
    shortName: "Grand Rapids",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MI",
    state: "Michigan",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MI"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-mi-085",
    lat: 42.359478,
    lng: -85.13218,
    panoId: "BSJXQuFdHZdaVtGGi2bodw",
    place: "Near Brownlee Park, Michigan",
    shortName: "Brownlee Park",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MI",
    state: "Michigan",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mi-086",
    lat: 43.068699,
    lng: -85.768074,
    panoId: "Kn_dJshjOvYeEh5wQhHgoA",
    place: "Near Walker, Michigan",
    shortName: "Walker",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MI",
    state: "Michigan",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mi-087",
    lat: 43.222147,
    lng: -86.154627,
    panoId: "gHMG_AIVw7_KNsl6ViQDXQ",
    place: "Near Wolf Lake, Michigan",
    shortName: "Wolf Lake",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MI",
    state: "Michigan",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mi-088",
    lat: 46.483649,
    lng: -87.241397,
    panoId: "RnKUfxAwF91AAZZaA7O5TQ",
    place: "Near Harvey, Michigan",
    shortName: "Harvey",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MI",
    state: "Michigan",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mi-089",
    lat: 43.532478,
    lng: -84.36982,
    panoId: "IsBEyVxFWx9aWD04aQ8_oA",
    place: "Near Midland, Michigan",
    shortName: "Midland",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MI",
    state: "Michigan",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mi-090",
    lat: 43.248951,
    lng: -86.193887,
    panoId: "MX5AFpMlpAI1zozA8ZY4OQ",
    place: "Near Muskegon, Michigan",
    shortName: "Muskegon",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MI",
    state: "Michigan",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mi-091",
    lat: 42.494662,
    lng: -84.54944,
    panoId: "5kUp7Enm62jwH4jSwYqhGQ",
    place: "Near Eaton Rapids, Michigan",
    shortName: "Eaton Rapids",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MI",
    state: "Michigan",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mi-092",
    lat: 42.98658,
    lng: -86.014344,
    panoId: "sMYeDNPj_o_bd_lXQVRXlw",
    place: "Near Allendale, Michigan",
    shortName: "Allendale",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MI",
    state: "Michigan",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mi-093",
    lat: 42.390785,
    lng: -85.486048,
    panoId: "S2e8ot-c5zZfUu7CC7We1g",
    place: "Near South Gull Lake, Michigan",
    shortName: "South Gull Lake",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MI",
    state: "Michigan",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mi-094",
    lat: 43.57627,
    lng: -85.368865,
    panoId: "IOXx_S2f5b0JLy30pv2vJA",
    place: "Near Canadian Lakes, Michigan",
    shortName: "Canadian Lakes",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MI",
    state: "Michigan",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mi-095",
    lat: 42.803368,
    lng: -85.935987,
    panoId: "Wkx4P6cIkHr5P3l-_blB5g",
    place: "Near Zeeland, Michigan",
    shortName: "Zeeland",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MI",
    state: "Michigan",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mi-096",
    lat: 42.356288,
    lng: -83.806646,
    panoId: "xy5Ew_wrhheFu8mGom5GiA",
    place: "Near Dexter, Michigan",
    shortName: "Dexter",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MI",
    state: "Michigan",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mi-097",
    lat: 42.692758,
    lng: -83.773094,
    panoId: "Bdn41rhY_L7CyHgTNRWgxw",
    place: "Near Argentine, Michigan",
    shortName: "Argentine",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MI",
    state: "Michigan",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mi-098",
    lat: 42.65133,
    lng: -83.648191,
    panoId: "O8addw3i6FBczYr6c6cEng",
    place: "Near Milford, Michigan",
    shortName: "Milford",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MI",
    state: "Michigan",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mi-099",
    lat: 42.63653,
    lng: -83.018386,
    panoId: "HDnKRsKSO0uOy-sxq0ZyIg",
    place: "Near Utica, Michigan",
    shortName: "Utica",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MI",
    state: "Michigan",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mi-100",
    lat: 42.419597,
    lng: -84.312374,
    panoId: "ZbVuIntPZcwYn-PVurDhKQ",
    place: "Near Leslie, Michigan",
    shortName: "Leslie",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MI",
    state: "Michigan",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-MI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mi-101",
    lat: 44.729824,
    lng: -85.421577,
    panoId: "ELFJeOCTGupL6qb-6-La2g",
    place: "Near Rapid City, Michigan",
    shortName: "Rapid City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MI",
    state: "Michigan",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-MI"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-mi-102",
    lat: 42.06725,
    lng: -84.13749,
    panoId: "c-MEYsL0T_tIHQJ_WKoPNg",
    place: "Near Brooklyn, Michigan",
    shortName: "Brooklyn",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MI",
    state: "Michigan",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-MI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mi-103",
    lat: 45.692096,
    lng: -87.325983,
    panoId: "Ecc5gpkncK34OjIy48QGCg",
    place: "Near Escanaba, Michigan",
    shortName: "Escanaba",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MI",
    state: "Michigan",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-MI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mi-104",
    lat: 44.958781,
    lng: -83.646851,
    panoId: "AB-Bb69JZGvSqvxZYkIzrA",
    place: "Near Alpena, Michigan",
    shortName: "Alpena",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MI",
    state: "Michigan",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-MI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mi-105",
    lat: 42.933776,
    lng: -83.124631,
    panoId: "xb8JtpxrVbkQj3slY9QwhQ",
    place: "Near Almont, Michigan",
    shortName: "Almont",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MI",
    state: "Michigan",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-MI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mn-000",
    lat: 45.072411,
    lng: -93.455703,
    panoId: "Stq61HXiAFELFoURFWQhTQ",
    place: "Near Maple Grove, Minnesota",
    shortName: "Maple Grove",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MN",
    state: "Minnesota",
    difficulty: "classic",
    pools: ["world","North America","US","US-MN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mn-001",
    lat: 44.649704,
    lng: -93.242801,
    panoId: "pUFgyA57UkOl7VmHZ6QBng",
    place: "Near Lakeville, Minnesota",
    shortName: "Lakeville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MN",
    state: "Minnesota",
    difficulty: "classic",
    pools: ["world","North America","US","US-MN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mn-002",
    lat: 44.804164,
    lng: -93.167014,
    panoId: "C0flBxK4x3qojI4VQZkyxg",
    place: "Near Eagan, Minnesota",
    shortName: "Eagan",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MN",
    state: "Minnesota",
    difficulty: "classic",
    pools: ["world","North America","US","US-MN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mn-003",
    lat: 44.848027,
    lng: -93.042759,
    panoId: "C5NeLHOPoz8WHaEQ7P1MuQ",
    place: "Near Inver Grove Heights, Minnesota",
    shortName: "Inver Grove Heights",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MN",
    state: "Minnesota",
    difficulty: "classic",
    pools: ["world","North America","US","US-MN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mn-004",
    lat: 44.948263,
    lng: -93.34802,
    panoId: "T15EZAjRaz0I9ozeGpxMKQ",
    place: "Near Saint Louis Park, Minnesota",
    shortName: "Saint Louis Park",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MN",
    state: "Minnesota",
    difficulty: "classic",
    pools: ["world","North America","US","US-MN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mn-005",
    lat: 44.731943,
    lng: -93.217758,
    panoId: "OU6Q3ogAdBrjSRBMZKdshg",
    place: "Near Apple Valley, Minnesota",
    shortName: "Apple Valley",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MN",
    state: "Minnesota",
    difficulty: "classic",
    pools: ["world","North America","US","US-MN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mn-006",
    lat: 45.560982,
    lng: -94.162667,
    panoId: "tSuEwj1Q2SfJybm3dRXEbw",
    place: "Near Saint Cloud, Minnesota",
    shortName: "Saint Cloud",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MN",
    state: "Minnesota",
    difficulty: "classic",
    pools: ["world","North America","US","US-MN"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-mn-007",
    lat: 44.944455,
    lng: -93.093266,
    panoId: "MhBasRjDUlDdSFd2OYbNvg",
    place: "Near Saint Paul, Minnesota",
    shortName: "Saint Paul",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MN",
    state: "Minnesota",
    difficulty: "classic",
    pools: ["world","North America","US","US-MN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mn-008",
    lat: 44.159086,
    lng: -94.009136,
    panoId: "1haPe5DR9qgyGejrJNXycA",
    place: "Near Mankato, Minnesota",
    shortName: "Mankato",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MN",
    state: "Minnesota",
    difficulty: "classic",
    pools: ["world","North America","US","US-MN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mn-009",
    lat: 45.159562,
    lng: -93.349781,
    panoId: "Tgmzhtw64-f7M6sbo6NNJQ",
    place: "Near West Coon Rapids, Minnesota",
    shortName: "West Coon Rapids",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MN",
    state: "Minnesota",
    difficulty: "classic",
    pools: ["world","North America","US","US-MN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mn-010",
    lat: 44.021612,
    lng: -92.469929,
    panoId: "OLahPP7ef-20wrXImaGrWQ",
    place: "Near Rochester, Minnesota",
    shortName: "Rochester",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MN",
    state: "Minnesota",
    difficulty: "classic",
    pools: ["world","North America","US","US-MN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mn-011",
    lat: 44.923825,
    lng: -92.959531,
    panoId: "tWANzW2TMVpArodmYc6fpA",
    place: "Near Woodbury, Minnesota",
    shortName: "Woodbury",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MN",
    state: "Minnesota",
    difficulty: "classic",
    pools: ["world","North America","US","US-MN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mn-012",
    lat: 44.779152,
    lng: -93.33635,
    panoId: "vV72fCrz_O7RYyN1bBuRGA",
    place: "Near Savage, Minnesota",
    shortName: "Savage",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MN",
    state: "Minnesota",
    difficulty: "classic",
    pools: ["world","North America","US","US-MN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mn-013",
    lat: 44.913294,
    lng: -93.503363,
    panoId: "CfGthPWj2OsUeqnCNZBedA",
    place: "Near Minnetonka, Minnesota",
    shortName: "Minnetonka",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MN",
    state: "Minnesota",
    difficulty: "classic",
    pools: ["world","North America","US","US-MN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mn-014",
    lat: 44.798022,
    lng: -93.526941,
    panoId: "XLnPXVglHrBLkAzeACwb5g",
    place: "Near Shakopee, Minnesota",
    shortName: "Shakopee",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MN",
    state: "Minnesota",
    difficulty: "classic",
    pools: ["world","North America","US","US-MN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mn-015",
    lat: 45.010425,
    lng: -93.455645,
    panoId: "Q64BJjfIz2zlZtPbd9itDg",
    place: "Near Plymouth, Minnesota",
    shortName: "Plymouth",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MN",
    state: "Minnesota",
    difficulty: "classic",
    pools: ["world","North America","US","US-MN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mn-016",
    lat: 45.006086,
    lng: -93.156619,
    panoId: "VafspwS7pxIkjZHn8fGD6Q",
    place: "Near Roseville, Minnesota",
    shortName: "Roseville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MN",
    state: "Minnesota",
    difficulty: "classic",
    pools: ["world","North America","US","US-MN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mn-017",
    lat: 44.942542,
    lng: -93.225693,
    panoId: "UoeHiyweLmPj_ukBBPoBhA",
    place: "Near Longfellow Community, Minnesota",
    shortName: "Longfellow Community",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MN",
    state: "Minnesota",
    difficulty: "classic",
    pools: ["world","North America","US","US-MN"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-mn-018",
    lat: 45.23351,
    lng: -93.291363,
    panoId: "pYIC77ouYOUcekVgj52DDA",
    place: "Near Andover, Minnesota",
    shortName: "Andover",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MN",
    state: "Minnesota",
    difficulty: "classic",
    pools: ["world","North America","US","US-MN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mn-019",
    lat: 44.97994,
    lng: -93.263817,
    panoId: "luQrrLR76vaqnJbcjD0kOw",
    place: "Near Minneapolis, Minnesota",
    shortName: "Minneapolis",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MN",
    state: "Minnesota",
    difficulty: "classic",
    pools: ["world","North America","US","US-MN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mn-020",
    lat: 44.82782,
    lng: -92.943986,
    panoId: "QOCL0Po8e7tmy6Y6X1pAOQ",
    place: "Near Cottage Grove, Minnesota",
    shortName: "Cottage Grove",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MN",
    state: "Minnesota",
    difficulty: "classic",
    pools: ["world","North America","US","US-MN"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-mn-021",
    lat: 44.883382,
    lng: -93.283046,
    panoId: "PFuPe4yYl_qvIa89ipBOMA",
    place: "Near Richfield, Minnesota",
    shortName: "Richfield",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MN",
    state: "Minnesota",
    difficulty: "classic",
    pools: ["world","North America","US","US-MN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mn-022",
    lat: 46.873847,
    lng: -96.76951,
    panoId: "FjXzySaRk-A-7UwEAh-YUg",
    place: "Near Moorhead, Minnesota",
    shortName: "Moorhead",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MN",
    state: "Minnesota",
    difficulty: "classic",
    pools: ["world","North America","US","US-MN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mn-023",
    lat: 44.049946,
    lng: -91.639337,
    panoId: "TQRm3WZDddWu2bUYsp-Nhw",
    place: "Near Winona, Minnesota",
    shortName: "Winona",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MN",
    state: "Minnesota",
    difficulty: "classic",
    pools: ["world","North America","US","US-MN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mn-024",
    lat: 44.941072,
    lng: -93.441801,
    panoId: "NFvScVcasiAnHwo0_695pw",
    place: "Near Minnetonka Mills, Minnesota",
    shortName: "Minnetonka Mills",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MN",
    state: "Minnesota",
    difficulty: "classic",
    pools: ["world","North America","US","US-MN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mn-025",
    lat: 44.840751,
    lng: -93.29829,
    panoId: "mEIHX9YHbqg3BQ_HkrkGCQ",
    place: "Near Bloomington, Minnesota",
    shortName: "Bloomington",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MN",
    state: "Minnesota",
    difficulty: "classic",
    pools: ["world","North America","US","US-MN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mn-026",
    lat: 44.08375,
    lng: -93.226041,
    panoId: "EvNM1VKTAQzh9f70EJsXxA",
    place: "Near Owatonna, Minnesota",
    shortName: "Owatonna",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MN",
    state: "Minnesota",
    difficulty: "classic",
    pools: ["world","North America","US","US-MN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mn-027",
    lat: 44.854458,
    lng: -93.470438,
    panoId: "OSMo_YEQ_hPNmbKJx2Qvcg",
    place: "Near Eden Prairie, Minnesota",
    shortName: "Eden Prairie",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MN",
    state: "Minnesota",
    difficulty: "classic",
    pools: ["world","North America","US","US-MN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mn-028",
    lat: 45.120196,
    lng: -93.287777,
    panoId: "jbKMlO9jc26Tkj5PSVbHew",
    place: "Near Coon Rapids, Minnesota",
    shortName: "Coon Rapids",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MN",
    state: "Minnesota",
    difficulty: "classic",
    pools: ["world","North America","US","US-MN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mn-029",
    lat: 46.783159,
    lng: -92.106375,
    panoId: "9n_hUU3RaLRCKLpBOCH_Iw",
    place: "Near Duluth, Minnesota",
    shortName: "Duluth",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MN",
    state: "Minnesota",
    difficulty: "classic",
    pools: ["world","North America","US","US-MN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mn-030",
    lat: 45.086087,
    lng: -93.263311,
    panoId: "PPOAh9BwDJKvA5idl9xKZA",
    place: "Near Fridley, Minnesota",
    shortName: "Fridley",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MN",
    state: "Minnesota",
    difficulty: "classic",
    pools: ["world","North America","US","US-MN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mn-031",
    lat: 44.889717,
    lng: -93.350003,
    panoId: "G1LE7TOP5PnupvjkpaY02w",
    place: "Near Edina, Minnesota",
    shortName: "Edina",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MN",
    state: "Minnesota",
    difficulty: "classic",
    pools: ["world","North America","US","US-MN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mn-032",
    lat: 44.953161,
    lng: -92.995193,
    panoId: "-t0M2IpAdp3ppYM39AqEnQ",
    place: "Near Maplewood, Minnesota",
    shortName: "Maplewood",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MN",
    state: "Minnesota",
    difficulty: "classic",
    pools: ["world","North America","US","US-MN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mn-033",
    lat: 44.963156,
    lng: -92.964926,
    panoId: "TveBjNChzYDQt2H4udxSsA",
    place: "Near Oakdale, Minnesota",
    shortName: "Oakdale",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MN",
    state: "Minnesota",
    difficulty: "classic",
    pools: ["world","North America","US","US-MN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mn-034",
    lat: 44.153265,
    lng: -94.018754,
    panoId: "2RKJ7-kMYZoshnkM0cwp3g",
    place: "Near Mankato, Minnesota",
    shortName: "Mankato",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MN",
    state: "Minnesota",
    difficulty: "classic",
    pools: ["world","North America","US","US-MN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mn-035",
    lat: 44.813235,
    lng: -92.952102,
    panoId: "DBMTDJIaOBkrdRUr2fsOFA",
    place: "Near Cottage Grove, Minnesota",
    shortName: "Cottage Grove",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MN",
    state: "Minnesota",
    difficulty: "classic",
    pools: ["world","North America","US","US-MN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mn-036",
    lat: 44.073126,
    lng: -93.202858,
    panoId: "BllrwGEMkB3NsIbxYVo8Eg",
    place: "Near Owatonna, Minnesota",
    shortName: "Owatonna",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MN",
    state: "Minnesota",
    difficulty: "classic",
    pools: ["world","North America","US","US-MN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mn-037",
    lat: 44.933445,
    lng: -92.982234,
    panoId: "wV_mk_sFRlcu7mybL0VNog",
    place: "Near Woodbury, Minnesota",
    shortName: "Woodbury",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MN",
    state: "Minnesota",
    difficulty: "classic",
    pools: ["world","North America","US","US-MN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mn-038",
    lat: 44.803568,
    lng: -93.142853,
    panoId: "fC87yPrfuaLKDBxz5CnFKA",
    place: "Near Eagan, Minnesota",
    shortName: "Eagan",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MN",
    state: "Minnesota",
    difficulty: "classic",
    pools: ["world","North America","US","US-MN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mn-039",
    lat: 45.006173,
    lng: -93.185269,
    panoId: "pSujJn2mSgEDD4xSb4M3Kw",
    place: "Near Lauderdale, Minnesota",
    shortName: "Lauderdale",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MN",
    state: "Minnesota",
    difficulty: "classic",
    pools: ["world","North America","US","US-MN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mn-040",
    lat: 44.659684,
    lng: -93.22358,
    panoId: "2PyLVePgZV0lsClnMig6yA",
    place: "Near Lakeville, Minnesota",
    shortName: "Lakeville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MN",
    state: "Minnesota",
    difficulty: "classic",
    pools: ["world","North America","US","US-MN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mn-041",
    lat: 46.860799,
    lng: -96.773664,
    panoId: "L6PqRFbgt4edIT8b2m-sIg",
    place: "Near Moorhead, Minnesota",
    shortName: "Moorhead",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MN",
    state: "Minnesota",
    difficulty: "classic",
    pools: ["world","North America","US","US-MN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mn-042",
    lat: 46.766127,
    lng: -92.114106,
    panoId: "K5GG_pPM_hNYrPR_WReRDw",
    place: "Near Duluth, Minnesota",
    shortName: "Duluth",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MN",
    state: "Minnesota",
    difficulty: "classic",
    pools: ["world","North America","US","US-MN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mn-043",
    lat: 45.575847,
    lng: -94.152745,
    panoId: "Ua6_pE8jg3Nwvqv-r6rxDA",
    place: "Near Saint Cloud, Minnesota",
    shortName: "Saint Cloud",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MN",
    state: "Minnesota",
    difficulty: "classic",
    pools: ["world","North America","US","US-MN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mn-044",
    lat: 44.035208,
    lng: -91.620915,
    panoId: "jIxoO-OqBBhEKM_vJEmzpA",
    place: "Near Winona, Minnesota",
    shortName: "Winona",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MN",
    state: "Minnesota",
    difficulty: "classic",
    pools: ["world","North America","US","US-MN"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-mn-045",
    lat: 44.020831,
    lng: -92.483472,
    panoId: "DRppHzUxDGl9tUEweuXtLA",
    place: "Near Rochester, Minnesota",
    shortName: "Rochester",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MN",
    state: "Minnesota",
    difficulty: "classic",
    pools: ["world","North America","US","US-MN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mn-046",
    lat: 44.867234,
    lng: -93.057461,
    panoId: "zXAViBfnluoLLxak7x_knA",
    place: "Near Inver Grove Heights, Minnesota",
    shortName: "Inver Grove Heights",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MN",
    state: "Minnesota",
    difficulty: "classic",
    pools: ["world","North America","US","US-MN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mn-047",
    lat: 44.71005,
    lng: -93.21451,
    panoId: "u_yB032DPs7N6iH2HL9KNQ",
    place: "Near Apple Valley, Minnesota",
    shortName: "Apple Valley",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MN",
    state: "Minnesota",
    difficulty: "classic",
    pools: ["world","North America","US","US-MN"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-mn-048",
    lat: 45.120658,
    lng: -93.350457,
    panoId: "vZdclWaN0zgAC6c5n4FcgQ",
    place: "Near Brooklyn Park, Minnesota",
    shortName: "Brooklyn Park",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MN",
    state: "Minnesota",
    difficulty: "classic",
    pools: ["world","North America","US","US-MN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mn-049",
    lat: 44.932204,
    lng: -93.251743,
    panoId: "J2En4HtiEjNqv4W0d9uR7Q",
    place: "Near Longfellow Community, Minnesota",
    shortName: "Longfellow Community",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MN",
    state: "Minnesota",
    difficulty: "classic",
    pools: ["world","North America","US","US-MN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mn-050",
    lat: 44.945468,
    lng: -93.392079,
    panoId: "0IEMdBw2CRjRvrByHzxvuw",
    place: "Near Saint Louis Park, Minnesota",
    shortName: "Saint Louis Park",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MN",
    state: "Minnesota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mn-051",
    lat: 45.208292,
    lng: -93.198162,
    panoId: "j78mENTgEUHoJmOQB_VOJg",
    place: "Near Blaine, Minnesota",
    shortName: "Blaine",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MN",
    state: "Minnesota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mn-052",
    lat: 45.2974,
    lng: -93.409874,
    panoId: "adKnANAMDO77TViYhYtN7Q",
    place: "Near Ramsey, Minnesota",
    shortName: "Ramsey",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MN",
    state: "Minnesota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mn-053",
    lat: 45.009967,
    lng: -93.413293,
    panoId: "-tPk674TFoLYy34tJZuINA",
    place: "Near Plymouth, Minnesota",
    shortName: "Plymouth",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MN",
    state: "Minnesota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mn-054",
    lat: 45.137755,
    lng: -93.391439,
    panoId: "eDhdki0ed5rKgufk-_CULQ",
    place: "Near Osseo, Minnesota",
    shortName: "Osseo",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MN",
    state: "Minnesota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mn-055",
    lat: 45.100097,
    lng: -93.4015,
    panoId: "YYB1hVxnhOEjBtiagA8GrA",
    place: "Near Osseo, Minnesota",
    shortName: "Osseo",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MN",
    state: "Minnesota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mn-056",
    lat: 44.873059,
    lng: -93.223117,
    panoId: "lyXneCv5teeyf6lMckZnkg",
    place: "Near Richfield, Minnesota",
    shortName: "Richfield",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MN",
    state: "Minnesota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mn-057",
    lat: 44.915175,
    lng: -93.263928,
    panoId: "f3yaLtPNAAW_hF1Nd5OC1Q",
    place: "Near Richfield, Minnesota",
    shortName: "Richfield",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MN",
    state: "Minnesota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mn-058",
    lat: 44.906162,
    lng: -93.315334,
    panoId: "P90rwU_aRprklF1Eyo7N_g",
    place: "Near Edina, Minnesota",
    shortName: "Edina",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MN",
    state: "Minnesota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mn-059",
    lat: 44.6868,
    lng: -93.136478,
    panoId: "Us8L08nDuXXKjGZPWvD9Lg",
    place: "Near Farmington, Minnesota",
    shortName: "Farmington",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MN",
    state: "Minnesota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mn-060",
    lat: 44.79731,
    lng: -93.003247,
    panoId: "_eZBOlZXwuTdehbQ9DiABw",
    place: "Near Saint Paul Park, Minnesota",
    shortName: "Saint Paul Park",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MN",
    state: "Minnesota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mn-061",
    lat: 44.060106,
    lng: -93.134013,
    panoId: "WPNg-d0TBsRwkJDqFCvhIQ",
    place: "Near Owatonna, Minnesota",
    shortName: "Owatonna",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MN",
    state: "Minnesota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mn-062",
    lat: 44.830889,
    lng: -93.711757,
    panoId: "yW5GKG2wn3PuZvOT8uZ_9A",
    place: "Near Victoria, Minnesota",
    shortName: "Victoria",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MN",
    state: "Minnesota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mn-063",
    lat: 44.623419,
    lng: -93.175241,
    panoId: "u2w7hPfUWoP1OiifPVdibw",
    place: "Near Farmington, Minnesota",
    shortName: "Farmington",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MN",
    state: "Minnesota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mn-064",
    lat: 44.796166,
    lng: -93.257855,
    panoId: "dW2PctN5a3jf3mJtBIut8g",
    place: "Near Burnsville, Minnesota",
    shortName: "Burnsville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MN",
    state: "Minnesota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mn-065",
    lat: 44.909384,
    lng: -93.177755,
    panoId: "g8u_Vg-Vx6DSj6sxOH3t7w",
    place: "Near Mendota Heights, Minnesota",
    shortName: "Mendota Heights",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MN",
    state: "Minnesota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mn-066",
    lat: 44.015117,
    lng: -91.684173,
    panoId: "deeSKybjq1bmB8ISRRnCPg",
    place: "Near Winona, Minnesota",
    shortName: "Winona",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MN",
    state: "Minnesota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mn-067",
    lat: 45.284818,
    lng: -93.473457,
    panoId: "ZgmecRvFIV0QdcAvAEmJMQ",
    place: "Near Ramsey, Minnesota",
    shortName: "Ramsey",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MN",
    state: "Minnesota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mn-068",
    lat: 46.811229,
    lng: -92.180405,
    panoId: "ZoZBlxFq-e_JTToeEKvxtQ",
    place: "Near Hermantown, Minnesota",
    shortName: "Hermantown",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MN",
    state: "Minnesota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MN"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-mn-069",
    lat: 44.69936,
    lng: -93.735033,
    panoId: "xJysZju0MCvJhgMribXQqw",
    place: "Near Cologne, Minnesota",
    shortName: "Cologne",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MN",
    state: "Minnesota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mn-070",
    lat: 43.637525,
    lng: -93.055844,
    panoId: "Qo1qVi8KCOQg3fnWbNhefg",
    place: "Near Austin, Minnesota",
    shortName: "Austin",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MN",
    state: "Minnesota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mn-071",
    lat: 45.094657,
    lng: -93.612435,
    panoId: "AqghuNj6m7JfsD5xkbYIBw",
    place: "Near Corcoran, Minnesota",
    shortName: "Corcoran",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MN",
    state: "Minnesota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mn-072",
    lat: 45.040441,
    lng: -93.44544,
    panoId: "9WcJ504gGf0ApBT3eF0N5Q",
    place: "Near Plymouth, Minnesota",
    shortName: "Plymouth",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MN",
    state: "Minnesota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mn-073",
    lat: 45.219041,
    lng: -93.340255,
    panoId: "7f2rxfMqj6f1grAbVQAH4w",
    place: "Near Andover, Minnesota",
    shortName: "Andover",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MN",
    state: "Minnesota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mn-074",
    lat: 45.34327,
    lng: -93.569191,
    panoId: "5PipPzak98M8MrdUMWabQw",
    place: "Near Elk River, Minnesota",
    shortName: "Elk River",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MN",
    state: "Minnesota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mn-075",
    lat: 44.630361,
    lng: -93.409729,
    panoId: "l9Fyn6tV2nePYXVZ98rDTA",
    place: "Near Prior Lake, Minnesota",
    shortName: "Prior Lake",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MN",
    state: "Minnesota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mn-076",
    lat: 44.731268,
    lng: -92.763303,
    panoId: "67nGbRmwyWyH6hqVL4ukiw",
    place: "Near Prescott, Minnesota",
    shortName: "Prescott",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MN",
    state: "Minnesota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mn-077",
    lat: 44.619862,
    lng: -93.414976,
    panoId: "4BZ7JqLQIZiSkS6TRs6SQw",
    place: "Near Elko New Market, Minnesota",
    shortName: "Elko New Market",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MN",
    state: "Minnesota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MN"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "us-mn-078",
    lat: 44.707862,
    lng: -93.176763,
    panoId: "7Lox2K_-m_8SwmRk2ujzCg",
    place: "Near Apple Valley, Minnesota",
    shortName: "Apple Valley",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MN",
    state: "Minnesota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mn-079",
    lat: 44.357472,
    lng: -93.322636,
    panoId: "ZNUsRra3PrvJwiTdZm2WjA",
    place: "Near Faribault, Minnesota",
    shortName: "Faribault",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MN",
    state: "Minnesota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MN"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "us-mn-080",
    lat: 45.174339,
    lng: -93.048374,
    panoId: "P24QU7dDf5WptZN0eeMVCw",
    place: "Near Centerville, Minnesota",
    shortName: "Centerville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MN",
    state: "Minnesota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mn-081",
    lat: 47.371675,
    lng: -92.912339,
    panoId: "M2lqr4JUcHOZZ6JgCaTNtw",
    place: "Near Hibbing, Minnesota",
    shortName: "Hibbing",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MN",
    state: "Minnesota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mn-082",
    lat: 45.120204,
    lng: -93.905101,
    panoId: "BEwhUeLpCR37WVd_NmF73w",
    place: "Near Montrose, Minnesota",
    shortName: "Montrose",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MN",
    state: "Minnesota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mn-083",
    lat: 45.655521,
    lng: -94.283965,
    panoId: "hBIwx2b2fXXFIeZDRHTaNg",
    place: "Near Sartell, Minnesota",
    shortName: "Sartell",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MN",
    state: "Minnesota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mn-084",
    lat: 47.495536,
    lng: -94.927551,
    panoId: "hcoZMIO0qukcbh6jiX78zA",
    place: "Near Bemidji, Minnesota",
    shortName: "Bemidji",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MN",
    state: "Minnesota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mn-085",
    lat: 45.081561,
    lng: -95.046204,
    panoId: "On90WSSqIepKsena6HnBEw",
    place: "Near Willmar, Minnesota",
    shortName: "Willmar",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MN",
    state: "Minnesota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MN"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-mn-086",
    lat: 44.326891,
    lng: -93.18885,
    panoId: "zeF3bZZQSYePyoMBaKW8Rg",
    place: "Near Faribault, Minnesota",
    shortName: "Faribault",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MN",
    state: "Minnesota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mn-087",
    lat: 43.631228,
    lng: -93.268359,
    panoId: "YgepAhOgnIahG6n99FEQTA",
    place: "Near Albert Lea, Minnesota",
    shortName: "Albert Lea",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MN",
    state: "Minnesota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mn-088",
    lat: 44.833343,
    lng: -92.829631,
    panoId: "Bl5hYkpMvysJYgKBPkbjoQ",
    place: "Near Afton, Minnesota",
    shortName: "Afton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MN",
    state: "Minnesota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mn-089",
    lat: 45.26686,
    lng: -92.901926,
    panoId: "yXw9nPQPH3_g7Dt9iZOvqg",
    place: "Near Forest Lake, Minnesota",
    shortName: "Forest Lake",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MN",
    state: "Minnesota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mn-090",
    lat: 45.208182,
    lng: -92.884199,
    panoId: "xTFqdjKK3GGrdqDGwdzP4Q",
    place: "Near Scandia, Minnesota",
    shortName: "Scandia",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MN",
    state: "Minnesota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mn-091",
    lat: 44.702502,
    lng: -92.96383,
    panoId: "f8Czq2SRinIbB9WKmcG9uA",
    place: "Near Hastings, Minnesota",
    shortName: "Hastings",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MN",
    state: "Minnesota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mn-092",
    lat: 44.998966,
    lng: -93.108789,
    panoId: "7fgJ5e4r93vDtLUekz0-3w",
    place: "Near Little Canada, Minnesota",
    shortName: "Little Canada",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MN",
    state: "Minnesota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MN"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-mn-093",
    lat: 44.935868,
    lng: -94.325201,
    panoId: "qq1HT3sNtF6pwjghb6OMlg",
    place: "Near Hutchinson, Minnesota",
    shortName: "Hutchinson",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MN",
    state: "Minnesota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MN"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-mn-094",
    lat: 44.999738,
    lng: -92.926484,
    panoId: "KbhzTMUI9bRT2vasOp60tQ",
    place: "Near Lake Elmo, Minnesota",
    shortName: "Lake Elmo",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MN",
    state: "Minnesota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mn-095",
    lat: 45.228838,
    lng: -93.054084,
    panoId: "aBqvyY1nAxXiee4lodolmg",
    place: "Near Columbus, Minnesota",
    shortName: "Columbus",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MN",
    state: "Minnesota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mn-096",
    lat: 45.197439,
    lng: -93.599413,
    panoId: "lsGRXUGA7OZIWbNnroKZnQ",
    place: "Near Rogers, Minnesota",
    shortName: "Rogers",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MN",
    state: "Minnesota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mn-097",
    lat: 43.71619,
    lng: -93.389016,
    panoId: "zoMLbxvd3wFAq4DuLVscVQ",
    place: "Near Albert Lea, Minnesota",
    shortName: "Albert Lea",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MN",
    state: "Minnesota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mn-098",
    lat: 45.046916,
    lng: -92.925852,
    panoId: "1xzq3QH88xIsHpKYdUgWJw",
    place: "Near Mahtomedi, Minnesota",
    shortName: "Mahtomedi",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MN",
    state: "Minnesota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mn-099",
    lat: 45.177386,
    lng: -93.185449,
    panoId: "tTxXJfX-7l2L6wUXLn6VKQ",
    place: "Near Circle Pines, Minnesota",
    shortName: "Circle Pines",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MN",
    state: "Minnesota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mn-100",
    lat: 44.330467,
    lng: -93.020377,
    panoId: "esqF4DPc79fLEOSc9ES9Lg",
    place: "Near Kenyon, Minnesota",
    shortName: "Kenyon",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MN",
    state: "Minnesota",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-MN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mn-101",
    lat: 44.646628,
    lng: -92.958572,
    panoId: "a12sXmqi9kSv2AOKKEWSTA",
    place: "Near Hastings, Minnesota",
    shortName: "Hastings",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MN",
    state: "Minnesota",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-MN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mn-102",
    lat: 45.446411,
    lng: -94.203961,
    panoId: "McTRy9nm0NdGYYnHyC-8xg",
    place: "Near Saint Augusta, Minnesota",
    shortName: "Saint Augusta",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MN",
    state: "Minnesota",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-MN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mn-103",
    lat: 47.13478,
    lng: -93.631279,
    panoId: "bx0RtZoxlpyzgrv1Mn2nRw",
    place: "Near Grand Rapids, Minnesota",
    shortName: "Grand Rapids",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MN",
    state: "Minnesota",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-MN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mn-104",
    lat: 45.042842,
    lng: -95.288285,
    panoId: "NYF1_yoq4qFL_S7SQj69ng",
    place: "Near Clara City, Minnesota",
    shortName: "Clara City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MN",
    state: "Minnesota",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-MN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mn-105",
    lat: 44.635145,
    lng: -92.772409,
    panoId: "vdNOJPoUtDyVsDqH_ie5CQ",
    place: "Near Prescott, Minnesota",
    shortName: "Prescott",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MN",
    state: "Minnesota",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-MN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ms-000",
    lat: 31.327097,
    lng: -89.290366,
    panoId: "Hy1vL9xBXm2l-G5YFVK-ow",
    place: "Near Hattiesburg, Mississippi",
    shortName: "Hattiesburg",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MS",
    state: "Mississippi",
    difficulty: "classic",
    pools: ["world","North America","US","US-MS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ms-001",
    lat: 31.693847,
    lng: -89.130653,
    panoId: "b8L2aiVALXHDEoLL2z6IpA",
    place: "Near Laurel, Mississippi",
    shortName: "Laurel",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MS",
    state: "Mississippi",
    difficulty: "classic",
    pools: ["world","North America","US","US-MS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ms-002",
    lat: 30.396091,
    lng: -88.885249,
    panoId: "WX3jQOnHJS7zgCuek66RUw",
    place: "Near Biloxi, Mississippi",
    shortName: "Biloxi",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MS",
    state: "Mississippi",
    difficulty: "classic",
    pools: ["world","North America","US","US-MS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ms-003",
    lat: 32.364353,
    lng: -88.703629,
    panoId: "pEya4Om42I_qXeVlJ1415w",
    place: "Near Meridian, Mississippi",
    shortName: "Meridian",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MS",
    state: "Mississippi",
    difficulty: "classic",
    pools: ["world","North America","US","US-MS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ms-004",
    lat: 32.341554,
    lng: -90.321765,
    panoId: "O27nGHoC3GAXdx8NcTRMfg",
    place: "Near Clinton, Mississippi",
    shortName: "Clinton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MS",
    state: "Mississippi",
    difficulty: "classic",
    pools: ["world","North America","US","US-MS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ms-005",
    lat: 30.404113,
    lng: -89.094279,
    panoId: "4bLg8hHhDZy0tBRSXGRGpA",
    place: "Near West Gulfport, Mississippi",
    shortName: "West Gulfport",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MS",
    state: "Mississippi",
    difficulty: "classic",
    pools: ["world","North America","US","US-MS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ms-006",
    lat: 30.365897,
    lng: -88.556211,
    panoId: "Ps_UfeRsej7B5J2Eb_ND_A",
    place: "Near Pascagoula, Mississippi",
    shortName: "Pascagoula",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MS",
    state: "Mississippi",
    difficulty: "classic",
    pools: ["world","North America","US","US-MS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ms-007",
    lat: 32.612607,
    lng: -90.036767,
    panoId: "iewTqlueTFJAU_ZY_wwDdw",
    place: "Near Canton, Mississippi",
    shortName: "Canton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MS",
    state: "Mississippi",
    difficulty: "classic",
    pools: ["world","North America","US","US-MS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ms-008",
    lat: 30.426413,
    lng: -88.890802,
    panoId: "cqG4UAU5JtO9a_ZOygTg0w",
    place: "Near D'Iberville, Mississippi",
    shortName: "D'Iberville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MS",
    state: "Mississippi",
    difficulty: "classic",
    pools: ["world","North America","US","US-MS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ms-009",
    lat: 34.824006,
    lng: -89.993444,
    panoId: "N6P6HQetrQzj9v_rqYYhpw",
    place: "Near Hernando, Mississippi",
    shortName: "Hernando",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MS",
    state: "Mississippi",
    difficulty: "classic",
    pools: ["world","North America","US","US-MS"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-ms-010",
    lat: 32.428526,
    lng: -90.132491,
    panoId: "o30rHPt55fD_Evrt00u_zw",
    place: "Near Ridgeland, Mississippi",
    shortName: "Ridgeland",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MS",
    state: "Mississippi",
    difficulty: "classic",
    pools: ["world","North America","US","US-MS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ms-011",
    lat: 31.579123,
    lng: -90.440673,
    panoId: "U5Twmz7ojyRckKPbhj-iQQ",
    place: "Near Brookhaven, Mississippi",
    shortName: "Brookhaven",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MS",
    state: "Mississippi",
    difficulty: "classic",
    pools: ["world","North America","US","US-MS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ms-012",
    lat: 34.366525,
    lng: -89.519194,
    panoId: "5iCbNIdGzlQXpPqtOdWj-g",
    place: "Near Oxford, Mississippi",
    shortName: "Oxford",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MS",
    state: "Mississippi",
    difficulty: "classic",
    pools: ["world","North America","US","US-MS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ms-013",
    lat: 32.273096,
    lng: -89.98589,
    panoId: "sctUybNrTdAIeU-5yoFDGg",
    place: "Near Brandon, Mississippi",
    shortName: "Brandon",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MS",
    state: "Mississippi",
    difficulty: "classic",
    pools: ["world","North America","US","US-MS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ms-014",
    lat: 30.616884,
    lng: -89.651622,
    panoId: "fr6K_0MARQygv717M0XGaA",
    place: "Near Carriere, Mississippi",
    shortName: "Carriere",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MS",
    state: "Mississippi",
    difficulty: "classic",
    pools: ["world","North America","US","US-MS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ms-015",
    lat: 32.461841,
    lng: -90.115312,
    panoId: "3CGt98LUl3kr8OYywCI7TQ",
    place: "Near Madison, Mississippi",
    shortName: "Madison",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MS",
    state: "Mississippi",
    difficulty: "classic",
    pools: ["world","North America","US","US-MS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ms-016",
    lat: 34.934586,
    lng: -88.521942,
    panoId: "FHc2omt28BXOEqcUFKfJew",
    place: "Near Corinth, Mississippi",
    shortName: "Corinth",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MS",
    state: "Mississippi",
    difficulty: "classic",
    pools: ["world","North America","US","US-MS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ms-017",
    lat: 33.768947,
    lng: -89.808381,
    panoId: "1PEEKwSbSvbmTF86BrLRlA",
    place: "Near Grenada, Mississippi",
    shortName: "Grenada",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MS",
    state: "Mississippi",
    difficulty: "classic",
    pools: ["world","North America","US","US-MS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ms-018",
    lat: 30.411343,
    lng: -88.534623,
    panoId: "eoi_dUFcyrlXSkI59CtB5Q",
    place: "Near Moss Point, Mississippi",
    shortName: "Moss Point",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MS",
    state: "Mississippi",
    difficulty: "classic",
    pools: ["world","North America","US","US-MS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ms-019",
    lat: 30.411275,
    lng: -88.827801,
    panoId: "08AH0GHPuyxIx65yjts3Fw",
    place: "Near Ocean Springs, Mississippi",
    shortName: "Ocean Springs",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MS",
    state: "Mississippi",
    difficulty: "classic",
    pools: ["world","North America","US","US-MS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ms-020",
    lat: 32.179307,
    lng: -90.2454,
    panoId: "lYMCkHumcU5SWhbKgNmPoQ",
    place: "Near Byram, Mississippi",
    shortName: "Byram",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MS",
    state: "Mississippi",
    difficulty: "classic",
    pools: ["world","North America","US","US-MS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ms-021",
    lat: 34.200135,
    lng: -90.570899,
    panoId: "z8yUU6p03dILlAUv71s90A",
    place: "Near Clarksdale, Mississippi",
    shortName: "Clarksdale",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MS",
    state: "Mississippi",
    difficulty: "classic",
    pools: ["world","North America","US","US-MS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ms-022",
    lat: 30.350481,
    lng: -89.152847,
    panoId: "uwOFb-I3n0lrpk64KRaNPQ",
    place: "Near Long Beach, Mississippi",
    shortName: "Long Beach",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MS",
    state: "Mississippi",
    difficulty: "classic",
    pools: ["world","North America","US","US-MS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ms-023",
    lat: 32.352639,
    lng: -90.877835,
    panoId: "vqHOo7g4FoZScYvoR7f9jg",
    place: "Near Vicksburg, Mississippi",
    shortName: "Vicksburg",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MS",
    state: "Mississippi",
    difficulty: "classic",
    pools: ["world","North America","US","US-MS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ms-024",
    lat: 31.560205,
    lng: -91.403258,
    panoId: "m0dA85fcOiJw4JP_N99qMQ",
    place: "Near Natchez, Mississippi",
    shortName: "Natchez",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MS",
    state: "Mississippi",
    difficulty: "classic",
    pools: ["world","North America","US","US-MS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ms-025",
    lat: 32.29872,
    lng: -90.184845,
    panoId: "4MrznAZa807Om-bm-sTiVw",
    place: "Near Jackson, Mississippi",
    shortName: "Jackson",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MS",
    state: "Mississippi",
    difficulty: "classic",
    pools: ["world","North America","US","US-MS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ms-026",
    lat: 30.385642,
    lng: -88.612313,
    panoId: "CWi2DpU6DPWFWA_WSY4Znw",
    place: "Near Gautier, Mississippi",
    shortName: "Gautier",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MS",
    state: "Mississippi",
    difficulty: "classic",
    pools: ["world","North America","US","US-MS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ms-027",
    lat: 33.744099,
    lng: -90.724873,
    panoId: "C07FxK6txU5hL6Y6L0x02w",
    place: "Near Cleveland, Mississippi",
    shortName: "Cleveland",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MS",
    state: "Mississippi",
    difficulty: "classic",
    pools: ["world","North America","US","US-MS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ms-028",
    lat: 33.516078,
    lng: -90.180096,
    panoId: "yXNGKzkOvVpigd0z8GdsHw",
    place: "Near Greenwood, Mississippi",
    shortName: "Greenwood",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MS",
    state: "Mississippi",
    difficulty: "classic",
    pools: ["world","North America","US","US-MS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ms-029",
    lat: 32.274627,
    lng: -90.13206,
    panoId: "Bb8KgeJCZZqe5oQXBGgqLw",
    place: "Near Pearl, Mississippi",
    shortName: "Pearl",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MS",
    state: "Mississippi",
    difficulty: "classic",
    pools: ["world","North America","US","US-MS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ms-030",
    lat: 30.367457,
    lng: -89.092808,
    panoId: "YZADc0p7_5jT9LMGnJoT0Q",
    place: "Near Gulfport, Mississippi",
    shortName: "Gulfport",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MS",
    state: "Mississippi",
    difficulty: "classic",
    pools: ["world","North America","US","US-MS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ms-031",
    lat: 31.243679,
    lng: -90.453144,
    panoId: "1zTz06L9xu4QRwvm_OUBMA",
    place: "Near McComb, Mississippi",
    shortName: "McComb",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MS",
    state: "Mississippi",
    difficulty: "classic",
    pools: ["world","North America","US","US-MS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ms-032",
    lat: 33.495734,
    lng: -88.426986,
    panoId: "DjAhuuYCCw5MNzV71b5sKg",
    place: "Near Columbus, Mississippi",
    shortName: "Columbus",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MS",
    state: "Mississippi",
    difficulty: "classic",
    pools: ["world","North America","US","US-MS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ms-033",
    lat: 33.450484,
    lng: -88.818244,
    panoId: "x3Qhvv5iNzigUyqkPzv-BA",
    place: "Near Starkville, Mississippi",
    shortName: "Starkville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MS",
    state: "Mississippi",
    difficulty: "classic",
    pools: ["world","North America","US","US-MS"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-ms-034",
    lat: 31.346624,
    lng: -89.260101,
    panoId: "9wH7E2oRirznoTLlRJg0BQ",
    place: "Near Petal, Mississippi",
    shortName: "Petal",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MS",
    state: "Mississippi",
    difficulty: "classic",
    pools: ["world","North America","US","US-MS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ms-035",
    lat: 33.607661,
    lng: -88.650434,
    panoId: "Zu0S7cX0LyKGpUmwktvVZQ",
    place: "Near West Point, Mississippi",
    shortName: "West Point",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MS",
    state: "Mississippi",
    difficulty: "classic",
    pools: ["world","North America","US","US-MS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ms-036",
    lat: 32.855097,
    lng: -90.405695,
    panoId: "5mdQ91FdXwKD90zlJQzicg",
    place: "Near Yazoo City, Mississippi",
    shortName: "Yazoo City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MS",
    state: "Mississippi",
    difficulty: "classic",
    pools: ["world","North America","US","US-MS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ms-037",
    lat: 30.52544,
    lng: -89.677847,
    panoId: "hH84HrShcwxLDee90bvZQQ",
    place: "Near Picayune, Mississippi",
    shortName: "Picayune",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MS",
    state: "Mississippi",
    difficulty: "classic",
    pools: ["world","North America","US","US-MS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ms-038",
    lat: 34.258096,
    lng: -88.704437,
    panoId: "FAoVdsct3KaqvSeTSkkwjg",
    place: "Near Tupelo, Mississippi",
    shortName: "Tupelo",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MS",
    state: "Mississippi",
    difficulty: "classic",
    pools: ["world","North America","US","US-MS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ms-039",
    lat: 34.359016,
    lng: -89.511803,
    panoId: "4fJFmhVgN5Pn91nwcjhtFQ",
    place: "Near Oxford, Mississippi",
    shortName: "Oxford",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MS",
    state: "Mississippi",
    difficulty: "classic",
    pools: ["world","North America","US","US-MS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ms-040",
    lat: 30.623462,
    lng: -89.642209,
    panoId: "zhm66_Ho71Q8t_GL_bEafw",
    place: "Near Carriere, Mississippi",
    shortName: "Carriere",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MS",
    state: "Mississippi",
    difficulty: "classic",
    pools: ["world","North America","US","US-MS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ms-041",
    lat: 30.3482,
    lng: -89.167853,
    panoId: "IbXBuV2alL_xB0KEq_WfIQ",
    place: "Near Long Beach, Mississippi",
    shortName: "Long Beach",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MS",
    state: "Mississippi",
    difficulty: "classic",
    pools: ["world","North America","US","US-MS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ms-042",
    lat: 30.371448,
    lng: -88.633244,
    panoId: "BJwaW944vOLgP6dgkQyNdg",
    place: "Near Gautier, Mississippi",
    shortName: "Gautier",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MS",
    state: "Mississippi",
    difficulty: "classic",
    pools: ["world","North America","US","US-MS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ms-043",
    lat: 30.414764,
    lng: -88.560651,
    panoId: "AoXg-csRui3u-JTNRfTgHA",
    place: "Near Moss Point, Mississippi",
    shortName: "Moss Point",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MS",
    state: "Mississippi",
    difficulty: "classic",
    pools: ["world","North America","US","US-MS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ms-044",
    lat: 32.482867,
    lng: -90.107244,
    panoId: "3DaYBZLvuTmZXA1jU0Vlcg",
    place: "Near Madison, Mississippi",
    shortName: "Madison",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MS",
    state: "Mississippi",
    difficulty: "classic",
    pools: ["world","North America","US","US-MS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ms-045",
    lat: 30.405804,
    lng: -88.869166,
    panoId: "TxzH3ub51Oc0VwOWNueGEw",
    place: "Near Biloxi, Mississippi",
    shortName: "Biloxi",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MS",
    state: "Mississippi",
    difficulty: "classic",
    pools: ["world","North America","US","US-MS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ms-046",
    lat: 31.308586,
    lng: -89.289448,
    panoId: "KP5Li7gIjhNd9likiJH9ag",
    place: "Near Hattiesburg, Mississippi",
    shortName: "Hattiesburg",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MS",
    state: "Mississippi",
    difficulty: "classic",
    pools: ["world","North America","US","US-MS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ms-047",
    lat: 33.755452,
    lng: -90.74518,
    panoId: "OSrXaiK9N50yWW4Olfcbpw",
    place: "Near Cleveland, Mississippi",
    shortName: "Cleveland",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MS",
    state: "Mississippi",
    difficulty: "classic",
    pools: ["world","North America","US","US-MS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ms-048",
    lat: 31.710985,
    lng: -89.124552,
    panoId: "qPOBtL2Cp6Ep1dxJyiAXcw",
    place: "Near Laurel, Mississippi",
    shortName: "Laurel",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MS",
    state: "Mississippi",
    difficulty: "classic",
    pools: ["world","North America","US","US-MS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ms-049",
    lat: 32.289151,
    lng: -90.116052,
    panoId: "WTDpeYtN1f195vPEgm8QnA",
    place: "Near Pearl, Mississippi",
    shortName: "Pearl",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MS",
    state: "Mississippi",
    difficulty: "classic",
    pools: ["world","North America","US","US-MS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ms-050",
    lat: 32.272918,
    lng: -90.167817,
    panoId: "3f6FHgaCEto0WFDTxw0Dtg",
    place: "Near Jackson, Mississippi",
    shortName: "Jackson",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MS",
    state: "Mississippi",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ms-051",
    lat: 34.941369,
    lng: -88.564912,
    panoId: "K3wkR6EXEADASUq-pCJxYA",
    place: "Near Corinth, Mississippi",
    shortName: "Corinth",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MS",
    state: "Mississippi",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ms-052",
    lat: 34.824609,
    lng: -89.947183,
    panoId: "Jjmv4pvp9v8QYHc7jVi7lg",
    place: "Near Hernando, Mississippi",
    shortName: "Hernando",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MS",
    state: "Mississippi",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ms-053",
    lat: 31.608182,
    lng: -90.424055,
    panoId: "mVGzLyPPhbqdvXN6b4CxAA",
    place: "Near Brookhaven, Mississippi",
    shortName: "Brookhaven",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MS",
    state: "Mississippi",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ms-054",
    lat: 31.284154,
    lng: -90.505897,
    panoId: "YYD2wkPOaZoO9h-6VODZeQ",
    place: "Near Summit, Mississippi",
    shortName: "Summit",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MS",
    state: "Mississippi",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ms-055",
    lat: 32.390416,
    lng: -88.676279,
    panoId: "QuP61U40tY60aaoFDHXtRQ",
    place: "Near Meridian, Mississippi",
    shortName: "Meridian",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MS",
    state: "Mississippi",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ms-056",
    lat: 34.267395,
    lng: -90.568063,
    panoId: "mcs8GFfjrV2Sn8t_4ixlHg",
    place: "Near Clarksdale, Mississippi",
    shortName: "Clarksdale",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MS",
    state: "Mississippi",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ms-057",
    lat: 32.317445,
    lng: -90.02691,
    panoId: "voGmKqEhmiwiwZ-Nz976Lg",
    place: "Near Brandon, Mississippi",
    shortName: "Brandon",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MS",
    state: "Mississippi",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ms-058",
    lat: 30.42903,
    lng: -88.791233,
    panoId: "M24pd1tnL0cPo1_wIsRp8Q",
    place: "Near Ocean Springs, Mississippi",
    shortName: "Ocean Springs",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MS",
    state: "Mississippi",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ms-059",
    lat: 32.145564,
    lng: -90.174244,
    panoId: "tcIJLhGUln0hgg_aGAlOtA",
    place: "Near Cleary, Mississippi",
    shortName: "Cleary",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MS",
    state: "Mississippi",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ms-060",
    lat: 33.48025,
    lng: -88.485675,
    panoId: "X_fctG_VVzBIsD9-Zs__Jw",
    place: "Near Columbus, Mississippi",
    shortName: "Columbus",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MS",
    state: "Mississippi",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ms-061",
    lat: 33.443479,
    lng: -91.00303,
    panoId: "lu1tqvdbfs7kC3mw9fe2zw",
    place: "Near Metcalfe, Mississippi",
    shortName: "Metcalfe",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MS",
    state: "Mississippi",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ms-062",
    lat: 30.405258,
    lng: -89.15541,
    panoId: "1iyW2sZORAXp-ikhlEc1Iw",
    place: "Near West Gulfport, Mississippi",
    shortName: "West Gulfport",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MS",
    state: "Mississippi",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ms-063",
    lat: 33.651445,
    lng: -88.69808,
    panoId: "ULf5-I3HIIgJPBuMkDws8Q",
    place: "Near West Point, Mississippi",
    shortName: "West Point",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MS",
    state: "Mississippi",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ms-064",
    lat: 32.453099,
    lng: -90.192464,
    panoId: "E8KQ7Kfu0fg7oOb6S4LRFA",
    place: "Near Ridgeland, Mississippi",
    shortName: "Ridgeland",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MS",
    state: "Mississippi",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ms-065",
    lat: 33.789122,
    lng: -89.782741,
    panoId: "EHUDqENc0wPXfMUlylIMag",
    place: "Near Grenada, Mississippi",
    shortName: "Grenada",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MS",
    state: "Mississippi",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ms-066",
    lat: 32.895348,
    lng: -90.40747,
    panoId: "Kg8iY4f0TroI-zySeTom3g",
    place: "Near Yazoo City, Mississippi",
    shortName: "Yazoo City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MS",
    state: "Mississippi",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ms-067",
    lat: 31.704474,
    lng: -89.076931,
    panoId: "rfqzSKGtlFRxl2F3Cyfliw",
    place: "Near Laurel, Mississippi",
    shortName: "Laurel",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MS",
    state: "Mississippi",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ms-068",
    lat: 30.596798,
    lng: -89.614805,
    panoId: "Km50b5VB8GDA1IrRvh7ELA",
    place: "Near Carriere, Mississippi",
    shortName: "Carriere",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MS",
    state: "Mississippi",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ms-069",
    lat: 30.407316,
    lng: -89.060545,
    panoId: "bG_hl1DvbxP8Oc0_wt1lfA",
    place: "Near West Gulfport, Mississippi",
    shortName: "West Gulfport",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MS",
    state: "Mississippi",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ms-070",
    lat: 33.416884,
    lng: -90.708484,
    panoId: "Jokg4hN0MYkSJmAewyAuUw",
    place: "Near Indianola, Mississippi",
    shortName: "Indianola",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MS",
    state: "Mississippi",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ms-071",
    lat: 34.888231,
    lng: -90.005669,
    panoId: "dY3V8vYignWjNPfxDcgbuQ",
    place: "Near Hernando, Mississippi",
    shortName: "Hernando",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MS",
    state: "Mississippi",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ms-072",
    lat: 34.870872,
    lng: -88.492951,
    panoId: "Cv6LJkH_BunybQ7ykuAsOA",
    place: "Near Corinth, Mississippi",
    shortName: "Corinth",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MS",
    state: "Mississippi",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ms-073",
    lat: 32.319166,
    lng: -90.868129,
    panoId: "ZETBRS8wCrqg83NtYRq6Dw",
    place: "Near Vicksburg, Mississippi",
    shortName: "Vicksburg",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MS",
    state: "Mississippi",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ms-074",
    lat: 32.571734,
    lng: -90.073647,
    panoId: "r7Atj5eITxIfjzO1_18zKQ",
    place: "Near Canton, Mississippi",
    shortName: "Canton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MS",
    state: "Mississippi",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ms-075",
    lat: 32.49063,
    lng: -90.127549,
    panoId: "JGEPbHOtkRhu20XjhCJ8Zw",
    place: "Near Madison, Mississippi",
    shortName: "Madison",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MS",
    state: "Mississippi",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ms-076",
    lat: 33.716681,
    lng: -90.745927,
    panoId: "TMHHdJp4nfrSGx1LnBkjKg",
    place: "Near Cleveland, Mississippi",
    shortName: "Cleveland",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MS",
    state: "Mississippi",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ms-077",
    lat: 32.28346,
    lng: -90.270589,
    panoId: "YCtK9mZ1PUXcecNNOvvmHg",
    place: "Near Clinton, Mississippi",
    shortName: "Clinton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MS",
    state: "Mississippi",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ms-078",
    lat: 30.586722,
    lng: -89.710125,
    panoId: "M-0ovLrprPRBHRdCoGIS8A",
    place: "Near Carriere, Mississippi",
    shortName: "Carriere",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MS",
    state: "Mississippi",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ms-079",
    lat: 30.479039,
    lng: -88.850616,
    panoId: "-MlQhCUJublI7TTMorcEUQ",
    place: "Near Saint Martin, Mississippi",
    shortName: "Saint Martin",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MS",
    state: "Mississippi",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ms-080",
    lat: 31.531793,
    lng: -90.453515,
    panoId: "J-nuIvrlVTEXp2YQC11vqw",
    place: "Near Brookhaven, Mississippi",
    shortName: "Brookhaven",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MS",
    state: "Mississippi",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ms-081",
    lat: 34.294072,
    lng: -88.630371,
    panoId: "GFSzUpKcM8vhF9ELThLahw",
    place: "Near Tupelo, Mississippi",
    shortName: "Tupelo",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MS",
    state: "Mississippi",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ms-082",
    lat: 32.31609,
    lng: -89.995834,
    panoId: "i-DOSxgAhV65ZgcmhKvE1Q",
    place: "Near Brandon, Mississippi",
    shortName: "Brandon",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MS",
    state: "Mississippi",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ms-083",
    lat: 30.460133,
    lng: -88.541666,
    panoId: "0smXcP8ikLzY6tieYJ9phQ",
    place: "Near Escatawpa, Mississippi",
    shortName: "Escatawpa",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MS",
    state: "Mississippi",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ms-084",
    lat: 31.540593,
    lng: -91.366095,
    panoId: "u-n-t-qTHzcCow1sRcsRqg",
    place: "Near Morgantown, Mississippi",
    shortName: "Morgantown",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MS",
    state: "Mississippi",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ms-085",
    lat: 32.381851,
    lng: -88.67118,
    panoId: "kYbxQ3tgDyPBwthhZKaOSw",
    place: "Near Meridian, Mississippi",
    shortName: "Meridian",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MS",
    state: "Mississippi",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ms-086",
    lat: 34.66549,
    lng: -88.520608,
    panoId: "ffBaF-5ltMXBGVFjgpcrlQ",
    place: "Near Booneville, Mississippi",
    shortName: "Booneville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MS",
    state: "Mississippi",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ms-087",
    lat: 32.325607,
    lng: -90.241022,
    panoId: "a9SPZ-JZnuelQAH1NiPNnw",
    place: "Near Jackson, Mississippi",
    shortName: "Jackson",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MS",
    state: "Mississippi",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ms-088",
    lat: 32.861133,
    lng: -90.443647,
    panoId: "iHD3TcE41GDlzf44R63PFQ",
    place: "Near Yazoo City, Mississippi",
    shortName: "Yazoo City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MS",
    state: "Mississippi",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ms-089",
    lat: 30.384249,
    lng: -88.665256,
    panoId: "oUdu2loi2kwSuR9QY8Z3dQ",
    place: "Near Gautier, Mississippi",
    shortName: "Gautier",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MS",
    state: "Mississippi",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ms-090",
    lat: 33.458046,
    lng: -90.929557,
    panoId: "XAm9jLdhOcKT8xJHfE3q8A",
    place: "Near Leland, Mississippi",
    shortName: "Leland",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MS",
    state: "Mississippi",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ms-091",
    lat: 34.296098,
    lng: -90.422726,
    panoId: "rwpJ2-yOPwuhgmBcOrCaZQ",
    place: "Near Jonestown, Mississippi",
    shortName: "Jonestown",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MS",
    state: "Mississippi",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ms-092",
    lat: 34.20274,
    lng: -88.913657,
    panoId: "EGEaWfRv-hW0W6ypBOZt4w",
    place: "Near Pontotoc, Mississippi",
    shortName: "Pontotoc",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MS",
    state: "Mississippi",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ms-093",
    lat: 30.395165,
    lng: -89.515193,
    panoId: "1miev3Vigk25wA7jy5wV9w",
    place: "Near Kiln, Mississippi",
    shortName: "Kiln",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MS",
    state: "Mississippi",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ms-094",
    lat: 32.356049,
    lng: -90.236154,
    panoId: "conAtk2c7TTWHtw08wxF1w",
    place: "Near Jackson, Mississippi",
    shortName: "Jackson",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MS",
    state: "Mississippi",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ms-095",
    lat: 34.276068,
    lng: -89.618313,
    panoId: "fuDf0MIWPvq7BCTjhmhuZw",
    place: "Near University, Mississippi",
    shortName: "University",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MS",
    state: "Mississippi",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ms-096",
    lat: 32.297329,
    lng: -90.828742,
    panoId: "gHbHSunVhVJOfkhxxkRuHg",
    place: "Near Beechwood, Mississippi",
    shortName: "Beechwood",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MS",
    state: "Mississippi",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ms-097",
    lat: 32.608858,
    lng: -90.152922,
    panoId: "UGdpSSoSL2RaPPxIZWhqgg",
    place: "Near Canton, Mississippi",
    shortName: "Canton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MS",
    state: "Mississippi",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ms-098",
    lat: 34.605274,
    lng: -90.126943,
    panoId: "Kr6LpWK2IvCGvEBsU-fJ-A",
    place: "Near Senatobia, Mississippi",
    shortName: "Senatobia",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MS",
    state: "Mississippi",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ms-099",
    lat: 34.103023,
    lng: -88.582341,
    panoId: "LWdW5S5pdlRmoLgofJxCpQ",
    place: "Near Nettleton, Mississippi",
    shortName: "Nettleton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MS",
    state: "Mississippi",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ms-100",
    lat: 34.534177,
    lng: -88.81721,
    panoId: "rmu2qMzcpfTjWr3K0BvR6A",
    place: "Near Baldwyn, Mississippi",
    shortName: "Baldwyn",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MS",
    state: "Mississippi",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-MS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ms-101",
    lat: 31.106905,
    lng: -90.579156,
    panoId: "1ITzojtWA2jrE7oyw8ENgw",
    place: "Near Magnolia, Mississippi",
    shortName: "Magnolia",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MS",
    state: "Mississippi",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-MS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ms-102",
    lat: 31.26265,
    lng: -90.163344,
    panoId: "QzmY3Iqb19wvrarcCXiZOg",
    place: "Near Tylertown, Mississippi",
    shortName: "Tylertown",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MS",
    state: "Mississippi",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-MS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ms-103",
    lat: 31.31831,
    lng: -89.694693,
    panoId: "NDkBmkisY2G3gtNJhiHi8Q",
    place: "Near Columbia, Mississippi",
    shortName: "Columbia",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MS",
    state: "Mississippi",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-MS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ms-104",
    lat: 34.579366,
    lng: -89.774902,
    panoId: "QnD6slKG5VQz20Au7Szgog",
    place: "Near Como, Mississippi",
    shortName: "Como",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MS",
    state: "Mississippi",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-MS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ms-105",
    lat: 34.595609,
    lng: -88.721801,
    panoId: "rXh3k2dGOM5mA6sXeltvnQ",
    place: "Near Baldwyn, Mississippi",
    shortName: "Baldwyn",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MS",
    state: "Mississippi",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-MS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ms-106",
    lat: 32.976515,
    lng: -89.067783,
    panoId: "aiJNr63AcSiXTjEaaHe3VQ",
    place: "Near Louisville, Mississippi",
    shortName: "Louisville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MS",
    state: "Mississippi",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-MS"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mo-000",
    lat: 38.800306,
    lng: -90.626524,
    panoId: "nfitzjfLMYuR-ZyIlkfmVA",
    place: "Near Saint Peters, Missouri",
    shortName: "Saint Peters",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MO",
    state: "Missouri",
    difficulty: "classic",
    pools: ["world","North America","US","US-MO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mo-001",
    lat: 38.576795,
    lng: -92.173468,
    panoId: "nRr5QgLlppKXcTXPjylKDQ",
    place: "Near Jefferson City, Missouri",
    shortName: "Jefferson City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MO",
    state: "Missouri",
    difficulty: "classic",
    pools: ["world","North America","US","US-MO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mo-002",
    lat: 37.084237,
    lng: -94.51349,
    panoId: "jfpRwNi2uBw-NgrtFbEdkg",
    place: "Near Joplin, Missouri",
    shortName: "Joplin",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MO",
    state: "Missouri",
    difficulty: "classic",
    pools: ["world","North America","US","US-MO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mo-003",
    lat: 38.712864,
    lng: -90.429615,
    panoId: "WmTGzEt2Mo7un8Rsd-3O5g",
    place: "Near Maryland Heights, Missouri",
    shortName: "Maryland Heights",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MO",
    state: "Missouri",
    difficulty: "classic",
    pools: ["world","North America","US","US-MO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mo-004",
    lat: 39.00864,
    lng: -94.463606,
    panoId: "CS_pE6IC49MwMYRpNPgF2A",
    place: "Near Raytown, Missouri",
    shortName: "Raytown",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MO",
    state: "Missouri",
    difficulty: "classic",
    pools: ["world","North America","US","US-MO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mo-005",
    lat: 38.910872,
    lng: -94.382202,
    panoId: "g6K0Boe2Qd274U1ktV8YSg",
    place: "Near Lee's Summit, Missouri",
    shortName: "Lee's Summit",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MO",
    state: "Missouri",
    difficulty: "classic",
    pools: ["world","North America","US","US-MO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mo-006",
    lat: 39.768853,
    lng: -94.846628,
    panoId: "LSZGhOjTw5L8j3V3jm94Hg",
    place: "Near Saint Joseph, Missouri",
    shortName: "Saint Joseph",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MO",
    state: "Missouri",
    difficulty: "classic",
    pools: ["world","North America","US","US-MO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mo-007",
    lat: 38.783992,
    lng: -90.481248,
    panoId: "xPNmhWKA5aS6FR1AuUlobg",
    place: "Near Saint Charles, Missouri",
    shortName: "Saint Charles",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MO",
    state: "Missouri",
    difficulty: "classic",
    pools: ["world","North America","US","US-MO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mo-008",
    lat: 39.246096,
    lng: -94.419141,
    panoId: "74w9dCzC8nmc3ewT477dLA",
    place: "Near Liberty, Missouri",
    shortName: "Liberty",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MO",
    state: "Missouri",
    difficulty: "classic",
    pools: ["world","North America","US","US-MO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mo-009",
    lat: 39.091023,
    lng: -94.415515,
    panoId: "Nzokt5QqQamXg-7xvBd2wQ",
    place: "Near Independence, Missouri",
    shortName: "Independence",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MO",
    state: "Missouri",
    difficulty: "classic",
    pools: ["world","North America","US","US-MO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mo-010",
    lat: 38.810619,
    lng: -90.699804,
    panoId: "-ENx03LvggwiYqArYPARZQ",
    place: "Near O'Fallon, Missouri",
    shortName: "O'Fallon",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MO",
    state: "Missouri",
    difficulty: "classic",
    pools: ["world","North America","US","US-MO"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-mo-011",
    lat: 38.951714,
    lng: -92.334129,
    panoId: "zLsAjWI9sn1pDX9XQKMbRw",
    place: "Near Columbia, Missouri",
    shortName: "Columbia",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MO",
    state: "Missouri",
    difficulty: "classic",
    pools: ["world","North America","US","US-MO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mo-012",
    lat: 38.744335,
    lng: -90.305418,
    panoId: "tSF7HKsTIorrwFa8eaEACQ",
    place: "Near Ferguson, Missouri",
    shortName: "Ferguson",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MO",
    state: "Missouri",
    difficulty: "classic",
    pools: ["world","North America","US","US-MO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mo-013",
    lat: 38.508466,
    lng: -90.323047,
    panoId: "oAypbhmj9YCmTF_uoGsxNA",
    place: "Near Mehlville, Missouri",
    shortName: "Mehlville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MO",
    state: "Missouri",
    difficulty: "classic",
    pools: ["world","North America","US","US-MO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mo-014",
    lat: 37.30591,
    lng: -89.518163,
    panoId: "nFc0utzfe5X42MbSkAF4nA",
    place: "Near Cape Girardeau, Missouri",
    shortName: "Cape Girardeau",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MO",
    state: "Missouri",
    difficulty: "classic",
    pools: ["world","North America","US","US-MO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mo-015",
    lat: 39.099695,
    lng: -94.578572,
    panoId: "ibnWjReHkJFOXcI6NFJH5A",
    place: "Near Kansas City, Missouri",
    shortName: "Kansas City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MO",
    state: "Missouri",
    difficulty: "classic",
    pools: ["world","North America","US","US-MO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mo-016",
    lat: 38.704458,
    lng: -93.22839,
    panoId: "bKBLxkYlJCYVlopU8LXeEQ",
    place: "Near Sedalia, Missouri",
    shortName: "Sedalia",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MO",
    state: "Missouri",
    difficulty: "classic",
    pools: ["world","North America","US","US-MO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mo-017",
    lat: 38.595218,
    lng: -90.545968,
    panoId: "9Ipp5XGVe3PRo67k4lpxjQ",
    place: "Near Ballwin, Missouri",
    shortName: "Ballwin",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MO",
    state: "Missouri",
    difficulty: "classic",
    pools: ["world","North America","US","US-MO"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-mo-018",
    lat: 39.203923,
    lng: -94.555022,
    panoId: "B283BGlOfqk-7X5Udl4pPQ",
    place: "Near Gladstone, Missouri",
    shortName: "Gladstone",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MO",
    state: "Missouri",
    difficulty: "classic",
    pools: ["world","North America","US","US-MO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mo-019",
    lat: 38.663402,
    lng: -90.576932,
    panoId: "nv2fCu_zBkaX-WN5bJFYsw",
    place: "Near Chesterfield, Missouri",
    shortName: "Chesterfield",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MO",
    state: "Missouri",
    difficulty: "classic",
    pools: ["world","North America","US","US-MO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mo-020",
    lat: 37.215481,
    lng: -93.298212,
    panoId: "kngCol_vo-D5xh0eBrkK8Q",
    place: "Near Springfield, Missouri",
    shortName: "Springfield",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MO",
    state: "Missouri",
    difficulty: "classic",
    pools: ["world","North America","US","US-MO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mo-021",
    lat: 38.592793,
    lng: -90.357301,
    panoId: "Dn_i2u3o6nfieFCWYBV2_w",
    place: "Near Webster Groves, Missouri",
    shortName: "Webster Groves",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MO",
    state: "Missouri",
    difficulty: "classic",
    pools: ["world","North America","US","US-MO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mo-022",
    lat: 38.801992,
    lng: -94.4527,
    panoId: "ggXFSF9nt0MCbyB722095Q",
    place: "Near Raymore, Missouri",
    shortName: "Raymore",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MO",
    state: "Missouri",
    difficulty: "classic",
    pools: ["world","North America","US","US-MO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mo-023",
    lat: 37.951488,
    lng: -91.771296,
    panoId: "8EsHZo_XzrmANDEGE_UNDQ",
    place: "Near Rolla, Missouri",
    shortName: "Rolla",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MO",
    state: "Missouri",
    difficulty: "classic",
    pools: ["world","North America","US","US-MO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mo-024",
    lat: 38.77157,
    lng: -90.370847,
    panoId: "BhkdCtaC4Jvb_DZsXWbBHQ",
    place: "Near Hazelwood, Missouri",
    shortName: "Hazelwood",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MO",
    state: "Missouri",
    difficulty: "classic",
    pools: ["world","North America","US","US-MO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mo-025",
    lat: 38.470219,
    lng: -90.304493,
    panoId: "FLsHgZWt0n4JpzoKaB1zxg",
    place: "Near Oakville, Missouri",
    shortName: "Oakville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MO",
    state: "Missouri",
    difficulty: "classic",
    pools: ["world","North America","US","US-MO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mo-026",
    lat: 38.550763,
    lng: -90.333227,
    panoId: "VujDVPGT5CFcm1NNqpsOiw",
    place: "Near Affton, Missouri",
    shortName: "Affton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MO",
    state: "Missouri",
    difficulty: "classic",
    pools: ["world","North America","US","US-MO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mo-027",
    lat: 38.811457,
    lng: -90.852891,
    panoId: "6XMjL1dJXVVUdqUs00fjUg",
    place: "Near Wentzville, Missouri",
    shortName: "Wentzville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MO",
    state: "Missouri",
    difficulty: "classic",
    pools: ["world","North America","US","US-MO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mo-028",
    lat: 38.65584,
    lng: -90.309186,
    panoId: "cO-Y-R_sIAFpS_jhueK7xA",
    place: "Near University City, Missouri",
    shortName: "University City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MO",
    state: "Missouri",
    difficulty: "classic",
    pools: ["world","North America","US","US-MO"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-mo-029",
    lat: 38.627343,
    lng: -90.197834,
    panoId: "XG5l7QYf5dbJ8g6aQRJ5yg",
    place: "Near St. Louis, Missouri",
    shortName: "St. Louis",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MO",
    state: "Missouri",
    difficulty: "classic",
    pools: ["world","North America","US","US-MO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mo-030",
    lat: 38.789232,
    lng: -90.322606,
    panoId: "zJaKcGJj_fvg6zAEI6d-_w",
    place: "Near Florissant, Missouri",
    shortName: "Florissant",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MO",
    state: "Missouri",
    difficulty: "classic",
    pools: ["world","North America","US","US-MO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mo-031",
    lat: 38.76281,
    lng: -93.735829,
    panoId: "rFXcp6DWDC7xmTMlrzNfHA",
    place: "Near Warrensburg, Missouri",
    shortName: "Warrensburg",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MO",
    state: "Missouri",
    difficulty: "classic",
    pools: ["world","North America","US","US-MO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mo-032",
    lat: 38.432868,
    lng: -90.377647,
    panoId: "NEaeN0HrVX-rukq6lqKtiQ",
    place: "Near Arnold, Missouri",
    shortName: "Arnold",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MO",
    state: "Missouri",
    difficulty: "classic",
    pools: ["world","North America","US","US-MO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mo-033",
    lat: 38.885798,
    lng: -94.532867,
    panoId: "ikEvC37TY23FgGLWffqRfQ",
    place: "Near Grandview, Missouri",
    shortName: "Grandview",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MO",
    state: "Missouri",
    difficulty: "classic",
    pools: ["world","North America","US","US-MO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mo-034",
    lat: 39.016996,
    lng: -94.281558,
    panoId: "n7e0RSB4dOYOwxct9PWxUg",
    place: "Near Blue Springs, Missouri",
    shortName: "Blue Springs",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MO",
    state: "Missouri",
    difficulty: "classic",
    pools: ["world","North America","US","US-MO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mo-035",
    lat: 38.583291,
    lng: -90.406811,
    panoId: "kCDglwPyd796aD4uF6QD-Q",
    place: "Near Kirkwood, Missouri",
    shortName: "Kirkwood",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MO",
    state: "Missouri",
    difficulty: "classic",
    pools: ["world","North America","US","US-MO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mo-036",
    lat: 37.043544,
    lng: -93.294355,
    panoId: "nVZlhNbKA7GB1Vm1TjOxjA",
    place: "Near Nixa, Missouri",
    shortName: "Nixa",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MO",
    state: "Missouri",
    difficulty: "classic",
    pools: ["world","North America","US","US-MO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mo-037",
    lat: 39.187711,
    lng: -94.551316,
    panoId: "M4qH5dFHsPx6jEk2fqcXDg",
    place: "Near Gladstone, Missouri",
    shortName: "Gladstone",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MO",
    state: "Missouri",
    difficulty: "classic",
    pools: ["world","North America","US","US-MO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mo-038",
    lat: 39.07974,
    lng: -94.574953,
    panoId: "s2dpEW3Xl7iF7O20500IBg",
    place: "Near Kansas City, Missouri",
    shortName: "Kansas City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MO",
    state: "Missouri",
    difficulty: "classic",
    pools: ["world","North America","US","US-MO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mo-039",
    lat: 39.081264,
    lng: -94.426704,
    panoId: "DsRHk_JLRhhN_UxCuurbTg",
    place: "Near Independence, Missouri",
    shortName: "Independence",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MO",
    state: "Missouri",
    difficulty: "classic",
    pools: ["world","North America","US","US-MO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mo-040",
    lat: 38.877695,
    lng: -94.556861,
    panoId: "ubw5zrIeMK-dgkAJyh1w-A",
    place: "Near Grandview, Missouri",
    shortName: "Grandview",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MO",
    state: "Missouri",
    difficulty: "classic",
    pools: ["world","North America","US","US-MO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mo-041",
    lat: 38.560056,
    lng: -92.161062,
    panoId: "1UKNAiUn7MIQXIMXNHnSMQ",
    place: "Near Jefferson City, Missouri",
    shortName: "Jefferson City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MO",
    state: "Missouri",
    difficulty: "classic",
    pools: ["world","North America","US","US-MO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mo-042",
    lat: 38.825442,
    lng: -90.835125,
    panoId: "4VQ_0bUxJNcGV3ZR9KnU2w",
    place: "Near Wentzville, Missouri",
    shortName: "Wentzville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MO",
    state: "Missouri",
    difficulty: "classic",
    pools: ["world","North America","US","US-MO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mo-043",
    lat: 38.638491,
    lng: -90.353526,
    panoId: "2NRmjfFWRfntMkKKQavy1w",
    place: "Near Brentwood, Missouri",
    shortName: "Brentwood",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MO",
    state: "Missouri",
    difficulty: "classic",
    pools: ["world","North America","US","US-MO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mo-044",
    lat: 39.229203,
    lng: -94.421429,
    panoId: "nhCTswy9d_rvp8QKGNFQ9g",
    place: "Near Liberty, Missouri",
    shortName: "Liberty",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MO",
    state: "Missouri",
    difficulty: "classic",
    pools: ["world","North America","US","US-MO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mo-045",
    lat: 37.971528,
    lng: -91.761653,
    panoId: "a4Nl6aloKs2oPnYAgJPvjA",
    place: "Near Rolla, Missouri",
    shortName: "Rolla",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MO",
    state: "Missouri",
    difficulty: "classic",
    pools: ["world","North America","US","US-MO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mo-046",
    lat: 38.694566,
    lng: -93.245755,
    panoId: "R30uePgimIYjDD3yWWscFg",
    place: "Near Sedalia, Missouri",
    shortName: "Sedalia",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MO",
    state: "Missouri",
    difficulty: "classic",
    pools: ["world","North America","US","US-MO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mo-047",
    lat: 38.924899,
    lng: -94.37637,
    panoId: "W1nassVnj3dykR3ucmR6gQ",
    place: "Near Lee's Summit, Missouri",
    shortName: "Lee's Summit",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MO",
    state: "Missouri",
    difficulty: "classic",
    pools: ["world","North America","US","US-MO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mo-048",
    lat: 38.988286,
    lng: -94.465286,
    panoId: "-Tc-MwqDN_VUq2CclNShtA",
    place: "Near Raytown, Missouri",
    shortName: "Raytown",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MO",
    state: "Missouri",
    difficulty: "classic",
    pools: ["world","North America","US","US-MO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mo-049",
    lat: 39.758001,
    lng: -94.852828,
    panoId: "JtY32-RNNQhhMA9YG6rdow",
    place: "Near Saint Joseph, Missouri",
    shortName: "Saint Joseph",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MO",
    state: "Missouri",
    difficulty: "classic",
    pools: ["world","North America","US","US-MO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mo-050",
    lat: 38.549924,
    lng: -90.707724,
    panoId: "Mzro27pwY24dHTzH_Jkk7w",
    place: "Near Wildwood, Missouri",
    shortName: "Wildwood",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MO",
    state: "Missouri",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mo-051",
    lat: 38.581126,
    lng: -90.625936,
    panoId: "xvQeM7PEKFFlTp6fEjEf5A",
    place: "Near Wildwood, Missouri",
    shortName: "Wildwood",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MO",
    state: "Missouri",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mo-052",
    lat: 38.655567,
    lng: -90.226292,
    panoId: "QzYqyd8TJaiX6ODnLaz80Q",
    place: "Near St. Louis, Missouri",
    shortName: "St. Louis",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MO",
    state: "Missouri",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mo-053",
    lat: 38.597611,
    lng: -90.280619,
    panoId: "pSQEmrv94VxjQec0XUl11A",
    place: "Near Maplewood, Missouri",
    shortName: "Maplewood",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MO",
    state: "Missouri",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mo-054",
    lat: 38.886396,
    lng: -90.286896,
    panoId: "Ow6CLvRvXRIq-USCtpyTpA",
    place: "Near Old Jamestown, Missouri",
    shortName: "Old Jamestown",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MO",
    state: "Missouri",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mo-055",
    lat: 38.911959,
    lng: -92.291985,
    panoId: "6aNNOGTEdRoO_Vw3QARGbA",
    place: "Near Columbia, Missouri",
    shortName: "Columbia",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MO",
    state: "Missouri",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mo-056",
    lat: 38.811897,
    lng: -94.400988,
    panoId: "yejjhYVNZjpr5qa09Lh-cg",
    place: "Near Lake Winnebago, Missouri",
    shortName: "Lake Winnebago",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MO",
    state: "Missouri",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mo-057",
    lat: 38.810113,
    lng: -93.771011,
    panoId: "I1meJIdtvDJ20VGgko_KOQ",
    place: "Near Warrensburg, Missouri",
    shortName: "Warrensburg",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MO",
    state: "Missouri",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mo-058",
    lat: 38.470754,
    lng: -90.238703,
    panoId: "ne0UzrWnkYrIWzNoqImd2g",
    place: "Near Columbia, Missouri",
    shortName: "Columbia",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MO",
    state: "Missouri",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mo-059",
    lat: 38.759328,
    lng: -90.696506,
    panoId: "1Ibdm8-hhWMlWH0VWBUEow",
    place: "Near Dardenne Prairie, Missouri",
    shortName: "Dardenne Prairie",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MO",
    state: "Missouri",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mo-060",
    lat: 37.058656,
    lng: -93.347059,
    panoId: "EF2xZD-v6G_rvbTNR7m1Gw",
    place: "Near Nixa, Missouri",
    shortName: "Nixa",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MO",
    state: "Missouri",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mo-061",
    lat: 36.990967,
    lng: -93.189849,
    panoId: "SAGuzaRbsFwD97nDmqQfnw",
    place: "Near Ozark, Missouri",
    shortName: "Ozark",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MO",
    state: "Missouri",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mo-062",
    lat: 37.263896,
    lng: -89.554231,
    panoId: "kEgWJXQTZVWJ5KrmOjiRvQ",
    place: "Near Cape Girardeau, Missouri",
    shortName: "Cape Girardeau",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MO",
    state: "Missouri",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mo-063",
    lat: 39.044676,
    lng: -94.589926,
    panoId: "nwyGRYyR4v1bs9Z7Za_mIA",
    place: "Near Westwood, Missouri",
    shortName: "Westwood",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MO",
    state: "Missouri",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mo-064",
    lat: 39.199837,
    lng: -94.473595,
    panoId: "iqATFu1yq-LRWvWZwt0tyA",
    place: "Near Claycomo, Missouri",
    shortName: "Claycomo",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MO",
    state: "Missouri",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mo-065",
    lat: 38.539626,
    lng: -92.223586,
    panoId: "RHb4oE_I5Ey7ZM19Msj2LQ",
    place: "Near Jefferson City, Missouri",
    shortName: "Jefferson City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MO",
    state: "Missouri",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mo-066",
    lat: 38.714246,
    lng: -93.273557,
    panoId: "w0J4Hz-uk9e2xF70OgQ_iw",
    place: "Near Sedalia, Missouri",
    shortName: "Sedalia",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MO",
    state: "Missouri",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mo-067",
    lat: 38.877801,
    lng: -94.369425,
    panoId: "cAxkBlix7h-C2DLLg7Q33Q",
    place: "Near Greenwood, Missouri",
    shortName: "Greenwood",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MO",
    state: "Missouri",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mo-068",
    lat: 37.155754,
    lng: -93.307724,
    panoId: "lAWAF3PyZ2X7kZYCfs_TRA",
    place: "Near Springfield, Missouri",
    shortName: "Springfield",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MO",
    state: "Missouri",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mo-069",
    lat: 39.186299,
    lng: -94.421513,
    panoId: "WmABCeNchdH667guDk3plA",
    place: "Near Pleasant Valley, Missouri",
    shortName: "Pleasant Valley",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MO",
    state: "Missouri",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mo-070",
    lat: 39.128435,
    lng: -94.401744,
    panoId: "mAIR2PyBxW9pLZUS4JUETA",
    place: "Near Sugar Creek, Missouri",
    shortName: "Sugar Creek",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MO",
    state: "Missouri",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mo-071",
    lat: 38.770878,
    lng: -94.532616,
    panoId: "2dQWKcEIAMwsmcur2rg__A",
    place: "Near Belton, Missouri",
    shortName: "Belton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MO",
    state: "Missouri",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mo-072",
    lat: 39.73375,
    lng: -94.852501,
    panoId: "tpnC5E0ndvTM70gpR1dynw",
    place: "Near Elwood, Missouri",
    shortName: "Elwood",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MO",
    state: "Missouri",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mo-073",
    lat: 36.998119,
    lng: -93.273998,
    panoId: "yMrhWu94HkMOD0HUvZSslQ",
    place: "Near Nixa, Missouri",
    shortName: "Nixa",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MO",
    state: "Missouri",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mo-074",
    lat: 37.920972,
    lng: -91.827188,
    panoId: "NkpmuHV_eUGjnRbHVvn4tg",
    place: "Near Rolla, Missouri",
    shortName: "Rolla",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MO",
    state: "Missouri",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MO"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-mo-075",
    lat: 39.020338,
    lng: -94.384022,
    panoId: "PcpqqgbNaUYLMBmDNJFt2Q",
    place: "Near Raytown, Missouri",
    shortName: "Raytown",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MO",
    state: "Missouri",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mo-076",
    lat: 38.776963,
    lng: -90.826373,
    panoId: "na-0WDUQat7-nnV2mSBQnA",
    place: "Near Lake Saint Louis, Missouri",
    shortName: "Lake Saint Louis",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MO",
    state: "Missouri",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mo-077",
    lat: 38.884156,
    lng: -90.754087,
    panoId: "AaCwW5djK5AZ_fh5tahLUg",
    place: "Near Saint Paul, Missouri",
    shortName: "Saint Paul",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MO",
    state: "Missouri",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mo-078",
    lat: 38.801729,
    lng: -93.674137,
    panoId: "1uxNYV_v8Yce3jjs8bZSNw",
    place: "Near Warrensburg, Missouri",
    shortName: "Warrensburg",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MO",
    state: "Missouri",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mo-079",
    lat: 38.868039,
    lng: -90.399837,
    panoId: "5jduv1vkJOUusrYbJqFx2g",
    place: "Near Old Jamestown, Missouri",
    shortName: "Old Jamestown",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MO",
    state: "Missouri",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mo-080",
    lat: 37.08236,
    lng: -93.250882,
    panoId: "PHPT4_nyVxGXjnxfGjjr8g",
    place: "Near Nixa, Missouri",
    shortName: "Nixa",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MO",
    state: "Missouri",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mo-081",
    lat: 38.425921,
    lng: -90.431131,
    panoId: "EA2KrSgCVQFuPfm-Pfk0hg",
    place: "Near Arnold, Missouri",
    shortName: "Arnold",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MO",
    state: "Missouri",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mo-082",
    lat: 38.649129,
    lng: -90.273375,
    panoId: "e_lw71jCuQwwkbzy5W7rNA",
    place: "Near University City, Missouri",
    shortName: "University City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MO",
    state: "Missouri",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mo-083",
    lat: 38.975018,
    lng: -94.234632,
    panoId: "3AdWZ9Yg5_R8cJvWcKWA2w",
    place: "Near Grain Valley, Missouri",
    shortName: "Grain Valley",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MO",
    state: "Missouri",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mo-084",
    lat: 38.663819,
    lng: -90.740677,
    panoId: "WY5zwmmQB5R02X-E_BVbnw",
    place: "Near Weldon Spring, Missouri",
    shortName: "Weldon Spring",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MO",
    state: "Missouri",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mo-085",
    lat: 39.719995,
    lng: -91.439006,
    panoId: "BFzcGounUHbG-2LXTTcSXQ",
    place: "Near Hannibal, Missouri",
    shortName: "Hannibal",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MO",
    state: "Missouri",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mo-086",
    lat: 40.197196,
    lng: -92.490854,
    panoId: "rbmzPOtqv4ei0-M0Hs1YiA",
    place: "Near Kirksville, Missouri",
    shortName: "Kirksville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MO",
    state: "Missouri",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mo-087",
    lat: 36.791582,
    lng: -90.354095,
    panoId: "UBTmgkzxIApxFU8xKPZbFQ",
    place: "Near Poplar Bluff, Missouri",
    shortName: "Poplar Bluff",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MO",
    state: "Missouri",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mo-088",
    lat: 37.745456,
    lng: -90.388502,
    panoId: "YMxvpXUsuBNGoekFY_kD9w",
    place: "Near Farmington, Missouri",
    shortName: "Farmington",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MO",
    state: "Missouri",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mo-089",
    lat: 39.014199,
    lng: -92.37414,
    panoId: "m4Crlj7yP2jzxJQiLwX2FQ",
    place: "Near Columbia, Missouri",
    shortName: "Columbia",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MO",
    state: "Missouri",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mo-090",
    lat: 38.525466,
    lng: -90.46469,
    panoId: "PWIpbH8NIaeBJ2VY12xbjg",
    place: "Near Fenton, Missouri",
    shortName: "Fenton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MO",
    state: "Missouri",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mo-091",
    lat: 37.618584,
    lng: -92.656128,
    panoId: "Sb9PYf8MFG7t9zcQPUgh5Q",
    place: "Near Lebanon, Missouri",
    shortName: "Lebanon",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MO",
    state: "Missouri",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mo-092",
    lat: 36.920725,
    lng: -89.555663,
    panoId: "qHg82XTCodN59-ZNxZbcYw",
    place: "Near Sikeston, Missouri",
    shortName: "Sikeston",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MO",
    state: "Missouri",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mo-093",
    lat: 37.216779,
    lng: -93.337138,
    panoId: "Jce6Zpbx9Y7KEhmWJSyOVw",
    place: "Near Springfield, Missouri",
    shortName: "Springfield",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MO",
    state: "Missouri",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mo-094",
    lat: 38.898358,
    lng: -90.785162,
    panoId: "UmvaYeUVUmfasmZC8dvgNA",
    place: "Near Saint Paul, Missouri",
    shortName: "Saint Paul",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MO",
    state: "Missouri",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mo-095",
    lat: 37.278331,
    lng: -94.351641,
    panoId: "LoTqzSHyGFb7rFcFlW_b7Q",
    place: "Near Carthage, Missouri",
    shortName: "Carthage",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MO",
    state: "Missouri",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mo-096",
    lat: 37.214574,
    lng: -89.563836,
    panoId: "COgK5nPK3WWUo88VQ1AtIw",
    place: "Near Scott City, Missouri",
    shortName: "Scott City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MO",
    state: "Missouri",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mo-097",
    lat: 38.368603,
    lng: -90.795213,
    panoId: "06JlznmVDGedley9DEx84g",
    place: "Near LaBarque Creek, Missouri",
    shortName: "LaBarque Creek",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MO",
    state: "Missouri",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mo-098",
    lat: 38.584514,
    lng: -90.831144,
    panoId: "uqLIT2Zcx0WBel1LFsYEww",
    place: "Near Gray Summit, Missouri",
    shortName: "Gray Summit",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MO",
    state: "Missouri",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mo-099",
    lat: 36.735634,
    lng: -90.280988,
    panoId: "p0KVUwE5S7xwdYGc5WxUCA",
    place: "Near Poplar Bluff, Missouri",
    shortName: "Poplar Bluff",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MO",
    state: "Missouri",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mo-100",
    lat: 37.105686,
    lng: -93.681508,
    panoId: "obCvVxCZE_OBVCpdUadNIQ",
    place: "Near Marionville, Missouri",
    shortName: "Marionville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MO",
    state: "Missouri",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-MO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mo-101",
    lat: 37.334654,
    lng: -94.466308,
    panoId: "Sa6L1R_b4Yv33OoJ62rbjg",
    place: "Near Oronogo, Missouri",
    shortName: "Oronogo",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MO",
    state: "Missouri",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-MO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mo-102",
    lat: 37.04005,
    lng: -94.27771,
    panoId: "FIGCoH9eWORalCuvhJTAyA",
    place: "Near Duenweg, Missouri",
    shortName: "Duenweg",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MO",
    state: "Missouri",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-MO"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-mo-103",
    lat: 37.612527,
    lng: -90.502128,
    panoId: "XwPfPAkwSUwjr4j_3KL0AA",
    place: "Near Ironton, Missouri",
    shortName: "Ironton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MO",
    state: "Missouri",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-MO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mo-104",
    lat: 38.811178,
    lng: -94.019157,
    panoId: "eza3QlA2ryN6KPzTp9-mHQ",
    place: "Near Holden, Missouri",
    shortName: "Holden",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MO",
    state: "Missouri",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-MO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mo-105",
    lat: 39.034282,
    lng: -92.569402,
    panoId: "BrrfAPc2CZppED9gsXymww",
    place: "Near New Franklin, Missouri",
    shortName: "New Franklin",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MO",
    state: "Missouri",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-MO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mo-106",
    lat: 36.84418,
    lng: -93.211735,
    panoId: "c89s63thbY90TRAOQNzY0Q",
    place: "Near Merriam Woods, Missouri",
    shortName: "Merriam Woods",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MO",
    state: "Missouri",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-MO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mt-000",
    lat: 48.195822,
    lng: -114.312924,
    panoId: "uALHDn8_R2KfGs0RKd4pFA",
    place: "Near Kalispell, Montana",
    shortName: "Kalispell",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MT",
    state: "Montana",
    difficulty: "classic",
    pools: ["world","North America","US","US-MT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mt-001",
    lat: 45.783261,
    lng: -108.500672,
    panoId: "_h77N2PjyU4uky-0MNnb1A",
    place: "Near Billings, Montana",
    shortName: "Billings",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MT",
    state: "Montana",
    difficulty: "classic",
    pools: ["world","North America","US","US-MT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mt-002",
    lat: 45.679675,
    lng: -111.038737,
    panoId: "SfwxxwC_fmKmyqidWRGufw",
    place: "Near Bozeman, Montana",
    shortName: "Bozeman",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MT",
    state: "Montana",
    difficulty: "classic",
    pools: ["world","North America","US","US-MT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mt-003",
    lat: 45.819076,
    lng: -108.413991,
    panoId: "27-phx2WkN_y81F0xFvr1Q",
    place: "Near Lockwood, Montana",
    shortName: "Lockwood",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MT",
    state: "Montana",
    difficulty: "classic",
    pools: ["world","North America","US","US-MT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mt-004",
    lat: 45.669161,
    lng: -108.77148,
    panoId: "th8f6C8uX5maaXX9KiNBXg",
    place: "Near Laurel, Montana",
    shortName: "Laurel",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MT",
    state: "Montana",
    difficulty: "classic",
    pools: ["world","North America","US","US-MT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mt-005",
    lat: 46.003918,
    lng: -112.534759,
    panoId: "Fqy2yMNg0ZQALOzqmM240w",
    place: "Near Butte, Montana",
    shortName: "Butte",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MT",
    state: "Montana",
    difficulty: "classic",
    pools: ["world","North America","US","US-MT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mt-006",
    lat: 46.872126,
    lng: -113.994087,
    panoId: "93fwYFuBsAvfHC-P95NVjA",
    place: "Near Missoula, Montana",
    shortName: "Missoula",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MT",
    state: "Montana",
    difficulty: "classic",
    pools: ["world","North America","US","US-MT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mt-007",
    lat: 48.22578,
    lng: -114.276342,
    panoId: "HnU6SVMW0zx8haS14EHVbA",
    place: "Near Evergreen, Montana",
    shortName: "Evergreen",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MT",
    state: "Montana",
    difficulty: "classic",
    pools: ["world","North America","US","US-MT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mt-008",
    lat: 46.863269,
    lng: -114.04846,
    panoId: "Xeur5dOmJN1bv2uVfh-1Yw",
    place: "Near Orchard Homes, Montana",
    shortName: "Orchard Homes",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MT",
    state: "Montana",
    difficulty: "classic",
    pools: ["world","North America","US","US-MT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mt-009",
    lat: 46.616934,
    lng: -111.921521,
    panoId: "h4GZl4CxbcRX2xjIUVuFig",
    place: "Near Helena Valley Southeast, Montana",
    shortName: "Helena Valley Southeast",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MT",
    state: "Montana",
    difficulty: "classic",
    pools: ["world","North America","US","US-MT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mt-010",
    lat: 46.592724,
    lng: -112.036056,
    panoId: "zFlgWTPcNTI2aUW14XS8NA",
    place: "Near Helena, Montana",
    shortName: "Helena",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MT",
    state: "Montana",
    difficulty: "classic",
    pools: ["world","North America","US","US-MT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mt-011",
    lat: 46.128507,
    lng: -112.94222,
    panoId: "DJ7WLiZzBpMZ5cfOiEWGcQ",
    place: "Near Anaconda, Montana",
    shortName: "Anaconda",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MT",
    state: "Montana",
    difficulty: "classic",
    pools: ["world","North America","US","US-MT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mt-012",
    lat: 46.663697,
    lng: -112.049745,
    panoId: "mnI1zlJ4dNcwIbqZ06Xkyg",
    place: "Near Helena Valley West Central, Montana",
    shortName: "Helena Valley West Central",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MT",
    state: "Montana",
    difficulty: "classic",
    pools: ["world","North America","US","US-MT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mt-013",
    lat: 47.716697,
    lng: -104.156254,
    panoId: "INcsI83Kb-5YZCnMG-4R4w",
    place: "Near Sidney, Montana",
    shortName: "Sidney",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MT",
    state: "Montana",
    difficulty: "classic",
    pools: ["world","North America","US","US-MT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mt-014",
    lat: 45.662486,
    lng: -110.561088,
    panoId: "MytI1Loo1U3ROhm-2RYP8w",
    place: "Near Livingston, Montana",
    shortName: "Livingston",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MT",
    state: "Montana",
    difficulty: "classic",
    pools: ["world","North America","US","US-MT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mt-015",
    lat: 45.776093,
    lng: -111.176897,
    panoId: "_Zv2ep79t-E5Sz-19gqNzQ",
    place: "Near Belgrade, Montana",
    shortName: "Belgrade",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MT",
    state: "Montana",
    difficulty: "classic",
    pools: ["world","North America","US","US-MT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mt-016",
    lat: 48.41107,
    lng: -114.338217,
    panoId: "qjZuKFlSgP1t1rjdi8bR2g",
    place: "Near Whitefish, Montana",
    shortName: "Whitefish",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MT",
    state: "Montana",
    difficulty: "classic",
    pools: ["world","North America","US","US-MT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mt-017",
    lat: 47.062606,
    lng: -109.428026,
    panoId: "Sun6NxqXH_9Jy-ej97cAlw",
    place: "Near Lewistown, Montana",
    shortName: "Lewistown",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MT",
    state: "Montana",
    difficulty: "classic",
    pools: ["world","North America","US","US-MT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mt-018",
    lat: 48.372452,
    lng: -114.181566,
    panoId: "ewKa7Bgtq-mvfwuEBp-muA",
    place: "Near Columbia Falls, Montana",
    shortName: "Columbia Falls",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MT",
    state: "Montana",
    difficulty: "classic",
    pools: ["world","North America","US","US-MT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mt-019",
    lat: 47.105309,
    lng: -104.712509,
    panoId: "eExLkYyRHwV15Pv3rgO8kQ",
    place: "Near Glendive, Montana",
    shortName: "Glendive",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MT",
    state: "Montana",
    difficulty: "classic",
    pools: ["world","North America","US","US-MT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mt-020",
    lat: 47.500239,
    lng: -111.300853,
    panoId: "I4nIzSUyNfAY1mRwQ7wp6Q",
    place: "Near Great Falls, Montana",
    shortName: "Great Falls",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MT",
    state: "Montana",
    difficulty: "classic",
    pools: ["world","North America","US","US-MT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mt-021",
    lat: 46.408363,
    lng: -105.840481,
    panoId: "i2QX2hnP6ACWysCQ15pZQA",
    place: "Near Miles City, Montana",
    shortName: "Miles City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MT",
    state: "Montana",
    difficulty: "classic",
    pools: ["world","North America","US","US-MT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mt-022",
    lat: 47.089248,
    lng: -104.706096,
    panoId: "avjmjOsEPKmNonAcAgUM8w",
    place: "Near Glendive, Montana",
    shortName: "Glendive",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MT",
    state: "Montana",
    difficulty: "classic",
    pools: ["world","North America","US","US-MT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mt-023",
    lat: 45.676525,
    lng: -108.74666,
    panoId: "k1conbKbYnrK3cK3hJApNg",
    place: "Near Laurel, Montana",
    shortName: "Laurel",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MT",
    state: "Montana",
    difficulty: "classic",
    pools: ["world","North America","US","US-MT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mt-024",
    lat: 45.825833,
    lng: -108.435491,
    panoId: "-EZMYVcnNQjGY7eLvaDQEw",
    place: "Near Lockwood, Montana",
    shortName: "Lockwood",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MT",
    state: "Montana",
    difficulty: "classic",
    pools: ["world","North America","US","US-MT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mt-025",
    lat: 48.181246,
    lng: -114.327727,
    panoId: "W9i9WCNnwk3o7RqPjWiiBw",
    place: "Near Kalispell, Montana",
    shortName: "Kalispell",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MT",
    state: "Montana",
    difficulty: "classic",
    pools: ["world","North America","US","US-MT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mt-026",
    lat: 45.758333,
    lng: -111.196587,
    panoId: "mMTTggqzYQ3yzMujA4_JNw",
    place: "Near Belgrade, Montana",
    shortName: "Belgrade",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MT",
    state: "Montana",
    difficulty: "classic",
    pools: ["world","North America","US","US-MT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mt-027",
    lat: 48.385209,
    lng: -114.187388,
    panoId: "7NW2UkaZuSDl0_3WTpjaVQ",
    place: "Near Columbia Falls, Montana",
    shortName: "Columbia Falls",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MT",
    state: "Montana",
    difficulty: "classic",
    pools: ["world","North America","US","US-MT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mt-028",
    lat: 45.818236,
    lng: -108.450042,
    panoId: "QHBxkDOiTMC8QvJJ4k1UIA",
    place: "Near Lockwood, Montana",
    shortName: "Lockwood",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MT",
    state: "Montana",
    difficulty: "classic",
    pools: ["world","North America","US","US-MT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mt-029",
    lat: 46.624895,
    lng: -111.893959,
    panoId: "pUDdjVNg7lZZdagXiN6gpw",
    place: "Near Helena Valley Southeast, Montana",
    shortName: "Helena Valley Southeast",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MT",
    state: "Montana",
    difficulty: "classic",
    pools: ["world","North America","US","US-MT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mt-030",
    lat: 48.559792,
    lng: -109.65483,
    panoId: "5qRzbqKSgUCD7vbjXctqoQ",
    place: "Near Havre, Montana",
    shortName: "Havre",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MT",
    state: "Montana",
    difficulty: "classic",
    pools: ["world","North America","US","US-MT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mt-031",
    lat: 48.505236,
    lng: -111.857043,
    panoId: "e4_16gov-0bY8Y10aqmP0w",
    place: "Near Shelby, Montana",
    shortName: "Shelby",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MT",
    state: "Montana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MT"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-mt-032",
    lat: 47.693577,
    lng: -114.163409,
    panoId: "XtpOHLj6SZPiFUygUDSxCg",
    place: "Near Polson, Montana",
    shortName: "Polson",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MT",
    state: "Montana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mt-033",
    lat: 48.0633,
    lng: -114.07211,
    panoId: "4lVAF-fJ42RHFFHgBklGcg",
    place: "Near Bigfork, Montana",
    shortName: "Bigfork",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MT",
    state: "Montana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mt-034",
    lat: 46.246838,
    lng: -114.160306,
    panoId: "UCtjenAot4zAWXzhLVOzpA",
    place: "Near Hamilton, Montana",
    shortName: "Hamilton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MT",
    state: "Montana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mt-035",
    lat: 45.659745,
    lng: -111.184712,
    panoId: "ghsec_-Zm95EcsY-T2Rd0w",
    place: "Near Four Corners, Montana",
    shortName: "Four Corners",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MT",
    state: "Montana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mt-036",
    lat: 45.732476,
    lng: -107.611968,
    panoId: "tcTMSfYJ-XDqzZDqVTqI4g",
    place: "Near Hardin, Montana",
    shortName: "Hardin",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MT",
    state: "Montana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mt-037",
    lat: 46.181364,
    lng: -112.784848,
    panoId: "p40mSMQiSn1_WcWoE8a_aA",
    place: "Near Warm Springs, Montana",
    shortName: "Warm Springs",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MT",
    state: "Montana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mt-038",
    lat: 46.758348,
    lng: -114.080991,
    panoId: "m_HMsxg9j9TF6CNF7OSHBw",
    place: "Near Lolo, Montana",
    shortName: "Lolo",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MT",
    state: "Montana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mt-039",
    lat: 46.704943,
    lng: -111.958368,
    panoId: "eDSdiTApVYxIl3uFlwrdFw",
    place: "Near Helena Valley Northeast, Montana",
    shortName: "Helena Valley Northeast",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MT",
    state: "Montana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mt-040",
    lat: 46.72891,
    lng: -112.063115,
    panoId: "k8rz0Co2_liIpYzIKcLUyw",
    place: "Near Helena Valley Northwest, Montana",
    shortName: "Helena Valley Northwest",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MT",
    state: "Montana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mt-041",
    lat: 46.53951,
    lng: -111.932503,
    panoId: "K7tnnLe1_PmfD5I1B-Kvtg",
    place: "Near Montana City, Montana",
    shortName: "Montana City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MT",
    state: "Montana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mt-042",
    lat: 48.090516,
    lng: -105.640866,
    panoId: "Typ2f2RDEmIQ0wPHX7LBFA",
    place: "Near Wolf Point, Montana",
    shortName: "Wolf Point",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MT",
    state: "Montana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mt-043",
    lat: 48.066723,
    lng: -114.093712,
    panoId: "ChtaLwa52inp4owRdeezHA",
    place: "Near Bigfork, Montana",
    shortName: "Bigfork",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MT",
    state: "Montana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mt-044",
    lat: 46.395628,
    lng: -112.730035,
    panoId: "KF0ny4Yw9yrTxvfzjBpIdA",
    place: "Near Deer Lodge, Montana",
    shortName: "Deer Lodge",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MT",
    state: "Montana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mt-045",
    lat: 45.719812,
    lng: -107.627183,
    panoId: "gf6hUuNsFm0uAQMzkcWj0g",
    place: "Near Hardin, Montana",
    shortName: "Hardin",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MT",
    state: "Montana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mt-046",
    lat: 48.519933,
    lng: -111.855716,
    panoId: "xoJZMIvKI2ZfMl2GywH69Q",
    place: "Near Shelby, Montana",
    shortName: "Shelby",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MT",
    state: "Montana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mt-047",
    lat: 45.670473,
    lng: -111.176768,
    panoId: "2az6su52CwI55_AhMU5dIQ",
    place: "Near Four Corners, Montana",
    shortName: "Four Corners",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MT",
    state: "Montana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mt-048",
    lat: 45.236911,
    lng: -112.639192,
    panoId: "KJVozsNt-AWUpSXsS-aC6Q",
    place: "Near Dillon, Montana",
    shortName: "Dillon",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MT",
    state: "Montana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mt-049",
    lat: 46.254051,
    lng: -114.150324,
    panoId: "MJqBf9xRK4qe_OJdgQZRYg",
    place: "Near Hamilton, Montana",
    shortName: "Hamilton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MT",
    state: "Montana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mt-050",
    lat: 46.901047,
    lng: -114.017033,
    panoId: "BpM3ORK5dbFdFOgipQEHFw",
    place: "Near Missoula, Montana",
    shortName: "Missoula",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MT",
    state: "Montana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mt-051",
    lat: 46.580307,
    lng: -111.934693,
    panoId: "6BXwasUnta4RKiIJH_f-xg",
    place: "Near East Helena, Montana",
    shortName: "East Helena",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MT",
    state: "Montana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mt-052",
    lat: 46.70361,
    lng: -112.106615,
    panoId: "cr-EHrMp2QxHdova7p-21g",
    place: "Near Helena Valley Northwest, Montana",
    shortName: "Helena Valley Northwest",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MT",
    state: "Montana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mt-053",
    lat: 47.783083,
    lng: -104.164192,
    panoId: "zFicTNDX97imQcoJmci-lA",
    place: "Near Sidney, Montana",
    shortName: "Sidney",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MT",
    state: "Montana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mt-054",
    lat: 47.674544,
    lng: -114.086922,
    panoId: "w2tvJkStzO7uzA25X0ukkw",
    place: "Near Polson, Montana",
    shortName: "Polson",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MT",
    state: "Montana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mt-055",
    lat: 48.326367,
    lng: -114.159421,
    panoId: "j0pALf28VFQZY7_9WZZZXg",
    place: "Near Columbia Falls, Montana",
    shortName: "Columbia Falls",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MT",
    state: "Montana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mt-056",
    lat: 46.826241,
    lng: -114.000458,
    panoId: "SICBtcwXRfEw1QokBArNBg",
    place: "Near Missoula, Montana",
    shortName: "Missoula",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MT",
    state: "Montana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mt-057",
    lat: 46.575215,
    lng: -111.911674,
    panoId: "GE4Tjb_Tn457jHoSqlGCLA",
    place: "Near East Helena, Montana",
    shortName: "East Helena",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MT",
    state: "Montana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mt-058",
    lat: 48.519567,
    lng: -109.64405,
    panoId: "uwhcoIRaY20kJQTP81Wq3A",
    place: "Near Havre, Montana",
    shortName: "Havre",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MT",
    state: "Montana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MT"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-mt-059",
    lat: 46.410085,
    lng: -105.928742,
    panoId: "MYcEBYjeH-weIwJfnA0ofg",
    place: "Near Miles City, Montana",
    shortName: "Miles City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MT",
    state: "Montana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mt-060",
    lat: 46.756779,
    lng: -114.114484,
    panoId: "LljZuGdEsMU8tPEUenQV7g",
    place: "Near Lolo, Montana",
    shortName: "Lolo",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MT",
    state: "Montana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mt-061",
    lat: 46.109753,
    lng: -112.881352,
    panoId: "pXq_jbmmGy_Y8JuZVJG1Lw",
    place: "Near Anaconda, Montana",
    shortName: "Anaconda",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MT",
    state: "Montana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MT"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-mt-062",
    lat: 46.733718,
    lng: -112.036063,
    panoId: "0_rU8FxJFAlN9waxlhSr-w",
    place: "Near Helena Valley Northwest, Montana",
    shortName: "Helena Valley Northwest",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MT",
    state: "Montana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mt-063",
    lat: 48.045773,
    lng: -114.079173,
    panoId: "xRGlCqD06VP59zK0etgueA",
    place: "Near Bigfork, Montana",
    shortName: "Bigfork",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MT",
    state: "Montana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mt-064",
    lat: 47.524391,
    lng: -111.328423,
    panoId: "uQkNlvSoaNY82N-7qSsPng",
    place: "Near Great Falls, Montana",
    shortName: "Great Falls",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MT",
    state: "Montana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mt-065",
    lat: 45.738594,
    lng: -107.635099,
    panoId: "ea-ZaBHKi9afs27fgtGsmQ",
    place: "Near Hardin, Montana",
    shortName: "Hardin",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MT",
    state: "Montana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mt-066",
    lat: 47.439811,
    lng: -111.147646,
    panoId: "l4yKKC33H9NeCkRFrJerPQ",
    place: "Near Malmstrom Air Force Base, Montana",
    shortName: "Malmstrom Air Force Base",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MT",
    state: "Montana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mt-067",
    lat: 45.797836,
    lng: -108.576186,
    panoId: "qCJ_ChVrbJPcgeTrpHxaxQ",
    place: "Near Billings, Montana",
    shortName: "Billings",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MT",
    state: "Montana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mt-068",
    lat: 48.014778,
    lng: -114.266595,
    panoId: "WdH_VKf7je0vHE2JSGH1Mg",
    place: "Near Lakeside, Montana",
    shortName: "Lakeside",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MT",
    state: "Montana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mt-069",
    lat: 46.187053,
    lng: -114.134272,
    panoId: "YVAhD4hGBwlotHEIseZfVQ",
    place: "Near Hamilton, Montana",
    shortName: "Hamilton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MT",
    state: "Montana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mt-070",
    lat: 45.705948,
    lng: -108.740707,
    panoId: "ae-6O0phZGlfuFu8o3pz1Q",
    place: "Near Laurel, Montana",
    shortName: "Laurel",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MT",
    state: "Montana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mt-071",
    lat: 45.688105,
    lng: -110.49785,
    panoId: "ncSZeeTk-abcj7UIOYJtZQ",
    place: "Near Livingston, Montana",
    shortName: "Livingston",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MT",
    state: "Montana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mt-072",
    lat: 48.258385,
    lng: -114.232365,
    panoId: "GbJg3PT5l_Z-RyHdvW9iDA",
    place: "Near Evergreen, Montana",
    shortName: "Evergreen",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MT",
    state: "Montana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mt-073",
    lat: 46.725285,
    lng: -112.142064,
    panoId: "gy3XLQVnVuhI50z_ncHzGQ",
    place: "Near Helena Valley Northwest, Montana",
    shortName: "Helena Valley Northwest",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MT",
    state: "Montana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mt-074",
    lat: 45.652612,
    lng: -110.947137,
    panoId: "J15Xh1u5CfnA-VtobzQYIw",
    place: "Near Bozeman, Montana",
    shortName: "Bozeman",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MT",
    state: "Montana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mt-075",
    lat: 46.617172,
    lng: -111.847158,
    panoId: "gMdhU7s6vuLoHfKCt3c7pA",
    place: "Near Helena Valley Southeast, Montana",
    shortName: "Helena Valley Southeast",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MT",
    state: "Montana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mt-076",
    lat: 46.849656,
    lng: -114.088706,
    panoId: "Iloo7H1i356jcGtnBsy97g",
    place: "Near Orchard Homes, Montana",
    shortName: "Orchard Homes",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MT",
    state: "Montana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mt-077",
    lat: 46.638823,
    lng: -112.031945,
    panoId: "5kQrd0e2H1aL-Sb6cGhWNA",
    place: "Near Helena Valley West Central, Montana",
    shortName: "Helena Valley West Central",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MT",
    state: "Montana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mt-078",
    lat: 46.940638,
    lng: -114.012038,
    panoId: "ZDxD_XFS1h0wASbardQPAw",
    place: "Near Missoula, Montana",
    shortName: "Missoula",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MT",
    state: "Montana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MT"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "us-mt-079",
    lat: 46.239644,
    lng: -112.776264,
    panoId: "WoQQHr5hPGUrXpGL-CEidA",
    place: "Near Warm Springs, Montana",
    shortName: "Warm Springs",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MT",
    state: "Montana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mt-080",
    lat: 48.497065,
    lng: -111.864027,
    panoId: "VDidby-Tk0xYrJOsxH2MHQ",
    place: "Near Shelby, Montana",
    shortName: "Shelby",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MT",
    state: "Montana",
    difficulty: "explorer",
    pools: ["world","North America","US","US-MT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mt-081",
    lat: 48.632919,
    lng: -112.326328,
    panoId: "IAzByQxNunzWTzwQGKgl5A",
    place: "Near Cut Bank, Montana",
    shortName: "Cut Bank",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MT",
    state: "Montana",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-MT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mt-082",
    lat: 48.196962,
    lng: -106.636648,
    panoId: "Lp6fSmQToP-i6NUzCXooEA",
    place: "Near Glasgow, Montana",
    shortName: "Glasgow",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MT",
    state: "Montana",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-MT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mt-083",
    lat: 48.190709,
    lng: -106.608503,
    panoId: "yChBSvjowhYwU_JOT09-5g",
    place: "Near Glasgow, Montana",
    shortName: "Glasgow",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MT",
    state: "Montana",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-MT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mt-084",
    lat: 48.122086,
    lng: -105.668502,
    panoId: "pPV-KeysBhQ1F1Kk6QxhyA",
    place: "Near Wolf Point, Montana",
    shortName: "Wolf Point",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MT",
    state: "Montana",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-MT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-mt-085",
    lat: 45.844841,
    lng: -112.498163,
    panoId: "BqEVxDDkarl64nOkDYog1Q",
    place: "Near Butte, Montana",
    shortName: "Butte",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MT",
    state: "Montana",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-MT"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-mt-086",
    lat: 47.654312,
    lng: -111.112299,
    panoId: "zfc2haXtIF8vDZ_bCpA67g",
    place: "Near Malmstrom Air Force Base, Montana",
    shortName: "Malmstrom Air Force Base",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "MT",
    state: "Montana",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-MT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-000",
    lat: 41.136635,
    lng: -95.890929,
    panoId: "kQ-giamLgvMDOLdF8_hQCQ",
    place: "Near Bellevue, Nebraska",
    shortName: "Bellevue",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "classic",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-001",
    lat: 41.256557,
    lng: -95.940443,
    panoId: "cOnn0eoWM2wxeLdwBHX-kA",
    place: "Near Omaha, Nebraska",
    shortName: "Omaha",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "classic",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-002",
    lat: 40.699507,
    lng: -99.081632,
    panoId: "Pkd9k008RIDWmwKZMMcUNg",
    place: "Near Kearney, Nebraska",
    shortName: "Kearney",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "classic",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-003",
    lat: 40.868019,
    lng: -97.591963,
    panoId: "D1p-RfNanz1cIr5vNUIyOw",
    place: "Near York, Nebraska",
    shortName: "York",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "classic",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-004",
    lat: 41.42971,
    lng: -97.368283,
    panoId: "cZGTHYlls-NOGogLrPEjgg",
    place: "Near Columbus, Nebraska",
    shortName: "Columbus",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "classic",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-005",
    lat: 40.780799,
    lng: -99.741519,
    panoId: "tTbe95lQEuAYTVrk_xzhOA",
    place: "Near Lexington, Nebraska",
    shortName: "Lexington",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "classic",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-006",
    lat: 42.473921,
    lng: -96.413651,
    panoId: "F3rCogdM1WI4DPz5b3KFrQ",
    place: "Near South Sioux City, Nebraska",
    shortName: "South Sioux City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "classic",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-007",
    lat: 40.201942,
    lng: -100.625791,
    panoId: "DyXXDkIyReIclld88PrT8A",
    place: "Near McCook, Nebraska",
    shortName: "McCook",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "classic",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-ne-008",
    lat: 40.586099,
    lng: -98.388397,
    panoId: "KQHMYpYVCnNtEcrg9rox0A",
    place: "Near Hastings, Nebraska",
    shortName: "Hastings",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "classic",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-ne-009",
    lat: 42.82931,
    lng: -102.999899,
    panoId: "tTycbmACtbkgux10pUUyqw",
    place: "Near Chadron, Nebraska",
    shortName: "Chadron",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "classic",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-010",
    lat: 40.906964,
    lng: -97.098867,
    panoId: "aEJq1OQPsYqlp3UKJjyx_A",
    place: "Near Seward, Nebraska",
    shortName: "Seward",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "classic",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-011",
    lat: 41.544426,
    lng: -96.125005,
    panoId: "zMOq2q4HLRSl-DAKbTvw4A",
    place: "Near Blair, Nebraska",
    shortName: "Blair",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "classic",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-012",
    lat: 41.825767,
    lng: -103.660471,
    panoId: "6aeG0ZioLx2sTfNugNWBjA",
    place: "Near Gering, Nebraska",
    shortName: "Gering",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "classic",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-013",
    lat: 41.011163,
    lng: -95.882182,
    panoId: "dlH-l91fYuRzgbv0pO3kOg",
    place: "Near Plattsmouth, Nebraska",
    shortName: "Plattsmouth",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "classic",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-014",
    lat: 41.447336,
    lng: -97.059462,
    panoId: "UIUSV3Rz9UkkRxigtbZscw",
    place: "Near Schuyler, Nebraska",
    shortName: "Schuyler",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "classic",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-015",
    lat: 41.123985,
    lng: -100.765454,
    panoId: "J3kqHInynvgUfNsIOA-23A",
    place: "Near North Platte, Nebraska",
    shortName: "North Platte",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "classic",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-ne-016",
    lat: 41.30006,
    lng: -96.130031,
    panoId: "P99kCn7jE4COJPqWct-2og",
    place: "Near Hillsborough, Nebraska",
    shortName: "Hillsborough",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "classic",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-017",
    lat: 41.2053,
    lng: -96.042464,
    panoId: "T1eWyIHhf-6WVROqU_9n5Q",
    place: "Near Ralston, Nebraska",
    shortName: "Ralston",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "classic",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-018",
    lat: 42.101672,
    lng: -102.872295,
    panoId: "PxHWr70UsoxcutlhFT-w4A",
    place: "Near Alliance, Nebraska",
    shortName: "Alliance",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "classic",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-019",
    lat: 41.866669,
    lng: -103.667064,
    panoId: "pGSdmzx6Si6j99Jvh77dvw",
    place: "Near Scottsbluff, Nebraska",
    shortName: "Scottsbluff",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "classic",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-020",
    lat: 40.440284,
    lng: -99.369802,
    panoId: "b29_szYiG0qWdYegg3_37g",
    place: "Near Holdrege, Nebraska",
    shortName: "Holdrege",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "classic",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-021",
    lat: 41.154409,
    lng: -96.042206,
    panoId: "R6agSFxS9pVAw3FWeP1Lcw",
    place: "Near Papillion, Nebraska",
    shortName: "Papillion",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "classic",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-022",
    lat: 40.925024,
    lng: -98.341987,
    panoId: "8nspFkgSSwdFTb03GDCKsw",
    place: "Near Grand Island, Nebraska",
    shortName: "Grand Island",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "classic",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-023",
    lat: 41.183904,
    lng: -96.031079,
    panoId: "YUXL-oBvqLa5EdXBNEVJIw",
    place: "Near La Vista, Nebraska",
    shortName: "La Vista",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "classic",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-024",
    lat: 40.676675,
    lng: -95.859131,
    panoId: "HFQ_t7yuIGwvLxHzbNLTQA",
    place: "Near Nebraska City, Nebraska",
    shortName: "Nebraska City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "classic",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-025",
    lat: 40.799862,
    lng: -96.66698,
    panoId: "_i2y94P0y5GBDZLIwYxCkg",
    place: "Near Lincoln, Nebraska",
    shortName: "Lincoln",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "classic",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-026",
    lat: 42.230551,
    lng: -97.017803,
    panoId: "N0nOxnp61DoEdmseT1D83w",
    place: "Near Wayne, Nebraska",
    shortName: "Wayne",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "classic",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-027",
    lat: 41.344959,
    lng: -96.253725,
    panoId: "QNfdWynRWgrlMBe-qqSaSQ",
    place: "Near Elkhorn, Nebraska",
    shortName: "Elkhorn",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "classic",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-028",
    lat: 41.183673,
    lng: -96.150388,
    panoId: "F1OjUXKckwhOQx9cIpb2Gg",
    place: "Near Chalco, Nebraska",
    shortName: "Chalco",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "classic",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-029",
    lat: 40.627784,
    lng: -96.961498,
    panoId: "9DSAKqQfyso7uTiwV49c0Q",
    place: "Near Crete, Nebraska",
    shortName: "Crete",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "classic",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-030",
    lat: 41.43314,
    lng: -96.498096,
    panoId: "7XY1kQ5gP4DZTm05y4E8Ng",
    place: "Near Fremont, Nebraska",
    shortName: "Fremont",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "classic",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-031",
    lat: 41.140857,
    lng: -96.239829,
    panoId: "ctV287JvT8vyi5RexnDGFQ",
    place: "Near Gretna, Nebraska",
    shortName: "Gretna",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "classic",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-032",
    lat: 42.028347,
    lng: -97.416842,
    panoId: "vJp6KA2g2hXGgZAPeMnqVQ",
    place: "Near Norfolk, Nebraska",
    shortName: "Norfolk",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "classic",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-033",
    lat: 41.142724,
    lng: -102.977879,
    panoId: "R9pROQxyCL144lsYBuglZQ",
    place: "Near Sidney, Nebraska",
    shortName: "Sidney",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "classic",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-034",
    lat: 42.842556,
    lng: -103.027484,
    panoId: "I2fVODy8NqJMbLQp-0UFLA",
    place: "Near Chadron, Nebraska",
    shortName: "Chadron",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "classic",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-ne-035",
    lat: 41.419716,
    lng: -97.359906,
    panoId: "Mmu0XfcTnNJFvDv6G5vOLw",
    place: "Near Columbus, Nebraska",
    shortName: "Columbus",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "classic",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-036",
    lat: 42.220751,
    lng: -97.017786,
    panoId: "0VdLCzDfS5vDP4JLsNnt5g",
    place: "Near Wayne, Nebraska",
    shortName: "Wayne",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "classic",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-037",
    lat: 40.775026,
    lng: -99.754324,
    panoId: "Bv6dSocpnin3YGAFOaXzDA",
    place: "Near Lexington, Nebraska",
    shortName: "Lexington",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "classic",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-038",
    lat: 41.004477,
    lng: -95.861639,
    panoId: "VGqHzJX551uv1nBoHtUWIw",
    place: "Near Plattsmouth, Nebraska",
    shortName: "Plattsmouth",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "classic",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-039",
    lat: 41.4425,
    lng: -97.079004,
    panoId: "YmsbBSoPGyDWzEJ2_bXxEQ",
    place: "Near Schuyler, Nebraska",
    shortName: "Schuyler",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "classic",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-040",
    lat: 41.546301,
    lng: -96.111263,
    panoId: "o1hbS9Af_ZubWth_mhB32Q",
    place: "Near Blair, Nebraska",
    shortName: "Blair",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "classic",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-041",
    lat: 40.686172,
    lng: -95.881863,
    panoId: "Gyi4hNJP9sXsu4XwZFQoLw",
    place: "Near Nebraska City, Nebraska",
    shortName: "Nebraska City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "classic",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-042",
    lat: 41.81431,
    lng: -103.660096,
    panoId: "YKnQD2T6g27jnzEzSw1_-w",
    place: "Near Gering, Nebraska",
    shortName: "Gering",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "classic",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-043",
    lat: 41.328079,
    lng: -96.266015,
    panoId: "yJJ5AyPRuZDOdsX_9y6MMQ",
    place: "Near Elkhorn, Nebraska",
    shortName: "Elkhorn",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "classic",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-044",
    lat: 41.108647,
    lng: -100.767947,
    panoId: "y56UZbYzDXnDcLnEBxG-Mw",
    place: "Near North Platte, Nebraska",
    shortName: "North Platte",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "classic",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-045",
    lat: 41.824743,
    lng: -103.636192,
    panoId: "fi5Noqp9nuW6e6GEYPYK_g",
    place: "Near Gering, Nebraska",
    shortName: "Gering",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "classic",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-046",
    lat: 41.150078,
    lng: -96.054528,
    panoId: "Um0q19Crabc3-JjDvBKZMA",
    place: "Near Papillion, Nebraska",
    shortName: "Papillion",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "classic",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-047",
    lat: 41.25579,
    lng: -95.850089,
    panoId: "FaioiEYupCN4PBHp1dxt6g",
    place: "Near Council Bluffs, Nebraska",
    shortName: "Council Bluffs",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "classic",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-048",
    lat: 40.915931,
    lng: -97.06526,
    panoId: "bMMqqPxHfUJtWooya70jfw",
    place: "Near Seward, Nebraska",
    shortName: "Seward",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "classic",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-049",
    lat: 41.432167,
    lng: -97.070244,
    panoId: "SuIhMNZJo1p7ymLl15RpXw",
    place: "Near Schuyler, Nebraska",
    shortName: "Schuyler",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "classic",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-050",
    lat: 41.120196,
    lng: -95.926513,
    panoId: "kbvhXa5pOsNrw2m_xeSbyA",
    place: "Near Offutt Air Force Base, Nebraska",
    shortName: "Offutt Air Force Base",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-051",
    lat: 40.060717,
    lng: -95.601909,
    panoId: "9QyOKtCAih-ltLYOoFUXnA",
    place: "Near Falls City, Nebraska",
    shortName: "Falls City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-052",
    lat: 41.211405,
    lng: -96.619918,
    panoId: "zlQahgF1Rl0BhELhpVHYtQ",
    place: "Near Wahoo, Nebraska",
    shortName: "Wahoo",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-053",
    lat: 40.867225,
    lng: -98.004245,
    panoId: "T4bffOFbs8j9iM2AZpi3Ig",
    place: "Near Aurora, Nebraska",
    shortName: "Aurora",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-054",
    lat: 41.127997,
    lng: -101.719747,
    panoId: "p4rHWF1RxH2kB5VcWDoCvw",
    place: "Near Ogallala, Nebraska",
    shortName: "Ogallala",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-055",
    lat: 41.116718,
    lng: -100.847424,
    panoId: "GThzy5tbUfHtVt7bpDQsUA",
    place: "Near North Platte, Nebraska",
    shortName: "North Platte",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-056",
    lat: 40.670444,
    lng: -99.128081,
    panoId: "8ooSgj_oKJI_IMmff9xtxw",
    place: "Near Kearney, Nebraska",
    shortName: "Kearney",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-057",
    lat: 42.076349,
    lng: -97.351149,
    panoId: "Ax3tFp_3g4ZaZNHmcvUFBA",
    place: "Near Norfolk, Nebraska",
    shortName: "Norfolk",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-058",
    lat: 40.639642,
    lng: -96.888699,
    panoId: "Diaq3z9B6TkcDEMAPBVnRQ",
    place: "Near Crete, Nebraska",
    shortName: "Crete",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-059",
    lat: 40.762084,
    lng: -96.61315,
    panoId: "vL9Q6aOpg1lVf9TsAKI_kw",
    place: "Near Lincoln, Nebraska",
    shortName: "Lincoln",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-060",
    lat: 41.152317,
    lng: -96.109945,
    panoId: "-Rls09tB95ZXUEXU6zNlgw",
    place: "Near Chalco, Nebraska",
    shortName: "Chalco",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-061",
    lat: 40.633674,
    lng: -98.401435,
    panoId: "wtWXV2GcLb9GETC0neGO_w",
    place: "Near Hastings, Nebraska",
    shortName: "Hastings",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-062",
    lat: 41.141552,
    lng: -95.813615,
    panoId: "7BkvNNeWV-mqD-gULpXhcQ",
    place: "Near Bellevue, Nebraska",
    shortName: "Bellevue",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-063",
    lat: 41.206815,
    lng: -95.97715,
    panoId: "52bjbH7decQdwOBV3GTwiw",
    place: "Near La Vista, Nebraska",
    shortName: "La Vista",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-064",
    lat: 41.297527,
    lng: -96.217776,
    panoId: "bfL5h9wPWXtLW56q4djWAw",
    place: "Near Waterloo, Nebraska",
    shortName: "Waterloo",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-065",
    lat: 41.205489,
    lng: -102.992778,
    panoId: "Mix195K09yYhldE0q-evzw",
    place: "Near Sidney, Nebraska",
    shortName: "Sidney",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-066",
    lat: 40.39639,
    lng: -99.369873,
    panoId: "DMCOdgzlXDduT1SBHWd36w",
    place: "Near Holdrege, Nebraska",
    shortName: "Holdrege",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-067",
    lat: 41.223339,
    lng: -96.148655,
    panoId: "cn4Y30lFsIBVzU9D9kaLxw",
    place: "Near Chalco, Nebraska",
    shortName: "Chalco",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-068",
    lat: 40.243555,
    lng: -96.82223,
    panoId: "B7hljGuipp6lXtDtjaxoCg",
    place: "Near Beatrice, Nebraska",
    shortName: "Beatrice",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-069",
    lat: 40.821107,
    lng: -97.606659,
    panoId: "oShnrKo828SY6Vs13hHZ_w",
    place: "Near York, Nebraska",
    shortName: "York",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-070",
    lat: 40.821853,
    lng: -98.052512,
    panoId: "ey14boS0bHZMnn8n2R9XOw",
    place: "Near Aurora, Nebraska",
    shortName: "Aurora",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-071",
    lat: 40.622646,
    lng: -95.799319,
    panoId: "NDpPh9hnzvnGF3toB_hEwQ",
    place: "Near Nebraska City, Nebraska",
    shortName: "Nebraska City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-072",
    lat: 41.067111,
    lng: -95.936912,
    panoId: "tCyYpe9hXkUoMBNPdS0Asw",
    place: "Near Offutt Air Force Base, Nebraska",
    shortName: "Offutt Air Force Base",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-073",
    lat: 40.703259,
    lng: -99.028866,
    panoId: "2-srKpv6tWHSRloPsosERw",
    place: "Near Kearney, Nebraska",
    shortName: "Kearney",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-074",
    lat: 40.085857,
    lng: -95.520431,
    panoId: "MG7jH8EPGwu8I4GB-_plbA",
    place: "Near Falls City, Nebraska",
    shortName: "Falls City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-075",
    lat: 40.888519,
    lng: -99.934375,
    panoId: "Nxv0waXDEqg0xbhs4lFIGw",
    place: "Near Cozad, Nebraska",
    shortName: "Cozad",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-076",
    lat: 41.178051,
    lng: -101.73168,
    panoId: "MxRBvQF5dAgTZnWF2qt53g",
    place: "Near Ogallala, Nebraska",
    shortName: "Ogallala",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-077",
    lat: 41.344243,
    lng: -96.206493,
    panoId: "sSwWNySXSXDPE7-td9HdKQ",
    place: "Near Elkhorn, Nebraska",
    shortName: "Elkhorn",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-078",
    lat: 40.869613,
    lng: -96.643808,
    panoId: "JwZesRSodYOhCEvs5Hq4-w",
    place: "Near Lincoln, Nebraska",
    shortName: "Lincoln",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-079",
    lat: 41.21979,
    lng: -96.011305,
    panoId: "hLZLU9TR7vzbZRvyCGK7Gg",
    place: "Near Ralston, Nebraska",
    shortName: "Ralston",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-080",
    lat: 41.176562,
    lng: -96.683031,
    panoId: "LQZ8glYcIMPWyyUO-4cM-w",
    place: "Near Wahoo, Nebraska",
    shortName: "Wahoo",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-081",
    lat: 41.175598,
    lng: -96.09335,
    panoId: "ifortnmHJ4um3CAWtKxteQ",
    place: "Near Chalco, Nebraska",
    shortName: "Chalco",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-082",
    lat: 41.476885,
    lng: -96.536875,
    panoId: "5D7iyL1Ke0E-xch3ziFDaQ",
    place: "Near Fremont, Nebraska",
    shortName: "Fremont",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-083",
    lat: 40.509974,
    lng: -98.37373,
    panoId: "fR_uCUV8STMh44tjX5iMIg",
    place: "Near Hastings, Nebraska",
    shortName: "Hastings",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-084",
    lat: 42.809451,
    lng: -102.930566,
    panoId: "b-3-6L6jmZjJ9_8dZwJKDg",
    place: "Near Chadron, Nebraska",
    shortName: "Chadron",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-085",
    lat: 41.596971,
    lng: -96.177052,
    panoId: "nzVJeYKdp9X7DhtrxNB1kQ",
    place: "Near Blair, Nebraska",
    shortName: "Blair",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-086",
    lat: 42.523253,
    lng: -96.462887,
    panoId: "Gm3GJmBwaJ08QlmG0aiW1A",
    place: "Near North Sioux City, Nebraska",
    shortName: "North Sioux City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-087",
    lat: 40.981569,
    lng: -95.825537,
    panoId: "SHlXlxXKHo5SF6sargqFdw",
    place: "Near Plattsmouth, Nebraska",
    shortName: "Plattsmouth",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-088",
    lat: 41.231538,
    lng: -95.99201,
    panoId: "hfzCls-AbU6cFKULda6oSg",
    place: "Near Omaha, Nebraska",
    shortName: "Omaha",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-089",
    lat: 40.80261,
    lng: -99.710556,
    panoId: "v_eHzTGfI98zPiBnDci_0g",
    place: "Near Lexington, Nebraska",
    shortName: "Lexington",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-090",
    lat: 41.467241,
    lng: -97.37725,
    panoId: "8z1lzLWo_N8JkM1fNrvqGQ",
    place: "Near Columbus, Nebraska",
    shortName: "Columbus",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-091",
    lat: 40.887177,
    lng: -98.337669,
    panoId: "TzXZxhPITiPAGe6Y-N-UMg",
    place: "Near Grand Island, Nebraska",
    shortName: "Grand Island",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-092",
    lat: 42.004236,
    lng: -97.387392,
    panoId: "epoHhm8G7LWDxlYxqtw5Kg",
    place: "Near Norfolk, Nebraska",
    shortName: "Norfolk",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-093",
    lat: 42.091307,
    lng: -102.800223,
    panoId: "E6rt5U8FKPKDOy5b_HY3fg",
    place: "Near Alliance, Nebraska",
    shortName: "Alliance",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-094",
    lat: 41.143027,
    lng: -95.855508,
    panoId: "9I1B4QGzJCx3YDDeK-k3Tg",
    place: "Near Bellevue, Nebraska",
    shortName: "Bellevue",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-095",
    lat: 41.154102,
    lng: -96.28228,
    panoId: "WDLfCsJOwwxHIlq-SPhrLA",
    place: "Near Gretna, Nebraska",
    shortName: "Gretna",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-096",
    lat: 40.405021,
    lng: -99.360751,
    panoId: "-WL2VgK4t0krXXXuPBI7Bw",
    place: "Near Holdrege, Nebraska",
    shortName: "Holdrege",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-097",
    lat: 40.806006,
    lng: -98.035683,
    panoId: "J4WEMy2V_OgPxXDsX0xBug",
    place: "Near Aurora, Nebraska",
    shortName: "Aurora",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-098",
    lat: 41.831889,
    lng: -103.716573,
    panoId: "S-tBQ4m3ailBxh5z9fw1tA",
    place: "Near Gering, Nebraska",
    shortName: "Gering",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-099",
    lat: 42.293178,
    lng: -96.97081,
    panoId: "KcTNPw7kF3kpJxpzpFLGYA",
    place: "Near Wayne, Nebraska",
    shortName: "Wayne",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-100",
    lat: 41.163801,
    lng: -101.596082,
    panoId: "4gjkp7LqShsPNNT00q1t7A",
    place: "Near Ogallala, Nebraska",
    shortName: "Ogallala",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-101",
    lat: 41.686931,
    lng: -96.789912,
    panoId: "n2W2IjVT56ApwDTj1hdS9A",
    place: "Near West Point, Nebraska",
    shortName: "West Point",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-102",
    lat: 40.640568,
    lng: -97.430693,
    panoId: "TFU1b2AsnbLt6u5oykJhTw",
    place: "Near Friend, Nebraska",
    shortName: "Friend",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-103",
    lat: 40.103103,
    lng: -96.936529,
    panoId: "a5btzXfAY5QwElncyn-S5g",
    place: "Near Fairbury, Nebraska",
    shortName: "Fairbury",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-104",
    lat: 41.192143,
    lng: -103.828083,
    panoId: "PpftU1MyEMuYVPA89U875Q",
    place: "Near Kimball, Nebraska",
    shortName: "Kimball",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-105",
    lat: 42.488273,
    lng: -96.643465,
    panoId: "69FBPmNd0xU6Rn7_Nq8Pew",
    place: "Near Ponca, Nebraska",
    shortName: "Ponca",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-106",
    lat: 41.712207,
    lng: -97.406847,
    panoId: "uqUdq_C8QTivLUorkJ6ohw",
    place: "Near Madison, Nebraska",
    shortName: "Madison",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-107",
    lat: 40.489029,
    lng: -96.779736,
    panoId: "ZzhuS7YL7TGxV-k3in6bMA",
    place: "Near Wilber, Nebraska",
    shortName: "Wilber",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-108",
    lat: 42.549983,
    lng: -98.42274,
    panoId: "AnmV2HfKIXfPnYBRneufHQ",
    place: "Near O'Neill, Nebraska",
    shortName: "O'Neill",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-109",
    lat: 40.045596,
    lng: -97.827508,
    panoId: "iidVVA4L4zICxmGbPg79-A",
    place: "Near Superior, Nebraska",
    shortName: "Superior",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-110",
    lat: 41.171839,
    lng: -98.671926,
    panoId: "7eQi7jkcp27qwN02X7JpCg",
    place: "Near Saint Paul, Nebraska",
    shortName: "Saint Paul",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-111",
    lat: 42.061282,
    lng: -97.719247,
    panoId: "Z0v6QVTQmfS_S4SizF91IA",
    place: "Near Battle Creek, Nebraska",
    shortName: "Battle Creek",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-112",
    lat: 40.98397,
    lng: -97.940561,
    panoId: "SEcmWt20vk3V5PymNZBRow",
    place: "Near Aurora, Nebraska",
    shortName: "Aurora",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-113",
    lat: 41.692761,
    lng: -96.386503,
    panoId: "myorerIAS0lfyAbdkCnxrg",
    place: "Near Tekamah, Nebraska",
    shortName: "Tekamah",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-114",
    lat: 40.393968,
    lng: -98.802857,
    panoId: "MIS7YtTBbHaTcCNOrNIylw",
    place: "Near Minden, Nebraska",
    shortName: "Minden",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-115",
    lat: 41.190493,
    lng: -103.860814,
    panoId: "9hijrs7oBFRklMj3NHHL7A",
    place: "Near Kimball, Nebraska",
    shortName: "Kimball",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-116",
    lat: 41.059719,
    lng: -96.496349,
    panoId: "DjG7-HvXfkjMEqbxBCEBjA",
    place: "Near Ashland, Nebraska",
    shortName: "Ashland",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-117",
    lat: 40.059234,
    lng: -97.395776,
    panoId: "0PMF0BnrIlliepXU5jZxHw",
    place: "Near Hebron, Nebraska",
    shortName: "Hebron",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ne-118",
    lat: 40.364966,
    lng: -96.539589,
    panoId: "wEOJRZwIqs-y2F7bGpyNrw",
    place: "Near Beatrice, Nebraska",
    shortName: "Beatrice",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NE",
    state: "Nebraska",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-NE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nv-000",
    lat: 36.208278,
    lng: -115.983964,
    panoId: "Swh-4dy7nGc6z1kq5JXhow",
    place: "Near Pahrump, Nevada",
    shortName: "Pahrump",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NV",
    state: "Nevada",
    difficulty: "classic",
    pools: ["world","North America","US","US-NV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nv-001",
    lat: 39.596369,
    lng: -119.776053,
    panoId: "jvARVqfUic7qPJVp6X31qg",
    place: "Near Sun Valley, Nevada",
    shortName: "Sun Valley",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NV",
    state: "Nevada",
    difficulty: "classic",
    pools: ["world","North America","US","US-NV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nv-002",
    lat: 39.534883,
    lng: -119.752743,
    panoId: "Dd9GoAH0yvdM_f97oziOYw",
    place: "Near Sparks, Nevada",
    shortName: "Sparks",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NV",
    state: "Nevada",
    difficulty: "classic",
    pools: ["world","North America","US","US-NV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nv-003",
    lat: 39.237283,
    lng: -119.592249,
    panoId: "Mr3KnXuqxEduk_JB_izkJA",
    place: "Near Dayton, Nevada",
    shortName: "Dayton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NV",
    state: "Nevada",
    difficulty: "classic",
    pools: ["world","North America","US","US-NV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nv-004",
    lat: 40.832521,
    lng: -115.762956,
    panoId: "GaMBJroSdYPVJkBr75srOg",
    place: "Near Elko, Nevada",
    shortName: "Elko",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NV",
    state: "Nevada",
    difficulty: "classic",
    pools: ["world","North America","US","US-NV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nv-005",
    lat: 39.415485,
    lng: -119.224635,
    panoId: "1nbtYSeSzlN4YtvKfsON0w",
    place: "Near Silver Springs, Nevada",
    shortName: "Silver Springs",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NV",
    state: "Nevada",
    difficulty: "classic",
    pools: ["world","North America","US","US-NV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nv-006",
    lat: 40.97294,
    lng: -117.735619,
    panoId: "FsCXY7YIq70caqvTpzpgxA",
    place: "Near Winnemucca, Nevada",
    shortName: "Winnemucca",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NV",
    state: "Nevada",
    difficulty: "classic",
    pools: ["world","North America","US","US-NV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nv-007",
    lat: 38.954101,
    lng: -119.765758,
    panoId: "nalEOXUD9wC5LwfcFEFrBA",
    place: "Near Minden, Nevada",
    shortName: "Minden",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NV",
    state: "Nevada",
    difficulty: "classic",
    pools: ["world","North America","US","US-NV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nv-008",
    lat: 39.529532,
    lng: -119.813752,
    panoId: "N0wCAyZdaRBV3K4qCahqPA",
    place: "Near Reno, Nevada",
    shortName: "Reno",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NV",
    state: "Nevada",
    difficulty: "classic",
    pools: ["world","North America","US","US-NV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nv-009",
    lat: 39.163768,
    lng: -119.767001,
    panoId: "1pkdSGbGKbVJrH_uyk_zHQ",
    place: "Near Carson City, Nevada",
    shortName: "Carson City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NV",
    state: "Nevada",
    difficulty: "classic",
    pools: ["world","North America","US","US-NV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nv-010",
    lat: 36.174966,
    lng: -115.137234,
    panoId: "nMJlZGrPJNhwg-BemnD_Cg",
    place: "Near Las Vegas, Nevada",
    shortName: "Las Vegas",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NV",
    state: "Nevada",
    difficulty: "classic",
    pools: ["world","North America","US","US-NV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nv-011",
    lat: 39.473491,
    lng: -118.777139,
    panoId: "C9uDNzi0Flwi3kn03Y7XvA",
    place: "Near Fallon, Nevada",
    shortName: "Fallon",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NV",
    state: "Nevada",
    difficulty: "classic",
    pools: ["world","North America","US","US-NV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nv-012",
    lat: 38.941414,
    lng: -119.749785,
    panoId: "yNsNBafGIXGbUqWWje3bqg",
    place: "Near Gardnerville, Nevada",
    shortName: "Gardnerville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NV",
    state: "Nevada",
    difficulty: "classic",
    pools: ["world","North America","US","US-NV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nv-013",
    lat: 39.251287,
    lng: -119.973007,
    panoId: "_zEZ3UVQ_MEffr66WJRXYg",
    place: "Near Incline Village, Nevada",
    shortName: "Incline Village",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NV",
    state: "Nevada",
    difficulty: "classic",
    pools: ["world","North America","US","US-NV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nv-014",
    lat: 39.047721,
    lng: -119.722119,
    panoId: "5rKHCOR2UpIeowoAAQeJDA",
    place: "Near Johnson Lane, Nevada",
    shortName: "Johnson Lane",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NV",
    state: "Nevada",
    difficulty: "classic",
    pools: ["world","North America","US","US-NV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nv-015",
    lat: 39.679978,
    lng: -119.976531,
    panoId: "eWgmvQ1vTTbrdcPMd17SXg",
    place: "Near Cold Springs, Nevada",
    shortName: "Cold Springs",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NV",
    state: "Nevada",
    difficulty: "classic",
    pools: ["world","North America","US","US-NV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nv-016",
    lat: 39.607984,
    lng: -119.251572,
    panoId: "YMuhYXR7N36Qg0NAhnzw6g",
    place: "Near Fernley, Nevada",
    shortName: "Fernley",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NV",
    state: "Nevada",
    difficulty: "classic",
    pools: ["world","North America","US","US-NV"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-nv-017",
    lat: 39.085847,
    lng: -119.784051,
    panoId: "2nyfGr3NdVtAihtEYrax3A",
    place: "Near Indian Hills, Nevada",
    shortName: "Indian Hills",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NV",
    state: "Nevada",
    difficulty: "classic",
    pools: ["world","North America","US","US-NV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nv-018",
    lat: 39.649068,
    lng: -119.707108,
    panoId: "IoaCgnzlQ_uErSMN3yfIpg",
    place: "Near Spanish Springs, Nevada",
    shortName: "Spanish Springs",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NV",
    state: "Nevada",
    difficulty: "classic",
    pools: ["world","North America","US","US-NV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nv-019",
    lat: 40.72637,
    lng: -115.584789,
    panoId: "MpY93bElFPIuUHDQGKSH1g",
    place: "Near Spring Creek, Nevada",
    shortName: "Spring Creek",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NV",
    state: "Nevada",
    difficulty: "classic",
    pools: ["world","North America","US","US-NV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nv-020",
    lat: 39.635978,
    lng: -119.843206,
    panoId: "o0kAgixSSikrLsy6zqNS3g",
    place: "Near Lemmon Valley, Nevada",
    shortName: "Lemmon Valley",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NV",
    state: "Nevada",
    difficulty: "classic",
    pools: ["world","North America","US","US-NV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nv-021",
    lat: 36.805368,
    lng: -114.067137,
    panoId: "68RIBwbY2Y5-QaxLMkE4nA",
    place: "Near Mesquite, Nevada",
    shortName: "Mesquite",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NV",
    state: "Nevada",
    difficulty: "classic",
    pools: ["world","North America","US","US-NV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nv-022",
    lat: 35.167764,
    lng: -114.572984,
    panoId: "X3lfCPRshLrpAt6nA0B-JQ",
    place: "Near Laughlin, Nevada",
    shortName: "Laughlin",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NV",
    state: "Nevada",
    difficulty: "classic",
    pools: ["world","North America","US","US-NV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nv-023",
    lat: 39.61543,
    lng: -119.826712,
    panoId: "m_NXPAWe_eSs21srqHWH5Q",
    place: "Near Golden Valley, Nevada",
    shortName: "Golden Valley",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NV",
    state: "Nevada",
    difficulty: "classic",
    pools: ["world","North America","US","US-NV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nv-024",
    lat: 38.866868,
    lng: -119.756948,
    panoId: "TE1GvQixMfKAja6Y3L9bAA",
    place: "Near Gardnerville Ranchos, Nevada",
    shortName: "Gardnerville Ranchos",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NV",
    state: "Nevada",
    difficulty: "classic",
    pools: ["world","North America","US","US-NV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nv-025",
    lat: 39.5922,
    lng: -119.257648,
    panoId: "TvbhPzyS-rNrcwDka13ADw",
    place: "Near Fernley, Nevada",
    shortName: "Fernley",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NV",
    state: "Nevada",
    difficulty: "classic",
    pools: ["world","North America","US","US-NV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nv-026",
    lat: 39.223589,
    lng: -119.597105,
    panoId: "6ouCfenk4y4Dt-qjJKty4g",
    place: "Near Dayton, Nevada",
    shortName: "Dayton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NV",
    state: "Nevada",
    difficulty: "classic",
    pools: ["world","North America","US","US-NV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nv-027",
    lat: 39.400368,
    lng: -119.223883,
    panoId: "5n2cIQiNB20oOPbyP6k_Zw",
    place: "Near Silver Springs, Nevada",
    shortName: "Silver Springs",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NV",
    state: "Nevada",
    difficulty: "classic",
    pools: ["world","North America","US","US-NV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nv-028",
    lat: 40.958615,
    lng: -117.717553,
    panoId: "8jRfYRIhWWut6y4Y0gGEew",
    place: "Near Winnemucca, Nevada",
    shortName: "Winnemucca",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NV",
    state: "Nevada",
    difficulty: "classic",
    pools: ["world","North America","US","US-NV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nv-029",
    lat: 40.818555,
    lng: -115.771893,
    panoId: "VHEwAck9kj2aBh5yqAM8rQ",
    place: "Near Elko, Nevada",
    shortName: "Elko",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NV",
    state: "Nevada",
    difficulty: "classic",
    pools: ["world","North America","US","US-NV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nv-030",
    lat: 39.691445,
    lng: -119.977035,
    panoId: "IJcHkT_SbfXAszPOw0THjA",
    place: "Near Cold Springs, Nevada",
    shortName: "Cold Springs",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NV",
    state: "Nevada",
    difficulty: "classic",
    pools: ["world","North America","US","US-NV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nv-031",
    lat: 36.212647,
    lng: -115.96831,
    panoId: "3Db6GHyRagCSnwV_qvaFYA",
    place: "Near Pahrump, Nevada",
    shortName: "Pahrump",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NV",
    state: "Nevada",
    difficulty: "classic",
    pools: ["world","North America","US","US-NV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nv-032",
    lat: 39.631189,
    lng: -119.687054,
    panoId: "z_8w70MaBbeCk64TBp5TKA",
    place: "Near Spanish Springs, Nevada",
    shortName: "Spanish Springs",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NV",
    state: "Nevada",
    difficulty: "classic",
    pools: ["world","North America","US","US-NV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nv-033",
    lat: 36.205321,
    lng: -115.957486,
    panoId: "BNc83KOPa5bSndXQ2WNNiw",
    place: "Near Pahrump, Nevada",
    shortName: "Pahrump",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NV",
    state: "Nevada",
    difficulty: "classic",
    pools: ["world","North America","US","US-NV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nv-034",
    lat: 38.939535,
    lng: -119.724997,
    panoId: "gMBe_EgtWAV0TQncCIU2NA",
    place: "Near Gardnerville, Nevada",
    shortName: "Gardnerville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NV",
    state: "Nevada",
    difficulty: "classic",
    pools: ["world","North America","US","US-NV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nv-035",
    lat: 39.589117,
    lng: -119.789249,
    panoId: "t1Rg_78wYNnHJDn4Iw80wQ",
    place: "Near Sun Valley, Nevada",
    shortName: "Sun Valley",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NV",
    state: "Nevada",
    difficulty: "classic",
    pools: ["world","North America","US","US-NV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nv-036",
    lat: 39.097879,
    lng: -119.75852,
    panoId: "u2GpZ4t8duaFW1CfMk_UDQ",
    place: "Near Indian Hills, Nevada",
    shortName: "Indian Hills",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NV",
    state: "Nevada",
    difficulty: "classic",
    pools: ["world","North America","US","US-NV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nv-037",
    lat: 39.656469,
    lng: -119.730162,
    panoId: "813nTP8apBgj4dDu_OXoYA",
    place: "Near Spanish Springs, Nevada",
    shortName: "Spanish Springs",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NV",
    state: "Nevada",
    difficulty: "classic",
    pools: ["world","North America","US","US-NV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nv-038",
    lat: 39.065389,
    lng: -119.766345,
    panoId: "ME1WQHgJq7Q3FtKlocq1Pg",
    place: "Near Indian Hills, Nevada",
    shortName: "Indian Hills",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NV",
    state: "Nevada",
    difficulty: "classic",
    pools: ["world","North America","US","US-NV"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "us-nv-039",
    lat: 39.448477,
    lng: -118.770835,
    panoId: "Uzw-OKd_E741jJrt3B2Sww",
    place: "Near Fallon, Nevada",
    shortName: "Fallon",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NV",
    state: "Nevada",
    difficulty: "classic",
    pools: ["world","North America","US","US-NV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nv-040",
    lat: 39.176662,
    lng: -119.73887,
    panoId: "eEOgJegSrR4LXhE1fd-7WA",
    place: "Near Carson City, Nevada",
    shortName: "Carson City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NV",
    state: "Nevada",
    difficulty: "classic",
    pools: ["world","North America","US","US-NV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nv-041",
    lat: 39.640389,
    lng: -119.828727,
    panoId: "8KahaO7jigSL4VngXTBpcA",
    place: "Near Lemmon Valley, Nevada",
    shortName: "Lemmon Valley",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NV",
    state: "Nevada",
    difficulty: "classic",
    pools: ["world","North America","US","US-NV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nv-042",
    lat: 39.089967,
    lng: -119.810937,
    panoId: "5IBSyxRr_6oqAzj5MKGJmw",
    place: "Near Indian Hills, Nevada",
    shortName: "Indian Hills",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NV",
    state: "Nevada",
    difficulty: "classic",
    pools: ["world","North America","US","US-NV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nv-043",
    lat: 39.037766,
    lng: -119.726298,
    panoId: "SK3vi9EkKdhAFtHPxvYrWA",
    place: "Near Johnson Lane, Nevada",
    shortName: "Johnson Lane",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NV",
    state: "Nevada",
    difficulty: "classic",
    pools: ["world","North America","US","US-NV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nv-044",
    lat: 38.975283,
    lng: -119.908069,
    panoId: "jDqhc93vWaxyD07zdeGJSg",
    place: "Near Kingsbury, Nevada",
    shortName: "Kingsbury",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NV",
    state: "Nevada",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nv-045",
    lat: 38.985658,
    lng: -119.16296,
    panoId: "CwP10oxv8v672ZIhab16vg",
    place: "Near Yerington, Nevada",
    shortName: "Yerington",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NV",
    state: "Nevada",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nv-046",
    lat: 40.179271,
    lng: -118.473301,
    panoId: "KQ8yPQLd0aY-gbiyA95yMw",
    place: "Near Lovelock, Nevada",
    shortName: "Lovelock",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NV",
    state: "Nevada",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nv-047",
    lat: 38.943437,
    lng: -119.700457,
    panoId: "Enl-6t47xXE6AzI_qR_Wew",
    place: "Near East Valley, Nevada",
    shortName: "East Valley",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NV",
    state: "Nevada",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nv-048",
    lat: 35.816433,
    lng: -115.630536,
    panoId: "k4d_OOjdrRN6ZbbSk523tw",
    place: "Near Sandy Valley, Nevada",
    shortName: "Sandy Valley",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NV",
    state: "Nevada",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nv-049",
    lat: 40.740117,
    lng: -114.073006,
    panoId: "r4Lm4uLU-fF6hZ_i4xpACQ",
    place: "Near West Wendover, Nevada",
    shortName: "West Wendover",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NV",
    state: "Nevada",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nv-050",
    lat: 39.373799,
    lng: -119.37427,
    panoId: "kCEkZYPCxSsulFaD8hO-lA",
    place: "Near Stagecoach, Nevada",
    shortName: "Stagecoach",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NV",
    state: "Nevada",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nv-051",
    lat: 38.783781,
    lng: -119.345791,
    panoId: "Hv_LP-8E2GErbUFapowNZQ",
    place: "Near Smith Valley, Nevada",
    shortName: "Smith Valley",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NV",
    state: "Nevada",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nv-052",
    lat: 38.06713,
    lng: -117.229975,
    panoId: "zWjSdEzqL4rWYfScvrTTkA",
    place: "Near Tonopah, Nevada",
    shortName: "Tonopah",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NV",
    state: "Nevada",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nv-053",
    lat: 38.734342,
    lng: -119.500347,
    panoId: "Z9jB-CfxqsKkVjsFm-VhDg",
    place: "Near Topaz Ranch Estates, Nevada",
    shortName: "Topaz Ranch Estates",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NV",
    state: "Nevada",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nv-054",
    lat: 38.524624,
    lng: -118.624627,
    panoId: "uN0fsggXxAESNNTj0bo1IQ",
    place: "Near Hawthorne, Nevada",
    shortName: "Hawthorne",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NV",
    state: "Nevada",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nv-055",
    lat: 40.641993,
    lng: -116.934397,
    panoId: "hqHz-hErY_Tt9C3-iya-2Q",
    place: "Near Battle Mountain, Nevada",
    shortName: "Battle Mountain",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NV",
    state: "Nevada",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nv-056",
    lat: 38.084988,
    lng: -117.247739,
    panoId: "OBp8GdVm7dVVeeoAOvuQuw",
    place: "Near Tonopah, Nevada",
    shortName: "Tonopah",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NV",
    state: "Nevada",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nv-057",
    lat: 40.72027,
    lng: -116.091492,
    panoId: "srWeKADpHUE-gYCYwf5WFQ",
    place: "Near Carlin, Nevada",
    shortName: "Carlin",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NV",
    state: "Nevada",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nv-058",
    lat: 38.97589,
    lng: -119.752109,
    panoId: "lqBqBC_DazfYchme7Zb9Uw",
    place: "Near Minden, Nevada",
    shortName: "Minden",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NV",
    state: "Nevada",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nv-059",
    lat: 39.379136,
    lng: -119.388487,
    panoId: "RaVaVoyEwk8h9cy8FdCVqA",
    place: "Near Stagecoach, Nevada",
    shortName: "Stagecoach",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NV",
    state: "Nevada",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nv-060",
    lat: 38.933547,
    lng: -119.673134,
    panoId: "2GyPGCcj6ofYq5C9f7GKPQ",
    place: "Near East Valley, Nevada",
    shortName: "East Valley",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NV",
    state: "Nevada",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nv-061",
    lat: 39.374739,
    lng: -119.338652,
    panoId: "hyxUIFpkbBoARn-AciYZYg",
    place: "Near Stagecoach, Nevada",
    shortName: "Stagecoach",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NV",
    state: "Nevada",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nv-062",
    lat: 39.161126,
    lng: -119.802975,
    panoId: "vineHZp_5_g_pjeK3kFQxw",
    place: "Near Carson City, Nevada",
    shortName: "Carson City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NV",
    state: "Nevada",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nv-063",
    lat: 39.440235,
    lng: -118.744155,
    panoId: "6q8OlZ-S8pc9tSYGhpJuYA",
    place: "Near Fallon, Nevada",
    shortName: "Fallon",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NV",
    state: "Nevada",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nv-064",
    lat: 39.54536,
    lng: -119.69199,
    panoId: "pffQZPJYwCao3ykEApHofg",
    place: "Near Sparks, Nevada",
    shortName: "Sparks",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NV",
    state: "Nevada",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nv-065",
    lat: 36.166768,
    lng: -115.172515,
    panoId: "P5t7DIfq_VDflt2RJyl2Dw",
    place: "Near Las Vegas, Nevada",
    shortName: "Las Vegas",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NV",
    state: "Nevada",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nv-066",
    lat: 40.747355,
    lng: -115.659151,
    panoId: "NS6xJPhDkelR6e-Q-yswEA",
    place: "Near Spring Creek, Nevada",
    shortName: "Spring Creek",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NV",
    state: "Nevada",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nv-067",
    lat: 39.005324,
    lng: -119.742886,
    panoId: "0Vl-YPrsd7Ovf4R6_u4GtA",
    place: "Near Johnson Lane, Nevada",
    shortName: "Johnson Lane",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NV",
    state: "Nevada",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NV"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "us-nv-068",
    lat: 40.684592,
    lng: -116.189028,
    panoId: "tMi8RU-3sgIS8thFnlyfIA",
    place: "Near Carlin, Nevada",
    shortName: "Carlin",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NV",
    state: "Nevada",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nv-069",
    lat: 39.03916,
    lng: -119.218407,
    panoId: "lQ8ELe4gz72GCd_FAt34Zg",
    place: "Near Yerington, Nevada",
    shortName: "Yerington",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NV",
    state: "Nevada",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nv-070",
    lat: 39.603408,
    lng: -119.850578,
    panoId: "hnLbj-wqd0FzsyuWxkuwVg",
    place: "Near Golden Valley, Nevada",
    shortName: "Golden Valley",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NV",
    state: "Nevada",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nv-071",
    lat: 39.475184,
    lng: -119.84631,
    panoId: "BIM3_oftwzCwA8ezsYcIpw",
    place: "Near Reno, Nevada",
    shortName: "Reno",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NV",
    state: "Nevada",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nv-072",
    lat: 40.710629,
    lng: -114.087007,
    panoId: "C9_yCPBoYb6uCOD4N-2EYw",
    place: "Near West Wendover, Nevada",
    shortName: "West Wendover",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NV",
    state: "Nevada",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nv-073",
    lat: 38.747573,
    lng: -119.522632,
    panoId: "YeqyGAVRXXTMlTIe58ywsg",
    place: "Near Topaz Ranch Estates, Nevada",
    shortName: "Topaz Ranch Estates",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NV",
    state: "Nevada",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nv-074",
    lat: 40.613993,
    lng: -116.871499,
    panoId: "Zsv3JU9WTEtZiagPvHhvMQ",
    place: "Near Battle Mountain, Nevada",
    shortName: "Battle Mountain",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NV",
    state: "Nevada",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nv-075",
    lat: 38.894788,
    lng: -119.779105,
    panoId: "SQM4Zi3bRYs6ccUZiL7cEQ",
    place: "Near Gardnerville Ranchos, Nevada",
    shortName: "Gardnerville Ranchos",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NV",
    state: "Nevada",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nv-076",
    lat: 39.694984,
    lng: -119.744545,
    panoId: "GHyNl4lKfto_ZyEhzkDI_w",
    place: "Near Spanish Springs, Nevada",
    shortName: "Spanish Springs",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NV",
    state: "Nevada",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nv-077",
    lat: 40.801946,
    lng: -115.833823,
    panoId: "Z_Z5oFGsFb5n90SBQ8U3UQ",
    place: "Near Elko, Nevada",
    shortName: "Elko",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NV",
    state: "Nevada",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nv-078",
    lat: 36.808572,
    lng: -114.018768,
    panoId: "ylr3psgEZhwc4UP6Mr4sgQ",
    place: "Near Scenic, Nevada",
    shortName: "Scenic",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NV",
    state: "Nevada",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nv-079",
    lat: 35.153079,
    lng: -114.528214,
    panoId: "ixeEJlsNUFR0WEGRaTwBlg",
    place: "Near Bullhead City, Nevada",
    shortName: "Bullhead City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NV",
    state: "Nevada",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nv-080",
    lat: 36.776694,
    lng: -114.057705,
    panoId: "rDP9TkQnd6yS7NUy8dz6Bw",
    place: "Near Mesquite, Nevada",
    shortName: "Mesquite",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NV",
    state: "Nevada",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nv-081",
    lat: 39.562733,
    lng: -119.737933,
    panoId: "CQruCDZvvqm26QBXZpgQtQ",
    place: "Near Sparks, Nevada",
    shortName: "Sparks",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NV",
    state: "Nevada",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nv-082",
    lat: 38.932185,
    lng: -119.803904,
    panoId: "FHMFfuCiyx9A67l_mZBK6w",
    place: "Near Minden, Nevada",
    shortName: "Minden",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NV",
    state: "Nevada",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nv-083",
    lat: 40.15272,
    lng: -118.494461,
    panoId: "FEV4HFmbjn8V5BGV1JAOqg",
    place: "Near Lovelock, Nevada",
    shortName: "Lovelock",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NV",
    state: "Nevada",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nv-084",
    lat: 39.618252,
    lng: -119.812465,
    panoId: "UC-Dh6mxtWz2USFrWYKk5g",
    place: "Near Golden Valley, Nevada",
    shortName: "Golden Valley",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NV",
    state: "Nevada",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nv-085",
    lat: 35.771169,
    lng: -115.585438,
    panoId: "Zoq0JK7kXnWLGQcJtNkuwA",
    place: "Near Sandy Valley, Nevada",
    shortName: "Sandy Valley",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NV",
    state: "Nevada",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nv-086",
    lat: 40.699471,
    lng: -116.172749,
    panoId: "cN8_Lt0NXMZW1JRzxPkbpQ",
    place: "Near Carlin, Nevada",
    shortName: "Carlin",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NV",
    state: "Nevada",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nv-087",
    lat: 39.55188,
    lng: -119.892944,
    panoId: "cwuE_G22jeenRd-AQ-e0Kw",
    place: "Near Mogul, Nevada",
    shortName: "Mogul",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NV",
    state: "Nevada",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NV"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-nv-088",
    lat: 39.647872,
    lng: -119.902044,
    panoId: "cApI0_WOhkieA3f8_khZnA",
    place: "Near Lemmon Valley, Nevada",
    shortName: "Lemmon Valley",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NV",
    state: "Nevada",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nv-089",
    lat: 36.156153,
    lng: -115.070696,
    panoId: "yF5yNEEHT_-NxwbRWB_PEQ",
    place: "Near Winchester, Nevada",
    shortName: "Winchester",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NV",
    state: "Nevada",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nv-090",
    lat: 37.641636,
    lng: -114.506421,
    panoId: "XbWJ-jodjEY4Ml79337v5Q",
    place: "Near Caliente, Nevada",
    shortName: "Caliente",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NV",
    state: "Nevada",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nv-091",
    lat: 38.968134,
    lng: -119.138573,
    panoId: "dVE9eEH8Xl3509xHQYt8XA",
    place: "Near Yerington, Nevada",
    shortName: "Yerington",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NV",
    state: "Nevada",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nv-092",
    lat: 38.741115,
    lng: -119.462613,
    panoId: "jMD0iRfZ_V1UMcxnyKNGZg",
    place: "Near Topaz Ranch Estates, Nevada",
    shortName: "Topaz Ranch Estates",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NV",
    state: "Nevada",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nv-093",
    lat: 36.691381,
    lng: -114.584854,
    panoId: "kyzvmNJy7hxXfRPRz4LYkw",
    place: "Near Moapa Town, Nevada",
    shortName: "Moapa Town",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NV",
    state: "Nevada",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nv-094",
    lat: 39.247443,
    lng: -114.888697,
    panoId: "WwwCyOMG0MBHkdZA-LXAgg",
    place: "Near Ely, Nevada",
    shortName: "Ely",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NV",
    state: "Nevada",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-NV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nv-095",
    lat: 38.062018,
    lng: -117.216291,
    panoId: "4LTdpFLzSd1SIBP1q96YoA",
    place: "Near Tonopah, Nevada",
    shortName: "Tonopah",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NV",
    state: "Nevada",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-NV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nv-096",
    lat: 39.291058,
    lng: -114.857462,
    panoId: "3w-fdCEYsRWFgV6M04xw9Q",
    place: "Near Ely, Nevada",
    shortName: "Ely",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NV",
    state: "Nevada",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-NV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nv-097",
    lat: 40.835944,
    lng: -114.2208,
    panoId: "m8yrASalmpa6KN-0i6MOmw",
    place: "Near West Wendover, Nevada",
    shortName: "West Wendover",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NV",
    state: "Nevada",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-NV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nv-098",
    lat: 36.652905,
    lng: -114.277571,
    panoId: "YfzTDCBmy1Q_xCq9M8yvGw",
    place: "Near Bunkerville, Nevada",
    shortName: "Bunkerville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NV",
    state: "Nevada",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-NV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nv-099",
    lat: 39.547979,
    lng: -119.043185,
    panoId: "oO7HuZuUUIXsjim_ZIaJeA",
    place: "Near Fernley, Nevada",
    shortName: "Fernley",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NV",
    state: "Nevada",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-NV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nh-000",
    lat: 42.995626,
    lng: -71.454782,
    panoId: "mLwkxsldo2b68i05trpivg",
    place: "Near Manchester, New Hampshire",
    shortName: "Manchester",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NH",
    state: "New Hampshire",
    difficulty: "classic",
    pools: ["world","North America","US","US-NH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nh-001",
    lat: 42.788481,
    lng: -71.200984,
    panoId: "V4gXHCBZ-9zK8WJ5wRyljw",
    place: "Near Salem, New Hampshire",
    shortName: "Salem",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NH",
    state: "New Hampshire",
    difficulty: "classic",
    pools: ["world","North America","US","US-NH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nh-002",
    lat: 42.89183,
    lng: -71.311717,
    panoId: "xnKPmYavbTGkAJB9-55xWg",
    place: "Near Derry Village, New Hampshire",
    shortName: "Derry Village",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NH",
    state: "New Hampshire",
    difficulty: "classic",
    pools: ["world","North America","US","US-NH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nh-003",
    lat: 43.146786,
    lng: -71.457555,
    panoId: "X71LCib5QvPk2WRMaIOong",
    place: "Near Pembroke, New Hampshire",
    shortName: "Pembroke",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NH",
    state: "New Hampshire",
    difficulty: "classic",
    pools: ["world","North America","US","US-NH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nh-004",
    lat: 43.222868,
    lng: -71.046941,
    panoId: "_cK0SblUM_8RvmVfNIW9dA",
    place: "Near Barrington, New Hampshire",
    shortName: "Barrington",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NH",
    state: "New Hampshire",
    difficulty: "classic",
    pools: ["world","North America","US","US-NH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nh-005",
    lat: 43.52774,
    lng: -71.47041,
    panoId: "3FTSbvC_0kxMpF-rv6GNug",
    place: "Near Laconia, New Hampshire",
    shortName: "Laconia",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NH",
    state: "New Hampshire",
    difficulty: "classic",
    pools: ["world","North America","US","US-NH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nh-006",
    lat: 43.094622,
    lng: -71.730522,
    panoId: "sMxbX_4zeRzdRp1xNabLqQ",
    place: "Near Weare, New Hampshire",
    shortName: "Weare",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NH",
    state: "New Hampshire",
    difficulty: "classic",
    pools: ["world","North America","US","US-NH"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "us-nh-007",
    lat: 44.468279,
    lng: -71.184336,
    panoId: "2px23KbpTRKXG7X91EBb2w",
    place: "Near Berlin, New Hampshire",
    shortName: "Berlin",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NH",
    state: "New Hampshire",
    difficulty: "classic",
    pools: ["world","North America","US","US-NH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nh-008",
    lat: 42.981632,
    lng: -70.947793,
    panoId: "lkXjqOAZLzk4x9L4EH_nhQ",
    place: "Near Exeter, New Hampshire",
    shortName: "Exeter",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NH",
    state: "New Hampshire",
    difficulty: "classic",
    pools: ["world","North America","US","US-NH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nh-009",
    lat: 42.836466,
    lng: -71.09493,
    panoId: "DNLvdum8YZV1JMj794fk-w",
    place: "Near Plaistow, New Hampshire",
    shortName: "Plaistow",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NH",
    state: "New Hampshire",
    difficulty: "classic",
    pools: ["world","North America","US","US-NH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nh-010",
    lat: 43.120726,
    lng: -71.511457,
    panoId: "ScWzza2GlvM0esKyoUDnLw",
    place: "Near Bow Bog, New Hampshire",
    shortName: "Bow Bog",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NH",
    state: "New Hampshire",
    difficulty: "classic",
    pools: ["world","North America","US","US-NH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nh-011",
    lat: 42.765425,
    lng: -71.467555,
    panoId: "zfp_Ymup7Bvd-03FWn3_xQ",
    place: "Near Nashua, New Hampshire",
    shortName: "Nashua",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NH",
    state: "New Hampshire",
    difficulty: "classic",
    pools: ["world","North America","US","US-NH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nh-012",
    lat: 43.261722,
    lng: -70.86533,
    panoId: "d3V60m3IjjDV3eBp-ooD2Q",
    place: "Near Somersworth, New Hampshire",
    shortName: "Somersworth",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NH",
    state: "New Hampshire",
    difficulty: "classic",
    pools: ["world","North America","US","US-NH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nh-013",
    lat: 43.208321,
    lng: -71.537637,
    panoId: "j8y4dclA_NqRl0LU8qATww",
    place: "Near Concord, New Hampshire",
    shortName: "Concord",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NH",
    state: "New Hampshire",
    difficulty: "classic",
    pools: ["world","North America","US","US-NH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nh-014",
    lat: 42.844128,
    lng: -71.479871,
    panoId: "rFc_UGrmJ6M502qKPy9ktA",
    place: "Near Litchfield, New Hampshire",
    shortName: "Litchfield",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NH",
    state: "New Hampshire",
    difficulty: "classic",
    pools: ["world","North America","US","US-NH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nh-015",
    lat: 43.376732,
    lng: -72.346727,
    panoId: "n4NBymwA0n9jLWc5tI3yHw",
    place: "Near Claremont, New Hampshire",
    shortName: "Claremont",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NH",
    state: "New Hampshire",
    difficulty: "classic",
    pools: ["world","North America","US","US-NH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nh-016",
    lat: 42.835316,
    lng: -71.649119,
    panoId: "3SAJc2qX4DctTZJ2DOIdWQ",
    place: "Near Milford, New Hampshire",
    shortName: "Milford",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NH",
    state: "New Hampshire",
    difficulty: "classic",
    pools: ["world","North America","US","US-NH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nh-017",
    lat: 42.734617,
    lng: -71.324362,
    panoId: "ovxgKbQdsxzz2N5bQIoxug",
    place: "Near Pelham, New Hampshire",
    shortName: "Pelham",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NH",
    state: "New Hampshire",
    difficulty: "classic",
    pools: ["world","North America","US","US-NH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nh-018",
    lat: 43.13395,
    lng: -70.926437,
    panoId: "wZGojrzAUapGQzNpK77wKA",
    place: "Near Durham, New Hampshire",
    shortName: "Durham",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NH",
    state: "New Hampshire",
    difficulty: "classic",
    pools: ["world","North America","US","US-NH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nh-019",
    lat: 42.946494,
    lng: -71.515864,
    panoId: "GKu1ph0H7wt0WlrhKkQeCQ",
    place: "Near Bedford, New Hampshire",
    shortName: "Bedford",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NH",
    state: "New Hampshire",
    difficulty: "classic",
    pools: ["world","North America","US","US-NH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nh-020",
    lat: 43.197886,
    lng: -70.873732,
    panoId: "gbHLjGfqsKPSuqYBX9_vXQ",
    place: "Near Dover, New Hampshire",
    shortName: "Dover",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NH",
    state: "New Hampshire",
    difficulty: "classic",
    pools: ["world","North America","US","US-NH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nh-021",
    lat: 42.894799,
    lng: -70.871199,
    panoId: "7ITlaVDro5I2RqErW8FimQ",
    place: "Near Seabrook, New Hampshire",
    shortName: "Seabrook",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NH",
    state: "New Hampshire",
    difficulty: "classic",
    pools: ["world","North America","US","US-NH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nh-022",
    lat: 43.641964,
    lng: -72.251715,
    panoId: "1fqtxVvCXfcyG4w5ISR6KQ",
    place: "Near Lebanon, New Hampshire",
    shortName: "Lebanon",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NH",
    state: "New Hampshire",
    difficulty: "classic",
    pools: ["world","North America","US","US-NH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nh-023",
    lat: 42.874463,
    lng: -71.181149,
    panoId: "kxFo278cGOmnIsipfYisJg",
    place: "Near Hampstead, New Hampshire",
    shortName: "Hampstead",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NH",
    state: "New Hampshire",
    difficulty: "classic",
    pools: ["world","North America","US","US-NH"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-nh-024",
    lat: 43.242124,
    lng: -71.53778,
    panoId: "kuuIF8FIgGQS7vCkiyR8vQ",
    place: "Near East Concord, New Hampshire",
    shortName: "East Concord",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NH",
    state: "New Hampshire",
    difficulty: "classic",
    pools: ["world","North America","US","US-NH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nh-025",
    lat: 42.865105,
    lng: -71.374059,
    panoId: "xvrKaPUDSBAdVEBNruY1Aw",
    place: "Near Londonderry, New Hampshire",
    shortName: "Londonderry",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NH",
    state: "New Hampshire",
    difficulty: "classic",
    pools: ["world","North America","US","US-NH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nh-026",
    lat: 43.548071,
    lng: -71.407197,
    panoId: "Uqp6nsqm3ilbkveSn4_K9w",
    place: "Near Gilford, New Hampshire",
    shortName: "Gilford",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NH",
    state: "New Hampshire",
    difficulty: "classic",
    pools: ["world","North America","US","US-NH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nh-027",
    lat: 42.743004,
    lng: -71.591658,
    panoId: "9E8Cd7THKC9Zk4CHHcNPaQ",
    place: "Near Hollis, New Hampshire",
    shortName: "Hollis",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NH",
    state: "New Hampshire",
    difficulty: "classic",
    pools: ["world","North America","US","US-NH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nh-028",
    lat: 42.865107,
    lng: -71.493479,
    panoId: "RxANXdqmiJHZdDGfqflvmA",
    place: "Near Merrimack, New Hampshire",
    shortName: "Merrimack",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NH",
    state: "New Hampshire",
    difficulty: "classic",
    pools: ["world","North America","US","US-NH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nh-029",
    lat: 42.800744,
    lng: -71.303935,
    panoId: "B4BmRz-G9ErwhrVJiQWzYQ",
    place: "Near Windham, New Hampshire",
    shortName: "Windham",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NH",
    state: "New Hampshire",
    difficulty: "classic",
    pools: ["world","North America","US","US-NH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nh-030",
    lat: 43.444306,
    lng: -71.64735,
    panoId: "BAhZjUfamOtSV8k3PBe-FA",
    place: "Near Franklin, New Hampshire",
    shortName: "Franklin",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NH",
    state: "New Hampshire",
    difficulty: "classic",
    pools: ["world","North America","US","US-NH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nh-031",
    lat: 43.077038,
    lng: -70.757667,
    panoId: "H19fo7a1PtHFPOK9ahS1sQ",
    place: "Near Portsmouth, New Hampshire",
    shortName: "Portsmouth",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NH",
    state: "New Hampshire",
    difficulty: "classic",
    pools: ["world","North America","US","US-NH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nh-032",
    lat: 42.880807,
    lng: -71.326987,
    panoId: "sPHIwbBmb5V0PPzEcE-g-A",
    place: "Near Derry, New Hampshire",
    shortName: "Derry",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NH",
    state: "New Hampshire",
    difficulty: "classic",
    pools: ["world","North America","US","US-NH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nh-033",
    lat: 43.702406,
    lng: -72.289547,
    panoId: "eN5Mb_b3FsyJVxVmsUviaQ",
    place: "Near Hanover, New Hampshire",
    shortName: "Hanover",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NH",
    state: "New Hampshire",
    difficulty: "classic",
    pools: ["world","North America","US","US-NH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nh-034",
    lat: 43.304348,
    lng: -70.975515,
    panoId: "BimyHwPwtjt3jQfyGFtqgw",
    place: "Near Rochester, New Hampshire",
    shortName: "Rochester",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NH",
    state: "New Hampshire",
    difficulty: "classic",
    pools: ["world","North America","US","US-NH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nh-035",
    lat: 42.93753,
    lng: -70.838877,
    panoId: "Y5SLh_elfb6exkTh83mbKA",
    place: "Near Hampton, New Hampshire",
    shortName: "Hampton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NH",
    state: "New Hampshire",
    difficulty: "classic",
    pools: ["world","North America","US","US-NH"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-nh-036",
    lat: 42.933728,
    lng: -72.278102,
    panoId: "RGJ4_uDzi6HL6n41XEpuSw",
    place: "Near Keene, New Hampshire",
    shortName: "Keene",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NH",
    state: "New Hampshire",
    difficulty: "classic",
    pools: ["world","North America","US","US-NH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nh-037",
    lat: 42.869977,
    lng: -72.282503,
    panoId: "lQd2Wh3uO5ufDFcz8FMBMw",
    place: "Near Swanzey, New Hampshire",
    shortName: "Swanzey",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NH",
    state: "New Hampshire",
    difficulty: "classic",
    pools: ["world","North America","US","US-NH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nh-038",
    lat: 42.764979,
    lng: -71.439967,
    panoId: "Yi7CaZKOdWYWu4Pnn7XNDQ",
    place: "Near Hudson, New Hampshire",
    shortName: "Hudson",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NH",
    state: "New Hampshire",
    difficulty: "classic",
    pools: ["world","North America","US","US-NH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nh-039",
    lat: 43.645495,
    lng: -72.280161,
    panoId: "fTWpzFj7GSBBJOXhqIB48g",
    place: "Near Lebanon, New Hampshire",
    shortName: "Lebanon",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NH",
    state: "New Hampshire",
    difficulty: "classic",
    pools: ["world","North America","US","US-NH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nh-040",
    lat: 42.751492,
    lng: -71.313827,
    panoId: "U5SLi-9MLlIyV_TPnWCegw",
    place: "Near Pelham, New Hampshire",
    shortName: "Pelham",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NH",
    state: "New Hampshire",
    difficulty: "classic",
    pools: ["world","North America","US","US-NH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nh-041",
    lat: 42.792813,
    lng: -71.330922,
    panoId: "mmbfDRTBBK5K3I1hvIMMlA",
    place: "Near Windham, New Hampshire",
    shortName: "Windham",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NH",
    state: "New Hampshire",
    difficulty: "classic",
    pools: ["world","North America","US","US-NH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nh-042",
    lat: 42.814681,
    lng: -71.638811,
    panoId: "q-3EK4WMdNST4W295BKrCA",
    place: "Near Milford, New Hampshire",
    shortName: "Milford",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NH",
    state: "New Hampshire",
    difficulty: "classic",
    pools: ["world","North America","US","US-NH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nh-043",
    lat: 43.428927,
    lng: -71.639022,
    panoId: "tg0y_8eQMB_C-wwDXBVwQA",
    place: "Near Franklin, New Hampshire",
    shortName: "Franklin",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NH",
    state: "New Hampshire",
    difficulty: "classic",
    pools: ["world","North America","US","US-NH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nh-044",
    lat: 42.755268,
    lng: -71.5666,
    panoId: "kFZCpiEpTr6VMMjJfnsh6g",
    place: "Near Hollis, New Hampshire",
    shortName: "Hollis",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NH",
    state: "New Hampshire",
    difficulty: "classic",
    pools: ["world","North America","US","US-NH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nh-045",
    lat: 43.146728,
    lng: -70.905305,
    panoId: "UhVXKE8YByEg7DQ2MlsgKg",
    place: "Near Durham, New Hampshire",
    shortName: "Durham",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NH",
    state: "New Hampshire",
    difficulty: "classic",
    pools: ["world","North America","US","US-NH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nh-046",
    lat: 42.947123,
    lng: -70.851169,
    panoId: "UAxgvOGIc5KUjj2gxkdx7A",
    place: "Near Hampton, New Hampshire",
    shortName: "Hampton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NH",
    state: "New Hampshire",
    difficulty: "classic",
    pools: ["world","North America","US","US-NH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nh-047",
    lat: 43.126618,
    lng: -71.54124,
    panoId: "MBtRpTjyFBmJsBV2M5fo7Q",
    place: "Near Bow Bog, New Hampshire",
    shortName: "Bow Bog",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NH",
    state: "New Hampshire",
    difficulty: "classic",
    pools: ["world","North America","US","US-NH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nh-048",
    lat: 43.314064,
    lng: -70.980631,
    panoId: "J9J-8VfoLjkdMHC79Pvp_w",
    place: "Near Rochester, New Hampshire",
    shortName: "Rochester",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NH",
    state: "New Hampshire",
    difficulty: "classic",
    pools: ["world","North America","US","US-NH"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-nh-049",
    lat: 43.190678,
    lng: -71.523011,
    panoId: "1ucVD3OM6HqtA4sUZEZ5pg",
    place: "Near Concord, New Hampshire",
    shortName: "Concord",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NH",
    state: "New Hampshire",
    difficulty: "classic",
    pools: ["world","North America","US","US-NH"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-nh-050",
    lat: 42.750604,
    lng: -71.397213,
    panoId: "DIant5seKQEtQW1ie4W4Yg",
    place: "Near Hudson, New Hampshire",
    shortName: "Hudson",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NH",
    state: "New Hampshire",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nh-051",
    lat: 43.219511,
    lng: -71.580985,
    panoId: "s0iJS7wQ1vE95-rpFtR8Ug",
    place: "Near Concord, New Hampshire",
    shortName: "Concord",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NH",
    state: "New Hampshire",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NH"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-nh-052",
    lat: 43.326528,
    lng: -70.887454,
    panoId: "LSgEN7408exQDnCZXQl6iQ",
    place: "Near Berwick, New Hampshire",
    shortName: "Berwick",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NH",
    state: "New Hampshire",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nh-053",
    lat: 42.781489,
    lng: -71.127088,
    panoId: "3GizMnUt8H-2wrSmBxY7_w",
    place: "Near Haverhill, New Hampshire",
    shortName: "Haverhill",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NH",
    state: "New Hampshire",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nh-054",
    lat: 42.916135,
    lng: -71.450456,
    panoId: "AQCWAcOH2wrnUJUmSMfaMQ",
    place: "Near East Merrimack, New Hampshire",
    shortName: "East Merrimack",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NH",
    state: "New Hampshire",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NH"],
    qualityTier: 4,
    verified: true,
  },
];

const CHUNK_3: GeoLocation[] = [
  {
    id: "us-nh-055",
    lat: 42.92097,
    lng: -71.466549,
    panoId: "n7GWUAPU6Muyk2l6VzUTLA",
    place: "Near Bedford, New Hampshire",
    shortName: "Bedford",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NH",
    state: "New Hampshire",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nh-056",
    lat: 43.285791,
    lng: -71.056641,
    panoId: "nCK5f2FyIJXf6CfLsGfqVA",
    place: "Near Rochester, New Hampshire",
    shortName: "Rochester",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NH",
    state: "New Hampshire",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nh-057",
    lat: 42.856232,
    lng: -71.430688,
    panoId: "0FvaeSTUSTv4Ljzjh_GOOw",
    place: "Near Litchfield, New Hampshire",
    shortName: "Litchfield",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NH",
    state: "New Hampshire",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nh-058",
    lat: 42.973084,
    lng: -70.864296,
    panoId: "b5kTouf8WT3Ex35AsZANkg",
    place: "Near North Hampton, New Hampshire",
    shortName: "North Hampton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NH",
    state: "New Hampshire",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nh-059",
    lat: 43.002622,
    lng: -70.912987,
    panoId: "x7Lzg3WO4aUcvw5AGxoOUw",
    place: "Near Exeter, New Hampshire",
    shortName: "Exeter",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NH",
    state: "New Hampshire",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nh-060",
    lat: 43.171713,
    lng: -71.567601,
    panoId: "b0d9jjG9ChDkB2nOTSAG3w",
    place: "Near Concord, New Hampshire",
    shortName: "Concord",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NH",
    state: "New Hampshire",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nh-061",
    lat: 42.833025,
    lng: -71.688189,
    panoId: "cE8nKKHaFOo-neqSppFRLQ",
    place: "Near Milford, New Hampshire",
    shortName: "Milford",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NH",
    state: "New Hampshire",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nh-062",
    lat: 43.07349,
    lng: -70.833775,
    panoId: "m8gWlXKeJ7zPM5FX9n27Fg",
    place: "Near Greenland, New Hampshire",
    shortName: "Greenland",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NH",
    state: "New Hampshire",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nh-063",
    lat: 42.708583,
    lng: -71.530832,
    panoId: "X6AcNQIS0SIOYcAfxkRjww",
    place: "Near Dunstable, New Hampshire",
    shortName: "Dunstable",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NH",
    state: "New Hampshire",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nh-064",
    lat: 43.380133,
    lng: -72.243413,
    panoId: "pjJXeZddH0tXKezvElEmWg",
    place: "Near Newport, New Hampshire",
    shortName: "Newport",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NH",
    state: "New Hampshire",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nh-065",
    lat: 43.162574,
    lng: -71.603774,
    panoId: "QYYCoSAR20NziaW5ZgOxgw",
    place: "Near Hopkinton, New Hampshire",
    shortName: "Hopkinton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NH",
    state: "New Hampshire",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NH"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-nh-066",
    lat: 42.804381,
    lng: -71.105289,
    panoId: "Wbn5dpEf3NtBncLgmP8ANg",
    place: "Near Plaistow, New Hampshire",
    shortName: "Plaistow",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NH",
    state: "New Hampshire",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nh-067",
    lat: 42.814277,
    lng: -71.39921,
    panoId: "V9IPGzd4ZXrwy1MNba4HoQ",
    place: "Near Londonderry, New Hampshire",
    shortName: "Londonderry",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NH",
    state: "New Hampshire",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nh-068",
    lat: 43.694459,
    lng: -72.236806,
    panoId: "ii4CYaQP9SR1YzxfEXztNQ",
    place: "Near Hanover, New Hampshire",
    shortName: "Hanover",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NH",
    state: "New Hampshire",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nh-069",
    lat: 43.056923,
    lng: -71.688744,
    panoId: "q1QoMsQ113XKWTn9wDKPkA",
    place: "Near Weare, New Hampshire",
    shortName: "Weare",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NH",
    state: "New Hampshire",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nh-070",
    lat: 42.809687,
    lng: -71.377822,
    panoId: "iSkVLukkMLL3lNwQuChN3w",
    place: "Near Windham, New Hampshire",
    shortName: "Windham",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NH",
    state: "New Hampshire",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nh-071",
    lat: 42.984249,
    lng: -71.502275,
    panoId: "kvcUpedcD4P46H_ATXcJxw",
    place: "Near Pinardville, New Hampshire",
    shortName: "Pinardville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NH",
    state: "New Hampshire",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nh-072",
    lat: 42.760164,
    lng: -71.300211,
    panoId: "sAuESsVFQ7bx9aX5xe0txw",
    place: "Near Pelham, New Hampshire",
    shortName: "Pelham",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NH",
    state: "New Hampshire",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nh-073",
    lat: 43.455536,
    lng: -71.563352,
    panoId: "25lG-7P4gSbFJzIKypIrTg",
    place: "Near Tilton, New Hampshire",
    shortName: "Tilton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NH",
    state: "New Hampshire",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nh-074",
    lat: 42.819343,
    lng: -71.4967,
    panoId: "H4vZxTavkkU3VTy61COu6w",
    place: "Near Litchfield, New Hampshire",
    shortName: "Litchfield",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NH",
    state: "New Hampshire",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nh-075",
    lat: 43.311856,
    lng: -70.861593,
    panoId: "XvN24zYZfXkyWxzWfU-81Q",
    place: "Near Berwick, New Hampshire",
    shortName: "Berwick",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NH",
    state: "New Hampshire",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nh-076",
    lat: 42.829165,
    lng: -71.550835,
    panoId: "2X-Vmo_hkavYSsA4SLHuiw",
    place: "Near Litchfield, New Hampshire",
    shortName: "Litchfield",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NH",
    state: "New Hampshire",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nh-077",
    lat: 43.186904,
    lng: -71.022868,
    panoId: "y_n1RhgxnHHX1-F1fNQfCQ",
    place: "Near Barrington, New Hampshire",
    shortName: "Barrington",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NH",
    state: "New Hampshire",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nh-078",
    lat: 43.256961,
    lng: -71.650512,
    panoId: "b3JqTOSSGw2OlC03RLs8Ag",
    place: "Near Contoocook, New Hampshire",
    shortName: "Contoocook",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NH",
    state: "New Hampshire",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nh-079",
    lat: 42.906876,
    lng: -70.914174,
    panoId: "lNYkZxrCBLZ1l_bS4rIpmw",
    place: "Near Kensington, New Hampshire",
    shortName: "Kensington",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NH",
    state: "New Hampshire",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nh-080",
    lat: 43.063326,
    lng: -70.805433,
    panoId: "hRManJikg3H5Ns0sAyrTMg",
    place: "Near Greenland, New Hampshire",
    shortName: "Greenland",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NH",
    state: "New Hampshire",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nh-081",
    lat: 42.904605,
    lng: -71.150589,
    panoId: "rwDlc8fafmMNxzVeSqsLsA",
    place: "Near Danville, New Hampshire",
    shortName: "Danville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NH",
    state: "New Hampshire",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NH"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-nh-082",
    lat: 44.336369,
    lng: -71.216235,
    panoId: "fZwpKOXyqyIBgbJ7ANC5UA",
    place: "Near Gorham, New Hampshire",
    shortName: "Gorham",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NH",
    state: "New Hampshire",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nh-083",
    lat: 43.700305,
    lng: -71.388394,
    panoId: "BQNZJlzyr54k4EY9JfcSTw",
    place: "Near Center Harbor, New Hampshire",
    shortName: "Center Harbor",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NH",
    state: "New Hampshire",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nh-084",
    lat: 42.944641,
    lng: -70.956994,
    panoId: "sMXWSYN5nXQQzwedChtKOw",
    place: "Near Kensington, New Hampshire",
    shortName: "Kensington",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NH",
    state: "New Hampshire",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nh-085",
    lat: 42.675574,
    lng: -71.236506,
    panoId: "qVsS6MKxk-0EeD_yCjIojA",
    place: "Near Dracut, New Hampshire",
    shortName: "Dracut",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NH",
    state: "New Hampshire",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nh-086",
    lat: 42.804263,
    lng: -72.364875,
    panoId: "52HoAKO8gNwsHo0mV6ktPA",
    place: "Near Winchester, New Hampshire",
    shortName: "Winchester",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NH",
    state: "New Hampshire",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nh-087",
    lat: 43.076308,
    lng: -71.612571,
    panoId: "M25fWw6JIOED8KOzMCaytA",
    place: "Near Goffstown, New Hampshire",
    shortName: "Goffstown",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NH",
    state: "New Hampshire",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nh-088",
    lat: 43.606975,
    lng: -72.392875,
    panoId: "vnDfTJ3gp9lRPJqmzwFC0A",
    place: "Near Hartford, New Hampshire",
    shortName: "Hartford",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NH",
    state: "New Hampshire",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nh-089",
    lat: 42.627658,
    lng: -71.279246,
    panoId: "dkWTSolozdUAguLdohbF-A",
    place: "Near Lowell, New Hampshire",
    shortName: "Lowell",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NH",
    state: "New Hampshire",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nh-090",
    lat: 42.866558,
    lng: -71.29446,
    panoId: "LSNnTTyLNGAwRpTtpA_jQA",
    place: "Near Derry, New Hampshire",
    shortName: "Derry",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NH",
    state: "New Hampshire",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nh-091",
    lat: 42.897038,
    lng: -71.225032,
    panoId: "ffwGQCxAtmHw2PZrqVjzhQ",
    place: "Near Hampstead, New Hampshire",
    shortName: "Hampstead",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NH",
    state: "New Hampshire",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nh-092",
    lat: 43.139537,
    lng: -70.865598,
    panoId: "iwR2jULpZmlsNm6b7P_Ddg",
    place: "Near Durham, New Hampshire",
    shortName: "Durham",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NH",
    state: "New Hampshire",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nh-093",
    lat: 43.530027,
    lng: -71.600282,
    panoId: "s34Qc7CWbYE2zM6eW_QRyA",
    place: "Near Sanbornton, New Hampshire",
    shortName: "Sanbornton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NH",
    state: "New Hampshire",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nh-094",
    lat: 42.870271,
    lng: -71.006563,
    panoId: "pMCx_lsifBMRQz4BUsIQiA",
    place: "Near Newton, New Hampshire",
    shortName: "Newton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NH",
    state: "New Hampshire",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NH"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-nh-095",
    lat: 42.901294,
    lng: -71.724134,
    panoId: "S24ODDh71X0W8OU9R5xNyQ",
    place: "Near Lyndeborough, New Hampshire",
    shortName: "Lyndeborough",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NH",
    state: "New Hampshire",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nh-096",
    lat: 42.819421,
    lng: -72.361374,
    panoId: "XdX9P0AVCSkdbAyZur3ulw",
    place: "Near Winchester, New Hampshire",
    shortName: "Winchester",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NH",
    state: "New Hampshire",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nh-097",
    lat: 42.623932,
    lng: -71.765934,
    panoId: "CQYuE_gcQAhWiRpmKeTnCQ",
    place: "Near Lunenburg, New Hampshire",
    shortName: "Lunenburg",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NH",
    state: "New Hampshire",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nh-098",
    lat: 43.069788,
    lng: -71.340406,
    panoId: "6eOq2G1fGgq_eXKNsat57Q",
    place: "Near Candia, New Hampshire",
    shortName: "Candia",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NH",
    state: "New Hampshire",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nh-099",
    lat: 43.466597,
    lng: -72.386401,
    panoId: "L2wt8VLWgorrWPKaiCW5dQ",
    place: "Near Windsor, New Hampshire",
    shortName: "Windsor",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NH",
    state: "New Hampshire",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nh-100",
    lat: 43.706507,
    lng: -71.178169,
    panoId: "uMHvuHGp4D6D_90e4tkzxQ",
    place: "Near Tuftonboro, New Hampshire",
    shortName: "Tuftonboro",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NH",
    state: "New Hampshire",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-NH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nh-101",
    lat: 43.471005,
    lng: -71.218922,
    panoId: "6dyLMFYUclFkzBhwLvCKUQ",
    place: "Near New Durham, New Hampshire",
    shortName: "New Durham",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NH",
    state: "New Hampshire",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-NH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nh-102",
    lat: 43.147062,
    lng: -71.234899,
    panoId: "RZAL4MyGPZcuPGwGyy2cyQ",
    place: "Near Candia, New Hampshire",
    shortName: "Candia",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NH",
    state: "New Hampshire",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-NH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nh-103",
    lat: 44.186089,
    lng: -72.051247,
    panoId: "e-3nYPGSEJlPSflerExB1A",
    place: "Near Woodsville, New Hampshire",
    shortName: "Woodsville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NH",
    state: "New Hampshire",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-NH"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-nh-104",
    lat: 43.166954,
    lng: -71.248626,
    panoId: "qICiqD37m0LF7BhhWiGIgg",
    place: "Near Northwood, New Hampshire",
    shortName: "Northwood",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NH",
    state: "New Hampshire",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-NH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nh-105",
    lat: 43.653733,
    lng: -70.96971,
    panoId: "cKQZbZtxJ7AJEFU0nc7qBw",
    place: "Near Parsonsfield, New Hampshire",
    shortName: "Parsonsfield",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NH",
    state: "New Hampshire",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-NH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nj-000",
    lat: 40.231494,
    lng: -74.671522,
    panoId: "Ysm-QDThFvzELLOyr3pnaA",
    place: "Near Mercerville-Hamilton Square, New Jersey",
    shortName: "Mercerville-Hamilton Square",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NJ",
    state: "New Jersey",
    difficulty: "classic",
    pools: ["world","North America","US","US-NJ"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-nj-001",
    lat: 40.916745,
    lng: -74.171656,
    panoId: "IIpowIyCOUv2Vhp7KVCojQ",
    place: "Near Paterson, New Jersey",
    shortName: "Paterson",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NJ",
    state: "New Jersey",
    difficulty: "classic",
    pools: ["world","North America","US","US-NJ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nj-002",
    lat: 40.518501,
    lng: -74.411818,
    panoId: "RYNr_oYxeJOep9uc46h6YQ",
    place: "Near Edison, New Jersey",
    shortName: "Edison",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NJ",
    state: "New Jersey",
    difficulty: "classic",
    pools: ["world","North America","US","US-NJ"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-nj-003",
    lat: 40.348765,
    lng: -74.658865,
    panoId: "j_B7lBNnInEWsDsQ89rLdA",
    place: "Near Princeton, New Jersey",
    shortName: "Princeton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NJ",
    state: "New Jersey",
    difficulty: "classic",
    pools: ["world","North America","US","US-NJ"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-nj-004",
    lat: 39.925941,
    lng: -75.119613,
    panoId: "_oM0c_iPm9ZaZKMS9ks4gA",
    place: "Near Camden, New Jersey",
    shortName: "Camden",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NJ",
    state: "New Jersey",
    difficulty: "classic",
    pools: ["world","North America","US","US-NJ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nj-005",
    lat: 41.131212,
    lng: -74.367509,
    panoId: "wFA3CtjHyVEZ7BoU4QWRTQ",
    place: "Near West Milford, New Jersey",
    shortName: "West Milford",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NJ",
    state: "New Jersey",
    difficulty: "classic",
    pools: ["world","North America","US","US-NJ"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "us-nj-006",
    lat: 40.600713,
    lng: -74.648171,
    panoId: "5WMq8Xpq6PJeSY6eT6Ersw",
    place: "Near Bridgewater, New Jersey",
    shortName: "Bridgewater",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NJ",
    state: "New Jersey",
    difficulty: "classic",
    pools: ["world","North America","US","US-NJ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nj-007",
    lat: 40.88602,
    lng: -74.043611,
    panoId: "ncgMOJ3itZFh3y7eYZPs6g",
    place: "Near Hackensack, New Jersey",
    shortName: "Hackensack",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NJ",
    state: "New Jersey",
    difficulty: "classic",
    pools: ["world","North America","US","US-NJ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nj-008",
    lat: 39.953665,
    lng: -74.19776,
    panoId: "V-5KC6UGxQ6jFw5TjIbXGA",
    place: "Near Toms River, New Jersey",
    shortName: "Toms River",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NJ",
    state: "New Jersey",
    difficulty: "classic",
    pools: ["world","North America","US","US-NJ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nj-009",
    lat: 39.364164,
    lng: -74.423062,
    panoId: "eaxESna0-tIWt7vPazDwpA",
    place: "Near Atlantic City, New Jersey",
    shortName: "Atlantic City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NJ",
    state: "New Jersey",
    difficulty: "classic",
    pools: ["world","North America","US","US-NJ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nj-010",
    lat: 40.41471,
    lng: -74.365361,
    panoId: "9k-grk9JEbdQVjVomngYLw",
    place: "Near Old Bridge, New Jersey",
    shortName: "Old Bridge",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NJ",
    state: "New Jersey",
    difficulty: "classic",
    pools: ["world","North America","US","US-NJ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nj-011",
    lat: 39.4019,
    lng: -75.039286,
    panoId: "d_nhbaDTY1Ssfdvtc4GWIA",
    place: "Near Millville, New Jersey",
    shortName: "Millville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NJ",
    state: "New Jersey",
    difficulty: "classic",
    pools: ["world","North America","US","US-NJ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nj-012",
    lat: 40.73565,
    lng: -74.172336,
    panoId: "svv8ZhLchTZ-z3seIEjP_w",
    place: "Near Newark, New Jersey",
    shortName: "Newark",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NJ",
    state: "New Jersey",
    difficulty: "classic",
    pools: ["world","North America","US","US-NJ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nj-013",
    lat: 40.454329,
    lng: -74.48211,
    panoId: "WWxz6uVRoYO145X1Kyu0Pw",
    place: "Near North Brunswick, New Jersey",
    shortName: "North Brunswick",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NJ",
    state: "New Jersey",
    difficulty: "classic",
    pools: ["world","North America","US","US-NJ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nj-014",
    lat: 39.486169,
    lng: -75.025703,
    panoId: "62qDZeTXVmx7uq8im5f2hA",
    place: "Near Vineland, New Jersey",
    shortName: "Vineland",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NJ",
    state: "New Jersey",
    difficulty: "classic",
    pools: ["world","North America","US","US-NJ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nj-015",
    lat: 40.304262,
    lng: -74.100414,
    panoId: "cbvFB4MD6MYerpzREmNYXA",
    place: "Near Tinton Falls, New Jersey",
    shortName: "Tinton Falls",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NJ",
    state: "New Jersey",
    difficulty: "classic",
    pools: ["world","North America","US","US-NJ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nj-016",
    lat: 40.706241,
    lng: -74.549325,
    panoId: "xih5rASmA7gorEKHCNrk_A",
    place: "Near Basking Ridge, New Jersey",
    shortName: "Basking Ridge",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NJ",
    state: "New Jersey",
    difficulty: "classic",
    pools: ["world","North America","US","US-NJ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nj-017",
    lat: 40.477615,
    lng: -74.626868,
    panoId: "saZp0Th5xhBBjwAL3vST4Q",
    place: "Near Hillsborough, New Jersey",
    shortName: "Hillsborough",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NJ",
    state: "New Jersey",
    difficulty: "classic",
    pools: ["world","North America","US","US-NJ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nj-018",
    lat: 40.486163,
    lng: -74.451866,
    panoId: "lEr2_DxygGX-prHQtfCPDA",
    place: "Near New Brunswick, New Jersey",
    shortName: "New Brunswick",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NJ",
    state: "New Jersey",
    difficulty: "classic",
    pools: ["world","North America","US","US-NJ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nj-019",
    lat: 40.408213,
    lng: -74.354338,
    panoId: "NuEPeYVXQhPxrv8fnziDKg",
    place: "Near South Old Bridge, New Jersey",
    shortName: "South Old Bridge",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NJ",
    state: "New Jersey",
    difficulty: "classic",
    pools: ["world","North America","US","US-NJ"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-nj-020",
    lat: 40.66393,
    lng: -74.210799,
    panoId: "f3dCof-L2yNPw2iI27Z4aA",
    place: "Near Elizabeth, New Jersey",
    shortName: "Elizabeth",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NJ",
    state: "New Jersey",
    difficulty: "classic",
    pools: ["world","North America","US","US-NJ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nj-021",
    lat: 39.389848,
    lng: -74.524004,
    panoId: "-_uORkwVddUqA4bmTawX5g",
    place: "Near Pleasantville, New Jersey",
    shortName: "Pleasantville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NJ",
    state: "New Jersey",
    difficulty: "classic",
    pools: ["world","North America","US","US-NJ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nj-022",
    lat: 40.315456,
    lng: -74.246385,
    panoId: "NZUqC4-OKkYvM98ZqEBbzg",
    place: "Near Marlboro, New Jersey",
    shortName: "Marlboro",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NJ",
    state: "New Jersey",
    difficulty: "classic",
    pools: ["world","North America","US","US-NJ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nj-023",
    lat: 40.499084,
    lng: -74.399028,
    panoId: "LU4mDWuYq9BOFLn_rIwDzQ",
    place: "Near Piscataway, New Jersey",
    shortName: "Piscataway",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NJ",
    state: "New Jersey",
    difficulty: "classic",
    pools: ["world","North America","US","US-NJ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nj-024",
    lat: 40.45921,
    lng: -74.361009,
    panoId: "ahlS5_8N4z1ZVkBw5Tb1WQ",
    place: "Near Sayreville, New Jersey",
    shortName: "Sayreville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NJ",
    state: "New Jersey",
    difficulty: "classic",
    pools: ["world","North America","US","US-NJ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nj-025",
    lat: 40.849105,
    lng: -74.582305,
    panoId: "x3GeyP66o6oVC3DDqyIwGA",
    place: "Near Randolph, New Jersey",
    shortName: "Randolph",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NJ",
    state: "New Jersey",
    difficulty: "classic",
    pools: ["world","North America","US","US-NJ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nj-026",
    lat: 40.097792,
    lng: -74.217627,
    panoId: "Ua5JCzKrl_r6rANgKkRXgQ",
    place: "Near Lakewood, New Jersey",
    shortName: "Lakewood",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NJ",
    state: "New Jersey",
    difficulty: "classic",
    pools: ["world","North America","US","US-NJ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nj-027",
    lat: 39.44605,
    lng: -75.028775,
    panoId: "5a3ATr7aXbFynb-0WHi_Sw",
    place: "Near South Vineland, New Jersey",
    shortName: "South Vineland",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NJ",
    state: "New Jersey",
    difficulty: "classic",
    pools: ["world","North America","US","US-NJ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nj-028",
    lat: 40.497298,
    lng: -74.488049,
    panoId: "rjnKQE2bQ4hxwsGL71FsWQ",
    place: "Near Somerset, New Jersey",
    shortName: "Somerset",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NJ",
    state: "New Jersey",
    difficulty: "classic",
    pools: ["world","North America","US","US-NJ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nj-029",
    lat: 41.033623,
    lng: -74.638832,
    panoId: "WUcdxfdSNkCWYs7_40CkOw",
    place: "Near Sparta, New Jersey",
    shortName: "Sparta",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NJ",
    state: "New Jersey",
    difficulty: "classic",
    pools: ["world","North America","US","US-NJ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nj-030",
    lat: 40.059282,
    lng: -74.137109,
    panoId: "Jn6Kgq5tfSQrvceeGADD7A",
    place: "Near Brick, New Jersey",
    shortName: "Brick",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NJ",
    state: "New Jersey",
    difficulty: "classic",
    pools: ["world","North America","US","US-NJ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nj-031",
    lat: 40.21708,
    lng: -74.742956,
    panoId: "NsLIZzNu6o-IMIlXvrwtcA",
    place: "Near Trenton, New Jersey",
    shortName: "Trenton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NJ",
    state: "New Jersey",
    difficulty: "classic",
    pools: ["world","North America","US","US-NJ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nj-032",
    lat: 39.427338,
    lng: -75.23399,
    panoId: "MAkCsh3_d_eFzHHoRcovaw",
    place: "Near Bridgeton, New Jersey",
    shortName: "Bridgeton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NJ",
    state: "New Jersey",
    difficulty: "classic",
    pools: ["world","North America","US","US-NJ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nj-033",
    lat: 40.269859,
    lng: -74.799955,
    panoId: "64Wr61OB4ILa97eKoyQa7A",
    place: "Near Ewing, New Jersey",
    shortName: "Ewing",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NJ",
    state: "New Jersey",
    difficulty: "classic",
    pools: ["world","North America","US","US-NJ"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-nj-034",
    lat: 39.909311,
    lng: -74.154889,
    panoId: "2BnAn8m-n7KYXQDe6_4mrQ",
    place: "Near Bayville, New Jersey",
    shortName: "Bayville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NJ",
    state: "New Jersey",
    difficulty: "classic",
    pools: ["world","North America","US","US-NJ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nj-035",
    lat: 40.082984,
    lng: -74.068086,
    panoId: "LBMMZ0XGlRNQlYPib1gqgA",
    place: "Near Point Pleasant, New Jersey",
    shortName: "Point Pleasant",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NJ",
    state: "New Jersey",
    difficulty: "classic",
    pools: ["world","North America","US","US-NJ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nj-036",
    lat: 40.743826,
    lng: -74.090328,
    panoId: "lBJsKPjPaOizw2WgbdCqMA",
    place: "Near Jersey City, New Jersey",
    shortName: "Jersey City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NJ",
    state: "New Jersey",
    difficulty: "classic",
    pools: ["world","North America","US","US-NJ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nj-037",
    lat: 39.946335,
    lng: -74.212788,
    panoId: "h5ZSumHUkmzcNvHe2luXyA",
    place: "Near South Toms River, New Jersey",
    shortName: "South Toms River",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NJ",
    state: "New Jersey",
    difficulty: "classic",
    pools: ["world","North America","US","US-NJ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nj-038",
    lat: 39.91717,
    lng: -75.140987,
    panoId: "aCDMXKPC3QgvKeW1JSTbbw",
    place: "Near Whitman, New Jersey",
    shortName: "Whitman",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NJ",
    state: "New Jersey",
    difficulty: "classic",
    pools: ["world","North America","US","US-NJ"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-nj-039",
    lat: 39.379557,
    lng: -74.408651,
    panoId: "ofbW1Vhmg3cuol5t1VpnKw",
    place: "Near Atlantic City, New Jersey",
    shortName: "Atlantic City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NJ",
    state: "New Jersey",
    difficulty: "classic",
    pools: ["world","North America","US","US-NJ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nj-040",
    lat: 39.389836,
    lng: -74.509586,
    panoId: "jHL9GEDuURrnVG5dzblcyw",
    place: "Near Pleasantville, New Jersey",
    shortName: "Pleasantville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NJ",
    state: "New Jersey",
    difficulty: "classic",
    pools: ["world","North America","US","US-NJ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nj-041",
    lat: 40.369292,
    lng: -74.652714,
    panoId: "YiCQYGR7V6c9ne_pyzkBYg",
    place: "Near Princeton, New Jersey",
    shortName: "Princeton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NJ",
    state: "New Jersey",
    difficulty: "classic",
    pools: ["world","North America","US","US-NJ"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-nj-042",
    lat: 40.237493,
    lng: -74.697235,
    panoId: "KcjSSoSyXm7jCribDIFOvQ",
    place: "Near Mercerville, New Jersey",
    shortName: "Mercerville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NJ",
    state: "New Jersey",
    difficulty: "classic",
    pools: ["world","North America","US","US-NJ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nj-043",
    lat: 40.27998,
    lng: -74.774929,
    panoId: "UAPBno72kifQwjiBO2G0Kg",
    place: "Near Ewing, New Jersey",
    shortName: "Ewing",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NJ",
    state: "New Jersey",
    difficulty: "classic",
    pools: ["world","North America","US","US-NJ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nj-044",
    lat: 39.923811,
    lng: -74.140769,
    panoId: "rCrBCIXVRB7zjzCfdJ2Lgg",
    place: "Near Ocean Gate, New Jersey",
    shortName: "Ocean Gate",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NJ",
    state: "New Jersey",
    difficulty: "classic",
    pools: ["world","North America","US","US-NJ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nj-045",
    lat: 40.108487,
    lng: -74.209265,
    panoId: "0Ia4qlAlBGn5a96vUh00Zg",
    place: "Near Lakewood, New Jersey",
    shortName: "Lakewood",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NJ",
    state: "New Jersey",
    difficulty: "classic",
    pools: ["world","North America","US","US-NJ"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-nj-046",
    lat: 40.065731,
    lng: -74.063424,
    panoId: "h9PfSf2D4HBYliMZsnJoTA",
    place: "Near Point Pleasant, New Jersey",
    shortName: "Point Pleasant",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NJ",
    state: "New Jersey",
    difficulty: "classic",
    pools: ["world","North America","US","US-NJ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nj-047",
    lat: 39.434657,
    lng: -75.222125,
    panoId: "ywxgj7Z2uaHOSVDcPq7Kkw",
    place: "Near Bridgeton, New Jersey",
    shortName: "Bridgeton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NJ",
    state: "New Jersey",
    difficulty: "classic",
    pools: ["world","North America","US","US-NJ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nj-048",
    lat: 40.071823,
    lng: -74.125483,
    panoId: "hEhn26FMBv2pN7daVf97mQ",
    place: "Near Brick, New Jersey",
    shortName: "Brick",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NJ",
    state: "New Jersey",
    difficulty: "classic",
    pools: ["world","North America","US","US-NJ"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-nj-049",
    lat: 39.449548,
    lng: -75.004583,
    panoId: "BgzVF5JFFvNqVSpeLaUIJA",
    place: "Near South Vineland, New Jersey",
    shortName: "South Vineland",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NJ",
    state: "New Jersey",
    difficulty: "classic",
    pools: ["world","North America","US","US-NJ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nj-050",
    lat: 40.852879,
    lng: -74.516549,
    panoId: "IzTue7RfhPDbpfbQa3xSCA",
    place: "Near Victory Gardens, New Jersey",
    shortName: "Victory Gardens",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NJ",
    state: "New Jersey",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NJ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nj-051",
    lat: 41.131169,
    lng: -74.27815,
    panoId: "mxX5fd7r8Cd6F4KXgysztQ",
    place: "Near Ringwood, New Jersey",
    shortName: "Ringwood",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NJ",
    state: "New Jersey",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NJ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nj-052",
    lat: 40.36423,
    lng: -74.376226,
    panoId: "rxqDJ3apfva2-r6HQg-SXg",
    place: "Near Spotswood, New Jersey",
    shortName: "Spotswood",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NJ",
    state: "New Jersey",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NJ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nj-053",
    lat: 40.466949,
    lng: -74.561953,
    panoId: "q5LFPqxvK252LFNyQgVn5Q",
    place: "Near Franklin Park, New Jersey",
    shortName: "Franklin Park",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NJ",
    state: "New Jersey",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NJ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nj-054",
    lat: 40.497975,
    lng: -74.545912,
    panoId: "LwrPsWGBcRVMm5zMFwcCWQ",
    place: "Near Middlebush, New Jersey",
    shortName: "Middlebush",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NJ",
    state: "New Jersey",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NJ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nj-055",
    lat: 40.407867,
    lng: -74.30297,
    panoId: "dUV5u32ZKr1-Cw6khvf3Dg",
    place: "Near Brownville, New Jersey",
    shortName: "Brownville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NJ",
    state: "New Jersey",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NJ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nj-056",
    lat: 40.46971,
    lng: -74.544449,
    panoId: "FW6mJ-fhnYgGywDzfB7RSw",
    place: "Near Sixmile Run, New Jersey",
    shortName: "Sixmile Run",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NJ",
    state: "New Jersey",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NJ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nj-057",
    lat: 40.260666,
    lng: -74.216819,
    panoId: "vIesmOQ50vQryp2OE2Q14A",
    place: "Near East Freehold, New Jersey",
    shortName: "East Freehold",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NJ",
    state: "New Jersey",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NJ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nj-058",
    lat: 40.627725,
    lng: -74.656356,
    panoId: "vrES5mXlNSrsysXPE786ug",
    place: "Near Bridgewater, New Jersey",
    shortName: "Bridgewater",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NJ",
    state: "New Jersey",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NJ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nj-059",
    lat: 40.372899,
    lng: -74.32557,
    panoId: "PH8apYEBwdWMBXcuB4XXbA",
    place: "Near Brownville, New Jersey",
    shortName: "Brownville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NJ",
    state: "New Jersey",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NJ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nj-060",
    lat: 40.978291,
    lng: -74.622495,
    panoId: "eOvEGrgtwde48nwmXf9ygQ",
    place: "Near Lake Hopatcong, New Jersey",
    shortName: "Lake Hopatcong",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NJ",
    state: "New Jersey",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NJ"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-nj-061",
    lat: 39.474999,
    lng: -74.943622,
    panoId: "ERNooDTzXaRIapWO9jwqkQ",
    place: "Near Buena, New Jersey",
    shortName: "Buena",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NJ",
    state: "New Jersey",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NJ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nj-062",
    lat: 40.390168,
    lng: -74.64541,
    panoId: "dmMZ-c82hVK8gYxjsG_UFA",
    place: "Near Kingston, New Jersey",
    shortName: "Kingston",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NJ",
    state: "New Jersey",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NJ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nj-063",
    lat: 39.963842,
    lng: -74.084657,
    panoId: "oTHKxDOizfS6w00-jlCLZw",
    place: "Near Dover Beaches South, New Jersey",
    shortName: "Dover Beaches South",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NJ",
    state: "New Jersey",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NJ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nj-064",
    lat: 40.202123,
    lng: -74.829213,
    panoId: "g5zszYbUr3yUUZvdw1dP5w",
    place: "Near Fairless Hills, New Jersey",
    shortName: "Fairless Hills",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NJ",
    state: "New Jersey",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NJ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nj-065",
    lat: 40.657015,
    lng: -74.555918,
    panoId: "NECPHy2Wnls5mft2FCkisg",
    place: "Near Basking Ridge, New Jersey",
    shortName: "Basking Ridge",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NJ",
    state: "New Jersey",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NJ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nj-066",
    lat: 39.511296,
    lng: -75.004283,
    panoId: "2Pg4hbh5KRwJhu2e-uiM-Q",
    place: "Near Vineland, New Jersey",
    shortName: "Vineland",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NJ",
    state: "New Jersey",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NJ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nj-067",
    lat: 39.34293,
    lng: -74.996038,
    panoId: "dZNRUPIXnWmmbjgeNhVWxg",
    place: "Near Laurel Lake, New Jersey",
    shortName: "Laurel Lake",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NJ",
    state: "New Jersey",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NJ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nj-068",
    lat: 40.788837,
    lng: -74.546936,
    panoId: "MamLCrdzpS6CQ3DSPilzOA",
    place: "Near Mendham, New Jersey",
    shortName: "Mendham",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NJ",
    state: "New Jersey",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NJ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nj-069",
    lat: 40.445776,
    lng: -74.670389,
    panoId: "1r0nTwRloaOMaPbFZLgIQA",
    place: "Near Hillsborough, New Jersey",
    shortName: "Hillsborough",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NJ",
    state: "New Jersey",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NJ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nj-070",
    lat: 40.900525,
    lng: -74.727331,
    panoId: "DG07B3cfOJc1v9hi7dDGyw",
    place: "Near Stanhope, New Jersey",
    shortName: "Stanhope",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NJ",
    state: "New Jersey",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NJ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nj-071",
    lat: 40.771619,
    lng: -74.105177,
    panoId: "OVZrmD2rq8SdufbUD19L0A",
    place: "Near North Arlington, New Jersey",
    shortName: "North Arlington",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NJ",
    state: "New Jersey",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NJ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nj-072",
    lat: 40.117529,
    lng: -74.303397,
    panoId: "JFnBrZni-X_FQSEYivCKmA",
    place: "Near Vista Center, New Jersey",
    shortName: "Vista Center",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NJ",
    state: "New Jersey",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NJ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nj-073",
    lat: 40.406311,
    lng: -74.450911,
    panoId: "5QTubpn6qaS0p8TL6aA7mg",
    place: "Near East Brunswick, New Jersey",
    shortName: "East Brunswick",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NJ",
    state: "New Jersey",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NJ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nj-074",
    lat: 40.529098,
    lng: -74.491759,
    panoId: "d95R-YhR7I3QIcPHKR6T2g",
    place: "Near Society Hill, New Jersey",
    shortName: "Society Hill",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NJ",
    state: "New Jersey",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NJ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nj-075",
    lat: 40.222695,
    lng: -74.863619,
    panoId: "wDQ1BtMltn6XJrNjfOVlfQ",
    place: "Near Woodside, New Jersey",
    shortName: "Woodside",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NJ",
    state: "New Jersey",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NJ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nj-076",
    lat: 40.765751,
    lng: -74.472735,
    panoId: "Oh5L3wv4hx4wnK0DL5pjdw",
    place: "Near Morristown, New Jersey",
    shortName: "Morristown",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NJ",
    state: "New Jersey",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NJ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nj-077",
    lat: 41.155016,
    lng: -74.336999,
    panoId: "_xmWLy8IWH42-uqMwG2-IA",
    place: "Near West Milford, New Jersey",
    shortName: "West Milford",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NJ",
    state: "New Jersey",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NJ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nj-078",
    lat: 39.688715,
    lng: -74.244303,
    panoId: "1pAf5U3PMqkMypuzp-rOng",
    place: "Near Manahawkin, New Jersey",
    shortName: "Manahawkin",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NJ",
    state: "New Jersey",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NJ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nj-079",
    lat: 39.636897,
    lng: -74.765868,
    panoId: "pQcy7Ecw84X_D8g9sYK8uA",
    place: "Near Hammonton, New Jersey",
    shortName: "Hammonton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NJ",
    state: "New Jersey",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NJ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nj-080",
    lat: 39.465841,
    lng: -75.057432,
    panoId: "wi-3XkJRAvVYrzoO3ubmcQ",
    place: "Near South Vineland, New Jersey",
    shortName: "South Vineland",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NJ",
    state: "New Jersey",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NJ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nj-081",
    lat: 41.092364,
    lng: -74.6903,
    panoId: "3zVL5JwDf4AI4nl3hBv_IA",
    place: "Near Newton, New Jersey",
    shortName: "Newton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NJ",
    state: "New Jersey",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NJ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nj-082",
    lat: 39.417513,
    lng: -75.093604,
    panoId: "Zc6yaxEYHmi2z20OABOcxQ",
    place: "Near Millville, New Jersey",
    shortName: "Millville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NJ",
    state: "New Jersey",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NJ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nj-083",
    lat: 40.227126,
    lng: -74.613798,
    panoId: "iJjtktMhGYiTV2gkdHuTpQ",
    place: "Near Robbinsville, New Jersey",
    shortName: "Robbinsville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NJ",
    state: "New Jersey",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NJ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nj-084",
    lat: 40.291455,
    lng: -74.598773,
    panoId: "VIwsJwcDLTxvBG0IaX2b0Q",
    place: "Near Princeton Junction, New Jersey",
    shortName: "Princeton Junction",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NJ",
    state: "New Jersey",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NJ"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-nj-085",
    lat: 39.997526,
    lng: -74.200946,
    panoId: "d3bQh6wgehZbXvytXl0B_g",
    place: "Near Pine Lake Park, New Jersey",
    shortName: "Pine Lake Park",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NJ",
    state: "New Jersey",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NJ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nj-086",
    lat: 39.378508,
    lng: -75.204755,
    panoId: "valvJo-81B_v4SJP-ilNpQ",
    place: "Near Fairton, New Jersey",
    shortName: "Fairton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NJ",
    state: "New Jersey",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NJ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nj-087",
    lat: 39.619271,
    lng: -75.415504,
    panoId: "iKs77RsmsHvsWd-xVNCTgw",
    place: "Near Salem, New Jersey",
    shortName: "Salem",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NJ",
    state: "New Jersey",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NJ"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-nj-088",
    lat: 39.966339,
    lng: -74.617283,
    panoId: "Hb-HimaaOyD3ALiaPoDQ_Q",
    place: "Near Browns Mills, New Jersey",
    shortName: "Browns Mills",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NJ",
    state: "New Jersey",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NJ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nj-089",
    lat: 40.562632,
    lng: -75.249691,
    panoId: "gB5Kau-2WEQMSHqOo05uTg",
    place: "Near Hellertown, New Jersey",
    shortName: "Hellertown",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NJ",
    state: "New Jersey",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NJ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nj-090",
    lat: 39.467885,
    lng: -74.534867,
    panoId: "v7akUntxnYueLDgMan2JaA",
    place: "Near Pomona, New Jersey",
    shortName: "Pomona",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NJ",
    state: "New Jersey",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NJ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nj-091",
    lat: 40.852083,
    lng: -74.670603,
    panoId: "fH_vUvWdRYTlN8vGSYUSJw",
    place: "Near Succasunna, New Jersey",
    shortName: "Succasunna",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NJ",
    state: "New Jersey",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NJ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nj-092",
    lat: 39.907098,
    lng: -74.308765,
    panoId: "REiMmSR5d7WcI0MM0wdpwQ",
    place: "Near Pine Ridge at Crestwood, New Jersey",
    shortName: "Pine Ridge at Crestwood",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NJ",
    state: "New Jersey",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NJ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nj-093",
    lat: 41.131432,
    lng: -74.761626,
    panoId: "VXIwhD4VJOUt0L5JjBqneA",
    place: "Near Crandon Lakes, New Jersey",
    shortName: "Crandon Lakes",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NJ",
    state: "New Jersey",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NJ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nj-094",
    lat: 40.103568,
    lng: -74.631067,
    panoId: "EKDf7KBZ08FRvyflLqtq-w",
    place: "Near Groveville, New Jersey",
    shortName: "Groveville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NJ",
    state: "New Jersey",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NJ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nj-095",
    lat: 40.189918,
    lng: -74.122722,
    panoId: "WP1ROrGRLXwmOyQA0DGRtA",
    place: "Near Farmingdale, New Jersey",
    shortName: "Farmingdale",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NJ",
    state: "New Jersey",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NJ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nj-096",
    lat: 40.230173,
    lng: -74.206664,
    panoId: "3OBp8VjvcGVxVCyyQvBV-Q",
    place: "Near Farmingdale, New Jersey",
    shortName: "Farmingdale",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NJ",
    state: "New Jersey",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NJ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nj-097",
    lat: 39.908575,
    lng: -74.615783,
    panoId: "FJf36NkVKu7LTpBQQfXntA",
    place: "Near Presidential Lakes Estates, New Jersey",
    shortName: "Presidential Lakes Estates",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NJ",
    state: "New Jersey",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NJ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nj-098",
    lat: 40.156555,
    lng: -74.227065,
    panoId: "mC7pUN3wjQoGPOVaftRmXQ",
    place: "Near Lakewood, New Jersey",
    shortName: "Lakewood",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NJ",
    state: "New Jersey",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NJ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nj-099",
    lat: 40.228374,
    lng: -74.254684,
    panoId: "3UPBJqnnA4asoFvBPhL9cg",
    place: "Near Freehold, New Jersey",
    shortName: "Freehold",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NJ",
    state: "New Jersey",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NJ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nj-100",
    lat: 39.530164,
    lng: -74.665025,
    panoId: "ammmEREvS2-A0q-yrxcEeg",
    place: "Near Egg Harbor City, New Jersey",
    shortName: "Egg Harbor City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NJ",
    state: "New Jersey",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-NJ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nj-101",
    lat: 40.053321,
    lng: -74.457041,
    panoId: "SO6oJIUXkQKw_bO2dlcd1A",
    place: "Near New Egypt, New Jersey",
    shortName: "New Egypt",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NJ",
    state: "New Jersey",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-NJ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nj-102",
    lat: 39.388773,
    lng: -74.674612,
    panoId: "EpTTeQfQxmMcTOPT5kvm_A",
    place: "Near Estell Manor, New Jersey",
    shortName: "Estell Manor",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NJ",
    state: "New Jersey",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-NJ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nj-103",
    lat: 40.181249,
    lng: -74.428514,
    panoId: "o4V1q9yO1u4U5e-rwYdQpA",
    place: "Near Shrewsbury, New Jersey",
    shortName: "Shrewsbury",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NJ",
    state: "New Jersey",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-NJ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nj-104",
    lat: 40.050779,
    lng: -74.505378,
    panoId: "GV-1stA0FmPm7Pnlioa8Gw",
    place: "Near New Egypt, New Jersey",
    shortName: "New Egypt",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NJ",
    state: "New Jersey",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-NJ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nj-105",
    lat: 40.151442,
    lng: -74.501167,
    panoId: "ubS7L9Gqwbe2P12b7t29BQ",
    place: "Near Shrewsbury, New Jersey",
    shortName: "Shrewsbury",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NJ",
    state: "New Jersey",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-NJ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nm-000",
    lat: 32.3123,
    lng: -106.778337,
    panoId: "evCPDuvYEDdvhUv-9GPFqw",
    place: "Near Las Cruces, New Mexico",
    shortName: "Las Cruces",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "classic",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nm-001",
    lat: 36.728093,
    lng: -108.218678,
    panoId: "FgP5AZtensYVrp-NZyg7TA",
    place: "Near Farmington, New Mexico",
    shortName: "Farmington",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "classic",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nm-002",
    lat: 35.593786,
    lng: -105.223827,
    panoId: "jM5OJP13YYPCWjtwkKG4ag",
    place: "Near Las Vegas, New Mexico",
    shortName: "Las Vegas",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "classic",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nm-003",
    lat: 35.300045,
    lng: -106.55112,
    panoId: "4XQiUWLyI0piDj1O75v1wQ",
    place: "Near Bernalillo, New Mexico",
    shortName: "Bernalillo",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "classic",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-nm-004",
    lat: 32.943953,
    lng: -103.348529,
    panoId: "XbvLN6ZxJ_VKXrZMkzjUCg",
    place: "Near Lovington, New Mexico",
    shortName: "Lovington",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "classic",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nm-005",
    lat: 32.702633,
    lng: -103.136219,
    panoId: "XqUaRKT3pO9l0VfAixSNJw",
    place: "Near Hobbs, New Mexico",
    shortName: "Hobbs",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "classic",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nm-006",
    lat: 36.700755,
    lng: -108.037337,
    panoId: "Dxtpl-lb-3KUeGMt9h0ZJw",
    place: "Near Lee Acres, New Mexico",
    shortName: "Lee Acres",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "classic",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nm-007",
    lat: 32.420688,
    lng: -104.228938,
    panoId: "8XGAz5Ah0pNp0c63M4FfFA",
    place: "Near Carlsbad, New Mexico",
    shortName: "Carlsbad",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "classic",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nm-008",
    lat: 33.331737,
    lng: -105.673096,
    panoId: "ucsWwKx6UVZXziLChAZGpA",
    place: "Near Ruidoso, New Mexico",
    shortName: "Ruidoso",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "classic",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nm-009",
    lat: 35.171817,
    lng: -103.726807,
    panoId: "A1ybRPtpN_Nl9R1l2uXe_g",
    place: "Near Tucumcari, New Mexico",
    shortName: "Tucumcari",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "classic",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nm-010",
    lat: 34.404904,
    lng: -103.205243,
    panoId: "KI4II8EBNn66-mBZoOPAfQ",
    place: "Near Clovis, New Mexico",
    shortName: "Clovis",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "classic",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nm-011",
    lat: 34.806032,
    lng: -106.733528,
    panoId: "gvHlNTv3LPNbw6H4jKXd7w",
    place: "Near Los Lunas, New Mexico",
    shortName: "Los Lunas",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "classic",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nm-012",
    lat: 35.072449,
    lng: -108.851022,
    panoId: "93PpbaVQjPdxYTWr386OuQ",
    place: "Near Zuni Pueblo, New Mexico",
    shortName: "Zuni Pueblo",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "classic",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nm-013",
    lat: 32.842241,
    lng: -104.40334,
    panoId: "3HN4W0kUZ1bmarSasA_AoQ",
    place: "Near Artesia, New Mexico",
    shortName: "Artesia",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "classic",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nm-014",
    lat: 34.725772,
    lng: -106.757247,
    panoId: "0scu5gE5C_aAK-kgRAPy6g",
    place: "Near Los Chavez, New Mexico",
    shortName: "Los Chavez",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "classic",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nm-015",
    lat: 35.991163,
    lng: -106.080573,
    panoId: "t8iHgyk66biCWzFT4InGgw",
    place: "Near Española, New Mexico",
    shortName: "Española",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "classic",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nm-016",
    lat: 35.084471,
    lng: -106.651092,
    panoId: "N5EDLfj0w22Mbu_CEwLNyA",
    place: "Near Albuquerque, New Mexico",
    shortName: "Albuquerque",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "classic",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nm-017",
    lat: 36.734211,
    lng: -108.359846,
    panoId: "8H7iHt6qPf9YuSjMVGti7A",
    place: "Near Kirtland, New Mexico",
    shortName: "Kirtland",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "classic",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nm-018",
    lat: 34.662798,
    lng: -106.776453,
    panoId: "0iUA2rnjBEXc9c_smunJdA",
    place: "Near Belen, New Mexico",
    shortName: "Belen",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "classic",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nm-019",
    lat: 36.822098,
    lng: -107.992385,
    panoId: "92KHgPl51T6ib_3vZdF9fg",
    place: "Near Aztec, New Mexico",
    shortName: "Aztec",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "classic",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nm-020",
    lat: 36.785547,
    lng: -108.687421,
    panoId: "0nifNXNJDBD1flacTaqKRg",
    place: "Near Shiprock, New Mexico",
    shortName: "Shiprock",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "classic",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nm-021",
    lat: 33.394239,
    lng: -104.524886,
    panoId: "ji9HJuu1xiJGwjg0TzJQ4A",
    place: "Near Roswell, New Mexico",
    shortName: "Roswell",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "classic",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nm-022",
    lat: 34.058494,
    lng: -106.891457,
    panoId: "HcN1TRToE6wDWpTDtWSetQ",
    place: "Near Socorro, New Mexico",
    shortName: "Socorro",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "classic",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nm-023",
    lat: 32.770066,
    lng: -108.280269,
    panoId: "xeOHrPJP2qISNPB013eGnA",
    place: "Near Silver City, New Mexico",
    shortName: "Silver City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "classic",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nm-024",
    lat: 36.407241,
    lng: -105.572965,
    panoId: "2MyTuIpP2Jgl9cltBPwc3g",
    place: "Near Taos, New Mexico",
    shortName: "Taos",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "classic",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nm-025",
    lat: 33.128483,
    lng: -107.252856,
    panoId: "xypkVsGJIAi367SaBo9_xA",
    place: "Near Truth or Consequences, New Mexico",
    shortName: "Truth or Consequences",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "classic",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nm-026",
    lat: 35.686889,
    lng: -105.937831,
    panoId: "Ou9MkFlt4JXfbNImfcnsUA",
    place: "Near Santa Fe, New Mexico",
    shortName: "Santa Fe",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "classic",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nm-027",
    lat: 35.526335,
    lng: -105.934932,
    panoId: "ekAzt2iAWrASkhs2uTxnUg",
    place: "Near Eldorado at Santa Fe, New Mexico",
    shortName: "Eldorado at Santa Fe",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "classic",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nm-028",
    lat: 36.7111,
    lng: -107.984445,
    panoId: "GaTHVEURd11EdrukajDUOA",
    place: "Near Bloomfield, New Mexico",
    shortName: "Bloomfield",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "classic",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nm-029",
    lat: 35.827549,
    lng: -106.203868,
    panoId: "80zFPsF16b-id-JHhkx-3w",
    place: "Near White Rock, New Mexico",
    shortName: "White Rock",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "classic",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nm-030",
    lat: 35.528125,
    lng: -108.742557,
    panoId: "51mK1HbQDGF1AT8tIG6s6w",
    place: "Near Gallup, New Mexico",
    shortName: "Gallup",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "classic",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nm-031",
    lat: 32.899564,
    lng: -105.960281,
    panoId: "6JSjBS-g-CcS8bD1eCXBEw",
    place: "Near Alamogordo, New Mexico",
    shortName: "Alamogordo",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "classic",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nm-032",
    lat: 34.186076,
    lng: -103.334376,
    panoId: "2RHnCgIVosRNBjsOTWzy5w",
    place: "Near Portales, New Mexico",
    shortName: "Portales",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "classic",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nm-033",
    lat: 32.268696,
    lng: -107.758594,
    panoId: "0KATemzHwRstoy3jlzsnXw",
    place: "Near Deming, New Mexico",
    shortName: "Deming",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "classic",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nm-034",
    lat: 35.148829,
    lng: -107.849669,
    panoId: "Y05YXrl1vcXjYCxR4WA-gw",
    place: "Near Grants, New Mexico",
    shortName: "Grants",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "classic",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nm-035",
    lat: 36.903357,
    lng: -104.439153,
    panoId: "3RE_xvHx4dR_6oNnmFQR4w",
    place: "Near Raton, New Mexico",
    shortName: "Raton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "classic",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nm-036",
    lat: 34.728211,
    lng: -106.736277,
    panoId: "FnF9e56c-sgqv9PseUC9Kg",
    place: "Near Tome, New Mexico",
    shortName: "Tome",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "classic",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nm-037",
    lat: 33.133229,
    lng: -107.278119,
    panoId: "Qj_WGp2nemI8va5u_cz-xQ",
    place: "Near Truth or Consequences, New Mexico",
    shortName: "Truth or Consequences",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "classic",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nm-038",
    lat: 32.71977,
    lng: -103.126709,
    panoId: "AyB7Qdkg-ycrMKbHrPtbsw",
    place: "Near Hobbs, New Mexico",
    shortName: "Hobbs",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "classic",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nm-039",
    lat: 36.710831,
    lng: -108.237783,
    panoId: "YiZg2V5A3jTIJWBlRBpPBQ",
    place: "Near Farmington, New Mexico",
    shortName: "Farmington",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "classic",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nm-040",
    lat: 35.513462,
    lng: -105.941109,
    panoId: "i7-UqR0d2K78X5URYIZ3TA",
    place: "Near Eldorado at Santa Fe, New Mexico",
    shortName: "Eldorado at Santa Fe",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "classic",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nm-041",
    lat: 32.776738,
    lng: -108.301148,
    panoId: "9L59zIBsZ0rgMG5y4htpNA",
    place: "Near Silver City, New Mexico",
    shortName: "Silver City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "classic",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nm-042",
    lat: 35.288766,
    lng: -106.547583,
    panoId: "qmRl68925AW902DS41T8VA",
    place: "Near Bernalillo, New Mexico",
    shortName: "Bernalillo",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "classic",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nm-043",
    lat: 32.407336,
    lng: -104.253678,
    panoId: "vLEcVDKPEy-Pm4F6LjVA8w",
    place: "Near Carlsbad, New Mexico",
    shortName: "Carlsbad",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "classic",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nm-044",
    lat: 36.74571,
    lng: -108.381936,
    panoId: "X01U9lgVYd2Av6PoMyALjw",
    place: "Near Kirtland, New Mexico",
    shortName: "Kirtland",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "classic",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nm-045",
    lat: 35.59047,
    lng: -105.237243,
    panoId: "VlhBsciujo4sSkvqVOfRAQ",
    place: "Near Las Vegas, New Mexico",
    shortName: "Las Vegas",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "classic",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nm-046",
    lat: 33.348106,
    lng: -105.683458,
    panoId: "hntxF8u-f8VTSvQnXjdIrQ",
    place: "Near Ruidoso, New Mexico",
    shortName: "Ruidoso",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "classic",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nm-047",
    lat: 35.706365,
    lng: -105.939059,
    panoId: "roRWSG5tAsjE-DtXgVSTjg",
    place: "Near Santa Fe, New Mexico",
    shortName: "Santa Fe",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "classic",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nm-048",
    lat: 35.846264,
    lng: -106.216195,
    panoId: "rxNoZJKrHrJVl7mc7DoJNA",
    place: "Near White Rock, New Mexico",
    shortName: "White Rock",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "classic",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nm-049",
    lat: 34.422737,
    lng: -103.181233,
    panoId: "57Up65Sic-Keezzi32zFAw",
    place: "Near Clovis, New Mexico",
    shortName: "Clovis",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "classic",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nm-050",
    lat: 34.649587,
    lng: -106.733997,
    panoId: "DDRxlo8tLIF5hQ7nhoHlsA",
    place: "Near Rio Communities, New Mexico",
    shortName: "Rio Communities",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nm-051",
    lat: 35.563222,
    lng: -106.131132,
    panoId: "rRhIQvfnMW3o7FZaY9IGMQ",
    place: "Near La Cienega, New Mexico",
    shortName: "La Cienega",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nm-052",
    lat: 32.283528,
    lng: -106.753456,
    panoId: "uLpDk8xVu7A-7dZeGAedWQ",
    place: "Near University Park, New Mexico",
    shortName: "University Park",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nm-053",
    lat: 32.319285,
    lng: -106.85744,
    panoId: "jg3ABeZ21hrXiwHQi9F0gg",
    place: "Near San Ysidro, New Mexico",
    shortName: "San Ysidro",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nm-054",
    lat: 35.051143,
    lng: -106.690107,
    panoId: "hDp_O5w_FkkzQ5StBn2ZKQ",
    place: "Near South Valley, New Mexico",
    shortName: "South Valley",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nm-055",
    lat: 35.868681,
    lng: -106.194978,
    panoId: "lmKUFmFr3WFwi9KKCUDGhw",
    place: "Near White Rock, New Mexico",
    shortName: "White Rock",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nm-056",
    lat: 32.275461,
    lng: -107.715557,
    panoId: "sb0fwKsxftzzrXNtIIaoNQ",
    place: "Near Deming, New Mexico",
    shortName: "Deming",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nm-057",
    lat: 34.171419,
    lng: -103.252435,
    panoId: "LrGkiJi6hM2BJjpmQeHpEg",
    place: "Near Portales, New Mexico",
    shortName: "Portales",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nm-058",
    lat: 35.080259,
    lng: -108.806859,
    panoId: "nI3PCwFshQKYU__TdoZ3fA",
    place: "Near Black Rock, New Mexico",
    shortName: "Black Rock",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nm-059",
    lat: 33.426732,
    lng: -104.507071,
    panoId: "l8nEWYjfuXG3SRTyRW2wYA",
    place: "Near Roswell, New Mexico",
    shortName: "Roswell",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nm-060",
    lat: 32.871546,
    lng: -104.371068,
    panoId: "3jVFIZske1EU-VfX47JYnw",
    place: "Near Artesia, New Mexico",
    shortName: "Artesia",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nm-061",
    lat: 36.956858,
    lng: -104.386692,
    panoId: "eAYXU_1iuLkNKQHoW7zqhQ",
    place: "Near Raton, New Mexico",
    shortName: "Raton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nm-062",
    lat: 35.837475,
    lng: -106.36263,
    panoId: "WtYhz7IW5ZoYv6XWpl1G0Q",
    place: "Near Los Alamos, New Mexico",
    shortName: "Los Alamos",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nm-063",
    lat: 36.458029,
    lng: -105.622204,
    panoId: "j5BdVDz3XqKpz62kS2g-9Q",
    place: "Near Taos, New Mexico",
    shortName: "Taos",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nm-064",
    lat: 35.508023,
    lng: -106.098535,
    panoId: "-IzEh9sG7KXJScWwPlvS7A",
    place: "Near La Cienega, New Mexico",
    shortName: "La Cienega",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nm-065",
    lat: 35.594522,
    lng: -105.136158,
    panoId: "NollOXyR3UYB_mcQoO1MNA",
    place: "Near Las Vegas, New Mexico",
    shortName: "Las Vegas",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nm-066",
    lat: 32.886773,
    lng: -103.304458,
    panoId: "o4-LEepfqfp28qNK1Gq3-Q",
    place: "Near Lovington, New Mexico",
    shortName: "Lovington",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nm-067",
    lat: 32.926192,
    lng: -105.943189,
    panoId: "RRw2ulWbbIRB7nORqgSvYw",
    place: "Near Alamogordo, New Mexico",
    shortName: "Alamogordo",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nm-068",
    lat: 34.67805,
    lng: -106.735117,
    panoId: "LMXmfGXvnO0xLgoJQa-uYA",
    place: "Near Rio Communities, New Mexico",
    shortName: "Rio Communities",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nm-069",
    lat: 32.768465,
    lng: -108.199006,
    panoId: "I30az2Fc0eJpng-BmvtOwg",
    place: "Near Arenas Valley, New Mexico",
    shortName: "Arenas Valley",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nm-070",
    lat: 35.19749,
    lng: -103.679499,
    panoId: "DWdH1y3ybBkOc2cqfGBujA",
    place: "Near Tucumcari, New Mexico",
    shortName: "Tucumcari",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nm-071",
    lat: 33.397509,
    lng: -105.704117,
    panoId: "TeQsxEEBRLUnhNCHrTbD7Q",
    place: "Near Ruidoso, New Mexico",
    shortName: "Ruidoso",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nm-072",
    lat: 35.146244,
    lng: -107.791653,
    panoId: "cRkE06vGl6JrwNdPFKxdMw",
    place: "Near Grants, New Mexico",
    shortName: "Grants",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nm-073",
    lat: 36.736979,
    lng: -107.943728,
    panoId: "fiPipNSxkoIXB0DCn9Gy_A",
    place: "Near Bloomfield, New Mexico",
    shortName: "Bloomfield",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nm-074",
    lat: 36.684365,
    lng: -107.998844,
    panoId: "ToPi1Z67H6Ko_1PK5Fa6AA",
    place: "Near Bloomfield, New Mexico",
    shortName: "Bloomfield",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nm-075",
    lat: 34.823298,
    lng: -106.701574,
    panoId: "vOyY_OdTZ-csphV9OZ251g",
    place: "Near Peralta, New Mexico",
    shortName: "Peralta",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nm-076",
    lat: 35.946942,
    lng: -106.069562,
    panoId: "M3RWXFafD9Obf8OaIpQVHA",
    place: "Near La Mesilla, New Mexico",
    shortName: "La Mesilla",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nm-077",
    lat: 34.703772,
    lng: -106.735702,
    panoId: "xp9kxmqstmybVryVnKyM3w",
    place: "Near Los Chavez, New Mexico",
    shortName: "Los Chavez",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nm-078",
    lat: 32.295533,
    lng: -107.728909,
    panoId: "G8ALNkUK9ph20ryQ7J2XAA",
    place: "Near Keeler Farm, New Mexico",
    shortName: "Keeler Farm",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nm-079",
    lat: 32.297287,
    lng: -106.691758,
    panoId: "-qPx26Jwi93IzxWuVauHbw",
    place: "Near University Park, New Mexico",
    shortName: "University Park",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nm-080",
    lat: 32.253927,
    lng: -106.743493,
    panoId: "MUL1c-kryRyZ-rBS-VdTVA",
    place: "Near University Park, New Mexico",
    shortName: "University Park",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nm-081",
    lat: 34.089708,
    lng: -106.887255,
    panoId: "jyfc8BXWmqFmR-tZ3b0MWw",
    place: "Near Socorro, New Mexico",
    shortName: "Socorro",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nm-082",
    lat: 36.468278,
    lng: -105.593574,
    panoId: "AH1VjQzzqdgd4AJR9BKyGA",
    place: "Near Taos Pueblo, New Mexico",
    shortName: "Taos Pueblo",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nm-083",
    lat: 35.672967,
    lng: -105.970635,
    panoId: "Dyw9rJTtwH6TEEwu0h1OHQ",
    place: "Near Santa Fe, New Mexico",
    shortName: "Santa Fe",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "us-nm-084",
    lat: 35.615999,
    lng: -106.114664,
    panoId: "mbtVP9sP7Upl9JKOCORG8Q",
    place: "Near La Cienega, New Mexico",
    shortName: "La Cienega",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nm-085",
    lat: 33.373486,
    lng: -104.578754,
    panoId: "q02X3rAkShtZ3BzHClXZKw",
    place: "Near Roswell, New Mexico",
    shortName: "Roswell",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nm-086",
    lat: 35.034755,
    lng: -106.203622,
    panoId: "JEmYOt_2EM74wCY9P3iWrg",
    place: "Near Edgewood, New Mexico",
    shortName: "Edgewood",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nm-087",
    lat: 33.175033,
    lng: -107.264397,
    panoId: "qXufmGJ78tVTXLOA6J2fRQ",
    place: "Near Truth or Consequences, New Mexico",
    shortName: "Truth or Consequences",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nm-088",
    lat: 32.918753,
    lng: -105.930622,
    panoId: "UjkeLzF99yMzOD6PJy_Cow",
    place: "Near Alamogordo, New Mexico",
    shortName: "Alamogordo",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nm-089",
    lat: 32.991002,
    lng: -103.352147,
    panoId: "YcmZrXX7koyRGnJiSg02jQ",
    place: "Near Lovington, New Mexico",
    shortName: "Lovington",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nm-090",
    lat: 32.900798,
    lng: -104.39179,
    panoId: "SqQ9JVlesEGrQ8thut7BnA",
    place: "Near Artesia, New Mexico",
    shortName: "Artesia",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nm-091",
    lat: 32.146895,
    lng: -106.64991,
    panoId: "mhAggizho7WVOKAMq4HclA",
    place: "Near Vado, New Mexico",
    shortName: "Vado",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nm-092",
    lat: 35.886729,
    lng: -106.367488,
    panoId: "JzBxw4ChE9m_m3Cf95DGJw",
    place: "Near Los Alamos, New Mexico",
    shortName: "Los Alamos",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nm-093",
    lat: 35.119635,
    lng: -103.728734,
    panoId: "p9Gpio4ZfbdgaxwB61a7FA",
    place: "Near Tucumcari, New Mexico",
    shortName: "Tucumcari",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nm-094",
    lat: 32.360099,
    lng: -104.263064,
    panoId: "NxxdZj-nuJIbEPaY3sfg-Q",
    place: "Near Carlsbad, New Mexico",
    shortName: "Carlsbad",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nm-095",
    lat: 32.476975,
    lng: -103.159488,
    panoId: "2nO-rVJ5yHseYLAiGhaLIA",
    place: "Near Eunice, New Mexico",
    shortName: "Eunice",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nm-096",
    lat: 35.008598,
    lng: -108.925147,
    panoId: "MtohrZfQN3wCWoRlSgTiVw",
    place: "Near Zuni Pueblo, New Mexico",
    shortName: "Zuni Pueblo",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nm-097",
    lat: 36.854745,
    lng: -108.701872,
    panoId: "2XPvxHDhUneBqQCYZraQsQ",
    place: "Near Shiprock, New Mexico",
    shortName: "Shiprock",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nm-098",
    lat: 34.774431,
    lng: -106.737747,
    panoId: "zIBXE8X-m0T2NX-Xzxi-1A",
    place: "Near El Cerro, New Mexico",
    shortName: "El Cerro",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nm-099",
    lat: 32.465391,
    lng: -103.176425,
    panoId: "cn_0bnsjpfadCCNb5AQNLQ",
    place: "Near Eunice, New Mexico",
    shortName: "Eunice",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nm-100",
    lat: 34.063197,
    lng: -107.09941,
    panoId: "eqpH08kZLw21zIYqvWfHjg",
    place: "Near Socorro, New Mexico",
    shortName: "Socorro",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nm-101",
    lat: 36.806679,
    lng: -108.875368,
    panoId: "msZmqOwC9Y3tLE7ZR2cTOw",
    place: "Near Shiprock, New Mexico",
    shortName: "Shiprock",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nm-102",
    lat: 36.59689,
    lng: -103.303364,
    panoId: "FT7m-lwDdm3bOaKKnAK0xQ",
    place: "Near Clayton, New Mexico",
    shortName: "Clayton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nm-103",
    lat: 36.491079,
    lng: -108.079009,
    panoId: "8nuzayCH_am11ayTp2lSbQ",
    place: "Near West Hammond, New Mexico",
    shortName: "West Hammond",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nm-104",
    lat: 36.187796,
    lng: -106.059255,
    panoId: "4_3Zs_t6tEUcdrFAsFbNJQ",
    place: "Near Ohkay Owingeh, New Mexico",
    shortName: "Ohkay Owingeh",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nm-105",
    lat: 35.671124,
    lng: -106.914389,
    panoId: "Ca4uxNI2Tf_ZvBvUqDZwyw",
    place: "Near Jemez Pueblo, New Mexico",
    shortName: "Jemez Pueblo",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nm-106",
    lat: 36.534816,
    lng: -103.272792,
    panoId: "NUKMLqMAFf2SfVy8IeIB5A",
    place: "Near Clayton, New Mexico",
    shortName: "Clayton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nm-107",
    lat: 35.14223,
    lng: -105.98924,
    panoId: "33anyUdrXvrCU_GNzXh4uA",
    place: "Near Moriarty, New Mexico",
    shortName: "Moriarty",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nm-108",
    lat: 33.39006,
    lng: -105.487287,
    panoId: "CI0dSaaXz8iTdlv2oDbNGA",
    place: "Near Ruidoso Downs, New Mexico",
    shortName: "Ruidoso Downs",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nm-109",
    lat: 36.698029,
    lng: -105.475514,
    panoId: "ctImRyT7qhYVzlrfCS_krA",
    place: "Near Questa, New Mexico",
    shortName: "Questa",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nm-110",
    lat: 36.603685,
    lng: -108.284738,
    panoId: "W1oNTpvzYNrzWPGINdz7ew",
    place: "Near Upper Fruitland, New Mexico",
    shortName: "Upper Fruitland",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nm-111",
    lat: 35.325659,
    lng: -107.998405,
    panoId: "wCCVXbOVyYwsha3fT1JU8A",
    place: "Near Milan, New Mexico",
    shortName: "Milan",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NM",
    state: "New Mexico",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-NM"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ny-000",
    lat: 42.886475,
    lng: -78.878797,
    panoId: "0-6T2_zrvbtTAkyB6t_LeQ",
    place: "Near Buffalo, New York",
    shortName: "Buffalo",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NY",
    state: "New York",
    difficulty: "classic",
    pools: ["world","North America","US","US-NY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ny-001",
    lat: 40.68145,
    lng: -73.836709,
    panoId: "3WVcr-jgsX3FMfZIgUK9vA",
    place: "Near Queens, New York",
    shortName: "Queens",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NY",
    state: "New York",
    difficulty: "classic",
    pools: ["world","North America","US","US-NY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ny-002",
    lat: 40.714257,
    lng: -74.006251,
    panoId: "01-KGUfHVU5mO3sIY7zijA",
    place: "Near New York City, New York",
    shortName: "New York City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NY",
    state: "New York",
    difficulty: "classic",
    pools: ["world","North America","US","US-NY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ny-003",
    lat: 42.814285,
    lng: -73.939816,
    panoId: "qbuyH1ae5qBfHv0vmaW27g",
    place: "Near Schenectady, New York",
    shortName: "Schenectady",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NY",
    state: "New York",
    difficulty: "classic",
    pools: ["world","North America","US","US-NY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ny-004",
    lat: 40.650083,
    lng: -73.949486,
    panoId: "VNWHFxTyGsUVM4knyNyDQQ",
    place: "Near Brooklyn, New York",
    shortName: "Brooklyn",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NY",
    state: "New York",
    difficulty: "classic",
    pools: ["world","North America","US","US-NY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ny-005",
    lat: 40.868706,
    lng: -73.001487,
    panoId: "Qv2z0rYZnYjxK0a-M3GBxQ",
    place: "Near Coram, New York",
    shortName: "Coram",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NY",
    state: "New York",
    difficulty: "classic",
    pools: ["world","North America","US","US-NY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ny-006",
    lat: 42.865735,
    lng: -73.770885,
    panoId: "jl2sNjBVC8h0TNIW6rrdEg",
    place: "Near Clifton Park, New York",
    shortName: "Clifton Park",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NY",
    state: "New York",
    difficulty: "classic",
    pools: ["world","North America","US","US-NY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ny-007",
    lat: 43.147538,
    lng: -77.550472,
    panoId: "7MJLgvXBmRGRn7s9DRMXKA",
    place: "Near Brighton, New York",
    shortName: "Brighton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NY",
    state: "New York",
    difficulty: "classic",
    pools: ["world","North America","US","US-NY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ny-008",
    lat: 42.098857,
    lng: -75.917921,
    panoId: "uL3jKKrxHxvwykiIScSUGA",
    place: "Near Binghamton, New York",
    shortName: "Binghamton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NY",
    state: "New York",
    difficulty: "classic",
    pools: ["world","North America","US","US-NY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ny-009",
    lat: 41.034062,
    lng: -73.762992,
    panoId: "3y31cAIlkxIXR19ifvZgug",
    place: "Near White Plains, New York",
    shortName: "White Plains",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NY",
    state: "New York",
    difficulty: "classic",
    pools: ["world","North America","US","US-NY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ny-010",
    lat: 40.781208,
    lng: -73.246184,
    panoId: "AuBB_p3m7xXR5ALQk-7ogw",
    place: "Near Brentwood, New York",
    shortName: "Brentwood",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NY",
    state: "New York",
    difficulty: "classic",
    pools: ["world","North America","US","US-NY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ny-011",
    lat: 43.154771,
    lng: -77.615506,
    panoId: "Big2nQgDLh2sZyE3zYeZxw",
    place: "Near Rochester, New York",
    shortName: "Rochester",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NY",
    state: "New York",
    difficulty: "classic",
    pools: ["world","North America","US","US-NY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ny-012",
    lat: 43.094462,
    lng: -79.056685,
    panoId: "puHEsTqSQRmGJIAyXT9pXQ",
    place: "Near Niagara Falls, New York",
    shortName: "Niagara Falls",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NY",
    state: "New York",
    difficulty: "classic",
    pools: ["world","North America","US","US-NY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ny-013",
    lat: 42.652663,
    lng: -73.756213,
    panoId: "ARQhmfO-US6C3CopOF_opg",
    place: "Near Albany, New York",
    shortName: "Albany",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NY",
    state: "New York",
    difficulty: "classic",
    pools: ["world","North America","US","US-NY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ny-014",
    lat: 43.21338,
    lng: -77.579708,
    panoId: "KKcgln7af9vJsL61vpgopg",
    place: "Near Irondequoit, New York",
    shortName: "Irondequoit",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NY",
    state: "New York",
    difficulty: "classic",
    pools: ["world","North America","US","US-NY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ny-015",
    lat: 43.100928,
    lng: -75.232646,
    panoId: "jVnJ_p7mT6k91nzEjZOiFA",
    place: "Near Utica, New York",
    shortName: "Utica",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NY",
    state: "New York",
    difficulty: "classic",
    pools: ["world","North America","US","US-NY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ny-016",
    lat: 40.718172,
    lng: -73.354247,
    panoId: "Ly9XhUPAhQXZeiIpzdcyWA",
    place: "Near West Babylon, New York",
    shortName: "West Babylon",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NY",
    state: "New York",
    difficulty: "classic",
    pools: ["world","North America","US","US-NY"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-ny-017",
    lat: 43.185923,
    lng: -76.172413,
    panoId: "r01P_nZPqxpoZmy4PMh_uQ",
    place: "Near Clay, New York",
    shortName: "Clay",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NY",
    state: "New York",
    difficulty: "classic",
    pools: ["world","North America","US","US-NY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ny-018",
    lat: 41.342095,
    lng: -74.168318,
    panoId: "Bt2YngvNCLt5ATPaD7z2mw",
    place: "Near Kiryas Joel, New York",
    shortName: "Kiryas Joel",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NY",
    state: "New York",
    difficulty: "classic",
    pools: ["world","North America","US","US-NY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ny-019",
    lat: 42.728425,
    lng: -73.691524,
    panoId: "H5xgKyeYAgr0mdUMPky7gg",
    place: "Near Troy, New York",
    shortName: "Troy",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NY",
    state: "New York",
    difficulty: "classic",
    pools: ["world","North America","US","US-NY"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-ny-020",
    lat: 43.17559,
    lng: -76.119334,
    panoId: "haFFQystkiSk2t-jR-HetQ",
    place: "Near Cicero, New York",
    shortName: "Cicero",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NY",
    state: "New York",
    difficulty: "classic",
    pools: ["world","North America","US","US-NY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ny-021",
    lat: 42.850043,
    lng: -78.799724,
    panoId: "H0bdOnp2JuNX5mjJxJvvgA",
    place: "Near West Seneca, New York",
    shortName: "West Seneca",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NY",
    state: "New York",
    difficulty: "classic",
    pools: ["world","North America","US","US-NY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ny-022",
    lat: 43.038645,
    lng: -78.864234,
    panoId: "ZD4jnbyB23qV20M0uzGhRw",
    place: "Near North Tonawanda, New York",
    shortName: "North Tonawanda",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NY",
    state: "New York",
    difficulty: "classic",
    pools: ["world","North America","US","US-NY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ny-023",
    lat: 40.562341,
    lng: -74.139845,
    panoId: "-tDFIrLnYTTQ7-ml_yGobg",
    place: "Near Staten Island, New York",
    shortName: "Staten Island",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NY",
    state: "New York",
    difficulty: "classic",
    pools: ["world","North America","US","US-NY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ny-024",
    lat: 43.059272,
    lng: -77.612148,
    panoId: "p3-2U-qOFp4pJZxLnjEHIQ",
    place: "Near Henrietta, New York",
    shortName: "Henrietta",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NY",
    state: "New York",
    difficulty: "classic",
    pools: ["world","North America","US","US-NY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ny-025",
    lat: 40.84287,
    lng: -73.292859,
    panoId: "ZRAFMBQfkTstrz0kINOTXw",
    place: "Near Commack, New York",
    shortName: "Commack",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NY",
    state: "New York",
    difficulty: "classic",
    pools: ["world","North America","US","US-NY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ny-026",
    lat: 42.440474,
    lng: -76.496642,
    panoId: "60zD4b64cFIwD4vKVYBRBg",
    place: "Near Ithaca, New York",
    shortName: "Ithaca",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NY",
    state: "New York",
    difficulty: "classic",
    pools: ["world","North America","US","US-NY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ny-027",
    lat: 40.790609,
    lng: -73.201761,
    panoId: "EdNP3Uu1EHroUwm9INSK8g",
    place: "Near Central Islip, New York",
    shortName: "Central Islip",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NY",
    state: "New York",
    difficulty: "classic",
    pools: ["world","North America","US","US-NY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ny-028",
    lat: 40.858309,
    lng: -73.099529,
    panoId: "XKcMmlaWen8LDTRS2lB-qw",
    place: "Near Centereach, New York",
    shortName: "Centereach",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NY",
    state: "New York",
    difficulty: "classic",
    pools: ["world","North America","US","US-NY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ny-029",
    lat: 41.147577,
    lng: -73.989205,
    panoId: "irZ_1vuWvwLH88fOKv8Abw",
    place: "Near New City, New York",
    shortName: "New City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NY",
    state: "New York",
    difficulty: "classic",
    pools: ["world","North America","US","US-NY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ny-030",
    lat: 43.212738,
    lng: -75.455533,
    panoId: "HIjerRu1Q4QJ2p6qou9P0A",
    place: "Near Rome, New York",
    shortName: "Rome",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NY",
    state: "New York",
    difficulty: "classic",
    pools: ["world","North America","US","US-NY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ny-031",
    lat: 43.048097,
    lng: -76.147414,
    panoId: "lv9nhHzgPZKfDyFHSqcEig",
    place: "Near Syracuse, New York",
    shortName: "Syracuse",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NY",
    state: "New York",
    difficulty: "classic",
    pools: ["world","North America","US","US-NY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ny-032",
    lat: 42.978477,
    lng: -78.79983,
    panoId: "M7AyTnoJARkQfcDM3WSvwA",
    place: "Near Amherst, New York",
    shortName: "Amherst",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NY",
    state: "New York",
    difficulty: "classic",
    pools: ["world","North America","US","US-NY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ny-033",
    lat: 40.849827,
    lng: -73.866856,
    panoId: "bPMegW5l5aYe13j427pckw",
    place: "Near The Bronx, New York",
    shortName: "The Bronx",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NY",
    state: "New York",
    difficulty: "classic",
    pools: ["world","North America","US","US-NY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ny-034",
    lat: 42.683152,
    lng: -73.778578,
    panoId: "buWD6fezGGcb76jzNJ_ciA",
    place: "Near West Albany, New York",
    shortName: "West Albany",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NY",
    state: "New York",
    difficulty: "classic",
    pools: ["world","North America","US","US-NY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ny-035",
    lat: 42.929241,
    lng: -74.052102,
    panoId: "BoKgGhWeOuwbbF7KvLtNKg",
    place: "Near Glenville, New York",
    shortName: "Glenville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NY",
    state: "New York",
    difficulty: "classic",
    pools: ["world","North America","US","US-NY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ny-036",
    lat: 41.700493,
    lng: -73.920825,
    panoId: "ZvYkMU5G8IrO9p-zqcQ35A",
    place: "Near Poughkeepsie, New York",
    shortName: "Poughkeepsie",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NY",
    state: "New York",
    difficulty: "classic",
    pools: ["world","North America","US","US-NY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ny-037",
    lat: 42.097008,
    lng: -79.235315,
    panoId: "UrIzIU-9XdfsUXacIGXiHw",
    place: "Near Jamestown, New York",
    shortName: "Jamestown",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NY",
    state: "New York",
    difficulty: "classic",
    pools: ["world","North America","US","US-NY"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-ny-038",
    lat: 40.687389,
    lng: -73.816285,
    panoId: "1clqAijMLdbVukJeQtUmCQ",
    place: "Near Jamaica, New York",
    shortName: "Jamaica",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NY",
    state: "New York",
    difficulty: "classic",
    pools: ["world","North America","US","US-NY"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-ny-039",
    lat: 40.876205,
    lng: -73.110451,
    panoId: "k4_X2WJs41aPUlQwcJOa8w",
    place: "Near Centereach, New York",
    shortName: "Centereach",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NY",
    state: "New York",
    difficulty: "classic",
    pools: ["world","North America","US","US-NY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ny-040",
    lat: 40.654112,
    lng: -73.926317,
    panoId: "ZhHyNIV-fmU_0CDKqGcScQ",
    place: "Near East Flatbush, New York",
    shortName: "East Flatbush",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NY",
    state: "New York",
    difficulty: "classic",
    pools: ["world","North America","US","US-NY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ny-041",
    lat: 41.044952,
    lng: -73.772908,
    panoId: "T_p3YrLdhuf2aIqy_NZYAQ",
    place: "Near White Plains, New York",
    shortName: "White Plains",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NY",
    state: "New York",
    difficulty: "classic",
    pools: ["world","North America","US","US-NY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ny-042",
    lat: 42.890807,
    lng: -78.764292,
    panoId: "rjHKFat1-7CeDVlZiVTALw",
    place: "Near Cheektowaga, New York",
    shortName: "Cheektowaga",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NY",
    state: "New York",
    difficulty: "classic",
    pools: ["world","North America","US","US-NY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ny-043",
    lat: 43.154668,
    lng: -76.119375,
    panoId: "sZRzC90Ud_SPA4BC6yzfSA",
    place: "Near Cicero, New York",
    shortName: "Cicero",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NY",
    state: "New York",
    difficulty: "classic",
    pools: ["world","North America","US","US-NY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "us-ny-044",
    lat: 43.035756,
    lng: -78.84955,
    panoId: "KTT8QSzSugfURZNmSimWIQ",
    place: "Near North Tonawanda, New York",
    shortName: "North Tonawanda",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NY",
    state: "New York",
    difficulty: "classic",
    pools: ["world","North America","US","US-NY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ny-045",
    lat: 40.792369,
    lng: -73.224256,
    panoId: "FREGFaIOeih1a0wrRr4Utg",
    place: "Near Central Islip, New York",
    shortName: "Central Islip",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NY",
    state: "New York",
    difficulty: "classic",
    pools: ["world","North America","US","US-NY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ny-046",
    lat: 41.129985,
    lng: -73.982262,
    panoId: "s6PwFtv_vrpobWHFfKQrkA",
    place: "Near New City, New York",
    shortName: "New City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NY",
    state: "New York",
    difficulty: "classic",
    pools: ["world","North America","US","US-NY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ny-047",
    lat: 40.803821,
    lng: -73.19741,
    panoId: "m6P1UsjpwC2KymL7zzlkGA",
    place: "Near Central Islip, New York",
    shortName: "Central Islip",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NY",
    state: "New York",
    difficulty: "classic",
    pools: ["world","North America","US","US-NY"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-ny-048",
    lat: 43.113794,
    lng: -75.215204,
    panoId: "SYwvkYZqbWn5QInKrbxnYQ",
    place: "Near Utica, New York",
    shortName: "Utica",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NY",
    state: "New York",
    difficulty: "classic",
    pools: ["world","North America","US","US-NY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ny-049",
    lat: 42.870838,
    lng: -73.795415,
    panoId: "nu4KneoeJk1rjAd10CVlQg",
    place: "Near Clifton Park, New York",
    shortName: "Clifton Park",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NY",
    state: "New York",
    difficulty: "classic",
    pools: ["world","North America","US","US-NY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ny-050",
    lat: 43.17357,
    lng: -76.22223,
    panoId: "52evFW3o7NUcskmjLq6A_g",
    place: "Near Clay, New York",
    shortName: "Clay",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NY",
    state: "New York",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ny-051",
    lat: 40.920861,
    lng: -72.98418,
    panoId: "m2HyOpAIPNfs8ro2V_aJKQ",
    place: "Near Sound Beach, New York",
    shortName: "Sound Beach",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NY",
    state: "New York",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ny-052",
    lat: 42.922578,
    lng: -73.808688,
    panoId: "UZzc4itAgkw-YGTauiiiyQ",
    place: "Near Country Knolls, New York",
    shortName: "Country Knolls",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NY",
    state: "New York",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ny-053",
    lat: 42.996177,
    lng: -77.594486,
    panoId: "XkUFiL4ghiUl63uYqOW06w",
    place: "Near Rush, New York",
    shortName: "Rush",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NY",
    state: "New York",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ny-054",
    lat: 42.814674,
    lng: -78.749409,
    panoId: "3I4lVByLhlX6ueMr0qKfKQ",
    place: "Near Orchard Park, New York",
    shortName: "Orchard Park",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NY",
    state: "New York",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ny-055",
    lat: 42.485593,
    lng: -76.46741,
    panoId: "EIRZ4i2zkx_HBrY6IxMyhA",
    place: "Near Lansing, New York",
    shortName: "Lansing",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NY",
    state: "New York",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ny-056",
    lat: 40.666563,
    lng: -74.076787,
    panoId: "gG1Nrh6hBwHzpEw_fLNjiw",
    place: "Near New Brighton, New York",
    shortName: "New Brighton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NY",
    state: "New York",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NY"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-ny-057",
    lat: 41.639267,
    lng: -73.896047,
    panoId: "C6H1Pc6ptRklim7SGeOCJA",
    place: "Near Spackenkill, New York",
    shortName: "Spackenkill",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NY",
    state: "New York",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NY"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-ny-058",
    lat: 43.17885,
    lng: -75.398668,
    panoId: "oYlptuHDQKFI0J1zNIi4MQ",
    place: "Near Oriskany, New York",
    shortName: "Oriskany",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NY",
    state: "New York",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ny-059",
    lat: 42.950377,
    lng: -74.001945,
    panoId: "EcXHKkzrLlk0Te4YQBPzJg",
    place: "Near Glenville, New York",
    shortName: "Glenville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NY",
    state: "New York",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ny-060",
    lat: 42.873692,
    lng: -78.741237,
    panoId: "97rhph7CyXNzVpI1SLAu3g",
    place: "Near Cheektowaga, New York",
    shortName: "Cheektowaga",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NY",
    state: "New York",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ny-061",
    lat: 42.119378,
    lng: -79.291557,
    panoId: "0SvqhR1kld0cwMEUzXprfw",
    place: "Near Celoron, New York",
    shortName: "Celoron",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NY",
    state: "New York",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ny-062",
    lat: 43.10471,
    lng: -78.867376,
    panoId: "-D9jJRfY_sDzWAbsCYNeoA",
    place: "Near Sanborn, New York",
    shortName: "Sanborn",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NY",
    state: "New York",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ny-063",
    lat: 43.221822,
    lng: -77.521525,
    panoId: "uFNHsKCTh7HkdqjESaMJZw",
    place: "Near Irondequoit, New York",
    shortName: "Irondequoit",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NY",
    state: "New York",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ny-064",
    lat: 42.498054,
    lng: -76.461819,
    panoId: "wUVokaTQwkEauLup2Fc31Q",
    place: "Near Lansing, New York",
    shortName: "Lansing",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NY",
    state: "New York",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ny-065",
    lat: 43.054237,
    lng: -75.244578,
    panoId: "keOmCR5RH5DUzG4qHiIbXg",
    place: "Near Washington Mills, New York",
    shortName: "Washington Mills",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NY",
    state: "New York",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ny-066",
    lat: 42.68159,
    lng: -73.627085,
    panoId: "E3XtlpQ-sg1YkKD1EeLNAQ",
    place: "Near Wynantskill, New York",
    shortName: "Wynantskill",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NY",
    state: "New York",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ny-067",
    lat: 43.114949,
    lng: -76.188223,
    panoId: "GXK5EFxt5Erlkye0Vk6NCw",
    place: "Near Liverpool, New York",
    shortName: "Liverpool",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NY",
    state: "New York",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NY"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-ny-068",
    lat: 42.084297,
    lng: -75.956186,
    panoId: "xRO26Nm0UrGxaS3u-gB_AA",
    place: "Near Johnson City, New York",
    shortName: "Johnson City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NY",
    state: "New York",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ny-069",
    lat: 42.776005,
    lng: -73.874938,
    panoId: "6CDSRIFSZhHD6PdIq2oLyQ",
    place: "Near Niskayuna, New York",
    shortName: "Niskayuna",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NY",
    state: "New York",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NY"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-ny-070",
    lat: 43.029131,
    lng: -77.586553,
    panoId: "tWsKQvaZ7e25NkphrZ_FFA",
    place: "Near Henrietta, New York",
    shortName: "Henrietta",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NY",
    state: "New York",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ny-071",
    lat: 41.63193,
    lng: -73.95973,
    panoId: "-TR2kxLEMAH9UG6NYuBKJA",
    place: "Near Crown Heights, New York",
    shortName: "Crown Heights",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NY",
    state: "New York",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ny-072",
    lat: 43.18447,
    lng: -75.508855,
    panoId: "rmjMGgRk9LUT1Wp5jzzAqQ",
    place: "Near Rome, New York",
    shortName: "Rome",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NY",
    state: "New York",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ny-073",
    lat: 41.645049,
    lng: -73.966268,
    panoId: "FVSiuOdWi8CTJr1c9w2eqg",
    place: "Near Milton, New York",
    shortName: "Milton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NY",
    state: "New York",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NY"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-ny-074",
    lat: 43.168213,
    lng: -77.788239,
    panoId: "lg0FjaAETRGrfK8GvFYO-A",
    place: "Near Spencerport, New York",
    shortName: "Spencerport",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NY",
    state: "New York",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ny-075",
    lat: 42.696259,
    lng: -73.665986,
    panoId: "XkwU8u8coSWcYqiqSTBtMQ",
    place: "Near Wynantskill, New York",
    shortName: "Wynantskill",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NY",
    state: "New York",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ny-076",
    lat: 43.270689,
    lng: -73.50519,
    panoId: "q7NXPZngc2VtEkU4KUMuCQ",
    place: "Near Fort Edward, New York",
    shortName: "Fort Edward",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NY",
    state: "New York",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ny-077",
    lat: 42.993071,
    lng: -74.264358,
    panoId: "i-pKePD8V0aXdudnWcVzjQ",
    place: "Near Tribes Hill, New York",
    shortName: "Tribes Hill",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NY",
    state: "New York",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ny-078",
    lat: 42.933901,
    lng: -73.964952,
    panoId: "-Hu4w_ECksTgFXH1RAGwFA",
    place: "Near East Glenville, New York",
    shortName: "East Glenville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NY",
    state: "New York",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ny-079",
    lat: 42.878888,
    lng: -78.997201,
    panoId: "qnSe3YVgXa_nQabG5CQ4SA",
    place: "Near Fort Erie, New York",
    shortName: "Fort Erie",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NY",
    state: "New York",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ny-080",
    lat: 42.905645,
    lng: -76.723823,
    panoId: "PE-W25NU9Uj7JnKE_trHhQ",
    place: "Near Bridgeport, New York",
    shortName: "Bridgeport",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NY",
    state: "New York",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ny-081",
    lat: 42.721972,
    lng: -74.000626,
    panoId: "-ypR2XX0OdKw37-dWoReDA",
    place: "Near Altamont, New York",
    shortName: "Altamont",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NY",
    state: "New York",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ny-082",
    lat: 42.990763,
    lng: -78.921495,
    panoId: "jsSWZak4KTY5yTqAcbIT7g",
    place: "Near Grandyle Village, New York",
    shortName: "Grandyle Village",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NY",
    state: "New York",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ny-083",
    lat: 41.21623,
    lng: -74.305884,
    panoId: "cC8OTfKIOYHSfiRXnhYkqw",
    place: "Near Greenwood Lake, New York",
    shortName: "Greenwood Lake",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NY",
    state: "New York",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ny-084",
    lat: 43.014398,
    lng: -78.923724,
    panoId: "jKi07yE7S8XL_ym0xrr2ZQ",
    place: "Near Grandyle Village, New York",
    shortName: "Grandyle Village",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NY",
    state: "New York",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ny-085",
    lat: 40.830051,
    lng: -72.683173,
    panoId: "64Bfdv9oxC-jcpZGiBUqTw",
    place: "Near Remsenburg-Speonk, New York",
    shortName: "Remsenburg-Speonk",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NY",
    state: "New York",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NY"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-ny-086",
    lat: 43.189966,
    lng: -76.220596,
    panoId: "PYOyR8LVmxi5sTZt5EBfsA",
    place: "Near Clay, New York",
    shortName: "Clay",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NY",
    state: "New York",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ny-087",
    lat: 41.950466,
    lng: -73.871795,
    panoId: "2VcR-iby7KKqOe8Jf74IKw",
    place: "Near Rhinebeck, New York",
    shortName: "Rhinebeck",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NY",
    state: "New York",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ny-088",
    lat: 41.411265,
    lng: -73.855608,
    panoId: "FwNQ1oDJiGFGPl_bdauFOw",
    place: "Near Cold Spring, New York",
    shortName: "Cold Spring",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NY",
    state: "New York",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ny-089",
    lat: 41.574004,
    lng: -74.309713,
    panoId: "yVx0T4MlkKaz28UWGBjuLA",
    place: "Near Pine Bush, New York",
    shortName: "Pine Bush",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NY",
    state: "New York",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ny-090",
    lat: 43.044135,
    lng: -78.809859,
    panoId: "MVsim4YkLQpPWaQcXrFykA",
    place: "Near North Tonawanda, New York",
    shortName: "North Tonawanda",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NY",
    state: "New York",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ny-091",
    lat: 42.108825,
    lng: -79.364976,
    panoId: "08z5Z8nuSWBC0TLoCQYdYA",
    place: "Near Lakewood, New York",
    shortName: "Lakewood",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NY",
    state: "New York",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ny-092",
    lat: 43.248827,
    lng: -77.761647,
    panoId: "r-_miGFjPi1HVrEOVTWUjg",
    place: "Near Hilton, New York",
    shortName: "Hilton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NY",
    state: "New York",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ny-093",
    lat: 41.322429,
    lng: -73.687201,
    panoId: "ROn3GO4I4X8ObMBJOu6obA",
    place: "Near Heritage Hills, New York",
    shortName: "Heritage Hills",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NY",
    state: "New York",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ny-094",
    lat: 40.884128,
    lng: -73.117578,
    panoId: "6E6LQdeURD0jfAYKOdMrJg",
    place: "Near Centereach, New York",
    shortName: "Centereach",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NY",
    state: "New York",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ny-095",
    lat: 42.96505,
    lng: -73.919357,
    panoId: "dLbCuXMEU_GHJFxJA5f_Zw",
    place: "Near Ballston Spa, New York",
    shortName: "Ballston Spa",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NY",
    state: "New York",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ny-096",
    lat: 43.035817,
    lng: -78.741916,
    panoId: "ywTKgSWnqjyJlb9l3gw1Uw",
    place: "Near East Amherst, New York",
    shortName: "East Amherst",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NY",
    state: "New York",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ny-097",
    lat: 43.903087,
    lng: -75.822673,
    panoId: "ygKPiXzfxIA-dm2mICmjhA",
    place: "Near Watertown, New York",
    shortName: "Watertown",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NY",
    state: "New York",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ny-098",
    lat: 43.135105,
    lng: -76.30226,
    panoId: "5hma7ysWkzWxzUmYTuliFQ",
    place: "Near Village Green, New York",
    shortName: "Village Green",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NY",
    state: "New York",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ny-099",
    lat: 41.892999,
    lng: -73.887338,
    panoId: "uMoNcN15jcKoX28L-OTp3A",
    place: "Near Rhinebeck, New York",
    shortName: "Rhinebeck",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NY",
    state: "New York",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ny-100",
    lat: 44.141351,
    lng: -75.892506,
    panoId: "ZxFLUUlT94y9giWi62plkA",
    place: "Near Calcium, New York",
    shortName: "Calcium",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NY",
    state: "New York",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-NY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ny-101",
    lat: 42.007336,
    lng: -76.274301,
    panoId: "wChtFzfU5nfsULLc9ZbKUg",
    place: "Near Owego, New York",
    shortName: "Owego",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NY",
    state: "New York",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-NY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ny-102",
    lat: 42.010925,
    lng: -76.960854,
    panoId: "I5oKPfxbqX6Dubp56rHJXw",
    place: "Near West Elmira, New York",
    shortName: "West Elmira",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NY",
    state: "New York",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-NY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ny-103",
    lat: 43.38448,
    lng: -73.455899,
    panoId: "lFURt2U7I09hPSw6bc_07A",
    place: "Near Hartford, New York",
    shortName: "Hartford",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NY",
    state: "New York",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-NY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ny-104",
    lat: 43.204594,
    lng: -78.915324,
    panoId: "rCCDsE05IaWp7TgqEXeN2w",
    place: "Near Ransomville, New York",
    shortName: "Ransomville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NY",
    state: "New York",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-NY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ny-105",
    lat: 42.207533,
    lng: -76.176884,
    panoId: "Tc-9hdsBQVD50fp_grkLsA",
    place: "Near Owego, New York",
    shortName: "Owego",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NY",
    state: "New York",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-NY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nc-000",
    lat: 35.979945,
    lng: -78.509852,
    panoId: "RLNF6yE8DMbdVQfVcOcljw",
    place: "Near Wake Forest, North Carolina",
    shortName: "Wake Forest",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NC",
    state: "North Carolina",
    difficulty: "classic",
    pools: ["world","North America","US","US-NC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nc-001",
    lat: 35.40884,
    lng: -80.581666,
    panoId: "XNpNO-0rpzVyPGR2IkTjkg",
    place: "Near Concord, North Carolina",
    shortName: "Concord",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NC",
    state: "North Carolina",
    difficulty: "classic",
    pools: ["world","North America","US","US-NC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nc-002",
    lat: 35.772144,
    lng: -78.638642,
    panoId: "WCpgOf6Fwannv8pnlEjJFQ",
    place: "Near Raleigh, North Carolina",
    shortName: "Raleigh",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NC",
    state: "North Carolina",
    difficulty: "classic",
    pools: ["world","North America","US","US-NC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nc-003",
    lat: 34.235518,
    lng: -77.946044,
    panoId: "Df7NFzQkXnXpA1Y9hHrsBA",
    place: "Near Wilmington, North Carolina",
    shortName: "Wilmington",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NC",
    state: "North Carolina",
    difficulty: "classic",
    pools: ["world","North America","US","US-NC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nc-004",
    lat: 35.10848,
    lng: -77.044064,
    panoId: "O57vylwFMvCyUyIDsh5lkw",
    place: "Near New Bern, North Carolina",
    shortName: "New Bern",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NC",
    state: "North Carolina",
    difficulty: "classic",
    pools: ["world","North America","US","US-NC"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "us-nc-005",
    lat: 36.095628,
    lng: -79.437722,
    panoId: "bdVL9cC5CuN3AoTIt1KuXQ",
    place: "Near Burlington, North Carolina",
    shortName: "Burlington",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NC",
    state: "North Carolina",
    difficulty: "classic",
    pools: ["world","North America","US","US-NC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nc-006",
    lat: 35.782643,
    lng: -80.887293,
    panoId: "s163gyCSpadT_6ZwbRHbwQ",
    place: "Near Statesville, North Carolina",
    shortName: "Statesville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NC",
    state: "North Carolina",
    difficulty: "classic",
    pools: ["world","North America","US","US-NC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nc-007",
    lat: 35.612714,
    lng: -77.366491,
    panoId: "FXm9eZrsYu6wJCcyTvm_MA",
    place: "Near Greenville, North Carolina",
    shortName: "Greenville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NC",
    state: "North Carolina",
    difficulty: "classic",
    pools: ["world","North America","US","US-NC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nc-008",
    lat: 35.227137,
    lng: -80.843181,
    panoId: "6MonrXnjRyFgJ8C4qjfV4g",
    place: "Near Charlotte, North Carolina",
    shortName: "Charlotte",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NC",
    state: "North Carolina",
    difficulty: "classic",
    pools: ["world","North America","US","US-NC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nc-009",
    lat: 35.262168,
    lng: -81.187348,
    panoId: "CFmtj1nZCFobBjGJseA4Bw",
    place: "Near Gastonia, North Carolina",
    shortName: "Gastonia",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NC",
    state: "North Carolina",
    difficulty: "classic",
    pools: ["world","North America","US","US-NC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nc-010",
    lat: 36.072573,
    lng: -79.792015,
    panoId: "LOlCW1ZYPlLR0ttzGbEA6A",
    place: "Near Greensboro, North Carolina",
    shortName: "Greensboro",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NC",
    state: "North Carolina",
    difficulty: "classic",
    pools: ["world","North America","US","US-NC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nc-011",
    lat: 35.913218,
    lng: -79.055825,
    panoId: "16WzaAAbJCO-D4B7ZAa2BQ",
    place: "Near Chapel Hill, North Carolina",
    shortName: "Chapel Hill",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NC",
    state: "North Carolina",
    difficulty: "classic",
    pools: ["world","North America","US","US-NC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nc-012",
    lat: 35.938236,
    lng: -77.790259,
    panoId: "g8Xsn_hJicKQBIbtgdOW7w",
    place: "Near Rocky Mount, North Carolina",
    shortName: "Rocky Mount",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NC",
    state: "North Carolina",
    difficulty: "classic",
    pools: ["world","North America","US","US-NC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nc-013",
    lat: 34.98538,
    lng: -80.5496,
    panoId: "pdFm0dPRDlCPvu5c7CLXoQ",
    place: "Near Monroe, North Carolina",
    shortName: "Monroe",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NC",
    state: "North Carolina",
    difficulty: "classic",
    pools: ["world","North America","US","US-NC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nc-014",
    lat: 35.384823,
    lng: -77.992853,
    panoId: "pJoFIsNy2DBOC3fJN_1L1g",
    place: "Near Goldsboro, North Carolina",
    shortName: "Goldsboro",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NC",
    state: "North Carolina",
    difficulty: "classic",
    pools: ["world","North America","US","US-NC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nc-015",
    lat: 34.618351,
    lng: -79.010272,
    panoId: "qvgPe0Gg0PBB6Jfo_Lhfbw",
    place: "Near Lumberton, North Carolina",
    shortName: "Lumberton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NC",
    state: "North Carolina",
    difficulty: "classic",
    pools: ["world","North America","US","US-NC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nc-016",
    lat: 35.05274,
    lng: -78.878413,
    panoId: "JvZFP1WcQK6svY1xzx5xug",
    place: "Near Fayetteville, North Carolina",
    shortName: "Fayetteville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NC",
    state: "North Carolina",
    difficulty: "classic",
    pools: ["world","North America","US","US-NC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nc-017",
    lat: 35.721308,
    lng: -77.915641,
    panoId: "ZzzdZpDBO4AoiFrHVuYPqg",
    place: "Near Wilson, North Carolina",
    shortName: "Wilson",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NC",
    state: "North Carolina",
    difficulty: "classic",
    pools: ["world","North America","US","US-NC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nc-018",
    lat: 34.754155,
    lng: -77.430215,
    panoId: "bnZfhKf7DHoVWICwNmqMSw",
    place: "Near Jacksonville, North Carolina",
    shortName: "Jacksonville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NC",
    state: "North Carolina",
    difficulty: "classic",
    pools: ["world","North America","US","US-NC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nc-019",
    lat: 36.119898,
    lng: -80.0736,
    panoId: "CWzRhK8GYucnRGizpw1KkQ",
    place: "Near Kernersville, North Carolina",
    shortName: "Kernersville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NC",
    state: "North Carolina",
    difficulty: "classic",
    pools: ["world","North America","US","US-NC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nc-020",
    lat: 35.711292,
    lng: -78.614131,
    panoId: "Mz_HCCE8AKWbZ2pRYiQ76A",
    place: "Near Garner, North Carolina",
    shortName: "Garner",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NC",
    state: "North Carolina",
    difficulty: "classic",
    pools: ["world","North America","US","US-NC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nc-021",
    lat: 35.993928,
    lng: -78.89873,
    panoId: "t56MWK3XmEopl37WZGSdgA",
    place: "Near Durham, North Carolina",
    shortName: "Durham",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NC",
    state: "North Carolina",
    difficulty: "classic",
    pools: ["world","North America","US","US-NC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nc-022",
    lat: 35.262405,
    lng: -77.581593,
    panoId: "MlwBZlL1loh2dY6rTDudSw",
    place: "Near Kinston, North Carolina",
    shortName: "Kinston",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NC",
    state: "North Carolina",
    difficulty: "classic",
    pools: ["world","North America","US","US-NC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nc-023",
    lat: 35.732664,
    lng: -78.85021,
    panoId: "p2FOV8SJKkh1QSEB01JeaQ",
    place: "Near Apex, North Carolina",
    shortName: "Apex",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NC",
    state: "North Carolina",
    difficulty: "classic",
    pools: ["world","North America","US","US-NC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nc-024",
    lat: 35.479802,
    lng: -79.180379,
    panoId: "gHYkCCU21FyjpVZ2ui8cqQ",
    place: "Near Sanford, North Carolina",
    shortName: "Sanford",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NC",
    state: "North Carolina",
    difficulty: "classic",
    pools: ["world","North America","US","US-NC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nc-025",
    lat: 35.882477,
    lng: -80.081973,
    panoId: "M-r5W2Pdm3ovkR-ECq44uw",
    place: "Near Thomasville, North Carolina",
    shortName: "Thomasville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NC",
    state: "North Carolina",
    difficulty: "classic",
    pools: ["world","North America","US","US-NC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nc-026",
    lat: 35.823543,
    lng: -78.825427,
    panoId: "m69obanZoTPXf5jQk6aqEQ",
    place: "Near Morrisville, North Carolina",
    shortName: "Morrisville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NC",
    state: "North Carolina",
    difficulty: "classic",
    pools: ["world","North America","US","US-NC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nc-027",
    lat: 35.670906,
    lng: -80.474199,
    panoId: "eVbFvZ3rLjww47gWwjz9UQ",
    place: "Near Salisbury, North Carolina",
    shortName: "Salisbury",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NC",
    state: "North Carolina",
    difficulty: "classic",
    pools: ["world","North America","US","US-NC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nc-028",
    lat: 36.099895,
    lng: -80.244266,
    panoId: "7xQjvnjvCmT1V27dBYsmHQ",
    place: "Near Winston-Salem, North Carolina",
    shortName: "Winston-Salem",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NC",
    state: "North Carolina",
    difficulty: "classic",
    pools: ["world","North America","US","US-NC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nc-029",
    lat: 35.651231,
    lng: -78.833608,
    panoId: "A_xij0R4OEKMV2pEUu1MLA",
    place: "Near Holly Springs, North Carolina",
    shortName: "Holly Springs",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NC",
    state: "North Carolina",
    difficulty: "classic",
    pools: ["world","North America","US","US-NC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nc-030",
    lat: 35.584348,
    lng: -78.799964,
    panoId: "ZWFGrMzwRnNO4HKv_Svuog",
    place: "Near Fuquay-Varina, North Carolina",
    shortName: "Fuquay-Varina",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NC",
    state: "North Carolina",
    difficulty: "classic",
    pools: ["world","North America","US","US-NC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nc-031",
    lat: 35.733381,
    lng: -81.341156,
    panoId: "u05vlQBEqQleh6BCF5ISnA",
    place: "Near Hickory, North Carolina",
    shortName: "Hickory",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NC",
    state: "North Carolina",
    difficulty: "classic",
    pools: ["world","North America","US","US-NC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nc-032",
    lat: 35.955699,
    lng: -80.005271,
    panoId: "T_TbkybRFQuvfWO8s0k8lw",
    place: "Near High Point, North Carolina",
    shortName: "High Point",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NC",
    state: "North Carolina",
    difficulty: "classic",
    pools: ["world","North America","US","US-NC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nc-033",
    lat: 35.707931,
    lng: -79.81374,
    panoId: "DzTqfTagHn-ceGx6KELmcA",
    place: "Near Asheboro, North Carolina",
    shortName: "Asheboro",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NC",
    state: "North Carolina",
    difficulty: "classic",
    pools: ["world","North America","US","US-NC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nc-034",
    lat: 35.791543,
    lng: -78.781128,
    panoId: "P7zDOY2geAd7O77I8ngdmQ",
    place: "Near Cary, North Carolina",
    shortName: "Cary",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NC",
    state: "North Carolina",
    difficulty: "classic",
    pools: ["world","North America","US","US-NC"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-nc-035",
    lat: 35.600851,
    lng: -82.554099,
    panoId: "cymgo7RtOnMFZ3nIEqXuXA",
    place: "Near Asheville, North Carolina",
    shortName: "Asheville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NC",
    state: "North Carolina",
    difficulty: "classic",
    pools: ["world","North America","US","US-NC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nc-036",
    lat: 35.910105,
    lng: -79.075372,
    panoId: "sOj0LvbnRDkVFTqP43kn1Q",
    place: "Near Carrboro, North Carolina",
    shortName: "Carrboro",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NC",
    state: "North Carolina",
    difficulty: "classic",
    pools: ["world","North America","US","US-NC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nc-037",
    lat: 34.879024,
    lng: -76.901367,
    panoId: "LtngR9KxkuXFKCGzhYLuaQ",
    place: "Near Havelock, North Carolina",
    shortName: "Havelock",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NC",
    state: "North Carolina",
    difficulty: "classic",
    pools: ["world","North America","US","US-NC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nc-038",
    lat: 35.292308,
    lng: -81.535522,
    panoId: "htXoSpyzMs3LvvIZDPloUA",
    place: "Near Shelby, North Carolina",
    shortName: "Shelby",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NC",
    state: "North Carolina",
    difficulty: "classic",
    pools: ["world","North America","US","US-NC"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-nc-039",
    lat: 34.255288,
    lng: -77.945578,
    panoId: "V66wrP-wGcmIkPifu5yyGQ",
    place: "Near Wilmington, North Carolina",
    shortName: "Wilmington",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NC",
    state: "North Carolina",
    difficulty: "classic",
    pools: ["world","North America","US","US-NC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nc-040",
    lat: 34.992018,
    lng: -80.569371,
    panoId: "RP6PURCHcfBBHycuoFgO1Q",
    place: "Near Monroe, North Carolina",
    shortName: "Monroe",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NC",
    state: "North Carolina",
    difficulty: "classic",
    pools: ["world","North America","US","US-NC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nc-041",
    lat: 36.106082,
    lng: -79.449308,
    panoId: "QYOKocPStqIon8M8Kd9rdA",
    place: "Near Burlington, North Carolina",
    shortName: "Burlington",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NC",
    state: "North Carolina",
    difficulty: "classic",
    pools: ["world","North America","US","US-NC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nc-042",
    lat: 35.715621,
    lng: -78.591524,
    panoId: "bABm8PT6iu4L2d5S9ltJtg",
    place: "Near Garner, North Carolina",
    shortName: "Garner",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NC",
    state: "North Carolina",
    difficulty: "classic",
    pools: ["world","North America","US","US-NC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nc-043",
    lat: 35.902395,
    lng: -79.034056,
    panoId: "9m9ivV-ujCqfMJb39leX1g",
    place: "Near Chapel Hill, North Carolina",
    shortName: "Chapel Hill",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NC",
    state: "North Carolina",
    difficulty: "classic",
    pools: ["world","North America","US","US-NC"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-nc-044",
    lat: 35.996772,
    lng: -78.916397,
    panoId: "ilvG_zmhtrBDlnAHwM6FtA",
    place: "Near Durham, North Carolina",
    shortName: "Durham",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NC",
    state: "North Carolina",
    difficulty: "classic",
    pools: ["world","North America","US","US-NC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nc-045",
    lat: 35.987804,
    lng: -78.515708,
    panoId: "Aw1SARwBNauAoxpskBghOQ",
    place: "Near Wake Forest, North Carolina",
    shortName: "Wake Forest",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NC",
    state: "North Carolina",
    difficulty: "classic",
    pools: ["world","North America","US","US-NC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nc-046",
    lat: 35.865062,
    lng: -80.094011,
    panoId: "Wa0gg_d7gnpmwiw5joOGIw",
    place: "Near Thomasville, North Carolina",
    shortName: "Thomasville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NC",
    state: "North Carolina",
    difficulty: "classic",
    pools: ["world","North America","US","US-NC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nc-047",
    lat: 35.271935,
    lng: -77.568871,
    panoId: "zTtTVBNl9T6IVghW7HfQdA",
    place: "Near Kinston, North Carolina",
    shortName: "Kinston",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NC",
    state: "North Carolina",
    difficulty: "classic",
    pools: ["world","North America","US","US-NC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nc-048",
    lat: 35.231119,
    lng: -80.818167,
    panoId: "zX0G0_xgJ5R_m1tYKnxyqQ",
    place: "Near Charlotte, North Carolina",
    shortName: "Charlotte",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NC",
    state: "North Carolina",
    difficulty: "classic",
    pools: ["world","North America","US","US-NC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nc-049",
    lat: 35.784101,
    lng: -80.86338,
    panoId: "npxL6K2WOeDDSn-RCEAd-w",
    place: "Near Statesville, North Carolina",
    shortName: "Statesville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NC",
    state: "North Carolina",
    difficulty: "classic",
    pools: ["world","North America","US","US-NC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nc-050",
    lat: 35.847098,
    lng: -78.777423,
    panoId: "Zg1xhAWKk_4W-hwuyKG9qw",
    place: "Near Morrisville, North Carolina",
    shortName: "Morrisville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NC",
    state: "North Carolina",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nc-051",
    lat: 35.832514,
    lng: -80.919645,
    panoId: "2N17QK9LgwaHTryZ0_Nf7A",
    place: "Near Statesville, North Carolina",
    shortName: "Statesville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NC",
    state: "North Carolina",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nc-052",
    lat: 36.107286,
    lng: -79.742156,
    panoId: "nzk3XIGtniDA-nTNzp9xrw",
    place: "Near Greensboro, North Carolina",
    shortName: "Greensboro",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NC",
    state: "North Carolina",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nc-053",
    lat: 35.098694,
    lng: -78.953523,
    panoId: "4f85913a7yhm2Eb6VQmzwA",
    place: "Near Fort Bragg, North Carolina",
    shortName: "Fort Bragg",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NC",
    state: "North Carolina",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nc-054",
    lat: 35.335113,
    lng: -78.026866,
    panoId: "LCfvCmwrrXUNy6KENuPdVg",
    place: "Near Mar-Mac, North Carolina",
    shortName: "Mar-Mac",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NC",
    state: "North Carolina",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nc-055",
    lat: 36.088394,
    lng: -80.103645,
    panoId: "vHKQIcdveRQVauRF4ro80g",
    place: "Near Kernersville, North Carolina",
    shortName: "Kernersville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NC",
    state: "North Carolina",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nc-056",
    lat: 35.671248,
    lng: -77.893027,
    panoId: "6ZaYre9mpZiC5S1OQaBCpw",
    place: "Near Wilson, North Carolina",
    shortName: "Wilson",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NC",
    state: "North Carolina",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nc-057",
    lat: 35.623231,
    lng: -77.411871,
    panoId: "Qv4oBeiFsYBXkPji8LYfPg",
    place: "Near Greenville, North Carolina",
    shortName: "Greenville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NC",
    state: "North Carolina",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nc-058",
    lat: 35.719312,
    lng: -78.676018,
    panoId: "BWKw4En6Jqm0xsxPrWujEQ",
    place: "Near Garner, North Carolina",
    shortName: "Garner",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NC",
    state: "North Carolina",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nc-059",
    lat: 36.065491,
    lng: -80.305167,
    panoId: "LSqse0gusrECIIH71uFGZQ",
    place: "Near Winston-Salem, North Carolina",
    shortName: "Winston-Salem",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NC",
    state: "North Carolina",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nc-060",
    lat: 35.381876,
    lng: -80.56373,
    panoId: "OCFXLoHsiVCprfKASx_SfQ",
    place: "Near Concord, North Carolina",
    shortName: "Concord",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NC",
    state: "North Carolina",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NC"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-nc-061",
    lat: 35.644289,
    lng: -80.517097,
    panoId: "7HwNG_L5aDHvxcgZlriY5A",
    place: "Near Salisbury, North Carolina",
    shortName: "Salisbury",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NC",
    state: "North Carolina",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nc-062",
    lat: 35.565938,
    lng: -78.852391,
    panoId: "IRGBHDOj6d5TwAsjE2mlCw",
    place: "Near Fuquay-Varina, North Carolina",
    shortName: "Fuquay-Varina",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NC",
    state: "North Carolina",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nc-063",
    lat: 35.348918,
    lng: -81.520234,
    panoId: "TahH0UqT6JnP3bS6w7JhNQ",
    place: "Near Shelby, North Carolina",
    shortName: "Shelby",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NC",
    state: "North Carolina",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nc-064",
    lat: 35.284805,
    lng: -81.219981,
    panoId: "jW2k1IHFeJIoN_uMpbVScQ",
    place: "Near Gastonia, North Carolina",
    shortName: "Gastonia",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NC",
    state: "North Carolina",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nc-065",
    lat: 35.656367,
    lng: -78.87048,
    panoId: "9JHb-YJjGBEoESS8wZedwg",
    place: "Near Holly Springs, North Carolina",
    shortName: "Holly Springs",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NC",
    state: "North Carolina",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nc-066",
    lat: 35.850288,
    lng: -78.800034,
    panoId: "1MXFpdsw2oRvYS0HYxbkQg",
    place: "Near Morrisville, North Carolina",
    shortName: "Morrisville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NC",
    state: "North Carolina",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nc-067",
    lat: 35.992637,
    lng: -77.756306,
    panoId: "a82ynXhBE6Ab86-bWxv2Rw",
    place: "Near Rocky Mount, North Carolina",
    shortName: "Rocky Mount",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NC",
    state: "North Carolina",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nc-068",
    lat: 35.955176,
    lng: -78.99987,
    panoId: "sx_PxIa_vhl5zKS5Ez2fcg",
    place: "Near Chapel Hill, North Carolina",
    shortName: "Chapel Hill",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NC",
    state: "North Carolina",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nc-069",
    lat: 35.722778,
    lng: -79.750904,
    panoId: "8FjRrNwRQetzukHTU-hGew",
    place: "Near Franklinville, North Carolina",
    shortName: "Franklinville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NC",
    state: "North Carolina",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nc-070",
    lat: 34.627745,
    lng: -79.057886,
    panoId: "K9FOIj-jSklMGc2Wxn0Juw",
    place: "Near Lumberton, North Carolina",
    shortName: "Lumberton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NC",
    state: "North Carolina",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nc-071",
    lat: 35.762485,
    lng: -81.368526,
    panoId: "IEoc7glz6UcQNLtQIzMJJw",
    place: "Near Northlakes, North Carolina",
    shortName: "Northlakes",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NC",
    state: "North Carolina",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nc-072",
    lat: 35.803498,
    lng: -78.742091,
    panoId: "rPPQ23_VIU7o_bPWlZFjyg",
    place: "Near Cary, North Carolina",
    shortName: "Cary",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NC",
    state: "North Carolina",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NC"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-nc-073",
    lat: 35.604634,
    lng: -82.516222,
    panoId: "on4kSBO1fcZBZ1xU83oA0Q",
    place: "Near Asheville, North Carolina",
    shortName: "Asheville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NC",
    state: "North Carolina",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nc-074",
    lat: 35.146355,
    lng: -76.976085,
    panoId: "SaUgVAJnm1cfeMX-bZbZOw",
    place: "Near New Bern, North Carolina",
    shortName: "New Bern",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NC",
    state: "North Carolina",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nc-075",
    lat: 34.968566,
    lng: -80.605065,
    panoId: "l2umxXmy6IFeOnOJIv9Mbg",
    place: "Near Monroe, North Carolina",
    shortName: "Monroe",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NC",
    state: "North Carolina",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nc-076",
    lat: 34.800731,
    lng: -76.924712,
    panoId: "IxwmCLwn-OvzNIIWyFjZ3w",
    place: "Near Newport, North Carolina",
    shortName: "Newport",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NC",
    state: "North Carolina",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NC"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-nc-077",
    lat: 36.038261,
    lng: -79.83381,
    panoId: "Tl2ZYwMO4Az4w4O8wsFDHQ",
    place: "Near Greensboro, North Carolina",
    shortName: "Greensboro",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NC",
    state: "North Carolina",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nc-078",
    lat: 36.033233,
    lng: -79.435854,
    panoId: "xaotnn7GFip8eyFYv6GREw",
    place: "Near Graham, North Carolina",
    shortName: "Graham",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NC",
    state: "North Carolina",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nc-079",
    lat: 35.509325,
    lng: -79.119448,
    panoId: "BQbs02Vr6xssrE5yn6BbwA",
    place: "Near Sanford, North Carolina",
    shortName: "Sanford",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NC",
    state: "North Carolina",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nc-080",
    lat: 35.607511,
    lng: -77.404546,
    panoId: "jBWbwpCFLt_1R2_1JUGJXg",
    place: "Near Greenville, North Carolina",
    shortName: "Greenville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NC",
    state: "North Carolina",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NC"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-nc-081",
    lat: 35.937499,
    lng: -78.573353,
    panoId: "LQ34IBWakl_k3VzRtM967w",
    place: "Near Wake Forest, North Carolina",
    shortName: "Wake Forest",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NC",
    state: "North Carolina",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NC"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-nc-082",
    lat: 35.958735,
    lng: -78.965412,
    panoId: "jEqIX3355l682zGJ4qsdTw",
    place: "Near Durham, North Carolina",
    shortName: "Durham",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NC",
    state: "North Carolina",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nc-083",
    lat: 35.924804,
    lng: -79.127674,
    panoId: "lqI-_PjU0suHLr9TVfSHiA",
    place: "Near Carrboro, North Carolina",
    shortName: "Carrboro",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NC",
    state: "North Carolina",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nc-084",
    lat: 35.345525,
    lng: -78.010502,
    panoId: "NZT766fc7eKxTK68Jj9Etg",
    place: "Near Mar-Mac, North Carolina",
    shortName: "Mar-Mac",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NC",
    state: "North Carolina",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nc-085",
    lat: 35.535468,
    lng: -78.841602,
    panoId: "xhyWTW4BmkhxDT3PcEyhmg",
    place: "Near Fuquay-Varina, North Carolina",
    shortName: "Fuquay-Varina",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NC",
    state: "North Carolina",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nc-086",
    lat: 34.228184,
    lng: -78.028437,
    panoId: "zUcB7ElPiM6RsEDm65QxPg",
    place: "Near Leland, North Carolina",
    shortName: "Leland",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NC",
    state: "North Carolina",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nc-087",
    lat: 35.982622,
    lng: -80.445994,
    panoId: "j8BDeoRv_1Y1U-g2JQhVQg",
    place: "Near Bermuda Run, North Carolina",
    shortName: "Bermuda Run",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NC",
    state: "North Carolina",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nc-088",
    lat: 35.197166,
    lng: -80.771728,
    panoId: "284_kqb38zfmq7IGoHa_jQ",
    place: "Near Charlotte, North Carolina",
    shortName: "Charlotte",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NC",
    state: "North Carolina",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nc-089",
    lat: 35.232891,
    lng: -77.568693,
    panoId: "xG8oOcXiMHASAaX1q9DnJw",
    place: "Near Kinston, North Carolina",
    shortName: "Kinston",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NC",
    state: "North Carolina",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nc-090",
    lat: 35.741317,
    lng: -77.873958,
    panoId: "QJhERfyagVBmdLItXrl0gw",
    place: "Near Wilson, North Carolina",
    shortName: "Wilson",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NC",
    state: "North Carolina",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nc-091",
    lat: 35.85927,
    lng: -78.823574,
    panoId: "WILlnzdwfiqe6q_gLlCj5Q",
    place: "Near Morrisville, North Carolina",
    shortName: "Morrisville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NC",
    state: "North Carolina",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NC"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-nc-092",
    lat: 34.728545,
    lng: -77.483483,
    panoId: "xrgekkapsHhixSUHCoHrBg",
    place: "Near Jacksonville, North Carolina",
    shortName: "Jacksonville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NC",
    state: "North Carolina",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nc-093",
    lat: 35.74,
    lng: -79.80437,
    panoId: "2F6pxSXThdMZfvGQxwhlBA",
    place: "Near Asheboro, North Carolina",
    shortName: "Asheboro",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NC",
    state: "North Carolina",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nc-094",
    lat: 34.585381,
    lng: -79.085196,
    panoId: "URf4v7JaDtpMno9v0zj9Cw",
    place: "Near Lumberton, North Carolina",
    shortName: "Lumberton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NC",
    state: "North Carolina",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nc-095",
    lat: 35.645803,
    lng: -80.313166,
    panoId: "fzP88jPyRBxnj-6I6XFOQA",
    place: "Near Southmont, North Carolina",
    shortName: "Southmont",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NC",
    state: "North Carolina",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nc-096",
    lat: 36.36189,
    lng: -79.855239,
    panoId: "26DYmRxi153qNRmjISyAIg",
    place: "Near Wentworth, North Carolina",
    shortName: "Wentworth",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NC",
    state: "North Carolina",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nc-097",
    lat: 36.082185,
    lng: -80.082463,
    panoId: "yLRxped71opS_UB3visUIA",
    place: "Near Kernersville, North Carolina",
    shortName: "Kernersville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NC",
    state: "North Carolina",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nc-098",
    lat: 35.122257,
    lng: -76.918233,
    panoId: "aK-MSehTRa7XnJfbUoDJ4g",
    place: "Near Fairfield Harbour, North Carolina",
    shortName: "Fairfield Harbour",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NC",
    state: "North Carolina",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nc-099",
    lat: 35.992312,
    lng: -79.954587,
    panoId: "iMquHdqGPIZeIrSGTHvFpw",
    place: "Near Jamestown, North Carolina",
    shortName: "Jamestown",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NC",
    state: "North Carolina",
    difficulty: "explorer",
    pools: ["world","North America","US","US-NC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nc-100",
    lat: 35.502706,
    lng: -80.254898,
    panoId: "XsG9HjqIuN5B5s9LrSY6uQ",
    place: "Near Rockwell, North Carolina",
    shortName: "Rockwell",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NC",
    state: "North Carolina",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-NC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nc-101",
    lat: 36.37447,
    lng: -76.439211,
    panoId: "Pk3nzwkbwVx6F4PBwPOCtg",
    place: "Near Elizabeth City, North Carolina",
    shortName: "Elizabeth City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NC",
    state: "North Carolina",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-NC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nc-102",
    lat: 35.130168,
    lng: -82.439855,
    panoId: "mgfjWEs8dzlCluEeUzOaSA",
    place: "Near Tigerville, North Carolina",
    shortName: "Tigerville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NC",
    state: "North Carolina",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-NC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nc-103",
    lat: 35.286226,
    lng: -79.257884,
    panoId: "cSNwE1MZCToOdo_B-PUI8w",
    place: "Near Whispering Pines, North Carolina",
    shortName: "Whispering Pines",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NC",
    state: "North Carolina",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-NC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nc-104",
    lat: 36.486789,
    lng: -76.304574,
    panoId: "Azzp8evp8oa4pCI4D8lXlw",
    place: "Near Moyock, North Carolina",
    shortName: "Moyock",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NC",
    state: "North Carolina",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-NC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nc-105",
    lat: 36.315796,
    lng: -78.223937,
    panoId: "8eZu0CH0w-jWWhyVKWl7gQ",
    place: "Near Warrenton, North Carolina",
    shortName: "Warrenton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "NC",
    state: "North Carolina",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-NC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nd-000",
    lat: 48.112809,
    lng: -98.865192,
    panoId: "Kxg-dZMRI98O0tyePePs3A",
    place: "Near Devils Lake, North Dakota",
    shortName: "Devils Lake",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ND",
    state: "North Dakota",
    difficulty: "classic",
    pools: ["world","North America","US","US-ND"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nd-001",
    lat: 46.877221,
    lng: -96.789804,
    panoId: "M2UBa5z5pj2kYb7bA4Dysg",
    place: "Near Fargo, North Dakota",
    shortName: "Fargo",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ND",
    state: "North Dakota",
    difficulty: "classic",
    pools: ["world","North America","US","US-ND"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nd-002",
    lat: 46.874794,
    lng: -96.900381,
    panoId: "qRWJXUG487k-U3Oe_Plgfg",
    place: "Near West Fargo, North Dakota",
    shortName: "West Fargo",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ND",
    state: "North Dakota",
    difficulty: "classic",
    pools: ["world","North America","US","US-ND"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nd-003",
    lat: 46.808555,
    lng: -100.783758,
    panoId: "Q2dTPgORKV432AI-YqikRQ",
    place: "Near Bismarck, North Dakota",
    shortName: "Bismarck",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ND",
    state: "North Dakota",
    difficulty: "classic",
    pools: ["world","North America","US","US-ND"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nd-004",
    lat: 47.92521,
    lng: -97.032832,
    panoId: "6WPVI9MoxfeyA3MzI0Sg9Q",
    place: "Near Grand Forks, North Dakota",
    shortName: "Grand Forks",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ND",
    state: "North Dakota",
    difficulty: "classic",
    pools: ["world","North America","US","US-ND"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nd-005",
    lat: 48.146836,
    lng: -103.617932,
    panoId: "S_W97OJznfK-v0FbrlusXA",
    place: "Near Williston, North Dakota",
    shortName: "Williston",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ND",
    state: "North Dakota",
    difficulty: "classic",
    pools: ["world","North America","US","US-ND"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nd-006",
    lat: 46.879219,
    lng: -102.789867,
    panoId: "Lg38H1FlZxxbccAIrKmy0Q",
    place: "Near Dickinson, North Dakota",
    shortName: "Dickinson",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ND",
    state: "North Dakota",
    difficulty: "classic",
    pools: ["world","North America","US","US-ND"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nd-007",
    lat: 46.264987,
    lng: -96.605888,
    panoId: "3Y7GdpInOF8nyaDZqwm5uw",
    place: "Near Wahpeton, North Dakota",
    shortName: "Wahpeton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ND",
    state: "North Dakota",
    difficulty: "classic",
    pools: ["world","North America","US","US-ND"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nd-008",
    lat: 46.923322,
    lng: -98.003198,
    panoId: "-Epnm-aJ5rxD7NLkgaKMhA",
    place: "Near Valley City, North Dakota",
    shortName: "Valley City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ND",
    state: "North Dakota",
    difficulty: "classic",
    pools: ["world","North America","US","US-ND"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nd-009",
    lat: 48.232432,
    lng: -101.296311,
    panoId: "R1agnsxJjDFJdPZCvtu1GQ",
    place: "Near Minot, North Dakota",
    shortName: "Minot",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ND",
    state: "North Dakota",
    difficulty: "classic",
    pools: ["world","North America","US","US-ND"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nd-010",
    lat: 47.802298,
    lng: -103.283217,
    panoId: "SVjR6D5TiV64ZJ_f90pUxA",
    place: "Near Watford City, North Dakota",
    shortName: "Watford City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ND",
    state: "North Dakota",
    difficulty: "classic",
    pools: ["world","North America","US","US-ND"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nd-011",
    lat: 46.910532,
    lng: -98.708565,
    panoId: "nqMb2C48P1KllS1xkWF0ew",
    place: "Near Jamestown, North Dakota",
    shortName: "Jamestown",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ND",
    state: "North Dakota",
    difficulty: "classic",
    pools: ["world","North America","US","US-ND"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nd-012",
    lat: 46.826596,
    lng: -100.889746,
    panoId: "ojbIBQwCuzfz9GqxbVcfeQ",
    place: "Near Mandan, North Dakota",
    shortName: "Mandan",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ND",
    state: "North Dakota",
    difficulty: "classic",
    pools: ["world","North America","US","US-ND"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nd-013",
    lat: 46.894411,
    lng: -96.804143,
    panoId: "PIY_t3-wcba3UQFhghSo4g",
    place: "Near Fargo, North Dakota",
    shortName: "Fargo",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ND",
    state: "North Dakota",
    difficulty: "classic",
    pools: ["world","North America","US","US-ND"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nd-014",
    lat: 46.829988,
    lng: -100.90459,
    panoId: "9kZ3r7lJNCDI48lVE2C_5Q",
    place: "Near Mandan, North Dakota",
    shortName: "Mandan",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ND",
    state: "North Dakota",
    difficulty: "classic",
    pools: ["world","North America","US","US-ND"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nd-015",
    lat: 46.864057,
    lng: -102.775184,
    panoId: "0z3TtLCU29FFNOF3JxHH-w",
    place: "Near Dickinson, North Dakota",
    shortName: "Dickinson",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ND",
    state: "North Dakota",
    difficulty: "classic",
    pools: ["world","North America","US","US-ND"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nd-016",
    lat: 47.940672,
    lng: -97.02453,
    panoId: "_R8RYbEdDyjc4k1T6_DZHg",
    place: "Near East Grand Forks, North Dakota",
    shortName: "East Grand Forks",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ND",
    state: "North Dakota",
    difficulty: "classic",
    pools: ["world","North America","US","US-ND"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-nd-017",
    lat: 47.819457,
    lng: -103.294477,
    panoId: "obSB5Mnlr6XZC3NB6BoaqA",
    place: "Near Watford City, North Dakota",
    shortName: "Watford City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ND",
    state: "North Dakota",
    difficulty: "classic",
    pools: ["world","North America","US","US-ND"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nd-018",
    lat: 48.216203,
    lng: -101.30861,
    panoId: "cINDpS6OFbFyFi5Lco-2jA",
    place: "Near Minot, North Dakota",
    shortName: "Minot",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ND",
    state: "North Dakota",
    difficulty: "classic",
    pools: ["world","North America","US","US-ND"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nd-019",
    lat: 46.89565,
    lng: -102.778564,
    panoId: "tBfvpsOOLbjtiUEQGT6g9g",
    place: "Near Dickinson, North Dakota",
    shortName: "Dickinson",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ND",
    state: "North Dakota",
    difficulty: "classic",
    pools: ["world","North America","US","US-ND"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nd-020",
    lat: 46.820834,
    lng: -100.857485,
    panoId: "6ATggyijHrREuCi2XTT7UA",
    place: "Near Mandan, North Dakota",
    shortName: "Mandan",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ND",
    state: "North Dakota",
    difficulty: "classic",
    pools: ["world","North America","US","US-ND"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nd-021",
    lat: 46.883578,
    lng: -96.869643,
    panoId: "JdMN1RSfzwA5-qAPh3f7Jw",
    place: "Near West Fargo, North Dakota",
    shortName: "West Fargo",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ND",
    state: "North Dakota",
    difficulty: "classic",
    pools: ["world","North America","US","US-ND"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nd-022",
    lat: 48.317346,
    lng: -102.390475,
    panoId: "-zcUVtHpOBiN1j1-jQotjg",
    place: "Near Stanley, North Dakota",
    shortName: "Stanley",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ND",
    state: "North Dakota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ND"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nd-023",
    lat: 46.183061,
    lng: -103.394985,
    panoId: "9EkebL1RXdCDObR8OYqJcA",
    place: "Near Bowman, North Dakota",
    shortName: "Bowman",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ND",
    state: "North Dakota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ND"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nd-024",
    lat: 48.914218,
    lng: -103.294787,
    panoId: "4yVPLOaGP4NWxBE_NrRn2Q",
    place: "Near Crosby, North Dakota",
    shortName: "Crosby",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ND",
    state: "North Dakota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ND"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nd-025",
    lat: 47.498041,
    lng: -97.3246,
    panoId: "odKwJjCTLfdYe62R-ZcH3g",
    place: "Near Mayville, North Dakota",
    shortName: "Mayville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ND",
    state: "North Dakota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ND"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nd-026",
    lat: 47.294403,
    lng: -101.622724,
    panoId: "SjeQHE6C5Q5SzsgLVYcWQQ",
    place: "Near Hazen, North Dakota",
    shortName: "Hazen",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ND",
    state: "North Dakota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ND"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nd-027",
    lat: 48.760039,
    lng: -98.368236,
    panoId: "wM0Mu6Sc0V_Hjq1-tb1-6Q",
    place: "Near Langdon, North Dakota",
    shortName: "Langdon",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ND",
    state: "North Dakota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ND"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nd-028",
    lat: 48.412441,
    lng: -97.410675,
    panoId: "w1FA1W62Nx1Tx4YOncCZQg",
    place: "Near Grafton, North Dakota",
    shortName: "Grafton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ND",
    state: "North Dakota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ND"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nd-029",
    lat: 46.762667,
    lng: -100.699948,
    panoId: "lxUUdRWluzC_j-jau-c7lw",
    place: "Near Lincoln, North Dakota",
    shortName: "Lincoln",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ND",
    state: "North Dakota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ND"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nd-030",
    lat: 48.839193,
    lng: -99.744944,
    panoId: "12uZhS9BIEZ0BwXYWfKF4g",
    place: "Near Belcourt, North Dakota",
    shortName: "Belcourt",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ND",
    state: "North Dakota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ND"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nd-031",
    lat: 47.652222,
    lng: -101.415841,
    panoId: "flZsmEon3r0ZcNoSvL-Thw",
    place: "Near Garrison, North Dakota",
    shortName: "Garrison",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ND",
    state: "North Dakota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ND"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nd-032",
    lat: 47.769705,
    lng: -99.935496,
    panoId: "fFTe5eeEuAYEa9QKgDCt6Q",
    place: "Near Harvey, North Dakota",
    shortName: "Harvey",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ND",
    state: "North Dakota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ND"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nd-033",
    lat: 46.758795,
    lng: -96.903729,
    panoId: "eqbMg_OA9rPsVVn19mmexQ",
    place: "Near Horace, North Dakota",
    shortName: "Horace",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ND",
    state: "North Dakota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ND"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nd-034",
    lat: 47.449726,
    lng: -99.126307,
    panoId: "kA7xq2F2NqLV5NalitTrOA",
    place: "Near Carrington, North Dakota",
    shortName: "Carrington",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ND",
    state: "North Dakota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ND"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nd-035",
    lat: 46.441505,
    lng: -97.681191,
    panoId: "aaMQlpH_TGbgoWSIQRkUrg",
    place: "Near Lisbon, North Dakota",
    shortName: "Lisbon",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ND",
    state: "North Dakota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ND"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nd-036",
    lat: 46.900526,
    lng: -97.211244,
    panoId: "_0ijoMZyt2F8B0DplLfGbA",
    place: "Near Casselton, North Dakota",
    shortName: "Casselton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ND",
    state: "North Dakota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ND"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nd-037",
    lat: 47.40396,
    lng: -97.061444,
    panoId: "gDa7s0NKCvIvWjy3IWH6Yw",
    place: "Near Hillsboro, North Dakota",
    shortName: "Hillsboro",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ND",
    state: "North Dakota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ND"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nd-038",
    lat: 47.263313,
    lng: -101.777937,
    panoId: "EROhwbU0QWird5yQ3grp-w",
    place: "Near Beulah, North Dakota",
    shortName: "Beulah",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ND",
    state: "North Dakota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ND"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nd-039",
    lat: 48.827323,
    lng: -100.445668,
    panoId: "c5lfJMA9ztFYlQw4rQlWVg",
    place: "Near Bottineau, North Dakota",
    shortName: "Bottineau",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ND",
    state: "North Dakota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ND"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nd-040",
    lat: 47.679977,
    lng: -99.137891,
    panoId: "ZKtvYMqDc7V_2-Ak6HRq_w",
    place: "Near New Rockford, North Dakota",
    shortName: "New Rockford",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ND",
    state: "North Dakota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ND"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nd-041",
    lat: 46.138579,
    lng: -98.090553,
    panoId: "pdPSpqEjlOab817uAYwWJw",
    place: "Near Oakes, North Dakota",
    shortName: "Oakes",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ND",
    state: "North Dakota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ND"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nd-042",
    lat: 48.368918,
    lng: -99.996104,
    panoId: "0RDWlJz0C3mL0tv64q4dgg",
    place: "Near Rugby, North Dakota",
    shortName: "Rugby",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ND",
    state: "North Dakota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ND"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nd-043",
    lat: 48.397283,
    lng: -102.938215,
    panoId: "RlWCiNdPGQReTlQqGQp2vA",
    place: "Near Tioga, North Dakota",
    shortName: "Tioga",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ND",
    state: "North Dakota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ND"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nd-044",
    lat: 48.398588,
    lng: -97.741137,
    panoId: "EbLi2j8e01Ro0LQQIfkSQg",
    place: "Near Park River, North Dakota",
    shortName: "Park River",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ND",
    state: "North Dakota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ND"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nd-045",
    lat: 48.375768,
    lng: -99.980274,
    panoId: "h8VpGrHIklgvaqJ0huhnpg",
    place: "Near Rugby, North Dakota",
    shortName: "Rugby",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ND",
    state: "North Dakota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ND"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nd-046",
    lat: 48.775881,
    lng: -98.365171,
    panoId: "Wl_wz92phihDPXpqQ1bHpQ",
    place: "Near Langdon, North Dakota",
    shortName: "Langdon",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ND",
    state: "North Dakota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ND"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nd-047",
    lat: 48.236495,
    lng: -101.133439,
    panoId: "fh-W7oKqbAh4YwbDIawfcQ",
    place: "Near Surrey, North Dakota",
    shortName: "Surrey",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ND",
    state: "North Dakota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ND"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nd-048",
    lat: 46.77377,
    lng: -96.899524,
    panoId: "gmvAycLhJ_F9Gil4ESjIyA",
    place: "Near Horace, North Dakota",
    shortName: "Horace",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ND",
    state: "North Dakota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ND"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nd-049",
    lat: 48.848802,
    lng: -99.750914,
    panoId: "dO4G7UDTA3ZE7AdrrvkyVw",
    place: "Near Belcourt, North Dakota",
    shortName: "Belcourt",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ND",
    state: "North Dakota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ND"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nd-050",
    lat: 47.258698,
    lng: -101.764505,
    panoId: "HV8Up1GZd5SsOViMQqgt1w",
    place: "Near Beulah, North Dakota",
    shortName: "Beulah",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ND",
    state: "North Dakota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ND"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nd-051",
    lat: 47.29469,
    lng: -101.643998,
    panoId: "C5tm5eAJODUWdxfyK1pD0Q",
    place: "Near Hazen, North Dakota",
    shortName: "Hazen",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ND",
    state: "North Dakota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ND"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nd-052",
    lat: 46.427781,
    lng: -97.677314,
    panoId: "jaa072wsL2afv_ut0tffwA",
    place: "Near Lisbon, North Dakota",
    shortName: "Lisbon",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ND",
    state: "North Dakota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ND"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nd-053",
    lat: 48.144931,
    lng: -103.668371,
    panoId: "gPIoB1fvNmzX_zY6XLKS9w",
    place: "Near Williston, North Dakota",
    shortName: "Williston",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ND",
    state: "North Dakota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ND"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nd-054",
    lat: 48.470187,
    lng: -97.378227,
    panoId: "CB8tkLLf-czMMExdB928iA",
    place: "Near Grafton, North Dakota",
    shortName: "Grafton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ND",
    state: "North Dakota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ND"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nd-055",
    lat: 48.820822,
    lng: -100.52718,
    panoId: "3r2ilWxreRPl-NXsuvlmJw",
    place: "Near Bottineau, North Dakota",
    shortName: "Bottineau",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ND",
    state: "North Dakota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ND"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nd-056",
    lat: 48.339784,
    lng: -102.376782,
    panoId: "ebh_W-2MYAM-k0LdKvvigg",
    place: "Near Stanley, North Dakota",
    shortName: "Stanley",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ND",
    state: "North Dakota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ND"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nd-057",
    lat: 46.249416,
    lng: -96.525889,
    panoId: "LuoUnXRKFFR2t_xN5-zJVw",
    place: "Near Breckenridge, North Dakota",
    shortName: "Breckenridge",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ND",
    state: "North Dakota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ND"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nd-058",
    lat: 47.379929,
    lng: -99.138596,
    panoId: "Gf43Bsb1ckC2MdDZahBULQ",
    place: "Near Carrington, North Dakota",
    shortName: "Carrington",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ND",
    state: "North Dakota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ND"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nd-059",
    lat: 46.950012,
    lng: -98.7397,
    panoId: "B4PUxH7S8t887XA7MPUrmg",
    place: "Near Jamestown, North Dakota",
    shortName: "Jamestown",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ND",
    state: "North Dakota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ND"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nd-060",
    lat: 48.458828,
    lng: -101.346167,
    panoId: "l3BGYA9bagPR6fNZTHBTFg",
    place: "Near Minot Air Force Base, North Dakota",
    shortName: "Minot Air Force Base",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ND",
    state: "North Dakota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ND"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nd-061",
    lat: 46.918648,
    lng: -97.946953,
    panoId: "9CJL1hYM_8ow7QRXg-JFKg",
    place: "Near Valley City, North Dakota",
    shortName: "Valley City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ND",
    state: "North Dakota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ND"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nd-062",
    lat: 47.989456,
    lng: -102.505784,
    panoId: "yDzwKRJt8vnRrFG62k9eEw",
    place: "Near New Town, North Dakota",
    shortName: "New Town",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ND",
    state: "North Dakota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ND"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nd-063",
    lat: 48.420501,
    lng: -102.907484,
    panoId: "gQo8P9NvCkCl2z8RmIVgEg",
    place: "Near Tioga, North Dakota",
    shortName: "Tioga",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ND",
    state: "North Dakota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ND"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nd-064",
    lat: 46.751806,
    lng: -100.784469,
    panoId: "4fcCJlDIrZfQW6at-8lDLQ",
    place: "Near Bismarck, North Dakota",
    shortName: "Bismarck",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ND",
    state: "North Dakota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ND"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nd-065",
    lat: 46.868879,
    lng: -96.85469,
    panoId: "1oJCg41Gm1J_Nz_cCwTwkw",
    place: "Near West Fargo, North Dakota",
    shortName: "West Fargo",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ND",
    state: "North Dakota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ND"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nd-066",
    lat: 46.467675,
    lng: -97.743173,
    panoId: "BzpDC6LrTWdeO2YmzvZ2EQ",
    place: "Near Lisbon, North Dakota",
    shortName: "Lisbon",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ND",
    state: "North Dakota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ND"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nd-067",
    lat: 46.138917,
    lng: -98.160956,
    panoId: "7yALgpf7UHuOf2tdRrvflg",
    place: "Near Oakes, North Dakota",
    shortName: "Oakes",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ND",
    state: "North Dakota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ND"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nd-068",
    lat: 47.41071,
    lng: -97.017101,
    panoId: "bGZbMSQXPMncsB1PV3hMwA",
    place: "Near Hillsboro, North Dakota",
    shortName: "Hillsboro",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ND",
    state: "North Dakota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ND"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nd-069",
    lat: 48.388932,
    lng: -99.993692,
    panoId: "qwxAbrYr5KoSuu5Aj4ZSGQ",
    place: "Near Rugby, North Dakota",
    shortName: "Rugby",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ND",
    state: "North Dakota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ND"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nd-070",
    lat: 47.293738,
    lng: -101.813835,
    panoId: "_EeD8sB3rALA9TzAYCXwXA",
    place: "Near Beulah, North Dakota",
    shortName: "Beulah",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ND",
    state: "North Dakota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ND"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nd-071",
    lat: 46.759562,
    lng: -100.735214,
    panoId: "LI05GZKuXJEWxujHOqwCbQ",
    place: "Near Lincoln, North Dakota",
    shortName: "Lincoln",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ND",
    state: "North Dakota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-ND"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nd-072",
    lat: 47.539216,
    lng: -97.089937,
    panoId: "qpdZHUDWuaH5GgEsuftgLQ",
    place: "Near Hillsboro, North Dakota",
    shortName: "Hillsboro",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ND",
    state: "North Dakota",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-ND"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nd-073",
    lat: 47.521267,
    lng: -101.449886,
    panoId: "xg5YB4oWCd3oWBud0ekspg",
    place: "Near Garrison, North Dakota",
    shortName: "Garrison",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ND",
    state: "North Dakota",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-ND"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nd-074",
    lat: 46.953882,
    lng: -97.366627,
    panoId: "sPox8fmpL5svLvEIMlKo_w",
    place: "Near Casselton, North Dakota",
    shortName: "Casselton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ND",
    state: "North Dakota",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-ND"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nd-075",
    lat: 47.74558,
    lng: -99.36437,
    panoId: "-uiEnh-1latf0xJAqhXHyw",
    place: "Near New Rockford, North Dakota",
    shortName: "New Rockford",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ND",
    state: "North Dakota",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-ND"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nd-076",
    lat: 48.255727,
    lng: -103.437155,
    panoId: "8pjLP1dlISczLdn-PkD_xQ",
    place: "Near Williston, North Dakota",
    shortName: "Williston",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ND",
    state: "North Dakota",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-ND"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nd-077",
    lat: 47.695891,
    lng: -101.164562,
    panoId: "ZAOopFlkchuPJgFc2KQXyg",
    place: "Near Garrison, North Dakota",
    shortName: "Garrison",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ND",
    state: "North Dakota",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-ND"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nd-078",
    lat: 48.152835,
    lng: -100.876517,
    panoId: "_tkRLwWHHR4ijYfrlDk8_g",
    place: "Near Velva, North Dakota",
    shortName: "Velva",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ND",
    state: "North Dakota",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-ND"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-nd-079",
    lat: 46.801671,
    lng: -97.346002,
    panoId: "Z2a1_SoPmchQDB9-9iobaQ",
    place: "Near Casselton, North Dakota",
    shortName: "Casselton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "ND",
    state: "North Dakota",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-ND"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-oh-000",
    lat: 41.368365,
    lng: -82.107529,
    panoId: "Hz3UMeHuumSGDm4GxDpaFg",
    place: "Near Elyria, Ohio",
    shortName: "Elyria",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OH",
    state: "Ohio",
    difficulty: "classic",
    pools: ["world","North America","US","US-OH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-oh-001",
    lat: 39.713661,
    lng: -82.599376,
    panoId: "l9nWa42gxsI6fq1m0_Sr1Q",
    place: "Near Lancaster, Ohio",
    shortName: "Lancaster",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OH",
    state: "Ohio",
    difficulty: "classic",
    pools: ["world","North America","US","US-OH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-oh-002",
    lat: 41.044095,
    lng: -83.64995,
    panoId: "AWCerK8VBo5j083uQrtdbg",
    place: "Near Findlay, Ohio",
    shortName: "Findlay",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OH",
    state: "Ohio",
    difficulty: "classic",
    pools: ["world","North America","US","US-OH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-oh-003",
    lat: 39.758946,
    lng: -84.191609,
    panoId: "y6eqjhF1cYt_af2PNEepKA",
    place: "Near Dayton, Ohio",
    shortName: "Dayton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OH",
    state: "Ohio",
    difficulty: "classic",
    pools: ["world","North America","US","US-OH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-oh-004",
    lat: 41.081258,
    lng: -81.519121,
    panoId: "XPKOWojpVLBCSRmCZ5vsrw",
    place: "Near Akron, Ohio",
    shortName: "Akron",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OH",
    state: "Ohio",
    difficulty: "classic",
    pools: ["world","North America","US","US-OH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-oh-005",
    lat: 41.404794,
    lng: -81.722761,
    panoId: "aioONODgVF32J6v0nCwwyQ",
    place: "Near Parma, Ohio",
    shortName: "Parma",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OH",
    state: "Ohio",
    difficulty: "classic",
    pools: ["world","North America","US","US-OH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-oh-006",
    lat: 39.515138,
    lng: -84.398624,
    panoId: "gBREJtjtmLipvNe3tN7QyA",
    place: "Near Middletown, Ohio",
    shortName: "Middletown",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OH",
    state: "Ohio",
    difficulty: "classic",
    pools: ["world","North America","US","US-OH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-oh-007",
    lat: 41.024216,
    lng: -80.662708,
    panoId: "Mu8kXlHsiAzOOm8hNrcqug",
    place: "Near Boardman, Ohio",
    shortName: "Boardman",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OH",
    state: "Ohio",
    difficulty: "classic",
    pools: ["world","North America","US","US-OH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-oh-008",
    lat: 40.798929,
    lng: -81.378409,
    panoId: "cqs2RZlaDTazP2ZhKxbOLw",
    place: "Near Canton, Ohio",
    shortName: "Canton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OH",
    state: "Ohio",
    difficulty: "classic",
    pools: ["world","North America","US","US-OH"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-oh-009",
    lat: 41.481851,
    lng: -81.798248,
    panoId: "92pY7THDuTGX-eFvwHyEcQ",
    place: "Near Lakewood, Ohio",
    shortName: "Lakewood",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OH",
    state: "Ohio",
    difficulty: "classic",
    pools: ["world","North America","US","US-OH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-oh-010",
    lat: 39.127245,
    lng: -84.514826,
    panoId: "loKqmEiYsufok9P9RvS6eA",
    place: "Near Cincinnati, Ohio",
    shortName: "Cincinnati",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OH",
    state: "Ohio",
    difficulty: "classic",
    pools: ["world","North America","US","US-OH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-oh-011",
    lat: 41.663949,
    lng: -83.555253,
    panoId: "oOImitQ4iNi0PUilXMvyvQ",
    place: "Near Toledo, Ohio",
    shortName: "Toledo",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OH",
    state: "Ohio",
    difficulty: "classic",
    pools: ["world","North America","US","US-OH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-oh-012",
    lat: 39.843913,
    lng: -84.124626,
    panoId: "5CytA4N_0TZrN_cBTmQxMA",
    place: "Near Huber Heights, Ohio",
    shortName: "Huber Heights",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OH",
    state: "Ohio",
    difficulty: "classic",
    pools: ["world","North America","US","US-OH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-oh-013",
    lat: 41.558374,
    lng: -81.569266,
    panoId: "hq5OHOzHciTLY48p1Dpnuw",
    place: "Near Collinwood, Ohio",
    shortName: "Collinwood",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OH",
    state: "Ohio",
    difficulty: "classic",
    pools: ["world","North America","US","US-OH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-oh-014",
    lat: 39.961162,
    lng: -82.998637,
    panoId: "xdnhS4j-4dJyAVUO7N30tA",
    place: "Near Columbus, Ohio",
    shortName: "Columbus",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OH",
    state: "Ohio",
    difficulty: "classic",
    pools: ["world","North America","US","US-OH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-oh-015",
    lat: 41.31424,
    lng: -81.835562,
    panoId: "h1Bv1Rauhrr5s1eGEmFmmg",
    place: "Near Strongsville, Ohio",
    shortName: "Strongsville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OH",
    state: "Ohio",
    difficulty: "classic",
    pools: ["world","North America","US","US-OH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-oh-016",
    lat: 39.924196,
    lng: -83.808515,
    panoId: "Yivc0EGXVBYJoTEiLxwKEQ",
    place: "Near Springfield, Ohio",
    shortName: "Springfield",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OH",
    state: "Ohio",
    difficulty: "classic",
    pools: ["world","North America","US","US-OH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-oh-017",
    lat: 40.742692,
    lng: -84.105197,
    panoId: "2nUSXHIoDE-40QomdXwqow",
    place: "Near Lima, Ohio",
    shortName: "Lima",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OH",
    state: "Ohio",
    difficulty: "classic",
    pools: ["world","North America","US","US-OH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-oh-018",
    lat: 41.159506,
    lng: -81.440354,
    panoId: "LySc1Aa8Sqz08RZPOum0DA",
    place: "Near Stow, Ohio",
    shortName: "Stow",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OH",
    state: "Ohio",
    difficulty: "classic",
    pools: ["world","North America","US","US-OH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-oh-019",
    lat: 39.399548,
    lng: -84.561255,
    panoId: "H7aze6PsqIEdMpqQ0c0vBw",
    place: "Near Hamilton, Ohio",
    shortName: "Hamilton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OH",
    state: "Ohio",
    difficulty: "classic",
    pools: ["world","North America","US","US-OH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-oh-020",
    lat: 40.588663,
    lng: -83.128548,
    panoId: "BfGQUvaGIgH44VF-OUqAvA",
    place: "Near Marion, Ohio",
    shortName: "Marion",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OH",
    state: "Ohio",
    difficulty: "classic",
    pools: ["world","North America","US","US-OH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-oh-021",
    lat: 40.29867,
    lng: -83.06779,
    panoId: "tpXsN2K08WRoxWJe3NdSfg",
    place: "Near Delaware, Ohio",
    shortName: "Delaware",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OH",
    state: "Ohio",
    difficulty: "classic",
    pools: ["world","North America","US","US-OH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-oh-022",
    lat: 41.099733,
    lng: -80.649421,
    panoId: "HKR5WxFuCHsc9wo0TnHFJw",
    place: "Near Youngstown, Ohio",
    shortName: "Youngstown",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OH",
    state: "Ohio",
    difficulty: "classic",
    pools: ["world","North America","US","US-OH"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-oh-023",
    lat: 41.666199,
    lng: -81.339954,
    panoId: "ez3cxbt88xF8nWkcpYzuYQ",
    place: "Near Mentor, Ohio",
    shortName: "Mentor",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OH",
    state: "Ohio",
    difficulty: "classic",
    pools: ["world","North America","US","US-OH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-oh-024",
    lat: 41.452809,
    lng: -82.182237,
    panoId: "3LWlYK6GAm77Pn67GqguJg",
    place: "Near Lorain, Ohio",
    shortName: "Lorain",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OH",
    state: "Ohio",
    difficulty: "classic",
    pools: ["world","North America","US","US-OH"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-oh-025",
    lat: 41.23749,
    lng: -80.818362,
    panoId: "roZ9aPKnsNKA_zDpbHVeWw",
    place: "Near Warren, Ohio",
    shortName: "Warren",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OH",
    state: "Ohio",
    difficulty: "classic",
    pools: ["world","North America","US","US-OH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-oh-026",
    lat: 41.593122,
    lng: -81.526786,
    panoId: "cgfTfps8fsh6yGlnWV36Gw",
    place: "Near Euclid, Ohio",
    shortName: "Euclid",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OH",
    state: "Ohio",
    difficulty: "classic",
    pools: ["world","North America","US","US-OH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-oh-027",
    lat: 40.758416,
    lng: -82.51549,
    panoId: "jq7GkPqvs1kk32Dn1UCg1Q",
    place: "Near Mansfield, Ohio",
    shortName: "Mansfield",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OH",
    state: "Ohio",
    difficulty: "classic",
    pools: ["world","North America","US","US-OH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-oh-028",
    lat: 39.709171,
    lng: -84.063121,
    panoId: "DO-2suOn8cwpDZd8DOqRAQ",
    place: "Near Beavercreek, Ohio",
    shortName: "Beavercreek",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OH",
    state: "Ohio",
    difficulty: "classic",
    pools: ["world","North America","US","US-OH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-oh-029",
    lat: 39.68951,
    lng: -84.168733,
    panoId: "Cp62G4rmghUgVwpFoVPMSg",
    place: "Near Kettering, Ohio",
    shortName: "Kettering",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OH",
    state: "Ohio",
    difficulty: "classic",
    pools: ["world","North America","US","US-OH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-oh-030",
    lat: 41.133939,
    lng: -81.484613,
    panoId: "9JSxNe-AqHrUSu9-ADEjJg",
    place: "Near Cuyahoga Falls, Ohio",
    shortName: "Cuyahoga Falls",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OH",
    state: "Ohio",
    difficulty: "classic",
    pools: ["world","North America","US","US-OH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-oh-031",
    lat: 39.360279,
    lng: -84.309964,
    panoId: "VQZVXxBUUQWYqVDKgKSf1A",
    place: "Near Mason, Ohio",
    shortName: "Mason",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OH",
    state: "Ohio",
    difficulty: "classic",
    pools: ["world","North America","US","US-OH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-oh-032",
    lat: 41.238246,
    lng: -81.841814,
    panoId: "z8KFnDVYt0BbTnyAlVGrSw",
    place: "Near Brunswick, Ohio",
    shortName: "Brunswick",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OH",
    state: "Ohio",
    difficulty: "classic",
    pools: ["world","North America","US","US-OH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-oh-033",
    lat: 40.05822,
    lng: -82.400926,
    panoId: "G2WBC9KysA6gSRZZqiwdBw",
    place: "Near Newark, Ohio",
    shortName: "Newark",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OH",
    state: "Ohio",
    difficulty: "classic",
    pools: ["world","North America","US","US-OH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-oh-034",
    lat: 39.345935,
    lng: -84.560518,
    panoId: "rU3uNp1aC60_NnZdVbu6HQ",
    place: "Near Fairfield, Ohio",
    shortName: "Fairfield",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OH",
    state: "Ohio",
    difficulty: "classic",
    pools: ["world","North America","US","US-OH"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-oh-035",
    lat: 41.499721,
    lng: -81.695665,
    panoId: "J8yuyA28QldvU_rJwA9WMg",
    place: "Near Cleveland, Ohio",
    shortName: "Cleveland",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OH",
    state: "Ohio",
    difficulty: "classic",
    pools: ["world","North America","US","US-OH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-oh-036",
    lat: 39.820918,
    lng: -84.019434,
    panoId: "xXCUPVS0ln849Azl75dWGQ",
    place: "Near Fairborn, Ohio",
    shortName: "Fairborn",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OH",
    state: "Ohio",
    difficulty: "classic",
    pools: ["world","North America","US","US-OH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-oh-037",
    lat: 41.520365,
    lng: -81.556269,
    panoId: "nEB76Bpv1rEsUXLGHr7Dew",
    place: "Near Cleveland Heights, Ohio",
    shortName: "Cleveland Heights",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OH",
    state: "Ohio",
    difficulty: "classic",
    pools: ["world","North America","US","US-OH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-oh-038",
    lat: 41.455327,
    lng: -81.917243,
    panoId: "F1-5qzUbZfT9qAQZpBaHBg",
    place: "Near Westlake, Ohio",
    shortName: "Westlake",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OH",
    state: "Ohio",
    difficulty: "classic",
    pools: ["world","North America","US","US-OH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-oh-039",
    lat: 41.087837,
    lng: -80.624789,
    panoId: "wkl7vY8fjAY08m7R1XHgMg",
    place: "Near Campbell, Ohio",
    shortName: "Campbell",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OH",
    state: "Ohio",
    difficulty: "classic",
    pools: ["world","North America","US","US-OH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-oh-040",
    lat: 41.389526,
    lng: -82.018689,
    panoId: "0aTP4pvmRWOyikzrnFqILQ",
    place: "Near North Ridgeville, Ohio",
    shortName: "North Ridgeville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OH",
    state: "Ohio",
    difficulty: "classic",
    pools: ["world","North America","US","US-OH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-oh-041",
    lat: 41.375154,
    lng: -82.133607,
    panoId: "aGfs1cLESoCAUbVEH6nG5Q",
    place: "Near Elyria, Ohio",
    shortName: "Elyria",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OH",
    state: "Ohio",
    difficulty: "classic",
    pools: ["world","North America","US","US-OH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-oh-042",
    lat: 40.728054,
    lng: -84.110256,
    panoId: "cshDf_dJOO8daa2OXUjzMA",
    place: "Near Lima, Ohio",
    shortName: "Lima",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OH",
    state: "Ohio",
    difficulty: "classic",
    pools: ["world","North America","US","US-OH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-oh-043",
    lat: 41.245106,
    lng: -80.809383,
    panoId: "saN1lArBPDL4rCdKcOYEAA",
    place: "Near Warren, Ohio",
    shortName: "Warren",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OH",
    state: "Ohio",
    difficulty: "classic",
    pools: ["world","North America","US","US-OH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-oh-044",
    lat: 41.67077,
    lng: -83.537521,
    panoId: "6aNq5UyBTYhDTX29N1MNeQ",
    place: "Near Toledo, Ohio",
    shortName: "Toledo",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OH",
    state: "Ohio",
    difficulty: "classic",
    pools: ["world","North America","US","US-OH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-oh-045",
    lat: 39.412828,
    lng: -84.568057,
    panoId: "1bukcG3Tezq0NsP2bejpNQ",
    place: "Near Hamilton, Ohio",
    shortName: "Hamilton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OH",
    state: "Ohio",
    difficulty: "classic",
    pools: ["world","North America","US","US-OH"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-oh-046",
    lat: 39.773587,
    lng: -84.178208,
    panoId: "ffWa7fA8H3f-67bLJ_VPYQ",
    place: "Near Dayton, Ohio",
    shortName: "Dayton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OH",
    state: "Ohio",
    difficulty: "classic",
    pools: ["world","North America","US","US-OH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-oh-047",
    lat: 41.052485,
    lng: -83.665794,
    panoId: "QAU6w5rYlFtEzd3JjuPqUg",
    place: "Near Findlay, Ohio",
    shortName: "Findlay",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OH",
    state: "Ohio",
    difficulty: "classic",
    pools: ["world","North America","US","US-OH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-oh-048",
    lat: 40.604798,
    lng: -83.143445,
    panoId: "Wreio69g7AUzk31DqNCZ6g",
    place: "Near Marion, Ohio",
    shortName: "Marion",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OH",
    state: "Ohio",
    difficulty: "classic",
    pools: ["world","North America","US","US-OH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-oh-049",
    lat: 40.792424,
    lng: -81.406285,
    panoId: "0sk9mueDwrruXCmrUzNjow",
    place: "Near Canton, Ohio",
    shortName: "Canton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OH",
    state: "Ohio",
    difficulty: "classic",
    pools: ["world","North America","US","US-OH"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-oh-050",
    lat: 39.704778,
    lng: -84.111403,
    panoId: "rKbsiT4HsvdYBlRt7d9Xrw",
    place: "Near Beavercreek, Ohio",
    shortName: "Beavercreek",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OH",
    state: "Ohio",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-oh-051",
    lat: 39.857495,
    lng: -83.814618,
    panoId: "6tJx5YAEP2xXbzWJLGGr1Q",
    place: "Near Springfield, Ohio",
    shortName: "Springfield",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OH",
    state: "Ohio",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-oh-052",
    lat: 41.586651,
    lng: -81.564731,
    panoId: "YxSyKqe8uosTDiAkrzrhoA",
    place: "Near Collinwood, Ohio",
    shortName: "Collinwood",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OH",
    state: "Ohio",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-oh-053",
    lat: 41.668478,
    lng: -81.392776,
    panoId: "hr7hmYBSBn7TV3JEWpJ3wA",
    place: "Near Willoughby, Ohio",
    shortName: "Willoughby",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OH",
    state: "Ohio",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-oh-054",
    lat: 40.277116,
    lng: -83.022919,
    panoId: "60D9odg4QHTiheKECYynbg",
    place: "Near Delaware, Ohio",
    shortName: "Delaware",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OH",
    state: "Ohio",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-oh-055",
    lat: 41.466982,
    lng: -81.618131,
    panoId: "jgh8zjuWXon1XVLZ5O_eWA",
    place: "Near Newburgh Heights, Ohio",
    shortName: "Newburgh Heights",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OH",
    state: "Ohio",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-oh-056",
    lat: 39.679854,
    lng: -82.579699,
    panoId: "xbBeB1LCri4mzApqSjkzQA",
    place: "Near Lancaster, Ohio",
    shortName: "Lancaster",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OH",
    state: "Ohio",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OH"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-oh-057",
    lat: 41.117684,
    lng: -81.36425,
    panoId: "q98ukpgip2tfJ0yyKkfW6w",
    place: "Near Brimfield, Ohio",
    shortName: "Brimfield",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OH",
    state: "Ohio",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-oh-058",
    lat: 39.736055,
    lng: -84.052583,
    panoId: "AQDPpOt_n0uTd2i3UkKVVg",
    place: "Near Beavercreek, Ohio",
    shortName: "Beavercreek",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OH",
    state: "Ohio",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-oh-059",
    lat: 39.917216,
    lng: -82.960206,
    panoId: "G1MUA6O2B0cQpJAHl2bs4Q",
    place: "Near Obetz, Ohio",
    shortName: "Obetz",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OH",
    state: "Ohio",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-oh-060",
    lat: 39.568719,
    lng: -84.43473,
    panoId: "748LV8aibrA-6rqNWoOg9w",
    place: "Near Middletown, Ohio",
    shortName: "Middletown",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OH",
    state: "Ohio",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-oh-061",
    lat: 41.253933,
    lng: -81.919555,
    panoId: "dolRuhK0epRSvV0cmOXs2g",
    place: "Near Brunswick, Ohio",
    shortName: "Brunswick",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OH",
    state: "Ohio",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OH"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-oh-062",
    lat: 40.82991,
    lng: -81.450224,
    panoId: "Kz9okr6jDp4KnmnSOxoS7Q",
    place: "Near Perry Heights, Ohio",
    shortName: "Perry Heights",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OH",
    state: "Ohio",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OH"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-oh-063",
    lat: 39.134356,
    lng: -84.57542,
    panoId: "2hfkRyS3YhBrcduHmcppdw",
    place: "Near Covedale, Ohio",
    shortName: "Covedale",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OH",
    state: "Ohio",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-oh-064",
    lat: 39.3006,
    lng: -84.562879,
    panoId: "Qbq5mR87jqqJLu-bcQpLFg",
    place: "Near Pleasant Run, Ohio",
    shortName: "Pleasant Run",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OH",
    state: "Ohio",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OH"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-oh-065",
    lat: 40.799279,
    lng: -82.499972,
    panoId: "G80Hvke40Pp6kEuP9s0nSQ",
    place: "Near Lincoln Heights, Ohio",
    shortName: "Lincoln Heights",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OH",
    state: "Ohio",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-oh-066",
    lat: 39.411222,
    lng: -84.512788,
    panoId: "7ZeC2bRUMiMEzT2Gpq-ZhQ",
    place: "Near New Miami, Ohio",
    shortName: "New Miami",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OH",
    state: "Ohio",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-oh-067",
    lat: 40.53481,
    lng: -83.125145,
    panoId: "o4-AaVduml4sCZYKOBfnLw",
    place: "Near Marion, Ohio",
    shortName: "Marion",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OH",
    state: "Ohio",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-oh-068",
    lat: 41.327664,
    lng: -81.994724,
    panoId: "X879muFloVBAexrMj15qoQ",
    place: "Near Eaton Estates, Ohio",
    shortName: "Eaton Estates",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OH",
    state: "Ohio",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OH"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-oh-069",
    lat: 41.431425,
    lng: -82.141005,
    panoId: "KhkyKRfk1afvGa_phEYBQg",
    place: "Near Sheffield, Ohio",
    shortName: "Sheffield",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OH",
    state: "Ohio",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-oh-070",
    lat: 39.725013,
    lng: -82.558119,
    panoId: "PKpqn0KPc_jn2PRrZ65r_Q",
    place: "Near Lancaster, Ohio",
    shortName: "Lancaster",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OH",
    state: "Ohio",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-oh-071",
    lat: 39.982483,
    lng: -83.856303,
    panoId: "fYXBXHw9199dh4xdGDkg2Q",
    place: "Near Northridge, Ohio",
    shortName: "Northridge",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OH",
    state: "Ohio",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-oh-072",
    lat: 41.25285,
    lng: -80.848636,
    panoId: "PThpsjApdwT0zDWtTv3bfQ",
    place: "Near Leavittsburg, Ohio",
    shortName: "Leavittsburg",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OH",
    state: "Ohio",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-oh-073",
    lat: 41.686282,
    lng: -83.585024,
    panoId: "9L4lsJGKyY1YRqp2iUhpaQ",
    place: "Near Toledo, Ohio",
    shortName: "Toledo",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OH",
    state: "Ohio",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-oh-074",
    lat: 41.192327,
    lng: -81.518684,
    panoId: "usR6sPryPGU3WCedFYK2HQ",
    place: "Near Silver Lake, Ohio",
    shortName: "Silver Lake",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OH",
    state: "Ohio",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-oh-075",
    lat: 40.802369,
    lng: -84.051297,
    panoId: "_7D17fkLR6CgziDaibitqA",
    place: "Near Lima, Ohio",
    shortName: "Lima",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OH",
    state: "Ohio",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-oh-076",
    lat: 41.09527,
    lng: -83.713511,
    panoId: "Iy3nKadlWooR3oOUr6aJAA",
    place: "Near McComb, Ohio",
    shortName: "McComb",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OH",
    state: "Ohio",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-oh-077",
    lat: 40.36749,
    lng: -83.079369,
    panoId: "IxaM31zFpCQT1TDVv-Nw8A",
    place: "Near Delaware, Ohio",
    shortName: "Delaware",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OH",
    state: "Ohio",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-oh-078",
    lat: 40.08445,
    lng: -82.427667,
    panoId: "B9Jxjv5LH3iBJuYNQYE7fw",
    place: "Near Newark, Ohio",
    shortName: "Newark",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OH",
    state: "Ohio",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-oh-079",
    lat: 39.761326,
    lng: -84.012283,
    panoId: "QIVSyxRkkWl-IlqY6mvrkw",
    place: "Near Fairborn, Ohio",
    shortName: "Fairborn",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OH",
    state: "Ohio",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-oh-080",
    lat: 39.451353,
    lng: -84.430602,
    panoId: "5yTYLFzu7jhCop16dGAcHg",
    place: "Near Trenton, Ohio",
    shortName: "Trenton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OH",
    state: "Ohio",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-oh-081",
    lat: 39.790513,
    lng: -84.072978,
    panoId: "tbQY1kyqbo4VGPMhwSsHgA",
    place: "Near Wright-Patterson AFB, Ohio",
    shortName: "Wright-Patterson AFB",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OH",
    state: "Ohio",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-oh-082",
    lat: 40.749334,
    lng: -81.534163,
    panoId: "GTJoJ_8DL5Yf96AtSK3Y8A",
    place: "Near Navarre, Ohio",
    shortName: "Navarre",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OH",
    state: "Ohio",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-oh-083",
    lat: 40.798609,
    lng: -82.569938,
    panoId: "lHVu6Cx-vv6Hy-tcxn3nuw",
    place: "Near Ontario, Ohio",
    shortName: "Ontario",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OH",
    state: "Ohio",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-oh-084",
    lat: 39.923782,
    lng: -83.047252,
    panoId: "htDEj88O5CYRurXSFaIt0Q",
    place: "Near Urbancrest, Ohio",
    shortName: "Urbancrest",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OH",
    state: "Ohio",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-oh-085",
    lat: 41.414638,
    lng: -82.132023,
    panoId: "8LkXxilwDImDHQ8HjLVFpA",
    place: "Near Sheffield, Ohio",
    shortName: "Sheffield",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OH",
    state: "Ohio",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-oh-086",
    lat: 41.560589,
    lng: -81.414991,
    panoId: "DEZCHkrYEiMohGywyz1HCA",
    place: "Near Mayfield, Ohio",
    shortName: "Mayfield",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OH",
    state: "Ohio",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-oh-087",
    lat: 41.143126,
    lng: -81.572673,
    panoId: "KmFbCyWXn1phjKyxr6PxeQ",
    place: "Near Fairlawn, Ohio",
    shortName: "Fairlawn",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OH",
    state: "Ohio",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-oh-088",
    lat: 41.35423,
    lng: -82.025426,
    panoId: "AboJjFoJplE_5-jwQ2svOw",
    place: "Near North Ridgeville, Ohio",
    shortName: "North Ridgeville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OH",
    state: "Ohio",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-oh-089",
    lat: 41.645295,
    lng: -81.130906,
    panoId: "8IMuHdLRFtFJuUYNItZ6yg",
    place: "Near Chardon, Ohio",
    shortName: "Chardon",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OH",
    state: "Ohio",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OH"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-oh-090",
    lat: 41.252859,
    lng: -82.00282,
    panoId: "lNXGodEAv0mbcnP43mL2Hw",
    place: "Near Grafton, Ohio",
    shortName: "Grafton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OH",
    state: "Ohio",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-oh-091",
    lat: 39.593825,
    lng: -83.910313,
    panoId: "iBetUfakXiRldBqsWjsfUw",
    place: "Near Xenia, Ohio",
    shortName: "Xenia",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OH",
    state: "Ohio",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OH"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-oh-092",
    lat: 39.327501,
    lng: -84.779631,
    panoId: "fv5MeTlUHUYgIVtGuM_D7w",
    place: "Near Harrison, Ohio",
    shortName: "Harrison",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OH",
    state: "Ohio",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-oh-093",
    lat: 41.529353,
    lng: -83.505729,
    panoId: "OpoJHavRli7HmA5Gg1ET8w",
    place: "Near Walbridge, Ohio",
    shortName: "Walbridge",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OH",
    state: "Ohio",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-oh-094",
    lat: 41.186673,
    lng: -80.857524,
    panoId: "eW624JJfbKFKY77xH_ReOA",
    place: "Near Lordstown, Ohio",
    shortName: "Lordstown",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OH",
    state: "Ohio",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-oh-095",
    lat: 41.327771,
    lng: -81.392678,
    panoId: "PqJ10ZvNbYKIhvOjSCPlxA",
    place: "Near Reminderville, Ohio",
    shortName: "Reminderville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OH",
    state: "Ohio",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OH"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-oh-096",
    lat: 40.839042,
    lng: -81.580499,
    panoId: "eVB2t5Uao3YkYMEJC-6m4A",
    place: "Near Canal Fulton, Ohio",
    shortName: "Canal Fulton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OH",
    state: "Ohio",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-oh-097",
    lat: 39.993134,
    lng: -81.887342,
    panoId: "6AgmkOKHjWOKcj20Dyu9VQ",
    place: "Near Pleasant Grove, Ohio",
    shortName: "Pleasant Grove",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OH",
    state: "Ohio",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-oh-098",
    lat: 40.283662,
    lng: -83.232576,
    panoId: "4bFpWQPC-o1Ph-4hUt6oug",
    place: "Near Marysville, Ohio",
    shortName: "Marysville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OH",
    state: "Ohio",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-oh-099",
    lat: 41.507379,
    lng: -81.335597,
    panoId: "mwfIL3ki5yLKmhRvm2Ei8g",
    place: "Near Chesterland, Ohio",
    shortName: "Chesterland",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OH",
    state: "Ohio",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OH"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-oh-100",
    lat: 40.707138,
    lng: -81.627233,
    panoId: "ZbgxS4pFGzCUyIW_fOZmLw",
    place: "Near Brewster, Ohio",
    shortName: "Brewster",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OH",
    state: "Ohio",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-OH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-oh-101",
    lat: 40.089393,
    lng: -84.01598,
    panoId: "cgE3LQKNAEu9GxnPnNqXqg",
    place: "Near Saint Paris, Ohio",
    shortName: "Saint Paris",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OH",
    state: "Ohio",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-OH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-oh-102",
    lat: 40.734792,
    lng: -82.174878,
    panoId: "voI7HUw7tUwAoXsIW-w1MQ",
    place: "Near Loudonville, Ohio",
    shortName: "Loudonville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OH",
    state: "Ohio",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-OH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-oh-103",
    lat: 39.179509,
    lng: -81.986546,
    panoId: "fIU9zkwkBRy3JFQlTE_hVQ",
    place: "Near Pomeroy, Ohio",
    shortName: "Pomeroy",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OH",
    state: "Ohio",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-OH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-oh-104",
    lat: 39.257153,
    lng: -83.186624,
    panoId: "Nvj0p9Xd43QwCyNjGizb-A",
    place: "Near Frankfort, Ohio",
    shortName: "Frankfort",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OH",
    state: "Ohio",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-OH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-oh-105",
    lat: 38.62275,
    lng: -83.073189,
    panoId: "GTIKf5jsfRfr1TIr50ylgw",
    place: "Near Portsmouth, Ohio",
    shortName: "Portsmouth",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OH",
    state: "Ohio",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-OH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-000",
    lat: 35.998724,
    lng: -96.114253,
    panoId: "4-HdUoZuuMMXAh6rjf-plw",
    place: "Near Sapulpa, Oklahoma",
    shortName: "Sapulpa",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "classic",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-001",
    lat: 36.39557,
    lng: -97.878376,
    panoId: "nqQO6W5cyHdS3D1Ng8pjnA",
    place: "Near Enid, Oklahoma",
    shortName: "Enid",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "classic",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-002",
    lat: 35.526048,
    lng: -98.707525,
    panoId: "J_0gBwU6i-YVw6R7vUkHQw",
    place: "Near Weatherford, Oklahoma",
    shortName: "Weatherford",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "classic",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-003",
    lat: 35.941994,
    lng: -95.883184,
    panoId: "Nz2ATzdu8NMexS3RNRo-7Q",
    place: "Near Bixby, Oklahoma",
    shortName: "Bixby",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "classic",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-004",
    lat: 35.052381,
    lng: -97.936454,
    panoId: "Mz8e7qNzZj3LkgX1XHeoag",
    place: "Near Chickasha, Oklahoma",
    shortName: "Chickasha",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "classic",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-005",
    lat: 34.60866,
    lng: -98.390361,
    panoId: "U0eRQECpTZKuOzNAU1ZL8g",
    place: "Near Lawton, Oklahoma",
    shortName: "Lawton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "classic",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-006",
    lat: 33.993808,
    lng: -96.370247,
    panoId: "n7NWPJbfeYAOehEihUHcVw",
    place: "Near Durant, Oklahoma",
    shortName: "Durant",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "classic",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-007",
    lat: 36.269522,
    lng: -95.854997,
    panoId: "ercGwQ2DZDvHNuLVWVzFVw",
    place: "Near Owasso, Oklahoma",
    shortName: "Owasso",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "classic",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-008",
    lat: 35.222577,
    lng: -97.439463,
    panoId: "OLnssdQYswKPgVMyl0kVbQ",
    place: "Near Norman, Oklahoma",
    shortName: "Norman",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "classic",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-009",
    lat: 35.532281,
    lng: -97.955011,
    panoId: "juTJeQKUMd_NhX9dAWaLJw",
    place: "Near El Reno, Oklahoma",
    shortName: "El Reno",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "classic",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-010",
    lat: 35.327368,
    lng: -96.925277,
    panoId: "6j0mz2_vgM0aZjZSgY2iOQ",
    place: "Near Shawnee, Oklahoma",
    shortName: "Shawnee",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "classic",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-011",
    lat: 34.933454,
    lng: -95.769673,
    panoId: "7pP9r_Ry2k5kGLPKe2ZevA",
    place: "Near McAlester, Oklahoma",
    shortName: "McAlester",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "classic",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-012",
    lat: 35.747949,
    lng: -95.369626,
    panoId: "W4P25xkuZgCdE3zhaHBk5g",
    place: "Near Muskogee, Oklahoma",
    shortName: "Muskogee",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "classic",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-013",
    lat: 35.46756,
    lng: -97.516416,
    panoId: "0B3D7Gm434whKz6DwrW94Q",
    place: "Near Oklahoma City, Oklahoma",
    shortName: "Oklahoma City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "classic",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-014",
    lat: 35.9154,
    lng: -94.969977,
    panoId: "CcG79ZyYKYVLfZWApWDHDQ",
    place: "Near Tahlequah, Oklahoma",
    shortName: "Tahlequah",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "classic",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-015",
    lat: 36.139811,
    lng: -96.108894,
    panoId: "-XEqrRK2Nz0ypbzO9f19KQ",
    place: "Near Sand Springs, Oklahoma",
    shortName: "Sand Springs",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "classic",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-016",
    lat: 34.638119,
    lng: -99.333936,
    panoId: "Zzk_2Cwc8rNn3iPNiZaI0A",
    place: "Near Altus, Oklahoma",
    shortName: "Altus",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "classic",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-017",
    lat: 36.115607,
    lng: -97.058404,
    panoId: "LUHGkoLiwRp6fORpSaaduQ",
    place: "Near Stillwater, Oklahoma",
    shortName: "Stillwater",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "classic",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-018",
    lat: 35.411712,
    lng: -99.404301,
    panoId: "LqtjUjaMQGWsajhnZNnr3g",
    place: "Near Elk City, Oklahoma",
    shortName: "Elk City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "classic",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-019",
    lat: 36.153954,
    lng: -95.99278,
    panoId: "TxkAqYgg-6tOFYFCkcnntQ",
    place: "Near Tulsa, Oklahoma",
    shortName: "Tulsa",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "classic",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-020",
    lat: 34.774567,
    lng: -96.678335,
    panoId: "XvQh_lP1uBuVkbBRM0BA2A",
    place: "Near Ada, Oklahoma",
    shortName: "Ada",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "classic",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-021",
    lat: 36.312598,
    lng: -95.616155,
    panoId: "jOZHs837lXIEQHvkJr1n0Q",
    place: "Near Claremore, Oklahoma",
    shortName: "Claremore",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "classic",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-022",
    lat: 35.623423,
    lng: -95.960596,
    panoId: "MpOVSmDVT0XqP6Cs5sAunw",
    place: "Near Okmulgee, Oklahoma",
    shortName: "Okmulgee",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "classic",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-023",
    lat: 35.951955,
    lng: -95.650798,
    panoId: "S4lnafAS5nbKFPQK7YsUpQ",
    place: "Near Coweta, Oklahoma",
    shortName: "Coweta",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "classic",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-024",
    lat: 36.706894,
    lng: -97.085624,
    panoId: "fM2omGnDE1-vjbXoRP60zQ",
    place: "Near Ponca City, Oklahoma",
    shortName: "Ponca City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "classic",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-025",
    lat: 36.022854,
    lng: -95.968349,
    panoId: "lt4V-ZopyOCA6nQlbzbu9g",
    place: "Near Jenks, Oklahoma",
    shortName: "Jenks",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "classic",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-026",
    lat: 35.878961,
    lng: -97.425332,
    panoId: "6W1adEbLb1A9UPGK19GJpA",
    place: "Near Guthrie, Oklahoma",
    shortName: "Guthrie",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "classic",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-027",
    lat: 36.433606,
    lng: -99.390366,
    panoId: "DT9-R942mzxJwTRpU1qmMw",
    place: "Near Woodward, Oklahoma",
    shortName: "Woodward",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "classic",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-028",
    lat: 36.052616,
    lng: -95.790788,
    panoId: "qFGPhz520OhCxmUuveA-Mw",
    place: "Near Broken Arrow, Oklahoma",
    shortName: "Broken Arrow",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "classic",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-029",
    lat: 36.682832,
    lng: -101.481568,
    panoId: "sXJFIUErvtz9Cmy2YHrIaQ",
    place: "Near Guymon, Oklahoma",
    shortName: "Guymon",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "classic",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-030",
    lat: 35.955376,
    lng: -96.008859,
    panoId: "yxWz6uXtGh0CH5OYEnPdKA",
    place: "Near Glenpool, Oklahoma",
    shortName: "Glenpool",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "classic",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-031",
    lat: 36.747318,
    lng: -95.981008,
    panoId: "L4HRSTLNLrU8UA2xVdvBcA",
    place: "Near Bartlesville, Oklahoma",
    shortName: "Bartlesville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "classic",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-032",
    lat: 35.515614,
    lng: -98.967184,
    panoId: "xnUP14S22mVEMJur1l4WjA",
    place: "Near Clinton, Oklahoma",
    shortName: "Clinton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "classic",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-033",
    lat: 34.502333,
    lng: -97.95824,
    panoId: "kLJ092O4P41PhjZEl1-geA",
    place: "Near Duncan, Oklahoma",
    shortName: "Duncan",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "classic",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-034",
    lat: 34.174296,
    lng: -97.143652,
    panoId: "2z7pMC0mQnsfd3ykeE59iw",
    place: "Near Ardmore, Oklahoma",
    shortName: "Ardmore",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "classic",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-035",
    lat: 36.874457,
    lng: -94.877562,
    panoId: "tqNelocxJTCESX1115cn2A",
    place: "Near Miami, Oklahoma",
    shortName: "Miami",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "classic",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-036",
    lat: 35.959415,
    lng: -95.369461,
    panoId: "DGlQjqyYgeZDErwU5FeIyA",
    place: "Near Wagoner, Oklahoma",
    shortName: "Wagoner",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "classic",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-037",
    lat: 36.308344,
    lng: -95.316927,
    panoId: "ltwY5oo7dATh871ErcPJBQ",
    place: "Near Pryor, Oklahoma",
    shortName: "Pryor",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "classic",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-038",
    lat: 35.05363,
    lng: -94.623668,
    panoId: "EvuF-S4Uha4X_l2EJAzO7g",
    place: "Near Poteau, Oklahoma",
    shortName: "Poteau",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "classic",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-039",
    lat: 35.908133,
    lng: -94.944654,
    panoId: "soGqhcyUBB0yOXQpa_obKA",
    place: "Near Tahlequah, Oklahoma",
    shortName: "Tahlequah",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "classic",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-040",
    lat: 35.529171,
    lng: -97.978609,
    panoId: "j3aqQmN7Eq3g4ZfhnJ8Vhg",
    place: "Near El Reno, Oklahoma",
    shortName: "El Reno",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "classic",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-041",
    lat: 34.628345,
    lng: -99.351435,
    panoId: "wQdLCh5YDKLpToUeW1yjEw",
    place: "Near Altus, Oklahoma",
    shortName: "Altus",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "classic",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-042",
    lat: 35.959286,
    lng: -95.864416,
    panoId: "6oS8aODW_pGxMj2pDRLEBA",
    place: "Near Bixby, Oklahoma",
    shortName: "Bixby",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "classic",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-043",
    lat: 36.388736,
    lng: -97.89182,
    panoId: "XTqazuXh5JqTJNse7VFOtA",
    place: "Near Enid, Oklahoma",
    shortName: "Enid",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "classic",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-044",
    lat: 35.770287,
    lng: -95.370557,
    panoId: "Y41sNbPyvaQiDNZY0ysl7g",
    place: "Near Muskogee, Oklahoma",
    shortName: "Muskogee",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "classic",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-045",
    lat: 35.536924,
    lng: -98.685291,
    panoId: "aNgq7JXcbG23T6Fg0z3TxQ",
    place: "Near Weatherford, Oklahoma",
    shortName: "Weatherford",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "classic",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-046",
    lat: 36.129914,
    lng: -96.11552,
    panoId: "Oug-S_kgTqDI_WgHaCO_iQ",
    place: "Near Sand Springs, Oklahoma",
    shortName: "Sand Springs",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "classic",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-047",
    lat: 35.241053,
    lng: -97.447422,
    panoId: "lMHyr1AGFaYrVN8Vp8j-Hg",
    place: "Near Norman, Oklahoma",
    shortName: "Norman",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "classic",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-ok-048",
    lat: 35.321676,
    lng: -96.938527,
    panoId: "cbLXUyAWWujLYzyKUN96iQ",
    place: "Near Shawnee, Oklahoma",
    shortName: "Shawnee",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "classic",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-049",
    lat: 33.98681,
    lng: -96.393802,
    panoId: "GNc_eo6jLtQZkFk5Bcd_pg",
    place: "Near Durant, Oklahoma",
    shortName: "Durant",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "classic",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-050",
    lat: 35.0004,
    lng: -97.88528,
    panoId: "Z2DbAGcgS5LvMQ3Vh8mrGQ",
    place: "Near Ninnekah, Oklahoma",
    shortName: "Ninnekah",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-051",
    lat: 34.025678,
    lng: -96.335253,
    panoId: "mg89CEbKM3-Y4F6d6vhkcA",
    place: "Near Durant, Oklahoma",
    shortName: "Durant",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-052",
    lat: 35.487791,
    lng: -97.581538,
    panoId: "6Xc_KLAIA2eNRsKv2VCQ8Q",
    place: "Near Warr Acres, Oklahoma",
    shortName: "Warr Acres",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-053",
    lat: 36.83003,
    lng: -94.890579,
    panoId: "E_xpVO3AOStNorpY9GWNeQ",
    place: "Near Miami, Oklahoma",
    shortName: "Miami",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-054",
    lat: 36.002845,
    lng: -95.844037,
    panoId: "0jxm12HVlw5rU65LAZ9I9Q",
    place: "Near Broken Arrow, Oklahoma",
    shortName: "Broken Arrow",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-055",
    lat: 35.935386,
    lng: -97.378388,
    panoId: "xH3rBFUOXCPcA4pSXmHmpg",
    place: "Near Guthrie, Oklahoma",
    shortName: "Guthrie",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-056",
    lat: 35.081163,
    lng: -94.669572,
    panoId: "wwxUbpbV6JiOQF9p5M3Vew",
    place: "Near Poteau, Oklahoma",
    shortName: "Poteau",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-057",
    lat: 35.551483,
    lng: -98.915812,
    panoId: "dvI4EwyfvO4O24SAyCcprw",
    place: "Near Arapaho, Oklahoma",
    shortName: "Arapaho",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-058",
    lat: 36.249543,
    lng: -95.813457,
    panoId: "EMlVesXg2rFj9mGuLDXDoA",
    place: "Near Owasso, Oklahoma",
    shortName: "Owasso",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-059",
    lat: 36.715229,
    lng: -95.943795,
    panoId: "Pm8XmQA8sB3DaNJdlYDxTg",
    place: "Near Bartlesville, Oklahoma",
    shortName: "Bartlesville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-060",
    lat: 35.984564,
    lng: -95.637377,
    panoId: "YmM6Vg_jFN2XSv-XMViOyQ",
    place: "Near Coweta, Oklahoma",
    shortName: "Coweta",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-061",
    lat: 35.421392,
    lng: -99.350991,
    panoId: "_E5D4Y8Pz0fY-Rg5_CFoAQ",
    place: "Near Elk City, Oklahoma",
    shortName: "Elk City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-062",
    lat: 35.959217,
    lng: -95.455203,
    panoId: "L7kSdF0LastmDe0FMOsdtw",
    place: "Near Wagoner, Oklahoma",
    shortName: "Wagoner",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-063",
    lat: 36.163302,
    lng: -96.035113,
    panoId: "rokJW5Xwh2lYjMXdE2TJ1g",
    place: "Near Tulsa, Oklahoma",
    shortName: "Tulsa",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-064",
    lat: 36.773718,
    lng: -97.065011,
    panoId: "-87eTFJe07j9FJXNQrnXwA",
    place: "Near Ponca City, Oklahoma",
    shortName: "Ponca City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-065",
    lat: 34.820112,
    lng: -96.722016,
    panoId: "3ebGkBKKAhWYNxfEK5w6eQ",
    place: "Near Ada, Oklahoma",
    shortName: "Ada",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-066",
    lat: 34.652333,
    lng: -99.386429,
    panoId: "TINTSMSu4duYUog-NHT8xQ",
    place: "Near Altus, Oklahoma",
    shortName: "Altus",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-067",
    lat: 36.155298,
    lng: -96.144117,
    panoId: "8mmLpOf8fjzv1K8c_iHXGA",
    place: "Near Sand Springs, Oklahoma",
    shortName: "Sand Springs",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-068",
    lat: 36.353292,
    lng: -95.578974,
    panoId: "QWFi5MZ9DvGrghEb3_Ovnw",
    place: "Near Claremore, Oklahoma",
    shortName: "Claremore",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-069",
    lat: 36.264837,
    lng: -95.363808,
    panoId: "AzLsh_mNvP1h-qFgqhmQLw",
    place: "Near Pryor Creek, Oklahoma",
    shortName: "Pryor Creek",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-070",
    lat: 34.194601,
    lng: -97.092819,
    panoId: "eyfEAZRVWwzR7Y6hJYyM-w",
    place: "Near Ardmore, Oklahoma",
    shortName: "Ardmore",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-071",
    lat: 36.273303,
    lng: -95.256147,
    panoId: "jFMJIMCB7zNNSXUz6ceoJA",
    place: "Near Pryor, Oklahoma",
    shortName: "Pryor",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-072",
    lat: 34.898607,
    lng: -95.825739,
    panoId: "1HrMLrEkn41Yilbg9Xx2yA",
    place: "Near McAlester, Oklahoma",
    shortName: "McAlester",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-073",
    lat: 36.448886,
    lng: -97.883327,
    panoId: "-rnh95k34bA8Gi4JOfhEOQ",
    place: "Near Enid, Oklahoma",
    shortName: "Enid",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-074",
    lat: 35.926992,
    lng: -94.886568,
    panoId: "IZeG3FPkHYrNeEKSpjdq0w",
    place: "Near Tahlequah, Oklahoma",
    shortName: "Tahlequah",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-075",
    lat: 35.973783,
    lng: -95.934096,
    panoId: "qb8O9JQGD4FHMxXj2U_dog",
    place: "Near Bixby, Oklahoma",
    shortName: "Bixby",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-076",
    lat: 35.885317,
    lng: -97.478179,
    panoId: "qeohlFjpjajRhrCTPrpRzA",
    place: "Near Guthrie, Oklahoma",
    shortName: "Guthrie",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-077",
    lat: 35.333191,
    lng: -96.995118,
    panoId: "XzPNEXmWn1hNSea7FvW5xA",
    place: "Near Bethel Acres, Oklahoma",
    shortName: "Bethel Acres",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-078",
    lat: 36.073379,
    lng: -96.024619,
    panoId: "T2LMyNAE7XEfEzlCymLjjA",
    place: "Near Oakhurst, Oklahoma",
    shortName: "Oakhurst",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-079",
    lat: 36.87132,
    lng: -94.79815,
    panoId: "r6J5jk1l5ekNJXubrQC0Sg",
    place: "Near Miami, Oklahoma",
    shortName: "Miami",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-080",
    lat: 36.05696,
    lng: -95.743869,
    panoId: "M0TU_brHAR-vrG3-PfSAAw",
    place: "Near Broken Arrow, Oklahoma",
    shortName: "Broken Arrow",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-081",
    lat: 35.492475,
    lng: -94.821596,
    panoId: "A_wEgHD4Znm8d0X7G4b6kw",
    place: "Near Sallisaw, Oklahoma",
    shortName: "Sallisaw",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-082",
    lat: 36.025232,
    lng: -96.172436,
    panoId: "SwAwMorcCc-Rfv4KqNbNWQ",
    place: "Near Sapulpa, Oklahoma",
    shortName: "Sapulpa",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-083",
    lat: 35.237712,
    lng: -97.385935,
    panoId: "ZCw0qsFZJye1Z6trDArVrw",
    place: "Near Hall Park, Oklahoma",
    shortName: "Hall Park",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-084",
    lat: 35.464516,
    lng: -97.939817,
    panoId: "g6L0FeczIACWDJBtktempg",
    place: "Near El Reno, Oklahoma",
    shortName: "El Reno",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-085",
    lat: 36.111222,
    lng: -97.01549,
    panoId: "TUqTpqu7SeYJEZoA5_8HFw",
    place: "Near Stillwater, Oklahoma",
    shortName: "Stillwater",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-086",
    lat: 35.037649,
    lng: -94.664319,
    panoId: "4Y6ymSlQmnAUDxUJ4071Zw",
    place: "Near Poteau, Oklahoma",
    shortName: "Poteau",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-087",
    lat: 34.125249,
    lng: -97.169435,
    panoId: "KapaODJpKVmtKFBiYMMOZw",
    place: "Near Ardmore, Oklahoma",
    shortName: "Ardmore",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-088",
    lat: 36.012878,
    lng: -95.646445,
    panoId: "RtY-cntqeFs4kmRPBG_0iw",
    place: "Near Coweta, Oklahoma",
    shortName: "Coweta",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-089",
    lat: 36.34227,
    lng: -95.564533,
    panoId: "Dl5mkkiVHtq0R6ewo-yg8g",
    place: "Near Justice, Oklahoma",
    shortName: "Justice",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-090",
    lat: 35.930151,
    lng: -96.050773,
    panoId: "1HtGxQHXEEwdvzfccFwFpw",
    place: "Near Kiefer, Oklahoma",
    shortName: "Kiefer",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-091",
    lat: 36.663333,
    lng: -97.022596,
    panoId: "ZZVWKVXenaqFDINZuAByxQ",
    place: "Near McCord, Oklahoma",
    shortName: "McCord",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-092",
    lat: 35.391324,
    lng: -99.329251,
    panoId: "0ZZkx9d-J7SH8VAjjKLHWw",
    place: "Near Elk City, Oklahoma",
    shortName: "Elk City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-093",
    lat: 35.261087,
    lng: -96.612187,
    panoId: "PRcuRpKl4D-RmwpVE6ut-Q",
    place: "Near Seminole, Oklahoma",
    shortName: "Seminole",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-094",
    lat: 35.8131,
    lng: -95.410292,
    panoId: "nMJCWqmPG2i452q2-dvr4A",
    place: "Near Muskogee, Oklahoma",
    shortName: "Muskogee",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-095",
    lat: 36.212546,
    lng: -95.901585,
    panoId: "i1ALaTq0wMhuIunPj-Se6A",
    place: "Near Turley, Oklahoma",
    shortName: "Turley",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-096",
    lat: 36.78795,
    lng: -96.055749,
    panoId: "14hyrMZk_3wKdhNA-SVe7A",
    place: "Near Bartlesville, Oklahoma",
    shortName: "Bartlesville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-097",
    lat: 35.320366,
    lng: -99.523314,
    panoId: "dEZy2JhXjdLKfk_trq0jrg",
    place: "Near Sayre, Oklahoma",
    shortName: "Sayre",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-098",
    lat: 35.624047,
    lng: -98.803607,
    panoId: "Cah9IXbFgBGmDNEpuKcnYA",
    place: "Near Weatherford, Oklahoma",
    shortName: "Weatherford",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-099",
    lat: 35.609685,
    lng: -95.79333,
    panoId: "4QTgP-uc3tMVsc1txwPjUA",
    place: "Near Morris, Oklahoma",
    shortName: "Morris",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-100",
    lat: 36.500753,
    lng: -101.503977,
    panoId: "xg7XymqkPal8XmOnMtkyOw",
    place: "Near Goodwell, Oklahoma",
    shortName: "Goodwell",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-101",
    lat: 35.711014,
    lng: -98.982617,
    panoId: "KfJQ9dDM9lz2Ns3aBU-N-A",
    place: "Near Arapaho, Oklahoma",
    shortName: "Arapaho",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-102",
    lat: 33.837536,
    lng: -94.677844,
    panoId: "DnUoV8PwfpKJu8sAGzsbUQ",
    place: "Near Idabel, Oklahoma",
    shortName: "Idabel",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-103",
    lat: 35.022407,
    lng: -95.903959,
    panoId: "qU7WXPFgjLyGGaFOr3CAeQ",
    place: "Near McAlester, Oklahoma",
    shortName: "McAlester",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-104",
    lat: 36.612111,
    lng: -95.339086,
    panoId: "B4shgfXoptXGcy1-NipIgw",
    place: "Near Chelsea, Oklahoma",
    shortName: "Chelsea",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-105",
    lat: 35.074314,
    lng: -98.41435,
    panoId: "kANm8a6_i0VIzMlYM-G0Rg",
    place: "Near Anadarko, Oklahoma",
    shortName: "Anadarko",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-106",
    lat: 36.429835,
    lng: -97.282725,
    panoId: "-wci6suEytgiPtpr5PlhQA",
    place: "Near Perry, Oklahoma",
    shortName: "Perry",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-107",
    lat: 35.427078,
    lng: -99.575901,
    panoId: "SgwP2GLkHpqxzuHAo_QKOw",
    place: "Near Elk City, Oklahoma",
    shortName: "Elk City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-108",
    lat: 34.971328,
    lng: -97.135474,
    panoId: "CqIvVPw-CkzfjJBbR7PtBw",
    place: "Near Lexington, Oklahoma",
    shortName: "Lexington",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-109",
    lat: 35.154054,
    lng: -94.406896,
    panoId: "qOPMYp3VprzSyec1H_gfJg",
    place: "Near Pocola, Oklahoma",
    shortName: "Pocola",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-110",
    lat: 35.229738,
    lng: -98.324101,
    panoId: "n-Ms-1I-EdepntfMRWvoIQ",
    place: "Near Anadarko, Oklahoma",
    shortName: "Anadarko",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-111",
    lat: 35.40757,
    lng: -99.737034,
    panoId: "VzuOClM0YISUlXCYTrvrDw",
    place: "Near Sayre, Oklahoma",
    shortName: "Sayre",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-112",
    lat: 36.67845,
    lng: -94.604804,
    panoId: "EnYfYjA4r_EyOhXvz7uHIw",
    place: "Near Anderson, Oklahoma",
    shortName: "Anderson",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ok-113",
    lat: 34.178282,
    lng: -94.782707,
    panoId: "jrIDIZ55vuQ1_WRs2lpvsQ",
    place: "Near Broken Bow, Oklahoma",
    shortName: "Broken Bow",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OK",
    state: "Oklahoma",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-OK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-or-000",
    lat: 44.942813,
    lng: -123.035176,
    panoId: "3GzL3wsPFmMje6kfug-HYg",
    place: "Near Salem, Oregon",
    shortName: "Salem",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OR",
    state: "Oregon",
    difficulty: "classic",
    pools: ["world","North America","US","US-OR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-or-001",
    lat: 44.046287,
    lng: -123.022038,
    panoId: "SVVfPU0KVQhDhM3MvVoT8A",
    place: "Near Springfield, Oregon",
    shortName: "Springfield",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OR",
    state: "Oregon",
    difficulty: "classic",
    pools: ["world","North America","US","US-OR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-or-002",
    lat: 44.052103,
    lng: -123.086727,
    panoId: "EKCylrEfres5TCUGgxF6AQ",
    place: "Near Eugene, Oregon",
    shortName: "Eugene",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OR",
    state: "Oregon",
    difficulty: "classic",
    pools: ["world","North America","US","US-OR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-or-003",
    lat: 45.672131,
    lng: -118.788343,
    panoId: "TQsl2rv0SbLz9tKtoGUw7g",
    place: "Near Pendleton, Oregon",
    shortName: "Pendleton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OR",
    state: "Oregon",
    difficulty: "classic",
    pools: ["world","North America","US","US-OR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-or-004",
    lat: 42.375921,
    lng: -122.916365,
    panoId: "TgIMfsrVUabQvC69GI5BPA",
    place: "Near Central Point, Oregon",
    shortName: "Central Point",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OR",
    state: "Oregon",
    difficulty: "classic",
    pools: ["world","North America","US","US-OR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-or-005",
    lat: 45.594781,
    lng: -121.17867,
    panoId: "HtRgYZZFtCGanMh87pu0cA",
    place: "Near The Dalles, Oregon",
    shortName: "The Dalles",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OR",
    state: "Oregon",
    difficulty: "classic",
    pools: ["world","North America","US","US-OR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-or-006",
    lat: 42.439246,
    lng: -123.330727,
    panoId: "6YAl0zDMN0wdGoxHXcxIww",
    place: "Near Grants Pass, Oregon",
    shortName: "Grants Pass",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OR",
    state: "Oregon",
    difficulty: "classic",
    pools: ["world","North America","US","US-OR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-or-007",
    lat: 44.56456,
    lng: -123.261998,
    panoId: "eDPt0IrdWrYAbiEdGbxKNw",
    place: "Near Corvallis, Oregon",
    shortName: "Corvallis",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OR",
    state: "Oregon",
    difficulty: "classic",
    pools: ["world","North America","US","US-OR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-or-008",
    lat: 44.058199,
    lng: -121.315319,
    panoId: "JRj0QRKEEQ-QsvHpea4JIg",
    place: "Near Bend, Oregon",
    shortName: "Bend",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OR",
    state: "Oregon",
    difficulty: "classic",
    pools: ["world","North America","US","US-OR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-or-009",
    lat: 45.005119,
    lng: -122.783211,
    panoId: "UN7xGw39x7DjJKNrBiGDrA",
    place: "Near Silverton, Oregon",
    shortName: "Silverton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OR",
    state: "Oregon",
    difficulty: "classic",
    pools: ["world","North America","US","US-OR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-or-010",
    lat: 45.522892,
    lng: -122.989781,
    panoId: "MLxpWs6CExUYCjW-VsMWVg",
    place: "Near Hillsboro, Oregon",
    shortName: "Hillsboro",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OR",
    state: "Oregon",
    difficulty: "classic",
    pools: ["world","North America","US","US-OR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-or-011",
    lat: 44.919441,
    lng: -123.317006,
    panoId: "1MRDe5RJAtYDcaNxarVACA",
    place: "Near Dallas, Oregon",
    shortName: "Dallas",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OR",
    state: "Oregon",
    difficulty: "classic",
    pools: ["world","North America","US","US-OR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-or-012",
    lat: 42.225164,
    lng: -121.781377,
    panoId: "srBOMk222v_pT2OvCKb3HA",
    place: "Near Klamath Falls, Oregon",
    shortName: "Klamath Falls",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OR",
    state: "Oregon",
    difficulty: "classic",
    pools: ["world","North America","US","US-OR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-or-013",
    lat: 45.840507,
    lng: -119.289507,
    panoId: "DCtbIhDFxXXyb3T9CPBFzA",
    place: "Near Hermiston, Oregon",
    shortName: "Hermiston",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OR",
    state: "Oregon",
    difficulty: "classic",
    pools: ["world","North America","US","US-OR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-or-014",
    lat: 42.326661,
    lng: -122.87536,
    panoId: "OOcqZG2RztVBinvGMXSldQ",
    place: "Near Medford, Oregon",
    shortName: "Medford",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OR",
    state: "Oregon",
    difficulty: "classic",
    pools: ["world","North America","US","US-OR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-or-015",
    lat: 45.523464,
    lng: -122.67647,
    panoId: "2clVS-LJlHwnz2tQQoI-4g",
    place: "Near Portland, Oregon",
    shortName: "Portland",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OR",
    state: "Oregon",
    difficulty: "classic",
    pools: ["world","North America","US","US-OR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-or-016",
    lat: 44.026592,
    lng: -116.962984,
    panoId: "BAFKU-rGn7K8OiQw7HnOag",
    place: "Near Ontario, Oregon",
    shortName: "Ontario",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OR",
    state: "Oregon",
    difficulty: "classic",
    pools: ["world","North America","US","US-OR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-or-017",
    lat: 45.324436,
    lng: -118.087809,
    panoId: "X6Gf-FjBN7yN5OgtvBXkIA",
    place: "Near La Grande, Oregon",
    shortName: "La Grande",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OR",
    state: "Oregon",
    difficulty: "classic",
    pools: ["world","North America","US","US-OR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-or-018",
    lat: 45.143576,
    lng: -122.855161,
    panoId: "C3-YIDZvhfEwD_EOJMOo_w",
    place: "Near Woodburn, Oregon",
    shortName: "Woodburn",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OR",
    state: "Oregon",
    difficulty: "classic",
    pools: ["world","North America","US","US-OR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-or-019",
    lat: 45.864282,
    lng: -122.806643,
    panoId: "P_j5indpUpeymWeHfOYzmg",
    place: "Near Saint Helens, Oregon",
    shortName: "Saint Helens",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OR",
    state: "Oregon",
    difficulty: "classic",
    pools: ["world","North America","US","US-OR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-or-020",
    lat: 44.636752,
    lng: -124.053374,
    panoId: "U8nm1o6rXHjVIOvrIzBB3g",
    place: "Near Newport, Oregon",
    shortName: "Newport",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OR",
    state: "Oregon",
    difficulty: "classic",
    pools: ["world","North America","US","US-OR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-or-021",
    lat: 43.797649,
    lng: -123.060006,
    panoId: "_DQASBONOkdgkJwbV-Qnrw",
    place: "Near Cottage Grove, Oregon",
    shortName: "Cottage Grove",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OR",
    state: "Oregon",
    difficulty: "classic",
    pools: ["world","North America","US","US-OR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-or-022",
    lat: 42.194625,
    lng: -122.709318,
    panoId: "QmI5JHK8bZ-a_2G_6VEekw",
    place: "Near Ashland, Oregon",
    shortName: "Ashland",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OR",
    state: "Oregon",
    difficulty: "classic",
    pools: ["world","North America","US","US-OR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-or-023",
    lat: 45.210016,
    lng: -123.198758,
    panoId: "u4YFkpiwkEa3PPcO0SLaIg",
    place: "Near McMinnville, Oregon",
    shortName: "McMinnville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OR",
    state: "Oregon",
    difficulty: "classic",
    pools: ["world","North America","US","US-OR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-or-024",
    lat: 44.848539,
    lng: -123.23403,
    panoId: "k2EdcQxQRSFPM5lzfodM5g",
    place: "Near Monmouth, Oregon",
    shortName: "Monmouth",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OR",
    state: "Oregon",
    difficulty: "classic",
    pools: ["world","North America","US","US-OR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-or-025",
    lat: 44.536538,
    lng: -122.907066,
    panoId: "NgJhMmQQCQ3laYyRF2BCmQ",
    place: "Near Lebanon, Oregon",
    shortName: "Lebanon",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OR",
    state: "Oregon",
    difficulty: "classic",
    pools: ["world","North America","US","US-OR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-or-026",
    lat: 44.990263,
    lng: -123.026175,
    panoId: "Q-xKX_4mpln24B-urgXEEg",
    place: "Near Keizer, Oregon",
    shortName: "Keizer",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OR",
    state: "Oregon",
    difficulty: "classic",
    pools: ["world","North America","US","US-OR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-or-027",
    lat: 44.927939,
    lng: -122.983658,
    panoId: "wXpHRKBPh-4Y8YLJWw7Gyg",
    place: "Near Four Corners, Oregon",
    shortName: "Four Corners",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OR",
    state: "Oregon",
    difficulty: "classic",
    pools: ["world","North America","US","US-OR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-or-028",
    lat: 43.216509,
    lng: -123.341743,
    panoId: "1PmOxZ0PW-d1AOz_xBD8UQ",
    place: "Near Roseburg, Oregon",
    shortName: "Roseburg",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OR",
    state: "Oregon",
    difficulty: "classic",
    pools: ["world","North America","US","US-OR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-or-029",
    lat: 42.206489,
    lng: -121.737152,
    panoId: "E4FAjg-mJAEZ7rHpwlkWLg",
    place: "Near Altamont, Oregon",
    shortName: "Altamont",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OR",
    state: "Oregon",
    difficulty: "classic",
    pools: ["world","North America","US","US-OR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-or-030",
    lat: 44.272561,
    lng: -121.17391,
    panoId: "Vh8JFevu6BZIMESJN1vBQw",
    place: "Near Redmond, Oregon",
    shortName: "Redmond",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OR",
    state: "Oregon",
    difficulty: "classic",
    pools: ["world","North America","US","US-OR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-or-031",
    lat: 43.366475,
    lng: -124.217876,
    panoId: "ye42AH9NkP6HgmWp_kU7JQ",
    place: "Near Coos Bay, Oregon",
    shortName: "Coos Bay",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OR",
    state: "Oregon",
    difficulty: "classic",
    pools: ["world","North America","US","US-OR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-or-032",
    lat: 44.636511,
    lng: -123.105901,
    panoId: "N6cvdDl8IO3HyzpGWCruRg",
    place: "Near Albany, Oregon",
    shortName: "Albany",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OR",
    state: "Oregon",
    difficulty: "classic",
    pools: ["world","North America","US","US-OR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-or-033",
    lat: 43.4066,
    lng: -124.224283,
    panoId: "-8xXDArBbkIOAlHXAaIP_g",
    place: "Near North Bend, Oregon",
    shortName: "North Bend",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OR",
    state: "Oregon",
    difficulty: "classic",
    pools: ["world","North America","US","US-OR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-or-034",
    lat: 46.187846,
    lng: -123.831394,
    panoId: "Aa1jSlRxjbNf5CQM-V0xUA",
    place: "Near Astoria, Oregon",
    shortName: "Astoria",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OR",
    state: "Oregon",
    difficulty: "classic",
    pools: ["world","North America","US","US-OR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-or-035",
    lat: 44.300275,
    lng: -120.834523,
    panoId: "WzFQvdSYcbXq6iL1wg_oYQ",
    place: "Near Prineville, Oregon",
    shortName: "Prineville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OR",
    state: "Oregon",
    difficulty: "classic",
    pools: ["world","North America","US","US-OR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-or-036",
    lat: 45.357209,
    lng: -122.606754,
    panoId: "ZYMUbYgri9kIH_6JokUwrA",
    place: "Near Oregon City, Oregon",
    shortName: "Oregon City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OR",
    state: "Oregon",
    difficulty: "classic",
    pools: ["world","North America","US","US-OR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-or-037",
    lat: 44.643615,
    lng: -124.024304,
    panoId: "GUKdEX2hCnzQqagNe95Jtg",
    place: "Near Newport, Oregon",
    shortName: "Newport",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OR",
    state: "Oregon",
    difficulty: "classic",
    pools: ["world","North America","US","US-OR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-or-038",
    lat: 42.217042,
    lng: -121.748577,
    panoId: "bSp2X2ewZQEvV3i0TvhguA",
    place: "Near Altamont, Oregon",
    shortName: "Altamont",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OR",
    state: "Oregon",
    difficulty: "classic",
    pools: ["world","North America","US","US-OR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-or-039",
    lat: 45.854192,
    lng: -122.833191,
    panoId: "rKykkgoJfOyqGIdTs_N2Kw",
    place: "Near Saint Helens, Oregon",
    shortName: "Saint Helens",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OR",
    state: "Oregon",
    difficulty: "classic",
    pools: ["world","North America","US","US-OR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-or-040",
    lat: 44.041924,
    lng: -123.105607,
    panoId: "hMx5J3Gjve8vRChbo1genQ",
    place: "Near Eugene, Oregon",
    shortName: "Eugene",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OR",
    state: "Oregon",
    difficulty: "classic",
    pools: ["world","North America","US","US-OR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-or-041",
    lat: 42.44452,
    lng: -123.354252,
    panoId: "TioxB9d0BeAoHwhzwb8-zA",
    place: "Near Grants Pass, Oregon",
    shortName: "Grants Pass",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OR",
    state: "Oregon",
    difficulty: "classic",
    pools: ["world","North America","US","US-OR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-or-042",
    lat: 43.211687,
    lng: -123.354428,
    panoId: "HbSMqDwYeo75pXIsoWs73w",
    place: "Near Roseburg, Oregon",
    shortName: "Roseburg",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OR",
    state: "Oregon",
    difficulty: "classic",
    pools: ["world","North America","US","US-OR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-or-043",
    lat: 43.367094,
    lng: -124.197866,
    panoId: "a4bpCHPXkEpQxceYzrg20Q",
    place: "Near Bunker Hill, Oregon",
    shortName: "Bunker Hill",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OR",
    state: "Oregon",
    difficulty: "classic",
    pools: ["world","North America","US","US-OR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-or-044",
    lat: 45.536364,
    lng: -122.99545,
    panoId: "hgMrrCMeI9Ioox8YhTcoeQ",
    place: "Near Hillsboro, Oregon",
    shortName: "Hillsboro",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OR",
    state: "Oregon",
    difficulty: "classic",
    pools: ["world","North America","US","US-OR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-or-045",
    lat: 42.366057,
    lng: -122.919539,
    panoId: "caB32jGGyUOIir4WGcaUjg",
    place: "Near Central Point, Oregon",
    shortName: "Central Point",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OR",
    state: "Oregon",
    difficulty: "classic",
    pools: ["world","North America","US","US-OR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-or-046",
    lat: 45.309213,
    lng: -118.067229,
    panoId: "nozYFeccNEwg86u9x6VbtA",
    place: "Near La Grande, Oregon",
    shortName: "La Grande",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OR",
    state: "Oregon",
    difficulty: "classic",
    pools: ["world","North America","US","US-OR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-or-047",
    lat: 45.199034,
    lng: -123.181932,
    panoId: "AhUKlTJtr-T_rFD9S_sCiw",
    place: "Near McMinnville, Oregon",
    shortName: "McMinnville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OR",
    state: "Oregon",
    difficulty: "classic",
    pools: ["world","North America","US","US-OR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-or-048",
    lat: 45.604147,
    lng: -121.182639,
    panoId: "W8L5pIeT2BLAlWEvsB-2mw",
    place: "Near The Dalles, Oregon",
    shortName: "The Dalles",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OR",
    state: "Oregon",
    difficulty: "classic",
    pools: ["world","North America","US","US-OR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-or-049",
    lat: 44.99705,
    lng: -123.001895,
    panoId: "FvMjI1kBkB_VbLayWK9X4Q",
    place: "Near Hayesville, Oregon",
    shortName: "Hayesville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OR",
    state: "Oregon",
    difficulty: "classic",
    pools: ["world","North America","US","US-OR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-or-050",
    lat: 42.365939,
    lng: -122.874829,
    panoId: "_PWBiIzkOdkl1EVhQi_AyQ",
    place: "Near Central Point, Oregon",
    shortName: "Central Point",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OR",
    state: "Oregon",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-or-051",
    lat: 44.973394,
    lng: -122.71466,
    panoId: "jpCzWmapOhCk59SRPut2Mg",
    place: "Near Silverton, Oregon",
    shortName: "Silverton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OR",
    state: "Oregon",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-or-052",
    lat: 45.203714,
    lng: -122.890123,
    panoId: "Jm2S6TD8Mkd4CfbIsC-d7Q",
    place: "Near Donald, Oregon",
    shortName: "Donald",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OR",
    state: "Oregon",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-or-053",
    lat: 44.911414,
    lng: -123.033684,
    panoId: "kv6QuhCbEXsYnjkgqvf-tA",
    place: "Near Salem, Oregon",
    shortName: "Salem",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OR",
    state: "Oregon",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-or-054",
    lat: 44.918312,
    lng: -123.22847,
    panoId: "LzPaejh0ZyxLcelqxq60-g",
    place: "Near Dallas, Oregon",
    shortName: "Dallas",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OR",
    state: "Oregon",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-or-055",
    lat: 43.967016,
    lng: -117.000374,
    panoId: "ECaOrHat7EYYt3N7suCTaQ",
    place: "Near Ontario, Oregon",
    shortName: "Ontario",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OR",
    state: "Oregon",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-or-056",
    lat: 44.63825,
    lng: -123.029112,
    panoId: "xSHMCgy61kOj4xAgeEdMHg",
    place: "Near Millersburg, Oregon",
    shortName: "Millersburg",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OR",
    state: "Oregon",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-or-057",
    lat: 44.082419,
    lng: -123.035982,
    panoId: "H5U13ZLncZXKOKy9Npz08g",
    place: "Near Springfield, Oregon",
    shortName: "Springfield",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OR",
    state: "Oregon",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-or-058",
    lat: 45.519283,
    lng: -122.619944,
    panoId: "IZ4mznaksu3BPkh-EKHQxQ",
    place: "Near Portland, Oregon",
    shortName: "Portland",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OR",
    state: "Oregon",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-or-059",
    lat: 44.076841,
    lng: -121.37173,
    panoId: "68K_UgZNdD59TSMQguV5JQ",
    place: "Near Bend, Oregon",
    shortName: "Bend",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OR",
    state: "Oregon",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-or-060",
    lat: 43.400229,
    lng: -124.28815,
    panoId: "bgVvvh2YkiY83wHfz4fVRA",
    place: "Near North Bend, Oregon",
    shortName: "North Bend",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OR",
    state: "Oregon",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-or-061",
    lat: 44.353325,
    lng: -120.846745,
    panoId: "2dbcYNGZ9tIxoBkrwN-ieQ",
    place: "Near Prineville, Oregon",
    shortName: "Prineville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OR",
    state: "Oregon",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-or-062",
    lat: 45.379568,
    lng: -122.52344,
    panoId: "3WV-bTQ0AyD1fMQj1-dGVA",
    place: "Near Clackamas, Oregon",
    shortName: "Clackamas",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OR",
    state: "Oregon",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-or-063",
    lat: 45.245499,
    lng: -123.230727,
    panoId: "e2Bpa4L-AhRL6xdhmMJfAg",
    place: "Near McMinnville, Oregon",
    shortName: "McMinnville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OR",
    state: "Oregon",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-or-064",
    lat: 43.740178,
    lng: -123.058714,
    panoId: "G7FzD4e4N2ECYUc6g0tcOw",
    place: "Near Cottage Grove, Oregon",
    shortName: "Cottage Grove",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OR",
    state: "Oregon",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-or-065",
    lat: 43.395011,
    lng: -124.264854,
    panoId: "FrY8DIQnjZcq71cnLs-JHw",
    place: "Near North Bend, Oregon",
    shortName: "North Bend",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OR",
    state: "Oregon",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-or-066",
    lat: 45.05867,
    lng: -122.770617,
    panoId: "eowvI3OjNwR6zjOxSijrjw",
    place: "Near Mount Angel, Oregon",
    shortName: "Mount Angel",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OR",
    state: "Oregon",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-or-067",
    lat: 44.905137,
    lng: -123.386741,
    panoId: "LnSaN8BkhAsZDLNUk0kbKw",
    place: "Near Dallas, Oregon",
    shortName: "Dallas",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OR",
    state: "Oregon",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-or-068",
    lat: 42.490169,
    lng: -123.344635,
    panoId: "NcwYG-WViQpSkhIw-FWjEQ",
    place: "Near Grants Pass, Oregon",
    shortName: "Grants Pass",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OR",
    state: "Oregon",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-or-069",
    lat: 44.578781,
    lng: -123.182033,
    panoId: "89V8imB7Ki3S6dOPMgM6bg",
    place: "Near Corvallis, Oregon",
    shortName: "Corvallis",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OR",
    state: "Oregon",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-or-070",
    lat: 45.87709,
    lng: -122.768454,
    panoId: "wfnUMIAGvJcXY9N28GzJuw",
    place: "Near Saint Helens, Oregon",
    shortName: "Saint Helens",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OR",
    state: "Oregon",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-or-071",
    lat: 44.894103,
    lng: -122.932586,
    panoId: "cR7Ie8bt0-6UfKOL-famCA",
    place: "Near Four Corners, Oregon",
    shortName: "Four Corners",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OR",
    state: "Oregon",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-or-072",
    lat: 44.081762,
    lng: -123.079928,
    panoId: "cxL6JWTkAz_LdT71E0UMrA",
    place: "Near Eugene, Oregon",
    shortName: "Eugene",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OR",
    state: "Oregon",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-or-073",
    lat: 44.599069,
    lng: -123.171377,
    panoId: "5bS6BM0qm78gLKyt6axwdw",
    place: "Near Albany, Oregon",
    shortName: "Albany",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OR",
    state: "Oregon",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-or-074",
    lat: 45.655119,
    lng: -121.193177,
    panoId: "ddt2sw0QQV3gS0ZYPYX8yg",
    place: "Near Dallesport, Oregon",
    shortName: "Dallesport",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OR",
    state: "Oregon",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-or-075",
    lat: 43.998055,
    lng: -123.102336,
    panoId: "CEF-GUSfw5Vq0WNxBuDMTg",
    place: "Near Eugene, Oregon",
    shortName: "Eugene",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OR",
    state: "Oregon",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-or-076",
    lat: 44.421293,
    lng: -122.813419,
    panoId: "5o2zWpRHwyTDRQw2n_-pLQ",
    place: "Near Sweet Home, Oregon",
    shortName: "Sweet Home",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OR",
    state: "Oregon",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-or-077",
    lat: 46.135667,
    lng: -123.79165,
    panoId: "h75RQ0HzlZuyu74K5ISyyA",
    place: "Near Astoria, Oregon",
    shortName: "Astoria",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OR",
    state: "Oregon",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-or-078",
    lat: 44.816921,
    lng: -117.768484,
    panoId: "sKvHn8DvFPFV-AOkodqkjQ",
    place: "Near Baker City, Oregon",
    shortName: "Baker City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OR",
    state: "Oregon",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-or-079",
    lat: 45.784449,
    lng: -119.300722,
    panoId: "YhrXKZ2_9wbe-EiljnJKIw",
    place: "Near Hermiston, Oregon",
    shortName: "Hermiston",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OR",
    state: "Oregon",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-or-080",
    lat: 44.544518,
    lng: -122.821145,
    panoId: "GdPllxwPspIy8OYKuzoZdQ",
    place: "Near Lebanon, Oregon",
    shortName: "Lebanon",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OR",
    state: "Oregon",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-or-081",
    lat: 44.746434,
    lng: -124.051964,
    panoId: "idz5DRnPo4YzG2v_481qXQ",
    place: "Near Depoe Bay, Oregon",
    shortName: "Depoe Bay",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OR",
    state: "Oregon",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-or-082",
    lat: 44.010437,
    lng: -116.994496,
    panoId: "jWIaIsUXw6XW2N2JOwUYCw",
    place: "Near Ontario, Oregon",
    shortName: "Ontario",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OR",
    state: "Oregon",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-or-083",
    lat: 44.80345,
    lng: -123.109745,
    panoId: "LFzgADWjAc40_SCuvcyO-A",
    place: "Near Independence, Oregon",
    shortName: "Independence",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OR",
    state: "Oregon",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-or-084",
    lat: 42.151851,
    lng: -122.633661,
    panoId: "MG5uMmLZ0ugsDGY3Prv7YQ",
    place: "Near Ashland, Oregon",
    shortName: "Ashland",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OR",
    state: "Oregon",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-or-085",
    lat: 42.248468,
    lng: -121.846267,
    panoId: "6l5z_fMUH9trtznyOrwM7w",
    place: "Near Klamath Falls, Oregon",
    shortName: "Klamath Falls",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OR",
    state: "Oregon",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-or-086",
    lat: 43.225243,
    lng: -123.279275,
    panoId: "iOPmgEJRk3gSb_WLBIrW8Q",
    place: "Near Roseburg, Oregon",
    shortName: "Roseburg",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OR",
    state: "Oregon",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-or-087",
    lat: 45.033189,
    lng: -122.951445,
    panoId: "rc_WSTirU8vMzUtHhUafnQ",
    place: "Near Hayesville, Oregon",
    shortName: "Hayesville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OR",
    state: "Oregon",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-or-088",
    lat: 44.777806,
    lng: -123.229221,
    panoId: "3d330uG6yG3qNbLG6ZsCdQ",
    place: "Near Monmouth, Oregon",
    shortName: "Monmouth",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OR",
    state: "Oregon",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-or-089",
    lat: 43.840562,
    lng: -123.018026,
    panoId: "7fazK-sjqHQjZuGKmw6vrQ",
    place: "Near Cottage Grove, Oregon",
    shortName: "Cottage Grove",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OR",
    state: "Oregon",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-or-090",
    lat: 46.11824,
    lng: -123.928116,
    panoId: "RJpQtFEPU_NreUvh0arGGg",
    place: "Near Warrenton, Oregon",
    shortName: "Warrenton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OR",
    state: "Oregon",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OR"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "us-or-091",
    lat: 45.60192,
    lng: -118.690646,
    panoId: "zQVwZtrFHbifiNf7ReuegA",
    place: "Near Mission, Oregon",
    shortName: "Mission",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OR",
    state: "Oregon",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-or-092",
    lat: 44.21685,
    lng: -121.037727,
    panoId: "eoCRU2BxzgFFp0WeLV6dRA",
    place: "Near Redmond, Oregon",
    shortName: "Redmond",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OR",
    state: "Oregon",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-or-093",
    lat: 44.919345,
    lng: -122.9336,
    panoId: "0KYl_t_CvquzCEYctylA1g",
    place: "Near Four Corners, Oregon",
    shortName: "Four Corners",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OR",
    state: "Oregon",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-or-094",
    lat: 45.140061,
    lng: -122.932565,
    panoId: "yqnCzdGx0DZ9XlxqA55jgQ",
    place: "Near Gervais, Oregon",
    shortName: "Gervais",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OR",
    state: "Oregon",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-or-095",
    lat: 45.320025,
    lng: -118.014339,
    panoId: "WC2V6HOt0gYkJTp2Qmy8Gw",
    place: "Near Island City, Oregon",
    shortName: "Island City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OR",
    state: "Oregon",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-or-096",
    lat: 43.293187,
    lng: -123.260983,
    panoId: "tQkun1ifmpokpgPFej4oqg",
    place: "Near Roseburg North, Oregon",
    shortName: "Roseburg North",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OR",
    state: "Oregon",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-or-097",
    lat: 42.289665,
    lng: -122.779208,
    panoId: "QjkRzGaeYpXgDc5SpWKoPg",
    place: "Near Phoenix, Oregon",
    shortName: "Phoenix",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OR",
    state: "Oregon",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-or-098",
    lat: 45.933138,
    lng: -123.910049,
    panoId: "LHLQLz2s_Ef1o2x6EzhEqw",
    place: "Near Cannon Beach, Oregon",
    shortName: "Cannon Beach",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OR",
    state: "Oregon",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-or-099",
    lat: 42.369365,
    lng: -122.957535,
    panoId: "xV88TW0DATblwqdO2Z8oVw",
    place: "Near Central Point, Oregon",
    shortName: "Central Point",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OR",
    state: "Oregon",
    difficulty: "explorer",
    pools: ["world","North America","US","US-OR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-or-100",
    lat: 44.608351,
    lng: -123.479773,
    panoId: "nQHmdeWHTSai1TH-uqt6pg",
    place: "Near Philomath, Oregon",
    shortName: "Philomath",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OR",
    state: "Oregon",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-OR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-or-101",
    lat: 44.909807,
    lng: -117.64643,
    panoId: "xy9BZP7-Kwls-84f0xjB3A",
    place: "Near Baker City, Oregon",
    shortName: "Baker City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OR",
    state: "Oregon",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-OR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-or-102",
    lat: 42.387021,
    lng: -122.580832,
    panoId: "mbJgAqQX5NmKKNQoYVhkkQ",
    place: "Near Eagle Point, Oregon",
    shortName: "Eagle Point",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OR",
    state: "Oregon",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-OR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-or-103",
    lat: 45.346251,
    lng: -121.970295,
    panoId: "5_UybaPNkOQKMqijPoR_Kw",
    place: "Near Mount Hood Village, Oregon",
    shortName: "Mount Hood Village",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OR",
    state: "Oregon",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-OR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-or-104",
    lat: 42.027123,
    lng: -121.629935,
    panoId: "SH2gLdKQVTtHfbyd55DI3w",
    place: "Near Altamont, Oregon",
    shortName: "Altamont",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OR",
    state: "Oregon",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-OR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-or-105",
    lat: 44.073122,
    lng: -123.857188,
    panoId: "cjHm9tQAd8XniUbwivvDow",
    place: "Near Florence, Oregon",
    shortName: "Florence",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "OR",
    state: "Oregon",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-OR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-pa-000",
    lat: 40.608096,
    lng: -75.489965,
    panoId: "jH9218p2MLTIs8IoOxdjnQ",
    place: "Near Allentown, Pennsylvania",
    shortName: "Allentown",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "PA",
    state: "Pennsylvania",
    difficulty: "classic",
    pools: ["world","North America","US","US-PA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-pa-001",
    lat: 40.440614,
    lng: -79.995945,
    panoId: "g5E0y3C36LA2iXpupjoHyA",
    place: "Near Pittsburgh, Pennsylvania",
    shortName: "Pittsburgh",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "PA",
    state: "Pennsylvania",
    difficulty: "classic",
    pools: ["world","North America","US","US-PA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-pa-002",
    lat: 39.962615,
    lng: -76.727805,
    panoId: "97ttHoh31OpixX_x5UaB9w",
    place: "Near York, Pennsylvania",
    shortName: "York",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "PA",
    state: "Pennsylvania",
    difficulty: "classic",
    pools: ["world","North America","US","US-PA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-pa-003",
    lat: 39.937553,
    lng: -77.661092,
    panoId: "1jjFDHdWZIx1gZZZJu1TLw",
    place: "Near Chambersburg, Pennsylvania",
    shortName: "Chambersburg",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "PA",
    state: "Pennsylvania",
    difficulty: "classic",
    pools: ["world","North America","US","US-PA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-pa-004",
    lat: 42.129184,
    lng: -80.085042,
    panoId: "c2dsXqFx6nXQf_jxD49Umg",
    place: "Near Erie, Pennsylvania",
    shortName: "Erie",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "PA",
    state: "Pennsylvania",
    difficulty: "classic",
    pools: ["world","North America","US","US-PA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-pa-005",
    lat: 41.241221,
    lng: -77.001093,
    panoId: "vhR9fZUNrA-LRSAhU4f_xg",
    place: "Near Williamsport, Pennsylvania",
    shortName: "Williamsport",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "PA",
    state: "Pennsylvania",
    difficulty: "classic",
    pools: ["world","North America","US","US-PA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-pa-006",
    lat: 40.518458,
    lng: -78.394893,
    panoId: "ZxnqRUjlF65kE11YDsXeRg",
    place: "Near Altoona, Pennsylvania",
    shortName: "Altoona",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "PA",
    state: "Pennsylvania",
    difficulty: "classic",
    pools: ["world","North America","US","US-PA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-pa-007",
    lat: 41.2459,
    lng: -75.881164,
    panoId: "hRYAzw9kDvltJQHXP_-nPg",
    place: "Near Wilkes-Barre, Pennsylvania",
    shortName: "Wilkes-Barre",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "PA",
    state: "Pennsylvania",
    difficulty: "classic",
    pools: ["world","North America","US","US-PA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-pa-008",
    lat: 41.336275,
    lng: -75.997115,
    panoId: "pAzN6Ng957f0VQynZCfVqg",
    place: "Near Back Mountain, Pennsylvania",
    shortName: "Back Mountain",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "PA",
    state: "Pennsylvania",
    difficulty: "classic",
    pools: ["world","North America","US","US-PA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-pa-009",
    lat: 40.338177,
    lng: -79.979005,
    panoId: "zvrOGovVY418UwrS_CElTg",
    place: "Near Baldwin, Pennsylvania",
    shortName: "Baldwin",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "PA",
    state: "Pennsylvania",
    difficulty: "classic",
    pools: ["world","North America","US","US-PA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-pa-010",
    lat: 40.688358,
    lng: -75.220674,
    panoId: "kmrJ7kA2vqaoFfKwbpZrLw",
    place: "Near Easton, Pennsylvania",
    shortName: "Easton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "PA",
    state: "Pennsylvania",
    difficulty: "classic",
    pools: ["world","North America","US","US-PA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-pa-011",
    lat: 39.952396,
    lng: -75.163618,
    panoId: "GOGEKjDusOA7jNlm-wGrXQ",
    place: "Near Philadelphia, Pennsylvania",
    shortName: "Philadelphia",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "PA",
    state: "Pennsylvania",
    difficulty: "classic",
    pools: ["world","North America","US","US-PA"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-pa-012",
    lat: 40.68498,
    lng: -80.107109,
    panoId: "5RccEqQVzZiOhZ2rMXdWnQ",
    place: "Near Cranberry Township, Pennsylvania",
    shortName: "Cranberry Township",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "PA",
    state: "Pennsylvania",
    difficulty: "classic",
    pools: ["world","North America","US","US-PA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-pa-013",
    lat: 41.233356,
    lng: -80.448647,
    panoId: "2O317_d-_bDquL6RnSFRxw",
    place: "Near Hermitage, Pennsylvania",
    shortName: "Hermitage",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "PA",
    state: "Pennsylvania",
    difficulty: "classic",
    pools: ["world","North America","US","US-PA"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-pa-014",
    lat: 40.559524,
    lng: -79.959247,
    panoId: "VkdLDTIuYYlKEUlP_xtHmA",
    place: "Near Allison Park, Pennsylvania",
    shortName: "Allison Park",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "PA",
    state: "Pennsylvania",
    difficulty: "classic",
    pools: ["world","North America","US","US-PA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-pa-015",
    lat: 40.335949,
    lng: -80.083426,
    panoId: "1T8L0nq6ayJSRvQ_Ekh67g",
    place: "Near Upper Saint Clair, Pennsylvania",
    shortName: "Upper Saint Clair",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "PA",
    state: "Pennsylvania",
    difficulty: "classic",
    pools: ["world","North America","US","US-PA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-pa-016",
    lat: 40.273722,
    lng: -76.884641,
    panoId: "v-L1yu9BenVxjt9fcszz1Q",
    place: "Near Harrisburg, Pennsylvania",
    shortName: "Harrisburg",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "PA",
    state: "Pennsylvania",
    difficulty: "classic",
    pools: ["world","North America","US","US-PA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-pa-017",
    lat: 40.793303,
    lng: -77.860158,
    panoId: "d6XNT2w_JHTM1q1XzZO1Ng",
    place: "Near State College, Pennsylvania",
    shortName: "State College",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "PA",
    state: "Pennsylvania",
    difficulty: "classic",
    pools: ["world","North America","US","US-PA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-pa-018",
    lat: 41.409084,
    lng: -75.664762,
    panoId: "HwwUvJaolONw4tYO1bDP2g",
    place: "Near Scranton, Pennsylvania",
    shortName: "Scranton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "PA",
    state: "Pennsylvania",
    difficulty: "classic",
    pools: ["world","North America","US","US-PA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-pa-019",
    lat: 40.355101,
    lng: -80.049404,
    panoId: "LWAQbj7LV7s2KhiRjHMNFQ",
    place: "Near Mount Lebanon, Pennsylvania",
    shortName: "Mount Lebanon",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "PA",
    state: "Pennsylvania",
    difficulty: "classic",
    pools: ["world","North America","US","US-PA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-pa-020",
    lat: 41.003481,
    lng: -80.346997,
    panoId: "m3FYy420LwYOKEMuAQubMQ",
    place: "Near New Castle, Pennsylvania",
    shortName: "New Castle",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "PA",
    state: "Pennsylvania",
    difficulty: "classic",
    pools: ["world","North America","US","US-PA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-pa-021",
    lat: 40.363514,
    lng: -79.866605,
    panoId: "srkdaPX8AN5ZTC5zzQh5Jw",
    place: "Near West Mifflin, Pennsylvania",
    shortName: "West Mifflin",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "PA",
    state: "Pennsylvania",
    difficulty: "classic",
    pools: ["world","North America","US","US-PA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-pa-022",
    lat: 40.326723,
    lng: -78.921838,
    panoId: "lHmq3zGIrUa-uWZZxiPthg",
    place: "Near Johnstown, Pennsylvania",
    shortName: "Johnstown",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "PA",
    state: "Pennsylvania",
    difficulty: "classic",
    pools: ["world","North America","US","US-PA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-pa-023",
    lat: 40.666716,
    lng: -75.499878,
    panoId: "4HxYfEHpCjeOkIukx6rKHQ",
    place: "Near Whitehall Township, Pennsylvania",
    shortName: "Whitehall Township",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "PA",
    state: "Pennsylvania",
    difficulty: "classic",
    pools: ["world","North America","US","US-PA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-pa-024",
    lat: 40.625896,
    lng: -75.370455,
    panoId: "ssL5bActeyDxmxMOVxwwKg",
    place: "Near Bethlehem, Pennsylvania",
    shortName: "Bethlehem",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "PA",
    state: "Pennsylvania",
    difficulty: "classic",
    pools: ["world","North America","US","US-PA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-pa-025",
    lat: 40.958329,
    lng: -75.974461,
    panoId: "UYPJhtKW3yvNgVA-GMPfvw",
    place: "Near Hazleton, Pennsylvania",
    shortName: "Hazleton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "PA",
    state: "Pennsylvania",
    difficulty: "classic",
    pools: ["world","North America","US","US-PA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-pa-026",
    lat: 40.421179,
    lng: -79.788128,
    panoId: "QuTaZXvXm5rtqDFwQvfjRg",
    place: "Near Monroeville, Pennsylvania",
    shortName: "Monroeville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "PA",
    state: "Pennsylvania",
    difficulty: "classic",
    pools: ["world","North America","US","US-PA"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-pa-027",
    lat: 40.347844,
    lng: -79.864268,
    panoId: "kdIXSGiTsNaHxg9c5urCUQ",
    place: "Near McKeesport, Pennsylvania",
    shortName: "McKeesport",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "PA",
    state: "Pennsylvania",
    difficulty: "classic",
    pools: ["world","North America","US","US-PA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-pa-028",
    lat: 40.428363,
    lng: -79.697552,
    panoId: "1vihCNfd6DeIRQ_gFKbcEA",
    place: "Near Murrysville, Pennsylvania",
    shortName: "Murrysville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "PA",
    state: "Pennsylvania",
    difficulty: "classic",
    pools: ["world","North America","US","US-PA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-pa-029",
    lat: 39.961129,
    lng: -75.608147,
    panoId: "BFj0rZJzFdXyqxGJtALJXw",
    place: "Near West Chester, Pennsylvania",
    shortName: "West Chester",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "PA",
    state: "Pennsylvania",
    difficulty: "classic",
    pools: ["world","North America","US","US-PA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-pa-030",
    lat: 40.245585,
    lng: -75.649606,
    panoId: "7cszL0L8x_a_AReNnRLxng",
    place: "Near Pottstown, Pennsylvania",
    shortName: "Pottstown",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "PA",
    state: "Pennsylvania",
    difficulty: "classic",
    pools: ["world","North America","US","US-PA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-pa-031",
    lat: 40.037958,
    lng: -76.305513,
    panoId: "gAzpYiP34tRUNn8LFOnd_A",
    place: "Near Lancaster, Pennsylvania",
    shortName: "Lancaster",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "PA",
    state: "Pennsylvania",
    difficulty: "classic",
    pools: ["world","North America","US","US-PA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-pa-032",
    lat: 40.121498,
    lng: -75.339851,
    panoId: "SJ2P4zqtjchPrXFgm3zJ_w",
    place: "Near Norristown, Pennsylvania",
    shortName: "Norristown",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "PA",
    state: "Pennsylvania",
    difficulty: "classic",
    pools: ["world","North America","US","US-PA"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-pa-033",
    lat: 40.341052,
    lng: -76.411336,
    panoId: "s8PNIaeBlahadrnZBq-DjA",
    place: "Near Lebanon, Pennsylvania",
    shortName: "Lebanon",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "PA",
    state: "Pennsylvania",
    difficulty: "classic",
    pools: ["world","North America","US","US-PA"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-pa-034",
    lat: 40.335362,
    lng: -75.926899,
    panoId: "SbchjeZOjXEga8xSz4S8zA",
    place: "Near Reading, Pennsylvania",
    shortName: "Reading",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "PA",
    state: "Pennsylvania",
    difficulty: "classic",
    pools: ["world","North America","US","US-PA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-pa-035",
    lat: 40.500318,
    lng: -79.749465,
    panoId: "JXk6mjMl_uXuDrJvrouNUA",
    place: "Near Plum, Pennsylvania",
    shortName: "Plum",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "PA",
    state: "Pennsylvania",
    difficulty: "classic",
    pools: ["world","North America","US","US-PA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-pa-036",
    lat: 40.20149,
    lng: -77.18883,
    panoId: "t6XkMQdXPwYn3wnk0-fkGA",
    place: "Near Carlisle, Pennsylvania",
    shortName: "Carlisle",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "PA",
    state: "Pennsylvania",
    difficulty: "classic",
    pools: ["world","North America","US","US-PA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-pa-037",
    lat: 40.327287,
    lng: -80.039359,
    panoId: "U1ldt0HxzQJ7sPvBUWaFtw",
    place: "Near Bethel Park, Pennsylvania",
    shortName: "Bethel Park",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "PA",
    state: "Pennsylvania",
    difficulty: "classic",
    pools: ["world","North America","US","US-PA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-pa-038",
    lat: 40.441795,
    lng: -79.88192,
    panoId: "4e-OxhegAegP5dJXoKPhFQ",
    place: "Near Wilkinsburg, Pennsylvania",
    shortName: "Wilkinsburg",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "PA",
    state: "Pennsylvania",
    difficulty: "classic",
    pools: ["world","North America","US","US-PA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-pa-039",
    lat: 40.327039,
    lng: -80.001251,
    panoId: "o9_EU8uvSqD4vk-qAGXg9Q",
    place: "Near Baldwin, Pennsylvania",
    shortName: "Baldwin",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "PA",
    state: "Pennsylvania",
    difficulty: "classic",
    pools: ["world","North America","US","US-PA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-pa-040",
    lat: 40.541215,
    lng: -79.959856,
    panoId: "7dkKkU1yiKF-HwrlEyGXpw",
    place: "Near Glenshaw, Pennsylvania",
    shortName: "Glenshaw",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "PA",
    state: "Pennsylvania",
    difficulty: "classic",
    pools: ["world","North America","US","US-PA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-pa-041",
    lat: 40.040792,
    lng: -76.283984,
    panoId: "re9kuuZo4h-qKWMYOZ4clA",
    place: "Near Lancaster, Pennsylvania",
    shortName: "Lancaster",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "PA",
    state: "Pennsylvania",
    difficulty: "classic",
    pools: ["world","North America","US","US-PA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-pa-042",
    lat: 41.323239,
    lng: -76.013243,
    panoId: "IGBmhXeq1BaBs6BSN6drXg",
    place: "Near Back Mountain, Pennsylvania",
    shortName: "Back Mountain",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "PA",
    state: "Pennsylvania",
    difficulty: "classic",
    pools: ["world","North America","US","US-PA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-pa-043",
    lat: 40.328646,
    lng: -80.061169,
    panoId: "KQJSUTXGo-VddZSxL3yELw",
    place: "Near Bethel Park, Pennsylvania",
    shortName: "Bethel Park",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "PA",
    state: "Pennsylvania",
    difficulty: "classic",
    pools: ["world","North America","US","US-PA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-pa-044",
    lat: 40.70359,
    lng: -75.200651,
    panoId: "lXSsF8YMQj5wlsjaNGLmUQ",
    place: "Near Phillipsburg, Pennsylvania",
    shortName: "Phillipsburg",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "PA",
    state: "Pennsylvania",
    difficulty: "classic",
    pools: ["world","North America","US","US-PA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-pa-045",
    lat: 40.434376,
    lng: -79.721488,
    panoId: "8rurebIyFQp6ya-WqYZSiQ",
    place: "Near Murrysville, Pennsylvania",
    shortName: "Murrysville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "PA",
    state: "Pennsylvania",
    difficulty: "classic",
    pools: ["world","North America","US","US-PA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-pa-046",
    lat: 39.946512,
    lng: -75.18013,
    panoId: "KqGLkFfN3msV58Ekb0lP8A",
    place: "Near Southwest Center City Philadelphia, Pennsylvania",
    shortName: "Southwest Center City Philadelphia",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "PA",
    state: "Pennsylvania",
    difficulty: "classic",
    pools: ["world","North America","US","US-PA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-pa-047",
    lat: 39.948813,
    lng: -76.742624,
    panoId: "E8ZGva96e-Ql0qPearrUbw",
    place: "Near West York, Pennsylvania",
    shortName: "West York",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "PA",
    state: "Pennsylvania",
    difficulty: "classic",
    pools: ["world","North America","US","US-PA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-pa-048",
    lat: 40.236628,
    lng: -75.510987,
    panoId: "gB8-spMA8hF_WfZtgMOuLg",
    place: "Near Limerick, Pennsylvania",
    shortName: "Limerick",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "PA",
    state: "Pennsylvania",
    difficulty: "classic",
    pools: ["world","North America","US","US-PA"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-pa-049",
    lat: 41.254917,
    lng: -76.982783,
    panoId: "flgx8D45q25Id_y-tXjwtA",
    place: "Near Faxon, Pennsylvania",
    shortName: "Faxon",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "PA",
    state: "Pennsylvania",
    difficulty: "classic",
    pools: ["world","North America","US","US-PA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-pa-050",
    lat: 40.397784,
    lng: -79.727766,
    panoId: "pnbPWX_lqLAWZ2B2MgNgnw",
    place: "Near Level Green, Pennsylvania",
    shortName: "Level Green",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "PA",
    state: "Pennsylvania",
    difficulty: "explorer",
    pools: ["world","North America","US","US-PA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-pa-051",
    lat: 40.718311,
    lng: -75.492107,
    panoId: "9hnGRaU4YWm5Kyb_c8FlWQ",
    place: "Near Laurys Station, Pennsylvania",
    shortName: "Laurys Station",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "PA",
    state: "Pennsylvania",
    difficulty: "explorer",
    pools: ["world","North America","US","US-PA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-pa-052",
    lat: 39.934361,
    lng: -75.563265,
    panoId: "0nGxMPcgNuNC9_cR9mq_bg",
    place: "Near West Chester, Pennsylvania",
    shortName: "West Chester",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "PA",
    state: "Pennsylvania",
    difficulty: "explorer",
    pools: ["world","North America","US","US-PA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-pa-053",
    lat: 40.312162,
    lng: -80.127096,
    panoId: "RD1t4m9Bn6Yl4PHJYJA3Ug",
    place: "Near Thompsonville, Pennsylvania",
    shortName: "Thompsonville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "PA",
    state: "Pennsylvania",
    difficulty: "explorer",
    pools: ["world","North America","US","US-PA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-pa-054",
    lat: 40.833909,
    lng: -77.818294,
    panoId: "2bBOBoZk16SjpACGMtwWSg",
    place: "Near Houserville, Pennsylvania",
    shortName: "Houserville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "PA",
    state: "Pennsylvania",
    difficulty: "explorer",
    pools: ["world","North America","US","US-PA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-pa-055",
    lat: 41.398981,
    lng: -75.751902,
    panoId: "8Zp0gFsDfANzZSKGSSWNhA",
    place: "Near Old Forge, Pennsylvania",
    shortName: "Old Forge",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "PA",
    state: "Pennsylvania",
    difficulty: "explorer",
    pools: ["world","North America","US","US-PA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-pa-056",
    lat: 40.236638,
    lng: -75.732401,
    panoId: "Rqn1APVVNcnP4Yf4q__Kzg",
    place: "Near Amity Gardens, Pennsylvania",
    shortName: "Amity Gardens",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "PA",
    state: "Pennsylvania",
    difficulty: "explorer",
    pools: ["world","North America","US","US-PA"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-pa-057",
    lat: 40.244199,
    lng: -77.25598,
    panoId: "LLl7OjOnjv0GsYPNCsI00Q",
    place: "Near Schlusser, Pennsylvania",
    shortName: "Schlusser",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "PA",
    state: "Pennsylvania",
    difficulty: "explorer",
    pools: ["world","North America","US","US-PA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-pa-058",
    lat: 39.934509,
    lng: -77.725892,
    panoId: "XVTAGeQba7ZlbIVGOuEf1w",
    place: "Near Chambersburg, Pennsylvania",
    shortName: "Chambersburg",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "PA",
    state: "Pennsylvania",
    difficulty: "explorer",
    pools: ["world","North America","US","US-PA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-pa-059",
    lat: 40.320735,
    lng: -78.96524,
    panoId: "TYy8l9bFTevE0stvrPyroQ",
    place: "Near Westmont, Pennsylvania",
    shortName: "Westmont",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "PA",
    state: "Pennsylvania",
    difficulty: "explorer",
    pools: ["world","North America","US","US-PA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-pa-060",
    lat: 41.026316,
    lng: -80.318541,
    panoId: "hzGhTAj3F-anjZ6kGQsjMQ",
    place: "Near New Castle Northwest, Pennsylvania",
    shortName: "New Castle Northwest",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "PA",
    state: "Pennsylvania",
    difficulty: "explorer",
    pools: ["world","North America","US","US-PA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-pa-061",
    lat: 40.293689,
    lng: -79.81688,
    panoId: "Je0MXayFZyLXO7RW1kQ4gg",
    place: "Near Greenock, Pennsylvania",
    shortName: "Greenock",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "PA",
    state: "Pennsylvania",
    difficulty: "explorer",
    pools: ["world","North America","US","US-PA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-pa-062",
    lat: 41.288237,
    lng: -75.873688,
    panoId: "VQBtb6VY6Mxkr7v4quDIgQ",
    place: "Near Swoyersville, Pennsylvania",
    shortName: "Swoyersville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "PA",
    state: "Pennsylvania",
    difficulty: "explorer",
    pools: ["world","North America","US","US-PA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-pa-063",
    lat: 40.317008,
    lng: -76.361271,
    panoId: "FV68Tg4eVo4WlG5iEnLgYw",
    place: "Near Avon, Pennsylvania",
    shortName: "Avon",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "PA",
    state: "Pennsylvania",
    difficulty: "explorer",
    pools: ["world","North America","US","US-PA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-pa-064",
    lat: 42.109825,
    lng: -80.003735,
    panoId: "IVmlV_xP1wpXshc2DvmBjw",
    place: "Near Wesleyville, Pennsylvania",
    shortName: "Wesleyville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "PA",
    state: "Pennsylvania",
    difficulty: "explorer",
    pools: ["world","North America","US","US-PA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-pa-065",
    lat: 40.995713,
    lng: -76.01898,
    panoId: "CSaUhxrNyJMD9X-d75Wy-Q",
    place: "Near Conyngham, Pennsylvania",
    shortName: "Conyngham",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "PA",
    state: "Pennsylvania",
    difficulty: "explorer",
    pools: ["world","North America","US","US-PA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-pa-066",
    lat: 40.481739,
    lng: -79.887289,
    panoId: "gJX9FuWX4Ox8L3GeB9VnPg",
    place: "Near Aspinwall, Pennsylvania",
    shortName: "Aspinwall",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "PA",
    state: "Pennsylvania",
    difficulty: "explorer",
    pools: ["world","North America","US","US-PA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-pa-067",
    lat: 41.255842,
    lng: -77.066929,
    panoId: "hi6PoqtCaazEU-FlmUFttA",
    place: "Near Garden View, Pennsylvania",
    shortName: "Garden View",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "PA",
    state: "Pennsylvania",
    difficulty: "explorer",
    pools: ["world","North America","US","US-PA"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-pa-068",
    lat: 40.546631,
    lng: -78.368107,
    panoId: "MOZdF6WtoQcemo1xUusW3g",
    place: "Near Greenwood, Pennsylvania",
    shortName: "Greenwood",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "PA",
    state: "Pennsylvania",
    difficulty: "explorer",
    pools: ["world","North America","US","US-PA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-pa-069",
    lat: 40.462845,
    lng: -79.801485,
    panoId: "2gq2t_3vfnJHhudwae8rJg",
    place: "Near Churchill, Pennsylvania",
    shortName: "Churchill",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "PA",
    state: "Pennsylvania",
    difficulty: "explorer",
    pools: ["world","North America","US","US-PA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-pa-070",
    lat: 40.658491,
    lng: -75.207981,
    panoId: "P9t1QE93hk6l24NeV9pdyw",
    place: "Near Raubsville, Pennsylvania",
    shortName: "Raubsville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "PA",
    state: "Pennsylvania",
    difficulty: "explorer",
    pools: ["world","North America","US","US-PA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-pa-071",
    lat: 40.640964,
    lng: -75.422851,
    panoId: "aBmWwukACud1ER9M7uZsxQ",
    place: "Near Fullerton, Pennsylvania",
    shortName: "Fullerton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "PA",
    state: "Pennsylvania",
    difficulty: "explorer",
    pools: ["world","North America","US","US-PA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-pa-072",
    lat: 41.381043,
    lng: -76.050717,
    panoId: "Umb8jnA7It5XuZpbZ7GgUw",
    place: "Near Harveys Lake, Pennsylvania",
    shortName: "Harveys Lake",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "PA",
    state: "Pennsylvania",
    difficulty: "explorer",
    pools: ["world","North America","US","US-PA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-pa-073",
    lat: 39.92125,
    lng: -75.527287,
    panoId: "64uRwonRJqOp7x7U1kv7xg",
    place: "Near Chester Heights, Pennsylvania",
    shortName: "Chester Heights",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "PA",
    state: "Pennsylvania",
    difficulty: "explorer",
    pools: ["world","North America","US","US-PA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-pa-074",
    lat: 40.206897,
    lng: -76.870275,
    panoId: "hNRteOAwJYdSQkp4P6DXcA",
    place: "Near New Cumberland, Pennsylvania",
    shortName: "New Cumberland",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "PA",
    state: "Pennsylvania",
    difficulty: "explorer",
    pools: ["world","North America","US","US-PA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-pa-075",
    lat: 40.234154,
    lng: -77.271268,
    panoId: "NZkmsD-HFYjH07ftjg1JkA",
    place: "Near Carlisle, Pennsylvania",
    shortName: "Carlisle",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "PA",
    state: "Pennsylvania",
    difficulty: "explorer",
    pools: ["world","North America","US","US-PA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-pa-076",
    lat: 41.464405,
    lng: -75.646053,
    panoId: "AlktRMVTgm10RulRcPCPzA",
    place: "Near Chinchilla, Pennsylvania",
    shortName: "Chinchilla",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "PA",
    state: "Pennsylvania",
    difficulty: "explorer",
    pools: ["world","North America","US","US-PA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-pa-077",
    lat: 40.942409,
    lng: -80.340539,
    panoId: "bh6lWvSjuDPXYE8WYT6-9A",
    place: "Near Oakland, Pennsylvania",
    shortName: "Oakland",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "PA",
    state: "Pennsylvania",
    difficulty: "explorer",
    pools: ["world","North America","US","US-PA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-pa-078",
    lat: 42.093869,
    lng: -80.082888,
    panoId: "-iUsW4M43HYBox1MJYcN2Q",
    place: "Near Erie, Pennsylvania",
    shortName: "Erie",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "PA",
    state: "Pennsylvania",
    difficulty: "explorer",
    pools: ["world","North America","US","US-PA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-pa-079",
    lat: 40.184496,
    lng: -75.694794,
    panoId: "ud0scMZ7Z_d-VYndLXTPqg",
    place: "Near South Pottstown, Pennsylvania",
    shortName: "South Pottstown",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "PA",
    state: "Pennsylvania",
    difficulty: "explorer",
    pools: ["world","North America","US","US-PA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-pa-080",
    lat: 40.380687,
    lng: -80.095115,
    panoId: "4Vu4Irj88hcH_Z1W5QfFbQ",
    place: "Near Heidelberg, Pennsylvania",
    shortName: "Heidelberg",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "PA",
    state: "Pennsylvania",
    difficulty: "explorer",
    pools: ["world","North America","US","US-PA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-pa-081",
    lat: 40.375062,
    lng: -78.9452,
    panoId: "1_hKAD3soSKTF1Frexs3tQ",
    place: "Near Johnstown, Pennsylvania",
    shortName: "Johnstown",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "PA",
    state: "Pennsylvania",
    difficulty: "explorer",
    pools: ["world","North America","US","US-PA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-pa-082",
    lat: 39.996912,
    lng: -77.631407,
    panoId: "zWAQOLkrE3-HxXJSQduciQ",
    place: "Near Scotland, Pennsylvania",
    shortName: "Scotland",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "PA",
    state: "Pennsylvania",
    difficulty: "explorer",
    pools: ["world","North America","US","US-PA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-pa-083",
    lat: 40.611174,
    lng: -80.114445,
    panoId: "Az43JoRi4Jn_Kf6o0dzlkA",
    place: "Near Franklin Park, Pennsylvania",
    shortName: "Franklin Park",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "PA",
    state: "Pennsylvania",
    difficulty: "explorer",
    pools: ["world","North America","US","US-PA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-pa-084",
    lat: 40.485386,
    lng: -79.960085,
    panoId: "UemDbQ0ep3NcyovBWNHDpQ",
    place: "Near Millvale, Pennsylvania",
    shortName: "Millvale",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "PA",
    state: "Pennsylvania",
    difficulty: "explorer",
    pools: ["world","North America","US","US-PA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-pa-085",
    lat: 40.465819,
    lng: -79.701838,
    panoId: "L46Sw78fU6qsxK15IkhnpA",
    place: "Near Murrysville, Pennsylvania",
    shortName: "Murrysville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "PA",
    state: "Pennsylvania",
    difficulty: "explorer",
    pools: ["world","North America","US","US-PA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-pa-086",
    lat: 40.772722,
    lng: -75.382856,
    panoId: "vVUscF7nERSsO8Vncf9IIg",
    place: "Near Bath, Pennsylvania",
    shortName: "Bath",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "PA",
    state: "Pennsylvania",
    difficulty: "explorer",
    pools: ["world","North America","US","US-PA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-pa-087",
    lat: 40.199576,
    lng: -76.516318,
    panoId: "6UJtcq4fwLZ9K_qecpggWA",
    place: "Near Elizabethtown, Pennsylvania",
    shortName: "Elizabethtown",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "PA",
    state: "Pennsylvania",
    difficulty: "explorer",
    pools: ["world","North America","US","US-PA"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-pa-088",
    lat: 40.830255,
    lng: -75.93772,
    panoId: "H-1LBsCWfwh8LQE952esFg",
    place: "Near Coaldale, Pennsylvania",
    shortName: "Coaldale",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "PA",
    state: "Pennsylvania",
    difficulty: "explorer",
    pools: ["world","North America","US","US-PA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-pa-089",
    lat: 40.959857,
    lng: -79.933242,
    panoId: "OdyHIS0s9tpCwOzINfRCuA",
    place: "Near Shanor-Northvue, Pennsylvania",
    shortName: "Shanor-Northvue",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "PA",
    state: "Pennsylvania",
    difficulty: "explorer",
    pools: ["world","North America","US","US-PA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-pa-090",
    lat: 40.520717,
    lng: -79.777405,
    panoId: "Pg4rDlLCo2MJzF5cid32YA",
    place: "Near Springdale, Pennsylvania",
    shortName: "Springdale",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "PA",
    state: "Pennsylvania",
    difficulty: "explorer",
    pools: ["world","North America","US","US-PA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-pa-091",
    lat: 40.391548,
    lng: -75.728223,
    panoId: "-Of5UPbPOd1vAdpGxBpKOg",
    place: "Near Oley, Pennsylvania",
    shortName: "Oley",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "PA",
    state: "Pennsylvania",
    difficulty: "explorer",
    pools: ["world","North America","US","US-PA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-pa-092",
    lat: 40.174733,
    lng: -76.834384,
    panoId: "i6ahxhfrZJMAlzUrRkUGZA",
    place: "Near Valley Green, Pennsylvania",
    shortName: "Valley Green",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "PA",
    state: "Pennsylvania",
    difficulty: "explorer",
    pools: ["world","North America","US","US-PA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-pa-093",
    lat: 40.216421,
    lng: -76.484609,
    panoId: "Rt0uUfWWZjVjawj3N4Kq9w",
    place: "Near Cornwall, Pennsylvania",
    shortName: "Cornwall",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "PA",
    state: "Pennsylvania",
    difficulty: "explorer",
    pools: ["world","North America","US","US-PA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-pa-094",
    lat: 41.311196,
    lng: -80.684294,
    panoId: "jH46Exor2vjT_2RLEbnXPA",
    place: "Near Cortland, Pennsylvania",
    shortName: "Cortland",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "PA",
    state: "Pennsylvania",
    difficulty: "explorer",
    pools: ["world","North America","US","US-PA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-pa-095",
    lat: 39.740235,
    lng: -76.779786,
    panoId: "JL3kOvFOzUArO6WjtgzxKg",
    place: "Near New Freedom, Pennsylvania",
    shortName: "New Freedom",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "PA",
    state: "Pennsylvania",
    difficulty: "explorer",
    pools: ["world","North America","US","US-PA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-pa-096",
    lat: 39.885286,
    lng: -76.64054,
    panoId: "Z7U05sSHv6pQudfWLDOCUw",
    place: "Near Dallastown, Pennsylvania",
    shortName: "Dallastown",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "PA",
    state: "Pennsylvania",
    difficulty: "explorer",
    pools: ["world","North America","US","US-PA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-pa-097",
    lat: 41.338645,
    lng: -80.569762,
    panoId: "m2CU7nFibU3tL_N8HohinQ",
    place: "Near Brookfield Center, Pennsylvania",
    shortName: "Brookfield Center",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "PA",
    state: "Pennsylvania",
    difficulty: "explorer",
    pools: ["world","North America","US","US-PA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-pa-098",
    lat: 40.280611,
    lng: -75.457497,
    panoId: "qDfn-GlYdB4PgMv1QlqiBA",
    place: "Near Spring Mount, Pennsylvania",
    shortName: "Spring Mount",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "PA",
    state: "Pennsylvania",
    difficulty: "explorer",
    pools: ["world","North America","US","US-PA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-pa-099",
    lat: 40.592817,
    lng: -75.648926,
    panoId: "6IREaqOy8LiegGtuML8iAQ",
    place: "Near Trexlertown, Pennsylvania",
    shortName: "Trexlertown",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "PA",
    state: "Pennsylvania",
    difficulty: "explorer",
    pools: ["world","North America","US","US-PA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-pa-100",
    lat: 40.637452,
    lng: -77.861353,
    panoId: "x6FXbv0nLbn80monu0gthg",
    place: "Near Pine Grove Mills, Pennsylvania",
    shortName: "Pine Grove Mills",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "PA",
    state: "Pennsylvania",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-PA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-pa-101",
    lat: 40.453153,
    lng: -79.424088,
    panoId: "EdklY7raXA3Tu08BgrtQPw",
    place: "Near Delmont, Pennsylvania",
    shortName: "Delmont",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "PA",
    state: "Pennsylvania",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-PA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-pa-102",
    lat: 40.010363,
    lng: -80.257618,
    panoId: "3GsCnWLvrbu8VAIF4EoTsw",
    place: "Near Waynesburg, Pennsylvania",
    shortName: "Waynesburg",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "PA",
    state: "Pennsylvania",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-PA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-pa-103",
    lat: 41.685713,
    lng: -79.900502,
    panoId: "7TwAJo-tMtd9WU85rEm5iA",
    place: "Near Cambridge Springs, Pennsylvania",
    shortName: "Cambridge Springs",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "PA",
    state: "Pennsylvania",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-PA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-pa-104",
    lat: 40.784068,
    lng: -79.765749,
    panoId: "bRaJdCRZPpX8JO0F_8qdeA",
    place: "Near Saxonburg, Pennsylvania",
    shortName: "Saxonburg",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "PA",
    state: "Pennsylvania",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-PA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-pa-105",
    lat: 40.022551,
    lng: -76.982799,
    panoId: "mYYMRui31fKxv78ACsiqBQ",
    place: "Near Lake Meade, Pennsylvania",
    shortName: "Lake Meade",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "PA",
    state: "Pennsylvania",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-PA"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-ri-000",
    lat: 42.002492,
    lng: -71.5142,
    panoId: "x99esu9CHnY4H5Rm9IFOvA",
    place: "Near Woonsocket, Rhode Island",
    shortName: "Woonsocket",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "RI",
    state: "Rhode Island",
    difficulty: "classic",
    pools: ["world","North America","US","US-RI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ri-001",
    lat: 41.700128,
    lng: -71.683078,
    panoId: "y7hUWMb30_G7jPk6P8zdMQ",
    place: "Near Coventry, Rhode Island",
    shortName: "Coventry",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "RI",
    state: "Rhode Island",
    difficulty: "classic",
    pools: ["world","North America","US","US-RI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ri-002",
    lat: 41.974447,
    lng: -71.466888,
    panoId: "63mMRIOy40QZ3RmDwDcuqg",
    place: "Near Cumberland Hill, Rhode Island",
    shortName: "Cumberland Hill",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "RI",
    state: "Rhode Island",
    difficulty: "classic",
    pools: ["world","North America","US","US-RI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ri-003",
    lat: 41.967632,
    lng: -71.43699,
    panoId: "DmMYolAFHhV3HCFx5VO_vA",
    place: "Near Cumberland, Rhode Island",
    shortName: "Cumberland",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "RI",
    state: "Rhode Island",
    difficulty: "classic",
    pools: ["world","North America","US","US-RI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ri-004",
    lat: 41.625896,
    lng: -71.213397,
    panoId: "h-MCUt7tVtDLlFWM7tTEkQ",
    place: "Near Tiverton, Rhode Island",
    shortName: "Tiverton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "RI",
    state: "Rhode Island",
    difficulty: "classic",
    pools: ["world","North America","US","US-RI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ri-005",
    lat: 41.740555,
    lng: -71.308764,
    panoId: "FYUOTpN2HA63GctAuyahdg",
    place: "Near Barrington, Rhode Island",
    shortName: "Barrington",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "RI",
    state: "Rhode Island",
    difficulty: "classic",
    pools: ["world","North America","US","US-RI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ri-006",
    lat: 41.823852,
    lng: -71.412659,
    panoId: "W1KZDzFRRNJC9nL1f3mueA",
    place: "Near Providence, Rhode Island",
    shortName: "Providence",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "RI",
    state: "Rhode Island",
    difficulty: "classic",
    pools: ["world","North America","US","US-RI"],
    qualityTier: 4,
    verified: true,
  },
];

const CHUNK_4: GeoLocation[] = [
  {
    id: "us-ri-007",
    lat: 41.447272,
    lng: -71.524566,
    panoId: "htckGiK8YSHD0i5pWibImQ",
    place: "Near South Kingstown, Rhode Island",
    shortName: "South Kingstown",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "RI",
    state: "Rhode Island",
    difficulty: "classic",
    pools: ["world","North America","US","US-RI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ri-008",
    lat: 41.677082,
    lng: -71.266103,
    panoId: "KzZO_7psVt6Z_ERjaM35NQ",
    place: "Near Bristol, Rhode Island",
    shortName: "Bristol",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "RI",
    state: "Rhode Island",
    difficulty: "classic",
    pools: ["world","North America","US","US-RI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ri-009",
    lat: 41.446478,
    lng: -71.500602,
    panoId: "SUxmA9PYOM6led8fkTXirg",
    place: "Near Wakefield-Peacedale, Rhode Island",
    shortName: "Wakefield-Peacedale",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "RI",
    state: "Rhode Island",
    difficulty: "classic",
    pools: ["world","North America","US","US-RI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ri-010",
    lat: 41.813635,
    lng: -71.370136,
    panoId: "dGpVBeyEePFGPRUc6JAtdA",
    place: "Near East Providence, Rhode Island",
    shortName: "East Providence",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "RI",
    state: "Rhode Island",
    difficulty: "classic",
    pools: ["world","North America","US","US-RI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ri-011",
    lat: 41.779562,
    lng: -71.437535,
    panoId: "LlXnub00-UTnv_Fnm2Slfg",
    place: "Near Cranston, Rhode Island",
    shortName: "Cranston",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "RI",
    state: "Rhode Island",
    difficulty: "classic",
    pools: ["world","North America","US","US-RI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ri-012",
    lat: 41.87125,
    lng: -71.552039,
    panoId: "Vga77pVVh8V-6bGP1LGsFw",
    place: "Near Greenville, Rhode Island",
    shortName: "Greenville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "RI",
    state: "Rhode Island",
    difficulty: "classic",
    pools: ["world","North America","US","US-RI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ri-013",
    lat: 41.449557,
    lng: -71.4489,
    panoId: "UQ765Oue-q9TRoCgbWRcVg",
    place: "Near Narragansett, Rhode Island",
    shortName: "Narragansett",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "RI",
    state: "Rhode Island",
    difficulty: "classic",
    pools: ["world","North America","US","US-RI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ri-014",
    lat: 41.490082,
    lng: -71.312843,
    panoId: "lxTgG2wDJoYDgqTqiBtE4g",
    place: "Near Newport, Rhode Island",
    shortName: "Newport",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "RI",
    state: "Rhode Island",
    difficulty: "classic",
    pools: ["world","North America","US","US-RI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ri-015",
    lat: 41.850209,
    lng: -71.465831,
    panoId: "G1Y_uPs0w7IkYr-uXmQPYg",
    place: "Near North Providence, Rhode Island",
    shortName: "North Providence",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "RI",
    state: "Rhode Island",
    difficulty: "classic",
    pools: ["world","North America","US","US-RI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ri-016",
    lat: 41.821373,
    lng: -71.506873,
    panoId: "DePvkTctVCO35G1OKbBRYg",
    place: "Near Johnston, Rhode Island",
    shortName: "Johnston",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "RI",
    state: "Rhode Island",
    difficulty: "classic",
    pools: ["world","North America","US","US-RI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ri-017",
    lat: 41.660378,
    lng: -71.455848,
    panoId: "B1KtXBqTTkFz6xeDZ6jWsA",
    place: "Near East Greenwich, Rhode Island",
    shortName: "East Greenwich",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "RI",
    state: "Rhode Island",
    difficulty: "classic",
    pools: ["world","North America","US","US-RI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ri-018",
    lat: 41.545689,
    lng: -71.291822,
    panoId: "FncIw06ze0TK7aZlvljesg",
    place: "Near Middletown, Rhode Island",
    shortName: "Middletown",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "RI",
    state: "Rhode Island",
    difficulty: "classic",
    pools: ["world","North America","US","US-RI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ri-019",
    lat: 41.696951,
    lng: -71.52207,
    panoId: "14vaNAE9mY0hNYdZC11yoA",
    place: "Near West Warwick, Rhode Island",
    shortName: "West Warwick",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "RI",
    state: "Rhode Island",
    difficulty: "classic",
    pools: ["world","North America","US","US-RI"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-ri-020",
    lat: 41.890704,
    lng: -71.392201,
    panoId: "2pY50vveaXtHlrGkHoHHrQ",
    place: "Near Central Falls, Rhode Island",
    shortName: "Central Falls",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "RI",
    state: "Rhode Island",
    difficulty: "classic",
    pools: ["world","North America","US","US-RI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ri-021",
    lat: 41.461322,
    lng: -71.777524,
    panoId: "kv6ATbl2RBcOsqW2AYbczg",
    place: "Near Hopkinton, Rhode Island",
    shortName: "Hopkinton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "RI",
    state: "Rhode Island",
    difficulty: "classic",
    pools: ["world","North America","US","US-RI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ri-022",
    lat: 41.906748,
    lng: -71.390599,
    panoId: "CRd073UuF_Q0R6lPmuaJCg",
    place: "Near Valley Falls, Rhode Island",
    shortName: "Valley Falls",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "RI",
    state: "Rhode Island",
    difficulty: "classic",
    pools: ["world","North America","US","US-RI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ri-023",
    lat: 41.831749,
    lng: -71.58732,
    panoId: "9i8Akv3A8u6a7_5EBFPqOQ",
    place: "Near North Scituate, Rhode Island",
    shortName: "North Scituate",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "RI",
    state: "Rhode Island",
    difficulty: "classic",
    pools: ["world","North America","US","US-RI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ri-024",
    lat: 41.966851,
    lng: -71.550851,
    panoId: "Prqq6944Zbk3GquZ8dgRCw",
    place: "Near North Smithfield, Rhode Island",
    shortName: "North Smithfield",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "RI",
    state: "Rhode Island",
    difficulty: "classic",
    pools: ["world","North America","US","US-RI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ri-025",
    lat: 41.922014,
    lng: -71.435964,
    panoId: "3lteQ8Ul4RLDVJX7gR0Amg",
    place: "Near Lincoln, Rhode Island",
    shortName: "Lincoln",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "RI",
    state: "Rhode Island",
    difficulty: "classic",
    pools: ["world","North America","US","US-RI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ri-026",
    lat: 41.377624,
    lng: -71.827217,
    panoId: "KWynvaLnJqyAyRC-GEkEUw",
    place: "Near Westerly, Rhode Island",
    shortName: "Westerly",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "RI",
    state: "Rhode Island",
    difficulty: "classic",
    pools: ["world","North America","US","US-RI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ri-027",
    lat: 41.382955,
    lng: -71.641911,
    panoId: "E-GOaDmxBv57D_pRjN7FhQ",
    place: "Near Charlestown, Rhode Island",
    shortName: "Charlestown",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "RI",
    state: "Rhode Island",
    difficulty: "classic",
    pools: ["world","North America","US","US-RI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ri-028",
    lat: 41.700034,
    lng: -71.415923,
    panoId: "3UIQCsZ_Yo-6cjYCfLB33Q",
    place: "Near Warwick, Rhode Island",
    shortName: "Warwick",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "RI",
    state: "Rhode Island",
    difficulty: "classic",
    pools: ["world","North America","US","US-RI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ri-029",
    lat: 41.730357,
    lng: -71.282571,
    panoId: "p7X4SHlr2hh-rlw6GUT3LA",
    place: "Near Warren, Rhode Island",
    shortName: "Warren",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "RI",
    state: "Rhode Island",
    difficulty: "classic",
    pools: ["world","North America","US","US-RI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ri-030",
    lat: 41.550008,
    lng: -71.467803,
    panoId: "_qxPoHXPCS3iumV2imrOZg",
    place: "Near North Kingstown, Rhode Island",
    shortName: "North Kingstown",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "RI",
    state: "Rhode Island",
    difficulty: "classic",
    pools: ["world","North America","US","US-RI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ri-031",
    lat: 41.922035,
    lng: -71.549638,
    panoId: "EYkflW9GBSIPODH4vpXmqg",
    place: "Near Smithfield, Rhode Island",
    shortName: "Smithfield",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "RI",
    state: "Rhode Island",
    difficulty: "classic",
    pools: ["world","North America","US","US-RI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ri-032",
    lat: 41.87868,
    lng: -71.382637,
    panoId: "PWOLWSjtmK-Qpd59LBBF4w",
    place: "Near Pawtucket, Rhode Island",
    shortName: "Pawtucket",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "RI",
    state: "Rhode Island",
    difficulty: "classic",
    pools: ["world","North America","US","US-RI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ri-033",
    lat: 41.602134,
    lng: -71.250449,
    panoId: "91JLTgKKehdeQMkK0obz6Q",
    place: "Near Portsmouth, Rhode Island",
    shortName: "Portsmouth",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "RI",
    state: "Rhode Island",
    difficulty: "classic",
    pools: ["world","North America","US","US-RI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ri-034",
    lat: 41.577581,
    lng: -71.537838,
    panoId: "hHmBRKG4EcNan_AX6pVLuw",
    place: "Near Exeter, Rhode Island",
    shortName: "Exeter",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "RI",
    state: "Rhode Island",
    difficulty: "classic",
    pools: ["world","North America","US","US-RI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ri-035",
    lat: 41.480324,
    lng: -71.52244,
    panoId: "gdgcHCwcWkdX2dv2fuGATQ",
    place: "Near Kingston, Rhode Island",
    shortName: "Kingston",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "RI",
    state: "Rhode Island",
    difficulty: "classic",
    pools: ["world","North America","US","US-RI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ri-036",
    lat: 41.802312,
    lng: -71.379443,
    panoId: "12hce17jF18iKEl1Aio2GA",
    place: "Near East Providence, Rhode Island",
    shortName: "East Providence",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "RI",
    state: "Rhode Island",
    difficulty: "classic",
    pools: ["world","North America","US","US-RI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ri-037",
    lat: 41.638904,
    lng: -71.666169,
    panoId: "3YDuOV-qVPXem8rPIGZ2Yw",
    place: "Near West Greenwich, Rhode Island",
    shortName: "West Greenwich",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "RI",
    state: "Rhode Island",
    difficulty: "classic",
    pools: ["world","North America","US","US-RI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ri-038",
    lat: 41.707228,
    lng: -71.692826,
    panoId: "Qzf_4Rk-DrUQ4Mwk4mSpoA",
    place: "Near Coventry, Rhode Island",
    shortName: "Coventry",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "RI",
    state: "Rhode Island",
    difficulty: "classic",
    pools: ["world","North America","US","US-RI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ri-039",
    lat: 41.438942,
    lng: -71.490732,
    panoId: "oVDnlA3C-vo2NOb-Z55L2g",
    place: "Near Wakefield-Peacedale, Rhode Island",
    shortName: "Wakefield-Peacedale",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "RI",
    state: "Rhode Island",
    difficulty: "classic",
    pools: ["world","North America","US","US-RI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ri-040",
    lat: 41.836061,
    lng: -71.419593,
    panoId: "yMtN0X2pze8xA8m84OrZpw",
    place: "Near Providence, Rhode Island",
    shortName: "Providence",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "RI",
    state: "Rhode Island",
    difficulty: "classic",
    pools: ["world","North America","US","US-RI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ri-041",
    lat: 41.499189,
    lng: -71.309868,
    panoId: "-f1XGeHRBmobB6BxFqtJVA",
    place: "Near Newport, Rhode Island",
    shortName: "Newport",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "RI",
    state: "Rhode Island",
    difficulty: "classic",
    pools: ["world","North America","US","US-RI"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-ri-042",
    lat: 41.917363,
    lng: -71.537297,
    panoId: "tj9aRBor8Yl-2rWU_kjqSg",
    place: "Near Smithfield, Rhode Island",
    shortName: "Smithfield",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "RI",
    state: "Rhode Island",
    difficulty: "classic",
    pools: ["world","North America","US","US-RI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ri-043",
    lat: 41.746337,
    lng: -71.294152,
    panoId: "a_hQE1cNk8vKiGf5xcePHw",
    place: "Near Barrington, Rhode Island",
    shortName: "Barrington",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "RI",
    state: "Rhode Island",
    difficulty: "classic",
    pools: ["world","North America","US","US-RI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ri-044",
    lat: 41.900551,
    lng: -71.37866,
    panoId: "ShxTHPVJARlwlmxDzvTTYw",
    place: "Near Valley Falls, Rhode Island",
    shortName: "Valley Falls",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "RI",
    state: "Rhode Island",
    difficulty: "classic",
    pools: ["world","North America","US","US-RI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ri-045",
    lat: 41.699283,
    lng: -71.43953,
    panoId: "oI2fX45A-gH1vnAhDij-Cw",
    place: "Near Warwick, Rhode Island",
    shortName: "Warwick",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "RI",
    state: "Rhode Island",
    difficulty: "classic",
    pools: ["world","North America","US","US-RI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ri-046",
    lat: 41.536596,
    lng: -71.297613,
    panoId: "cYuN5bh9FzDETrII2IOcAA",
    place: "Near Middletown, Rhode Island",
    shortName: "Middletown",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "RI",
    state: "Rhode Island",
    difficulty: "classic",
    pools: ["world","North America","US","US-RI"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-ri-047",
    lat: 41.908928,
    lng: -71.450398,
    panoId: "M0uuZ9URXLnssPwbFv9P1g",
    place: "Near Lincoln, Rhode Island",
    shortName: "Lincoln",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "RI",
    state: "Rhode Island",
    difficulty: "classic",
    pools: ["world","North America","US","US-RI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ri-048",
    lat: 41.889118,
    lng: -71.561679,
    panoId: "m0VNS_-sebwohC-GhLW65Q",
    place: "Near Greenville, Rhode Island",
    shortName: "Greenville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "RI",
    state: "Rhode Island",
    difficulty: "classic",
    pools: ["world","North America","US","US-RI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ri-049",
    lat: 41.963971,
    lng: -71.425172,
    panoId: "2iasp1JWuCcB8wVy4HK5lQ",
    place: "Near Cumberland, Rhode Island",
    shortName: "Cumberland",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "RI",
    state: "Rhode Island",
    difficulty: "classic",
    pools: ["world","North America","US","US-RI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ri-050",
    lat: 41.449764,
    lng: -71.39867,
    panoId: "qciyiWUhh666qDSIShFMRg",
    place: "Near Narragansett, Rhode Island",
    shortName: "Narragansett",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "RI",
    state: "Rhode Island",
    difficulty: "explorer",
    pools: ["world","North America","US","US-RI"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-ri-051",
    lat: 41.894329,
    lng: -71.606076,
    panoId: "HgXq1AmSqfZF2vcmIQYw5Q",
    place: "Near Greenville, Rhode Island",
    shortName: "Greenville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "RI",
    state: "Rhode Island",
    difficulty: "explorer",
    pools: ["world","North America","US","US-RI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ri-052",
    lat: 41.521981,
    lng: -71.538323,
    panoId: "wnNu70larbHL14o5rP7Gng",
    place: "Near Kingston, Rhode Island",
    shortName: "Kingston",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "RI",
    state: "Rhode Island",
    difficulty: "explorer",
    pools: ["world","North America","US","US-RI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ri-053",
    lat: 41.924089,
    lng: -71.620054,
    panoId: "8m5N51UrbuBjspkTg3j0FQ",
    place: "Near Chepachet, Rhode Island",
    shortName: "Chepachet",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "RI",
    state: "Rhode Island",
    difficulty: "explorer",
    pools: ["world","North America","US","US-RI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ri-054",
    lat: 41.407189,
    lng: -71.591305,
    panoId: "bSKqel2CldQFBeWj5IHfQg",
    place: "Near Charlestown, Rhode Island",
    shortName: "Charlestown",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "RI",
    state: "Rhode Island",
    difficulty: "explorer",
    pools: ["world","North America","US","US-RI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ri-055",
    lat: 41.472192,
    lng: -71.814705,
    panoId: "BlRN3fAI5BR3-QdljoEh2A",
    place: "Near Hopkinton, Rhode Island",
    shortName: "Hopkinton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "RI",
    state: "Rhode Island",
    difficulty: "explorer",
    pools: ["world","North America","US","US-RI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ri-056",
    lat: 41.58347,
    lng: -71.19476,
    panoId: "TYFwYIj5fTZFWf34me6QxQ",
    place: "Near Tiverton, Rhode Island",
    shortName: "Tiverton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "RI",
    state: "Rhode Island",
    difficulty: "explorer",
    pools: ["world","North America","US","US-RI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ri-057",
    lat: 41.501996,
    lng: -71.49891,
    panoId: "iCwBgqedTKTqP6hMVPnbHw",
    place: "Near Kingston, Rhode Island",
    shortName: "Kingston",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "RI",
    state: "Rhode Island",
    difficulty: "explorer",
    pools: ["world","North America","US","US-RI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ri-058",
    lat: 41.576901,
    lng: -71.702178,
    panoId: "xklZQs_lCU_KjLMjF4V40g",
    place: "Near West Greenwich, Rhode Island",
    shortName: "West Greenwich",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "RI",
    state: "Rhode Island",
    difficulty: "explorer",
    pools: ["world","North America","US","US-RI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ri-059",
    lat: 41.850656,
    lng: -71.368192,
    panoId: "u-tf92mzjGfGFxxaHxYhTw",
    place: "Near Pawtucket, Rhode Island",
    shortName: "Pawtucket",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "RI",
    state: "Rhode Island",
    difficulty: "explorer",
    pools: ["world","North America","US","US-RI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ri-060",
    lat: 41.681305,
    lng: -71.302533,
    panoId: "osQ-wvJ8ai8Kd2-3PMo3VQ",
    place: "Near Bristol, Rhode Island",
    shortName: "Bristol",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "RI",
    state: "Rhode Island",
    difficulty: "explorer",
    pools: ["world","North America","US","US-RI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ri-061",
    lat: 41.535199,
    lng: -71.554373,
    panoId: "TWtzmpItpSKYxV7zqHvv1g",
    place: "Near Exeter, Rhode Island",
    shortName: "Exeter",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "RI",
    state: "Rhode Island",
    difficulty: "explorer",
    pools: ["world","North America","US","US-RI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ri-062",
    lat: 42.035595,
    lng: -71.484916,
    panoId: "W8u998Vlj13rrzlUpwKmzQ",
    place: "Near Woonsocket, Rhode Island",
    shortName: "Woonsocket",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "RI",
    state: "Rhode Island",
    difficulty: "explorer",
    pools: ["world","North America","US","US-RI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ri-063",
    lat: 41.800294,
    lng: -71.577253,
    panoId: "FkzHte9XOXn_0ZVIH7Fn9w",
    place: "Near North Scituate, Rhode Island",
    shortName: "North Scituate",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "RI",
    state: "Rhode Island",
    difficulty: "explorer",
    pools: ["world","North America","US","US-RI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ri-064",
    lat: 41.748092,
    lng: -71.359289,
    panoId: "aJUM5FziRY8R4unTLfaVBA",
    place: "Near Barrington, Rhode Island",
    shortName: "Barrington",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "RI",
    state: "Rhode Island",
    difficulty: "explorer",
    pools: ["world","North America","US","US-RI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ri-065",
    lat: 41.722253,
    lng: -71.486696,
    panoId: "3CroPDljHwSPNkvRnzp4Kg",
    place: "Near West Warwick, Rhode Island",
    shortName: "West Warwick",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "RI",
    state: "Rhode Island",
    difficulty: "explorer",
    pools: ["world","North America","US","US-RI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ri-066",
    lat: 41.992087,
    lng: -71.599167,
    panoId: "vZvel3doJ8E7_vdRhLHbDA",
    place: "Near Millville, Rhode Island",
    shortName: "Millville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "RI",
    state: "Rhode Island",
    difficulty: "explorer",
    pools: ["world","North America","US","US-RI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ri-067",
    lat: 41.614444,
    lng: -71.461304,
    panoId: "2GkW1UDhAxcUBozKayhBIw",
    place: "Near East Greenwich, Rhode Island",
    shortName: "East Greenwich",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "RI",
    state: "Rhode Island",
    difficulty: "explorer",
    pools: ["world","North America","US","US-RI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ri-068",
    lat: 41.398997,
    lng: -71.792352,
    panoId: "mp4kID7d9ilOFlH46XRbfA",
    place: "Near Ashaway, Rhode Island",
    shortName: "Ashaway",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "RI",
    state: "Rhode Island",
    difficulty: "explorer",
    pools: ["world","North America","US","US-RI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ri-069",
    lat: 42.006288,
    lng: -71.588083,
    panoId: "lKfmQ_OGRmr9k98xfXtcsQ",
    place: "Near Millville, Rhode Island",
    shortName: "Millville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "RI",
    state: "Rhode Island",
    difficulty: "explorer",
    pools: ["world","North America","US","US-RI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ri-070",
    lat: 41.636191,
    lng: -71.473408,
    panoId: "pC5ZgoKKl3wJ1TXlV9zgag",
    place: "Near East Greenwich, Rhode Island",
    shortName: "East Greenwich",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "RI",
    state: "Rhode Island",
    difficulty: "explorer",
    pools: ["world","North America","US","US-RI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ri-071",
    lat: 41.880401,
    lng: -71.490279,
    panoId: "cQdwxnYFBcPCXgW5NvBP8Q",
    place: "Near North Providence, Rhode Island",
    shortName: "North Providence",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "RI",
    state: "Rhode Island",
    difficulty: "explorer",
    pools: ["world","North America","US","US-RI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ri-072",
    lat: 41.759857,
    lng: -71.518734,
    panoId: "oHEKElh0wxdJczPLDUyQqA",
    place: "Near Johnston, Rhode Island",
    shortName: "Johnston",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "RI",
    state: "Rhode Island",
    difficulty: "explorer",
    pools: ["world","North America","US","US-RI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ri-073",
    lat: 41.525037,
    lng: -71.36912,
    panoId: "xZREf2x8nncQ2yee3Znlhw",
    place: "Near Jamestown, Rhode Island",
    shortName: "Jamestown",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "RI",
    state: "Rhode Island",
    difficulty: "explorer",
    pools: ["world","North America","US","US-RI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ri-074",
    lat: 41.524822,
    lng: -71.233344,
    panoId: "yfk4eDchOGbKnDXcfLiaNA",
    place: "Near Newport East, Rhode Island",
    shortName: "Newport East",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "RI",
    state: "Rhode Island",
    difficulty: "explorer",
    pools: ["world","North America","US","US-RI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ri-075",
    lat: 41.476145,
    lng: -71.460434,
    panoId: "O0-XcwiMwn37AL-9LKeLDQ",
    place: "Near Narragansett, Rhode Island",
    shortName: "Narragansett",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "RI",
    state: "Rhode Island",
    difficulty: "explorer",
    pools: ["world","North America","US","US-RI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ri-076",
    lat: 41.377038,
    lng: -71.572,
    panoId: "kdYbtiNq6zbcNTxsFPainQ",
    place: "Near Charlestown, Rhode Island",
    shortName: "Charlestown",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "RI",
    state: "Rhode Island",
    difficulty: "explorer",
    pools: ["world","North America","US","US-RI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ri-077",
    lat: 41.98465,
    lng: -71.682824,
    panoId: "1fuupGnhV2KTbbWlr1NT-Q",
    place: "Near Harrisville, Rhode Island",
    shortName: "Harrisville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "RI",
    state: "Rhode Island",
    difficulty: "explorer",
    pools: ["world","North America","US","US-RI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ri-078",
    lat: 41.717173,
    lng: -71.35855,
    panoId: "WTQdljPQo28k5idBTvlU9A",
    place: "Near Barrington, Rhode Island",
    shortName: "Barrington",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "RI",
    state: "Rhode Island",
    difficulty: "explorer",
    pools: ["world","North America","US","US-RI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ri-079",
    lat: 41.617639,
    lng: -71.44912,
    panoId: "ZjTWrXBiH_RZyehWYWJ50Q",
    place: "Near East Greenwich, Rhode Island",
    shortName: "East Greenwich",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "RI",
    state: "Rhode Island",
    difficulty: "explorer",
    pools: ["world","North America","US","US-RI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ri-080",
    lat: 41.520282,
    lng: -71.867707,
    panoId: "WGGHWhzrfs9NaezxRE7GCg",
    place: "Near Preston City, Rhode Island",
    shortName: "Preston City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "RI",
    state: "Rhode Island",
    difficulty: "explorer",
    pools: ["world","North America","US","US-RI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ri-081",
    lat: 41.996767,
    lng: -71.58614,
    panoId: "rtq_7EScpwK7x86dwTY_dg",
    place: "Near Millville, Rhode Island",
    shortName: "Millville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "RI",
    state: "Rhode Island",
    difficulty: "explorer",
    pools: ["world","North America","US","US-RI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ri-082",
    lat: 41.808856,
    lng: -71.847303,
    panoId: "cABi1BQi2bEqhEkY5Xs3EA",
    place: "Near Danielson, Rhode Island",
    shortName: "Danielson",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "RI",
    state: "Rhode Island",
    difficulty: "explorer",
    pools: ["world","North America","US","US-RI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ri-083",
    lat: 41.933519,
    lng: -71.477198,
    panoId: "Cz98XgOrr2SOYrDG7X5X3Q",
    place: "Near Lincoln, Rhode Island",
    shortName: "Lincoln",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "RI",
    state: "Rhode Island",
    difficulty: "explorer",
    pools: ["world","North America","US","US-RI"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-ri-084",
    lat: 41.55746,
    lng: -71.156061,
    panoId: "UkEY2X0rKz56gHkhWvhqKA",
    place: "Near Tiverton, Rhode Island",
    shortName: "Tiverton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "RI",
    state: "Rhode Island",
    difficulty: "explorer",
    pools: ["world","North America","US","US-RI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ri-085",
    lat: 41.757395,
    lng: -71.699921,
    panoId: "jo6m-zz1Ri5rlhepftbinA",
    place: "Near Coventry, Rhode Island",
    shortName: "Coventry",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "RI",
    state: "Rhode Island",
    difficulty: "explorer",
    pools: ["world","North America","US","US-RI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ri-086",
    lat: 41.511451,
    lng: -71.841029,
    panoId: "YlvJv78e8f6swG6bwSLOIg",
    place: "Near Hopkinton, Rhode Island",
    shortName: "Hopkinton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "RI",
    state: "Rhode Island",
    difficulty: "explorer",
    pools: ["world","North America","US","US-RI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ri-087",
    lat: 41.424732,
    lng: -71.656387,
    panoId: "mFhvOxPQy5PJ36QRvk_sIQ",
    place: "Near Charlestown, Rhode Island",
    shortName: "Charlestown",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "RI",
    state: "Rhode Island",
    difficulty: "explorer",
    pools: ["world","North America","US","US-RI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ri-088",
    lat: 41.850941,
    lng: -71.286721,
    panoId: "n4JBtk_K_637efo8G4Oh3g",
    place: "Near Rehoboth, Rhode Island",
    shortName: "Rehoboth",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "RI",
    state: "Rhode Island",
    difficulty: "explorer",
    pools: ["world","North America","US","US-RI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ri-089",
    lat: 41.772667,
    lng: -71.310904,
    panoId: "xxV6zUBk7obldbkipghwdA",
    place: "Near Barrington, Rhode Island",
    shortName: "Barrington",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "RI",
    state: "Rhode Island",
    difficulty: "explorer",
    pools: ["world","North America","US","US-RI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ri-090",
    lat: 41.672866,
    lng: -71.706728,
    panoId: "L1PqEnct1-DWT-WPCANjwQ",
    place: "Near Coventry, Rhode Island",
    shortName: "Coventry",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "RI",
    state: "Rhode Island",
    difficulty: "explorer",
    pools: ["world","North America","US","US-RI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ri-091",
    lat: 41.562628,
    lng: -71.091878,
    panoId: "v-IwvJraGCvn6uqQK7PPHw",
    place: "Near Head of Westport, Rhode Island",
    shortName: "Head of Westport",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "RI",
    state: "Rhode Island",
    difficulty: "explorer",
    pools: ["world","North America","US","US-RI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ri-092",
    lat: 41.449147,
    lng: -71.86478,
    panoId: "H3NjzBa8TkpBRh8uLyzckA",
    place: "Near Ashaway, Rhode Island",
    shortName: "Ashaway",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "RI",
    state: "Rhode Island",
    difficulty: "explorer",
    pools: ["world","North America","US","US-RI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ri-093",
    lat: 41.558275,
    lng: -71.622196,
    panoId: "jUMzmWWZNGTdcPxlEqO2FA",
    place: "Near Exeter, Rhode Island",
    shortName: "Exeter",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "RI",
    state: "Rhode Island",
    difficulty: "explorer",
    pools: ["world","North America","US","US-RI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ri-094",
    lat: 41.553745,
    lng: -71.652249,
    panoId: "fby20xONFtcoCiK3vFoW6A",
    place: "Near Hope Valley, Rhode Island",
    shortName: "Hope Valley",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "RI",
    state: "Rhode Island",
    difficulty: "explorer",
    pools: ["world","North America","US","US-RI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ri-095",
    lat: 41.641845,
    lng: -71.136261,
    panoId: "g9SGpxXO3OWqxs7l3-HvIA",
    place: "Near North Westport, Rhode Island",
    shortName: "North Westport",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "RI",
    state: "Rhode Island",
    difficulty: "explorer",
    pools: ["world","North America","US","US-RI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ri-096",
    lat: 41.948494,
    lng: -71.920612,
    panoId: "Vi_meiGR8THdpadKau5OIw",
    place: "Near South Woodstock, Rhode Island",
    shortName: "South Woodstock",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "RI",
    state: "Rhode Island",
    difficulty: "explorer",
    pools: ["world","North America","US","US-RI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ri-097",
    lat: 41.781179,
    lng: -71.573228,
    panoId: "fMb7dkBNIVCOP6_FiXsoSQ",
    place: "Near North Scituate, Rhode Island",
    shortName: "North Scituate",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "RI",
    state: "Rhode Island",
    difficulty: "explorer",
    pools: ["world","North America","US","US-RI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ri-098",
    lat: 41.568827,
    lng: -71.954005,
    panoId: "Oh4GPk09UxqPveecz5MIfA",
    place: "Near Preston City, Rhode Island",
    shortName: "Preston City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "RI",
    state: "Rhode Island",
    difficulty: "explorer",
    pools: ["world","North America","US","US-RI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ri-099",
    lat: 41.437048,
    lng: -71.706401,
    panoId: "eGI62yNbG6hXj51Q-6xF2Q",
    place: "Near Bradford, Rhode Island",
    shortName: "Bradford",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "RI",
    state: "Rhode Island",
    difficulty: "explorer",
    pools: ["world","North America","US","US-RI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ri-100",
    lat: 41.853885,
    lng: -71.758166,
    panoId: "xdatuO0vgZQkMi9F-smfzQ",
    place: "Near Foster, Rhode Island",
    shortName: "Foster",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "RI",
    state: "Rhode Island",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-RI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ri-101",
    lat: 41.855454,
    lng: -71.724259,
    panoId: "czSF4KKDl1eDa52XZMt_Ig",
    place: "Near Foster, Rhode Island",
    shortName: "Foster",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "RI",
    state: "Rhode Island",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-RI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ri-102",
    lat: 41.867235,
    lng: -71.732419,
    panoId: "jVB96-vv69iTL5W_v2Jvvw",
    place: "Near Foster, Rhode Island",
    shortName: "Foster",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "RI",
    state: "Rhode Island",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-RI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ri-103",
    lat: 41.491749,
    lng: -71.666658,
    panoId: "JdxJf3fyWvFeDKV3WXV0nw",
    place: "Near Hope Valley, Rhode Island",
    shortName: "Hope Valley",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "RI",
    state: "Rhode Island",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-RI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ri-104",
    lat: 41.926214,
    lng: -71.698689,
    panoId: "qWTXLeRMpgIp-tkVjgcjnA",
    place: "Near Chepachet, Rhode Island",
    shortName: "Chepachet",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "RI",
    state: "Rhode Island",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-RI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ri-105",
    lat: 41.500429,
    lng: -71.168658,
    panoId: "qgJMnxt-uAHcai_tci20Fw",
    place: "Near Newport East, Rhode Island",
    shortName: "Newport East",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "RI",
    state: "Rhode Island",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-RI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sc-000",
    lat: 34.000803,
    lng: -81.034865,
    panoId: "JYqPG-gVBmeJlaS6Rir1kQ",
    place: "Near Columbia, South Carolina",
    shortName: "Columbia",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SC",
    state: "South Carolina",
    difficulty: "classic",
    pools: ["world","North America","US","US-SC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sc-001",
    lat: 34.949529,
    lng: -81.932005,
    panoId: "ixii3h-__XuPuCzmoocYfA",
    place: "Near Spartanburg, South Carolina",
    shortName: "Spartanburg",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SC",
    state: "South Carolina",
    difficulty: "classic",
    pools: ["world","North America","US","US-SC"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-sc-002",
    lat: 34.938668,
    lng: -82.227037,
    panoId: "lluzTnwmoAy8hISMgVgoFA",
    place: "Near Greer, South Carolina",
    shortName: "Greer",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SC",
    state: "South Carolina",
    difficulty: "classic",
    pools: ["world","North America","US","US-SC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sc-003",
    lat: 32.776368,
    lng: -79.932745,
    panoId: "i799S9yJ6BIsw-QgLeoEhg",
    place: "Near Charleston, South Carolina",
    shortName: "Charleston",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SC",
    state: "South Carolina",
    difficulty: "classic",
    pools: ["world","North America","US","US-SC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sc-004",
    lat: 34.852683,
    lng: -82.394162,
    panoId: "AQ4wwfb3iLV5k0NxgoxKLA",
    place: "Near Greenville, South Carolina",
    shortName: "Greenville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SC",
    state: "South Carolina",
    difficulty: "classic",
    pools: ["world","North America","US","US-SC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sc-005",
    lat: 32.854562,
    lng: -79.974905,
    panoId: "cVph201Eih0c3iGg3ZGEkg",
    place: "Near North Charleston, South Carolina",
    shortName: "North Charleston",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SC",
    state: "South Carolina",
    difficulty: "classic",
    pools: ["world","North America","US","US-SC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sc-006",
    lat: 32.981027,
    lng: -80.032567,
    panoId: "vQHr86xlmmSm-9oY8CSHew",
    place: "Near Goose Creek, South Carolina",
    shortName: "Goose Creek",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SC",
    state: "South Carolina",
    difficulty: "classic",
    pools: ["world","North America","US","US-SC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sc-007",
    lat: 32.794348,
    lng: -79.862518,
    panoId: "hlVFB3_C-VdzOrzOGOuIoA",
    place: "Near Mount Pleasant, South Carolina",
    shortName: "Mount Pleasant",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SC",
    state: "South Carolina",
    difficulty: "classic",
    pools: ["world","North America","US","US-SC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sc-008",
    lat: 33.018715,
    lng: -80.175502,
    panoId: "bo9kpGMUVBEe2jd2Rx7Pjw",
    place: "Near Summerville, South Carolina",
    shortName: "Summerville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SC",
    state: "South Carolina",
    difficulty: "classic",
    pools: ["world","North America","US","US-SC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sc-009",
    lat: 33.689332,
    lng: -78.88709,
    panoId: "6AQwj9asByLC_o-MhACM7Q",
    place: "Near Myrtle Beach, South Carolina",
    shortName: "Myrtle Beach",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SC",
    state: "South Carolina",
    difficulty: "classic",
    pools: ["world","North America","US","US-SC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sc-010",
    lat: 34.195357,
    lng: -79.762488,
    panoId: "Ro1AC4L9tOWI1_HZIbDe_w",
    place: "Near Florence, South Carolina",
    shortName: "Florence",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SC",
    state: "South Carolina",
    difficulty: "classic",
    pools: ["world","North America","US","US-SC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sc-011",
    lat: 34.042576,
    lng: -81.100561,
    panoId: "lejZTpt4tnjdKNOB_BoZKA",
    place: "Near Saint Andrews, South Carolina",
    shortName: "Saint Andrews",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SC",
    state: "South Carolina",
    difficulty: "classic",
    pools: ["world","North America","US","US-SC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sc-012",
    lat: 33.560433,
    lng: -81.719549,
    panoId: "ruoIDkaVGoatqJVdug6igA",
    place: "Near Aiken, South Carolina",
    shortName: "Aiken",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SC",
    state: "South Carolina",
    difficulty: "classic",
    pools: ["world","North America","US","US-SC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sc-013",
    lat: 34.920578,
    lng: -82.296154,
    panoId: "q2HWfIRaUIGi2s6gvJBvPA",
    place: "Near Taylors, South Carolina",
    shortName: "Taylors",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SC",
    state: "South Carolina",
    difficulty: "classic",
    pools: ["world","North America","US","US-SC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sc-014",
    lat: 34.82984,
    lng: -82.601401,
    panoId: "Byu5nZ7sclfQln_VnSZoXg",
    place: "Near Easley, South Carolina",
    shortName: "Easley",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SC",
    state: "South Carolina",
    difficulty: "classic",
    pools: ["world","North America","US","US-SC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sc-015",
    lat: 32.918511,
    lng: -80.021979,
    panoId: "8hQAvVY9a8CRHSt_OAHK_w",
    place: "Near Hanahan, South Carolina",
    shortName: "Hanahan",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SC",
    state: "South Carolina",
    difficulty: "classic",
    pools: ["world","North America","US","US-SC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sc-016",
    lat: 34.903752,
    lng: -82.333209,
    panoId: "eo6E0TCZE8tE_Dxvp6OfsQ",
    place: "Near Wade Hampton, South Carolina",
    shortName: "Wade Hampton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SC",
    state: "South Carolina",
    difficulty: "classic",
    pools: ["world","North America","US","US-SC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sc-017",
    lat: 33.92037,
    lng: -80.341485,
    panoId: "v4n_MNBzJyXw-Mn3aKkDkQ",
    place: "Near Sumter, South Carolina",
    shortName: "Sumter",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SC",
    state: "South Carolina",
    difficulty: "classic",
    pools: ["world","North America","US","US-SC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sc-018",
    lat: 34.683473,
    lng: -82.837532,
    panoId: "VNbgX_6ZIQwHzw0tLc98GA",
    place: "Near Clemson, South Carolina",
    shortName: "Clemson",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SC",
    state: "South Carolina",
    difficulty: "classic",
    pools: ["world","North America","US","US-SC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sc-019",
    lat: 34.737141,
    lng: -82.253844,
    panoId: "T-tb13Oc-1lzCKobuPQv2w",
    place: "Near Simpsonville, South Carolina",
    shortName: "Simpsonville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SC",
    state: "South Carolina",
    difficulty: "classic",
    pools: ["world","North America","US","US-SC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sc-020",
    lat: 34.778797,
    lng: -82.310008,
    panoId: "CDtYAjWhMUiUSE9GoLF_QQ",
    place: "Near Mauldin, South Carolina",
    shortName: "Mauldin",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SC",
    state: "South Carolina",
    difficulty: "classic",
    pools: ["world","North America","US","US-SC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sc-021",
    lat: 33.683476,
    lng: -78.998407,
    panoId: "iAnmzTNO4KySmVOJJqy3-w",
    place: "Near Socastee, South Carolina",
    shortName: "Socastee",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SC",
    state: "South Carolina",
    difficulty: "classic",
    pools: ["world","North America","US","US-SC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sc-022",
    lat: 34.503469,
    lng: -82.650154,
    panoId: "xiX-Mljv7Mh4ZkB7bOr-VA",
    place: "Near Anderson, South Carolina",
    shortName: "Anderson",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SC",
    state: "South Carolina",
    difficulty: "classic",
    pools: ["world","North America","US","US-SC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sc-023",
    lat: 34.885323,
    lng: -82.45623,
    panoId: "Ybb9I6ypiWhGic_-iTnYjg",
    place: "Near Berea, South Carolina",
    shortName: "Berea",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SC",
    state: "South Carolina",
    difficulty: "classic",
    pools: ["world","North America","US","US-SC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sc-024",
    lat: 33.993532,
    lng: -81.073986,
    panoId: "qFB51tdmAxiMLd3PNif0SA",
    place: "Near West Columbia, South Carolina",
    shortName: "West Columbia",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SC",
    state: "South Carolina",
    difficulty: "classic",
    pools: ["world","North America","US","US-SC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sc-025",
    lat: 33.98141,
    lng: -81.23628,
    panoId: "i1Hn9xVzf1pwrqepyDDP_A",
    place: "Near Lexington, South Carolina",
    shortName: "Lexington",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SC",
    state: "South Carolina",
    difficulty: "classic",
    pools: ["world","North America","US","US-SC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sc-026",
    lat: 33.816021,
    lng: -78.679967,
    panoId: "Uvrtwk5tbvje20MFA7dBPA",
    place: "Near North Myrtle Beach, South Carolina",
    shortName: "North Myrtle Beach",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SC",
    state: "South Carolina",
    difficulty: "classic",
    pools: ["world","North America","US","US-SC"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-sc-027",
    lat: 34.049225,
    lng: -81.146593,
    panoId: "KbNHgyJ7CpgUgDqJdye9Kg",
    place: "Near Seven Oaks, South Carolina",
    shortName: "Seven Oaks",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SC",
    state: "South Carolina",
    difficulty: "classic",
    pools: ["world","North America","US","US-SC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sc-028",
    lat: 34.804795,
    lng: -82.229528,
    panoId: "iAb4Yce0zrGn75DopXL6HQ",
    place: "Near Five Forks, South Carolina",
    shortName: "Five Forks",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SC",
    state: "South Carolina",
    difficulty: "classic",
    pools: ["world","North America","US","US-SC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sc-029",
    lat: 34.800094,
    lng: -82.424354,
    panoId: "l_FYdJ4ShIeMJiXKI8kwwQ",
    place: "Near Gantt, South Carolina",
    shortName: "Gantt",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SC",
    state: "South Carolina",
    difficulty: "classic",
    pools: ["world","North America","US","US-SC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sc-030",
    lat: 33.835916,
    lng: -79.047814,
    panoId: "GEehBsO1b5lxYMnConK2Kg",
    place: "Near Conway, South Carolina",
    shortName: "Conway",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SC",
    state: "South Carolina",
    difficulty: "classic",
    pools: ["world","North America","US","US-SC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sc-031",
    lat: 34.195283,
    lng: -82.161809,
    panoId: "Tx5HIXjg7qYLCLGlvy-OeQ",
    place: "Near Greenwood, South Carolina",
    shortName: "Greenwood",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SC",
    state: "South Carolina",
    difficulty: "classic",
    pools: ["world","North America","US","US-SC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sc-032",
    lat: 32.216388,
    lng: -80.752611,
    panoId: "fsDsRZPpzMHJSSaKXb-3LA",
    place: "Near Hilton Head, South Carolina",
    shortName: "Hilton Head",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SC",
    state: "South Carolina",
    difficulty: "classic",
    pools: ["world","North America","US","US-SC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sc-033",
    lat: 33.491855,
    lng: -80.855736,
    panoId: "-TqFNmc6yA3vJD_DZTjvrg",
    place: "Near Orangeburg, South Carolina",
    shortName: "Orangeburg",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SC",
    state: "South Carolina",
    difficulty: "classic",
    pools: ["world","North America","US","US-SC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sc-034",
    lat: 32.237147,
    lng: -80.860381,
    panoId: "CWUOPAF9qbzhM6JfVtvGFg",
    place: "Near Bluffton, South Carolina",
    shortName: "Bluffton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SC",
    state: "South Carolina",
    difficulty: "classic",
    pools: ["world","North America","US","US-SC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sc-035",
    lat: 33.965664,
    lng: -81.074088,
    panoId: "ZM4awkqj1vh9NO4Vze2k7A",
    place: "Near Cayce, South Carolina",
    shortName: "Cayce",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SC",
    state: "South Carolina",
    difficulty: "classic",
    pools: ["world","North America","US","US-SC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sc-036",
    lat: 34.064014,
    lng: -80.958084,
    panoId: "-1hR6QcjpNFbqsnpuM7tWw",
    place: "Near Dentsville, South Carolina",
    shortName: "Dentsville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SC",
    state: "South Carolina",
    difficulty: "classic",
    pools: ["world","North America","US","US-SC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sc-037",
    lat: 34.936532,
    lng: -81.915386,
    panoId: "j09sJbEKiqTx_0_gOMykAg",
    place: "Near Spartanburg, South Carolina",
    shortName: "Spartanburg",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SC",
    state: "South Carolina",
    difficulty: "classic",
    pools: ["world","North America","US","US-SC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sc-038",
    lat: 34.873957,
    lng: -82.390699,
    panoId: "-TnTLzz7plQaoOB8x3z_eA",
    place: "Near Greenville, South Carolina",
    shortName: "Greenville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SC",
    state: "South Carolina",
    difficulty: "classic",
    pools: ["world","North America","US","US-SC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sc-039",
    lat: 33.013277,
    lng: -80.154533,
    panoId: "CVCuLHt4Qj66uSzkcR5IOQ",
    place: "Near Lincolnville, South Carolina",
    shortName: "Lincolnville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SC",
    state: "South Carolina",
    difficulty: "classic",
    pools: ["world","North America","US","US-SC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sc-040",
    lat: 33.819583,
    lng: -78.668445,
    panoId: "dA5TLIpr9V6L4O3kGqqlsg",
    place: "Near North Myrtle Beach, South Carolina",
    shortName: "North Myrtle Beach",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SC",
    state: "South Carolina",
    difficulty: "classic",
    pools: ["world","North America","US","US-SC"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-sc-041",
    lat: 34.812383,
    lng: -82.418986,
    panoId: "7j6DdTzwCgxiF_1vdldAvg",
    place: "Near Dunean, South Carolina",
    shortName: "Dunean",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SC",
    state: "South Carolina",
    difficulty: "classic",
    pools: ["world","North America","US","US-SC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sc-042",
    lat: 32.985664,
    lng: -80.109758,
    panoId: "bGVxsxmd6URdcmWVW9F7cA",
    place: "Near Ladson, South Carolina",
    shortName: "Ladson",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SC",
    state: "South Carolina",
    difficulty: "classic",
    pools: ["world","North America","US","US-SC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sc-043",
    lat: 33.980038,
    lng: -81.256742,
    panoId: "iHVtRjhKttrkPJToH6sMbQ",
    place: "Near Lexington, South Carolina",
    shortName: "Lexington",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SC",
    state: "South Carolina",
    difficulty: "classic",
    pools: ["world","North America","US","US-SC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sc-044",
    lat: 32.181251,
    lng: -80.734347,
    panoId: "1kS3AqTSDevK1wyrQ3uK3A",
    place: "Near Hilton Head Island, South Carolina",
    shortName: "Hilton Head Island",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SC",
    state: "South Carolina",
    difficulty: "classic",
    pools: ["world","North America","US","US-SC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sc-045",
    lat: 34.493592,
    lng: -82.663524,
    panoId: "r42C9-2VzphNnHbbadJcuQ",
    place: "Near Anderson, South Carolina",
    shortName: "Anderson",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SC",
    state: "South Carolina",
    difficulty: "classic",
    pools: ["world","North America","US","US-SC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sc-046",
    lat: 34.936484,
    lng: -82.209082,
    panoId: "JHoI9EOWfgszudqb05gReQ",
    place: "Near Greer, South Carolina",
    shortName: "Greer",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SC",
    state: "South Carolina",
    difficulty: "classic",
    pools: ["world","North America","US","US-SC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sc-047",
    lat: 34.680469,
    lng: -82.824215,
    panoId: "Trp286_gjxSXyE3x9uu0uw",
    place: "Near Clemson, South Carolina",
    shortName: "Clemson",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SC",
    state: "South Carolina",
    difficulty: "classic",
    pools: ["world","North America","US","US-SC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sc-048",
    lat: 33.567522,
    lng: -81.709271,
    panoId: "AumLnpndY9nPcqT7sIbcLQ",
    place: "Near Aiken, South Carolina",
    shortName: "Aiken",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SC",
    state: "South Carolina",
    difficulty: "classic",
    pools: ["world","North America","US","US-SC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sc-049",
    lat: 34.838168,
    lng: -82.623764,
    panoId: "PiOz13hLGXr1cVY7BLIapg",
    place: "Near Arial, South Carolina",
    shortName: "Arial",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SC",
    state: "South Carolina",
    difficulty: "classic",
    pools: ["world","North America","US","US-SC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sc-050",
    lat: 33.723822,
    lng: -79.024369,
    panoId: "CUpe7eMQc67JViSsSC5Qew",
    place: "Near Socastee, South Carolina",
    shortName: "Socastee",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SC",
    state: "South Carolina",
    difficulty: "explorer",
    pools: ["world","North America","US","US-SC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sc-051",
    lat: 34.783259,
    lng: -82.64399,
    panoId: "VFkwWEobTQPhewT92Pw0OQ",
    place: "Near Liberty, South Carolina",
    shortName: "Liberty",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SC",
    state: "South Carolina",
    difficulty: "explorer",
    pools: ["world","North America","US","US-SC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sc-052",
    lat: 33.847986,
    lng: -79.009004,
    panoId: "p3PGn_8OPtg-Y9B97T9FWw",
    place: "Near Red Hill, South Carolina",
    shortName: "Red Hill",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SC",
    state: "South Carolina",
    difficulty: "explorer",
    pools: ["world","North America","US","US-SC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sc-053",
    lat: 33.464928,
    lng: -82.034255,
    panoId: "ovBIoh2-44qoYJ15do1CdA",
    place: "Near Augusta, South Carolina",
    shortName: "Augusta",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SC",
    state: "South Carolina",
    difficulty: "explorer",
    pools: ["world","North America","US","US-SC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sc-054",
    lat: 34.230547,
    lng: -82.128357,
    panoId: "Ve6SytVHYZBiu0BAnjsTPw",
    place: "Near Greenwood, South Carolina",
    shortName: "Greenwood",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SC",
    state: "South Carolina",
    difficulty: "explorer",
    pools: ["world","North America","US","US-SC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sc-055",
    lat: 33.549672,
    lng: -80.862428,
    panoId: "iVYgVyXp35A69cZ2bQwnUQ",
    place: "Near Wilkinson Heights, South Carolina",
    shortName: "Wilkinson Heights",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SC",
    state: "South Carolina",
    difficulty: "explorer",
    pools: ["world","North America","US","US-SC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sc-056",
    lat: 32.152761,
    lng: -80.731496,
    panoId: "huZErIm-9u5yJ87UsUX-GQ",
    place: "Near Hilton Head Island, South Carolina",
    shortName: "Hilton Head Island",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SC",
    state: "South Carolina",
    difficulty: "explorer",
    pools: ["world","North America","US","US-SC"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-sc-057",
    lat: 33.941619,
    lng: -80.276393,
    panoId: "U_pmPY-WrstR4xP3M7IDNg",
    place: "Near East Sumter, South Carolina",
    shortName: "East Sumter",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SC",
    state: "South Carolina",
    difficulty: "explorer",
    pools: ["world","North America","US","US-SC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sc-058",
    lat: 33.989625,
    lng: -81.192398,
    panoId: "sP5ChcG9sFvU5AtqpTQJbg",
    place: "Near Lexington, South Carolina",
    shortName: "Lexington",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SC",
    state: "South Carolina",
    difficulty: "explorer",
    pools: ["world","North America","US","US-SC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sc-059",
    lat: 34.780545,
    lng: -82.386945,
    panoId: "BgG4mhZx9ty62P_5BCwo4A",
    place: "Near Gantt, South Carolina",
    shortName: "Gantt",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SC",
    state: "South Carolina",
    difficulty: "explorer",
    pools: ["world","North America","US","US-SC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sc-060",
    lat: 34.15093,
    lng: -79.738488,
    panoId: "p6xoe-poe1_hhPI55NxGYA",
    place: "Near Florence, South Carolina",
    shortName: "Florence",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SC",
    state: "South Carolina",
    difficulty: "explorer",
    pools: ["world","North America","US","US-SC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sc-061",
    lat: 34.034227,
    lng: -81.017387,
    panoId: "hoB92Wr2uHpFIStSvNHaxw",
    place: "Near Forest Acres, South Carolina",
    shortName: "Forest Acres",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SC",
    state: "South Carolina",
    difficulty: "explorer",
    pools: ["world","North America","US","US-SC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sc-062",
    lat: 32.958555,
    lng: -80.130056,
    panoId: "_GxxsV7khc-pFxU-zNEkVg",
    place: "Near Ladson, South Carolina",
    shortName: "Ladson",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SC",
    state: "South Carolina",
    difficulty: "explorer",
    pools: ["world","North America","US","US-SC"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-sc-063",
    lat: 34.728139,
    lng: -82.30888,
    panoId: "VqRVjgVYnf6rtf55mEuh7Q",
    place: "Near Simpsonville, South Carolina",
    shortName: "Simpsonville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SC",
    state: "South Carolina",
    difficulty: "explorer",
    pools: ["world","North America","US","US-SC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sc-064",
    lat: 33.974077,
    lng: -81.016978,
    panoId: "Kqll_GmJ95zggU1daT3rMg",
    place: "Near Columbia, South Carolina",
    shortName: "Columbia",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SC",
    state: "South Carolina",
    difficulty: "explorer",
    pools: ["world","North America","US","US-SC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sc-065",
    lat: 34.927226,
    lng: -81.984209,
    panoId: "7os66636TUDPrecipr_Q_g",
    place: "Near Arcadia, South Carolina",
    shortName: "Arcadia",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SC",
    state: "South Carolina",
    difficulty: "explorer",
    pools: ["world","North America","US","US-SC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sc-066",
    lat: 34.631978,
    lng: -82.829395,
    panoId: "ibg-GjY5YwaCw72TG4XlJw",
    place: "Near Pendleton, South Carolina",
    shortName: "Pendleton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SC",
    state: "South Carolina",
    difficulty: "explorer",
    pools: ["world","North America","US","US-SC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sc-067",
    lat: 33.524963,
    lng: -80.90568,
    panoId: "F2wo_Ndw6rKsOJIOxFzuQA",
    place: "Near Edisto, South Carolina",
    shortName: "Edisto",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SC",
    state: "South Carolina",
    difficulty: "explorer",
    pools: ["world","North America","US","US-SC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sc-068",
    lat: 32.151626,
    lng: -80.767169,
    panoId: "eBo7XEbK454cn4aKdPaw-A",
    place: "Near Hilton Head Island, South Carolina",
    shortName: "Hilton Head Island",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SC",
    state: "South Carolina",
    difficulty: "explorer",
    pools: ["world","North America","US","US-SC"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-sc-069",
    lat: 33.838107,
    lng: -78.744613,
    panoId: "C4aNACUHjdNHOOVy4zR0Gg",
    place: "Near North Myrtle Beach, South Carolina",
    shortName: "North Myrtle Beach",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SC",
    state: "South Carolina",
    difficulty: "explorer",
    pools: ["world","North America","US","US-SC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sc-070",
    lat: 33.607375,
    lng: -81.741478,
    panoId: "m-ROsdJFhEjLER1IVuZDOA",
    place: "Near Aiken, South Carolina",
    shortName: "Aiken",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SC",
    state: "South Carolina",
    difficulty: "explorer",
    pools: ["world","North America","US","US-SC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sc-071",
    lat: 34.209559,
    lng: -82.205412,
    panoId: "GhgdAJGA1NXAhg1ZZ1v-2A",
    place: "Near Greenwood, South Carolina",
    shortName: "Greenwood",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SC",
    state: "South Carolina",
    difficulty: "explorer",
    pools: ["world","North America","US","US-SC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sc-072",
    lat: 34.921903,
    lng: -82.410715,
    panoId: "LSlxX9RdAbKltg38wityMA",
    place: "Near Sans Souci, South Carolina",
    shortName: "Sans Souci",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SC",
    state: "South Carolina",
    difficulty: "explorer",
    pools: ["world","North America","US","US-SC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sc-073",
    lat: 32.9652,
    lng: -80.222918,
    panoId: "gqBqTd9Zy9dIUFEkPi01tg",
    place: "Near Centerville, South Carolina",
    shortName: "Centerville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SC",
    state: "South Carolina",
    difficulty: "explorer",
    pools: ["world","North America","US","US-SC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sc-074",
    lat: 32.864967,
    lng: -80.005274,
    panoId: "7lL99mVmccFEIX-QJ2J70A",
    place: "Near North Charleston, South Carolina",
    shortName: "North Charleston",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SC",
    state: "South Carolina",
    difficulty: "explorer",
    pools: ["world","North America","US","US-SC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sc-075",
    lat: 34.878963,
    lng: -82.275328,
    panoId: "P77Y7wlxYgdzzzXsJRNLUg",
    place: "Near Taylors, South Carolina",
    shortName: "Taylors",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SC",
    state: "South Carolina",
    difficulty: "explorer",
    pools: ["world","North America","US","US-SC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sc-076",
    lat: 33.813131,
    lng: -79.101773,
    panoId: "MiXvaA-F5qUvaczgad75_Q",
    place: "Near Conway, South Carolina",
    shortName: "Conway",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SC",
    state: "South Carolina",
    difficulty: "explorer",
    pools: ["world","North America","US","US-SC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sc-077",
    lat: 34.806308,
    lng: -82.299198,
    panoId: "tni1bIjno1scWqP321cRpg",
    place: "Near Mauldin, South Carolina",
    shortName: "Mauldin",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SC",
    state: "South Carolina",
    difficulty: "explorer",
    pools: ["world","North America","US","US-SC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sc-078",
    lat: 33.937014,
    lng: -79.221124,
    panoId: "oFZdWPHQFGuZXB2Yi1negw",
    place: "Near Red Hill, South Carolina",
    shortName: "Red Hill",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SC",
    state: "South Carolina",
    difficulty: "explorer",
    pools: ["world","North America","US","US-SC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sc-079",
    lat: 34.125965,
    lng: -79.777635,
    panoId: "91mfn4NHZ5cUdcUXWfCxMw",
    place: "Near Florence, South Carolina",
    shortName: "Florence",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SC",
    state: "South Carolina",
    difficulty: "explorer",
    pools: ["world","North America","US","US-SC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sc-080",
    lat: 34.531262,
    lng: -82.638969,
    panoId: "iHWOFwfcq7GRM6oY0KqZCg",
    place: "Near Anderson, South Carolina",
    shortName: "Anderson",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SC",
    state: "South Carolina",
    difficulty: "explorer",
    pools: ["world","North America","US","US-SC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sc-081",
    lat: 33.905195,
    lng: -80.421001,
    panoId: "ZhwQrKykXBCoPvn-4_O2pA",
    place: "Near Cane Savannah, South Carolina",
    shortName: "Cane Savannah",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SC",
    state: "South Carolina",
    difficulty: "explorer",
    pools: ["world","North America","US","US-SC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sc-082",
    lat: 32.961211,
    lng: -80.184379,
    panoId: "NnlfQ_aKu8Nb9fdpZPTJdQ",
    place: "Near Centerville, South Carolina",
    shortName: "Centerville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SC",
    state: "South Carolina",
    difficulty: "explorer",
    pools: ["world","North America","US","US-SC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sc-083",
    lat: 34.972322,
    lng: -82.249037,
    panoId: "rjUNOFjYrD5-24Q4JRDbMQ",
    place: "Near Greer, South Carolina",
    shortName: "Greer",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SC",
    state: "South Carolina",
    difficulty: "explorer",
    pools: ["world","North America","US","US-SC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sc-084",
    lat: 32.235743,
    lng: -80.952976,
    panoId: "qBxpDEOLFWt4LfBRfnKHbQ",
    place: "Near Bluffton, South Carolina",
    shortName: "Bluffton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SC",
    state: "South Carolina",
    difficulty: "explorer",
    pools: ["world","North America","US","US-SC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sc-085",
    lat: 34.712417,
    lng: -82.425443,
    panoId: "0lcObk1SsdYkEfkms45ijw",
    place: "Near Golden Grove, South Carolina",
    shortName: "Golden Grove",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SC",
    state: "South Carolina",
    difficulty: "explorer",
    pools: ["world","North America","US","US-SC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sc-086",
    lat: 34.02781,
    lng: -81.055977,
    panoId: "QSMMu4dHZ5HshWGJGQLsMQ",
    place: "Near Columbia, South Carolina",
    shortName: "Columbia",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SC",
    state: "South Carolina",
    difficulty: "explorer",
    pools: ["world","North America","US","US-SC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sc-087",
    lat: 34.699818,
    lng: -82.557048,
    panoId: "YZniFfNZLK4gouQARQV82A",
    place: "Near Piedmont, South Carolina",
    shortName: "Piedmont",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SC",
    state: "South Carolina",
    difficulty: "explorer",
    pools: ["world","North America","US","US-SC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sc-088",
    lat: 33.910831,
    lng: -78.512423,
    panoId: "afCXP0RmATm8TJ6-J52zaA",
    place: "Near Sunset Beach, South Carolina",
    shortName: "Sunset Beach",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SC",
    state: "South Carolina",
    difficulty: "explorer",
    pools: ["world","North America","US","US-SC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sc-089",
    lat: 34.170008,
    lng: -81.133232,
    panoId: "B-yVn1x_Tcrz9t3FZx5u2g",
    place: "Near Irmo, South Carolina",
    shortName: "Irmo",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SC",
    state: "South Carolina",
    difficulty: "explorer",
    pools: ["world","North America","US","US-SC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sc-090",
    lat: 33.989278,
    lng: -81.268685,
    panoId: "fM8jX9s2i27NOo43QSCUDQ",
    place: "Near Lexington, South Carolina",
    shortName: "Lexington",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SC",
    state: "South Carolina",
    difficulty: "explorer",
    pools: ["world","North America","US","US-SC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sc-091",
    lat: 34.374005,
    lng: -81.530868,
    panoId: "IUUEuq81i97oh670RdoDrQ",
    place: "Near Newberry, South Carolina",
    shortName: "Newberry",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SC",
    state: "South Carolina",
    difficulty: "explorer",
    pools: ["world","North America","US","US-SC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sc-092",
    lat: 33.958208,
    lng: -81.009472,
    panoId: "a3DYrfc8fNhq6O7fNbseoA",
    place: "Near Columbia, South Carolina",
    shortName: "Columbia",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SC",
    state: "South Carolina",
    difficulty: "explorer",
    pools: ["world","North America","US","US-SC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sc-093",
    lat: 32.370442,
    lng: -80.805188,
    panoId: "Ds-asu89BPj_hjTwlgnzxg",
    place: "Near Shell Point, South Carolina",
    shortName: "Shell Point",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SC",
    state: "South Carolina",
    difficulty: "explorer",
    pools: ["world","North America","US","US-SC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sc-094",
    lat: 33.937761,
    lng: -81.31546,
    panoId: "p_Pn4P_W9VN9m5_d-QihNA",
    place: "Near Red Bank, South Carolina",
    shortName: "Red Bank",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SC",
    state: "South Carolina",
    difficulty: "explorer",
    pools: ["world","North America","US","US-SC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sc-095",
    lat: 34.019306,
    lng: -81.13455,
    panoId: "nmd7dbfuyWBFPauTA0K2Ig",
    place: "Near Seven Oaks, South Carolina",
    shortName: "Seven Oaks",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SC",
    state: "South Carolina",
    difficulty: "explorer",
    pools: ["world","North America","US","US-SC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sc-096",
    lat: 34.144266,
    lng: -79.326721,
    panoId: "b40wSXhRY_eAAdZBvxrb6w",
    place: "Near Marion, South Carolina",
    shortName: "Marion",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SC",
    state: "South Carolina",
    difficulty: "explorer",
    pools: ["world","North America","US","US-SC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sc-097",
    lat: 35.004346,
    lng: -82.515325,
    panoId: "LyY_4Pn69GQNa0PCrK8R2g",
    place: "Near Slater-Marietta, South Carolina",
    shortName: "Slater-Marietta",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SC",
    state: "South Carolina",
    difficulty: "explorer",
    pools: ["world","North America","US","US-SC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sc-098",
    lat: 34.969048,
    lng: -81.792072,
    panoId: "AvqEBkVs7jyNeC4Vkw5LTw",
    place: "Near Cowpens, South Carolina",
    shortName: "Cowpens",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SC",
    state: "South Carolina",
    difficulty: "explorer",
    pools: ["world","North America","US","US-SC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sc-099",
    lat: 32.905416,
    lng: -80.11925,
    panoId: "eCX3Nc-hBBLMJYL09oimHg",
    place: "Near Ladson, South Carolina",
    shortName: "Ladson",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SC",
    state: "South Carolina",
    difficulty: "explorer",
    pools: ["world","North America","US","US-SC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sc-100",
    lat: 33.652379,
    lng: -79.18335,
    panoId: "7AvSDtivMGEwTZBqsa4qDA",
    place: "Near Murrells Inlet, South Carolina",
    shortName: "Murrells Inlet",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SC",
    state: "South Carolina",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-SC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sc-101",
    lat: 33.869915,
    lng: -79.224776,
    panoId: "swoPXH5lsZdUZZppX9G8EA",
    place: "Near Red Hill, South Carolina",
    shortName: "Red Hill",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SC",
    state: "South Carolina",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-SC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sc-102",
    lat: 34.79454,
    lng: -80.957955,
    panoId: "xbZogycZh4IqrVgvERh52w",
    place: "Near Catawba, South Carolina",
    shortName: "Catawba",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SC",
    state: "South Carolina",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-SC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sc-103",
    lat: 34.137957,
    lng: -81.500776,
    panoId: "NLDxahrAe6nOE09FX1sODw",
    place: "Near Prosperity, South Carolina",
    shortName: "Prosperity",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SC",
    state: "South Carolina",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-SC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sc-104",
    lat: 34.511794,
    lng: -82.234686,
    panoId: "6jMj0y0zRBlqpA77VVbshQ",
    place: "Near Ware Shoals, South Carolina",
    shortName: "Ware Shoals",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SC",
    state: "South Carolina",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-SC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sc-105",
    lat: 33.093463,
    lng: -80.340124,
    panoId: "tQy8X0DVW_lqedBY1etsdw",
    place: "Near Ridgeville, South Carolina",
    shortName: "Ridgeville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SC",
    state: "South Carolina",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-SC"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sd-000",
    lat: 44.368254,
    lng: -100.350887,
    panoId: "5vYg1Bsl-d7onQ82sL1B0g",
    place: "Near Pierre, South Dakota",
    shortName: "Pierre",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SD",
    state: "South Dakota",
    difficulty: "classic",
    pools: ["world","North America","US","US-SD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sd-001",
    lat: 44.899404,
    lng: -97.114993,
    panoId: "kRBa1UOR_koEUF0Xpj_x9Q",
    place: "Near Watertown, South Dakota",
    shortName: "Watertown",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SD",
    state: "South Dakota",
    difficulty: "classic",
    pools: ["world","North America","US","US-SD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sd-002",
    lat: 42.779397,
    lng: -96.929262,
    panoId: "puf2m-cmXPG1LzVB52IPkQ",
    place: "Near Vermillion, South Dakota",
    shortName: "Vermillion",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SD",
    state: "South Dakota",
    difficulty: "classic",
    pools: ["world","North America","US","US-SD"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-sd-003",
    lat: 44.363234,
    lng: -98.214254,
    panoId: "2IgOQDLyuCqwOy7N6TXyqQ",
    place: "Near Huron, South Dakota",
    shortName: "Huron",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SD",
    state: "South Dakota",
    difficulty: "classic",
    pools: ["world","North America","US","US-SD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sd-004",
    lat: 42.871166,
    lng: -97.397272,
    panoId: "UnTBiN13WYSjr3H3VBzRhQ",
    place: "Near Yankton, South Dakota",
    shortName: "Yankton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SD",
    state: "South Dakota",
    difficulty: "classic",
    pools: ["world","North America","US","US-SD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sd-005",
    lat: 43.594719,
    lng: -96.571981,
    panoId: "4nzbKn-qmEXBDE7W136-CA",
    place: "Near Brandon, South Dakota",
    shortName: "Brandon",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SD",
    state: "South Dakota",
    difficulty: "classic",
    pools: ["world","North America","US","US-SD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sd-006",
    lat: 43.709439,
    lng: -98.029751,
    panoId: "P_w_e374s8XU6muoA7Ulag",
    place: "Near Mitchell, South Dakota",
    shortName: "Mitchell",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SD",
    state: "South Dakota",
    difficulty: "classic",
    pools: ["world","North America","US","US-SD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sd-007",
    lat: 45.464683,
    lng: -98.485966,
    panoId: "aH3CcG-1aEHH3gAJ8Z7YSg",
    place: "Near Aberdeen, South Dakota",
    shortName: "Aberdeen",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SD",
    state: "South Dakota",
    difficulty: "classic",
    pools: ["world","North America","US","US-SD"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-sd-008",
    lat: 44.409734,
    lng: -103.509116,
    panoId: "qtcNEpmc-97IvC3OHA1IEA",
    place: "Near Sturgis, South Dakota",
    shortName: "Sturgis",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SD",
    state: "South Dakota",
    difficulty: "classic",
    pools: ["world","North America","US","US-SD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sd-009",
    lat: 43.543462,
    lng: -96.72799,
    panoId: "iq4OJJhqzIpPu6tRWty-_Q",
    place: "Near Sioux Falls, South Dakota",
    shortName: "Sioux Falls",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SD",
    state: "South Dakota",
    difficulty: "classic",
    pools: ["world","North America","US","US-SD"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-sd-010",
    lat: 43.431462,
    lng: -96.697209,
    panoId: "gCPF5UvlOqjuOP0cK-1nlg",
    place: "Near Harrisburg, South Dakota",
    shortName: "Harrisburg",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SD",
    state: "South Dakota",
    difficulty: "classic",
    pools: ["world","North America","US","US-SD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sd-011",
    lat: 44.08056,
    lng: -103.231073,
    panoId: "_t2DGn40fI7kq-CyNv8ccA",
    place: "Near Rapid City, South Dakota",
    shortName: "Rapid City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SD",
    state: "South Dakota",
    difficulty: "classic",
    pools: ["world","North America","US","US-SD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sd-012",
    lat: 44.112431,
    lng: -103.068248,
    panoId: "9oMueCCe6ScCDmvGPVKbOg",
    place: "Near Box Elder, South Dakota",
    shortName: "Box Elder",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SD",
    state: "South Dakota",
    difficulty: "classic",
    pools: ["world","North America","US","US-SD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sd-013",
    lat: 44.062468,
    lng: -103.145437,
    panoId: "CTzwudG29nNpo1ObPD1GNw",
    place: "Near Rapid Valley, South Dakota",
    shortName: "Rapid Valley",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SD",
    state: "South Dakota",
    difficulty: "classic",
    pools: ["world","North America","US","US-SD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sd-014",
    lat: 44.671364,
    lng: -103.852181,
    panoId: "WdiDLpbEoVqMC2M65Vz5ig",
    place: "Near Belle Fourche, South Dakota",
    shortName: "Belle Fourche",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SD",
    state: "South Dakota",
    difficulty: "classic",
    pools: ["world","North America","US","US-SD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sd-015",
    lat: 44.311353,
    lng: -96.798598,
    panoId: "hCv0A41AT_CNZ7IvJkTvAg",
    place: "Near Brookings, South Dakota",
    shortName: "Brookings",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SD",
    state: "South Dakota",
    difficulty: "classic",
    pools: ["world","North America","US","US-SD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sd-016",
    lat: 44.490818,
    lng: -103.859193,
    panoId: "BtZZvhSdEE_SomhnoRd0aw",
    place: "Near Spearfish, South Dakota",
    shortName: "Spearfish",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SD",
    state: "South Dakota",
    difficulty: "classic",
    pools: ["world","North America","US","US-SD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sd-017",
    lat: 44.006047,
    lng: -97.113974,
    panoId: "wTTTy6wpSrJlFuYb9h_9ig",
    place: "Near Madison, South Dakota",
    shortName: "Madison",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SD",
    state: "South Dakota",
    difficulty: "classic",
    pools: ["world","North America","US","US-SD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sd-018",
    lat: 43.696701,
    lng: -98.026218,
    panoId: "c23hQQhBpLuJAGxYxjbFXg",
    place: "Near Mitchell, South Dakota",
    shortName: "Mitchell",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SD",
    state: "South Dakota",
    difficulty: "classic",
    pools: ["world","North America","US","US-SD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sd-019",
    lat: 42.786607,
    lng: -96.913038,
    panoId: "nKmUSQbq0PJ-Mq1StNnqSA",
    place: "Near Vermillion, South Dakota",
    shortName: "Vermillion",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SD",
    state: "South Dakota",
    difficulty: "classic",
    pools: ["world","North America","US","US-SD"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-sd-020",
    lat: 44.355623,
    lng: -100.338161,
    panoId: "CPHQGcf1mOVEU5LN8lW_iQ",
    place: "Near Pierre, South Dakota",
    shortName: "Pierre",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SD",
    state: "South Dakota",
    difficulty: "classic",
    pools: ["world","North America","US","US-SD"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-sd-021",
    lat: 44.895972,
    lng: -97.099682,
    panoId: "9TSgvQw2uxpcOWOwMqCMPg",
    place: "Near Watertown, South Dakota",
    shortName: "Watertown",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SD",
    state: "South Dakota",
    difficulty: "classic",
    pools: ["world","North America","US","US-SD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sd-022",
    lat: 43.580505,
    lng: -96.56851,
    panoId: "8t28mbbN6lRE8sGLyPDnOQ",
    place: "Near Brandon, South Dakota",
    shortName: "Brandon",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SD",
    state: "South Dakota",
    difficulty: "classic",
    pools: ["world","North America","US","US-SD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sd-023",
    lat: 44.422171,
    lng: -103.531306,
    panoId: "w4vZRk9aJREW8Zw-cClBfA",
    place: "Near Sturgis, South Dakota",
    shortName: "Sturgis",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SD",
    state: "South Dakota",
    difficulty: "classic",
    pools: ["world","North America","US","US-SD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sd-024",
    lat: 44.131743,
    lng: -103.069232,
    panoId: "vXLAaSmI40QC6qisIYQkXA",
    place: "Near Ellsworth Air Force Base, South Dakota",
    shortName: "Ellsworth Air Force Base",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SD",
    state: "South Dakota",
    difficulty: "classic",
    pools: ["world","North America","US","US-SD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sd-025",
    lat: 44.154543,
    lng: -103.050577,
    panoId: "EwBN3rSRarw9nHknMhxbPg",
    place: "Near Ellsworth Air Force Base, South Dakota",
    shortName: "Ellsworth Air Force Base",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SD",
    state: "South Dakota",
    difficulty: "classic",
    pools: ["world","North America","US","US-SD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sd-026",
    lat: 44.413398,
    lng: -103.491904,
    panoId: "IIdE68UrtU5gaaHlGj3Kog",
    place: "Near Sturgis, South Dakota",
    shortName: "Sturgis",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SD",
    state: "South Dakota",
    difficulty: "classic",
    pools: ["world","North America","US","US-SD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sd-027",
    lat: 44.078242,
    lng: -103.135534,
    panoId: "dhTpwj50wzB6YUenzNLzyA",
    place: "Near Rapid Valley, South Dakota",
    shortName: "Rapid Valley",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SD",
    state: "South Dakota",
    difficulty: "classic",
    pools: ["world","North America","US","US-SD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sd-028",
    lat: 44.140093,
    lng: -103.042687,
    panoId: "nbTpc8thrAQdjGyWLoNZ0g",
    place: "Near Ellsworth Air Force Base, South Dakota",
    shortName: "Ellsworth Air Force Base",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SD",
    state: "South Dakota",
    difficulty: "classic",
    pools: ["world","North America","US","US-SD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sd-029",
    lat: 42.478214,
    lng: -96.415104,
    panoId: "wA9iMVlFOTgWyUJ1SxyXVg",
    place: "Near South Sioux City, South Dakota",
    shortName: "South Sioux City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SD",
    state: "South Dakota",
    difficulty: "classic",
    pools: ["world","North America","US","US-SD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sd-030",
    lat: 44.151041,
    lng: -103.30813,
    panoId: "JpOcmBKolS3G5iyL0OWppw",
    place: "Near Blackhawk, South Dakota",
    shortName: "Blackhawk",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SD",
    state: "South Dakota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-SD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sd-031",
    lat: 42.527272,
    lng: -96.483071,
    panoId: "wc3zQJDsl_oBTzYjnxXpjQ",
    place: "Near North Sioux City, South Dakota",
    shortName: "North Sioux City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SD",
    state: "South Dakota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-SD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sd-032",
    lat: 43.025511,
    lng: -102.556369,
    panoId: "LKh4z_3-IzXQKv5eh68yLQ",
    place: "Near Pine Ridge, South Dakota",
    shortName: "Pine Ridge",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SD",
    state: "South Dakota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-SD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sd-033",
    lat: 43.810736,
    lng: -99.330415,
    panoId: "EgpytiCT6PSBJJf1XUe97Q",
    place: "Near Chamberlain, South Dakota",
    shortName: "Chamberlain",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SD",
    state: "South Dakota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-SD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sd-034",
    lat: 43.82615,
    lng: -96.70615,
    panoId: "_mftxw3zP9PHEIrd8lkDEg",
    place: "Near Dell Rapids, South Dakota",
    shortName: "Dell Rapids",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SD",
    state: "South Dakota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-SD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sd-035",
    lat: 45.537243,
    lng: -100.428128,
    panoId: "riVxL7r57Amm3u2-WwU0HA",
    place: "Near Mobridge, South Dakota",
    shortName: "Mobridge",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SD",
    state: "South Dakota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-SD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sd-036",
    lat: 43.354274,
    lng: -96.892042,
    panoId: "-b1VSEtNEv_y131sJtuLIA",
    place: "Near Lennox, South Dakota",
    shortName: "Lennox",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SD",
    state: "South Dakota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-SD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sd-037",
    lat: 43.431683,
    lng: -103.474368,
    panoId: "on-yUdrri1SrEzFHGNKVlQ",
    place: "Near Hot Springs, South Dakota",
    shortName: "Hot Springs",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SD",
    state: "South Dakota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-SD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sd-038",
    lat: 45.218957,
    lng: -96.635573,
    panoId: "oHxhjXxCpyZZIHlbhwJYCg",
    place: "Near Milbank, South Dakota",
    shortName: "Milbank",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SD",
    state: "South Dakota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-SD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sd-039",
    lat: 43.623052,
    lng: -96.942603,
    panoId: "DPhI1W7-nt7epxHg-Bn-aw",
    place: "Near Hartford, South Dakota",
    shortName: "Hartford",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SD",
    state: "South Dakota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-SD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sd-040",
    lat: 44.0077,
    lng: -103.315941,
    panoId: "GkH0JgqH8onkn18d0_RhcQ",
    place: "Near Colonial Pine Hills, South Dakota",
    shortName: "Colonial Pine Hills",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SD",
    state: "South Dakota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-SD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sd-041",
    lat: 44.049441,
    lng: -96.59535,
    panoId: "me3SJEJpT-aqFXIrrsXZAg",
    place: "Near Flandreau, South Dakota",
    shortName: "Flandreau",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SD",
    state: "South Dakota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-SD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sd-042",
    lat: 44.875745,
    lng: -98.51872,
    panoId: "cnkqmLu62boY0nOINpdo7g",
    place: "Near Redfield, South Dakota",
    shortName: "Redfield",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SD",
    state: "South Dakota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-SD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sd-043",
    lat: 44.507405,
    lng: -103.893121,
    panoId: "DMSt0J1oQdGsORUzLn2VGg",
    place: "Near North Spearfish, South Dakota",
    shortName: "North Spearfish",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SD",
    state: "South Dakota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-SD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sd-044",
    lat: 42.48739,
    lng: -96.486778,
    panoId: "WntbtoOWCtRRTHxBErpc5g",
    place: "Near Dakota Dunes, South Dakota",
    shortName: "Dakota Dunes",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SD",
    state: "South Dakota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-SD"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-sd-045",
    lat: 43.376546,
    lng: -99.859071,
    panoId: "aHrUGQAvhRZQvxj25Mby9A",
    place: "Near Winner, South Dakota",
    shortName: "Winner",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SD",
    state: "South Dakota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-SD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sd-046",
    lat: 43.30086,
    lng: -96.592821,
    panoId: "GpWXXUFXctV87TFwWsY_Bw",
    place: "Near Canton, South Dakota",
    shortName: "Canton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SD",
    state: "South Dakota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-SD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sd-047",
    lat: 44.352069,
    lng: -103.765233,
    panoId: "Uu2Zac7l5Kd8eukWOELAXg",
    place: "Near Lead, South Dakota",
    shortName: "Lead",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SD",
    state: "South Dakota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-SD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sd-048",
    lat: 43.446475,
    lng: -96.835879,
    panoId: "tnMDIKHVgbOxsxx-CTnA1Q",
    place: "Near Tea, South Dakota",
    shortName: "Tea",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SD",
    state: "South Dakota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-SD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sd-049",
    lat: 45.66463,
    lng: -97.049808,
    panoId: "jj790LG-9zHx1KK_Cw582Q",
    place: "Near Sisseton, South Dakota",
    shortName: "Sisseton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SD",
    state: "South Dakota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-SD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sd-050",
    lat: 44.189995,
    lng: -103.343929,
    panoId: "7yzkGxMYjK2FW4T6QGZyeA",
    place: "Near Summerset, South Dakota",
    shortName: "Summerset",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SD",
    state: "South Dakota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-SD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sd-051",
    lat: 43.609137,
    lng: -96.92724,
    panoId: "saJs_pQm_ipDbrRZt0hUUA",
    place: "Near Hartford, South Dakota",
    shortName: "Hartford",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SD",
    state: "South Dakota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-SD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sd-052",
    lat: 43.357342,
    lng: -99.837144,
    panoId: "9PxvSaKPa4XW3WYFTivpug",
    place: "Near Winner, South Dakota",
    shortName: "Winner",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SD",
    state: "South Dakota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-SD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sd-053",
    lat: 43.346501,
    lng: -96.865931,
    panoId: "7sW3YWOQeaNo7IGfHmvOUQ",
    place: "Near Lennox, South Dakota",
    shortName: "Lennox",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SD",
    state: "South Dakota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-SD"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-sd-054",
    lat: 43.811511,
    lng: -96.704542,
    panoId: "EhA2q1vwXZFWxf7bEiUfmw",
    place: "Near Dell Rapids, South Dakota",
    shortName: "Dell Rapids",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SD",
    state: "South Dakota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-SD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sd-055",
    lat: 43.334874,
    lng: -96.648642,
    panoId: "noziSpdQzWC4_61ajRC3VA",
    place: "Near Canton, South Dakota",
    shortName: "Canton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SD",
    state: "South Dakota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-SD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sd-056",
    lat: 43.403605,
    lng: -103.517545,
    panoId: "vRP6eNvglohNGfsjSwzMXg",
    place: "Near Hot Springs, South Dakota",
    shortName: "Hot Springs",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SD",
    state: "South Dakota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-SD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sd-057",
    lat: 44.369793,
    lng: -103.770139,
    panoId: "EAjC_A0Cpg4g3_MPEWZyQw",
    place: "Near Lead, South Dakota",
    shortName: "Lead",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SD",
    state: "South Dakota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-SD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sd-058",
    lat: 44.06916,
    lng: -103.292448,
    panoId: "jnmkmeKkjCmeDPuvlt-vvw",
    place: "Near Rapid City, South Dakota",
    shortName: "Rapid City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SD",
    state: "South Dakota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-SD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sd-059",
    lat: 44.165025,
    lng: -103.309153,
    panoId: "znJLrRHsGgM34kdRxTwa_g",
    place: "Near Blackhawk, South Dakota",
    shortName: "Blackhawk",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SD",
    state: "South Dakota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-SD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sd-060",
    lat: 43.949619,
    lng: -97.046852,
    panoId: "ptsyJ3B77ZVj9qi5m7ZqBQ",
    place: "Near Madison, South Dakota",
    shortName: "Madison",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SD",
    state: "South Dakota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-SD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sd-061",
    lat: 43.775357,
    lng: -96.675983,
    panoId: "PyVZuckT14YeuEd179C_zg",
    place: "Near Baltic, South Dakota",
    shortName: "Baltic",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SD",
    state: "South Dakota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-SD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sd-062",
    lat: 43.440549,
    lng: -96.845411,
    panoId: "B4XaFE2oygDMjUKBWir_mw",
    place: "Near Tea, South Dakota",
    shortName: "Tea",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SD",
    state: "South Dakota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-SD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sd-063",
    lat: 42.539293,
    lng: -96.417961,
    panoId: "ebf4XRma6wyFGJGUXdeDng",
    place: "Near Sioux City, South Dakota",
    shortName: "Sioux City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SD",
    state: "South Dakota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-SD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sd-064",
    lat: 42.865463,
    lng: -97.444052,
    panoId: "O5IMomisDKYiqjwGPbWGNA",
    place: "Near Yankton, South Dakota",
    shortName: "Yankton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SD",
    state: "South Dakota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-SD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sd-065",
    lat: 44.218006,
    lng: -103.309449,
    panoId: "-aPhQQzC2oaufiznmrOdxw",
    place: "Near Summerset, South Dakota",
    shortName: "Summerset",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SD",
    state: "South Dakota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-SD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sd-066",
    lat: 44.009436,
    lng: -103.182104,
    panoId: "nuYkGfGz2z059apUMLd2wg",
    place: "Near Rapid Valley, South Dakota",
    shortName: "Rapid Valley",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SD",
    state: "South Dakota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-SD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sd-067",
    lat: 44.623538,
    lng: -103.87247,
    panoId: "aMTVuPmUn3ylQ543-vCdrA",
    place: "Near Belle Fourche, South Dakota",
    shortName: "Belle Fourche",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SD",
    state: "South Dakota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-SD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sd-068",
    lat: 43.587199,
    lng: -96.765288,
    panoId: "4EiUBQJNp54RtaEyEjWLoA",
    place: "Near Sioux Falls, South Dakota",
    shortName: "Sioux Falls",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SD",
    state: "South Dakota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-SD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sd-069",
    lat: 43.645212,
    lng: -96.972602,
    panoId: "n3yfy6wZ-i0DCpxYr0uwrg",
    place: "Near Hartford, South Dakota",
    shortName: "Hartford",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SD",
    state: "South Dakota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-SD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sd-070",
    lat: 44.04316,
    lng: -96.648586,
    panoId: "OIIpT01yvJ2vMWIbNvl2xQ",
    place: "Near Flandreau, South Dakota",
    shortName: "Flandreau",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SD",
    state: "South Dakota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-SD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sd-071",
    lat: 43.375202,
    lng: -96.648496,
    panoId: "BbPkjS-WSVz-Mg-5n8wQ7g",
    place: "Near Harrisburg, South Dakota",
    shortName: "Harrisburg",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SD",
    state: "South Dakota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-SD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sd-072",
    lat: 44.336202,
    lng: -96.887863,
    panoId: "XDsdR7jdZ3CgjWkRERz0LQ",
    place: "Near Volga, South Dakota",
    shortName: "Volga",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SD",
    state: "South Dakota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-SD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sd-073",
    lat: 44.352356,
    lng: -98.254732,
    panoId: "mJd9zpjvsBLdUkTTDN9G-w",
    place: "Near Huron, South Dakota",
    shortName: "Huron",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SD",
    state: "South Dakota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-SD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sd-074",
    lat: 44.536661,
    lng: -103.950018,
    panoId: "1vzXER3s0ZIlAWdMUA7KPA",
    place: "Near North Spearfish, South Dakota",
    shortName: "North Spearfish",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SD",
    state: "South Dakota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-SD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sd-075",
    lat: 45.642607,
    lng: -97.123473,
    panoId: "Z3cSG5aG8gPD0sI_WCpiPw",
    place: "Near Sisseton, South Dakota",
    shortName: "Sisseton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SD",
    state: "South Dakota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-SD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sd-076",
    lat: 43.078265,
    lng: -102.585827,
    panoId: "VQlVMY52MTLCutf825y2QQ",
    place: "Near Pine Ridge, South Dakota",
    shortName: "Pine Ridge",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SD",
    state: "South Dakota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-SD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sd-077",
    lat: 43.620177,
    lng: -96.590129,
    panoId: "OYT23dggBKy3Obr87KfoBA",
    place: "Near Brandon, South Dakota",
    shortName: "Brandon",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SD",
    state: "South Dakota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-SD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sd-078",
    lat: 44.168384,
    lng: -103.277413,
    panoId: "hOKvuFLedpff0vkoWeCgww",
    place: "Near Blackhawk, South Dakota",
    shortName: "Blackhawk",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SD",
    state: "South Dakota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-SD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sd-079",
    lat: 43.303979,
    lng: -96.493709,
    panoId: "pLn4dRb1Js16z1MzLYkzuA",
    place: "Near Canton, South Dakota",
    shortName: "Canton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SD",
    state: "South Dakota",
    difficulty: "explorer",
    pools: ["world","North America","US","US-SD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sd-080",
    lat: 45.551766,
    lng: -100.397211,
    panoId: "DDFtrDF5uYTBzcZ8DpEuXw",
    place: "Near Mobridge, South Dakota",
    shortName: "Mobridge",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SD",
    state: "South Dakota",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-SD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sd-081",
    lat: 45.120481,
    lng: -96.639657,
    panoId: "tja4oQTsyLpSIaGFlqZRiA",
    place: "Near Milbank, South Dakota",
    shortName: "Milbank",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SD",
    state: "South Dakota",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-SD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sd-082",
    lat: 45.547009,
    lng: -100.274741,
    panoId: "lN7PuOfK9fVy13hs4vK4kQ",
    place: "Near Mobridge, South Dakota",
    shortName: "Mobridge",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SD",
    state: "South Dakota",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-SD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sd-083",
    lat: 45.178925,
    lng: -96.806302,
    panoId: "jIsD6jDLtiC3UISsm5mV5g",
    place: "Near Milbank, South Dakota",
    shortName: "Milbank",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SD",
    state: "South Dakota",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-SD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sd-084",
    lat: 42.628912,
    lng: -96.461403,
    panoId: "XC2p-alQyKPBjHsgHUXQNQ",
    place: "Near North Sioux City, South Dakota",
    shortName: "North Sioux City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SD",
    state: "South Dakota",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-SD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-sd-085",
    lat: 44.753645,
    lng: -98.503807,
    panoId: "lgFzXjD8R4OlAlv3bKG9zw",
    place: "Near Redfield, South Dakota",
    shortName: "Redfield",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "SD",
    state: "South Dakota",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-SD"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tn-000",
    lat: 36.165662,
    lng: -86.784926,
    panoId: "Uxu7mTsMZQ02EX45sNl0bA",
    place: "Near Nashville, Tennessee",
    shortName: "Nashville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TN",
    state: "Tennessee",
    difficulty: "classic",
    pools: ["world","North America","US","US-TN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tn-001",
    lat: 35.06535,
    lng: -85.249048,
    panoId: "dPc6lsNNI3tS4E87IhX7Dg",
    place: "Near East Chattanooga, Tennessee",
    shortName: "East Chattanooga",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TN",
    state: "Tennessee",
    difficulty: "classic",
    pools: ["world","North America","US","US-TN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tn-002",
    lat: 36.313696,
    lng: -82.353608,
    panoId: "pHU9sNc-bbT22JVSGeTXdg",
    place: "Near Johnson City, Tennessee",
    shortName: "Johnson City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TN",
    state: "Tennessee",
    difficulty: "classic",
    pools: ["world","North America","US","US-TN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tn-003",
    lat: 35.149671,
    lng: -90.048935,
    panoId: "LvyB5T1bsLoMBJghaeQyUA",
    place: "Near Memphis, Tennessee",
    shortName: "Memphis",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TN",
    state: "Tennessee",
    difficulty: "classic",
    pools: ["world","North America","US","US-TN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tn-004",
    lat: 36.076912,
    lng: -87.387959,
    panoId: "1OdmK-jR_DXoyFZ5TOdFrA",
    place: "Near Dickson, Tennessee",
    shortName: "Dickson",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TN",
    state: "Tennessee",
    difficulty: "classic",
    pools: ["world","North America","US","US-TN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tn-005",
    lat: 35.045724,
    lng: -85.309649,
    panoId: "H4xQaJMQV0K_K7WwERs-3Q",
    place: "Near Chattanooga, Tennessee",
    shortName: "Chattanooga",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TN",
    state: "Tennessee",
    difficulty: "classic",
    pools: ["world","North America","US","US-TN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tn-006",
    lat: 36.548539,
    lng: -82.561738,
    panoId: "CTL21W5iU_-w8J0AIxduag",
    place: "Near Kingsport, Tennessee",
    shortName: "Kingsport",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TN",
    state: "Tennessee",
    difficulty: "classic",
    pools: ["world","North America","US","US-TN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tn-007",
    lat: 36.214003,
    lng: -83.29479,
    panoId: "6VlThnqivYpsajHUsQCvpw",
    place: "Near Morristown, Tennessee",
    shortName: "Morristown",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TN",
    state: "Tennessee",
    difficulty: "classic",
    pools: ["world","North America","US","US-TN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tn-008",
    lat: 35.159537,
    lng: -84.876612,
    panoId: "haIq0Z_d9PqKWhMAETbr3A",
    place: "Near Cleveland, Tennessee",
    shortName: "Cleveland",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TN",
    state: "Tennessee",
    difficulty: "classic",
    pools: ["world","North America","US","US-TN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tn-009",
    lat: 35.884502,
    lng: -84.153482,
    panoId: "wtR7NTUx5onre9ZOykxqHA",
    place: "Near Farragut, Tennessee",
    shortName: "Farragut",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TN",
    state: "Tennessee",
    difficulty: "classic",
    pools: ["world","North America","US","US-TN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tn-010",
    lat: 35.751203,
    lng: -86.930101,
    panoId: "Bn2in7qrWsLw3jykraPGrQ",
    place: "Near Spring Hill, Tennessee",
    shortName: "Spring Hill",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TN",
    state: "Tennessee",
    difficulty: "classic",
    pools: ["world","North America","US","US-TN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tn-011",
    lat: 35.014235,
    lng: -85.251891,
    panoId: "iVlZ8o28Qj6qHxt0QtLEJA",
    place: "Near East Ridge, Tennessee",
    shortName: "East Ridge",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TN",
    state: "Tennessee",
    difficulty: "classic",
    pools: ["world","North America","US","US-TN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tn-012",
    lat: 36.034449,
    lng: -89.385669,
    panoId: "7DlLhozJRhlermr_sBd9_A",
    place: "Near Dyersburg, Tennessee",
    shortName: "Dyersburg",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TN",
    state: "Tennessee",
    difficulty: "classic",
    pools: ["world","North America","US","US-TN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tn-013",
    lat: 35.960579,
    lng: -83.920774,
    panoId: "QkadwN8cWG_EZ-cAfhISKQ",
    place: "Near Knoxville, Tennessee",
    shortName: "Knoxville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TN",
    state: "Tennessee",
    difficulty: "classic",
    pools: ["world","North America","US","US-TN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tn-014",
    lat: 35.483482,
    lng: -86.460259,
    panoId: "KJSr-UgRSF7OTE_KVzkSYA",
    place: "Near Shelbyville, Tennessee",
    shortName: "Shelbyville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TN",
    state: "Tennessee",
    difficulty: "classic",
    pools: ["world","North America","US","US-TN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tn-015",
    lat: 35.442928,
    lng: -84.593036,
    panoId: "AEuoUuh0yIR0pX-zkZxcUg",
    place: "Near Athens, Tennessee",
    shortName: "Athens",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TN",
    state: "Tennessee",
    difficulty: "classic",
    pools: ["world","North America","US","US-TN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tn-016",
    lat: 36.162798,
    lng: -85.501638,
    panoId: "-rVnDDXol9_UbjeMP2B82Q",
    place: "Near Cookeville, Tennessee",
    shortName: "Cookeville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TN",
    state: "Tennessee",
    difficulty: "classic",
    pools: ["world","North America","US","US-TN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tn-017",
    lat: 36.388238,
    lng: -86.446665,
    panoId: "-uSHRr55DJxFipforxqPKA",
    place: "Near Gallatin, Tennessee",
    shortName: "Gallatin",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TN",
    state: "Tennessee",
    difficulty: "classic",
    pools: ["world","North America","US","US-TN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tn-018",
    lat: 35.925001,
    lng: -86.8689,
    panoId: "VRynA4CPK4V7g42dLP8onQ",
    place: "Near Franklin, Tennessee",
    shortName: "Franklin",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TN",
    state: "Tennessee",
    difficulty: "classic",
    pools: ["world","North America","US","US-TN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tn-019",
    lat: 34.996138,
    lng: -85.150878,
    panoId: "k8eARl4RaBetGAahyOjlJw",
    place: "Near East Brainerd, Tennessee",
    shortName: "East Brainerd",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TN",
    state: "Tennessee",
    difficulty: "classic",
    pools: ["world","North America","US","US-TN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tn-020",
    lat: 36.163129,
    lng: -82.830948,
    panoId: "VuzUdPu3nsnpjSU-qtGeOw",
    place: "Near Greeneville, Tennessee",
    shortName: "Greeneville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TN",
    state: "Tennessee",
    difficulty: "classic",
    pools: ["world","North America","US","US-TN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tn-021",
    lat: 36.529729,
    lng: -87.359446,
    panoId: "U8S6xcw2soG1_LWMxT7ZAw",
    place: "Near Clarksville, Tennessee",
    shortName: "Clarksville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TN",
    state: "Tennessee",
    difficulty: "classic",
    pools: ["world","North America","US","US-TN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tn-022",
    lat: 35.756604,
    lng: -83.970618,
    panoId: "kAtezEV-QDcvIMNgIz2hBQ",
    place: "Near Maryville, Tennessee",
    shortName: "Maryville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TN",
    state: "Tennessee",
    difficulty: "classic",
    pools: ["world","North America","US","US-TN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tn-023",
    lat: 35.845575,
    lng: -86.390236,
    panoId: "L9mmxXgDZV1qXA6PaGdOQg",
    place: "Near Murfreesboro, Tennessee",
    shortName: "Murfreesboro",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TN",
    state: "Tennessee",
    difficulty: "classic",
    pools: ["world","North America","US","US-TN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tn-024",
    lat: 36.595145,
    lng: -82.188778,
    panoId: "PiIi80rEJdHt1vnC-uwexQ",
    place: "Near Bristol, Tennessee",
    shortName: "Bristol",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TN",
    state: "Tennessee",
    difficulty: "classic",
    pools: ["world","North America","US","US-TN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tn-025",
    lat: 36.208166,
    lng: -86.291121,
    panoId: "0fknCj2LUir6yxzXpORRaw",
    place: "Near Lebanon, Tennessee",
    shortName: "Lebanon",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TN",
    state: "Tennessee",
    difficulty: "classic",
    pools: ["world","North America","US","US-TN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tn-026",
    lat: 35.61417,
    lng: -88.813944,
    panoId: "YKvNaMVFwR_2pKRoiQaiVw",
    place: "Near Jackson, Tennessee",
    shortName: "Jackson",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TN",
    state: "Tennessee",
    difficulty: "classic",
    pools: ["world","North America","US","US-TN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tn-027",
    lat: 36.509251,
    lng: -86.884997,
    panoId: "svmekuDhvRIhwjWFzGqlqg",
    place: "Near Springfield, Tennessee",
    shortName: "Springfield",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TN",
    state: "Tennessee",
    difficulty: "classic",
    pools: ["world","North America","US","US-TN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tn-028",
    lat: 35.195991,
    lng: -85.184476,
    panoId: "pzYXh_1qgUQnoOduh30Vzg",
    place: "Near Middle Valley, Tennessee",
    shortName: "Middle Valley",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TN",
    state: "Tennessee",
    difficulty: "classic",
    pools: ["world","North America","US","US-TN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tn-029",
    lat: 36.34873,
    lng: -82.210626,
    panoId: "NdRF4bUVP9buy-y2E4vFxA",
    place: "Near Elizabethton, Tennessee",
    shortName: "Elizabethton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TN",
    state: "Tennessee",
    difficulty: "classic",
    pools: ["world","North America","US","US-TN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tn-030",
    lat: 36.010398,
    lng: -84.269627,
    panoId: "5A2yijUvKMaW1Qv9tdCYbg",
    place: "Near Oak Ridge, Tennessee",
    shortName: "Oak Ridge",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TN",
    state: "Tennessee",
    difficulty: "classic",
    pools: ["world","North America","US","US-TN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tn-031",
    lat: 35.61499,
    lng: -87.035308,
    panoId: "ePvw6pcll0ADTA6r1b_qCQ",
    place: "Near Columbia, Tennessee",
    shortName: "Columbia",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TN",
    state: "Tennessee",
    difficulty: "classic",
    pools: ["world","North America","US","US-TN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tn-032",
    lat: 35.868093,
    lng: -83.561859,
    panoId: "Jb1PvnJ1W0_tOg5VYS9ETw",
    place: "Near Sevierville, Tennessee",
    shortName: "Sevierville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TN",
    state: "Tennessee",
    difficulty: "classic",
    pools: ["world","North America","US","US-TN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tn-033",
    lat: 35.361931,
    lng: -86.209469,
    panoId: "ier--NZCEhsNVEfggYSlag",
    place: "Near Tullahoma, Tennessee",
    shortName: "Tullahoma",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TN",
    state: "Tennessee",
    difficulty: "classic",
    pools: ["world","North America","US","US-TN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tn-034",
    lat: 35.683512,
    lng: -85.769906,
    panoId: "DWJnDXJvBICECmymknQxEQ",
    place: "Near McMinnville, Tennessee",
    shortName: "McMinnville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TN",
    state: "Tennessee",
    difficulty: "classic",
    pools: ["world","North America","US","US-TN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tn-035",
    lat: 35.235959,
    lng: -85.190632,
    panoId: "lai3OeV1kcSoNGVjLyMwaw",
    place: "Near Soddy-Daisy, Tennessee",
    shortName: "Soddy-Daisy",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TN",
    state: "Tennessee",
    difficulty: "classic",
    pools: ["world","North America","US","US-TN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tn-036",
    lat: 35.449173,
    lng: -86.789004,
    panoId: "tC8-CoWMqjt4rQ3fnmF8Fg",
    place: "Near Lewisburg, Tennessee",
    shortName: "Lewisburg",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TN",
    state: "Tennessee",
    difficulty: "classic",
    pools: ["world","North America","US","US-TN"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-tn-037",
    lat: 36.581741,
    lng: -86.516269,
    panoId: "NpdcGWKE6mMtRzOsNLQ6Hg",
    place: "Near Portland, Tennessee",
    shortName: "Portland",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TN",
    state: "Tennessee",
    difficulty: "classic",
    pools: ["world","North America","US","US-TN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tn-038",
    lat: 35.948949,
    lng: -85.026864,
    panoId: "2WHodm4ugXNjCHICcr5anQ",
    place: "Near Crossville, Tennessee",
    shortName: "Crossville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TN",
    state: "Tennessee",
    difficulty: "classic",
    pools: ["world","North America","US","US-TN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tn-039",
    lat: 35.112413,
    lng: -85.294119,
    panoId: "Goci5Gssv6EDzZSCqBpqlw",
    place: "Near Red Bank, Tennessee",
    shortName: "Red Bank",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TN",
    state: "Tennessee",
    difficulty: "classic",
    pools: ["world","North America","US","US-TN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tn-040",
    lat: 36.204546,
    lng: -83.307116,
    panoId: "cU9HbiFScRvxpfqVOmEizg",
    place: "Near Morristown, Tennessee",
    shortName: "Morristown",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TN",
    state: "Tennessee",
    difficulty: "classic",
    pools: ["world","North America","US","US-TN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tn-041",
    lat: 36.359875,
    lng: -82.187289,
    panoId: "MS_AWmy5y2_umpi-XzdC9g",
    place: "Near Elizabethton, Tennessee",
    shortName: "Elizabethton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TN",
    state: "Tennessee",
    difficulty: "classic",
    pools: ["world","North America","US","US-TN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tn-042",
    lat: 36.145607,
    lng: -85.496208,
    panoId: "r0Q5phBYZGhWjLPkpZv0Iw",
    place: "Near Cookeville, Tennessee",
    shortName: "Cookeville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TN",
    state: "Tennessee",
    difficulty: "classic",
    pools: ["world","North America","US","US-TN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tn-043",
    lat: 36.554765,
    lng: -82.588257,
    panoId: "i-EDHzs2avkbL5yGVO1mDA",
    place: "Near Kingsport, Tennessee",
    shortName: "Kingsport",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TN",
    state: "Tennessee",
    difficulty: "classic",
    pools: ["world","North America","US","US-TN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tn-044",
    lat: 35.764864,
    lng: -86.919809,
    panoId: "H6cCn6Jrfw9jiIIsgeLVRA",
    place: "Near Spring Hill, Tennessee",
    shortName: "Spring Hill",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TN",
    state: "Tennessee",
    difficulty: "classic",
    pools: ["world","North America","US","US-TN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tn-045",
    lat: 35.167313,
    lng: -84.895216,
    panoId: "9cvXrJXLbr_2LI06ECDAfQ",
    place: "Near Cleveland, Tennessee",
    shortName: "Cleveland",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TN",
    state: "Tennessee",
    difficulty: "classic",
    pools: ["world","North America","US","US-TN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tn-046",
    lat: 35.368219,
    lng: -86.201163,
    panoId: "jNgyvJr21itHkVjVnbWdXA",
    place: "Near Tullahoma, Tennessee",
    shortName: "Tullahoma",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TN",
    state: "Tennessee",
    difficulty: "classic",
    pools: ["world","North America","US","US-TN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tn-047",
    lat: 35.055991,
    lng: -85.232562,
    panoId: "6l8K_vRslo8Slyuiv4r0uw",
    place: "Near East Chattanooga, Tennessee",
    shortName: "East Chattanooga",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TN",
    state: "Tennessee",
    difficulty: "classic",
    pools: ["world","North America","US","US-TN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tn-048",
    lat: 36.147782,
    lng: -86.797782,
    panoId: "RpMB0u2bYCye2vV8Go_LxA",
    place: "Near Nashville, Tennessee",
    shortName: "Nashville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TN",
    state: "Tennessee",
    difficulty: "classic",
    pools: ["world","North America","US","US-TN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tn-049",
    lat: 36.192323,
    lng: -86.272638,
    panoId: "eC0lOWrID6Sj-quVdj9ICg",
    place: "Near Lebanon, Tennessee",
    shortName: "Lebanon",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TN",
    state: "Tennessee",
    difficulty: "classic",
    pools: ["world","North America","US","US-TN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tn-050",
    lat: 35.988407,
    lng: -86.862836,
    panoId: "8rXf7oZiNkFxAPtJdUR0OA",
    place: "Near Franklin, Tennessee",
    shortName: "Franklin",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TN",
    state: "Tennessee",
    difficulty: "explorer",
    pools: ["world","North America","US","US-TN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tn-051",
    lat: 34.991818,
    lng: -85.183545,
    panoId: "58myNYqXMLvKwXqHrUQUyw",
    place: "Near East Brainerd, Tennessee",
    shortName: "East Brainerd",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TN",
    state: "Tennessee",
    difficulty: "explorer",
    pools: ["world","North America","US","US-TN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tn-052",
    lat: 35.832412,
    lng: -83.566945,
    panoId: "DnhYr0xwEKmAgFnb--BJJg",
    place: "Near Sevierville, Tennessee",
    shortName: "Sevierville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TN",
    state: "Tennessee",
    difficulty: "explorer",
    pools: ["world","North America","US","US-TN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tn-053",
    lat: 36.268625,
    lng: -82.298682,
    panoId: "OhfC92y758upitybFETpeQ",
    place: "Near Pine Crest, Tennessee",
    shortName: "Pine Crest",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TN",
    state: "Tennessee",
    difficulty: "explorer",
    pools: ["world","North America","US","US-TN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tn-054",
    lat: 36.113628,
    lng: -82.895579,
    panoId: "Ujxs6Ugt6HMWk3Z4ioe6Uw",
    place: "Near Greeneville, Tennessee",
    shortName: "Greeneville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TN",
    state: "Tennessee",
    difficulty: "explorer",
    pools: ["world","North America","US","US-TN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tn-055",
    lat: 35.050509,
    lng: -85.368539,
    panoId: "msYHk78Rd34W3wuItAfzdg",
    place: "Near Chattanooga, Tennessee",
    shortName: "Chattanooga",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TN",
    state: "Tennessee",
    difficulty: "explorer",
    pools: ["world","North America","US","US-TN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tn-056",
    lat: 35.285587,
    lng: -85.2265,
    panoId: "MluW3SuFkbSW7miAZ3CmBQ",
    place: "Near Mowbray Mountain, Tennessee",
    shortName: "Mowbray Mountain",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TN",
    state: "Tennessee",
    difficulty: "explorer",
    pools: ["world","North America","US","US-TN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tn-057",
    lat: 36.085177,
    lng: -87.424397,
    panoId: "M9SdVdZJvLp5J8_H-WxwHw",
    place: "Near Dickson, Tennessee",
    shortName: "Dickson",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TN",
    state: "Tennessee",
    difficulty: "explorer",
    pools: ["world","North America","US","US-TN"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-tn-058",
    lat: 36.60242,
    lng: -82.105238,
    panoId: "3Sza_z_vLgCBkfdHQzI9yw",
    place: "Near Fairmount, Tennessee",
    shortName: "Fairmount",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TN",
    state: "Tennessee",
    difficulty: "explorer",
    pools: ["world","North America","US","US-TN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tn-059",
    lat: 35.483119,
    lng: -84.57737,
    panoId: "07ad-jxKYx1rHAF7l1jevg",
    place: "Near Athens, Tennessee",
    shortName: "Athens",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TN",
    state: "Tennessee",
    difficulty: "explorer",
    pools: ["world","North America","US","US-TN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tn-060",
    lat: 36.004496,
    lng: -89.327837,
    panoId: "F5SpcPhzXoD6jj6GVLQzIw",
    place: "Near Dyersburg, Tennessee",
    shortName: "Dyersburg",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TN",
    state: "Tennessee",
    difficulty: "explorer",
    pools: ["world","North America","US","US-TN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tn-061",
    lat: 35.748753,
    lng: -85.741728,
    panoId: "H8vbjd4H4furPg0n9KzYvQ",
    place: "Near McMinnville, Tennessee",
    shortName: "McMinnville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TN",
    state: "Tennessee",
    difficulty: "explorer",
    pools: ["world","North America","US","US-TN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tn-062",
    lat: 36.572539,
    lng: -86.589273,
    panoId: "jkEpbswn324x6poDSGUMzw",
    place: "Near Portland, Tennessee",
    shortName: "Portland",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TN",
    state: "Tennessee",
    difficulty: "explorer",
    pools: ["world","North America","US","US-TN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tn-063",
    lat: 36.509118,
    lng: -87.319293,
    panoId: "yvCWtLOyxeD6K_w8eBOSOA",
    place: "Near Clarksville, Tennessee",
    shortName: "Clarksville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TN",
    state: "Tennessee",
    difficulty: "explorer",
    pools: ["world","North America","US","US-TN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tn-064",
    lat: 35.615585,
    lng: -88.858189,
    panoId: "Xe7KMpsKh0k38uLC6Q3Wig",
    place: "Near Jackson, Tennessee",
    shortName: "Jackson",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TN",
    state: "Tennessee",
    difficulty: "explorer",
    pools: ["world","North America","US","US-TN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tn-065",
    lat: 35.555222,
    lng: -87.043019,
    panoId: "e1GcBN9Idx_18aMvJn1tvw",
    place: "Near Columbia, Tennessee",
    shortName: "Columbia",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TN",
    state: "Tennessee",
    difficulty: "explorer",
    pools: ["world","North America","US","US-TN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tn-066",
    lat: 35.542021,
    lng: -86.459992,
    panoId: "-lKsp85l6BxZg8VXus1XFg",
    place: "Near Shelbyville, Tennessee",
    shortName: "Shelbyville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TN",
    state: "Tennessee",
    difficulty: "explorer",
    pools: ["world","North America","US","US-TN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tn-067",
    lat: 34.974083,
    lng: -85.221144,
    panoId: "XORGZy2iDZhEVfCXEgjgqA",
    place: "Near Lakeview, Tennessee",
    shortName: "Lakeview",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TN",
    state: "Tennessee",
    difficulty: "explorer",
    pools: ["world","North America","US","US-TN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tn-068",
    lat: 35.941658,
    lng: -85.111011,
    panoId: "rHs01wYDANZLGkxJZk_REQ",
    place: "Near Crossville, Tennessee",
    shortName: "Crossville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TN",
    state: "Tennessee",
    difficulty: "explorer",
    pools: ["world","North America","US","US-TN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tn-069",
    lat: 36.326976,
    lng: -86.47631,
    panoId: "cYJZTdw-XpzZAiWd4YuAGQ",
    place: "Near Gallatin, Tennessee",
    shortName: "Gallatin",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TN",
    state: "Tennessee",
    difficulty: "explorer",
    pools: ["world","North America","US","US-TN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tn-070",
    lat: 36.466636,
    lng: -86.947644,
    panoId: "Rvpgt1nuMLu9cHQvxEo9hA",
    place: "Near Coopertown, Tennessee",
    shortName: "Coopertown",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TN",
    state: "Tennessee",
    difficulty: "explorer",
    pools: ["world","North America","US","US-TN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tn-071",
    lat: 35.071374,
    lng: -85.281831,
    panoId: "opN4ttjZTVUPBckRdwfTzQ",
    place: "Near East Chattanooga, Tennessee",
    shortName: "East Chattanooga",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TN",
    state: "Tennessee",
    difficulty: "explorer",
    pools: ["world","North America","US","US-TN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tn-072",
    lat: 35.694332,
    lng: -84.005378,
    panoId: "QSiYVsflbYud_UQAOa4TfQ",
    place: "Near Maryville, Tennessee",
    shortName: "Maryville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TN",
    state: "Tennessee",
    difficulty: "explorer",
    pools: ["world","North America","US","US-TN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tn-073",
    lat: 35.127524,
    lng: -89.987048,
    panoId: "yUYiaeV3eO5v-vqGzY09UA",
    place: "Near Memphis, Tennessee",
    shortName: "Memphis",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TN",
    state: "Tennessee",
    difficulty: "explorer",
    pools: ["world","North America","US","US-TN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tn-074",
    lat: 36.191579,
    lng: -85.571381,
    panoId: "Cb7ElQmEzIIQEoy7LNIQnw",
    place: "Near Cookeville, Tennessee",
    shortName: "Cookeville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TN",
    state: "Tennessee",
    difficulty: "explorer",
    pools: ["world","North America","US","US-TN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tn-075",
    lat: 36.244018,
    lng: -82.332289,
    panoId: "pa156fuNvb17cY0w9Kgw5w",
    place: "Near Unicoi, Tennessee",
    shortName: "Unicoi",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TN",
    state: "Tennessee",
    difficulty: "explorer",
    pools: ["world","North America","US","US-TN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tn-076",
    lat: 35.022818,
    lng: -85.140074,
    panoId: "MZpHe69_ecqXwxbWTYmk-g",
    place: "Near East Brainerd, Tennessee",
    shortName: "East Brainerd",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TN",
    state: "Tennessee",
    difficulty: "explorer",
    pools: ["world","North America","US","US-TN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tn-077",
    lat: 36.196454,
    lng: -86.805835,
    panoId: "KVbRyBBh0d1Yuxb11jGfmQ",
    place: "Near Nashville, Tennessee",
    shortName: "Nashville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TN",
    state: "Tennessee",
    difficulty: "explorer",
    pools: ["world","North America","US","US-TN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tn-078",
    lat: 36.351622,
    lng: -82.12767,
    panoId: "o9C01jZMkY5iELjj_8FB-g",
    place: "Near Hunter, Tennessee",
    shortName: "Hunter",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TN",
    state: "Tennessee",
    difficulty: "explorer",
    pools: ["world","North America","US","US-TN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tn-079",
    lat: 36.071668,
    lng: -87.333579,
    panoId: "oZAByJ7ddOP2mjJLggXqLw",
    place: "Near Burns, Tennessee",
    shortName: "Burns",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TN",
    state: "Tennessee",
    difficulty: "explorer",
    pools: ["world","North America","US","US-TN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tn-080",
    lat: 35.660907,
    lng: -87.046232,
    panoId: "P7RTjmBANR77CQpuXfymVA",
    place: "Near Columbia, Tennessee",
    shortName: "Columbia",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TN",
    state: "Tennessee",
    difficulty: "explorer",
    pools: ["world","North America","US","US-TN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tn-081",
    lat: 36.616079,
    lng: -86.579085,
    panoId: "GvVdiiPubsPFVN7PjbnIJw",
    place: "Near Portland, Tennessee",
    shortName: "Portland",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TN",
    state: "Tennessee",
    difficulty: "explorer",
    pools: ["world","North America","US","US-TN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tn-082",
    lat: 35.993257,
    lng: -83.955631,
    panoId: "WUrLnVc1vvuxUnAPSPFcXQ",
    place: "Near Knoxville, Tennessee",
    shortName: "Knoxville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TN",
    state: "Tennessee",
    difficulty: "explorer",
    pools: ["world","North America","US","US-TN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tn-083",
    lat: 36.14881,
    lng: -82.753049,
    panoId: "PxkFKo-49ia1xPion3Xuzg",
    place: "Near Tusculum, Tennessee",
    shortName: "Tusculum",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TN",
    state: "Tennessee",
    difficulty: "explorer",
    pools: ["world","North America","US","US-TN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tn-084",
    lat: 35.581627,
    lng: -88.877836,
    panoId: "L1xj9CS1hwPsG-3gb699Gg",
    place: "Near Jackson, Tennessee",
    shortName: "Jackson",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TN",
    state: "Tennessee",
    difficulty: "explorer",
    pools: ["world","North America","US","US-TN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tn-085",
    lat: 35.035442,
    lng: -85.276631,
    panoId: "wUPwBFAJ1rKxBc2uNZPXQQ",
    place: "Near Chattanooga, Tennessee",
    shortName: "Chattanooga",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TN",
    state: "Tennessee",
    difficulty: "explorer",
    pools: ["world","North America","US","US-TN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tn-086",
    lat: 36.539674,
    lng: -82.475323,
    panoId: "Vbo7NvfYuug9M1BaED1URg",
    place: "Near Bloomingdale, Tennessee",
    shortName: "Bloomingdale",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TN",
    state: "Tennessee",
    difficulty: "explorer",
    pools: ["world","North America","US","US-TN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tn-087",
    lat: 35.987623,
    lng: -84.323797,
    panoId: "iSfmIONa1bXhXN4u5jS-YA",
    place: "Near Oak Ridge, Tennessee",
    shortName: "Oak Ridge",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TN",
    state: "Tennessee",
    difficulty: "explorer",
    pools: ["world","North America","US","US-TN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tn-088",
    lat: 36.426857,
    lng: -86.486139,
    panoId: "GEhHbmaMnfzCOHV-U4efxQ",
    place: "Near Gallatin, Tennessee",
    shortName: "Gallatin",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TN",
    state: "Tennessee",
    difficulty: "explorer",
    pools: ["world","North America","US","US-TN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tn-089",
    lat: 36.281397,
    lng: -88.809497,
    panoId: "cCC7z6wFFAPBW5QkI4haDA",
    place: "Near Martin, Tennessee",
    shortName: "Martin",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TN",
    state: "Tennessee",
    difficulty: "explorer",
    pools: ["world","North America","US","US-TN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tn-090",
    lat: 35.426912,
    lng: -84.659102,
    panoId: "-zT5N_TsHxIN7Ubcms8qww",
    place: "Near Athens, Tennessee",
    shortName: "Athens",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TN",
    state: "Tennessee",
    difficulty: "explorer",
    pools: ["world","North America","US","US-TN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tn-091",
    lat: 35.496895,
    lng: -86.428478,
    panoId: "ka2NidK5Fc5gk6--LSbP5A",
    place: "Near Shelbyville, Tennessee",
    shortName: "Shelbyville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TN",
    state: "Tennessee",
    difficulty: "explorer",
    pools: ["world","North America","US","US-TN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tn-092",
    lat: 36.622157,
    lng: -82.075322,
    panoId: "y5-xLi3hgwBShKlvc5dXnA",
    place: "Near Fairmount, Tennessee",
    shortName: "Fairmount",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TN",
    state: "Tennessee",
    difficulty: "explorer",
    pools: ["world","North America","US","US-TN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tn-093",
    lat: 36.522165,
    lng: -86.85137,
    panoId: "bWeraITx3XZTPB56TE7QuA",
    place: "Near Springfield, Tennessee",
    shortName: "Springfield",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TN",
    state: "Tennessee",
    difficulty: "explorer",
    pools: ["world","North America","US","US-TN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tn-094",
    lat: 35.888249,
    lng: -84.3057,
    panoId: "7NdTMZ1RNEVQ8r4TWtekmQ",
    place: "Near Lenoir City, Tennessee",
    shortName: "Lenoir City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TN",
    state: "Tennessee",
    difficulty: "explorer",
    pools: ["world","North America","US","US-TN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tn-095",
    lat: 35.416313,
    lng: -86.392416,
    panoId: "kvSFfzJ0hz6L22MsQTx20g",
    place: "Near Shelbyville, Tennessee",
    shortName: "Shelbyville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TN",
    state: "Tennessee",
    difficulty: "explorer",
    pools: ["world","North America","US","US-TN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tn-096",
    lat: 35.118034,
    lng: -84.807403,
    panoId: "7jJghmR3kDtZZ8O2v7sX5A",
    place: "Near Wildwood Lake, Tennessee",
    shortName: "Wildwood Lake",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TN",
    state: "Tennessee",
    difficulty: "explorer",
    pools: ["world","North America","US","US-TN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tn-097",
    lat: 35.480619,
    lng: -86.87762,
    panoId: "VrpoaO27wxYhv-hvMIBd_g",
    place: "Near Lewisburg, Tennessee",
    shortName: "Lewisburg",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TN",
    state: "Tennessee",
    difficulty: "explorer",
    pools: ["world","North America","US","US-TN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tn-098",
    lat: 36.614877,
    lng: -89.0446,
    panoId: "7LEUsLLtuo8rEQAcOrxS3g",
    place: "Near Clinton, Tennessee",
    shortName: "Clinton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TN",
    state: "Tennessee",
    difficulty: "explorer",
    pools: ["world","North America","US","US-TN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tn-099",
    lat: 35.728507,
    lng: -86.881936,
    panoId: "1ajDYu4NGtPbeEvcYouX9Q",
    place: "Near Spring Hill, Tennessee",
    shortName: "Spring Hill",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TN",
    state: "Tennessee",
    difficulty: "explorer",
    pools: ["world","North America","US","US-TN"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-tn-100",
    lat: 35.79315,
    lng: -89.323076,
    panoId: "Xz3Z4n9DsAEhooIKBg5sCg",
    place: "Near Halls, Tennessee",
    shortName: "Halls",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TN",
    state: "Tennessee",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-TN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tn-101",
    lat: 35.798898,
    lng: -85.871244,
    panoId: "HTxm4xXoIP7KuDMeWFOSLA",
    place: "Near McMinnville, Tennessee",
    shortName: "McMinnville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TN",
    state: "Tennessee",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-TN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tn-102",
    lat: 36.393108,
    lng: -87.227971,
    panoId: "2K8LyGNIkbgxukhr5Wc5ZQ",
    place: "Near Pleasant View, Tennessee",
    shortName: "Pleasant View",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TN",
    state: "Tennessee",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-TN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tn-103",
    lat: 35.378994,
    lng: -87.341034,
    panoId: "5NLSlvvBpFCdkiFKEkFDDg",
    place: "Near Lawrenceburg, Tennessee",
    shortName: "Lawrenceburg",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TN",
    state: "Tennessee",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-TN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tn-104",
    lat: 36.357249,
    lng: -88.520265,
    panoId: "FB1GyGkKNVlWjFDJcoPUcQ",
    place: "Near Gleason, Tennessee",
    shortName: "Gleason",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TN",
    state: "Tennessee",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-TN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tn-105",
    lat: 35.580428,
    lng: -89.442055,
    panoId: "iPQD3C3rI5d2gB7fs21LUA",
    place: "Near Brownsville, Tennessee",
    shortName: "Brownsville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TN",
    state: "Tennessee",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-TN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tn-106",
    lat: 35.480015,
    lng: -89.438867,
    panoId: "-gdGC7suPpxZnja4blgu_Q",
    place: "Near Mason, Tennessee",
    shortName: "Mason",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TN",
    state: "Tennessee",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-TN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tn-107",
    lat: 35.054012,
    lng: -88.316938,
    panoId: "zd2x3l_EVLcA2oRMcor_-A",
    place: "Near Farmington, Tennessee",
    shortName: "Farmington",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TN",
    state: "Tennessee",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-TN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tn-108",
    lat: 35.420748,
    lng: -84.827144,
    panoId: "34trfT3SqwMx75ObDAe3iQ",
    place: "Near Decatur, Tennessee",
    shortName: "Decatur",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TN",
    state: "Tennessee",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-TN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tn-109",
    lat: 36.246378,
    lng: -83.955662,
    panoId: "kvQvueugWcrnGEdcHZUHGw",
    place: "Near Norris, Tennessee",
    shortName: "Norris",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TN",
    state: "Tennessee",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-TN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tn-110",
    lat: 35.749414,
    lng: -89.337759,
    panoId: "_kbbtfwuwnMjI6_duO1B7Q",
    place: "Near Halls, Tennessee",
    shortName: "Halls",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TN",
    state: "Tennessee",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-TN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tx-000",
    lat: 26.203423,
    lng: -98.230018,
    panoId: "IxGeugXU2qcO4qbT5FFW4w",
    place: "Near McAllen, Texas",
    shortName: "McAllen",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TX",
    state: "Texas",
    difficulty: "classic",
    pools: ["world","North America","US","US-TX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tx-001",
    lat: 31.09821,
    lng: -97.342811,
    panoId: "WLbnypqmwcTZlEEHUDQf3Q",
    place: "Near Temple, Texas",
    shortName: "Temple",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TX",
    state: "Texas",
    difficulty: "classic",
    pools: ["world","North America","US","US-TX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tx-002",
    lat: 31.997441,
    lng: -102.077935,
    panoId: "lJfRyrZEPM6Ru_kMWJ5Amg",
    place: "Near Midland, Texas",
    shortName: "Midland",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TX",
    state: "Texas",
    difficulty: "classic",
    pools: ["world","North America","US","US-TX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tx-003",
    lat: 29.763512,
    lng: -95.363578,
    panoId: "TY8TN5PBmNOyGEuZyBtrhA",
    place: "Near Houston, Texas",
    shortName: "Houston",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TX",
    state: "Texas",
    difficulty: "classic",
    pools: ["world","North America","US","US-TX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tx-004",
    lat: 30.628041,
    lng: -96.334497,
    panoId: "YTWVjNqA9pcvrnsFe-pzag",
    place: "Near College Station, Texas",
    shortName: "College Station",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TX",
    state: "Texas",
    difficulty: "classic",
    pools: ["world","North America","US","US-TX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tx-005",
    lat: 32.725383,
    lng: -97.320854,
    panoId: "3iCsVrXjt0E5ZW0IeRElnw",
    place: "Near Fort Worth, Texas",
    shortName: "Fort Worth",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TX",
    state: "Texas",
    difficulty: "classic",
    pools: ["world","North America","US","US-TX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tx-006",
    lat: 31.549412,
    lng: -97.146803,
    panoId: "-9peMxZKzDUhps_KDlSIOQ",
    place: "Near Waco, Texas",
    shortName: "Waco",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TX",
    state: "Texas",
    difficulty: "classic",
    pools: ["world","North America","US","US-TX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tx-007",
    lat: 32.351207,
    lng: -95.300629,
    panoId: "UYtsdSUrZYGnzF4L63mQdQ",
    place: "Near Tyler, Texas",
    shortName: "Tyler",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TX",
    state: "Texas",
    difficulty: "classic",
    pools: ["world","North America","US","US-TX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tx-008",
    lat: 26.190675,
    lng: -97.696056,
    panoId: "EMRzHpldhMia8pmRqD0HCg",
    place: "Near Harlingen, Texas",
    shortName: "Harlingen",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TX",
    state: "Texas",
    difficulty: "classic",
    pools: ["world","North America","US","US-TX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tx-009",
    lat: 31.117009,
    lng: -97.727867,
    panoId: "4R2e5ZpnBJ_8Hv5DIdZr3w",
    place: "Near Killeen, Texas",
    shortName: "Killeen",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TX",
    state: "Texas",
    difficulty: "classic",
    pools: ["world","North America","US","US-TX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tx-010",
    lat: 26.301749,
    lng: -98.163516,
    panoId: "8Sr-FvE3pcRubl1LrRYTAg",
    place: "Near Edinburg, Texas",
    shortName: "Edinburg",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TX",
    state: "Texas",
    difficulty: "classic",
    pools: ["world","North America","US","US-TX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tx-011",
    lat: 33.913626,
    lng: -98.493467,
    panoId: "ipdVMB8BB7Ziuvl7155kXQ",
    place: "Near Wichita Falls, Texas",
    shortName: "Wichita Falls",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TX",
    state: "Texas",
    difficulty: "classic",
    pools: ["world","North America","US","US-TX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tx-012",
    lat: 31.758635,
    lng: -106.486996,
    panoId: "VtVHfz6v0weo5QagClfxQA",
    place: "Near El Paso, Texas",
    shortName: "El Paso",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TX",
    state: "Texas",
    difficulty: "classic",
    pools: ["world","North America","US","US-TX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tx-013",
    lat: 33.214524,
    lng: -97.133041,
    panoId: "245jPFlw4Lme9rgoDtVDFA",
    place: "Near Denton, Texas",
    shortName: "Denton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TX",
    state: "Texas",
    difficulty: "classic",
    pools: ["world","North America","US","US-TX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tx-014",
    lat: 30.674378,
    lng: -96.369954,
    panoId: "DmHpCUfGsdoD_nEgITyuWA",
    place: "Near Bryan, Texas",
    shortName: "Bryan",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TX",
    state: "Texas",
    difficulty: "classic",
    pools: ["world","North America","US","US-TX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tx-015",
    lat: 30.267113,
    lng: -97.743111,
    panoId: "BrCQIewHCqaUd7DMps_nnA",
    place: "Near Austin, Texas",
    shortName: "Austin",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TX",
    state: "Texas",
    difficulty: "classic",
    pools: ["world","North America","US","US-TX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tx-016",
    lat: 26.215865,
    lng: -98.325287,
    panoId: "Kfi6psr3HJgHAnkGkHPs_g",
    place: "Near Mission, Texas",
    shortName: "Mission",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TX",
    state: "Texas",
    difficulty: "classic",
    pools: ["world","North America","US","US-TX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tx-017",
    lat: 33.5779,
    lng: -101.855177,
    panoId: "PpYI6rR2WlEPBcQKGrg1Mw",
    place: "Near Lubbock, Texas",
    shortName: "Lubbock",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TX",
    state: "Texas",
    difficulty: "classic",
    pools: ["world","North America","US","US-TX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tx-018",
    lat: 29.424153,
    lng: -98.493648,
    panoId: "rHsp0nB4I4x-FNsccDdxOw",
    place: "Near San Antonio, Texas",
    shortName: "San Antonio",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TX",
    state: "Texas",
    difficulty: "classic",
    pools: ["world","North America","US","US-TX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tx-019",
    lat: 31.463877,
    lng: -100.437091,
    panoId: "OfHfXA2vapZlLxkGPGFXsQ",
    place: "Near San Angelo, Texas",
    shortName: "San Angelo",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TX",
    state: "Texas",
    difficulty: "classic",
    pools: ["world","North America","US","US-TX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tx-020",
    lat: 28.805294,
    lng: -97.003557,
    panoId: "BCpXRvl4AopPW5LiMPZVpQ",
    place: "Near Victoria, Texas",
    shortName: "Victoria",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TX",
    state: "Texas",
    difficulty: "classic",
    pools: ["world","North America","US","US-TX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tx-021",
    lat: 31.845678,
    lng: -102.367598,
    panoId: "o7B35fR_sWdMWhTurW3TTQ",
    place: "Near Odessa, Texas",
    shortName: "Odessa",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TX",
    state: "Texas",
    difficulty: "classic",
    pools: ["world","North America","US","US-TX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tx-022",
    lat: 33.324633,
    lng: -96.784467,
    panoId: "ZBDJT8LyXTgHPDEl4wu0NQ",
    place: "Near Celina, Texas",
    shortName: "Celina",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TX",
    state: "Texas",
    difficulty: "classic",
    pools: ["world","North America","US","US-TX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tx-023",
    lat: 26.194876,
    lng: -98.183645,
    panoId: "5b5tSjyZTyrWRGoGBWRPYw",
    place: "Near Pharr, Texas",
    shortName: "Pharr",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TX",
    state: "Texas",
    difficulty: "classic",
    pools: ["world","North America","US","US-TX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tx-024",
    lat: 32.448724,
    lng: -99.733146,
    panoId: "XCxPyfnNL4JVsTxb1cg-kA",
    place: "Near Abilene, Texas",
    shortName: "Abilene",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TX",
    state: "Texas",
    difficulty: "classic",
    pools: ["world","North America","US","US-TX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tx-025",
    lat: 32.783119,
    lng: -96.806545,
    panoId: "SXauNB1vuJ8_Y28pNn7FQw",
    place: "Near Dallas, Texas",
    shortName: "Dallas",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TX",
    state: "Texas",
    difficulty: "classic",
    pools: ["world","North America","US","US-TX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tx-026",
    lat: 30.086142,
    lng: -94.10187,
    panoId: "xtfHZO2YceIaAhlbkifguw",
    place: "Near Beaumont, Texas",
    shortName: "Beaumont",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TX",
    state: "Texas",
    difficulty: "classic",
    pools: ["world","North America","US","US-TX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tx-027",
    lat: 33.150495,
    lng: -96.823691,
    panoId: "qKCqcP84InwMVSx25c2wLg",
    place: "Near Frisco, Texas",
    shortName: "Frisco",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TX",
    state: "Texas",
    difficulty: "classic",
    pools: ["world","North America","US","US-TX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tx-028",
    lat: 35.221971,
    lng: -101.831333,
    panoId: "3IhlfXzOtlrcn0gcERPC0A",
    place: "Near Amarillo, Texas",
    shortName: "Amarillo",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TX",
    state: "Texas",
    difficulty: "classic",
    pools: ["world","North America","US","US-TX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tx-029",
    lat: 25.90175,
    lng: -97.497533,
    panoId: "ysg2fhA4TPDoPwppuyJZRA",
    place: "Near Brownsville, Texas",
    shortName: "Brownsville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TX",
    state: "Texas",
    difficulty: "classic",
    pools: ["world","North America","US","US-TX"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-tx-030",
    lat: 32.500639,
    lng: -94.740525,
    panoId: "8lRSAGC1gpOVfndJsE1vFA",
    place: "Near Longview, Texas",
    shortName: "Longview",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TX",
    state: "Texas",
    difficulty: "classic",
    pools: ["world","North America","US","US-TX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tx-031",
    lat: 30.311877,
    lng: -95.456031,
    panoId: "jx-miZIP-IRf9J1WDY4-Mw",
    place: "Near Conroe, Texas",
    shortName: "Conroe",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TX",
    state: "Texas",
    difficulty: "classic",
    pools: ["world","North America","US","US-TX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tx-032",
    lat: 29.702919,
    lng: -98.124386,
    panoId: "kW7wnAh4M9gpMazeGAL_DA",
    place: "Near New Braunfels, Texas",
    shortName: "New Braunfels",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TX",
    state: "Texas",
    difficulty: "classic",
    pools: ["world","North America","US","US-TX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tx-033",
    lat: 27.506384,
    lng: -99.507507,
    panoId: "30WMqD_u81NRknfc4383Iw",
    place: "Near Laredo, Texas",
    shortName: "Laredo",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TX",
    state: "Texas",
    difficulty: "classic",
    pools: ["world","North America","US","US-TX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tx-034",
    lat: 33.197657,
    lng: -96.615039,
    panoId: "S_J0Hl1l5O2WskiGF59IWg",
    place: "Near McKinney, Texas",
    shortName: "McKinney",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TX",
    state: "Texas",
    difficulty: "classic",
    pools: ["world","North America","US","US-TX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tx-035",
    lat: 27.800644,
    lng: -97.396423,
    panoId: "XSH5hYxWBl2aWfjRQ8c6tg",
    place: "Near Corpus Christi, Texas",
    shortName: "Corpus Christi",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TX",
    state: "Texas",
    difficulty: "classic",
    pools: ["world","North America","US","US-TX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tx-036",
    lat: 29.883242,
    lng: -97.941508,
    panoId: "MH5r-hXM0nutnlMXol2vOQ",
    place: "Near San Marcos, Texas",
    shortName: "San Marcos",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TX",
    state: "Texas",
    difficulty: "classic",
    pools: ["world","North America","US","US-TX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tx-037",
    lat: 30.632706,
    lng: -97.676962,
    panoId: "C9hAxoSV7PVXlEkW2oH1Sg",
    place: "Near Georgetown, Texas",
    shortName: "Georgetown",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TX",
    state: "Texas",
    difficulty: "classic",
    pools: ["world","North America","US","US-TX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tx-038",
    lat: 32.706273,
    lng: -97.320164,
    panoId: "IsZXpfuD0FgPxVM5WgsyBQ",
    place: "Near Fort Worth, Texas",
    shortName: "Fort Worth",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TX",
    state: "Texas",
    difficulty: "classic",
    pools: ["world","North America","US","US-TX"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-tx-039",
    lat: 30.659732,
    lng: -96.384219,
    panoId: "Mu9-rSaEiCN8fYJ6XBG_Zg",
    place: "Near Bryan, Texas",
    shortName: "Bryan",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TX",
    state: "Texas",
    difficulty: "classic",
    pools: ["world","North America","US","US-TX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tx-040",
    lat: 31.834645,
    lng: -102.389067,
    panoId: "iunBk3nqqvw311IiZ9csNQ",
    place: "Near Odessa, Texas",
    shortName: "Odessa",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TX",
    state: "Texas",
    difficulty: "classic",
    pools: ["world","North America","US","US-TX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tx-041",
    lat: 30.146209,
    lng: -95.476072,
    panoId: "fMLpzuTixrILG66qOce5Vg",
    place: "Near The Woodlands, Texas",
    shortName: "The Woodlands",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TX",
    state: "Texas",
    difficulty: "classic",
    pools: ["world","North America","US","US-TX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tx-042",
    lat: 29.717896,
    lng: -98.123859,
    panoId: "IGSh3LWL03i9jrQ4kLUxZA",
    place: "Near New Braunfels, Texas",
    shortName: "New Braunfels",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TX",
    state: "Texas",
    difficulty: "classic",
    pools: ["world","North America","US","US-TX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tx-043",
    lat: 33.905715,
    lng: -98.502637,
    panoId: "LwI-XaiEtmT0LLNb7rFeqw",
    place: "Near Wichita Falls, Texas",
    shortName: "Wichita Falls",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TX",
    state: "Texas",
    difficulty: "classic",
    pools: ["world","North America","US","US-TX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tx-044",
    lat: 26.206335,
    lng: -98.214673,
    panoId: "DYvX0WJEM_HuBkMPxZPPvg",
    place: "Near McAllen, Texas",
    shortName: "McAllen",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TX",
    state: "Texas",
    difficulty: "classic",
    pools: ["world","North America","US","US-TX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tx-045",
    lat: 31.116988,
    lng: -97.744499,
    panoId: "yNN0jeaBegzbIcx_tjfUEg",
    place: "Near Killeen, Texas",
    shortName: "Killeen",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TX",
    state: "Texas",
    difficulty: "classic",
    pools: ["world","North America","US","US-TX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tx-046",
    lat: 29.434029,
    lng: -98.512132,
    panoId: "oWDDvS0yYQzX0mO8Hk-jag",
    place: "Near San Antonio, Texas",
    shortName: "San Antonio",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TX",
    state: "Texas",
    difficulty: "classic",
    pools: ["world","North America","US","US-TX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tx-047",
    lat: 31.569708,
    lng: -97.143272,
    panoId: "t_8_5GBwoZATLSDpKwne4w",
    place: "Near Waco, Texas",
    shortName: "Waco",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TX",
    state: "Texas",
    difficulty: "classic",
    pools: ["world","North America","US","US-TX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tx-048",
    lat: 29.768869,
    lng: -95.387391,
    panoId: "OK6LlnWV9naoW6j667j8RA",
    place: "Near Houston, Texas",
    shortName: "Houston",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TX",
    state: "Texas",
    difficulty: "classic",
    pools: ["world","North America","US","US-TX"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-tx-049",
    lat: 33.179141,
    lng: -96.601379,
    panoId: "XTXgGxyb_qIMBnkibgi5Vg",
    place: "Near McKinney, Texas",
    shortName: "McKinney",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TX",
    state: "Texas",
    difficulty: "classic",
    pools: ["world","North America","US","US-TX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tx-050",
    lat: 26.158312,
    lng: -97.740185,
    panoId: "x16Di30g27ZCLwCki4q2Yw",
    place: "Near Las Palmas II, Texas",
    shortName: "Las Palmas II",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TX",
    state: "Texas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-TX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tx-051",
    lat: 32.551487,
    lng: -94.725363,
    panoId: "RVCSSQogvrI0G6smYupMaw",
    place: "Near Longview, Texas",
    shortName: "Longview",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TX",
    state: "Texas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-TX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tx-052",
    lat: 33.231555,
    lng: -97.093866,
    panoId: "Facamv2qo9nh8u2JWgQhdw",
    place: "Near Denton, Texas",
    shortName: "Denton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TX",
    state: "Texas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-TX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tx-053",
    lat: 31.113424,
    lng: -97.42289,
    panoId: "ge67ctKK3zaQO-ialfEyyw",
    place: "Near Morgans Point Resort, Texas",
    shortName: "Morgans Point Resort",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TX",
    state: "Texas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-TX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tx-054",
    lat: 33.570826,
    lng: -101.811206,
    panoId: "VHSy20eVoALRUx94O7ADVA",
    place: "Near Lubbock, Texas",
    shortName: "Lubbock",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TX",
    state: "Texas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-TX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tx-055",
    lat: 31.940916,
    lng: -102.073805,
    panoId: "VkRdWsVVHEw1xNzyomJSyw",
    place: "Near Midland, Texas",
    shortName: "Midland",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TX",
    state: "Texas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-TX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tx-056",
    lat: 30.370525,
    lng: -95.478388,
    panoId: "Za3MdL5eeDnTT8CYFeUAtA",
    place: "Near Panorama Village, Texas",
    shortName: "Panorama Village",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TX",
    state: "Texas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-TX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tx-057",
    lat: 28.78621,
    lng: -97.037756,
    panoId: "Mt5rFP_jjjqgMqQzNCFunA",
    place: "Near Victoria, Texas",
    shortName: "Victoria",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TX",
    state: "Texas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-TX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tx-058",
    lat: 32.469086,
    lng: -99.687289,
    panoId: "NaVo6U-TaewD_nfrlZKVsQ",
    place: "Near Abilene, Texas",
    shortName: "Abilene",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TX",
    state: "Texas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-TX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tx-059",
    lat: 30.696808,
    lng: -96.327261,
    panoId: "axUZFwzVQkjggHHqeRlYFQ",
    place: "Near Bryan, Texas",
    shortName: "Bryan",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TX",
    state: "Texas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-TX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tx-060",
    lat: 31.688364,
    lng: -106.47156,
    panoId: "dnWRDGd8AAfki4AWkFa8vw",
    place: "Near Ciudad Juárez, Texas",
    shortName: "Ciudad Juárez",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TX",
    state: "Texas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-TX"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-tx-061",
    lat: 32.353986,
    lng: -95.222293,
    panoId: "ouVyxf1lUHNrNwuWQoqW5w",
    place: "Near Tyler, Texas",
    shortName: "Tyler",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TX",
    state: "Texas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-TX"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-tx-062",
    lat: 33.152856,
    lng: -96.782167,
    panoId: "yWTBW_mZufmtVHFusKpwWw",
    place: "Near Frisco, Texas",
    shortName: "Frisco",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TX",
    state: "Texas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-TX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tx-063",
    lat: 27.764212,
    lng: -97.413309,
    panoId: "nzkW1a9xDVAFfjrohzwVVw",
    place: "Near Corpus Christi, Texas",
    shortName: "Corpus Christi",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TX",
    state: "Texas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-TX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tx-064",
    lat: 33.341423,
    lng: -96.739834,
    panoId: "V0BUMkoi0ige0fIJ87owlQ",
    place: "Near Celina, Texas",
    shortName: "Celina",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TX",
    state: "Texas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-TX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tx-065",
    lat: 35.250914,
    lng: -101.808351,
    panoId: "HHlsX9Sqy1ljmxGzp7Usrw",
    place: "Near Amarillo, Texas",
    shortName: "Amarillo",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TX",
    state: "Texas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-TX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tx-066",
    lat: 29.813397,
    lng: -93.954734,
    panoId: "-Apy1EJ5k0oe3KVtrHBZ5w",
    place: "Near Port Arthur, Texas",
    shortName: "Port Arthur",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TX",
    state: "Texas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-TX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tx-067",
    lat: 30.274927,
    lng: -97.708134,
    panoId: "ueMNGLDZ0rtoOLrXLhbezg",
    place: "Near University of Texas, Texas",
    shortName: "University of Texas",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TX",
    state: "Texas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-TX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tx-068",
    lat: 29.899541,
    lng: -97.891624,
    panoId: "KZ6MJy6FdCXLckG3pv8JdA",
    place: "Near San Marcos, Texas",
    shortName: "San Marcos",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TX",
    state: "Texas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-TX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tx-069",
    lat: 30.677066,
    lng: -97.663667,
    panoId: "Zqnof2ylYwGQAQARQr6thQ",
    place: "Near Serenada, Texas",
    shortName: "Serenada",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TX",
    state: "Texas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-TX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tx-070",
    lat: 31.821466,
    lng: -102.320744,
    panoId: "lA9eDB0SlqhoAB5VZGgbhw",
    place: "Near Odessa, Texas",
    shortName: "Odessa",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TX",
    state: "Texas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-TX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tx-071",
    lat: 29.76799,
    lng: -95.317882,
    panoId: "o3aH32MuhJDX1ASlBGJIaQ",
    place: "Near Houston, Texas",
    shortName: "Houston",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TX",
    state: "Texas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-TX"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "us-tx-072",
    lat: 31.105849,
    lng: -97.800282,
    panoId: "MSmLANON7UIqSJmprkqdaw",
    place: "Near Fort Cavazos, Texas",
    shortName: "Fort Cavazos",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TX",
    state: "Texas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-TX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tx-073",
    lat: 32.440932,
    lng: -94.71733,
    panoId: "mCQ-6gQdMKf2rUV15O9s7Q",
    place: "Near Longview, Texas",
    shortName: "Longview",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TX",
    state: "Texas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-TX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tx-074",
    lat: 33.877706,
    lng: -98.437419,
    panoId: "9FQM8rebrVATsfEmcXZ0Nw",
    place: "Near Wichita Falls, Texas",
    shortName: "Wichita Falls",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TX",
    state: "Texas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-TX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tx-075",
    lat: 30.056552,
    lng: -94.098305,
    panoId: "jmQs5J98CNCCt7ZRlbyqsQ",
    place: "Near Beaumont, Texas",
    shortName: "Beaumont",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TX",
    state: "Texas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-TX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tx-076",
    lat: 31.491622,
    lng: -100.475914,
    panoId: "_B0wzYxu8qJX_lWrRj1jNg",
    place: "Near San Angelo, Texas",
    shortName: "San Angelo",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TX",
    state: "Texas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-TX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tx-077",
    lat: 26.249966,
    lng: -98.257588,
    panoId: "ckQuxgMb82zSHLIJjVr8Wg",
    place: "Near McAllen, Texas",
    shortName: "McAllen",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TX",
    state: "Texas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-TX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tx-078",
    lat: 29.459003,
    lng: -98.521757,
    panoId: "-fEfcajlnhDVAo0bltXzhw",
    place: "Near Olmos Park, Texas",
    shortName: "Olmos Park",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TX",
    state: "Texas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-TX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tx-079",
    lat: 30.136566,
    lng: -95.456298,
    panoId: "8uXXz_dvazZJoVIdb_jCpg",
    place: "Near Oak Ridge North, Texas",
    shortName: "Oak Ridge North",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TX",
    state: "Texas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-TX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tx-080",
    lat: 33.247757,
    lng: -97.061613,
    panoId: "qizT07divOzqrkjNnGF74w",
    place: "Near Denton, Texas",
    shortName: "Denton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TX",
    state: "Texas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-TX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tx-081",
    lat: 31.975194,
    lng: -102.0042,
    panoId: "q9uRYGSi9mMRnhPLVGJMaQ",
    place: "Near Midland, Texas",
    shortName: "Midland",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TX",
    state: "Texas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-TX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tx-082",
    lat: 28.805238,
    lng: -96.95612,
    panoId: "Lg6zQvIkrp2snVtLvhwVlg",
    place: "Near Victoria, Texas",
    shortName: "Victoria",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TX",
    state: "Texas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-TX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tx-083",
    lat: 32.379065,
    lng: -95.322213,
    panoId: "OqmVDeNES3uSF7Aydf0_0g",
    place: "Near Tyler, Texas",
    shortName: "Tyler",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TX",
    state: "Texas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-TX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tx-084",
    lat: 29.900338,
    lng: -93.875843,
    panoId: "9KincVURaGoLHWCabjjZyg",
    place: "Near Port Arthur, Texas",
    shortName: "Port Arthur",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TX",
    state: "Texas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-TX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tx-085",
    lat: 30.288543,
    lng: -95.416409,
    panoId: "1hh6uqSSpb4GRM0kIuARSg",
    place: "Near Conroe, Texas",
    shortName: "Conroe",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TX",
    state: "Texas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-TX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tx-086",
    lat: 30.655196,
    lng: -96.336794,
    panoId: "Vw2Hbi6Oc0n60Lfj92tWog",
    place: "Near College Station, Texas",
    shortName: "College Station",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TX",
    state: "Texas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-TX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tx-087",
    lat: 31.160926,
    lng: -97.36931,
    panoId: "gTYwyJN3te6WjE_2MvrqRg",
    place: "Near Temple, Texas",
    shortName: "Temple",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TX",
    state: "Texas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-TX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tx-088",
    lat: 33.098595,
    lng: -96.826931,
    panoId: "IunndXb0NEjbFpzhet8KGQ",
    place: "Near The Colony, Texas",
    shortName: "The Colony",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TX",
    state: "Texas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-TX"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-tx-089",
    lat: 27.736257,
    lng: -97.379979,
    panoId: "YEUUPt0AkCAcBFkAUJlA0A",
    place: "Near Corpus Christi, Texas",
    shortName: "Corpus Christi",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TX",
    state: "Texas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-TX"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-tx-090",
    lat: 35.232381,
    lng: -101.760013,
    panoId: "fLk2ClPATSlGdOgC1PBppw",
    place: "Near Amarillo, Texas",
    shortName: "Amarillo",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TX",
    state: "Texas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-TX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tx-091",
    lat: 25.951125,
    lng: -97.508595,
    panoId: "AjhDTS0g2yuFYrJjQUTJ-g",
    place: "Near Cameron Park, Texas",
    shortName: "Cameron Park",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TX",
    state: "Texas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-TX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tx-092",
    lat: 33.483222,
    lng: -101.817329,
    panoId: "3WGaKgorN58apUHurDfHwg",
    place: "Near Lubbock, Texas",
    shortName: "Lubbock",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TX",
    state: "Texas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-TX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tx-093",
    lat: 33.204361,
    lng: -96.964194,
    panoId: "zuY87aoKHcSjB5LX8lYbDA",
    place: "Near Paloma Creek South, Texas",
    shortName: "Paloma Creek South",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TX",
    state: "Texas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-TX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tx-094",
    lat: 26.328791,
    lng: -98.33098,
    panoId: "swunR2W2F7eSQunOq0b8LA",
    place: "Near Alton North (historical), Texas",
    shortName: "Alton North (historical)",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TX",
    state: "Texas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-TX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tx-095",
    lat: 26.073638,
    lng: -97.586761,
    panoId: "guJAzY7_No_Fv8obIXIe6Q",
    place: "Near Rancho Viejo, Texas",
    shortName: "Rancho Viejo",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TX",
    state: "Texas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-TX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tx-096",
    lat: 26.328066,
    lng: -97.786101,
    panoId: "OnyQTWwRspQvaEC_6QIKtw",
    place: "Near Sebastian, Texas",
    shortName: "Sebastian",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TX",
    state: "Texas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-TX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tx-097",
    lat: 33.33724,
    lng: -96.499893,
    panoId: "WYUkdcT7O1g5p3thEF_HLw",
    place: "Near Anna, Texas",
    shortName: "Anna",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TX",
    state: "Texas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-TX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tx-098",
    lat: 31.124703,
    lng: -97.969931,
    panoId: "vwKqeH3knh91J_-zJq9f9w",
    place: "Near Kempner, Texas",
    shortName: "Kempner",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TX",
    state: "Texas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-TX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tx-099",
    lat: 32.262619,
    lng: -96.864421,
    panoId: "Lp8ZZIGD7X9q5pZSCJ562w",
    place: "Near Nash, Texas",
    shortName: "Nash",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TX",
    state: "Texas",
    difficulty: "explorer",
    pools: ["world","North America","US","US-TX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tx-100",
    lat: 26.452486,
    lng: -98.240132,
    panoId: "t2jIPIjIk4dPuYgbt6x8zQ",
    place: "Near Doolittle, Texas",
    shortName: "Doolittle",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TX",
    state: "Texas",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-TX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tx-101",
    lat: 32.092185,
    lng: -101.491409,
    panoId: "sZfp5NEshwkTJsb8bg6qlQ",
    place: "Near Big Spring, Texas",
    shortName: "Big Spring",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TX",
    state: "Texas",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-TX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tx-102",
    lat: 31.424911,
    lng: -100.260669,
    panoId: "Qas0BIRZU6M_hF_RYJBYbA",
    place: "Near San Angelo, Texas",
    shortName: "San Angelo",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TX",
    state: "Texas",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-TX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tx-103",
    lat: 29.87219,
    lng: -94.158804,
    panoId: "DOqpdtofWPt-sCvpqfDxiw",
    place: "Near Fannett, Texas",
    shortName: "Fannett",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TX",
    state: "Texas",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-TX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tx-104",
    lat: 28.711054,
    lng: -100.688426,
    panoId: "fpHJYOgURxOTIH-TIeseXw",
    place: "Near Colonia Venustiano Carranza, Texas",
    shortName: "Colonia Venustiano Carranza",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TX",
    state: "Texas",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-TX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tx-105",
    lat: 30.969726,
    lng: -97.756557,
    panoId: "MymmcqkSSFR10fVcArrIFg",
    place: "Near Florence, Texas",
    shortName: "Florence",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TX",
    state: "Texas",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-TX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tx-106",
    lat: 28.912963,
    lng: -95.544262,
    panoId: "eQ5wj6MiOq079_4XsGioqQ",
    place: "Near Jones Creek, Texas",
    shortName: "Jones Creek",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TX",
    state: "Texas",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-TX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tx-107",
    lat: 32.064004,
    lng: -101.482624,
    panoId: "RRdfUk_XhyOGyhkChnVPdw",
    place: "Near Big Spring, Texas",
    shortName: "Big Spring",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TX",
    state: "Texas",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-TX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tx-108",
    lat: 29.893113,
    lng: -99.062188,
    panoId: "LYnAEUP3x_cd6Yc0WesMBg",
    place: "Near Comfort, Texas",
    shortName: "Comfort",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TX",
    state: "Texas",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-TX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tx-109",
    lat: 31.672527,
    lng: -102.555569,
    panoId: "ekjsYw1z0W_77aCs5oQp5A",
    place: "Near West Odessa, Texas",
    shortName: "West Odessa",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TX",
    state: "Texas",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-TX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-tx-110",
    lat: 33.347093,
    lng: -93.896822,
    panoId: "j3KQWkJ5CIqc6_nBmmiaLA",
    place: "Near Texarkana, Texas",
    shortName: "Texarkana",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "TX",
    state: "Texas",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-TX"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-ut-000",
    lat: 40.691637,
    lng: -112.001192,
    panoId: "IpIq_VdsMDsXzPlOFmqeXw",
    place: "Near West Valley City, Utah",
    shortName: "West Valley City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "UT",
    state: "Utah",
    difficulty: "classic",
    pools: ["world","North America","US","US-UT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ut-001",
    lat: 37.104167,
    lng: -113.583359,
    panoId: "xNcqJ53ZMUZANWVCIAcfcA",
    place: "Near Saint George, Utah",
    shortName: "Saint George",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "UT",
    state: "Utah",
    difficulty: "classic",
    pools: ["world","North America","US","US-UT"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-ut-002",
    lat: 40.530628,
    lng: -112.298218,
    panoId: "gOBFrj_yZWC7hRqoQVw4Jg",
    place: "Near Tooele, Utah",
    shortName: "Tooele",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "UT",
    state: "Utah",
    difficulty: "classic",
    pools: ["world","North America","US","US-UT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ut-003",
    lat: 41.735571,
    lng: -111.834341,
    panoId: "cIPbkA5HkRL_CkR3yAkqsg",
    place: "Near Logan, Utah",
    shortName: "Logan",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "UT",
    state: "Utah",
    difficulty: "classic",
    pools: ["world","North America","US","US-UT"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-ut-004",
    lat: 41.2228,
    lng: -111.973798,
    panoId: "j88UZ-kf-2EHGZmudizr8Q",
    place: "Near Ogden, Utah",
    shortName: "Ogden",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "UT",
    state: "Utah",
    difficulty: "classic",
    pools: ["world","North America","US","US-UT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ut-005",
    lat: 40.115015,
    lng: -111.654958,
    panoId: "uQgEbfquW2ikrsfLpQZm_Q",
    place: "Near Spanish Fork, Utah",
    shortName: "Spanish Fork",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "UT",
    state: "Utah",
    difficulty: "classic",
    pools: ["world","North America","US","US-UT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ut-006",
    lat: 40.296882,
    lng: -111.694815,
    panoId: "gFnjWNztTjbkhMVlrZbdmA",
    place: "Near Orem, Utah",
    shortName: "Orem",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "UT",
    state: "Utah",
    difficulty: "classic",
    pools: ["world","North America","US","US-UT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ut-007",
    lat: 40.667711,
    lng: -111.938844,
    panoId: "9krT_tZmCbCAk_jw69UkCA",
    place: "Near Taylorsville, Utah",
    shortName: "Taylorsville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "UT",
    state: "Utah",
    difficulty: "classic",
    pools: ["world","North America","US","US-UT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ut-008",
    lat: 40.165228,
    lng: -111.610632,
    panoId: "1IH1Z6-KANswNKmyFXIv7A",
    place: "Near Springville, Utah",
    shortName: "Springville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "UT",
    state: "Utah",
    difficulty: "classic",
    pools: ["world","North America","US","US-UT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ut-009",
    lat: 40.348814,
    lng: -111.905144,
    panoId: "KXkRr8lBFMiKoJaKvdgKLw",
    place: "Near Saratoga Springs, Utah",
    shortName: "Saratoga Springs",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "UT",
    state: "Utah",
    difficulty: "classic",
    pools: ["world","North America","US","US-UT"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "us-ut-010",
    lat: 40.233839,
    lng: -111.658592,
    panoId: "Y94fDUmPy_iupsqrADqv8w",
    place: "Near Provo, Utah",
    shortName: "Provo",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "UT",
    state: "Utah",
    difficulty: "classic",
    pools: ["world","North America","US","US-UT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ut-011",
    lat: 40.591662,
    lng: -111.884154,
    panoId: "feZXZhyhe3oCQKuMasghkQ",
    place: "Near Sandy, Utah",
    shortName: "Sandy",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "UT",
    state: "Utah",
    difficulty: "classic",
    pools: ["world","North America","US","US-UT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ut-012",
    lat: 40.562122,
    lng: -111.929699,
    panoId: "ngu7poxpN4DNycjiaofZ3A",
    place: "Near South Jordan, Utah",
    shortName: "South Jordan",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "UT",
    state: "Utah",
    difficulty: "classic",
    pools: ["world","North America","US","US-UT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ut-013",
    lat: 40.666954,
    lng: -111.888033,
    panoId: "JFbghhNuDPF4O3IIe7gZaw",
    place: "Near Murray, Utah",
    shortName: "Murray",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "UT",
    state: "Utah",
    difficulty: "classic",
    pools: ["world","North America","US","US-UT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ut-014",
    lat: 40.524717,
    lng: -111.863436,
    panoId: "aVSGySZQKj1AVoRSR-qq0g",
    place: "Near Draper, Utah",
    shortName: "Draper",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "UT",
    state: "Utah",
    difficulty: "classic",
    pools: ["world","North America","US","US-UT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ut-015",
    lat: 41.16152,
    lng: -112.026311,
    panoId: "ZpJgRq9RJcb2dm2AAH20Zg",
    place: "Near Roy, Utah",
    shortName: "Roy",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "UT",
    state: "Utah",
    difficulty: "classic",
    pools: ["world","North America","US","US-UT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ut-016",
    lat: 40.363907,
    lng: -111.738556,
    panoId: "xvVVZk0p3ymZToIyyohuaQ",
    place: "Near Pleasant Grove, Utah",
    shortName: "Pleasant Grove",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "UT",
    state: "Utah",
    difficulty: "classic",
    pools: ["world","North America","US","US-UT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ut-017",
    lat: 40.709153,
    lng: -112.101644,
    panoId: "MpvzdiuYSOe6O7bt-vO1CA",
    place: "Near Magna, Utah",
    shortName: "Magna",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "UT",
    state: "Utah",
    difficulty: "classic",
    pools: ["world","North America","US","US-UT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ut-018",
    lat: 40.687069,
    lng: -111.875536,
    panoId: "pgJEWC7vBiixN63BN3O_lw",
    place: "Near Millcreek, Utah",
    shortName: "Millcreek",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "UT",
    state: "Utah",
    difficulty: "classic",
    pools: ["world","North America","US","US-UT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ut-019",
    lat: 40.391631,
    lng: -111.850891,
    panoId: "piVFvuodR5cY0Qxjaqb7Kw",
    place: "Near Lehi, Utah",
    shortName: "Lehi",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "UT",
    state: "Utah",
    difficulty: "classic",
    pools: ["world","North America","US","US-UT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ut-020",
    lat: 40.668855,
    lng: -111.824675,
    panoId: "Gt6b3BGh9w5qdVpoLEueZw",
    place: "Near Holladay, Utah",
    shortName: "Holladay",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "UT",
    state: "Utah",
    difficulty: "classic",
    pools: ["world","North America","US","US-UT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ut-021",
    lat: 37.677361,
    lng: -113.061875,
    panoId: "plDT3RcUF3eyC6wptjy2jA",
    place: "Near Cedar City, Utah",
    shortName: "Cedar City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "UT",
    state: "Utah",
    difficulty: "classic",
    pools: ["world","North America","US","US-UT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ut-022",
    lat: 40.889345,
    lng: -111.880753,
    panoId: "Y0DYPcSX6Rx1mCySWtYkww",
    place: "Near Bountiful, Utah",
    shortName: "Bountiful",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "UT",
    state: "Utah",
    difficulty: "classic",
    pools: ["world","North America","US","US-UT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ut-023",
    lat: 40.609586,
    lng: -111.939092,
    panoId: "iMfMGxfSObKkesFCBcIl7A",
    place: "Near West Jordan, Utah",
    shortName: "West Jordan",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "UT",
    state: "Utah",
    difficulty: "classic",
    pools: ["world","North America","US","US-UT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ut-024",
    lat: 40.376787,
    lng: -111.795709,
    panoId: "vlSTz111btyYc0bqZXs9DA",
    place: "Near American Fork, Utah",
    shortName: "American Fork",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "UT",
    state: "Utah",
    difficulty: "classic",
    pools: ["world","North America","US","US-UT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ut-025",
    lat: 40.619812,
    lng: -111.810255,
    panoId: "lRKYN7-d6BSeQZMqUe_X-Q",
    place: "Near Cottonwood Heights, Utah",
    shortName: "Cottonwood Heights",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "UT",
    state: "Utah",
    difficulty: "classic",
    pools: ["world","North America","US","US-UT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ut-026",
    lat: 40.313972,
    lng: -112.006933,
    panoId: "tKYi74KR7FJRi6llgz2e7Q",
    place: "Near Eagle Mountain, Utah",
    shortName: "Eagle Mountain",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "UT",
    state: "Utah",
    difficulty: "classic",
    pools: ["world","North America","US","US-UT"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "us-ut-027",
    lat: 40.760796,
    lng: -111.890993,
    panoId: "rAND0m3sFcJRnBBH6bamcQ",
    place: "Near Salt Lake City, Utah",
    shortName: "Salt Lake City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "UT",
    state: "Utah",
    difficulty: "classic",
    pools: ["world","North America","US","US-UT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ut-028",
    lat: 40.660012,
    lng: -111.996325,
    panoId: "-sLbOb2UXC_GJ59bPg1uKQ",
    place: "Near Kearns, Utah",
    shortName: "Kearns",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "UT",
    state: "Utah",
    difficulty: "classic",
    pools: ["world","North America","US","US-UT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ut-029",
    lat: 41.060192,
    lng: -111.971067,
    panoId: "5ST9HfipRIKnGiV5Q-1DEA",
    place: "Near Layton, Utah",
    shortName: "Layton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "UT",
    state: "Utah",
    difficulty: "classic",
    pools: ["world","North America","US","US-UT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ut-030",
    lat: 41.110848,
    lng: -112.025956,
    panoId: "NK0TIMNufsPjYgJcWFTDqw",
    place: "Near Clearfield, Utah",
    shortName: "Clearfield",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "UT",
    state: "Utah",
    difficulty: "classic",
    pools: ["world","North America","US","US-UT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ut-031",
    lat: 41.089348,
    lng: -112.06468,
    panoId: "P458_NpH5ko21IegjllYXg",
    place: "Near Syracuse, Utah",
    shortName: "Syracuse",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "UT",
    state: "Utah",
    difficulty: "classic",
    pools: ["world","North America","US","US-UT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ut-032",
    lat: 40.514161,
    lng: -112.033013,
    panoId: "8-gXonMkss5SrguATuH8zA",
    place: "Near Herriman, Utah",
    shortName: "Herriman",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "UT",
    state: "Utah",
    difficulty: "classic",
    pools: ["world","North America","US","US-UT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ut-033",
    lat: 41.035259,
    lng: -111.93855,
    panoId: "U81azyXC5BWGkCeyQI9GMQ",
    place: "Near Kaysville, Utah",
    shortName: "Kaysville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "UT",
    state: "Utah",
    difficulty: "classic",
    pools: ["world","North America","US","US-UT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ut-034",
    lat: 40.610929,
    lng: -111.899891,
    panoId: "w8pXmNKYn8HHWWWuWVQBkQ",
    place: "Near Midvale, Utah",
    shortName: "Midvale",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "UT",
    state: "Utah",
    difficulty: "classic",
    pools: ["world","North America","US","US-UT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ut-035",
    lat: 40.521829,
    lng: -111.939144,
    panoId: "BRO9anj2h60Vo-he_csh8w",
    place: "Near Riverton, Utah",
    shortName: "Riverton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "UT",
    state: "Utah",
    difficulty: "classic",
    pools: ["world","North America","US","US-UT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ut-036",
    lat: 41.139932,
    lng: -112.050578,
    panoId: "ZvdcMeb8nvWfJCDsjTzLGA",
    place: "Near Clinton, Utah",
    shortName: "Clinton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "UT",
    state: "Utah",
    difficulty: "classic",
    pools: ["world","North America","US","US-UT"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-ut-037",
    lat: 40.980482,
    lng: -111.887438,
    panoId: "gN4s58kiGY2z3TmvzB6f5g",
    place: "Near Farmington, Utah",
    shortName: "Farmington",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "UT",
    state: "Utah",
    difficulty: "classic",
    pools: ["world","North America","US","US-UT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ut-038",
    lat: 40.718858,
    lng: -111.888344,
    panoId: "JX8YLdunOnw3nG_vCxGP_w",
    place: "Near South Salt Lake, Utah",
    shortName: "South Salt Lake",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "UT",
    state: "Utah",
    difficulty: "classic",
    pools: ["world","North America","US","US-UT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ut-039",
    lat: 37.130495,
    lng: -113.508205,
    panoId: "J3yqblic-9-rx2znfteh5w",
    place: "Near Washington, Utah",
    shortName: "Washington",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "UT",
    state: "Utah",
    difficulty: "classic",
    pools: ["world","North America","US","US-UT"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-ut-040",
    lat: 40.370122,
    lng: -111.729185,
    panoId: "k5cYdMD-Pe-XoXf8vDGdNw",
    place: "Near Pleasant Grove, Utah",
    shortName: "Pleasant Grove",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "UT",
    state: "Utah",
    difficulty: "classic",
    pools: ["world","North America","US","US-UT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ut-041",
    lat: 40.50907,
    lng: -111.863882,
    panoId: "Fa-dA7Ma1C0B6SacBrwsOQ",
    place: "Near Draper, Utah",
    shortName: "Draper",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "UT",
    state: "Utah",
    difficulty: "classic",
    pools: ["world","North America","US","US-UT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ut-042",
    lat: 37.695785,
    lng: -113.06296,
    panoId: "9tMSrxVpy3e0Vc36y6hgAA",
    place: "Near Cedar City, Utah",
    shortName: "Cedar City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "UT",
    state: "Utah",
    difficulty: "classic",
    pools: ["world","North America","US","US-UT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ut-043",
    lat: 40.662338,
    lng: -111.92855,
    panoId: "BuS1qHb5mWgjSn4jiO7GrA",
    place: "Near Taylorsville, Utah",
    shortName: "Taylorsville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "UT",
    state: "Utah",
    difficulty: "classic",
    pools: ["world","North America","US","US-UT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ut-044",
    lat: 41.124424,
    lng: -112.029334,
    panoId: "SV-oJhW9lAZ8yi8oxl4yqQ",
    place: "Near Sunset, Utah",
    shortName: "Sunset",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "UT",
    state: "Utah",
    difficulty: "classic",
    pools: ["world","North America","US","US-UT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ut-045",
    lat: 41.202703,
    lng: -111.971655,
    panoId: "-OtnnTj3yNPyjoRFNYEq_w",
    place: "Near South Ogden, Utah",
    shortName: "South Ogden",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "UT",
    state: "Utah",
    difficulty: "classic",
    pools: ["world","North America","US","US-UT"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-ut-046",
    lat: 40.401075,
    lng: -111.840758,
    panoId: "kdtr5hDwZzfSXbXP3TJMKw",
    place: "Near Lehi, Utah",
    shortName: "Lehi",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "UT",
    state: "Utah",
    difficulty: "classic",
    pools: ["world","North America","US","US-UT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ut-047",
    lat: 40.168061,
    lng: -111.589171,
    panoId: "ytbA9KLdzLMRep4pif3kXg",
    place: "Near Springville, Utah",
    shortName: "Springville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "UT",
    state: "Utah",
    difficulty: "classic",
    pools: ["world","North America","US","US-UT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ut-048",
    lat: 40.331859,
    lng: -111.90105,
    panoId: "ylHxipGHuRH0fULC9DDeOA",
    place: "Near Saratoga Springs, Utah",
    shortName: "Saratoga Springs",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "UT",
    state: "Utah",
    difficulty: "classic",
    pools: ["world","North America","US","US-UT"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "us-ut-049",
    lat: 40.225787,
    lng: -111.682765,
    panoId: "AVYlSF2Yo5ezWjU2d-lygw",
    place: "Near Provo, Utah",
    shortName: "Provo",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "UT",
    state: "Utah",
    difficulty: "classic",
    pools: ["world","North America","US","US-UT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ut-050",
    lat: 40.623819,
    lng: -111.743334,
    panoId: "sNb1WYeP7tVkZiywYIBG7A",
    place: "Near Cottonwood Heights, Utah",
    shortName: "Cottonwood Heights",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "UT",
    state: "Utah",
    difficulty: "explorer",
    pools: ["world","North America","US","US-UT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ut-051",
    lat: 40.548832,
    lng: -112.064087,
    panoId: "DMFCVij5ZW-lczvLrz-lQw",
    place: "Near Herriman, Utah",
    shortName: "Herriman",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "UT",
    state: "Utah",
    difficulty: "explorer",
    pools: ["world","North America","US","US-UT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ut-052",
    lat: 40.295013,
    lng: -111.753342,
    panoId: "Fadlhm-iNX467IhG58xL3Q",
    place: "Near Vineyard, Utah",
    shortName: "Vineyard",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "UT",
    state: "Utah",
    difficulty: "explorer",
    pools: ["world","North America","US","US-UT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ut-053",
    lat: 40.638484,
    lng: -111.855767,
    panoId: "iIq_4aGXNJDbRhCQ8SVJdw",
    place: "Near Murray, Utah",
    shortName: "Murray",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "UT",
    state: "Utah",
    difficulty: "explorer",
    pools: ["world","North America","US","US-UT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ut-054",
    lat: 41.70033,
    lng: -111.900446,
    panoId: "l7GHacPdGjMELvU4xQ261g",
    place: "Near Nibley, Utah",
    shortName: "Nibley",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "UT",
    state: "Utah",
    difficulty: "explorer",
    pools: ["world","North America","US","US-UT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ut-055",
    lat: 40.751114,
    lng: -111.99331,
    panoId: "Le4OpIA1FuOIaAj_mkpQ3g",
    place: "Near West Valley City, Utah",
    shortName: "West Valley City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "UT",
    state: "Utah",
    difficulty: "explorer",
    pools: ["world","North America","US","US-UT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ut-056",
    lat: 41.045737,
    lng: -112.026398,
    panoId: "3g8Tj6bY0s5-gEyhapbUIQ",
    place: "Near Layton, Utah",
    shortName: "Layton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "UT",
    state: "Utah",
    difficulty: "explorer",
    pools: ["world","North America","US","US-UT"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-ut-057",
    lat: 40.575811,
    lng: -112.274766,
    panoId: "pHLgg1Bbcg-wfkdA8Hc7zA",
    place: "Near Erda, Utah",
    shortName: "Erda",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "UT",
    state: "Utah",
    difficulty: "explorer",
    pools: ["world","North America","US","US-UT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ut-058",
    lat: 40.554627,
    lng: -111.991457,
    panoId: "hdTwlbONTbl6zg1jTVVGYw",
    place: "Near South Jordan Heights, Utah",
    shortName: "South Jordan Heights",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "UT",
    state: "Utah",
    difficulty: "explorer",
    pools: ["world","North America","US","US-UT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ut-059",
    lat: 40.110636,
    lng: -111.73051,
    panoId: "qmoZz1srhfBbgJbK3Y9Qmg",
    place: "Near Benjamin, Utah",
    shortName: "Benjamin",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "UT",
    state: "Utah",
    difficulty: "explorer",
    pools: ["world","North America","US","US-UT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ut-060",
    lat: 37.041112,
    lng: -113.628055,
    panoId: "OnpYcLkJwTx20Tu-hgllOQ",
    place: "Near Saint George, Utah",
    shortName: "Saint George",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "UT",
    state: "Utah",
    difficulty: "explorer",
    pools: ["world","North America","US","US-UT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ut-061",
    lat: 41.07468,
    lng: -112.024833,
    panoId: "ne8zBRM7tk8wxJGqBRMY0w",
    place: "Near Syracuse, Utah",
    shortName: "Syracuse",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "UT",
    state: "Utah",
    difficulty: "explorer",
    pools: ["world","North America","US","US-UT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ut-062",
    lat: 40.355236,
    lng: -111.996537,
    panoId: "WjW1vVdgH4ye_nqTWU3MHQ",
    place: "Near Eagle Mountain, Utah",
    shortName: "Eagle Mountain",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "UT",
    state: "Utah",
    difficulty: "explorer",
    pools: ["world","North America","US","US-UT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ut-063",
    lat: 41.167541,
    lng: -112.068853,
    panoId: "Aea1GOjK0T4zCPNXWqinIw",
    place: "Near Clinton, Utah",
    shortName: "Clinton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "UT",
    state: "Utah",
    difficulty: "explorer",
    pools: ["world","North America","US","US-UT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ut-064",
    lat: 41.710266,
    lng: -111.881704,
    panoId: "ACo1LLwkU53aES8E2VO2jA",
    place: "Near Logan, Utah",
    shortName: "Logan",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "UT",
    state: "Utah",
    difficulty: "explorer",
    pools: ["world","North America","US","US-UT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ut-065",
    lat: 41.209293,
    lng: -112.010018,
    panoId: "DEgeEOt92efe1wF1U-1YJQ",
    place: "Near Ogden, Utah",
    shortName: "Ogden",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "UT",
    state: "Utah",
    difficulty: "explorer",
    pools: ["world","North America","US","US-UT"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-ut-066",
    lat: 41.022898,
    lng: -111.975621,
    panoId: "Np5lhL8eF7-eF_8BcueuQw",
    place: "Near Kaysville, Utah",
    shortName: "Kaysville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "UT",
    state: "Utah",
    difficulty: "explorer",
    pools: ["world","North America","US","US-UT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ut-067",
    lat: 40.592244,
    lng: -112.0998,
    panoId: "hAdRCBz_1-iE_LH1ZjwH0Q",
    place: "Near Oquirrh, Utah",
    shortName: "Oquirrh",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "UT",
    state: "Utah",
    difficulty: "explorer",
    pools: ["world","North America","US","US-UT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ut-068",
    lat: 40.432684,
    lng: -111.84656,
    panoId: "lxCIrKN3uLXeXHX2RCh5jQ",
    place: "Near Highland, Utah",
    shortName: "Highland",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "UT",
    state: "Utah",
    difficulty: "explorer",
    pools: ["world","North America","US","US-UT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ut-069",
    lat: 40.768145,
    lng: -111.710556,
    panoId: "wkFV3OR8puYjuzG7DuTYPw",
    place: "Near Summit Park, Utah",
    shortName: "Summit Park",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "UT",
    state: "Utah",
    difficulty: "explorer",
    pools: ["world","North America","US","US-UT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ut-070",
    lat: 40.474079,
    lng: -112.075106,
    panoId: "Pgm3whLWSU6eI9Hlf_dxRA",
    place: "Near Herriman, Utah",
    shortName: "Herriman",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "UT",
    state: "Utah",
    difficulty: "explorer",
    pools: ["world","North America","US","US-UT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ut-071",
    lat: 41.271785,
    lng: -112.147033,
    panoId: "UTHL03YYL-4TccqPPFGgeQ",
    place: "Near Plain City, Utah",
    shortName: "Plain City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "UT",
    state: "Utah",
    difficulty: "explorer",
    pools: ["world","North America","US","US-UT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ut-072",
    lat: 40.821618,
    lng: -111.953521,
    panoId: "u7snYAPjULX2B3TsKn-3kA",
    place: "Near North Salt Lake, Utah",
    shortName: "North Salt Lake",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "UT",
    state: "Utah",
    difficulty: "explorer",
    pools: ["world","North America","US","US-UT"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-ut-073",
    lat: 40.453415,
    lng: -111.890749,
    panoId: "1-ePeLDORfgzKheU4bPO2Q",
    place: "Near Bluffdale, Utah",
    shortName: "Bluffdale",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "UT",
    state: "Utah",
    difficulty: "explorer",
    pools: ["world","North America","US","US-UT"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-ut-074",
    lat: 41.529211,
    lng: -112.078574,
    panoId: "SHTIYesZAEoRMKZZyAk3Vw",
    place: "Near Brigham City, Utah",
    shortName: "Brigham City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "UT",
    state: "Utah",
    difficulty: "explorer",
    pools: ["world","North America","US","US-UT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ut-075",
    lat: 40.771355,
    lng: -112.073958,
    panoId: "7CvrLWjbXPIYaWzlMTj77g",
    place: "Near Magna, Utah",
    shortName: "Magna",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "UT",
    state: "Utah",
    difficulty: "explorer",
    pools: ["world","North America","US","US-UT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ut-076",
    lat: 41.195246,
    lng: -112.085865,
    panoId: "2yzvxuuJdJH2ScIhU2t4Vw",
    place: "Near West Haven, Utah",
    shortName: "West Haven",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "UT",
    state: "Utah",
    difficulty: "explorer",
    pools: ["world","North America","US","US-UT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ut-077",
    lat: 40.738358,
    lng: -111.742818,
    panoId: "AozqEuOO1n1nX4HaQvizDA",
    place: "Near Mount Olympus, Utah",
    shortName: "Mount Olympus",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "UT",
    state: "Utah",
    difficulty: "explorer",
    pools: ["world","North America","US","US-UT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ut-078",
    lat: 40.781276,
    lng: -112.016362,
    panoId: "nCJjnk1s-1efkym91qPOkQ",
    place: "Near West Valley City, Utah",
    shortName: "West Valley City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "UT",
    state: "Utah",
    difficulty: "explorer",
    pools: ["world","North America","US","US-UT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ut-079",
    lat: 41.105629,
    lng: -111.93645,
    panoId: "31zFtGJnIchlOO0qs9prZQ",
    place: "Near South Weber, Utah",
    shortName: "South Weber",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "UT",
    state: "Utah",
    difficulty: "explorer",
    pools: ["world","North America","US","US-UT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ut-080",
    lat: 39.900535,
    lng: -111.828133,
    panoId: "UhUKfLn0l8-KITWNjATXRg",
    place: "Near Santaquin, Utah",
    shortName: "Santaquin",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "UT",
    state: "Utah",
    difficulty: "explorer",
    pools: ["world","North America","US","US-UT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ut-081",
    lat: 40.349507,
    lng: -111.80174,
    panoId: "GZh_MnMP4xHlh13kwinzRw",
    place: "Near American Fork, Utah",
    shortName: "American Fork",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "UT",
    state: "Utah",
    difficulty: "explorer",
    pools: ["world","North America","US","US-UT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ut-082",
    lat: 40.421055,
    lng: -111.933211,
    panoId: "D5xyaklGkP4hI2JAKepMXA",
    place: "Near Bluffdale, Utah",
    shortName: "Bluffdale",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "UT",
    state: "Utah",
    difficulty: "explorer",
    pools: ["world","North America","US","US-UT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ut-083",
    lat: 39.584944,
    lng: -110.715268,
    panoId: "UA0nLb1zBYNSRHa9M2CH6w",
    place: "Near Wellington, Utah",
    shortName: "Wellington",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "UT",
    state: "Utah",
    difficulty: "explorer",
    pools: ["world","North America","US","US-UT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ut-084",
    lat: 37.200362,
    lng: -113.401372,
    panoId: "2-xIAZR5jUluPBWYkZlU3g",
    place: "Near Hurricane, Utah",
    shortName: "Hurricane",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "UT",
    state: "Utah",
    difficulty: "explorer",
    pools: ["world","North America","US","US-UT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ut-085",
    lat: 40.780514,
    lng: -111.855537,
    panoId: "CXFBeWHZMXt_OiucGurPvQ",
    place: "Near Salt Lake City, Utah",
    shortName: "Salt Lake City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "UT",
    state: "Utah",
    difficulty: "explorer",
    pools: ["world","North America","US","US-UT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ut-086",
    lat: 40.792529,
    lng: -111.923646,
    panoId: "W9smrxsXjqTmw0V8qQCcIQ",
    place: "Near Salt Lake City, Utah",
    shortName: "Salt Lake City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "UT",
    state: "Utah",
    difficulty: "explorer",
    pools: ["world","North America","US","US-UT"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-ut-087",
    lat: 40.780428,
    lng: -111.952883,
    panoId: "hQ5SWTMbvDeQpmD_lcyOCw",
    place: "Near Salt Lake City, Utah",
    shortName: "Salt Lake City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "UT",
    state: "Utah",
    difficulty: "explorer",
    pools: ["world","North America","US","US-UT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ut-088",
    lat: 40.101859,
    lng: -111.740047,
    panoId: "umSA6XLzwZR1174nCijHaA",
    place: "Near Benjamin, Utah",
    shortName: "Benjamin",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "UT",
    state: "Utah",
    difficulty: "explorer",
    pools: ["world","North America","US","US-UT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ut-089",
    lat: 40.361938,
    lng: -112.010493,
    panoId: "lVjU8sLMe7P4z2d7wxREIg",
    place: "Near Eagle Mountain, Utah",
    shortName: "Eagle Mountain",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "UT",
    state: "Utah",
    difficulty: "explorer",
    pools: ["world","North America","US","US-UT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ut-090",
    lat: 40.857298,
    lng: -111.840574,
    panoId: "S_07hGu1n1viBU-4Vyd9Sw",
    place: "Near Woods Cross, Utah",
    shortName: "Woods Cross",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "UT",
    state: "Utah",
    difficulty: "explorer",
    pools: ["world","North America","US","US-UT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ut-091",
    lat: 37.057539,
    lng: -113.585808,
    panoId: "WPyd-LCpJgWBlLqcgdL9UQ",
    place: "Near Saint George, Utah",
    shortName: "Saint George",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "UT",
    state: "Utah",
    difficulty: "explorer",
    pools: ["world","North America","US","US-UT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ut-092",
    lat: 37.592891,
    lng: -112.908103,
    panoId: "xnd_04D8a67oc8STY-yeUw",
    place: "Near Cedar City, Utah",
    shortName: "Cedar City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "UT",
    state: "Utah",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-UT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ut-093",
    lat: 39.974658,
    lng: -111.504295,
    panoId: "32gfDZwn5L3d2je88OKXBg",
    place: "Near Woodland Hills, Utah",
    shortName: "Woodland Hills",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "UT",
    state: "Utah",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-UT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ut-094",
    lat: 40.59177,
    lng: -111.631774,
    panoId: "XXzrzu7fVcfVMGW-VhlrMg",
    place: "Near Park City, Utah",
    shortName: "Park City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "UT",
    state: "Utah",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-UT"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-ut-095",
    lat: 40.994844,
    lng: -111.693953,
    panoId: "cyUzKjyyisidRMb-n4VywA",
    place: "Near Morgan, Utah",
    shortName: "Morgan",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "UT",
    state: "Utah",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-UT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ut-096",
    lat: 40.60452,
    lng: -111.348944,
    panoId: "x0MEs5s2cg-sCFgk_KHXMg",
    place: "Near Francis, Utah",
    shortName: "Francis",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "UT",
    state: "Utah",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-UT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-ut-097",
    lat: 41.654492,
    lng: -111.690689,
    panoId: "YgtjH6l6N9O1ae-pOEunwQ",
    place: "Near Millville, Utah",
    shortName: "Millville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "UT",
    state: "Utah",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-UT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-vt-000",
    lat: 44.475961,
    lng: -73.212047,
    panoId: "XbeBqgrMA8ZwbiSBHZ-o5A",
    place: "Near Burlington, Vermont",
    shortName: "Burlington",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VT",
    state: "Vermont",
    difficulty: "classic",
    pools: ["world","North America","US","US-VT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-vt-001",
    lat: 44.491372,
    lng: -73.185736,
    panoId: "C2DB6FZyZwGRf76_cXUHhg",
    place: "Near Winooski, Vermont",
    shortName: "Winooski",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VT",
    state: "Vermont",
    difficulty: "classic",
    pools: ["world","North America","US","US-VT"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-vt-002",
    lat: 44.425226,
    lng: -72.015091,
    panoId: "DN2Bjxf2CaX2KhBgjpBDqw",
    place: "Near St Johnsbury, Vermont",
    shortName: "St Johnsbury",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VT",
    state: "Vermont",
    difficulty: "classic",
    pools: ["world","North America","US","US-VT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-vt-003",
    lat: 43.61064,
    lng: -72.972588,
    panoId: "FuImMl8ZfS5oaL0KY69rqQ",
    place: "Near Rutland, Vermont",
    shortName: "Rutland",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VT",
    state: "Vermont",
    difficulty: "classic",
    pools: ["world","North America","US","US-VT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-vt-004",
    lat: 43.66056,
    lng: -72.338392,
    panoId: "NvhK4DUL7d0o--TRX4_o9A",
    place: "Near Hartford, Vermont",
    shortName: "Hartford",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VT",
    state: "Vermont",
    difficulty: "classic",
    pools: ["world","North America","US","US-VT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-vt-005",
    lat: 44.46694,
    lng: -73.170978,
    panoId: "2frC06kiQCT_EyC_GRlncA",
    place: "Near South Burlington, Vermont",
    shortName: "South Burlington",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VT",
    state: "Vermont",
    difficulty: "classic",
    pools: ["world","North America","US","US-VT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-vt-006",
    lat: 44.260058,
    lng: -72.575414,
    panoId: "6nLhav2i39Se5EW203tySg",
    place: "Near Montpelier, Vermont",
    shortName: "Montpelier",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VT",
    state: "Vermont",
    difficulty: "classic",
    pools: ["world","North America","US","US-VT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-vt-007",
    lat: 42.830406,
    lng: -72.567898,
    panoId: "iYizagEwKXX7V7dAFKjPbw",
    place: "Near White River Junction VA Medical Center, Vermont",
    shortName: "White River Junction VA Medical Center",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VT",
    state: "Vermont",
    difficulty: "classic",
    pools: ["world","North America","US","US-VT"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-vt-008",
    lat: 44.54391,
    lng: -73.147945,
    panoId: "V_Srcbi_Zgkeosa-xAcusA",
    place: "Near Colchester, Vermont",
    shortName: "Colchester",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VT",
    state: "Vermont",
    difficulty: "classic",
    pools: ["world","North America","US","US-VT"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-vt-009",
    lat: 44.514127,
    lng: -72.010974,
    panoId: "iUz_fCSceTyzPRqi_mV7tQ",
    place: "Near Lyndon, Vermont",
    shortName: "Lyndon",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VT",
    state: "Vermont",
    difficulty: "classic",
    pools: ["world","North America","US","US-VT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-vt-010",
    lat: 44.810858,
    lng: -73.083463,
    panoId: "iSt0MSKqM8hhARxQv-1pIA",
    place: "Near Saint Albans, Vermont",
    shortName: "Saint Albans",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VT",
    state: "Vermont",
    difficulty: "classic",
    pools: ["world","North America","US","US-VT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-vt-011",
    lat: 44.490636,
    lng: -73.110954,
    panoId: "SL1pw1BLLkozChQ1SIIWCw",
    place: "Near Essex Junction, Vermont",
    shortName: "Essex Junction",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VT",
    state: "Vermont",
    difficulty: "classic",
    pools: ["world","North America","US","US-VT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-vt-012",
    lat: 44.437586,
    lng: -73.068099,
    panoId: "VTFwq5KCsW8SXWa16z_UTQ",
    place: "Near Williston, Vermont",
    shortName: "Williston",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VT",
    state: "Vermont",
    difficulty: "classic",
    pools: ["world","North America","US","US-VT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-vt-013",
    lat: 44.55718,
    lng: -72.623757,
    panoId: "-fhi8-yPqxFrS5Q2yk0zBA",
    place: "Near Morristown, Vermont",
    shortName: "Morristown",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VT",
    state: "Vermont",
    difficulty: "classic",
    pools: ["world","North America","US","US-VT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-vt-014",
    lat: 42.878268,
    lng: -73.196693,
    panoId: "9EDAYE2QHzHJWLMeKaE8IA",
    place: "Near Bennington, Vermont",
    shortName: "Bennington",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VT",
    state: "Vermont",
    difficulty: "classic",
    pools: ["world","North America","US","US-VT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-vt-015",
    lat: 43.648994,
    lng: -72.319315,
    panoId: "PfKdk0E9ON_3_yhYTvgKFg",
    place: "Near White River Junction, Vermont",
    shortName: "White River Junction",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VT",
    state: "Vermont",
    difficulty: "classic",
    pools: ["world","North America","US","US-VT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-vt-016",
    lat: 42.850745,
    lng: -72.557906,
    panoId: "Li-Sj7qoDFPAoEW6ijogaw",
    place: "Near Brattleboro, Vermont",
    shortName: "Brattleboro",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VT",
    state: "Vermont",
    difficulty: "classic",
    pools: ["world","North America","US","US-VT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-vt-017",
    lat: 44.196952,
    lng: -72.502259,
    panoId: "eoiWXUcEMpDosmHqhL1x4A",
    place: "Near Barre, Vermont",
    shortName: "Barre",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VT",
    state: "Vermont",
    difficulty: "classic",
    pools: ["world","North America","US","US-VT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-vt-018",
    lat: 44.015765,
    lng: -73.169511,
    panoId: "GOjeEdkpnopFRYfgzhk9Uw",
    place: "Near Middlebury (village), Vermont",
    shortName: "Middlebury (village)",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VT",
    state: "Vermont",
    difficulty: "classic",
    pools: ["world","North America","US","US-VT"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-vt-019",
    lat: 43.187612,
    lng: -72.489246,
    panoId: "h1OU4dVBamlA5d75SAcQig",
    place: "Near Rockingham, Vermont",
    shortName: "Rockingham",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VT",
    state: "Vermont",
    difficulty: "classic",
    pools: ["world","North America","US","US-VT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-vt-020",
    lat: 44.561684,
    lng: -72.598497,
    panoId: "2OIVjLAB2eFbtnbwUvs0gQ",
    place: "Near Morrisville, Vermont",
    shortName: "Morrisville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VT",
    state: "Vermont",
    difficulty: "classic",
    pools: ["world","North America","US","US-VT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-vt-021",
    lat: 43.675377,
    lng: -72.346603,
    panoId: "6XM9paOirhlrxRVDJOOLZA",
    place: "Near Hartford, Vermont",
    shortName: "Hartford",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VT",
    state: "Vermont",
    difficulty: "classic",
    pools: ["world","North America","US","US-VT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-vt-022",
    lat: 44.505881,
    lng: -73.085894,
    panoId: "K17s-m5_w1tfagb3dX-lWg",
    place: "Near Essex Junction, Vermont",
    shortName: "Essex Junction",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VT",
    state: "Vermont",
    difficulty: "classic",
    pools: ["world","North America","US","US-VT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-vt-023",
    lat: 42.879152,
    lng: -73.169095,
    panoId: "U_d88xbf-junsVGgoM76LQ",
    place: "Near Bennington, Vermont",
    shortName: "Bennington",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VT",
    state: "Vermont",
    difficulty: "classic",
    pools: ["world","North America","US","US-VT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-vt-024",
    lat: 44.501145,
    lng: -73.171062,
    panoId: "uA8jzUZFmSPr8RfaCt-RWw",
    place: "Near Winooski, Vermont",
    shortName: "Winooski",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VT",
    state: "Vermont",
    difficulty: "classic",
    pools: ["world","North America","US","US-VT"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-vt-025",
    lat: 44.279263,
    lng: -72.570897,
    panoId: "uspSxtcc6UofnPow9u_cOg",
    place: "Near Montpelier, Vermont",
    shortName: "Montpelier",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VT",
    state: "Vermont",
    difficulty: "classic",
    pools: ["world","North America","US","US-VT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-vt-026",
    lat: 44.40701,
    lng: -72.019298,
    panoId: "79hJyisr4p0Vsh3HsRq9Ug",
    place: "Near Saint Johnsbury, Vermont",
    shortName: "Saint Johnsbury",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VT",
    state: "Vermont",
    difficulty: "classic",
    pools: ["world","North America","US","US-VT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-vt-027",
    lat: 44.430421,
    lng: -71.999422,
    panoId: "TkqSVDONZo_DHt9vzCNGiw",
    place: "Near St Johnsbury, Vermont",
    shortName: "St Johnsbury",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VT",
    state: "Vermont",
    difficulty: "classic",
    pools: ["world","North America","US","US-VT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-vt-028",
    lat: 43.620802,
    lng: -72.986863,
    panoId: "6p6KAFk9GTbGdhaeAckbjg",
    place: "Near Rutland, Vermont",
    shortName: "Rutland",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VT",
    state: "Vermont",
    difficulty: "classic",
    pools: ["world","North America","US","US-VT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-vt-029",
    lat: 44.510126,
    lng: -73.174259,
    panoId: "xcNJ4P3xsHDmWv__vC5RTQ",
    place: "Near Winooski, Vermont",
    shortName: "Winooski",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VT",
    state: "Vermont",
    difficulty: "classic",
    pools: ["world","North America","US","US-VT"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-vt-030",
    lat: 44.454722,
    lng: -73.199088,
    panoId: "NKfnBjmg5dQNR6MuLCw2hQ",
    place: "Near Burlington, Vermont",
    shortName: "Burlington",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VT",
    state: "Vermont",
    difficulty: "classic",
    pools: ["world","North America","US","US-VT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-vt-031",
    lat: 44.430742,
    lng: -72.038711,
    panoId: "46R7xoHTWS2wvdqxB8WwWw",
    place: "Near St Johnsbury, Vermont",
    shortName: "St Johnsbury",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VT",
    state: "Vermont",
    difficulty: "classic",
    pools: ["world","North America","US","US-VT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-vt-032",
    lat: 42.867758,
    lng: -72.557802,
    panoId: "DLOHTNY2Aif6s7vELPBxrQ",
    place: "Near Brattleboro, Vermont",
    shortName: "Brattleboro",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VT",
    state: "Vermont",
    difficulty: "classic",
    pools: ["world","North America","US","US-VT"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-vt-033",
    lat: 44.465317,
    lng: -72.68463,
    panoId: "c9CTVUz0LfPIRBGD5I0F-w",
    place: "Near Stowe, Vermont",
    shortName: "Stowe",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VT",
    state: "Vermont",
    difficulty: "explorer",
    pools: ["world","North America","US","US-VT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-vt-034",
    lat: 42.765628,
    lng: -73.235981,
    panoId: "YGfq9H1GGuCtOimjlWVE7Q",
    place: "Near Pownal, Vermont",
    shortName: "Pownal",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VT",
    state: "Vermont",
    difficulty: "explorer",
    pools: ["world","North America","US","US-VT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-vt-035",
    lat: 43.262823,
    lng: -72.595068,
    panoId: "uY2VsmdN7PxXK16enjwKbg",
    place: "Near Chester, Vermont",
    shortName: "Chester",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VT",
    state: "Vermont",
    difficulty: "explorer",
    pools: ["world","North America","US","US-VT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-vt-036",
    lat: 44.150721,
    lng: -72.656515,
    panoId: "b3auQn2UkrvKJ8Pd1Ygupw",
    place: "Near Northfield, Vermont",
    shortName: "Northfield",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VT",
    state: "Vermont",
    difficulty: "explorer",
    pools: ["world","North America","US","US-VT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-vt-037",
    lat: 44.32925,
    lng: -73.110294,
    panoId: "9x7NGMLqQeW-etQpjZcpZw",
    place: "Near Hinesburg, Vermont",
    shortName: "Hinesburg",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VT",
    state: "Vermont",
    difficulty: "explorer",
    pools: ["world","North America","US","US-VT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-vt-038",
    lat: 44.918075,
    lng: -73.12437,
    panoId: "Sm8q_cCT6-gpBOksVrFZJw",
    place: "Near Swanton, Vermont",
    shortName: "Swanton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VT",
    state: "Vermont",
    difficulty: "explorer",
    pools: ["world","North America","US","US-VT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-vt-039",
    lat: 43.298458,
    lng: -72.482,
    panoId: "GDiKfaoYzpeDgX9fEZvxrg",
    place: "Near Springfield, Vermont",
    shortName: "Springfield",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VT",
    state: "Vermont",
    difficulty: "explorer",
    pools: ["world","North America","US","US-VT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-vt-040",
    lat: 43.176994,
    lng: -73.056968,
    panoId: "MNWXFFVbHQ2zRSYNnnh5BA",
    place: "Near Manchester Center, Vermont",
    shortName: "Manchester Center",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VT",
    state: "Vermont",
    difficulty: "explorer",
    pools: ["world","North America","US","US-VT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-vt-041",
    lat: 43.594863,
    lng: -73.265663,
    panoId: "GnTziU6zNLge_uumqvIf3w",
    place: "Near Fair Haven, Vermont",
    shortName: "Fair Haven",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VT",
    state: "Vermont",
    difficulty: "explorer",
    pools: ["world","North America","US","US-VT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-vt-042",
    lat: 44.205578,
    lng: -73.246196,
    panoId: "0BwRcaE7Xxd_0Vu-sK0jrg",
    place: "Near Ferrisburgh, Vermont",
    shortName: "Ferrisburgh",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VT",
    state: "Vermont",
    difficulty: "explorer",
    pools: ["world","North America","US","US-VT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-vt-043",
    lat: 44.167279,
    lng: -73.254131,
    panoId: "O_r-EpWm_E67ToZok2Ssag",
    place: "Near Vergennes, Vermont",
    shortName: "Vergennes",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VT",
    state: "Vermont",
    difficulty: "explorer",
    pools: ["world","North America","US","US-VT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-vt-044",
    lat: 44.936399,
    lng: -72.205085,
    panoId: "ou18u0W5jHho08amLfhmbg",
    place: "Near Newport, Vermont",
    shortName: "Newport",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VT",
    state: "Vermont",
    difficulty: "explorer",
    pools: ["world","North America","US","US-VT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-vt-045",
    lat: 43.13344,
    lng: -72.44399,
    panoId: "M0B595D5CR7J3L-oslQElw",
    place: "Near Bellows Falls, Vermont",
    shortName: "Bellows Falls",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VT",
    state: "Vermont",
    difficulty: "explorer",
    pools: ["world","North America","US","US-VT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-vt-046",
    lat: 44.309693,
    lng: -73.26097,
    panoId: "2ZAqMSKYIXxEyJ90ACrIEw",
    place: "Near Charlotte, Vermont",
    shortName: "Charlotte",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VT",
    state: "Vermont",
    difficulty: "explorer",
    pools: ["world","North America","US","US-VT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-vt-047",
    lat: 42.855809,
    lng: -72.603145,
    panoId: "_ob9xhnyRTiEhHq29zZ7OQ",
    place: "Near West Brattleboro, Vermont",
    shortName: "West Brattleboro",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VT",
    state: "Vermont",
    difficulty: "explorer",
    pools: ["world","North America","US","US-VT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-vt-048",
    lat: 44.133275,
    lng: -73.078986,
    panoId: "QuQy8XE9B2ppafwknwbKpg",
    place: "Near Bristol, Vermont",
    shortName: "Bristol",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VT",
    state: "Vermont",
    difficulty: "explorer",
    pools: ["world","North America","US","US-VT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-vt-049",
    lat: 43.480323,
    lng: -72.384831,
    panoId: "2ULHo_Wu7XXOX0ATTsh4Ng",
    place: "Near Windsor, Vermont",
    shortName: "Windsor",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VT",
    state: "Vermont",
    difficulty: "explorer",
    pools: ["world","North America","US","US-VT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-vt-050",
    lat: 43.162465,
    lng: -73.082412,
    panoId: "pyhQcKvArG54rX4JPgtEiw",
    place: "Near Manchester Center, Vermont",
    shortName: "Manchester Center",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VT",
    state: "Vermont",
    difficulty: "explorer",
    pools: ["world","North America","US","US-VT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-vt-051",
    lat: 43.593138,
    lng: -73.045034,
    panoId: "KqdBqPvBOwQ6avF8pvdjCg",
    place: "Near West Rutland, Vermont",
    shortName: "West Rutland",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VT",
    state: "Vermont",
    difficulty: "explorer",
    pools: ["world","North America","US","US-VT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-vt-052",
    lat: 43.247388,
    lng: -72.603647,
    panoId: "GlDODZ3vlDa6gao7YJPPLA",
    place: "Near Chester, Vermont",
    shortName: "Chester",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VT",
    state: "Vermont",
    difficulty: "explorer",
    pools: ["world","North America","US","US-VT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-vt-053",
    lat: 42.750503,
    lng: -73.211559,
    panoId: "rwk7mLopY-eyjF5ui3gDYA",
    place: "Near Pownal, Vermont",
    shortName: "Pownal",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VT",
    state: "Vermont",
    difficulty: "explorer",
    pools: ["world","North America","US","US-VT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-vt-054",
    lat: 44.045335,
    lng: -73.162959,
    panoId: "-cnCL-LVi2ALPC0FtrJhUw",
    place: "Near Middlebury (village), Vermont",
    shortName: "Middlebury (village)",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VT",
    state: "Vermont",
    difficulty: "explorer",
    pools: ["world","North America","US","US-VT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-vt-055",
    lat: 44.133439,
    lng: -73.216468,
    panoId: "iVQrhh1-hhB6skboVxHenQ",
    place: "Near Vergennes, Vermont",
    shortName: "Vergennes",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VT",
    state: "Vermont",
    difficulty: "explorer",
    pools: ["world","North America","US","US-VT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-vt-056",
    lat: 44.528712,
    lng: -73.254727,
    panoId: "XdH1ANwAQidBCVwZcWWj0A",
    place: "Near Burlington, Vermont",
    shortName: "Burlington",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VT",
    state: "Vermont",
    difficulty: "explorer",
    pools: ["world","North America","US","US-VT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-vt-057",
    lat: 43.634627,
    lng: -73.002023,
    panoId: "Z-LVzuQTaC2jACmY9OeRdA",
    place: "Near Rutland, Vermont",
    shortName: "Rutland",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VT",
    state: "Vermont",
    difficulty: "explorer",
    pools: ["world","North America","US","US-VT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-vt-058",
    lat: 43.292252,
    lng: -72.512959,
    panoId: "tEucX2P5h19pnl8oej9K5w",
    place: "Near Springfield, Vermont",
    shortName: "Springfield",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VT",
    state: "Vermont",
    difficulty: "explorer",
    pools: ["world","North America","US","US-VT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-vt-059",
    lat: 42.788004,
    lng: -72.53098,
    panoId: "QuFPu_3KrBCgOPQX-FkkcQ",
    place: "Near Hinsdale, Vermont",
    shortName: "Hinsdale",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VT",
    state: "Vermont",
    difficulty: "explorer",
    pools: ["world","North America","US","US-VT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-vt-060",
    lat: 43.577129,
    lng: -73.205164,
    panoId: "W__a7LuM-yhfI3f0L3Mq6g",
    place: "Near Castleton, Vermont",
    shortName: "Castleton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VT",
    state: "Vermont",
    difficulty: "explorer",
    pools: ["world","North America","US","US-VT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-vt-061",
    lat: 43.157741,
    lng: -72.446282,
    panoId: "VPAHYe4dUkCCueysCC7AVw",
    place: "Near Bellows Falls, Vermont",
    shortName: "Bellows Falls",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VT",
    state: "Vermont",
    difficulty: "explorer",
    pools: ["world","North America","US","US-VT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-vt-062",
    lat: 44.908313,
    lng: -72.177597,
    panoId: "Zpo8hpC8IxO7J_ufprHnGg",
    place: "Near Newport, Vermont",
    shortName: "Newport",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VT",
    state: "Vermont",
    difficulty: "explorer",
    pools: ["world","North America","US","US-VT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-vt-063",
    lat: 42.851909,
    lng: -72.641833,
    panoId: "dU-XmbhKkH1UM-6zAvk55w",
    place: "Near West Brattleboro, Vermont",
    shortName: "West Brattleboro",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VT",
    state: "Vermont",
    difficulty: "explorer",
    pools: ["world","North America","US","US-VT"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-vt-064",
    lat: 44.267308,
    lng: -73.23277,
    panoId: "I6IcOls7CkMS_S-y0GuK-w",
    place: "Near Charlotte, Vermont",
    shortName: "Charlotte",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VT",
    state: "Vermont",
    difficulty: "explorer",
    pools: ["world","North America","US","US-VT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-vt-065",
    lat: 44.176245,
    lng: -72.714426,
    panoId: "dVjrkndkE1yyA665Qhu28Q",
    place: "Near Northfield, Vermont",
    shortName: "Northfield",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VT",
    state: "Vermont",
    difficulty: "explorer",
    pools: ["world","North America","US","US-VT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-vt-066",
    lat: 44.15454,
    lng: -72.438786,
    panoId: "B8fja50d6_Dwx5oxFDuyww",
    place: "Near Washington, Vermont",
    shortName: "Washington",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VT",
    state: "Vermont",
    difficulty: "explorer",
    pools: ["world","North America","US","US-VT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-vt-067",
    lat: 43.230079,
    lng: -73.024938,
    panoId: "32zMPA_jAKCz6lJKCM0fOg",
    place: "Near Manchester Center, Vermont",
    shortName: "Manchester Center",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VT",
    state: "Vermont",
    difficulty: "explorer",
    pools: ["world","North America","US","US-VT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-vt-068",
    lat: 43.236337,
    lng: -72.497858,
    panoId: "4E4dVabGl6839m2o8R4NBQ",
    place: "Near Rockingham, Vermont",
    shortName: "Rockingham",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VT",
    state: "Vermont",
    difficulty: "explorer",
    pools: ["world","North America","US","US-VT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-vt-069",
    lat: 44.904644,
    lng: -73.165743,
    panoId: "-9nkcRblfLokqLLL4xPI4A",
    place: "Near Swanton, Vermont",
    shortName: "Swanton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VT",
    state: "Vermont",
    difficulty: "explorer",
    pools: ["world","North America","US","US-VT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-vt-070",
    lat: 43.55143,
    lng: -72.963703,
    panoId: "g9LNTknh3OtJWcxzyRL0Zg",
    place: "Near Clarendon, Vermont",
    shortName: "Clarendon",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VT",
    state: "Vermont",
    difficulty: "explorer",
    pools: ["world","North America","US","US-VT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-vt-071",
    lat: 44.601681,
    lng: -72.53304,
    panoId: "paJVl1x45lDh7S3UMvaVHA",
    place: "Near Hyde Park, Vermont",
    shortName: "Hyde Park",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VT",
    state: "Vermont",
    difficulty: "explorer",
    pools: ["world","North America","US","US-VT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-vt-072",
    lat: 44.375852,
    lng: -73.146914,
    panoId: "19qPp1D3PCOtIck0-ychQg",
    place: "Near Hinesburg, Vermont",
    shortName: "Hinesburg",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VT",
    state: "Vermont",
    difficulty: "explorer",
    pools: ["world","North America","US","US-VT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-vt-073",
    lat: 44.581023,
    lng: -73.161644,
    panoId: "QOvCtheTCYqQFj29ufk-Og",
    place: "Near Colchester, Vermont",
    shortName: "Colchester",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VT",
    state: "Vermont",
    difficulty: "explorer",
    pools: ["world","North America","US","US-VT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-vt-074",
    lat: 44.191672,
    lng: -73.174322,
    panoId: "r-RS6ycflraCvMCoL7Qu8A",
    place: "Near Ferrisburgh, Vermont",
    shortName: "Ferrisburgh",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VT",
    state: "Vermont",
    difficulty: "explorer",
    pools: ["world","North America","US","US-VT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-vt-075",
    lat: 44.124912,
    lng: -73.129323,
    panoId: "nUlntXUqtrXIiHbDyLQaEQ",
    place: "Near Bristol, Vermont",
    shortName: "Bristol",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VT",
    state: "Vermont",
    difficulty: "explorer",
    pools: ["world","North America","US","US-VT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-vt-076",
    lat: 42.897541,
    lng: -72.539745,
    panoId: "IszYkVz-PDjIn7SItw7hBw",
    place: "Near Brattleboro, Vermont",
    shortName: "Brattleboro",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VT",
    state: "Vermont",
    difficulty: "explorer",
    pools: ["world","North America","US","US-VT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-vt-077",
    lat: 43.16736,
    lng: -72.444115,
    panoId: "I9vkzy8Yl06OngLGSi5C6Q",
    place: "Near Bellows Falls, Vermont",
    shortName: "Bellows Falls",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VT",
    state: "Vermont",
    difficulty: "explorer",
    pools: ["world","North America","US","US-VT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-vt-078",
    lat: 44.426786,
    lng: -73.117651,
    panoId: "i9YktVKYdxiSHwXSp-95Eg",
    place: "Near Williston, Vermont",
    shortName: "Williston",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VT",
    state: "Vermont",
    difficulty: "explorer",
    pools: ["world","North America","US","US-VT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-vt-079",
    lat: 42.875215,
    lng: -73.157873,
    panoId: "txpXhl21GA3neckQNAiQLw",
    place: "Near Bennington, Vermont",
    shortName: "Bennington",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VT",
    state: "Vermont",
    difficulty: "explorer",
    pools: ["world","North America","US","US-VT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-vt-080",
    lat: 44.430567,
    lng: -73.193222,
    panoId: "1-Uwq554Q6p6tvD3RZ1XbA",
    place: "Near South Burlington, Vermont",
    shortName: "South Burlington",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VT",
    state: "Vermont",
    difficulty: "explorer",
    pools: ["world","North America","US","US-VT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-vt-081",
    lat: 43.614299,
    lng: -72.346275,
    panoId: "Lw_f1VbOce0DQmKYGkV5Ag",
    place: "Near White River Junction, Vermont",
    shortName: "White River Junction",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VT",
    state: "Vermont",
    difficulty: "explorer",
    pools: ["world","North America","US","US-VT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-vt-082",
    lat: 43.593566,
    lng: -72.354577,
    panoId: "zQ5e7qGzVSOOxM1D95mcGQ",
    place: "Near White River Junction, Vermont",
    shortName: "White River Junction",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VT",
    state: "Vermont",
    difficulty: "explorer",
    pools: ["world","North America","US","US-VT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-vt-083",
    lat: 44.692912,
    lng: -72.469524,
    panoId: "qx5sSSXw6-SrVpLFTBQIxA",
    place: "Near Hyde Park, Vermont",
    shortName: "Hyde Park",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VT",
    state: "Vermont",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-VT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-vt-084",
    lat: 44.641139,
    lng: -72.153775,
    panoId: "WMPb4HmExBxkEZ85HBbrvg",
    place: "Near Lyndonville, Vermont",
    shortName: "Lyndonville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VT",
    state: "Vermont",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-VT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-vt-085",
    lat: 44.673174,
    lng: -72.884675,
    panoId: "mycud_OcNNSqmWI4HWUt3Q",
    place: "Near Johnson, Vermont",
    shortName: "Johnson",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VT",
    state: "Vermont",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-VT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-vt-086",
    lat: 43.740067,
    lng: -72.494775,
    panoId: "kvzcqN2AwL1UmscPSpkT-w",
    place: "Near Woodstock, Vermont",
    shortName: "Woodstock",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VT",
    state: "Vermont",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-VT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-vt-087",
    lat: 43.242369,
    lng: -73.390636,
    panoId: "6bgV8FvdbaRA6sl7ZwtvDw",
    place: "Near Hartford, Vermont",
    shortName: "Hartford",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VT",
    state: "Vermont",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-VT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-vt-088",
    lat: 42.972012,
    lng: -73.49604,
    panoId: "P0kP_p3imLzO3_PQ0Zzvkg",
    place: "Near Cambridge, Vermont",
    shortName: "Cambridge",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VT",
    state: "Vermont",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-VT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-vt-089",
    lat: 44.527402,
    lng: -71.812016,
    panoId: "iuOH1yVZZ8xXKvRzrFSbDA",
    place: "Near Lunenburg, Vermont",
    shortName: "Lunenburg",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VT",
    state: "Vermont",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-VT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-vt-090",
    lat: 43.774976,
    lng: -72.777963,
    panoId: "7iBq8zvZd-hvHpPo920eKw",
    place: "Near Chittenden, Vermont",
    shortName: "Chittenden",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VT",
    state: "Vermont",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-VT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-vt-091",
    lat: 43.699108,
    lng: -73.149403,
    panoId: "JEDr3aOlCP0Vv4HJVQ9AYA",
    place: "Near Castleton, Vermont",
    shortName: "Castleton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VT",
    state: "Vermont",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-VT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-vt-092",
    lat: 42.779466,
    lng: -72.827974,
    panoId: "jvyrD0gwXp3PXmvTIy6TzQ",
    place: "Near Colrain, Vermont",
    shortName: "Colrain",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VT",
    state: "Vermont",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-VT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-va-000",
    lat: 37.413654,
    lng: -79.142225,
    panoId: "q6xWzrSD9bq1SFbTbgHAPg",
    place: "Near Lynchburg, Virginia",
    shortName: "Lynchburg",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VA",
    state: "Virginia",
    difficulty: "classic",
    pools: ["world","North America","US","US-VA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-va-001",
    lat: 38.449488,
    lng: -78.868595,
    panoId: "n2-gRE1dM6kY6Aw5F4WABQ",
    place: "Near Harrisonburg, Virginia",
    shortName: "Harrisonburg",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VA",
    state: "Virginia",
    difficulty: "classic",
    pools: ["world","North America","US","US-VA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-va-002",
    lat: 39.043747,
    lng: -77.48743,
    panoId: "9EuHELCWCM9MwaUpzuyHBg",
    place: "Near Ashburn, Virginia",
    shortName: "Ashburn",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VA",
    state: "Virginia",
    difficulty: "classic",
    pools: ["world","North America","US","US-VA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-va-003",
    lat: 36.821337,
    lng: -76.368651,
    panoId: "2AEvxW1K6F5VhCNpTgkkTw",
    place: "Near Portsmouth Heights, Virginia",
    shortName: "Portsmouth Heights",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VA",
    state: "Virginia",
    difficulty: "classic",
    pools: ["world","North America","US","US-VA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-va-004",
    lat: 38.029526,
    lng: -78.476552,
    panoId: "3-n7qZA4_qZxhEgii_h9Hg",
    place: "Near Charlottesville, Virginia",
    shortName: "Charlottesville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VA",
    state: "Virginia",
    difficulty: "classic",
    pools: ["world","North America","US","US-VA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-va-005",
    lat: 36.853149,
    lng: -75.97806,
    panoId: "HZjyF6Wo-WX5J2UX4F7k8g",
    place: "Near Virginia Beach, Virginia",
    shortName: "Virginia Beach",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VA",
    state: "Virginia",
    difficulty: "classic",
    pools: ["world","North America","US","US-VA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-va-006",
    lat: 37.55366,
    lng: -77.460474,
    panoId: "Mj5BvScSaj47bmJPJqzMhQ",
    place: "Near Richmond, Virginia",
    shortName: "Richmond",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VA",
    state: "Virginia",
    difficulty: "classic",
    pools: ["world","North America","US","US-VA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-va-007",
    lat: 37.229452,
    lng: -80.414056,
    panoId: "B-Fvu9oDigrX-QpEJ8lK_w",
    place: "Near Blacksburg, Virginia",
    shortName: "Blacksburg",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VA",
    state: "Virginia",
    difficulty: "classic",
    pools: ["world","North America","US","US-VA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-va-008",
    lat: 37.037502,
    lng: -76.33157,
    panoId: "J9KSydzzzaMK_Tjn1JyE0g",
    place: "Near East Hampton, Virginia",
    shortName: "East Hampton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VA",
    state: "Virginia",
    difficulty: "classic",
    pools: ["world","North America","US","US-VA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-va-009",
    lat: 36.717121,
    lng: -76.590185,
    panoId: "EK8KelnwsYE6IsjDkXFV9g",
    place: "Near South Suffolk, Virginia",
    shortName: "South Suffolk",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VA",
    state: "Virginia",
    difficulty: "classic",
    pools: ["world","North America","US","US-VA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-va-010",
    lat: 38.881135,
    lng: -77.104299,
    panoId: "ICJfwLiJrFBG6f2ODC5_eA",
    place: "Near Arlington, Virginia",
    shortName: "Arlington",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VA",
    state: "Virginia",
    difficulty: "classic",
    pools: ["world","North America","US","US-VA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-va-011",
    lat: 38.14996,
    lng: -79.072677,
    panoId: "TzRbIrXM0jRSCtvkHfUwTA",
    place: "Near Staunton, Virginia",
    shortName: "Staunton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VA",
    state: "Virginia",
    difficulty: "classic",
    pools: ["world","North America","US","US-VA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-va-012",
    lat: 39.185657,
    lng: -78.163433,
    panoId: "2AlkKzAndbpuN1iJ-2FrzA",
    place: "Near Winchester, Virginia",
    shortName: "Winchester",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VA",
    state: "Virginia",
    difficulty: "classic",
    pools: ["world","North America","US","US-VA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-va-013",
    lat: 38.750916,
    lng: -77.475143,
    panoId: "cSRJaoA8l8zB3XcjLQAy2w",
    place: "Near Manassas, Virginia",
    shortName: "Manassas",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VA",
    state: "Virginia",
    difficulty: "classic",
    pools: ["world","North America","US","US-VA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-va-014",
    lat: 36.846791,
    lng: -76.285215,
    panoId: "irRxS6P5N4ZiWrOtdA2i3A",
    place: "Near Norfolk, Virginia",
    shortName: "Norfolk",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VA",
    state: "Virginia",
    difficulty: "classic",
    pools: ["world","North America","US","US-VA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-va-015",
    lat: 38.759896,
    lng: -77.575118,
    panoId: "OKoCqvTCJW88DRHqMw_MTQ",
    place: "Near Linton Hall, Virginia",
    shortName: "Linton Hall",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VA",
    state: "Virginia",
    difficulty: "classic",
    pools: ["world","North America","US","US-VA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-va-016",
    lat: 39.115267,
    lng: -77.56384,
    panoId: "PK24lAL0vJ2e3uBGukWZ1g",
    place: "Near Leesburg, Virginia",
    shortName: "Leesburg",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VA",
    state: "Virginia",
    difficulty: "classic",
    pools: ["world","North America","US","US-VA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-va-017",
    lat: 36.585987,
    lng: -79.394951,
    panoId: "slv0JKDe5D9DuRjlsgcavg",
    place: "Near Danville, Virginia",
    shortName: "Danville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VA",
    state: "Virginia",
    difficulty: "classic",
    pools: ["world","North America","US","US-VA"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-va-018",
    lat: 36.728341,
    lng: -76.584806,
    panoId: "B3zFuXvZBTxEZoCBmy1q2Q",
    place: "Near Suffolk, Virginia",
    shortName: "Suffolk",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VA",
    state: "Virginia",
    difficulty: "classic",
    pools: ["world","North America","US","US-VA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-va-019",
    lat: 38.804865,
    lng: -77.04694,
    panoId: "7vh812U1WTC4FEV5WZ0oVQ",
    place: "Near Alexandria, Virginia",
    shortName: "Alexandria",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VA",
    state: "Virginia",
    difficulty: "classic",
    pools: ["world","North America","US","US-VA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-va-020",
    lat: 37.029829,
    lng: -76.345305,
    panoId: "Qe_Ug8v_tqMS_SxYTjsQ2w",
    place: "Near Hampton, Virginia",
    shortName: "Hampton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VA",
    state: "Virginia",
    difficulty: "classic",
    pools: ["world","North America","US","US-VA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-va-021",
    lat: 37.650425,
    lng: -77.612558,
    panoId: "sKZWLDWDqR0lcvG0bXnJmw",
    place: "Near Short Pump, Virginia",
    shortName: "Short Pump",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VA",
    state: "Virginia",
    difficulty: "classic",
    pools: ["world","North America","US","US-VA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-va-022",
    lat: 37.608751,
    lng: -77.373404,
    panoId: "0B-NycZA9009CqWoxNM5NA",
    place: "Near Mechanicsville, Virginia",
    shortName: "Mechanicsville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VA",
    state: "Virginia",
    difficulty: "classic",
    pools: ["world","North America","US","US-VA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-va-023",
    lat: 38.921095,
    lng: -77.503814,
    panoId: "vdcRf6MkobP_KlZsZ0G7EA",
    place: "Near South Riding, Virginia",
    shortName: "South Riding",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VA",
    state: "Virginia",
    difficulty: "classic",
    pools: ["world","North America","US","US-VA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-va-024",
    lat: 37.228059,
    lng: -77.401922,
    panoId: "xjBXAzJIjdZ_96L4tjiukg",
    place: "Near Petersburg, Virginia",
    shortName: "Petersburg",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VA",
    state: "Virginia",
    difficulty: "classic",
    pools: ["world","North America","US","US-VA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-va-025",
    lat: 37.293499,
    lng: -80.054716,
    panoId: "161MR2cBfn88DfWV00ZgsA",
    place: "Near Salem, Virginia",
    shortName: "Salem",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VA",
    state: "Virginia",
    difficulty: "classic",
    pools: ["world","North America","US","US-VA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-va-026",
    lat: 37.304417,
    lng: -77.287168,
    panoId: "hgDiD23LdTP2HF3obZBFvg",
    place: "Near Hopewell, Virginia",
    shortName: "Hopewell",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VA",
    state: "Virginia",
    difficulty: "classic",
    pools: ["world","North America","US","US-VA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-va-027",
    lat: 36.83544,
    lng: -76.298253,
    panoId: "DC6R0_shQphNiwt554eXiQ",
    place: "Near Portsmouth, Virginia",
    shortName: "Portsmouth",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VA",
    state: "Virginia",
    difficulty: "classic",
    pools: ["world","North America","US","US-VA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-va-028",
    lat: 37.403227,
    lng: -79.178086,
    panoId: "WdZS9Kmo1weiTcKkdiJHtw",
    place: "Near West Lynchburg, Virginia",
    shortName: "West Lynchburg",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VA",
    state: "Virginia",
    difficulty: "classic",
    pools: ["world","North America","US","US-VA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-va-029",
    lat: 37.590301,
    lng: -77.556337,
    panoId: "R05a86qHGF4X2cvEnwa0fg",
    place: "Near Tuckahoe, Virginia",
    shortName: "Tuckahoe",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VA",
    state: "Virginia",
    difficulty: "classic",
    pools: ["world","North America","US","US-VA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-va-030",
    lat: 37.271178,
    lng: -79.941464,
    panoId: "1eqoP_AqxGcRmUQUlZqEWg",
    place: "Near Roanoke, Virginia",
    shortName: "Roanoke",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VA",
    state: "Virginia",
    difficulty: "classic",
    pools: ["world","North America","US","US-VA"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-va-031",
    lat: 36.980388,
    lng: -76.429764,
    panoId: "Pn6ylrBZYbLj9aTP7wCWvA",
    place: "Near Newport News, Virginia",
    shortName: "Newport News",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VA",
    state: "Virginia",
    difficulty: "classic",
    pools: ["world","North America","US","US-VA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-va-032",
    lat: 38.846219,
    lng: -77.306374,
    panoId: "AQho4F_MkOiCPrwtMt8baw",
    place: "Near Fairfax, Virginia",
    shortName: "Fairfax",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VA",
    state: "Virginia",
    difficulty: "classic",
    pools: ["world","North America","US","US-VA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-va-033",
    lat: 38.303153,
    lng: -77.460563,
    panoId: "1wO9FYcQnZ_GPzcJ8c3-cQ",
    place: "Near Fredericksburg, Virginia",
    shortName: "Fredericksburg",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VA",
    state: "Virginia",
    difficulty: "classic",
    pools: ["world","North America","US","US-VA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-va-034",
    lat: 36.818978,
    lng: -76.275056,
    panoId: "qZ3CVQfGzmwyVSdwflXyVg",
    place: "Near Chesapeake, Virginia",
    shortName: "Chesapeake",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VA",
    state: "Virginia",
    difficulty: "classic",
    pools: ["world","North America","US","US-VA"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "us-va-035",
    lat: 37.129814,
    lng: -80.408853,
    panoId: "h-FEYNoK41eWIktMJ2kjxA",
    place: "Near Christiansburg, Virginia",
    shortName: "Christiansburg",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VA",
    state: "Virginia",
    difficulty: "classic",
    pools: ["world","North America","US","US-VA"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-va-036",
    lat: 37.356862,
    lng: -77.441546,
    panoId: "uOrT-C8awJZvPqSIlnadLA",
    place: "Near Chester, Virginia",
    shortName: "Chester",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VA",
    state: "Virginia",
    difficulty: "classic",
    pools: ["world","North America","US","US-VA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-va-037",
    lat: 38.068445,
    lng: -78.889493,
    panoId: "TqsVsLXPL_7l5UGo5uEigA",
    place: "Near Waynesboro, Virginia",
    shortName: "Waynesboro",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VA",
    state: "Virginia",
    difficulty: "classic",
    pools: ["world","North America","US","US-VA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-va-038",
    lat: 38.924581,
    lng: -77.486895,
    panoId: "d6DzKWr-r3cqkRGLPhN2lQ",
    place: "Near South Riding, Virginia",
    shortName: "South Riding",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VA",
    state: "Virginia",
    difficulty: "classic",
    pools: ["world","North America","US","US-VA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-va-039",
    lat: 37.205911,
    lng: -77.397006,
    panoId: "KAE-_ePPm3gZ6qF2xOwN2Q",
    place: "Near Petersburg, Virginia",
    shortName: "Petersburg",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VA",
    state: "Virginia",
    difficulty: "classic",
    pools: ["world","North America","US","US-VA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-va-040",
    lat: 38.779749,
    lng: -77.582331,
    panoId: "THBmOVvqkhvEX-qv9GSdhw",
    place: "Near Linton Hall, Virginia",
    shortName: "Linton Hall",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VA",
    state: "Virginia",
    difficulty: "classic",
    pools: ["world","North America","US","US-VA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-va-041",
    lat: 37.398665,
    lng: -79.129588,
    panoId: "zSCtnqTErHGiYsfbg2QN7w",
    place: "Near Lynchburg, Virginia",
    shortName: "Lynchburg",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VA",
    state: "Virginia",
    difficulty: "classic",
    pools: ["world","North America","US","US-VA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-va-042",
    lat: 36.846258,
    lng: -76.309787,
    panoId: "XOMNaXTtcylzPW8baLNEGg",
    place: "Near Portsmouth, Virginia",
    shortName: "Portsmouth",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VA",
    state: "Virginia",
    difficulty: "classic",
    pools: ["world","North America","US","US-VA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-va-043",
    lat: 39.187204,
    lng: -78.150592,
    panoId: "CGu1vyNOoAxooH3cvm5OJw",
    place: "Near Winchester, Virginia",
    shortName: "Winchester",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VA",
    state: "Virginia",
    difficulty: "classic",
    pools: ["world","North America","US","US-VA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-va-044",
    lat: 37.233427,
    lng: -80.390629,
    panoId: "Bw50l27r5MC9KTDnXOPpiw",
    place: "Near Blacksburg, Virginia",
    shortName: "Blacksburg",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VA",
    state: "Virginia",
    difficulty: "classic",
    pools: ["world","North America","US","US-VA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-va-045",
    lat: 39.064045,
    lng: -77.499795,
    panoId: "r9wEpZb0UTpLTcAwDO4OLg",
    place: "Near Belmont, Virginia",
    shortName: "Belmont",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VA",
    state: "Virginia",
    difficulty: "classic",
    pools: ["world","North America","US","US-VA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-va-046",
    lat: 36.993666,
    lng: -76.440187,
    panoId: "vw3BmXnhj9WxDqsdyCnViw",
    place: "Near Newport News, Virginia",
    shortName: "Newport News",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VA",
    state: "Virginia",
    difficulty: "classic",
    pools: ["world","North America","US","US-VA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-va-047",
    lat: 37.53917,
    lng: -77.474292,
    panoId: "RDL8TAFuwHHo4WCPVN-seQ",
    place: "Near Richmond, Virginia",
    shortName: "Richmond",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VA",
    state: "Virginia",
    difficulty: "classic",
    pools: ["world","North America","US","US-VA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-va-048",
    lat: 36.844284,
    lng: -75.98989,
    panoId: "o51E1ByIpKRrNpeTSRkHkw",
    place: "Near Virginia Beach, Virginia",
    shortName: "Virginia Beach",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VA",
    state: "Virginia",
    difficulty: "classic",
    pools: ["world","North America","US","US-VA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-va-049",
    lat: 38.853415,
    lng: -77.323279,
    panoId: "81z0T8WijgIMz1TPp17oSA",
    place: "Near Fairfax, Virginia",
    shortName: "Fairfax",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VA",
    state: "Virginia",
    difficulty: "classic",
    pools: ["world","North America","US","US-VA"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-va-050",
    lat: 38.319195,
    lng: -77.509496,
    panoId: "dD7a00YwzkoTDDVDH3rwdw",
    place: "Near Southern Gateway, Virginia",
    shortName: "Southern Gateway",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VA",
    state: "Virginia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-VA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-va-051",
    lat: 37.55567,
    lng: -77.627899,
    panoId: "KMjTp_J5QfKCN5BATQQFkQ",
    place: "Near Midlothian, Virginia",
    shortName: "Midlothian",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VA",
    state: "Virginia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-VA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-va-052",
    lat: 36.828537,
    lng: -76.434054,
    panoId: "xpu4ciKfhCBahIcv5foupg",
    place: "Near Portsmouth Heights, Virginia",
    shortName: "Portsmouth Heights",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VA",
    state: "Virginia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-VA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-va-053",
    lat: 36.990547,
    lng: -76.386948,
    panoId: "1l7joC6cJshHaC5ko_YcrA",
    place: "Near Newport News, Virginia",
    shortName: "Newport News",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VA",
    state: "Virginia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-VA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-va-054",
    lat: 37.248381,
    lng: -80.044593,
    panoId: "tiRbdegiu1oa3uXtVhbWvA",
    place: "Near Cave Spring, Virginia",
    shortName: "Cave Spring",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VA",
    state: "Virginia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-VA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-va-055",
    lat: 36.663503,
    lng: -76.56503,
    panoId: "toHQVGJy-5P3i54WzNKE-w",
    place: "Near South Suffolk, Virginia",
    shortName: "South Suffolk",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VA",
    state: "Virginia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-VA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-va-056",
    lat: 38.777894,
    lng: -77.408886,
    panoId: "Hm45Yb__08iGS8xGb8xrPw",
    place: "Near Yorkshire, Virginia",
    shortName: "Yorkshire",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VA",
    state: "Virginia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-VA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-va-057",
    lat: 38.919414,
    lng: -77.131078,
    panoId: "AmCvKV37thJWGtkwL-rSrQ",
    place: "Near Brookmont, Virginia",
    shortName: "Brookmont",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VA",
    state: "Virginia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-VA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-va-058",
    lat: 37.719124,
    lng: -77.639871,
    panoId: "gHtiW5OTtCTaQa1TEH61eg",
    place: "Near Wyndham, Virginia",
    shortName: "Wyndham",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VA",
    state: "Virginia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-VA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-va-059",
    lat: 37.645003,
    lng: -77.368488,
    panoId: "EVLFI58qrTo3SaMsdH4FRw",
    place: "Near Mechanicsville, Virginia",
    shortName: "Mechanicsville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VA",
    state: "Virginia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-VA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-va-060",
    lat: 36.679239,
    lng: -76.56041,
    panoId: "IzcWJKOpMQAeWUH3YraNuA",
    place: "Near South Suffolk, Virginia",
    shortName: "South Suffolk",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VA",
    state: "Virginia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-VA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-va-061",
    lat: 37.030209,
    lng: -76.426473,
    panoId: "TJsNhMISj-YQG0ppKTbdAw",
    place: "Near Newport News, Virginia",
    shortName: "Newport News",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VA",
    state: "Virginia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-VA"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "us-va-062",
    lat: 37.331827,
    lng: -77.30397,
    panoId: "65ExiNmQhtUIcY2Is2WHvQ",
    place: "Near Enon, Virginia",
    shortName: "Enon",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VA",
    state: "Virginia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-VA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-va-063",
    lat: 38.106633,
    lng: -79.053842,
    panoId: "fkReNm6eng97mGmwTTXsvw",
    place: "Near Jolivue, Virginia",
    shortName: "Jolivue",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VA",
    state: "Virginia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-VA"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-va-064",
    lat: 37.165296,
    lng: -77.414782,
    panoId: "nQkGH5-jTR0xVTezC2hBeA",
    place: "Near Petersburg, Virginia",
    shortName: "Petersburg",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VA",
    state: "Virginia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-VA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-va-065",
    lat: 36.881954,
    lng: -76.245395,
    panoId: "DYY0DWW91rrxD12AOy73KQ",
    place: "Near Norfolk, Virginia",
    shortName: "Norfolk",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VA",
    state: "Virginia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-VA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-va-066",
    lat: 37.023295,
    lng: -76.384042,
    panoId: "sM4E-NpsOU21marrHkIq2A",
    place: "Near Hampton, Virginia",
    shortName: "Hampton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VA",
    state: "Virginia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-VA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-va-067",
    lat: 36.823907,
    lng: -76.241031,
    panoId: "WlhIF7XhFPqwhh98QfCjbA",
    place: "Near Chesapeake, Virginia",
    shortName: "Chesapeake",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VA",
    state: "Virginia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-VA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-va-068",
    lat: 36.565498,
    lng: -79.335469,
    panoId: "57UTvAnSKMKr6fjeZl9cEw",
    place: "Near Danville, Virginia",
    shortName: "Danville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VA",
    state: "Virginia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-VA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-va-069",
    lat: 37.296353,
    lng: -80.415586,
    panoId: "nnS2J6IjsDja5MC7sQ0-xQ",
    place: "Near Blacksburg, Virginia",
    shortName: "Blacksburg",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VA",
    state: "Virginia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-VA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-va-070",
    lat: 37.28196,
    lng: -80.019775,
    panoId: "b2-Lm62sLJKdk8kde40z6Q",
    place: "Near Salem, Virginia",
    shortName: "Salem",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VA",
    state: "Virginia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-VA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-va-071",
    lat: 39.185135,
    lng: -78.248352,
    panoId: "AVl805VtXFsnj1OcqLbiCw",
    place: "Near Winchester, Virginia",
    shortName: "Winchester",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VA",
    state: "Virginia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-VA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-va-072",
    lat: 36.887179,
    lng: -76.025354,
    panoId: "5p-uUP1oFOabtkLWAzloKw",
    place: "Near Virginia Beach, Virginia",
    shortName: "Virginia Beach",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VA",
    state: "Virginia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-VA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-va-073",
    lat: 37.460809,
    lng: -77.511745,
    panoId: "gqNTbKLnFvT4TMQoOr8UbQ",
    place: "Near Meadowbrook, Virginia",
    shortName: "Meadowbrook",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VA",
    state: "Virginia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-VA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-va-074",
    lat: 36.760515,
    lng: -76.599554,
    panoId: "G0oacxnXEalWW7eKtUn-xQ",
    place: "Near Suffolk, Virginia",
    shortName: "Suffolk",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VA",
    state: "Virginia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-VA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-va-075",
    lat: 37.281153,
    lng: -77.349134,
    panoId: "LZx35MGdzf2sli6SuCddXg",
    place: "Near Fort Lee, Virginia",
    shortName: "Fort Lee",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VA",
    state: "Virginia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-VA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-va-076",
    lat: 37.561493,
    lng: -77.516872,
    panoId: "vY7x1V6wRgbxeGOT6GXWwA",
    place: "Near Tuckahoe, Virginia",
    shortName: "Tuckahoe",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VA",
    state: "Virginia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-VA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-va-077",
    lat: 36.883916,
    lng: -76.101335,
    panoId: "XIJ3b8e6KUtekWW1Nqi9DA",
    place: "Near Virginia Beach, Virginia",
    shortName: "Virginia Beach",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VA",
    state: "Virginia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-VA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-va-078",
    lat: 37.179369,
    lng: -76.461552,
    panoId: "3yYGGnO-8cNdQ_Z4Jk_RzQ",
    place: "Near Yorktown, Virginia",
    shortName: "Yorktown",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VA",
    state: "Virginia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-VA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-va-079",
    lat: 38.423226,
    lng: -78.032261,
    panoId: "CRggDKc-xkHNuFEYVkRZvg",
    place: "Near Merrimac, Virginia",
    shortName: "Merrimac",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VA",
    state: "Virginia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-VA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-va-080",
    lat: 37.07046,
    lng: -80.316153,
    panoId: "4IDwQyKfXWwNUV6sUv8CKg",
    place: "Near Christiansburg, Virginia",
    shortName: "Christiansburg",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VA",
    state: "Virginia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-VA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-va-081",
    lat: 37.348408,
    lng: -76.546591,
    panoId: "N2kIAhUyHFjimuIqyOCp1Q",
    place: "Near Gloucester Courthouse, Virginia",
    shortName: "Gloucester Courthouse",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VA",
    state: "Virginia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-VA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-va-082",
    lat: 38.652389,
    lng: -77.489371,
    panoId: "v8kBobBkU5HFHyQteUxzgQ",
    place: "Near Independent Hill, Virginia",
    shortName: "Independent Hill",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VA",
    state: "Virginia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-VA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-va-083",
    lat: 37.416563,
    lng: -79.236037,
    panoId: "1I0kkAySHrjRoN9ACgF0Yw",
    place: "Near West Lynchburg, Virginia",
    shortName: "West Lynchburg",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VA",
    state: "Virginia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-VA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-va-084",
    lat: 36.802541,
    lng: -76.497582,
    panoId: "xkh1pJSFzwYB2bj0JQEhZw",
    place: "Near Suffolk, Virginia",
    shortName: "Suffolk",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VA",
    state: "Virginia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-VA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-va-085",
    lat: 37.681031,
    lng: -77.542083,
    panoId: "BENiQg5R1CAi2C5HkYaFDg",
    place: "Near Glen Allen, Virginia",
    shortName: "Glen Allen",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VA",
    state: "Virginia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-VA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-va-086",
    lat: 39.234807,
    lng: -77.702574,
    panoId: "wTzK8yq8vyOmDuKcIhEBew",
    place: "Near Lovettsville, Virginia",
    shortName: "Lovettsville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VA",
    state: "Virginia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-VA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-va-087",
    lat: 36.726011,
    lng: -76.361759,
    panoId: "-5AGKyxBUX0s39nfTCmviA",
    place: "Near Portsmouth Heights, Virginia",
    shortName: "Portsmouth Heights",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VA",
    state: "Virginia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-VA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-va-088",
    lat: 38.905906,
    lng: -78.271486,
    panoId: "cwhCdnRpoysULVVPVLzeuA",
    place: "Near Front Royal, Virginia",
    shortName: "Front Royal",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VA",
    state: "Virginia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-VA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-va-089",
    lat: 37.515737,
    lng: -77.593126,
    panoId: "1YOBLf3QtclcqlpQH3NIDw",
    place: "Near Bon Air, Virginia",
    shortName: "Bon Air",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VA",
    state: "Virginia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-VA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-va-090",
    lat: 37.711118,
    lng: -77.354178,
    panoId: "p53SJazygW50NkamZ5tY7g",
    place: "Near Hanover, Virginia",
    shortName: "Hanover",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VA",
    state: "Virginia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-VA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-va-091",
    lat: 36.515203,
    lng: -82.267953,
    panoId: "wmz4TAGSQFJGHcSkyFW4Zw",
    place: "Near Bluff City, Virginia",
    shortName: "Bluff City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VA",
    state: "Virginia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-VA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-va-092",
    lat: 37.127456,
    lng: -80.54072,
    panoId: "60vxiauddBA-1NdgHiMmUA",
    place: "Near Radford, Virginia",
    shortName: "Radford",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VA",
    state: "Virginia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-VA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-va-093",
    lat: 38.179016,
    lng: -79.082104,
    panoId: "STchUfAh9fWGCIoeIdOXSQ",
    place: "Near Staunton, Virginia",
    shortName: "Staunton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VA",
    state: "Virginia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-VA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-va-094",
    lat: 36.670232,
    lng: -79.332181,
    panoId: "iJ3odgpj8N4m5gsOM9nBRg",
    place: "Near Mount Hermon, Virginia",
    shortName: "Mount Hermon",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VA",
    state: "Virginia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-VA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-va-095",
    lat: 37.331337,
    lng: -77.226628,
    panoId: "EXlye3lCRxkvXpskAJfkKg",
    place: "Near Hopewell, Virginia",
    shortName: "Hopewell",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VA",
    state: "Virginia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-VA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-va-096",
    lat: 37.427839,
    lng: -77.524853,
    panoId: "Xi7uQDb3-jbo6khcZAwEHg",
    place: "Near Meadowbrook, Virginia",
    shortName: "Meadowbrook",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VA",
    state: "Virginia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-VA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-va-097",
    lat: 38.993722,
    lng: -77.706122,
    panoId: "j40TBqEBrpun6ZAraON0Ow",
    place: "Near Bull Run Mountain Estates, Virginia",
    shortName: "Bull Run Mountain Estates",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VA",
    state: "Virginia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-VA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-va-098",
    lat: 37.63207,
    lng: -77.586635,
    panoId: "3P80Zty_lL3a4Q50hDNpPg",
    place: "Near Short Pump, Virginia",
    shortName: "Short Pump",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VA",
    state: "Virginia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-VA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-va-099",
    lat: 37.760947,
    lng: -77.565775,
    panoId: "kIW1nrRhzx-B0JQGMC12uQ",
    place: "Near Ashland, Virginia",
    shortName: "Ashland",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VA",
    state: "Virginia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-VA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-va-100",
    lat: 37.094639,
    lng: -80.111807,
    panoId: "JFlFSXh1WvzzACYXEDS9BA",
    place: "Near Shawsville, Virginia",
    shortName: "Shawsville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VA",
    state: "Virginia",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-VA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-va-101",
    lat: 37.49268,
    lng: -79.78946,
    panoId: "tBqffLEmsopeWbo5Y-8s-g",
    place: "Near Fincastle, Virginia",
    shortName: "Fincastle",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VA",
    state: "Virginia",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-VA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-va-102",
    lat: 36.536026,
    lng: -80.017632,
    panoId: "mkTLPtaEVPBEEJObCiXkDw",
    place: "Near Horse Pasture, Virginia",
    shortName: "Horse Pasture",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VA",
    state: "Virginia",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-VA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-va-103",
    lat: 38.600074,
    lng: -78.18438,
    panoId: "VPqvs8QaOaJoBKD1Ev3v6g",
    place: "Near Washington, Virginia",
    shortName: "Washington",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VA",
    state: "Virginia",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-VA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-va-104",
    lat: 37.249701,
    lng: -77.648354,
    panoId: "edRXSa910bMDMEOfuqf3zQ",
    place: "Near Matoaca, Virginia",
    shortName: "Matoaca",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VA",
    state: "Virginia",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-VA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-va-105",
    lat: 38.096147,
    lng: -78.259828,
    panoId: "9WV8ldWkEAUd_x01BvH2SA",
    place: "Near Gordonsville, Virginia",
    shortName: "Gordonsville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "VA",
    state: "Virginia",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-VA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wa-000",
    lat: 47.606392,
    lng: -122.332186,
    panoId: "K50OqIfHcihf28bIGDGOlw",
    place: "Near Seattle, Washington",
    shortName: "Seattle",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WA",
    state: "Washington",
    difficulty: "classic",
    pools: ["world","North America","US","US-WA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wa-001",
    lat: 47.044872,
    lng: -122.901689,
    panoId: "8UBNntgOi8HzT2nkH_Nzcg",
    place: "Near Olympia, Washington",
    shortName: "Olympia",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WA",
    state: "Washington",
    difficulty: "classic",
    pools: ["world","North America","US","US-WA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wa-002",
    lat: 48.759601,
    lng: -122.48818,
    panoId: "8iPaDKk8F29F8nQ2HsRcAg",
    place: "Near Bellingham, Washington",
    shortName: "Bellingham",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WA",
    state: "Washington",
    difficulty: "classic",
    pools: ["world","North America","US","US-WA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wa-003",
    lat: 46.239594,
    lng: -119.100623,
    panoId: "-JUFwU6poi4QfrmgV_ayUA",
    place: "Near Pasco, Washington",
    shortName: "Pasco",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WA",
    state: "Washington",
    difficulty: "classic",
    pools: ["world","North America","US","US-WA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wa-004",
    lat: 47.99344,
    lng: -122.101767,
    panoId: "jITD6sEkIuVPUwOEOw8Geg",
    place: "Near West Lake Stevens, Washington",
    shortName: "West Lake Stevens",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WA",
    state: "Washington",
    difficulty: "classic",
    pools: ["world","North America","US","US-WA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wa-005",
    lat: 46.731056,
    lng: -117.18015,
    panoId: "uxHWw1rebItGzpY3TRJeag",
    place: "Near Pullman, Washington",
    shortName: "Pullman",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WA",
    state: "Washington",
    difficulty: "classic",
    pools: ["world","North America","US","US-WA"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-wa-006",
    lat: 47.13017,
    lng: -119.278094,
    panoId: "GKqmOuhfJgM8bdSk1PmmeA",
    place: "Near Moses Lake, Washington",
    shortName: "Moses Lake",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WA",
    state: "Washington",
    difficulty: "classic",
    pools: ["world","North America","US","US-WA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wa-007",
    lat: 47.423463,
    lng: -120.310374,
    panoId: "-Kj6foONtDQ5vibNoBXSlg",
    place: "Near Wenatchee, Washington",
    shortName: "Wenatchee",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WA",
    state: "Washington",
    difficulty: "classic",
    pools: ["world","North America","US","US-WA"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-wa-008",
    lat: 46.211263,
    lng: -119.137189,
    panoId: "WC3CKt4twQZEANNq5vnQ8A",
    place: "Near Kennewick, Washington",
    shortName: "Kennewick",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WA",
    state: "Washington",
    difficulty: "classic",
    pools: ["world","North America","US","US-WA"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-wa-009",
    lat: 47.155432,
    lng: -122.434077,
    panoId: "IjHH2wzuU_MPklTfJAXDwg",
    place: "Near Parkland, Washington",
    shortName: "Parkland",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WA",
    state: "Washington",
    difficulty: "classic",
    pools: ["world","North America","US","US-WA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wa-010",
    lat: 47.171805,
    lng: -122.518491,
    panoId: "ssHvYPDzmGU_Ikiz6Jm97w",
    place: "Near Lakewood, Washington",
    shortName: "Lakewood",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WA",
    state: "Washington",
    difficulty: "classic",
    pools: ["world","North America","US","US-WA"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-wa-011",
    lat: 45.638731,
    lng: -122.661506,
    panoId: "AbUwvJVOjdzNWG5mNv6OBA",
    place: "Near Vancouver, Washington",
    shortName: "Vancouver",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WA",
    state: "Washington",
    difficulty: "classic",
    pools: ["world","North America","US","US-WA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wa-012",
    lat: 46.285725,
    lng: -119.284426,
    panoId: "ujPiUoehJdm3P0hRaRjrNg",
    place: "Near Richland, Washington",
    shortName: "Richland",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WA",
    state: "Washington",
    difficulty: "classic",
    pools: ["world","North America","US","US-WA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wa-013",
    lat: 47.235609,
    lng: -122.550384,
    panoId: "zLGFBume4V2JcS-ukvGtBQ",
    place: "Near University Place, Washington",
    shortName: "University Place",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WA",
    state: "Washington",
    difficulty: "classic",
    pools: ["world","North America","US","US-WA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wa-014",
    lat: 48.198734,
    lng: -122.125105,
    panoId: "l8o3s7FEYh891aC_EUdo_g",
    place: "Near Arlington, Washington",
    shortName: "Arlington",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WA",
    state: "Washington",
    difficulty: "classic",
    pools: ["world","North America","US","US-WA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wa-015",
    lat: 46.602082,
    lng: -120.506042,
    panoId: "0owSNPyphV-r-nuBg5eT6g",
    place: "Near Yakima, Washington",
    shortName: "Yakima",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WA",
    state: "Washington",
    difficulty: "classic",
    pools: ["world","North America","US","US-WA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wa-016",
    lat: 48.293204,
    lng: -122.643309,
    panoId: "UxtL8qW-6otrnVhIfNg3qA",
    place: "Near Oak Harbor, Washington",
    shortName: "Oak Harbor",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WA",
    state: "Washington",
    difficulty: "classic",
    pools: ["world","North America","US","US-WA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wa-017",
    lat: 47.252791,
    lng: -122.444239,
    panoId: "A4VkNZpDVAXkY4q0RvpeVw",
    place: "Near Tacoma, Washington",
    shortName: "Tacoma",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WA",
    state: "Washington",
    difficulty: "classic",
    pools: ["world","North America","US","US-WA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wa-018",
    lat: 47.141573,
    lng: -122.268753,
    panoId: "8UixxAe3iH4N8MpeqHX7yw",
    place: "Near South Hill, Washington",
    shortName: "South Hill",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WA",
    state: "Washington",
    difficulty: "classic",
    pools: ["world","North America","US","US-WA"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-wa-019",
    lat: 47.185237,
    lng: -122.292916,
    panoId: "GId1-LUpfV_h7bAHGqHG4g",
    place: "Near Puyallup, Washington",
    shortName: "Puyallup",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WA",
    state: "Washington",
    difficulty: "classic",
    pools: ["world","North America","US","US-WA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wa-020",
    lat: 47.103969,
    lng: -122.43485,
    panoId: "qTgYQGMLb4EXmGxJEWj_sQ",
    place: "Near Spanaway, Washington",
    shortName: "Spanaway",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WA",
    state: "Washington",
    difficulty: "classic",
    pools: ["world","North America","US","US-WA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wa-021",
    lat: 47.673192,
    lng: -117.23951,
    panoId: "Y6sFZ-4w7irQ1fop62NeNg",
    place: "Near Spokane Valley, Washington",
    shortName: "Spokane Valley",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WA",
    state: "Washington",
    difficulty: "classic",
    pools: ["world","North America","US","US-WA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wa-022",
    lat: 47.979163,
    lng: -122.202061,
    panoId: "66CaVGfQv3jIZSx_YugX3w",
    place: "Near Everett, Washington",
    shortName: "Everett",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WA",
    state: "Washington",
    difficulty: "classic",
    pools: ["world","North America","US","US-WA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wa-023",
    lat: 48.015155,
    lng: -122.063869,
    panoId: "olGvRE7hwNg7gmB2rO6txA",
    place: "Near Lake Stevens, Washington",
    shortName: "Lake Stevens",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WA",
    state: "Washington",
    difficulty: "classic",
    pools: ["world","North America","US","US-WA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wa-024",
    lat: 48.118262,
    lng: -123.431013,
    panoId: "pmTWxf8YeyLUzPL5UnAA3g",
    place: "Near Port Angeles, Washington",
    shortName: "Port Angeles",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WA",
    state: "Washington",
    difficulty: "classic",
    pools: ["world","North America","US","US-WA"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-wa-025",
    lat: 46.996532,
    lng: -120.547899,
    panoId: "gcUMthWulLrdHlp3MaVtjw",
    place: "Near Ellensburg, Washington",
    shortName: "Ellensburg",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WA",
    state: "Washington",
    difficulty: "classic",
    pools: ["world","North America","US","US-WA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wa-026",
    lat: 46.138126,
    lng: -122.938259,
    panoId: "wuMymxxYB-FCmIKsml10qQ",
    place: "Near Longview, Washington",
    shortName: "Longview",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WA",
    state: "Washington",
    difficulty: "classic",
    pools: ["world","North America","US","US-WA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wa-027",
    lat: 47.034287,
    lng: -122.823256,
    panoId: "cZrH9H2RN6HtiX1xj2QDZQ",
    place: "Near Lacey, Washington",
    shortName: "Lacey",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WA",
    state: "Washington",
    difficulty: "classic",
    pools: ["world","North America","US","US-WA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wa-028",
    lat: 47.00737,
    lng: -122.909218,
    panoId: "SF6AMxPM1tn1RBonPyufkA",
    place: "Near Tumwater, Washington",
    shortName: "Tumwater",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WA",
    state: "Washington",
    difficulty: "classic",
    pools: ["world","North America","US","US-WA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wa-029",
    lat: 48.421205,
    lng: -122.333983,
    panoId: "0OnWcWMz_H9gqvblzxVr9Q",
    place: "Near Mount Vernon, Washington",
    shortName: "Mount Vernon",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WA",
    state: "Washington",
    difficulty: "classic",
    pools: ["world","North America","US","US-WA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wa-030",
    lat: 47.052875,
    lng: -122.294047,
    panoId: "j_8MbxzTOxPIpIQ39s7UzQ",
    place: "Near Graham, Washington",
    shortName: "Graham",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WA",
    state: "Washington",
    difficulty: "classic",
    pools: ["world","North America","US","US-WA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wa-031",
    lat: 46.24537,
    lng: -119.195962,
    panoId: "zBmVatdEZqd0G18avLnwVg",
    place: "Near Tri-Cities, Washington",
    shortName: "Tri-Cities",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WA",
    state: "Washington",
    difficulty: "classic",
    pools: ["world","North America","US","US-WA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wa-032",
    lat: 47.659047,
    lng: -117.429055,
    panoId: "pQugIOk8IorIuqE89Bci8A",
    place: "Near Spokane, Washington",
    shortName: "Spokane",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WA",
    state: "Washington",
    difficulty: "classic",
    pools: ["world","North America","US","US-WA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wa-033",
    lat: 46.06464,
    lng: -118.342851,
    panoId: "60XUCx6WAmMnWA5Z9rwdqg",
    place: "Near Walla Walla, Washington",
    shortName: "Walla Walla",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WA",
    state: "Washington",
    difficulty: "classic",
    pools: ["world","North America","US","US-WA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wa-034",
    lat: 48.051793,
    lng: -122.177143,
    panoId: "XzN1ShbN6615yI9_H-GsyQ",
    place: "Near Marysville, Washington",
    shortName: "Marysville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WA",
    state: "Washington",
    difficulty: "classic",
    pools: ["world","North America","US","US-WA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wa-035",
    lat: 46.716205,
    lng: -122.954352,
    panoId: "ilevPvZqglxrc0DvNGSKoA",
    place: "Near Centralia, Washington",
    shortName: "Centralia",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WA",
    state: "Washington",
    difficulty: "classic",
    pools: ["world","North America","US","US-WA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wa-036",
    lat: 48.51262,
    lng: -122.612712,
    panoId: "h1U8z_G7delvfZ_PlJOyQA",
    place: "Near Anacortes, Washington",
    shortName: "Anacortes",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WA",
    state: "Washington",
    difficulty: "classic",
    pools: ["world","North America","US","US-WA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wa-037",
    lat: 47.096334,
    lng: -122.358758,
    panoId: "HYEhhf3kUXlWZ3u6es6Mnw",
    place: "Near Frederickson, Washington",
    shortName: "Frederickson",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WA",
    state: "Washington",
    difficulty: "classic",
    pools: ["world","North America","US","US-WA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wa-038",
    lat: 46.323783,
    lng: -120.00867,
    panoId: "GadYlQirp2yG664a-IAYYA",
    place: "Near Sunnyside, Washington",
    shortName: "Sunnyside",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WA",
    state: "Washington",
    difficulty: "classic",
    pools: ["world","North America","US","US-WA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wa-039",
    lat: 46.128766,
    lng: -122.911916,
    panoId: "7zeIdq1ecRqwE9TZS9ItGA",
    place: "Near Kelso, Washington",
    shortName: "Kelso",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WA",
    state: "Washington",
    difficulty: "classic",
    pools: ["world","North America","US","US-WA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wa-040",
    lat: 47.645796,
    lng: -117.421579,
    panoId: "8jYm498GH6M2DlZSv0IW1A",
    place: "Near Spokane, Washington",
    shortName: "Spokane",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WA",
    state: "Washington",
    difficulty: "classic",
    pools: ["world","North America","US","US-WA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wa-041",
    lat: 48.303216,
    lng: -122.661153,
    panoId: "j04I-K9t70WOo81bspEtxg",
    place: "Near Oak Harbor, Washington",
    shortName: "Oak Harbor",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WA",
    state: "Washington",
    difficulty: "classic",
    pools: ["world","North America","US","US-WA"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-wa-042",
    lat: 47.174665,
    lng: -122.428323,
    panoId: "qi_se-pLwJnYB56BZC7ZFQ",
    place: "Near Midland, Washington",
    shortName: "Midland",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WA",
    state: "Washington",
    difficulty: "classic",
    pools: ["world","North America","US","US-WA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wa-043",
    lat: 47.40978,
    lng: -120.3236,
    panoId: "OzupFFGVEaBfZIz3gMQ3Kw",
    place: "Near Wenatchee, Washington",
    shortName: "Wenatchee",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WA",
    state: "Washington",
    difficulty: "classic",
    pools: ["world","North America","US","US-WA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wa-044",
    lat: 47.184973,
    lng: -122.318839,
    panoId: "5hTyvmEydIDlJ6np2Q1SVw",
    place: "Near Puyallup, Washington",
    shortName: "Puyallup",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WA",
    state: "Washington",
    difficulty: "classic",
    pools: ["world","North America","US","US-WA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wa-045",
    lat: 46.993831,
    lng: -120.529011,
    panoId: "G5uesq3JMWuL6Yk6w0BfYQ",
    place: "Near Ellensburg, Washington",
    shortName: "Ellensburg",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WA",
    state: "Washington",
    difficulty: "classic",
    pools: ["world","North America","US","US-WA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wa-046",
    lat: 48.02311,
    lng: -122.084385,
    panoId: "hsPEyWjC2FBD7OfsjvM_1w",
    place: "Near Lake Stevens, Washington",
    shortName: "Lake Stevens",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WA",
    state: "Washington",
    difficulty: "classic",
    pools: ["world","North America","US","US-WA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wa-047",
    lat: 47.138738,
    lng: -119.263604,
    panoId: "-m56m3aK3GaruxGUxzk7NA",
    place: "Near Moses Lake, Washington",
    shortName: "Moses Lake",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WA",
    state: "Washington",
    difficulty: "classic",
    pools: ["world","North America","US","US-WA"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-wa-048",
    lat: 47.988167,
    lng: -122.21452,
    panoId: "tiDmCg5465Dlm0jiRgoShA",
    place: "Near Everett, Washington",
    shortName: "Everett",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WA",
    state: "Washington",
    difficulty: "classic",
    pools: ["world","North America","US","US-WA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wa-049",
    lat: 48.189126,
    lng: -122.131116,
    panoId: "JcZTEUGq2_4uvsQZxDi1Wg",
    place: "Near Arlington, Washington",
    shortName: "Arlington",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WA",
    state: "Washington",
    difficulty: "classic",
    pools: ["world","North America","US","US-WA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wa-050",
    lat: 47.192324,
    lng: -122.574269,
    panoId: "vF5QFUgaRPTlTF4od704Lw",
    place: "Near Steilacoom, Washington",
    shortName: "Steilacoom",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WA",
    state: "Washington",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wa-051",
    lat: 47.114039,
    lng: -122.494002,
    panoId: "hT2IiNfdxXHwsWKTfaKl9w",
    place: "Near McChord Air Force Base, Washington",
    shortName: "McChord Air Force Base",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WA",
    state: "Washington",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wa-052",
    lat: 47.199744,
    lng: -122.117692,
    panoId: "lmVbB61lPSCraBKbdQ3PCQ",
    place: "Near Prairie Heights, Washington",
    shortName: "Prairie Heights",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WA",
    state: "Washington",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wa-053",
    lat: 48.172427,
    lng: -122.070408,
    panoId: "ZUMpylISArYZqFJFFf0BUg",
    place: "Near Arlington Heights, Washington",
    shortName: "Arlington Heights",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WA",
    state: "Washington",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wa-054",
    lat: 47.010941,
    lng: -122.782864,
    panoId: "325pjnV8_4fzeFMbVsz0sA",
    place: "Near Lacey, Washington",
    shortName: "Lacey",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WA",
    state: "Washington",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wa-055",
    lat: 46.213904,
    lng: -119.218689,
    panoId: "7_aIPr4j2jBRTfZfntgHLQ",
    place: "Near Tri-Cities, Washington",
    shortName: "Tri-Cities",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WA",
    state: "Washington",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wa-056",
    lat: 47.044633,
    lng: -122.946475,
    panoId: "lkWfVFisBTDAygk3Dhh93A",
    place: "Near Olympia, Washington",
    shortName: "Olympia",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WA",
    state: "Washington",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wa-057",
    lat: 46.254691,
    lng: -119.312733,
    panoId: "mhrjPuycDYa4JLaMA-71aA",
    place: "Near Richland, Washington",
    shortName: "Richland",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WA",
    state: "Washington",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wa-058",
    lat: 47.674885,
    lng: -117.334485,
    panoId: "_7UNphLVut9W9tY4RUuA1g",
    place: "Near Millwood, Washington",
    shortName: "Millwood",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WA",
    state: "Washington",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wa-059",
    lat: 46.000668,
    lng: -118.340744,
    panoId: "qdz15hzjvu9vG2-26dhR2g",
    place: "Near Walla Walla East, Washington",
    shortName: "Walla Walla East",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WA",
    state: "Washington",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wa-060",
    lat: 48.45851,
    lng: -122.560165,
    panoId: "eTlnlTxZs7a68ENqSGLc7w",
    place: "Near Anacortes, Washington",
    shortName: "Anacortes",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WA",
    state: "Washington",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wa-061",
    lat: 46.994514,
    lng: -122.276971,
    panoId: "0Z-yBGn3DM7V7BgDeRUwNQ",
    place: "Near Graham, Washington",
    shortName: "Graham",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WA",
    state: "Washington",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wa-062",
    lat: 48.735953,
    lng: -122.390991,
    panoId: "eVaRRsILNlZuhjehc272Wg",
    place: "Near Geneva, Washington",
    shortName: "Geneva",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WA",
    state: "Washington",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wa-063",
    lat: 48.10483,
    lng: -123.502454,
    panoId: "ZDCZRxGdfCVdA3j1C-5BsA",
    place: "Near Port Angeles, Washington",
    shortName: "Port Angeles",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WA",
    state: "Washington",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wa-064",
    lat: 46.760335,
    lng: -122.914925,
    panoId: "JpjBcA_Pf1BCFXPPBfuYFg",
    place: "Near Centralia, Washington",
    shortName: "Centralia",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WA",
    state: "Washington",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wa-065",
    lat: 48.065682,
    lng: -122.094772,
    panoId: "doYoyh28C1ST2sorkor6pw",
    place: "Near Lochsloy, Washington",
    shortName: "Lochsloy",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WA",
    state: "Washington",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wa-066",
    lat: 47.545218,
    lng: -122.327282,
    panoId: "jl6esODWo_UhJr5Y4m4wGg",
    place: "Near Boulevard Park, Washington",
    shortName: "Boulevard Park",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WA",
    state: "Washington",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wa-067",
    lat: 47.074549,
    lng: -122.268931,
    panoId: "FXZC2EGbY3_c5X8X6wwvYw",
    place: "Near Graham, Washington",
    shortName: "Graham",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WA",
    state: "Washington",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wa-068",
    lat: 46.781514,
    lng: -117.192866,
    panoId: "o-ptlqdqsOIc-xlYV5aYBQ",
    place: "Near Pullman, Washington",
    shortName: "Pullman",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WA",
    state: "Washington",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wa-069",
    lat: 47.745849,
    lng: -117.244033,
    panoId: "i6WwTLJ2QfTN5w40qjMDDg",
    place: "Near Trentwood, Washington",
    shortName: "Trentwood",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WA",
    state: "Washington",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wa-070",
    lat: 46.316644,
    lng: -120.068095,
    panoId: "9GyEo0FiPiZ_HSAqwOxnGw",
    place: "Near Sunnyside, Washington",
    shortName: "Sunnyside",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WA",
    state: "Washington",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wa-071",
    lat: 48.038845,
    lng: -122.252759,
    panoId: "eXlPs1wngyrll_jS-aO0lw",
    place: "Near Tulalip Bay, Washington",
    shortName: "Tulalip Bay",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WA",
    state: "Washington",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wa-072",
    lat: 46.065972,
    lng: -118.264372,
    panoId: "ddcvI5bFHFJYEhOrayzsCQ",
    place: "Near Walla Walla East, Washington",
    shortName: "Walla Walla East",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WA",
    state: "Washington",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wa-073",
    lat: 46.093459,
    lng: -122.949101,
    panoId: "IWb-O6Yc40pLXbDzxmKxEw",
    place: "Near Rainier, Washington",
    shortName: "Rainier",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WA",
    state: "Washington",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wa-074",
    lat: 47.116556,
    lng: -122.248865,
    panoId: "O17rkdhLsQuP3pNm-631Ew",
    place: "Near McMillin, Washington",
    shortName: "McMillin",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WA",
    state: "Washington",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wa-075",
    lat: 46.154109,
    lng: -119.149079,
    panoId: "J8nCxId0eVbH61B1VjQ74A",
    place: "Near Highland, Washington",
    shortName: "Highland",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WA",
    state: "Washington",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wa-076",
    lat: 47.466489,
    lng: -120.324554,
    panoId: "qDEtILx-9z5SmOwDChrhvg",
    place: "Near Sunnyslope, Washington",
    shortName: "Sunnyslope",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WA",
    state: "Washington",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WA"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-wa-077",
    lat: 47.170934,
    lng: -122.122835,
    panoId: "4Cd5WwbYfq76_BbnQSHNcw",
    place: "Near Prairie Heights, Washington",
    shortName: "Prairie Heights",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WA",
    state: "Washington",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wa-078",
    lat: 46.204914,
    lng: -119.223561,
    panoId: "xHAeoBBCFKIEQSmMUIBUYw",
    place: "Near Tri-Cities, Washington",
    shortName: "Tri-Cities",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WA",
    state: "Washington",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wa-079",
    lat: 48.336024,
    lng: -122.635387,
    panoId: "0QdtKye4TqRHTFGS3-31Uw",
    place: "Near Ault Field, Washington",
    shortName: "Ault Field",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WA",
    state: "Washington",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WA"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-wa-080",
    lat: 46.948489,
    lng: -120.517878,
    panoId: "Kjh3NajUy9eBwGtLWSIdmg",
    place: "Near Ellensburg, Washington",
    shortName: "Ellensburg",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WA",
    state: "Washington",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wa-081",
    lat: 47.003445,
    lng: -122.515379,
    panoId: "N5De0gB5kgnNxiJ1Hoc7yw",
    place: "Near North Yelm, Washington",
    shortName: "North Yelm",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WA",
    state: "Washington",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wa-082",
    lat: 48.874718,
    lng: -122.704205,
    panoId: "TbKNwFHmwccCQjKPG31ZhQ",
    place: "Near Birch Bay, Washington",
    shortName: "Birch Bay",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WA",
    state: "Washington",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wa-083",
    lat: 45.490013,
    lng: -122.670104,
    panoId: "Sj_czV-0HvsCZoSwFIcCWA",
    place: "Near Portland, Washington",
    shortName: "Portland",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WA",
    state: "Washington",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WA"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-wa-084",
    lat: 47.36519,
    lng: -120.354786,
    panoId: "xeCUp4uChSA0ChgdTy2gFA",
    place: "Near South Wenatchee, Washington",
    shortName: "South Wenatchee",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WA",
    state: "Washington",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wa-085",
    lat: 46.919286,
    lng: -122.387719,
    panoId: "MUTZ13mIklBdgkpslv0QDg",
    place: "Near Eatonville, Washington",
    shortName: "Eatonville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WA",
    state: "Washington",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wa-086",
    lat: 47.326307,
    lng: -122.642739,
    panoId: "GPPgUsmSEUOZu8AA9Pw6dA",
    place: "Near Rosedale, Washington",
    shortName: "Rosedale",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WA",
    state: "Washington",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wa-087",
    lat: 48.368868,
    lng: -122.588366,
    panoId: "PwDdJTW91a7hccqz63fAKA",
    place: "Near Ault Field, Washington",
    shortName: "Ault Field",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WA",
    state: "Washington",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wa-088",
    lat: 47.102251,
    lng: -119.271391,
    panoId: "U5ObXY-fSrRJLWhWcA6KKQ",
    place: "Near Moses Lake, Washington",
    shortName: "Moses Lake",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WA",
    state: "Washington",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wa-089",
    lat: 47.580954,
    lng: -122.313778,
    panoId: "VibJXUyCSqPPgOodOg8CcA",
    place: "Near Seattle, Washington",
    shortName: "Seattle",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WA",
    state: "Washington",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wa-090",
    lat: 46.229214,
    lng: -119.956354,
    panoId: "Y02bq3rYT_MkhKSyVXn_VA",
    place: "Near Mabton, Washington",
    shortName: "Mabton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WA",
    state: "Washington",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wa-091",
    lat: 46.44791,
    lng: -120.589786,
    panoId: "Znbo0PoOxc6Wm9Drm8wyvQ",
    place: "Near Ahtanum, Washington",
    shortName: "Ahtanum",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WA",
    state: "Washington",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wa-092",
    lat: 48.228569,
    lng: -122.757953,
    panoId: "Ii1cuANVVxeeOVlRIyyeig",
    place: "Near Coupeville, Washington",
    shortName: "Coupeville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WA",
    state: "Washington",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wa-093",
    lat: 48.088882,
    lng: -122.097992,
    panoId: "K1qMji308QfrH8g7QBQswQ",
    place: "Near Sisco Heights, Washington",
    shortName: "Sisco Heights",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WA",
    state: "Washington",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wa-094",
    lat: 47.099224,
    lng: -122.152357,
    panoId: "CFLppWHu3DATXGueOY0X4w",
    place: "Near Orting, Washington",
    shortName: "Orting",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WA",
    state: "Washington",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wa-095",
    lat: 46.476481,
    lng: -120.314056,
    panoId: "fiyU6caY7uB-b9H-nJM_Vg",
    place: "Near Wapato, Washington",
    shortName: "Wapato",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WA",
    state: "Washington",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wa-096",
    lat: 47.245967,
    lng: -122.621177,
    panoId: "cJ8pGZuKhRrdy0XUOuI9_w",
    place: "Near Fox Island, Washington",
    shortName: "Fox Island",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WA",
    state: "Washington",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wa-097",
    lat: 48.724108,
    lng: -122.445939,
    panoId: "-XoDxeTr9oXp95AuQY2K9A",
    place: "Near Geneva, Washington",
    shortName: "Geneva",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WA",
    state: "Washington",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wa-098",
    lat: 47.164655,
    lng: -122.822952,
    panoId: "MYxss-chDghFkJ-_ikdDmw",
    place: "Near Longbranch, Washington",
    shortName: "Longbranch",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WA",
    state: "Washington",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wa-099",
    lat: 47.145302,
    lng: -122.999713,
    panoId: "7wbq69zXasWa-wMwbzbf7Q",
    place: "Near Shelton, Washington",
    shortName: "Shelton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WA",
    state: "Washington",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wa-100",
    lat: 46.187238,
    lng: -119.47902,
    panoId: "p7A9sfrlPEpoUY4MEwQuLA",
    place: "Near Benton City, Washington",
    shortName: "Benton City",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WA",
    state: "Washington",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-WA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wa-101",
    lat: 46.815088,
    lng: -117.425174,
    panoId: "jVPirqQKeFQm4YmEahW3lg",
    place: "Near Colfax, Washington",
    shortName: "Colfax",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WA",
    state: "Washington",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-WA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wa-102",
    lat: 46.96514,
    lng: -123.604415,
    panoId: "0705wCIv0AqGA4Xs_Ng0VA",
    place: "Near Montesano, Washington",
    shortName: "Montesano",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WA",
    state: "Washington",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-WA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wa-103",
    lat: 46.185714,
    lng: -118.213397,
    panoId: "KnSATwyywcji_Z_-rD7K6Q",
    place: "Near Waitsburg, Washington",
    shortName: "Waitsburg",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WA",
    state: "Washington",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-WA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wa-104",
    lat: 47.289822,
    lng: -120.162065,
    panoId: "NAQYgWpn0EK3DIsPr3aOJQ",
    place: "Near South Wenatchee, Washington",
    shortName: "South Wenatchee",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WA",
    state: "Washington",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-WA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wa-105",
    lat: 48.008088,
    lng: -122.557018,
    panoId: "BK9QJpAT2wiqNwXzYx4iuA",
    place: "Near Freeland, Washington",
    shortName: "Freeland",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WA",
    state: "Washington",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-WA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wv-000",
    lat: 39.629625,
    lng: -79.956063,
    panoId: "2gaMGttrOo3uYy7_3Dptrg",
    place: "Near Morgantown, West Virginia",
    shortName: "Morgantown",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "classic",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wv-001",
    lat: 39.266668,
    lng: -81.561406,
    panoId: "j27lsP0MOuzQ5VOd4doRAw",
    place: "Near Parkersburg, West Virginia",
    shortName: "Parkersburg",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "classic",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wv-002",
    lat: 38.419201,
    lng: -82.445222,
    panoId: "BwpUq_VVHNwzpA7_Fz2QuQ",
    place: "Near Huntington, West Virginia",
    shortName: "Huntington",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "classic",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wv-003",
    lat: 38.385626,
    lng: -81.83646,
    panoId: "u7yUk-AIdJPVVSnLnfyDtw",
    place: "Near Saint Albans, West Virginia",
    shortName: "Saint Albans",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "classic",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wv-004",
    lat: 37.269901,
    lng: -81.222372,
    panoId: "kXBCmOPIWGowYhv3fIycJQ",
    place: "Near Bluefield, West Virginia",
    shortName: "Bluefield",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "classic",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wv-005",
    lat: 38.360763,
    lng: -81.737514,
    panoId: "tzro2LsTqzL7FFfMkvbOKg",
    place: "Near Dunbar, West Virginia",
    shortName: "Dunbar",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "classic",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wv-006",
    lat: 39.280595,
    lng: -80.344554,
    panoId: "WdIDO5nvwdfWISBPDM6ulg",
    place: "Near Clarksburg, West Virginia",
    shortName: "Clarksburg",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "classic",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wv-007",
    lat: 40.06396,
    lng: -80.720807,
    panoId: "nqPyYfApHu030kWnqf63lQ",
    place: "Near Wheeling, West Virginia",
    shortName: "Wheeling",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "classic",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wv-008",
    lat: 39.340885,
    lng: -80.018951,
    panoId: "d0Jf4xmR9dwjkQhMolmoiA",
    place: "Near Grafton, West Virginia",
    shortName: "Grafton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "classic",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wv-009",
    lat: 40.408316,
    lng: -80.539146,
    panoId: "dTxArLWJx22A14sJGnSojA",
    place: "Near Weirton Heights, West Virginia",
    shortName: "Weirton Heights",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "classic",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wv-010",
    lat: 39.456206,
    lng: -77.963805,
    panoId: "pT55gzceXh8hj0ciJEDFWA",
    place: "Near Martinsburg, West Virginia",
    shortName: "Martinsburg",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "classic",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wv-011",
    lat: 38.450137,
    lng: -81.929216,
    panoId: "qLWbjvMtlg6xzNPyu5LQcw",
    place: "Near Teays Valley, West Virginia",
    shortName: "Teays Valley",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "classic",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wv-012",
    lat: 39.326994,
    lng: -81.548451,
    panoId: "60-d43YPyvcHTVjM3HBWkw",
    place: "Near Vienna, West Virginia",
    shortName: "Vienna",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "classic",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wv-013",
    lat: 38.413689,
    lng: -82.318837,
    panoId: "wSawud_qV47BQF69IJFlJQ",
    place: "Near Pea Ridge, West Virginia",
    shortName: "Pea Ridge",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "classic",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wv-014",
    lat: 38.349766,
    lng: -81.632625,
    panoId: "ujR5wKi_sVCc9ih3NCyGVg",
    place: "Near Charleston, West Virginia",
    shortName: "Charleston",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "classic",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wv-015",
    lat: 39.295323,
    lng: -78.637813,
    panoId: "rCsEkDYmqMcpEbpiH_ONgg",
    place: "Near Augusta, West Virginia",
    shortName: "Augusta",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "classic",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wv-016",
    lat: 38.994019,
    lng: -80.232086,
    panoId: "zZTfPeUpZGYuQDtK2sJSDQ",
    place: "Near Buckhannon, West Virginia",
    shortName: "Buckhannon",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "classic",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wv-017",
    lat: 39.644495,
    lng: -80.857585,
    panoId: "rw07UzKLQcZsPHalDWtL8w",
    place: "Near New Martinsville, West Virginia",
    shortName: "New Martinsville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "classic",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wv-018",
    lat: 37.972324,
    lng: -81.148632,
    panoId: "DEHumsL999qcbIPQP6mpwA",
    place: "Near Oak Hill, West Virginia",
    shortName: "Oak Hill",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "classic",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wv-019",
    lat: 38.925979,
    lng: -79.846775,
    panoId: "hd6XiOpwUJGaD7KmuchN8A",
    place: "Near Elkins, West Virginia",
    shortName: "Elkins",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "classic",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wv-020",
    lat: 39.286417,
    lng: -80.256168,
    panoId: "ahzyldAV8btceEmv_G4xog",
    place: "Near Bridgeport, West Virginia",
    shortName: "Bridgeport",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "classic",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wv-021",
    lat: 38.42041,
    lng: -81.79055,
    panoId: "lG1PLe0-VrmSWu4dgvw03g",
    place: "Near Cross Lanes, West Virginia",
    shortName: "Cross Lanes",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "classic",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wv-022",
    lat: 39.672114,
    lng: -79.853358,
    panoId: "GvVRyVb3oEhqknClLhbuWQ",
    place: "Near Cheat Lake, West Virginia",
    shortName: "Cheat Lake",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "classic",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wv-023",
    lat: 39.288934,
    lng: -77.859836,
    panoId: "D4O-GuOWUFefcZybhbX5Pg",
    place: "Near Charles Town, West Virginia",
    shortName: "Charles Town",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "classic",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wv-024",
    lat: 39.440886,
    lng: -78.973906,
    panoId: "PjatPG0zxLk79ePXnTge8Q",
    place: "Near Keyser, West Virginia",
    shortName: "Keyser",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "classic",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wv-025",
    lat: 39.611841,
    lng: -79.904309,
    panoId: "bYivTT7r37i4A03sIEqodw",
    place: "Near Brookhaven, West Virginia",
    shortName: "Brookhaven",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "classic",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wv-026",
    lat: 37.366296,
    lng: -81.102728,
    panoId: "zsz9ClfLMvrQa5W31-3_3Q",
    place: "Near Princeton, West Virginia",
    shortName: "Princeton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "classic",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wv-027",
    lat: 39.920288,
    lng: -80.743137,
    panoId: "KobVi7CxUE6KLzI2bpJ39w",
    place: "Near Moundsville, West Virginia",
    shortName: "Moundsville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "classic",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wv-028",
    lat: 38.432638,
    lng: -82.020124,
    panoId: "YPxwD7Y9Y-e4N5mFshmh8A",
    place: "Near Hurricane, West Virginia",
    shortName: "Hurricane",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "classic",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wv-029",
    lat: 37.778218,
    lng: -81.188061,
    panoId: "5KPVbTjnsY88el8i0t4hSg",
    place: "Near Beckley, West Virginia",
    shortName: "Beckley",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "classic",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wv-030",
    lat: 38.368284,
    lng: -81.699519,
    panoId: "pxOtzRnGzvhpk0A4jaAG_Q",
    place: "Near South Charleston, West Virginia",
    shortName: "South Charleston",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "classic",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wv-031",
    lat: 40.418985,
    lng: -80.589578,
    panoId: "g9S9bmV35-LXrWMdfHs5Sw",
    place: "Near Weirton, West Virginia",
    shortName: "Weirton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "classic",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wv-032",
    lat: 38.409516,
    lng: -82.294589,
    panoId: "tGNs30I9WjVqRjl8Jg_HNw",
    place: "Near Barboursville, West Virginia",
    shortName: "Barboursville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "classic",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wv-033",
    lat: 39.634606,
    lng: -79.96974,
    panoId: "MfaZ_Hu82yjlt-MzhIGPEg",
    place: "Near Westover, West Virginia",
    shortName: "Westover",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "classic",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wv-034",
    lat: 39.656906,
    lng: -80.880201,
    panoId: "4GDaU7hufYbf_Sf9NrZGSQ",
    place: "Near New Martinsville, West Virginia",
    shortName: "New Martinsville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "classic",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wv-035",
    lat: 39.436587,
    lng: -77.964779,
    panoId: "d55iYjmSeUCVYTgV2OY71w",
    place: "Near Martinsburg, West Virginia",
    shortName: "Martinsburg",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "classic",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wv-036",
    lat: 38.369599,
    lng: -81.845136,
    panoId: "O6twJEcTaizJtPLAz8uXnw",
    place: "Near Saint Albans, West Virginia",
    shortName: "Saint Albans",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "classic",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wv-037",
    lat: 39.267783,
    lng: -80.347526,
    panoId: "Sw5ZEP8W1KuulQUmUd4_xw",
    place: "Near Clarksburg, West Virginia",
    shortName: "Clarksburg",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "classic",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wv-038",
    lat: 39.485021,
    lng: -80.142803,
    panoId: "0geNlI7zXxI-X7dR0iw9JA",
    place: "Near Fairmont, West Virginia",
    shortName: "Fairmont",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "classic",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wv-039",
    lat: 38.911645,
    lng: -79.859932,
    panoId: "I5fRRRr_leOfrIMYU7jz_Q",
    place: "Near Elkins, West Virginia",
    shortName: "Elkins",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "classic",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wv-040",
    lat: 37.956556,
    lng: -81.130724,
    panoId: "nQUtS2Y7rrZXw72XaKEnlQ",
    place: "Near Oak Hill, West Virginia",
    shortName: "Oak Hill",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "classic",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wv-041",
    lat: 39.637561,
    lng: -79.94304,
    panoId: "ob5yV_UmFaF93A_QAUeZzQ",
    place: "Near Morgantown, West Virginia",
    shortName: "Morgantown",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "classic",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-wv-042",
    lat: 39.302365,
    lng: -80.247973,
    panoId: "EXdPGchnUMaobDj8Dyvs2w",
    place: "Near Bridgeport, West Virginia",
    shortName: "Bridgeport",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "classic",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wv-043",
    lat: 39.272943,
    lng: -81.536327,
    panoId: "KIPHvlurV-LteBKsIAA0ag",
    place: "Near Parkersburg, West Virginia",
    shortName: "Parkersburg",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "classic",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wv-044",
    lat: 38.974919,
    lng: -80.227908,
    panoId: "nsTCQCpNkAESjpeYaoKrzw",
    place: "Near Buckhannon, West Virginia",
    shortName: "Buckhannon",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "classic",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-wv-045",
    lat: 39.336181,
    lng: -81.560564,
    panoId: "bDeFWYMzm9FIsrZJzLpvwg",
    place: "Near Vienna, West Virginia",
    shortName: "Vienna",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "classic",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wv-046",
    lat: 39.302269,
    lng: -78.657058,
    panoId: "y66D05keGmSXdd634ctO4Q",
    place: "Near Augusta, West Virginia",
    shortName: "Augusta",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "classic",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wv-047",
    lat: 38.429026,
    lng: -81.770075,
    panoId: "yWINrUHBCqOFNIELUF_gLg",
    place: "Near Cross Lanes, West Virginia",
    shortName: "Cross Lanes",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "classic",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wv-048",
    lat: 37.264523,
    lng: -81.297536,
    panoId: "Yn77guk5Hcj1JxIFOM-4kA",
    place: "Near Bluefield, West Virginia",
    shortName: "Bluefield",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "classic",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wv-049",
    lat: 38.356146,
    lng: -81.685333,
    panoId: "4XU0LprHtw6NyrpNYqx_Xg",
    place: "Near South Charleston, West Virginia",
    shortName: "South Charleston",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "classic",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wv-050",
    lat: 38.844514,
    lng: -82.137142,
    panoId: "6Tq0k33sEu3nnuOAW6bb_w",
    place: "Near Point Pleasant, West Virginia",
    shortName: "Point Pleasant",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wv-051",
    lat: 38.528108,
    lng: -81.630951,
    panoId: "8dkN89HiYRppiSmLvFGd5Q",
    place: "Near Sissonville, West Virginia",
    shortName: "Sissonville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wv-052",
    lat: 39.038391,
    lng: -80.467427,
    panoId: "6h1OYJlV0rZ5V9qIOsL9CA",
    place: "Near Weston, West Virginia",
    shortName: "Weston",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wv-053",
    lat: 39.335799,
    lng: -78.599338,
    panoId: "cOwiklK0rtzGZq3-UdvDpg",
    place: "Near Augusta, West Virginia",
    shortName: "Augusta",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wv-054",
    lat: 38.449808,
    lng: -82.300219,
    panoId: "GWlqFiXK9WMqdom2M8Xxyg",
    place: "Near Pea Ridge, West Virginia",
    shortName: "Pea Ridge",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wv-055",
    lat: 40.44623,
    lng: -80.570455,
    panoId: "3403Bj5oKFLKAjx8In9cUA",
    place: "Near Toronto, West Virginia",
    shortName: "Toronto",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wv-056",
    lat: 38.466678,
    lng: -82.412545,
    panoId: "Lz4-4jRDrisfJ0ck9Sy4Rg",
    place: "Near Huntington, West Virginia",
    shortName: "Huntington",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wv-057",
    lat: 38.322744,
    lng: -81.710766,
    panoId: "OXUPPdgFlfsBtwKT4K-QjA",
    place: "Near Dunbar, West Virginia",
    shortName: "Dunbar",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wv-058",
    lat: 39.468025,
    lng: -79.017401,
    panoId: "WyD8Yqt8YD7WZyQAjlzeMg",
    place: "Near Westernport, West Virginia",
    shortName: "Westernport",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wv-059",
    lat: 38.31528,
    lng: -81.744791,
    panoId: "9CsPQHxFoJp2RLuXdh96dg",
    place: "Near Dunbar, West Virginia",
    shortName: "Dunbar",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wv-060",
    lat: 38.455632,
    lng: -81.979807,
    panoId: "MeopyMp-1zM_dhYjC6lBYA",
    place: "Near Hurricane, West Virginia",
    shortName: "Hurricane",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wv-061",
    lat: 39.035042,
    lng: -80.478477,
    panoId: "rfOJqyCSfq_69egBsl5TrA",
    place: "Near Weston, West Virginia",
    shortName: "Weston",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wv-062",
    lat: 39.660123,
    lng: -79.779133,
    panoId: "JI1BYr-oH6WMwBFlh98yBg",
    place: "Near Cheat Lake, West Virginia",
    shortName: "Cheat Lake",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wv-063",
    lat: 39.639997,
    lng: -80.776271,
    panoId: "7y8wpIpR6zFVitIWe2bJBQ",
    place: "Near New Martinsville, West Virginia",
    shortName: "New Martinsville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wv-064",
    lat: 37.767865,
    lng: -81.138042,
    panoId: "o1RYRU62AoaYERFJzQLQ4Q",
    place: "Near Beaver, West Virginia",
    shortName: "Beaver",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wv-065",
    lat: 38.903409,
    lng: -82.142308,
    panoId: "YbUKoMJOw99PQd7cBipFDw",
    place: "Near Point Pleasant, West Virginia",
    shortName: "Point Pleasant",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wv-066",
    lat: 38.44015,
    lng: -82.36107,
    panoId: "oXaj4brmsK56zyeK4cfsxQ",
    place: "Near Pea Ridge, West Virginia",
    shortName: "Pea Ridge",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wv-067",
    lat: 39.322508,
    lng: -80.081175,
    panoId: "3ebfUNnYmybZEfWvcJchJg",
    place: "Near Grafton, West Virginia",
    shortName: "Grafton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wv-068",
    lat: 37.335716,
    lng: -81.059252,
    panoId: "XIbBtJfBAmkHTHhGE_80IQ",
    place: "Near Princeton, West Virginia",
    shortName: "Princeton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wv-069",
    lat: 39.478873,
    lng: -78.011253,
    panoId: "eo6qnDgeK3pTHw3rNlAvhQ",
    place: "Near Martinsburg, West Virginia",
    shortName: "Martinsburg",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wv-070",
    lat: 39.283676,
    lng: -77.768137,
    panoId: "ApZhHqv9uR3VJqCB9r-bWA",
    place: "Near Bolivar, West Virginia",
    shortName: "Bolivar",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-wv-071",
    lat: 38.43844,
    lng: -81.881472,
    panoId: "iezizrGDumtLzlOGhycmwQ",
    place: "Near Nitro, West Virginia",
    shortName: "Nitro",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wv-072",
    lat: 39.043542,
    lng: -80.182681,
    panoId: "u9CGdr0Cym3HqJXJGgA-lA",
    place: "Near Buckhannon, West Virginia",
    shortName: "Buckhannon",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wv-073",
    lat: 38.396286,
    lng: -81.883068,
    panoId: "rA3_C46Pr6tmyEZoXWha4Q",
    place: "Near Nitro, West Virginia",
    shortName: "Nitro",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wv-074",
    lat: 39.392903,
    lng: -79.008032,
    panoId: "flzgh3wxQhj9vQf28g909Q",
    place: "Near Keyser, West Virginia",
    shortName: "Keyser",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wv-075",
    lat: 39.332345,
    lng: -80.347091,
    panoId: "SY2PpfljvJuwEc19cNFogA",
    place: "Near Clarksburg, West Virginia",
    shortName: "Clarksburg",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wv-076",
    lat: 37.306049,
    lng: -81.148422,
    panoId: "BqwQ6Ku_w1PltQ9-bjwkOg",
    place: "Near Bluefield, West Virginia",
    shortName: "Bluefield",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wv-077",
    lat: 39.576537,
    lng: -79.859027,
    panoId: "Vi-MJ4y1EE0efTRBPLBB1Q",
    place: "Near Brookhaven, West Virginia",
    shortName: "Brookhaven",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wv-078",
    lat: 39.233847,
    lng: -81.634606,
    panoId: "3GuWntwvdzWx8jiigyV0Hw",
    place: "Near Lubeck, West Virginia",
    shortName: "Lubeck",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wv-079",
    lat: 38.376364,
    lng: -81.772069,
    panoId: "O9MFFx1Gn32vg1N8vQxNAw",
    place: "Near Dunbar, West Virginia",
    shortName: "Dunbar",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wv-080",
    lat: 38.51669,
    lng: -81.630703,
    panoId: "pejzfHnSG2YILmch1y5mAg",
    place: "Near Sissonville, West Virginia",
    shortName: "Sissonville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wv-081",
    lat: 38.003973,
    lng: -81.154774,
    panoId: "IvtYn6Pip6DOZWBA_Jr88A",
    place: "Near Oak Hill, West Virginia",
    shortName: "Oak Hill",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wv-082",
    lat: 38.408119,
    lng: -82.244851,
    panoId: "ahLWV-XLBtN7kbJMfjF-Zw",
    place: "Near Barboursville, West Virginia",
    shortName: "Barboursville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wv-083",
    lat: 39.937099,
    lng: -80.703222,
    panoId: "_iBy1Gn0Kc-l1_jI-3rbFQ",
    place: "Near Moundsville, West Virginia",
    shortName: "Moundsville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 4,
    verified: true,
  },
];

const CHUNK_5: GeoLocation[] = [
  {
    id: "us-wv-084",
    lat: 39.598654,
    lng: -80.016375,
    panoId: "QM26SFHf8dPwX47dwosAXA",
    place: "Near Westover, West Virginia",
    shortName: "Westover",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wv-085",
    lat: 38.299528,
    lng: -81.696508,
    panoId: "oPhj9Sem3G9eQnqYOZuRfg",
    place: "Near South Charleston, West Virginia",
    shortName: "South Charleston",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wv-086",
    lat: 38.991042,
    lng: -80.427182,
    panoId: "bdTxQmqsexo_L0zkFHy2MA",
    place: "Near Weston, West Virginia",
    shortName: "Weston",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wv-087",
    lat: 38.392563,
    lng: -82.409026,
    panoId: "VwP4gvXzzNt1KRpVB-BCKQ",
    place: "Near Huntington, West Virginia",
    shortName: "Huntington",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wv-088",
    lat: 38.896754,
    lng: -82.182305,
    panoId: "XeLSAdo1O27vaOkBcVkKCA",
    place: "Near Point Pleasant, West Virginia",
    shortName: "Point Pleasant",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wv-089",
    lat: 37.758135,
    lng: -81.254397,
    panoId: "_8cqJBy4WKhSCos_nAHm-g",
    place: "Near Crab Orchard, West Virginia",
    shortName: "Crab Orchard",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wv-090",
    lat: 38.431172,
    lng: -81.893175,
    panoId: "mKGynC7gEKqki3MAjAg1vg",
    place: "Near Teays Valley, West Virginia",
    shortName: "Teays Valley",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wv-091",
    lat: 40.449697,
    lng: -80.646327,
    panoId: "2wXZED2F8ZlMSPqz2CT6dw",
    place: "Near Toronto, West Virginia",
    shortName: "Toronto",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wv-092",
    lat: 37.398505,
    lng: -81.054277,
    panoId: "0PvxDF6VmvMSI6kb4sp9YA",
    place: "Near Princeton, West Virginia",
    shortName: "Princeton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wv-093",
    lat: 38.988117,
    lng: -79.983007,
    panoId: "IWUoWm5Wh3lhchxo2BYO9A",
    place: "Near Belington, West Virginia",
    shortName: "Belington",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wv-094",
    lat: 39.410854,
    lng: -77.962831,
    panoId: "EpIvycU7msw-9k4esD8xjQ",
    place: "Near Martinsburg, West Virginia",
    shortName: "Martinsburg",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wv-095",
    lat: 38.004816,
    lng: -81.814439,
    panoId: "cBoQKceTEbrl8V9JBHmaOA",
    place: "Near Madison, West Virginia",
    shortName: "Madison",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wv-096",
    lat: 39.34988,
    lng: -81.38172,
    panoId: "2KwjwhrYPOhqkRjO8KZd0A",
    place: "Near Reno, West Virginia",
    shortName: "Reno",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wv-097",
    lat: 39.574798,
    lng: -80.099886,
    panoId: "h9my8gZlTdXmgCmGo7o4Sg",
    place: "Near Barrackville, West Virginia",
    shortName: "Barrackville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wv-098",
    lat: 39.280103,
    lng: -79.881593,
    panoId: "mHROQ29IvCUfWo3udmDdtw",
    place: "Near Grafton, West Virginia",
    shortName: "Grafton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wv-099",
    lat: 39.286025,
    lng: -80.080119,
    panoId: "asOP5VZVuT5sDk_7GbhRnA",
    place: "Near Grafton, West Virginia",
    shortName: "Grafton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wv-100",
    lat: 38.823533,
    lng: -81.531258,
    panoId: "3utmtYYAzBS3lPproqqxUw",
    place: "Near Ripley, West Virginia",
    shortName: "Ripley",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wv-101",
    lat: 39.30995,
    lng: -79.592386,
    panoId: "da9vjh6O66HfxqQZKzqVRw",
    place: "Near Terra Alta, West Virginia",
    shortName: "Terra Alta",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wv-102",
    lat: 37.787394,
    lng: -82.262227,
    panoId: "GXhskM5dSERv8TNjl-UHzA",
    place: "Near Williamson, West Virginia",
    shortName: "Williamson",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wv-103",
    lat: 38.553219,
    lng: -82.46624,
    panoId: "zJhnDAVDEqj7TJ3sl9vYmQ",
    place: "Near Huntington, West Virginia",
    shortName: "Huntington",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wv-104",
    lat: 38.617352,
    lng: -81.71322,
    panoId: "t30y3pOjEu7avbQM5uO1mA",
    place: "Near Sissonville, West Virginia",
    shortName: "Sissonville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wv-105",
    lat: 39.449849,
    lng: -80.827028,
    panoId: "Ap0devhMyhnBJ4g4TxO3gQ",
    place: "Near Middlebourne, West Virginia",
    shortName: "Middlebourne",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wv-106",
    lat: 37.563479,
    lng: -80.910437,
    panoId: "ZMxUbqUtsp2sYCLr7Zi2dQ",
    place: "Near Hinton, West Virginia",
    shortName: "Hinton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wv-107",
    lat: 39.913091,
    lng: -80.531866,
    panoId: "pYfW8_DnzdlAjGnayA1gSw",
    place: "Near Moundsville, West Virginia",
    shortName: "Moundsville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wv-108",
    lat: 39.653968,
    lng: -80.165919,
    panoId: "ka30a9mnujq1o1R3UJjtoQ",
    place: "Near Granville, West Virginia",
    shortName: "Granville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wv-109",
    lat: 39.55557,
    lng: -79.475803,
    panoId: "P2nnKjg6_PZ3Yh096yJ1lw",
    place: "Near Terra Alta, West Virginia",
    shortName: "Terra Alta",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wv-110",
    lat: 38.185968,
    lng: -80.744738,
    panoId: "rXFghlCBvw3H1W0cGTtriw",
    place: "Near Summersville, West Virginia",
    shortName: "Summersville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wv-111",
    lat: 37.995627,
    lng: -80.47329,
    panoId: "84yjT3j3G-Xlwnban7zMvQ",
    place: "Near Lewisburg, West Virginia",
    shortName: "Lewisburg",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WV",
    state: "West Virginia",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-WV"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wi-000",
    lat: 43.801422,
    lng: -91.239598,
    panoId: "P0O9AGliBsmuX8kT3K1cbg",
    place: "Near La Crosse, Wisconsin",
    shortName: "La Crosse",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WI",
    state: "Wisconsin",
    difficulty: "classic",
    pools: ["world","North America","US","US-WI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wi-001",
    lat: 42.725966,
    lng: -87.782894,
    panoId: "9UX2cYnnYi5hWR_Bc2BqTQ",
    place: "Near Racine, Wisconsin",
    shortName: "Racine",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WI",
    state: "Wisconsin",
    difficulty: "classic",
    pools: ["world","North America","US","US-WI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wi-002",
    lat: 44.519252,
    lng: -88.01982,
    panoId: "nfAiiR3xg_du8cjU5hWK6A",
    place: "Near Green Bay, Wisconsin",
    shortName: "Green Bay",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WI",
    state: "Wisconsin",
    difficulty: "classic",
    pools: ["world","North America","US","US-WI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wi-003",
    lat: 43.77504,
    lng: -88.438963,
    panoId: "zytb5wVLADL-h0-4q7sljg",
    place: "Near Fond du Lac, Wisconsin",
    shortName: "Fond du Lac",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WI",
    state: "Wisconsin",
    difficulty: "classic",
    pools: ["world","North America","US","US-WI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wi-004",
    lat: 44.523472,
    lng: -89.574531,
    panoId: "3x-RapmbkES9xFun_rW8_g",
    place: "Near Stevens Point, Wisconsin",
    shortName: "Stevens Point",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WI",
    state: "Wisconsin",
    difficulty: "classic",
    pools: ["world","North America","US","US-WI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wi-005",
    lat: 43.038867,
    lng: -87.906489,
    panoId: "wWeBMiXbKHxdKfju0f_N8w",
    place: "Near Milwaukee, Wisconsin",
    shortName: "Milwaukee",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WI",
    state: "Wisconsin",
    difficulty: "classic",
    pools: ["world","North America","US","US-WI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wi-006",
    lat: 42.553032,
    lng: -87.933413,
    panoId: "xOlDOIomzqHVZjMXDNnsfQ",
    place: "Near Pleasant Prairie, Wisconsin",
    shortName: "Pleasant Prairie",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WI",
    state: "Wisconsin",
    difficulty: "classic",
    pools: ["world","North America","US","US-WI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wi-007",
    lat: 44.383591,
    lng: -89.817146,
    panoId: "ixXXm-UDkDIdQcMzoi-tZA",
    place: "Near Wisconsin Rapids, Wisconsin",
    shortName: "Wisconsin Rapids",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WI",
    state: "Wisconsin",
    difficulty: "classic",
    pools: ["world","North America","US","US-WI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wi-008",
    lat: 44.482215,
    lng: -88.070031,
    panoId: "iTNaJCAYIOpEXHPe9hlVYQ",
    place: "Near Ashwaubenon, Wisconsin",
    shortName: "Ashwaubenon",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WI",
    state: "Wisconsin",
    difficulty: "classic",
    pools: ["world","North America","US","US-WI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wi-009",
    lat: 43.097209,
    lng: -89.504294,
    panoId: "dYYldTM97VoovFOXUFsrng",
    place: "Near Middleton, Wisconsin",
    shortName: "Middleton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WI",
    state: "Wisconsin",
    difficulty: "classic",
    pools: ["world","North America","US","US-WI"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-wi-010",
    lat: 44.875546,
    lng: -91.919277,
    panoId: "vmjT_H_l-zzbcVHplHzr2g",
    place: "Near Menomonie, Wisconsin",
    shortName: "Menomonie",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WI",
    state: "Wisconsin",
    difficulty: "classic",
    pools: ["world","North America","US","US-WI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wi-011",
    lat: 44.959093,
    lng: -89.630173,
    panoId: "iJhOz6RDC3SuM0S4xPGsvg",
    place: "Near Wausau, Wisconsin",
    shortName: "Wausau",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WI",
    state: "Wisconsin",
    difficulty: "classic",
    pools: ["world","North America","US","US-WI"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-wi-012",
    lat: 44.261872,
    lng: -88.415398,
    panoId: "IpYbaTS5JgrFw7FA5E60FA",
    place: "Near Appleton, Wisconsin",
    shortName: "Appleton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WI",
    state: "Wisconsin",
    difficulty: "classic",
    pools: ["world","North America","US","US-WI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wi-013",
    lat: 43.846313,
    lng: -91.248178,
    panoId: "u6evdjQ_e4QsiVzCo71fKw",
    place: "Near North La Crosse, Wisconsin",
    shortName: "North La Crosse",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WI",
    state: "Wisconsin",
    difficulty: "classic",
    pools: ["world","North America","US","US-WI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wi-014",
    lat: 42.508322,
    lng: -89.031742,
    panoId: "RoR3l42v94C46WrrnqUvRA",
    place: "Near Beloit, Wisconsin",
    shortName: "Beloit",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WI",
    state: "Wisconsin",
    difficulty: "classic",
    pools: ["world","North America","US","US-WI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wi-015",
    lat: 43.425208,
    lng: -88.183546,
    panoId: "T2utdXTqob8caScb0T1bWw",
    place: "Near West Bend, Wisconsin",
    shortName: "West Bend",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WI",
    state: "Wisconsin",
    difficulty: "classic",
    pools: ["world","North America","US","US-WI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wi-016",
    lat: 43.884464,
    lng: -91.235113,
    panoId: "8QUgx_H9reaK-egsjQR6tw",
    place: "Near Onalaska, Wisconsin",
    shortName: "Onalaska",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WI",
    state: "Wisconsin",
    difficulty: "classic",
    pools: ["world","North America","US","US-WI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wi-017",
    lat: 42.960834,
    lng: -89.469706,
    panoId: "OoB0SSv35rfE2GLME-9dkQ",
    place: "Near Fitchburg, Wisconsin",
    shortName: "Fitchburg",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WI",
    state: "Wisconsin",
    difficulty: "classic",
    pools: ["world","North America","US","US-WI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wi-018",
    lat: 46.720744,
    lng: -92.104015,
    panoId: "k8ELSr-7teSUR2NgQZnJow",
    place: "Near Superior, Wisconsin",
    shortName: "Superior",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WI",
    state: "Wisconsin",
    difficulty: "classic",
    pools: ["world","North America","US","US-WI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wi-019",
    lat: 44.088501,
    lng: -87.657601,
    panoId: "4r1-0_cAKpVYPnjWWjbyXw",
    place: "Near Manitowoc, Wisconsin",
    shortName: "Manitowoc",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WI",
    state: "Wisconsin",
    difficulty: "classic",
    pools: ["world","North America","US","US-WI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wi-020",
    lat: 42.682954,
    lng: -89.018366,
    panoId: "oucb_OtI9vP8-52dpgx_iw",
    place: "Near Janesville, Wisconsin",
    shortName: "Janesville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WI",
    state: "Wisconsin",
    difficulty: "classic",
    pools: ["world","North America","US","US-WI"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-wi-021",
    lat: 44.668991,
    lng: -90.172081,
    panoId: "An3aQyFrSJwjWEidJ-GcBA",
    place: "Near Marshfield, Wisconsin",
    shortName: "Marshfield",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WI",
    state: "Wisconsin",
    difficulty: "classic",
    pools: ["world","North America","US","US-WI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wi-022",
    lat: 44.185843,
    lng: -88.462512,
    panoId: "u_IOG0kCt-vUysMnT6iQag",
    place: "Near Neenah, Wisconsin",
    shortName: "Neenah",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WI",
    state: "Wisconsin",
    difficulty: "classic",
    pools: ["world","North America","US","US-WI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wi-023",
    lat: 43.111641,
    lng: -88.499473,
    panoId: "kpqJYkqifFClUrzHxVgMuw",
    place: "Near Oconomowoc, Wisconsin",
    shortName: "Oconomowoc",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WI",
    state: "Wisconsin",
    difficulty: "classic",
    pools: ["world","North America","US","US-WI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wi-024",
    lat: 44.202034,
    lng: -88.446511,
    panoId: "9ixrr_seg_a6PVMECGrTVw",
    place: "Near Menasha, Wisconsin",
    shortName: "Menasha",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WI",
    state: "Wisconsin",
    difficulty: "classic",
    pools: ["world","North America","US","US-WI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wi-025",
    lat: 44.448844,
    lng: -88.060458,
    panoId: "IwMgrqs-nMxOYykLSudD5g",
    place: "Near De Pere, Wisconsin",
    shortName: "De Pere",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WI",
    state: "Wisconsin",
    difficulty: "classic",
    pools: ["world","North America","US","US-WI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wi-026",
    lat: 42.584759,
    lng: -87.821183,
    panoId: "T0sLII-UGurtzfuX-Jh9LQ",
    place: "Near Kenosha, Wisconsin",
    shortName: "Kenosha",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WI",
    state: "Wisconsin",
    difficulty: "classic",
    pools: ["world","North America","US","US-WI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wi-027",
    lat: 44.54363,
    lng: -88.088093,
    panoId: "bLW5g5yoxrS9OJeMjT0OAA",
    place: "Near Howard, Wisconsin",
    shortName: "Howard",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WI",
    state: "Wisconsin",
    difficulty: "classic",
    pools: ["world","North America","US","US-WI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wi-028",
    lat: 44.02469,
    lng: -88.542597,
    panoId: "vmcM67PJ5JMI4YYLYwLGnQ",
    place: "Near Oshkosh, Wisconsin",
    shortName: "Oshkosh",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WI",
    state: "Wisconsin",
    difficulty: "classic",
    pools: ["world","North America","US","US-WI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wi-029",
    lat: 43.194855,
    lng: -88.728937,
    panoId: "ucELeEHz6NPOR2En_7TiUg",
    place: "Near Watertown, Wisconsin",
    shortName: "Watertown",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WI",
    state: "Wisconsin",
    difficulty: "classic",
    pools: ["world","North America","US","US-WI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wi-030",
    lat: 44.811332,
    lng: -91.498476,
    panoId: "u43-J0KdRxBWY6Y3yTLJdg",
    place: "Near Eau Claire, Wisconsin",
    shortName: "Eau Claire",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WI",
    state: "Wisconsin",
    difficulty: "classic",
    pools: ["world","North America","US","US-WI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wi-031",
    lat: 43.457759,
    lng: -88.836944,
    panoId: "_CW3_VTglkeTlkw-b5B8ew",
    place: "Near Beaver Dam, Wisconsin",
    shortName: "Beaver Dam",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WI",
    state: "Wisconsin",
    difficulty: "classic",
    pools: ["world","North America","US","US-WI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wi-032",
    lat: 43.750874,
    lng: -87.714515,
    panoId: "o8jeCeCc2FotsFEvW1EmKg",
    place: "Near Sheboygan, Wisconsin",
    shortName: "Sheboygan",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WI",
    state: "Wisconsin",
    difficulty: "classic",
    pools: ["world","North America","US","US-WI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wi-033",
    lat: 43.183602,
    lng: -89.213588,
    panoId: "fu-xo_V_aFpTlAd85Qu_aw",
    place: "Near Sun Prairie, Wisconsin",
    shortName: "Sun Prairie",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WI",
    state: "Wisconsin",
    difficulty: "classic",
    pools: ["world","North America","US","US-WI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wi-034",
    lat: 43.073284,
    lng: -89.401223,
    panoId: "srMuU9EFstBKP2H07-_oXQ",
    place: "Near Madison, Wisconsin",
    shortName: "Madison",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WI",
    state: "Wisconsin",
    difficulty: "classic",
    pools: ["world","North America","US","US-WI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wi-035",
    lat: 43.011599,
    lng: -88.231462,
    panoId: "Nvp4pZ9_DaDahPBMl6nFgw",
    place: "Near Waukesha, Wisconsin",
    shortName: "Waukesha",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WI",
    state: "Wisconsin",
    difficulty: "classic",
    pools: ["world","North America","US","US-WI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wi-036",
    lat: 44.887488,
    lng: -89.54759,
    panoId: "Hb-fTeoOWuMk0_YFWb_Djw",
    place: "Near Weston, Wisconsin",
    shortName: "Weston",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WI",
    state: "Wisconsin",
    difficulty: "classic",
    pools: ["world","North America","US","US-WI"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-wi-037",
    lat: 44.255984,
    lng: -88.387571,
    panoId: "MdaXgfwFR6r32u1Ic2tDjA",
    place: "Near Appleton, Wisconsin",
    shortName: "Appleton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WI",
    state: "Wisconsin",
    difficulty: "classic",
    pools: ["world","North America","US","US-WI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wi-038",
    lat: 44.527421,
    lng: -89.548377,
    panoId: "ma0hgd_VmO9xcUjJyGvYTA",
    place: "Near Stevens Point, Wisconsin",
    shortName: "Stevens Point",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WI",
    state: "Wisconsin",
    difficulty: "classic",
    pools: ["world","North America","US","US-WI"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-wi-039",
    lat: 44.444112,
    lng: -87.920141,
    panoId: "Bh95f9lafxFGHB8RKogroQ",
    place: "Near Bellevue, Wisconsin",
    shortName: "Bellevue",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WI",
    state: "Wisconsin",
    difficulty: "classic",
    pools: ["world","North America","US","US-WI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wi-040",
    lat: 44.400491,
    lng: -89.818003,
    panoId: "U8qvlhDS9RTT4wMr5CBLnQ",
    place: "Near Wisconsin Rapids, Wisconsin",
    shortName: "Wisconsin Rapids",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WI",
    state: "Wisconsin",
    difficulty: "classic",
    pools: ["world","North America","US","US-WI"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-wi-041",
    lat: 44.014187,
    lng: -88.560254,
    panoId: "EFXOcntfiY1NS3vKOKGOmA",
    place: "Near Oshkosh, Wisconsin",
    shortName: "Oshkosh",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WI",
    state: "Wisconsin",
    difficulty: "classic",
    pools: ["world","North America","US","US-WI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wi-042",
    lat: 43.049328,
    lng: -87.900055,
    panoId: "3YEADt0Xn6KJNLoJ5GefBg",
    place: "Near Milwaukee, Wisconsin",
    shortName: "Milwaukee",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WI",
    state: "Wisconsin",
    difficulty: "classic",
    pools: ["world","North America","US","US-WI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wi-043",
    lat: 43.084794,
    lng: -89.379414,
    panoId: "rfQg4ZV-x1ZIpy8hibR6kA",
    place: "Near Madison, Wisconsin",
    shortName: "Madison",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WI",
    state: "Wisconsin",
    difficulty: "classic",
    pools: ["world","North America","US","US-WI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wi-044",
    lat: 42.543968,
    lng: -87.945993,
    panoId: "DUf8H2CySBnffmLJHXjtmA",
    place: "Near Pleasant Prairie, Wisconsin",
    shortName: "Pleasant Prairie",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WI",
    state: "Wisconsin",
    difficulty: "classic",
    pools: ["world","North America","US","US-WI"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-wi-045",
    lat: 43.081246,
    lng: -89.518209,
    panoId: "Bxrxl-XTdA7VB_LeAFWk2Q",
    place: "Near Middleton, Wisconsin",
    shortName: "Middleton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WI",
    state: "Wisconsin",
    difficulty: "classic",
    pools: ["world","North America","US","US-WI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wi-046",
    lat: 43.826198,
    lng: -91.254519,
    panoId: "0fdAk_p7YfUlo3eQ_PRi5Q",
    place: "Near North La Crosse, Wisconsin",
    shortName: "North La Crosse",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WI",
    state: "Wisconsin",
    difficulty: "classic",
    pools: ["world","North America","US","US-WI"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-wi-047",
    lat: 44.888594,
    lng: -91.913022,
    panoId: "8ha3GRQv5htCyhrDPVyoGg",
    place: "Near Menomonie, Wisconsin",
    shortName: "Menomonie",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WI",
    state: "Wisconsin",
    difficulty: "classic",
    pools: ["world","North America","US","US-WI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wi-048",
    lat: 44.440413,
    lng: -88.046423,
    panoId: "qY0Xp0t_YF1wFCFIOoP7og",
    place: "Near De Pere, Wisconsin",
    shortName: "De Pere",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WI",
    state: "Wisconsin",
    difficulty: "classic",
    pools: ["world","North America","US","US-WI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wi-049",
    lat: 43.201929,
    lng: -89.228233,
    panoId: "Af08ApXxcthmHjlasnl3tg",
    place: "Near Sun Prairie, Wisconsin",
    shortName: "Sun Prairie",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WI",
    state: "Wisconsin",
    difficulty: "classic",
    pools: ["world","North America","US","US-WI"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-wi-050",
    lat: 42.716322,
    lng: -87.817351,
    panoId: "Rx7JV3PfrLt4jqVBe9u-xA",
    place: "Near Racine, Wisconsin",
    shortName: "Racine",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WI",
    state: "Wisconsin",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wi-051",
    lat: 44.713092,
    lng: -90.1156,
    panoId: "UXCqSC5imdttAVOyHQLLjg",
    place: "Near Marshfield, Wisconsin",
    shortName: "Marshfield",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WI",
    state: "Wisconsin",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wi-052",
    lat: 43.165493,
    lng: -89.241826,
    panoId: "cemuwNiKZUkfiiK02AboOA",
    place: "Near Sun Prairie, Wisconsin",
    shortName: "Sun Prairie",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WI",
    state: "Wisconsin",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wi-053",
    lat: 43.780117,
    lng: -87.735673,
    panoId: "PcCBn7lSVreXZIPUdRIc_A",
    place: "Near Sheboygan, Wisconsin",
    shortName: "Sheboygan",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WI",
    state: "Wisconsin",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wi-054",
    lat: 46.659166,
    lng: -92.064574,
    panoId: "H9HxkbiK6xJFvi0XAONFsw",
    place: "Near Superior, Wisconsin",
    shortName: "Superior",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WI",
    state: "Wisconsin",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wi-055",
    lat: 43.047434,
    lng: -88.260517,
    panoId: "aWxFVAuUzs4th5zUDpBJZA",
    place: "Near Pewaukee, Wisconsin",
    shortName: "Pewaukee",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WI",
    state: "Wisconsin",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wi-056",
    lat: 44.907484,
    lng: -92.583697,
    panoId: "Rov1I78NWYWdCrT18Pf-dg",
    place: "Near River Falls, Wisconsin",
    shortName: "River Falls",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WI",
    state: "Wisconsin",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wi-057",
    lat: 43.407748,
    lng: -88.872024,
    panoId: "I4wvhFJ-vPyXye0hFEcXPA",
    place: "Near Beaver Dam, Wisconsin",
    shortName: "Beaver Dam",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WI",
    state: "Wisconsin",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wi-058",
    lat: 43.867691,
    lng: -91.311159,
    panoId: "nSTEJM1XomyshkA261wpKQ",
    place: "Near French Island, Wisconsin",
    shortName: "French Island",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WI",
    state: "Wisconsin",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WI"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-wi-059",
    lat: 43.241254,
    lng: -88.672656,
    panoId: "0NZ0aw6SbZifYPhNClRI7Q",
    place: "Near Watertown, Wisconsin",
    shortName: "Watertown",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WI",
    state: "Wisconsin",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wi-060",
    lat: 44.389001,
    lng: -89.905094,
    panoId: "-TFjaGpYEKJiAzzJZdhxHA",
    place: "Near Port Edwards, Wisconsin",
    shortName: "Port Edwards",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WI",
    state: "Wisconsin",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WI"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-wi-061",
    lat: 43.450107,
    lng: -88.241497,
    panoId: "IQQwpdaDDZQAmDDjmnwchA",
    place: "Near Barton, Wisconsin",
    shortName: "Barton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WI",
    state: "Wisconsin",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wi-062",
    lat: 42.524168,
    lng: -88.010103,
    panoId: "X2Rl-v4e5U36Y6XGw__SEQ",
    place: "Near Bristol, Wisconsin",
    shortName: "Bristol",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WI",
    state: "Wisconsin",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wi-063",
    lat: 44.221245,
    lng: -88.52424,
    panoId: "3hJ615idLReCk5SJ_if6nA",
    place: "Near Neenah, Wisconsin",
    shortName: "Neenah",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WI",
    state: "Wisconsin",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wi-064",
    lat: 44.043897,
    lng: -88.583044,
    panoId: "CWybH4afdFFwzcNxWYvs8g",
    place: "Near Oshkosh, Wisconsin",
    shortName: "Oshkosh",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WI",
    state: "Wisconsin",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wi-065",
    lat: 44.898461,
    lng: -89.454818,
    panoId: "7GfatGcP8VQzr97LEKkGag",
    place: "Near Weston, Wisconsin",
    shortName: "Weston",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WI",
    state: "Wisconsin",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wi-066",
    lat: 43.082558,
    lng: -88.500282,
    panoId: "vkDflslFo3uZ0TWsK06xhQ",
    place: "Near Oconomowoc, Wisconsin",
    shortName: "Oconomowoc",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WI",
    state: "Wisconsin",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wi-067",
    lat: 42.661042,
    lng: -89.059626,
    panoId: "SLITAbAyj0keeUyqoEnYzg",
    place: "Near Janesville, Wisconsin",
    shortName: "Janesville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WI",
    state: "Wisconsin",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wi-068",
    lat: 44.84575,
    lng: -91.853701,
    panoId: "RIZKIwjPkSyEifD_3dbN4A",
    place: "Near Menomonie, Wisconsin",
    shortName: "Menomonie",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WI",
    state: "Wisconsin",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wi-069",
    lat: 44.550829,
    lng: -88.040436,
    panoId: "_dYlfaiG-VgNkYtzE5Ql0A",
    place: "Near Howard, Wisconsin",
    shortName: "Howard",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WI",
    state: "Wisconsin",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wi-070",
    lat: 42.948429,
    lng: -88.235242,
    panoId: "M1pREue-tY1VF7Hhr4XdQA",
    place: "Near Waukesha, Wisconsin",
    shortName: "Waukesha",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WI",
    state: "Wisconsin",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wi-071",
    lat: 44.135236,
    lng: -87.620511,
    panoId: "J9Nn5NuUAlV-IwWooV4IMA",
    place: "Near Two Rivers, Wisconsin",
    shortName: "Two Rivers",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WI",
    state: "Wisconsin",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wi-072",
    lat: 44.856967,
    lng: -91.560162,
    panoId: "EHyQLwMHQKSI8OaJplot6w",
    place: "Near Eau Claire, Wisconsin",
    shortName: "Eau Claire",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WI",
    state: "Wisconsin",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wi-073",
    lat: 44.880233,
    lng: -92.563626,
    panoId: "GC_zPqoEBVflqyT6kkMWwg",
    place: "Near River Falls, Wisconsin",
    shortName: "River Falls",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WI",
    state: "Wisconsin",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wi-074",
    lat: 43.78428,
    lng: -88.374379,
    panoId: "HgJgO-JlYFXzK2dEJQGA2A",
    place: "Near Fond du Lac, Wisconsin",
    shortName: "Fond du Lac",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WI",
    state: "Wisconsin",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wi-075",
    lat: 44.45368,
    lng: -87.987757,
    panoId: "c5C7-FkX_3DerPnTaKKNsA",
    place: "Near Allouez, Wisconsin",
    shortName: "Allouez",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WI",
    state: "Wisconsin",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wi-076",
    lat: 43.735508,
    lng: -91.256031,
    panoId: "4A9dkEPk746QAFKgoQFmeQ",
    place: "Near La Crosse, Wisconsin",
    shortName: "La Crosse",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WI",
    state: "Wisconsin",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WI"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-wi-077",
    lat: 44.606109,
    lng: -90.180386,
    panoId: "oXFNH0cV355_TeCbkwNibg",
    place: "Near Marshfield, Wisconsin",
    shortName: "Marshfield",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WI",
    state: "Wisconsin",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wi-078",
    lat: 43.019981,
    lng: -87.967689,
    panoId: "WUdqwDeWmp7VSjzKCTPusg",
    place: "Near West Milwaukee, Wisconsin",
    shortName: "West Milwaukee",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WI",
    state: "Wisconsin",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wi-079",
    lat: 44.489308,
    lng: -87.976093,
    panoId: "zIYxY6rSlGyQLfU1rMp0sw",
    place: "Near Allouez, Wisconsin",
    shortName: "Allouez",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WI",
    state: "Wisconsin",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WI"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "us-wi-080",
    lat: 43.189123,
    lng: -88.766794,
    panoId: "4gW2DN3qThEwuROVWnxQ-w",
    place: "Near Watertown, Wisconsin",
    shortName: "Watertown",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WI",
    state: "Wisconsin",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wi-081",
    lat: 43.898501,
    lng: -87.731083,
    panoId: "LVOl8bnGSKlaqbXalcbxxQ",
    place: "Near Cleveland, Wisconsin",
    shortName: "Cleveland",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WI",
    state: "Wisconsin",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wi-082",
    lat: 44.462542,
    lng: -87.86677,
    panoId: "w5zv9PK6lw0QTvpmfozrNg",
    place: "Near Bellevue, Wisconsin",
    shortName: "Bellevue",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WI",
    state: "Wisconsin",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wi-083",
    lat: 43.56757,
    lng: -88.090472,
    panoId: "TlP9MNM0ky70qrDlc9dZLw",
    place: "Near Kohler, Wisconsin",
    shortName: "Kohler",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WI",
    state: "Wisconsin",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wi-084",
    lat: 43.440982,
    lng: -89.295354,
    panoId: "qWffGBeeuhwL8bYmYHml0Q",
    place: "Near Rio, Wisconsin",
    shortName: "Rio",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WI",
    state: "Wisconsin",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wi-085",
    lat: 44.884029,
    lng: -92.749642,
    panoId: "CRCLVepOY9YMhvCtMgZ6lw",
    place: "Near Afton, Wisconsin",
    shortName: "Afton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WI",
    state: "Wisconsin",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wi-086",
    lat: 42.962655,
    lng: -89.65825,
    panoId: "TkJ47n4pZypImBid0HIkTA",
    place: "Near Mount Horeb, Wisconsin",
    shortName: "Mount Horeb",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WI",
    state: "Wisconsin",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wi-087",
    lat: 42.725884,
    lng: -87.832383,
    panoId: "2aZLDCj1I91smHnhLv2fvA",
    place: "Near Mount Pleasant, Wisconsin",
    shortName: "Mount Pleasant",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WI",
    state: "Wisconsin",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wi-088",
    lat: 42.746658,
    lng: -89.240155,
    panoId: "JpasTFum9liI7FSC-xfRfw",
    place: "Near Evansville, Wisconsin",
    shortName: "Evansville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WI",
    state: "Wisconsin",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wi-089",
    lat: 43.064045,
    lng: -88.474264,
    panoId: "yCJfD5N42m_T1dxGwTtX8w",
    place: "Near Dousman, Wisconsin",
    shortName: "Dousman",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WI",
    state: "Wisconsin",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wi-090",
    lat: 45.001971,
    lng: -92.582884,
    panoId: "go8LNCjoSk80HNKC5JiFdw",
    place: "Near Roberts, Wisconsin",
    shortName: "Roberts",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WI",
    state: "Wisconsin",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wi-091",
    lat: 45.009835,
    lng: -91.338253,
    panoId: "xC0NotlN3w9GCEreoxSaAg",
    place: "Near Chippewa Falls, Wisconsin",
    shortName: "Chippewa Falls",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WI",
    state: "Wisconsin",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wi-092",
    lat: 45.027547,
    lng: -87.861239,
    panoId: "KhwoPwCFhfoXNXSJnlVZwg",
    place: "Near Peshtigo, Wisconsin",
    shortName: "Peshtigo",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WI",
    state: "Wisconsin",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wi-093",
    lat: 42.704981,
    lng: -90.307982,
    panoId: "G311DbacHJN9xWildh-82w",
    place: "Near Platteville, Wisconsin",
    shortName: "Platteville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WI",
    state: "Wisconsin",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wi-094",
    lat: 43.384244,
    lng: -89.432389,
    panoId: "gzx6zuGzsdK7Fo64e_osAA",
    place: "Near Poynette, Wisconsin",
    shortName: "Poynette",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WI",
    state: "Wisconsin",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wi-095",
    lat: 43.015354,
    lng: -89.648277,
    panoId: "qMErW1C-EJUp_wDf-tkffA",
    place: "Near Mount Horeb, Wisconsin",
    shortName: "Mount Horeb",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WI",
    state: "Wisconsin",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wi-096",
    lat: 43.042201,
    lng: -89.171835,
    panoId: "mTg6YNHbLfBY_xxCgglncQ",
    place: "Near Cottage Grove, Wisconsin",
    shortName: "Cottage Grove",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WI",
    state: "Wisconsin",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wi-097",
    lat: 44.876979,
    lng: -89.367047,
    panoId: "NPEaNkvNjsmFwxt99rxZqQ",
    place: "Near Bevent, Wisconsin",
    shortName: "Bevent",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WI",
    state: "Wisconsin",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wi-098",
    lat: 43.296305,
    lng: -88.40755,
    panoId: "bZGF5q8qsLineUKe8lI03w",
    place: "Near Hartford, Wisconsin",
    shortName: "Hartford",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WI",
    state: "Wisconsin",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wi-099",
    lat: 44.528267,
    lng: -87.916184,
    panoId: "wW6xs5i3K7WopieEOBrtaw",
    place: "Near Green Bay, Wisconsin",
    shortName: "Green Bay",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WI",
    state: "Wisconsin",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wi-100",
    lat: 44.238977,
    lng: -88.645499,
    panoId: "8Y0TSi6YefSWDlQNIOncXQ",
    place: "Near Hortonville, Wisconsin",
    shortName: "Hortonville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WI",
    state: "Wisconsin",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-WI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wi-101",
    lat: 44.553214,
    lng: -89.365108,
    panoId: "xNAMjipakCE6oCTpb3GUUQ",
    place: "Near Amherst, Wisconsin",
    shortName: "Amherst",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WI",
    state: "Wisconsin",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-WI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wi-102",
    lat: 42.489155,
    lng: -89.531103,
    panoId: "zOuiiDvamyQfC969XerWgA",
    place: "Near Lake Summerset, Wisconsin",
    shortName: "Lake Summerset",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WI",
    state: "Wisconsin",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-WI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wi-103",
    lat: 43.293033,
    lng: -89.765639,
    panoId: "dtnS4y2Ns4q0ulIARPrV7A",
    place: "Near Prairie du Sac, Wisconsin",
    shortName: "Prairie du Sac",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WI",
    state: "Wisconsin",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-WI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wi-104",
    lat: 45.245314,
    lng: -87.510294,
    panoId: "_1X5_c2iX7e3agbbnvw2Bw",
    place: "Near Menominee, Wisconsin",
    shortName: "Menominee",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WI",
    state: "Wisconsin",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-WI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wi-105",
    lat: 45.351706,
    lng: -89.673166,
    panoId: "RLl2HF5oqq5U0PWFK_NQ5w",
    place: "Near Tomahawk, Wisconsin",
    shortName: "Tomahawk",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WI",
    state: "Wisconsin",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-WI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wy-000",
    lat: 43.024946,
    lng: -108.380608,
    panoId: "PEmxtfKydXsxeiALeFHJTA",
    place: "Near Riverton, Wyoming",
    shortName: "Riverton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WY",
    state: "Wyoming",
    difficulty: "classic",
    pools: ["world","North America","US","US-WY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wy-001",
    lat: 41.268333,
    lng: -110.963353,
    panoId: "FWJrxRfOCAKf4__xzgfuPg",
    place: "Near Evanston, Wyoming",
    shortName: "Evanston",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WY",
    state: "Wyoming",
    difficulty: "classic",
    pools: ["world","North America","US","US-WY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wy-002",
    lat: 44.291221,
    lng: -105.502237,
    panoId: "gAlg9bR0A7fwtPhNKAOBwg",
    place: "Near Gillette, Wyoming",
    shortName: "Gillette",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WY",
    state: "Wyoming",
    difficulty: "classic",
    pools: ["world","North America","US","US-WY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wy-003",
    lat: 42.862744,
    lng: -106.314867,
    panoId: "CxAm2qYOG0KdjsI3OvNIYw",
    place: "Near Casper, Wyoming",
    shortName: "Casper",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WY",
    state: "Wyoming",
    difficulty: "classic",
    pools: ["world","North America","US","US-WY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wy-004",
    lat: 42.062459,
    lng: -104.184361,
    panoId: "Qj2f_iEzEDe0pAO2yLoJNw",
    place: "Near Torrington, Wyoming",
    shortName: "Torrington",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WY",
    state: "Wyoming",
    difficulty: "classic",
    pools: ["world","North America","US","US-WY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wy-005",
    lat: 44.526376,
    lng: -109.056327,
    panoId: "_t9DYLAi4r0D2yAC_O6MIQ",
    place: "Near Cody, Wyoming",
    shortName: "Cody",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WY",
    state: "Wyoming",
    difficulty: "classic",
    pools: ["world","North America","US","US-WY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wy-006",
    lat: 42.833043,
    lng: -108.730696,
    panoId: "1pLRMxmWtiIXNW5z0YXiag",
    place: "Near Lander, Wyoming",
    shortName: "Lander",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WY",
    state: "Wyoming",
    difficulty: "classic",
    pools: ["world","North America","US","US-WY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wy-007",
    lat: 41.139785,
    lng: -104.820076,
    panoId: "lqlLG7xhE-rwE4Stgb5-5Q",
    place: "Near Cheyenne, Wyoming",
    shortName: "Cheyenne",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WY",
    state: "Wyoming",
    difficulty: "classic",
    pools: ["world","North America","US","US-WY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wy-008",
    lat: 44.753817,
    lng: -108.757611,
    panoId: "gutVZ-P0Vlg7Yt1iEP3TXA",
    place: "Near Powell, Wyoming",
    shortName: "Powell",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WY",
    state: "Wyoming",
    difficulty: "classic",
    pools: ["world","North America","US","US-WY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wy-009",
    lat: 42.759504,
    lng: -105.382182,
    panoId: "sYSz8UVlPmJL4bW_hLWKhg",
    place: "Near Douglas, Wyoming",
    shortName: "Douglas",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WY",
    state: "Wyoming",
    difficulty: "classic",
    pools: ["world","North America","US","US-WY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wy-010",
    lat: 41.587402,
    lng: -109.203157,
    panoId: "m_TIAS4K0uc-2kT8TW64Ew",
    place: "Near Rock Springs, Wyoming",
    shortName: "Rock Springs",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WY",
    state: "Wyoming",
    difficulty: "classic",
    pools: ["world","North America","US","US-WY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wy-011",
    lat: 44.797256,
    lng: -106.95621,
    panoId: "aAERTKcmz7lIl6CudMqtlw",
    place: "Near Sheridan, Wyoming",
    shortName: "Sheridan",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WY",
    state: "Wyoming",
    difficulty: "classic",
    pools: ["world","North America","US","US-WY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wy-012",
    lat: 41.791073,
    lng: -107.238638,
    panoId: "jHxUUiIZXHlVXfe5TvwuTA",
    place: "Near Rawlins, Wyoming",
    shortName: "Rawlins",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WY",
    state: "Wyoming",
    difficulty: "classic",
    pools: ["world","North America","US","US-WY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wy-013",
    lat: 41.21831,
    lng: -104.790298,
    panoId: "oMki_RJNjzjDpbLKZ6_nCA",
    place: "Near Ranchettes, Wyoming",
    shortName: "Ranchettes",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WY",
    state: "Wyoming",
    difficulty: "classic",
    pools: ["world","North America","US","US-WY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wy-014",
    lat: 44.016841,
    lng: -107.955331,
    panoId: "OQIat9kR8Jh3Sd9ktWKoug",
    place: "Near Worland, Wyoming",
    shortName: "Worland",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WY",
    state: "Wyoming",
    difficulty: "classic",
    pools: ["world","North America","US","US-WY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wy-015",
    lat: 43.479894,
    lng: -110.762355,
    panoId: "_Vf5bnuf12uNl9xRdpvNKA",
    place: "Near Jackson, Wyoming",
    shortName: "Jackson",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WY",
    state: "Wyoming",
    difficulty: "classic",
    pools: ["world","North America","US","US-WY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wy-016",
    lat: 41.528591,
    lng: -109.466273,
    panoId: "ti2dGSDm3-kx9QQjNdCkIQ",
    place: "Near Green River, Wyoming",
    shortName: "Green River",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WY",
    state: "Wyoming",
    difficulty: "classic",
    pools: ["world","North America","US","US-WY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wy-017",
    lat: 41.297323,
    lng: -105.579841,
    panoId: "WUPBqmP-rRlNmtFQfwS2MA",
    place: "Near Laramie, Wyoming",
    shortName: "Laramie",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WY",
    state: "Wyoming",
    difficulty: "classic",
    pools: ["world","North America","US","US-WY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wy-018",
    lat: 41.573614,
    lng: -109.193778,
    panoId: "mdAs7afHWaJ9K9ETfz31dg",
    place: "Near Rock Springs, Wyoming",
    shortName: "Rock Springs",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WY",
    state: "Wyoming",
    difficulty: "classic",
    pools: ["world","North America","US","US-WY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wy-019",
    lat: 42.074563,
    lng: -104.159618,
    panoId: "cIpA_Un8VwbuFzTac-NFEw",
    place: "Near Torrington, Wyoming",
    shortName: "Torrington",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WY",
    state: "Wyoming",
    difficulty: "classic",
    pools: ["world","North America","US","US-WY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wy-020",
    lat: 43.497462,
    lng: -110.75973,
    panoId: "98PAXyGZ9aKh3bqgXAbOUg",
    place: "Near Jackson, Wyoming",
    shortName: "Jackson",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WY",
    state: "Wyoming",
    difficulty: "classic",
    pools: ["world","North America","US","US-WY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wy-021",
    lat: 44.037097,
    lng: -107.940929,
    panoId: "dp2EbDp32DiVVkZ8wPADYw",
    place: "Near Worland, Wyoming",
    shortName: "Worland",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WY",
    state: "Wyoming",
    difficulty: "classic",
    pools: ["world","North America","US","US-WY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wy-022",
    lat: 41.587072,
    lng: -109.217938,
    panoId: "b5sGsee212XeHZqkQEoA1g",
    place: "Near Rock Springs, Wyoming",
    shortName: "Rock Springs",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WY",
    state: "Wyoming",
    difficulty: "classic",
    pools: ["world","North America","US","US-WY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wy-023",
    lat: 42.879786,
    lng: -106.310237,
    panoId: "GllZXZ1xuzJlBpjzfpj4GQ",
    place: "Near Casper, Wyoming",
    shortName: "Casper",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WY",
    state: "Wyoming",
    difficulty: "classic",
    pools: ["world","North America","US","US-WY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wy-024",
    lat: 42.871762,
    lng: -106.291251,
    panoId: "xfWWb66oFDCUA1hi1zm-SA",
    place: "Near Casper, Wyoming",
    shortName: "Casper",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WY",
    state: "Wyoming",
    difficulty: "classic",
    pools: ["world","North America","US","US-WY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wy-025",
    lat: 44.512319,
    lng: -109.065692,
    panoId: "bIp6-gFcwWhI79ec0bb2lQ",
    place: "Near Cody, Wyoming",
    shortName: "Cody",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WY",
    state: "Wyoming",
    difficulty: "classic",
    pools: ["world","North America","US","US-WY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wy-026",
    lat: 44.348346,
    lng: -106.699109,
    panoId: "JcD7LJ1VsjsmOX-2f8kxuA",
    place: "Near Buffalo, Wyoming",
    shortName: "Buffalo",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WY",
    state: "Wyoming",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wy-027",
    lat: 42.054057,
    lng: -104.953231,
    panoId: "xOjng8I6Kq-W67cpXRG9EQ",
    place: "Near Wheatland, Wyoming",
    shortName: "Wheatland",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WY",
    state: "Wyoming",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wy-028",
    lat: 43.8546,
    lng: -104.204772,
    panoId: "wZ4IYE-MHoGAbc0NW3dsoA",
    place: "Near Newcastle, Wyoming",
    shortName: "Newcastle",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WY",
    state: "Wyoming",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wy-029",
    lat: 43.751509,
    lng: -105.492117,
    panoId: "CYcwtD7KEudmW87rCD0ytw",
    place: "Near Wright, Wyoming",
    shortName: "Wright",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WY",
    state: "Wyoming",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wy-030",
    lat: 44.837493,
    lng: -108.389563,
    panoId: "z8v-5CNaoXS1bu56xFgN4g",
    place: "Near Lovell, Wyoming",
    shortName: "Lovell",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WY",
    state: "Wyoming",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wy-031",
    lat: 41.096926,
    lng: -104.806679,
    panoId: "FNvIBzGKbbOH6x8rsBrKzA",
    place: "Near South Greeley, Wyoming",
    shortName: "South Greeley",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WY",
    state: "Wyoming",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wy-032",
    lat: 42.913313,
    lng: -106.343286,
    panoId: "zceIsPvsGReJt3UXId2J4A",
    place: "Near Bar Nunn, Wyoming",
    shortName: "Bar Nunn",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WY",
    state: "Wyoming",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wy-033",
    lat: 41.112138,
    lng: -104.785256,
    panoId: "S5uLxIoFS0ZfhQbTXZRaBQ",
    place: "Near Fox Farm-College, Wyoming",
    shortName: "Fox Farm-College",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WY",
    state: "Wyoming",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wy-034",
    lat: 42.861423,
    lng: -105.872217,
    panoId: "4okKoGSxO_klgzGOkZo6mg",
    place: "Near Glenrock, Wyoming",
    shortName: "Glenrock",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WY",
    state: "Wyoming",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wy-035",
    lat: 41.327441,
    lng: -110.292932,
    panoId: "dr6LOtLedRMYZ-ioXoGUiQ",
    place: "Near Lyman, Wyoming",
    shortName: "Lyman",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WY",
    state: "Wyoming",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wy-036",
    lat: 42.840516,
    lng: -106.365798,
    panoId: "f7509kF366I57SDc15XEow",
    place: "Near Mills, Wyoming",
    shortName: "Mills",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WY",
    state: "Wyoming",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wy-037",
    lat: 41.792318,
    lng: -110.538124,
    panoId: "_1wbnmrmhAYuiEum6DT8pw",
    place: "Near Kemmerer, Wyoming",
    shortName: "Kemmerer",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WY",
    state: "Wyoming",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wy-038",
    lat: 42.859977,
    lng: -106.268307,
    panoId: "VOs7vtbBJyd0r6R4KDrSQQ",
    place: "Near Evansville, Wyoming",
    shortName: "Evansville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WY",
    state: "Wyoming",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wy-039",
    lat: 42.725325,
    lng: -110.931868,
    panoId: "z8mHiLScCnANjGZR6AKetg",
    place: "Near Afton, Wyoming",
    shortName: "Afton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WY",
    state: "Wyoming",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wy-040",
    lat: 44.489096,
    lng: -108.05641,
    panoId: "g_Bs-vNwP5Q7wxuoJX_t4g",
    place: "Near Greybull, Wyoming",
    shortName: "Greybull",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WY",
    state: "Wyoming",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wy-041",
    lat: 41.643715,
    lng: -109.265646,
    panoId: "naLy4TQH2BJop7_hF6y2_w",
    place: "Near North Rock Springs, Wyoming",
    shortName: "North Rock Springs",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WY",
    state: "Wyoming",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wy-042",
    lat: 43.64608,
    lng: -108.211987,
    panoId: "nMdTvl4kf96JBpQ6LyXLLA",
    place: "Near Thermopolis, Wyoming",
    shortName: "Thermopolis",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WY",
    state: "Wyoming",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wy-043",
    lat: 43.421076,
    lng: -110.79195,
    panoId: "DOEo93_OTRz1OlrYgfLNZg",
    place: "Near South Park, Wyoming",
    shortName: "South Park",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WY",
    state: "Wyoming",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wy-044",
    lat: 43.525165,
    lng: -110.842049,
    panoId: "kODl4VWOFSlurVPogruPaQ",
    place: "Near Moose Wilson Road, Wyoming",
    shortName: "Moose Wilson Road",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WY",
    state: "Wyoming",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wy-045",
    lat: 41.45482,
    lng: -106.806438,
    panoId: "i1aGe73nTdsKEYsvg_fVcQ",
    place: "Near Saratoga, Wyoming",
    shortName: "Saratoga",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WY",
    state: "Wyoming",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wy-046",
    lat: 43.006365,
    lng: -108.882419,
    panoId: "_x830e6Yx6xOfGkhRwuIYw",
    place: "Near Fort Washakie, Wyoming",
    shortName: "Fort Washakie",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WY",
    state: "Wyoming",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wy-047",
    lat: 43.741423,
    lng: -105.474778,
    panoId: "iMtsm2sVNkx9IS-jbloUUg",
    place: "Near Wright, Wyoming",
    shortName: "Wright",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WY",
    state: "Wyoming",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wy-048",
    lat: 42.855181,
    lng: -106.239801,
    panoId: "AZebc0_8n5tpVmcX5Jabvg",
    place: "Near Evansville, Wyoming",
    shortName: "Evansville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WY",
    state: "Wyoming",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wy-049",
    lat: 42.877138,
    lng: -105.855786,
    panoId: "jTgBezhbmrZJkbutaBHiKQ",
    place: "Near Glenrock, Wyoming",
    shortName: "Glenrock",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WY",
    state: "Wyoming",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wy-050",
    lat: 41.331176,
    lng: -110.26591,
    panoId: "N1GUw3cf-QHNcSQTDlmgWg",
    place: "Near Lyman, Wyoming",
    shortName: "Lyman",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WY",
    state: "Wyoming",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wy-051",
    lat: 41.113072,
    lng: -104.769564,
    panoId: "ZGUwKJJ4iI5IeM5wt-eaZw",
    place: "Near Fox Farm-College, Wyoming",
    shortName: "Fox Farm-College",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WY",
    state: "Wyoming",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wy-052",
    lat: 42.709908,
    lng: -110.93459,
    panoId: "03LmnZERLYcHnHb97Ep3xg",
    place: "Near Afton, Wyoming",
    shortName: "Afton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WY",
    state: "Wyoming",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wy-053",
    lat: 42.993556,
    lng: -108.34526,
    panoId: "Qp3iETclojK5pof54qfWTg",
    place: "Near Riverton, Wyoming",
    shortName: "Riverton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WY",
    state: "Wyoming",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wy-054",
    lat: 44.504366,
    lng: -109.008635,
    panoId: "CB6m0YKXRSsu_OAgukr-yA",
    place: "Near Cody, Wyoming",
    shortName: "Cody",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WY",
    state: "Wyoming",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wy-055",
    lat: 43.566157,
    lng: -110.82205,
    panoId: "D3qKgF9tGj8C-i8ypFvdBg",
    place: "Near Moose Wilson Road, Wyoming",
    shortName: "Moose Wilson Road",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WY",
    state: "Wyoming",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wy-056",
    lat: 44.823766,
    lng: -108.460657,
    panoId: "5femaLpaXaW62LLNzRqUOg",
    place: "Near Lovell, Wyoming",
    shortName: "Lovell",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WY",
    state: "Wyoming",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wy-057",
    lat: 43.612648,
    lng: -108.2155,
    panoId: "c29aG3BAN8_cebSv64THmg",
    place: "Near Thermopolis, Wyoming",
    shortName: "Thermopolis",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WY",
    state: "Wyoming",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wy-058",
    lat: 41.325937,
    lng: -110.998242,
    panoId: "FaAf6iIbXNyvUfW99bG8JA",
    place: "Near Evanston, Wyoming",
    shortName: "Evanston",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WY",
    state: "Wyoming",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wy-059",
    lat: 44.309101,
    lng: -105.449532,
    panoId: "HU0X_ElguvltWv1pWx2qdA",
    place: "Near Gillette, Wyoming",
    shortName: "Gillette",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WY",
    state: "Wyoming",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wy-060",
    lat: 42.68875,
    lng: -110.989337,
    panoId: "xzNw5em8DdzMz5-G_Dg-HA",
    place: "Near Afton, Wyoming",
    shortName: "Afton",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WY",
    state: "Wyoming",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wy-061",
    lat: 44.548468,
    lng: -108.088788,
    panoId: "WsbvttUXDIDhQPJyPtBQKQ",
    place: "Near Greybull, Wyoming",
    shortName: "Greybull",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WY",
    state: "Wyoming",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wy-062",
    lat: 44.848669,
    lng: -106.979942,
    panoId: "Cue0wTzRYFqhOdWYvTBbDw",
    place: "Near Sheridan, Wyoming",
    shortName: "Sheridan",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WY",
    state: "Wyoming",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wy-063",
    lat: 43.737911,
    lng: -105.544815,
    panoId: "fa7b18BzKF0v7qQe70S7RQ",
    place: "Near Wright, Wyoming",
    shortName: "Wright",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WY",
    state: "Wyoming",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wy-064",
    lat: 42.089375,
    lng: -104.998343,
    panoId: "Jav5S0HcLDsqL6jCUZ4tvQ",
    place: "Near Wheatland, Wyoming",
    shortName: "Wheatland",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WY",
    state: "Wyoming",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wy-065",
    lat: 41.051452,
    lng: -104.739006,
    panoId: "SWkhlIgIwBuvVtYAxG899w",
    place: "Near South Greeley, Wyoming",
    shortName: "South Greeley",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WY",
    state: "Wyoming",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wy-066",
    lat: 42.86269,
    lng: -106.384874,
    panoId: "jcS5ar_fryasfxdJ6RencQ",
    place: "Near Mills, Wyoming",
    shortName: "Mills",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WY",
    state: "Wyoming",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wy-067",
    lat: 42.827251,
    lng: -106.392808,
    panoId: "kB8Yasrv3DSfRGqMJag7bA",
    place: "Near Mills, Wyoming",
    shortName: "Mills",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WY",
    state: "Wyoming",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wy-068",
    lat: 41.17553,
    lng: -104.783364,
    panoId: "0EKybMpkTL08swoWLRhrjw",
    place: "Near Ranchettes, Wyoming",
    shortName: "Ranchettes",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WY",
    state: "Wyoming",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wy-069",
    lat: 44.355556,
    lng: -106.764489,
    panoId: "uRGKp63K3v0a7DSK5c3IBg",
    place: "Near Buffalo, Wyoming",
    shortName: "Buffalo",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WY",
    state: "Wyoming",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wy-070",
    lat: 43.3884,
    lng: -110.767614,
    panoId: "AYfQq5dwPm-MhUtJliwITA",
    place: "Near South Park, Wyoming",
    shortName: "South Park",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WY",
    state: "Wyoming",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wy-071",
    lat: 42.718525,
    lng: -105.376014,
    panoId: "Cghm9urVX7CbdZqqf3abFQ",
    place: "Near Douglas, Wyoming",
    shortName: "Douglas",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WY",
    state: "Wyoming",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wy-072",
    lat: 43.003596,
    lng: -108.842538,
    panoId: "ceB1VVPfcOf1mG_7yPYt3w",
    place: "Near Fort Washakie, Wyoming",
    shortName: "Fort Washakie",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WY",
    state: "Wyoming",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wy-073",
    lat: 41.299784,
    lng: -105.631783,
    panoId: "gc8KU9WVjAVHMH5RQ97rbg",
    place: "Near Laramie, Wyoming",
    shortName: "Laramie",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WY",
    state: "Wyoming",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wy-074",
    lat: 44.818743,
    lng: -107.022426,
    panoId: "ICLSnyKJo84L4yFVWYYYVw",
    place: "Near Sheridan, Wyoming",
    shortName: "Sheridan",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WY",
    state: "Wyoming",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wy-075",
    lat: 43.825777,
    lng: -104.14936,
    panoId: "q4DE_VRn0rgxuEcucb7qgQ",
    place: "Near Newcastle, Wyoming",
    shortName: "Newcastle",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WY",
    state: "Wyoming",
    difficulty: "explorer",
    pools: ["world","North America","US","US-WY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wy-076",
    lat: 42.866617,
    lng: -109.860971,
    panoId: "DvyqjnFsVFtFqL9YF_NvMg",
    place: "Near Pinedale, Wyoming",
    shortName: "Pinedale",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WY",
    state: "Wyoming",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-WY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wy-077",
    lat: 43.800355,
    lng: -104.181124,
    panoId: "h-CC1P8lEa3hYXn54ARmrA",
    place: "Near Newcastle, Wyoming",
    shortName: "Newcastle",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WY",
    state: "Wyoming",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-WY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wy-078",
    lat: 42.853265,
    lng: -109.792563,
    panoId: "LL8oOMnFPsXIaBYzlc5kcg",
    place: "Near Pinedale, Wyoming",
    shortName: "Pinedale",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WY",
    state: "Wyoming",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-WY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wy-079",
    lat: 42.837575,
    lng: -106.015404,
    panoId: "1lSHcyGVW40hCmDlf-AxUg",
    place: "Near Glenrock, Wyoming",
    shortName: "Glenrock",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WY",
    state: "Wyoming",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-WY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wy-080",
    lat: 42.783795,
    lng: -106.148808,
    panoId: "pf707mrK7___LsDsLMPzqw",
    place: "Near Evansville, Wyoming",
    shortName: "Evansville",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WY",
    state: "Wyoming",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-WY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "us-wy-081",
    lat: 43.550997,
    lng: -108.193945,
    panoId: "Ze2-fuDA-U6H6xcZGL0ViA",
    place: "Near Thermopolis, Wyoming",
    shortName: "Thermopolis",
    countryCode: "US",
    country: "United States",
    continent: "North America",
    stateCode: "WY",
    state: "Wyoming",
    difficulty: "adventurer",
    pools: ["world","North America","US","US-WY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fr-000",
    lat: 43.703115,
    lng: 7.266148,
    panoId: "DmQDo-8mZVtiquAs-bLkyg",
    place: "Near Nice, Provence-Alpes-Côte d'Azur",
    shortName: "Nice",
    countryCode: "FR",
    country: "France",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","FR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fr-001",
    lat: 49.493365,
    lng: 0.107843,
    panoId: "h2JEri_-atM0JVUXELXmoA",
    place: "Near Le Havre, Normandy",
    shortName: "Le Havre",
    countryCode: "FR",
    country: "France",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","FR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "fr-002",
    lat: 48.11102,
    lng: -1.674554,
    panoId: "JQDEdsm8717ROmzS_ty9Pg",
    place: "Near Rennes, Brittany",
    shortName: "Rennes",
    countryCode: "FR",
    country: "France",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","FR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fr-003",
    lat: 47.394888,
    lng: 0.704,
    panoId: "QSkhqx4ZwTlUBqUHK0rRqA",
    place: "Near Tours, Centre-Val de Loire",
    shortName: "Tours",
    countryCode: "FR",
    country: "France",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","FR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fr-004",
    lat: 43.61096,
    lng: 3.876417,
    panoId: "mhdcJUzGSGz-7Ikvtk7cEA",
    place: "Near Montpellier, Occitanie",
    shortName: "Montpellier",
    countryCode: "FR",
    country: "France",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","FR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fr-005",
    lat: 43.124436,
    lng: 5.928421,
    panoId: "3un1__FxOzLyup8lUs10KQ",
    place: "Near Toulon, Provence-Alpes-Côte d'Azur",
    shortName: "Toulon",
    countryCode: "FR",
    country: "France",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","FR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fr-006",
    lat: 49.900006,
    lng: 2.30027,
    panoId: "jRkOMpduoU9pN4OsL_0ugQ",
    place: "Near Amiens, Hauts-de-France",
    shortName: "Amiens",
    countryCode: "FR",
    country: "France",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","FR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fr-007",
    lat: 45.833666,
    lng: 1.24759,
    panoId: "yNhkpjfXqJf3gKwvHAFYmQ",
    place: "Near Limoges, New Aquitaine",
    shortName: "Limoges",
    countryCode: "FR",
    country: "France",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","FR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fr-008",
    lat: 45.433843,
    lng: 4.389915,
    panoId: "2T7ujKgfHJdkqJoNlt2p6A",
    place: "Near Saint-Étienne, Rhône-Alpes",
    shortName: "Saint-Étienne",
    countryCode: "FR",
    country: "France",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","FR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fr-009",
    lat: 43.297002,
    lng: 5.381183,
    panoId: "Po89bw9AM0uwre2otN0AKQ",
    place: "Near Marseille, Provence-Alpes-Côte d'Azur",
    shortName: "Marseille",
    countryCode: "FR",
    country: "France",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","FR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fr-010",
    lat: 47.313459,
    lng: 5.013982,
    panoId: "BYozRd0bh_1gbKhv_wEWjA",
    place: "Near Dijon, Bourgogne",
    shortName: "Dijon",
    countryCode: "FR",
    country: "France",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","FR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fr-011",
    lat: 47.471576,
    lng: -0.55202,
    panoId: "2HFhbaHlWQItkyaSdlXzLg",
    place: "Near Angers, Pays de la Loire",
    shortName: "Angers",
    countryCode: "FR",
    country: "France",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","FR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fr-012",
    lat: 48.00213,
    lng: 0.20252,
    panoId: "NetPKLnOwCsx77Yh3eB8hw",
    place: "Near Le Mans, Pays de la Loire",
    shortName: "Le Mans",
    countryCode: "FR",
    country: "France",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","FR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fr-013",
    lat: 48.583994,
    lng: 7.745512,
    panoId: "naLxDYRzqlGCJ2ZV5OF8XA",
    place: "Near Strasbourg, Grand Est",
    shortName: "Strasbourg",
    countryCode: "FR",
    country: "France",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","FR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fr-014",
    lat: 49.443027,
    lng: 1.099347,
    panoId: "hgFNdma1l6x1SOQomIWGXw",
    place: "Near Rouen, Normandy",
    shortName: "Rouen",
    countryCode: "FR",
    country: "France",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","FR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fr-015",
    lat: 45.178776,
    lng: 5.71483,
    panoId: "WRc_WlHFRskeYqxa1gNi_A",
    place: "Near Grenoble, Rhône-Alpes",
    shortName: "Grenoble",
    countryCode: "FR",
    country: "France",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","FR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fr-016",
    lat: 50.633929,
    lng: 3.055118,
    panoId: "JMlmiSMX455vven6TmCbag",
    place: "Near Lille, Hauts-de-France",
    shortName: "Lille",
    countryCode: "FR",
    country: "France",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","FR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fr-017",
    lat: 47.902681,
    lng: 1.904056,
    panoId: "6P-Fs4Zhk7cIwo784VmYfg",
    place: "Near Orléans, Centre-Val de Loire",
    shortName: "Orléans",
    countryCode: "FR",
    country: "France",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","FR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fr-018",
    lat: 43.948345,
    lng: 4.808884,
    panoId: "ihvNSeAGad4_hlV37Xl_gw",
    place: "Near Avignon, Provence-Alpes-Côte d'Azur",
    shortName: "Avignon",
    countryCode: "FR",
    country: "France",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","FR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fr-019",
    lat: 47.751985,
    lng: 7.328352,
    panoId: "CGlin3JQWzJ2e1WwftTEjQ",
    place: "Near Mulhouse, Grand Est",
    shortName: "Mulhouse",
    countryCode: "FR",
    country: "France",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","FR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "fr-020",
    lat: 42.697642,
    lng: 2.895518,
    panoId: "l2BZNr-vGb6rn0HUs28ipw",
    place: "Near Perpignan, Occitanie",
    shortName: "Perpignan",
    countryCode: "FR",
    country: "France",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","FR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fr-021",
    lat: 48.390257,
    lng: -4.486324,
    panoId: "Umg3zTDR5jWro-6eombAkQ",
    place: "Near Brest, Brittany",
    shortName: "Brest",
    countryCode: "FR",
    country: "France",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","FR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fr-022",
    lat: 48.684588,
    lng: 6.185634,
    panoId: "63gEfHo6HWhMcoWKSqI9kA",
    place: "Near Nancy, Grand Est",
    shortName: "Nancy",
    countryCode: "FR",
    country: "France",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","FR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fr-023",
    lat: 49.185919,
    lng: -0.359116,
    panoId: "8oUP17WYmwobZWRFWDro7Q",
    place: "Near Caen, Normandy",
    shortName: "Caen",
    countryCode: "FR",
    country: "France",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","FR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fr-024",
    lat: 45.779447,
    lng: 3.086867,
    panoId: "wvny2nxcpEqbjJOHSJu52A",
    place: "Near Clermont-Ferrand, Rhône-Alpes",
    shortName: "Clermont-Ferrand",
    countryCode: "FR",
    country: "France",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","FR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fr-025",
    lat: 47.217244,
    lng: -1.553323,
    panoId: "UChc4YnV-cnYtquEgvUJcg",
    place: "Near Nantes, Pays de la Loire",
    shortName: "Nantes",
    countryCode: "FR",
    country: "France",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","FR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fr-026",
    lat: 45.749081,
    lng: 4.847862,
    panoId: "bFjCXjHzF_7RTFWFarCexw",
    place: "Near Lyon, Rhône-Alpes",
    shortName: "Lyon",
    countryCode: "FR",
    country: "France",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","FR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fr-027",
    lat: 44.84122,
    lng: -0.580115,
    panoId: "5O8aTaS7M8uUbHpzy5ScSw",
    place: "Near Bordeaux, New Aquitaine",
    shortName: "Bordeaux",
    countryCode: "FR",
    country: "France",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","FR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "fr-028",
    lat: 49.119263,
    lng: 6.172812,
    panoId: "ai45aQFcXRCxa8R5TkvIoA",
    place: "Near Metz, Grand Est",
    shortName: "Metz",
    countryCode: "FR",
    country: "France",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","FR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fr-029",
    lat: 50.724118,
    lng: 3.160663,
    panoId: "eqrKMHSLGP8vS_kQ_-9Cmw",
    place: "Near Tourcoing, Hauts-de-France",
    shortName: "Tourcoing",
    countryCode: "FR",
    country: "France",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","FR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fr-030",
    lat: 43.836692,
    lng: 4.357858,
    panoId: "HsZzC5LVaOjyQex2Xoa3dw",
    place: "Near Nîmes, Occitanie",
    shortName: "Nîmes",
    countryCode: "FR",
    country: "France",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","FR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fr-031",
    lat: 47.248793,
    lng: 6.018159,
    panoId: "kOMMiODB--MiZqMoJ1IDmg",
    place: "Near Besançon, Bourgogne",
    shortName: "Besançon",
    countryCode: "FR",
    country: "France",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","FR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fr-032",
    lat: 49.265397,
    lng: 4.028762,
    panoId: "gBHFUdC8Ugr245uxwk0pGw",
    place: "Near Reims, Grand Est",
    shortName: "Reims",
    countryCode: "FR",
    country: "France",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","FR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fr-033",
    lat: 46.582591,
    lng: 0.34344,
    panoId: "dpcmZvKuriVszzRbesNlCw",
    place: "Near Poitiers, New Aquitaine",
    shortName: "Poitiers",
    countryCode: "FR",
    country: "France",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","FR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "fr-034",
    lat: 48.803386,
    lng: 2.134121,
    panoId: "onM_jhTOqXsZNk_0ig_i7Q",
    place: "Near Versailles, Île-de-France",
    shortName: "Versailles",
    countryCode: "FR",
    country: "France",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","FR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fr-035",
    lat: 48.891504,
    lng: 2.206263,
    panoId: "9P0AVp_4Vv5fqGZGFS9vRQ",
    place: "Near Nanterre, Île-de-France",
    shortName: "Nanterre",
    countryCode: "FR",
    country: "France",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","FR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fr-036",
    lat: 43.62905,
    lng: 3.872292,
    panoId: "kupxEPTuuIBSC7CrMShRkQ",
    place: "Near Montpellier, Occitanie",
    shortName: "Montpellier",
    countryCode: "FR",
    country: "France",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","FR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fr-037",
    lat: 51.034387,
    lng: 2.376866,
    panoId: "NfoOwQNx18V8k6b5RRj4jA",
    place: "Near Dunkirk, Hauts-de-France",
    shortName: "Dunkirk",
    countryCode: "FR",
    country: "France",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","FR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fr-038",
    lat: 50.693749,
    lng: 3.202611,
    panoId: "XRwCaeMOCBHxfs4qNpnm_Q",
    place: "Near Wattrelos, Hauts-de-France",
    shortName: "Wattrelos",
    countryCode: "FR",
    country: "France",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","FR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fr-039",
    lat: 48.379271,
    lng: -4.485705,
    panoId: "P4MnwfI2yuP9ooIF1u_edw",
    place: "Near Brest, Brittany",
    shortName: "Brest",
    countryCode: "FR",
    country: "France",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","FR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "fr-040",
    lat: 48.603596,
    lng: 7.729542,
    panoId: "wShUXFhQE97yi9nLoXLoBA",
    place: "Near Schiltigheim, Grand Est",
    shortName: "Schiltigheim",
    countryCode: "FR",
    country: "France",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","FR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fr-041",
    lat: 47.994893,
    lng: 0.223452,
    panoId: "a5Lqy6AyvUfHbfXpZwo1YQ",
    place: "Near Le Mans, Pays de la Loire",
    shortName: "Le Mans",
    countryCode: "FR",
    country: "France",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","FR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fr-042",
    lat: 47.318251,
    lng: 5.03026,
    panoId: "EUjMH-lFeF7HikVcmJud6Q",
    place: "Near Dijon, Bourgogne",
    shortName: "Dijon",
    countryCode: "FR",
    country: "France",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","FR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fr-043",
    lat: 42.696802,
    lng: 2.922786,
    panoId: "cwYkGJVO0ocHOHfrSdOHtw",
    place: "Near Perpignan, Occitanie",
    shortName: "Perpignan",
    countryCode: "FR",
    country: "France",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","FR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fr-044",
    lat: 43.306239,
    lng: 5.363473,
    panoId: "A0GTQ2vpLbBUuFjnDtDb1A",
    place: "Near La Joliette, Provence-Alpes-Côte d'Azur",
    shortName: "La Joliette",
    countryCode: "FR",
    country: "France",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","FR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "fr-045",
    lat: 45.75194,
    lng: 4.816587,
    panoId: "THF_unnWkFZmUF86onsXGg",
    place: "Near Lyon 02, Rhône-Alpes",
    shortName: "Lyon 02",
    countryCode: "FR",
    country: "France",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","FR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fr-046",
    lat: 45.760685,
    lng: 3.09846,
    panoId: "jGDBAbB1G51bm_w4MAMw5w",
    place: "Near Aubière, Rhône-Alpes",
    shortName: "Aubière",
    countryCode: "FR",
    country: "France",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","FR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fr-047",
    lat: 47.740178,
    lng: 7.345627,
    panoId: "cyt49piMucWjPBsNtf1zzg",
    place: "Near Mulhouse, Grand Est",
    shortName: "Mulhouse",
    countryCode: "FR",
    country: "France",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","FR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fr-048",
    lat: 45.853486,
    lng: 1.257373,
    panoId: "_wCNU-GSIWeQQMhdXa-V2g",
    place: "Near Limoges, New Aquitaine",
    shortName: "Limoges",
    countryCode: "FR",
    country: "France",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","FR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "fr-049",
    lat: 48.694535,
    lng: 6.195247,
    panoId: "fZsatlORGnude5aPwqTGlA",
    place: "Near Nancy, Grand Est",
    shortName: "Nancy",
    countryCode: "FR",
    country: "France",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","FR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fr-050",
    lat: 49.22745,
    lng: -0.370135,
    panoId: "eCGtK_AFah_nJxhmoACJKw",
    place: "Near Épron, Normandy",
    shortName: "Épron",
    countryCode: "FR",
    country: "France",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","FR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fr-051",
    lat: 43.888847,
    lng: 4.772512,
    panoId: "YH0F8ZwZ7Hntjjp3J_y_kw",
    place: "Near Barbentane, Provence-Alpes-Côte d'Azur",
    shortName: "Barbentane",
    countryCode: "FR",
    country: "France",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","FR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fr-052",
    lat: 49.931031,
    lng: 2.232523,
    panoId: "lFLE8M_9-5Hc5p33-zCkJA",
    place: "Near Saint-Sauveur, Hauts-de-France",
    shortName: "Saint-Sauveur",
    countryCode: "FR",
    country: "France",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","FR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fr-053",
    lat: 47.85502,
    lng: 1.840155,
    panoId: "VushcKtT1PSZ3Jdj1xzWgg",
    place: "Near Saint-Hilaire-Saint-Mesmin, Centre-Val de Loire",
    shortName: "Saint-Hilaire-Saint-Mesmin",
    countryCode: "FR",
    country: "France",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","FR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fr-054",
    lat: 48.390609,
    lng: -4.573858,
    panoId: "uIOJGhHspNLhFhei_PEejw",
    place: "Near Plouzané, Brittany",
    shortName: "Plouzané",
    countryCode: "FR",
    country: "France",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","FR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fr-055",
    lat: 45.767971,
    lng: 1.240651,
    panoId: "BKPUT9Mmwq3-NPgQA2pFug",
    place: "Near Condat-sur-Vienne, New Aquitaine",
    shortName: "Condat-sur-Vienne",
    countryCode: "FR",
    country: "France",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","FR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fr-056",
    lat: 47.999915,
    lng: 0.126943,
    panoId: "6oUODjEN7K_78rKg5z1sfQ",
    place: "Near Rouillon, Pays de la Loire",
    shortName: "Rouillon",
    countryCode: "FR",
    country: "France",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","FR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fr-057",
    lat: 49.158391,
    lng: 6.198102,
    panoId: "tDPhmI-Hn8mPEzA8SFvUPQ",
    place: "Near Saint-Julien-lès-Metz, Grand Est",
    shortName: "Saint-Julien-lès-Metz",
    countryCode: "FR",
    country: "France",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","FR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fr-058",
    lat: 43.804408,
    lng: 4.347165,
    panoId: "XvXyZ7d_vnV-vi6fond3Ig",
    place: "Near Caissargues, Occitanie",
    shortName: "Caissargues",
    countryCode: "FR",
    country: "France",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","FR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fr-059",
    lat: 45.429298,
    lng: 4.454815,
    panoId: "t_Hiu4TmvHDTnThk69-vaw",
    place: "Near Saint-Jean-Bonnefonds, Rhône-Alpes",
    shortName: "Saint-Jean-Bonnefonds",
    countryCode: "FR",
    country: "France",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","FR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fr-060",
    lat: 46.537809,
    lng: 0.40212,
    panoId: "Wj8mqULpYkLrZcDZgO02zQ",
    place: "Near Mignaloux-Beauvoir, New Aquitaine",
    shortName: "Mignaloux-Beauvoir",
    countryCode: "FR",
    country: "France",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","FR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fr-061",
    lat: 47.495861,
    lng: -0.63894,
    panoId: "7BlTQ-nQ0AWfJxSeegAT1w",
    place: "Near Beaucouzé, Pays de la Loire",
    shortName: "Beaucouzé",
    countryCode: "FR",
    country: "France",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","FR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fr-062",
    lat: 47.430882,
    lng: 0.771522,
    panoId: "v_TdxmLr5nqh9l32Ghm_mA",
    place: "Near Rochecorbon, Centre-Val de Loire",
    shortName: "Rochecorbon",
    countryCode: "FR",
    country: "France",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","FR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "fr-063",
    lat: 43.353491,
    lng: -0.381581,
    panoId: "Xs8se2fHQkS9ZE2LqpkdRg",
    place: "Near Montardon, New Aquitaine",
    shortName: "Montardon",
    countryCode: "FR",
    country: "France",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","FR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fr-064",
    lat: 49.277547,
    lng: 3.943728,
    panoId: "KjgUvn4PiladgWCQ2VBkgQ",
    place: "Near Saint-Brice-Courcelles, Grand Est",
    shortName: "Saint-Brice-Courcelles",
    countryCode: "FR",
    country: "France",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","FR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fr-065",
    lat: 43.18127,
    lng: 5.956406,
    panoId: "IdmQDcKR8-RMletZ6K1MQw",
    place: "Near Le Revest-les-Eaux, Provence-Alpes-Côte d'Azur",
    shortName: "Le Revest-les-Eaux",
    countryCode: "FR",
    country: "France",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","FR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fr-066",
    lat: 43.323768,
    lng: 3.258884,
    panoId: "jYNDS3kBUL8wVNQ1tBuS1g",
    place: "Near Villeneuve-lès-Béziers, Occitanie",
    shortName: "Villeneuve-lès-Béziers",
    countryCode: "FR",
    country: "France",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","FR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fr-067",
    lat: 47.042792,
    lng: 2.376393,
    panoId: "XCvHmibch45d9B41VquVVg",
    place: "Near Trouy, Centre-Val de Loire",
    shortName: "Trouy",
    countryCode: "FR",
    country: "France",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","FR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fr-068",
    lat: 45.236863,
    lng: 5.750939,
    panoId: "mh1farH-kVSfAt9661hZ1g",
    place: "Near Corenc, Rhône-Alpes",
    shortName: "Corenc",
    countryCode: "FR",
    country: "France",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","FR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fr-069",
    lat: 43.056564,
    lng: 5.835797,
    panoId: "k94mN7z_wcP7HhCEHF638g",
    place: "Near Six-Fours-les-Plages, Provence-Alpes-Côte d'Azur",
    shortName: "Six-Fours-les-Plages",
    countryCode: "FR",
    country: "France",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","FR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fr-070",
    lat: 47.263387,
    lng: -2.122889,
    panoId: "kn5lq0ifh-H6ADRTN7hRWg",
    place: "Near Saint-Brevin-les-Pins, Pays de la Loire",
    shortName: "Saint-Brevin-les-Pins",
    countryCode: "FR",
    country: "France",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","FR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fr-071",
    lat: 47.844569,
    lng: -4.040453,
    panoId: "l8EM65YXkOknq9CY4NxUWQ",
    place: "Near Fouesnant, Brittany",
    shortName: "Fouesnant",
    countryCode: "FR",
    country: "France",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","FR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fr-072",
    lat: 44.798524,
    lng: 4.915609,
    panoId: "Gs0SMav6ZHQx5uddKeLXCQ",
    place: "Near Montoison, Rhône-Alpes",
    shortName: "Montoison",
    countryCode: "FR",
    country: "France",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","FR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fr-073",
    lat: 43.803063,
    lng: 4.154506,
    panoId: "Png71jkyEH3UiBoLq3XZZA",
    place: "Near Congénies, Occitanie",
    shortName: "Congénies",
    countryCode: "FR",
    country: "France",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","FR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fr-074",
    lat: 43.776795,
    lng: 1.383334,
    panoId: "NpF9wnaQJGuFdkJXUJycpw",
    place: "Near Bouloc, Occitanie",
    shortName: "Bouloc",
    countryCode: "FR",
    country: "France",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","FR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fr-075",
    lat: 43.339383,
    lng: -0.208785,
    panoId: "dAAIODdl9653FhS-KABjRw",
    place: "Near Morlaàs, New Aquitaine",
    shortName: "Morlaàs",
    countryCode: "FR",
    country: "France",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","FR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fr-076",
    lat: 49.111503,
    lng: 1.141585,
    panoId: "SLqUY02p6i4-44Hp-uhJBw",
    place: "Near Normanville, Normandy",
    shortName: "Normanville",
    countryCode: "FR",
    country: "France",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","FR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fr-077",
    lat: 45.576961,
    lng: 6.033297,
    panoId: "n0t54V3QFxMgwSsiVHUPfw",
    place: "Near Barby, Rhône-Alpes",
    shortName: "Barby",
    countryCode: "FR",
    country: "France",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","FR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fr-078",
    lat: 47.315494,
    lng: 6.004427,
    panoId: "Wcl4UnkUStnDoldMwLuxhw",
    place: "Near Châtillon-le-Duc, Bourgogne",
    shortName: "Châtillon-le-Duc",
    countryCode: "FR",
    country: "France",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","FR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fr-079",
    lat: 50.612351,
    lng: 3.276646,
    panoId: "_UnhF-o6k3SHKgfA93HGNw",
    place: "Near Baisieux, Hauts-de-France",
    shortName: "Baisieux",
    countryCode: "FR",
    country: "France",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","FR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fr-080",
    lat: 46.166865,
    lng: -1.20677,
    panoId: "m2W3mWQPg0hFPXIB_LNBIA",
    place: "Near La Rochelle, New Aquitaine",
    shortName: "La Rochelle",
    countryCode: "FR",
    country: "France",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","FR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fr-081",
    lat: 44.689434,
    lng: -0.774386,
    panoId: "URaLa1E6hAn9iC-M4Q7o7A",
    place: "Near Marcheprime, New Aquitaine",
    shortName: "Marcheprime",
    countryCode: "FR",
    country: "France",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","FR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fr-082",
    lat: 47.621786,
    lng: 6.63808,
    panoId: "h9pgYv-0h_sfq9evAIrj4g",
    place: "Near Ronchamp, Bourgogne",
    shortName: "Ronchamp",
    countryCode: "FR",
    country: "France",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","FR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fr-083",
    lat: 43.566022,
    lng: 4.790981,
    panoId: "jqQcJksT1DfyVVBKC37QVg",
    place: "Near Saint-Martin-de-Crau, Provence-Alpes-Côte d'Azur",
    shortName: "Saint-Martin-de-Crau",
    countryCode: "FR",
    country: "France",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","FR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fr-084",
    lat: 47.831875,
    lng: -2.89463,
    panoId: "ExFOS3F9kGpUQcW21Cfapw",
    place: "Near Plumelin, Brittany",
    shortName: "Plumelin",
    countryCode: "FR",
    country: "France",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","FR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fr-085",
    lat: 50.888572,
    lng: 2.139016,
    panoId: "LSJuZlOW3zQ2MxSMMGeUWA",
    place: "Near Sainte-Marie-Kerque, Hauts-de-France",
    shortName: "Sainte-Marie-Kerque",
    countryCode: "FR",
    country: "France",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","FR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fr-086",
    lat: 46.575111,
    lng: -1.450235,
    panoId: "qmhxjK-DajP8StMaYaB8wA",
    place: "Near La Boissière-des-Landes, Pays de la Loire",
    shortName: "La Boissière-des-Landes",
    countryCode: "FR",
    country: "France",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","FR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fr-087",
    lat: 45.094287,
    lng: 4.818007,
    panoId: "eFrBCsVJWHfGOidvSNaAUA",
    place: "Near Saint-Jean-de-Muzols, Rhône-Alpes",
    shortName: "Saint-Jean-de-Muzols",
    countryCode: "FR",
    country: "France",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","FR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fr-088",
    lat: 46.707415,
    lng: 1.733622,
    panoId: "R9jLr0d7IiBMIkxeT0ErLQ",
    place: "Near Arthon, Centre-Val de Loire",
    shortName: "Arthon",
    countryCode: "FR",
    country: "France",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","FR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fr-089",
    lat: 45.209094,
    lng: 1.690961,
    panoId: "1BLDCL4DQ3jsueTfAz30VA",
    place: "Near Cornil, New Aquitaine",
    shortName: "Cornil",
    countryCode: "FR",
    country: "France",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","FR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fr-090",
    lat: 47.056634,
    lng: 2.235836,
    panoId: "WfM9E0fJuuGIwFdUDecnmw",
    place: "Near Marmagne, Centre-Val de Loire",
    shortName: "Marmagne",
    countryCode: "FR",
    country: "France",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","FR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fr-091",
    lat: 44.738305,
    lng: -0.561054,
    panoId: "J0y_23Y_qTinP-NwCJDTDg",
    place: "Near Cadaujac, New Aquitaine",
    shortName: "Cadaujac",
    countryCode: "FR",
    country: "France",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","FR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fr-092",
    lat: 49.371232,
    lng: 2.048747,
    panoId: "XVUZfpnZKbuxY6hmndOxhQ",
    place: "Near Auneuil, Hauts-de-France",
    shortName: "Auneuil",
    countryCode: "FR",
    country: "France",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","FR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fr-093",
    lat: 49.003871,
    lng: 1.109556,
    panoId: "pFjtjyjB_9m09oIQeJ46qw",
    place: "Near Arnières-sur-Iton, Normandy",
    shortName: "Arnières-sur-Iton",
    countryCode: "FR",
    country: "France",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","FR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fr-094",
    lat: 43.462685,
    lng: 6.771598,
    panoId: "qzdxnArAeeRHlY5Fia12_A",
    place: "Near Fréjus, Provence-Alpes-Côte d'Azur",
    shortName: "Fréjus",
    countryCode: "FR",
    country: "France",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","FR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fr-095",
    lat: 45.713064,
    lng: 5.817629,
    panoId: "WOdYbr4hn0w4lGxW3m-QrQ",
    place: "Near Yenne, Rhône-Alpes",
    shortName: "Yenne",
    countryCode: "FR",
    country: "France",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","FR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fr-096",
    lat: 47.044732,
    lng: -1.071225,
    panoId: "BUPZ-wE4M4G33Z2Gl0RNpA",
    place: "Near Le Longeron, Pays de la Loire",
    shortName: "Le Longeron",
    countryCode: "FR",
    country: "France",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","FR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fr-097",
    lat: 50.77157,
    lng: 3.279641,
    panoId: "l16KHPPp3RT9cmTCLCjjeA",
    place: "Near Bellegem, Flanders",
    shortName: "Bellegem",
    countryCode: "FR",
    country: "France",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","FR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fr-098",
    lat: 43.272913,
    lng: 3.157159,
    panoId: "OWKY0vXoMDjVuJNfVZ_inA",
    place: "Near Lespignan, Occitanie",
    shortName: "Lespignan",
    countryCode: "FR",
    country: "France",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","FR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fr-099",
    lat: 47.742703,
    lng: 6.910194,
    panoId: "Um_tujYUGFqebHIf6vBi7g",
    place: "Near Rougemont-le-Château, Bourgogne",
    shortName: "Rougemont-le-Château",
    countryCode: "FR",
    country: "France",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","FR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fr-100",
    lat: 48.099872,
    lng: 4.081392,
    panoId: "1fQ5oKxBmGTCjRphTg-brg",
    place: "Near Chaource, Grand Est",
    shortName: "Chaource",
    countryCode: "FR",
    country: "France",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","FR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fr-101",
    lat: 41.951689,
    lng: 8.906434,
    panoId: "sDccQ0zJnnWZA0FJESvj3w",
    place: "Near Cuttoli-Corticchiato, Corsica",
    shortName: "Cuttoli-Corticchiato",
    countryCode: "FR",
    country: "France",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","FR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fr-102",
    lat: 48.26277,
    lng: 3.863322,
    panoId: "4ntDGgj9GJsHuBd_QIXXFA",
    place: "Near Estissac, Grand Est",
    shortName: "Estissac",
    countryCode: "FR",
    country: "France",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","FR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fr-103",
    lat: 47.191369,
    lng: 6.194352,
    panoId: "gwDqqkzHWBWjlheGz76hnQ",
    place: "Near Mamirolle, Bourgogne",
    shortName: "Mamirolle",
    countryCode: "FR",
    country: "France",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","FR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fr-104",
    lat: 47.428313,
    lng: 1.285911,
    panoId: "oOKaLlG09Jwss_-8gT82qw",
    place: "Near Pontlevoy, Centre-Val de Loire",
    shortName: "Pontlevoy",
    countryCode: "FR",
    country: "France",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","FR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fr-105",
    lat: 48.499767,
    lng: 4.083925,
    panoId: "wZ3SQMiHdkIogra-dTVR0w",
    place: "Near Arcis-sur-Aube, Grand Est",
    shortName: "Arcis-sur-Aube",
    countryCode: "FR",
    country: "France",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","FR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "it-000",
    lat: 38.116616,
    lng: 13.363612,
    panoId: "C4rxBZohgYGJ7nPjy9ARRw",
    place: "Near Palermo, Sicily",
    shortName: "Palermo",
    countryCode: "IT",
    country: "Italy",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","IT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "it-001",
    lat: 44.647751,
    lng: 10.925575,
    panoId: "IpAWWoFxLlB7m7mdTlW9wg",
    place: "Near Modena, Emilia-Romagna",
    shortName: "Modena",
    countryCode: "IT",
    country: "Italy",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","IT"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "it-002",
    lat: 37.494354,
    lng: 15.070999,
    panoId: "UcfoT7IpFPd1vpYjix_V6w",
    place: "Near Catania, Sicily",
    shortName: "Catania",
    countryCode: "IT",
    country: "Italy",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","IT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "it-003",
    lat: 40.852177,
    lng: 14.268168,
    panoId: "sHALEG1wxQlyQXeC2-IFSQ",
    place: "Near Naples, Campania",
    shortName: "Naples",
    countryCode: "IT",
    country: "Italy",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","IT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "it-004",
    lat: 44.493812,
    lng: 11.338541,
    panoId: "IqmsknngO_wSs0RgeliOCg",
    place: "Near Bologna, Emilia-Romagna",
    shortName: "Bologna",
    countryCode: "IT",
    country: "Italy",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","IT"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "it-005",
    lat: 44.404745,
    lng: 8.944403,
    panoId: "cOpxa6byR0p2fCnCefjn-w",
    place: "Near Genoa, Liguria",
    shortName: "Genoa",
    countryCode: "IT",
    country: "Italy",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","IT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "it-006",
    lat: 45.07051,
    lng: 7.686952,
    panoId: "lp0JTXbZjNkTKzwBDANfkA",
    place: "Near Turin, Piedmont",
    shortName: "Turin",
    countryCode: "IT",
    country: "Italy",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","IT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "it-007",
    lat: 44.057521,
    lng: 12.5652,
    panoId: "9cu5n_7jo7pNbt4h9sEHvQ",
    place: "Near Rimini, Emilia-Romagna",
    shortName: "Rimini",
    countryCode: "IT",
    country: "Italy",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","IT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "it-008",
    lat: 45.58001,
    lng: 9.272367,
    panoId: "KOJ_Dt6wTHFWSs0zIU8Ghw",
    place: "Near Monza, Lombardy",
    shortName: "Monza",
    countryCode: "IT",
    country: "Italy",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","IT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "it-009",
    lat: 41.458482,
    lng: 15.551836,
    panoId: "YaSJTxR0i5aU-EWVPVluog",
    place: "Near Foggia, Apulia",
    shortName: "Foggia",
    countryCode: "IT",
    country: "Italy",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","IT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "it-010",
    lat: 43.544048,
    lng: 10.326183,
    panoId: "2f2qM2NOoJvu1jmX8rlIXQ",
    place: "Near Livorno, Tuscany",
    shortName: "Livorno",
    countryCode: "IT",
    country: "Italy",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","IT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "it-011",
    lat: 44.221777,
    lng: 12.041376,
    panoId: "shnD9WkYKRwV2V8ttVDKHQ",
    place: "Near Forlì, Emilia-Romagna",
    shortName: "Forlì",
    countryCode: "IT",
    country: "Italy",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","IT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "it-012",
    lat: 42.458494,
    lng: 14.202796,
    panoId: "TOvbKfcdaG1Le8x19NfNwQ",
    place: "Near Pescara, Abruzzo",
    shortName: "Pescara",
    countryCode: "IT",
    country: "Italy",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","IT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "it-013",
    lat: 40.675337,
    lng: 14.793168,
    panoId: "yk51yLOnDRjWp2rqALPSZQ",
    place: "Near Salerno, Campania",
    shortName: "Salerno",
    countryCode: "IT",
    country: "Italy",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","IT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "it-014",
    lat: 45.546859,
    lng: 11.54732,
    panoId: "D235N2SDuaE0F-EtPgZ8LQ",
    place: "Near Vicenza, Veneto",
    shortName: "Vicenza",
    countryCode: "IT",
    country: "Italy",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","IT"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "it-015",
    lat: 41.891533,
    lng: 12.51091,
    panoId: "8I0z_Tw8lavCRKDYZwiQ2w",
    place: "Near Rome, Lazio",
    shortName: "Rome",
    countryCode: "IT",
    country: "Italy",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","IT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "it-016",
    lat: 41.120646,
    lng: 16.869806,
    panoId: "6dSAEhH_gfApc5dz7ro3Ow",
    place: "Near Bari, Apulia",
    shortName: "Bari",
    countryCode: "IT",
    country: "Italy",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","IT"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "it-017",
    lat: 45.695787,
    lng: 9.667419,
    panoId: "BuXzlhCUCqVKugtmZq8vGw",
    place: "Near Bergamo, Lombardy",
    shortName: "Bergamo",
    countryCode: "IT",
    country: "Italy",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","IT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "it-018",
    lat: 44.698095,
    lng: 10.631133,
    panoId: "nlk0J1lG9Jw1RPJLG41Yhg",
    place: "Near Reggio nell'Emilia, Emilia-Romagna",
    shortName: "Reggio nell'Emilia",
    countryCode: "IT",
    country: "Italy",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","IT"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "it-019",
    lat: 38.110466,
    lng: 15.661308,
    panoId: "JtOpz2X5aubBwGXDAYS_yA",
    place: "Near Reggio Calabria, Calabria",
    shortName: "Reggio Calabria",
    countryCode: "IT",
    country: "Italy",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","IT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "it-020",
    lat: 38.193896,
    lng: 15.552573,
    panoId: "1gggwGMfS13RpHR638WJUg",
    place: "Near Messina, Sicily",
    shortName: "Messina",
    countryCode: "IT",
    country: "Italy",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","IT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "it-021",
    lat: 45.53542,
    lng: 10.215062,
    panoId: "3joG3EG4Zp0fc598sqf40A",
    place: "Near Brescia, Lombardy",
    shortName: "Brescia",
    countryCode: "IT",
    country: "Italy",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","IT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "it-022",
    lat: 44.799445,
    lng: 10.325995,
    panoId: "IeJHCKvSRlAAEEzFJ-kNrw",
    place: "Near Parma, Emilia-Romagna",
    shortName: "Parma",
    countryCode: "IT",
    country: "Italy",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","IT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "it-023",
    lat: 43.779693,
    lng: 11.246252,
    panoId: "nM_MWN3Zqrht8KmFdiBySw",
    place: "Near Florence, Tuscany",
    shortName: "Florence",
    countryCode: "IT",
    country: "Italy",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","IT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "it-024",
    lat: 43.880501,
    lng: 11.096942,
    panoId: "FqkbBFo7rSR_IOm-zev5KQ",
    place: "Near Prato, Tuscany",
    shortName: "Prato",
    countryCode: "IT",
    country: "Italy",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","IT"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "it-025",
    lat: 40.464406,
    lng: 17.247122,
    panoId: "blzOBVDE1oH55AjQz3we_g",
    place: "Near Taranto, Apulia",
    shortName: "Taranto",
    countryCode: "IT",
    country: "Italy",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","IT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "it-026",
    lat: 39.230289,
    lng: 9.120176,
    panoId: "vS-b-nI5cY-817e2wlT7uA",
    place: "Near Cagliari, Sardinia",
    shortName: "Cagliari",
    countryCode: "IT",
    country: "Italy",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","IT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "it-027",
    lat: 44.838101,
    lng: 11.620455,
    panoId: "U3WKohCDFC1iB1kGtZvQ_g",
    place: "Near Ferrara, Emilia-Romagna",
    shortName: "Ferrara",
    countryCode: "IT",
    country: "Italy",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","IT"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "it-028",
    lat: 45.649539,
    lng: 13.776774,
    panoId: "NABVa7TG49H1Ycx0W8o9zg",
    place: "Near Trieste, Friuli Venezia Giulia",
    shortName: "Trieste",
    countryCode: "IT",
    country: "Italy",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","IT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "it-029",
    lat: 37.075402,
    lng: 15.286672,
    panoId: "s-Zlgf6_Z73xYwdQNqVI1A",
    place: "Near Siracusa, Sicily",
    shortName: "Siracusa",
    countryCode: "IT",
    country: "Italy",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","IT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "it-030",
    lat: 43.112224,
    lng: 12.388773,
    panoId: "PAZLB804A4P-4UkRR1OgEg",
    place: "Near Perugia, Umbria",
    shortName: "Perugia",
    countryCode: "IT",
    country: "Italy",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","IT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "it-031",
    lat: 45.491667,
    lng: 12.245388,
    panoId: "veSkp8S5GDZYMjLc8Rl_Rg",
    place: "Near Mestre, Veneto",
    shortName: "Mestre",
    countryCode: "IT",
    country: "Italy",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","IT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "it-032",
    lat: 45.407901,
    lng: 11.886106,
    panoId: "SB0W_np5-qn_ul6ca6pIJw",
    place: "Near Padua, Veneto",
    shortName: "Padua",
    countryCode: "IT",
    country: "Italy",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","IT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "it-033",
    lat: 46.067783,
    lng: 11.120864,
    panoId: "YPifc4Mi1xCFeBSSFa6A_A",
    place: "Near Trento, Trentino-Alto Adige",
    shortName: "Trento",
    countryCode: "IT",
    country: "Italy",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","IT"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "it-034",
    lat: 43.708235,
    lng: 10.403427,
    panoId: "-hh8bLjMhUi5ha9cTh4c9g",
    place: "Near Pisa, Tuscany",
    shortName: "Pisa",
    countryCode: "IT",
    country: "Italy",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","IT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "it-035",
    lat: 46.491175,
    lng: 11.339396,
    panoId: "_ZhKMz7bhiqOsiRsejktYw",
    place: "Near Bolzano, Trentino-Alto Adige",
    shortName: "Bolzano",
    countryCode: "IT",
    country: "Italy",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","IT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "it-036",
    lat: 45.052443,
    lng: 9.693468,
    panoId: "wRte-JK650NLZlRd4yuneQ",
    place: "Near Piacenza, Emilia-Romagna",
    shortName: "Piacenza",
    countryCode: "IT",
    country: "Italy",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","IT"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "it-037",
    lat: 42.470301,
    lng: 14.180757,
    panoId: "GsfyIy9PKSyRQ_pK7H5U2A",
    place: "Near Villa Raspa, Abruzzo",
    shortName: "Villa Raspa",
    countryCode: "IT",
    country: "Italy",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","IT"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "it-038",
    lat: 41.89638,
    lng: 12.537664,
    panoId: "PGF9GdtkS4qvyCMBmp1UwA",
    place: "Near Casal Bertone, Lazio",
    shortName: "Casal Bertone",
    countryCode: "IT",
    country: "Italy",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","IT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "it-039",
    lat: 43.54499,
    lng: 10.33908,
    panoId: "Ni4kDWaSK4h2tkiUh8dZNA",
    place: "Near Livorno, Tuscany",
    shortName: "Livorno",
    countryCode: "IT",
    country: "Italy",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","IT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "it-040",
    lat: 40.471392,
    lng: 17.267247,
    panoId: "hZdhu_UjE-behP48MI7Ayw",
    place: "Near Taranto, Apulia",
    shortName: "Taranto",
    countryCode: "IT",
    country: "Italy",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","IT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "it-041",
    lat: 45.631007,
    lng: 13.778369,
    panoId: "G3jRkK5McZ3s3RApFxTGgQ",
    place: "Near Trieste, Friuli Venezia Giulia",
    shortName: "Trieste",
    countryCode: "IT",
    country: "Italy",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","IT"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "it-042",
    lat: 37.085592,
    lng: 15.299102,
    panoId: "UF52NJ92iil_RC6X4A7Xxg",
    place: "Near Siracusa, Sicily",
    shortName: "Siracusa",
    countryCode: "IT",
    country: "Italy",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","IT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "it-043",
    lat: 41.455904,
    lng: 15.537366,
    panoId: "SHIRqMmVd5lgODOdr8Ypkw",
    place: "Near Foggia, Apulia",
    shortName: "Foggia",
    countryCode: "IT",
    country: "Italy",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","IT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "it-044",
    lat: 39.227618,
    lng: 9.101828,
    panoId: "NpgtO80ebx55DNMiuItXbQ",
    place: "Near Cagliari, Sardinia",
    shortName: "Cagliari",
    countryCode: "IT",
    country: "Italy",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","IT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "it-045",
    lat: 44.818946,
    lng: 11.633067,
    panoId: "XZO-KUhpplz3-l1hqNLOqA",
    place: "Near Ferrara, Emilia-Romagna",
    shortName: "Ferrara",
    countryCode: "IT",
    country: "Italy",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","IT"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "it-046",
    lat: 45.546073,
    lng: 10.194078,
    panoId: "ZhAddpZRDeyv_s9O-o-EsQ",
    place: "Near Brescia, Lombardy",
    shortName: "Brescia",
    countryCode: "IT",
    country: "Italy",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","IT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "it-047",
    lat: 42.563536,
    lng: 12.643363,
    panoId: "6KrzEptLKxrJZ4A2O151PA",
    place: "Near Terni, Umbria",
    shortName: "Terni",
    countryCode: "IT",
    country: "Italy",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","IT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "it-048",
    lat: 45.41842,
    lng: 11.898496,
    panoId: "eEJZ9KFdSf2-fa7AmXF2Qg",
    place: "Near Arcella, Veneto",
    shortName: "Arcella",
    countryCode: "IT",
    country: "Italy",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","IT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "it-049",
    lat: 41.114036,
    lng: 16.842941,
    panoId: "9A_TjN9JO2I4FQvAPHHKiA",
    place: "Near Bari, Apulia",
    shortName: "Bari",
    countryCode: "IT",
    country: "Italy",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","IT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "it-050",
    lat: 44.528149,
    lng: 11.29922,
    panoId: "YsLsRXdw5ISbW8rhzpU5lw",
    place: "Near Trebbo, Emilia-Romagna",
    shortName: "Trebbo",
    countryCode: "IT",
    country: "Italy",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","IT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "it-051",
    lat: 44.231535,
    lng: 11.949749,
    panoId: "EpDyb_hhd5ynXcIBnfZfBg",
    place: "Near Castrocaro Terme e Terra del Sole, Emilia-Romagna",
    shortName: "Castrocaro Terme e Terra del Sole",
    countryCode: "IT",
    country: "Italy",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","IT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "it-052",
    lat: 44.696277,
    lng: 10.891912,
    panoId: "EmJxnPAiaCfUYqwEBd7HcA",
    place: "Near Villanova, Emilia-Romagna",
    shortName: "Villanova",
    countryCode: "IT",
    country: "Italy",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","IT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "it-053",
    lat: 41.396178,
    lng: 15.591565,
    panoId: "xaLlCLkj3iwhiByYpA6_oA",
    place: "Near Foggia, Apulia",
    shortName: "Foggia",
    countryCode: "IT",
    country: "Italy",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","IT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "it-054",
    lat: 43.747728,
    lng: 10.401287,
    panoId: "efd9_2ZsJlaC60aa2VqVRw",
    place: "Near Gello, Tuscany",
    shortName: "Gello",
    countryCode: "IT",
    country: "Italy",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","IT"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "it-055",
    lat: 40.41668,
    lng: 17.206422,
    panoId: "UkgAjPFDAG1Aue4uCis8xw",
    place: "Near Taranto, Apulia",
    shortName: "Taranto",
    countryCode: "IT",
    country: "Italy",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","IT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "it-056",
    lat: 46.514381,
    lng: 11.404195,
    panoId: "cZdeAAatdVnm9R0TMp0vTA",
    place: "Near Soprabolzano, Trentino-Alto Adige",
    shortName: "Soprabolzano",
    countryCode: "IT",
    country: "Italy",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","IT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "it-057",
    lat: 44.026206,
    lng: 12.544757,
    panoId: "whD4N0Ceb-1JnpNkE9wjkw",
    place: "Near Rimini, Emilia-Romagna",
    shortName: "Rimini",
    countryCode: "IT",
    country: "Italy",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","IT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "it-058",
    lat: 43.571805,
    lng: 10.369151,
    panoId: "lEZVUTSg8lnmdUd0_gqW2Q",
    place: "Near Guasticce, Tuscany",
    shortName: "Guasticce",
    countryCode: "IT",
    country: "Italy",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","IT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "it-059",
    lat: 44.468952,
    lng: 11.313047,
    panoId: "Hpa3L-96JbVS_UqLFr-XkQ",
    place: "Near Casalecchio di Reno, Emilia-Romagna",
    shortName: "Casalecchio di Reno",
    countryCode: "IT",
    country: "Italy",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","IT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "it-060",
    lat: 44.88728,
    lng: 11.665773,
    panoId: "RpwKfWRGY84n2cj5DqQx4A",
    place: "Near Francolino, Emilia-Romagna",
    shortName: "Francolino",
    countryCode: "IT",
    country: "Italy",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","IT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "it-061",
    lat: 40.709338,
    lng: 14.802552,
    panoId: "oqkCU610Vl99wKAKw7AZAg",
    place: "Near Capezzano-Cologna, Campania",
    shortName: "Capezzano-Cologna",
    countryCode: "IT",
    country: "Italy",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","IT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "it-062",
    lat: 45.503735,
    lng: 11.027909,
    panoId: "d0TVZqufBmaVSTD1qP0WxA",
    place: "Near Grezzana, Veneto",
    shortName: "Grezzana",
    countryCode: "IT",
    country: "Italy",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","IT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "it-063",
    lat: 42.414955,
    lng: 14.239158,
    panoId: "3-LdyBSaOzlXIqT87NEYtw",
    place: "Near Francavilla al Mare, Abruzzo",
    shortName: "Francavilla al Mare",
    countryCode: "IT",
    country: "Italy",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","IT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "it-064",
    lat: 41.948334,
    lng: 12.4854,
    panoId: "0fHxDjO97-a4Ka6Pub4S2w",
    place: "Near Campo Marzio, Lazio",
    shortName: "Campo Marzio",
    countryCode: "IT",
    country: "Italy",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","IT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "it-065",
    lat: 37.017958,
    lng: 15.282139,
    panoId: "8Imj229zrxNZNOVGA1ssKg",
    place: "Near Carrozziere, Sicily",
    shortName: "Carrozziere",
    countryCode: "IT",
    country: "Italy",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","IT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "it-066",
    lat: 43.870256,
    lng: 11.010422,
    panoId: "RsINdj-mawkuqZRoPG51Zw",
    place: "Near Vignole-Olmi, Tuscany",
    shortName: "Vignole-Olmi",
    countryCode: "IT",
    country: "Italy",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","IT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "it-067",
    lat: 46.512095,
    lng: 11.300279,
    panoId: "VYjlseimL_LGJmlcdCXRiA",
    place: "Near San Genesio Atesino, Trentino-Alto Adige",
    shortName: "San Genesio Atesino",
    countryCode: "IT",
    country: "Italy",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","IT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "it-068",
    lat: 43.731319,
    lng: 11.21219,
    panoId: "5D-wWJ58y6BlOjZK7-scmw",
    place: "Near Tavarnuzze, Tuscany",
    shortName: "Tavarnuzze",
    countryCode: "IT",
    country: "Italy",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","IT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "it-069",
    lat: 44.424434,
    lng: 8.975752,
    panoId: "gUyQYUvm4BRz4t39GOiLDQ",
    place: "Near Genoa, Liguria",
    shortName: "Genoa",
    countryCode: "IT",
    country: "Italy",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","IT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "it-070",
    lat: 44.709596,
    lng: 10.708536,
    panoId: "EWJd_GlCCl2u1gKvkU4Brw",
    place: "Near Massenzatico, Emilia-Romagna",
    shortName: "Massenzatico",
    countryCode: "IT",
    country: "Italy",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","IT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "it-071",
    lat: 44.215973,
    lng: 11.970163,
    panoId: "86JIasqIL0JJnl3cJzmViA",
    place: "Near Castrocaro Terme e Terra del Sole, Emilia-Romagna",
    shortName: "Castrocaro Terme e Terra del Sole",
    countryCode: "IT",
    country: "Italy",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","IT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "it-072",
    lat: 37.432484,
    lng: 15.080427,
    panoId: "Ab5tNG3pugVCEV90vZoTAA",
    place: "Near Catania, Sicily",
    shortName: "Catania",
    countryCode: "IT",
    country: "Italy",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","IT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "it-073",
    lat: 46.020729,
    lng: 13.165013,
    panoId: "SFBTlfNrBqIIey6xYWuXpw",
    place: "Near Campoformido, Friuli Venezia Giulia",
    shortName: "Campoformido",
    countryCode: "IT",
    country: "Italy",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","IT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "it-074",
    lat: 46.018033,
    lng: 11.084625,
    panoId: "PEuGuliaoT_NqB1L7QV8DQ",
    place: "Near Romagnano, Trentino-Alto Adige",
    shortName: "Romagnano",
    countryCode: "IT",
    country: "Italy",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","IT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "it-075",
    lat: 45.486048,
    lng: 8.60218,
    panoId: "VhjXT0sIouvrG4CAN049ww",
    place: "Near Caltignaga, Piedmont",
    shortName: "Caltignaga",
    countryCode: "IT",
    country: "Italy",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","IT"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "it-076",
    lat: 40.730494,
    lng: 8.63729,
    panoId: "fEipLYZDzAr1_Dt1Nai-Tw",
    place: "Near Osilo, Sardinia",
    shortName: "Osilo",
    countryCode: "IT",
    country: "Italy",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","IT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "it-077",
    lat: 38.073904,
    lng: 13.337926,
    panoId: "0HLBxuMYz56r09oF5elFeQ",
    place: "Near Villa Ciambra, Sicily",
    shortName: "Villa Ciambra",
    countryCode: "IT",
    country: "Italy",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","IT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "it-078",
    lat: 40.698594,
    lng: 14.861262,
    panoId: "W1J-_DjD2MjdjtBC_shXDw",
    place: "Near Pezzano-Filetta, Campania",
    shortName: "Pezzano-Filetta",
    countryCode: "IT",
    country: "Italy",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","IT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "it-079",
    lat: 43.594024,
    lng: 13.556523,
    panoId: "FzXEARloUZlpfKHvKVIhWA",
    place: "Near Pietra la Croce, The Marches",
    shortName: "Pietra la Croce",
    countryCode: "IT",
    country: "Italy",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","IT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "it-080",
    lat: 41.275067,
    lng: 16.222819,
    panoId: "uCR1YVYx9c_m3wrndLTGag",
    place: "Near Barletta, Apulia",
    shortName: "Barletta",
    countryCode: "IT",
    country: "Italy",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","IT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "it-081",
    lat: 45.406279,
    lng: 10.969148,
    panoId: "wzVhdmrQYQVhmmE04z-BlA",
    place: "Near Verona, Veneto",
    shortName: "Verona",
    countryCode: "IT",
    country: "Italy",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","IT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "it-082",
    lat: 44.080106,
    lng: 9.778368,
    panoId: "NFmyylhQ5JLRt9338S7rTQ",
    place: "Near Riomaggiore, Liguria",
    shortName: "Riomaggiore",
    countryCode: "IT",
    country: "Italy",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","IT"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "it-083",
    lat: 41.314707,
    lng: 16.220404,
    panoId: "4pMf0yNUOCewIoFsstmELg",
    place: "Near Barletta, Apulia",
    shortName: "Barletta",
    countryCode: "IT",
    country: "Italy",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","IT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "it-084",
    lat: 44.68845,
    lng: 10.236885,
    panoId: "LtGd72X_ENB5oZX2__b0Fw",
    place: "Near Felino, Emilia-Romagna",
    shortName: "Felino",
    countryCode: "IT",
    country: "Italy",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","IT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "it-085",
    lat: 38.866926,
    lng: 16.572074,
    panoId: "qbQYr-GivtfeXnIQPRXxTw",
    place: "Near Catanzaro, Calabria",
    shortName: "Catanzaro",
    countryCode: "IT",
    country: "Italy",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","IT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "it-086",
    lat: 44.165325,
    lng: 12.104097,
    panoId: "LcIHdk0Jo8iM6qns1TbFXw",
    place: "Near Fratta Terme, Emilia-Romagna",
    shortName: "Fratta Terme",
    countryCode: "IT",
    country: "Italy",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","IT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "it-087",
    lat: 43.886475,
    lng: 12.605137,
    panoId: "ZWJ9pNtmvKUj5jyk-mGGPw",
    place: "Near Montefiore Conca, Emilia-Romagna",
    shortName: "Montefiore Conca",
    countryCode: "IT",
    country: "Italy",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","IT"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "it-088",
    lat: 44.738089,
    lng: 10.835128,
    panoId: "q3_NmnSZh9N_wVl6P8DL6A",
    place: "Near Santa Croce Scuole, Emilia-Romagna",
    shortName: "Santa Croce Scuole",
    countryCode: "IT",
    country: "Italy",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","IT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "it-089",
    lat: 46.034116,
    lng: 11.1669,
    panoId: "D3vwBjNmi-cUCLvdLUt0Nw",
    place: "Near Povo, Trentino-Alto Adige",
    shortName: "Povo",
    countryCode: "IT",
    country: "Italy",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","IT"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "it-090",
    lat: 42.481236,
    lng: 12.883131,
    panoId: "1xRanw_SOdbDGyvCG3_DaQ",
    place: "Near Poggio Bustone, Lazio",
    shortName: "Poggio Bustone",
    countryCode: "IT",
    country: "Italy",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","IT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "it-091",
    lat: 44.171875,
    lng: 9.706964,
    panoId: "pJR2GFovmyS3Yz-W_6Yg-A",
    place: "Near Pignone, Liguria",
    shortName: "Pignone",
    countryCode: "IT",
    country: "Italy",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","IT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "it-092",
    lat: 45.534061,
    lng: 8.571092,
    panoId: "zRMI0OHOn0SfqwbbyEr0Qw",
    place: "Near Caltignaga, Piedmont",
    shortName: "Caltignaga",
    countryCode: "IT",
    country: "Italy",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","IT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "it-093",
    lat: 44.16451,
    lng: 12.018878,
    panoId: "e1uQAy08mzf-7BYOFkEFdw",
    place: "Near Fiumana, Emilia-Romagna",
    shortName: "Fiumana",
    countryCode: "IT",
    country: "Italy",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","IT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "it-094",
    lat: 45.042322,
    lng: 7.470244,
    panoId: "2wkxQ5WGdxojldeCfFPDQQ",
    place: "Near Villarbasse, Piedmont",
    shortName: "Villarbasse",
    countryCode: "IT",
    country: "Italy",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","IT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "it-095",
    lat: 43.71485,
    lng: 10.513792,
    panoId: "ugIc-4tT540QBymqwjC1tg",
    place: "Near Calci, Tuscany",
    shortName: "Calci",
    countryCode: "IT",
    country: "Italy",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","IT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "it-096",
    lat: 44.300817,
    lng: 12.022834,
    panoId: "PIR80iqBFzYz6BbwgIpA5w",
    place: "Near San Pancrazio, Emilia-Romagna",
    shortName: "San Pancrazio",
    countryCode: "IT",
    country: "Italy",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","IT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "it-097",
    lat: 41.541381,
    lng: 12.870948,
    panoId: "Y7fw5EtB7VqcIddnB-31BQ",
    place: "Near Borgo Podgora, Lazio",
    shortName: "Borgo Podgora",
    countryCode: "IT",
    country: "Italy",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","IT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "it-098",
    lat: 44.000267,
    lng: 10.805966,
    panoId: "hFSRMafIMkvuPSAqTCiccw",
    place: "Near Piteglio, Tuscany",
    shortName: "Piteglio",
    countryCode: "IT",
    country: "Italy",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","IT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "it-099",
    lat: 44.592079,
    lng: 8.904753,
    panoId: "xDRDQMgaAeM0Zb_PTDbKGg",
    place: "Near Fraconalto, Piedmont",
    shortName: "Fraconalto",
    countryCode: "IT",
    country: "Italy",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","IT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "it-100",
    lat: 44.312843,
    lng: 11.463505,
    panoId: "ZO85FfvOEQxp0Ujcg64FXA",
    place: "Near Monterenzio, Emilia-Romagna",
    shortName: "Monterenzio",
    countryCode: "IT",
    country: "Italy",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","IT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "it-101",
    lat: 45.042162,
    lng: 10.190013,
    panoId: "tArSrCAsmD5gXORxak94tg",
    place: "Near San Daniele Po, Lombardy",
    shortName: "San Daniele Po",
    countryCode: "IT",
    country: "Italy",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","IT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "it-102",
    lat: 39.117623,
    lng: 16.439488,
    panoId: "rQWHaExaT8NicN_8FS0dcw",
    place: "Near Bianchi, Calabria",
    shortName: "Bianchi",
    countryCode: "IT",
    country: "Italy",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","IT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "it-103",
    lat: 45.126613,
    lng: 10.212231,
    panoId: "kf_KuF53hGzy0mhcjdLpcQ",
    place: "Near Pieve San Giacomo, Lombardy",
    shortName: "Pieve San Giacomo",
    countryCode: "IT",
    country: "Italy",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","IT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "it-104",
    lat: 44.031088,
    lng: 10.601449,
    panoId: "Fr0KegL9oYKNa_qkzpxIEw",
    place: "Near Bagni di Lucca, Tuscany",
    shortName: "Bagni di Lucca",
    countryCode: "IT",
    country: "Italy",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","IT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "it-105",
    lat: 39.135467,
    lng: 16.365971,
    panoId: "VerTeHa9GWyUYzoovLvjFw",
    place: "Near Colosimi, Calabria",
    shortName: "Colosimi",
    countryCode: "IT",
    country: "Italy",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","IT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gb-000",
    lat: 51.508482,
    lng: -0.125751,
    panoId: "uJsohasYMidxahmH5gVKUQ",
    place: "Near London, England",
    shortName: "London",
    countryCode: "GB",
    country: "United Kingdom",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","GB"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gb-001",
    lat: 55.865069,
    lng: -4.257057,
    panoId: "Z0w3w1x9Q82iSeiXA7H4NA",
    place: "Near Glasgow, Scotland",
    shortName: "Glasgow",
    countryCode: "GB",
    country: "United Kingdom",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","GB"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gb-002",
    lat: 52.481377,
    lng: -1.899748,
    panoId: "2K_tzkcSGMP3U87XtC96MQ",
    place: "Near Birmingham, England",
    shortName: "Birmingham",
    countryCode: "GB",
    country: "United Kingdom",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","GB"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gb-003",
    lat: 53.796564,
    lng: -1.547911,
    panoId: "06l4YYWvPfT90wb66aWTQw",
    place: "Near Leeds, England",
    shortName: "Leeds",
    countryCode: "GB",
    country: "United Kingdom",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","GB"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gb-004",
    lat: 53.480991,
    lng: -2.237368,
    panoId: "aOXKWh53bXMkOsk0og02Hw",
    place: "Near Manchester, England",
    shortName: "Manchester",
    countryCode: "GB",
    country: "United Kingdom",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","GB"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "gb-005",
    lat: 51.455215,
    lng: -2.596583,
    panoId: "x3r2XYvN0uXKy27hdFrkpQ",
    place: "Near Bristol, England",
    shortName: "Bristol",
    countryCode: "GB",
    country: "United Kingdom",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","GB"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gb-006",
    lat: 53.793949,
    lng: -1.752298,
    panoId: "xWA_efru8ZmZtAKqcuREig",
    place: "Near Bradford, England",
    shortName: "Bradford",
    countryCode: "GB",
    country: "United Kingdom",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","GB"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gb-007",
    lat: 53.410423,
    lng: -2.97762,
    panoId: "rxV2pyUrdL3iXO7wPJuyUg",
    place: "Near Liverpool, England",
    shortName: "Liverpool",
    countryCode: "GB",
    country: "United Kingdom",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","GB"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gb-008",
    lat: 54.596839,
    lng: -5.925372,
    panoId: "wMKUReFw2NJ3FZSBnWJMxA",
    place: "Near Belfast, Northern Ireland",
    shortName: "Belfast",
    countryCode: "GB",
    country: "United Kingdom",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","GB"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gb-009",
    lat: 52.406567,
    lng: -1.512249,
    panoId: "cy4QuukfHsKWeCpN9QZiEw",
    place: "Near Coventry, England",
    shortName: "Coventry",
    countryCode: "GB",
    country: "United Kingdom",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","GB"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gb-010",
    lat: 53.382964,
    lng: -1.465968,
    panoId: "3WtPEsXc9iXTlcPOijQANA",
    place: "Near Sheffield, England",
    shortName: "Sheffield",
    countryCode: "GB",
    country: "United Kingdom",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","GB"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gb-011",
    lat: 53.744637,
    lng: -0.33525,
    panoId: "gJGUUHkWm3c8SbQjelMwGw",
    place: "Near Kingston upon Hull, England",
    shortName: "Kingston upon Hull",
    countryCode: "GB",
    country: "United Kingdom",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","GB"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gb-012",
    lat: 57.144496,
    lng: -2.098197,
    panoId: "kwkGJO4rWlXNOMBORKjLrg",
    place: "Near Aberdeen, Scotland",
    shortName: "Aberdeen",
    countryCode: "GB",
    country: "United Kingdom",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","GB"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gb-013",
    lat: 51.480129,
    lng: -3.180169,
    panoId: "2X8lFUL5-6f-H5bwMUrFFA",
    place: "Near Cardiff, Wales",
    shortName: "Cardiff",
    countryCode: "GB",
    country: "United Kingdom",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","GB"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gb-014",
    lat: 51.620776,
    lng: -3.943209,
    panoId: "65bZmK3-BCiJjJ8VtqsWyg",
    place: "Near Swansea, Wales",
    shortName: "Swansea",
    countryCode: "GB",
    country: "United Kingdom",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","GB"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "gb-015",
    lat: 55.952022,
    lng: -3.196494,
    panoId: "nROALWKaVQkGbDgu6GxlOw",
    place: "Near Edinburgh, Scotland",
    shortName: "Edinburgh",
    countryCode: "GB",
    country: "United Kingdom",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","GB"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gb-016",
    lat: 51.520124,
    lng: -0.928489,
    panoId: "y6TTixL1Rq8V81YH2UGdzw",
    place: "Near Henley-on-Thames, England",
    shortName: "Henley-on-Thames",
    countryCode: "GB",
    country: "United Kingdom",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","GB"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gb-017",
    lat: 54.610312,
    lng: -5.919317,
    panoId: "Kvq9fO9SyllkUp7WWiBKJg",
    place: "Near Belfast, Northern Ireland",
    shortName: "Belfast",
    countryCode: "GB",
    country: "United Kingdom",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","GB"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gb-018",
    lat: 54.921215,
    lng: -1.675001,
    panoId: "ErwN0yfWc-A0ZVvt2NOZAA",
    place: "Near Whickham, England",
    shortName: "Whickham",
    countryCode: "GB",
    country: "United Kingdom",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","GB"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gb-019",
    lat: 50.850625,
    lng: -1.37307,
    panoId: "1Yw_Mu2vsJZUeVTqKU3jrA",
    place: "Near Hythe, England",
    shortName: "Hythe",
    countryCode: "GB",
    country: "United Kingdom",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","GB"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "gb-020",
    lat: 52.671498,
    lng: -1.129693,
    panoId: "onhFHcY8bSGEr_uyUE4rRA",
    place: "Near Birstall, England",
    shortName: "Birstall",
    countryCode: "GB",
    country: "United Kingdom",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","GB"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gb-021",
    lat: 53.773551,
    lng: -2.67224,
    panoId: "QkUPevioWwGkkC-3w6obag",
    place: "Near Red Scar, England",
    shortName: "Red Scar",
    countryCode: "GB",
    country: "United Kingdom",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","GB"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gb-022",
    lat: 52.974366,
    lng: -2.10262,
    panoId: "7wPMxZHiWUPlV5YK5rooMA",
    place: "Near Longton, England",
    shortName: "Longton",
    countryCode: "GB",
    country: "United Kingdom",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","GB"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gb-023",
    lat: 52.896056,
    lng: -1.477592,
    panoId: "BzYKCpdni3psa2D2ypNxJg",
    place: "Near Sinfin, England",
    shortName: "Sinfin",
    countryCode: "GB",
    country: "United Kingdom",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","GB"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gb-024",
    lat: 50.376561,
    lng: -4.205475,
    panoId: "-a99KIwB5adHsvrA5m3SRw",
    place: "Near Torpoint, England",
    shortName: "Torpoint",
    countryCode: "GB",
    country: "United Kingdom",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","GB"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gb-025",
    lat: 52.572212,
    lng: -2.15222,
    panoId: "MXoJpipechZyau3CoIPURw",
    place: "Near Wolverhampton, England",
    shortName: "Wolverhampton",
    countryCode: "GB",
    country: "United Kingdom",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","GB"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gb-026",
    lat: 57.147867,
    lng: -2.075875,
    panoId: "EvORcHN_0xsalr3_FSgYRA",
    place: "Near Aberdeen, Scotland",
    shortName: "Aberdeen",
    countryCode: "GB",
    country: "United Kingdom",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","GB"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gb-027",
    lat: 55.865018,
    lng: -4.278281,
    panoId: "CW-Pijewk25Si8rBAGyKjg",
    place: "Near Glasgow, Scotland",
    shortName: "Glasgow",
    countryCode: "GB",
    country: "United Kingdom",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","GB"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gb-028",
    lat: 51.481656,
    lng: -3.145893,
    panoId: "4X2C76PpN1x2tq6hPvf1Kg",
    place: "Near Cardiff, Wales",
    shortName: "Cardiff",
    countryCode: "GB",
    country: "United Kingdom",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","GB"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gb-029",
    lat: 55.959765,
    lng: -3.184981,
    panoId: "OWdiyCTRraXmQmWzdNZzZQ",
    place: "Near Edinburgh, Scotland",
    shortName: "Edinburgh",
    countryCode: "GB",
    country: "United Kingdom",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","GB"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gb-030",
    lat: 51.61143,
    lng: -3.962155,
    panoId: "sAsMQAlhy8MGUibJSAIzQA",
    place: "Near Swansea, Wales",
    shortName: "Swansea",
    countryCode: "GB",
    country: "United Kingdom",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","GB"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "gb-031",
    lat: 52.590639,
    lng: -2.006676,
    panoId: "8RBshoHiXlwj7K9pRL7hsw",
    place: "Near Walsall, England",
    shortName: "Walsall",
    countryCode: "GB",
    country: "United Kingdom",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","GB"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "gb-032",
    lat: 53.463471,
    lng: -2.524177,
    panoId: "mtP7QW8QQAW8egj-Dyd3sA",
    place: "Near Culcheth, England",
    shortName: "Culcheth",
    countryCode: "GB",
    country: "United Kingdom",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","GB"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gb-033",
    lat: 51.389645,
    lng: -0.04498,
    panoId: "ddctnUFIfCcuBN5ltPrp_g",
    place: "Near Shirley, England",
    shortName: "Shirley",
    countryCode: "GB",
    country: "United Kingdom",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","GB"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gb-034",
    lat: 51.460051,
    lng: -3.172507,
    panoId: "U2dviK2yBmgHtzJAKz362Q",
    place: "Near Cardiff, Wales",
    shortName: "Cardiff",
    countryCode: "GB",
    country: "United Kingdom",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","GB"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gb-035",
    lat: 52.487303,
    lng: -2.041926,
    panoId: "948c3L1wcMJpKVwQ4RzINQ",
    place: "Near Rowley Regis, England",
    shortName: "Rowley Regis",
    countryCode: "GB",
    country: "United Kingdom",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","GB"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gb-036",
    lat: 53.563779,
    lng: -2.850998,
    panoId: "t76y3pHDmsn1qLPr_gpb9A",
    place: "Near Ormskirk, England",
    shortName: "Ormskirk",
    countryCode: "GB",
    country: "United Kingdom",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","GB"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gb-037",
    lat: 54.583801,
    lng: -5.803712,
    panoId: "nGe5GXgqRtFepbqwcDUObw",
    place: "Near Dundonald, Northern Ireland",
    shortName: "Dundonald",
    countryCode: "GB",
    country: "United Kingdom",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","GB"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gb-038",
    lat: 52.970047,
    lng: -0.964472,
    panoId: "WxOwCnDzO1GR5N6ivfSxvA",
    place: "Near East Bridgford, England",
    shortName: "East Bridgford",
    countryCode: "GB",
    country: "United Kingdom",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","GB"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gb-039",
    lat: 51.587757,
    lng: -2.998281,
    panoId: "dzEQ-UNXMmrOtLcJpNPp5w",
    place: "Near Newport, Wales",
    shortName: "Newport",
    countryCode: "GB",
    country: "United Kingdom",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","GB"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gb-040",
    lat: 56.469149,
    lng: -2.974756,
    panoId: "6bbugSnU3n4fRzECxrxtsg",
    place: "Near Dundee, Scotland",
    shortName: "Dundee",
    countryCode: "GB",
    country: "United Kingdom",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","GB"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gb-041",
    lat: 55.944494,
    lng: -3.179781,
    panoId: "YB_TWS9Nm8xPERsgexGe4Q",
    place: "Near Edinburgh, Scotland",
    shortName: "Edinburgh",
    countryCode: "GB",
    country: "United Kingdom",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","GB"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gb-042",
    lat: 54.997968,
    lng: -7.308971,
    panoId: "-dz5nZnGjwQQPZyO_Ypc0A",
    place: "Near Derry, Northern Ireland",
    shortName: "Derry",
    countryCode: "GB",
    country: "United Kingdom",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","GB"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gb-043",
    lat: 54.523248,
    lng: -6.034991,
    panoId: "M2VuQDZ8F65fPZ1372r7KA",
    place: "Near Lisburn, Northern Ireland",
    shortName: "Lisburn",
    countryCode: "GB",
    country: "United Kingdom",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","GB"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gb-044",
    lat: 55.831733,
    lng: -4.432619,
    panoId: "FQJyy3aY4rgruZPs4fF_YA",
    place: "Near Paisley, Scotland",
    shortName: "Paisley",
    countryCode: "GB",
    country: "United Kingdom",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","GB"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gb-045",
    lat: 51.658961,
    lng: -3.448843,
    panoId: "wCX9XQj5C9VokQJgCd_LpQ",
    place: "Near Rhondda, Wales",
    shortName: "Rhondda",
    countryCode: "GB",
    country: "United Kingdom",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","GB"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gb-046",
    lat: 53.046634,
    lng: -2.991632,
    panoId: "bX9ko77jSwGlcxzrDVyvog",
    place: "Near Wrexham, Wales",
    shortName: "Wrexham",
    countryCode: "GB",
    country: "United Kingdom",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","GB"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gb-047",
    lat: 54.659853,
    lng: -5.90834,
    panoId: "8WJgdM1ZMuu70iEUSD9a0Q",
    place: "Near Newtownabbey, Northern Ireland",
    shortName: "Newtownabbey",
    countryCode: "GB",
    country: "United Kingdom",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","GB"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gb-048",
    lat: 51.621948,
    lng: -3.455168,
    panoId: "Lld4FrCm_ntT8NFY6wBCZQ",
    place: "Near Tonypandy, Wales",
    shortName: "Tonypandy",
    countryCode: "GB",
    country: "United Kingdom",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","GB"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gb-049",
    lat: 54.660826,
    lng: -5.668066,
    panoId: "bzxOvzeG4en1E3xLufqSXQ",
    place: "Near Bangor, Northern Ireland",
    shortName: "Bangor",
    countryCode: "GB",
    country: "United Kingdom",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","GB"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gb-050",
    lat: 53.733292,
    lng: -0.452705,
    panoId: "E4FaLn09YZFbJMHaNsD86A",
    place: "Near Hessle, England",
    shortName: "Hessle",
    countryCode: "GB",
    country: "United Kingdom",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","GB"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gb-051",
    lat: 50.910501,
    lng: 0.052394,
    panoId: "9yU9auUAuajJuWPRZc8PQQ",
    place: "Near Ringmer, England",
    shortName: "Ringmer",
    countryCode: "GB",
    country: "United Kingdom",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","GB"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gb-052",
    lat: 51.999713,
    lng: -0.570948,
    panoId: "nptJjJ-WDyz9Is6Rq-8yFA",
    place: "Near Eversholt, England",
    shortName: "Eversholt",
    countryCode: "GB",
    country: "United Kingdom",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","GB"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gb-053",
    lat: 50.804551,
    lng: -0.867124,
    panoId: "-vRbhIoZ_c7TfxL0K_0UMQ",
    place: "Near Birdham, England",
    shortName: "Birdham",
    countryCode: "GB",
    country: "United Kingdom",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","GB"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gb-054",
    lat: 51.420018,
    lng: -1.877685,
    panoId: "3p0Z8j37pbkEztHnx5s7Vw",
    place: "Near Avebury, England",
    shortName: "Avebury",
    countryCode: "GB",
    country: "United Kingdom",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","GB"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gb-055",
    lat: 57.195549,
    lng: -2.099906,
    panoId: "_1FaeWdGQYXfLnhYeztJPQ",
    place: "Near Dyce, Scotland",
    shortName: "Dyce",
    countryCode: "GB",
    country: "United Kingdom",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","GB"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gb-056",
    lat: 53.20423,
    lng: -3.179192,
    panoId: "uY3tganNfQNV2YFjHLvoGw",
    place: "Near Halkyn, Wales",
    shortName: "Halkyn",
    countryCode: "GB",
    country: "United Kingdom",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","GB"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gb-057",
    lat: 55.72475,
    lng: -4.063392,
    panoId: "ycBm3jVtHd4ZP1a1cNoGMQ",
    place: "Near Meikle Earnock, Scotland",
    shortName: "Meikle Earnock",
    countryCode: "GB",
    country: "United Kingdom",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","GB"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gb-058",
    lat: 55.409285,
    lng: -4.577011,
    panoId: "gM2zyDbykYujIEYIwxauHw",
    place: "Near Dalrymple, Scotland",
    shortName: "Dalrymple",
    countryCode: "GB",
    country: "United Kingdom",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","GB"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gb-059",
    lat: 56.380266,
    lng: -3.350584,
    panoId: "NXqXkCSPZJ7cocuNzWJkgQ",
    place: "Near Bridge of Earn, Scotland",
    shortName: "Bridge of Earn",
    countryCode: "GB",
    country: "United Kingdom",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","GB"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gb-060",
    lat: 51.647607,
    lng: -3.712184,
    panoId: "FhELGl4bsSzdDTEk7Ost5g",
    place: "Near Bryn, Wales",
    shortName: "Bryn",
    countryCode: "GB",
    country: "United Kingdom",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","GB"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "gb-061",
    lat: 55.911764,
    lng: -4.827019,
    panoId: "QdrCdz8dDbgQHottne2BRA",
    place: "Near Inverkip, Scotland",
    shortName: "Inverkip",
    countryCode: "GB",
    country: "United Kingdom",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","GB"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gb-062",
    lat: 56.184206,
    lng: -3.286704,
    panoId: "yjy57qIW7EeNrrVjfydsOw",
    place: "Near Kinglassie, Scotland",
    shortName: "Kinglassie",
    countryCode: "GB",
    country: "United Kingdom",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","GB"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gb-063",
    lat: 51.604186,
    lng: -3.988785,
    panoId: "T_JLiRBVGBN10aeLfk2K7w",
    place: "Near Swansea, Wales",
    shortName: "Swansea",
    countryCode: "GB",
    country: "United Kingdom",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","GB"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gb-064",
    lat: 51.446454,
    lng: -3.328516,
    panoId: "YwmRCEMFroH8y5GsseN43Q",
    place: "Near Wenvoe, Wales",
    shortName: "Wenvoe",
    countryCode: "GB",
    country: "United Kingdom",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","GB"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gb-065",
    lat: 51.60583,
    lng: -2.907678,
    panoId: "_ZR2NQGWUkWrySWrl9W25A",
    place: "Near Langstone, Wales",
    shortName: "Langstone",
    countryCode: "GB",
    country: "United Kingdom",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","GB"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gb-066",
    lat: 51.750166,
    lng: -2.986581,
    panoId: "amttbHsyNcHEaiVQNVsMdA",
    place: "Near Pontypool, Wales",
    shortName: "Pontypool",
    countryCode: "GB",
    country: "United Kingdom",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","GB"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gb-067",
    lat: 54.397685,
    lng: -6.415767,
    panoId: "2tlKzV4EeVubcM6r7jEoLQ",
    place: "Near Portadown, Northern Ireland",
    shortName: "Portadown",
    countryCode: "GB",
    country: "United Kingdom",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","GB"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gb-068",
    lat: 51.773146,
    lng: -3.349429,
    panoId: "Wxtx_YVceSDQV2K-Kn1WUQ",
    place: "Near Merthyr Tydfil, Wales",
    shortName: "Merthyr Tydfil",
    countryCode: "GB",
    country: "United Kingdom",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","GB"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gb-069",
    lat: 55.738549,
    lng: -4.083632,
    panoId: "XTVMMXTD164qA8L2Hzc9JQ",
    place: "Near Meikle Earnock, Scotland",
    shortName: "Meikle Earnock",
    countryCode: "GB",
    country: "United Kingdom",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","GB"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gb-070",
    lat: 54.547911,
    lng: -5.9404,
    panoId: "uHl-HetPB9Br47J7rm9ucg",
    place: "Near Castlereagh, Northern Ireland",
    shortName: "Castlereagh",
    countryCode: "GB",
    country: "United Kingdom",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","GB"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gb-071",
    lat: 52.997774,
    lng: -2.860313,
    panoId: "5aZHFI0-Wz5S78vd5-jIwA",
    place: "Near Overton, Wales",
    shortName: "Overton",
    countryCode: "GB",
    country: "United Kingdom",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","GB"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gb-072",
    lat: 51.59884,
    lng: -4.088106,
    panoId: "xNexz5pcHVBgP4UET_zxWQ",
    place: "Near Pennard, Wales",
    shortName: "Pennard",
    countryCode: "GB",
    country: "United Kingdom",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","GB"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gb-073",
    lat: 54.378191,
    lng: -6.495002,
    panoId: "kaWu3DQDTyDVnBR3o_UO3A",
    place: "Near Tandragee, Northern Ireland",
    shortName: "Tandragee",
    countryCode: "GB",
    country: "United Kingdom",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","GB"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gb-074",
    lat: 55.015967,
    lng: -7.203623,
    panoId: "42YKCfJfDwt8cIdPnjZLug",
    place: "Near Eglinton, Northern Ireland",
    shortName: "Eglinton",
    countryCode: "GB",
    country: "United Kingdom",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","GB"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gb-075",
    lat: 54.557977,
    lng: -6.000109,
    panoId: "RJjN7s3uaVN0td4TfjsbIQ",
    place: "Near Lisburn, Northern Ireland",
    shortName: "Lisburn",
    countryCode: "GB",
    country: "United Kingdom",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","GB"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gb-076",
    lat: 53.014637,
    lng: -3.196894,
    panoId: "zv8n0RkmOtav7aoc5U_7QQ",
    place: "Near Llandegla, Wales",
    shortName: "Llandegla",
    countryCode: "GB",
    country: "United Kingdom",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","GB"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gb-077",
    lat: 55.617273,
    lng: -4.160339,
    panoId: "emdVoyOgKuUgixyHS_8Z0g",
    place: "Near Darvel, Scotland",
    shortName: "Darvel",
    countryCode: "GB",
    country: "United Kingdom",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","GB"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gb-078",
    lat: 57.559337,
    lng: -4.418872,
    panoId: "zNNAkpKFBxn7UPe9zV3nNg",
    place: "Near Conon Bridge, Scotland",
    shortName: "Conon Bridge",
    countryCode: "GB",
    country: "United Kingdom",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","GB"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gb-079",
    lat: 51.737035,
    lng: -3.881733,
    panoId: "7-WkYzykomNank7tmiIlYQ",
    place: "Near Clydach, Wales",
    shortName: "Clydach",
    countryCode: "GB",
    country: "United Kingdom",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","GB"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gb-080",
    lat: 51.688814,
    lng: -2.904373,
    panoId: "P_AKgdRcWbs9KCTlfrtJcw",
    place: "Near Llanbadoc, Wales",
    shortName: "Llanbadoc",
    countryCode: "GB",
    country: "United Kingdom",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","GB"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gb-081",
    lat: 51.706759,
    lng: -3.405838,
    panoId: "YhaVYUPsJnJ8LPytN9m5yA",
    place: "Near Cwmbach, Wales",
    shortName: "Cwmbach",
    countryCode: "GB",
    country: "United Kingdom",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","GB"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gb-082",
    lat: 56.370029,
    lng: -3.096299,
    panoId: "t-4xkvc72MQNp50pWFxNjg",
    place: "Near Errol, Scotland",
    shortName: "Errol",
    countryCode: "GB",
    country: "United Kingdom",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","GB"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gb-083",
    lat: 51.496274,
    lng: -3.497243,
    panoId: "dbOYVViJLgKn2oKRfP8PTg",
    place: "Near Llangan, Wales",
    shortName: "Llangan",
    countryCode: "GB",
    country: "United Kingdom",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","GB"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gb-084",
    lat: 56.043994,
    lng: -3.502459,
    panoId: "du2l-jGKjzSnhgi_pa4YAQ",
    place: "Near Limekilns, Scotland",
    shortName: "Limekilns",
    countryCode: "GB",
    country: "United Kingdom",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","GB"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gb-085",
    lat: 54.581723,
    lng: -5.58832,
    panoId: "UO7ZBuMhcK_2b12xxHrk0Q",
    place: "Near Millisle, Northern Ireland",
    shortName: "Millisle",
    countryCode: "GB",
    country: "United Kingdom",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","GB"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gb-086",
    lat: 54.746676,
    lng: -5.766755,
    panoId: "t367uHnC6MRBfz1YFB8l1A",
    place: "Near Whitehead, Northern Ireland",
    shortName: "Whitehead",
    countryCode: "GB",
    country: "United Kingdom",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","GB"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gb-087",
    lat: 54.419878,
    lng: -5.814288,
    panoId: "SOLcKCGWMeKFo2X32ub87Q",
    place: "Near Crossgar, Northern Ireland",
    shortName: "Crossgar",
    countryCode: "GB",
    country: "United Kingdom",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","GB"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gb-088",
    lat: 54.75359,
    lng: -6.125171,
    panoId: "yTX5Bbv_h5LPa-5sBlwevg",
    place: "Near Doagh, Northern Ireland",
    shortName: "Doagh",
    countryCode: "GB",
    country: "United Kingdom",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","GB"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gb-089",
    lat: 54.894322,
    lng: -5.959132,
    panoId: "axYUipUqikyIBXgZiI45TQ",
    place: "Near Larne, Northern Ireland",
    shortName: "Larne",
    countryCode: "GB",
    country: "United Kingdom",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","GB"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gb-090",
    lat: 54.039327,
    lng: -6.099576,
    panoId: "eIFeZmoRTOyyeL4Uj2vlUA",
    place: "Near Carlingford, Leinster",
    shortName: "Carlingford",
    countryCode: "GB",
    country: "United Kingdom",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","GB"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gb-091",
    lat: 34.735902,
    lng: 32.986888,
    panoId: "AgPsoM-0hP4lWhw8GTPmFQ",
    place: "Near Páno Polemídia, Limassol",
    shortName: "Páno Polemídia",
    countryCode: "GB",
    country: "United Kingdom",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","GB"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gb-092",
    lat: 56.562128,
    lng: -3.570575,
    panoId: "0CIi8J0azB7sHJwPug4xVw",
    place: "Near Dunkeld, Scotland",
    shortName: "Dunkeld",
    countryCode: "GB",
    country: "United Kingdom",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","GB"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gb-093",
    lat: 54.932265,
    lng: -3.810493,
    panoId: "7S6iDlllI4fWCqYTPkMlWA",
    place: "Near Dalbeattie, Scotland",
    shortName: "Dalbeattie",
    countryCode: "GB",
    country: "United Kingdom",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","GB"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gb-094",
    lat: 56.341273,
    lng: -3.177988,
    panoId: "HScpDmeMqfIJA4TtSeLRDw",
    place: "Near Newburgh, Scotland",
    shortName: "Newburgh",
    countryCode: "GB",
    country: "United Kingdom",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","GB"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gb-095",
    lat: 54.831976,
    lng: -6.722268,
    panoId: "BJxBF0N8EiV3bXX8qDpHvw",
    place: "Near Maghera, Northern Ireland",
    shortName: "Maghera",
    countryCode: "GB",
    country: "United Kingdom",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","GB"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gb-096",
    lat: 54.565639,
    lng: -6.886907,
    panoId: "jBzbMA7VKgkdSVC0AzRFuA",
    place: "Near Dungannon, Northern Ireland",
    shortName: "Dungannon",
    countryCode: "GB",
    country: "United Kingdom",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","GB"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gb-097",
    lat: 54.979377,
    lng: -6.742021,
    panoId: "JjUOh1tQ2pXXCUGSyAxRzg",
    place: "Near Garvagh, Northern Ireland",
    shortName: "Garvagh",
    countryCode: "GB",
    country: "United Kingdom",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","GB"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "de-000",
    lat: 51.962091,
    lng: 7.625663,
    panoId: "EHs3_rU4FfslhDiZZl7I3g",
    place: "Near Münster, North Rhine-Westphalia",
    shortName: "Münster",
    countryCode: "DE",
    country: "Germany",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "de-001",
    lat: 48.782314,
    lng: 9.177156,
    panoId: "um3Kz2HoQk3H0Vc1_QBPJw",
    place: "Near Stuttgart, Baden-Wurttemberg",
    shortName: "Stuttgart",
    countryCode: "DE",
    country: "Germany",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "de-002",
    lat: 49.01082,
    lng: 8.404429,
    panoId: "sl-Pugnur_kld0HX4UOQ_Q",
    place: "Near Karlsruhe, Baden-Wurttemberg",
    shortName: "Karlsruhe",
    countryCode: "DE",
    country: "Germany",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "de-003",
    lat: 51.22321,
    lng: 6.779294,
    panoId: "QzdbmMxdA2Jiq1IVDgeQ2g",
    place: "Near Düsseldorf, North Rhine-Westphalia",
    shortName: "Düsseldorf",
    countryCode: "DE",
    country: "Germany",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "de-004",
    lat: 52.524508,
    lng: 13.410013,
    panoId: "BPZQ5K5wVPPzg7cBxOBJJA",
    place: "Near Berlin, State of Berlin",
    shortName: "Berlin",
    countryCode: "DE",
    country: "Germany",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "de-005",
    lat: 52.370788,
    lng: 9.733656,
    panoId: "djJCcWF7WHfBIUhrmN9jqQ",
    place: "Near Hannover, Lower Saxony",
    shortName: "Hannover",
    countryCode: "DE",
    country: "Germany",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "de-006",
    lat: 50.835329,
    lng: 12.92886,
    panoId: "VE27SqbcdOK0kq2CjKfA-g",
    place: "Near Chemnitz, Saxony",
    shortName: "Chemnitz",
    countryCode: "DE",
    country: "Germany",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "de-007",
    lat: 51.051354,
    lng: 13.738429,
    panoId: "WiLBUlUxZmEERSPSsBWafw",
    place: "Near Dresden, Saxony",
    shortName: "Dresden",
    countryCode: "DE",
    country: "Germany",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "de-008",
    lat: 48.371422,
    lng: 10.897709,
    panoId: "EECNME6Y1NhXm6i2EDn3nw",
    place: "Near Augsburg, Bavaria",
    shortName: "Augsburg",
    countryCode: "DE",
    country: "Germany",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "de-009",
    lat: 50.933352,
    lng: 6.949723,
    panoId: "KWkV7LaI2zLcD8kepBFvUw",
    place: "Near Köln, North Rhine-Westphalia",
    shortName: "Köln",
    countryCode: "DE",
    country: "Germany",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "de-010",
    lat: 52.272936,
    lng: 8.049481,
    panoId: "o851WG-ws3X1E2MW2UJqWg",
    place: "Near Osnabrück, Lower Saxony",
    shortName: "Osnabrück",
    countryCode: "DE",
    country: "Germany",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "de-011",
    lat: 51.339602,
    lng: 12.371274,
    panoId: "3gBE49No7UjMAWa90j6ZTg",
    place: "Near Leipzig, Saxony",
    shortName: "Leipzig",
    countryCode: "DE",
    country: "Germany",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "de-012",
    lat: 54.088182,
    lng: 12.1419,
    panoId: "rxmiSYKhH7URNeA0VBXzNQ",
    place: "Near Rostock, Mecklenburg-Vorpommern",
    shortName: "Rostock",
    countryCode: "DE",
    country: "Germany",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "de-013",
    lat: 51.514909,
    lng: 7.465978,
    panoId: "MegaUy2mKN4HSOdxiVehmg",
    place: "Near Dortmund, North Rhine-Westphalia",
    shortName: "Dortmund",
    countryCode: "DE",
    country: "Germany",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "de-014",
    lat: 48.137436,
    lng: 11.575527,
    panoId: "WJlDGt6GFy3iTos2Re7zDw",
    place: "Near Munich, Bavaria",
    shortName: "Munich",
    countryCode: "DE",
    country: "Germany",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "de-015",
    lat: 53.074974,
    lng: 8.80713,
    panoId: "s-7eQgIC3EPZgAQfKgVW8g",
    place: "Near Bremen, Bremen",
    shortName: "Bremen",
    countryCode: "DE",
    country: "Germany",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "de-016",
    lat: 49.871166,
    lng: 8.65046,
    panoId: "t4VofE45WSZHZHr11yHTqw",
    place: "Near Darmstadt, Hesse",
    shortName: "Darmstadt",
    countryCode: "DE",
    country: "Germany",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "de-017",
    lat: 51.456371,
    lng: 7.012553,
    panoId: "jaknhvUS6VWt1hyOOVjs8g",
    place: "Near Essen, North Rhine-Westphalia",
    shortName: "Essen",
    countryCode: "DE",
    country: "Germany",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "de-018",
    lat: 50.777227,
    lng: 6.084425,
    panoId: "pVIllb4hyKLqqByPQg06DA",
    place: "Near Aachen, North Rhine-Westphalia",
    shortName: "Aachen",
    countryCode: "DE",
    country: "Germany",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "de-019",
    lat: 52.265728,
    lng: 10.525902,
    panoId: "LLmTIDDJoN28BceZtJpFRQ",
    place: "Near Braunschweig, Lower Saxony",
    shortName: "Braunschweig",
    countryCode: "DE",
    country: "Germany",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "de-020",
    lat: 52.03325,
    lng: 8.532352,
    panoId: "1-PShOCaoPed-F1GLUFJZg",
    place: "Near Bielefeld, North Rhine-Westphalia",
    shortName: "Bielefeld",
    countryCode: "DE",
    country: "Germany",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "de-021",
    lat: 49.488933,
    lng: 8.467389,
    panoId: "lIN7PkeMnbcfzyNUHwn-QA",
    place: "Near Mannheim, Baden-Wurttemberg",
    shortName: "Mannheim",
    countryCode: "DE",
    country: "Germany",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "de-022",
    lat: 47.997393,
    lng: 7.851445,
    panoId: "UphwCh2l3ckt98RLRqXJJg",
    place: "Near Freiburg, Baden-Wurttemberg",
    shortName: "Freiburg",
    countryCode: "DE",
    country: "Germany",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "de-023",
    lat: 52.398626,
    lng: 13.065843,
    panoId: "A657CcRKGy1VS-K-PgY4bA",
    place: "Near Potsdam, Brandenburg",
    shortName: "Potsdam",
    countryCode: "DE",
    country: "Germany",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "de-024",
    lat: 50.085969,
    lng: 8.244376,
    panoId: "tho_6MbCKP0eckV-lP6k5Q",
    place: "Near Wiesbaden, Hesse",
    shortName: "Wiesbaden",
    countryCode: "DE",
    country: "Germany",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "de-025",
    lat: 53.866278,
    lng: 10.6839,
    panoId: "m4qMGBfN3qyiwomZ899xFA",
    place: "Near Lübeck, Schleswig-Holstein",
    shortName: "Lübeck",
    countryCode: "DE",
    country: "Germany",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "de-026",
    lat: 51.432508,
    lng: 6.764917,
    panoId: "odQ7z7TUCPcCkE_PIgK1PQ",
    place: "Near Duisburg, North Rhine-Westphalia",
    shortName: "Duisburg",
    countryCode: "DE",
    country: "Germany",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "de-027",
    lat: 50.115508,
    lng: 8.684843,
    panoId: "OmNAliVa6L-aPwEyAkYviw",
    place: "Near Frankfurt am Main, Hesse",
    shortName: "Frankfurt am Main",
    countryCode: "DE",
    country: "Germany",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "de-028",
    lat: 54.321674,
    lng: 10.134654,
    panoId: "WJZCjnFQgkgQq4oWa8RRdA",
    place: "Near Kiel, Schleswig-Holstein",
    shortName: "Kiel",
    countryCode: "DE",
    country: "Germany",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "de-029",
    lat: 49.454459,
    lng: 11.077919,
    panoId: "6nNKr4WNHTxnUBe9OvKghQ",
    place: "Near Nuremberg, Bavaria",
    shortName: "Nuremberg",
    countryCode: "DE",
    country: "Germany",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "de-030",
    lat: 51.316545,
    lng: 9.500381,
    panoId: "UwKt3ZzOauRtTefAacwVVw",
    place: "Near Kassel, Hesse",
    shortName: "Kassel",
    countryCode: "DE",
    country: "Germany",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "de-031",
    lat: 49.981807,
    lng: 8.280035,
    panoId: "F_2o_W7dN5_T0vsuP1OIsA",
    place: "Near Mainz, Rheinland-Pfalz",
    shortName: "Mainz",
    countryCode: "DE",
    country: "Germany",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "de-032",
    lat: 49.233656,
    lng: 7.012815,
    panoId: "hnT1IuC0O7qfn8mCPUsHDw",
    place: "Near Saarbrücken, Saarland",
    shortName: "Saarbrücken",
    countryCode: "DE",
    country: "Germany",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "de-033",
    lat: 53.550686,
    lng: 9.9931,
    panoId: "qbyIWFZy2Sfh1yqi3YmlfQ",
    place: "Near Hamburg, Hamburg",
    shortName: "Hamburg",
    countryCode: "DE",
    country: "Germany",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "de-034",
    lat: 50.977798,
    lng: 11.034796,
    panoId: "uS09gnPu6zIF-Ftax5UOZw",
    place: "Near Erfurt, Thuringia",
    shortName: "Erfurt",
    countryCode: "DE",
    country: "Germany",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "de-035",
    lat: 52.131289,
    lng: 11.631844,
    panoId: "fi6hojw9PKCaU7lneCDuPw",
    place: "Near Magdeburg, Saxony-Anhalt",
    shortName: "Magdeburg",
    countryCode: "DE",
    country: "Germany",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "de-036",
    lat: 49.015132,
    lng: 12.10173,
    panoId: "A4i1ES1BICo-lTDNDSe5qA",
    place: "Near Regensburg, Bavaria",
    shortName: "Regensburg",
    countryCode: "DE",
    country: "Germany",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "de-037",
    lat: 49.407588,
    lng: 8.690795,
    panoId: "p6solGhhZ0U0VSfrYoZEyg",
    place: "Near Heidelberg, Baden-Wurttemberg",
    shortName: "Heidelberg",
    countryCode: "DE",
    country: "Germany",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "de-038",
    lat: 49.480774,
    lng: 8.44701,
    panoId: "Tb9gz5Bds68DnvF0SNCHNA",
    place: "Near Ludwigshafen am Rhein, Rheinland-Pfalz",
    shortName: "Ludwigshafen am Rhein",
    countryCode: "DE",
    country: "Germany",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "de-039",
    lat: 54.079997,
    lng: 12.162289,
    panoId: "gbtkoSme6rC1azPXqIzMqQ",
    place: "Near Rostock, Mecklenburg-Vorpommern",
    shortName: "Rostock",
    countryCode: "DE",
    country: "Germany",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "de-040",
    lat: 50.780034,
    lng: 6.050651,
    panoId: "xeD2CgktjO0s1V53kOQSuA",
    place: "Near Aachen, North Rhine-Westphalia",
    shortName: "Aachen",
    countryCode: "DE",
    country: "Germany",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "de-041",
    lat: 53.090658,
    lng: 8.801423,
    panoId: "8QSYNKd6DkNdlE2Scs89hg",
    place: "Near Bremen, Bremen",
    shortName: "Bremen",
    countryCode: "DE",
    country: "Germany",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "de-042",
    lat: 52.528987,
    lng: 13.433983,
    panoId: "UH9p6Jxtm6Go17MhgmsHhA",
    place: "Near Prenzlauer Berg, State of Berlin",
    shortName: "Prenzlauer Berg",
    countryCode: "DE",
    country: "Germany",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "de-043",
    lat: 53.884463,
    lng: 10.665538,
    panoId: "hqQ5-MMpFTCrXvupBOjAXw",
    place: "Near Stockelsdorf, Schleswig-Holstein",
    shortName: "Stockelsdorf",
    countryCode: "DE",
    country: "Germany",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "de-044",
    lat: 48.801549,
    lng: 9.191568,
    panoId: "v2QuqLrAsX4It-NZE8O8Rw",
    place: "Near Stuttgart, Baden-Wurttemberg",
    shortName: "Stuttgart",
    countryCode: "DE",
    country: "Germany",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "de-045",
    lat: 49.978086,
    lng: 8.311437,
    panoId: "mCI8lOPbgrtmMHFH-99Row",
    place: "Near Mainz, Rheinland-Pfalz",
    shortName: "Mainz",
    countryCode: "DE",
    country: "Germany",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "de-046",
    lat: 50.830442,
    lng: 12.9484,
    panoId: "yHqymchfh6gam8XaI9Xvgg",
    place: "Near Chemnitz, Saxony",
    shortName: "Chemnitz",
    countryCode: "DE",
    country: "Germany",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "de-047",
    lat: 51.326507,
    lng: 12.345191,
    panoId: "1VXnf18XIAcwDaLJ7U_rKA",
    place: "Near Kleinzschocher, Saxony",
    shortName: "Kleinzschocher",
    countryCode: "DE",
    country: "Germany",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "de-048",
    lat: 51.058742,
    lng: 13.750197,
    panoId: "pJoBZwUUtNJnjFiok1uoRg",
    place: "Near Äußere Neustadt, Saxony",
    shortName: "Äußere Neustadt",
    countryCode: "DE",
    country: "Germany",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "de-049",
    lat: 52.251284,
    lng: 8.046706,
    panoId: "B-YZJZ_1suf761f1RqB6wA",
    place: "Near Osnabrück, Lower Saxony",
    shortName: "Osnabrück",
    countryCode: "DE",
    country: "Germany",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "de-050",
    lat: 51.460815,
    lng: 6.818078,
    panoId: "O2aR2vu4tSqo7NqLqnWUqw",
    place: "Near Meiderich, North Rhine-Westphalia",
    shortName: "Meiderich",
    countryCode: "DE",
    country: "Germany",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "de-051",
    lat: 52.021468,
    lng: 8.474928,
    panoId: "x5HP6zBEiJjanroA41IruQ",
    place: "Near Bielefeld, North Rhine-Westphalia",
    shortName: "Bielefeld",
    countryCode: "DE",
    country: "Germany",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "de-052",
    lat: 52.087534,
    lng: 11.663184,
    panoId: "Nmw3AiSE8YZOwoRr1Gr4vA",
    place: "Near Magdeburg, Saxony-Anhalt",
    shortName: "Magdeburg",
    countryCode: "DE",
    country: "Germany",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "de-053",
    lat: 53.187432,
    lng: 8.144095,
    panoId: "17as4Z7nZO1NMClENRawMA",
    place: "Near Oldenburg, Lower Saxony",
    shortName: "Oldenburg",
    countryCode: "DE",
    country: "Germany",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "de-054",
    lat: 51.222437,
    lng: 6.712075,
    panoId: "bAzBDRb0jStbKNumcVKdtw",
    place: "Near Neuss, North Rhine-Westphalia",
    shortName: "Neuss",
    countryCode: "DE",
    country: "Germany",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "de-055",
    lat: 49.475822,
    lng: 8.364908,
    panoId: "wOYMbgBsbE0g-QWi0hk8Pg",
    place: "Near Gartenstadt, Rheinland-Pfalz",
    shortName: "Gartenstadt",
    countryCode: "DE",
    country: "Germany",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "de-056",
    lat: 50.811892,
    lng: 12.907923,
    panoId: "cbaFaQtBWIARmEk_XTPKPA",
    place: "Near Chemnitz, Saxony",
    shortName: "Chemnitz",
    countryCode: "DE",
    country: "Germany",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "de-057",
    lat: 52.441174,
    lng: 12.987329,
    panoId: "hRNIeo4Lap_MBBYeemCNGA",
    place: "Near Potsdam, Brandenburg",
    shortName: "Potsdam",
    countryCode: "DE",
    country: "Germany",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "de-058",
    lat: 54.080715,
    lng: 12.050836,
    panoId: "MpZ32R_I3GeMF8XMxANFTA",
    place: "Near Kritzmow, Mecklenburg-Vorpommern",
    shortName: "Kritzmow",
    countryCode: "DE",
    country: "Germany",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "de-059",
    lat: 50.950871,
    lng: 10.972778,
    panoId: "o6im9aTQaN4LtNjslkoCTw",
    place: "Near Ingersleben, Thuringia",
    shortName: "Ingersleben",
    countryCode: "DE",
    country: "Germany",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "de-060",
    lat: 50.154343,
    lng: 8.642197,
    panoId: "A45XHUcftSy0U0S64Tl8mA",
    place: "Near Steinbach am Taunus, Hesse",
    shortName: "Steinbach am Taunus",
    countryCode: "DE",
    country: "Germany",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "de-061",
    lat: 48.00515,
    lng: 7.761002,
    panoId: "UmeZ-VoRge0Tw35XICJBpw",
    place: "Near Umkirch, Baden-Wurttemberg",
    shortName: "Umkirch",
    countryCode: "DE",
    country: "Germany",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "de-062",
    lat: 53.894411,
    lng: 10.72397,
    panoId: "ipYq91fM067StlHHdkYL0g",
    place: "Near Bad Schwartau, Schleswig-Holstein",
    shortName: "Bad Schwartau",
    countryCode: "DE",
    country: "Germany",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "de-063",
    lat: 51.688653,
    lng: 8.729018,
    panoId: "RVU62EXfdSHg_svc_whDxg",
    place: "Near Paderborn, North Rhine-Westphalia",
    shortName: "Paderborn",
    countryCode: "DE",
    country: "Germany",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "de-064",
    lat: 51.317043,
    lng: 9.41349,
    panoId: "NOPMhVWhH4WWSeIgs_daXg",
    place: "Near Kassel, Hesse",
    shortName: "Kassel",
    countryCode: "DE",
    country: "Germany",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "de-065",
    lat: 54.373425,
    lng: 10.099794,
    panoId: "Qi9miXpeEGE69Sk2HWcHDQ",
    place: "Near Altenholz, Schleswig-Holstein",
    shortName: "Altenholz",
    countryCode: "DE",
    country: "Germany",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "de-066",
    lat: 48.969351,
    lng: 8.401644,
    panoId: "ukTTq1AOu8HHP_B41omvdw",
    place: "Near Ettlingen, Baden-Wurttemberg",
    shortName: "Ettlingen",
    countryCode: "DE",
    country: "Germany",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "de-067",
    lat: 49.034979,
    lng: 12.167832,
    panoId: "8rRaFKwgRH3ygQqwzOsfdQ",
    place: "Near Tegernheim, Bavaria",
    shortName: "Tegernheim",
    countryCode: "DE",
    country: "Germany",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "de-068",
    lat: 51.324865,
    lng: 12.480667,
    panoId: "TP2JD2TwIpX-aoEmPwsZvg",
    place: "Near Borsdorf, Saxony",
    shortName: "Borsdorf",
    countryCode: "DE",
    country: "Germany",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "de-069",
    lat: 53.141324,
    lng: 8.113841,
    panoId: "uG74Br7q7WK0ke1BSlpy_w",
    place: "Near Oldenburg, Lower Saxony",
    shortName: "Oldenburg",
    countryCode: "DE",
    country: "Germany",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "de-070",
    lat: 52.309897,
    lng: 10.501305,
    panoId: "_9BAJcHylvEmeHKFgPJFaQ",
    place: "Near Veltenhof, Lower Saxony",
    shortName: "Veltenhof",
    countryCode: "DE",
    country: "Germany",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "de-071",
    lat: 49.86604,
    lng: 8.711324,
    panoId: "3ZbtYzf_Ut86g5cdJquJSQ",
    place: "Near Roßdorf, Hesse",
    shortName: "Roßdorf",
    countryCode: "DE",
    country: "Germany",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "de-072",
    lat: 49.420552,
    lng: 11.161004,
    panoId: "Cusoz8RMzBX4911oXEnrXA",
    place: "Near Schwaig, Bavaria",
    shortName: "Schwaig",
    countryCode: "DE",
    country: "Germany",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "de-073",
    lat: 49.497853,
    lng: 8.373206,
    panoId: "iUKoImF7kR48vSHW_YQtDA",
    place: "Near Frankenthal, Rheinland-Pfalz",
    shortName: "Frankenthal",
    countryCode: "DE",
    country: "Germany",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "de-074",
    lat: 48.397505,
    lng: 10.065863,
    panoId: "WDzqRZO9tapi84RlYXe69w",
    place: "Near Holzheim, Bavaria",
    shortName: "Holzheim",
    countryCode: "DE",
    country: "Germany",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "de-075",
    lat: 48.826744,
    lng: 11.461758,
    panoId: "NeB93WYfdgPr9C83Ojg6Og",
    place: "Near Gaimersheim, Bavaria",
    shortName: "Gaimersheim",
    countryCode: "DE",
    country: "Germany",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "de-076",
    lat: 48.113113,
    lng: 11.544682,
    panoId: "LjjsACXgjaefGW4X9aXBqg",
    place: "Near Munich, Bavaria",
    shortName: "Munich",
    countryCode: "DE",
    country: "Germany",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "de-077",
    lat: 50.360602,
    lng: 7.635365,
    panoId: "U5nldiv8S6mn7Ii8Fm02MA",
    place: "Near Urbar, Rheinland-Pfalz",
    shortName: "Urbar",
    countryCode: "DE",
    country: "Germany",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "de-078",
    lat: 50.779544,
    lng: 12.421563,
    panoId: "AzMyK2ZgAICSPGCrL-GL7Q",
    place: "Near Hartmannsdorf, Saxony",
    shortName: "Hartmannsdorf",
    countryCode: "DE",
    country: "Germany",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "de-079",
    lat: 52.066066,
    lng: 11.676263,
    panoId: "KthLWnVSPxuTt-n-fkCzhg",
    place: "Near Schönebeck, Saxony-Anhalt",
    shortName: "Schönebeck",
    countryCode: "DE",
    country: "Germany",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "de-080",
    lat: 50.882648,
    lng: 11.509291,
    panoId: "3xvSljoTfGynw_CLTVFz1A",
    place: "Near Bucha, Thuringia",
    shortName: "Bucha",
    countryCode: "DE",
    country: "Germany",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "de-081",
    lat: 51.713229,
    lng: 8.443861,
    panoId: "dgycfWlMPkMCanaoKuVDHw",
    place: "Near Lippstadt, North Rhine-Westphalia",
    shortName: "Lippstadt",
    countryCode: "DE",
    country: "Germany",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "de-082",
    lat: 51.943561,
    lng: 7.889398,
    panoId: "6xxg6pHDIjO7pivv3fhUMw",
    place: "Near Everswinkel, North Rhine-Westphalia",
    shortName: "Everswinkel",
    countryCode: "DE",
    country: "Germany",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "de-083",
    lat: 52.426461,
    lng: 7.260272,
    panoId: "tRCHf1rrDwRD7mPL46y_gw",
    place: "Near Emsbüren, Lower Saxony",
    shortName: "Emsbüren",
    countryCode: "DE",
    country: "Germany",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "de-084",
    lat: 52.177909,
    lng: 10.716447,
    panoId: "00-5rzbnQS6IxuOkRz5q2A",
    place: "Near Evessen, Lower Saxony",
    shortName: "Evessen",
    countryCode: "DE",
    country: "Germany",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "de-085",
    lat: 49.787924,
    lng: 6.626513,
    panoId: "LcU2lVuC_3luzrsXQ4-cEA",
    place: "Near Aach, Rheinland-Pfalz",
    shortName: "Aach",
    countryCode: "DE",
    country: "Germany",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "de-086",
    lat: 49.731413,
    lng: 9.924852,
    panoId: "z1QSMxzEkBHz0mqEFtR0SA",
    place: "Near Reichenberg, Bavaria",
    shortName: "Reichenberg",
    countryCode: "DE",
    country: "Germany",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "de-087",
    lat: 48.540216,
    lng: 9.006773,
    panoId: "goj269j-5xLU5eR_zjQapQ",
    place: "Near Tübingen, Baden-Wurttemberg",
    shortName: "Tübingen",
    countryCode: "DE",
    country: "Germany",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "de-088",
    lat: 52.269952,
    lng: 10.007934,
    panoId: "POT0IJ197Qbkm-g0yV5auw",
    place: "Near Algermissen, Lower Saxony",
    shortName: "Algermissen",
    countryCode: "DE",
    country: "Germany",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "de-089",
    lat: 54.81426,
    lng: 9.520033,
    panoId: "U9PscmEqFTkNn4HByC19ZQ",
    place: "Near Wees, Schleswig-Holstein",
    shortName: "Wees",
    countryCode: "DE",
    country: "Germany",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "de-090",
    lat: 49.456705,
    lng: 7.508626,
    panoId: "B2lg75yi6cKMtzGKs0dnNg",
    place: "Near Steinwenden, Rheinland-Pfalz",
    shortName: "Steinwenden",
    countryCode: "DE",
    country: "Germany",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "de-091",
    lat: 49.567299,
    lng: 8.612831,
    panoId: "3XuOdzkvvL6J67W9OkbGVQ",
    place: "Near Hemsbach, Baden-Wurttemberg",
    shortName: "Hemsbach",
    countryCode: "DE",
    country: "Germany",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "de-092",
    lat: 53.500228,
    lng: 8.407431,
    panoId: "t8JVWVkqvl2ffkbC_5v3Dw",
    place: "Near Nordenham, Lower Saxony",
    shortName: "Nordenham",
    countryCode: "DE",
    country: "Germany",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "de-093",
    lat: 48.019352,
    lng: 8.609737,
    panoId: "ff_F9y4_0b1k3SuKulcX-Q",
    place: "Near Tuningen, Baden-Wurttemberg",
    shortName: "Tuningen",
    countryCode: "DE",
    country: "Germany",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "de-094",
    lat: 48.310854,
    lng: 10.215124,
    panoId: "GfLOnIeDOK-ZiflpLwksEg",
    place: "Near Roggenburg, Bavaria",
    shortName: "Roggenburg",
    countryCode: "DE",
    country: "Germany",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "de-095",
    lat: 53.005546,
    lng: 8.209065,
    panoId: "aQ5L49LHuwH2L_peSHadmg",
    place: "Near Wardenburg, Lower Saxony",
    shortName: "Wardenburg",
    countryCode: "DE",
    country: "Germany",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "de-096",
    lat: 48.481043,
    lng: 12.18672,
    panoId: "8dBEoSyNF4mNvlUNbLrXfw",
    place: "Near Eging, Bavaria",
    shortName: "Eging",
    countryCode: "DE",
    country: "Germany",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "de-097",
    lat: 50.469867,
    lng: 8.839605,
    panoId: "_6W7NRaYmk03Tdvtcixv9Q",
    place: "Near Hungen, Hesse",
    shortName: "Hungen",
    countryCode: "DE",
    country: "Germany",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "de-098",
    lat: 50.454634,
    lng: 7.366642,
    panoId: "VR-Y8yZQasiCV4oUN5B1Pg",
    place: "Near Leutesdorf, Rheinland-Pfalz",
    shortName: "Leutesdorf",
    countryCode: "DE",
    country: "Germany",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "de-099",
    lat: 50.892231,
    lng: 11.914581,
    panoId: "RiT3soqbVudJh1iXmXckUg",
    place: "Near Kraftsdorf, Thuringia",
    shortName: "Kraftsdorf",
    countryCode: "DE",
    country: "Germany",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "de-100",
    lat: 53.535892,
    lng: 11.647454,
    panoId: "mWAkZ7mJ5PCAmNX21gyTHQ",
    place: "Near Crivitz, Mecklenburg-Vorpommern",
    shortName: "Crivitz",
    countryCode: "DE",
    country: "Germany",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "de-101",
    lat: 49.799139,
    lng: 6.418552,
    panoId: "k1rT_0aDFxsk8DDjYmiBpA",
    place: "Near Echternach, Echternach",
    shortName: "Echternach",
    countryCode: "DE",
    country: "Germany",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "de-102",
    lat: 53.61726,
    lng: 8.772897,
    panoId: "O_V-5G54f34gdT5tPCrCpw",
    place: "Near Drangstedt, Lower Saxony",
    shortName: "Drangstedt",
    countryCode: "DE",
    country: "Germany",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "de-103",
    lat: 50.131897,
    lng: 11.635036,
    panoId: "1U25_c3Ax1-l8kvjQM4s0Q",
    place: "Near Steinbach, Bavaria",
    shortName: "Steinbach",
    countryCode: "DE",
    country: "Germany",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "de-104",
    lat: 53.442935,
    lng: 13.083334,
    panoId: "Q6XJG8x3GrZMsQsYJfh7ZA",
    place: "Near Wustrow, Mecklenburg-Vorpommern",
    shortName: "Wustrow",
    countryCode: "DE",
    country: "Germany",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "de-105",
    lat: 53.771246,
    lng: 11.479464,
    panoId: "cVxgKYlCopCQBWADca9pQA",
    place: "Near Bad Kleinen, Mecklenburg-Vorpommern",
    shortName: "Bad Kleinen",
    countryCode: "DE",
    country: "Germany",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","DE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "es-000",
    lat: 36.720243,
    lng: -4.420376,
    panoId: "t0qc5PKAkZBtkHkJ1CEyeQ",
    place: "Near Málaga, Andalusia",
    shortName: "Málaga",
    countryCode: "ES",
    country: "Spain",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","ES"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "es-001",
    lat: 28.101792,
    lng: -15.415715,
    panoId: "gyLm1aEnyk1JMqqNHVJJPg",
    place: "Near Las Palmas de Gran Canaria, Canary Islands",
    shortName: "Las Palmas de Gran Canaria",
    countryCode: "ES",
    country: "Spain",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","ES"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "es-002",
    lat: 37.382776,
    lng: -5.973073,
    panoId: "fa9LR8FXLKIQ_cIBiqfSSw",
    place: "Near Sevilla, Andalusia",
    shortName: "Sevilla",
    countryCode: "ES",
    country: "Spain",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","ES"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "es-003",
    lat: 38.994122,
    lng: -1.856554,
    panoId: "7BImHhBTto1Gbm09MfBL3g",
    place: "Near Albacete, Castille-La Mancha",
    shortName: "Albacete",
    countryCode: "ES",
    country: "Spain",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","ES"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "es-004",
    lat: 40.968804,
    lng: -5.663717,
    panoId: "RmphLdTeqNUTgt-2AEMeLw",
    place: "Near Salamanca, Castille and León",
    shortName: "Salamanca",
    countryCode: "ES",
    country: "Spain",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","ES"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "es-005",
    lat: 41.655426,
    lng: -4.723557,
    panoId: "pkeL70GTz1PFekmJZmLL1Q",
    place: "Near Valladolid, Castille and León",
    shortName: "Valladolid",
    countryCode: "ES",
    country: "Spain",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","ES"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "es-006",
    lat: 41.655924,
    lng: -0.877461,
    panoId: "5v3k7nLSjOmjkPstcwQkEQ",
    place: "Near Zaragoza, Aragon",
    shortName: "Zaragoza",
    countryCode: "ES",
    country: "Spain",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","ES"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "es-007",
    lat: 41.388744,
    lng: 2.158857,
    panoId: "xdPL-dTcPCanVezkSzJCMw",
    place: "Near Barcelona, Catalonia",
    shortName: "Barcelona",
    countryCode: "ES",
    country: "Spain",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","ES"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "es-008",
    lat: 40.416492,
    lng: -3.702277,
    panoId: "qdFBHRcd67XUXIEikvGUoQ",
    place: "Near Madrid, Madrid",
    shortName: "Madrid",
    countryCode: "ES",
    country: "Spain",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","ES"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "es-009",
    lat: 39.473949,
    lng: -0.379643,
    panoId: "Z0VIx9d3bR1wZml6ykNAIw",
    place: "Near Valencia, Valencia",
    shortName: "Valencia",
    countryCode: "ES",
    country: "Spain",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","ES"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "es-010",
    lat: 37.188159,
    lng: -3.607096,
    panoId: "WENvt5hgxv8KXFSzRZ77Og",
    place: "Near Granada, Andalusia",
    shortName: "Granada",
    countryCode: "ES",
    country: "Spain",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","ES"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "es-011",
    lat: 38.34514,
    lng: -0.481506,
    panoId: "ZVQZRIPXVZpKUZ970xGLyA",
    place: "Near Alicante, Valencia",
    shortName: "Alicante",
    countryCode: "ES",
    country: "Spain",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","ES"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "es-012",
    lat: 37.266331,
    lng: -6.939852,
    panoId: "CCtzp0hL6KcGfWG5ygdgaQ",
    place: "Near Huelva, Andalusia",
    shortName: "Huelva",
    countryCode: "ES",
    country: "Spain",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","ES"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "es-013",
    lat: 43.312726,
    lng: -1.973949,
    panoId: "UaUppdTEmGemrVCx-j98vQ",
    place: "Near Donostia / San Sebastián, Basque Country",
    shortName: "Donostia / San Sebastián",
    countryCode: "ES",
    country: "Spain",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","ES"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "es-014",
    lat: 37.891467,
    lng: -4.772737,
    panoId: "QRzbd2dIsNZrwIl7QjEHNg",
    place: "Near Córdoba, Andalusia",
    shortName: "Córdoba",
    countryCode: "ES",
    country: "Spain",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","ES"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "es-015",
    lat: 42.816902,
    lng: -1.643269,
    panoId: "ua0okd3H-CxgKojgxCV_Jw",
    place: "Near Pamplona, Navarre",
    shortName: "Pamplona",
    countryCode: "ES",
    country: "Spain",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","ES"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "es-016",
    lat: 37.601836,
    lng: -0.9838,
    panoId: "CI2NEe_O5a8kWn-ZsMtDiA",
    place: "Near Cartagena, Murcia",
    shortName: "Cartagena",
    countryCode: "ES",
    country: "Spain",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","ES"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "es-017",
    lat: 28.468202,
    lng: -16.254626,
    panoId: "mjXylCzpX9STM-XwxMKtxQ",
    place: "Near Santa Cruz de Tenerife, Canary Islands",
    shortName: "Santa Cruz de Tenerife",
    countryCode: "ES",
    country: "Spain",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","ES"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "es-018",
    lat: 43.262731,
    lng: -2.925088,
    panoId: "fjOcDeOrdNl1hrKm04mGFQ",
    place: "Near Bilbao, Basque Country",
    shortName: "Bilbao",
    countryCode: "ES",
    country: "Spain",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","ES"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "es-019",
    lat: 38.262171,
    lng: -0.701032,
    panoId: "mo-6o8_Pfo649bQ9sdHBUA",
    place: "Near Elche, Valencia",
    shortName: "Elche",
    countryCode: "ES",
    country: "Spain",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","ES"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "es-020",
    lat: 43.371346,
    lng: -8.396398,
    panoId: "Nbqyr3nUhAuCULCFhEKeKw",
    place: "Near A Coruña, Galicia",
    shortName: "A Coruña",
    countryCode: "ES",
    country: "Spain",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","ES"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "es-021",
    lat: 42.232799,
    lng: -8.723278,
    panoId: "CNM2Kv8UdXRhm5oSwH-0ug",
    place: "Near Vigo, Galicia",
    shortName: "Vigo",
    countryCode: "ES",
    country: "Spain",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","ES"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "es-022",
    lat: 42.850013,
    lng: -2.672585,
    panoId: "_Ne_T0ceSBnejgLgODozJw",
    place: "Near Gasteiz / Vitoria, Basque Country",
    shortName: "Gasteiz / Vitoria",
    countryCode: "ES",
    country: "Spain",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","ES"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "es-023",
    lat: 38.877985,
    lng: -6.97078,
    panoId: "aA2Z0ZjQ2RLo8lladhNE7Q",
    place: "Near Badajoz, Extremadura",
    shortName: "Badajoz",
    countryCode: "ES",
    country: "Spain",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","ES"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "es-024",
    lat: 36.686331,
    lng: -6.135684,
    panoId: "ANju5fUhuCJedhF9O_1hYg",
    place: "Near Jerez de la Frontera, Andalusia",
    shortName: "Jerez de la Frontera",
    countryCode: "ES",
    country: "Spain",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","ES"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "es-025",
    lat: 43.36031,
    lng: -5.84482,
    panoId: "u1LyXo6xdLwG1PVhdQhuvA",
    place: "Near Oviedo, Asturias",
    shortName: "Oviedo",
    countryCode: "ES",
    country: "Spain",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","ES"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "es-026",
    lat: 43.53562,
    lng: -5.661757,
    panoId: "GpCzuDwFWdS5TYEszhIvbw",
    place: "Near Gijón, Asturias",
    shortName: "Gijón",
    countryCode: "ES",
    country: "Spain",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","ES"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "es-027",
    lat: 42.465998,
    lng: -2.451131,
    panoId: "OlA36FVi8oA5mK75nxNbcg",
    place: "Near Logroño, La Rioja",
    shortName: "Logroño",
    countryCode: "ES",
    country: "Spain",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","ES"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "es-028",
    lat: 39.985655,
    lng: -0.049432,
    panoId: "Uj6Dic569dTu0RtCIFSlpA",
    place: "Near Castelló de la Plana, Valencia",
    shortName: "Castelló de la Plana",
    countryCode: "ES",
    country: "Spain",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","ES"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "es-029",
    lat: 28.485398,
    lng: -16.320107,
    panoId: "qSOvHWsyWxnc5u6nZa94MQ",
    place: "Near La Laguna, Canary Islands",
    shortName: "La Laguna",
    countryCode: "ES",
    country: "Spain",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","ES"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "es-030",
    lat: 42.341067,
    lng: -3.701825,
    panoId: "l2rpER6Z7CZaRYvJfE5Qwg",
    place: "Near Burgos, Castille and León",
    shortName: "Burgos",
    countryCode: "ES",
    country: "Spain",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","ES"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "es-031",
    lat: 37.986961,
    lng: -1.130036,
    panoId: "GrbfUtQ-7Y_FPxnCszLe-A",
    place: "Near Murcia, Murcia",
    shortName: "Murcia",
    countryCode: "ES",
    country: "Spain",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","ES"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "es-032",
    lat: 43.465888,
    lng: -3.804868,
    panoId: "pOIRJ2oUnIHrWLBO1c2eOA",
    place: "Near Santander, Cantabria",
    shortName: "Santander",
    countryCode: "ES",
    country: "Spain",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","ES"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "es-033",
    lat: 36.515473,
    lng: -4.885835,
    panoId: "OJVKy5SpLAreFgUY2rM9-Q",
    place: "Near Marbella, Andalusia",
    shortName: "Marbella",
    countryCode: "ES",
    country: "Spain",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","ES"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "es-034",
    lat: 36.83801,
    lng: -2.459818,
    panoId: "B9IhLl9K9vEs0A2ILZxc5Q",
    place: "Near Almería, Andalusia",
    shortName: "Almería",
    countryCode: "ES",
    country: "Spain",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","ES"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "es-035",
    lat: 42.599994,
    lng: -5.570496,
    panoId: "0hNNG5VXGdEtfoheEK9x5w",
    place: "Near León, Castille and León",
    shortName: "León",
    countryCode: "ES",
    country: "Spain",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","ES"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "es-036",
    lat: 39.56948,
    lng: 2.65033,
    panoId: "PX_jH1OQAA-TxJQmbPtBlg",
    place: "Near Palma, Balearic Islands",
    shortName: "Palma",
    countryCode: "ES",
    country: "Spain",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","ES"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "es-037",
    lat: 27.992601,
    lng: -15.419288,
    panoId: "eWAhE3B84OhpZWyzQfz7uw",
    place: "Near Telde, Canary Islands",
    shortName: "Telde",
    countryCode: "ES",
    country: "Spain",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","ES"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "es-038",
    lat: 42.225901,
    lng: -8.744204,
    panoId: "x-ITMXJzBXE-l8lKTaM58Q",
    place: "Near Vigo, Galicia",
    shortName: "Vigo",
    countryCode: "ES",
    country: "Spain",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","ES"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "es-039",
    lat: 37.603753,
    lng: -0.972306,
    panoId: "_mH83r7XD4Q-tzYCNdTlLQ",
    place: "Near Cartagena, Murcia",
    shortName: "Cartagena",
    countryCode: "ES",
    country: "Spain",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","ES"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "es-040",
    lat: 36.677396,
    lng: -6.119536,
    panoId: "Ce7rXqchzvhZEsBAfXeCkQ",
    place: "Near Jerez de la Frontera, Andalusia",
    shortName: "Jerez de la Frontera",
    countryCode: "ES",
    country: "Spain",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","ES"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "es-041",
    lat: 41.616675,
    lng: 0.622201,
    panoId: "WN4F8J3lBBB9M0_M8yzC1w",
    place: "Near Lleida, Catalonia",
    shortName: "Lleida",
    countryCode: "ES",
    country: "Spain",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","ES"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "es-042",
    lat: 36.731003,
    lng: -4.426828,
    panoId: "dv7vQw3bbSuCNg0sHTI6YQ",
    place: "Near Málaga, Andalusia",
    shortName: "Málaga",
    countryCode: "ES",
    country: "Spain",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","ES"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "es-043",
    lat: 39.488317,
    lng: -0.385264,
    panoId: "mRsRcZQTw41g1OPl0i9QDA",
    place: "Near Valencia, Valencia",
    shortName: "Valencia",
    countryCode: "ES",
    country: "Spain",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","ES"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "es-044",
    lat: 41.673127,
    lng: -4.713068,
    panoId: "0I5a-ehd3WBUxPi6Nnfzmg",
    place: "Near Valladolid, Castille and León",
    shortName: "Valladolid",
    countryCode: "ES",
    country: "Spain",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","ES"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "es-045",
    lat: 39.995481,
    lng: -0.038834,
    panoId: "etvqXBVWFF5prSrEOLi4zQ",
    place: "Near Castelló de la Plana, Valencia",
    shortName: "Castelló de la Plana",
    countryCode: "ES",
    country: "Spain",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","ES"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "es-046",
    lat: 43.356092,
    lng: -5.819733,
    panoId: "E3X3NcKbayHfLVENmFN5Kw",
    place: "Near Oviedo, Asturias",
    shortName: "Oviedo",
    countryCode: "ES",
    country: "Spain",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","ES"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "es-047",
    lat: 42.802633,
    lng: -1.660876,
    panoId: "JjQeEd8Kxe_3_NGTYGHk4Q",
    place: "Near Iturrama, Navarre",
    shortName: "Iturrama",
    countryCode: "ES",
    country: "Spain",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","ES"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "es-048",
    lat: 38.884305,
    lng: -6.954629,
    panoId: "hmLJNlBqeNRJWQSy4NmITQ",
    place: "Near Badajoz, Extremadura",
    shortName: "Badajoz",
    countryCode: "ES",
    country: "Spain",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","ES"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "es-049",
    lat: 40.957859,
    lng: -5.657953,
    panoId: "6xh64gGi_SCXrAJmbNGVMg",
    place: "Near Salamanca, Castille and León",
    shortName: "Salamanca",
    countryCode: "ES",
    country: "Spain",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","ES"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "es-050",
    lat: 36.787935,
    lng: -4.383839,
    panoId: "XZwGmaHfvQg1cp18N6rfOA",
    place: "Near Totalán, Andalusia",
    shortName: "Totalán",
    countryCode: "ES",
    country: "Spain",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","ES"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "es-051",
    lat: 37.36805,
    lng: -5.919823,
    panoId: "rRqHODJnLPPc4cUAwGKKkw",
    place: "Near Sevilla, Andalusia",
    shortName: "Sevilla",
    countryCode: "ES",
    country: "Spain",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","ES"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "es-052",
    lat: 37.938745,
    lng: -4.755671,
    panoId: "JJUFLpnpm4EWQHlPM0GWRg",
    place: "Near Córdoba, Andalusia",
    shortName: "Córdoba",
    countryCode: "ES",
    country: "Spain",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","ES"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "es-053",
    lat: 37.217166,
    lng: -6.946943,
    panoId: "gkpWpSJT5_C6xj9Mfw8OSA",
    place: "Near Punta Umbría, Andalusia",
    shortName: "Punta Umbría",
    countryCode: "ES",
    country: "Spain",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","ES"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "es-054",
    lat: 28.044425,
    lng: -15.4617,
    panoId: "M58wriDZvzptJarCTnfL_g",
    place: "Near Santa Brígida, Canary Islands",
    shortName: "Santa Brígida",
    countryCode: "ES",
    country: "Spain",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","ES"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "es-055",
    lat: 43.345773,
    lng: -8.451178,
    panoId: "Goxuql1_GBX3gg7zGK0-zg",
    place: "Near Pastoriza, Galicia",
    shortName: "Pastoriza",
    countryCode: "ES",
    country: "Spain",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","ES"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "es-056",
    lat: 43.447419,
    lng: -3.731526,
    panoId: "K5rBDutkZlycda7qOLqarw",
    place: "Near Santander, Cantabria",
    shortName: "Santander",
    countryCode: "ES",
    country: "Spain",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","ES"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "es-057",
    lat: 36.074302,
    lng: -5.434866,
    panoId: "kJDQbnJg3Y_0Us1VqBt8Sw",
    place: "Near Algeciras, Andalusia",
    shortName: "Algeciras",
    countryCode: "ES",
    country: "Spain",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","ES"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "es-058",
    lat: 40.894648,
    lng: -5.632613,
    panoId: "gSNinQsr8iYzUSNY0myxuw",
    place: "Near Arapiles, Castille and León",
    shortName: "Arapiles",
    countryCode: "ES",
    country: "Spain",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","ES"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "es-059",
    lat: 43.362746,
    lng: -5.88478,
    panoId: "dwEqxkEEAa9mu3FTvseBMg",
    place: "Near Oviedo, Asturias",
    shortName: "Oviedo",
    countryCode: "ES",
    country: "Spain",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","ES"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "es-060",
    lat: 36.504146,
    lng: -4.916818,
    panoId: "bvDtnqoGm69Rl2YfWTrmvA",
    place: "Near Marbella, Andalusia",
    shortName: "Marbella",
    countryCode: "ES",
    country: "Spain",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","ES"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "es-061",
    lat: 37.961037,
    lng: -1.108567,
    panoId: "dhiFnLLoErXU2uUtJk9sug",
    place: "Near Murcia, Murcia",
    shortName: "Murcia",
    countryCode: "ES",
    country: "Spain",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","ES"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "es-062",
    lat: 41.594349,
    lng: 0.710288,
    panoId: "0IB1j6pN813MMm6RiI7Dkw",
    place: "Near Alcoletge, Catalonia",
    shortName: "Alcoletge",
    countryCode: "ES",
    country: "Spain",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","ES"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "es-063",
    lat: 38.906317,
    lng: -6.966247,
    panoId: "eEdpNMElUnbXiq25GGvG0Q",
    place: "Near Badajoz, Extremadura",
    shortName: "Badajoz",
    countryCode: "ES",
    country: "Spain",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","ES"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "es-064",
    lat: 43.557676,
    lng: -5.746653,
    panoId: "QeQvL5SfpftKSUHP46TLkg",
    place: "Near Candás, Asturias",
    shortName: "Candás",
    countryCode: "ES",
    country: "Spain",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","ES"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "es-065",
    lat: 36.91001,
    lng: -2.465795,
    panoId: "iztKJ4OOkIgogjHR6BQZMA",
    place: "Near Benahadux, Andalusia",
    shortName: "Benahadux",
    countryCode: "ES",
    country: "Spain",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","ES"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "es-066",
    lat: 38.315448,
    lng: -0.6934,
    panoId: "ckMNO0fuaGmxgdm1QJ7aqw",
    place: "Near Elche, Valencia",
    shortName: "Elche",
    countryCode: "ES",
    country: "Spain",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","ES"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "es-067",
    lat: 41.647091,
    lng: -4.76204,
    panoId: "4Yz9KEytkUFhimLqSG1JSw",
    place: "Near Zaratán, Castille and León",
    shortName: "Zaratán",
    countryCode: "ES",
    country: "Spain",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","ES"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "es-068",
    lat: 42.798352,
    lng: -2.71845,
    panoId: "dvlF_rOzj-mbmmbUvjatKg",
    place: "Near Gasteiz / Vitoria, Basque Country",
    shortName: "Gasteiz / Vitoria",
    countryCode: "ES",
    country: "Spain",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","ES"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "es-069",
    lat: 41.645166,
    lng: -0.792765,
    panoId: "rX6BU6T-tdT0-XX5SqUsMw",
    place: "Near Puebla de Alfindén, Aragon",
    shortName: "Puebla de Alfindén",
    countryCode: "ES",
    country: "Spain",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","ES"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "es-070",
    lat: 42.503365,
    lng: -2.420431,
    panoId: "H5yyG4s_4A2YOHgdRHq0XQ",
    place: "Near Oion / Oyón, Basque Country",
    shortName: "Oion / Oyón",
    countryCode: "ES",
    country: "Spain",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","ES"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "es-071",
    lat: 42.296313,
    lng: -7.837555,
    panoId: "6636ww7AKr9UehrOvv2wvQ",
    place: "Near Ourense, Galicia",
    shortName: "Ourense",
    countryCode: "ES",
    country: "Spain",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","ES"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "es-072",
    lat: 42.845252,
    lng: -1.707185,
    panoId: "6gVE4z74TKJamvghYGB7BQ",
    place: "Near Berriobeiti, Navarre",
    shortName: "Berriobeiti",
    countryCode: "ES",
    country: "Spain",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","ES"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "es-073",
    lat: 28.423304,
    lng: -16.316569,
    panoId: "Q2Eje7CAaa7oaCumM8VGFw",
    place: "Near La Laguna, Canary Islands",
    shortName: "La Laguna",
    countryCode: "ES",
    country: "Spain",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","ES"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "es-074",
    lat: 36.297016,
    lng: -6.142038,
    panoId: "0wOMnrvhLhcw0BxL0Xcj2w",
    place: "Near Conil de la Frontera, Andalusia",
    shortName: "Conil de la Frontera",
    countryCode: "ES",
    country: "Spain",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","ES"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "es-075",
    lat: 41.94958,
    lng: 2.776807,
    panoId: "BEq0Ajzg0aejbwbpzVUoAw",
    place: "Near Vilablareix, Catalonia",
    shortName: "Vilablareix",
    countryCode: "ES",
    country: "Spain",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","ES"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "es-076",
    lat: 43.235192,
    lng: -3.014877,
    panoId: "8t_C56Ir5B5kD8A5Hw64gw",
    place: "Near Alonsotegi, Basque Country",
    shortName: "Alonsotegi",
    countryCode: "ES",
    country: "Spain",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","ES"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "es-077",
    lat: 28.030539,
    lng: -15.395348,
    panoId: "Z43Ai90-nVLVKER4GOJ8vQ",
    place: "Near Telde, Canary Islands",
    shortName: "Telde",
    countryCode: "ES",
    country: "Spain",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","ES"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "es-078",
    lat: 36.725469,
    lng: -2.658728,
    panoId: "h4KvzKuWC-Q-0KtnkW5HYg",
    place: "Near Roquetas de Mar, Andalusia",
    shortName: "Roquetas de Mar",
    countryCode: "ES",
    country: "Spain",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","ES"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "es-079",
    lat: 39.525855,
    lng: -6.328801,
    panoId: "3q38EwYH7VIIxJQyQqWRZQ",
    place: "Near Cáceres, Extremadura",
    shortName: "Cáceres",
    countryCode: "ES",
    country: "Spain",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","ES"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "es-080",
    lat: 37.959687,
    lng: -1.152894,
    panoId: "7gMdsyHO8Y1Vbed4a-FQPg",
    place: "Near Murcia, Murcia",
    shortName: "Murcia",
    countryCode: "ES",
    country: "Spain",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","ES"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "es-081",
    lat: 41.675792,
    lng: 0.647927,
    panoId: "OYVbIdyRCi73gAre2QLOUg",
    place: "Near Torrefarrera, Catalonia",
    shortName: "Torrefarrera",
    countryCode: "ES",
    country: "Spain",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","ES"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "es-082",
    lat: 40.667621,
    lng: -3.163571,
    panoId: "oWTUA56xVW3MJ9-fbf-Seg",
    place: "Near Marchamalo, Castille-La Mancha",
    shortName: "Marchamalo",
    countryCode: "ES",
    country: "Spain",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","ES"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "es-083",
    lat: 36.395981,
    lng: -6.20546,
    panoId: "PMGBbg0JD76iOsafvvn_yw",
    place: "Near Chiclana de la Frontera, Andalusia",
    shortName: "Chiclana de la Frontera",
    countryCode: "ES",
    country: "Spain",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","ES"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "es-084",
    lat: 41.138143,
    lng: 1.31349,
    panoId: "tT-uD7-qKmJ34Q1B79C9Tw",
    place: "Near el Catllar, Catalonia",
    shortName: "el Catllar",
    countryCode: "ES",
    country: "Spain",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","ES"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "es-085",
    lat: 28.514939,
    lng: -16.242846,
    panoId: "rI0EFtHYuVJh5ZhiXNU5Pg",
    place: "Near Santa Cruz de Tenerife, Canary Islands",
    shortName: "Santa Cruz de Tenerife",
    countryCode: "ES",
    country: "Spain",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","ES"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "es-086",
    lat: 39.046592,
    lng: -1.836181,
    panoId: "ajPdRsSSHC376OdcGwRLLg",
    place: "Near Albacete, Castille-La Mancha",
    shortName: "Albacete",
    countryCode: "ES",
    country: "Spain",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","ES"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "es-087",
    lat: 41.19441,
    lng: 1.134613,
    panoId: "G9SvDIH6C1iO4HSAr9_CEw",
    place: "Near Almoster, Catalonia",
    shortName: "Almoster",
    countryCode: "ES",
    country: "Spain",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","ES"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "es-088",
    lat: 36.66967,
    lng: -6.340256,
    panoId: "wpl7btgpvW28Ik6w3hM-ig",
    place: "Near Rota, Andalusia",
    shortName: "Rota",
    countryCode: "ES",
    country: "Spain",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","ES"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "es-089",
    lat: 39.910198,
    lng: -3.979302,
    panoId: "GJLAggYJIj96VvkhR1mRVQ",
    place: "Near Olías del Rey, Castille-La Mancha",
    shortName: "Olías del Rey",
    countryCode: "ES",
    country: "Spain",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","ES"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "es-090",
    lat: 37.738684,
    lng: -3.719828,
    panoId: "hCQ5-A187aqqJ5lfbFwBMg",
    place: "Near La Guardia de Jaén, Andalusia",
    shortName: "La Guardia de Jaén",
    countryCode: "ES",
    country: "Spain",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","ES"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "es-091",
    lat: 43.37496,
    lng: -3.883881,
    panoId: "nVLu_Av78pAQ_E-_SFQlgA",
    place: "Near Camargo, Cantabria",
    shortName: "Camargo",
    countryCode: "ES",
    country: "Spain",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","ES"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "es-092",
    lat: 42.409251,
    lng: -7.87274,
    panoId: "mcNTxx4UW31vc4R-0-JERw",
    place: "Near Vilarnaz, Galicia",
    shortName: "Vilarnaz",
    countryCode: "ES",
    country: "Spain",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","ES"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "es-093",
    lat: 41.979841,
    lng: 2.750272,
    panoId: "yqdCH0YZZOXTc8In6Yhlhg",
    place: "Near Sant Gregori, Catalonia",
    shortName: "Sant Gregori",
    countryCode: "ES",
    country: "Spain",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","ES"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "es-094",
    lat: 42.389376,
    lng: -8.617425,
    panoId: "09tkwSWYJFZ1f208j7W3Kw",
    place: "Near Pontevedra, Galicia",
    shortName: "Pontevedra",
    countryCode: "ES",
    country: "Spain",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","ES"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "es-095",
    lat: 36.7804,
    lng: -2.643314,
    panoId: "t3xTv-_uxtYqVfn4SnTTxw",
    place: "Near Roquetas de Mar, Andalusia",
    shortName: "Roquetas de Mar",
    countryCode: "ES",
    country: "Spain",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","ES"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "es-096",
    lat: 36.398258,
    lng: -6.177755,
    panoId: "7jjTzETS-cIdJ23MtxZkMA",
    place: "Near Chiclana de la Frontera, Andalusia",
    shortName: "Chiclana de la Frontera",
    countryCode: "ES",
    country: "Spain",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","ES"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "es-097",
    lat: 42.586539,
    lng: -5.739946,
    panoId: "7LAXjvb0Yj45rZL6R1numQ",
    place: "Near Valverde de la Virgen, Castille and León",
    shortName: "Valverde de la Virgen",
    countryCode: "ES",
    country: "Spain",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","ES"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "es-098",
    lat: 36.682274,
    lng: -6.170852,
    panoId: "5XgYBf-pK3t1SLi2zEryyg",
    place: "Near Jerez de la Frontera, Andalusia",
    shortName: "Jerez de la Frontera",
    countryCode: "ES",
    country: "Spain",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","ES"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "es-099",
    lat: 42.594943,
    lng: -8.486905,
    panoId: "hc1I3M0tQOj8z-i1udfxrQ",
    place: "Near Cuntis, Galicia",
    shortName: "Cuntis",
    countryCode: "ES",
    country: "Spain",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","ES"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "es-100",
    lat: 42.198097,
    lng: -4.513639,
    panoId: "9YKP5VQ7qnHrVJ742Xtu_Q",
    place: "Near San Cebrián de Campos, Castille and León",
    shortName: "San Cebrián de Campos",
    countryCode: "ES",
    country: "Spain",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","ES"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "es-101",
    lat: 39.656845,
    lng: -6.391781,
    panoId: "rGvkSCah7ram3MkZmm06-A",
    place: "Near Santiago del Campo, Extremadura",
    shortName: "Santiago del Campo",
    countryCode: "ES",
    country: "Spain",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","ES"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "es-102",
    lat: 42.41193,
    lng: -3.866558,
    panoId: "LlWmsLEr4cAu6y49tEZkBA",
    place: "Near Villanueva de Argaño, Castille and León",
    shortName: "Villanueva de Argaño",
    countryCode: "ES",
    country: "Spain",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","ES"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "es-103",
    lat: 42.459962,
    lng: -2.210061,
    panoId: "ci2uXM4JEtv_yolJzRwUrA",
    place: "Near Mendavia, Navarre",
    shortName: "Mendavia",
    countryCode: "ES",
    country: "Spain",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","ES"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "es-104",
    lat: 37.635727,
    lng: -1.543969,
    panoId: "NX1hnWnx30uxz3L7Q6xhjA",
    place: "Near Cazalla, Murcia",
    shortName: "Cazalla",
    countryCode: "ES",
    country: "Spain",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","ES"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "es-105",
    lat: 39.982552,
    lng: -4.610963,
    panoId: "KyckB_0XAcq9BOYTPiR_dw",
    place: "Near Lucillos, Castille-La Mancha",
    shortName: "Lucillos",
    countryCode: "ES",
    country: "Spain",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","ES"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nl-000",
    lat: 51.586552,
    lng: 4.776145,
    panoId: "QJkH5rc6bZxafAUuzRkbjg",
    place: "Near Breda, North Brabant",
    shortName: "Breda",
    countryCode: "NL",
    country: "Netherlands",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","NL"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "nl-001",
    lat: 51.699121,
    lng: 5.304203,
    panoId: "KL_oe-Q9We53f1TtkoaYFQ",
    place: "Near 's-Hertogenbosch, North Brabant",
    shortName: "'s-Hertogenbosch",
    countryCode: "NL",
    country: "Netherlands",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","NL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nl-002",
    lat: 51.922445,
    lng: 4.47896,
    panoId: "ok_JiIfdEgJh2g8kDM0OCg",
    place: "Near Rotterdam, South Holland",
    shortName: "Rotterdam",
    countryCode: "NL",
    country: "Netherlands",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","NL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nl-003",
    lat: 52.374109,
    lng: 4.889507,
    panoId: "1i5LEjzxrsaFVKHuV9_iSg",
    place: "Near Amsterdam, North Holland",
    shortName: "Amsterdam",
    countryCode: "NL",
    country: "Netherlands",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","NL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nl-004",
    lat: 53.219231,
    lng: 6.567009,
    panoId: "IoY4HcteGJzRWVQwrdpr5w",
    place: "Near Groningen, Groningen",
    shortName: "Groningen",
    countryCode: "NL",
    country: "Netherlands",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","NL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nl-005",
    lat: 52.380792,
    lng: 4.636819,
    panoId: "QnGB7pISOfsbxaic6qY7DQ",
    place: "Near Haarlem, North Holland",
    shortName: "Haarlem",
    countryCode: "NL",
    country: "Netherlands",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","NL"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "nl-006",
    lat: 50.848445,
    lng: 5.688915,
    panoId: "yF5sZGsX10CDLVVmcQrEEw",
    place: "Near Maastricht, Limburg",
    shortName: "Maastricht",
    countryCode: "NL",
    country: "Netherlands",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","NL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nl-007",
    lat: 52.033577,
    lng: 5.658029,
    panoId: "2xBlltii8nIJsZvFzPFLag",
    place: "Near Ede, Gelderland",
    shortName: "Ede",
    countryCode: "NL",
    country: "Netherlands",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","NL"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "nl-008",
    lat: 53.20279,
    lng: 5.809649,
    panoId: "Z1I8jidUsbpERiFD51W6Zg",
    place: "Near Leeuwarden, Friesland",
    shortName: "Leeuwarden",
    countryCode: "NL",
    country: "Netherlands",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","NL"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "nl-009",
    lat: 51.842499,
    lng: 5.852813,
    panoId: "not5FXR6NjHzW3bVSQ-bWA",
    place: "Near Nijmegen, Gelderland",
    shortName: "Nijmegen",
    countryCode: "NL",
    country: "Netherlands",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","NL"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "nl-010",
    lat: 50.884059,
    lng: 5.982437,
    panoId: "2bhUInEH86dGjWu1O73dgg",
    place: "Near Heerlen, Limburg",
    shortName: "Heerlen",
    countryCode: "NL",
    country: "Netherlands",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","NL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nl-011",
    lat: 51.53083,
    lng: 4.465398,
    panoId: "lNLjV9afaqmXvLUh-iFQWA",
    place: "Near Roosendaal, North Brabant",
    shortName: "Roosendaal",
    countryCode: "NL",
    country: "Netherlands",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","NL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nl-012",
    lat: 51.555189,
    lng: 5.091257,
    panoId: "cO94s5nhENDOkVivLkMJjQ",
    place: "Near Tilburg, North Brabant",
    shortName: "Tilburg",
    countryCode: "NL",
    country: "Netherlands",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","NL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nl-013",
    lat: 51.980129,
    lng: 5.911483,
    panoId: "NUJZKLwrTkjAXF_3ozpaYA",
    place: "Near Arnhem, Gelderland",
    shortName: "Arnhem",
    countryCode: "NL",
    country: "Netherlands",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","NL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nl-014",
    lat: 52.090831,
    lng: 5.122103,
    panoId: "4tjetNQD5ApB5S9JUkixlg",
    place: "Near Utrecht, Utrecht",
    shortName: "Utrecht",
    countryCode: "NL",
    country: "Netherlands",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","NL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nl-015",
    lat: 52.779102,
    lng: 6.906867,
    panoId: "8Zbu8CcutFmn6i2PO83aqw",
    place: "Near Emmen, Drenthe",
    shortName: "Emmen",
    countryCode: "NL",
    country: "Netherlands",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","NL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nl-016",
    lat: 52.356692,
    lng: 6.662553,
    panoId: "a2I31k9hIx2u_OaoR4IptA",
    place: "Near Almelo, Overijssel",
    shortName: "Almelo",
    countryCode: "NL",
    country: "Netherlands",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","NL"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "nl-017",
    lat: 52.512414,
    lng: 6.094416,
    panoId: "cjTc3BPAfPbDDVg2CjKzgA",
    place: "Near Zwolle, Overijssel",
    shortName: "Zwolle",
    countryCode: "NL",
    country: "Netherlands",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","NL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nl-018",
    lat: 51.76492,
    lng: 5.518157,
    panoId: "SH3Ur9Vk1VMEN43dnXeicw",
    place: "Near Oss, North Brabant",
    shortName: "Oss",
    countryCode: "NL",
    country: "Netherlands",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","NL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nl-019",
    lat: 52.218189,
    lng: 6.895727,
    panoId: "GcyWoPPP6F_DDDKPbmlBYw",
    place: "Near Enschede, Overijssel",
    shortName: "Enschede",
    countryCode: "NL",
    country: "Netherlands",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","NL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nl-020",
    lat: 52.21011,
    lng: 5.969628,
    panoId: "grUmG7eUUh5RStcrfIM0Vg",
    place: "Near Apeldoorn, Gelderland",
    shortName: "Apeldoorn",
    countryCode: "NL",
    country: "Netherlands",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","NL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nl-021",
    lat: 51.440793,
    lng: 5.477509,
    panoId: "4ikGtQ4Mp85gwdnNOjhhCQ",
    place: "Near Eindhoven, North Brabant",
    shortName: "Eindhoven",
    countryCode: "NL",
    country: "Netherlands",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","NL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nl-022",
    lat: 52.255247,
    lng: 6.163909,
    panoId: "GpsAyLrjubRRzPgsIkOjuw",
    place: "Near Deventer, Overijssel",
    shortName: "Deventer",
    countryCode: "NL",
    country: "Netherlands",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","NL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nl-023",
    lat: 52.028692,
    lng: 5.559004,
    panoId: "XpRQbbZ8_zCONTe7hRbNpg",
    place: "Near Veenendaal, Utrecht",
    shortName: "Veenendaal",
    countryCode: "NL",
    country: "Netherlands",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","NL"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "nl-024",
    lat: 52.996681,
    lng: 6.562667,
    panoId: "zebXLYhx00rZV0SQRi3vmw",
    place: "Near Assen, Drenthe",
    shortName: "Assen",
    countryCode: "NL",
    country: "Netherlands",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","NL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nl-025",
    lat: 51.370009,
    lng: 6.167807,
    panoId: "RlUSSjTX_oxrmbFxBRkc1w",
    place: "Near Venlo, Limburg",
    shortName: "Venlo",
    countryCode: "NL",
    country: "Netherlands",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","NL"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "nl-026",
    lat: 51.644984,
    lng: 4.859682,
    panoId: "en5EJiw2eE68om8_9no3aw",
    place: "Near Oosterhout, North Brabant",
    shortName: "Oosterhout",
    countryCode: "NL",
    country: "Netherlands",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","NL"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "nl-027",
    lat: 52.508372,
    lng: 5.474744,
    panoId: "crC6r3qhYbSZSScnMw-vCQ",
    place: "Near Lelystad, Flevoland",
    shortName: "Lelystad",
    countryCode: "NL",
    country: "Netherlands",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","NL"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "nl-028",
    lat: 52.95987,
    lng: 4.759346,
    panoId: "K2N4k5xZsNbIZBRO6_bzHA",
    place: "Near Den Helder, North Holland",
    shortName: "Den Helder",
    countryCode: "NL",
    country: "Netherlands",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","NL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nl-029",
    lat: 52.265679,
    lng: 6.793335,
    panoId: "gehK6gv3w5nPwB-Vl7y8yQ",
    place: "Near Hengelo, Overijssel",
    shortName: "Hengelo",
    countryCode: "NL",
    country: "Netherlands",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","NL"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "nl-030",
    lat: 52.029283,
    lng: 5.080565,
    panoId: "MtxXZzcgHDuy9wYQBVnOjA",
    place: "Near Nieuwegein, Utrecht",
    shortName: "Nieuwegein",
    countryCode: "NL",
    country: "Netherlands",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","NL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nl-031",
    lat: 51.494962,
    lng: 4.291477,
    panoId: "6BueO588VFf2l4FpbBGgfQ",
    place: "Near Bergen op Zoom, North Brabant",
    shortName: "Bergen op Zoom",
    countryCode: "NL",
    country: "Netherlands",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","NL"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "nl-032",
    lat: 50.998592,
    lng: 5.869127,
    panoId: "0yNcaID5ylVdgsf4GMKmVQ",
    place: "Near Sittard, Limburg",
    shortName: "Sittard",
    countryCode: "NL",
    country: "Netherlands",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","NL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nl-033",
    lat: 52.555378,
    lng: 5.912192,
    panoId: "AHGrgGlEuC0JmEKHrfvbHg",
    place: "Near Kampen, Overijssel",
    shortName: "Kampen",
    countryCode: "NL",
    country: "Netherlands",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","NL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nl-034",
    lat: 51.251685,
    lng: 5.706917,
    panoId: "LP1vsWkcWGBtSGkOl46eQA",
    place: "Near Weert, Limburg",
    shortName: "Weert",
    countryCode: "NL",
    country: "Netherlands",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","NL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nl-035",
    lat: 51.544262,
    lng: 4.485187,
    panoId: "pVQebC_TNwFnDsgRQXi72A",
    place: "Near Kalsdonk, North Brabant",
    shortName: "Kalsdonk",
    countryCode: "NL",
    country: "Netherlands",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","NL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nl-036",
    lat: 51.470875,
    lng: 5.692484,
    panoId: "KKbSdhzL9ixmi9XFnAIbpQ",
    place: "Near Helmond, North Brabant",
    shortName: "Helmond",
    countryCode: "NL",
    country: "Netherlands",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","NL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nl-037",
    lat: 51.997204,
    lng: 5.921528,
    panoId: "GlBg4hIwNtqXIk1Z0Ael_Q",
    place: "Near Geitenkamp, Gelderland",
    shortName: "Geitenkamp",
    countryCode: "NL",
    country: "Netherlands",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","NL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nl-038",
    lat: 50.865643,
    lng: 6.061915,
    panoId: "wXWhdZECCe6KnhI5nKQBrQ",
    place: "Near Kerkrade, Limburg",
    shortName: "Kerkrade",
    countryCode: "NL",
    country: "Netherlands",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","NL"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "nl-039",
    lat: 52.770233,
    lng: 6.900876,
    panoId: "j-OT49Ig1B5fLHiph5_agA",
    place: "Near Noordbarge, Drenthe",
    shortName: "Noordbarge",
    countryCode: "NL",
    country: "Netherlands",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","NL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nl-040",
    lat: 52.944597,
    lng: 4.734649,
    panoId: "dkDTTxiuKJ5c3ehSW3uIXA",
    place: "Near Den Helder, North Holland",
    shortName: "Den Helder",
    countryCode: "NL",
    country: "Netherlands",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","NL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nl-041",
    lat: 50.86445,
    lng: 5.977814,
    panoId: "Q44IBAt837PEKBqgWEp94g",
    place: "Near Heerlen, Limburg",
    shortName: "Heerlen",
    countryCode: "NL",
    country: "Netherlands",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","NL"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "nl-042",
    lat: 51.918365,
    lng: 4.459223,
    panoId: "zOoTw3vduKE1Soj0rVmqDA",
    place: "Near Rotterdam, South Holland",
    shortName: "Rotterdam",
    countryCode: "NL",
    country: "Netherlands",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","NL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nl-043",
    lat: 52.995244,
    lng: 6.540936,
    panoId: "SdxWg4iR5L33j-DWjhcgKQ",
    place: "Near Assen, Drenthe",
    shortName: "Assen",
    countryCode: "NL",
    country: "Netherlands",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","NL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nl-044",
    lat: 52.364995,
    lng: 4.628796,
    panoId: "81HLwwRGpnugyHu_172P-w",
    place: "Near Heemstede, North Holland",
    shortName: "Heemstede",
    countryCode: "NL",
    country: "Netherlands",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","NL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nl-045",
    lat: 53.238555,
    lng: 6.58032,
    panoId: "JJzvFB27R1VqDvMjPktgVw",
    place: "Near Korrewegwijk, Groningen",
    shortName: "Korrewegwijk",
    countryCode: "NL",
    country: "Netherlands",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","NL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nl-046",
    lat: 52.101421,
    lng: 5.153927,
    panoId: "ywYRuwWFD4Ej48Df1evCWQ",
    place: "Near De Bilt, Utrecht",
    shortName: "De Bilt",
    countryCode: "NL",
    country: "Netherlands",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","NL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nl-047",
    lat: 51.95999,
    lng: 6.257313,
    panoId: "nuLhgZSIqUHy4qPxuQwFwQ",
    place: "Near Doetinchem, Gelderland",
    shortName: "Doetinchem",
    countryCode: "NL",
    country: "Netherlands",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","NL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nl-048",
    lat: 52.263163,
    lng: 6.823177,
    panoId: "y9PrvbaVtUYlakGJAuH_cg",
    place: "Near Klein Driene, Overijssel",
    shortName: "Klein Driene",
    countryCode: "NL",
    country: "Netherlands",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","NL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nl-049",
    lat: 52.210963,
    lng: 6.874018,
    panoId: "YhXQp4uTFg0wUdGKi63JjA",
    place: "Near Pathmos, Overijssel",
    shortName: "Pathmos",
    countryCode: "NL",
    country: "Netherlands",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","NL"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "nl-050",
    lat: 51.817358,
    lng: 5.48603,
    panoId: "5sB0CYlzgbDdK4SCDsWIPw",
    place: "Near Lith, North Brabant",
    shortName: "Lith",
    countryCode: "NL",
    country: "Netherlands",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","NL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nl-051",
    lat: 51.673666,
    lng: 5.221304,
    panoId: "mnANfkgCD0Pd9KYzCkHLmw",
    place: "Near Vliedberg, North Brabant",
    shortName: "Vliedberg",
    countryCode: "NL",
    country: "Netherlands",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","NL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nl-052",
    lat: 51.51495,
    lng: 4.390853,
    panoId: "UpCwFNklb-uFrA7mEVtpsQ",
    place: "Near Wouw, North Brabant",
    shortName: "Wouw",
    countryCode: "NL",
    country: "Netherlands",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","NL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nl-053",
    lat: 52.569831,
    lng: 6.146655,
    panoId: "fCJFE_ica7ysXgx257QdSg",
    place: "Near Hasselt, Overijssel",
    shortName: "Hasselt",
    countryCode: "NL",
    country: "Netherlands",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","NL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nl-054",
    lat: 51.190938,
    lng: 5.71927,
    panoId: "eN377f9CC2pfkVjvqJal3A",
    place: "Near Stramproy, Limburg",
    shortName: "Stramproy",
    countryCode: "NL",
    country: "Netherlands",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","NL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nl-055",
    lat: 52.527569,
    lng: 6.578764,
    panoId: "HpFCs_R42tJAMz3jU1bGdg",
    place: "Near Hardenberg, Overijssel",
    shortName: "Hardenberg",
    countryCode: "NL",
    country: "Netherlands",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","NL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nl-056",
    lat: 51.523769,
    lng: 4.987674,
    panoId: "ykOXByIKMmlcvl1Fla49QQ",
    place: "Near Gilze, North Brabant",
    shortName: "Gilze",
    countryCode: "NL",
    country: "Netherlands",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","NL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nl-057",
    lat: 51.484124,
    lng: 4.431411,
    panoId: "mGOPE6AXV-KoLvgHEC_oHg",
    place: "Near Nispen, North Brabant",
    shortName: "Nispen",
    countryCode: "NL",
    country: "Netherlands",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","NL"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "nl-058",
    lat: 52.225232,
    lng: 5.905123,
    panoId: "gx3naDMRAzRNWW0KTd2xDg",
    place: "Near Berg en Bos, Gelderland",
    shortName: "Berg en Bos",
    countryCode: "NL",
    country: "Netherlands",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","NL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nl-059",
    lat: 52.152077,
    lng: 5.148577,
    panoId: "b2kXHQ-NMMaavtMnYTcVJg",
    place: "Near Westbroek, Utrecht",
    shortName: "Westbroek",
    countryCode: "NL",
    country: "Netherlands",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","NL"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "nl-060",
    lat: 52.829153,
    lng: 6.969765,
    panoId: "pZ5GsFaFXZ99NbYIbWCfrw",
    place: "Near Emmer-Erfscheidenveen, Drenthe",
    shortName: "Emmer-Erfscheidenveen",
    countryCode: "NL",
    country: "Netherlands",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","NL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nl-061",
    lat: 52.032064,
    lng: 5.862636,
    panoId: "fEd6Ju-T7WJK_i_H2hH5kA",
    place: "Near Bakenberg, Gelderland",
    shortName: "Bakenberg",
    countryCode: "NL",
    country: "Netherlands",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","NL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nl-062",
    lat: 53.046681,
    lng: 6.608,
    panoId: "I-J0-MDGT5K5G0BHd4hcQQ",
    place: "Near Tynaarlo, Drenthe",
    shortName: "Tynaarlo",
    countryCode: "NL",
    country: "Netherlands",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","NL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nl-063",
    lat: 52.530504,
    lng: 5.930691,
    panoId: "W8fmaFopaXUMRU4vevC0GQ",
    place: "Near Flevowijk, Overijssel",
    shortName: "Flevowijk",
    countryCode: "NL",
    country: "Netherlands",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","NL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nl-064",
    lat: 52.048269,
    lng: 5.000221,
    panoId: "QkFunQj15TU9Br6ET-WPYA",
    place: "Near Veldhuizen, Utrecht",
    shortName: "Veldhuizen",
    countryCode: "NL",
    country: "Netherlands",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","NL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nl-065",
    lat: 52.417931,
    lng: 4.710588,
    panoId: "0Jyc8hvFQ5PbVOlRW-rMbg",
    place: "Near Spaarndam, North Holland",
    shortName: "Spaarndam",
    countryCode: "NL",
    country: "Netherlands",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","NL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nl-066",
    lat: 52.662605,
    lng: 5.669348,
    panoId: "vLt6t3XTTm1vpJ8jIkwdnQ",
    place: "Near Tollebeek, Flevoland",
    shortName: "Tollebeek",
    countryCode: "NL",
    country: "Netherlands",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","NL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nl-067",
    lat: 52.307495,
    lng: 6.698061,
    panoId: "YlFOvFcwrBTG2gDmQF-DDw",
    place: "Near Borne, Overijssel",
    shortName: "Borne",
    countryCode: "NL",
    country: "Netherlands",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","NL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nl-068",
    lat: 52.09215,
    lng: 5.360638,
    panoId: "4NAqSmLuNhvg-gCZ_J2zng",
    place: "Near Maarn, Utrecht",
    shortName: "Maarn",
    countryCode: "NL",
    country: "Netherlands",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","NL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nl-069",
    lat: 51.194639,
    lng: 5.764136,
    panoId: "e1FxQAlTibkUgRncdqkH8A",
    place: "Near Stramproy, Limburg",
    shortName: "Stramproy",
    countryCode: "NL",
    country: "Netherlands",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","NL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nl-070",
    lat: 52.538718,
    lng: 5.45815,
    panoId: "FirthOnWuwrQyvUN-Y3Atg",
    place: "Near Lelystad, Flevoland",
    shortName: "Lelystad",
    countryCode: "NL",
    country: "Netherlands",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","NL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nl-071",
    lat: 52.287527,
    lng: 6.234877,
    panoId: "2-VzNc-E-Fn7ehar2BD3_Q",
    place: "Near Schalkhaar, Overijssel",
    shortName: "Schalkhaar",
    countryCode: "NL",
    country: "Netherlands",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","NL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nl-072",
    lat: 50.837778,
    lng: 6.04929,
    panoId: "ivipx8mSSqIjda41Q-qq_w",
    place: "Near Gracht, Limburg",
    shortName: "Gracht",
    countryCode: "NL",
    country: "Netherlands",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","NL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nl-073",
    lat: 52.348368,
    lng: 4.836772,
    panoId: "ZgGuaViQufi5C3oh0ETHCw",
    place: "Near Badhoevedorp, North Holland",
    shortName: "Badhoevedorp",
    countryCode: "NL",
    country: "Netherlands",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","NL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nl-074",
    lat: 52.379823,
    lng: 5.570796,
    panoId: "pgXGJ4XBCTwOEwl-hpNUYQ",
    place: "Near Harderwijk, Gelderland",
    shortName: "Harderwijk",
    countryCode: "NL",
    country: "Netherlands",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","NL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nl-075",
    lat: 51.999772,
    lng: 6.258909,
    panoId: "pphqjdFQeMjQygTXQtskPQ",
    place: "Near Hummelo, Gelderland",
    shortName: "Hummelo",
    countryCode: "NL",
    country: "Netherlands",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","NL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nl-076",
    lat: 51.588648,
    lng: 5.544449,
    panoId: "bJaX-H109WtF90n0kcM9Tw",
    place: "Near Zijtaart, North Brabant",
    shortName: "Zijtaart",
    countryCode: "NL",
    country: "Netherlands",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","NL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nl-077",
    lat: 52.0444,
    lng: 5.490438,
    panoId: "vyze5Ekyvo2O8Qfdu_FeLA",
    place: "Near Overberg, Utrecht",
    shortName: "Overberg",
    countryCode: "NL",
    country: "Netherlands",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","NL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nl-078",
    lat: 52.542856,
    lng: 5.963021,
    panoId: "vHS8eWyOBwHr9nu4EJntAg",
    place: "Near Oosterholt, Overijssel",
    shortName: "Oosterholt",
    countryCode: "NL",
    country: "Netherlands",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","NL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nl-079",
    lat: 50.862279,
    lng: 6.013473,
    panoId: "XJM4L0Ct2sBN6b2rFZBt6g",
    place: "Near Terwinselen, Limburg",
    shortName: "Terwinselen",
    countryCode: "NL",
    country: "Netherlands",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","NL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nl-080",
    lat: 51.5457,
    lng: 6.06221,
    panoId: "go70GGrw-v69-ZKbx3ugiw",
    place: "Near Wanssum, Limburg",
    shortName: "Wanssum",
    countryCode: "NL",
    country: "Netherlands",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","NL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nl-081",
    lat: 52.537529,
    lng: 6.681467,
    panoId: "KlW0McoZ_lCxaf5cuxt9rA",
    place: "Near Baalder, Overijssel",
    shortName: "Baalder",
    countryCode: "NL",
    country: "Netherlands",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","NL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nl-082",
    lat: 51.929201,
    lng: 5.461092,
    panoId: "FcbcaWx9h3rsS6LTA2FzeA",
    place: "Near Ingen, Gelderland",
    shortName: "Ingen",
    countryCode: "NL",
    country: "Netherlands",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","NL"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "nl-083",
    lat: 52.201665,
    lng: 5.54259,
    panoId: "mqxpa7Cuz5BXcRG6OaUdxw",
    place: "Near Nijkerk, Gelderland",
    shortName: "Nijkerk",
    countryCode: "NL",
    country: "Netherlands",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","NL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nl-084",
    lat: 51.44918,
    lng: 3.842599,
    panoId: "8lxfRVM7BSfBAbo3hk_9hw",
    place: "Near Goes, Zeeland",
    shortName: "Goes",
    countryCode: "NL",
    country: "Netherlands",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","NL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nl-085",
    lat: 52.751696,
    lng: 5.024752,
    panoId: "buoiIkI8vPoI0IA0h0MkMA",
    place: "Near Twisk, North Holland",
    shortName: "Twisk",
    countryCode: "NL",
    country: "Netherlands",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","NL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nl-086",
    lat: 52.488745,
    lng: 4.710563,
    panoId: "7trjBDh-XV53wuBkgjzalA",
    place: "Near Assendelft, North Holland",
    shortName: "Assendelft",
    countryCode: "NL",
    country: "Netherlands",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","NL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nl-087",
    lat: 51.430558,
    lng: 5.193159,
    panoId: "J4EQQIPQsMNM7eBCJZDxww",
    place: "Near Lage Mierde, North Brabant",
    shortName: "Lage Mierde",
    countryCode: "NL",
    country: "Netherlands",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","NL"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "nl-088",
    lat: 51.650507,
    lng: 5.378657,
    panoId: "NsXeqc9cZaE3JBHz0al6hw",
    place: "Near Maaskantje, North Brabant",
    shortName: "Maaskantje",
    countryCode: "NL",
    country: "Netherlands",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","NL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nl-089",
    lat: 51.577457,
    lng: 6.160104,
    panoId: "MiYUfmq03pvWE7_byr1M1w",
    place: "Near Wellerlooi, Limburg",
    shortName: "Wellerlooi",
    countryCode: "NL",
    country: "Netherlands",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","NL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nl-090",
    lat: 52.115796,
    lng: 5.714713,
    panoId: "wjr1tU1qdtSYClHrlOOaxw",
    place: "Near Wekerom, Gelderland",
    shortName: "Wekerom",
    countryCode: "NL",
    country: "Netherlands",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","NL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nl-091",
    lat: 51.67244,
    lng: 5.242104,
    panoId: "DKdt0fYReft45hsSOi3GDQ",
    place: "Near Deuteren, North Brabant",
    shortName: "Deuteren",
    countryCode: "NL",
    country: "Netherlands",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","NL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nl-092",
    lat: 52.525067,
    lng: 4.782602,
    panoId: "8JnQ6vEcludwvQD525ySGw",
    place: "Near Langeheit, North Holland",
    shortName: "Langeheit",
    countryCode: "NL",
    country: "Netherlands",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","NL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nl-093",
    lat: 52.815657,
    lng: 6.511783,
    panoId: "uvAGbfFEpuzRu6jbOUOdyg",
    place: "Near Beilen, Drenthe",
    shortName: "Beilen",
    countryCode: "NL",
    country: "Netherlands",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","NL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nl-094",
    lat: 51.542482,
    lng: 3.775016,
    panoId: "VTi6INSalrPzWJuREPAesA",
    place: "Near Wolphaartsdijk, Zeeland",
    shortName: "Wolphaartsdijk",
    countryCode: "NL",
    country: "Netherlands",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","NL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nl-095",
    lat: 52.318064,
    lng: 5.867664,
    panoId: "lQZ8nbVOkKZ0OWbir-jubA",
    place: "Near Elspeet, Gelderland",
    shortName: "Elspeet",
    countryCode: "NL",
    country: "Netherlands",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","NL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nl-096",
    lat: 52.916984,
    lng: 6.070184,
    panoId: "57U-JOY3G_ZUu1x_AOexcw",
    place: "Near Nieuwehorne, Friesland",
    shortName: "Nieuwehorne",
    countryCode: "NL",
    country: "Netherlands",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","NL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nl-097",
    lat: 52.266823,
    lng: 5.38325,
    panoId: "HjRyDF9oDwg0PZPfDBntaA",
    place: "Near Spakenburg, Utrecht",
    shortName: "Spakenburg",
    countryCode: "NL",
    country: "Netherlands",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","NL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nl-098",
    lat: 52.534375,
    lng: 5.631835,
    panoId: "nNiQEfxrEpfLsXOwhQgIcQ",
    place: "Near Swifterbant, Flevoland",
    shortName: "Swifterbant",
    countryCode: "NL",
    country: "Netherlands",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","NL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nl-099",
    lat: 51.944154,
    lng: 5.505395,
    panoId: "NH2O1Yk_E84z_lPRpdTBqQ",
    place: "Near Lienden, Gelderland",
    shortName: "Lienden",
    countryCode: "NL",
    country: "Netherlands",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","NL"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "nl-100",
    lat: 53.249174,
    lng: 6.746507,
    panoId: "Wp7SebgjQZt-_TXWGfX75g",
    place: "Near Ten Boer, Groningen",
    shortName: "Ten Boer",
    countryCode: "NL",
    country: "Netherlands",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","NL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nl-101",
    lat: 52.900665,
    lng: 5.000831,
    panoId: "STonEcX8QJ0OuvP25U7lRQ",
    place: "Near Hippolytushoef, North Holland",
    shortName: "Hippolytushoef",
    countryCode: "NL",
    country: "Netherlands",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","NL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nl-102",
    lat: 52.86777,
    lng: 5.031164,
    panoId: "ZC3LUD9c99-_cb3cz8xt4g",
    place: "Near Wieringerwerf, North Holland",
    shortName: "Wieringerwerf",
    countryCode: "NL",
    country: "Netherlands",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","NL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nl-103",
    lat: 50.818592,
    lng: 5.904023,
    panoId: "ncT4kefgOdVXeUmhQHVouQ",
    place: "Near Gulpen, Limburg",
    shortName: "Gulpen",
    countryCode: "NL",
    country: "Netherlands",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","NL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nl-104",
    lat: 52.773506,
    lng: 5.857781,
    panoId: "yZq_5CLCa2AQwRs3tD76VA",
    place: "Near Luttelgeest, Flevoland",
    shortName: "Luttelgeest",
    countryCode: "NL",
    country: "Netherlands",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","NL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nl-105",
    lat: 52.864996,
    lng: 6.27525,
    panoId: "5pZUo1_zZS5OWAEZZjLPBQ",
    place: "Near Diever, Drenthe",
    shortName: "Diever",
    countryCode: "NL",
    country: "Netherlands",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","NL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pt-000",
    lat: 41.14848,
    lng: -8.610751,
    panoId: "MqGSMY0emjt3wl2_a4iNJA",
    place: "Near Porto, Porto",
    shortName: "Porto",
    countryCode: "PT",
    country: "Portugal",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","PT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pt-001",
    lat: 40.150817,
    lng: -8.861825,
    panoId: "tNE-mUMn9vhis57SuVAMyg",
    place: "Near Figueira da Foz, Coimbra",
    shortName: "Figueira da Foz",
    countryCode: "PT",
    country: "Portugal",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","PT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pt-002",
    lat: 41.551331,
    lng: -8.423247,
    panoId: "VnAkkw3tDmq7ff4DjC60Qg",
    place: "Near Braga, Braga",
    shortName: "Braga",
    countryCode: "PT",
    country: "Portugal",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","PT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pt-003",
    lat: 40.206919,
    lng: -8.419871,
    panoId: "HpNkJcukAnZcGvM7DJVyrA",
    place: "Near Coimbra, Coimbra",
    shortName: "Coimbra",
    countryCode: "PT",
    country: "Portugal",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","PT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pt-004",
    lat: 41.693181,
    lng: -8.833061,
    panoId: "Z6UGXSa_OUKrAyrOotDykQ",
    place: "Near Viana do Castelo, Viana do Castelo",
    shortName: "Viana do Castelo",
    countryCode: "PT",
    country: "Portugal",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","PT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pt-005",
    lat: 38.724944,
    lng: -9.149637,
    panoId: "uOIF5QNylRdC0iIP4XYCrg",
    place: "Near Lisbon, Lisbon",
    shortName: "Lisbon",
    countryCode: "PT",
    country: "Portugal",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","PT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pt-006",
    lat: 41.178767,
    lng: -8.559373,
    panoId: "ocXeELCfHwYytgYxSCD89w",
    place: "Near Rio Tinto, Porto",
    shortName: "Rio Tinto",
    countryCode: "PT",
    country: "Portugal",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","PT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pt-007",
    lat: 39.743472,
    lng: -8.807231,
    panoId: "T9528ag4uQOycQbFaICrjw",
    place: "Near Leiria, Leiria",
    shortName: "Leiria",
    countryCode: "PT",
    country: "Portugal",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","PT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pt-008",
    lat: 38.565972,
    lng: -7.904187,
    panoId: "5bqVh12MolzTQGcJY7XCww",
    place: "Near Évora, Évora",
    shortName: "Évora",
    countryCode: "PT",
    country: "Portugal",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","PT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pt-009",
    lat: 32.665746,
    lng: -16.92561,
    panoId: "X04LqWTYnUT8GQdk9rwyhw",
    place: "Near Funchal, Madeira",
    shortName: "Funchal",
    countryCode: "PT",
    country: "Portugal",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","PT"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "pt-010",
    lat: 41.124075,
    lng: -8.612382,
    panoId: "fihFsiRQLKPUSzHiEl1knw",
    place: "Near Vila Nova de Gaia, Porto",
    shortName: "Vila Nova de Gaia",
    countryCode: "PT",
    country: "Portugal",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","PT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pt-011",
    lat: 40.218045,
    lng: -8.405145,
    panoId: "ZId039rndYk0MuBzKL021w",
    place: "Near Santo António dos Olivais, Coimbra",
    shortName: "Santo António dos Olivais",
    countryCode: "PT",
    country: "Portugal",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","PT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pt-012",
    lat: 41.172818,
    lng: -8.599259,
    panoId: "HwvJa-RL-PDY4pw_OhU9gw",
    place: "Near Paranhos, Porto",
    shortName: "Paranhos",
    countryCode: "PT",
    country: "Portugal",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","PT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pt-013",
    lat: 37.018672,
    lng: -7.927153,
    panoId: "nMZpl9rR_U-UmpE5cg-yhg",
    place: "Near Faro, Faro",
    shortName: "Faro",
    countryCode: "PT",
    country: "Portugal",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","PT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pt-014",
    lat: 38.524285,
    lng: -8.888276,
    panoId: "4Mq_3W07BKPc0c9mz-wUig",
    place: "Near Setúbal, Setúbal",
    shortName: "Setúbal",
    countryCode: "PT",
    country: "Portugal",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","PT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pt-015",
    lat: 41.807196,
    lng: -6.758759,
    panoId: "jbXs8PnaWVNf2jnyGGPWNg",
    place: "Near Bragança, Bragança",
    shortName: "Bragança",
    countryCode: "PT",
    country: "Portugal",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","PT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pt-016",
    lat: 41.11383,
    lng: -8.602224,
    panoId: "I_1PE9Eh9oK77J2COL6Xew",
    place: "Near Santo Ovídio, Porto",
    shortName: "Santo Ovídio",
    countryCode: "PT",
    country: "Portugal",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","PT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pt-017",
    lat: 39.823867,
    lng: -7.490766,
    panoId: "y9fnZn5QuvLYeZMmSqlN-w",
    place: "Near Castelo Branco, Castelo Branco",
    shortName: "Castelo Branco",
    countryCode: "PT",
    country: "Portugal",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","PT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pt-018",
    lat: 41.76687,
    lng: -8.583627,
    panoId: "Fd9PadXxOPMNp3BhOLyhBA",
    place: "Near Ponte de Lima, Viana do Castelo",
    shortName: "Ponte de Lima",
    countryCode: "PT",
    country: "Portugal",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","PT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pt-019",
    lat: 37.101998,
    lng: -8.674219,
    panoId: "EprccVTF4MHYIQXM8axWTA",
    place: "Near Lagos, Faro",
    shortName: "Lagos",
    countryCode: "PT",
    country: "Portugal",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","PT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pt-020",
    lat: 41.368096,
    lng: -8.193952,
    panoId: "eu8A5RALdWrJsTk_6_SKAw",
    place: "Near Felgueiras, Porto",
    shortName: "Felgueiras",
    countryCode: "PT",
    country: "Portugal",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","PT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pt-021",
    lat: 40.645502,
    lng: -8.646065,
    panoId: "X_k0qEV4ej25_hBTUUR3qw",
    place: "Near Aveiro, Aveiro",
    shortName: "Aveiro",
    countryCode: "PT",
    country: "Portugal",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","PT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pt-022",
    lat: 38.691021,
    lng: -9.310781,
    panoId: "rZzu-NhmqzuSNCoWVj2TBA",
    place: "Near Oeiras, Lisbon",
    shortName: "Oeiras",
    countryCode: "PT",
    country: "Portugal",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","PT"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "pt-023",
    lat: 41.536312,
    lng: -8.782045,
    panoId: "gggyy4MOg1E3Fy41J0IXhg",
    place: "Near Esposende, Braga",
    shortName: "Esposende",
    countryCode: "PT",
    country: "Portugal",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","PT"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "pt-024",
    lat: 38.679074,
    lng: -9.15689,
    panoId: "OVeK1b0jP2ddvB5M37QlHw",
    place: "Near Almada, Setúbal",
    shortName: "Almada",
    countryCode: "PT",
    country: "Portugal",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","PT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pt-025",
    lat: 41.543075,
    lng: -8.407091,
    panoId: "UVhZzsHe3BQwLqGhLF19fg",
    place: "Near Bairro Novo, Braga",
    shortName: "Bairro Novo",
    countryCode: "PT",
    country: "Portugal",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","PT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pt-026",
    lat: 41.216592,
    lng: -8.553224,
    panoId: "4JT9J4CJwsFxMS5vVmdv4g",
    place: "Near Ermesinde, Porto",
    shortName: "Ermesinde",
    countryCode: "PT",
    country: "Portugal",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","PT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pt-027",
    lat: 40.537606,
    lng: -7.266295,
    panoId: "RyyMiI0MmshbFa-R-6obZQ",
    place: "Near Guarda, Guarda",
    shortName: "Guarda",
    countryCode: "PT",
    country: "Portugal",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","PT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pt-028",
    lat: 38.662775,
    lng: -9.074387,
    panoId: "3cVynK8AJvtXr2H34phjOA",
    place: "Near Barreiro, Setúbal",
    shortName: "Barreiro",
    countryCode: "PT",
    country: "Portugal",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","PT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pt-029",
    lat: 41.23571,
    lng: -8.619858,
    panoId: "PwmSAPX-ZZ5g7OBOHNMEpA",
    place: "Near Maia, Porto",
    shortName: "Maia",
    countryCode: "PT",
    country: "Portugal",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","PT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pt-030",
    lat: 38.706779,
    lng: -8.973808,
    panoId: "Y8Y4UCkvlSWnQI_IYBtfWg",
    place: "Near Montijo, Setúbal",
    shortName: "Montijo",
    countryCode: "PT",
    country: "Portugal",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","PT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pt-031",
    lat: 41.444083,
    lng: -8.29596,
    panoId: "g1arRNAfNbg-0QmcG4UGnw",
    place: "Near Guimarães, Braga",
    shortName: "Guimarães",
    countryCode: "PT",
    country: "Portugal",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","PT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pt-032",
    lat: 39.462016,
    lng: -8.711786,
    panoId: "KBw8OD5OdDyMYEtgdkEAAQ",
    place: "Near Monsanto, Santarém",
    shortName: "Monsanto",
    countryCode: "PT",
    country: "Portugal",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","PT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pt-033",
    lat: 40.661645,
    lng: -7.909071,
    panoId: "iBZ-PVGYT6H8jCXlT9b1dw",
    place: "Near Viseu, Viseu",
    shortName: "Viseu",
    countryCode: "PT",
    country: "Portugal",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","PT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pt-034",
    lat: 41.14384,
    lng: -8.646211,
    panoId: "5i1pcOvrSS_jhjjIECUpaQ",
    place: "Near Afurada de Baixo, Porto",
    shortName: "Afurada de Baixo",
    countryCode: "PT",
    country: "Portugal",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","PT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pt-035",
    lat: 41.157031,
    lng: -8.574711,
    panoId: "_vmIHxs_IDrPHOSHFmJvug",
    place: "Near Campanhã, Porto",
    shortName: "Campanhã",
    countryCode: "PT",
    country: "Portugal",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","PT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pt-036",
    lat: 40.153409,
    lng: -8.848778,
    panoId: "xGDX7q-dz_8UDbkyz2i9gQ",
    place: "Near Figueira da Foz, Coimbra",
    shortName: "Figueira da Foz",
    countryCode: "PT",
    country: "Portugal",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","PT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pt-037",
    lat: 41.007644,
    lng: -8.641399,
    panoId: "LWbmxe357tv3hU-4BzoLZg",
    place: "Near Espinho, Aveiro",
    shortName: "Espinho",
    countryCode: "PT",
    country: "Portugal",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","PT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pt-038",
    lat: 40.663416,
    lng: -7.931816,
    panoId: "tJ2OtSg4O5Nf8J6HK3TOyw",
    place: "Near Viseu, Viseu",
    shortName: "Viseu",
    countryCode: "PT",
    country: "Portugal",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","PT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pt-039",
    lat: 41.560815,
    lng: -8.43449,
    panoId: "ktJGFWiNvIIRa4AbiDrjFA",
    place: "Near Real, Braga",
    shortName: "Real",
    countryCode: "PT",
    country: "Portugal",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","PT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pt-040",
    lat: 38.669737,
    lng: -9.046674,
    panoId: "qMUVKf40JgQ3YXNlYVWhQQ",
    place: "Near Lavradio, Setúbal",
    shortName: "Lavradio",
    countryCode: "PT",
    country: "Portugal",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","PT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pt-041",
    lat: 39.733309,
    lng: -8.820022,
    panoId: "Kso8trA7kXmSTmlERy_vaw",
    place: "Near Leiria, Leiria",
    shortName: "Leiria",
    countryCode: "PT",
    country: "Portugal",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","PT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pt-042",
    lat: 39.451901,
    lng: -8.688283,
    panoId: "kcKDn5-_Okn3O0qDZ48igg",
    place: "Near Alcanena, Santarém",
    shortName: "Alcanena",
    countryCode: "PT",
    country: "Portugal",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","PT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pt-043",
    lat: 41.772798,
    lng: -8.599493,
    panoId: "divxJLboR8XXDw_0yAakVQ",
    place: "Near Ponte de Lima, Viana do Castelo",
    shortName: "Ponte de Lima",
    countryCode: "PT",
    country: "Portugal",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","PT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pt-044",
    lat: 40.193996,
    lng: -8.399855,
    panoId: "SLFwhgqFqPMWlbSH3UnyNQ",
    place: "Near Coimbra, Coimbra",
    shortName: "Coimbra",
    countryCode: "PT",
    country: "Portugal",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","PT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pt-045",
    lat: 39.828276,
    lng: -7.516347,
    panoId: "WTnp9_a8-JmoxXtKZP1aUA",
    place: "Near Castelo Branco, Castelo Branco",
    shortName: "Castelo Branco",
    countryCode: "PT",
    country: "Portugal",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","PT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pt-046",
    lat: 41.531893,
    lng: -8.768903,
    panoId: "su7TADwnQC0A_qpSVxcQgg",
    place: "Near Esposende, Braga",
    shortName: "Esposende",
    countryCode: "PT",
    country: "Portugal",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","PT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pt-047",
    lat: 40.214449,
    lng: -8.389148,
    panoId: "i3lZb0dO4r4t_JmBBeqiLg",
    place: "Near Santo António dos Olivais, Coimbra",
    shortName: "Santo António dos Olivais",
    countryCode: "PT",
    country: "Portugal",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","PT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pt-048",
    lat: 37.114273,
    lng: -8.688833,
    panoId: "y9B_5oJoPd9MPOOy4er_kA",
    place: "Near Lagos, Faro",
    shortName: "Lagos",
    countryCode: "PT",
    country: "Portugal",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","PT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pt-049",
    lat: 38.710759,
    lng: -9.134013,
    panoId: "KjXPcjuxGSXdP9G8xWSQvg",
    place: "Near Baixa, Lisbon",
    shortName: "Baixa",
    countryCode: "PT",
    country: "Portugal",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","PT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pt-050",
    lat: 41.384888,
    lng: -8.106511,
    panoId: "4VaTb23_T4QQc2AiYKSs0Q",
    place: "Near Felgueiras, Porto",
    shortName: "Felgueiras",
    countryCode: "PT",
    country: "Portugal",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","PT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pt-051",
    lat: 41.272643,
    lng: -8.520867,
    panoId: "xHnpyPl2zarA24kVmJ0XKA",
    place: "Near Água Longa, Porto",
    shortName: "Água Longa",
    countryCode: "PT",
    country: "Portugal",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","PT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pt-052",
    lat: 41.303948,
    lng: -8.59696,
    panoId: "RsAlD3LOPAFpPzuV90vm7Q",
    place: "Near Coronado, Porto",
    shortName: "Coronado",
    countryCode: "PT",
    country: "Portugal",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","PT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pt-053",
    lat: 38.532866,
    lng: -7.916303,
    panoId: "QSlkzfn5BEb-1BzSMl7xEg",
    place: "Near Évora, Évora",
    shortName: "Évora",
    countryCode: "PT",
    country: "Portugal",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","PT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pt-054",
    lat: 40.203018,
    lng: -8.354246,
    panoId: "y-U3CLCqiYH00JBpgkagZw",
    place: "Near Santo António dos Olivais, Coimbra",
    shortName: "Santo António dos Olivais",
    countryCode: "PT",
    country: "Portugal",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","PT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pt-055",
    lat: 39.867112,
    lng: -7.530375,
    panoId: "CxPldEHdUpFWfMQCxRrJag",
    place: "Near Castelo Branco, Castelo Branco",
    shortName: "Castelo Branco",
    countryCode: "PT",
    country: "Portugal",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","PT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pt-056",
    lat: 38.489673,
    lng: -8.903827,
    panoId: "53gvfzTmZmWCkDJabdmzWA",
    place: "Near Setúbal, Setúbal",
    shortName: "Setúbal",
    countryCode: "PT",
    country: "Portugal",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","PT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pt-057",
    lat: 41.754617,
    lng: -8.620661,
    panoId: "DMcmnheTUAm85jIXX_r8Fg",
    place: "Near Ponte de Lima, Viana do Castelo",
    shortName: "Ponte de Lima",
    countryCode: "PT",
    country: "Portugal",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","PT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pt-058",
    lat: 40.556611,
    lng: -7.335359,
    panoId: "NLyOd1BBx3C2bFKY-9DdRQ",
    place: "Near Guarda, Guarda",
    shortName: "Guarda",
    countryCode: "PT",
    country: "Portugal",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","PT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pt-059",
    lat: 39.184785,
    lng: -8.652385,
    panoId: "Kc78XaaymTJCirudMHwk8Q",
    place: "Near Almeirim, Santarém",
    shortName: "Almeirim",
    countryCode: "PT",
    country: "Portugal",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","PT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pt-060",
    lat: 37.110653,
    lng: -8.507187,
    panoId: "zg2jSEptlOSHzrtudZnO3w",
    place: "Near Ferragudo, Faro",
    shortName: "Ferragudo",
    countryCode: "PT",
    country: "Portugal",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","PT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pt-061",
    lat: 38.045074,
    lng: -7.800522,
    panoId: "AbvZ0prLLQ9eNNC1GlJvfw",
    place: "Near Neves, Beja",
    shortName: "Neves",
    countryCode: "PT",
    country: "Portugal",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","PT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pt-062",
    lat: 41.863119,
    lng: -6.804186,
    panoId: "ka3_49ic_k-cTAdtNpmL4Q",
    place: "Near Bragança, Bragança",
    shortName: "Bragança",
    countryCode: "PT",
    country: "Portugal",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","PT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pt-063",
    lat: 40.53487,
    lng: -7.196367,
    panoId: "KQ_IJWik2r6orfyFPBIxEg",
    place: "Near Sequeira, Guarda",
    shortName: "Sequeira",
    countryCode: "PT",
    country: "Portugal",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","PT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pt-064",
    lat: 40.942085,
    lng: -8.659027,
    panoId: "CQ7__kOowVieZqo3Y0zeFw",
    place: "Near Esmoriz, Aveiro",
    shortName: "Esmoriz",
    countryCode: "PT",
    country: "Portugal",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","PT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pt-065",
    lat: 39.708029,
    lng: -8.951548,
    panoId: "RuEEScZActOaEhz93ip0QA",
    place: "Near Marinha Grande, Leiria",
    shortName: "Marinha Grande",
    countryCode: "PT",
    country: "Portugal",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","PT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pt-066",
    lat: 41.372657,
    lng: -8.628921,
    panoId: "jXN_UT2BbTTsQNnk2YRZ-w",
    place: "Near Fradelos, Braga",
    shortName: "Fradelos",
    countryCode: "PT",
    country: "Portugal",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","PT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pt-067",
    lat: 39.405888,
    lng: -9.200235,
    panoId: "DRmYDPdJYyOxP1deAEqwDA",
    place: "Near Nadadouro, Leiria",
    shortName: "Nadadouro",
    countryCode: "PT",
    country: "Portugal",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","PT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pt-068",
    lat: 41.378433,
    lng: -8.728057,
    panoId: "3Fst0dqUeN2Lkyqf5_NWRQ",
    place: "Near Argivai, Porto",
    shortName: "Argivai",
    countryCode: "PT",
    country: "Portugal",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","PT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pt-069",
    lat: 41.478907,
    lng: -8.230944,
    panoId: "-iekZeDC4p5ykhbKPatPmw",
    place: "Near Arões, Braga",
    shortName: "Arões",
    countryCode: "PT",
    country: "Portugal",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","PT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pt-070",
    lat: 40.704307,
    lng: -7.854777,
    panoId: "RYA5XBrZB0Bm0RzuY5Q4zQ",
    place: "Near Rio de Loba, Viseu",
    shortName: "Rio de Loba",
    countryCode: "PT",
    country: "Portugal",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","PT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pt-071",
    lat: 37.059774,
    lng: -7.949848,
    panoId: "z8lV3zfG8C5tSLYwWFwaRA",
    place: "Near Faro, Faro",
    shortName: "Faro",
    countryCode: "PT",
    country: "Portugal",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","PT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pt-072",
    lat: 40.560904,
    lng: -7.174199,
    panoId: "yM2Ot5BanZa4aeMaPCKS2A",
    place: "Near Sequeira, Guarda",
    shortName: "Sequeira",
    countryCode: "PT",
    country: "Portugal",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","PT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pt-073",
    lat: 41.833749,
    lng: -6.808056,
    panoId: "RBDJIB2Nw2jzNLJEP_gkQQ",
    place: "Near Bragança, Bragança",
    shortName: "Bragança",
    countryCode: "PT",
    country: "Portugal",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","PT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pt-074",
    lat: 37.161854,
    lng: -8.585412,
    panoId: "4NUlF_hGhZWy_gMDLfhE-Q",
    place: "Near Mexilhoeira Grande, Faro",
    shortName: "Mexilhoeira Grande",
    countryCode: "PT",
    country: "Portugal",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","PT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pt-075",
    lat: 37.996328,
    lng: -7.952658,
    panoId: "A1VgbNI8ESuiVmWZp_zYBw",
    place: "Near Penedo Gordo, Beja",
    shortName: "Penedo Gordo",
    countryCode: "PT",
    country: "Portugal",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","PT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pt-076",
    lat: 41.527836,
    lng: -8.320484,
    panoId: "02R2RmEJlhyQ5P9PqO2cmg",
    place: "Near Sobreposta, Braga",
    shortName: "Sobreposta",
    countryCode: "PT",
    country: "Portugal",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","PT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pt-077",
    lat: 38.8205,
    lng: -9.417979,
    panoId: "o9NGc59sk9YO9NirWs-bKA",
    place: "Near Colares, Lisbon",
    shortName: "Colares",
    countryCode: "PT",
    country: "Portugal",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","PT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pt-078",
    lat: 39.245148,
    lng: -7.449851,
    panoId: "PpUE_YIjOT59WU0fOtKnmA",
    place: "Near Urra, Portalegre",
    shortName: "Urra",
    countryCode: "PT",
    country: "Portugal",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","PT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pt-079",
    lat: 32.716334,
    lng: -16.885804,
    panoId: "VIx0RoB8Lhf-P1-J-QEUEQ",
    place: "Near Camacha, Madeira",
    shortName: "Camacha",
    countryCode: "PT",
    country: "Portugal",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","PT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pt-080",
    lat: 40.861402,
    lng: -8.556395,
    panoId: "-hbI8fQGT-9O4mY-nwbpRQ",
    place: "Near Válega, Aveiro",
    shortName: "Válega",
    countryCode: "PT",
    country: "Portugal",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","PT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pt-081",
    lat: 32.694348,
    lng: -16.954488,
    panoId: "oqB883rEwCJufOxDdEpRMQ",
    place: "Near Curral das Freiras, Madeira",
    shortName: "Curral das Freiras",
    countryCode: "PT",
    country: "Portugal",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","PT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pt-082",
    lat: 39.045593,
    lng: -8.847778,
    panoId: "4WnG5sPyRdqlauanzNpqPQ",
    place: "Near Azambuja, Lisbon",
    shortName: "Azambuja",
    countryCode: "PT",
    country: "Portugal",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","PT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pt-083",
    lat: 40.875759,
    lng: -8.191636,
    panoId: "tlk5eYoBR74CMwerzW2IAg",
    place: "Near Arouca, Aveiro",
    shortName: "Arouca",
    countryCode: "PT",
    country: "Portugal",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","PT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pt-084",
    lat: 37.146469,
    lng: -8.31986,
    panoId: "J76DkfyfTAApYrMJemRmWQ",
    place: "Near Algoz, Faro",
    shortName: "Algoz",
    countryCode: "PT",
    country: "Portugal",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","PT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pt-085",
    lat: 39.447684,
    lng: -9.132147,
    panoId: "T8zDuT8UDKy_aYhr7jgUJQ",
    place: "Near Salir de Matos, Leiria",
    shortName: "Salir de Matos",
    countryCode: "PT",
    country: "Portugal",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","PT"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "pt-086",
    lat: 41.76685,
    lng: -8.624125,
    panoId: "aLfN6xoMAwxrxEMBETASMQ",
    place: "Near Ponte de Lima, Viana do Castelo",
    shortName: "Ponte de Lima",
    countryCode: "PT",
    country: "Portugal",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","PT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pt-087",
    lat: 41.245925,
    lng: -7.880831,
    panoId: "HAyONUUQhTgxQIXHpzNDZQ",
    place: "Near Santa Marta de Penaguião, Vila Real",
    shortName: "Santa Marta de Penaguião",
    countryCode: "PT",
    country: "Portugal",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","PT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pt-088",
    lat: 39.654552,
    lng: -8.304536,
    panoId: "PnDPHP2KfoMY_36rmrq0-g",
    place: "Near Ferreira do Zêzere, Santarém",
    shortName: "Ferreira do Zêzere",
    countryCode: "PT",
    country: "Portugal",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","PT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pt-089",
    lat: 40.818804,
    lng: -8.264114,
    panoId: "c2q25L4k4yZSRXl6nCIdRg",
    place: "Near Macieira de Cambra, Aveiro",
    shortName: "Macieira de Cambra",
    countryCode: "PT",
    country: "Portugal",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","PT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pt-090",
    lat: 32.74662,
    lng: -17.039166,
    panoId: "BHjOsouOXzKbYfGB7LtPOg",
    place: "Near São Vicente, Madeira",
    shortName: "São Vicente",
    countryCode: "PT",
    country: "Portugal",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","PT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pt-091",
    lat: 39.137628,
    lng: -9.189479,
    panoId: "gXJLV9qN-Yozsi8qKQ8LBA",
    place: "Near Vila Verde dos Francos, Lisbon",
    shortName: "Vila Verde dos Francos",
    countryCode: "PT",
    country: "Portugal",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","PT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pt-092",
    lat: 41.714993,
    lng: -7.385606,
    panoId: "0oyFMs8hbKeA_WEVYUI8Ag",
    place: "Near Chaves, Vila Real",
    shortName: "Chaves",
    countryCode: "PT",
    country: "Portugal",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","PT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pt-093",
    lat: 41.082414,
    lng: -8.140765,
    panoId: "t-WL9w8nCPrXJFXInnIrBg",
    place: "Near Cinfães, Viseu",
    shortName: "Cinfães",
    countryCode: "PT",
    country: "Portugal",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","PT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pt-094",
    lat: 41.135802,
    lng: -7.323098,
    panoId: "jqYaJPAUHtfUAYFohSj0lg",
    place: "Near Custoias, Guarda",
    shortName: "Custoias",
    countryCode: "PT",
    country: "Portugal",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","PT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pt-095",
    lat: 41.649129,
    lng: -8.245463,
    panoId: "Q63sbjvYmQB0uJNbOsd0ZQ",
    place: "Near Póvoa de Lanhoso, Braga",
    shortName: "Póvoa de Lanhoso",
    countryCode: "PT",
    country: "Portugal",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","PT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pt-096",
    lat: 41.392833,
    lng: -8.697164,
    panoId: "obNEl0-nS9o0BNNheURUeg",
    place: "Near Rio Mau, Porto",
    shortName: "Rio Mau",
    countryCode: "PT",
    country: "Portugal",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","PT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pt-097",
    lat: 39.979828,
    lng: -8.813187,
    panoId: "dKisnx6Ms1J536aFw47_Hw",
    place: "Near Louriçal, Leiria",
    shortName: "Louriçal",
    countryCode: "PT",
    country: "Portugal",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","PT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pt-098",
    lat: 39.586105,
    lng: -8.995457,
    panoId: "ygGFh_Fz3PaPpzXoUwY77Q",
    place: "Near Valado de Frades, Leiria",
    shortName: "Valado de Frades",
    countryCode: "PT",
    country: "Portugal",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","PT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pt-099",
    lat: 38.480991,
    lng: -8.977665,
    panoId: "elhH9nIWQU8u5RbMJYTLEg",
    place: "Near Azeitão, Setúbal",
    shortName: "Azeitão",
    countryCode: "PT",
    country: "Portugal",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","PT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pt-100",
    lat: 40.749384,
    lng: -8.312109,
    panoId: "rXqDB3QBtIKYG1m2ePfQpQ",
    place: "Near Sever do Vouga, Aveiro",
    shortName: "Sever do Vouga",
    countryCode: "PT",
    country: "Portugal",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","PT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pt-101",
    lat: 40.620719,
    lng: -7.092773,
    panoId: "C7zGlwM9IuvYqMiKYTNRoA",
    place: "Near Sequeira, Guarda",
    shortName: "Sequeira",
    countryCode: "PT",
    country: "Portugal",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","PT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pt-102",
    lat: 37.256511,
    lng: -8.041699,
    panoId: "x61uqm6FDzoCaEwjwh3XIw",
    place: "Near Loulé, Faro",
    shortName: "Loulé",
    countryCode: "PT",
    country: "Portugal",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","PT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pt-103",
    lat: 39.326449,
    lng: -8.34269,
    panoId: "YXcwtAvjeic0OYrNnXqB4w",
    place: "Near Pinheiro Grande, Santarém",
    shortName: "Pinheiro Grande",
    countryCode: "PT",
    country: "Portugal",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","PT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pt-104",
    lat: 38.399257,
    lng: -8.773237,
    panoId: "8qMBr5o62Hr0-2dQ6UIpzA",
    place: "Near Comporta, Setúbal",
    shortName: "Comporta",
    countryCode: "PT",
    country: "Portugal",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","PT"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "pt-105",
    lat: 40.619654,
    lng: -7.069387,
    panoId: "1eDVdIckKLBSxW-yjEuyKQ",
    place: "Near Sequeira, Guarda",
    shortName: "Sequeira",
    countryCode: "PT",
    country: "Portugal",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","PT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "be-000",
    lat: 51.209079,
    lng: 3.224069,
    panoId: "oAgu_79ByEKblTsoJQK2dg",
    place: "Near Brugge, Flanders",
    shortName: "Brugge",
    countryCode: "BE",
    country: "Belgium",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","BE"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "be-001",
    lat: 50.82794,
    lng: 3.264905,
    panoId: "eb227AYhsiU2e6K3oWCVkA",
    place: "Near Kortrijk, Flanders",
    shortName: "Kortrijk",
    countryCode: "BE",
    country: "Belgium",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","BE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "be-002",
    lat: 51.220462,
    lng: 4.400141,
    panoId: "W5eRZT5pquq24OYTjyEg9A",
    place: "Near Antwerpen, Flanders",
    shortName: "Antwerpen",
    countryCode: "BE",
    country: "Belgium",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","BE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "be-003",
    lat: 50.485083,
    lng: 4.188034,
    panoId: "75_cPXlbAPZvph4GXv5zjg",
    place: "Near La Louvière, Wallonia",
    shortName: "La Louvière",
    countryCode: "BE",
    country: "Belgium",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","BE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "be-004",
    lat: 50.607172,
    lng: 3.389333,
    panoId: "K63stgNCoLE_BgLES5POlg",
    place: "Near Tournai, Wallonia",
    shortName: "Tournai",
    countryCode: "BE",
    country: "Belgium",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","BE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "be-005",
    lat: 50.850419,
    lng: 4.348835,
    panoId: "Wxv4D3WDGyhG4d8qCWmTqw",
    place: "Near Brussels, Brussels Capital",
    shortName: "Brussels",
    countryCode: "BE",
    country: "Belgium",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","BE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "be-006",
    lat: 50.63372,
    lng: 5.567367,
    panoId: "FYw05ntODN4HiFGDC851xA",
    place: "Near Liège, Wallonia",
    shortName: "Liège",
    countryCode: "BE",
    country: "Belgium",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","BE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "be-007",
    lat: 51.049485,
    lng: 5.225887,
    panoId: "Berf7bcMwwpeJ_fyRKC53w",
    place: "Near Beringen, Flanders",
    shortName: "Beringen",
    countryCode: "BE",
    country: "Belgium",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","BE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "be-008",
    lat: 50.589253,
    lng: 5.862289,
    panoId: "4UHltI_t9WIpI7SuC0fOHw",
    place: "Near Verviers, Wallonia",
    shortName: "Verviers",
    countryCode: "BE",
    country: "Belgium",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","BE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "be-009",
    lat: 50.94657,
    lng: 3.12267,
    panoId: "LC1dhNEqiFWjSTGy8xcwwA",
    place: "Near Roeselare, Flanders",
    shortName: "Roeselare",
    countryCode: "BE",
    country: "Belgium",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","BE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "be-010",
    lat: 50.583619,
    lng: 5.501119,
    panoId: "Ln14Ent0WFJTKW_RjP_hwQ",
    place: "Near Seraing, Wallonia",
    shortName: "Seraing",
    countryCode: "BE",
    country: "Belgium",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","BE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "be-011",
    lat: 50.816721,
    lng: 5.1863,
    panoId: "LNxNDNQGDwrzb9GXPFhN5A",
    place: "Near Sint-Truiden, Flanders",
    shortName: "Sint-Truiden",
    countryCode: "BE",
    country: "Belgium",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","BE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "be-012",
    lat: 50.850878,
    lng: 2.885403,
    panoId: "mRDSwzU7poebhUEFGFnoZg",
    place: "Near Ieper, Flanders",
    shortName: "Ieper",
    countryCode: "BE",
    country: "Belgium",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","BE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "be-013",
    lat: 50.403184,
    lng: 4.528448,
    panoId: "t5kWRd-d0-JbOWy-uBc1Lg",
    place: "Near Châtelet, Wallonia",
    shortName: "Châtelet",
    countryCode: "BE",
    country: "Belgium",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","BE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "be-014",
    lat: 50.965396,
    lng: 5.69456,
    panoId: "f_lq8H-e00E12F7Yo58nRA",
    place: "Near Maasmechelen, Flanders",
    shortName: "Maasmechelen",
    countryCode: "BE",
    country: "Belgium",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","BE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "be-015",
    lat: 50.74489,
    lng: 3.206422,
    panoId: "0MDixVdz7lonGKAbPw_olQ",
    place: "Near Mouscron, Wallonia",
    shortName: "Mouscron",
    countryCode: "BE",
    country: "Belgium",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","BE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "be-016",
    lat: 50.851697,
    lng: 3.608945,
    panoId: "EmSbfDJzTvqvqMlg3TkqnA",
    place: "Near Oudenaarde, Flanders",
    shortName: "Oudenaarde",
    countryCode: "BE",
    country: "Belgium",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","BE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "be-017",
    lat: 50.411639,
    lng: 4.164356,
    panoId: "Y94TzBxkkzG2I8yUBaUzuQ",
    place: "Near Binche, Wallonia",
    shortName: "Binche",
    countryCode: "BE",
    country: "Belgium",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","BE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "be-018",
    lat: 50.807433,
    lng: 4.938352,
    panoId: "hmzC42NKoQna2WMae2AZKA",
    place: "Near Tienen, Flanders",
    shortName: "Tienen",
    countryCode: "BE",
    country: "Belgium",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","BE"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "be-019",
    lat: 50.664087,
    lng: 5.624015,
    panoId: "4_rXll4rKso6ab03R5ot0w",
    place: "Near Herstal, Wallonia",
    shortName: "Herstal",
    countryCode: "BE",
    country: "Belgium",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","BE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "be-020",
    lat: 50.411407,
    lng: 4.444432,
    panoId: "J4JzvjODCYBkSpwZGHvoQw",
    place: "Near Charleroi, Wallonia",
    shortName: "Charleroi",
    countryCode: "BE",
    country: "Belgium",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","BE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "be-021",
    lat: 51.341253,
    lng: 3.31558,
    panoId: "TpPPX2o5wKCmGEcHQ8H2tg",
    place: "Near Knokke, Flanders",
    shortName: "Knokke",
    countryCode: "BE",
    country: "Belgium",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","BE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "be-022",
    lat: 51.091085,
    lng: 5.215739,
    panoId: "hyLREp5UGRMtLEyNum4TRQ",
    place: "Near Beverlo, Flanders",
    shortName: "Beverlo",
    countryCode: "BE",
    country: "Belgium",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","BE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "be-023",
    lat: 50.385964,
    lng: 4.487527,
    panoId: "gh4tBrM-4yEgqHmpMs9Elw",
    place: "Near Loverval, Wallonia",
    shortName: "Loverval",
    countryCode: "BE",
    country: "Belgium",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","BE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "be-024",
    lat: 51.04734,
    lng: 3.731755,
    panoId: "AzM6-DLpzxQC6iPaxeiUlA",
    place: "Near Gent, Flanders",
    shortName: "Gent",
    countryCode: "BE",
    country: "Belgium",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","BE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "be-025",
    lat: 50.456318,
    lng: 3.938189,
    panoId: "xJRrULa6oP0mxvpbe5fhFA",
    place: "Near Mons, Wallonia",
    shortName: "Mons",
    countryCode: "BE",
    country: "Belgium",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","BE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "be-026",
    lat: 50.45715,
    lng: 4.792006,
    panoId: "9GYN6f4Id2EImN8s0DO5cA",
    place: "Near Flawinne, Wallonia",
    shortName: "Flawinne",
    countryCode: "BE",
    country: "Belgium",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","BE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "be-027",
    lat: 51.150077,
    lng: 4.964248,
    panoId: "5T94uU0p4EzaxiCI3ENe-A",
    place: "Near Geel, Flanders",
    shortName: "Geel",
    countryCode: "BE",
    country: "Belgium",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","BE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "be-028",
    lat: 50.846656,
    lng: 4.318045,
    panoId: "2o6D8nYZxPz5-mnSCwzJQw",
    place: "Near Molenbeek-Saint-Jean, Brussels Capital",
    shortName: "Molenbeek-Saint-Jean",
    countryCode: "BE",
    country: "Belgium",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","BE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "be-029",
    lat: 50.652145,
    lng: 5.473425,
    panoId: "Jj-AwAzb1a_ZJX36C-jheg",
    place: "Near Hollogne-aux-Pierres, Wallonia",
    shortName: "Hollogne-aux-Pierres",
    countryCode: "BE",
    country: "Belgium",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","BE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "be-030",
    lat: 50.44857,
    lng: 4.826002,
    panoId: "0WvabR9ScBHPXRPY0KnWoQ",
    place: "Near Flawinne, Wallonia",
    shortName: "Flawinne",
    countryCode: "BE",
    country: "Belgium",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","BE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "be-031",
    lat: 50.40106,
    lng: 4.373663,
    panoId: "J2zmEbARARjw_BiKONpt8A",
    place: "Near Goutroux, Wallonia",
    shortName: "Goutroux",
    countryCode: "BE",
    country: "Belgium",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","BE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "be-032",
    lat: 50.68807,
    lng: 5.545045,
    panoId: "t-269ieHg6VA5bQ8_z3Sog",
    place: "Near Voroux-lez-Liers, Wallonia",
    shortName: "Voroux-lez-Liers",
    countryCode: "BE",
    country: "Belgium",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","BE"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "be-033",
    lat: 50.467493,
    lng: 3.937568,
    panoId: "FXxRnGgfz0Q2LfI_ePZcPQ",
    place: "Near Nimy, Wallonia",
    shortName: "Nimy",
    countryCode: "BE",
    country: "Belgium",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","BE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "be-034",
    lat: 50.770053,
    lng: 3.206358,
    panoId: "iLgzjBqnkYumIQJVWhLrKA",
    place: "Near Aalbeke, Flanders",
    shortName: "Aalbeke",
    countryCode: "BE",
    country: "Belgium",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","BE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "be-035",
    lat: 51.048878,
    lng: 4.394018,
    panoId: "6YaRSM9058XBg_qly3-vwQ",
    place: "Near Blaasveld, Flanders",
    shortName: "Blaasveld",
    countryCode: "BE",
    country: "Belgium",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","BE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "be-036",
    lat: 50.834987,
    lng: 4.362932,
    panoId: "AQhhmuQ4dLEl1d9lC94MiQ",
    place: "Near Ixelles, Brussels Capital",
    shortName: "Ixelles",
    countryCode: "BE",
    country: "Belgium",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","BE"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "be-037",
    lat: 51.176979,
    lng: 5.385665,
    panoId: "yS_3fIcB_TJDYQxwGhU4xw",
    place: "Near Eksel, Flanders",
    shortName: "Eksel",
    countryCode: "BE",
    country: "Belgium",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","BE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "be-038",
    lat: 51.35123,
    lng: 5.208549,
    panoId: "4d1_3cNLms6wEqEsEaj7pg",
    place: "Near Bladel, North Brabant",
    shortName: "Bladel",
    countryCode: "BE",
    country: "Belgium",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","BE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "be-039",
    lat: 50.863927,
    lng: 5.236317,
    panoId: "TJDuPg5o_c03iz0fEK4Z3Q",
    place: "Near Kozen, Flanders",
    shortName: "Kozen",
    countryCode: "BE",
    country: "Belgium",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","BE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "be-040",
    lat: 50.729557,
    lng: 4.87775,
    panoId: "DsFERMSCnAT9N6Tqg8N5Ew",
    place: "Near Jodoigne, Wallonia",
    shortName: "Jodoigne",
    countryCode: "BE",
    country: "Belgium",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","BE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "be-041",
    lat: 50.673471,
    lng: 3.176697,
    panoId: "ctJPaswDpiI2dvzyk01g2w",
    place: "Near Croix, Hauts-de-France",
    shortName: "Croix",
    countryCode: "BE",
    country: "Belgium",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","BE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "be-042",
    lat: 50.763966,
    lng: 5.484959,
    panoId: "ZAR2J6FELliCn1IgfuZtew",
    place: "Near Vreren, Flanders",
    shortName: "Vreren",
    countryCode: "BE",
    country: "Belgium",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","BE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "be-043",
    lat: 50.444243,
    lng: 4.590525,
    panoId: "JTzQQTHwS1GQwJ93BNKOYg",
    place: "Near Moignelée, Wallonia",
    shortName: "Moignelée",
    countryCode: "BE",
    country: "Belgium",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","BE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "be-044",
    lat: 50.67933,
    lng: 6.137607,
    panoId: "QHQ5bqzJMbQdiV63Z2Sm5A",
    place: "Near Raeren, Wallonia",
    shortName: "Raeren",
    countryCode: "BE",
    country: "Belgium",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","BE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "be-045",
    lat: 50.753446,
    lng: 3.29676,
    panoId: "4qIh78W7MmzOyaIdC6E9zg",
    place: "Near Dottignies, Wallonia",
    shortName: "Dottignies",
    countryCode: "BE",
    country: "Belgium",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","BE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "be-046",
    lat: 50.47372,
    lng: 3.917091,
    panoId: "vNmIy3WxrDJukqCLTLFB5A",
    place: "Near Ghlin, Wallonia",
    shortName: "Ghlin",
    countryCode: "BE",
    country: "Belgium",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","BE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "be-047",
    lat: 50.970043,
    lng: 5.57986,
    panoId: "MR1u9nrtRjAzAxGNPWv0UQ",
    place: "Near Zutendaal, Flanders",
    shortName: "Zutendaal",
    countryCode: "BE",
    country: "Belgium",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","BE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "be-048",
    lat: 51.135931,
    lng: 5.162641,
    panoId: "KGdRWINSbXRS1IrakxpVcw",
    place: "Near Olmen, Flanders",
    shortName: "Olmen",
    countryCode: "BE",
    country: "Belgium",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","BE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "be-049",
    lat: 50.952389,
    lng: 5.617018,
    panoId: "l7xymIdgWbOXvOFxTQ8jTA",
    place: "Near Zutendaal, Flanders",
    shortName: "Zutendaal",
    countryCode: "BE",
    country: "Belgium",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","BE"],
    qualityTier: 4,
    verified: true,
  },
];

const CHUNK_6: GeoLocation[] = [
  {
    id: "be-050",
    lat: 51.068257,
    lng: 3.491284,
    panoId: "A7Jeaa80OWh56ajmLCCnow",
    place: "Near Bellem, Flanders",
    shortName: "Bellem",
    countryCode: "BE",
    country: "Belgium",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","BE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "be-051",
    lat: 51.063798,
    lng: 5.9017,
    panoId: "04g1esA5j9jYtXcBd_fMPA",
    place: "Near Heide, Limburg",
    shortName: "Heide",
    countryCode: "BE",
    country: "Belgium",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","BE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "be-052",
    lat: 50.358694,
    lng: 4.197118,
    panoId: "whoXDPwq93TGSI0waTBSbA",
    place: "Near Buvrinnes, Wallonia",
    shortName: "Buvrinnes",
    countryCode: "BE",
    country: "Belgium",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","BE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "be-053",
    lat: 50.770143,
    lng: 5.512298,
    panoId: "-PY-t3wBOC6ox06f3SgeLA",
    place: "Near Mal, Flanders",
    shortName: "Mal",
    countryCode: "BE",
    country: "Belgium",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","BE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "be-054",
    lat: 50.299156,
    lng: 4.404347,
    panoId: "jlljxMRPSe75NtJag1Ep0A",
    place: "Near Thy-le-Château, Wallonia",
    shortName: "Thy-le-Château",
    countryCode: "BE",
    country: "Belgium",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","BE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "be-055",
    lat: 50.620692,
    lng: 3.457796,
    panoId: "97-bb7JDCBtQdev9THpiCQ",
    place: "Near Havinnes, Wallonia",
    shortName: "Havinnes",
    countryCode: "BE",
    country: "Belgium",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","BE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "be-056",
    lat: 50.585828,
    lng: 3.857229,
    panoId: "6_ODNXHVpfKVex1uzvGvDA",
    place: "Near Brugelette, Wallonia",
    shortName: "Brugelette",
    countryCode: "BE",
    country: "Belgium",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","BE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "be-057",
    lat: 50.737008,
    lng: 4.944791,
    panoId: "7G3KPQtQL3-SXv-Xwc-S8g",
    place: "Near Noduwez, Wallonia",
    shortName: "Noduwez",
    countryCode: "BE",
    country: "Belgium",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","BE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "be-058",
    lat: 51.164903,
    lng: 5.29159,
    panoId: "aaLMLIq2ec3VkSuHC0y5hg",
    place: "Near Leopoldsburg, Flanders",
    shortName: "Leopoldsburg",
    countryCode: "BE",
    country: "Belgium",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","BE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "be-059",
    lat: 51.021711,
    lng: 5.475236,
    panoId: "lch10R-drwD0KRLPGEqIwQ",
    place: "Near Genk, Flanders",
    shortName: "Genk",
    countryCode: "BE",
    country: "Belgium",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","BE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "be-060",
    lat: 50.621835,
    lng: 3.317957,
    panoId: "9C3wh-HyzpcoJcEHR3tfgA",
    place: "Near Marquain, Wallonia",
    shortName: "Marquain",
    countryCode: "BE",
    country: "Belgium",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","BE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "be-061",
    lat: 51.268857,
    lng: 5.266335,
    panoId: "XC4eXn47ZE37JiUvLL7nSg",
    place: "Near Luyksgestel, North Brabant",
    shortName: "Luyksgestel",
    countryCode: "BE",
    country: "Belgium",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","BE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "be-062",
    lat: 50.797665,
    lng: 2.701361,
    panoId: "42bs8xBUNOekx9QopJo6kA",
    place: "Near Boeschepe, Hauts-de-France",
    shortName: "Boeschepe",
    countryCode: "BE",
    country: "Belgium",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","BE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ch-000",
    lat: 47.366582,
    lng: 8.549101,
    panoId: "0d94Ho-T_J_FNFusD-KBEg",
    place: "Near Zürich, Zurich",
    shortName: "Zürich",
    countryCode: "CH",
    country: "Switzerland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","CH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ch-001",
    lat: 46.433149,
    lng: 6.911343,
    panoId: "7uJFByxKkBb_jJyROeT3SA",
    place: "Near Montreux, Vaud",
    shortName: "Montreux",
    countryCode: "CH",
    country: "Switzerland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","CH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ch-002",
    lat: 46.617667,
    lng: 7.056764,
    panoId: "0QLePfZ8rw1MX_GPzTyxew",
    place: "Near Bulle, Fribourg",
    shortName: "Bulle",
    countryCode: "CH",
    country: "Switzerland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","CH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ch-003",
    lat: 47.401487,
    lng: 8.400174,
    panoId: "VvpWBQ7ZP88HbqTHMkhrdw",
    place: "Near Dietikon, Zurich",
    shortName: "Dietikon",
    countryCode: "CH",
    country: "Switzerland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","CH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ch-004",
    lat: 47.078131,
    lng: 8.273264,
    panoId: "WGC_CtCvoDWGr09irf48gg",
    place: "Near Emmen, Lucerne",
    shortName: "Emmen",
    countryCode: "CH",
    country: "Switzerland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","CH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ch-005",
    lat: 46.010139,
    lng: 8.959605,
    panoId: "Y_ooc0-oy8EQxX2DgsjL4Q",
    place: "Near Lugano, Ticino",
    shortName: "Lugano",
    countryCode: "CH",
    country: "Switzerland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","CH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ch-006",
    lat: 47.461467,
    lng: 9.046004,
    panoId: "QFkP4Ir7nAwdeNUu9oKrvg",
    place: "Near Wil, Saint Gallen",
    shortName: "Wil",
    countryCode: "CH",
    country: "Switzerland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","CH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ch-007",
    lat: 47.346994,
    lng: 8.722569,
    panoId: "jsTUADkoDCrRmhhYVC1VYg",
    place: "Near Uster, Zurich",
    shortName: "Uster",
    countryCode: "CH",
    country: "Switzerland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","CH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ch-008",
    lat: 46.924234,
    lng: 7.414746,
    panoId: "H6XiYl5jD9BSMZmwnEgkrA",
    place: "Near Köniz, Bern",
    shortName: "Köniz",
    countryCode: "CH",
    country: "Switzerland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","CH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ch-009",
    lat: 47.326419,
    lng: 8.797922,
    panoId: "KgKt_wKst25G3KJI5iUE0g",
    place: "Near Wetzikon, Zurich",
    shortName: "Wetzikon",
    countryCode: "CH",
    country: "Switzerland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","CH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ch-010",
    lat: 47.172544,
    lng: 8.516607,
    panoId: "YKGAmm6tcwXEwJ1cVtO_OQ",
    place: "Near Zug, Zug",
    shortName: "Zug",
    countryCode: "CH",
    country: "Switzerland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","CH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ch-011",
    lat: 46.751142,
    lng: 7.621504,
    panoId: "bOevgblBuOE-H2PpDivDGA",
    place: "Near Thun, Bern",
    shortName: "Thun",
    countryCode: "CH",
    country: "Switzerland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","CH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ch-012",
    lat: 47.195908,
    lng: 8.529138,
    panoId: "tSbq5b4a26Ql5sjueutNfg",
    place: "Near Baar, Zug",
    shortName: "Baar",
    countryCode: "CH",
    country: "Switzerland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","CH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ch-013",
    lat: 47.259472,
    lng: 8.597497,
    panoId: "R0L07S7kl8JqFKT9yXg6vg",
    place: "Near Horgen, Zurich",
    shortName: "Horgen",
    countryCode: "CH",
    country: "Switzerland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","CH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ch-014",
    lat: 47.431615,
    lng: 8.576479,
    panoId: "Hk7IFnEBh8kEAdBvGLA0Zw",
    place: "Near Opfikon, Zurich",
    shortName: "Opfikon",
    countryCode: "CH",
    country: "Switzerland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","CH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ch-015",
    lat: 46.217093,
    lng: 6.083108,
    panoId: "pbz_gbMhIO53Qul8sfRb-w",
    place: "Near Vernier, Geneva",
    shortName: "Vernier",
    countryCode: "CH",
    country: "Switzerland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","CH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ch-016",
    lat: 47.650493,
    lng: 9.175066,
    panoId: "hhKBGwFAQjIcSxLMa8jW_w",
    place: "Near Kreuzlingen, Thurgau",
    shortName: "Kreuzlingen",
    countryCode: "CH",
    country: "Switzerland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","CH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ch-017",
    lat: 46.778444,
    lng: 6.64194,
    panoId: "LviBC0wTqyCtC7AkQNOtug",
    place: "Near Yverdon-les-Bains, Vaud",
    shortName: "Yverdon-les-Bains",
    countryCode: "CH",
    country: "Switzerland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","CH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ch-018",
    lat: 46.227581,
    lng: 7.355562,
    panoId: "t8pH7Q-zncETXEILjOk5Tw",
    place: "Near Sitten, Valais",
    shortName: "Sitten",
    countryCode: "CH",
    country: "Switzerland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","CH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ch-019",
    lat: 47.578835,
    lng: 7.646807,
    panoId: "8MBtX4qGDZAoFejgTknp7w",
    place: "Near Riehen, Basel-City",
    shortName: "Riehen",
    countryCode: "CH",
    country: "Switzerland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","CH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ch-020",
    lat: 47.558669,
    lng: 7.573954,
    panoId: "OLKmY--7gx3ywFULGxhrvA",
    place: "Near Basel, Basel-City",
    shortName: "Basel",
    countryCode: "CH",
    country: "Switzerland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","CH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ch-021",
    lat: 47.137239,
    lng: 7.246289,
    panoId: "mNXerhFL0A3dWRslaMsMLw",
    place: "Near Biel/Bienne, Bern",
    shortName: "Biel/Bienne",
    countryCode: "CH",
    country: "Switzerland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","CH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ch-022",
    lat: 47.506077,
    lng: 8.724764,
    panoId: "BewkzXAlVrrqKsujAVtIMw",
    place: "Near Winterthur, Zurich",
    shortName: "Winterthur",
    countryCode: "CH",
    country: "Switzerland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","CH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ch-023",
    lat: 46.539734,
    lng: 6.58944,
    panoId: "tjFfTQoafEMby4d4E2Exkw",
    place: "Near Renens, Vaud",
    shortName: "Renens",
    countryCode: "CH",
    country: "Switzerland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","CH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ch-024",
    lat: 47.557624,
    lng: 8.899205,
    panoId: "lJtGUzOEAl4-icYR-0Tdmg",
    place: "Near Frauenfeld, Thurgau",
    shortName: "Frauenfeld",
    countryCode: "CH",
    country: "Switzerland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","CH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ch-025",
    lat: 46.992204,
    lng: 6.931763,
    panoId: "erRzU6TR_7SJLcjz2rnjaw",
    place: "Near Neuchâtel, Neuchâtel",
    shortName: "Neuchâtel",
    countryCode: "CH",
    country: "Switzerland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","CH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ch-026",
    lat: 47.391882,
    lng: 8.044905,
    panoId: "dUNgGy-dFv04WWfheIdcUg",
    place: "Near Aarau, Aargau",
    shortName: "Aarau",
    countryCode: "CH",
    country: "Switzerland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","CH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ch-027",
    lat: 47.031497,
    lng: 8.284316,
    panoId: "VokkWvSH4KpdqBMTAKSpQA",
    place: "Near Kriens, Lucerne",
    shortName: "Kriens",
    countryCode: "CH",
    country: "Switzerland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","CH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ch-028",
    lat: 47.522055,
    lng: 8.540539,
    panoId: "sBbEgm5q0mrD54rejdjKeg",
    place: "Near Bülach, Zurich",
    shortName: "Bülach",
    countryCode: "CH",
    country: "Switzerland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","CH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ch-029",
    lat: 47.032829,
    lng: 8.327637,
    panoId: "a27SLtLP6HqdDSvhJkTSxA",
    place: "Near Horw, Lucerne",
    shortName: "Horw",
    countryCode: "CH",
    country: "Switzerland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","CH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ch-030",
    lat: 47.278308,
    lng: 8.615288,
    panoId: "39VdusEciNbyIlz7Yzo2Mg",
    place: "Near Feldmeilen, Zurich",
    shortName: "Feldmeilen",
    countryCode: "CH",
    country: "Switzerland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","CH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ch-031",
    lat: 46.193361,
    lng: 6.17562,
    panoId: "G1hgsP-6dC-GAUyiKxHTzQ",
    place: "Near Chêne-Bougeries, Geneva",
    shortName: "Chêne-Bougeries",
    countryCode: "CH",
    country: "Switzerland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","CH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ch-032",
    lat: 46.441379,
    lng: 6.886377,
    panoId: "tRjmmuawDBvJCv_DdMRwwg",
    place: "Near Montreux, Vaud",
    shortName: "Montreux",
    countryCode: "CH",
    country: "Switzerland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","CH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ch-033",
    lat: 46.634099,
    lng: 7.045223,
    panoId: "li8Zmc2CeB4D4pomb9KFBQ",
    place: "Near Riaz, Fribourg",
    shortName: "Riaz",
    countryCode: "CH",
    country: "Switzerland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","CH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ch-034",
    lat: 46.942694,
    lng: 7.424122,
    panoId: "06qjTUG4jnHIu1N6bhQAhg",
    place: "Near Bern, Bern",
    shortName: "Bern",
    countryCode: "CH",
    country: "Switzerland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","CH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ch-035",
    lat: 46.766152,
    lng: 7.632061,
    panoId: "QuZd3tHWz5iuZtl7akKVKA",
    place: "Near Steffisburg, Bern",
    shortName: "Steffisburg",
    countryCode: "CH",
    country: "Switzerland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","CH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ch-036",
    lat: 46.810326,
    lng: 7.138029,
    panoId: "G3RzyLffrozsKo-e0jLG5Q",
    place: "Near Givisiez, Fribourg",
    shortName: "Givisiez",
    countryCode: "CH",
    country: "Switzerland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","CH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ch-037",
    lat: 47.112775,
    lng: 6.84561,
    panoId: "ZlsvYv71s1Yar0VGG4Nw2Q",
    place: "Near La Chaux-de-Fonds, Neuchâtel",
    shortName: "La Chaux-de-Fonds",
    countryCode: "CH",
    country: "Switzerland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","CH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ch-038",
    lat: 47.419781,
    lng: 9.352248,
    panoId: "bvRvAeX1HEERioPytZ5WPw",
    place: "Near Sankt Gallen, Saint Gallen",
    shortName: "Sankt Gallen",
    countryCode: "CH",
    country: "Switzerland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","CH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ch-039",
    lat: 46.504606,
    lng: 6.62725,
    panoId: "4q0jnqqe3y835xSfUcDdCw",
    place: "Near Lausanne, Vaud",
    shortName: "Lausanne",
    countryCode: "CH",
    country: "Switzerland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","CH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ch-040",
    lat: 47.645431,
    lng: 9.195842,
    panoId: "jyfNJrK8cIbyuJrWP73rDw",
    place: "Near Bottighofen, Thurgau",
    shortName: "Bottighofen",
    countryCode: "CH",
    country: "Switzerland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","CH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ch-041",
    lat: 46.200865,
    lng: 6.094832,
    panoId: "nKzwUG_SkQo4UIPw5SZ6iA",
    place: "Near Lancy, Geneva",
    shortName: "Lancy",
    countryCode: "CH",
    country: "Switzerland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","CH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ch-042",
    lat: 46.22289,
    lng: 7.38025,
    panoId: "YjsAsRDDDC7tFiwhsv39ig",
    place: "Near Vex, Valais",
    shortName: "Vex",
    countryCode: "CH",
    country: "Switzerland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","CH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ch-043",
    lat: 46.762546,
    lng: 6.654418,
    panoId: "IW-VBuoNGQYDrPZ4X4Kb3Q",
    place: "Near Yverdon-les-Bains, Vaud",
    shortName: "Yverdon-les-Bains",
    countryCode: "CH",
    country: "Switzerland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","CH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ch-044",
    lat: 47.120366,
    lng: 7.22861,
    panoId: "IMpgVDLKlECGwT1_-zR7pg",
    place: "Near Nidau, Bern",
    shortName: "Nidau",
    countryCode: "CH",
    country: "Switzerland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","CH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ch-045",
    lat: 47.5819,
    lng: 7.668533,
    panoId: "vD19CHVCIihhTcjE2QEurw",
    place: "Near Bettingen, Basel-City",
    shortName: "Bettingen",
    countryCode: "CH",
    country: "Switzerland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","CH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ch-046",
    lat: 47.428466,
    lng: 8.55423,
    panoId: "Ykp8_Cju-eSN0aRG334esw",
    place: "Near Glattbrugg, Zurich",
    shortName: "Glattbrugg",
    countryCode: "CH",
    country: "Switzerland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","CH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ch-047",
    lat: 47.209497,
    lng: 8.536018,
    panoId: "tp9aY0G8Gzc2MJLarrKJMA",
    place: "Near Baar, Zug",
    shortName: "Baar",
    countryCode: "CH",
    country: "Switzerland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","CH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ch-048",
    lat: 46.624596,
    lng: 7.077384,
    panoId: "KnzSYQ0jNfsJ4Bun4RTXzg",
    place: "Near Bulle, Fribourg",
    shortName: "Bulle",
    countryCode: "CH",
    country: "Switzerland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","CH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ch-049",
    lat: 46.858193,
    lng: 9.526941,
    panoId: "4ZPVlyOsjI9009dVnzj1hw",
    place: "Near Chur, Grisons",
    shortName: "Chur",
    countryCode: "CH",
    country: "Switzerland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","CH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ch-050",
    lat: 47.40625,
    lng: 8.983644,
    panoId: "6wQ86yjyGOJ70UX02Tq56g",
    place: "Near Fischingen, Thurgau",
    shortName: "Fischingen",
    countryCode: "CH",
    country: "Switzerland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","CH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ch-051",
    lat: 47.39439,
    lng: 8.828152,
    panoId: "DB5yNM7I1RI65C2pnkSYDA",
    place: "Near Wila, Zurich",
    shortName: "Wila",
    countryCode: "CH",
    country: "Switzerland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","CH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ch-052",
    lat: 47.740902,
    lng: 8.644923,
    panoId: "I8Y-63Tcyr1h-FwiFh36cg",
    place: "Near Stetten, Schaffhausen",
    shortName: "Stetten",
    countryCode: "CH",
    country: "Switzerland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","CH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ch-053",
    lat: 46.400642,
    lng: 6.926357,
    panoId: "cw-FPk8GSGHpW2LyMypZVg",
    place: "Near Villeneuve, Vaud",
    shortName: "Villeneuve",
    countryCode: "CH",
    country: "Switzerland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","CH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ch-054",
    lat: 47.148769,
    lng: 6.820294,
    panoId: "Z8J2zn550l9d7JTfrqqk1g",
    place: "Near La Chaux-de-Fonds, Neuchâtel",
    shortName: "La Chaux-de-Fonds",
    countryCode: "CH",
    country: "Switzerland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","CH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ch-055",
    lat: 47.407712,
    lng: 9.436506,
    panoId: "38pwjbakqovcq2-6YRzWzw",
    place: "Near Speicher, Appenzell Ausserrhoden",
    shortName: "Speicher",
    countryCode: "CH",
    country: "Switzerland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","CH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ch-056",
    lat: 46.72121,
    lng: 6.657419,
    panoId: "SCaB05MXDByrv1iak8-zFw",
    place: "Near Pailly, Vaud",
    shortName: "Pailly",
    countryCode: "CH",
    country: "Switzerland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","CH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ch-057",
    lat: 46.59722,
    lng: 6.526941,
    panoId: "HkbYFfBqAP3JjwMGxKQyog",
    place: "Near Penthalaz, Vaud",
    shortName: "Penthalaz",
    countryCode: "CH",
    country: "Switzerland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","CH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ch-058",
    lat: 46.822095,
    lng: 9.539152,
    panoId: "Vnr6D8QRyC5moR5AbGFE8w",
    place: "Near Chur, Grisons",
    shortName: "Chur",
    countryCode: "CH",
    country: "Switzerland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","CH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ch-059",
    lat: 46.733434,
    lng: 7.583186,
    panoId: "TQhoaRN4O6Pr3Xlsub2ppQ",
    place: "Near Uebeschi, Bern",
    shortName: "Uebeschi",
    countryCode: "CH",
    country: "Switzerland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","CH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ch-060",
    lat: 46.07101,
    lng: 7.069778,
    panoId: "hHzShmqEWkXlbLsvahb17A",
    place: "Near Martigny-Combe, Valais",
    shortName: "Martigny-Combe",
    countryCode: "CH",
    country: "Switzerland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","CH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ch-061",
    lat: 47.459348,
    lng: 9.281168,
    panoId: "1bvitGOqd4hkD5YcMlVW_g",
    place: "Near Waldkirch, Saint Gallen",
    shortName: "Waldkirch",
    countryCode: "CH",
    country: "Switzerland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","CH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ch-062",
    lat: 47.684316,
    lng: 8.346811,
    panoId: "zdlaRs0FyZoEA6iuQBv9DQ",
    place: "Near Wutöschingen, Baden-Wurttemberg",
    shortName: "Wutöschingen",
    countryCode: "CH",
    country: "Switzerland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","CH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ch-063",
    lat: 47.155906,
    lng: 7.455852,
    panoId: "YutBaN2fvkYKXkVXR5NoQw",
    place: "Near Leuzigen, Bern",
    shortName: "Leuzigen",
    countryCode: "CH",
    country: "Switzerland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","CH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ch-064",
    lat: 47.36959,
    lng: 8.993964,
    panoId: "rE4cCvCQtcGi0vdSPtnCig",
    place: "Near Mosnang, Saint Gallen",
    shortName: "Mosnang",
    countryCode: "CH",
    country: "Switzerland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","CH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ch-065",
    lat: 46.821442,
    lng: 7.10459,
    panoId: "no5Qt8b1Z--BEt1YF8yI-A",
    place: "Near Belfaux, Fribourg",
    shortName: "Belfaux",
    countryCode: "CH",
    country: "Switzerland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","CH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ch-066",
    lat: 47.287039,
    lng: 8.269736,
    panoId: "yMivX5CmId1jmGhmECz8yA",
    place: "Near Sarmenstorf, Aargau",
    shortName: "Sarmenstorf",
    countryCode: "CH",
    country: "Switzerland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","CH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ch-067",
    lat: 47.41781,
    lng: 8.777981,
    panoId: "GGZid8KM5HOIM0qrtKdD_g",
    place: "Near Weisslingen, Zurich",
    shortName: "Weisslingen",
    countryCode: "CH",
    country: "Switzerland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","CH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ch-068",
    lat: 47.543001,
    lng: 8.169806,
    panoId: "Vyuoip_L1KN6zdw4du8QqQ",
    place: "Near Gansingen, Aargau",
    shortName: "Gansingen",
    countryCode: "CH",
    country: "Switzerland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","CH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ch-069",
    lat: 47.315513,
    lng: 8.387919,
    panoId: "4rLIH_O8Mkp4dDgFjaLSlw",
    place: "Near Oberlunkhofen, Aargau",
    shortName: "Oberlunkhofen",
    countryCode: "CH",
    country: "Switzerland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","CH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ch-070",
    lat: 46.366152,
    lng: 6.310279,
    panoId: "_ikkuvv7cpScq9bCBTgfBA",
    place: "Near Messery, Rhône-Alpes",
    shortName: "Messery",
    countryCode: "CH",
    country: "Switzerland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","CH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ch-071",
    lat: 47.269082,
    lng: 9.052951,
    panoId: "4o2jZibmLBmmyY3Bv-bRaw",
    place: "Near Wattwil, Saint Gallen",
    shortName: "Wattwil",
    countryCode: "CH",
    country: "Switzerland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","CH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ch-072",
    lat: 47.463762,
    lng: 9.196794,
    panoId: "7ncaznvRNr_GiP7Ymw6aJg",
    place: "Near Niederbüren, Saint Gallen",
    shortName: "Niederbüren",
    countryCode: "CH",
    country: "Switzerland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","CH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ch-073",
    lat: 47.338787,
    lng: 8.894014,
    panoId: "UKIQFRSpcuyj3R2n7x8W_A",
    place: "Near Bäretswil, Zurich",
    shortName: "Bäretswil",
    countryCode: "CH",
    country: "Switzerland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","CH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ch-074",
    lat: 47.153345,
    lng: 7.489679,
    panoId: "mEb-IxnuiihXikpjYFrUDQ",
    place: "Near Leuzigen, Bern",
    shortName: "Leuzigen",
    countryCode: "CH",
    country: "Switzerland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","CH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ch-075",
    lat: 47.456533,
    lng: 8.419855,
    panoId: "nLuMFyDO0Fm1DF-kxt3krQ",
    place: "Near Dänikon, Zurich",
    shortName: "Dänikon",
    countryCode: "CH",
    country: "Switzerland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","CH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ch-076",
    lat: 47.079178,
    lng: 6.684388,
    panoId: "YJTmqXT4C9r37c5ubHEYWw",
    place: "Near Les Brenets, Neuchâtel",
    shortName: "Les Brenets",
    countryCode: "CH",
    country: "Switzerland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","CH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ch-077",
    lat: 45.82272,
    lng: 8.881111,
    panoId: "GzOaVZmgjNYUm8GUcwD6Dw",
    place: "Near Cantello, Lombardy",
    shortName: "Cantello",
    countryCode: "CH",
    country: "Switzerland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","CH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ch-078",
    lat: 47.232681,
    lng: 7.340735,
    panoId: "eaT5WOjZcORQsqYA4aNF7Q",
    place: "Near Court, Bern",
    shortName: "Court",
    countryCode: "CH",
    country: "Switzerland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","CH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ch-079",
    lat: 47.509693,
    lng: 9.291132,
    panoId: "j0_jsfEsoo54GYZE_vSKvg",
    place: "Near Muolen, Saint Gallen",
    shortName: "Muolen",
    countryCode: "CH",
    country: "Switzerland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","CH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ch-080",
    lat: 47.345448,
    lng: 7.619818,
    panoId: "BIn6GapqnZDvSA-_iPYwTg",
    place: "Near Laupersdorf, Solothurn",
    shortName: "Laupersdorf",
    countryCode: "CH",
    country: "Switzerland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","CH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ch-081",
    lat: 47.723324,
    lng: 9.175038,
    panoId: "wI-FBHHrEjvSKyKtRr4dXw",
    place: "Near Litzelstetten, Baden-Wurttemberg",
    shortName: "Litzelstetten",
    countryCode: "CH",
    country: "Switzerland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","CH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ch-082",
    lat: 47.668645,
    lng: 7.441555,
    panoId: "mXHg6lgMbAbXrLaEFA0uRw",
    place: "Near Sierentz, Grand Est",
    shortName: "Sierentz",
    countryCode: "CH",
    country: "Switzerland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","CH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ch-083",
    lat: 46.191909,
    lng: 5.989478,
    panoId: "VPDB_TWZ1hmmTwQB0YvDiQ",
    place: "Near Dardagny, Geneva",
    shortName: "Dardagny",
    countryCode: "CH",
    country: "Switzerland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","CH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ch-084",
    lat: 45.996389,
    lng: 8.837912,
    panoId: "gp-wJ4ezraCzl_xRzKUbTQ",
    place: "Near Bedigliora, Ticino",
    shortName: "Bedigliora",
    countryCode: "CH",
    country: "Switzerland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","CH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ch-085",
    lat: 46.09951,
    lng: 5.992494,
    panoId: "qwhMIjPCu5Kd2Qqs_ON4Gg",
    place: "Near Valleiry, Rhône-Alpes",
    shortName: "Valleiry",
    countryCode: "CH",
    country: "Switzerland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","CH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ch-086",
    lat: 46.47911,
    lng: 6.320805,
    panoId: "oCrDCAMW2gVaLq0I0ZmATQ",
    place: "Near Rolle, Vaud",
    shortName: "Rolle",
    countryCode: "CH",
    country: "Switzerland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","CH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ch-087",
    lat: 47.200973,
    lng: 7.086632,
    panoId: "4jE5aRgcZnOtNfzTNIScoQ",
    place: "Near Tramelan, Bern",
    shortName: "Tramelan",
    countryCode: "CH",
    country: "Switzerland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","CH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ch-088",
    lat: 46.373874,
    lng: 6.862586,
    panoId: "UUMsLlkDhuy6eXpU312ZeQ",
    place: "Near Tanay, Valais",
    shortName: "Tanay",
    countryCode: "CH",
    country: "Switzerland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","CH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ch-089",
    lat: 47.060085,
    lng: 7.776372,
    panoId: "hnWyUyznkYp9NgJlbJMb9Q",
    place: "Near Dürrenroth, Bern",
    shortName: "Dürrenroth",
    countryCode: "CH",
    country: "Switzerland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","CH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ch-090",
    lat: 47.376204,
    lng: 7.254845,
    panoId: "A7Rk2wNbDToiHNC43mRN8Q",
    place: "Near Bassecourt, Jura",
    shortName: "Bassecourt",
    countryCode: "CH",
    country: "Switzerland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","CH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ch-091",
    lat: 46.36449,
    lng: 6.02495,
    panoId: "R3uzwDQ2BlM9aKjpknJFzQ",
    place: "Near Gex, Rhône-Alpes",
    shortName: "Gex",
    countryCode: "CH",
    country: "Switzerland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","CH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ch-092",
    lat: 47.509784,
    lng: 9.204527,
    panoId: "rNzpQv2qtOnTkHZddG0KEA",
    place: "Near Hohentannen, Thurgau",
    shortName: "Hohentannen",
    countryCode: "CH",
    country: "Switzerland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","CH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ch-093",
    lat: 46.865771,
    lng: 7.650429,
    panoId: "wyEG48wi0OzPokQQzINl-w",
    place: "Near Oberhünigen, Bern",
    shortName: "Oberhünigen",
    countryCode: "CH",
    country: "Switzerland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","CH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ch-094",
    lat: 47.182391,
    lng: 9.682231,
    panoId: "gemlRwkbHFvz6pYCx_cCGg",
    place: "Near Nenzing, Vorarlberg",
    shortName: "Nenzing",
    countryCode: "CH",
    country: "Switzerland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","CH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ch-095",
    lat: 46.347934,
    lng: 7.436753,
    panoId: "lFJy8Ufr4J37Rtp6QV8wQA",
    place: "Near Crans-Montana, Valais",
    shortName: "Crans-Montana",
    countryCode: "CH",
    country: "Switzerland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","CH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ch-096",
    lat: 47.674343,
    lng: 9.320792,
    panoId: "e300LhHbXuZKWNNh73o49w",
    place: "Near Hagnau, Baden-Wurttemberg",
    shortName: "Hagnau",
    countryCode: "CH",
    country: "Switzerland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","CH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ch-097",
    lat: 47.457667,
    lng: 7.544802,
    panoId: "LPmHz4a0G928dpDRg6lHtg",
    place: "Near Zwingen, Basel-Landschaft",
    shortName: "Zwingen",
    countryCode: "CH",
    country: "Switzerland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","CH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ch-098",
    lat: 47.6006,
    lng: 8.728794,
    panoId: "sVkSP4D6CZba1PrvdGy5vQ",
    place: "Near Kleinandelfingen, Zurich",
    shortName: "Kleinandelfingen",
    countryCode: "CH",
    country: "Switzerland",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","CH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ch-099",
    lat: 46.229286,
    lng: 6.394765,
    panoId: "LivD4G1HJyEAmk2-KywxJQ",
    place: "Near Boëge, Rhône-Alpes",
    shortName: "Boëge",
    countryCode: "CH",
    country: "Switzerland",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","CH"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "ch-100",
    lat: 46.45129,
    lng: 6.152809,
    panoId: "1_F210o-QxH6OgxOmq1pIg",
    place: "Near Saint-Cergue, Vaud",
    shortName: "Saint-Cergue",
    countryCode: "CH",
    country: "Switzerland",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","CH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ch-101",
    lat: 47.424078,
    lng: 7.221504,
    panoId: "f08ie3_3JKNporhN5V4ojA",
    place: "Near Alle, Jura",
    shortName: "Alle",
    countryCode: "CH",
    country: "Switzerland",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","CH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ch-102",
    lat: 47.333164,
    lng: 7.202213,
    panoId: "b4PEJWI9yKMQJodMuqHGnQ",
    place: "Near Glovelier, Jura",
    shortName: "Glovelier",
    countryCode: "CH",
    country: "Switzerland",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","CH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ch-103",
    lat: 46.091058,
    lng: 8.605739,
    panoId: "a99AuXgBpEyBqF42rmJrlQ",
    place: "Near Falmenta, Piedmont",
    shortName: "Falmenta",
    countryCode: "CH",
    country: "Switzerland",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","CH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "at-000",
    lat: 48.208513,
    lng: 16.372049,
    panoId: "2E5ktTVSSj2a_oeGWlcXHg",
    place: "Near Vienna, State of Vienna",
    shortName: "Vienna",
    countryCode: "AT",
    country: "Austria",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","AT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "at-001",
    lat: 48.221073,
    lng: 14.238965,
    panoId: "ApX8_jetREz9o1_Vv8T7GQ",
    place: "Near Traun, Upper Austria",
    shortName: "Traun",
    countryCode: "AT",
    country: "Austria",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","AT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "at-002",
    lat: 47.067419,
    lng: 15.441643,
    panoId: "OpTBe6hNojau_35a64nWpw",
    place: "Near Graz, Styria",
    shortName: "Graz",
    countryCode: "AT",
    country: "Austria",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","AT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "at-003",
    lat: 47.216382,
    lng: 14.815933,
    panoId: "p7-zoRvUjZauTUdZb8BC6A",
    place: "Near Knittelfeld, Styria",
    shortName: "Knittelfeld",
    countryCode: "AT",
    country: "Austria",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","AT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "at-004",
    lat: 48.306371,
    lng: 14.286055,
    panoId: "xQ9Cl3lV2apCUfZvO8iC6w",
    place: "Near Linz, Upper Austria",
    shortName: "Linz",
    countryCode: "AT",
    country: "Austria",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","AT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "at-005",
    lat: 47.361084,
    lng: 9.687156,
    panoId: "yCHrzqsRdAFpohx-KVeKig",
    place: "Near Hohenems, Vorarlberg",
    shortName: "Hohenems",
    countryCode: "AT",
    country: "Austria",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","AT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "at-006",
    lat: 47.799338,
    lng: 13.043947,
    panoId: "uXVON2CF2l_5hUnLOzc3Cw",
    place: "Near Salzburg, State of Salzburg",
    shortName: "Salzburg",
    countryCode: "AT",
    country: "Austria",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","AT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "at-007",
    lat: 48.328266,
    lng: 16.058623,
    panoId: "hkZEqJdGO1gAK8XL23P3vA",
    place: "Near Tulln, Lower Austria",
    shortName: "Tulln",
    countryCode: "AT",
    country: "Austria",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","AT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "at-008",
    lat: 47.283263,
    lng: 11.516615,
    panoId: "PaftKF_unR128iDLzF4o5g",
    place: "Near Hall in Tirol, Tyrol",
    shortName: "Hall in Tirol",
    countryCode: "AT",
    country: "Austria",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","AT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "at-009",
    lat: 47.427025,
    lng: 12.848097,
    panoId: "XR268JVXHWm_fQsJVPU3uw",
    place: "Near Saalfelden am Steinernen Meer, State of Salzburg",
    shortName: "Saalfelden am Steinernen Meer",
    countryCode: "AT",
    country: "Austria",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","AT"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "at-010",
    lat: 48.042706,
    lng: 14.421214,
    panoId: "0IPDyTy9RGV5gHzopJeXdA",
    place: "Near Steyr, Upper Austria",
    shortName: "Steyr",
    countryCode: "AT",
    country: "Austria",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","AT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "at-011",
    lat: 47.15479,
    lng: 9.822657,
    panoId: "5KZEsCuIsdI2LLY7sc_p7Q",
    place: "Near Bludenz, Vorarlberg",
    shortName: "Bludenz",
    countryCode: "AT",
    country: "Austria",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","AT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "at-012",
    lat: 47.503046,
    lng: 9.74713,
    panoId: "AVmkVW4xtaZQNn4g5dfBkA",
    place: "Near Bregenz, Vorarlberg",
    shortName: "Bregenz",
    countryCode: "AT",
    country: "Austria",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","AT"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "at-013",
    lat: 47.236414,
    lng: 9.597436,
    panoId: "1Vjb5x773L6c1kbeJW81hg",
    place: "Near Feldkirch, Vorarlberg",
    shortName: "Feldkirch",
    countryCode: "AT",
    country: "Austria",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","AT"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "at-014",
    lat: 47.270887,
    lng: 9.64343,
    panoId: "EdGWwOak4BpGA6_i5HhW0A",
    place: "Near Rankweil, Vorarlberg",
    shortName: "Rankweil",
    countryCode: "AT",
    country: "Austria",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","AT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "at-015",
    lat: 47.720773,
    lng: 16.081358,
    panoId: "5hVijH1uhVjOTMljFVQgPA",
    place: "Near Neunkirchen, Lower Austria",
    shortName: "Neunkirchen",
    countryCode: "AT",
    country: "Austria",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","AT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "at-016",
    lat: 47.488899,
    lng: 12.061824,
    panoId: "ezqx0XoTZw5snaR9oqTFpQ",
    place: "Near Wörgl, Tyrol",
    shortName: "Wörgl",
    countryCode: "AT",
    country: "Austria",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","AT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "at-017",
    lat: 48.166664,
    lng: 14.03338,
    panoId: "byFj1pOaWK7n4b5Ax2_pPQ",
    place: "Near Wels, Upper Austria",
    shortName: "Wels",
    countryCode: "AT",
    country: "Austria",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","AT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "at-018",
    lat: 48.123086,
    lng: 14.872124,
    panoId: "ZSzBIx4QR8V4uoTI65sluQ",
    place: "Near Amstetten, Lower Austria",
    shortName: "Amstetten",
    countryCode: "AT",
    country: "Austria",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","AT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "at-019",
    lat: 47.482983,
    lng: 9.682839,
    panoId: "YoaxagaaUk1uXuJojGUxmw",
    place: "Near Hard, Vorarlberg",
    shortName: "Hard",
    countryCode: "AT",
    country: "Austria",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","AT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "at-020",
    lat: 47.426455,
    lng: 9.658523,
    panoId: "9NO_kiZAJh5DBkluK5eH4A",
    place: "Near Lustenau, Vorarlberg",
    shortName: "Lustenau",
    countryCode: "AT",
    country: "Austria",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","AT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "at-021",
    lat: 46.800016,
    lng: 13.499944,
    panoId: "onGw1B34nGSGMohVEqMoQA",
    place: "Near Spittal an der Drau, Carinthia",
    shortName: "Spittal an der Drau",
    countryCode: "AT",
    country: "Austria",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","AT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "at-022",
    lat: 48.409289,
    lng: 15.614094,
    panoId: "UXgpG6KJYh5ap5xhBhBsOQ",
    place: "Near Krems an der Donau, Lower Austria",
    shortName: "Krems an der Donau",
    countryCode: "AT",
    country: "Austria",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","AT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "at-023",
    lat: 46.62471,
    lng: 14.30547,
    panoId: "nwWpHqeSR6uSkcrIvUM1lA",
    place: "Near Klagenfurt am Wörthersee, Carinthia",
    shortName: "Klagenfurt am Wörthersee",
    countryCode: "AT",
    country: "Austria",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","AT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "at-024",
    lat: 47.262668,
    lng: 11.394579,
    panoId: "IvBv0wNoYKON8zhJ9EftsQ",
    place: "Near Innsbruck, Tyrol",
    shortName: "Innsbruck",
    countryCode: "AT",
    country: "Austria",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","AT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "at-025",
    lat: 47.351847,
    lng: 11.709841,
    panoId: "oy00g4bVZwxxtdNjE2Ld1g",
    place: "Near Schwaz, Tyrol",
    shortName: "Schwaz",
    countryCode: "AT",
    country: "Austria",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","AT"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "at-026",
    lat: 47.333197,
    lng: 9.633148,
    panoId: "sqVZKM-sfSv0pACpa-Ms8A",
    place: "Near Götzis, Vorarlberg",
    shortName: "Götzis",
    countryCode: "AT",
    country: "Austria",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","AT"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "at-027",
    lat: 46.840565,
    lng: 14.844063,
    panoId: "ZEW4ZhazEGZPipeU3CyDDg",
    place: "Near Wolfsberg, Carinthia",
    shortName: "Wolfsberg",
    countryCode: "AT",
    country: "Austria",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","AT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "at-028",
    lat: 47.918291,
    lng: 13.799349,
    panoId: "qHc6dtET2i6PISmyAmue_A",
    place: "Near Gmunden, Upper Austria",
    shortName: "Gmunden",
    countryCode: "AT",
    country: "Austria",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","AT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "at-029",
    lat: 46.610573,
    lng: 13.856061,
    panoId: "jHo83ht0hJ1CI4kffsbpcg",
    place: "Near Villach, Carinthia",
    shortName: "Villach",
    countryCode: "AT",
    country: "Austria",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","AT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "at-030",
    lat: 47.307187,
    lng: 11.068471,
    panoId: "2EDdNtJPbd0leHRyOa68Wg",
    place: "Near Telfs, Tyrol",
    shortName: "Telfs",
    countryCode: "AT",
    country: "Austria",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","AT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "at-031",
    lat: 46.828936,
    lng: 12.768776,
    panoId: "5FaAeTvNFmS2LP-sR4aUOA",
    place: "Near Lienz, Tyrol",
    shortName: "Lienz",
    countryCode: "AT",
    country: "Austria",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","AT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "at-032",
    lat: 48.208446,
    lng: 15.637277,
    panoId: "2J5NRyTRdbPcU7qRJvdh_Q",
    place: "Near Sankt Pölten, Lower Austria",
    shortName: "Sankt Pölten",
    countryCode: "AT",
    country: "Austria",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","AT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "at-033",
    lat: 48.211268,
    lng: 13.488583,
    panoId: "AATN7VIRXih73aPzcB6IMA",
    place: "Near Ried im Innkreis, Upper Austria",
    shortName: "Ried im Innkreis",
    countryCode: "AT",
    country: "Austria",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","AT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "at-034",
    lat: 47.804665,
    lng: 16.23301,
    panoId: "RdwZypkr1NAGMJF9-F78UQ",
    place: "Near Wiener Neustadt, Lower Austria",
    shortName: "Wiener Neustadt",
    countryCode: "AT",
    country: "Austria",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","AT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "at-035",
    lat: 47.414399,
    lng: 9.742257,
    panoId: "OwhnucnXItuqUWGXKXOLFQ",
    place: "Near Dornbirn, Vorarlberg",
    shortName: "Dornbirn",
    countryCode: "AT",
    country: "Austria",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","AT"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "at-036",
    lat: 46.768379,
    lng: 14.360716,
    panoId: "VJmuKBl3hGhHEwlP9QbxgA",
    place: "Near Sankt Veit an der Glan, Carinthia",
    shortName: "Sankt Veit an der Glan",
    countryCode: "AT",
    country: "Austria",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","AT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "at-037",
    lat: 47.245225,
    lng: 10.739647,
    panoId: "NB_ymZD9wHF9PeOobtrXxQ",
    place: "Near Imst, Tyrol",
    shortName: "Imst",
    countryCode: "AT",
    country: "Austria",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","AT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "at-038",
    lat: 47.981719,
    lng: 13.821697,
    panoId: "lIyvjV40EPFj1Vfya1hPvw",
    place: "Near Laakirchen, Upper Austria",
    shortName: "Laakirchen",
    countryCode: "AT",
    country: "Austria",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","AT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "at-039",
    lat: 47.147772,
    lng: 9.814259,
    panoId: "jR6nYwIvb0KNvvqFYzbUww",
    place: "Near Bludenz, Vorarlberg",
    shortName: "Bludenz",
    countryCode: "AT",
    country: "Austria",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","AT"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "at-040",
    lat: 47.508321,
    lng: 12.050363,
    panoId: "RzoEANqT7cH6TIzL4SA6yA",
    place: "Near Angerberg, Tyrol",
    shortName: "Angerberg",
    countryCode: "AT",
    country: "Austria",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","AT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "at-041",
    lat: 48.138115,
    lng: 14.874282,
    panoId: "w_JW76MNQROX4_4mduNqSQ",
    place: "Near Amstetten, Lower Austria",
    shortName: "Amstetten",
    countryCode: "AT",
    country: "Austria",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","AT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "at-042",
    lat: 46.787356,
    lng: 13.479803,
    panoId: "sJjDE_IjqseKEvin8PXrMA",
    place: "Near Spittal an der Drau, Carinthia",
    shortName: "Spittal an der Drau",
    countryCode: "AT",
    country: "Austria",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","AT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "at-043",
    lat: 47.200624,
    lng: 14.816562,
    panoId: "11cKQI9zNx1kRDNRTvoFcQ",
    place: "Near Apfelberg, Styria",
    shortName: "Apfelberg",
    countryCode: "AT",
    country: "Austria",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","AT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "at-044",
    lat: 47.289281,
    lng: 11.495788,
    panoId: "jUFJJ_UFBtlvdipIrp2nnQ",
    place: "Near Absam, Tyrol",
    shortName: "Absam",
    countryCode: "AT",
    country: "Austria",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","AT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "at-045",
    lat: 46.854364,
    lng: 14.83383,
    panoId: "jeu8jxYh_qlj7mlY1hkcDA",
    place: "Near Wolfsberg, Carinthia",
    shortName: "Wolfsberg",
    countryCode: "AT",
    country: "Austria",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","AT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "at-046",
    lat: 48.026618,
    lng: 14.415966,
    panoId: "GYM2L8cH1yAL9p6VAYLh8Q",
    place: "Near Garsten, Upper Austria",
    shortName: "Garsten",
    countryCode: "AT",
    country: "Austria",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","AT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "at-047",
    lat: 46.815107,
    lng: 12.773219,
    panoId: "vKcpo0zQvMg2jo93anM1tQ",
    place: "Near Amlach, Tyrol",
    shortName: "Amlach",
    countryCode: "AT",
    country: "Austria",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","AT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "at-048",
    lat: 48.198431,
    lng: 15.664975,
    panoId: "zkiy36UKtpwbFOqihUbx2Q",
    place: "Near Oberwagram, Lower Austria",
    shortName: "Oberwagram",
    countryCode: "AT",
    country: "Austria",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","AT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "at-049",
    lat: 47.430428,
    lng: 12.813257,
    panoId: "jpC0fA7DEn93GiTu1Pji5g",
    place: "Near Saalfelden am Steinernen Meer, State of Salzburg",
    shortName: "Saalfelden am Steinernen Meer",
    countryCode: "AT",
    country: "Austria",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","AT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "at-050",
    lat: 47.272808,
    lng: 9.590529,
    panoId: "fvGOCw2FTTZN8zUOBzryeA",
    place: "Near Meiningen, Vorarlberg",
    shortName: "Meiningen",
    countryCode: "AT",
    country: "Austria",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","AT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "at-051",
    lat: 47.211483,
    lng: 9.565496,
    panoId: "8d1HEG3GLQIP_NkiagMVHg",
    place: "Near Mauren, Mauren",
    shortName: "Mauren",
    countryCode: "AT",
    country: "Austria",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","AT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "at-052",
    lat: 47.445457,
    lng: 9.778093,
    panoId: "6CNcBOlYeMMPhwmnm7PSkA",
    place: "Near Bildstein, Vorarlberg",
    shortName: "Bildstein",
    countryCode: "AT",
    country: "Austria",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","AT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "at-053",
    lat: 47.198238,
    lng: 9.779938,
    panoId: "DtRod4WaIaok1g274ZmRJA",
    place: "Near Ludesch, Vorarlberg",
    shortName: "Ludesch",
    countryCode: "AT",
    country: "Austria",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","AT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "at-054",
    lat: 48.312296,
    lng: 16.009024,
    panoId: "E6bljG85ZBdZBaLQRu87UA",
    place: "Near Langenrohr, Lower Austria",
    shortName: "Langenrohr",
    countryCode: "AT",
    country: "Austria",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","AT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "at-055",
    lat: 47.818412,
    lng: 16.282231,
    panoId: "uTyeNaCTQo2K3A9S0Rkh6A",
    place: "Near Lichtenwörth, Lower Austria",
    shortName: "Lichtenwörth",
    countryCode: "AT",
    country: "Austria",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","AT"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "at-056",
    lat: 48.118202,
    lng: 13.958449,
    panoId: "0crpyjZHXT_S1NFfFDCYCA",
    place: "Near Gunskirchen, Upper Austria",
    shortName: "Gunskirchen",
    countryCode: "AT",
    country: "Austria",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","AT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "at-057",
    lat: 48.263973,
    lng: 13.550941,
    panoId: "srmFxvJ48sJDGMEQwGHsgg",
    place: "Near Taiskirchen im Innkreis, Upper Austria",
    shortName: "Taiskirchen im Innkreis",
    countryCode: "AT",
    country: "Austria",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","AT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "at-058",
    lat: 47.284177,
    lng: 11.165244,
    panoId: "gxsHlOg9NYVhwOtYALAvCA",
    place: "Near Hatting, Tyrol",
    shortName: "Hatting",
    countryCode: "AT",
    country: "Austria",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","AT"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "at-059",
    lat: 48.414847,
    lng: 15.53085,
    panoId: "FCg-RTCHu5Spb2OUaQ7sPw",
    place: "Near Dürnstein, Lower Austria",
    shortName: "Dürnstein",
    countryCode: "AT",
    country: "Austria",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","AT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "at-060",
    lat: 48.361818,
    lng: 14.261454,
    panoId: "nQd6Ovj9uHmTaYtqpd3PCw",
    place: "Near Altlichtenberg, Upper Austria",
    shortName: "Altlichtenberg",
    countryCode: "AT",
    country: "Austria",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","AT"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "at-061",
    lat: 47.220812,
    lng: 11.367913,
    panoId: "cdHUf0Ke_36Sxc8bmaEDrw",
    place: "Near Natters, Tyrol",
    shortName: "Natters",
    countryCode: "AT",
    country: "Austria",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","AT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "at-062",
    lat: 47.477447,
    lng: 11.979351,
    panoId: "SVTpX35qfTET23K_tYPKbQ",
    place: "Near Breitenbach am Inn, Tyrol",
    shortName: "Breitenbach am Inn",
    countryCode: "AT",
    country: "Austria",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","AT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "at-063",
    lat: 46.562784,
    lng: 14.310204,
    panoId: "xBqJ3aWKcRJhorzpjK-WCw",
    place: "Near Maria Rain, Carinthia",
    shortName: "Maria Rain",
    countryCode: "AT",
    country: "Austria",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","AT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "at-064",
    lat: 47.518042,
    lng: 12.470653,
    panoId: "CwI8zA0GFIKmPOjh5zcP0A",
    place: "Near Sankt Johann in Tirol, Tyrol",
    shortName: "Sankt Johann in Tirol",
    countryCode: "AT",
    country: "Austria",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","AT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "at-065",
    lat: 46.780834,
    lng: 13.558236,
    panoId: "aoqqQzdgz08rcPmYvwyJtQ",
    place: "Near Millstatt, Carinthia",
    shortName: "Millstatt",
    countryCode: "AT",
    country: "Austria",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","AT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "at-066",
    lat: 47.972334,
    lng: 13.719385,
    panoId: "9oUmhgFJjlKJW3l8ib447w",
    place: "Near Puchheim, Upper Austria",
    shortName: "Puchheim",
    countryCode: "AT",
    country: "Austria",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","AT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "at-067",
    lat: 47.867419,
    lng: 13.777673,
    panoId: "aNMs6geUyTDmWLc7teGYzg",
    place: "Near Traunkirchen, Upper Austria",
    shortName: "Traunkirchen",
    countryCode: "AT",
    country: "Austria",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","AT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "at-068",
    lat: 47.751445,
    lng: 16.08899,
    panoId: "OehnPMCOy1A1LbWteeTILQ",
    place: "Near Neunkirchen, Lower Austria",
    shortName: "Neunkirchen",
    countryCode: "AT",
    country: "Austria",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","AT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "at-069",
    lat: 46.867863,
    lng: 14.762166,
    panoId: "clfxiGESL1-AgLQwKO_Yzg",
    place: "Near Wolfsberg, Carinthia",
    shortName: "Wolfsberg",
    countryCode: "AT",
    country: "Austria",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","AT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "at-070",
    lat: 48.258326,
    lng: 15.57508,
    panoId: "i0fRALW2mZ74kC0fI3lOYg",
    place: "Near Karlstetten, Lower Austria",
    shortName: "Karlstetten",
    countryCode: "AT",
    country: "Austria",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","AT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "at-071",
    lat: 48.036386,
    lng: 14.522896,
    panoId: "cd2LsKlftoA1k6pUmWoMtw",
    place: "Near Penz, Lower Austria",
    shortName: "Penz",
    countryCode: "AT",
    country: "Austria",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","AT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "at-072",
    lat: 48.123113,
    lng: 14.800835,
    panoId: "K8nX63TVqJx2yOcC61kxgg",
    place: "Near Zeillern, Lower Austria",
    shortName: "Zeillern",
    countryCode: "AT",
    country: "Austria",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","AT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "at-073",
    lat: 47.757284,
    lng: 13.102474,
    panoId: "tzz-L9AgNMFpq6ZsqJpOcQ",
    place: "Near Glasenbach, State of Salzburg",
    shortName: "Glasenbach",
    countryCode: "AT",
    country: "Austria",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","AT"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "at-074",
    lat: 47.342665,
    lng: 9.498187,
    panoId: "hH02yOEqpYXXi-oEMxidXw",
    place: "Near Eichberg, Saint Gallen",
    shortName: "Eichberg",
    countryCode: "AT",
    country: "Austria",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","AT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "at-075",
    lat: 47.198835,
    lng: 10.746869,
    panoId: "VC2lgnHZjveBfAC_gXA_HA",
    place: "Near Arzl im Pitztal, Tyrol",
    shortName: "Arzl im Pitztal",
    countryCode: "AT",
    country: "Austria",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","AT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "at-076",
    lat: 48.167545,
    lng: 13.553926,
    panoId: "HyJF5elmaonLuaJvKnSCng",
    place: "Near Eberschwang, Upper Austria",
    shortName: "Eberschwang",
    countryCode: "AT",
    country: "Austria",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","AT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "at-077",
    lat: 48.148466,
    lng: 14.444204,
    panoId: "Qc6Dt85HcGO24i8Fj0R2_w",
    place: "Near Kronstorf, Upper Austria",
    shortName: "Kronstorf",
    countryCode: "AT",
    country: "Austria",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","AT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "at-078",
    lat: 48.142588,
    lng: 14.461206,
    panoId: "kWfHouxqY9EnLUst8OS2xw",
    place: "Near Kronstorf, Upper Austria",
    shortName: "Kronstorf",
    countryCode: "AT",
    country: "Austria",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","AT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "at-079",
    lat: 46.746391,
    lng: 14.293003,
    panoId: "kCbfIYY9GaDtKQBteBsQWA",
    place: "Near Liebenfels, Carinthia",
    shortName: "Liebenfels",
    countryCode: "AT",
    country: "Austria",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","AT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "at-080",
    lat: 47.204452,
    lng: 9.813537,
    panoId: "A6anTQWM4STXbsmEO82JXg",
    place: "Near Raggal, Vorarlberg",
    shortName: "Raggal",
    countryCode: "AT",
    country: "Austria",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","AT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "at-081",
    lat: 47.392049,
    lng: 9.42683,
    panoId: "hZsWVKIdQEkYQUJQiH-2Sg",
    place: "Near Bühler, Appenzell Ausserrhoden",
    shortName: "Bühler",
    countryCode: "AT",
    country: "Austria",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","AT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "at-082",
    lat: 47.195281,
    lng: 15.701213,
    panoId: "KPZ0kkMMUc1kymMey2pCwg",
    place: "Near Unterfladnitz, Styria",
    shortName: "Unterfladnitz",
    countryCode: "AT",
    country: "Austria",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","AT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "at-083",
    lat: 47.129754,
    lng: 14.628748,
    panoId: "LyjQroWxgNhpPyXwvax4iw",
    place: "Near Oberweg, Styria",
    shortName: "Oberweg",
    countryCode: "AT",
    country: "Austria",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","AT"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "at-084",
    lat: 47.385808,
    lng: 9.7309,
    panoId: "ldn2gx5ph100p7uVR0TWvg",
    place: "Near Dornbirn, Vorarlberg",
    shortName: "Dornbirn",
    countryCode: "AT",
    country: "Austria",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","AT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "at-085",
    lat: 47.443408,
    lng: 15.262412,
    panoId: "sq2FW-arKGKjiuho9YA_Rw",
    place: "Near Diemlach, Styria",
    shortName: "Diemlach",
    countryCode: "AT",
    country: "Austria",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","AT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "at-086",
    lat: 46.719855,
    lng: 15.584579,
    panoId: "un7h2lT4OUJ7tugY5JX7HA",
    place: "Near Ehrenhausen, Styria",
    shortName: "Ehrenhausen",
    countryCode: "AT",
    country: "Austria",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","AT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "at-087",
    lat: 46.538433,
    lng: 14.314206,
    panoId: "ij3g1YglbFEfKMkwmIJ1OQ",
    place: "Near Ferlach, Carinthia",
    shortName: "Ferlach",
    countryCode: "AT",
    country: "Austria",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","AT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "at-088",
    lat: 46.551819,
    lng: 13.829499,
    panoId: "Zz2JM_GHVfQqwNEOtMYHBw",
    place: "Near Fürnitz, Carinthia",
    shortName: "Fürnitz",
    countryCode: "AT",
    country: "Austria",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","AT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "at-089",
    lat: 47.074152,
    lng: 15.113721,
    panoId: "ZG-da2UScqL-iM_KtSeZIA",
    place: "Near Bärnbach, Styria",
    shortName: "Bärnbach",
    countryCode: "AT",
    country: "Austria",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","AT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "at-090",
    lat: 47.401921,
    lng: 14.963938,
    panoId: "24-dLdyBglxXaxtCZPMTyg",
    place: "Near Traboch, Styria",
    shortName: "Traboch",
    countryCode: "AT",
    country: "Austria",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","AT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "at-091",
    lat: 48.388187,
    lng: 14.595276,
    panoId: "xYc5mF-2_m64xGatibnJvw",
    place: "Near Gutau, Upper Austria",
    shortName: "Gutau",
    countryCode: "AT",
    country: "Austria",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","AT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "at-092",
    lat: 47.783035,
    lng: 16.482052,
    panoId: "ZE8nOLc1IqrGFckkjOmLQA",
    place: "Near Antau, Burgenland",
    shortName: "Antau",
    countryCode: "AT",
    country: "Austria",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","AT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "at-093",
    lat: 47.294347,
    lng: 9.436905,
    panoId: "1BlrmKMTcljszk1b5BeHIw",
    place: "Near Appenzell, Appenzell Innerrhoden",
    shortName: "Appenzell",
    countryCode: "AT",
    country: "Austria",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","AT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "at-094",
    lat: 48.13297,
    lng: 14.604995,
    panoId: "PQHQAimT4fig3avYgBM77Q",
    place: "Near Haag, Lower Austria",
    shortName: "Haag",
    countryCode: "AT",
    country: "Austria",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","AT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "at-095",
    lat: 47.536643,
    lng: 9.898215,
    panoId: "CXXrodTVMO8twhoUPwOSiw",
    place: "Near Sulzberg, Vorarlberg",
    shortName: "Sulzberg",
    countryCode: "AT",
    country: "Austria",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","AT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "at-096",
    lat: 47.973387,
    lng: 13.747141,
    panoId: "h9VK-7iMrKyfgNzO7QuNDw",
    place: "Near Ohlsdorf, Upper Austria",
    shortName: "Ohlsdorf",
    countryCode: "AT",
    country: "Austria",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","AT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "at-097",
    lat: 47.756772,
    lng: 12.209046,
    panoId: "3Vlv5p8ZZ-WW_sVpRvXtgw",
    place: "Near Samerberg, Bavaria",
    shortName: "Samerberg",
    countryCode: "AT",
    country: "Austria",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","AT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "at-098",
    lat: 48.078119,
    lng: 13.999273,
    panoId: "m4QKhqSwABXKxHcyoT4hHA",
    place: "Near Steinerkirchen an der Traun, Upper Austria",
    shortName: "Steinerkirchen an der Traun",
    countryCode: "AT",
    country: "Austria",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","AT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "at-099",
    lat: 47.644967,
    lng: 9.654185,
    panoId: "D_tKhv3BJKlA5plotFdMhg",
    place: "Near Neukirch, Baden-Wurttemberg",
    shortName: "Neukirch",
    countryCode: "AT",
    country: "Austria",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","AT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "at-100",
    lat: 47.137535,
    lng: 11.547133,
    panoId: "Sen4rLKMAO9t2l0a2RQ3cA",
    place: "Near Navis, Tyrol",
    shortName: "Navis",
    countryCode: "AT",
    country: "Austria",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","AT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "at-101",
    lat: 47.238335,
    lng: 15.198973,
    panoId: "KymIVJlaKaf8Jrb6A53oUA",
    place: "Near Übelbach, Styria",
    shortName: "Übelbach",
    countryCode: "AT",
    country: "Austria",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","AT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "at-102",
    lat: 48.076389,
    lng: 13.469636,
    panoId: "NVembxyBhPiGZJkewYMN2A",
    place: "Near Frankenburg, Upper Austria",
    shortName: "Frankenburg",
    countryCode: "AT",
    country: "Austria",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","AT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "at-103",
    lat: 46.856576,
    lng: 15.745378,
    panoId: "HkBcKwPKhpZ4uMBbllLUrA",
    place: "Near Jagerberg, Styria",
    shortName: "Jagerberg",
    countryCode: "AT",
    country: "Austria",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","AT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "at-104",
    lat: 48.678176,
    lng: 16.196365,
    panoId: "UZfq6aMOE-V5DHCUsHBJdA",
    place: "Near Mailberg, Lower Austria",
    shortName: "Mailberg",
    countryCode: "AT",
    country: "Austria",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","AT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "at-105",
    lat: 47.303936,
    lng: 13.049868,
    panoId: "fEI_q_3iLkPXAgEQ26vPQA",
    place: "Near Lend, State of Salzburg",
    shortName: "Lend",
    countryCode: "AT",
    country: "Austria",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","AT"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "se-000",
    lat: 58.410809,
    lng: 15.621242,
    panoId: "oGH8DsQrH2RvI6nt7IXUrw",
    place: "Near Linköping, Östergötland",
    shortName: "Linköping",
    countryCode: "SE",
    country: "Sweden",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","SE"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "se-001",
    lat: 59.858876,
    lng: 17.638853,
    panoId: "V2sO4znRIN7fkaTrIvvATw",
    place: "Near Uppsala, Uppsala",
    shortName: "Uppsala",
    countryCode: "SE",
    country: "Sweden",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","SE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "se-002",
    lat: 57.707399,
    lng: 11.966667,
    panoId: "3gkgx_2ZwPyYa3026Wzrww",
    place: "Near Gothenburg, Västra Götaland",
    shortName: "Gothenburg",
    countryCode: "SE",
    country: "Sweden",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","SE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "se-003",
    lat: 59.329508,
    lng: 18.06857,
    panoId: "R9JNnTxl42mSX3N3MAcIkQ",
    place: "Near Stockholm, Stockholm",
    shortName: "Stockholm",
    countryCode: "SE",
    country: "Sweden",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","SE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "se-004",
    lat: 55.605746,
    lng: 13.000949,
    panoId: "6fxPRetgT3p56vPf2ulJOQ",
    place: "Near Malmö, Skåne",
    shortName: "Malmö",
    countryCode: "SE",
    country: "Sweden",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","SE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "se-005",
    lat: 57.655469,
    lng: 12.013761,
    panoId: "8ZfV9ZV16hPzE8GU2u5Nzg",
    place: "Near Mölndal, Västra Götaland",
    shortName: "Mölndal",
    countryCode: "SE",
    country: "Sweden",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","SE"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "se-006",
    lat: 56.046725,
    lng: 12.694407,
    panoId: "qmORifJK2Aov_KfsZyV68Q",
    place: "Near Helsingborg, Skåne",
    shortName: "Helsingborg",
    countryCode: "SE",
    country: "Sweden",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","SE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "se-007",
    lat: 59.359973,
    lng: 18.000917,
    panoId: "iyaYnaqYXyevEdZfKzU9hQ",
    place: "Near Solna, Stockholm",
    shortName: "Solna",
    countryCode: "SE",
    country: "Sweden",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","SE"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "se-008",
    lat: 63.828455,
    lng: 20.259676,
    panoId: "IZRWc2fHR7wi7mJJCfzxSg",
    place: "Near Umeå, Västerbotten",
    shortName: "Umeå",
    countryCode: "SE",
    country: "Sweden",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","SE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "se-009",
    lat: 59.23701,
    lng: 17.981925,
    panoId: "WJv_bnawBR2HGHNochltHA",
    place: "Near Huddinge, Stockholm",
    shortName: "Huddinge",
    countryCode: "SE",
    country: "Sweden",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","SE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "se-010",
    lat: 60.674233,
    lng: 17.142103,
    panoId: "uS3yDH4d87p5jUoCf7KDtg",
    place: "Near Gävle, Gävleborg",
    shortName: "Gävle",
    countryCode: "SE",
    country: "Sweden",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","SE"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "se-011",
    lat: 59.366586,
    lng: 16.50773,
    panoId: "REeLTl1ofufwwBedXtkR1g",
    place: "Near Eskilstuna, Södermanland",
    shortName: "Eskilstuna",
    countryCode: "SE",
    country: "Sweden",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","SE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "se-012",
    lat: 59.1956,
    lng: 17.625286,
    panoId: "R3x7gnMOBElxh2S0-R6gHg",
    place: "Near Södertälje, Stockholm",
    shortName: "Södertälje",
    countryCode: "SE",
    country: "Sweden",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","SE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "se-013",
    lat: 60.485893,
    lng: 15.437436,
    panoId: "AYEpk8raYNc4CGo2DYF-DA",
    place: "Near Borlänge, Dalarna",
    shortName: "Borlänge",
    countryCode: "SE",
    country: "Sweden",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","SE"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "se-014",
    lat: 59.61614,
    lng: 16.552697,
    panoId: "YvYTnjLEgK5kQBkna4xXDw",
    place: "Near Västerås, Västmanland",
    shortName: "Västerås",
    countryCode: "SE",
    country: "Sweden",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","SE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "se-015",
    lat: 59.2743,
    lng: 15.206088,
    panoId: "vN_TFnF2R07dOmvVkRXvbQ",
    place: "Near Örebro, Örebro",
    shortName: "Örebro",
    countryCode: "SE",
    country: "Sweden",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","SE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "se-016",
    lat: 55.705705,
    lng: 13.192916,
    panoId: "plGGaJUibPHaHQ_j1PwDSQ",
    place: "Near Lund, Skåne",
    shortName: "Lund",
    countryCode: "SE",
    country: "Sweden",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","SE"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "se-017",
    lat: 62.391256,
    lng: 17.306325,
    panoId: "Tz8IRNu9xq-x-QfOEoXckg",
    place: "Near Sundsvall, Västernorrland",
    shortName: "Sundsvall",
    countryCode: "SE",
    country: "Sweden",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","SE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "se-018",
    lat: 59.379204,
    lng: 13.503569,
    panoId: "JigDf51ll8kS5bAs4a06tg",
    place: "Near Karlstad, Värmland",
    shortName: "Karlstad",
    countryCode: "SE",
    country: "Sweden",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","SE"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "se-019",
    lat: 56.674458,
    lng: 12.856696,
    panoId: "U8UzdiZYITNrY3xhjBUf9A",
    place: "Near Halmstad, Halland",
    shortName: "Halmstad",
    countryCode: "SE",
    country: "Sweden",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","SE"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "se-020",
    lat: 59.198551,
    lng: 17.833165,
    panoId: "Tp3IsilKYsuUdP9HVaYxmQ",
    place: "Near Tumba, Stockholm",
    shortName: "Tumba",
    countryCode: "SE",
    country: "Sweden",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","SE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "se-021",
    lat: 60.60364,
    lng: 15.625841,
    panoId: "Tt2yEFwZm3sMGTQL-I8kMQ",
    place: "Near Falun, Dalarna",
    shortName: "Falun",
    countryCode: "SE",
    country: "Sweden",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","SE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "se-022",
    lat: 58.594243,
    lng: 16.182668,
    panoId: "-_d8Db1KFXSXo1W8OrWjXw",
    place: "Near Norrköping, Östergötland",
    shortName: "Norrköping",
    countryCode: "SE",
    country: "Sweden",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","SE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "se-023",
    lat: 57.721163,
    lng: 12.939938,
    panoId: "sw1KNngYtfBZySS5BXflxg",
    place: "Near Borås, Västra Götaland",
    shortName: "Borås",
    countryCode: "SE",
    country: "Sweden",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","SE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "se-024",
    lat: 59.444035,
    lng: 18.068527,
    panoId: "C0MxGaN93wsxMfDpZsU2Fw",
    place: "Near Täby, Stockholm",
    shortName: "Täby",
    countryCode: "SE",
    country: "Sweden",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","SE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "se-025",
    lat: 59.36663,
    lng: 18.133554,
    panoId: "JaGEk3Lv7rrCCTwF_0bv6Q",
    place: "Near Lidingö, Stockholm",
    shortName: "Lidingö",
    countryCode: "SE",
    country: "Sweden",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","SE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "se-026",
    lat: 56.03132,
    lng: 14.152397,
    panoId: "CBleJ8n3WQSMBM2hH_vMaQ",
    place: "Near Kristianstad, Skåne",
    shortName: "Kristianstad",
    countryCode: "SE",
    country: "Sweden",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","SE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "se-027",
    lat: 58.753066,
    lng: 17.008065,
    panoId: "F5up6MkMuqIi6EUH3kZwSw",
    place: "Near Nyköping, Södermanland",
    shortName: "Nyköping",
    countryCode: "SE",
    country: "Sweden",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","SE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "se-028",
    lat: 56.661593,
    lng: 16.361622,
    panoId: "H-qbC4fe8UC48bs3onITIg",
    place: "Near Kalmar, Kalmar",
    shortName: "Kalmar",
    countryCode: "SE",
    country: "Sweden",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","SE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "se-029",
    lat: 57.781282,
    lng: 14.156818,
    panoId: "nES76XFCJJWzPq5Lm03UZg",
    place: "Near Jönköping, Jönköping",
    shortName: "Jönköping",
    countryCode: "SE",
    country: "Sweden",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","SE"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "se-030",
    lat: 56.877622,
    lng: 14.809043,
    panoId: "YWHNFRz_4fgbcP5sHcU6fw",
    place: "Near Växjö, Kronoberg",
    shortName: "Växjö",
    countryCode: "SE",
    country: "Sweden",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","SE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "se-031",
    lat: 59.427848,
    lng: 17.950084,
    panoId: "sSCX-e5S7MMSGqsaxuSCdA",
    place: "Near Sollentuna, Stockholm",
    shortName: "Sollentuna",
    countryCode: "SE",
    country: "Sweden",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","SE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "se-032",
    lat: 56.161469,
    lng: 15.586245,
    panoId: "a-bKfx1YLBA-aVNrNS__xw",
    place: "Near Karlskrona, Blekinge",
    shortName: "Karlskrona",
    countryCode: "SE",
    country: "Sweden",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","SE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "se-033",
    lat: 59.517883,
    lng: 17.91117,
    panoId: "Ub9TvZxYc1TCY7JfP7vIiA",
    place: "Near Upplands Väsby, Stockholm",
    shortName: "Upplands Väsby",
    countryCode: "SE",
    country: "Sweden",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","SE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "se-034",
    lat: 58.347848,
    lng: 11.942472,
    panoId: "6taeUI4LYJY6vsC2HBvySQ",
    place: "Near Uddevalla, Västra Götaland",
    shortName: "Uddevalla",
    countryCode: "SE",
    country: "Sweden",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","SE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "se-035",
    lat: 59.17387,
    lng: 17.635163,
    panoId: "C5gERCPVuAJj7QcjwfwWow",
    place: "Near Pershagen, Stockholm",
    shortName: "Pershagen",
    countryCode: "SE",
    country: "Sweden",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","SE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "se-036",
    lat: 64.751183,
    lng: 20.953167,
    panoId: "Hr7LSXPBNLwrKpY10uylsg",
    place: "Near Skellefteå, Västerbotten",
    shortName: "Skellefteå",
    countryCode: "SE",
    country: "Sweden",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","SE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "se-037",
    lat: 65.591652,
    lng: 22.167741,
    panoId: "WDJxc7YjaGgMT_28PTZF2g",
    place: "Near Luleå, Norrbotten",
    shortName: "Luleå",
    countryCode: "SE",
    country: "Sweden",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","SE"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "se-038",
    lat: 56.029825,
    lng: 14.17568,
    panoId: "Q67GVdqwD0w06INAREjcjg",
    place: "Near Kristianstad, Skåne",
    shortName: "Kristianstad",
    countryCode: "SE",
    country: "Sweden",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","SE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "se-039",
    lat: 55.697572,
    lng: 13.230123,
    panoId: "xua-SkfkC3mw_0G15sDGsg",
    place: "Near Lund, Skåne",
    shortName: "Lund",
    countryCode: "SE",
    country: "Sweden",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","SE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "se-040",
    lat: 59.846115,
    lng: 17.62437,
    panoId: "gD79q7bKsAX4lIU9U3WAWQ",
    place: "Near Flogsta, Uppsala",
    shortName: "Flogsta",
    countryCode: "SE",
    country: "Sweden",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","SE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "se-041",
    lat: 59.351718,
    lng: 16.511444,
    panoId: "sMNrKi_xaqk2T-SPecM-1w",
    place: "Near Eskilstuna, Södermanland",
    shortName: "Eskilstuna",
    countryCode: "SE",
    country: "Sweden",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","SE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "se-042",
    lat: 57.717659,
    lng: 12.902838,
    panoId: "t78uLj63FjpNKxFpIARaUQ",
    place: "Near Borås, Västra Götaland",
    shortName: "Borås",
    countryCode: "SE",
    country: "Sweden",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","SE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "se-043",
    lat: 57.666466,
    lng: 11.9913,
    panoId: "RmZ85sGURCytYDagy4rSyw",
    place: "Near Mölndal, Västra Götaland",
    shortName: "Mölndal",
    countryCode: "SE",
    country: "Sweden",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","SE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "se-044",
    lat: 63.843002,
    lng: 20.269504,
    panoId: "ARpz8AytgJy5PYhaeDwbgw",
    place: "Near Umeå, Västerbotten",
    shortName: "Umeå",
    countryCode: "SE",
    country: "Sweden",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","SE"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "se-045",
    lat: 59.617445,
    lng: 16.516576,
    panoId: "aDqnR8ERePgX3M0iJHwxCw",
    place: "Near Västerås, Västmanland",
    shortName: "Västerås",
    countryCode: "SE",
    country: "Sweden",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","SE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "se-046",
    lat: 56.67164,
    lng: 12.88322,
    panoId: "yKiZVyBq9So0Qn0ZPHca-w",
    place: "Near Halmstad, Halland",
    shortName: "Halmstad",
    countryCode: "SE",
    country: "Sweden",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","SE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "se-047",
    lat: 58.600325,
    lng: 16.160932,
    panoId: "S4oodNzw3cQy1_WwK98rTw",
    place: "Near Norrköping, Östergötland",
    shortName: "Norrköping",
    countryCode: "SE",
    country: "Sweden",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","SE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "se-048",
    lat: 55.614145,
    lng: 13.008674,
    panoId: "nZSLeBM_hgBwNJopwlhhAA",
    place: "Near Malmö, Skåne",
    shortName: "Malmö",
    countryCode: "SE",
    country: "Sweden",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","SE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "se-049",
    lat: 60.685799,
    lng: 17.136427,
    panoId: "-DKOru6z73wJoVFlLE0aNA",
    place: "Near Gävle, Gävleborg",
    shortName: "Gävle",
    countryCode: "SE",
    country: "Sweden",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","SE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "se-050",
    lat: 59.166634,
    lng: 17.689089,
    panoId: "syZvNSaqptexdFX2nu7WBA",
    place: "Near Pershagen, Stockholm",
    shortName: "Pershagen",
    countryCode: "SE",
    country: "Sweden",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","SE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "se-051",
    lat: 59.548054,
    lng: 17.932727,
    panoId: "NFbRcGaIIk3i2DNyM0qVug",
    place: "Near Upplands Väsby, Stockholm",
    shortName: "Upplands Väsby",
    countryCode: "SE",
    country: "Sweden",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","SE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "se-052",
    lat: 56.723955,
    lng: 16.356979,
    panoId: "65IKv0BBKWF5U6gXUOzH2Q",
    place: "Near Lindsdal, Kalmar",
    shortName: "Lindsdal",
    countryCode: "SE",
    country: "Sweden",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","SE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "se-053",
    lat: 65.573177,
    lng: 22.293548,
    panoId: "9z5I7rJ90hFD-2Hoi7wQWQ",
    place: "Near Luleå, Norrbotten",
    shortName: "Luleå",
    countryCode: "SE",
    country: "Sweden",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","SE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "se-054",
    lat: 58.378386,
    lng: 13.972862,
    panoId: "dxnZo7zhCqZPRI40XaIgIQ",
    place: "Near Skövde, Västra Götaland",
    shortName: "Skövde",
    countryCode: "SE",
    country: "Sweden",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","SE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "se-055",
    lat: 57.738347,
    lng: 14.084478,
    panoId: "xwfvDuVdmVREPDhX0ZTD6w",
    place: "Near Odensjö, Jönköping",
    shortName: "Odensjö",
    countryCode: "SE",
    country: "Sweden",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","SE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "se-056",
    lat: 59.510717,
    lng: 17.766866,
    panoId: "8M2vv38Rw0iHuHTSP5nGIw",
    place: "Near Brunna, Stockholm",
    shortName: "Brunna",
    countryCode: "SE",
    country: "Sweden",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","SE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "se-057",
    lat: 56.813934,
    lng: 14.831365,
    panoId: "V4MglSX1X-XteyBSdclemw",
    place: "Near Växjö, Kronoberg",
    shortName: "Växjö",
    countryCode: "SE",
    country: "Sweden",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","SE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "se-058",
    lat: 63.142602,
    lng: 14.52272,
    panoId: "mwyIhmdQlQgCeIRLQZyX5g",
    place: "Near Östersund, Jämtland",
    shortName: "Östersund",
    countryCode: "SE",
    country: "Sweden",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","SE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "se-059",
    lat: 57.7207,
    lng: 12.821107,
    panoId: "Ihrw225v47r_MaagoM6neQ",
    place: "Near Sjömarken, Västra Götaland",
    shortName: "Sjömarken",
    countryCode: "SE",
    country: "Sweden",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","SE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "se-060",
    lat: 58.554914,
    lng: 16.131164,
    panoId: "0FKXp3kuF_Rh1ueLVR0B0A",
    place: "Near Norrköping, Östergötland",
    shortName: "Norrköping",
    countryCode: "SE",
    country: "Sweden",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","SE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "se-061",
    lat: 55.678143,
    lng: 13.143451,
    panoId: "XQc2nd8GLO003WferzA5HQ",
    place: "Near Hjärup, Skåne",
    shortName: "Hjärup",
    countryCode: "SE",
    country: "Sweden",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","SE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "se-062",
    lat: 59.328196,
    lng: 15.276341,
    panoId: "NXAZVy4SnoUvgY5ZVZoxBA",
    place: "Near Hovsta, Örebro",
    shortName: "Hovsta",
    countryCode: "SE",
    country: "Sweden",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","SE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "se-063",
    lat: 60.706373,
    lng: 17.014996,
    panoId: "t1FGCfK-XcHE4S2QM_j7OA",
    place: "Near Valbo, Gävleborg",
    shortName: "Valbo",
    countryCode: "SE",
    country: "Sweden",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","SE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "se-064",
    lat: 56.027758,
    lng: 12.816935,
    panoId: "N-AH3QTfwTX8XcPZQJycwg",
    place: "Near Påarp, Skåne",
    shortName: "Påarp",
    countryCode: "SE",
    country: "Sweden",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","SE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "se-065",
    lat: 64.738099,
    lng: 20.85018,
    panoId: "LQik0NvgRoaiMLwftHaTgw",
    place: "Near Viken, Västerbotten",
    shortName: "Viken",
    countryCode: "SE",
    country: "Sweden",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","SE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "se-066",
    lat: 60.598284,
    lng: 15.53245,
    panoId: "JDaraE90AXA1lc4in6-I3w",
    place: "Near Falun, Dalarna",
    shortName: "Falun",
    countryCode: "SE",
    country: "Sweden",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","SE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "se-067",
    lat: 56.717446,
    lng: 12.925268,
    panoId: "UO1Phwpf6Cub8hhl2OLuxw",
    place: "Near Åled, Halland",
    shortName: "Åled",
    countryCode: "SE",
    country: "Sweden",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","SE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "se-068",
    lat: 58.719014,
    lng: 17.048247,
    panoId: "XQu2gjgLJiLqwM6vPHzsJw",
    place: "Near Arnö, Södermanland",
    shortName: "Arnö",
    countryCode: "SE",
    country: "Sweden",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","SE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "se-069",
    lat: 58.333179,
    lng: 12.00893,
    panoId: "24isPNcKo19NJF6BRmjcgA",
    place: "Near Uddevalla, Västra Götaland",
    shortName: "Uddevalla",
    countryCode: "SE",
    country: "Sweden",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","SE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "se-070",
    lat: 58.461482,
    lng: 15.718278,
    panoId: "NkELiV9Wbs1FtOAa_AL0Wg",
    place: "Near Tallboda, Östergötland",
    shortName: "Tallboda",
    countryCode: "SE",
    country: "Sweden",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","SE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "se-071",
    lat: 57.679304,
    lng: 11.982608,
    panoId: "goAlwAT8jg42rEG6litYRQ",
    place: "Near Gothenburg, Västra Götaland",
    shortName: "Gothenburg",
    countryCode: "SE",
    country: "Sweden",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","SE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "se-072",
    lat: 62.362151,
    lng: 17.369767,
    panoId: "7Dfw6jipSXsMbt4H5apZew",
    place: "Near Stockvik, Västernorrland",
    shortName: "Stockvik",
    countryCode: "SE",
    country: "Sweden",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","SE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "se-073",
    lat: 63.339201,
    lng: 18.641516,
    panoId: "ZcpZNIcJKZ_fL5z1IOR8_Q",
    place: "Near Örnsköldsvik, Västernorrland",
    shortName: "Örnsköldsvik",
    countryCode: "SE",
    country: "Sweden",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","SE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "se-074",
    lat: 65.566829,
    lng: 22.07599,
    panoId: "25v7Pqz3KXBhaOPc6FhPVA",
    place: "Near Bergnäset, Norrbotten",
    shortName: "Bergnäset",
    countryCode: "SE",
    country: "Sweden",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","SE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "se-075",
    lat: 63.155664,
    lng: 14.595667,
    panoId: "6lwTMymbTZper86YsAmx6w",
    place: "Near Östersund, Jämtland",
    shortName: "Östersund",
    countryCode: "SE",
    country: "Sweden",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","SE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "se-076",
    lat: 58.3604,
    lng: 13.779573,
    panoId: "Z4beRoR22moYKqvyJyzLwA",
    place: "Near Skultorp, Västra Götaland",
    shortName: "Skultorp",
    countryCode: "SE",
    country: "Sweden",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","SE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "se-077",
    lat: 57.787709,
    lng: 12.32666,
    panoId: "19wIJqXMoj9jMlcJUIFkdw",
    place: "Near Stenkullen, Västra Götaland",
    shortName: "Stenkullen",
    countryCode: "SE",
    country: "Sweden",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","SE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "se-078",
    lat: 57.9564,
    lng: 12.569103,
    panoId: "xd3cCUs1fTUmz1Im0BtRHw",
    place: "Near Alingsås, Västra Götaland",
    shortName: "Alingsås",
    countryCode: "SE",
    country: "Sweden",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","SE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "se-079",
    lat: 58.600392,
    lng: 14.98655,
    panoId: "wGepkh5CuU9IP8YxPcm37A",
    place: "Near Motala, Östergötland",
    shortName: "Motala",
    countryCode: "SE",
    country: "Sweden",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","SE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "se-080",
    lat: 59.607232,
    lng: 16.643281,
    panoId: "TovWHyP5PNjO6k7kTGryow",
    place: "Near Irsta, Västmanland",
    shortName: "Irsta",
    countryCode: "SE",
    country: "Sweden",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","SE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "se-081",
    lat: 57.738559,
    lng: 14.158601,
    panoId: "fxBsALfrnnl2hLm_w0UVBA",
    place: "Near Odensjö, Jönköping",
    shortName: "Odensjö",
    countryCode: "SE",
    country: "Sweden",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","SE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "se-082",
    lat: 57.872025,
    lng: 12.034035,
    panoId: "ee63czjm6ah9zHbeOd_mEw",
    place: "Near Kungälv, Västra Götaland",
    shortName: "Kungälv",
    countryCode: "SE",
    country: "Sweden",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","SE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "se-083",
    lat: 59.20895,
    lng: 18.027121,
    panoId: "K43tRTe848WMA9gBpixlXA",
    place: "Near Huddinge, Stockholm",
    shortName: "Huddinge",
    countryCode: "SE",
    country: "Sweden",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","SE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "se-084",
    lat: 60.629063,
    lng: 15.683786,
    panoId: "6wkolpKcwTb96EYL3nLHlg",
    place: "Near Falun, Dalarna",
    shortName: "Falun",
    countryCode: "SE",
    country: "Sweden",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","SE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "se-085",
    lat: 60.65404,
    lng: 16.784785,
    panoId: "ZdXdLrufghdl9iQQYJHE5w",
    place: "Near Sandviken, Gävleborg",
    shortName: "Sandviken",
    countryCode: "SE",
    country: "Sweden",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","SE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "se-086",
    lat: 63.836877,
    lng: 20.343938,
    panoId: "D1J4L_FuVmdTVqYyMh5mww",
    place: "Near Umeå, Västerbotten",
    shortName: "Umeå",
    countryCode: "SE",
    country: "Sweden",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","SE"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "se-087",
    lat: 59.307933,
    lng: 17.752061,
    panoId: "b8EHoqlnLO7K2jNrgEGa8Q",
    place: "Near Ekerö, Stockholm",
    shortName: "Ekerö",
    countryCode: "SE",
    country: "Sweden",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","SE"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "se-088",
    lat: 58.311162,
    lng: 12.336356,
    panoId: "BaPmUMlVDtnUfW5G5zcs5g",
    place: "Near Trollhättan, Västra Götaland",
    shortName: "Trollhättan",
    countryCode: "SE",
    country: "Sweden",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","SE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "se-089",
    lat: 59.235008,
    lng: 17.675736,
    panoId: "nv3j1KgDWvH45wv4msDmmw",
    place: "Near Rönninge, Stockholm",
    shortName: "Rönninge",
    countryCode: "SE",
    country: "Sweden",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","SE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "se-090",
    lat: 56.909891,
    lng: 12.566684,
    panoId: "dvpEJfmF9ZXzaB5-4IQxYQ",
    place: "Near Skrea, Halland",
    shortName: "Skrea",
    countryCode: "SE",
    country: "Sweden",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","SE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "se-091",
    lat: 59.270929,
    lng: 14.441221,
    panoId: "SxjqNHGqTMJaeFTN-dG9Tg",
    place: "Near Degerfors, Örebro",
    shortName: "Degerfors",
    countryCode: "SE",
    country: "Sweden",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","SE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "se-092",
    lat: 60.451932,
    lng: 15.427015,
    panoId: "VZivE_vcwz2CqljYB5oxTg",
    place: "Near Borlänge, Dalarna",
    shortName: "Borlänge",
    countryCode: "SE",
    country: "Sweden",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","SE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "se-093",
    lat: 59.019168,
    lng: 16.133236,
    panoId: "ZjchTsqLEZYyRPaJ4t_LjQ",
    place: "Near Katrineholm, Södermanland",
    shortName: "Katrineholm",
    countryCode: "SE",
    country: "Sweden",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","SE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "se-094",
    lat: 58.564565,
    lng: 15.088041,
    panoId: "02jlOqBEcHpoWwArabmbuA",
    place: "Near Motala, Östergötland",
    shortName: "Motala",
    countryCode: "SE",
    country: "Sweden",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","SE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "se-095",
    lat: 59.571593,
    lng: 17.860874,
    panoId: "uzrIZA4LRlfT_uaaaSnFyw",
    place: "Near Rosersberg, Stockholm",
    shortName: "Rosersberg",
    countryCode: "SE",
    country: "Sweden",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","SE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "se-096",
    lat: 56.255267,
    lng: 15.382143,
    panoId: "3DVa2CdtbsUH7lYy_gsdDQ",
    place: "Near Kallinge, Blekinge",
    shortName: "Kallinge",
    countryCode: "SE",
    country: "Sweden",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","SE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "se-097",
    lat: 57.941174,
    lng: 12.801957,
    panoId: "-EgQEj85zTCxAM4wYKVAdQ",
    place: "Near Jonstorp, Västra Götaland",
    shortName: "Jonstorp",
    countryCode: "SE",
    country: "Sweden",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","SE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "se-098",
    lat: 56.979849,
    lng: 12.508964,
    panoId: "ttu6xtAqV_4u9YCEVUNtzg",
    place: "Near Falkenberg, Halland",
    shortName: "Falkenberg",
    countryCode: "SE",
    country: "Sweden",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","SE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "se-099",
    lat: 59.351784,
    lng: 17.739873,
    panoId: "ud59QW4IQkgZWB004bZU4Q",
    place: "Near Stenhamra, Stockholm",
    shortName: "Stenhamra",
    countryCode: "SE",
    country: "Sweden",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","SE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "se-100",
    lat: 58.534536,
    lng: 12.454665,
    panoId: "ikak5LUBx65vX9_Eazzl-A",
    place: "Near Brålanda, Västra Götaland",
    shortName: "Brålanda",
    countryCode: "SE",
    country: "Sweden",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","SE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "se-101",
    lat: 57.789342,
    lng: 18.52553,
    panoId: "CYO1nDuqVjPmkFrDzfEMyw",
    place: "Near Visby, Gotland",
    shortName: "Visby",
    countryCode: "SE",
    country: "Sweden",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","SE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "se-102",
    lat: 58.127821,
    lng: 12.311962,
    panoId: "FOyiabuM2qkAAii1JraN4g",
    place: "Near Göta, Västra Götaland",
    shortName: "Göta",
    countryCode: "SE",
    country: "Sweden",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","SE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "se-103",
    lat: 63.449251,
    lng: 18.639591,
    panoId: "6uRswJ0tWcwJDbSVSkPP1A",
    place: "Near Örnsköldsvik, Västernorrland",
    shortName: "Örnsköldsvik",
    countryCode: "SE",
    country: "Sweden",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","SE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "se-104",
    lat: 65.97409,
    lng: 21.614371,
    panoId: "FNWrkVKao4WmsjlW7_YcPA",
    place: "Near Boden, Norrbotten",
    shortName: "Boden",
    countryCode: "SE",
    country: "Sweden",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","SE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "se-105",
    lat: 57.644104,
    lng: 18.552855,
    panoId: "K0VjY4VFYYbLHfAa_RVLQA",
    place: "Near Visby, Gotland",
    shortName: "Visby",
    countryCode: "SE",
    country: "Sweden",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","SE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "no-000",
    lat: 60.392902,
    lng: 5.324045,
    panoId: "kv0yLdFylUudRxW7JNaTTA",
    place: "Near Bergen, Vestland",
    shortName: "Bergen",
    countryCode: "NO",
    country: "Norway",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","NO"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "no-001",
    lat: 59.218406,
    lng: 10.929542,
    panoId: "7zpmlbb2kvMoNFsbtdnLbw",
    place: "Near Fredrikstad, Østfold",
    shortName: "Fredrikstad",
    countryCode: "NO",
    country: "Norway",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","NO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "no-002",
    lat: 63.746289,
    lng: 11.299297,
    panoId: "VNFVjVKIx6yzyrwQ37ktSw",
    place: "Near Levanger, Trøndelag",
    shortName: "Levanger",
    countryCode: "NO",
    country: "Norway",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","NO"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "no-003",
    lat: 61.115128,
    lng: 10.466171,
    panoId: "MvgmGnFMsIf_FHl6lfjVhQ",
    place: "Near Lillehammer, Innlandet",
    shortName: "Lillehammer",
    countryCode: "NO",
    country: "Norway",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","NO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "no-004",
    lat: 58.461599,
    lng: 8.77247,
    panoId: "-1FrJyk3Ia43_37mMkkdOQ",
    place: "Near Arendal, Agder",
    shortName: "Arendal",
    countryCode: "NO",
    country: "Norway",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","NO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "no-005",
    lat: 59.05342,
    lng: 10.035291,
    panoId: "My4546LYC8vaHrZp5nO-tg",
    place: "Near Larvik, Vestfold",
    shortName: "Larvik",
    countryCode: "NO",
    country: "Norway",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","NO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "no-006",
    lat: 59.955988,
    lng: 11.048821,
    panoId: "mFguZHh6ysNRXzYacJxZ9A",
    place: "Near Lillestrøm, Akershus",
    shortName: "Lillestrøm",
    countryCode: "NO",
    country: "Norway",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","NO"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "no-007",
    lat: 59.912732,
    lng: 10.746118,
    panoId: "UNmuPcLeYj5TGATyG5DH_w",
    place: "Near Oslo, Oslo",
    shortName: "Oslo",
    countryCode: "NO",
    country: "Norway",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","NO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "no-008",
    lat: 59.434064,
    lng: 10.657742,
    panoId: "5oyumhiAUYPI0jNlMZXF4w",
    place: "Near Moss, Østfold",
    shortName: "Moss",
    countryCode: "NO",
    country: "Norway",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","NO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "no-009",
    lat: 59.267542,
    lng: 10.407601,
    panoId: "AJq4x7VRvi1d88M47ahEeA",
    place: "Near Tønsberg, Vestfold",
    shortName: "Tønsberg",
    countryCode: "NO",
    country: "Norway",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","NO"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "no-010",
    lat: 59.744093,
    lng: 10.204579,
    panoId: "sQOCtS5Put5OqKLmzioSsw",
    place: "Near Drammen, Buskerud",
    shortName: "Drammen",
    countryCode: "NO",
    country: "Norway",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","NO"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "no-011",
    lat: 59.12469,
    lng: 11.387628,
    panoId: "RFDRi4doMh4DV3ghL1RUZA",
    place: "Near Halden, Østfold",
    shortName: "Halden",
    countryCode: "NO",
    country: "Norway",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","NO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "no-012",
    lat: 62.472234,
    lng: 6.154895,
    panoId: "rzQ_AvVA6mZPkyhtsXibnw",
    place: "Near Ålesund, Møre og Romsdal",
    shortName: "Ålesund",
    countryCode: "NO",
    country: "Norway",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","NO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "no-013",
    lat: 67.282695,
    lng: 14.375068,
    panoId: "LEvk6RvC8SSIRaSKNdumaw",
    place: "Near Bodø, Nordland",
    shortName: "Bodø",
    countryCode: "NO",
    country: "Norway",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","NO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "no-014",
    lat: 58.969989,
    lng: 5.733248,
    panoId: "L70-BFcHFv9x6Be7Fa4ytw",
    place: "Near Stavanger, Rogaland",
    shortName: "Stavanger",
    countryCode: "NO",
    country: "Norway",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","NO"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "no-015",
    lat: 59.131186,
    lng: 10.216703,
    panoId: "FbLPhGvaFtFn7nlKPTU1yA",
    place: "Near Sandefjord, Vestfold",
    shortName: "Sandefjord",
    countryCode: "NO",
    country: "Norway",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","NO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "no-016",
    lat: 69.650453,
    lng: 19.017367,
    panoId: "x91UssgNAFrdCTMk6p7wQA",
    place: "Near Tromsdalen, Troms",
    shortName: "Tromsdalen",
    countryCode: "NO",
    country: "Norway",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","NO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "no-017",
    lat: 68.798297,
    lng: 16.54159,
    panoId: "V3PpzaAwciTr8FDmNRW3Dw",
    place: "Near Harstad, Troms",
    shortName: "Harstad",
    countryCode: "NO",
    country: "Norway",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","NO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "no-018",
    lat: 59.140711,
    lng: 9.655637,
    panoId: "l0Hp_o4W3PmJfzlU-TUWIA",
    place: "Near Porsgrunn, Telemark",
    shortName: "Porsgrunn",
    countryCode: "NO",
    country: "Norway",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","NO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "no-019",
    lat: 69.648892,
    lng: 18.955075,
    panoId: "qjFTyjSJoQADdJEnGWJ6nQ",
    place: "Near Tromsø, Troms",
    shortName: "Tromsø",
    countryCode: "NO",
    country: "Norway",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","NO"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "no-020",
    lat: 58.732999,
    lng: 5.699864,
    panoId: "-0XFy0YXajq3abe_XoPjTg",
    place: "Near Time, Rogaland",
    shortName: "Time",
    countryCode: "NO",
    country: "Norway",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","NO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "no-021",
    lat: 59.283917,
    lng: 11.109643,
    panoId: "5glOkhePAtwtAQDEy6lTrg",
    place: "Near Sarpsborg, Østfold",
    shortName: "Sarpsborg",
    countryCode: "NO",
    country: "Norway",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","NO"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "no-022",
    lat: 58.147012,
    lng: 7.99513,
    panoId: "KBykiIeife-QlCDYW2PYxg",
    place: "Near Kristiansand, Agder",
    shortName: "Kristiansand",
    countryCode: "NO",
    country: "Norway",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","NO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "no-023",
    lat: 58.852461,
    lng: 5.735189,
    panoId: "790bvUqi7myoRMeKGMSG_Q",
    place: "Near Sandnes, Rogaland",
    shortName: "Sandnes",
    countryCode: "NO",
    country: "Norway",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","NO"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "no-024",
    lat: 59.417239,
    lng: 10.483407,
    panoId: "tNJ3pecf2f2S0lfgRs2uqA",
    place: "Near Horten, Vestfold",
    shortName: "Horten",
    countryCode: "NO",
    country: "Norway",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","NO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "no-025",
    lat: 60.794481,
    lng: 11.067986,
    panoId: "lJgeNwNS5clRpxfLTysR7w",
    place: "Near Hamar, Innlandet",
    shortName: "Hamar",
    countryCode: "NO",
    country: "Norway",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","NO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "no-026",
    lat: 59.833348,
    lng: 10.4367,
    panoId: "huz5uo4glVq2jiW4I4adMw",
    place: "Near Asker, Akershus",
    shortName: "Asker",
    countryCode: "NO",
    country: "Norway",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","NO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "no-027",
    lat: 59.413906,
    lng: 5.268389,
    panoId: "S6gEkepyG6hqVgv3hn_LCg",
    place: "Near Haugesund, Rogaland",
    shortName: "Haugesund",
    countryCode: "NO",
    country: "Norway",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","NO"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "no-028",
    lat: 62.737511,
    lng: 7.159167,
    panoId: "THbCUtyDUZIdEnFWfKJ0iQ",
    place: "Near Molde, Møre og Romsdal",
    shortName: "Molde",
    countryCode: "NO",
    country: "Norway",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","NO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "no-029",
    lat: 66.31296,
    lng: 14.14283,
    panoId: "LtUv27RfF5SQMrvfwwiY2Q",
    place: "Near Mo i Rana, Nordland",
    shortName: "Mo i Rana",
    countryCode: "NO",
    country: "Norway",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","NO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "no-030",
    lat: 58.888586,
    lng: 5.652822,
    panoId: "B1SRW-iGQolcqUD_q3xmfA",
    place: "Near Sola, Rogaland",
    shortName: "Sola",
    countryCode: "NO",
    country: "Norway",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","NO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "no-031",
    lat: 58.340484,
    lng: 8.593558,
    panoId: "cbM5thhD3giTnBx9_ipCYg",
    place: "Near Grimstad, Agder",
    shortName: "Grimstad",
    countryCode: "NO",
    country: "Norway",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","NO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "no-032",
    lat: 63.110464,
    lng: 7.727937,
    panoId: "s8KOvvEA5wOgxw_srCPcMg",
    place: "Near Kristiansund, Møre og Romsdal",
    shortName: "Kristiansund",
    countryCode: "NO",
    country: "Norway",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","NO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "no-033",
    lat: 60.318195,
    lng: 5.352681,
    panoId: "JE0H5krrDPP-KTudAKZi8A",
    place: "Near Nesttun, Vestland",
    shortName: "Nesttun",
    countryCode: "NO",
    country: "Norway",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","NO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "no-034",
    lat: 59.668618,
    lng: 9.650142,
    panoId: "0MiywbMD_GablHQBTjzn2g",
    place: "Near Kongsberg, Buskerud",
    shortName: "Kongsberg",
    countryCode: "NO",
    country: "Norway",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","NO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "no-035",
    lat: 60.795747,
    lng: 10.691587,
    panoId: "Gx2wndZ1GQHuayqIkfgPFA",
    place: "Near Gjøvik, Innlandet",
    shortName: "Gjøvik",
    countryCode: "NO",
    country: "Norway",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","NO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "no-036",
    lat: 63.740582,
    lng: 11.34641,
    panoId: "8nmiD12cRYY7NVV6ZQtJoA",
    place: "Near Levanger, Trøndelag",
    shortName: "Levanger",
    countryCode: "NO",
    country: "Norway",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","NO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "no-037",
    lat: 59.036752,
    lng: 10.060354,
    panoId: "3NxwUyAK994kjb_4APhp3A",
    place: "Near Larvik, Vestfold",
    shortName: "Larvik",
    countryCode: "NO",
    country: "Norway",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","NO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "no-038",
    lat: 59.441421,
    lng: 10.62945,
    panoId: "yGQ1lhIwdIMEm4RjHec-GQ",
    place: "Near Moss, Østfold",
    shortName: "Moss",
    countryCode: "NO",
    country: "Norway",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","NO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "no-039",
    lat: 68.78349,
    lng: 16.567744,
    panoId: "UGaGttHrMeAc_3FpQNUWnw",
    place: "Near Harstad, Troms",
    shortName: "Harstad",
    countryCode: "NO",
    country: "Norway",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","NO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "no-040",
    lat: 59.145785,
    lng: 10.189979,
    panoId: "SOqBnW3H8uGAxiF8i75rSA",
    place: "Near Sandefjord, Vestfold",
    shortName: "Sandefjord",
    countryCode: "NO",
    country: "Norway",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","NO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "no-041",
    lat: 67.274982,
    lng: 14.40746,
    panoId: "Yz3vC6b7Qoqe-DqImcR7KA",
    place: "Near Bodø, Nordland",
    shortName: "Bodø",
    countryCode: "NO",
    country: "Norway",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","NO"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "no-042",
    lat: 62.469372,
    lng: 6.135095,
    panoId: "-5_6ApNdsDK7R8WDqWgsvg",
    place: "Near Ålesund, Møre og Romsdal",
    shortName: "Ålesund",
    countryCode: "NO",
    country: "Norway",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","NO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "no-043",
    lat: 58.720248,
    lng: 5.688118,
    panoId: "fiq25WLhFvUq77vgwCqFiQ",
    place: "Near Time, Rogaland",
    shortName: "Time",
    countryCode: "NO",
    country: "Norway",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","NO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "no-044",
    lat: 58.141148,
    lng: 7.979727,
    panoId: "dDpIAormnDo-opjIbAd1Wg",
    place: "Near Kristiansand, Agder",
    shortName: "Kristiansand",
    countryCode: "NO",
    country: "Norway",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","NO"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "no-045",
    lat: 63.433354,
    lng: 10.364673,
    panoId: "YnVtPLPTA5NCySiT2tGl2w",
    place: "Near Trondheim, Trøndelag",
    shortName: "Trondheim",
    countryCode: "NO",
    country: "Norway",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","NO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "no-046",
    lat: 59.264412,
    lng: 11.118913,
    panoId: "G_i5EApjwWNmpROe6uE0QQ",
    place: "Near Sarpsborg, Østfold",
    shortName: "Sarpsborg",
    countryCode: "NO",
    country: "Norway",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","NO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "no-047",
    lat: 59.213149,
    lng: 10.89307,
    panoId: "b2xlgEXyD-9ksYNXDVnh5w",
    place: "Near Fredrikstad, Østfold",
    shortName: "Fredrikstad",
    countryCode: "NO",
    country: "Norway",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","NO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "no-048",
    lat: 58.339791,
    lng: 8.562277,
    panoId: "tUxgGACtUlSkGUeNlbII-w",
    place: "Near Grimstad, Agder",
    shortName: "Grimstad",
    countryCode: "NO",
    country: "Norway",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","NO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "no-049",
    lat: 60.379555,
    lng: 5.345899,
    panoId: "5xVIyzNJkxTEBwQrY_wuKw",
    place: "Near Bergen, Vestland",
    shortName: "Bergen",
    countryCode: "NO",
    country: "Norway",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","NO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "no-050",
    lat: 59.393523,
    lng: 5.393416,
    panoId: "29e6dkDbkrr-oCQrUVO8Gw",
    place: "Near Eike, Rogaland",
    shortName: "Eike",
    countryCode: "NO",
    country: "Norway",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","NO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "no-051",
    lat: 58.846631,
    lng: 5.797207,
    panoId: "vRp3PcE8a3R1SAiyYHJ38A",
    place: "Near Sandnes, Rogaland",
    shortName: "Sandnes",
    countryCode: "NO",
    country: "Norway",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","NO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "no-052",
    lat: 59.942295,
    lng: 10.82969,
    panoId: "m7_z1NmxXF4ZllCbFi8JnA",
    place: "Near Frydenberg, Oslo",
    shortName: "Frydenberg",
    countryCode: "NO",
    country: "Norway",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","NO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "no-053",
    lat: 58.468383,
    lng: 8.661161,
    panoId: "hL5TfYuRpUWEBSCV4KCAxA",
    place: "Near Blakstad, Agder",
    shortName: "Blakstad",
    countryCode: "NO",
    country: "Norway",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","NO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "no-054",
    lat: 60.79211,
    lng: 11.196863,
    panoId: "Pu1PWKkl337SFHorPjcbfw",
    place: "Near Hamar, Innlandet",
    shortName: "Hamar",
    countryCode: "NO",
    country: "Norway",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","NO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "no-055",
    lat: 59.223728,
    lng: 10.360824,
    panoId: "xKUdtRVHlpF9u_ACHFdCLQ",
    place: "Near Melsomvik, Vestfold",
    shortName: "Melsomvik",
    countryCode: "NO",
    country: "Norway",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","NO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "no-056",
    lat: 59.092177,
    lng: 10.167201,
    panoId: "XloNSL-SG7N282MvSJiBuA",
    place: "Near Sandefjord, Vestfold",
    shortName: "Sandefjord",
    countryCode: "NO",
    country: "Norway",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","NO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "no-057",
    lat: 59.027571,
    lng: 10.091841,
    panoId: "R-D4Caj16go45IGeQld1Fg",
    place: "Near Larvik, Vestfold",
    shortName: "Larvik",
    countryCode: "NO",
    country: "Norway",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","NO"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "no-058",
    lat: 66.315607,
    lng: 14.234288,
    panoId: "ZBC5qW4OB-Nn7Dr1V_OAWg",
    place: "Near Mo i Rana, Nordland",
    shortName: "Mo i Rana",
    countryCode: "NO",
    country: "Norway",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","NO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "no-059",
    lat: 59.46464,
    lng: 5.291537,
    panoId: "cQu27ayaJEa_0fg39GAOLQ",
    place: "Near Haugesund, Rogaland",
    shortName: "Haugesund",
    countryCode: "NO",
    country: "Norway",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","NO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "no-060",
    lat: 63.412365,
    lng: 10.3453,
    panoId: "GAuUkPP_JLJfJb3IPtOw2g",
    place: "Near Trondheim, Trøndelag",
    shortName: "Trondheim",
    countryCode: "NO",
    country: "Norway",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","NO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "no-061",
    lat: 60.860723,
    lng: 10.675612,
    panoId: "Nlt9_7lAa5x9lRF73hXbqQ",
    place: "Near Gjøvik, Innlandet",
    shortName: "Gjøvik",
    countryCode: "NO",
    country: "Norway",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","NO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "no-062",
    lat: 59.650702,
    lng: 9.577155,
    panoId: "19qJrpKteLPIBd5wyJ8nCA",
    place: "Near Kongsberg, Buskerud",
    shortName: "Kongsberg",
    countryCode: "NO",
    country: "Norway",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","NO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "no-063",
    lat: 58.210624,
    lng: 8.006498,
    panoId: "gGO7iEHdcXPoM4de4jDV9w",
    place: "Near Justvik, Agder",
    shortName: "Justvik",
    countryCode: "NO",
    country: "Norway",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","NO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "no-064",
    lat: 63.80201,
    lng: 11.215756,
    panoId: "cG9a82Cd6FtEEJX6H5e-9g",
    place: "Near Levanger, Trøndelag",
    shortName: "Levanger",
    countryCode: "NO",
    country: "Norway",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","NO"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "no-065",
    lat: 58.322135,
    lng: 8.547509,
    panoId: "s55udKG64kIAzmS-i0zaQg",
    place: "Near Grimstad, Agder",
    shortName: "Grimstad",
    countryCode: "NO",
    country: "Norway",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","NO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "no-066",
    lat: 59.197528,
    lng: 10.884309,
    panoId: "Buj44wtMA52j8aEA3J3bOw",
    place: "Near Fredrikstad, Østfold",
    shortName: "Fredrikstad",
    countryCode: "NO",
    country: "Norway",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","NO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "no-067",
    lat: 59.41797,
    lng: 10.419464,
    panoId: "QQOop1L-nk1k10NNZ44_wA",
    place: "Near Skoppum, Vestfold",
    shortName: "Skoppum",
    countryCode: "NO",
    country: "Norway",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","NO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "no-068",
    lat: 59.683654,
    lng: 10.265755,
    panoId: "xQW2n0RFIWVw1ZTOpcOItA",
    place: "Near Skoger, Buskerud",
    shortName: "Skoger",
    countryCode: "NO",
    country: "Norway",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","NO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "no-069",
    lat: 59.085188,
    lng: 11.44237,
    panoId: "-GqXKVX7WSFENSfw_obKuQ",
    place: "Near Halden, Østfold",
    shortName: "Halden",
    countryCode: "NO",
    country: "Norway",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","NO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "no-070",
    lat: 60.350476,
    lng: 5.360042,
    panoId: "rohZQLxfvKTiHBSGLZZ2kw",
    place: "Near Nesttun, Vestland",
    shortName: "Nesttun",
    countryCode: "NO",
    country: "Norway",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","NO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "no-071",
    lat: 60.026372,
    lng: 11.027667,
    panoId: "Ey4_h4mCONham-3k0FULww",
    place: "Near Frogner, Akershus",
    shortName: "Frogner",
    countryCode: "NO",
    country: "Norway",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","NO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "no-072",
    lat: 59.946072,
    lng: 10.682168,
    panoId: "ztWvxdbrT7wNuvWigEZ3MQ",
    place: "Near Sjølyststranda, Oslo",
    shortName: "Sjølyststranda",
    countryCode: "NO",
    country: "Norway",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","NO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "no-073",
    lat: 61.084002,
    lng: 10.495196,
    panoId: "fzeLRS_5-pNpzR3qWfznQQ",
    place: "Near Lillehammer, Innlandet",
    shortName: "Lillehammer",
    countryCode: "NO",
    country: "Norway",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","NO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "no-074",
    lat: 67.281475,
    lng: 14.462048,
    panoId: "9meGK_fATrZShQ5x0y2lRg",
    place: "Near Løpsmarka, Nordland",
    shortName: "Løpsmarka",
    countryCode: "NO",
    country: "Norway",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","NO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "no-075",
    lat: 62.802681,
    lng: 7.192466,
    panoId: "iwuzxSZ79jXMR8omftnh1A",
    place: "Near Elnesvågen, Møre og Romsdal",
    shortName: "Elnesvågen",
    countryCode: "NO",
    country: "Norway",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","NO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "no-076",
    lat: 60.117548,
    lng: 10.232299,
    panoId: "sk3KAUJlKWXn2xuptkFprg",
    place: "Near Vik, Buskerud",
    shortName: "Vik",
    countryCode: "NO",
    country: "Norway",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","NO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "no-077",
    lat: 59.786309,
    lng: 5.409993,
    panoId: "By9aWX_oAmNBXuuXEYTy0w",
    place: "Near Sagvåg, Vestland",
    shortName: "Sagvåg",
    countryCode: "NO",
    country: "Norway",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","NO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "no-078",
    lat: 59.616224,
    lng: 11.259046,
    panoId: "anJNd3FEHKp1J6Nx6lr1ww",
    place: "Near Skjønhaug, Østfold",
    shortName: "Skjønhaug",
    countryCode: "NO",
    country: "Norway",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","NO"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "no-079",
    lat: 58.819021,
    lng: 5.687921,
    panoId: "tXwRoi0gDAjtOxMBOW51Ag",
    place: "Near Orstad, Rogaland",
    shortName: "Orstad",
    countryCode: "NO",
    country: "Norway",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","NO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "no-080",
    lat: 60.874824,
    lng: 11.681711,
    panoId: "zlsVAMU_LtPvFT1B2UlFmA",
    place: "Near Elverum, Innlandet",
    shortName: "Elverum",
    countryCode: "NO",
    country: "Norway",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","NO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "no-081",
    lat: 62.501342,
    lng: 6.224029,
    panoId: "fcPmo4BS62Gd6YhDN5CVkQ",
    place: "Near Valderøy, Møre og Romsdal",
    shortName: "Valderøy",
    countryCode: "NO",
    country: "Norway",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","NO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "no-082",
    lat: 58.828484,
    lng: 5.631486,
    panoId: "P3pICwfSCpNRL70GvE59vg",
    place: "Near Kleppe, Rogaland",
    shortName: "Kleppe",
    countryCode: "NO",
    country: "Norway",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","NO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "no-083",
    lat: 63.508601,
    lng: 11.020231,
    panoId: "H_RetoIN6fJjjxWPAmEoHw",
    place: "Near Stjørdalshalsen, Trøndelag",
    shortName: "Stjørdalshalsen",
    countryCode: "NO",
    country: "Norway",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","NO"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "no-084",
    lat: 69.932716,
    lng: 23.283503,
    panoId: "kCExGHRhM-CXZePVlkjURg",
    place: "Near Alta, Finnmark",
    shortName: "Alta",
    countryCode: "NO",
    country: "Norway",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","NO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "no-085",
    lat: 59.747585,
    lng: 10.344435,
    panoId: "mmsts-wcIbujTUm0Px6t-g",
    place: "Near Røyken, Akershus",
    shortName: "Røyken",
    countryCode: "NO",
    country: "Norway",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","NO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "no-086",
    lat: 58.310281,
    lng: 7.965651,
    panoId: "bgPp50G2rkuI6oGhlj7wjA",
    place: "Near Vennesla, Agder",
    shortName: "Vennesla",
    countryCode: "NO",
    country: "Norway",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","NO"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "no-087",
    lat: 66.346175,
    lng: 14.148303,
    panoId: "ku_TmI6CsOQZssFeHIBQrQ",
    place: "Near Mo i Rana, Nordland",
    shortName: "Mo i Rana",
    countryCode: "NO",
    country: "Norway",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","NO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "no-088",
    lat: 59.629526,
    lng: 9.718922,
    panoId: "SMhlMVPFgXZqYGsvWbpzpQ",
    place: "Near Kongsberg, Buskerud",
    shortName: "Kongsberg",
    countryCode: "NO",
    country: "Norway",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","NO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "no-089",
    lat: 59.309733,
    lng: 11.079355,
    panoId: "2kwkDM7o1NUPpN43MMwHkQ",
    place: "Near Sarpsborg, Østfold",
    shortName: "Sarpsborg",
    countryCode: "NO",
    country: "Norway",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","NO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "no-090",
    lat: 60.169978,
    lng: 12.067294,
    panoId: "9auFjcOiHHmmAOqvYSSF4w",
    place: "Near Kongsvinger, Innlandet",
    shortName: "Kongsvinger",
    countryCode: "NO",
    country: "Norway",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","NO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "no-091",
    lat: 59.017731,
    lng: 5.765153,
    panoId: "ei9yS73LKyHH-mfQRx_7Tw",
    place: "Near Stavanger, Rogaland",
    shortName: "Stavanger",
    countryCode: "NO",
    country: "Norway",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","NO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "no-092",
    lat: 58.502875,
    lng: 8.759983,
    panoId: "UivCbk4EOf45Z1BC2Su26g",
    place: "Near Arendal, Agder",
    shortName: "Arendal",
    countryCode: "NO",
    country: "Norway",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","NO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "no-093",
    lat: 63.417361,
    lng: 10.26053,
    panoId: "6YDgEHu-pQ0voa3AdzUHUg",
    place: "Near Trondheim, Trøndelag",
    shortName: "Trondheim",
    countryCode: "NO",
    country: "Norway",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","NO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "no-094",
    lat: 58.455464,
    lng: 5.899125,
    panoId: "se0GxtrHaRegyZGXhMy8sA",
    place: "Near Egersund, Rogaland",
    shortName: "Egersund",
    countryCode: "NO",
    country: "Norway",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","NO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "no-095",
    lat: 60.113903,
    lng: 10.283517,
    panoId: "FJwzUFsHCvPqsCdg5o3KSw",
    place: "Near Vik, Buskerud",
    shortName: "Vik",
    countryCode: "NO",
    country: "Norway",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","NO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "no-096",
    lat: 68.39273,
    lng: 17.533901,
    panoId: "hwXfq2P-Lc0Fu8dvwdsJjA",
    place: "Near Narvik, Nordland",
    shortName: "Narvik",
    countryCode: "NO",
    country: "Norway",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","NO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "no-097",
    lat: 59.434348,
    lng: 10.60022,
    panoId: "dQkNpiDfX6appmCl6cED2A",
    place: "Near Moss, Østfold",
    shortName: "Moss",
    countryCode: "NO",
    country: "Norway",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","NO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "no-098",
    lat: 59.276168,
    lng: 10.305424,
    panoId: "OyhyBavnGZu89wcOoEQXkA",
    place: "Near Sem, Vestfold",
    shortName: "Sem",
    countryCode: "NO",
    country: "Norway",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","NO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "no-099",
    lat: 59.183375,
    lng: 11.359564,
    panoId: "Dc8wMQUF7qyGROoakt-fvA",
    place: "Near Halden, Østfold",
    shortName: "Halden",
    countryCode: "NO",
    country: "Norway",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","NO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "no-100",
    lat: 59.981528,
    lng: 10.249276,
    panoId: "lF3koAwe10_eS1y6asrIUg",
    place: "Near Vik, Buskerud",
    shortName: "Vik",
    countryCode: "NO",
    country: "Norway",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","NO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "no-101",
    lat: 59.216638,
    lng: 6.125869,
    panoId: "RM2aJU2hd3JnI1xb-9yL0A",
    place: "Near Hjelmelandsvågen, Rogaland",
    shortName: "Hjelmelandsvågen",
    countryCode: "NO",
    country: "Norway",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","NO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "no-102",
    lat: 61.440468,
    lng: 5.57412,
    panoId: "RhZ2fXFayYXQT5V3ryw1-w",
    place: "Near Naustdal, Vestland",
    shortName: "Naustdal",
    countryCode: "NO",
    country: "Norway",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","NO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "no-103",
    lat: 58.019593,
    lng: 7.109856,
    panoId: "jwq2wVBGhLoCMs6iGHDtjQ",
    place: "Near Lyngdal, Agder",
    shortName: "Lyngdal",
    countryCode: "NO",
    country: "Norway",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","NO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "no-104",
    lat: 59.353371,
    lng: 5.661592,
    panoId: "7fbKHBqqyt0M9I6CLCUktA",
    place: "Near Tysvær, Rogaland",
    shortName: "Tysvær",
    countryCode: "NO",
    country: "Norway",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","NO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "no-105",
    lat: 60.189059,
    lng: 10.900674,
    panoId: "btljudfluGqH1Gn755Rt8Q",
    place: "Near Teigebyen, Akershus",
    shortName: "Teigebyen",
    countryCode: "NO",
    country: "Norway",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","NO"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "no-106",
    lat: 60.31845,
    lng: 12.27268,
    panoId: "kLnQYStlX-EAab99gH8XQw",
    place: "Near Kirkenær, Innlandet",
    shortName: "Kirkenær",
    countryCode: "NO",
    country: "Norway",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","NO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "no-107",
    lat: 59.786223,
    lng: 5.851371,
    panoId: "_EAFQS5RhNZ7ef_1qsxgKg",
    place: "Near Etne, Vestland",
    shortName: "Etne",
    countryCode: "NO",
    country: "Norway",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","NO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "no-108",
    lat: 63.232375,
    lng: 9.596467,
    panoId: "zPH6k2nNucMsVbjXEp-bmg",
    place: "Near Orkanger, Trøndelag",
    shortName: "Orkanger",
    countryCode: "NO",
    country: "Norway",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","NO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "no-109",
    lat: 60.9567,
    lng: 11.809202,
    panoId: "nReCK4FMIxwiSGYir1A4pQ",
    place: "Near Elverum, Innlandet",
    shortName: "Elverum",
    countryCode: "NO",
    country: "Norway",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","NO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "dk-000",
    lat: 55.470493,
    lng: 8.451902,
    panoId: "T39VsceaYVoRU1ZWI0xcOA",
    place: "Near Esbjerg, South Denmark",
    shortName: "Esbjerg",
    countryCode: "DK",
    country: "Denmark",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","DK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "dk-001",
    lat: 55.650036,
    lng: 12.301522,
    panoId: "YnL4uOr2gmCG5_vNWCGBMw",
    place: "Near Taastrup, Capital Region",
    shortName: "Taastrup",
    countryCode: "DK",
    country: "Denmark",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","DK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "dk-002",
    lat: 57.464122,
    lng: 9.98247,
    panoId: "NEP6DXFGj9XKAEEV3nY9PA",
    place: "Near Hjørring, North Denmark",
    shortName: "Hjørring",
    countryCode: "DK",
    country: "Denmark",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","DK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "dk-003",
    lat: 55.709293,
    lng: 9.535758,
    panoId: "k-XcB8HghryJCpP1pdtVug",
    place: "Near Vejle, South Denmark",
    shortName: "Vejle",
    countryCode: "DK",
    country: "Denmark",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","DK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "dk-004",
    lat: 55.641475,
    lng: 12.080427,
    panoId: "jL_NFfPeVka_nVLqEOS79A",
    place: "Near Roskilde, Zealand",
    shortName: "Roskilde",
    countryCode: "DK",
    country: "Denmark",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","DK"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "dk-005",
    lat: 56.453195,
    lng: 9.401954,
    panoId: "qeMzqPJIyD3R__EXHOBFnw",
    place: "Near Viborg, Central Jutland",
    shortName: "Viborg",
    countryCode: "DK",
    country: "Denmark",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","DK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "dk-006",
    lat: 55.860666,
    lng: 9.850337,
    panoId: "N-ABfLzqR0ev3ialwmcp9w",
    place: "Near Horsens, Central Jutland",
    shortName: "Horsens",
    countryCode: "DK",
    country: "Denmark",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","DK"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "dk-007",
    lat: 56.169789,
    lng: 9.544992,
    panoId: "ptr7nRxqQbwKTINkbMuE4Q",
    place: "Near Silkeborg, Central Jutland",
    shortName: "Silkeborg",
    countryCode: "DK",
    country: "Denmark",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","DK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "dk-008",
    lat: 55.229965,
    lng: 11.760884,
    panoId: "PtrppJm4Z82lgAhJIFfVxg",
    place: "Near Næstved, Zealand",
    shortName: "Næstved",
    countryCode: "DK",
    country: "Denmark",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","DK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "dk-009",
    lat: 55.675928,
    lng: 12.565456,
    panoId: "VNV_hHBJcTUQs2s-QyCOIQ",
    place: "Near Copenhagen, Capital Region",
    shortName: "Copenhagen",
    countryCode: "DK",
    country: "Denmark",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","DK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "dk-010",
    lat: 55.731668,
    lng: 12.363345,
    panoId: "qKcK6aAt6Y-FLNGuk6vHMg",
    place: "Near Ballerup, Capital Region",
    shortName: "Ballerup",
    countryCode: "DK",
    country: "Denmark",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","DK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "dk-011",
    lat: 55.196709,
    lng: 11.59634,
    panoId: "Ht0AnAc4rHzvok3jNM2U4g",
    place: "Near Klinteby Frihed, Zealand",
    shortName: "Klinteby Frihed",
    countryCode: "DK",
    country: "Denmark",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","DK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "dk-012",
    lat: 55.752415,
    lng: 12.574589,
    panoId: "N0zlzIzZWfhLXqKhBiALAA",
    place: "Near Charlottenlund, Capital Region",
    shortName: "Charlottenlund",
    countryCode: "DK",
    country: "Denmark",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","DK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "dk-013",
    lat: 55.880994,
    lng: 12.501332,
    panoId: "V-MB_3QMQ3m7VvUFyCV3ew",
    place: "Near Hørsholm, Capital Region",
    shortName: "Hørsholm",
    countryCode: "DK",
    country: "Denmark",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","DK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "dk-014",
    lat: 57.058798,
    lng: 9.922831,
    panoId: "RekuVF2EmVWxjGS6IHMyGg",
    place: "Near Nørresundby, North Denmark",
    shortName: "Nørresundby",
    countryCode: "DK",
    country: "Denmark",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","DK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "dk-015",
    lat: 56.156552,
    lng: 10.2107,
    panoId: "3whHnKVaOT5vTtZhXR50dQ",
    place: "Near Århus, Central Jutland",
    shortName: "Århus",
    countryCode: "DK",
    country: "Denmark",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","DK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "dk-016",
    lat: 56.036092,
    lng: 12.613593,
    panoId: "jKA_djGE0T1Gdrs97hKzbQ",
    place: "Near Helsingør, Capital Region",
    shortName: "Helsingør",
    countryCode: "DK",
    country: "Denmark",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","DK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "dk-017",
    lat: 55.402796,
    lng: 11.354508,
    panoId: "PSYH7oleT_eedTEWMWiIHg",
    place: "Near Slagelse, Zealand",
    shortName: "Slagelse",
    countryCode: "DK",
    country: "Denmark",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","DK"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "dk-018",
    lat: 56.122723,
    lng: 10.151293,
    panoId: "T63eQJO5zXMN2fJuOwg0og",
    place: "Near Viby, Central Jutland",
    shortName: "Viby",
    countryCode: "DK",
    country: "Denmark",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","DK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "dk-019",
    lat: 55.680589,
    lng: 12.45368,
    panoId: "SMZjVY-V8PMwOUza87G03Q",
    place: "Near Rødovre, Capital Region",
    shortName: "Rødovre",
    countryCode: "DK",
    country: "Denmark",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","DK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "dk-020",
    lat: 56.136162,
    lng: 8.976661,
    panoId: "Rgu0ekxTp5-8pHhNIjXWmQ",
    place: "Near Herning, Central Jutland",
    shortName: "Herning",
    countryCode: "DK",
    country: "Denmark",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","DK"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "dk-021",
    lat: 55.583618,
    lng: 12.3001,
    panoId: "46fluPAtPbivADvVwIlMIQ",
    place: "Near Greve, Zealand",
    shortName: "Greve",
    countryCode: "DK",
    country: "Denmark",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","DK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "dk-022",
    lat: 55.717527,
    lng: 11.712793,
    panoId: "nsPQy1nWkO__1DTP1vIS-Q",
    place: "Near Holbæk, Zealand",
    shortName: "Holbæk",
    countryCode: "DK",
    country: "Denmark",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","DK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "dk-023",
    lat: 56.359639,
    lng: 8.616044,
    panoId: "54XnrowUt5UqWxGRwkBl2w",
    place: "Near Holstebro, Central Jutland",
    shortName: "Holstebro",
    countryCode: "DK",
    country: "Denmark",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","DK"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "dk-024",
    lat: 55.679063,
    lng: 12.534462,
    panoId: "YK7EEET8gMM-V7YWsM1Gpg",
    place: "Near Frederiksberg, Capital Region",
    shortName: "Frederiksberg",
    countryCode: "DK",
    country: "Denmark",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","DK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "dk-025",
    lat: 55.565682,
    lng: 9.75257,
    panoId: "lidVITWspTxuit5IwqD_OA",
    place: "Near Fredericia, South Denmark",
    shortName: "Fredericia",
    countryCode: "DK",
    country: "Denmark",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","DK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "dk-026",
    lat: 55.64296,
    lng: 12.476538,
    panoId: "EUE_KT1wX3y5YA4PN0xgmA",
    place: "Near Hvidovre, Capital Region",
    shortName: "Hvidovre",
    countryCode: "DK",
    country: "Denmark",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","DK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "dk-027",
    lat: 55.442586,
    lng: 11.789978,
    panoId: "5_t--UBdV2XY-T1W1IMkfQ",
    place: "Near Ringsted, Zealand",
    shortName: "Ringsted",
    countryCode: "DK",
    country: "Denmark",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","DK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "dk-028",
    lat: 55.656925,
    lng: 12.363774,
    panoId: "8UvaiCn5InBNFo3gP-TjJA",
    place: "Near Albertslund, Capital Region",
    shortName: "Albertslund",
    countryCode: "DK",
    country: "Denmark",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","DK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "dk-029",
    lat: 55.770405,
    lng: 9.701079,
    panoId: "K0QNWa9TOr5_Vdo13V666w",
    place: "Near Hedensted, Central Jutland",
    shortName: "Hedensted",
    countryCode: "DK",
    country: "Denmark",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","DK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "dk-030",
    lat: 55.45801,
    lng: 12.182179,
    panoId: "hBZCBvTlJCeRkcK0m6tjwQ",
    place: "Near Køge, Zealand",
    shortName: "Køge",
    countryCode: "DK",
    country: "Denmark",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","DK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "dk-031",
    lat: 55.059832,
    lng: 10.606649,
    panoId: "CLM2NTXZs-EXxK0ulMt8Fg",
    place: "Near Svendborg, South Denmark",
    shortName: "Svendborg",
    countryCode: "DK",
    country: "Denmark",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","DK"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "dk-032",
    lat: 55.474629,
    lng: 12.164604,
    panoId: "M9mK6Rq1nyxsx8TEMa8a5A",
    place: "Near Køge, Zealand",
    shortName: "Køge",
    countryCode: "DK",
    country: "Denmark",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","DK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "dk-033",
    lat: 55.695355,
    lng: 9.55443,
    panoId: "sbW6ueCSPBYzsHYKlJbIYg",
    place: "Near Vejle, South Denmark",
    shortName: "Vejle",
    countryCode: "DK",
    country: "Denmark",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","DK"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "dk-034",
    lat: 54.898693,
    lng: 9.796397,
    panoId: "4dhm2_Kv3X3NbxPxifpVyQ",
    place: "Near Sønderborg, South Denmark",
    shortName: "Sønderborg",
    countryCode: "DK",
    country: "Denmark",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","DK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "dk-035",
    lat: 55.760187,
    lng: 9.730332,
    panoId: "M0rBKvyeCcvzFDmDEvLVkQ",
    place: "Near Hedensted, Central Jutland",
    shortName: "Hedensted",
    countryCode: "DK",
    country: "Denmark",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","DK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "dk-036",
    lat: 55.638979,
    lng: 12.098611,
    panoId: "wS8TJotKV9CCjVPZuQ1SmA",
    place: "Near Roskilde, Zealand",
    shortName: "Roskilde",
    countryCode: "DK",
    country: "Denmark",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","DK"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "dk-037",
    lat: 55.490227,
    lng: 8.444599,
    panoId: "Je3zu2WdKi7cSGBwjPmhYw",
    place: "Near Esbjerg, South Denmark",
    shortName: "Esbjerg",
    countryCode: "DK",
    country: "Denmark",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","DK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "dk-038",
    lat: 56.465212,
    lng: 9.421983,
    panoId: "EzctRNrVAnTqofmKJxXOdQ",
    place: "Near Viborg, Central Jutland",
    shortName: "Viborg",
    countryCode: "DK",
    country: "Denmark",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","DK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "dk-039",
    lat: 55.046468,
    lng: 10.589739,
    panoId: "U-yD1ZyneA0Yd0CayQppQg",
    place: "Near Vindeby, South Denmark",
    shortName: "Vindeby",
    countryCode: "DK",
    country: "Denmark",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","DK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "dk-040",
    lat: 57.441993,
    lng: 10.543155,
    panoId: "bD_f8kc99g-tElol6qEyjA",
    place: "Near Frederikshavn, North Denmark",
    shortName: "Frederikshavn",
    countryCode: "DK",
    country: "Denmark",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","DK"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "dk-041",
    lat: 57.472888,
    lng: 9.953006,
    panoId: "TjpnokD7qSfG9dbVvZzW9Q",
    place: "Near Hjørring, North Denmark",
    shortName: "Hjørring",
    countryCode: "DK",
    country: "Denmark",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","DK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "dk-042",
    lat: 57.041674,
    lng: 9.923855,
    panoId: "wmnKnUQyRXRy9V2ZGcBhJg",
    place: "Near Aalborg, North Denmark",
    shortName: "Aalborg",
    countryCode: "DK",
    country: "Denmark",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","DK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "dk-043",
    lat: 55.391635,
    lng: 10.35801,
    panoId: "94oXiOPWWoqfQhpEDc-i1Q",
    place: "Near Odense, South Denmark",
    shortName: "Odense",
    countryCode: "DK",
    country: "Denmark",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","DK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "dk-044",
    lat: 55.659392,
    lng: 12.47212,
    panoId: "cihes7abpKobfBI6ShEGkg",
    place: "Near Vigerslev, Capital Region",
    shortName: "Vigerslev",
    countryCode: "DK",
    country: "Denmark",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","DK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "dk-045",
    lat: 55.698,
    lng: 12.434226,
    panoId: "9xrLKdEixeU3n3DF42b9Dg",
    place: "Near Rødovre, Capital Region",
    shortName: "Rødovre",
    countryCode: "DK",
    country: "Denmark",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","DK"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "dk-046",
    lat: 55.580403,
    lng: 9.72576,
    panoId: "TICR1SShdw4tD7gdS-4HfQ",
    place: "Near Fredericia, South Denmark",
    shortName: "Fredericia",
    countryCode: "DK",
    country: "Denmark",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","DK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "dk-047",
    lat: 57.424999,
    lng: 10.527382,
    panoId: "fy27NYSxHHdIa1a8sVUfGA",
    place: "Near Frederikshavn, North Denmark",
    shortName: "Frederikshavn",
    countryCode: "DK",
    country: "Denmark",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","DK"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "dk-048",
    lat: 56.472792,
    lng: 9.395233,
    panoId: "G0X6c4Lo1y08pJWILYysFw",
    place: "Near Viborg, Central Jutland",
    shortName: "Viborg",
    countryCode: "DK",
    country: "Denmark",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","DK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "dk-049",
    lat: 55.668989,
    lng: 12.617345,
    panoId: "Tb0W-WsNjILL3e6gxsV2Gw",
    place: "Near Christianshavn, Capital Region",
    shortName: "Christianshavn",
    countryCode: "DK",
    country: "Denmark",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","DK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "dk-050",
    lat: 55.957898,
    lng: 12.334788,
    panoId: "pQRpgrvW5gMXXLJ5pRg-ig",
    place: "Near Nødebo, Capital Region",
    shortName: "Nødebo",
    countryCode: "DK",
    country: "Denmark",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","DK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "dk-051",
    lat: 55.673151,
    lng: 12.084375,
    panoId: "d8sfS6YEGKAJwpah6fjhIA",
    place: "Near Roskilde, Zealand",
    shortName: "Roskilde",
    countryCode: "DK",
    country: "Denmark",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","DK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "dk-052",
    lat: 55.704075,
    lng: 12.28355,
    panoId: "sVaBJdgvdMGTeSHEMKepsg",
    place: "Near Smørumnedre, Capital Region",
    shortName: "Smørumnedre",
    countryCode: "DK",
    country: "Denmark",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","DK"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "dk-053",
    lat: 56.213904,
    lng: 9.512346,
    panoId: "rVDpSlIXZ9NeU6fHCs4NbA",
    place: "Near Silkeborg, Central Jutland",
    shortName: "Silkeborg",
    countryCode: "DK",
    country: "Denmark",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","DK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "dk-054",
    lat: 55.95992,
    lng: 12.236931,
    panoId: "Z4YrNl7LJcHvHOFwhnWBtw",
    place: "Near Hillerød, Capital Region",
    shortName: "Hillerød",
    countryCode: "DK",
    country: "Denmark",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","DK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "dk-055",
    lat: 55.419322,
    lng: 11.313891,
    panoId: "qA2ejd6P_JPzV7eQMo8rSA",
    place: "Near Slagelse, Zealand",
    shortName: "Slagelse",
    countryCode: "DK",
    country: "Denmark",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","DK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "dk-056",
    lat: 55.713703,
    lng: 12.401968,
    panoId: "PuwaQyI0ecVWd_ly8swXUQ",
    place: "Near Herlev, Capital Region",
    shortName: "Herlev",
    countryCode: "DK",
    country: "Denmark",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","DK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "dk-057",
    lat: 56.017022,
    lng: 12.706444,
    panoId: "r-M0BGJbEkaDZ2ov7KTZGg",
    place: "Near Helsingborg, Skåne",
    shortName: "Helsingborg",
    countryCode: "DK",
    country: "Denmark",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","DK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "dk-058",
    lat: 55.178025,
    lng: 11.675891,
    panoId: "QMthaIHWjoS7JRqWJiPHYg",
    place: "Near Klinteby Frihed, Zealand",
    shortName: "Klinteby Frihed",
    countryCode: "DK",
    country: "Denmark",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","DK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "dk-059",
    lat: 56.417959,
    lng: 9.940288,
    panoId: "y8BLXFuNZ2srn6ZoLzxodQ",
    place: "Near Langå, Central Jutland",
    shortName: "Langå",
    countryCode: "DK",
    country: "Denmark",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","DK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "dk-060",
    lat: 55.24421,
    lng: 11.687337,
    panoId: "1BlB-NW7Jkwt-Ge99Dl4AQ",
    place: "Near Næstved, Zealand",
    shortName: "Næstved",
    countryCode: "DK",
    country: "Denmark",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","DK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "dk-061",
    lat: 55.673404,
    lng: 12.253873,
    panoId: "qRmWJsalLClhg0ohQbQi1g",
    place: "Near Taastrup, Capital Region",
    shortName: "Taastrup",
    countryCode: "DK",
    country: "Denmark",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","DK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "dk-062",
    lat: 56.096152,
    lng: 10.242011,
    panoId: "eG57IIvbjzYFUjdQsgRBTQ",
    place: "Near Beder, Central Jutland",
    shortName: "Beder",
    countryCode: "DK",
    country: "Denmark",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","DK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "dk-063",
    lat: 56.308789,
    lng: 8.531292,
    panoId: "Xlwn3c4MXrnYHPiodl8a-A",
    place: "Near Holstebro, Central Jutland",
    shortName: "Holstebro",
    countryCode: "DK",
    country: "Denmark",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","DK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "dk-064",
    lat: 55.599464,
    lng: 9.780572,
    panoId: "jkjkvCIeWw6nOT7LWRogdw",
    place: "Near Fredericia, South Denmark",
    shortName: "Fredericia",
    countryCode: "DK",
    country: "Denmark",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","DK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "dk-065",
    lat: 55.689968,
    lng: 12.339048,
    panoId: "Jc8XxR1BS67sVoC08kwoZw",
    place: "Near Albertslund, Capital Region",
    shortName: "Albertslund",
    countryCode: "DK",
    country: "Denmark",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","DK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "dk-066",
    lat: 55.756727,
    lng: 11.670653,
    panoId: "gggNc462S-0tBVIWBBjX7w",
    place: "Near Holbæk, Zealand",
    shortName: "Holbæk",
    countryCode: "DK",
    country: "Denmark",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","DK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "dk-067",
    lat: 55.064615,
    lng: 10.534153,
    panoId: "h9sjWVlx0wNdm1fFcVf2eQ",
    place: "Near Svendborg, South Denmark",
    shortName: "Svendborg",
    countryCode: "DK",
    country: "Denmark",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","DK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "dk-068",
    lat: 55.302586,
    lng: 9.430747,
    panoId: "_4rIvQ7FLasi18Ntb1NdyA",
    place: "Near Haderslev, South Denmark",
    shortName: "Haderslev",
    countryCode: "DK",
    country: "Denmark",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","DK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "dk-069",
    lat: 54.893473,
    lng: 9.892271,
    panoId: "8OaAuUP8hrVtpPVTHvoJMQ",
    place: "Near Høruphav, South Denmark",
    shortName: "Høruphav",
    countryCode: "DK",
    country: "Denmark",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","DK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "dk-070",
    lat: 56.224246,
    lng: 9.514241,
    panoId: "IPyUF6KozMUX4WlX_fL-uQ",
    place: "Near Silkeborg, Central Jutland",
    shortName: "Silkeborg",
    countryCode: "DK",
    country: "Denmark",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","DK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "dk-071",
    lat: 55.744081,
    lng: 9.641141,
    panoId: "UVRfsG56dLJ2LRNb771G4A",
    place: "Near Hedensted, Central Jutland",
    shortName: "Hedensted",
    countryCode: "DK",
    country: "Denmark",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","DK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "dk-072",
    lat: 55.842629,
    lng: 9.799286,
    panoId: "IKGi_eylVlMWczFEoZN31w",
    place: "Near Hatting, Central Jutland",
    shortName: "Hatting",
    countryCode: "DK",
    country: "Denmark",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","DK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "dk-073",
    lat: 55.206739,
    lng: 11.803928,
    panoId: "6kL3kurIpLLVWsWh0spC5g",
    place: "Near Næstved, Zealand",
    shortName: "Næstved",
    countryCode: "DK",
    country: "Denmark",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","DK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "dk-074",
    lat: 55.431343,
    lng: 9.493888,
    panoId: "H2olXlqLcx8-BCg-x7rakA",
    place: "Near Sønder Bjert, South Denmark",
    shortName: "Sønder Bjert",
    countryCode: "DK",
    country: "Denmark",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","DK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "dk-075",
    lat: 56.593823,
    lng: 9.118731,
    panoId: "3y5liNeyKXIUio2H5470vQ",
    place: "Near Skive, Central Jutland",
    shortName: "Skive",
    countryCode: "DK",
    country: "Denmark",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","DK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "dk-076",
    lat: 55.531737,
    lng: 8.407396,
    panoId: "wDDidl00tp3me3GJpm84YA",
    place: "Near Esbjerg, South Denmark",
    shortName: "Esbjerg",
    countryCode: "DK",
    country: "Denmark",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","DK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "dk-077",
    lat: 54.745555,
    lng: 11.847895,
    panoId: "X3rbtn_5b2vwwZfEQgq2mw",
    place: "Near Sundby, Zealand",
    shortName: "Sundby",
    countryCode: "DK",
    country: "Denmark",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","DK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "dk-078",
    lat: 54.908628,
    lng: 9.844601,
    panoId: "UYYWIOsucXOCfvm5Ok3LcQ",
    place: "Near Høruphav, South Denmark",
    shortName: "Høruphav",
    countryCode: "DK",
    country: "Denmark",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","DK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "dk-079",
    lat: 57.491502,
    lng: 10.451085,
    panoId: "A_sAIMdZU6BlYDEIP26xQg",
    place: "Near Elling, North Denmark",
    shortName: "Elling",
    countryCode: "DK",
    country: "Denmark",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","DK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "dk-080",
    lat: 57.010816,
    lng: 9.928066,
    panoId: "kSX_lSU4ysYnwWSSuC0hDw",
    place: "Near Aalborg, North Denmark",
    shortName: "Aalborg",
    countryCode: "DK",
    country: "Denmark",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","DK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "dk-081",
    lat: 55.213575,
    lng: 9.50457,
    panoId: "_o3PszKlx4kxYiwaRTP0VA",
    place: "Near Starup, South Denmark",
    shortName: "Starup",
    countryCode: "DK",
    country: "Denmark",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","DK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "dk-082",
    lat: 55.760819,
    lng: 12.454201,
    panoId: "HZrcg0mkDKUSVHQj8acXAQ",
    place: "Near Buddinge, Capital Region",
    shortName: "Buddinge",
    countryCode: "DK",
    country: "Denmark",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","DK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "dk-083",
    lat: 55.395171,
    lng: 10.326232,
    panoId: "CorUsnH_uvS39PTfxYUxbQ",
    place: "Near Odense, South Denmark",
    shortName: "Odense",
    countryCode: "DK",
    country: "Denmark",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","DK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "dk-084",
    lat: 57.114795,
    lng: 9.924355,
    panoId: "GyNoEeRCNlb_Q-yAa-dFVg",
    place: "Near Vestbjerg, North Denmark",
    shortName: "Vestbjerg",
    countryCode: "DK",
    country: "Denmark",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","DK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "dk-085",
    lat: 56.735969,
    lng: 8.948458,
    panoId: "6LrS-3FuNYhcXTvvaG-Zkw",
    place: "Near Hinnerup, Central Jutland",
    shortName: "Hinnerup",
    countryCode: "DK",
    country: "Denmark",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","DK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "dk-086",
    lat: 55.873389,
    lng: 12.552197,
    panoId: "ENzqIsxc9d3fT6k0KxnkPA",
    place: "Near Hørsholm, Capital Region",
    shortName: "Hørsholm",
    countryCode: "DK",
    country: "Denmark",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","DK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "dk-087",
    lat: 56.465183,
    lng: 8.581483,
    panoId: "iruRdqSFypr2x1-p-NMrmg",
    place: "Near Struer, Central Jutland",
    shortName: "Struer",
    countryCode: "DK",
    country: "Denmark",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","DK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "dk-088",
    lat: 54.898247,
    lng: 11.753542,
    panoId: "MrT6YF60aWTNhp7LK6n5ig",
    place: "Near Nørre Alslev, Zealand",
    shortName: "Nørre Alslev",
    countryCode: "DK",
    country: "Denmark",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","DK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "dk-089",
    lat: 56.09394,
    lng: 8.948652,
    panoId: "tYcqUdXOmDasLL28_4xs1Q",
    place: "Near Lind, Central Jutland",
    shortName: "Lind",
    countryCode: "DK",
    country: "Denmark",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","DK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "dk-090",
    lat: 55.678692,
    lng: 11.837852,
    panoId: "wM6q2Q9Atws2tC1lWU9Tag",
    place: "Near Ejby, Zealand",
    shortName: "Ejby",
    countryCode: "DK",
    country: "Denmark",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","DK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "dk-091",
    lat: 55.39527,
    lng: 11.519848,
    panoId: "6GPJWTLNQJWPiHHDi9vtjw",
    place: "Near Frederiksberg, Zealand",
    shortName: "Frederiksberg",
    countryCode: "DK",
    country: "Denmark",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","DK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "dk-092",
    lat: 56.325867,
    lng: 10.24737,
    panoId: "GrgKnQkUIKMfZ-stdP4wjg",
    place: "Near Hornslet, Central Jutland",
    shortName: "Hornslet",
    countryCode: "DK",
    country: "Denmark",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","DK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "dk-093",
    lat: 56.368398,
    lng: 9.776191,
    panoId: "fJUaKqGBMk4XpUeahkrYMw",
    place: "Near Ulstrup, Central Jutland",
    shortName: "Ulstrup",
    countryCode: "DK",
    country: "Denmark",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","DK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "dk-094",
    lat: 55.992408,
    lng: 9.934996,
    panoId: "d_BhOybhH_Ox-vmqNr6GIw",
    place: "Near Skanderborg, Central Jutland",
    shortName: "Skanderborg",
    countryCode: "DK",
    country: "Denmark",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","DK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "dk-095",
    lat: 55.989357,
    lng: 9.01636,
    panoId: "i73-CbdCUrmeC6y3w5sEyQ",
    place: "Near Brande, Central Jutland",
    shortName: "Brande",
    countryCode: "DK",
    country: "Denmark",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","DK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "dk-096",
    lat: 54.707286,
    lng: 11.571982,
    panoId: "8bZ72ZgH9KSlvAP_iodOhQ",
    place: "Near Holeby, Zealand",
    shortName: "Holeby",
    countryCode: "DK",
    country: "Denmark",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","DK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "dk-097",
    lat: 56.653968,
    lng: 8.916506,
    panoId: "5xQDU4a3w90wCAZH2Kn0gQ",
    place: "Near Skive, Central Jutland",
    shortName: "Skive",
    countryCode: "DK",
    country: "Denmark",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","DK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "dk-098",
    lat: 55.664055,
    lng: 9.621842,
    panoId: "3OuM2qnW1FGXFCmb-PaMKQ",
    place: "Near Børkop, South Denmark",
    shortName: "Børkop",
    countryCode: "DK",
    country: "Denmark",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","DK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "dk-099",
    lat: 54.871799,
    lng: 9.600069,
    panoId: "wZETQS6mavRJymkMZBCbXQ",
    place: "Near Glücksburg, Schleswig-Holstein",
    shortName: "Glücksburg",
    countryCode: "DK",
    country: "Denmark",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","DK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "dk-100",
    lat: 55.467976,
    lng: 10.073769,
    panoId: "0VFmVq09tu-Lv8HLsfieiQ",
    place: "Near Brenderup, South Denmark",
    shortName: "Brenderup",
    countryCode: "DK",
    country: "Denmark",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","DK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "dk-101",
    lat: 56.613972,
    lng: 9.492754,
    panoId: "D5HS0uvUJsFcK_lFzYecKg",
    place: "Near Skals, Central Jutland",
    shortName: "Skals",
    countryCode: "DK",
    country: "Denmark",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","DK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "dk-102",
    lat: 57.395893,
    lng: 10.29832,
    panoId: "PAlWRQhseLiiiY62QJ-GlA",
    place: "Near Sindal, North Denmark",
    shortName: "Sindal",
    countryCode: "DK",
    country: "Denmark",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","DK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "dk-103",
    lat: 56.989915,
    lng: 10.242185,
    panoId: "5ikU0Iueb6EdK7-CqxFLEw",
    place: "Near Hals, North Denmark",
    shortName: "Hals",
    countryCode: "DK",
    country: "Denmark",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","DK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "dk-104",
    lat: 57.14027,
    lng: 10.181788,
    panoId: "oQzU4aqOj6Th7U8YZ1CNXg",
    place: "Near Hjallerup, North Denmark",
    shortName: "Hjallerup",
    countryCode: "DK",
    country: "Denmark",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","DK"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "dk-105",
    lat: 57.250398,
    lng: 10.255819,
    panoId: "nm0PmKYWYAz8lSOYZFQSQg",
    place: "Near Dronninglund, North Denmark",
    shortName: "Dronninglund",
    countryCode: "DK",
    country: "Denmark",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","DK"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "fi-000",
    lat: 61.480804,
    lng: 21.78559,
    panoId: "Qd5FraE3Pzz6BNsWEBGn4g",
    place: "Near Pori, Satakunta",
    shortName: "Pori",
    countryCode: "FI",
    country: "Finland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","FI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fi-001",
    lat: 60.451499,
    lng: 22.268739,
    panoId: "qan-f-Py6EcMdV6l9-Zsug",
    place: "Near Turku, Southwest Finland",
    shortName: "Turku",
    countryCode: "FI",
    country: "Finland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","FI"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "fi-002",
    lat: 62.601141,
    lng: 29.763126,
    panoId: "ipQYGYm-IQrwC8pKBIF3Xw",
    place: "Near Joensuu, North Karelia",
    shortName: "Joensuu",
    countryCode: "FI",
    country: "Finland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","FI"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "fi-003",
    lat: 62.24148,
    lng: 25.720431,
    panoId: "MOTpZSjlnVZYJTWpWyzfTA",
    place: "Near Jyväskylä, Central Finland",
    shortName: "Jyväskylä",
    countryCode: "FI",
    country: "Finland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","FI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fi-004",
    lat: 63.096329,
    lng: 21.615416,
    panoId: "1-Q8xIzcbNzFHlsWSAkNMg",
    place: "Near Vaasa, Ostrobothnia",
    shortName: "Vaasa",
    countryCode: "FI",
    country: "Finland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","FI"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "fi-005",
    lat: 60.866684,
    lng: 26.699925,
    panoId: "cqapWQRYMAjO03t-QknwGg",
    place: "Near Kouvola, Kymenlaakso",
    shortName: "Kouvola",
    countryCode: "FI",
    country: "Finland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","FI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fi-006",
    lat: 61.466465,
    lng: 23.500155,
    panoId: "8xx2e3Pl6H_jbj7BD54deg",
    place: "Near Nokia, Pirkanmaa",
    shortName: "Nokia",
    countryCode: "FI",
    country: "Finland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","FI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fi-007",
    lat: 61.058701,
    lng: 28.18878,
    panoId: "ImvOA9yMTnhwdddKllNJgQ",
    place: "Near Lappeenranta, South Karelia",
    shortName: "Lappeenranta",
    countryCode: "FI",
    country: "Finland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","FI"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "fi-008",
    lat: 66.498938,
    lng: 25.688572,
    panoId: "YPYo5Pc8fikExB71GFrG3A",
    place: "Near Rovaniemi, Lapland",
    shortName: "Rovaniemi",
    countryCode: "FI",
    country: "Finland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","FI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fi-009",
    lat: 62.892401,
    lng: 27.67705,
    panoId: "c8kbsG1MjVPZq2ON75McdA",
    place: "Near Kuopio, North Savo",
    shortName: "Kuopio",
    countryCode: "FI",
    country: "Finland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","FI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fi-010",
    lat: 60.99595,
    lng: 24.464344,
    panoId: "AcgcA-pxuAW-wKkiREltDA",
    place: "Near Hämeenlinna, Kanta-Häme",
    shortName: "Hämeenlinna",
    countryCode: "FI",
    country: "Finland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","FI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fi-011",
    lat: 60.63315,
    lng: 24.866881,
    panoId: "ERQGGZtnr3oKkYU4EJ2FJw",
    place: "Near Hyvinge, Uusimaa",
    shortName: "Hyvinge",
    countryCode: "FI",
    country: "Finland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","FI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fi-012",
    lat: 61.869937,
    lng: 28.879932,
    panoId: "Ry2E7iw8S6jLxjDBRCiyPw",
    place: "Near Savonlinna, South Savo",
    shortName: "Savonlinna",
    countryCode: "FI",
    country: "Finland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","FI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fi-013",
    lat: 60.737698,
    lng: 24.777395,
    panoId: "N8HP2aXP_yqx2nMeUaucxQ",
    place: "Near Riihimäki, Kanta-Häme",
    shortName: "Riihimäki",
    countryCode: "FI",
    country: "Finland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","FI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fi-014",
    lat: 61.688538,
    lng: 27.272286,
    panoId: "0ZhgDGALBDe4DiNz4nyloQ",
    place: "Near Mikkeli, South Savo",
    shortName: "Mikkeli",
    countryCode: "FI",
    country: "Finland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","FI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fi-015",
    lat: 61.171809,
    lng: 28.7524,
    panoId: "GLoW3YthGanyw7gFP9Fnjw",
    place: "Near Imatra, South Karelia",
    shortName: "Imatra",
    countryCode: "FI",
    country: "Finland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","FI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fi-016",
    lat: 61.463818,
    lng: 24.076109,
    panoId: "tUctk867gKrq0zr5CLinPA",
    place: "Near Kangasala, Pirkanmaa",
    shortName: "Kangasala",
    countryCode: "FI",
    country: "Finland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","FI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fi-017",
    lat: 60.485892,
    lng: 22.168873,
    panoId: "1aZiNHrmc_BHDNRrKfRoDQ",
    place: "Near Raisio, Southwest Finland",
    shortName: "Raisio",
    countryCode: "FI",
    country: "Finland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","FI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fi-018",
    lat: 60.169507,
    lng: 24.935417,
    panoId: "9e9qF7dw8frrm8TwiuNauw",
    place: "Near Helsinki, Uusimaa",
    shortName: "Helsinki",
    countryCode: "FI",
    country: "Finland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","FI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fi-019",
    lat: 62.794483,
    lng: 22.828157,
    panoId: "EWT54rxq1eMdXpkxcD060A",
    place: "Near Seinäjoki, South Ostrobothnia",
    shortName: "Seinäjoki",
    countryCode: "FI",
    country: "Finland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","FI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fi-020",
    lat: 60.248802,
    lng: 24.065677,
    panoId: "h2i3Xtw0-2g4Qw8N4CC_Mw",
    place: "Near Lohja, Uusimaa",
    shortName: "Lohja",
    countryCode: "FI",
    country: "Finland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","FI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fi-021",
    lat: 61.556334,
    lng: 23.59625,
    panoId: "nz2TgznaFmbjPgh8Gc3CTA",
    place: "Near Ylöjärvi, Pirkanmaa",
    shortName: "Ylöjärvi",
    countryCode: "FI",
    country: "Finland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","FI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fi-022",
    lat: 60.466531,
    lng: 26.945714,
    panoId: "75AviVpLXi4UneCnDJPTRA",
    place: "Near Kotka, Kymenlaakso",
    shortName: "Kotka",
    countryCode: "FI",
    country: "Finland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","FI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fi-023",
    lat: 61.316693,
    lng: 23.750047,
    panoId: "9woISOiTX76dh7XdOnSnNQ",
    place: "Near Lempäälä, Pirkanmaa",
    shortName: "Lempäälä",
    countryCode: "FI",
    country: "Finland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","FI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fi-024",
    lat: 61.12704,
    lng: 21.511202,
    panoId: "lgormjDbbLQVSVBu3_e9_Q",
    place: "Near Rauma, Satakunta",
    shortName: "Rauma",
    countryCode: "FI",
    country: "Finland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","FI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fi-025",
    lat: 63.838496,
    lng: 23.130686,
    panoId: "jKw4HV9EqjAnoKMHhgpPLg",
    place: "Near Kokkola, Central Ostrobothnia",
    shortName: "Kokkola",
    countryCode: "FI",
    country: "Finland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","FI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fi-026",
    lat: 60.392346,
    lng: 25.665074,
    panoId: "N45GKS9PvwygihsfuTHVBw",
    place: "Near Porvoo, Uusimaa",
    shortName: "Porvoo",
    countryCode: "FI",
    country: "Finland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","FI"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "fi-027",
    lat: 60.407184,
    lng: 22.369133,
    panoId: "ZzZfe5B8Ot8QQ8IUVsP3HQ",
    place: "Near Kaarina, Southwest Finland",
    shortName: "Kaarina",
    countryCode: "FI",
    country: "Finland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","FI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fi-028",
    lat: 60.383671,
    lng: 23.133419,
    panoId: "qf6tR433G5PTGR5N5fqmxA",
    place: "Near Salo, Southwest Finland",
    shortName: "Salo",
    countryCode: "FI",
    country: "Finland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","FI"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "fi-029",
    lat: 61.349878,
    lng: 22.908624,
    panoId: "MBttpM4jgAMg5vE4Txi9mg",
    place: "Near Sastamala, Pirkanmaa",
    shortName: "Sastamala",
    countryCode: "FI",
    country: "Finland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","FI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fi-030",
    lat: 65.012341,
    lng: 25.468137,
    panoId: "kOx6tQLfijX2dfdFKnGBJw",
    place: "Near Oulu, North Ostrobothnia",
    shortName: "Oulu",
    countryCode: "FI",
    country: "Finland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","FI"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "fi-031",
    lat: 61.499122,
    lng: 23.7871,
    panoId: "YrtZP56JRgeu2gVWDFemfA",
    place: "Near Tampere, Pirkanmaa",
    shortName: "Tampere",
    countryCode: "FI",
    country: "Finland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","FI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fi-032",
    lat: 59.977281,
    lng: 23.439446,
    panoId: "Z6xGkJh8JV0Q2pM6K3fA6w",
    place: "Near Raseborg, Uusimaa",
    shortName: "Raseborg",
    countryCode: "FI",
    country: "Finland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","FI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fi-033",
    lat: 60.416991,
    lng: 24.319633,
    panoId: "xP_u-VjRfbf6SDFcX5IEig",
    place: "Near Vihti, Uusimaa",
    shortName: "Vihti",
    countryCode: "FI",
    country: "Finland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","FI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fi-034",
    lat: 60.982707,
    lng: 25.661513,
    panoId: "hUDV36mtr22J4r_AMvvlsw",
    place: "Near Lahti, Paijat-Hame",
    shortName: "Lahti",
    countryCode: "FI",
    country: "Finland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","FI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fi-035",
    lat: 61.000273,
    lng: 25.500265,
    panoId: "oOmavkW0ArK6a3Zxt_8gXA",
    place: "Near Hollola, Paijat-Hame",
    shortName: "Hollola",
    countryCode: "FI",
    country: "Finland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","FI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fi-036",
    lat: 63.083317,
    lng: 27.665706,
    panoId: "7n52xkRwMLVyQl7mGjvOYA",
    place: "Near Siilinjärvi, North Savo",
    shortName: "Siilinjärvi",
    countryCode: "FI",
    country: "Finland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","FI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fi-037",
    lat: 64.683337,
    lng: 24.483228,
    panoId: "hOHApolAOl_ivHCwlAslOQ",
    place: "Near Raahe, North Ostrobothnia",
    shortName: "Raahe",
    countryCode: "FI",
    country: "Finland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","FI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fi-038",
    lat: 60.240993,
    lng: 24.038702,
    panoId: "A9RMo32xD6o0BcbJxKamAg",
    place: "Near Lohja, Uusimaa",
    shortName: "Lohja",
    countryCode: "FI",
    country: "Finland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","FI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fi-039",
    lat: 62.25816,
    lng: 25.69196,
    panoId: "fcxk3tLpKa4KGyMnE5KcfA",
    place: "Near Jyväskylä, Central Finland",
    shortName: "Jyväskylä",
    countryCode: "FI",
    country: "Finland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","FI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fi-040",
    lat: 60.411025,
    lng: 24.347057,
    panoId: "sxuY-u75K1uC2SMOiEegXQ",
    place: "Near Vihti, Uusimaa",
    shortName: "Vihti",
    countryCode: "FI",
    country: "Finland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","FI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fi-041",
    lat: 60.618342,
    lng: 24.833573,
    panoId: "hq4l2pgd72H8ss6FvTV6Ow",
    place: "Near Veikkari, Uusimaa",
    shortName: "Veikkari",
    countryCode: "FI",
    country: "Finland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","FI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fi-042",
    lat: 60.74824,
    lng: 24.814746,
    panoId: "JM2HFVQWT9Xx4rZ-Foging",
    place: "Near Riihimäki, Kanta-Häme",
    shortName: "Riihimäki",
    countryCode: "FI",
    country: "Finland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","FI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fi-043",
    lat: 64.224232,
    lng: 27.690002,
    panoId: "Vo5Kd5QMGH_CNRINOMhyDg",
    place: "Near Kajaani, Kainuu",
    shortName: "Kajaani",
    countryCode: "FI",
    country: "Finland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","FI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fi-044",
    lat: 61.309054,
    lng: 23.776053,
    panoId: "V76ZWzm9L8UXMpwNQtRtfQ",
    place: "Near Lempäälä, Pirkanmaa",
    shortName: "Lempäälä",
    countryCode: "FI",
    country: "Finland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","FI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fi-045",
    lat: 61.353142,
    lng: 22.941336,
    panoId: "acGkzlrFcYhiEXDnjGBeHQ",
    place: "Near Sastamala, Pirkanmaa",
    shortName: "Sastamala",
    countryCode: "FI",
    country: "Finland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","FI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fi-046",
    lat: 63.10948,
    lng: 21.648356,
    panoId: "13CWqELGwyK0Qn7U2z-tOw",
    place: "Near Korsholm, Ostrobothnia",
    shortName: "Korsholm",
    countryCode: "FI",
    country: "Finland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","FI"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "fi-047",
    lat: 61.465546,
    lng: 21.773939,
    panoId: "9wjbvlBFgVH4p7EGSsCXBw",
    place: "Near Pori, Satakunta",
    shortName: "Pori",
    countryCode: "FI",
    country: "Finland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","FI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fi-048",
    lat: 61.567917,
    lng: 23.605522,
    panoId: "Nt-XJzyc9YZi2cDFlx2H6w",
    place: "Near Ylöjärvi, Pirkanmaa",
    shortName: "Ylöjärvi",
    countryCode: "FI",
    country: "Finland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","FI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fi-049",
    lat: 60.389998,
    lng: 22.393616,
    panoId: "ssjvLiwZeZcxwzD1C-PDcA",
    place: "Near Kaarina, Southwest Finland",
    shortName: "Kaarina",
    countryCode: "FI",
    country: "Finland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","FI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fi-050",
    lat: 61.078175,
    lng: 21.418428,
    panoId: "-1WbykxVm3tin7DYRWwHOA",
    place: "Near Rauma, Satakunta",
    shortName: "Rauma",
    countryCode: "FI",
    country: "Finland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","FI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fi-051",
    lat: 61.454168,
    lng: 24.005864,
    panoId: "MJGKsQj6NfR1mtYmMyb1mQ",
    place: "Near Kangasala, Pirkanmaa",
    shortName: "Kangasala",
    countryCode: "FI",
    country: "Finland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","FI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fi-052",
    lat: 61.460658,
    lng: 23.396433,
    panoId: "ITxr4Flb8oACL_TAX9UwWw",
    place: "Near Nokia, Pirkanmaa",
    shortName: "Nokia",
    countryCode: "FI",
    country: "Finland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","FI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fi-053",
    lat: 63.104192,
    lng: 27.70942,
    panoId: "5CvE6IG8C4TwkLAiVL290g",
    place: "Near Siilinjärvi, North Savo",
    shortName: "Siilinjärvi",
    countryCode: "FI",
    country: "Finland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","FI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fi-054",
    lat: 61.887304,
    lng: 28.824058,
    panoId: "u7lvXJSlu5NQFVHF3-Qcfg",
    place: "Near Savonlinna, South Savo",
    shortName: "Savonlinna",
    countryCode: "FI",
    country: "Finland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","FI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fi-055",
    lat: 63.78062,
    lng: 23.135047,
    panoId: "Cs857E6DOqWaBbBfYT2dcQ",
    place: "Near Kokkola, Central Ostrobothnia",
    shortName: "Kokkola",
    countryCode: "FI",
    country: "Finland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","FI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fi-056",
    lat: 62.185296,
    lng: 25.629289,
    panoId: "OJ3ilt8h7HMhKJ2BvCxWMw",
    place: "Near Muurame, Central Finland",
    shortName: "Muurame",
    countryCode: "FI",
    country: "Finland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","FI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fi-057",
    lat: 64.197438,
    lng: 27.630454,
    panoId: "HkgTTh6c0A-FQAzrWyeiVA",
    place: "Near Kajaani, Kainuu",
    shortName: "Kajaani",
    countryCode: "FI",
    country: "Finland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","FI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fi-058",
    lat: 60.366234,
    lng: 25.720201,
    panoId: "ftxGSZtBVgwkqPtnH4kSfg",
    place: "Near Porvoo, Uusimaa",
    shortName: "Porvoo",
    countryCode: "FI",
    country: "Finland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","FI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fi-059",
    lat: 60.958244,
    lng: 25.553344,
    panoId: "dX_Sppf5HTuwJcusqZRaXg",
    place: "Near Hollola, Paijat-Hame",
    shortName: "Hollola",
    countryCode: "FI",
    country: "Finland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","FI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fi-060",
    lat: 60.439745,
    lng: 23.173492,
    panoId: "TArxBLlq3WfmZ_lygRnteQ",
    place: "Near Pertteli, Southwest Finland",
    shortName: "Pertteli",
    countryCode: "FI",
    country: "Finland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","FI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fi-061",
    lat: 61.049152,
    lng: 24.516008,
    panoId: "w3jO6MZ-RmrmR2D14cp7hQ",
    place: "Near Hämeenlinna, Kanta-Häme",
    shortName: "Hämeenlinna",
    countryCode: "FI",
    country: "Finland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","FI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fi-062",
    lat: 60.572934,
    lng: 24.859683,
    panoId: "wpZLi-AVtGBnTeT3fU80Lw",
    place: "Near Veikkari, Uusimaa",
    shortName: "Veikkari",
    countryCode: "FI",
    country: "Finland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","FI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fi-063",
    lat: 61.023168,
    lng: 28.152602,
    panoId: "Z0j4RIr-QePxhDtHavkHog",
    place: "Near Kourula, South Karelia",
    shortName: "Kourula",
    countryCode: "FI",
    country: "Finland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","FI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fi-064",
    lat: 63.150942,
    lng: 21.697329,
    panoId: "SE_VMvVrZBLIN1FLQBqAIg",
    place: "Near Smedsby, Ostrobothnia",
    shortName: "Smedsby",
    countryCode: "FI",
    country: "Finland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","FI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fi-065",
    lat: 61.059933,
    lng: 25.601641,
    panoId: "V2ATbiYMVkMjDS-cEDpUuQ",
    place: "Near Hollola, Paijat-Hame",
    shortName: "Hollola",
    countryCode: "FI",
    country: "Finland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","FI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fi-066",
    lat: 61.520664,
    lng: 23.923728,
    panoId: "t8TDPamPn308ka9o58ehlQ",
    place: "Near Tasanne, Pirkanmaa",
    shortName: "Tasanne",
    countryCode: "FI",
    country: "Finland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","FI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fi-067",
    lat: 61.093286,
    lng: 21.543909,
    panoId: "4o9uz3gLbrcCuTPN3XL9iA",
    place: "Near Rauma, Satakunta",
    shortName: "Rauma",
    countryCode: "FI",
    country: "Finland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","FI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fi-068",
    lat: 61.356614,
    lng: 23.67203,
    panoId: "GdguHbezkyjGoxcFEEmxng",
    place: "Near Vesilahti, Pirkanmaa",
    shortName: "Vesilahti",
    countryCode: "FI",
    country: "Finland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","FI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fi-069",
    lat: 59.970612,
    lng: 23.577414,
    panoId: "-_335Ow53csJXUBArl7zyQ",
    place: "Near Raseborg, Uusimaa",
    shortName: "Raseborg",
    countryCode: "FI",
    country: "Finland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","FI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fi-070",
    lat: 60.70912,
    lng: 24.72811,
    panoId: "lzLfBG-VS6BWnQxtk76pKQ",
    place: "Near Riihimäki, Kanta-Häme",
    shortName: "Riihimäki",
    countryCode: "FI",
    country: "Finland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","FI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fi-071",
    lat: 63.809453,
    lng: 23.175138,
    panoId: "c9Kvq70rKpZw7-ByVWDD6Q",
    place: "Near Kokkola, Central Ostrobothnia",
    shortName: "Kokkola",
    countryCode: "FI",
    country: "Finland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","FI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fi-072",
    lat: 66.553472,
    lng: 25.650732,
    panoId: "QgQVRSMC1i0CvTCzhVAZlg",
    place: "Near Rovaniemi, Lapland",
    shortName: "Rovaniemi",
    countryCode: "FI",
    country: "Finland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","FI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fi-073",
    lat: 61.371514,
    lng: 23.046139,
    panoId: "M8Rcqmz1rNWFAcVIzbR0ig",
    place: "Near Sastamala, Pirkanmaa",
    shortName: "Sastamala",
    countryCode: "FI",
    country: "Finland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","FI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fi-074",
    lat: 60.477176,
    lng: 22.34311,
    panoId: "cPd9l7AWnEmiQtpCzG6a0Q",
    place: "Near I kaupunginosa, Southwest Finland",
    shortName: "I kaupunginosa",
    countryCode: "FI",
    country: "Finland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","FI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fi-075",
    lat: 63.148233,
    lng: 27.666,
    panoId: "BD_Vj5XPrUJlVndPsjjUHQ",
    place: "Near Siilinjärvi, North Savo",
    shortName: "Siilinjärvi",
    countryCode: "FI",
    country: "Finland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","FI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fi-076",
    lat: 60.199367,
    lng: 24.09982,
    panoId: "J8dv4YudGtu9wN5RQ5r5eg",
    place: "Near Lohja, Uusimaa",
    shortName: "Lohja",
    countryCode: "FI",
    country: "Finland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","FI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fi-077",
    lat: 61.62701,
    lng: 27.215473,
    panoId: "JdBdaxEjfHJTQttWxsKStg",
    place: "Near Mikkeli, South Savo",
    shortName: "Mikkeli",
    countryCode: "FI",
    country: "Finland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","FI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fi-078",
    lat: 61.410891,
    lng: 21.801025,
    panoId: "Sg8Q6qDT96IEwKr8ZVIyHw",
    place: "Near Ulvila, Satakunta",
    shortName: "Ulvila",
    countryCode: "FI",
    country: "Finland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","FI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fi-079",
    lat: 60.404332,
    lng: 22.29534,
    panoId: "Mb8dj0M4P7_aHYo_8sVNYQ",
    place: "Near Kaarina, Southwest Finland",
    shortName: "Kaarina",
    countryCode: "FI",
    country: "Finland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","FI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fi-080",
    lat: 60.365818,
    lng: 25.569182,
    panoId: "vaUIn23f3g_WME4_PGJ6jw",
    place: "Near Porvoo, Uusimaa",
    shortName: "Porvoo",
    countryCode: "FI",
    country: "Finland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","FI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fi-081",
    lat: 60.443336,
    lng: 26.897129,
    panoId: "Vz6PXRBqLmPR95KccHWOtQ",
    place: "Near Kotka, Kymenlaakso",
    shortName: "Kotka",
    countryCode: "FI",
    country: "Finland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","FI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fi-082",
    lat: 60.62318,
    lng: 25.381361,
    panoId: "yusjw9_Om6Gw8m0vDfJIhg",
    place: "Near Mäntsälä, Uusimaa",
    shortName: "Mäntsälä",
    countryCode: "FI",
    country: "Finland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","FI"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "fi-083",
    lat: 61.160007,
    lng: 28.60237,
    panoId: "sHhSdpu5b9ckpmGCifiFdg",
    place: "Near Korvenkylä, South Karelia",
    shortName: "Korvenkylä",
    countryCode: "FI",
    country: "Finland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","FI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fi-084",
    lat: 60.435137,
    lng: 24.182726,
    panoId: "qaqNSUZIY14cXiy3AyLysg",
    place: "Near Vihti, Uusimaa",
    shortName: "Vihti",
    countryCode: "FI",
    country: "Finland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","FI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fi-085",
    lat: 60.47052,
    lng: 22.413704,
    panoId: "y-9o4UVAuLqrSRACpPujYw",
    place: "Near Lieto, Southwest Finland",
    shortName: "Lieto",
    countryCode: "FI",
    country: "Finland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","FI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fi-086",
    lat: 62.925861,
    lng: 27.675606,
    panoId: "b5VXGIY3HGBvQEdCHKv5AQ",
    place: "Near Kuopio, North Savo",
    shortName: "Kuopio",
    countryCode: "FI",
    country: "Finland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","FI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fi-087",
    lat: 63.675805,
    lng: 22.857509,
    panoId: "Qfdyxl-iKiZUx4jCUpVgGQ",
    place: "Near Kållby, Ostrobothnia",
    shortName: "Kållby",
    countryCode: "FI",
    country: "Finland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","FI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fi-088",
    lat: 62.668913,
    lng: 22.327062,
    panoId: "qY7qmxDUDnqykS4ml7tibA",
    place: "Near Kurikka, South Ostrobothnia",
    shortName: "Kurikka",
    countryCode: "FI",
    country: "Finland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","FI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fi-089",
    lat: 60.949522,
    lng: 25.578875,
    panoId: "ioqBYYG5cr0ePdtsXbqHNg",
    place: "Near Lahti, Paijat-Hame",
    shortName: "Lahti",
    countryCode: "FI",
    country: "Finland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","FI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fi-090",
    lat: 62.739628,
    lng: 22.780337,
    panoId: "fQkSlykBXR6F-DAwFo-O_w",
    place: "Near Seinäjoki, South Ostrobothnia",
    shortName: "Seinäjoki",
    countryCode: "FI",
    country: "Finland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","FI"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "fi-091",
    lat: 64.249543,
    lng: 27.58321,
    panoId: "_qXVveIVh1R2tz22w9BViQ",
    place: "Near Kajaani, Kainuu",
    shortName: "Kajaani",
    countryCode: "FI",
    country: "Finland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","FI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fi-092",
    lat: 62.296473,
    lng: 27.004587,
    panoId: "VBI1aaZfoazjY0IkwDOgLg",
    place: "Near Pieksämäki, South Savo",
    shortName: "Pieksämäki",
    countryCode: "FI",
    country: "Finland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","FI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fi-093",
    lat: 60.618491,
    lng: 27.21347,
    panoId: "KJSAhdH5af12D5NV_aVf9w",
    place: "Near Hamina, Kymenlaakso",
    shortName: "Hamina",
    countryCode: "FI",
    country: "Finland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","FI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fi-094",
    lat: 60.466669,
    lng: 26.879296,
    panoId: "Lv9WXxmkrXnWdLZXKHM8rg",
    place: "Near Kotka, Kymenlaakso",
    shortName: "Kotka",
    countryCode: "FI",
    country: "Finland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","FI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fi-095",
    lat: 60.166209,
    lng: 24.554086,
    panoId: "keMuE-V4ba00wSFi4l0Z_w",
    place: "Near Kurttila, Uusimaa",
    shortName: "Kurttila",
    countryCode: "FI",
    country: "Finland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","FI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fi-096",
    lat: 60.45611,
    lng: 22.416759,
    panoId: "1m2i2VA5AQhAA3UmRnmI4Q",
    place: "Near Kaarina, Southwest Finland",
    shortName: "Kaarina",
    countryCode: "FI",
    country: "Finland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","FI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fi-097",
    lat: 60.803231,
    lng: 24.455767,
    panoId: "FxsO0RefqkwuBC7L_05FaQ",
    place: "Near Tervakoski, Kanta-Häme",
    shortName: "Tervakoski",
    countryCode: "FI",
    country: "Finland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","FI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fi-098",
    lat: 61.363311,
    lng: 24.238299,
    panoId: "dvc8VHb5OQuuEZpDuyU3Gw",
    place: "Near Pälkäne, Pirkanmaa",
    shortName: "Pälkäne",
    countryCode: "FI",
    country: "Finland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","FI"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "fi-099",
    lat: 64.805527,
    lng: 24.568146,
    panoId: "8e8UgLMpAPVWONV8bHFyMg",
    place: "Near Siikajoki, North Ostrobothnia",
    shortName: "Siikajoki",
    countryCode: "FI",
    country: "Finland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","FI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fi-100",
    lat: 61.72957,
    lng: 28.735663,
    panoId: "1lJ2ocfsRAP0tEzoBlmaxg",
    place: "Near Savonlinna, South Savo",
    shortName: "Savonlinna",
    countryCode: "FI",
    country: "Finland",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","FI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fi-101",
    lat: 61.759237,
    lng: 24.930268,
    panoId: "HDjogi6Rh8_xwb_j9n241A",
    place: "Near Jämsä, Central Finland",
    shortName: "Jämsä",
    countryCode: "FI",
    country: "Finland",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","FI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fi-102",
    lat: 66.13337,
    lng: 28.979561,
    panoId: "mStiRXU5D0PqkeTHZZ5UKw",
    place: "Near Kuusamo, North Ostrobothnia",
    shortName: "Kuusamo",
    countryCode: "FI",
    country: "Finland",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","FI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fi-103",
    lat: 63.051586,
    lng: 22.752906,
    panoId: "VnoZRhSE8MAzxQ-ZBNeGyQ",
    place: "Near Ylihärmä, South Ostrobothnia",
    shortName: "Ylihärmä",
    countryCode: "FI",
    country: "Finland",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","FI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fi-104",
    lat: 61.256004,
    lng: 23.240101,
    panoId: "voF38gs1dAjEc3N8ZcDmew",
    place: "Near Punkalaidun, Pirkanmaa",
    shortName: "Punkalaidun",
    countryCode: "FI",
    country: "Finland",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","FI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fi-105",
    lat: 62.4665,
    lng: 27.019426,
    panoId: "piOURLobi-WPmtK2PTWCpw",
    place: "Near Suonenjoki, North Savo",
    shortName: "Suonenjoki",
    countryCode: "FI",
    country: "Finland",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","FI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fi-106",
    lat: 60.776252,
    lng: 25.349342,
    panoId: "LWjbrBoOqv0NFlkvHeNiWA",
    place: "Near Järvelä, Paijat-Hame",
    shortName: "Järvelä",
    countryCode: "FI",
    country: "Finland",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","FI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "fi-107",
    lat: 62.874386,
    lng: 23.245962,
    panoId: "57CyFemeHfDS3GCmszSJXg",
    place: "Near Kuortane, South Ostrobothnia",
    shortName: "Kuortane",
    countryCode: "FI",
    country: "Finland",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","FI"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ie-000",
    lat: 51.89795,
    lng: -8.470622,
    panoId: "EquHIOqCaMKynIKEp3GZQw",
    place: "Near Cork, Munster",
    shortName: "Cork",
    countryCode: "IE",
    country: "Ireland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","IE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ie-001",
    lat: 54.000015,
    lng: -6.416621,
    panoId: "y0B326edcjtuA6MdrIAJqQ",
    place: "Near Dundalk, Leinster",
    shortName: "Dundalk",
    countryCode: "IE",
    country: "Ireland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","IE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ie-002",
    lat: 54.269633,
    lng: -8.469484,
    panoId: "fBHKw6KPiEhQMKPg9OpGHg",
    place: "Near Sligo, Connacht",
    shortName: "Sligo",
    countryCode: "IE",
    country: "Ireland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","IE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ie-003",
    lat: 53.718638,
    lng: -6.347749,
    panoId: "g6rKzR6JyPofA3PrYumXNg",
    place: "Near Drogheda, Leinster",
    shortName: "Drogheda",
    countryCode: "IE",
    country: "Ireland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","IE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ie-004",
    lat: 53.422764,
    lng: -7.937112,
    panoId: "8PL5NPOkEJRFTK-HdYWGvg",
    place: "Near Athlone, Leinster",
    shortName: "Athlone",
    countryCode: "IE",
    country: "Ireland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","IE"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "ie-005",
    lat: 52.664562,
    lng: -8.623059,
    panoId: "iEiQXg9Ief-gHcf7-i-OFQ",
    place: "Near Limerick, Munster",
    shortName: "Limerick",
    countryCode: "IE",
    country: "Ireland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","IE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ie-006",
    lat: 52.843744,
    lng: -8.986348,
    panoId: "gnPmeLUPtLPoBePRcKykxA",
    place: "Near Ennis, Munster",
    shortName: "Ennis",
    countryCode: "IE",
    country: "Ireland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","IE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ie-007",
    lat: 53.332988,
    lng: -6.248755,
    panoId: "sqwkRZhNXhwwXiE4_chf_g",
    place: "Near Dublin, Leinster",
    shortName: "Dublin",
    countryCode: "IE",
    country: "Ireland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","IE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ie-008",
    lat: 53.84995,
    lng: -9.299915,
    panoId: "K3_bZVczTQlvIJiS-76OIQ",
    place: "Near Castlebar, Connacht",
    shortName: "Castlebar",
    countryCode: "IE",
    country: "Ireland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","IE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ie-009",
    lat: 53.215962,
    lng: -6.666956,
    panoId: "hERiR_wKmFUc8lhFDdr4Sg",
    place: "Near Naas, Leinster",
    shortName: "Naas",
    countryCode: "IE",
    country: "Ireland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","IE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ie-010",
    lat: 53.285912,
    lng: -6.37349,
    panoId: "6p6B_ZHuky0j9Dg3sGldHw",
    place: "Near Tallaght, Leinster",
    shortName: "Tallaght",
    countryCode: "IE",
    country: "Ireland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","IE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ie-011",
    lat: 52.334025,
    lng: -6.457387,
    panoId: "cuOp3AKvnUd0n1XnCHyEkA",
    place: "Near Wexford, Leinster",
    shortName: "Wexford",
    countryCode: "IE",
    country: "Ireland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","IE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ie-012",
    lat: 53.182045,
    lng: -6.796848,
    panoId: "_tGgL7eNWOLcP8j9uB1mhQ",
    place: "Near Droichead Nua, Leinster",
    shortName: "Droichead Nua",
    countryCode: "IE",
    country: "Ireland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","IE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ie-013",
    lat: 53.034459,
    lng: -7.300075,
    panoId: "bF3bsnowl85bHzNmmT1ZBg",
    place: "Near Portlaoise, Leinster",
    shortName: "Portlaoise",
    countryCode: "IE",
    country: "Ireland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","IE"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "ie-014",
    lat: 51.87436,
    lng: -8.434909,
    panoId: "NlyXSMz1iuxrydxr9Fz8QQ",
    place: "Near Douglas, Munster",
    shortName: "Douglas",
    countryCode: "IE",
    country: "Ireland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","IE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ie-015",
    lat: 51.811462,
    lng: -8.398633,
    panoId: "bmpi62HlZRsWV_ZouK-6xQ",
    place: "Near Carrigaline, Munster",
    shortName: "Carrigaline",
    countryCode: "IE",
    country: "Ireland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","IE"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "ie-016",
    lat: 53.52514,
    lng: -7.339081,
    panoId: "1lYbOIfvTXdXFE1Ilc_enA",
    place: "Near An Muileann gCearr, Leinster",
    shortName: "An Muileann gCearr",
    countryCode: "IE",
    country: "Ireland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","IE"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "ie-017",
    lat: 52.35514,
    lng: -7.70401,
    panoId: "uz7xq2TjZLel4gQk17b83A",
    place: "Near Cluain Meala, Munster",
    shortName: "Cluain Meala",
    countryCode: "IE",
    country: "Ireland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","IE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ie-018",
    lat: 52.162244,
    lng: -7.152641,
    panoId: "ByIp9boqsOGhzlukzO58WA",
    place: "Near Trá Mhór, Munster",
    shortName: "Trá Mhór",
    countryCode: "IE",
    country: "Ireland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","IE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ie-019",
    lat: 54.116776,
    lng: -9.166671,
    panoId: "n1Yyp87yaLhz1YBrvEkKYA",
    place: "Near Ballina, Connacht",
    shortName: "Ballina",
    countryCode: "IE",
    country: "Ireland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","IE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ie-020",
    lat: 52.270725,
    lng: -9.703055,
    panoId: "mWRw_iSS9oJJjePjuIV6QQ",
    place: "Near Tralee, Munster",
    shortName: "Tralee",
    countryCode: "IE",
    country: "Ireland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","IE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ie-021",
    lat: 51.883555,
    lng: -8.583292,
    panoId: "AcI124sUpmhYcnZOJm6fqg",
    place: "Near Ballincollig, Munster",
    shortName: "Ballincollig",
    countryCode: "IE",
    country: "Ireland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","IE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ie-022",
    lat: 53.272489,
    lng: -9.050992,
    panoId: "Dz1UICQpfgoFrQjlFH9AXw",
    place: "Near Galway, Connacht",
    shortName: "Galway",
    countryCode: "IE",
    country: "Ireland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","IE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ie-023",
    lat: 51.915397,
    lng: -8.18062,
    panoId: "F7sSMqRWxe2syI0dHIEMDQ",
    place: "Near Midleton, Munster",
    shortName: "Midleton",
    countryCode: "IE",
    country: "Ireland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","IE"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "ie-024",
    lat: 54.949926,
    lng: -7.733067,
    panoId: "-vdymvQ4RUJygLFyHfRsPQ",
    place: "Near Letterkenny, Ulster",
    shortName: "Letterkenny",
    countryCode: "IE",
    country: "Ireland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","IE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ie-025",
    lat: 53.535439,
    lng: -7.33292,
    panoId: "Kv7FPadbeKSyJ-Ih0Im-Tg",
    place: "Near An Muileann gCearr, Leinster",
    shortName: "An Muileann gCearr",
    countryCode: "IE",
    country: "Ireland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","IE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ie-026",
    lat: 53.414547,
    lng: -6.149867,
    panoId: "WxCSnwoGH8RG82FbrsKkJw",
    place: "Near Portmarnock, Leinster",
    shortName: "Portmarnock",
    countryCode: "IE",
    country: "Ireland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","IE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ie-027",
    lat: 54.105236,
    lng: -9.142023,
    panoId: "lJVgzXTzYSlqT9HRa50P2g",
    place: "Near Ballina, Connacht",
    shortName: "Ballina",
    countryCode: "IE",
    country: "Ireland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","IE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ie-028",
    lat: 54.968007,
    lng: -7.745802,
    panoId: "aDs0Xlw3lgHWmO_T8OUbHw",
    place: "Near Letterkenny, Ulster",
    shortName: "Letterkenny",
    countryCode: "IE",
    country: "Ireland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","IE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ie-029",
    lat: 54.26527,
    lng: -8.431047,
    panoId: "u17_9NjgFMYyrKmgzNp6aw",
    place: "Near Sligo, Connacht",
    shortName: "Sligo",
    countryCode: "IE",
    country: "Ireland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","IE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ie-030",
    lat: 51.847497,
    lng: -8.306172,
    panoId: "6eo_-kBb9RJ93lPAXJvfEg",
    place: "Near Cobh, Munster",
    shortName: "Cobh",
    countryCode: "IE",
    country: "Ireland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","IE"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "ie-031",
    lat: 53.282038,
    lng: -9.042182,
    panoId: "f5yCTv5BDo2--JlACJdMtQ",
    place: "Near Galway, Connacht",
    shortName: "Galway",
    countryCode: "IE",
    country: "Ireland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","IE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ie-032",
    lat: 54.271933,
    lng: -8.504005,
    panoId: "pTub0siOHo6TJnzmeyZ_Hw",
    place: "Near Sligo, Connacht",
    shortName: "Sligo",
    countryCode: "IE",
    country: "Ireland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","IE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ie-033",
    lat: 53.665279,
    lng: -6.645954,
    panoId: "4VGgJ7-fDmTK1kEFGO0OqQ",
    place: "Near Navan, Leinster",
    shortName: "Navan",
    countryCode: "IE",
    country: "Ireland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","IE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ie-034",
    lat: 54.245886,
    lng: -6.971035,
    panoId: "rTnCEgB90C9RwBXTWj-k1g",
    place: "Near Monaghan, Ulster",
    shortName: "Monaghan",
    countryCode: "IE",
    country: "Ireland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","IE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ie-035",
    lat: 55.133328,
    lng: -7.450458,
    panoId: "Z-E2aU9Nb-6upibsyd80lg",
    place: "Near Buncrana, Ulster",
    shortName: "Buncrana",
    countryCode: "IE",
    country: "Ireland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","IE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ie-036",
    lat: 53.32749,
    lng: -8.219528,
    panoId: "whuXmXNxy3HtHXKaUX46lw",
    place: "Near Ballinasloe, Connacht",
    shortName: "Ballinasloe",
    countryCode: "IE",
    country: "Ireland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","IE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ie-037",
    lat: 53.990859,
    lng: -7.360337,
    panoId: "vDSbuEE1rhEqs06H118sTw",
    place: "Near Cavan, Ulster",
    shortName: "Cavan",
    countryCode: "IE",
    country: "Ireland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","IE"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "ie-038",
    lat: 53.799773,
    lng: -9.516629,
    panoId: "t-ldVpj_KD0yCy0tEgFUdg",
    place: "Near Westport, Connacht",
    shortName: "Westport",
    countryCode: "IE",
    country: "Ireland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","IE"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "ie-039",
    lat: 53.972745,
    lng: -6.71884,
    panoId: "5T1ily7B8R3RBvn-eyFUzw",
    place: "Near Carrickmacross, Ulster",
    shortName: "Carrickmacross",
    countryCode: "IE",
    country: "Ireland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","IE"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "ie-040",
    lat: 54.23125,
    lng: -6.9429,
    panoId: "NoLdrYmHQMR1d7xUIRZC_g",
    place: "Near Monaghan, Ulster",
    shortName: "Monaghan",
    countryCode: "IE",
    country: "Ireland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","IE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ie-041",
    lat: 53.17706,
    lng: -8.563149,
    panoId: "-aFF_dYjUki0VF1pIBkqGg",
    place: "Near Loughrea, Connacht",
    shortName: "Loughrea",
    countryCode: "IE",
    country: "Ireland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","IE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ie-042",
    lat: 53.2746,
    lng: -7.432282,
    panoId: "Vu5cucUw-rznNE8O2mHwyA",
    place: "Near Tullamore, Leinster",
    shortName: "Tullamore",
    countryCode: "IE",
    country: "Ireland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","IE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ie-043",
    lat: 53.044828,
    lng: -6.068678,
    panoId: "T8k4g-W_dUHD53n2DvTlPA",
    place: "Near Ashford, Leinster",
    shortName: "Ashford",
    countryCode: "IE",
    country: "Ireland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","IE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ie-044",
    lat: 53.669971,
    lng: -6.590479,
    panoId: "ZyhW1wJaxGZ3fwcsY9KsbQ",
    place: "Near Slane, Leinster",
    shortName: "Slane",
    countryCode: "IE",
    country: "Ireland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","IE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ie-045",
    lat: 52.751898,
    lng: -8.88175,
    panoId: "CRtpvRgR61fX4A_bFaS-kw",
    place: "Near Newmarket on Fergus, Munster",
    shortName: "Newmarket on Fergus",
    countryCode: "IE",
    country: "Ireland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","IE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ie-046",
    lat: 52.675627,
    lng: -7.152482,
    panoId: "Iy4hBfqzzqLERWllpcpyJA",
    place: "Near Kilkenny, Leinster",
    shortName: "Kilkenny",
    countryCode: "IE",
    country: "Ireland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","IE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ie-047",
    lat: 52.824499,
    lng: -6.12148,
    panoId: "S8zxADe6_UVnd0d9C8m4nw",
    place: "Near Arklow, Leinster",
    shortName: "Arklow",
    countryCode: "IE",
    country: "Ireland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","IE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ie-048",
    lat: 53.191433,
    lng: -6.735174,
    panoId: "O6YHlFWUvKAb0sEnXJudbA",
    place: "Near Droichead Nua, Leinster",
    shortName: "Droichead Nua",
    countryCode: "IE",
    country: "Ireland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","IE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ie-049",
    lat: 52.217996,
    lng: -7.134058,
    panoId: "9U9Ls9nlY1fq7Ecc5AIcwA",
    place: "Near Waterford, Munster",
    shortName: "Waterford",
    countryCode: "IE",
    country: "Ireland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","IE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ie-050",
    lat: 53.041377,
    lng: -7.230727,
    panoId: "g-qd32PJWhJ-iphEj5aycw",
    place: "Near Portlaoise, Leinster",
    shortName: "Portlaoise",
    countryCode: "IE",
    country: "Ireland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","IE"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "ie-051",
    lat: 52.352784,
    lng: -7.789531,
    panoId: "htwR7SGcoxxzRC1DfN70Tw",
    place: "Near Cluain Meala, Munster",
    shortName: "Cluain Meala",
    countryCode: "IE",
    country: "Ireland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","IE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ie-052",
    lat: 51.854169,
    lng: -8.500996,
    panoId: "ZeAVybiLv-L0FwZ8QKKIzQ",
    place: "Near Douglas, Munster",
    shortName: "Douglas",
    countryCode: "IE",
    country: "Ireland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","IE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ie-053",
    lat: 52.076288,
    lng: -9.419496,
    panoId: "yOV7gR8vRpsos8TPnH7BHA",
    place: "Near Killarney, Munster",
    shortName: "Killarney",
    countryCode: "IE",
    country: "Ireland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","IE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ie-054",
    lat: 52.641183,
    lng: -6.348658,
    panoId: "6CJ0SiiUUBXcPaVFtnl8uw",
    place: "Near Gorey, Leinster",
    shortName: "Gorey",
    countryCode: "IE",
    country: "Ireland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","IE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ie-055",
    lat: 52.863667,
    lng: -8.899568,
    panoId: "cm2IjCoifpI4JsivKf2WPw",
    place: "Near Ennis, Munster",
    shortName: "Ennis",
    countryCode: "IE",
    country: "Ireland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","IE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ie-056",
    lat: 52.669695,
    lng: -8.797621,
    panoId: "irN1HtHC_K8g0hYQUSnqQg",
    place: "Near Shannon, Munster",
    shortName: "Shannon",
    countryCode: "IE",
    country: "Ireland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","IE"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "ie-057",
    lat: 52.172069,
    lng: -7.262223,
    panoId: "ahhAU1kb0g3vPvrkgYylxA",
    place: "Near Trá Mhór, Munster",
    shortName: "Trá Mhór",
    countryCode: "IE",
    country: "Ireland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","IE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ie-058",
    lat: 52.629752,
    lng: -8.675194,
    panoId: "Km23bol4L10CsVQX7lAQLA",
    place: "Near Limerick, Munster",
    shortName: "Limerick",
    countryCode: "IE",
    country: "Ireland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","IE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ie-059",
    lat: 53.359157,
    lng: -7.713479,
    panoId: "2mux4SjmOYGnnZv7GpjYDA",
    place: "Near Moate, Leinster",
    shortName: "Moate",
    countryCode: "IE",
    country: "Ireland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","IE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ie-060",
    lat: 53.532638,
    lng: -7.183177,
    panoId: "BDo3w5x8KzaWuzmeHvmQ8A",
    place: "Near Killucan, Leinster",
    shortName: "Killucan",
    countryCode: "IE",
    country: "Ireland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","IE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ie-061",
    lat: 52.954105,
    lng: -6.358616,
    panoId: "99WEWOn8SbM1GKMMRPDs3g",
    place: "Near Rathdrum, Leinster",
    shortName: "Rathdrum",
    countryCode: "IE",
    country: "Ireland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","IE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ie-062",
    lat: 55.013936,
    lng: -7.712914,
    panoId: "YIL-hY_6uQyR2LfqGBFpRw",
    place: "Near Ramelton, Ulster",
    shortName: "Ramelton",
    countryCode: "IE",
    country: "Ireland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","IE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ie-063",
    lat: 54.08215,
    lng: -9.069042,
    panoId: "KGhly9mPhqgTMtkILCHWuQ",
    place: "Near Ballina, Connacht",
    shortName: "Ballina",
    countryCode: "IE",
    country: "Ireland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","IE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ie-064",
    lat: 53.318793,
    lng: -6.475372,
    panoId: "tPMOIV3XysZh0EiltW2C2A",
    place: "Near Newcastle, Leinster",
    shortName: "Newcastle",
    countryCode: "IE",
    country: "Ireland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","IE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ie-065",
    lat: 52.484232,
    lng: -6.603891,
    panoId: "wDIajybE4EWBDED2EkA1Og",
    place: "Near Enniscorthy, Leinster",
    shortName: "Enniscorthy",
    countryCode: "IE",
    country: "Ireland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","IE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ie-066",
    lat: 53.15912,
    lng: -6.85057,
    panoId: "jPYCQmYB5ShTSgeuicCw1A",
    place: "Near Kildare, Leinster",
    shortName: "Kildare",
    countryCode: "IE",
    country: "Ireland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","IE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ie-067",
    lat: 52.783444,
    lng: -7.484714,
    panoId: "2PQF6GvijwxC6KzF9MolEw",
    place: "Near Urlingford, Leinster",
    shortName: "Urlingford",
    countryCode: "IE",
    country: "Ireland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","IE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ie-068",
    lat: 53.557233,
    lng: -6.697803,
    panoId: "1QvAxiRI2h677tAJ4G6V6w",
    place: "Near Newtown Trim, Leinster",
    shortName: "Newtown Trim",
    countryCode: "IE",
    country: "Ireland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","IE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ie-069",
    lat: 52.669776,
    lng: -8.775061,
    panoId: "vd9ka4Qn8-Zv18CGF6_Tgg",
    place: "Near Shannon, Munster",
    shortName: "Shannon",
    countryCode: "IE",
    country: "Ireland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","IE"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "ie-070",
    lat: 52.706249,
    lng: -8.605839,
    panoId: "v1tQQFWGUEcV44_V0GGlDw",
    place: "Near Ardnacrusha, Munster",
    shortName: "Ardnacrusha",
    countryCode: "IE",
    country: "Ireland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","IE"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "ie-071",
    lat: 53.844513,
    lng: -9.215408,
    panoId: "TEtZMZG41wIYhqgakg1Tzg",
    place: "Near Castlebar, Connacht",
    shortName: "Castlebar",
    countryCode: "IE",
    country: "Ireland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","IE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ie-072",
    lat: 52.431201,
    lng: -7.91394,
    panoId: "yuS3AobVTDQpI1oWkkCvMQ",
    place: "Near Cahir, Munster",
    shortName: "Cahir",
    countryCode: "IE",
    country: "Ireland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","IE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ie-073",
    lat: 52.802875,
    lng: -8.72892,
    panoId: "UEiU_Jdfs7LyA8qM-rt52g",
    place: "Near Sixmilebridge, Munster",
    shortName: "Sixmilebridge",
    countryCode: "IE",
    country: "Ireland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","IE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ie-074",
    lat: 52.105332,
    lng: -8.886814,
    panoId: "U4VBWudOrclsg8_hgw5uRg",
    place: "Near Kanturk, Munster",
    shortName: "Kanturk",
    countryCode: "IE",
    country: "Ireland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","IE"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "ie-075",
    lat: 53.273127,
    lng: -8.955752,
    panoId: "OU5p_1iPZtxv1yPN2hk9qA",
    place: "Near Oranmore, Connacht",
    shortName: "Oranmore",
    countryCode: "IE",
    country: "Ireland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","IE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ie-076",
    lat: 52.20382,
    lng: -7.013882,
    panoId: "6LdXdE1IZa-eE-xU2x18PQ",
    place: "Near Dunmore East, Munster",
    shortName: "Dunmore East",
    countryCode: "IE",
    country: "Ireland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","IE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ie-077",
    lat: 51.798543,
    lng: -8.773737,
    panoId: "fqQB4Q-JyThurmy0EWiv8g",
    place: "Near Bandon, Munster",
    shortName: "Bandon",
    countryCode: "IE",
    country: "Ireland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","IE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ie-078",
    lat: 52.028809,
    lng: -7.694115,
    panoId: "xgOTDGgXWPTfMq2DYbmeeg",
    place: "Near Dungarvan, Munster",
    shortName: "Dungarvan",
    countryCode: "IE",
    country: "Ireland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","IE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ie-079",
    lat: 52.014596,
    lng: -8.210765,
    panoId: "X4K8ZgVoVLbTjn48Riqe5g",
    place: "Near Rathcormac, Munster",
    shortName: "Rathcormac",
    countryCode: "IE",
    country: "Ireland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","IE"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "ie-080",
    lat: 52.016618,
    lng: -8.570254,
    panoId: "O3GUP0cuyU45yao4_oibgw",
    place: "Near Courtbrack, Munster",
    shortName: "Courtbrack",
    countryCode: "IE",
    country: "Ireland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","IE"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "ie-081",
    lat: 55.050054,
    lng: -8.231942,
    panoId: "3S3Z7Eb64qA3ccDqEGVWnA",
    place: "Near Gweedore, Ulster",
    shortName: "Gweedore",
    countryCode: "IE",
    country: "Ireland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","IE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ie-082",
    lat: 53.811611,
    lng: -9.219642,
    panoId: "Fj-UnHKwSnNYvk7s9JUGpQ",
    place: "Near Castlebar, Connacht",
    shortName: "Castlebar",
    countryCode: "IE",
    country: "Ireland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","IE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ie-083",
    lat: 54.116594,
    lng: -6.733846,
    panoId: "a7nBV799jb04DoAZfrxY2Q",
    place: "Near Castleblayney, Ulster",
    shortName: "Castleblayney",
    countryCode: "IE",
    country: "Ireland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","IE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ie-084",
    lat: 55.022321,
    lng: -8.103057,
    panoId: "Ekkl-6HyJLZkFVfvIDEmDw",
    place: "Near Dunlewy, Ulster",
    shortName: "Dunlewy",
    countryCode: "IE",
    country: "Ireland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","IE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ie-085",
    lat: 53.772217,
    lng: -9.546348,
    panoId: "rSEJJ0s-WiHhh4iLZWyn-A",
    place: "Near Westport, Connacht",
    shortName: "Westport",
    countryCode: "IE",
    country: "Ireland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","IE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ie-086",
    lat: 53.892609,
    lng: -8.005697,
    panoId: "PvWn6dwrPL4mjWxUivuoXw",
    place: "Near Carrick-on-Shannon, Connacht",
    shortName: "Carrick-on-Shannon",
    countryCode: "IE",
    country: "Ireland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","IE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ie-087",
    lat: 53.130191,
    lng: -8.764137,
    panoId: "yXnR9Kb1jNgjArVN-X_yzg",
    place: "Near Gort, Connacht",
    shortName: "Gort",
    countryCode: "IE",
    country: "Ireland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","IE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ie-088",
    lat: 53.968914,
    lng: -8.222689,
    panoId: "qIuYoeZnQ-HT3jyIssHnUg",
    place: "Near Boyle, Connacht",
    shortName: "Boyle",
    countryCode: "IE",
    country: "Ireland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","IE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ie-089",
    lat: 53.778015,
    lng: -8.679607,
    panoId: "HVJTQYyZBOBklvnpgem8yg",
    place: "Near Ballyhaunis, Connacht",
    shortName: "Ballyhaunis",
    countryCode: "IE",
    country: "Ireland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","IE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ie-090",
    lat: 53.242212,
    lng: -8.70917,
    panoId: "p65mxM5ovvFKC0eV7-sz8A",
    place: "Near Athenry, Connacht",
    shortName: "Athenry",
    countryCode: "IE",
    country: "Ireland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","IE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ie-091",
    lat: 55.138878,
    lng: -7.576444,
    panoId: "TzPuHGcGRVGUHIYtoAGP1g",
    place: "Near Buncrana, Ulster",
    shortName: "Buncrana",
    countryCode: "IE",
    country: "Ireland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","IE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ie-092",
    lat: 53.56839,
    lng: -7.97662,
    panoId: "SrC516qa9srU70lOcgzeUQ",
    place: "Near Lanesborough, Leinster",
    shortName: "Lanesborough",
    countryCode: "IE",
    country: "Ireland",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","IE"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "ie-093",
    lat: 53.008157,
    lng: -8.615363,
    panoId: "x_QmCf99wtyRJFFnLmd05g",
    place: "Near Gort, Connacht",
    shortName: "Gort",
    countryCode: "IE",
    country: "Ireland",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","IE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ie-094",
    lat: 53.422183,
    lng: -10.097365,
    panoId: "UkDGRQ1zzlPKCLyFFstK8w",
    place: "Near Clifden, Connacht",
    shortName: "Clifden",
    countryCode: "IE",
    country: "Ireland",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","IE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ie-095",
    lat: 54.993328,
    lng: -8.441458,
    panoId: "NNmX-yEDfjiFDzDlH4UEOQ",
    place: "Near Dungloe, Ulster",
    shortName: "Dungloe",
    countryCode: "IE",
    country: "Ireland",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","IE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ie-096",
    lat: 54.034052,
    lng: -7.958894,
    panoId: "bK_WGVmUsxwjOPipsgniyw",
    place: "Near Carrick-on-Shannon, Connacht",
    shortName: "Carrick-on-Shannon",
    countryCode: "IE",
    country: "Ireland",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","IE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ie-097",
    lat: 55.204758,
    lng: -7.999323,
    panoId: "MbdUEb2j_FdJKlN9a7UTyA",
    place: "Near Dunlewy, Ulster",
    shortName: "Dunlewy",
    countryCode: "IE",
    country: "Ireland",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","IE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pl-000",
    lat: 52.406554,
    lng: 16.929568,
    panoId: "vUpgLwD09O63Ln1jqGPjcQ",
    place: "Near Poznań, Greater Poland",
    shortName: "Poznań",
    countryCode: "PL",
    country: "Poland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","PL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pl-001",
    lat: 50.061163,
    lng: 19.936426,
    panoId: "q2CUP5ukOu0256nD8tP-cw",
    place: "Near Kraków, Lesser Poland",
    shortName: "Kraków",
    countryCode: "PL",
    country: "Poland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","PL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pl-002",
    lat: 52.229566,
    lng: 21.011917,
    panoId: "Byp1nzAseVdWnQk5xFKW0w",
    place: "Near Warsaw, Mazovia",
    shortName: "Warsaw",
    countryCode: "PL",
    country: "Poland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","PL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pl-003",
    lat: 54.352257,
    lng: 18.649147,
    panoId: "bABzJvx0k4rJcOCKYe6FUg",
    place: "Near Gdańsk, Pomerania",
    shortName: "Gdańsk",
    countryCode: "PL",
    country: "Poland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","PL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pl-004",
    lat: 51.102768,
    lng: 17.030019,
    panoId: "JDVAibFLzs08eejc0moIgA",
    place: "Near Wrocław, Lower Silesia",
    shortName: "Wrocław",
    countryCode: "PL",
    country: "Poland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","PL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pl-005",
    lat: 53.428941,
    lng: 14.55302,
    panoId: "iFTjKitQQ_YmrYXCYStyVg",
    place: "Near Szczecin, West Pomerania",
    shortName: "Szczecin",
    countryCode: "PL",
    country: "Poland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","PL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pl-006",
    lat: 50.041346,
    lng: 21.999046,
    panoId: "wCyBjB1NL4xCiMziGLtSOw",
    place: "Near Rzeszów, Subcarpathia",
    shortName: "Rzeszów",
    countryCode: "PL",
    country: "Poland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","PL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pl-007",
    lat: 51.402513,
    lng: 21.147151,
    panoId: "Qk4cJCv1wrodJS4TkGSxRw",
    place: "Near Radom, Mazovia",
    shortName: "Radom",
    countryCode: "PL",
    country: "Poland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","PL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pl-008",
    lat: 54.518942,
    lng: 18.531713,
    panoId: "kCv6UvbQzy9wIxTMHIM0dA",
    place: "Near Gdynia, Pomerania",
    shortName: "Gdynia",
    countryCode: "PL",
    country: "Poland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","PL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pl-009",
    lat: 50.870307,
    lng: 20.627461,
    panoId: "VaETjziyf98-4v3SPsvXdQ",
    place: "Near Kielce, Świętokrzyskie",
    shortName: "Kielce",
    countryCode: "PL",
    country: "Poland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","PL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pl-010",
    lat: 52.733977,
    lng: 15.224663,
    panoId: "chCwN2swsdxct4403qNViA",
    place: "Near Gorzów Wielkopolski, Lubusz",
    shortName: "Gorzów Wielkopolski",
    countryCode: "PL",
    country: "Poland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","PL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pl-011",
    lat: 50.771232,
    lng: 16.284348,
    panoId: "cYe5B7mMjEf-wngrSiLTKg",
    place: "Near Wałbrzych, Lower Silesia",
    shortName: "Wałbrzych",
    countryCode: "PL",
    country: "Poland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","PL"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "pl-012",
    lat: 50.324946,
    lng: 18.785751,
    panoId: "lmLXiT2Ofs4_O6tu8okOXw",
    place: "Near Zabrze, Silesia",
    shortName: "Zabrze",
    countryCode: "PL",
    country: "Poland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","PL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pl-013",
    lat: 50.671111,
    lng: 17.926093,
    panoId: "WyF1ypJJpqw30H-uDwEfsg",
    place: "Near Opole, Opole Voivodeship",
    shortName: "Opole",
    countryCode: "PL",
    country: "Poland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","PL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pl-014",
    lat: 53.123507,
    lng: 18.007473,
    panoId: "yU9GCAtvKOCk2pN5AKZR5Q",
    place: "Near Bydgoszcz, Kujawsko-Pomorskie",
    shortName: "Bydgoszcz",
    countryCode: "PL",
    country: "Poland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","PL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pl-015",
    lat: 51.770698,
    lng: 19.474796,
    panoId: "6tCMpmwAyLUIAmQO0D9S8w",
    place: "Near Łódź, Łódź Voivodeship",
    shortName: "Łódź",
    countryCode: "PL",
    country: "Poland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","PL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pl-016",
    lat: 52.546642,
    lng: 19.706161,
    panoId: "grdvcugHAdidqxbIxVGWlA",
    place: "Near Płock, Mazovia",
    shortName: "Płock",
    countryCode: "PL",
    country: "Poland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","PL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pl-017",
    lat: 50.305906,
    lng: 18.974404,
    panoId: "cZZh_5I8hosB3VN_CGYgpg",
    place: "Near Chorzów, Silesia",
    shortName: "Chorzów",
    countryCode: "PL",
    country: "Poland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","PL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pl-018",
    lat: 50.348128,
    lng: 18.932805,
    panoId: "xpn6gFYRkuHWzPS0JXKocA",
    place: "Near Bytom, Silesia",
    shortName: "Bytom",
    countryCode: "PL",
    country: "Poland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","PL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pl-019",
    lat: 51.935439,
    lng: 15.506225,
    panoId: "z6JwIbdLsXINpDBKXfDjBg",
    place: "Near Zielona Góra, Lubusz",
    shortName: "Zielona Góra",
    countryCode: "PL",
    country: "Poland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","PL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pl-020",
    lat: 50.137033,
    lng: 18.966921,
    panoId: "z5R7ltVYcmrSR2gkd4R7dw",
    place: "Near Tychy, Silesia",
    shortName: "Tychy",
    countryCode: "PL",
    country: "Poland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","PL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pl-021",
    lat: 54.152331,
    lng: 19.407395,
    panoId: "PvWAJDfsDVcTN2JEeIK08w",
    place: "Near Elbląg, Warmia-Masuria",
    shortName: "Elbląg",
    countryCode: "PL",
    country: "Poland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","PL"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "pl-022",
    lat: 53.013717,
    lng: 18.598108,
    panoId: "-yofCxoSLarU255aovc7Rg",
    place: "Near Toruń, Kujawsko-Pomorskie",
    shortName: "Toruń",
    countryCode: "PL",
    country: "Poland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","PL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pl-023",
    lat: 53.133064,
    lng: 23.164712,
    panoId: "ZPcNPAhOrpmSzlR2tNgAWA",
    place: "Near Białystok, Podlasie",
    shortName: "Białystok",
    countryCode: "PL",
    country: "Poland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","PL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pl-024",
    lat: 50.796411,
    lng: 19.123972,
    panoId: "UHg2Kz2pKDjRVxqVkOLn6A",
    place: "Near Częstochowa, Silesia",
    shortName: "Częstochowa",
    countryCode: "PL",
    country: "Poland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","PL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pl-025",
    lat: 52.648178,
    lng: 19.067896,
    panoId: "OII2CQ5PjPxPhpGLS06iyA",
    place: "Near Włocławek, Kujawsko-Pomorskie",
    shortName: "Włocławek",
    countryCode: "PL",
    country: "Poland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","PL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pl-026",
    lat: 49.822699,
    lng: 19.046767,
    panoId: "QC04mEsIEZBzoAE9eDeCnA",
    place: "Near Bielsko-Biala, Silesia",
    shortName: "Bielsko-Biala",
    countryCode: "PL",
    country: "Poland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","PL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pl-027",
    lat: 50.257717,
    lng: 18.857882,
    panoId: "Wo4Y0tRoSLu8JxFv3Edt6g",
    place: "Near Ruda Śląska, Silesia",
    shortName: "Ruda Śląska",
    countryCode: "PL",
    country: "Poland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","PL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pl-028",
    lat: 50.297664,
    lng: 18.67647,
    panoId: "_fN7A_c0O88heBdiNWDA6w",
    place: "Near Gliwice, Silesia",
    shortName: "Gliwice",
    countryCode: "PL",
    country: "Poland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","PL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pl-029",
    lat: 50.259703,
    lng: 19.021623,
    panoId: "Pc9u5UtUwCVOleMPat5lIA",
    place: "Near Katowice, Silesia",
    shortName: "Katowice",
    countryCode: "PL",
    country: "Poland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","PL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pl-030",
    lat: 53.783974,
    lng: 20.492732,
    panoId: "0c3BeKgznoVGOxIPMcAcpA",
    place: "Near Olsztyn, Warmia-Masuria",
    shortName: "Olsztyn",
    countryCode: "PL",
    country: "Poland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","PL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pl-031",
    lat: 50.33389,
    lng: 19.204727,
    panoId: "zpZ5gES8t7hIZhPrLRL21A",
    place: "Near Dąbrowa Górnicza, Silesia",
    shortName: "Dąbrowa Górnicza",
    countryCode: "PL",
    country: "Poland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","PL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pl-032",
    lat: 51.761097,
    lng: 18.091031,
    panoId: "1-J5j2D84sfNCWZ_74rBBw",
    place: "Near Kalisz, Greater Poland",
    shortName: "Kalisz",
    countryCode: "PL",
    country: "Poland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","PL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pl-033",
    lat: 51.250582,
    lng: 22.569815,
    panoId: "POKlsOk9b2wjSto2uLauLw",
    place: "Near Lublin, Lublin",
    shortName: "Lublin",
    countryCode: "PL",
    country: "Poland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","PL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pl-034",
    lat: 51.09458,
    lng: 17.057898,
    panoId: "uM73xzqxMVcOU4GYD7L0YQ",
    place: "Near Osiedle Henrykowskie, Lower Silesia",
    shortName: "Osiedle Henrykowskie",
    countryCode: "PL",
    country: "Poland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","PL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pl-035",
    lat: 52.529784,
    lng: 19.713338,
    panoId: "4MhR44zUFrv1XfgQO801Ww",
    place: "Near Płock, Mazovia",
    shortName: "Płock",
    countryCode: "PL",
    country: "Poland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","PL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pl-036",
    lat: 54.464092,
    lng: 17.02875,
    panoId: "C4ryEgrVvAAswa2yUCQRyA",
    place: "Near Słupsk, Pomerania",
    shortName: "Słupsk",
    countryCode: "PL",
    country: "Poland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","PL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pl-037",
    lat: 51.949326,
    lng: 15.480101,
    panoId: "ZVm8vYQ-_0_8VZtawCpNfQ",
    place: "Near Zielona Góra, Lubusz",
    shortName: "Zielona Góra",
    countryCode: "PL",
    country: "Poland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","PL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pl-038",
    lat: 50.053096,
    lng: 21.991548,
    panoId: "i24fhykw1pi6dLvmf63zxA",
    place: "Near Rzeszów, Subcarpathia",
    shortName: "Rzeszów",
    countryCode: "PL",
    country: "Poland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","PL"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "pl-039",
    lat: 52.724535,
    lng: 15.205056,
    panoId: "MqSXcHXbvt4h2AP6N_G7oA",
    place: "Near Gorzów Wielkopolski, Lubusz",
    shortName: "Gorzów Wielkopolski",
    countryCode: "PL",
    country: "Poland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","PL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pl-040",
    lat: 50.226696,
    lng: 19.140445,
    panoId: "gSATIMzVo6jKGvUwA6y6Kw",
    place: "Near Mysłowice, Silesia",
    shortName: "Mysłowice",
    countryCode: "PL",
    country: "Poland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","PL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pl-041",
    lat: 52.247473,
    lng: 20.990406,
    panoId: "wvpiGwycRCQFlFhWPX-gpw",
    place: "Near Żoliborz, Mazovia",
    shortName: "Żoliborz",
    countryCode: "PL",
    country: "Poland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","PL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pl-042",
    lat: 53.142548,
    lng: 17.998902,
    panoId: "PACmRFj3fm8wqKjM0jV6Ew",
    place: "Near Bydgoszcz, Kujawsko-Pomorskie",
    shortName: "Bydgoszcz",
    countryCode: "PL",
    country: "Poland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","PL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pl-043",
    lat: 50.851783,
    lng: 20.627814,
    panoId: "9aOrZVKeN7TReGnhF4ZGsA",
    place: "Near Kielce, Świętokrzyskie",
    shortName: "Kielce",
    countryCode: "PL",
    country: "Poland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","PL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pl-044",
    lat: 50.780923,
    lng: 16.279049,
    panoId: "PHFqU_otnEMVCQK8gPieiA",
    place: "Near Wałbrzych, Lower Silesia",
    shortName: "Wałbrzych",
    countryCode: "PL",
    country: "Poland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","PL"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "pl-045",
    lat: 54.194394,
    lng: 16.17224,
    panoId: "wzc22W42Qiy1Wkw35sI4rA",
    place: "Near Koszalin, West Pomerania",
    shortName: "Koszalin",
    countryCode: "PL",
    country: "Poland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","PL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pl-046",
    lat: 53.784373,
    lng: 20.464977,
    panoId: "8_CZwiTRftmxxV9h33NqvA",
    place: "Near Olsztyn, Warmia-Masuria",
    shortName: "Olsztyn",
    countryCode: "PL",
    country: "Poland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","PL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pl-047",
    lat: 52.399772,
    lng: 16.953476,
    panoId: "Q69RHl5ncLCmX5scxZSV0w",
    place: "Near Poznań, Greater Poland",
    shortName: "Poznań",
    countryCode: "PL",
    country: "Poland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","PL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pl-048",
    lat: 53.115707,
    lng: 23.149448,
    panoId: "3CpllcdLGkNea5raFSSy9A",
    place: "Near Białystok, Podlasie",
    shortName: "Białystok",
    countryCode: "PL",
    country: "Poland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","PL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pl-049",
    lat: 53.420705,
    lng: 14.519803,
    panoId: "YSQoUpcPZNERbybkss_E-w",
    place: "Near Świerczewo, West Pomerania",
    shortName: "Świerczewo",
    countryCode: "PL",
    country: "Poland",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","PL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pl-050",
    lat: 50.139402,
    lng: 18.545999,
    panoId: "48wAW9IkPlYDX4KtqbElaw",
    place: "Near Książenice, Silesia",
    shortName: "Książenice",
    countryCode: "PL",
    country: "Poland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","PL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pl-051",
    lat: 50.324543,
    lng: 19.291832,
    panoId: "9_xc4wJWzJlkeTdYbynQJA",
    place: "Near Dąbrowa Górnicza, Silesia",
    shortName: "Dąbrowa Górnicza",
    countryCode: "PL",
    country: "Poland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","PL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pl-052",
    lat: 50.345376,
    lng: 18.983048,
    panoId: "6hAEH3lLCAXI4WjFPn-TAQ",
    place: "Near Brzeziny Śląskie, Silesia",
    shortName: "Brzeziny Śląskie",
    countryCode: "PL",
    country: "Poland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","PL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pl-053",
    lat: 50.364251,
    lng: 18.791418,
    panoId: "PanYswL3kzkRkH9ZEhC1DQ",
    place: "Near Wieszowa, Silesia",
    shortName: "Wieszowa",
    countryCode: "PL",
    country: "Poland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","PL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pl-054",
    lat: 50.820976,
    lng: 19.159077,
    panoId: "2iW9rZMvYVBLSefHqhGMrA",
    place: "Near Częstochowa, Silesia",
    shortName: "Częstochowa",
    countryCode: "PL",
    country: "Poland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","PL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pl-055",
    lat: 50.138745,
    lng: 19.037014,
    panoId: "U648OQpD5cKT0N_q52ryxQ",
    place: "Near Tychy, Silesia",
    shortName: "Tychy",
    countryCode: "PL",
    country: "Poland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","PL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pl-056",
    lat: 49.865989,
    lng: 19.102756,
    panoId: "gLtevVHWQBQ9qK54ROs56g",
    place: "Near Janowice, Silesia",
    shortName: "Janowice",
    countryCode: "PL",
    country: "Poland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","PL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pl-057",
    lat: 50.372659,
    lng: 18.977422,
    panoId: "Gz2356jSGRmN4IYDruY79A",
    place: "Near Bobrowniki, Silesia",
    shortName: "Bobrowniki",
    countryCode: "PL",
    country: "Poland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","PL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pl-058",
    lat: 50.807692,
    lng: 20.595298,
    panoId: "uEmoryk5CqbcbOVSItP8xA",
    place: "Near Osiedle-Nowiny, Świętokrzyskie",
    shortName: "Osiedle-Nowiny",
    countryCode: "PL",
    country: "Poland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","PL"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "pl-059",
    lat: 50.34439,
    lng: 18.406272,
    panoId: "0_x1bakBVd8PQtR4_rWBrQ",
    place: "Near Rudziniec, Silesia",
    shortName: "Rudziniec",
    countryCode: "PL",
    country: "Poland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","PL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pl-060",
    lat: 54.162902,
    lng: 19.341427,
    panoId: "2qltlfqLDedE0oDUjpJpgg",
    place: "Near Elbląg, Warmia-Masuria",
    shortName: "Elbląg",
    countryCode: "PL",
    country: "Poland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","PL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pl-061",
    lat: 53.150453,
    lng: 17.976506,
    panoId: "iAecKgqNGKfERRfJA5vB9A",
    place: "Near Bydgoszcz, Kujawsko-Pomorskie",
    shortName: "Bydgoszcz",
    countryCode: "PL",
    country: "Poland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","PL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pl-062",
    lat: 54.466496,
    lng: 17.117363,
    panoId: "apqvzhfsZ9ywYfXyC5Vrzw",
    place: "Near Słupsk, Pomerania",
    shortName: "Słupsk",
    countryCode: "PL",
    country: "Poland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","PL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pl-063",
    lat: 54.567411,
    lng: 18.484848,
    panoId: "0JAS0poaaCddf_-hOP--cw",
    place: "Near Pogórze, Pomerania",
    shortName: "Pogórze",
    countryCode: "PL",
    country: "Poland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","PL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pl-064",
    lat: 52.444861,
    lng: 16.876776,
    panoId: "D9UptFUDj--RlCkZvuCTzw",
    place: "Near Suchy Las, Greater Poland",
    shortName: "Suchy Las",
    countryCode: "PL",
    country: "Poland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","PL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pl-065",
    lat: 52.695341,
    lng: 15.133345,
    panoId: "sxrFLKUDgXnYEMQmlq5NQg",
    place: "Near Jenin, Lubusz",
    shortName: "Jenin",
    countryCode: "PL",
    country: "Poland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","PL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pl-066",
    lat: 54.339922,
    lng: 18.746211,
    panoId: "n1Mo37AOaL_l2QTRRgu2MA",
    place: "Near Krakowiec-Górki Zachodnie, Pomerania",
    shortName: "Krakowiec-Górki Zachodnie",
    countryCode: "PL",
    country: "Poland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","PL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pl-067",
    lat: 53.49148,
    lng: 14.539009,
    panoId: "2_Vumx1O0QF5W2kD6vCcAw",
    place: "Near Pilchowo, West Pomerania",
    shortName: "Pilchowo",
    countryCode: "PL",
    country: "Poland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","PL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pl-068",
    lat: 50.05261,
    lng: 21.014066,
    panoId: "wS9XbETB8sxVEB234P5kRA",
    place: "Near Lisia Góra, Lesser Poland",
    shortName: "Lisia Góra",
    countryCode: "PL",
    country: "Poland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","PL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pl-069",
    lat: 53.736313,
    lng: 20.539355,
    panoId: "P6RKuq3BNcw5b3v00BaY8g",
    place: "Near Kortowo, Warmia-Masuria",
    shortName: "Kortowo",
    countryCode: "PL",
    country: "Poland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","PL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pl-070",
    lat: 53.104475,
    lng: 23.180595,
    panoId: "eQNlqa_0B2pJV_qFBqHIBQ",
    place: "Near Białystok, Podlasie",
    shortName: "Białystok",
    countryCode: "PL",
    country: "Poland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","PL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pl-071",
    lat: 51.972463,
    lng: 15.452909,
    panoId: "OWgDLTJmdEDhTtlh5vCNAA",
    place: "Near Czerwieńsk, Lubusz",
    shortName: "Czerwieńsk",
    countryCode: "PL",
    country: "Poland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","PL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pl-072",
    lat: 53.037356,
    lng: 18.672171,
    panoId: "dduEsQsVsffAuOwE2e2Xxw",
    place: "Near Lubicz Dolny, Kujawsko-Pomorskie",
    shortName: "Lubicz Dolny",
    countryCode: "PL",
    country: "Poland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","PL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pl-073",
    lat: 51.438774,
    lng: 21.181253,
    panoId: "olPLJnRzfd66QtdFEXarOw",
    place: "Near Radom, Mazovia",
    shortName: "Radom",
    countryCode: "PL",
    country: "Poland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","PL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pl-074",
    lat: 50.377181,
    lng: 18.829414,
    panoId: "MOnSRD5lr_4Wo-tW0x0UMQ",
    place: "Near Wieszowa, Silesia",
    shortName: "Wieszowa",
    countryCode: "PL",
    country: "Poland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","PL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pl-075",
    lat: 50.35233,
    lng: 18.889754,
    panoId: "LreR6BIVPdyQLlYxWoGOSQ",
    place: "Near Bytom, Silesia",
    shortName: "Bytom",
    countryCode: "PL",
    country: "Poland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","PL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pl-076",
    lat: 50.120359,
    lng: 20.003984,
    panoId: "Zs-QI9LvLThplx8Ti_Vstw",
    place: "Near Bieńczyce, Lesser Poland",
    shortName: "Bieńczyce",
    countryCode: "PL",
    country: "Poland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","PL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pl-077",
    lat: 51.804735,
    lng: 18.180058,
    panoId: "GY4xqO7RK2vwVTO1lTizvA",
    place: "Near Żelazków, Greater Poland",
    shortName: "Żelazków",
    countryCode: "PL",
    country: "Poland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","PL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pl-078",
    lat: 51.228001,
    lng: 16.241056,
    panoId: "Ru04h6ufY2eB3NXUmcQBVA",
    place: "Near Kunice, Lower Silesia",
    shortName: "Kunice",
    countryCode: "PL",
    country: "Poland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","PL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pl-079",
    lat: 50.226763,
    lng: 19.08491,
    panoId: "tiKiyxeQSJYgwCTZfAW14Q",
    place: "Near Murcki, Silesia",
    shortName: "Murcki",
    countryCode: "PL",
    country: "Poland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","PL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pl-080",
    lat: 52.70857,
    lng: 19.124979,
    panoId: "9l6mW5Id7DSJbDIZSNmSXA",
    place: "Near Fabianki, Kujawsko-Pomorskie",
    shortName: "Fabianki",
    countryCode: "PL",
    country: "Poland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","PL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pl-081",
    lat: 50.459694,
    lng: 19.136398,
    panoId: "ea5pBtHCSiQCkJ-kz_dvIQ",
    place: "Near Mierzęcice, Silesia",
    shortName: "Mierzęcice",
    countryCode: "PL",
    country: "Poland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","PL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pl-082",
    lat: 50.677995,
    lng: 19.257346,
    panoId: "PaaE6GkSMLsdQlUJP_ufmQ",
    place: "Near Choroń, Silesia",
    shortName: "Choroń",
    countryCode: "PL",
    country: "Poland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","PL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pl-083",
    lat: 52.744171,
    lng: 18.20786,
    panoId: "5-7hdKyXPBaAAxt1_WqpYA",
    place: "Near Janikowo, Kujawsko-Pomorskie",
    shortName: "Janikowo",
    countryCode: "PL",
    country: "Poland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","PL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pl-084",
    lat: 50.7158,
    lng: 17.856972,
    panoId: "krmiHhM-vOjkIhQ1R1dyRg",
    place: "Near Czarnowąsy, Opole Voivodeship",
    shortName: "Czarnowąsy",
    countryCode: "PL",
    country: "Poland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","PL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pl-085",
    lat: 52.283808,
    lng: 18.196243,
    panoId: "Or2MmROPNOui80ran6LEKw",
    place: "Near Kazimierz Biskupi, Greater Poland",
    shortName: "Kazimierz Biskupi",
    countryCode: "PL",
    country: "Poland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","PL"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "pl-086",
    lat: 50.440153,
    lng: 18.816728,
    panoId: "7FqbrccsvYCa7na0xDAKuw",
    place: "Near Tarnowskie Góry, Silesia",
    shortName: "Tarnowskie Góry",
    countryCode: "PL",
    country: "Poland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","PL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pl-087",
    lat: 51.2861,
    lng: 22.613057,
    panoId: "9nQGe7SZ2__14mZWiMxuhQ",
    place: "Near Jakubowice Murowane, Lublin",
    shortName: "Jakubowice Murowane",
    countryCode: "PL",
    country: "Poland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","PL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pl-088",
    lat: 54.099936,
    lng: 19.361088,
    panoId: "dPpfBIFEUNWmD_eLxNtOCg",
    place: "Near Gronowo Elbląskie, Warmia-Masuria",
    shortName: "Gronowo Elbląskie",
    countryCode: "PL",
    country: "Poland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","PL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pl-089",
    lat: 49.633483,
    lng: 20.593923,
    panoId: "CT87Em9xQR13KSZEMHSdng",
    place: "Near Chełmiec, Lesser Poland",
    shortName: "Chełmiec",
    countryCode: "PL",
    country: "Poland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","PL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pl-090",
    lat: 50.074628,
    lng: 20.959208,
    panoId: "e4jmej5NDTU7vlWl9dheew",
    place: "Near Łukowa, Lesser Poland",
    shortName: "Łukowa",
    countryCode: "PL",
    country: "Poland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","PL"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "pl-091",
    lat: 51.447126,
    lng: 19.693689,
    panoId: "tzrFXEylMTUnp9eCjGoA4g",
    place: "Near Piotrków Trybunalski, Łódź Voivodeship",
    shortName: "Piotrków Trybunalski",
    countryCode: "PL",
    country: "Poland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","PL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pl-092",
    lat: 51.662011,
    lng: 17.85961,
    panoId: "SNGu9005-vXKXgwfo1vk6Q",
    place: "Near Ostrów Wielkopolski, Greater Poland",
    shortName: "Ostrów Wielkopolski",
    countryCode: "PL",
    country: "Poland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","PL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pl-093",
    lat: 53.330757,
    lng: 14.949184,
    panoId: "VYytp1iSwePmLzduI13Ewg",
    place: "Near Kobylanka, West Pomerania",
    shortName: "Kobylanka",
    countryCode: "PL",
    country: "Poland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","PL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pl-094",
    lat: 51.368433,
    lng: 16.157898,
    panoId: "2vXpD0HRz0ZaurwzOu8d1g",
    place: "Near Lubin, Lower Silesia",
    shortName: "Lubin",
    countryCode: "PL",
    country: "Poland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","PL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pl-095",
    lat: 54.220905,
    lng: 16.227347,
    panoId: "Gei7k7QXBfBn85zb8h7VSw",
    place: "Near Sianów, West Pomerania",
    shortName: "Sianów",
    countryCode: "PL",
    country: "Poland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","PL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pl-096",
    lat: 54.165444,
    lng: 23.006482,
    panoId: "U4sTiDMIybpeKaufXr2e6g",
    place: "Near Suwałki, Podlasie",
    shortName: "Suwałki",
    countryCode: "PL",
    country: "Poland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","PL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pl-097",
    lat: 53.189308,
    lng: 18.088154,
    panoId: "Q_Jp_T_NEm3OnIYBBPXiCA",
    place: "Near Osielsko, Kujawsko-Pomorskie",
    shortName: "Osielsko",
    countryCode: "PL",
    country: "Poland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","PL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pl-098",
    lat: 52.557489,
    lng: 17.621457,
    panoId: "wwVFbAYrL1xcEaqW-E_lSQ",
    place: "Near Gniezno, Greater Poland",
    shortName: "Gniezno",
    countryCode: "PL",
    country: "Poland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","PL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pl-099",
    lat: 49.825477,
    lng: 22.808452,
    panoId: "lkZNP2HLWvx11nE3wDUZbQ",
    place: "Near Żurawica, Subcarpathia",
    shortName: "Żurawica",
    countryCode: "PL",
    country: "Poland",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","PL"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "pl-100",
    lat: 51.189038,
    lng: 19.267017,
    panoId: "1Sbe4dVqP0LNlso59UxFTg",
    place: "Near Kleszczów, Łódź Voivodeship",
    shortName: "Kleszczów",
    countryCode: "PL",
    country: "Poland",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","PL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pl-101",
    lat: 51.250898,
    lng: 21.803673,
    panoId: "8YtJUu1rwvuhG5Dp9oSVMg",
    place: "Near Chotcza, Mazovia",
    shortName: "Chotcza",
    countryCode: "PL",
    country: "Poland",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","PL"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "pl-102",
    lat: 51.511902,
    lng: 17.660616,
    panoId: "oz1r-l4i38BtTilCshdSug",
    place: "Near Sośnie, Greater Poland",
    shortName: "Sośnie",
    countryCode: "PL",
    country: "Poland",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","PL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pl-103",
    lat: 50.747585,
    lng: 23.512409,
    panoId: "RTTtQnAQEI_Op_ytkKXxPg",
    place: "Near Miączyn, Lublin",
    shortName: "Miączyn",
    countryCode: "PL",
    country: "Poland",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","PL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pl-104",
    lat: 50.21762,
    lng: 18.118993,
    panoId: "7j2nOWTCrHalM2BXUXyLeA",
    place: "Near Polska Cerekiew, Opole Voivodeship",
    shortName: "Polska Cerekiew",
    countryCode: "PL",
    country: "Poland",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","PL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pl-105",
    lat: 53.490491,
    lng: 15.255285,
    panoId: "GmqFXdBmPzn95wEuWyTzBQ",
    place: "Near Chociwel, West Pomerania",
    shortName: "Chociwel",
    countryCode: "PL",
    country: "Poland",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","PL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cz-000",
    lat: 50.503201,
    lng: 13.6362,
    panoId: "mFupbLzJ5L9TrSDchJdecA",
    place: "Near Most, Ústí nad Labem Region",
    shortName: "Most",
    countryCode: "CZ",
    country: "Czechia",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","CZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cz-001",
    lat: 49.747555,
    lng: 13.376779,
    panoId: "qhw3AMNrvpZ_7Y0SFkKZ5w",
    place: "Near Pilsen, Plzeň Region",
    shortName: "Pilsen",
    countryCode: "CZ",
    country: "Czechia",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","CZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cz-002",
    lat: 49.226447,
    lng: 17.670672,
    panoId: "b3k_roSONtJ5reZoljq7kg",
    place: "Near Zlín, Zlín",
    shortName: "Zlín",
    countryCode: "CZ",
    country: "Czechia",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","CZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cz-003",
    lat: 49.308812,
    lng: 14.147579,
    panoId: "YMyugbR8S2MD5hijPAGEHA",
    place: "Near Písek, South Bohemian Region",
    shortName: "Písek",
    countryCode: "CZ",
    country: "Czechia",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","CZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cz-004",
    lat: 48.974071,
    lng: 14.474224,
    panoId: "S2iZk1cAYaMb5Gd9tKKuVw",
    place: "Near České Budějovice, South Bohemian Region",
    shortName: "České Budějovice",
    countryCode: "CZ",
    country: "Czechia",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","CZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cz-005",
    lat: 49.195272,
    lng: 16.608211,
    panoId: "rdD9v_oI67zEPgvWuqt9AQ",
    place: "Near Brno, South Moravian",
    shortName: "Brno",
    countryCode: "CZ",
    country: "Czechia",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","CZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cz-006",
    lat: 49.682711,
    lng: 18.348614,
    panoId: "FyjMmh3IB4M_lcvbVsDlGA",
    place: "Near Frýdek-Místek, Moravian-Silesian Region",
    shortName: "Frýdek-Místek",
    countryCode: "CZ",
    country: "Czechia",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","CZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cz-007",
    lat: 49.45543,
    lng: 17.451614,
    panoId: "p2xgMgIO80i4eM8MoIvz6w",
    place: "Near Přerov, Olomouc Region",
    shortName: "Přerov",
    countryCode: "CZ",
    country: "Czechia",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","CZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cz-008",
    lat: 50.660674,
    lng: 14.032243,
    panoId: "MN8dq283Zqwjdlicq5S9ug",
    place: "Near Ústí nad Labem, Ústí nad Labem Region",
    shortName: "Ústí nad Labem",
    countryCode: "CZ",
    country: "Czechia",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","CZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cz-009",
    lat: 49.853988,
    lng: 18.541574,
    panoId: "N2fcEExBAodOAIZHzUANfQ",
    place: "Near Karviná, Moravian-Silesian Region",
    shortName: "Karviná",
    countryCode: "CZ",
    country: "Czechia",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","CZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cz-010",
    lat: 50.724343,
    lng: 15.170759,
    panoId: "Uw9EUTEGBxSlbnKERDtc5Q",
    place: "Near Jablonec nad Nisou, Liberec Region",
    shortName: "Jablonec nad Nisou",
    countryCode: "CZ",
    country: "Czechia",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","CZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cz-011",
    lat: 50.767043,
    lng: 15.056167,
    panoId: "7aVHaMMflawO1liGDErEWQ",
    place: "Near Liberec, Liberec Region",
    shortName: "Liberec",
    countryCode: "CZ",
    country: "Czechia",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","CZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cz-012",
    lat: 49.595445,
    lng: 17.251831,
    panoId: "c0O4X_yF7Ggv5LGodvHBVg",
    place: "Near Olomouc, Olomouc Region",
    shortName: "Olomouc",
    countryCode: "CZ",
    country: "Czechia",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","CZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cz-013",
    lat: 49.395964,
    lng: 15.591002,
    panoId: "bCDYw7lR-cUnYFYyEkEEPw",
    place: "Near Jihlava, Vysocina",
    shortName: "Jihlava",
    countryCode: "CZ",
    country: "Czechia",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","CZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cz-014",
    lat: 50.640309,
    lng: 13.824334,
    panoId: "RqyN7X5Gf6iYvo0ciAGbDw",
    place: "Near Teplice, Ústí nad Labem Region",
    shortName: "Teplice",
    countryCode: "CZ",
    country: "Czechia",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","CZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cz-015",
    lat: 49.471992,
    lng: 17.11211,
    panoId: "IvZxi-r-ssgywNhNks8XwQ",
    place: "Near Prostějov, Olomouc Region",
    shortName: "Prostějov",
    countryCode: "CZ",
    country: "Czechia",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","CZ"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "cz-016",
    lat: 49.689896,
    lng: 14.01001,
    panoId: "TfVwe7TGLHYmaMwsDlrJuA",
    place: "Near Příbram, Central Bohemia",
    shortName: "Příbram",
    countryCode: "CZ",
    country: "Czechia",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","CZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cz-017",
    lat: 50.460487,
    lng: 13.417805,
    panoId: "bVKhyZz0PUFBjDpwWtI5_Q",
    place: "Near Chomutov, Ústí nad Labem Region",
    shortName: "Chomutov",
    countryCode: "CZ",
    country: "Czechia",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","CZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cz-018",
    lat: 49.677708,
    lng: 18.670815,
    panoId: "bOKKX-QHPEjPGBoBKnxmvA",
    place: "Near Třinec, Moravian-Silesian Region",
    shortName: "Třinec",
    countryCode: "CZ",
    country: "Czechia",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","CZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cz-019",
    lat: 50.232723,
    lng: 12.871204,
    panoId: "q4vkXTJe-flJ9wqCA-5p0Q",
    place: "Near Karlovy Vary, Carlsbad Region",
    shortName: "Karlovy Vary",
    countryCode: "CZ",
    country: "Czechia",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","CZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cz-020",
    lat: 49.214991,
    lng: 15.881719,
    panoId: "TRC24wlrDgqIfy8QDTXZdQ",
    place: "Near Třebíč, Vysocina",
    shortName: "Třebíč",
    countryCode: "CZ",
    country: "Czechia",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","CZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cz-021",
    lat: 49.965344,
    lng: 16.97093,
    panoId: "rEZ4KgisaKV4gg39zPCuqA",
    place: "Near Šumperk, Olomouc Region",
    shortName: "Šumperk",
    countryCode: "CZ",
    country: "Czechia",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","CZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cz-022",
    lat: 49.414369,
    lng: 14.657819,
    panoId: "rxn-lnAiHaDX3czN5dn21w",
    place: "Near Tábor, South Bohemian Region",
    shortName: "Tábor",
    countryCode: "CZ",
    country: "Czechia",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","CZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cz-023",
    lat: 49.834813,
    lng: 18.28184,
    panoId: "FXNyeGpaicl0Ikj3PtUHxQ",
    place: "Near Ostrava, Moravian-Silesian Region",
    shortName: "Ostrava",
    countryCode: "CZ",
    country: "Czechia",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","CZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cz-024",
    lat: 50.411309,
    lng: 14.903072,
    panoId: "sPEPGGDkpgdC0yTTfTJt_Q",
    place: "Near Mladá Boleslav, Central Bohemia",
    shortName: "Mladá Boleslav",
    countryCode: "CZ",
    country: "Czechia",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","CZ"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "cz-025",
    lat: 50.079653,
    lng: 12.373602,
    panoId: "xJxUOJ5Fn0m3gSSgO9Nrbw",
    place: "Near Cheb, Carlsbad Region",
    shortName: "Cheb",
    countryCode: "CZ",
    country: "Czechia",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","CZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cz-026",
    lat: 49.938563,
    lng: 17.902416,
    panoId: "diXMu1TdLiFV5qGSc8FkCA",
    place: "Near Opava, Moravian-Silesian Region",
    shortName: "Opava",
    countryCode: "CZ",
    country: "Czechia",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","CZ"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "cz-027",
    lat: 48.855226,
    lng: 16.04843,
    panoId: "-CZ2eJHE9qtqSffoXYhRmA",
    place: "Near Znojmo, South Moravian",
    shortName: "Znojmo",
    countryCode: "CZ",
    country: "Czechia",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","CZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cz-028",
    lat: 50.782222,
    lng: 14.214667,
    panoId: "QhhaN9Uh_pLqXxPg3MOM3g",
    place: "Near Děčín, Ústí nad Labem Region",
    shortName: "Děčín",
    countryCode: "CZ",
    country: "Czechia",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","CZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cz-029",
    lat: 49.77986,
    lng: 18.437553,
    panoId: "Tl5NizAqNXiNZ2y92_tjag",
    place: "Near Havířov, Moravian-Silesian Region",
    shortName: "Havířov",
    countryCode: "CZ",
    country: "Czechia",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","CZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cz-030",
    lat: 50.087974,
    lng: 14.420927,
    panoId: "VJNtOBjvDmv3NY-Jx83jKw",
    place: "Near Prague, Prague",
    shortName: "Prague",
    countryCode: "CZ",
    country: "Czechia",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","CZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cz-031",
    lat: 50.028115,
    lng: 15.199898,
    panoId: "0ffZ0z5Zx6MqqXAT7unGPQ",
    place: "Near Kolín, Central Bohemia",
    shortName: "Kolín",
    countryCode: "CZ",
    country: "Czechia",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","CZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cz-032",
    lat: 49.471861,
    lng: 17.97114,
    panoId: "xbWP08Q1DVpojwx6JkANDw",
    place: "Near Valašské Meziříčí, Zlín",
    shortName: "Valašské Meziříčí",
    countryCode: "CZ",
    country: "Czechia",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","CZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cz-033",
    lat: 49.845401,
    lng: 18.429887,
    panoId: "pIAJ1sJUvPvoPOC67OtwMw",
    place: "Near Orlová, Moravian-Silesian Region",
    shortName: "Orlová",
    countryCode: "CZ",
    country: "Czechia",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","CZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cz-034",
    lat: 49.676889,
    lng: 14.018633,
    panoId: "H-kWgkNcEFDwxXo03IUonQ",
    place: "Near Příbram, Central Bohemia",
    shortName: "Příbram",
    countryCode: "CZ",
    country: "Czechia",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","CZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cz-035",
    lat: 49.399768,
    lng: 15.567432,
    panoId: "anPTAt2lROdrPiQ0eZVoJQ",
    place: "Near Jihlava, Vysocina",
    shortName: "Jihlava",
    countryCode: "CZ",
    country: "Czechia",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","CZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cz-036",
    lat: 49.67551,
    lng: 18.325112,
    panoId: "iQp2u1KiCdbkOQraBhPUdQ",
    place: "Near Sviadnov, Moravian-Silesian Region",
    shortName: "Sviadnov",
    countryCode: "CZ",
    country: "Czechia",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","CZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cz-037",
    lat: 49.678016,
    lng: 18.689475,
    panoId: "wUosJandq6FNqV3vnQwNgA",
    place: "Near Třinec, Moravian-Silesian Region",
    shortName: "Třinec",
    countryCode: "CZ",
    country: "Czechia",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","CZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cz-038",
    lat: 49.843336,
    lng: 18.558901,
    panoId: "yPnur349B5pXyk4nmJi0xA",
    place: "Near Karviná, Moravian-Silesian Region",
    shortName: "Karviná",
    countryCode: "CZ",
    country: "Czechia",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","CZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cz-039",
    lat: 49.435009,
    lng: 14.657006,
    panoId: "WTSwqZPnCl15uHC4y2G7wg",
    place: "Near Tábor, South Bohemian Region",
    shortName: "Tábor",
    countryCode: "CZ",
    country: "Czechia",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","CZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cz-040",
    lat: 48.960064,
    lng: 14.486394,
    panoId: "APbJ5CvFmLUwoyTW1HOB1g",
    place: "Near České Budějovice, South Bohemian Region",
    shortName: "České Budějovice",
    countryCode: "CZ",
    country: "Czechia",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","CZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cz-041",
    lat: 49.215032,
    lng: 17.661045,
    panoId: "m4ywq08MERLPhgxEpVeHOQ",
    place: "Near Zlín, Zlín",
    shortName: "Zlín",
    countryCode: "CZ",
    country: "Czechia",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","CZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cz-042",
    lat: 50.637182,
    lng: 13.79254,
    panoId: "cE5KJ7bsnjiv3_p2DnkgLA",
    place: "Near Teplice, Ústí nad Labem Region",
    shortName: "Teplice",
    countryCode: "CZ",
    country: "Czechia",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","CZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cz-043",
    lat: 49.452974,
    lng: 17.116321,
    panoId: "WA_0w3jm8FM-fyWrbwh3rg",
    place: "Near Prostějov, Olomouc Region",
    shortName: "Prostějov",
    countryCode: "CZ",
    country: "Czechia",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","CZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cz-044",
    lat: 49.297909,
    lng: 17.393296,
    panoId: "ryx5Y-mD23tLUfZGRK09EA",
    place: "Near Kroměříž, Zlín",
    shortName: "Kroměříž",
    countryCode: "CZ",
    country: "Czechia",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","CZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cz-045",
    lat: 50.449047,
    lng: 13.444217,
    panoId: "M1FFkCue3tUnVSbQbytgAQ",
    place: "Near Údlice, Ústí nad Labem Region",
    shortName: "Údlice",
    countryCode: "CZ",
    country: "Czechia",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","CZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cz-046",
    lat: 50.089308,
    lng: 12.401701,
    panoId: "rtbt1oqT59jZlN3YIfKXTg",
    place: "Near Cheb, Carlsbad Region",
    shortName: "Cheb",
    countryCode: "CZ",
    country: "Czechia",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","CZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cz-047",
    lat: 49.580578,
    lng: 17.228883,
    panoId: "4EvT925W0FA33tlDeMv_Qg",
    place: "Near Olomouc, Olomouc Region",
    shortName: "Olomouc",
    countryCode: "CZ",
    country: "Czechia",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","CZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cz-048",
    lat: 50.560751,
    lng: 15.92352,
    panoId: "CyDAcVrBStm_oxc4aQ5yRw",
    place: "Near Trutnov, Hradec Králové Region",
    shortName: "Trutnov",
    countryCode: "CZ",
    country: "Czechia",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","CZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cz-049",
    lat: 50.670741,
    lng: 14.049103,
    panoId: "obYYLjwSGVMJ-l-1-c1Kjw",
    place: "Near Ústí nad Labem, Ústí nad Labem Region",
    shortName: "Ústí nad Labem",
    countryCode: "CZ",
    country: "Czechia",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","CZ"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "cz-050",
    lat: 49.758513,
    lng: 18.465816,
    panoId: "95QcHub-_k3VIZpMPY8G9Q",
    place: "Near Horní Těrlicko, Moravian-Silesian Region",
    shortName: "Horní Těrlicko",
    countryCode: "CZ",
    country: "Czechia",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","CZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cz-051",
    lat: 49.845704,
    lng: 18.182083,
    panoId: "FaXsUlQjD_f1UwR0Do6rug",
    place: "Near Vřesina, Moravian-Silesian Region",
    shortName: "Vřesina",
    countryCode: "CZ",
    country: "Czechia",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","CZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cz-052",
    lat: 49.987585,
    lng: 17.85681,
    panoId: "wD7D1VJKnDoV0Dr5Y81cMg",
    place: "Near Holasovice, Moravian-Silesian Region",
    shortName: "Holasovice",
    countryCode: "CZ",
    country: "Czechia",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","CZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cz-053",
    lat: 50.733467,
    lng: 15.118732,
    panoId: "ngY1pER99gbo-NumQzOJHQ",
    place: "Near Jablonec nad Nisou, Liberec Region",
    shortName: "Jablonec nad Nisou",
    countryCode: "CZ",
    country: "Czechia",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","CZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cz-054",
    lat: 50.259589,
    lng: 12.865588,
    panoId: "TpbvkkwRJoVXgmAtLSY1mQ",
    place: "Near Sadov, Carlsbad Region",
    shortName: "Sadov",
    countryCode: "CZ",
    country: "Czechia",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","CZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cz-055",
    lat: 49.726412,
    lng: 18.36609,
    panoId: "Tsnxopt9DBHlaSttCILjYw",
    place: "Near Sedliště, Moravian-Silesian Region",
    shortName: "Sedliště",
    countryCode: "CZ",
    country: "Czechia",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","CZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cz-056",
    lat: 49.619551,
    lng: 14.020754,
    panoId: "BiMRrLOod2ez47YVSSaaRQ",
    place: "Near Milín, Central Bohemia",
    shortName: "Milín",
    countryCode: "CZ",
    country: "Czechia",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","CZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cz-057",
    lat: 49.436083,
    lng: 17.388016,
    panoId: "HeIIrxLZi7dkquXMYdwyVw",
    place: "Near Troubky, Olomouc Region",
    shortName: "Troubky",
    countryCode: "CZ",
    country: "Czechia",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","CZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cz-058",
    lat: 49.75165,
    lng: 18.477769,
    panoId: "1NYNWQBPeyX5hYvwHM8lHw",
    place: "Near Horní Těrlicko, Moravian-Silesian Region",
    shortName: "Horní Těrlicko",
    countryCode: "CZ",
    country: "Czechia",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","CZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cz-059",
    lat: 50.778953,
    lng: 15.229666,
    panoId: "Z-OHtS1OZsLascVAlYQ73g",
    place: "Near Josefův Důl, Liberec Region",
    shortName: "Josefův Důl",
    countryCode: "CZ",
    country: "Czechia",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","CZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cz-060",
    lat: 50.591812,
    lng: 13.991781,
    panoId: "Fll_s5cMKzxDjEPcwF9RZg",
    place: "Near Řehlovice, Ústí nad Labem Region",
    shortName: "Řehlovice",
    countryCode: "CZ",
    country: "Czechia",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","CZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cz-061",
    lat: 50.502969,
    lng: 13.573438,
    panoId: "jKv5gPYQ8OtfPzDSxGox2Q",
    place: "Near Most, Ústí nad Labem Region",
    shortName: "Most",
    countryCode: "CZ",
    country: "Czechia",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","CZ"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "cz-062",
    lat: 48.856323,
    lng: 15.987032,
    panoId: "gSU58ApxAVsbjlAKIRNfOQ",
    place: "Near Znojmo, South Moravian",
    shortName: "Znojmo",
    countryCode: "CZ",
    country: "Czechia",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","CZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cz-063",
    lat: 49.507519,
    lng: 17.113783,
    panoId: "vSAxQHVX7LdXLL9AGD0F3w",
    place: "Near Smržice, Olomouc Region",
    shortName: "Smržice",
    countryCode: "CZ",
    country: "Czechia",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","CZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cz-064",
    lat: 50.715711,
    lng: 14.599807,
    panoId: "EEF9GeR-uTbkNrjoNem90A",
    place: "Near Zákupy, Liberec Region",
    shortName: "Zákupy",
    countryCode: "CZ",
    country: "Czechia",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","CZ"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "cz-065",
    lat: 50.237128,
    lng: 15.88293,
    panoId: "YiluGkH4jFCsIFBpP85r9Q",
    place: "Near Černilov, Hradec Králové Region",
    shortName: "Černilov",
    countryCode: "CZ",
    country: "Czechia",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","CZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cz-066",
    lat: 49.247424,
    lng: 15.835949,
    panoId: "87EjRjmgzLQJrLhwyrJq8Q",
    place: "Near Okříšky, Vysocina",
    shortName: "Okříšky",
    countryCode: "CZ",
    country: "Czechia",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","CZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cz-067",
    lat: 49.797529,
    lng: 18.481434,
    panoId: "4U-y0C3HcnLGaSlVE1M-Tg",
    place: "Near Horní Suchá, Moravian-Silesian Region",
    shortName: "Horní Suchá",
    countryCode: "CZ",
    country: "Czechia",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","CZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cz-068",
    lat: 50.81888,
    lng: 14.203777,
    panoId: "nx-9byZJG3nDYb6IOojSDw",
    place: "Near Děčín, Ústí nad Labem Region",
    shortName: "Děčín",
    countryCode: "CZ",
    country: "Czechia",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","CZ"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "cz-069",
    lat: 49.656982,
    lng: 18.02836,
    panoId: "y0iqip_pYlqoVKZanHI78A",
    place: "Near Bartošovice, Moravian-Silesian Region",
    shortName: "Bartošovice",
    countryCode: "CZ",
    country: "Czechia",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","CZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cz-070",
    lat: 49.522618,
    lng: 18.014974,
    panoId: "jnHI_TJwqaVvRjwJegI7xg",
    place: "Near Hodslavice, Moravian-Silesian Region",
    shortName: "Hodslavice",
    countryCode: "CZ",
    country: "Czechia",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","CZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cz-071",
    lat: 50.356038,
    lng: 14.911205,
    panoId: "TPlDAjRrXBhGjoEyE8MHEQ",
    place: "Near Dobrovice, Central Bohemia",
    shortName: "Dobrovice",
    countryCode: "CZ",
    country: "Czechia",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","CZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cz-072",
    lat: 49.012228,
    lng: 14.39819,
    panoId: "VMQPDrKB-D84WhBO29pe5Q",
    place: "Near Dubné, South Bohemian Region",
    shortName: "Dubné",
    countryCode: "CZ",
    country: "Czechia",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","CZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cz-073",
    lat: 49.473461,
    lng: 14.702931,
    panoId: "QKUISUpUTVHsMHfJhpwoQA",
    place: "Near Chotoviny, South Bohemian Region",
    shortName: "Chotoviny",
    countryCode: "CZ",
    country: "Czechia",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","CZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cz-074",
    lat: 50.536387,
    lng: 15.82846,
    panoId: "i95FGyxEyULeJ1aeKOUdtQ",
    place: "Near Pilníkov, Hradec Králové Region",
    shortName: "Pilníkov",
    countryCode: "CZ",
    country: "Czechia",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","CZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cz-075",
    lat: 50.039945,
    lng: 15.277434,
    panoId: "8Gmst6dHHZ3qOZsPz-duQA",
    place: "Near Starý Kolín, Central Bohemia",
    shortName: "Starý Kolín",
    countryCode: "CZ",
    country: "Czechia",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","CZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cz-076",
    lat: 49.657131,
    lng: 17.234094,
    panoId: "Lx98NX_PcY5PHVZeaAoW7g",
    place: "Near Horka nad Moravou, Olomouc Region",
    shortName: "Horka nad Moravou",
    countryCode: "CZ",
    country: "Czechia",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","CZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cz-077",
    lat: 50.205158,
    lng: 12.894077,
    panoId: "qzkDpKT1PycP9QayXMTEWQ",
    place: "Near Karlovy Vary, Carlsbad Region",
    shortName: "Karlovy Vary",
    countryCode: "CZ",
    country: "Czechia",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","CZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cz-078",
    lat: 49.316021,
    lng: 17.941313,
    panoId: "TAb6JbVJ_VGlsh0ku0uUZA",
    place: "Near Liptál, Zlín",
    shortName: "Liptál",
    countryCode: "CZ",
    country: "Czechia",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","CZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cz-079",
    lat: 49.290282,
    lng: 16.600565,
    panoId: "2Mz_qd9LQyslBJcW-Ou1PQ",
    place: "Near Lelekovice, South Moravian",
    shortName: "Lelekovice",
    countryCode: "CZ",
    country: "Czechia",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","CZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cz-080",
    lat: 48.81319,
    lng: 16.889798,
    panoId: "3TMkiF3U43LKt2Eq_aU8DQ",
    place: "Near Ladná, South Moravian",
    shortName: "Ladná",
    countryCode: "CZ",
    country: "Czechia",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","CZ"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "cz-081",
    lat: 50.156867,
    lng: 15.878582,
    panoId: "j8E1Diyb9H4GsVA_ZV6WiA",
    place: "Near Býšť, Pardubice Region",
    shortName: "Býšť",
    countryCode: "CZ",
    country: "Czechia",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","CZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cz-082",
    lat: 50.48852,
    lng: 14.112133,
    panoId: "PYiPoAEIj1SY10DCUfRw0A",
    place: "Near Bohušovice nad Ohří, Ústí nad Labem Region",
    shortName: "Bohušovice nad Ohří",
    countryCode: "CZ",
    country: "Czechia",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","CZ"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "cz-083",
    lat: 49.669418,
    lng: 15.578665,
    panoId: "gMBk0ltxtEuQWhUIAf9z-w",
    place: "Near Havlíčkův Brod, Vysocina",
    shortName: "Havlíčkův Brod",
    countryCode: "CZ",
    country: "Czechia",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","CZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cz-084",
    lat: 49.708571,
    lng: 13.336016,
    panoId: "_rZX746VYkXEfc3RvtqwNw",
    place: "Near Vejprnice, Plzeň Region",
    shortName: "Vejprnice",
    countryCode: "CZ",
    country: "Czechia",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","CZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cz-085",
    lat: 49.893058,
    lng: 15.847675,
    panoId: "CxFarF-AG3QHEuGbx2BXTA",
    place: "Near Slatiňany, Pardubice Region",
    shortName: "Slatiňany",
    countryCode: "CZ",
    country: "Czechia",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","CZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cz-086",
    lat: 49.247445,
    lng: 15.928527,
    panoId: "2Dy34M6SoukzoKW88EcX9g",
    place: "Near Třebíč, Vysocina",
    shortName: "Třebíč",
    countryCode: "CZ",
    country: "Czechia",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","CZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cz-087",
    lat: 49.486247,
    lng: 17.484558,
    panoId: "hWVx_EWUvoyOkMsUb07mUQ",
    place: "Near Radslavice, Olomouc Region",
    shortName: "Radslavice",
    countryCode: "CZ",
    country: "Czechia",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","CZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cz-088",
    lat: 49.098794,
    lng: 14.937504,
    panoId: "fdcErYCWxzgSjNrBMYX2BQ",
    place: "Near Jindřichův Hradec, South Bohemian Region",
    shortName: "Jindřichův Hradec",
    countryCode: "CZ",
    country: "Czechia",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","CZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cz-089",
    lat: 49.294333,
    lng: 13.82263,
    panoId: "GQkhhJ4vXx8J3wrIKQuqHQ",
    place: "Near Katovice, South Bohemian Region",
    shortName: "Katovice",
    countryCode: "CZ",
    country: "Czechia",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","CZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cz-090",
    lat: 50.599749,
    lng: 15.867757,
    panoId: "JKCRnwxzHnEGyhojls6E2w",
    place: "Near Mladé Buky, Hradec Králové Region",
    shortName: "Mladé Buky",
    countryCode: "CZ",
    country: "Czechia",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","CZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cz-091",
    lat: 50.001454,
    lng: 15.734808,
    panoId: "-gJb644f3ih8BA4AH3_qHA",
    place: "Near Pardubice, Pardubice Region",
    shortName: "Pardubice",
    countryCode: "CZ",
    country: "Czechia",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","CZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cz-092",
    lat: 50.756787,
    lng: 14.260764,
    panoId: "hoDO2l_EKL2JIDuq12lbrw",
    place: "Near Benešov nad Ploučnicí, Ústí nad Labem Region",
    shortName: "Benešov nad Ploučnicí",
    countryCode: "CZ",
    country: "Czechia",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","CZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cz-093",
    lat: 49.432286,
    lng: 18.048736,
    panoId: "36v467O1lGpTva77POpG9Q",
    place: "Near Vidče, Zlín",
    shortName: "Vidče",
    countryCode: "CZ",
    country: "Czechia",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","CZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cz-094",
    lat: 49.900052,
    lng: 18.500113,
    panoId: "kZ-17ZShjYtlymoXCfPA7w",
    place: "Near Gołkowice, Silesia",
    shortName: "Gołkowice",
    countryCode: "CZ",
    country: "Czechia",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","CZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cz-095",
    lat: 49.380013,
    lng: 18.024184,
    panoId: "5fkSGX-aMs4_7c7Wj41-ow",
    place: "Near Vsetín, Zlín",
    shortName: "Vsetín",
    countryCode: "CZ",
    country: "Czechia",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","CZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cz-096",
    lat: 49.646634,
    lng: 18.09479,
    panoId: "48_bvy_LJPGbH-jXk4mcoQ",
    place: "Near Sedlnice, Moravian-Silesian Region",
    shortName: "Sedlnice",
    countryCode: "CZ",
    country: "Czechia",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","CZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cz-097",
    lat: 49.882629,
    lng: 18.146651,
    panoId: "gnNlAbyGrlowULd2qNUyig",
    place: "Near Kozmice, Moravian-Silesian Region",
    shortName: "Kozmice",
    countryCode: "CZ",
    country: "Czechia",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","CZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cz-098",
    lat: 49.700637,
    lng: 18.643916,
    panoId: "AcGHz96FNj_edvLps_-auQ",
    place: "Near Ropice, Moravian-Silesian Region",
    shortName: "Ropice",
    countryCode: "CZ",
    country: "Czechia",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","CZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cz-099",
    lat: 50.000694,
    lng: 18.12517,
    panoId: "-KNVYH71NmKRELT7Qh8pqQ",
    place: "Near Chuchelná, Moravian-Silesian Region",
    shortName: "Chuchelná",
    countryCode: "CZ",
    country: "Czechia",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","CZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cz-100",
    lat: 49.648722,
    lng: 15.801008,
    panoId: "FngspkhFgR9m3Unl_omKiQ",
    place: "Near Ždírec nad Doubravkou, Vysocina",
    shortName: "Ždírec nad Doubravkou",
    countryCode: "CZ",
    country: "Czechia",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","CZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cz-101",
    lat: 49.295462,
    lng: 16.791491,
    panoId: "-XDUnhcuOR53aDKo63dIAA",
    place: "Near Březina, South Moravian",
    shortName: "Březina",
    countryCode: "CZ",
    country: "Czechia",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","CZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cz-102",
    lat: 49.251152,
    lng: 15.239005,
    panoId: "wujBqK83010yd5ykw3Jm3Q",
    place: "Near Počátky, Vysocina",
    shortName: "Počátky",
    countryCode: "CZ",
    country: "Czechia",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","CZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cz-103",
    lat: 49.592887,
    lng: 15.110264,
    panoId: "aUWSPXBY-n9e4nkQvrpuyQ",
    place: "Near Čechtice, Central Bohemia",
    shortName: "Čechtice",
    countryCode: "CZ",
    country: "Czechia",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","CZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cz-104",
    lat: 49.440138,
    lng: 15.439099,
    panoId: "2ZhAnKSHy-F-18sUQBZLyQ",
    place: "Near Herálec, Vysocina",
    shortName: "Herálec",
    countryCode: "CZ",
    country: "Czechia",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","CZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cz-105",
    lat: 50.348165,
    lng: 15.445796,
    panoId: "tl8y2Nqc4Rl2vtjnNExYDQ",
    place: "Near Smidary, Hradec Králové Region",
    shortName: "Smidary",
    countryCode: "CZ",
    country: "Czechia",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","CZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gr-000",
    lat: 41.152858,
    lng: 24.147388,
    panoId: "2iOTM4H2mg-eMVKHp59AEw",
    place: "Near Dráma, East Macedonia and Thrace",
    shortName: "Dráma",
    countryCode: "GR",
    country: "Greece",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","GR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gr-001",
    lat: 36.435099,
    lng: 28.222007,
    panoId: "1MOp944X1VaWvZe0QzxqnQ",
    place: "Near Ródos, South Aegean",
    shortName: "Ródos",
    countryCode: "GR",
    country: "Greece",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","GR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gr-002",
    lat: 40.58249,
    lng: 22.950535,
    panoId: "fd-KWcb9MoCu-GVinpuYVA",
    place: "Near Kalamariá, Central Macedonia",
    shortName: "Kalamariá",
    countryCode: "GR",
    country: "Greece",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","GR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gr-003",
    lat: 40.670536,
    lng: 22.908355,
    panoId: "1lKi7xQJTAjnRbJ0lygCbQ",
    place: "Near Évosmos, Central Macedonia",
    shortName: "Évosmos",
    countryCode: "GR",
    country: "Greece",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","GR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gr-004",
    lat: 37.975775,
    lng: 23.769079,
    panoId: "BUNzp-tsCOAzrtuNOOzXMA",
    place: "Near Zográfos, Attica",
    shortName: "Zográfos",
    countryCode: "GR",
    country: "Greece",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","GR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gr-005",
    lat: 39.554999,
    lng: 21.768478,
    panoId: "uUUtlK7KXunRO6SBB16D2g",
    place: "Near Tríkala, Thessaly",
    shortName: "Tríkala",
    countryCode: "GR",
    country: "Greece",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","GR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gr-006",
    lat: 35.327781,
    lng: 25.14339,
    panoId: "wlI7FN7buFubSCFZqepfjQ",
    place: "Near Irákleion, Crete",
    shortName: "Irákleion",
    countryCode: "GR",
    country: "Greece",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","GR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gr-007",
    lat: 35.511329,
    lng: 24.029239,
    panoId: "-GuoF7GafcSRetNO5Yo6BA",
    place: "Near Chaniá, Crete",
    shortName: "Chaniá",
    countryCode: "GR",
    country: "Greece",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","GR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gr-008",
    lat: 40.269584,
    lng: 22.50612,
    panoId: "GzFWd61XSu3Fosif-OGSwQ",
    place: "Near Kateríni, Central Macedonia",
    shortName: "Kateríni",
    countryCode: "GR",
    country: "Greece",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","GR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gr-009",
    lat: 38.325014,
    lng: 23.318788,
    panoId: "nmvyaEzW6xS1rgiW7i1GDw",
    place: "Near Thívai, Central Greece",
    shortName: "Thívai",
    countryCode: "GR",
    country: "Greece",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","GR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gr-010",
    lat: 41.085592,
    lng: 23.547006,
    panoId: "NUOBwyBS4Csp3NuT0nFF-A",
    place: "Near Sérres, Central Macedonia",
    shortName: "Sérres",
    countryCode: "GR",
    country: "Greece",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","GR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gr-011",
    lat: 40.666736,
    lng: 22.948864,
    panoId: "UqknUnPM9NbfFsnAHe1GnA",
    place: "Near Políchni, Central Macedonia",
    shortName: "Políchni",
    countryCode: "GR",
    country: "Greece",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","GR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gr-012",
    lat: 40.749835,
    lng: 23.066562,
    panoId: "aRke-KcbAdoZOxmV7dkSIQ",
    place: "Near Lagkadás, Central Macedonia",
    shortName: "Lagkadás",
    countryCode: "GR",
    country: "Greece",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","GR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gr-013",
    lat: 39.663348,
    lng: 20.851723,
    panoId: "EK9uh2bIQM9nqiOWGdD-qQ",
    place: "Near Ioánnina, Epirus",
    shortName: "Ioánnina",
    countryCode: "GR",
    country: "Greece",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","GR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gr-014",
    lat: 41.117621,
    lng: 25.405854,
    panoId: "3ornqPyfSXhx1e_T66hwHw",
    place: "Near Komotiní, East Macedonia and Thrace",
    shortName: "Komotiní",
    countryCode: "GR",
    country: "Greece",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","GR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gr-015",
    lat: 40.640718,
    lng: 22.934973,
    panoId: "UppABQOl-4vYC9PNVFboOQ",
    place: "Near Thessaloníki, Central Macedonia",
    shortName: "Thessaloníki",
    countryCode: "GR",
    country: "Greece",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","GR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gr-016",
    lat: 37.983792,
    lng: 23.72787,
    panoId: "h7yjZcHXKnSmwsd8j58Tww",
    place: "Near Athens, Attica",
    shortName: "Athens",
    countryCode: "GR",
    country: "Greece",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","GR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gr-017",
    lat: 38.899482,
    lng: 22.433764,
    panoId: "39YIY0G3Hi0w6LxwXE-8cw",
    place: "Near Lamía, Central Greece",
    shortName: "Lamía",
    countryCode: "GR",
    country: "Greece",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","GR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gr-018",
    lat: 40.52426,
    lng: 22.202216,
    panoId: "XKBJOf3QBmZD_hhGxBKWGQ",
    place: "Near Véroia, Central Macedonia",
    shortName: "Véroia",
    countryCode: "GR",
    country: "Greece",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","GR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gr-019",
    lat: 39.628477,
    lng: 22.421138,
    panoId: "fKqOzBrPqoaDHfhezBpVEw",
    place: "Near Lárisa, Thessaly",
    shortName: "Lárisa",
    countryCode: "GR",
    country: "Greece",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","GR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gr-020",
    lat: 40.939514,
    lng: 24.406712,
    panoId: "1CKHZ3cmFRqHdVWM0qrv3g",
    place: "Near Kavála, East Macedonia and Thrace",
    shortName: "Kavála",
    countryCode: "GR",
    country: "Greece",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","GR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gr-021",
    lat: 39.379217,
    lng: 22.927377,
    panoId: "eCzHBTBWgnOBQcmZs9iqyQ",
    place: "Near Néa Ionía, Thessaly",
    shortName: "Néa Ionía",
    countryCode: "GR",
    country: "Greece",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","GR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gr-022",
    lat: 38.621228,
    lng: 21.407757,
    panoId: "Ahhm4ZgJIBNdnMxynCdU6A",
    place: "Near Agrínio, West Greece",
    shortName: "Agrínio",
    countryCode: "GR",
    country: "Greece",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","GR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gr-023",
    lat: 35.365634,
    lng: 24.482365,
    panoId: "S5drmoiUkv0ZXQijLSLJVQ",
    place: "Near Rethymno, Crete",
    shortName: "Rethymno",
    countryCode: "GR",
    country: "Greece",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","GR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gr-024",
    lat: 40.849988,
    lng: 25.876512,
    panoId: "U_q4Cr1AGiwOvHQ7PTIYiw",
    place: "Near Alexandroupoli, East Macedonia and Thrace",
    shortName: "Alexandroupoli",
    countryCode: "GR",
    country: "Greece",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","GR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gr-025",
    lat: 39.369143,
    lng: 22.947672,
    panoId: "l2OhqgAggqolfRqo8HdtfA",
    place: "Near Volos, Thessaly",
    shortName: "Volos",
    countryCode: "GR",
    country: "Greece",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","GR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gr-026",
    lat: 40.599098,
    lng: 22.986228,
    panoId: "ePJTNKcyfTwXg0M5gk2v4A",
    place: "Near Pylaía, Central Macedonia",
    shortName: "Pylaía",
    countryCode: "GR",
    country: "Greece",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","GR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gr-027",
    lat: 37.039173,
    lng: 22.112679,
    panoId: "I8hKToVswbojBSLjgPTVsg",
    place: "Near Kalamata, Peloponnese",
    shortName: "Kalamata",
    countryCode: "GR",
    country: "Greece",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","GR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gr-028",
    lat: 40.649467,
    lng: 22.950889,
    panoId: "7ERtHHErO9RNI2Jkj6DnEg",
    place: "Near Sykiés, Central Macedonia",
    shortName: "Sykiés",
    countryCode: "GR",
    country: "Greece",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","GR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gr-029",
    lat: 39.364891,
    lng: 21.921737,
    panoId: "1nNML9AzhDXMzVyyH0KBsA",
    place: "Near Kardítsa, Thessaly",
    shortName: "Kardítsa",
    countryCode: "GR",
    country: "Greece",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","GR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gr-030",
    lat: 41.134898,
    lng: 24.88807,
    panoId: "vwV9-JVb4rdJEqzCxUur_A",
    place: "Near Xánthi, East Macedonia and Thrace",
    shortName: "Xánthi",
    countryCode: "GR",
    country: "Greece",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","GR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gr-031",
    lat: 38.463453,
    lng: 23.602802,
    panoId: "rm2MDHHxnfrqai45SLuk2w",
    place: "Near Chalkída, Central Greece",
    shortName: "Chalkída",
    countryCode: "GR",
    country: "Greece",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","GR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gr-032",
    lat: 41.163863,
    lng: 24.138367,
    panoId: "zxIqTpi-i9E4OqeNyHpujg",
    place: "Near Dráma, East Macedonia and Thrace",
    shortName: "Dráma",
    countryCode: "GR",
    country: "Greece",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","GR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gr-033",
    lat: 37.93897,
    lng: 22.950176,
    panoId: "DEB201otnFigCfBzmyDa_A",
    place: "Near Kórinthos, Peloponnese",
    shortName: "Kórinthos",
    countryCode: "GR",
    country: "Greece",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","GR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gr-034",
    lat: 35.518635,
    lng: 24.035695,
    panoId: "CrBuAz5OXVEsH_OuWaUHIw",
    place: "Near Chaniá, Crete",
    shortName: "Chaniá",
    countryCode: "GR",
    country: "Greece",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","GR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gr-035",
    lat: 40.51468,
    lng: 21.678693,
    panoId: "3lELiM53EcEiGk7CzUvbaA",
    place: "Near Ptolemaḯda, West Macedonia",
    shortName: "Ptolemaḯda",
    countryCode: "GR",
    country: "Greece",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","GR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gr-036",
    lat: 36.430785,
    lng: 28.237404,
    panoId: "6rSRfidJ1eTvU1QGPPrW0Q",
    place: "Near Ródos, South Aegean",
    shortName: "Ródos",
    countryCode: "GR",
    country: "Greece",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","GR"],
    qualityTier: 4,
    verified: true,
  },
];

const CHUNK_7: GeoLocation[] = [
  {
    id: "gr-037",
    lat: 38.339819,
    lng: 23.305934,
    panoId: "PGFHjd6lXvbNdY3eQD-xBQ",
    place: "Near Thívai, Central Greece",
    shortName: "Thívai",
    countryCode: "GR",
    country: "Greece",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","GR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gr-038",
    lat: 41.132379,
    lng: 24.86531,
    panoId: "I6kUKnbSQ6LHOBfzayyjXg",
    place: "Near Xánthi, East Macedonia and Thrace",
    shortName: "Xánthi",
    countryCode: "GR",
    country: "Greece",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","GR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gr-039",
    lat: 35.309052,
    lng: 25.137958,
    panoId: "CNsk2g11LUUKspeq1zy_Mg",
    place: "Near Irákleion, Crete",
    shortName: "Irákleion",
    countryCode: "GR",
    country: "Greece",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","GR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gr-040",
    lat: 39.373086,
    lng: 22.908178,
    panoId: "Ssg35sBCMYpVdBG5sfCaug",
    place: "Near Néa Ionía, Thessaly",
    shortName: "Néa Ionía",
    countryCode: "GR",
    country: "Greece",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","GR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gr-041",
    lat: 40.307538,
    lng: 21.811412,
    panoId: "YGQ8wycNWwKL58HmlFMA5w",
    place: "Near Kozáni, West Macedonia",
    shortName: "Kozáni",
    countryCode: "GR",
    country: "Greece",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","GR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gr-042",
    lat: 38.451876,
    lng: 23.605085,
    panoId: "fdF9NiKWKMxr0AIBkN0upA",
    place: "Near Chalkída, Central Greece",
    shortName: "Chalkída",
    countryCode: "GR",
    country: "Greece",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","GR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gr-043",
    lat: 40.630318,
    lng: 22.994158,
    panoId: "7oP9Ny8LZ1ff58k2JJkgIA",
    place: "Near Triandría, Central Macedonia",
    shortName: "Triandría",
    countryCode: "GR",
    country: "Greece",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","GR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gr-044",
    lat: 38.247825,
    lng: 21.760468,
    panoId: "0vQmEUh4xxOX2EP7aCSjEA",
    place: "Near Pátra, West Greece",
    shortName: "Pátra",
    countryCode: "GR",
    country: "Greece",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","GR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gr-045",
    lat: 40.71328,
    lng: 22.58116,
    panoId: "t8wKDcZ5AHEyoWbuLDGXTw",
    place: "Near Chalkidóna, Central Macedonia",
    shortName: "Chalkidóna",
    countryCode: "GR",
    country: "Greece",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","GR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gr-046",
    lat: 41.135169,
    lng: 25.401766,
    panoId: "il22oBb98jYKEA-omrkDBA",
    place: "Near Komotiní, East Macedonia and Thrace",
    shortName: "Komotiní",
    countryCode: "GR",
    country: "Greece",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","GR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gr-047",
    lat: 37.035606,
    lng: 22.137992,
    panoId: "mN4jBwZ2UogihY3NI4nflw",
    place: "Near Kalamata, Peloponnese",
    shortName: "Kalamata",
    countryCode: "GR",
    country: "Greece",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","GR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gr-048",
    lat: 39.636616,
    lng: 22.397595,
    panoId: "1ksHxkYFiWoFrqxcaYFZ6Q",
    place: "Near Lárisa, Thessaly",
    shortName: "Lárisa",
    countryCode: "GR",
    country: "Greece",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","GR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gr-049",
    lat: 39.628054,
    lng: 19.90509,
    panoId: "7il3CR2pGKhT6-wHGHrF8Q",
    place: "Near Corfu, Ionian Islands",
    shortName: "Corfu",
    countryCode: "GR",
    country: "Greece",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","GR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gr-050",
    lat: 40.725446,
    lng: 22.98455,
    panoId: "i6DXWZa1iQVUxwO4Xdl_jA",
    place: "Near Lagyná, Central Macedonia",
    shortName: "Lagyná",
    countryCode: "GR",
    country: "Greece",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","GR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gr-051",
    lat: 41.058433,
    lng: 23.618679,
    panoId: "Ti3O5VPeRFh2dHAs_yzckA",
    place: "Near Chrysó, Central Macedonia",
    shortName: "Chrysó",
    countryCode: "GR",
    country: "Greece",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","GR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gr-052",
    lat: 40.306401,
    lng: 22.579448,
    panoId: "vcfzFOzyiamc6VOjtqFCXQ",
    place: "Near Korinós, Central Macedonia",
    shortName: "Korinós",
    countryCode: "GR",
    country: "Greece",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","GR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gr-053",
    lat: 40.674656,
    lng: 23.0497,
    panoId: "kBX1OQSuIBg6_sPnxiIEJQ",
    place: "Near Fíliro, Central Macedonia",
    shortName: "Fíliro",
    countryCode: "GR",
    country: "Greece",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","GR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gr-054",
    lat: 40.50468,
    lng: 22.26211,
    panoId: "yDz7S8zfzNIX0Uxhly3eyA",
    place: "Near Diavatós, Central Macedonia",
    shortName: "Diavatós",
    countryCode: "GR",
    country: "Greece",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","GR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gr-055",
    lat: 41.21237,
    lng: 24.164131,
    panoId: "dfGXlfT6NUiFYArRqu9Nrw",
    place: "Near Xiropótamos, East Macedonia and Thrace",
    shortName: "Xiropótamos",
    countryCode: "GR",
    country: "Greece",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","GR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gr-056",
    lat: 39.344068,
    lng: 22.870134,
    panoId: "k7E0A-MAKTACl6rXYYguCA",
    place: "Near Néa Ionía, Thessaly",
    shortName: "Néa Ionía",
    countryCode: "GR",
    country: "Greece",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","GR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gr-057",
    lat: 39.566969,
    lng: 21.833529,
    panoId: "UnwWnLuS_g665c2nrR4AkQ",
    place: "Near Megalochóri, Thessaly",
    shortName: "Megalochóri",
    countryCode: "GR",
    country: "Greece",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","GR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gr-058",
    lat: 39.059089,
    lng: 26.577345,
    panoId: "sowbFm6tCKex7J3NfNF_TA",
    place: "Near Vareiá, North Aegean",
    shortName: "Vareiá",
    countryCode: "GR",
    country: "Greece",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","GR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gr-059",
    lat: 39.348194,
    lng: 22.893977,
    panoId: "Ye2N2m1tOzxev5ZjkTjyjQ",
    place: "Near Néa Ionía, Thessaly",
    shortName: "Néa Ionía",
    countryCode: "GR",
    country: "Greece",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","GR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gr-060",
    lat: 40.660748,
    lng: 22.849168,
    panoId: "sphhd_HyImp3ItFuCvSNBg",
    place: "Near Kalochóri, Central Macedonia",
    shortName: "Kalochóri",
    countryCode: "GR",
    country: "Greece",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","GR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gr-061",
    lat: 41.077897,
    lng: 25.368569,
    panoId: "d77omOzeZg64mK0qJ8kIXA",
    place: "Near Komotiní, East Macedonia and Thrace",
    shortName: "Komotiní",
    countryCode: "GR",
    country: "Greece",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","GR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gr-062",
    lat: 40.541742,
    lng: 21.62643,
    panoId: "S0Yj4mNxPLT10cnjGYBwFw",
    place: "Near Ptolemaḯda, West Macedonia",
    shortName: "Ptolemaḯda",
    countryCode: "GR",
    country: "Greece",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","GR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gr-063",
    lat: 39.370867,
    lng: 21.985604,
    panoId: "vVBeFxYU649Kn-3pA7L7aw",
    place: "Near Karpochóri, Thessaly",
    shortName: "Karpochóri",
    countryCode: "GR",
    country: "Greece",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","GR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gr-064",
    lat: 40.705902,
    lng: 22.803296,
    panoId: "qKQ_r8PXpcDg21TAogQ6uA",
    place: "Near Síndos, Central Macedonia",
    shortName: "Síndos",
    countryCode: "GR",
    country: "Greece",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","GR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gr-065",
    lat: 40.247726,
    lng: 21.789512,
    panoId: "OpZDs4I10w41eACfc4ssug",
    place: "Near Krókos, West Macedonia",
    shortName: "Krókos",
    countryCode: "GR",
    country: "Greece",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","GR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gr-066",
    lat: 37.481466,
    lng: 22.438056,
    panoId: "GPZMe5b7nALqGY5F5cjePA",
    place: "Near Aléa, Peloponnese",
    shortName: "Aléa",
    countryCode: "GR",
    country: "Greece",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","GR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gr-067",
    lat: 40.986682,
    lng: 24.38045,
    panoId: "g2vnlL01Unf4gX0eK1B7Kg",
    place: "Near Zygós, East Macedonia and Thrace",
    shortName: "Zygós",
    countryCode: "GR",
    country: "Greece",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","GR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gr-068",
    lat: 39.113691,
    lng: 20.971709,
    panoId: "6m3Pgc92oPchFdT_BjJAIQ",
    place: "Near Kostakioí, Epirus",
    shortName: "Kostakioí",
    countryCode: "GR",
    country: "Greece",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","GR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gr-069",
    lat: 35.323084,
    lng: 24.501647,
    panoId: "_ZT1HwqIODy_blb2ZthgQQ",
    place: "Near Rethymno, Crete",
    shortName: "Rethymno",
    countryCode: "GR",
    country: "Greece",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","GR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gr-070",
    lat: 37.658967,
    lng: 21.476312,
    panoId: "UTeNFS6BlLh1MUM3GWtiJA",
    place: "Near Varvásaina, West Greece",
    shortName: "Varvásaina",
    countryCode: "GR",
    country: "Greece",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","GR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gr-071",
    lat: 41.033457,
    lng: 23.768811,
    panoId: "MOadtDDrr2aYbnhwXvXmnw",
    place: "Near Néa Zíchni, Central Macedonia",
    shortName: "Néa Zíchni",
    countryCode: "GR",
    country: "Greece",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","GR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gr-072",
    lat: 40.87041,
    lng: 25.911277,
    panoId: "SyvtLd5ZXfnE8W6LJwnyDg",
    place: "Near Alexandroupoli, East Macedonia and Thrace",
    shortName: "Alexandroupoli",
    countryCode: "GR",
    country: "Greece",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","GR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gr-073",
    lat: 40.48452,
    lng: 21.991488,
    panoId: "Y2GtnFfwKBkRBGUodDDbQA",
    place: "Near Akriní, West Macedonia",
    shortName: "Akriní",
    countryCode: "GR",
    country: "Greece",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","GR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gr-074",
    lat: 40.570788,
    lng: 22.722878,
    panoId: "u6HtzuplhRYg6ivaSdQHFg",
    place: "Near Kýmina, Central Macedonia",
    shortName: "Kýmina",
    countryCode: "GR",
    country: "Greece",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","GR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gr-075",
    lat: 38.897889,
    lng: 22.355169,
    panoId: "m5ayiMKsvlgdsIuCjjhP-A",
    place: "Near Stavrós, Central Greece",
    shortName: "Stavrós",
    countryCode: "GR",
    country: "Greece",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","GR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gr-076",
    lat: 40.757066,
    lng: 22.027569,
    panoId: "c0HypRkpqW-gEiblBmmBaA",
    place: "Near Édessa, Central Macedonia",
    shortName: "Édessa",
    countryCode: "GR",
    country: "Greece",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","GR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gr-077",
    lat: 37.614369,
    lng: 22.676261,
    panoId: "rS7j9hCFBSenjgGTJKf8qQ",
    place: "Near Árgos, Peloponnese",
    shortName: "Árgos",
    countryCode: "GR",
    country: "Greece",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","GR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gr-078",
    lat: 40.674376,
    lng: 22.6866,
    panoId: "qKQ9sN26kBK9xOp3Q56jxQ",
    place: "Near Anatolikó, Central Macedonia",
    shortName: "Anatolikó",
    countryCode: "GR",
    country: "Greece",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","GR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gr-079",
    lat: 38.217171,
    lng: 22.12849,
    panoId: "G6HtbxNE3vsEoEjHxweW-w",
    place: "Near Témeni, West Greece",
    shortName: "Témeni",
    countryCode: "GR",
    country: "Greece",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","GR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gr-080",
    lat: 40.334388,
    lng: 21.779452,
    panoId: "p2MQR2l1dbRUtJ2w3T-Wng",
    place: "Near Koíla, West Macedonia",
    shortName: "Koíla",
    countryCode: "GR",
    country: "Greece",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","GR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gr-081",
    lat: 40.793521,
    lng: 21.50434,
    panoId: "MP0N5BcKpolNb65gvWVmQw",
    place: "Near Ammochóri, West Macedonia",
    shortName: "Ammochóri",
    countryCode: "GR",
    country: "Greece",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","GR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gr-082",
    lat: 39.594172,
    lng: 22.422747,
    panoId: "J725lFC31iL77iW0SXRfkw",
    place: "Near Lárisa, Thessaly",
    shortName: "Lárisa",
    countryCode: "GR",
    country: "Greece",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","GR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gr-083",
    lat: 35.313958,
    lng: 24.462424,
    panoId: "oF5kFwa5pGglTNbUX4mLpw",
    place: "Near Atsipópoulo, Crete",
    shortName: "Atsipópoulo",
    countryCode: "GR",
    country: "Greece",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","GR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gr-084",
    lat: 39.149377,
    lng: 20.90146,
    panoId: "Kl2obqm54jhSMlLsE07d8w",
    place: "Near Chalkiádes, Epirus",
    shortName: "Chalkiádes",
    countryCode: "GR",
    country: "Greece",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","GR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gr-085",
    lat: 37.98328,
    lng: 23.032934,
    panoId: "6M4RlUsf_u6wdEDSTEhhBQ",
    place: "Near Loutráki, Peloponnese",
    shortName: "Loutráki",
    countryCode: "GR",
    country: "Greece",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","GR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gr-086",
    lat: 41.122344,
    lng: 24.39449,
    panoId: "y0AOoQ_SbXTORRDGq9yFuQ",
    place: "Near Kýria, East Macedonia and Thrace",
    shortName: "Kýria",
    countryCode: "GR",
    country: "Greece",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","GR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gr-087",
    lat: 37.635998,
    lng: 22.659536,
    panoId: "uC1Mq4a0hYuAxplk2s-dGQ",
    place: "Near Árgos, Peloponnese",
    shortName: "Árgos",
    countryCode: "GR",
    country: "Greece",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","GR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gr-088",
    lat: 38.477013,
    lng: 22.800393,
    panoId: "AHWWZ1jvWn5VL7miebrjhA",
    place: "Near Livadeiá, Central Greece",
    shortName: "Livadeiá",
    countryCode: "GR",
    country: "Greece",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","GR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gr-089",
    lat: 36.846095,
    lng: 27.321721,
    panoId: "SGODeYtsuPNL9PqT7EMUmg",
    place: "Near Kos, South Aegean",
    shortName: "Kos",
    countryCode: "GR",
    country: "Greece",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","GR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gr-090",
    lat: 39.730323,
    lng: 19.825833,
    panoId: "5UjIHBwbDgXHeaOBuDNgVw",
    place: "Near Nýmfes, Ionian Islands",
    shortName: "Nýmfes",
    countryCode: "GR",
    country: "Greece",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","GR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gr-091",
    lat: 35.323301,
    lng: 25.016879,
    panoId: "Zf2CSP07vDYM4XTcrOUbxw",
    place: "Near Tílisos, Crete",
    shortName: "Tílisos",
    countryCode: "GR",
    country: "Greece",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","GR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gr-092",
    lat: 37.735543,
    lng: 21.337038,
    panoId: "Wn6PYAED1dTMJP4nMKNvEw",
    place: "Near Amaliáda, West Greece",
    shortName: "Amaliáda",
    countryCode: "GR",
    country: "Greece",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","GR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gr-093",
    lat: 40.484012,
    lng: 21.19827,
    panoId: "2XnKvcZTRUUYs-8Lv03OyQ",
    place: "Near Mesopotamía, West Macedonia",
    shortName: "Mesopotamía",
    countryCode: "GR",
    country: "Greece",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","GR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gr-094",
    lat: 40.785061,
    lng: 21.365357,
    panoId: "zAoO-aVumWKqwh6HbGnkmw",
    place: "Near Flórina, West Macedonia",
    shortName: "Flórina",
    countryCode: "GR",
    country: "Greece",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","GR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gr-095",
    lat: 38.913172,
    lng: 20.811134,
    panoId: "WnW5hA1hCVgjdl8sI_6uFQ",
    place: "Near Vónitsa, West Greece",
    shortName: "Vónitsa",
    countryCode: "GR",
    country: "Greece",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","GR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gr-096",
    lat: 38.252369,
    lng: 26.303445,
    panoId: "LAhkUHm3nQT-qsSakRW-Sg",
    place: "Near Alaçatı, İzmir Province",
    shortName: "Alaçatı",
    countryCode: "GR",
    country: "Greece",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","GR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gr-097",
    lat: 38.043503,
    lng: 22.897804,
    panoId: "vvwFw-MwgGMlMFG2Z-S5vw",
    place: "Near Perachóra, Peloponnese",
    shortName: "Perachóra",
    countryCode: "GR",
    country: "Greece",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","GR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gr-098",
    lat: 38.275141,
    lng: 22.989217,
    panoId: "BjL6ebX1wvh1gjx6DE_U3g",
    place: "Near Domvraína, Central Greece",
    shortName: "Domvraína",
    countryCode: "GR",
    country: "Greece",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","GR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gr-099",
    lat: 37.55692,
    lng: 22.717537,
    panoId: "Dz4yKBCnjVUYl5U5Gt1Grw",
    place: "Near Néa Kíos, Peloponnese",
    shortName: "Néa Kíos",
    countryCode: "GR",
    country: "Greece",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","GR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gr-100",
    lat: 35.178233,
    lng: 25.896044,
    panoId: "eus9oVRTaqXp5DTHRUB5zQ",
    place: "Near Ágios Nikólaos, Crete",
    shortName: "Ágios Nikólaos",
    countryCode: "GR",
    country: "Greece",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","GR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gr-101",
    lat: 38.624124,
    lng: 23.110072,
    panoId: "Cix5Y9T3XWBSUjsOgdZMzQ",
    place: "Near Atalánti, Central Greece",
    shortName: "Atalánti",
    countryCode: "GR",
    country: "Greece",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","GR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gr-102",
    lat: 39.145189,
    lng: 20.680841,
    panoId: "gvxNy54zV5EYURHX2XnN8w",
    place: "Near Néos Oropós, Epirus",
    shortName: "Néos Oropós",
    countryCode: "GR",
    country: "Greece",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","GR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gr-103",
    lat: 39.967956,
    lng: 21.604287,
    panoId: "RDqscnoOra2tAlJWHnOO9Q",
    place: "Near Deskáti, West Macedonia",
    shortName: "Deskáti",
    countryCode: "GR",
    country: "Greece",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","GR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gr-104",
    lat: 37.805364,
    lng: 21.568116,
    panoId: "6uKmaWBZbAHJCUUL85qMcQ",
    place: "Near Folói, West Greece",
    shortName: "Folói",
    countryCode: "GR",
    country: "Greece",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","GR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "gr-105",
    lat: 35.169783,
    lng: 25.495858,
    panoId: "jIZCKZhz8Uga4eq5v1FzBQ",
    place: "Near Mokhós, Crete",
    shortName: "Mokhós",
    countryCode: "GR",
    country: "Greece",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","GR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hu-000",
    lat: 47.498562,
    lng: 19.040398,
    panoId: "HXY4RMzy50Z2GZhsvspuFA",
    place: "Near Budapest, Budapest",
    shortName: "Budapest",
    countryCode: "HU",
    country: "Hungary",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","HU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hu-001",
    lat: 47.394678,
    lng: 18.913793,
    panoId: "k8Krc_xVu54mtPUwnpdMWw",
    place: "Near Érd, Pest County",
    shortName: "Érd",
    countryCode: "HU",
    country: "Hungary",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","HU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hu-002",
    lat: 47.903157,
    lng: 20.373026,
    panoId: "GRHzjeIXfuLLF1InltJOwg",
    place: "Near Eger, Heves County",
    shortName: "Eger",
    countryCode: "HU",
    country: "Hungary",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","HU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hu-003",
    lat: 47.180524,
    lng: 20.198307,
    panoId: "0Keg3DyREkuWITnLUYLTLw",
    place: "Near Szolnok, Jász-Nagykun-Szolnok",
    shortName: "Szolnok",
    countryCode: "HU",
    country: "Hungary",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","HU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hu-004",
    lat: 47.592575,
    lng: 18.380959,
    panoId: "PgE-k_6EjkxAsXMONko2bg",
    place: "Near Tatabánya, Komárom-Esztergom",
    shortName: "Tatabánya",
    countryCode: "HU",
    country: "Hungary",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","HU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hu-005",
    lat: 47.531713,
    lng: 21.624528,
    panoId: "JpYPJAM_nYObeAH8W-5yFw",
    place: "Near Debrecen, Hajdú-Bihar",
    shortName: "Debrecen",
    countryCode: "HU",
    country: "Hungary",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","HU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hu-006",
    lat: 47.093598,
    lng: 17.911492,
    panoId: "DuH85fM96tiKi6VAd-a5aA",
    place: "Near Veszprém, Veszprém",
    shortName: "Veszprém",
    countryCode: "HU",
    country: "Hungary",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","HU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hu-007",
    lat: 47.190251,
    lng: 18.410044,
    panoId: "1FKWyNYMB4dgaGKKdlNTQw",
    place: "Near Székesfehérvár, Fejér",
    shortName: "Székesfehérvár",
    countryCode: "HU",
    country: "Hungary",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","HU"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "hu-008",
    lat: 48.251828,
    lng: 20.633562,
    panoId: "_iJ9K6uG_pYvqxFQ8jB3yw",
    place: "Near Kazincbarcika, Borsod-Abaúj-Zemplén",
    shortName: "Kazincbarcika",
    countryCode: "HU",
    country: "Hungary",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","HU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hu-009",
    lat: 46.366671,
    lng: 17.799936,
    panoId: "qFA9eIiLd5g__j-GEejswQ",
    place: "Near Kaposvár, Somogy County",
    shortName: "Kaposvár",
    countryCode: "HU",
    country: "Hungary",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","HU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hu-010",
    lat: 46.453648,
    lng: 16.991025,
    panoId: "Et6mqJRiQ3wAwi3lbqcONQ",
    place: "Near Nagykanizsa, Zala County",
    shortName: "Nagykanizsa",
    countryCode: "HU",
    country: "Hungary",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","HU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hu-011",
    lat: 46.906184,
    lng: 19.691237,
    panoId: "zA0V9tk4YqJ99gWnrF0jRw",
    place: "Near Kecskemét, Bács-Kiskun",
    shortName: "Kecskemét",
    countryCode: "HU",
    country: "Hungary",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","HU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hu-012",
    lat: 46.683614,
    lng: 21.099886,
    panoId: "-E97PUaE7yNdFoBFVY6W1g",
    place: "Near Békéscsaba, Bekes County",
    shortName: "Békéscsaba",
    countryCode: "HU",
    country: "Hungary",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","HU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hu-013",
    lat: 47.59653,
    lng: 19.355685,
    panoId: "-sLPEXYccm_3ER9BObRGqQ",
    place: "Near Gödöllő, Pest County",
    shortName: "Gödöllő",
    countryCode: "HU",
    country: "Hungary",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","HU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hu-014",
    lat: 48.09899,
    lng: 19.803009,
    panoId: "PVEtsouukZ5fZYM-L9boGw",
    place: "Near Salgótarján, Nógrád",
    shortName: "Salgótarján",
    countryCode: "HU",
    country: "Hungary",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","HU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hu-015",
    lat: 46.347198,
    lng: 18.711975,
    panoId: "Mzri6gsCiAE1Erb8g5sojA",
    place: "Near Szekszárd, Tolna County",
    shortName: "Szekszárd",
    countryCode: "HU",
    country: "Hungary",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","HU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hu-016",
    lat: 46.416395,
    lng: 20.33302,
    panoId: "wuj8h0tFKTeudQ9Pr_M1rg",
    place: "Near Hódmezővásárhely, Csongrád",
    shortName: "Hódmezővásárhely",
    countryCode: "HU",
    country: "Hungary",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","HU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hu-017",
    lat: 46.183069,
    lng: 18.952874,
    panoId: "51txM4GdTQB54zmZvPMeBw",
    place: "Near Baja, Bács-Kiskun",
    shortName: "Baja",
    countryCode: "HU",
    country: "Hungary",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","HU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hu-018",
    lat: 47.78257,
    lng: 19.927979,
    panoId: "fQQZnbcbu4slIbqYfx4Hqw",
    place: "Near Gyöngyös, Heves County",
    shortName: "Gyöngyös",
    countryCode: "HU",
    country: "Hungary",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","HU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hu-019",
    lat: 46.964624,
    lng: 18.939908,
    panoId: "1r2GtueDa5CTtTX33INBsQ",
    place: "Near Dunaújváros, Fejér",
    shortName: "Dunaújváros",
    countryCode: "HU",
    country: "Hungary",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","HU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hu-020",
    lat: 46.836924,
    lng: 16.844014,
    panoId: "OxE-LXV5ILhdJUqsEd02HA",
    place: "Near Zalaegerszeg, Zala County",
    shortName: "Zalaegerszeg",
    countryCode: "HU",
    country: "Hungary",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","HU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hu-021",
    lat: 48.216606,
    lng: 20.299484,
    panoId: "DSZ0em0KGXpmI4McoMskIw",
    place: "Near Ózd, Borsod-Abaúj-Zemplén",
    shortName: "Ózd",
    countryCode: "HU",
    country: "Hungary",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","HU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hu-022",
    lat: 46.650021,
    lng: 21.283453,
    panoId: "pFDAZEZIPSCt7n1HdLC8Xg",
    place: "Near Gyula, Bekes County",
    shortName: "Gyula",
    countryCode: "HU",
    country: "Hungary",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","HU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hu-023",
    lat: 47.666474,
    lng: 21.517072,
    panoId: "R-GPhtDXtjE9GPQq1H9u9A",
    place: "Near Hajdúböszörmény, Hajdú-Bihar",
    shortName: "Hajdúböszörmény",
    countryCode: "HU",
    country: "Hungary",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","HU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hu-024",
    lat: 47.683427,
    lng: 17.634987,
    panoId: "U2foPMokwNJlNZuFuq76qw",
    place: "Near Győr, Győr-Moson-Sopron",
    shortName: "Győr",
    countryCode: "HU",
    country: "Hungary",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","HU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hu-025",
    lat: 47.101915,
    lng: 17.558848,
    panoId: "64HfbGPpE--gSrHNQYPmOw",
    place: "Near Ajka, Veszprém",
    shortName: "Ajka",
    countryCode: "HU",
    country: "Hungary",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","HU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hu-026",
    lat: 46.712048,
    lng: 19.844373,
    panoId: "_N4XiJ4BvlCUa755ry2Hlg",
    place: "Near Kiskunfélegyháza, Bács-Kiskun",
    shortName: "Kiskunfélegyháza",
    countryCode: "HU",
    country: "Hungary",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","HU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hu-027",
    lat: 47.172841,
    lng: 19.799159,
    panoId: "wXdZTZ3LfGatnSJY0kM8SA",
    place: "Near Cegléd, Pest County",
    shortName: "Cegléd",
    countryCode: "HU",
    country: "Hungary",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","HU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hu-028",
    lat: 47.33013,
    lng: 17.467446,
    panoId: "R2oZgx7456qESWsEe0OP5A",
    place: "Near Pápa, Veszprém",
    shortName: "Pápa",
    countryCode: "HU",
    country: "Hungary",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","HU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hu-029",
    lat: 47.955426,
    lng: 21.716372,
    panoId: "w3p1xCKBtx26JNZ86kTnwQ",
    place: "Near Nyíregyháza, Szabolcs-Szatmár-Bereg",
    shortName: "Nyíregyháza",
    countryCode: "HU",
    country: "Hungary",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","HU"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "hu-030",
    lat: 46.434073,
    lng: 19.484749,
    panoId: "S94qTwZucPuO-7D1_YE5uQ",
    place: "Near Kiskunhalas, Bács-Kiskun",
    shortName: "Kiskunhalas",
    countryCode: "HU",
    country: "Hungary",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","HU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hu-031",
    lat: 47.602004,
    lng: 18.394237,
    panoId: "-i4ZLf6sUJwbnys4e5VWYw",
    place: "Near Tatabánya, Komárom-Esztergom",
    shortName: "Tatabánya",
    countryCode: "HU",
    country: "Hungary",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","HU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hu-032",
    lat: 47.184487,
    lng: 20.210469,
    panoId: "MZ-DrWYayVH7j_XzBOZl6g",
    place: "Near Szolnok, Jász-Nagykun-Szolnok",
    shortName: "Szolnok",
    countryCode: "HU",
    country: "Hungary",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","HU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hu-033",
    lat: 47.233885,
    lng: 16.636107,
    panoId: "vyIqB5RgiMfLn6Dma8YTXg",
    place: "Near Szombathely, Vas County",
    shortName: "Szombathely",
    countryCode: "HU",
    country: "Hungary",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","HU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hu-034",
    lat: 47.399304,
    lng: 18.925837,
    panoId: "fyTP2q5qFdeF1uquDgOcjQ",
    place: "Near Érd, Pest County",
    shortName: "Érd",
    countryCode: "HU",
    country: "Hungary",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","HU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hu-035",
    lat: 47.636447,
    lng: 19.138718,
    panoId: "n9-XkM1Rw0rhwTQSC2kf-A",
    place: "Near Dunakeszi, Pest County",
    shortName: "Dunakeszi",
    countryCode: "HU",
    country: "Hungary",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","HU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hu-036",
    lat: 47.792734,
    lng: 18.741691,
    panoId: "o7Ue0g7z-YGIyA5fOvKILQ",
    place: "Near Esztergom, Komárom-Esztergom",
    shortName: "Esztergom",
    countryCode: "HU",
    country: "Hungary",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","HU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hu-037",
    lat: 47.086584,
    lng: 17.551586,
    panoId: "hnW3ABss2af8yGkYqs30cQ",
    place: "Near Ajka, Veszprém",
    shortName: "Ajka",
    countryCode: "HU",
    country: "Hungary",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","HU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hu-038",
    lat: 46.662238,
    lng: 21.273333,
    panoId: "hX8EAriz1o3vXQbp4-T29Q",
    place: "Near Gyula, Bekes County",
    shortName: "Gyula",
    countryCode: "HU",
    country: "Hungary",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","HU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hu-039",
    lat: 46.96351,
    lng: 18.908648,
    panoId: "W8AWscZsUKy_IfSJ3ak3oA",
    place: "Near Dunaújváros, Fejér",
    shortName: "Dunaújváros",
    countryCode: "HU",
    country: "Hungary",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","HU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hu-040",
    lat: 46.406421,
    lng: 20.345334,
    panoId: "o8bVfLyUBzgVCpfE4kNJ1Q",
    place: "Near Hódmezővásárhely, Csongrád",
    shortName: "Hódmezővásárhely",
    countryCode: "HU",
    country: "Hungary",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","HU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hu-041",
    lat: 47.86788,
    lng: 17.269714,
    panoId: "dc3inBA_HJWdDTm7XykE0Q",
    place: "Near Mosonmagyaróvár, Győr-Moson-Sopron",
    shortName: "Mosonmagyaróvár",
    countryCode: "HU",
    country: "Hungary",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","HU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hu-042",
    lat: 46.471413,
    lng: 17.007737,
    panoId: "hUuDxQsTyREeKzbiDaliyg",
    place: "Near Nagykanizsa, Zala County",
    shortName: "Nagykanizsa",
    countryCode: "HU",
    country: "Hungary",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","HU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hu-043",
    lat: 47.616653,
    lng: 19.353216,
    panoId: "nO3uUqJBrT3q1dplpGCWqg",
    place: "Near Gödöllő, Pest County",
    shortName: "Gödöllő",
    countryCode: "HU",
    country: "Hungary",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","HU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hu-044",
    lat: 47.675726,
    lng: 16.581882,
    panoId: "QAUjvYDqdYaIP8O3Msgczw",
    place: "Near Sopron, Győr-Moson-Sopron",
    shortName: "Sopron",
    countryCode: "HU",
    country: "Hungary",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","HU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hu-045",
    lat: 46.169136,
    lng: 18.939067,
    panoId: "Pk66-trRMDHgGqyl-0FhhQ",
    place: "Near Baja, Bács-Kiskun",
    shortName: "Baja",
    countryCode: "HU",
    country: "Hungary",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","HU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hu-046",
    lat: 46.665899,
    lng: 21.095519,
    panoId: "urm7s-D1WEf2N563g_j2Ig",
    place: "Near Békéscsaba, Bekes County",
    shortName: "Békéscsaba",
    countryCode: "HU",
    country: "Hungary",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","HU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hu-047",
    lat: 48.234303,
    lng: 20.308706,
    panoId: "29LJRa0oN_DI4Pvmr4-4CQ",
    place: "Near Ózd, Borsod-Abaúj-Zemplén",
    shortName: "Ózd",
    countryCode: "HU",
    country: "Hungary",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","HU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hu-048",
    lat: 47.675329,
    lng: 17.641982,
    panoId: "fJgEhGu0skNj5dnD1qkWaQ",
    place: "Near Győr, Győr-Moson-Sopron",
    shortName: "Győr",
    countryCode: "HU",
    country: "Hungary",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","HU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hu-049",
    lat: 46.905842,
    lng: 19.67569,
    panoId: "hUsvxhf0bhYOWJn6JxOItA",
    place: "Near Kecskemét, Bács-Kiskun",
    shortName: "Kecskemét",
    countryCode: "HU",
    country: "Hungary",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","HU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hu-050",
    lat: 46.411383,
    lng: 20.403998,
    panoId: "UnITkkIkw0TRylJxjPAAVQ",
    place: "Near Hódmezővásárhely, Csongrád",
    shortName: "Hódmezővásárhely",
    countryCode: "HU",
    country: "Hungary",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","HU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hu-051",
    lat: 46.497657,
    lng: 19.458661,
    panoId: "Lqiz0GvY-7X7z1FIyV8I0A",
    place: "Near Tázlár, Bács-Kiskun",
    shortName: "Tázlár",
    countryCode: "HU",
    country: "Hungary",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","HU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hu-052",
    lat: 47.649231,
    lng: 18.431901,
    panoId: "WySQrC_dF9-0FCuwn8ukmQ",
    place: "Near Tardos, Komárom-Esztergom",
    shortName: "Tardos",
    countryCode: "HU",
    country: "Hungary",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","HU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hu-053",
    lat: 47.722566,
    lng: 16.513463,
    panoId: "DfXSkuGHLuRdn6iKEOFfyg",
    place: "Near Schattendorf, Burgenland",
    shortName: "Schattendorf",
    countryCode: "HU",
    country: "Hungary",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","HU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hu-054",
    lat: 47.699678,
    lng: 17.717435,
    panoId: "ISBXEwv46i4S4LqXtL8Jow",
    place: "Near Győr, Győr-Moson-Sopron",
    shortName: "Győr",
    countryCode: "HU",
    country: "Hungary",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","HU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hu-055",
    lat: 47.265924,
    lng: 16.639061,
    panoId: "ktSg0VapVr_-XcfZ9Xf-xA",
    place: "Near Gencsapáti, Vas County",
    shortName: "Gencsapáti",
    countryCode: "HU",
    country: "Hungary",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","HU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hu-056",
    lat: 46.847568,
    lng: 16.921291,
    panoId: "Q_gRz619PqBXXZVi1iXI9g",
    place: "Near Zalaegerszeg, Zala County",
    shortName: "Zalaegerszeg",
    countryCode: "HU",
    country: "Hungary",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","HU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hu-057",
    lat: 46.711709,
    lng: 21.056906,
    panoId: "piN2xs7axrobJfcFwg5aVw",
    place: "Near Békéscsaba, Bekes County",
    shortName: "Békéscsaba",
    countryCode: "HU",
    country: "Hungary",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","HU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hu-058",
    lat: 48.180272,
    lng: 20.340068,
    panoId: "rs6H8KWVQPsv-ozzGSyIoQ",
    place: "Near Farkaslyuk, Borsod-Abaúj-Zemplén",
    shortName: "Farkaslyuk",
    countryCode: "HU",
    country: "Hungary",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","HU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hu-059",
    lat: 47.220909,
    lng: 20.236475,
    panoId: "05Ju5smAogvREY_29LoZQw",
    place: "Near Szolnok, Jász-Nagykun-Szolnok",
    shortName: "Szolnok",
    countryCode: "HU",
    country: "Hungary",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","HU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hu-060",
    lat: 46.304876,
    lng: 20.131857,
    panoId: "tYjWuVlwgHOBt-siCkI-jQ",
    place: "Near Szeged, Csongrád",
    shortName: "Szeged",
    countryCode: "HU",
    country: "Hungary",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","HU"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "hu-061",
    lat: 46.320695,
    lng: 17.763552,
    panoId: "WXEDY1c9tqItPDWSXA6NNg",
    place: "Near Kaposvár, Somogy County",
    shortName: "Kaposvár",
    countryCode: "HU",
    country: "Hungary",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","HU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hu-062",
    lat: 46.706446,
    lng: 21.252429,
    panoId: "8AI-aR5kO2bWFURhbVvE2A",
    place: "Near Doboz, Bekes County",
    shortName: "Doboz",
    countryCode: "HU",
    country: "Hungary",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","HU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hu-063",
    lat: 46.119108,
    lng: 18.209222,
    panoId: "2hTYMxajRj2EUOJsCQiTuw",
    place: "Near Pécs, Baranya",
    shortName: "Pécs",
    countryCode: "HU",
    country: "Hungary",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","HU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hu-064",
    lat: 46.925982,
    lng: 19.642232,
    panoId: "9lhyOqJita8m5ByuNjCs5g",
    place: "Near Kecskemét, Bács-Kiskun",
    shortName: "Kecskemét",
    countryCode: "HU",
    country: "Hungary",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","HU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hu-065",
    lat: 46.64925,
    lng: 20.196347,
    panoId: "4LhfsrFwoMfV8t2wL3KhSA",
    place: "Near Szentes, Csongrád",
    shortName: "Szentes",
    countryCode: "HU",
    country: "Hungary",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","HU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hu-066",
    lat: 46.508036,
    lng: 16.979306,
    panoId: "AJ08ho-5SEHE88u_38goHQ",
    place: "Near Nagyrécse, Zala County",
    shortName: "Nagyrécse",
    countryCode: "HU",
    country: "Hungary",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","HU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hu-067",
    lat: 47.80721,
    lng: 17.299449,
    panoId: "R4UH7evsT10Ue50FInQFYA",
    place: "Near Kimle, Győr-Moson-Sopron",
    shortName: "Kimle",
    countryCode: "HU",
    country: "Hungary",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","HU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hu-068",
    lat: 46.370174,
    lng: 19.513373,
    panoId: "pZsZN5zeDioYV0rFx4c8nQ",
    place: "Near Balotaszállás, Bács-Kiskun",
    shortName: "Balotaszállás",
    countryCode: "HU",
    country: "Hungary",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","HU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hu-069",
    lat: 46.387912,
    lng: 18.718128,
    panoId: "Tox49B1GsbbG4GIFDL3aLQ",
    place: "Near Szekszárd, Tolna County",
    shortName: "Szekszárd",
    countryCode: "HU",
    country: "Hungary",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","HU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hu-070",
    lat: 47.935234,
    lng: 21.745692,
    panoId: "sAjpkqDIdqgByV3yp3PM9Q",
    place: "Near Nyíregyháza, Szabolcs-Szatmár-Bereg",
    shortName: "Nyíregyháza",
    countryCode: "HU",
    country: "Hungary",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","HU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hu-071",
    lat: 47.151201,
    lng: 19.708509,
    panoId: "p2vGrnEbTh_161Kvfomzog",
    place: "Near Csemő, Pest County",
    shortName: "Csemő",
    countryCode: "HU",
    country: "Hungary",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","HU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hu-072",
    lat: 46.248561,
    lng: 18.310503,
    panoId: "Hy4X2Q7kX1NDEiS3xc0d3g",
    place: "Near Szászvár, Baranya",
    shortName: "Szászvár",
    countryCode: "HU",
    country: "Hungary",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","HU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hu-073",
    lat: 47.141427,
    lng: 17.992971,
    panoId: "AECLJ3TeBgVY8UKQ3vYSTw",
    place: "Near Hajmáskér, Veszprém",
    shortName: "Hajmáskér",
    countryCode: "HU",
    country: "Hungary",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","HU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hu-074",
    lat: 46.66632,
    lng: 19.818989,
    panoId: "EyJlkok3t0sVmvGrz0LSUA",
    place: "Near Kiskunfélegyháza, Bács-Kiskun",
    shortName: "Kiskunfélegyháza",
    countryCode: "HU",
    country: "Hungary",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","HU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hu-075",
    lat: 48.077632,
    lng: 19.735651,
    panoId: "pVus0gG1gM31YkMDMepJuA",
    place: "Near Salgótarján, Nógrád",
    shortName: "Salgótarján",
    countryCode: "HU",
    country: "Hungary",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","HU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hu-076",
    lat: 47.711434,
    lng: 21.504138,
    panoId: "rJ1012E95XkaW_lwMIuhrw",
    place: "Near Hajdúböszörmény, Hajdú-Bihar",
    shortName: "Hajdúböszörmény",
    countryCode: "HU",
    country: "Hungary",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","HU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hu-077",
    lat: 47.747657,
    lng: 18.794881,
    panoId: "LDI8w7F38PQHq3u4JqPa_w",
    place: "Near Kesztölc, Komárom-Esztergom",
    shortName: "Kesztölc",
    countryCode: "HU",
    country: "Hungary",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","HU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hu-078",
    lat: 46.784425,
    lng: 16.838118,
    panoId: "GvfKv8GMsP8irF0CsnFbcg",
    place: "Near Zalaegerszeg, Zala County",
    shortName: "Zalaegerszeg",
    countryCode: "HU",
    country: "Hungary",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","HU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hu-079",
    lat: 46.636645,
    lng: 20.232256,
    panoId: "LRRVUfx39H26Tkp5hLt7Rw",
    place: "Near Szentes, Csongrád",
    shortName: "Szentes",
    countryCode: "HU",
    country: "Hungary",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","HU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hu-080",
    lat: 48.173088,
    lng: 20.778603,
    panoId: "EyXTGDQTr14RGldI-yzKhQ",
    place: "Near Szirmabesenyő, Borsod-Abaúj-Zemplén",
    shortName: "Szirmabesenyő",
    countryCode: "HU",
    country: "Hungary",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","HU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hu-081",
    lat: 47.501948,
    lng: 21.628757,
    panoId: "ADynHygm2SDDhtrltd-teQ",
    place: "Near Debrecen, Hajdú-Bihar",
    shortName: "Debrecen",
    countryCode: "HU",
    country: "Hungary",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","HU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hu-082",
    lat: 47.633496,
    lng: 16.654546,
    panoId: "EuaySi9rW5QfCdb0TSTnUw",
    place: "Near Deutschkreutz, Burgenland",
    shortName: "Deutschkreutz",
    countryCode: "HU",
    country: "Hungary",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","HU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hu-083",
    lat: 47.309492,
    lng: 17.336867,
    panoId: "haON3sX_Ip_PAgnCjNmshw",
    place: "Near Pápa, Veszprém",
    shortName: "Pápa",
    countryCode: "HU",
    country: "Hungary",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","HU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hu-084",
    lat: 46.594156,
    lng: 20.710471,
    panoId: "jLF_l2FcI8rygW-wsZodDw",
    place: "Near Orosháza, Bekes County",
    shortName: "Orosháza",
    countryCode: "HU",
    country: "Hungary",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","HU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hu-085",
    lat: 46.342457,
    lng: 17.875792,
    panoId: "cUJI6nY-g3b3zAbQ_AMN1g",
    place: "Near Taszár, Somogy County",
    shortName: "Taszár",
    countryCode: "HU",
    country: "Hungary",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","HU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hu-086",
    lat: 47.181385,
    lng: 16.622414,
    panoId: "BA9J_QKXF_P5lZhQpkZI-Q",
    place: "Near Ják, Vas County",
    shortName: "Ják",
    countryCode: "HU",
    country: "Hungary",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","HU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hu-087",
    lat: 46.199127,
    lng: 18.348428,
    panoId: "NU_fkwfHoamHm7oMCHEXag",
    place: "Near Hosszúhetény, Baranya",
    shortName: "Hosszúhetény",
    countryCode: "HU",
    country: "Hungary",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","HU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hu-088",
    lat: 47.469423,
    lng: 21.356006,
    panoId: "nlQlCAhKziRp8dN2MWWqxg",
    place: "Near Hajdúszoboszló, Hajdú-Bihar",
    shortName: "Hajdúszoboszló",
    countryCode: "HU",
    country: "Hungary",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","HU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hu-089",
    lat: 47.356613,
    lng: 19.274166,
    panoId: "ZKnmxPVsQTUcOXqK6_TBqw",
    place: "Near Felsőpakony, Pest County",
    shortName: "Felsőpakony",
    countryCode: "HU",
    country: "Hungary",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","HU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hu-090",
    lat: 46.720795,
    lng: 21.078618,
    panoId: "Pwq7G75npeKLyZUwBkvDCQ",
    place: "Near Békéscsaba, Bekes County",
    shortName: "Békéscsaba",
    countryCode: "HU",
    country: "Hungary",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","HU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hu-091",
    lat: 47.723366,
    lng: 21.571018,
    panoId: "WcN-fl1MH1NhZDgqrqqrpw",
    place: "Near Hajdúböszörmény, Hajdú-Bihar",
    shortName: "Hajdúböszörmény",
    countryCode: "HU",
    country: "Hungary",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","HU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hu-092",
    lat: 47.373664,
    lng: 19.408348,
    panoId: "wuF4fQ3V8Wo-KcI8obnoaQ",
    place: "Near Péteri, Pest County",
    shortName: "Péteri",
    countryCode: "HU",
    country: "Hungary",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","HU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hu-093",
    lat: 47.345757,
    lng: 20.854984,
    panoId: "cDIwhts9qCp8FQWYrr1OOQ",
    place: "Near Karcag, Jász-Nagykun-Szolnok",
    shortName: "Karcag",
    countryCode: "HU",
    country: "Hungary",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","HU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hu-094",
    lat: 46.183458,
    lng: 19.07225,
    panoId: "jBgp6OpAF4Ql0jFjeZp_xA",
    place: "Near Csávoly, Bács-Kiskun",
    shortName: "Csávoly",
    countryCode: "HU",
    country: "Hungary",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","HU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hu-095",
    lat: 48.00236,
    lng: 19.71611,
    panoId: "OXY5ny754EzXlBKFsoBEXA",
    place: "Near Mátraverebély, Nógrád",
    shortName: "Mátraverebély",
    countryCode: "HU",
    country: "Hungary",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","HU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hu-096",
    lat: 46.795205,
    lng: 19.607207,
    panoId: "ZNimmBFhWfkmzuv3-VYQtw",
    place: "Near Jakabszállás, Bács-Kiskun",
    shortName: "Jakabszállás",
    countryCode: "HU",
    country: "Hungary",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","HU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hu-097",
    lat: 45.900336,
    lng: 18.250681,
    panoId: "QCkEP2N6j_AJKGl_ZFdnqQ",
    place: "Near Harkány, Baranya",
    shortName: "Harkány",
    countryCode: "HU",
    country: "Hungary",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","HU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hu-098",
    lat: 46.536051,
    lng: 20.290534,
    panoId: "6xGLvSJQaC00Lh4pr-QVOg",
    place: "Near Szegvár, Csongrád",
    shortName: "Szegvár",
    countryCode: "HU",
    country: "Hungary",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","HU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hu-099",
    lat: 47.882331,
    lng: 18.146656,
    panoId: "DffloKRmVkhZ5Le6As-kEA",
    place: "Near Imeľ, Nitra Region",
    shortName: "Imeľ",
    countryCode: "HU",
    country: "Hungary",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","HU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hu-100",
    lat: 46.54593,
    lng: 18.686975,
    panoId: "55czNoz9Wj6bFs1D56zXig",
    place: "Near Tengelic, Tolna County",
    shortName: "Tengelic",
    countryCode: "HU",
    country: "Hungary",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","HU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hu-101",
    lat: 48.097208,
    lng: 20.383522,
    panoId: "EAZUB2K9Mm6_zGGeElAx7g",
    place: "Near Szilvásvárad, Heves County",
    shortName: "Szilvásvárad",
    countryCode: "HU",
    country: "Hungary",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","HU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hu-102",
    lat: 46.668461,
    lng: 20.472266,
    panoId: "Vpk0GNQiCBZdnzxtydgXBA",
    place: "Near Fábiánsebestyén, Csongrád",
    shortName: "Fábiánsebestyén",
    countryCode: "HU",
    country: "Hungary",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","HU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hu-103",
    lat: 47.77244,
    lng: 20.162782,
    panoId: "5enl1bUcw3ZzCRkNIe2ZZA",
    place: "Near Aldebrő, Heves County",
    shortName: "Aldebrő",
    countryCode: "HU",
    country: "Hungary",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","HU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hu-104",
    lat: 46.652706,
    lng: 18.608019,
    panoId: "-6zGndLwFTqsuf5Ukhd82w",
    place: "Near Nagydorog, Tolna County",
    shortName: "Nagydorog",
    countryCode: "HU",
    country: "Hungary",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","HU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hu-105",
    lat: 47.762767,
    lng: 17.392559,
    panoId: "mX_UO1pyJ2pcN8ReynC5vA",
    place: "Near Lébény, Győr-Moson-Sopron",
    shortName: "Lébény",
    countryCode: "HU",
    country: "Hungary",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","HU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ro-000",
    lat: 45.648999,
    lng: 25.605695,
    panoId: "1Ex8OxirwxZ69buacIdHbA",
    place: "Near Braşov, Brașov County",
    shortName: "Braşov",
    countryCode: "RO",
    country: "Romania",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","RO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ro-001",
    lat: 44.432315,
    lng: 26.106124,
    panoId: "U-4D1UoSBMTtFsI90fmrLw",
    place: "Near Bucharest, Bucharest",
    shortName: "Bucharest",
    countryCode: "RO",
    country: "Romania",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","RO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ro-002",
    lat: 46.567136,
    lng: 26.913761,
    panoId: "Op4KLlw5OzVJmJ0rvuIjvQ",
    place: "Near Bacău, Bacău County",
    shortName: "Bacău",
    countryCode: "RO",
    country: "Romania",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","RO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ro-003",
    lat: 45.27196,
    lng: 27.974378,
    panoId: "JGuTScEDVspbB92SzfXAdA",
    place: "Near Brăila, Brăila County",
    shortName: "Brăila",
    countryCode: "RO",
    country: "Romania",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","RO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ro-004",
    lat: 44.949904,
    lng: 26.016684,
    panoId: "c0avoBK_S3MT61BHr3DQDA",
    place: "Near Ploieşti, Prahova",
    shortName: "Ploieşti",
    countryCode: "RO",
    country: "Romania",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","RO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ro-005",
    lat: 46.916669,
    lng: 26.325531,
    panoId: "thz_ykt-VB9eUUccAiNFhw",
    place: "Near Piatra Neamţ, Neamț County",
    shortName: "Piatra Neamţ",
    countryCode: "RO",
    country: "Romania",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","RO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ro-006",
    lat: 47.657293,
    lng: 23.568123,
    panoId: "hRzg4g6PQ96dfIOkFqa9fA",
    place: "Near Baia Mare, Maramureş",
    shortName: "Baia Mare",
    countryCode: "RO",
    country: "Romania",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","RO"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "ro-007",
    lat: 46.766605,
    lng: 23.599719,
    panoId: "rZYRMQ0SUFKcDE0vjkZTAg",
    place: "Near Cluj-Napoca, Cluj County",
    shortName: "Cluj-Napoca",
    countryCode: "RO",
    country: "Romania",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","RO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ro-008",
    lat: 45.88336,
    lng: 22.900197,
    panoId: "5GxuVf7cRjGDnxtmu1hSgg",
    place: "Near Deva, Hunedoara County",
    shortName: "Deva",
    countryCode: "RO",
    country: "Romania",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","RO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ro-009",
    lat: 47.166672,
    lng: 27.6001,
    panoId: "03mQlYDQmryPhDMOEW4voA",
    place: "Near Iaşi, Iași County",
    shortName: "Iaşi",
    countryCode: "RO",
    country: "Romania",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","RO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ro-010",
    lat: 47.635143,
    lng: 26.248298,
    panoId: "FWwNlAwCEManNHhKpGIfww",
    place: "Near Suceava, Suceava",
    shortName: "Suceava",
    countryCode: "RO",
    country: "Romania",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","RO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ro-011",
    lat: 45.150462,
    lng: 26.832656,
    panoId: "PYg4hjJ3nU1tAFKOpUKx6Q",
    place: "Near Buzău, Buzău County",
    shortName: "Buzău",
    countryCode: "RO",
    country: "Romania",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","RO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ro-012",
    lat: 45.050002,
    lng: 23.283271,
    panoId: "aeff8kOfTkaIN3vMt2uclw",
    place: "Near Târgu Jiu, Gorj County",
    shortName: "Târgu Jiu",
    countryCode: "RO",
    country: "Romania",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","RO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ro-013",
    lat: 45.700025,
    lng: 27.183649,
    panoId: "SppL0ZkCzOdwEjKoneyxaw",
    place: "Near Focșani, Vrancea",
    shortName: "Focșani",
    countryCode: "RO",
    country: "Romania",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","RO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ro-014",
    lat: 46.066284,
    lng: 23.583063,
    panoId: "k1rwyHdKZtqRtMo00MZJ4g",
    place: "Near Alba Iulia, Alba County",
    shortName: "Alba Iulia",
    countryCode: "RO",
    country: "Romania",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","RO"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "ro-015",
    lat: 46.542415,
    lng: 24.55766,
    panoId: "7a-uGcpt6YsOXEwIIqVs8w",
    place: "Near Târgu Mureş, Mureș County",
    shortName: "Târgu Mureş",
    countryCode: "RO",
    country: "Romania",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","RO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ro-016",
    lat: 44.925396,
    lng: 25.456534,
    panoId: "gQ4HL0-PaJSWnwbQjU29wA",
    place: "Near Târgovişte, Dâmbovița County",
    shortName: "Târgovişte",
    countryCode: "RO",
    country: "Romania",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","RO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ro-017",
    lat: 45.753758,
    lng: 21.225425,
    panoId: "mJFT9A0PjcoDeIWLhpPKzg",
    place: "Near Timişoara, Timiș County",
    shortName: "Timişoara",
    countryCode: "RO",
    country: "Romania",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","RO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ro-018",
    lat: 45.750034,
    lng: 22.899982,
    panoId: "T4qXOQ1q3hEcNPbg8jamlA",
    place: "Near Hunedoara, Hunedoara County",
    shortName: "Hunedoara",
    countryCode: "RO",
    country: "Romania",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","RO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ro-019",
    lat: 45.178685,
    lng: 28.804996,
    panoId: "9WQFyGGzduq2ljz6wBss8Q",
    place: "Near Tulcea, Tulcea County",
    shortName: "Tulcea",
    countryCode: "RO",
    country: "Romania",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","RO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ro-020",
    lat: 46.183321,
    lng: 21.316621,
    panoId: "JUbbWbkXPUa1dFxSOE0cVw",
    place: "Near Arad, Arad County",
    shortName: "Arad",
    countryCode: "RO",
    country: "Romania",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","RO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ro-021",
    lat: 45.800282,
    lng: 24.149862,
    panoId: "pk-fGE3z6O1_1CMSiXfxiw",
    place: "Near Sibiu, Sibiu County",
    shortName: "Sibiu",
    countryCode: "RO",
    country: "Romania",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","RO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ro-022",
    lat: 47.133033,
    lng: 24.500229,
    panoId: "_2gs3v3aOyUJR8xNQZpDXA",
    place: "Near Bistriţa, Bistrița-Năsăud County",
    shortName: "Bistriţa",
    countryCode: "RO",
    country: "Romania",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","RO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ro-023",
    lat: 46.231936,
    lng: 27.669062,
    panoId: "M8N1SdVQWKPJIKUpb1NIzA",
    place: "Near Bârlad, Vaslui County",
    shortName: "Bârlad",
    countryCode: "RO",
    country: "Romania",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","RO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ro-024",
    lat: 47.045818,
    lng: 21.918334,
    panoId: "Ee9KJD2ooUNVjxhAieyRhg",
    place: "Near Oradea, Bihor County",
    shortName: "Oradea",
    countryCode: "RO",
    country: "Romania",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","RO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ro-025",
    lat: 45.436864,
    lng: 28.050276,
    panoId: "xXrz8hjpf2_7p2PKOK9FVw",
    place: "Near Galaţi, Galați County",
    shortName: "Galaţi",
    countryCode: "RO",
    country: "Romania",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","RO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ro-026",
    lat: 44.850047,
    lng: 24.866669,
    panoId: "zMTHQdY_92KVnZKQihXKvw",
    place: "Near Piteşti, Arges",
    shortName: "Piteşti",
    countryCode: "RO",
    country: "Romania",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","RO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ro-027",
    lat: 44.433224,
    lng: 24.367572,
    panoId: "4jzxPfU5HHSLOvapIy9I7w",
    place: "Near Slatina, Olt",
    shortName: "Slatina",
    countryCode: "RO",
    country: "Romania",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","RO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ro-028",
    lat: 45.100275,
    lng: 24.366702,
    panoId: "rsDi0JqREzKZd80pk7Nh2A",
    place: "Near Râmnicu Vâlcea, Vâlcea County",
    shortName: "Râmnicu Vâlcea",
    countryCode: "RO",
    country: "Romania",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","RO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ro-029",
    lat: 45.303006,
    lng: 21.886191,
    panoId: "EVgVfUooDTMRSFfvs6XJMg",
    place: "Near Reşiţa, Caraș-Severin County",
    shortName: "Reşiţa",
    countryCode: "RO",
    country: "Romania",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","RO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ro-030",
    lat: 47.749936,
    lng: 26.666759,
    panoId: "s60DRxg1g4dL3I5PnMJGxA",
    place: "Near Botoşani, Botoșani County",
    shortName: "Botoşani",
    countryCode: "RO",
    country: "Romania",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","RO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ro-031",
    lat: 44.626923,
    lng: 22.652843,
    panoId: "pqmFZuC1QV7DRK6ALurBKw",
    place: "Near Drobeta-Turnu Severin, Mehedinți County",
    shortName: "Drobeta-Turnu Severin",
    countryCode: "RO",
    country: "Romania",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","RO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ro-032",
    lat: 46.166728,
    lng: 24.350433,
    panoId: "7VcqwkbyzrKlrV9zTXy1LQ",
    place: "Near Mediaş, Sibiu County",
    shortName: "Mediaş",
    countryCode: "RO",
    country: "Romania",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","RO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ro-033",
    lat: 43.886657,
    lng: 25.962693,
    panoId: "XlY0D4ZEWRuY-tpm_y-dxg",
    place: "Near Giurgiu, Giurgiu County",
    shortName: "Giurgiu",
    countryCode: "RO",
    country: "Romania",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","RO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ro-034",
    lat: 46.632616,
    lng: 27.732916,
    panoId: "mvFR-L-XAiCZMhgxTmSpaQ",
    place: "Near Vaslui, Vaslui County",
    shortName: "Vaslui",
    countryCode: "RO",
    country: "Romania",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","RO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ro-035",
    lat: 45.879247,
    lng: 22.917469,
    panoId: "wGecE54XLkJioVm0a0LxMg",
    place: "Near Deva, Hunedoara County",
    shortName: "Deva",
    countryCode: "RO",
    country: "Romania",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","RO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ro-036",
    lat: 46.57786,
    lng: 26.90811,
    panoId: "XwYrfmmF3JZgaYHauodgFg",
    place: "Near Bacău, Bacău County",
    shortName: "Bacău",
    countryCode: "RO",
    country: "Romania",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","RO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ro-037",
    lat: 45.771573,
    lng: 21.245574,
    panoId: "Dm4c0rvNCuAaSqmnrb1H9Q",
    place: "Near Timişoara, Timiș County",
    shortName: "Timişoara",
    countryCode: "RO",
    country: "Romania",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","RO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ro-038",
    lat: 45.69857,
    lng: 27.200083,
    panoId: "FVdhto466mEZWg0RLIfJig",
    place: "Near Focșani, Vrancea",
    shortName: "Focșani",
    countryCode: "RO",
    country: "Romania",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","RO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ro-039",
    lat: 45.662893,
    lng: 25.626405,
    panoId: "ceo3q0jhU-xa4icJV81nNQ",
    place: "Near Braşov, Brașov County",
    shortName: "Braşov",
    countryCode: "RO",
    country: "Romania",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","RO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ro-040",
    lat: 47.787038,
    lng: 22.842852,
    panoId: "X9dhuCNmEW3h_WfpfD8jFQ",
    place: "Near Satu Mare, Satu Mare County",
    shortName: "Satu Mare",
    countryCode: "RO",
    country: "Romania",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","RO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ro-041",
    lat: 46.927198,
    lng: 26.94768,
    panoId: "emJotwas0PSdMIDwaKWcow",
    place: "Near Roman, Neamț County",
    shortName: "Roman",
    countryCode: "RO",
    country: "Romania",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","RO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ro-042",
    lat: 46.243486,
    lng: 27.678322,
    panoId: "Ai6mtNxu05KhkNq7NsEe3g",
    place: "Near Bârlad, Vaslui County",
    shortName: "Bârlad",
    countryCode: "RO",
    country: "Romania",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","RO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ro-043",
    lat: 46.755343,
    lng: 23.572197,
    panoId: "bdc7AbDJ8wHAjND1c4H1AQ",
    place: "Near Cluj-Napoca, Cluj County",
    shortName: "Cluj-Napoca",
    countryCode: "RO",
    country: "Romania",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","RO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ro-044",
    lat: 45.060605,
    lng: 23.27349,
    panoId: "q9PrCkMjERpgWneViCGdHg",
    place: "Near Târgu Jiu, Gorj County",
    shortName: "Târgu Jiu",
    countryCode: "RO",
    country: "Romania",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","RO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ro-045",
    lat: 47.157805,
    lng: 27.609498,
    panoId: "zcTE7oOgcRNHDIvdoIXM9A",
    place: "Near Iaşi, Iași County",
    shortName: "Iaşi",
    countryCode: "RO",
    country: "Romania",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","RO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ro-046",
    lat: 45.165491,
    lng: 28.827163,
    panoId: "2k4i79C7P15Lvs1t0knjvg",
    place: "Near Tulcea, Tulcea County",
    shortName: "Tulcea",
    countryCode: "RO",
    country: "Romania",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","RO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ro-047",
    lat: 46.936148,
    lng: 26.33886,
    panoId: "tDNrw9088l9LCa0rvMn1bQ",
    place: "Near Piatra Neamţ, Neamț County",
    shortName: "Piatra Neamţ",
    countryCode: "RO",
    country: "Romania",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","RO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ro-048",
    lat: 44.837849,
    lng: 24.865667,
    panoId: "dRP2Z4kvS8Plmo7_dshPgg",
    place: "Near Piteşti, Arges",
    shortName: "Piteşti",
    countryCode: "RO",
    country: "Romania",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","RO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ro-049",
    lat: 47.634543,
    lng: 26.278176,
    panoId: "yXO6k1sRsNRglLcJd1HIVA",
    place: "Near Ipoteşti, Suceava",
    shortName: "Ipoteşti",
    countryCode: "RO",
    country: "Romania",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","RO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ro-050",
    lat: 44.209198,
    lng: 28.628889,
    panoId: "Sn2MVBCZ0JweYIFNMeK18Q",
    place: "Near Palazu Mare, Constanța County",
    shortName: "Palazu Mare",
    countryCode: "RO",
    country: "Romania",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","RO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ro-051",
    lat: 45.120466,
    lng: 26.8771,
    panoId: "w4BcEcxpGAJjShxZYvOgoQ",
    place: "Near Scurtești, Buzău County",
    shortName: "Scurtești",
    countryCode: "RO",
    country: "Romania",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","RO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ro-052",
    lat: 44.45357,
    lng: 24.394006,
    panoId: "KJ67quboxCHcWO7kEJddoQ",
    place: "Near Slatina, Olt",
    shortName: "Slatina",
    countryCode: "RO",
    country: "Romania",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","RO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ro-053",
    lat: 47.251373,
    lng: 22.982906,
    panoId: "sjqx9_dcIGlNayv2yhcgPg",
    place: "Near Hereclean, Sălaj County",
    shortName: "Hereclean",
    countryCode: "RO",
    country: "Romania",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","RO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ro-054",
    lat: 47.066833,
    lng: 21.836121,
    panoId: "BTOcM0DOv6Sfz5q7rXoABA",
    place: "Near Sântandrei, Bihor County",
    shortName: "Sântandrei",
    countryCode: "RO",
    country: "Romania",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","RO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ro-055",
    lat: 45.720015,
    lng: 22.877757,
    panoId: "UVeQWkZK7wTP-DiTS1LgrQ",
    place: "Near Teliucu Inferior, Hunedoara County",
    shortName: "Teliucu Inferior",
    countryCode: "RO",
    country: "Romania",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","RO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ro-056",
    lat: 45.80254,
    lng: 21.157987,
    panoId: "x2KLxuyLGXx-xhWdnrXh0A",
    place: "Near Sânandrei, Timiș County",
    shortName: "Sânandrei",
    countryCode: "RO",
    country: "Romania",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","RO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ro-057",
    lat: 45.871051,
    lng: 22.846115,
    panoId: "ergTX_kXrDGNrD2iVnYBNg",
    place: "Near Cârjiţi, Hunedoara County",
    shortName: "Cârjiţi",
    countryCode: "RO",
    country: "Romania",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","RO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ro-058",
    lat: 47.672201,
    lng: 26.327875,
    panoId: "pPCsQ50QMb5xAn8xF2wd_Q",
    place: "Near Plopeni, Suceava",
    shortName: "Plopeni",
    countryCode: "RO",
    country: "Romania",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","RO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ro-059",
    lat: 45.71571,
    lng: 27.117042,
    panoId: "oBOGcAyUSN8BpizpjOk9rg",
    place: "Near Câmpineanca, Vrancea",
    shortName: "Câmpineanca",
    countryCode: "RO",
    country: "Romania",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","RO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ro-060",
    lat: 45.20579,
    lng: 28.783632,
    panoId: "DHX3VDs-z2WoMm1vZ9Nmcg",
    place: "Near Tulcea, Tulcea County",
    shortName: "Tulcea",
    countryCode: "RO",
    country: "Romania",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","RO"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "ro-061",
    lat: 45.594713,
    lng: 25.531942,
    panoId: "V3Ay_zxxASjtbOYPdGrwOQ",
    place: "Near Cristian, Brașov County",
    shortName: "Cristian",
    countryCode: "RO",
    country: "Romania",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","RO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ro-062",
    lat: 47.112283,
    lng: 27.593384,
    panoId: "Tv8q1xSV0AL9xrUy4X61ug",
    place: "Near Lunca Cetățuii, Iași County",
    shortName: "Lunca Cetățuii",
    countryCode: "RO",
    country: "Romania",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","RO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ro-063",
    lat: 45.441134,
    lng: 27.98745,
    panoId: "-9KJ0P78mK0kEbwei1z4uQ",
    place: "Near Galaţi, Galați County",
    shortName: "Galaţi",
    countryCode: "RO",
    country: "Romania",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","RO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ro-064",
    lat: 46.115714,
    lng: 24.382348,
    panoId: "xyyO5mKP4RqQJsrYFuXOqQ",
    place: "Near Ighișu Nou, Sibiu County",
    shortName: "Ighișu Nou",
    countryCode: "RO",
    country: "Romania",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","RO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ro-065",
    lat: 46.717969,
    lng: 23.630324,
    panoId: "t4qaxzLHVkIrTBse3YqG4g",
    place: "Near Feleacu, Cluj County",
    shortName: "Feleacu",
    countryCode: "RO",
    country: "Romania",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","RO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ro-066",
    lat: 46.976332,
    lng: 26.360836,
    panoId: "AjhEg9AHAl3-dyzUW4a9GQ",
    place: "Near Gârcina, Neamț County",
    shortName: "Gârcina",
    countryCode: "RO",
    country: "Romania",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","RO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ro-067",
    lat: 46.225843,
    lng: 21.368,
    panoId: "ndpJD_D17HX3y-90Fg8DqQ",
    place: "Near Livada, Arad County",
    shortName: "Livada",
    countryCode: "RO",
    country: "Romania",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","RO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ro-068",
    lat: 44.48952,
    lng: 24.330375,
    panoId: "dZJd1gR_QGEv3nOJ-BYe0A",
    place: "Near Curtişoara, Olt",
    shortName: "Curtişoara",
    countryCode: "RO",
    country: "Romania",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","RO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ro-069",
    lat: 45.812341,
    lng: 25.773486,
    panoId: "3S1AtOQsAhoYQ4nsuYjWJg",
    place: "Near Ilieni, Covasna County",
    shortName: "Ilieni",
    countryCode: "RO",
    country: "Romania",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","RO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ro-070",
    lat: 43.852975,
    lng: 26.010729,
    panoId: "Qizzy8-WcPen_A73lzjpkA",
    place: "Near Ruse, Ruse",
    shortName: "Ruse",
    countryCode: "RO",
    country: "Romania",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","RO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ro-071",
    lat: 44.137382,
    lng: 28.603982,
    panoId: "LOvnIH4PJ9Mkp3K81R1blg",
    place: "Near Cumpăna, Constanța County",
    shortName: "Cumpăna",
    countryCode: "RO",
    country: "Romania",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","RO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ro-072",
    lat: 47.617058,
    lng: 23.585477,
    panoId: "J9zzTGBkbBNgG5eZiJq-rw",
    place: "Near Groşi, Maramureş",
    shortName: "Groşi",
    countryCode: "RO",
    country: "Romania",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","RO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ro-073",
    lat: 45.213353,
    lng: 28.028505,
    panoId: "-EunDEa6IZCLf45PcI08uQ",
    place: "Near Brăila, Brăila County",
    shortName: "Brăila",
    countryCode: "RO",
    country: "Romania",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","RO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ro-074",
    lat: 44.430843,
    lng: 26.064148,
    panoId: "BePq0W8LMrH--tVa6kLyUQ",
    place: "Near Bucharest, Bucharest",
    shortName: "Bucharest",
    countryCode: "RO",
    country: "Romania",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","RO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ro-075",
    lat: 46.615836,
    lng: 23.782687,
    panoId: "zNxNPlzedRPIhk7wT8vhfg",
    place: "Near Copăceni, Cluj County",
    shortName: "Copăceni",
    countryCode: "RO",
    country: "Romania",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","RO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ro-076",
    lat: 47.061904,
    lng: 21.998847,
    panoId: "Z7dOsPLHkb7vlZAJ5XRWgQ",
    place: "Near Oșorhei, Bihor County",
    shortName: "Oșorhei",
    countryCode: "RO",
    country: "Romania",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","RO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ro-077",
    lat: 45.426341,
    lng: 27.053226,
    panoId: "yymCKRxIJ_hQqeKbYQYuVQ",
    place: "Near Podgoria, Buzău County",
    shortName: "Podgoria",
    countryCode: "RO",
    country: "Romania",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","RO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ro-078",
    lat: 46.614905,
    lng: 26.941189,
    panoId: "U0C72E_QQayaNGx98DY5AA",
    place: "Near Săucești, Bacău County",
    shortName: "Săucești",
    countryCode: "RO",
    country: "Romania",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","RO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ro-079",
    lat: 47.130933,
    lng: 24.418789,
    panoId: "clSRAi5WRYjzaA6eqQ5nJw",
    place: "Near Viișoara, Bistrița-Năsăud County",
    shortName: "Viișoara",
    countryCode: "RO",
    country: "Romania",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","RO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ro-080",
    lat: 46.284276,
    lng: 25.213094,
    panoId: "HvvKLroxxjwO2Pg_XPDhMg",
    place: "Near Mugeni, Harghita County",
    shortName: "Mugeni",
    countryCode: "RO",
    country: "Romania",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","RO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ro-081",
    lat: 46.242882,
    lng: 24.761385,
    panoId: "EIa26HT7EcZ1cJeyZl6_Ww",
    place: "Near Sighișoara, Mureș County",
    shortName: "Sighișoara",
    countryCode: "RO",
    country: "Romania",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","RO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ro-082",
    lat: 44.960359,
    lng: 25.476501,
    panoId: "_H2QwuPqF00zqtgoxr0ixA",
    place: "Near Viforâta, Dâmbovița County",
    shortName: "Viforâta",
    countryCode: "RO",
    country: "Romania",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","RO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ro-083",
    lat: 44.304424,
    lng: 23.705143,
    panoId: "XKHgZG7GlKCyDaAnHiWI6g",
    place: "Near Bucovăţ, Dolj",
    shortName: "Bucovăţ",
    countryCode: "RO",
    country: "Romania",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","RO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ro-084",
    lat: 46.478077,
    lng: 24.576554,
    panoId: "AD3Y92ALuPZGxaclGDLifA",
    place: "Near Crăciuneşti, Mureș County",
    shortName: "Crăciuneşti",
    countryCode: "RO",
    country: "Romania",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","RO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ro-085",
    lat: 47.089674,
    lng: 23.896252,
    panoId: "UG42qRNzkZU3dP6JtexfXA",
    place: "Near Ocna Dejului, Cluj County",
    shortName: "Ocna Dejului",
    countryCode: "RO",
    country: "Romania",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","RO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ro-086",
    lat: 43.82447,
    lng: 28.492351,
    panoId: "WkROjXryNjeYY1ddhbCGCA",
    place: "Near Limanu, Constanța County",
    shortName: "Limanu",
    countryCode: "RO",
    country: "Romania",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","RO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ro-087",
    lat: 46.106289,
    lng: 23.544067,
    panoId: "MOy8-M277zFgfNKdmZ8DAQ",
    place: "Near Micești, Alba County",
    shortName: "Micești",
    countryCode: "RO",
    country: "Romania",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","RO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ro-088",
    lat: 45.301688,
    lng: 21.9714,
    panoId: "V28SYPX66PdlpBPYCK4s9A",
    place: "Near Târnova, Caraș-Severin County",
    shortName: "Târnova",
    countryCode: "RO",
    country: "Romania",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","RO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ro-089",
    lat: 47.096732,
    lng: 22.813497,
    panoId: "KZPgfTQPf_rQV_5z6OfDaQ",
    place: "Near Bănişor, Sălaj County",
    shortName: "Bănişor",
    countryCode: "RO",
    country: "Romania",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","RO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ro-090",
    lat: 46.75062,
    lng: 27.914335,
    panoId: "Nj6bJTLKaF22gmSWoQT6rQ",
    place: "Near Gugești, Vaslui County",
    shortName: "Gugești",
    countryCode: "RO",
    country: "Romania",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","RO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ro-091",
    lat: 47.808272,
    lng: 26.610166,
    panoId: "hGCKbYm4QZPBswHVeAvNLA",
    place: "Near Roma, Botoșani County",
    shortName: "Roma",
    countryCode: "RO",
    country: "Romania",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","RO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ro-092",
    lat: 46.501701,
    lng: 23.953792,
    panoId: "bBoUI1YJQTi8Ozh5gkX3pg",
    place: "Near Luna, Cluj County",
    shortName: "Luna",
    countryCode: "RO",
    country: "Romania",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","RO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ro-093",
    lat: 48.070556,
    lng: 26.301339,
    panoId: "lY5a_djoGgtmZt7p3L9O2g",
    place: "Near Pomârla, Botoșani County",
    shortName: "Pomârla",
    countryCode: "RO",
    country: "Romania",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","RO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ro-094",
    lat: 44.229896,
    lng: 24.122051,
    panoId: "oo0iDYdyQk5GPe8pnaTe1g",
    place: "Near Drăgoteşti, Dolj",
    shortName: "Drăgoteşti",
    countryCode: "RO",
    country: "Romania",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","RO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ro-095",
    lat: 44.111119,
    lng: 25.399327,
    panoId: "5KjRhwNYZTaKfbTXadsaMA",
    place: "Near Merișani, Teleorman County",
    shortName: "Merișani",
    countryCode: "RO",
    country: "Romania",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","RO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ro-096",
    lat: 45.446862,
    lng: 23.343674,
    panoId: "BXGUskLHTXK5E_X5tjN_2A",
    place: "Near Petroşani, Hunedoara County",
    shortName: "Petroşani",
    countryCode: "RO",
    country: "Romania",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","RO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ro-097",
    lat: 44.303533,
    lng: 28.080979,
    panoId: "qkPYtB3SPI3qQLW3HLy7VQ",
    place: "Near Saligny, Constanța County",
    shortName: "Saligny",
    countryCode: "RO",
    country: "Romania",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","RO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ro-098",
    lat: 44.942519,
    lng: 25.753091,
    panoId: "_iiW9ORc7MPiXhOn-4HRmQ",
    place: "Near Mărginenii de Sus, Dâmbovița County",
    shortName: "Mărginenii de Sus",
    countryCode: "RO",
    country: "Romania",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","RO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ro-099",
    lat: 43.697037,
    lng: 24.817088,
    panoId: "m0OFVD_uYdDcTFhIAgabdw",
    place: "Near Islaz, Teleorman County",
    shortName: "Islaz",
    countryCode: "RO",
    country: "Romania",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","RO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ro-100",
    lat: 47.679484,
    lng: 22.6991,
    panoId: "h3ujr0nhzzUGfr4ELh7HxQ",
    place: "Near Terebeşti, Satu Mare County",
    shortName: "Terebeşti",
    countryCode: "RO",
    country: "Romania",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","RO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ro-101",
    lat: 45.785026,
    lng: 25.202428,
    panoId: "q3Fl9olwhVxKng589Ciiqg",
    place: "Near Perșani, Brașov County",
    shortName: "Perșani",
    countryCode: "RO",
    country: "Romania",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","RO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ro-102",
    lat: 43.691711,
    lng: 28.495378,
    panoId: "dvCtOwb1zy22zXo4-B9ASA",
    place: "Near Limanu, Constanța County",
    shortName: "Limanu",
    countryCode: "RO",
    country: "Romania",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","RO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ro-103",
    lat: 43.939911,
    lng: 24.42517,
    panoId: "F5QvcoMYNcfsyWlG8vRYOA",
    place: "Near Crușovu, Olt",
    shortName: "Crușovu",
    countryCode: "RO",
    country: "Romania",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","RO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ro-104",
    lat: 44.353858,
    lng: 23.549754,
    panoId: "9VDe0gR1zKiWsZt9qvHQIg",
    place: "Near Pleșoi, Dolj",
    shortName: "Pleșoi",
    countryCode: "RO",
    country: "Romania",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","RO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ro-105",
    lat: 47.061585,
    lng: 23.658477,
    panoId: "8PQoZ3kde4SAslM4jV7V_A",
    place: "Near Corneşti, Cluj County",
    shortName: "Corneşti",
    countryCode: "RO",
    country: "Romania",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","RO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hr-000",
    lat: 45.437621,
    lng: 16.289774,
    panoId: "rJwloAEerh3wTKufsw-2cw",
    place: "Near Petrinja, Sisak-Moslavina",
    shortName: "Petrinja",
    countryCode: "HR",
    country: "Croatia",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","HR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hr-001",
    lat: 43.50887,
    lng: 16.439162,
    panoId: "4fH2Z6XF6mO1zCJzmpWcpg",
    place: "Near Split, Split-Dalmatia",
    shortName: "Split",
    countryCode: "HR",
    country: "Croatia",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","HR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hr-002",
    lat: 45.897639,
    lng: 16.851303,
    panoId: "cc37k67NRQE9i5WIyi4-dQ",
    place: "Near Bjelovar, Bjelovar-Bilogora",
    shortName: "Bjelovar",
    countryCode: "HR",
    country: "Croatia",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","HR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hr-003",
    lat: 45.161502,
    lng: 18.016385,
    panoId: "Ad9DOKcxz_vdaOWBv0vPdg",
    place: "Near Slavonski Brod, Brod-Posavina",
    shortName: "Slavonski Brod",
    countryCode: "HR",
    country: "Croatia",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","HR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hr-004",
    lat: 43.734339,
    lng: 15.894274,
    panoId: "4HERJtSuPSDYYBiCsXBXHg",
    place: "Near Šibenik, Šibenik-Knin",
    shortName: "Šibenik",
    countryCode: "HR",
    country: "Croatia",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","HR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hr-005",
    lat: 45.339959,
    lng: 17.685772,
    panoId: "wRbu4JfnWP05EfZansXMRA",
    place: "Near Požega, Požega-Slavonia",
    shortName: "Požega",
    countryCode: "HR",
    country: "Croatia",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","HR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hr-006",
    lat: 46.304337,
    lng: 16.337459,
    panoId: "oXOrLu3KkKtuXKknRT3yOQ",
    place: "Near Varaždin, Varaždin",
    shortName: "Varaždin",
    countryCode: "HR",
    country: "Croatia",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","HR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hr-007",
    lat: 45.288023,
    lng: 18.804802,
    panoId: "YiX0ta_Rj1L7w9QtJ1ayWw",
    place: "Near Vinkovci, Vukovar-Srijem",
    shortName: "Vinkovci",
    countryCode: "HR",
    country: "Croatia",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","HR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hr-008",
    lat: 43.296709,
    lng: 17.017391,
    panoId: "I0VNeV7ep4T5mQgivtqwEA",
    place: "Near Makarska, Split-Dalmatia",
    shortName: "Makarska",
    countryCode: "HR",
    country: "Croatia",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","HR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hr-009",
    lat: 43.054122,
    lng: 17.648296,
    panoId: "s79wRqdhBCMeimhMPcC6Kg",
    place: "Near Metković, Dubrovnik-Neretva",
    shortName: "Metković",
    countryCode: "HR",
    country: "Croatia",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","HR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hr-010",
    lat: 45.550605,
    lng: 18.694391,
    panoId: "upX8cPu9mYxYWYTx50BiXQ",
    place: "Near Osijek, County of Osijek-Baranja",
    shortName: "Osijek",
    countryCode: "HR",
    country: "Croatia",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","HR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hr-011",
    lat: 43.543274,
    lng: 16.492443,
    panoId: "pLWQFdcoeuU870ML7fGS6g",
    place: "Near Solin, Split-Dalmatia",
    shortName: "Solin",
    countryCode: "HR",
    country: "Croatia",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","HR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hr-012",
    lat: 45.083451,
    lng: 13.637564,
    panoId: "VWEvUvoa-3ktLq4Q3rjFsw",
    place: "Near Rovinj, Istria",
    shortName: "Rovinj",
    countryCode: "HR",
    country: "Croatia",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","HR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hr-013",
    lat: 45.466101,
    lng: 16.377521,
    panoId: "jlyOzyzcUHnw3TPqlqVDRw",
    place: "Near Sisak, Sisak-Moslavina",
    shortName: "Sisak",
    countryCode: "HR",
    country: "Croatia",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","HR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hr-014",
    lat: 45.834423,
    lng: 17.385485,
    panoId: "iiFiGacOj9qHga0WacvtyA",
    place: "Near Virovitica, Virovitica-Podravina",
    shortName: "Virovitica",
    countryCode: "HR",
    country: "Croatia",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","HR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hr-015",
    lat: 45.856301,
    lng: 15.80786,
    panoId: "n0f8iRTXqau1o-s9ZzurlA",
    place: "Near Zaprešić, Zagreb County",
    shortName: "Zaprešić",
    countryCode: "HR",
    country: "Croatia",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","HR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hr-016",
    lat: 45.80598,
    lng: 16.244079,
    panoId: "if99BMYR1F9gfJSbzwydxw",
    place: "Near Dugo Selo, Zagreb County",
    shortName: "Dugo Selo",
    countryCode: "HR",
    country: "Croatia",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","HR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hr-017",
    lat: 45.491689,
    lng: 15.550017,
    panoId: "6ubb1viIuxwI-22k_9KV4A",
    place: "Near Karlovac, Karlovac",
    shortName: "Karlovac",
    countryCode: "HR",
    country: "Croatia",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","HR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hr-018",
    lat: 45.077622,
    lng: 18.696505,
    panoId: "PKzf027HR7o992V2MeOOOg",
    place: "Near Županja, Vukovar-Srijem",
    shortName: "Županja",
    countryCode: "HR",
    country: "Croatia",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","HR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hr-019",
    lat: 45.814593,
    lng: 15.978471,
    panoId: "2XLK2VwrobFWup7r8eShnw",
    place: "Near Zagreb, Zagreb",
    shortName: "Zagreb",
    countryCode: "HR",
    country: "Croatia",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","HR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hr-020",
    lat: 45.374186,
    lng: 14.346614,
    panoId: "CDtDDLw4ng8-2erzyZF8gw",
    place: "Near Kastav, Primorje-Gorski Kotar",
    shortName: "Kastav",
    countryCode: "HR",
    country: "Croatia",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","HR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "hr-021",
    lat: 45.351277,
    lng: 19.0012,
    panoId: "BGSuwh8aggAQ9aDtZvRcDQ",
    place: "Near Vukovar, Vukovar-Srijem",
    shortName: "Vukovar",
    countryCode: "HR",
    country: "Croatia",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","HR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hr-022",
    lat: 46.384674,
    lng: 16.434489,
    panoId: "9RYz04YeI_s2l6Zy_Y6e8g",
    place: "Near Čakovec, Međimurje",
    shortName: "Čakovec",
    countryCode: "HR",
    country: "Croatia",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","HR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hr-023",
    lat: 46.16363,
    lng: 16.829761,
    panoId: "T8INv1MH5E0J9KZ6Y3QdAw",
    place: "Near Koprivnica, Koprivnica-Križevci",
    shortName: "Koprivnica",
    countryCode: "HR",
    country: "Croatia",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","HR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hr-024",
    lat: 45.803192,
    lng: 15.717856,
    panoId: "jkE1cfSEY4_JMY_Qg7wAng",
    place: "Near Samobor, Zagreb County",
    shortName: "Samobor",
    countryCode: "HR",
    country: "Croatia",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","HR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hr-025",
    lat: 43.703005,
    lng: 16.639433,
    panoId: "xxbtVXTR05PWGsJF0f_IKQ",
    place: "Near Sinj, Split-Dalmatia",
    shortName: "Sinj",
    countryCode: "HR",
    country: "Croatia",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","HR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hr-026",
    lat: 45.254819,
    lng: 17.382954,
    panoId: "FTKcYmQMVpGm7-P4kf4ADA",
    place: "Near Nova Gradiška, Brod-Posavina",
    shortName: "Nova Gradiška",
    countryCode: "HR",
    country: "Croatia",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","HR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hr-027",
    lat: 43.486585,
    lng: 16.550306,
    panoId: "8eaCKnaDewdbtKgqQFcKtQ",
    place: "Near Podstrana, Split-Dalmatia",
    shortName: "Podstrana",
    countryCode: "HR",
    country: "Croatia",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","HR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hr-028",
    lat: 46.022487,
    lng: 16.542584,
    panoId: "8XhRIFf1SxKo0vcFqGqhyA",
    place: "Near Križevci, Koprivnica-Križevci",
    shortName: "Križevci",
    countryCode: "HR",
    country: "Croatia",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","HR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hr-029",
    lat: 44.868437,
    lng: 13.847833,
    panoId: "T2S732MfSMLL9QuH14h09Q",
    place: "Near Pula, Istria",
    shortName: "Pula",
    countryCode: "HR",
    country: "Croatia",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","HR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hr-030",
    lat: 45.708445,
    lng: 16.396511,
    panoId: "nLlof0Kuj5I1wI7i7Pc7cg",
    place: "Near Ivanić-Grad, Zagreb County",
    shortName: "Ivanić-Grad",
    countryCode: "HR",
    country: "Croatia",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","HR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hr-031",
    lat: 43.524319,
    lng: 16.436252,
    panoId: "A3BnOlb3kBbMjiSjDhhQQQ",
    place: "Near Split, Split-Dalmatia",
    shortName: "Split",
    countryCode: "HR",
    country: "Croatia",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","HR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "hr-032",
    lat: 45.715064,
    lng: 16.050722,
    panoId: "I0PStLYKuIM7cWJ5ZO3Q7Q",
    place: "Near Gradići, Zagreb County",
    shortName: "Gradići",
    countryCode: "HR",
    country: "Croatia",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","HR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hr-033",
    lat: 45.073268,
    lng: 13.636401,
    panoId: "m_-Q_malh1TnobhpIBx5DQ",
    place: "Near Rovinj, Istria",
    shortName: "Rovinj",
    countryCode: "HR",
    country: "Croatia",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","HR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hr-034",
    lat: 45.170107,
    lng: 18.032274,
    panoId: "X9xQ3EnoT49lhhoNrW3NrQ",
    place: "Near Slavonski Brod, Brod-Posavina",
    shortName: "Slavonski Brod",
    countryCode: "HR",
    country: "Croatia",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","HR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hr-035",
    lat: 45.333403,
    lng: 14.440906,
    panoId: "kxYECY57NsUfgs254iHVNg",
    place: "Near Rijeka, Primorje-Gorski Kotar",
    shortName: "Rijeka",
    countryCode: "HR",
    country: "Croatia",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","HR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hr-036",
    lat: 45.351256,
    lng: 17.669366,
    panoId: "oGzs9ChzilNzPXBoI7dZHQ",
    place: "Near Požega, Požega-Slavonia",
    shortName: "Požega",
    countryCode: "HR",
    country: "Croatia",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","HR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hr-037",
    lat: 45.888182,
    lng: 16.846121,
    panoId: "fIB1Y1ZQeGvYrunYhNFK-Q",
    place: "Near Bjelovar, Bjelovar-Bilogora",
    shortName: "Bjelovar",
    countryCode: "HR",
    country: "Croatia",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","HR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hr-038",
    lat: 45.532453,
    lng: 18.688468,
    panoId: "zET1z6NreUmPJ9UNQzyrDw",
    place: "Near Brijest, County of Osijek-Baranja",
    shortName: "Brijest",
    countryCode: "HR",
    country: "Croatia",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","HR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hr-039",
    lat: 45.358019,
    lng: 14.3505,
    panoId: "x6P259wHveFFaNF52VnOWg",
    place: "Near Rubeši, Primorje-Gorski Kotar",
    shortName: "Rubeši",
    countryCode: "HR",
    country: "Croatia",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","HR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hr-040",
    lat: 45.797775,
    lng: 16.258522,
    panoId: "5iK_3Mh6RrZQKikiCv6s8Q",
    place: "Near Dugo Selo, Zagreb County",
    shortName: "Dugo Selo",
    countryCode: "HR",
    country: "Croatia",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","HR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "hr-041",
    lat: 45.836911,
    lng: 17.399654,
    panoId: "MBgiMQJydvlZ6XKwhVPIlw",
    place: "Near Virovitica, Virovitica-Podravina",
    shortName: "Virovitica",
    countryCode: "HR",
    country: "Croatia",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","HR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hr-042",
    lat: 43.494997,
    lng: 16.540034,
    panoId: "hmV_3HYF0U3OLADBhN8PRA",
    place: "Near Podstrana - Miljevac, Split-Dalmatia",
    shortName: "Podstrana - Miljevac",
    countryCode: "HR",
    country: "Croatia",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","HR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hr-043",
    lat: 45.085148,
    lng: 18.709391,
    panoId: "ddL_OXA5lm4MU9Q2djtQBw",
    place: "Near Županja, Vukovar-Srijem",
    shortName: "Županja",
    countryCode: "HR",
    country: "Croatia",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","HR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hr-044",
    lat: 43.73594,
    lng: 15.875076,
    panoId: "a6S1yJ5-2cV_3g86-6lnag",
    place: "Near Šibenik, Šibenik-Knin",
    shortName: "Šibenik",
    countryCode: "HR",
    country: "Croatia",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","HR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hr-045",
    lat: 44.106836,
    lng: 15.239781,
    panoId: "NvepMjpOCtksPQkPK-NcaQ",
    place: "Near Zadar, Zadar",
    shortName: "Zadar",
    countryCode: "HR",
    country: "Croatia",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","HR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hr-046",
    lat: 45.845759,
    lng: 15.815515,
    panoId: "IxD7UeQK_gGiTpdboNvGbA",
    place: "Near Zaprešić, Zagreb County",
    shortName: "Zaprešić",
    countryCode: "HR",
    country: "Croatia",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","HR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hr-047",
    lat: 43.52691,
    lng: 16.271348,
    panoId: "R92c_5kJRNhhmVJQ1PF1pA",
    place: "Near Trogir, Split-Dalmatia",
    shortName: "Trogir",
    countryCode: "HR",
    country: "Croatia",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","HR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hr-048",
    lat: 45.262831,
    lng: 17.372051,
    panoId: "2xt8XONCiDgmHKOa_P1pIg",
    place: "Near Nova Gradiška, Brod-Posavina",
    shortName: "Nova Gradiška",
    countryCode: "HR",
    country: "Croatia",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","HR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hr-049",
    lat: 45.306118,
    lng: 18.404347,
    panoId: "XfkMbWfXjaXGNjEuiEU0CQ",
    place: "Near Đakovo, County of Osijek-Baranja",
    shortName: "Đakovo",
    countryCode: "HR",
    country: "Croatia",
    continent: "Europe",
    difficulty: "classic",
    pools: ["world","Europe","HR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hr-050",
    lat: 42.643925,
    lng: 18.146873,
    panoId: "kMqryw0hzHfGd-SeDTKlpQ",
    place: "Near Čibača, Dubrovnik-Neretva",
    shortName: "Čibača",
    countryCode: "HR",
    country: "Croatia",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","HR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hr-051",
    lat: 45.294219,
    lng: 14.529605,
    panoId: "x7eLpkwAA_ZQR7fLvoAFyw",
    place: "Near Bakar, Primorje-Gorski Kotar",
    shortName: "Bakar",
    countryCode: "HR",
    country: "Croatia",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","HR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hr-052",
    lat: 45.808065,
    lng: 17.428629,
    panoId: "0BKuoJXMtSgfWfcOmrE7qw",
    place: "Near Rezovac, Virovitica-Podravina",
    shortName: "Rezovac",
    countryCode: "HR",
    country: "Croatia",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","HR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "hr-053",
    lat: 45.465655,
    lng: 16.864782,
    panoId: "8XLw-b6IXdEWc2piNISOZQ",
    place: "Near Kutina, Sisak-Moslavina",
    shortName: "Kutina",
    countryCode: "HR",
    country: "Croatia",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","HR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hr-054",
    lat: 45.403886,
    lng: 17.709789,
    panoId: "oQf7SQ-NlLYLQ6heTUB4Rw",
    place: "Near Kaptol, Požega-Slavonia",
    shortName: "Kaptol",
    countryCode: "HR",
    country: "Croatia",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","HR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hr-055",
    lat: 45.741478,
    lng: 16.018912,
    panoId: "kevgjTUcj73PHoAJnVmMsA",
    place: "Near Veliko Polje, Zagreb",
    shortName: "Veliko Polje",
    countryCode: "HR",
    country: "Croatia",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","HR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hr-056",
    lat: 43.572822,
    lng: 16.198279,
    panoId: "tQx2c_x0xZC5Zvx1ljKtKg",
    place: "Near Prgomet, Split-Dalmatia",
    shortName: "Prgomet",
    countryCode: "HR",
    country: "Croatia",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","HR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hr-057",
    lat: 46.364221,
    lng: 16.478909,
    panoId: "H8JY4UlNxudo9iya0Ia_Og",
    place: "Near Ivanovec, Međimurje",
    shortName: "Ivanovec",
    countryCode: "HR",
    country: "Croatia",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","HR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hr-058",
    lat: 44.1499,
    lng: 15.22112,
    panoId: "C9GVTnOfoRDmATPUcck6Nw",
    place: "Near Zadar, Zadar",
    shortName: "Zadar",
    countryCode: "HR",
    country: "Croatia",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","HR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hr-059",
    lat: 46.088645,
    lng: 16.502096,
    panoId: "090gVHLeFjrVwKz7g9nS-A",
    place: "Near Sveti Petar Orehovec, Koprivnica-Križevci",
    shortName: "Sveti Petar Orehovec",
    countryCode: "HR",
    country: "Croatia",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","HR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hr-060",
    lat: 45.485714,
    lng: 16.439948,
    panoId: "tDzxBxizsXabPdUOE2Rirg",
    place: "Near Budaševo, Sisak-Moslavina",
    shortName: "Budaševo",
    countryCode: "HR",
    country: "Croatia",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","HR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hr-061",
    lat: 45.350283,
    lng: 14.382121,
    panoId: "7D7qQ1TbAm-NiTH6WttQwA",
    place: "Near Marinići, Primorje-Gorski Kotar",
    shortName: "Marinići",
    countryCode: "HR",
    country: "Croatia",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","HR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hr-062",
    lat: 43.803801,
    lng: 15.916205,
    panoId: "NfCDGzDpiCRwYBx3B-gDpw",
    place: "Near Skradin, Šibenik-Knin",
    shortName: "Skradin",
    countryCode: "HR",
    country: "Croatia",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","HR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hr-063",
    lat: 45.138647,
    lng: 18.723101,
    panoId: "3Rq4wez_cA56XC9xST1VTQ",
    place: "Near Gradište, Vukovar-Srijem",
    shortName: "Gradište",
    countryCode: "HR",
    country: "Croatia",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","HR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hr-064",
    lat: 45.895216,
    lng: 15.794958,
    panoId: "lBp8HfOqU6BtZFV2zchJhA",
    place: "Near Pojatno, Zagreb County",
    shortName: "Pojatno",
    countryCode: "HR",
    country: "Croatia",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","HR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hr-065",
    lat: 45.264589,
    lng: 13.585828,
    panoId: "GPRVHv9hwnU0c8KtAZAHdA",
    place: "Near Poreč, Istria",
    shortName: "Poreč",
    countryCode: "HR",
    country: "Croatia",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","HR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hr-066",
    lat: 45.193521,
    lng: 17.419371,
    panoId: "oUYaqmKswvsZtpqvGj06ag",
    place: "Near Vrbje, Brod-Posavina",
    shortName: "Vrbje",
    countryCode: "HR",
    country: "Croatia",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","HR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hr-067",
    lat: 45.797329,
    lng: 16.337375,
    panoId: "0e2dMADQe0wAxRgT2rDP9A",
    place: "Near Velika Ostrna, Zagreb County",
    shortName: "Velika Ostrna",
    countryCode: "HR",
    country: "Croatia",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","HR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hr-068",
    lat: 45.234135,
    lng: 15.217931,
    panoId: "OW12hM_UNeNJp_fnsKk2Yw",
    place: "Near Ogulin, Karlovac",
    shortName: "Ogulin",
    countryCode: "HR",
    country: "Croatia",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","HR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hr-069",
    lat: 45.399076,
    lng: 16.310206,
    panoId: "uSVn-u1eCoDQn4VUNAQFDg",
    place: "Near Petrinja, Sisak-Moslavina",
    shortName: "Petrinja",
    countryCode: "HR",
    country: "Croatia",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","HR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hr-070",
    lat: 45.559727,
    lng: 17.149747,
    panoId: "vIx4U7-gl8DDGbQzff_pcg",
    place: "Near Dežanovac, Bjelovar-Bilogora",
    shortName: "Dežanovac",
    countryCode: "HR",
    country: "Croatia",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","HR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hr-071",
    lat: 43.07551,
    lng: 17.580101,
    panoId: "3G6AZtkAtVF74j9yu_i5oQ",
    place: "Near Kula Norinska, Dubrovnik-Neretva",
    shortName: "Kula Norinska",
    countryCode: "HR",
    country: "Croatia",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","HR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hr-072",
    lat: 45.762488,
    lng: 15.955724,
    panoId: "HIVAp75ajRbBh7CSqhQwEQ",
    place: "Near Novi Zagreb, Zagreb",
    shortName: "Novi Zagreb",
    countryCode: "HR",
    country: "Croatia",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","HR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hr-073",
    lat: 43.698457,
    lng: 16.556599,
    panoId: "TIMlOOPFjMNPFd2KXJYgkA",
    place: "Near Sinj, Split-Dalmatia",
    shortName: "Sinj",
    countryCode: "HR",
    country: "Croatia",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","HR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hr-074",
    lat: 44.011318,
    lng: 16.24107,
    panoId: "VF1FGx6Cm_VbgeoUmRozFA",
    place: "Near Biskupija, Šibenik-Knin",
    shortName: "Biskupija",
    countryCode: "HR",
    country: "Croatia",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","HR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hr-075",
    lat: 42.682412,
    lng: 18.151369,
    panoId: "YOLnXKBg-J29KiyJEa48UA",
    place: "Near Nova Mokošica, Dubrovnik-Neretva",
    shortName: "Nova Mokošica",
    countryCode: "HR",
    country: "Croatia",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","HR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hr-076",
    lat: 43.570527,
    lng: 16.245985,
    panoId: "Bj4d06Jnj1JkwGpVs7RWOg",
    place: "Near Prgomet, Split-Dalmatia",
    shortName: "Prgomet",
    countryCode: "HR",
    country: "Croatia",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","HR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hr-077",
    lat: 44.099173,
    lng: 15.172634,
    panoId: "bCuUBD21nWtZUUXQtvcQmw",
    place: "Near Preko, Zadar",
    shortName: "Preko",
    countryCode: "HR",
    country: "Croatia",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","HR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "hr-078",
    lat: 46.407709,
    lng: 16.511233,
    panoId: "3-ZQOTsUn3VkDqgBsHp9sQ",
    place: "Near Belica, Međimurje",
    shortName: "Belica",
    countryCode: "HR",
    country: "Croatia",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","HR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hr-079",
    lat: 45.398254,
    lng: 18.977953,
    panoId: "3R1Z0nt4qOXde-GsPp9EMA",
    place: "Near Borovo, Vukovar-Srijem",
    shortName: "Borovo",
    countryCode: "HR",
    country: "Croatia",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","HR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hr-080",
    lat: 45.360832,
    lng: 18.398826,
    panoId: "vAzZbluncArvJ8uVCYMWZg",
    place: "Near Satnica Ðakovačka, County of Osijek-Baranja",
    shortName: "Satnica Ðakovačka",
    countryCode: "HR",
    country: "Croatia",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","HR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hr-081",
    lat: 43.588085,
    lng: 16.441502,
    panoId: "-ECzBpNee6VnpZK6zq05_w",
    place: "Near Kaštel Sućurac, Split-Dalmatia",
    shortName: "Kaštel Sućurac",
    countryCode: "HR",
    country: "Croatia",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","HR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hr-082",
    lat: 44.825046,
    lng: 13.856184,
    panoId: "HR9v3AUW5tqivAr6L4XjoA",
    place: "Near Pula, Istria",
    shortName: "Pula",
    countryCode: "HR",
    country: "Croatia",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","HR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hr-083",
    lat: 45.865785,
    lng: 15.722852,
    panoId: "7ldUSNkBnroKi7ohc5RDqw",
    place: "Near Prigorje Brdovečko, Zagreb County",
    shortName: "Prigorje Brdovečko",
    countryCode: "HR",
    country: "Croatia",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","HR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hr-084",
    lat: 45.78814,
    lng: 18.674095,
    panoId: "vZDIsIT4l37AnyOmadyBJw",
    place: "Near Popovac, County of Osijek-Baranja",
    shortName: "Popovac",
    countryCode: "HR",
    country: "Croatia",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","HR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hr-085",
    lat: 44.587233,
    lng: 15.294368,
    panoId: "VIZSg6rV4BNHoWLpVIYv1A",
    place: "Near Gospić, Lika-Senj",
    shortName: "Gospić",
    countryCode: "HR",
    country: "Croatia",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","HR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hr-086",
    lat: 46.268963,
    lng: 16.36858,
    panoId: "cL9rYXxwNyp9CMYN_kAqaQ",
    place: "Near Kućan Gornji, Varaždin",
    shortName: "Kućan Gornji",
    countryCode: "HR",
    country: "Croatia",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","HR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hr-087",
    lat: 45.55122,
    lng: 15.551112,
    panoId: "pWOGiPdSlw876pKU5675Bw",
    place: "Near Karlovac, Karlovac",
    shortName: "Karlovac",
    countryCode: "HR",
    country: "Croatia",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","HR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hr-088",
    lat: 46.060849,
    lng: 16.479198,
    panoId: "JvRweDDIPyLdJ4ioQsTCgQ",
    place: "Near Sveti Petar Orehovec, Koprivnica-Križevci",
    shortName: "Sveti Petar Orehovec",
    countryCode: "HR",
    country: "Croatia",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","HR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hr-089",
    lat: 45.39179,
    lng: 13.600221,
    panoId: "Le6L3CDHPEmQnI4xxCgFYA",
    place: "Near Brtonigla, Istria",
    shortName: "Brtonigla",
    countryCode: "HR",
    country: "Croatia",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","HR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hr-090",
    lat: 45.216468,
    lng: 13.657232,
    panoId: "ESpAl-SkapmP8iYDjJPKxA",
    place: "Near Poreč, Istria",
    shortName: "Poreč",
    countryCode: "HR",
    country: "Croatia",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","HR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hr-091",
    lat: 45.612506,
    lng: 18.455664,
    panoId: "WY7s-_oHkY837KncjE5TCA",
    place: "Near Ladimirevci, County of Osijek-Baranja",
    shortName: "Ladimirevci",
    countryCode: "HR",
    country: "Croatia",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","HR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hr-092",
    lat: 43.513887,
    lng: 16.294233,
    panoId: "cf3yxr0iz55WC9cxRtzmTw",
    place: "Near Okrug Gornji, Split-Dalmatia",
    shortName: "Okrug Gornji",
    countryCode: "HR",
    country: "Croatia",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","HR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hr-093",
    lat: 43.309867,
    lng: 16.849237,
    panoId: "0VCB4RlaFWnPcFJdru4sYQ",
    place: "Near Selca, Split-Dalmatia",
    shortName: "Selca",
    countryCode: "HR",
    country: "Croatia",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","HR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hr-094",
    lat: 45.481435,
    lng: 18.673909,
    panoId: "RMFWlljDKZ6eVqSQsI5cLA",
    place: "Near Antunovac, County of Osijek-Baranja",
    shortName: "Antunovac",
    countryCode: "HR",
    country: "Croatia",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","HR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hr-095",
    lat: 45.410621,
    lng: 16.413674,
    panoId: "Vbxii6-Vm3fScZVCUoKXmA",
    place: "Near Mošćenica, Sisak-Moslavina",
    shortName: "Mošćenica",
    countryCode: "HR",
    country: "Croatia",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","HR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hr-096",
    lat: 45.145122,
    lng: 14.634092,
    panoId: "ZKm8JMy_kus_mYFIFNu41g",
    place: "Near Dobrinj, Primorje-Gorski Kotar",
    shortName: "Dobrinj",
    countryCode: "HR",
    country: "Croatia",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","HR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hr-097",
    lat: 43.4328,
    lng: 16.752199,
    panoId: "jUnBlXts-DX5-1464XojHQ",
    place: "Near Omiš, Split-Dalmatia",
    shortName: "Omiš",
    countryCode: "HR",
    country: "Croatia",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","HR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hr-098",
    lat: 45.29388,
    lng: 18.319223,
    panoId: "NFUpKps4IZgYibz51ddM2g",
    place: "Near Selci Ðakovački, County of Osijek-Baranja",
    shortName: "Selci Ðakovački",
    countryCode: "HR",
    country: "Croatia",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","HR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hr-099",
    lat: 43.603022,
    lng: 16.580365,
    panoId: "Q9CmdtSaDyY1tgftMxKy_Q",
    place: "Near Dugopolje, Split-Dalmatia",
    shortName: "Dugopolje",
    countryCode: "HR",
    country: "Croatia",
    continent: "Europe",
    difficulty: "explorer",
    pools: ["world","Europe","HR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hr-100",
    lat: 45.336472,
    lng: 18.150141,
    panoId: "UGvCs_iSGcxaeZsAVeb_bQ",
    place: "Near Levanjska Varoš, County of Osijek-Baranja",
    shortName: "Levanjska Varoš",
    countryCode: "HR",
    country: "Croatia",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","HR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hr-101",
    lat: 45.109487,
    lng: 15.24414,
    panoId: "7W8zOJ3csXHPzpx2qH0Btw",
    place: "Near Josipdol, Karlovac",
    shortName: "Josipdol",
    countryCode: "HR",
    country: "Croatia",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","HR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hr-102",
    lat: 45.60501,
    lng: 17.533167,
    panoId: "HdHGmim0a7PEG6YjgoyPVQ",
    place: "Near Voćin, Virovitica-Podravina",
    shortName: "Voćin",
    countryCode: "HR",
    country: "Croatia",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","HR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hr-103",
    lat: 44.057897,
    lng: 15.927614,
    panoId: "9LP2jBqrfxZsQa6V7j4D7g",
    place: "Near Ervenik, Šibenik-Knin",
    shortName: "Ervenik",
    countryCode: "HR",
    country: "Croatia",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","HR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hr-104",
    lat: 45.477655,
    lng: 17.044277,
    panoId: "7ar0lRBy_AsevlY27nrKGQ",
    place: "Near Dežanovac, Bjelovar-Bilogora",
    shortName: "Dežanovac",
    countryCode: "HR",
    country: "Croatia",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","HR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hr-105",
    lat: 43.60579,
    lng: 16.859521,
    panoId: "up1aOjSy_LvSDMxNtFYdug",
    place: "Near Trilj, Split-Dalmatia",
    shortName: "Trilj",
    countryCode: "HR",
    country: "Croatia",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","HR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hr-106",
    lat: 44.491047,
    lng: 15.597735,
    panoId: "MJKOSQkBmxwQadgdSMMLDQ",
    place: "Near Lovinac, Lika-Senj",
    shortName: "Lovinac",
    countryCode: "HR",
    country: "Croatia",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","HR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hr-107",
    lat: 45.41403,
    lng: 15.170064,
    panoId: "RLiB_LCddea1aOSLQPbpEg",
    place: "Near Krč Bosiljevski, Karlovac",
    shortName: "Krč Bosiljevski",
    countryCode: "HR",
    country: "Croatia",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","HR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hr-108",
    lat: 42.837836,
    lng: 18.029649,
    panoId: "W2dmAt42Y6KJ6VHhgWKCFg",
    place: "Near Ravno, Federation of B&H",
    shortName: "Ravno",
    countryCode: "HR",
    country: "Croatia",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","HR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "hr-109",
    lat: 45.99524,
    lng: 17.266195,
    panoId: "rxndsd79zLXPohK549ZZzg",
    place: "Near Brodić, Koprivnica-Križevci",
    shortName: "Brodić",
    countryCode: "HR",
    country: "Croatia",
    continent: "Europe",
    difficulty: "adventurer",
    pools: ["world","Europe","HR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "jp-000",
    lat: 35.433458,
    lng: 139.649982,
    panoId: "iu27pAkKSQbSY7Y6Puxg4w",
    place: "Near Yokohama, Kanagawa",
    shortName: "Yokohama",
    countryCode: "JP",
    country: "Japan",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","JP"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "jp-001",
    lat: 32.805914,
    lng: 130.691652,
    panoId: "HNiXzVC-wkepO8owjI4J_g",
    place: "Near Kumamoto, Kumamoto",
    shortName: "Kumamoto",
    countryCode: "JP",
    country: "Japan",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","JP"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "jp-002",
    lat: 38.266629,
    lng: 140.866686,
    panoId: "DZ0p138ubs1_uslm9L7TNw",
    place: "Near Sendai, Miyagi",
    shortName: "Sendai",
    countryCode: "JP",
    country: "Japan",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","JP"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "jp-003",
    lat: 35.561214,
    lng: 139.716292,
    panoId: "QVAdL8Q7j7D4dso4t8tgfQ",
    place: "Near Ōta, Tokyo",
    shortName: "Ōta",
    countryCode: "JP",
    country: "Japan",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","JP"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "jp-004",
    lat: 34.816621,
    lng: 134.700127,
    panoId: "1I1ENsrULYquS6ArWJPAfA",
    place: "Near Himeji, Hyōgo",
    shortName: "Himeji",
    countryCode: "JP",
    country: "Japan",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","JP"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "jp-005",
    lat: 35.689494,
    lng: 139.691437,
    panoId: "REUXF14hDZN0li8kOeW7xg",
    place: "Near Tokyo, Tokyo",
    shortName: "Tokyo",
    countryCode: "JP",
    country: "Japan",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","JP"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "jp-006",
    lat: 34.693402,
    lng: 135.501145,
    panoId: "_4i8E37YDIbDKRIzOyjIjA",
    place: "Near Osaka, Osaka",
    shortName: "Osaka",
    countryCode: "JP",
    country: "Japan",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","JP"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "jp-007",
    lat: 34.399911,
    lng: 132.450191,
    panoId: "aGXqwYOuKDAk1Sb5MO59rw",
    place: "Near Hiroshima, Hiroshima",
    shortName: "Hiroshima",
    countryCode: "JP",
    country: "Japan",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","JP"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "jp-008",
    lat: 34.650007,
    lng: 133.933369,
    panoId: "NSZri3LXs3hhUp54fQaeMw",
    place: "Near Okayama, Okayama",
    shortName: "Okayama",
    countryCode: "JP",
    country: "Japan",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","JP"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "jp-009",
    lat: 35.567453,
    lng: 139.241826,
    panoId: "vtFFp-IXzFoV5mtgy2vVeg",
    place: "Near Sagamihara, Kanagawa",
    shortName: "Sagamihara",
    countryCode: "JP",
    country: "Japan",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","JP"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "jp-010",
    lat: 34.48339,
    lng: 133.36688,
    panoId: "bvcdEcqroot3pwWiF8io3g",
    place: "Near Fukuyama, Hiroshima",
    shortName: "Fukuyama",
    countryCode: "JP",
    country: "Japan",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","JP"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "jp-011",
    lat: 37.922569,
    lng: 139.041234,
    panoId: "-msy9yvKN2X_zHqiyg2X-A",
    place: "Near Niigata, Niigata",
    shortName: "Niigata",
    countryCode: "JP",
    country: "Japan",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","JP"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "jp-012",
    lat: 34.699987,
    lng: 137.733344,
    panoId: "Uwb9r0jmbxhFQ2_lg1oojQ",
    place: "Near Hamamatsu, Shizuoka",
    shortName: "Hamamatsu",
    countryCode: "JP",
    country: "Japan",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","JP"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "jp-013",
    lat: 32.778627,
    lng: 130.745497,
    panoId: "d4VERgYL7BAcBXP5Br4IQA",
    place: "Near Kotō, Kumamoto",
    shortName: "Kotō",
    countryCode: "JP",
    country: "Japan",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","JP"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "jp-014",
    lat: 35.599906,
    lng: 140.116593,
    panoId: "yYjk7BCuqjftzivxmeaFOQ",
    place: "Near Chiba, Chiba",
    shortName: "Chiba",
    countryCode: "JP",
    country: "Japan",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","JP"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "jp-015",
    lat: 35.520761,
    lng: 139.717271,
    panoId: "r-mEpfAqH0NsgQZex_2lug",
    place: "Near Kawasaki, Kanagawa",
    shortName: "Kawasaki",
    countryCode: "JP",
    country: "Japan",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","JP"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "jp-016",
    lat: 35.907932,
    lng: 139.656165,
    panoId: "EtkvUoVWtEVGkC9OZaFVlw",
    place: "Near Saitama, Saitama",
    shortName: "Saitama",
    countryCode: "JP",
    country: "Japan",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","JP"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "jp-017",
    lat: 33.600059,
    lng: 130.416766,
    panoId: "nTPth1X9SAkGTcml8DTD5Q",
    place: "Near Fukuoka, Fukuoka",
    shortName: "Fukuoka",
    countryCode: "JP",
    country: "Japan",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","JP"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "jp-018",
    lat: 34.691415,
    lng: 135.182836,
    panoId: "JtIFGQGLWZrqJkbrv5TYYg",
    place: "Near Kobe, Hyōgo",
    shortName: "Kobe",
    countryCode: "JP",
    country: "Japan",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","JP"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "jp-019",
    lat: 34.582141,
    lng: 135.466492,
    panoId: "-zb5ILINu-7qfeZfnxlJqA",
    place: "Near Sakai, Osaka",
    shortName: "Sakai",
    countryCode: "JP",
    country: "Japan",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","JP"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "jp-020",
    lat: 34.983316,
    lng: 138.383314,
    panoId: "obMAlArpziKDsMdgEP_6nw",
    place: "Near Shizuoka, Shizuoka",
    shortName: "Shizuoka",
    countryCode: "JP",
    country: "Japan",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","JP"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "jp-021",
    lat: 33.839153,
    lng: 132.765847,
    panoId: "7XtRu1R-CenkvNx6PLb2hw",
    place: "Near Matsuyama, Ehime",
    shortName: "Matsuyama",
    countryCode: "JP",
    country: "Japan",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","JP"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "jp-022",
    lat: 36.599683,
    lng: 136.616739,
    panoId: "BqvlnLIfvJWABRgjEOOZow",
    place: "Near Kanazawa, Ishikawa",
    shortName: "Kanazawa",
    countryCode: "JP",
    country: "Japan",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","JP"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "jp-023",
    lat: 34.583271,
    lng: 133.766715,
    panoId: "E-3NO9lA2qcJ_D5SQgUprw",
    place: "Near Kurashiki, Okayama",
    shortName: "Kurashiki",
    countryCode: "JP",
    country: "Japan",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","JP"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "jp-024",
    lat: 35.600077,
    lng: 139.316694,
    panoId: "y1Yd35jCUohxtABLeHcvnA",
    place: "Near Aihara, Kanagawa",
    shortName: "Aihara",
    countryCode: "JP",
    country: "Japan",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","JP"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "jp-025",
    lat: 35.779802,
    lng: 139.901307,
    panoId: "xwKxjOJHfErCiqPn5W9IqQ",
    place: "Near Matsudo, Chiba",
    shortName: "Matsudo",
    countryCode: "JP",
    country: "Japan",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","JP"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "jp-026",
    lat: 33.233396,
    lng: 131.599783,
    panoId: "UOlo_j_6Mi7a7FV3Ulhb-A",
    place: "Near Ōita, Oita",
    shortName: "Ōita",
    countryCode: "JP",
    country: "Japan",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","JP"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "jp-027",
    lat: 35.655756,
    lng: 139.323853,
    panoId: "HH1IdWnxG17QN_bDzMYuSA",
    place: "Near Hachiōji, Tokyo",
    shortName: "Hachiōji",
    countryCode: "JP",
    country: "Japan",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","JP"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "jp-028",
    lat: 35.021212,
    lng: 135.753834,
    panoId: "diWBltdRU128KcEolMvVoQ",
    place: "Near Kyoto, Kyoto",
    shortName: "Kyoto",
    countryCode: "JP",
    country: "Japan",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","JP"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "jp-029",
    lat: 35.805208,
    lng: 139.710555,
    panoId: "hXylbh5ue6FJpEtnyDquVA",
    place: "Near Kawaguchi, Saitama",
    shortName: "Kawaguchi",
    countryCode: "JP",
    country: "Japan",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","JP"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "jp-030",
    lat: 43.066704,
    lng: 141.349994,
    panoId: "w_LZOrLCFBzr3LYqDAl7SQ",
    place: "Near Sapporo, Hokkaido",
    shortName: "Sapporo",
    countryCode: "JP",
    country: "Japan",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","JP"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "jp-031",
    lat: 31.566722,
    lng: 130.549897,
    panoId: "ZD5EdqmiOjR4xdoZeuM84A",
    place: "Near Kagoshima, Kagoshima",
    shortName: "Kagoshima",
    countryCode: "JP",
    country: "Japan",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","JP"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "jp-032",
    lat: 36.567091,
    lng: 139.883472,
    panoId: "vTsE7fvogPqusR4IgMmOCw",
    place: "Near Utsunomiya, Tochigi",
    shortName: "Utsunomiya",
    countryCode: "JP",
    country: "Japan",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","JP"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "jp-033",
    lat: 34.66666,
    lng: 135.583492,
    panoId: "eazaedNQ4LHc20SeBkNMWw",
    place: "Near Higashiosaka, Osaka",
    shortName: "Higashiosaka",
    countryCode: "JP",
    country: "Japan",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","JP"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "jp-034",
    lat: 34.715244,
    lng: 135.331983,
    panoId: "7oPPPrd18hXdP7Lra4csoA",
    place: "Near Nishinomiya, Hyōgo",
    shortName: "Nishinomiya",
    countryCode: "JP",
    country: "Japan",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","JP"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "jp-035",
    lat: 35.349709,
    lng: 139.47675,
    panoId: "ZnLav1GRbViAPPgWzb0jcw",
    place: "Near Fujisawa, Kanagawa",
    shortName: "Fujisawa",
    countryCode: "JP",
    country: "Japan",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","JP"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "jp-036",
    lat: 35.733315,
    lng: 139.849952,
    panoId: "9sBi3LBTOzGsr6eh23EOFA",
    place: "Near Katsushika, Tokyo",
    shortName: "Katsushika",
    countryCode: "JP",
    country: "Japan",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","JP"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "jp-037",
    lat: 34.716644,
    lng: 135.416844,
    panoId: "fvfxSUdZ5rqPpwKyuQODLw",
    place: "Near Amagasaki, Hyōgo",
    shortName: "Amagasaki",
    countryCode: "JP",
    country: "Japan",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","JP"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "jp-038",
    lat: 34.710961,
    lng: 135.347085,
    panoId: "S285EelUcXJzYAUW5X0N8Q",
    place: "Near Nishinomiya, Hyōgo",
    shortName: "Nishinomiya",
    countryCode: "JP",
    country: "Japan",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","JP"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "jp-039",
    lat: 33.241556,
    lng: 131.615096,
    panoId: "hnL8vgy7xQUrblb1hFVDhw",
    place: "Near Ōita, Oita",
    shortName: "Ōita",
    countryCode: "JP",
    country: "Japan",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","JP"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "jp-040",
    lat: 34.65655,
    lng: 135.564365,
    panoId: "BiNOgRGh9j-Mhz-bh6q3pQ",
    place: "Near Higashiosaka, Osaka",
    shortName: "Higashiosaka",
    countryCode: "JP",
    country: "Japan",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","JP"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "jp-041",
    lat: 34.470868,
    lng: 133.360864,
    panoId: "hNcgX-jG7rqieGNTk26f5Q",
    place: "Near Fukuyama, Hiroshima",
    shortName: "Fukuyama",
    countryCode: "JP",
    country: "Japan",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","JP"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "jp-042",
    lat: 34.399784,
    lng: 132.42425,
    panoId: "hdWWn-Kqp9hboLm1PlAwPw",
    place: "Near Hiroshima, Hiroshima",
    shortName: "Hiroshima",
    countryCode: "JP",
    country: "Japan",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","JP"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "jp-043",
    lat: 37.932621,
    lng: 139.041156,
    panoId: "LK7Y-h0eFoY-P6RQcWdv4g",
    place: "Near Niigata, Niigata",
    shortName: "Niigata",
    countryCode: "JP",
    country: "Japan",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","JP"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "jp-044",
    lat: 34.718794,
    lng: 137.728978,
    panoId: "_qnYJjEbIbf23XIYAu2uSQ",
    place: "Near Hamamatsu, Shizuoka",
    shortName: "Hamamatsu",
    countryCode: "JP",
    country: "Japan",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","JP"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "jp-045",
    lat: 32.802215,
    lng: 130.679379,
    panoId: "vJ-5gVmpH2BTN6rNBDO87Q",
    place: "Near Kumamoto, Kumamoto",
    shortName: "Kumamoto",
    countryCode: "JP",
    country: "Japan",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","JP"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "jp-046",
    lat: 33.835435,
    lng: 132.748326,
    panoId: "-e1aytvTZZ9cH5xPC1a7oA",
    place: "Near Matsuyama, Ehime",
    shortName: "Matsuyama",
    countryCode: "JP",
    country: "Japan",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","JP"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "jp-047",
    lat: 35.694856,
    lng: 139.712853,
    panoId: "QDuuKuGS3_jZQcWYA5dv7g",
    place: "Near Shinjuku, Tokyo",
    shortName: "Shinjuku",
    countryCode: "JP",
    country: "Japan",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","JP"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "jp-048",
    lat: 34.802811,
    lng: 134.715391,
    panoId: "9xMbiI0pBulKvpmVH1-qeA",
    place: "Near Himeji, Hyōgo",
    shortName: "Himeji",
    countryCode: "JP",
    country: "Japan",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","JP"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "jp-049",
    lat: 33.614782,
    lng: 130.4088,
    panoId: "z6eU3RemqCf6l-Lfj8jryg",
    place: "Near Fukuoka, Fukuoka",
    shortName: "Fukuoka",
    countryCode: "JP",
    country: "Japan",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","JP"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "jp-050",
    lat: 34.684344,
    lng: 133.987652,
    panoId: "g_egjkukUHXK5oGzAzKYYQ",
    place: "Near Okayama, Okayama",
    shortName: "Okayama",
    countryCode: "JP",
    country: "Japan",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","JP"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "jp-051",
    lat: 32.711919,
    lng: 130.771604,
    panoId: "JNtbQWWwQElgjO6NkG_HkA",
    place: "Near Uejima, Kumamoto",
    shortName: "Uejima",
    countryCode: "JP",
    country: "Japan",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","JP"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "jp-052",
    lat: 34.969256,
    lng: 135.753997,
    panoId: "6fhJcnDxdC7BdwYBX-L5ZQ",
    place: "Near Mukō, Kyoto",
    shortName: "Mukō",
    countryCode: "JP",
    country: "Japan",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","JP"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "jp-053",
    lat: 33.888127,
    lng: 130.892695,
    panoId: "fnGLfrqm-z5zRaLJ5eu7ig",
    place: "Near Kitakyushu, Fukuoka",
    shortName: "Kitakyushu",
    countryCode: "JP",
    country: "Japan",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","JP"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "jp-054",
    lat: 35.497199,
    lng: 139.696457,
    panoId: "H-cp4GkrGEXHWYiJpFdDbA",
    place: "Near Kawasaki, Kanagawa",
    shortName: "Kawasaki",
    countryCode: "JP",
    country: "Japan",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","JP"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "jp-055",
    lat: 35.013749,
    lng: 138.328146,
    panoId: "sdoJf6kfhYNn5krEsI_7BQ",
    place: "Near Shizuoka, Shizuoka",
    shortName: "Shizuoka",
    countryCode: "JP",
    country: "Japan",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","JP"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "jp-056",
    lat: 34.81876,
    lng: 134.770383,
    panoId: "vw4fIpF6W966vZ5NjdN19g",
    place: "Near Shirahamachō-usazakiminami, Hyōgo",
    shortName: "Shirahamachō-usazakiminami",
    countryCode: "JP",
    country: "Japan",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","JP"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "jp-057",
    lat: 36.548792,
    lng: 139.827187,
    panoId: "_d4rt4kHuTAiH5Kq90ypuw",
    place: "Near Utsunomiya, Tochigi",
    shortName: "Utsunomiya",
    countryCode: "JP",
    country: "Japan",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","JP"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "jp-058",
    lat: 33.628695,
    lng: 130.353961,
    panoId: "nIajuDKLNhlNDcj3PkF0sA",
    place: "Near Fukuoka, Fukuoka",
    shortName: "Fukuoka",
    countryCode: "JP",
    country: "Japan",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","JP"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "jp-059",
    lat: 32.869419,
    lng: 130.727357,
    panoId: "bjrrDQ7Ub_zPIFryKFn8Iw",
    place: "Near Uekimachi-mōno, Kumamoto",
    shortName: "Uekimachi-mōno",
    countryCode: "JP",
    country: "Japan",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","JP"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "jp-060",
    lat: 36.574402,
    lng: 136.58467,
    panoId: "2CfrlRDpdTz5r7_LvNcwPA",
    place: "Near Kanazawa, Ishikawa",
    shortName: "Kanazawa",
    countryCode: "JP",
    country: "Japan",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","JP"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "jp-061",
    lat: 38.316527,
    lng: 140.861355,
    panoId: "Mig6VugZY27Cmx21mmyx9A",
    place: "Near Sendai, Miyagi",
    shortName: "Sendai",
    countryCode: "JP",
    country: "Japan",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","JP"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "jp-062",
    lat: 32.845342,
    lng: 130.76301,
    panoId: "HrbziPjjeg4fbFmjrnJWug",
    place: "Near Okino, Kumamoto",
    shortName: "Okino",
    countryCode: "JP",
    country: "Japan",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","JP"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "jp-063",
    lat: 34.642966,
    lng: 135.530693,
    panoId: "iBVMqgoS0Thf9T8jY_SFzw",
    place: "Near Higashiosaka, Osaka",
    shortName: "Higashiosaka",
    countryCode: "JP",
    country: "Japan",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","JP"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "jp-064",
    lat: 34.672759,
    lng: 133.989594,
    panoId: "A527H66lWehnn-VXAJyYCw",
    place: "Near Okayama, Okayama",
    shortName: "Okayama",
    countryCode: "JP",
    country: "Japan",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","JP"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "jp-065",
    lat: 31.51967,
    lng: 130.522921,
    panoId: "1aqhdhKb134p1pScqGiQ5A",
    place: "Near Kagoshima, Kagoshima",
    shortName: "Kagoshima",
    countryCode: "JP",
    country: "Japan",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","JP"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "jp-066",
    lat: 34.629794,
    lng: 133.722816,
    panoId: "maTgy7xiXhJgHSyOGOFx6A",
    place: "Near Sōja, Okayama",
    shortName: "Sōja",
    countryCode: "JP",
    country: "Japan",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","JP"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "jp-067",
    lat: 34.690258,
    lng: 137.700625,
    panoId: "mFYifNYRMVUz_uILsxQFgg",
    place: "Near Hamamatsu, Shizuoka",
    shortName: "Hamamatsu",
    countryCode: "JP",
    country: "Japan",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","JP"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "jp-068",
    lat: 35.538694,
    lng: 139.655467,
    panoId: "x-WeNscYFp0Iv_b9hChWmQ",
    place: "Near Kikuna, Kanagawa",
    shortName: "Kikuna",
    countryCode: "JP",
    country: "Japan",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","JP"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "jp-069",
    lat: 34.980293,
    lng: 135.787374,
    panoId: "JSosTchn8PckvIGZp_REdw",
    place: "Near Kyoto, Kyoto",
    shortName: "Kyoto",
    countryCode: "JP",
    country: "Japan",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","JP"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "jp-070",
    lat: 35.663611,
    lng: 139.241324,
    panoId: "uB66USFzAeTpfc4YEuLhAA",
    place: "Near Itsukaichi, Tokyo",
    shortName: "Itsukaichi",
    countryCode: "JP",
    country: "Japan",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","JP"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "jp-071",
    lat: 34.936244,
    lng: 138.335052,
    panoId: "MJ4Hy3T35jsI46Cx8o0FoA",
    place: "Near Shizuoka, Shizuoka",
    shortName: "Shizuoka",
    countryCode: "JP",
    country: "Japan",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","JP"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "jp-072",
    lat: 35.579562,
    lng: 139.788969,
    panoId: "mtnklmPdgtIK2KAT-zDleA",
    place: "Near Aomi, Tokyo",
    shortName: "Aomi",
    countryCode: "JP",
    country: "Japan",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","JP"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "jp-073",
    lat: 34.735224,
    lng: 135.390698,
    panoId: "zoOoBiT9KkiSNmgaHY_j-g",
    place: "Near Amagasaki, Hyōgo",
    shortName: "Amagasaki",
    countryCode: "JP",
    country: "Japan",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","JP"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "jp-074",
    lat: 34.714432,
    lng: 135.139098,
    panoId: "JU_GfqnMG6a7r9c8km9Qvw",
    place: "Near Kobe, Hyōgo",
    shortName: "Kobe",
    countryCode: "JP",
    country: "Japan",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","JP"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "jp-075",
    lat: 43.102145,
    lng: 141.339275,
    panoId: "1mS2CyRTCtmyHCxsOQ2PIA",
    place: "Near Sapporo, Hokkaido",
    shortName: "Sapporo",
    countryCode: "JP",
    country: "Japan",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","JP"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "jp-076",
    lat: 33.215277,
    lng: 131.564305,
    panoId: "hJUAKmGPEptd3MqYfiobIw",
    place: "Near Ōita, Oita",
    shortName: "Ōita",
    countryCode: "JP",
    country: "Japan",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","JP"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "jp-077",
    lat: 34.439568,
    lng: 133.413561,
    panoId: "3n4rwcStoscsrqA0y6N_Lg",
    place: "Near Fukuyama, Hiroshima",
    shortName: "Fukuyama",
    countryCode: "JP",
    country: "Japan",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","JP"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "jp-078",
    lat: 35.136096,
    lng: 136.87993,
    panoId: "0ABC-tgyYOd21iIWbqPcNw",
    place: "Near Nagoya, Aichi",
    shortName: "Nagoya",
    countryCode: "JP",
    country: "Japan",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","JP"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "jp-079",
    lat: 35.115695,
    lng: 137.163587,
    panoId: "LSTXuiN6o3htUy7gF9Whhw",
    place: "Near Toyota, Aichi",
    shortName: "Toyota",
    countryCode: "JP",
    country: "Japan",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","JP"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "jp-080",
    lat: 36.54277,
    lng: 139.867655,
    panoId: "_Uglo2o3JoLAnqMYjdQtRA",
    place: "Near Utsunomiya, Tochigi",
    shortName: "Utsunomiya",
    countryCode: "JP",
    country: "Japan",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","JP"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "jp-081",
    lat: 36.685987,
    lng: 137.15713,
    panoId: "6uBlulTotDALfxEXAih16w",
    place: "Near Toyama, Toyama",
    shortName: "Toyama",
    countryCode: "JP",
    country: "Japan",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","JP"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "jp-082",
    lat: 32.715188,
    lng: 129.898442,
    panoId: "CCSYHlMUd8eVCgAyCDkWuw",
    place: "Near Nagasaki, Nagasaki",
    shortName: "Nagasaki",
    countryCode: "JP",
    country: "Japan",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","JP"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "jp-083",
    lat: 34.662551,
    lng: 135.445473,
    panoId: "9vFvl0uLmgjAeYCMJwAoxw",
    place: "Near Ebie, Osaka",
    shortName: "Ebie",
    countryCode: "JP",
    country: "Japan",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","JP"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "jp-084",
    lat: 34.309387,
    lng: 134.079884,
    panoId: "8xni-3FsuESTErW8UE7b_w",
    place: "Near Takamatsu, Kagawa",
    shortName: "Takamatsu",
    countryCode: "JP",
    country: "Japan",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","JP"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "jp-085",
    lat: 35.2651,
    lng: 139.730586,
    panoId: "l86HPJ7jRf8alg9sXx4duw",
    place: "Near Nagase, Kanagawa",
    shortName: "Nagase",
    countryCode: "JP",
    country: "Japan",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","JP"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "jp-086",
    lat: 34.725258,
    lng: 135.483959,
    panoId: "4F1BQxruhX3DLDKG45icbw",
    place: "Near Umeda, Osaka",
    shortName: "Umeda",
    countryCode: "JP",
    country: "Japan",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","JP"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "jp-087",
    lat: 37.867282,
    lng: 139.054117,
    panoId: "GjLeS1i4VdTXVF7FnrPOlw",
    place: "Near Kameda-honchō, Niigata",
    shortName: "Kameda-honchō",
    countryCode: "JP",
    country: "Japan",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","JP"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "jp-088",
    lat: 36.287246,
    lng: 138.963194,
    panoId: "ML1eA1MsNQvmACtgfY_38A",
    place: "Near Yoshii, Gunma",
    shortName: "Yoshii",
    countryCode: "JP",
    country: "Japan",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","JP"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "jp-089",
    lat: 31.881216,
    lng: 131.384236,
    panoId: "PfsSb0u6n7QWFsxe5Z6iuQ",
    place: "Near Miyazaki, Miyazaki",
    shortName: "Miyazaki",
    countryCode: "JP",
    country: "Japan",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","JP"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "jp-090",
    lat: 35.21415,
    lng: 139.6512,
    panoId: "Dr0p5WDxw2t5m3FkIF9cOA",
    place: "Near Kurihama, Kanagawa",
    shortName: "Kurihama",
    countryCode: "JP",
    country: "Japan",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","JP"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "jp-091",
    lat: 34.495227,
    lng: 133.85472,
    panoId: "0V63gEABeAp3XT3PSgrIIw",
    place: "Near Tamano, Okayama",
    shortName: "Tamano",
    countryCode: "JP",
    country: "Japan",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","JP"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "jp-092",
    lat: 34.816938,
    lng: 135.887545,
    panoId: "SxRc3wHWt4A5tH9BXe_FhA",
    place: "Near Kamatsuka, Kyoto",
    shortName: "Kamatsuka",
    countryCode: "JP",
    country: "Japan",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","JP"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "jp-093",
    lat: 34.662805,
    lng: 135.620525,
    panoId: "NnDPWLJv3mOFxpuRJHwdPA",
    place: "Near Higashiosaka, Osaka",
    shortName: "Higashiosaka",
    countryCode: "JP",
    country: "Japan",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","JP"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "jp-094",
    lat: 36.724398,
    lng: 137.064911,
    panoId: "T0HOKd_t99qGPd-5nyggWw",
    place: "Near Takaoka, Toyama",
    shortName: "Takaoka",
    countryCode: "JP",
    country: "Japan",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","JP"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "jp-095",
    lat: 36.539435,
    lng: 138.928475,
    panoId: "-qKLNnnB5GBKEiw_7OonEw",
    place: "Near Shibukawa, Gunma",
    shortName: "Shibukawa",
    countryCode: "JP",
    country: "Japan",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","JP"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "jp-096",
    lat: 34.255334,
    lng: 134.233147,
    panoId: "hnD4I8Be9zXum6hzDlllEQ",
    place: "Near Sanuki, Kagawa",
    shortName: "Sanuki",
    countryCode: "JP",
    country: "Japan",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","JP"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "jp-097",
    lat: 31.654793,
    lng: 130.475734,
    panoId: "aSy8L27_cB6mtHxvLJzmGw",
    place: "Near Ijūin, Kagoshima",
    shortName: "Ijūin",
    countryCode: "JP",
    country: "Japan",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","JP"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "jp-098",
    lat: 34.785118,
    lng: 135.26973,
    panoId: "_gNfWHmOyaOO3vScA-Fb8g",
    place: "Near Ashiya, Hyōgo",
    shortName: "Ashiya",
    countryCode: "JP",
    country: "Japan",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","JP"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "jp-099",
    lat: 36.72826,
    lng: 138.322741,
    panoId: "lZlkTCKGtKyrspn6igjqrg",
    place: "Near Obuse, Nagano",
    shortName: "Obuse",
    countryCode: "JP",
    country: "Japan",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","JP"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "jp-100",
    lat: 37.176082,
    lng: 140.735122,
    panoId: "YV_bgyksDyh41GkRVjuWdA",
    place: "Near Kitakata, Fukushima",
    shortName: "Kitakata",
    countryCode: "JP",
    country: "Japan",
    continent: "Asia",
    difficulty: "adventurer",
    pools: ["world","Asia","JP"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "jp-101",
    lat: 34.957425,
    lng: 137.339076,
    panoId: "uiE2xVs8NDFtSMSPPC88Nw",
    place: "Near Okazaki, Aichi",
    shortName: "Okazaki",
    countryCode: "JP",
    country: "Japan",
    continent: "Asia",
    difficulty: "adventurer",
    pools: ["world","Asia","JP"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "jp-102",
    lat: 34.980688,
    lng: 137.320449,
    panoId: "Gx_9sc8pu2NbR9C7FFzDAg",
    place: "Near Okazaki, Aichi",
    shortName: "Okazaki",
    countryCode: "JP",
    country: "Japan",
    continent: "Asia",
    difficulty: "adventurer",
    pools: ["world","Asia","JP"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "jp-103",
    lat: 33.417132,
    lng: 133.432435,
    panoId: "fSHE-9Guw8IgZaRDOn0W_A",
    place: "Near Tosa, Kochi",
    shortName: "Tosa",
    countryCode: "JP",
    country: "Japan",
    continent: "Asia",
    difficulty: "adventurer",
    pools: ["world","Asia","JP"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "jp-104",
    lat: 43.730418,
    lng: 142.225683,
    panoId: "DSgwrz5OISy7z8D7YJk1Og",
    place: "Near Asahikawa, Hokkaido",
    shortName: "Asahikawa",
    countryCode: "JP",
    country: "Japan",
    continent: "Asia",
    difficulty: "adventurer",
    pools: ["world","Asia","JP"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "jp-105",
    lat: 37.395026,
    lng: 140.262756,
    panoId: "QYe8KBMYc-lmn7D99WtJRA",
    place: "Near Kōriyama, Fukushima",
    shortName: "Kōriyama",
    countryCode: "JP",
    country: "Japan",
    continent: "Asia",
    difficulty: "adventurer",
    pools: ["world","Asia","JP"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "kr-000",
    lat: 35.149476,
    lng: 126.921319,
    panoId: "Kdd5lYxUaI_4L29E0Utk-Q",
    place: "Near Gwangju, Gwangju",
    shortName: "Gwangju",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","KR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "kr-001",
    lat: 33.509883,
    lng: 126.52171,
    panoId: "2t9EHF7O8ZBfFJ5_BIQ_MQ",
    place: "Near Jeju City, Jeju-do",
    shortName: "Jeju City",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","KR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "kr-002",
    lat: 35.342025,
    lng: 129.033608,
    panoId: "8bTluh3BMtPDWf-aL57jDg",
    place: "Near Yangsan, Gyeongsangnam-do",
    shortName: "Yangsan",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","KR"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "kr-003",
    lat: 37.456717,
    lng: 126.705098,
    panoId: "zmSVOvJsLUyyW2N3lFZ8Mg",
    place: "Near Incheon, Incheon",
    shortName: "Incheon",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","KR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "kr-004",
    lat: 36.121216,
    lng: 128.119279,
    panoId: "cc-kVet-eqrZy5HDJIpjGg",
    place: "Near Gimcheon, Gyeongsangbuk-do",
    shortName: "Gimcheon",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","KR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "kr-005",
    lat: 37.879651,
    lng: 127.728345,
    panoId: "-kxEvG8hmO6EQvK4IeIAGQ",
    place: "Near Chuncheon, Gangwon-do",
    shortName: "Chuncheon",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","KR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "kr-006",
    lat: 36.112979,
    lng: 128.335645,
    panoId: "3yrGRxeMbSIHEbti5YSeQA",
    place: "Near Gumi, Gyeongsangbuk-do",
    shortName: "Gumi",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","KR"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "kr-007",
    lat: 37.438981,
    lng: 127.137627,
    panoId: "lIxr1TgXOIcMqL_8QFw7hw",
    place: "Near Seongnam-si, Gyeonggi-do",
    shortName: "Seongnam-si",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","KR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "kr-008",
    lat: 35.870329,
    lng: 128.591204,
    panoId: "ZNvLNcXepHy7mzcHTqWMnQ",
    place: "Near Daegu, Daegu",
    shortName: "Daegu",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","KR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "kr-009",
    lat: 33.253291,
    lng: 126.561829,
    panoId: "yPZqvjv0oZylzbdiCEUyhw",
    place: "Near Seogwipo, Jeju-do",
    shortName: "Seogwipo",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","KR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "kr-010",
    lat: 37.317556,
    lng: 126.821465,
    panoId: "Mpq_E5_kCzAs13YnyL4New",
    place: "Near Ansan-si, Gyeonggi-do",
    shortName: "Ansan-si",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","KR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "kr-011",
    lat: 35.22984,
    lng: 128.882318,
    panoId: "tqnpDPpNPwipbm1ieAkEqQ",
    place: "Near Kimhae, Gyeongsangnam-do",
    shortName: "Kimhae",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","KR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "kr-012",
    lat: 37.351504,
    lng: 127.94539,
    panoId: "7VThb9CQobCVjsAVr5icnQ",
    place: "Near Wŏnju, Gangwon-do",
    shortName: "Wŏnju",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","KR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "kr-013",
    lat: 35.101803,
    lng: 129.030063,
    panoId: "UhFcLUPrbdzMxlUWougVZg",
    place: "Near Busan, Busan",
    shortName: "Busan",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","KR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "kr-014",
    lat: 37.498831,
    lng: 126.78361,
    panoId: "RipQAVvzJExDrW7W2-k8RA",
    place: "Near Bucheon-si, Gyeonggi-do",
    shortName: "Bucheon-si",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","KR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "kr-015",
    lat: 34.761192,
    lng: 127.662765,
    panoId: "e1-prjDLw-yhwKIg_ZO_HA",
    place: "Near Yeosu, Jeollanam-do",
    shortName: "Yeosu",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","KR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "kr-016",
    lat: 37.207692,
    lng: 126.816536,
    panoId: "ouonP6_YHPpq1GLZWSIEYQ",
    place: "Near Hwaseong-si, Gyeonggi-do",
    shortName: "Hwaseong-si",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","KR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "kr-017",
    lat: 35.821883,
    lng: 127.148999,
    panoId: "8Aznas6RoYYNgDweUAUQPg",
    place: "Near Jeonju, Jeollabuk-do",
    shortName: "Jeonju",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","KR"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "kr-018",
    lat: 34.947876,
    lng: 127.490114,
    panoId: "VmnV57TRLnvQyMZm5v8tCA",
    place: "Near Suncheon, Jeollanam-do",
    shortName: "Suncheon",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","KR"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "kr-019",
    lat: 34.94124,
    lng: 127.695674,
    panoId: "fv5B1ndpza2J9O-8AJXUmg",
    place: "Near Gwangyang, Jeollanam-do",
    shortName: "Gwangyang",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","KR"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "kr-020",
    lat: 34.811706,
    lng: 126.391402,
    panoId: "Jyqr161RAp5vNFEbLaFGZA",
    place: "Near Mokpo, Jeollanam-do",
    shortName: "Mokpo",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","KR"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "kr-021",
    lat: 36.349069,
    lng: 127.384971,
    panoId: "mmEuRIpDfQiCJQHDTGfWbg",
    place: "Near Daejeon, Daejeon",
    shortName: "Daejeon",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","KR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "kr-022",
    lat: 36.029053,
    lng: 129.364938,
    panoId: "gSSwZNyUq6F06WVFLMGuCA",
    place: "Near Pohang, Gyeongsangbuk-do",
    shortName: "Pohang",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","KR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "kr-023",
    lat: 37.392377,
    lng: 126.926784,
    panoId: "5Sc1kcDX835pWjZoIld-9Q",
    place: "Near Anyang-si, Gyeonggi-do",
    shortName: "Anyang-si",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","KR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "kr-024",
    lat: 35.823274,
    lng: 128.737466,
    panoId: "PtepuampTg_Oo78j0vmrxg",
    place: "Near Gyeongsan-si, Gyeongsangbuk-do",
    shortName: "Gyeongsan-si",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","KR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "kr-025",
    lat: 37.656353,
    lng: 126.834989,
    panoId: "3CEKHoB7IsbI2alBtNv-kA",
    place: "Near Goyang-si, Gyeonggi-do",
    shortName: "Goyang-si",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","KR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "kr-026",
    lat: 36.130813,
    lng: 128.136643,
    panoId: "Ebl-cYDEHux-nzxV103AUA",
    place: "Near Gimcheon, Gyeongsangbuk-do",
    shortName: "Gimcheon",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","KR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "kr-027",
    lat: 37.48025,
    lng: 126.766954,
    panoId: "roOlsZY_1cRTSR3UPl1MIQ",
    place: "Near Bucheon-si, Gyeonggi-do",
    shortName: "Bucheon-si",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","KR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "kr-028",
    lat: 37.751436,
    lng: 128.88981,
    panoId: "S7kvzAS-uS07B9x4AG9XRQ",
    place: "Near Gangneung, Gangwon-do",
    shortName: "Gangneung",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","KR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "kr-029",
    lat: 37.291083,
    lng: 127.008858,
    panoId: "HkAAIpiZIw9YeUAVSFOVOA",
    place: "Near Suwon, Gyeonggi-do",
    shortName: "Suwon",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","KR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "kr-030",
    lat: 33.519334,
    lng: 126.52868,
    panoId: "h2hVfGD204VaKBss7xCUVA",
    place: "Near Sanji, Jeju-do",
    shortName: "Sanji",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","KR"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "kr-031",
    lat: 34.794706,
    lng: 126.390692,
    panoId: "qKufxjIRD_dyODhhgA1zxg",
    place: "Near Mokpo, Jeollanam-do",
    shortName: "Mokpo",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","KR"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "kr-032",
    lat: 36.112846,
    lng: 128.355525,
    panoId: "-HLKOzemJNA8fT7dkeNM5A",
    place: "Near Gumi, Gyeongsangbuk-do",
    shortName: "Gumi",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","KR"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "kr-033",
    lat: 37.427175,
    lng: 127.153335,
    panoId: "b9Mxs_6zdwMgjQWp7hbZaQ",
    place: "Near Seongnam-si, Gyeonggi-do",
    shortName: "Seongnam-si",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","KR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "kr-034",
    lat: 37.342241,
    lng: 127.96009,
    panoId: "-EcJcGZOfs95Ly81lLZC0Q",
    place: "Near Wŏnju, Gangwon-do",
    shortName: "Wŏnju",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","KR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "kr-035",
    lat: 34.9541,
    lng: 127.697386,
    panoId: "1bzjIby2SIlpYstHWG6jvQ",
    place: "Near Gwangyang, Jeollanam-do",
    shortName: "Gwangyang",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","KR"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "kr-036",
    lat: 35.874625,
    lng: 128.617219,
    panoId: "I91W8ZvQzX0oGhJ8lMh0oQ",
    place: "Near Daegu, Daegu",
    shortName: "Daegu",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","KR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "kr-037",
    lat: 35.824977,
    lng: 128.718487,
    panoId: "DdIAR5cPy-OHzaNgHJDa3A",
    place: "Near Gyeongsan-si, Gyeongsangbuk-do",
    shortName: "Gyeongsan-si",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","KR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "kr-038",
    lat: 35.219167,
    lng: 128.875002,
    panoId: "cUW1L6mblfxu6wDheJb_PQ",
    place: "Near Kimhae, Gyeongsangnam-do",
    shortName: "Kimhae",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","KR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "kr-039",
    lat: 33.24809,
    lng: 126.584061,
    panoId: "z3XeFDgvqpyfleaFHVG6pg",
    place: "Near Seogwipo, Jeju-do",
    shortName: "Seogwipo",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","KR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "kr-040",
    lat: 37.380254,
    lng: 126.929871,
    panoId: "ck3eA5C6ZurMUzZuwq4bRQ",
    place: "Near Anyang-si, Gyeonggi-do",
    shortName: "Anyang-si",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","KR"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "kr-041",
    lat: 34.948743,
    lng: 127.504373,
    panoId: "1iqnT7xXCH5i-nN3v8qdiQ",
    place: "Near Suncheon, Jeollanam-do",
    shortName: "Suncheon",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","KR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "kr-042",
    lat: 37.545541,
    lng: 126.987712,
    panoId: "4_5U5w2uARfF9CD9dn0VlQ",
    place: "Near Yongsan-dong, Seoul",
    shortName: "Yongsan-dong",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","KR"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "kr-043",
    lat: 37.438471,
    lng: 126.690968,
    panoId: "YniaOBqOtZ5sw0498Bqpdw",
    place: "Near Incheon, Incheon",
    shortName: "Incheon",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","KR"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "kr-044",
    lat: 36.359665,
    lng: 127.382857,
    panoId: "-qXEdIOqOnsgASzSZ3gPMw",
    place: "Near Daejeon, Daejeon",
    shortName: "Daejeon",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","KR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "kr-045",
    lat: 37.885125,
    lng: 127.717843,
    panoId: "iowK9zPtgXoAAAQvxgR5DQ",
    place: "Near Chuncheon, Gangwon-do",
    shortName: "Chuncheon",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","KR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "kr-046",
    lat: 35.349763,
    lng: 129.042047,
    panoId: "7TUbl6bzgYs0QbCcxJ95_Q",
    place: "Near Yangsan, Gyeongsangnam-do",
    shortName: "Yangsan",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","KR"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "kr-047",
    lat: 35.121727,
    lng: 129.039157,
    panoId: "smSCYO6vQQNS73wYZX67pg",
    place: "Near Busan, Busan",
    shortName: "Busan",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","KR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "kr-048",
    lat: 34.802715,
    lng: 126.379731,
    panoId: "vYCr4pZjrZzuw2Dqqig8qQ",
    place: "Near Mokpo, Jeollanam-do",
    shortName: "Mokpo",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","KR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "kr-049",
    lat: 37.360492,
    lng: 127.947957,
    panoId: "vvV9uan99mo_spxmhEo8OA",
    place: "Near Wŏnju, Gangwon-do",
    shortName: "Wŏnju",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","KR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "kr-050",
    lat: 35.493985,
    lng: 129.270378,
    panoId: "7eJ5PIoXypgrW-gkDusg0A",
    place: "Near Ulsan, Ulsan",
    shortName: "Ulsan",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","KR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "kr-051",
    lat: 37.412682,
    lng: 126.89009,
    panoId: "9SAKrTw9xO3GhzvqeQU6tg",
    place: "Near Anyang-si, Gyeonggi-do",
    shortName: "Anyang-si",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","KR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "kr-052",
    lat: 37.380252,
    lng: 126.799755,
    panoId: "8V3a8VGMqE0Op0QCoVzFCw",
    place: "Near Ansan-si, Gyeonggi-do",
    shortName: "Ansan-si",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","KR"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "kr-053",
    lat: 37.611357,
    lng: 126.870873,
    panoId: "wDZ2opjvt-WtQyXhBwLSQA",
    place: "Near Goyang-si, Gyeonggi-do",
    shortName: "Goyang-si",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","KR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "kr-054",
    lat: 34.954352,
    lng: 127.521595,
    panoId: "OJw55wwwrvcaani5hpUqFw",
    place: "Near Suncheon, Jeollanam-do",
    shortName: "Suncheon",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","KR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "kr-055",
    lat: 35.171216,
    lng: 128.921379,
    panoId: "hdRs9pFKqn1rVSeLKVZn5A",
    place: "Near Kimhae, Gyeongsangnam-do",
    shortName: "Kimhae",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","KR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "kr-056",
    lat: 37.557998,
    lng: 126.826677,
    panoId: "aWJHKo6_ayHauCFKK42Pbw",
    place: "Near Bucheon-si, Gyeonggi-do",
    shortName: "Bucheon-si",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","KR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "kr-057",
    lat: 37.777291,
    lng: 128.810542,
    panoId: "LXV12w4ByMrjWY1hE3GVcw",
    place: "Near Gangneung, Gangwon-do",
    shortName: "Gangneung",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","KR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "kr-058",
    lat: 35.814367,
    lng: 127.212089,
    panoId: "IHwOouWxTRRTOm3NnbsEEg",
    place: "Near Jeonju, Jeollabuk-do",
    shortName: "Jeonju",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","KR"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "kr-059",
    lat: 34.994393,
    lng: 126.434282,
    panoId: "jS2ZdJajAXzJ3H77DKFW4A",
    place: "Near Muan, Jeollanam-do",
    shortName: "Muan",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","KR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "kr-060",
    lat: 34.959886,
    lng: 127.723236,
    panoId: "ckbZ5wwghUmY9Zd0ouR6Ng",
    place: "Near Gwangyang, Jeollanam-do",
    shortName: "Gwangyang",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","KR"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "kr-061",
    lat: 37.471397,
    lng: 127.173264,
    panoId: "nkql-oZHboa3uxExxG4Wcg",
    place: "Near Seongnam-si, Gyeonggi-do",
    shortName: "Seongnam-si",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","KR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "kr-062",
    lat: 36.086706,
    lng: 128.107147,
    panoId: "rO8dwYukiF0429m9mNFysw",
    place: "Near Gimcheon, Gyeongsangbuk-do",
    shortName: "Gimcheon",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","KR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "kr-063",
    lat: 37.377823,
    lng: 126.778978,
    panoId: "EPZtXzDwZ6uTyj2wFyFC6w",
    place: "Near Ansan-si, Gyeonggi-do",
    shortName: "Ansan-si",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","KR"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "kr-064",
    lat: 35.170528,
    lng: 126.886309,
    panoId: "2U1LdUepeQ4x2EYAc2bfTw",
    place: "Near Gwangju, Gwangju",
    shortName: "Gwangju",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","KR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "kr-065",
    lat: 37.533403,
    lng: 127.022835,
    panoId: "C2zKIgl4OidPo9u0v4dNGA",
    place: "Near Yongsan-dong, Seoul",
    shortName: "Yongsan-dong",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","KR"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "kr-066",
    lat: 37.696953,
    lng: 126.878399,
    panoId: "Coio57EyiSrjRdY8ONiE0w",
    place: "Near Goyang-si, Gyeonggi-do",
    shortName: "Goyang-si",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","KR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "kr-067",
    lat: 35.146981,
    lng: 129.058714,
    panoId: "7-F-LWQBSlcixF4Jy-_Dcw",
    place: "Near Busan, Busan",
    shortName: "Busan",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","KR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "kr-068",
    lat: 36.60663,
    lng: 128.159997,
    panoId: "p4griZUP0STCDctrssUKTQ",
    place: "Near Mungyeong, Gyeongsangbuk-do",
    shortName: "Mungyeong",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","KR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "kr-069",
    lat: 35.885793,
    lng: 128.721349,
    panoId: "cz1OCidyFU4MmVZn9MnNvQ",
    place: "Near Gyeongsan-si, Gyeongsangbuk-do",
    shortName: "Gyeongsan-si",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","KR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "kr-070",
    lat: 37.857861,
    lng: 127.466537,
    panoId: "k5qEDWutNP_dy5BpA2yzsg",
    place: "Near Gapyeong, Gyeonggi-do",
    shortName: "Gapyeong",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","KR"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "kr-071",
    lat: 36.833831,
    lng: 127.958215,
    panoId: "02C1985cfP5IDAZkJ7thKA",
    place: "Near Koesan, North Chungcheong",
    shortName: "Koesan",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","KR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "kr-072",
    lat: 34.954668,
    lng: 127.631353,
    panoId: "bIPQP22cZ6fKBWS_506qXQ",
    place: "Near Kwangyang, Jeollanam-do",
    shortName: "Kwangyang",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","KR"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "kr-073",
    lat: 34.81353,
    lng: 126.632761,
    panoId: "62sm2zR9D9LW_sTn2Vh-Mw",
    place: "Near Dopo, Jeollanam-do",
    shortName: "Dopo",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","KR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "kr-074",
    lat: 35.119668,
    lng: 126.975991,
    panoId: "g3KQL6aIBf-GgG4Y3RAv7w",
    place: "Near Hwasun, Jeollanam-do",
    shortName: "Hwasun",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","KR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "kr-075",
    lat: 34.826305,
    lng: 127.639492,
    panoId: "3EggbY4opdDkPiP1KUUpZw",
    place: "Near Yeosu, Jeollanam-do",
    shortName: "Yeosu",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","KR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "kr-076",
    lat: 36.396854,
    lng: 128.238777,
    panoId: "g6vQ7v4M6ywIXMIWq6cI2A",
    place: "Near Sangju, Gyeongsangbuk-do",
    shortName: "Sangju",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","KR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "kr-077",
    lat: 35.007729,
    lng: 126.400483,
    panoId: "qgJSwOl0AGJvLfMSrP7Ssg",
    place: "Near Muan, Jeollanam-do",
    shortName: "Muan",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","KR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "kr-078",
    lat: 35.250505,
    lng: 127.469888,
    panoId: "VAJKDtVg0tDcZ0GZ9fX5Eg",
    place: "Near Kurye, Jeollanam-do",
    shortName: "Kurye",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","KR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "kr-079",
    lat: 34.907485,
    lng: 127.583949,
    panoId: "o1r5BvXfrt6OnvIOHmjL2A",
    place: "Near Haeryong, Jeollanam-do",
    shortName: "Haeryong",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","KR"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "kr-080",
    lat: 36.749654,
    lng: 128.57746,
    panoId: "z-cM6UxUed0bYyYlsmB9cw",
    place: "Near Yeongju, Gyeongsangbuk-do",
    shortName: "Yeongju",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","KR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "kr-081",
    lat: 33.494582,
    lng: 126.426154,
    panoId: "yQy1aXNzEiCjxItOLSL5uA",
    place: "Near Tallang-dong, Jeju-do",
    shortName: "Tallang-dong",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","KR"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "kr-082",
    lat: 36.015678,
    lng: 129.284926,
    panoId: "cWL4Y6aoM-A9M6ykpE1j0g",
    place: "Near Yeonil, Gyeongsangbuk-do",
    shortName: "Yeonil",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","KR"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "kr-083",
    lat: 36.174429,
    lng: 129.380937,
    panoId: "ycQyQpj79FwaungiNhEh4w",
    place: "Near Cheongha, Gyeongsangbuk-do",
    shortName: "Cheongha",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","KR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "kr-084",
    lat: 33.434805,
    lng: 126.473394,
    panoId: "ogWslIaaO7fxm-wreYRmyw",
    place: "Near Seodong, Jeju-do",
    shortName: "Seodong",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","KR"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "kr-085",
    lat: 35.002634,
    lng: 127.719085,
    panoId: "gX1Gm9MECZRpzWZ5_rjWGA",
    place: "Near Jinsang, Jeollanam-do",
    shortName: "Jinsang",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","KR"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "kr-086",
    lat: 37.853904,
    lng: 127.549443,
    panoId: "05Ew_yxRSeOcF7WTZmNThg",
    place: "Near Gapyeong, Gyeonggi-do",
    shortName: "Gapyeong",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","KR"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "kr-087",
    lat: 37.327429,
    lng: 127.212332,
    panoId: "t3h5W0Kh2H6P46JBkZTnIQ",
    place: "Near Gwangju, Gyeonggi-do",
    shortName: "Gwangju",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","KR"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "kr-088",
    lat: 38.179968,
    lng: 127.266844,
    panoId: "FqCTJvvcSdUukJDSA8yHhg",
    place: "Near Gwanin, Gyeonggi-do",
    shortName: "Gwanin",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","KR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "kr-089",
    lat: 36.202378,
    lng: 128.618869,
    panoId: "IkYZ1vpED3U8ydMj4OB1OA",
    place: "Near Kunwi, Gyeongsangbuk-do",
    shortName: "Kunwi",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","KR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "kr-090",
    lat: 36.504678,
    lng: 129.054811,
    panoId: "b31vgOiirx10D6xC5qS5mA",
    place: "Near Cheongsong gun, Gyeongsangbuk-do",
    shortName: "Cheongsong gun",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","KR"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "kr-091",
    lat: 35.081678,
    lng: 126.548667,
    panoId: "p2FMoAqIt0wWEfvaJQyWkA",
    place: "Near Nasan, Jeollanam-do",
    shortName: "Nasan",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","KR"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "kr-092",
    lat: 36.64088,
    lng: 128.54797,
    panoId: "YABZ0cHYlMXmPeyRgWG2Zw",
    place: "Near Yecheon, Gyeongsangbuk-do",
    shortName: "Yecheon",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","KR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "kr-093",
    lat: 35.953548,
    lng: 129.368126,
    panoId: "MxJmir7Dd-NVTUM9S0XZ9w",
    place: "Near Ocheon, Gyeongsangbuk-do",
    shortName: "Ocheon",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","KR"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "kr-094",
    lat: 35.103824,
    lng: 127.689367,
    panoId: "JH_C_V25LDKZvymNKWLIyw",
    place: "Near Hadong, Gyeongsangnam-do",
    shortName: "Hadong",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","KR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "kr-095",
    lat: 38.22375,
    lng: 127.151146,
    panoId: "gHbVzU3eeVQKq1vNIF9bnw",
    place: "Near Sinseo, Gyeonggi-do",
    shortName: "Sinseo",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","KR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "kr-096",
    lat: 36.30645,
    lng: 128.314826,
    panoId: "EgBAsepMcL07Pv4zYkEWKg",
    place: "Near Jenzan, Gyeongsangbuk-do",
    shortName: "Jenzan",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","KR"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "kr-097",
    lat: 37.190947,
    lng: 128.501394,
    panoId: "FAKSCMJE7XCkT1oUTdertQ",
    place: "Near Neietsu, Gangwon-do",
    shortName: "Neietsu",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","KR"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "kr-098",
    lat: 37.848411,
    lng: 128.788158,
    panoId: "33lOmfdyIoerFJcL7EXh4w",
    place: "Near Jumunjin, Gangwon-do",
    shortName: "Jumunjin",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","KR"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "kr-099",
    lat: 33.473807,
    lng: 126.448936,
    panoId: "DDTnWpgn5y0nZpQSFrmqPA",
    place: "Near Tallang-dong, Jeju-do",
    shortName: "Tallang-dong",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","KR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "kr-100",
    lat: 35.264559,
    lng: 127.896185,
    panoId: "OlNBIlVn4M32pKzODI9rXA",
    place: "Near Chinju, Gyeongsangnam-do",
    shortName: "Chinju",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "adventurer",
    pools: ["world","Asia","KR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "kr-101",
    lat: 35.193792,
    lng: 127.868564,
    panoId: "T3dis4ZV3Gk8ZLTpVJP2RQ",
    place: "Near Jeongnyang, Gyeongsangnam-do",
    shortName: "Jeongnyang",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "adventurer",
    pools: ["world","Asia","KR"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "kr-102",
    lat: 37.957698,
    lng: 127.337063,
    panoId: "xWMD417pWDmbm6YlqLYEUg",
    place: "Near Gapyeong, Gyeonggi-do",
    shortName: "Gapyeong",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "adventurer",
    pools: ["world","Asia","KR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "kr-103",
    lat: 37.028748,
    lng: 126.791315,
    panoId: "ThwbhIOJdpPFJiKDlSw3LQ",
    place: "Near Hwaseong-si, Gyeonggi-do",
    shortName: "Hwaseong-si",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "adventurer",
    pools: ["world","Asia","KR"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "kr-104",
    lat: 36.578496,
    lng: 129.029556,
    panoId: "2-HTsYpswBjfDYEYB9_GoQ",
    place: "Near Cheongsong gun, Gyeongsangbuk-do",
    shortName: "Cheongsong gun",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "adventurer",
    pools: ["world","Asia","KR"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "kr-105",
    lat: 36.187468,
    lng: 129.141432,
    panoId: "fW1OKgV3TKvuWG991Z9Q2A",
    place: "Near Singwang, Gyeongsangbuk-do",
    shortName: "Singwang",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "adventurer",
    pools: ["world","Asia","KR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "kr-106",
    lat: 38.050292,
    lng: 127.313346,
    panoId: "siVMciPl2tLaaLF4DMoEcA",
    place: "Near Gwanin, Gyeonggi-do",
    shortName: "Gwanin",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "adventurer",
    pools: ["world","Asia","KR"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "kr-107",
    lat: 38.06675,
    lng: 127.073293,
    panoId: "bjOIx28wWVh_9dT6VHGZMA",
    place: "Near Yeoncheon, Gyeonggi-do",
    shortName: "Yeoncheon",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "adventurer",
    pools: ["world","Asia","KR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "kr-108",
    lat: 36.465313,
    lng: 129.386703,
    panoId: "nlwNxOJfJAETeOxvwXcePA",
    place: "Near Yeongdeok, Gyeongsangbuk-do",
    shortName: "Yeongdeok",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "adventurer",
    pools: ["world","Asia","KR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "kr-109",
    lat: 38.061819,
    lng: 127.52392,
    panoId: "L7HVF_sQ6AxXi-bxFK3sVg",
    place: "Near Hwacheon, Gangwon-do",
    shortName: "Hwacheon",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "adventurer",
    pools: ["world","Asia","KR"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "kr-110",
    lat: 37.965473,
    lng: 127.242092,
    panoId: "OqePyon0y9EHZKwzpyIP5Q",
    place: "Near Jeongok, Gyeonggi-do",
    shortName: "Jeongok",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "adventurer",
    pools: ["world","Asia","KR"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "kr-111",
    lat: 35.084919,
    lng: 126.264274,
    panoId: "vZ2LwEann5D2f_x9fMU_7A",
    place: "Near Haeje, Jeollanam-do",
    shortName: "Haeje",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "adventurer",
    pools: ["world","Asia","KR"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "kr-112",
    lat: 37.259386,
    lng: 128.256744,
    panoId: "f05GFDd9FFpRupNLyqc5BQ",
    place: "Near Pyeongchang, Gangwon-do",
    shortName: "Pyeongchang",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "adventurer",
    pools: ["world","Asia","KR"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "kr-113",
    lat: 35.453218,
    lng: 126.506209,
    panoId: "1emnrjr1bbliFOwUdwmZuA",
    place: "Near Sangha, Jeollabuk-do",
    shortName: "Sangha",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "adventurer",
    pools: ["world","Asia","KR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "kr-114",
    lat: 35.449237,
    lng: 127.820979,
    panoId: "nJ4tjwBFtp47zfYswy0YxA",
    place: "Near Byeonggok, Gyeongsangnam-do",
    shortName: "Byeonggok",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "adventurer",
    pools: ["world","Asia","KR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "kr-115",
    lat: 35.396738,
    lng: 127.659861,
    panoId: "joLyf9jhW5FDtWmp84WaZw",
    place: "Near Byeonggok, Gyeongsangnam-do",
    shortName: "Byeonggok",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "adventurer",
    pools: ["world","Asia","KR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "kr-116",
    lat: 37.578355,
    lng: 128.105657,
    panoId: "BDU3PO-wzZ0Yl9cmj-sxPw",
    place: "Near Seoseok, Gangwon-do",
    shortName: "Seoseok",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "adventurer",
    pools: ["world","Asia","KR"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "kr-117",
    lat: 35.867568,
    lng: 127.771205,
    panoId: "-emGozkx1oe5IspH_T1nxw",
    place: "Near Seolcheon, Jeollabuk-do",
    shortName: "Seolcheon",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "adventurer",
    pools: ["world","Asia","KR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "kr-118",
    lat: 33.273819,
    lng: 126.345509,
    panoId: "fPTZXGB4QV0zbSnIKVm8yQ",
    place: "Near Seogwipo, Jeju-do",
    shortName: "Seogwipo",
    countryCode: "KR",
    country: "South Korea",
    continent: "Asia",
    difficulty: "adventurer",
    pools: ["world","Asia","KR"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "tw-000",
    lat: 24.993856,
    lng: 121.297001,
    panoId: "s_xsKDLqnBBGsnYSJ5Rcsw",
    place: "Near Taoyuan, Taiwan",
    shortName: "Taoyuan",
    countryCode: "TW",
    country: "Taiwan",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TW"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tw-001",
    lat: 22.991035,
    lng: 120.213339,
    panoId: "RfmMUt135a6k3oOn2re50w",
    place: "Near Tainan, Taiwan",
    shortName: "Tainan",
    countryCode: "TW",
    country: "Taiwan",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TW"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tw-002",
    lat: 25.014254,
    lng: 121.467198,
    panoId: "cjfmNxy2SqvwAviQkDM70w",
    place: "Near Banqiao, Taipei",
    shortName: "Banqiao",
    countryCode: "TW",
    country: "Taiwan",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TW"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "tw-003",
    lat: 22.616256,
    lng: 120.313301,
    panoId: "EMUSv61RVVbhYjXOXw5b_A",
    place: "Near Kaohsiung, Takao",
    shortName: "Kaohsiung",
    countryCode: "TW",
    country: "Taiwan",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TW"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tw-004",
    lat: 22.626582,
    lng: 120.361237,
    panoId: "NrSzWPNZEn_576syjFFRHw",
    place: "Near Fengshan, Takao",
    shortName: "Fengshan",
    countryCode: "TW",
    country: "Taiwan",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TW"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tw-005",
    lat: 25.053036,
    lng: 121.526398,
    panoId: "AeROwMk1c9GJ7xZ5WvGCmQ",
    place: "Near Taipei, Taiwan",
    shortName: "Taipei",
    countryCode: "TW",
    country: "Taiwan",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TW"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "tw-006",
    lat: 24.146816,
    lng: 120.684007,
    panoId: "6UqxJZ58zUti77KouJXm2A",
    place: "Near Taichung, Taiwan",
    shortName: "Taichung",
    countryCode: "TW",
    country: "Taiwan",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TW"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tw-007",
    lat: 24.56421,
    lng: 120.82405,
    panoId: "x9aqDxDS25QOXwzKMo8wsQ",
    place: "Near Miaoli, Taiwan",
    shortName: "Miaoli",
    countryCode: "TW",
    country: "Taiwan",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TW"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tw-008",
    lat: 23.307215,
    lng: 120.310463,
    panoId: "5pCeofusSG1HWSesAZDxgA",
    place: "Near Xinying, Taiwan",
    shortName: "Xinying",
    countryCode: "TW",
    country: "Taiwan",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TW"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tw-009",
    lat: 23.479191,
    lng: 120.448862,
    panoId: "gc3yN0N4Y7ffY0Ya7J6R-g",
    place: "Near Chiayi City, Taiwan",
    shortName: "Chiayi City",
    countryCode: "TW",
    country: "Taiwan",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TW"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "tw-010",
    lat: 23.45947,
    lng: 120.332051,
    panoId: "-fOkz4ZhqiJH-1qMsSHXcQ",
    place: "Near Taibao, Taiwan",
    shortName: "Taibao",
    countryCode: "TW",
    country: "Taiwan",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TW"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tw-011",
    lat: 24.838305,
    lng: 121.007792,
    panoId: "IV8-9x6fzlvkNAW4sJ1XCA",
    place: "Near Zhubei, Taiwan",
    shortName: "Zhubei",
    countryCode: "TW",
    country: "Taiwan",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TW"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tw-012",
    lat: 23.569798,
    lng: 120.301428,
    panoId: "-wlRlrkr27SQu3MMvjjYSw",
    place: "Near Beigang, Taiwan",
    shortName: "Beigang",
    countryCode: "TW",
    country: "Taiwan",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TW"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tw-013",
    lat: 24.439127,
    lng: 118.421568,
    panoId: "eqWj4aG2oxKN5JgFwMwYyg",
    place: "Near Jinhu, Fukien",
    shortName: "Jinhu",
    countryCode: "TW",
    country: "Taiwan",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TW"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "tw-014",
    lat: 24.434018,
    lng: 118.317003,
    panoId: "FaLthiCvjal1HvwPnykurg",
    place: "Near Jincheng, Fukien",
    shortName: "Jincheng",
    countryCode: "TW",
    country: "Taiwan",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TW"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "tw-015",
    lat: 25.062094,
    lng: 121.457045,
    panoId: "Iwep3hRIeUA7EklOJmFNGw",
    place: "Near New Taipei City, Taipei",
    shortName: "New Taipei City",
    countryCode: "TW",
    country: "Taiwan",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TW"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "tw-016",
    lat: 22.612106,
    lng: 120.325109,
    panoId: "cB-4hA43y5Uw9IitBegSAg",
    place: "Near Kaohsiung, Takao",
    shortName: "Kaohsiung",
    countryCode: "TW",
    country: "Taiwan",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TW"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tw-017",
    lat: 23.884134,
    lng: 120.35379,
    panoId: "Os9qOer9Rphq6s7r7Wei7Q",
    place: "Near Erlin, Taiwan",
    shortName: "Erlin",
    countryCode: "TW",
    country: "Taiwan",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TW"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tw-018",
    lat: 23.714812,
    lng: 120.524402,
    panoId: "UO08a0VOLRn7vbwyuIhSLQ",
    place: "Near Douliu, Taiwan",
    shortName: "Douliu",
    countryCode: "TW",
    country: "Taiwan",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TW"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tw-019",
    lat: 25.032864,
    lng: 121.477349,
    panoId: "OEXGlzYQ0zOoS1regvsZCA",
    place: "Near Banqiao, Taipei",
    shortName: "Banqiao",
    countryCode: "TW",
    country: "Taiwan",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TW"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tw-020",
    lat: 24.822066,
    lng: 120.988021,
    panoId: "LxFqZ2tj0Gvtq69ccro4lQ",
    place: "Near Zhubei, Taiwan",
    shortName: "Zhubei",
    countryCode: "TW",
    country: "Taiwan",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TW"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "tw-021",
    lat: 23.39946,
    lng: 120.161141,
    panoId: "_EhSx1o_cdZsHfn08QlIGw",
    place: "Near Budai, Taiwan",
    shortName: "Budai",
    countryCode: "TW",
    country: "Taiwan",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TW"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "tw-022",
    lat: 22.625857,
    lng: 120.333798,
    panoId: "Nl3YiiqCjZhPT8RLvwC-8w",
    place: "Near Kaohsiung, Takao",
    shortName: "Kaohsiung",
    countryCode: "TW",
    country: "Taiwan",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TW"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tw-023",
    lat: 25.083415,
    lng: 121.461221,
    panoId: "jbN2tpcYuDQyT2yhB9czyQ",
    place: "Near New Taipei City, Taipei",
    shortName: "New Taipei City",
    countryCode: "TW",
    country: "Taiwan",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TW"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tw-024",
    lat: 25.028658,
    lng: 121.442185,
    panoId: "CEw06FainV8Bq8IIG6puaA",
    place: "Near Banqiao, Taipei",
    shortName: "Banqiao",
    countryCode: "TW",
    country: "Taiwan",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TW"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tw-025",
    lat: 25.038938,
    lng: 121.522848,
    panoId: "Eo8Sjq2rsvagtl-0MDtaIA",
    place: "Near Taipei, Taiwan",
    shortName: "Taipei",
    countryCode: "TW",
    country: "Taiwan",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TW"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tw-026",
    lat: 22.799871,
    lng: 121.176894,
    panoId: "eyfEA-bz8OsfiNpgBVUfRg",
    place: "Near Taitung, Taiwan",
    shortName: "Taitung",
    countryCode: "TW",
    country: "Taiwan",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TW"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tw-027",
    lat: 23.87649,
    lng: 120.681358,
    panoId: "o-tToX1XSGcS0z3HJ5emyw",
    place: "Near Nantou, Taiwan",
    shortName: "Nantou",
    countryCode: "TW",
    country: "Taiwan",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TW"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tw-028",
    lat: 23.805424,
    lng: 120.703054,
    panoId: "zzH8pi1_UWMZz4hhulA3Rg",
    place: "Near Zhushan, Taiwan",
    shortName: "Zhushan",
    countryCode: "TW",
    country: "Taiwan",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TW"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tw-029",
    lat: 25.176392,
    lng: 121.702595,
    panoId: "6P_GkRyWXpuTJVWmBL5TLw",
    place: "Near Keelung, Taiwan",
    shortName: "Keelung",
    countryCode: "TW",
    country: "Taiwan",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TW"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tw-030",
    lat: 24.768229,
    lng: 121.107358,
    panoId: "wB0KjWOQ6exrZEild56xfw",
    place: "Near Zhudong, Taiwan",
    shortName: "Zhudong",
    countryCode: "TW",
    country: "Taiwan",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TW"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tw-031",
    lat: 23.562801,
    lng: 120.403849,
    panoId: "S_hHjV4j-KcbD18BSL4Ppw",
    place: "Near Xingang, Taiwan",
    shortName: "Xingang",
    countryCode: "TW",
    country: "Taiwan",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TW"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tw-032",
    lat: 23.436519,
    lng: 120.199628,
    panoId: "JRs0xRVuQhvHKstx7qbGnQ",
    place: "Near Dongshi, Taiwan",
    shortName: "Dongshi",
    countryCode: "TW",
    country: "Taiwan",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TW"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tw-033",
    lat: 24.14467,
    lng: 120.504394,
    panoId: "Ch72X3n6ex4GTM7WY5HCeg",
    place: "Near Zhongliao, Taiwan",
    shortName: "Zhongliao",
    countryCode: "TW",
    country: "Taiwan",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TW"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tw-034",
    lat: 23.805801,
    lng: 120.557388,
    panoId: "6xmdS_2MzniLq9mw3nsUAQ",
    place: "Near Ershui, Taiwan",
    shortName: "Ershui",
    countryCode: "TW",
    country: "Taiwan",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TW"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tw-035",
    lat: 24.211334,
    lng: 120.517768,
    panoId: "6YnqC3xoFdYlFU_l1JKaAw",
    place: "Near Buzi, Taiwan",
    shortName: "Buzi",
    countryCode: "TW",
    country: "Taiwan",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TW"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tw-036",
    lat: 24.719728,
    lng: 121.817726,
    panoId: "YSAgpWMhf4VKae99hGM1YQ",
    place: "Near Yilan, Taiwan",
    shortName: "Yilan",
    countryCode: "TW",
    country: "Taiwan",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TW"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tw-037",
    lat: 23.396799,
    lng: 120.319364,
    panoId: "Rq0nXgbBjJpcwQc0duaRPw",
    place: "Near Taibao, Taiwan",
    shortName: "Taibao",
    countryCode: "TW",
    country: "Taiwan",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TW"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tw-038",
    lat: 23.44271,
    lng: 120.279877,
    panoId: "4XiGZtpg7_Jy0HuRcOUQ1A",
    place: "Near Taibao, Taiwan",
    shortName: "Taibao",
    countryCode: "TW",
    country: "Taiwan",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TW"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tw-039",
    lat: 24.427753,
    lng: 118.251817,
    panoId: "HtWPLi3S6chBaj7EYU90wA",
    place: "Near Linhu, Fukien",
    shortName: "Linhu",
    countryCode: "TW",
    country: "Taiwan",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TW"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "tw-040",
    lat: 24.436868,
    lng: 118.383164,
    panoId: "ANOfBas_8iifiXclbrfCzg",
    place: "Near Jinhu, Fukien",
    shortName: "Jinhu",
    countryCode: "TW",
    country: "Taiwan",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TW"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "tw-041",
    lat: 22.585551,
    lng: 120.417553,
    panoId: "hsvNLeavxoIgaljLwAvjxQ",
    place: "Near Fengshan, Takao",
    shortName: "Fengshan",
    countryCode: "TW",
    country: "Taiwan",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TW"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tw-042",
    lat: 24.418269,
    lng: 118.239511,
    panoId: "6V1JLr7WJMNtb1j8pIWIPQ",
    place: "Near Shanglin, Fukien",
    shortName: "Shanglin",
    countryCode: "TW",
    country: "Taiwan",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TW"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "tw-043",
    lat: 22.55983,
    lng: 120.365004,
    panoId: "ebdikwv6hlwCLVLRzrsPXQ",
    place: "Near Fengshan, Takao",
    shortName: "Fengshan",
    countryCode: "TW",
    country: "Taiwan",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TW"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tw-044",
    lat: 24.433175,
    lng: 118.260424,
    panoId: "Yozd8Kn4t6Rff1j2JuZUxA",
    place: "Near Linhu, Fukien",
    shortName: "Linhu",
    countryCode: "TW",
    country: "Taiwan",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TW"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "tw-045",
    lat: 24.448845,
    lng: 118.255537,
    panoId: "vVtgQZGhzoyhQu_7KbIOow",
    place: "Near Xikou Village, Fukien",
    shortName: "Xikou Village",
    countryCode: "TW",
    country: "Taiwan",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TW"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "tw-046",
    lat: 25.164152,
    lng: 121.663326,
    panoId: "EjnZ_2Vu7FDSKhGpSA2kCg",
    place: "Near Keelung, Taiwan",
    shortName: "Keelung",
    countryCode: "TW",
    country: "Taiwan",
    continent: "Asia",
    difficulty: "adventurer",
    pools: ["world","Asia","TW"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tw-047",
    lat: 23.434753,
    lng: 120.513877,
    panoId: "a0srPG_nry0CE-y--Xv9DA",
    place: "Near Chiayi City, Taiwan",
    shortName: "Chiayi City",
    countryCode: "TW",
    country: "Taiwan",
    continent: "Asia",
    difficulty: "adventurer",
    pools: ["world","Asia","TW"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tw-048",
    lat: 23.132936,
    lng: 120.290565,
    panoId: "AJQEFfMxZc4YT-SoM6WqsQ",
    place: "Near Yongkang, Taiwan",
    shortName: "Yongkang",
    countryCode: "TW",
    country: "Taiwan",
    continent: "Asia",
    difficulty: "adventurer",
    pools: ["world","Asia","TW"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tw-049",
    lat: 24.411473,
    lng: 118.216287,
    panoId: "oToHokUFOz-3T9Hdlzqbrw",
    place: "Near Shangqi Village, Fukien",
    shortName: "Shangqi Village",
    countryCode: "TW",
    country: "Taiwan",
    continent: "Asia",
    difficulty: "adventurer",
    pools: ["world","Asia","TW"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "tw-050",
    lat: 24.427623,
    lng: 118.230495,
    panoId: "u750RibymYlwObugPXis3g",
    place: "Near Shanglin, Fukien",
    shortName: "Shanglin",
    countryCode: "TW",
    country: "Taiwan",
    continent: "Asia",
    difficulty: "adventurer",
    pools: ["world","Asia","TW"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "tw-051",
    lat: 24.442174,
    lng: 118.234601,
    panoId: "7DOrUEO_NHVFZLxhrxLplw",
    place: "Near Xikou Village, Fukien",
    shortName: "Xikou Village",
    countryCode: "TW",
    country: "Taiwan",
    continent: "Asia",
    difficulty: "adventurer",
    pools: ["world","Asia","TW"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "th-000",
    lat: 13.597583,
    lng: 100.597254,
    panoId: "sSCxMOaIwOAAe-BMq3y09g",
    place: "Near Samut Prakan, Samut Prakan",
    shortName: "Samut Prakan",
    countryCode: "TH",
    country: "Thailand",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "th-001",
    lat: 13.951328,
    lng: 101.717449,
    panoId: "LCXUofmvIUJW-79Z7DeGeQ",
    place: "Near Kabin Buri, Prachin Buri",
    shortName: "Kabin Buri",
    countryCode: "TH",
    country: "Thailand",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "th-002",
    lat: 13.658291,
    lng: 100.533512,
    panoId: "yphm8xR8bFiEencnWuTlyQ",
    place: "Near Phra Pradaeng, Samut Prakan",
    shortName: "Phra Pradaeng",
    countryCode: "TH",
    country: "Thailand",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TH"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "th-003",
    lat: 13.860204,
    lng: 100.514681,
    panoId: "je7JdS5oxZYwKlh8TsnPMg",
    place: "Near Mueang Nonthaburi, Nonthaburi",
    shortName: "Mueang Nonthaburi",
    countryCode: "TH",
    country: "Thailand",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "th-004",
    lat: 12.933906,
    lng: 100.883743,
    panoId: "IXEmxKzjwgOkNvXGcOAyJA",
    place: "Near Pattaya, Chon Buri",
    shortName: "Pattaya",
    countryCode: "TH",
    country: "Thailand",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "th-005",
    lat: 13.79068,
    lng: 100.570125,
    panoId: "bF74D_wrrqr4hMZKHSTy-A",
    place: "Near Din Daeng, Bangkok",
    shortName: "Din Daeng",
    countryCode: "TH",
    country: "Thailand",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "th-006",
    lat: 13.785702,
    lng: 100.66938,
    panoId: "ME_qDKipzFZ1xbknswGuTA",
    place: "Near Bueng Kum, Bangkok",
    shortName: "Bueng Kum",
    countryCode: "TH",
    country: "Thailand",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "th-007",
    lat: 13.810983,
    lng: 100.530625,
    panoId: "TJ5itSrKrGITomisuvZDXA",
    place: "Near Bang Sue, Bangkok",
    shortName: "Bang Sue",
    countryCode: "TH",
    country: "Thailand",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "th-008",
    lat: 13.722037,
    lng: 100.784714,
    panoId: "2OkhJYPIICUbWeGEkEfv7w",
    place: "Near Lat Krabang, Bangkok",
    shortName: "Lat Krabang",
    countryCode: "TH",
    country: "Thailand",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "th-009",
    lat: 13.911793,
    lng: 100.497701,
    panoId: "dWHs5oUp34iGQWt2xmugzw",
    place: "Near Pak Kret, Nonthaburi",
    shortName: "Pak Kret",
    countryCode: "TH",
    country: "Thailand",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "th-010",
    lat: 17.41557,
    lng: 102.7864,
    panoId: "lI_NkgXZffkYdD5wKSEDeQ",
    place: "Near Udon Thani, Udon Thani",
    shortName: "Udon Thani",
    countryCode: "TH",
    country: "Thailand",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "th-011",
    lat: 13.920619,
    lng: 100.645889,
    panoId: "JZfn8PAdOHwlsteOZHLjnw",
    place: "Near Sai Mai, Bangkok",
    shortName: "Sai Mai",
    countryCode: "TH",
    country: "Thailand",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "th-012",
    lat: 13.855363,
    lng: 100.862077,
    panoId: "EglqJn0KU2ffwgBdUUlaEw",
    place: "Near Nong Chok, Bangkok",
    shortName: "Nong Chok",
    countryCode: "TH",
    country: "Thailand",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "th-013",
    lat: 13.66324,
    lng: 100.43453,
    panoId: "DH4quSk3B6pV0fa3rSDR_g",
    place: "Near Bang Khun Thian, Bangkok",
    shortName: "Bang Khun Thian",
    countryCode: "TH",
    country: "Thailand",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "th-014",
    lat: 18.292566,
    lng: 99.49291,
    panoId: "QjPmV8i49g0YCCT15OvWIA",
    place: "Near Lampang, Lampang",
    shortName: "Lampang",
    countryCode: "TH",
    country: "Thailand",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "th-015",
    lat: 13.803377,
    lng: 100.606972,
    panoId: "C3DlCkZtskavxAYiDufXAw",
    place: "Near Lat Phrao, Bangkok",
    shortName: "Lat Phrao",
    countryCode: "TH",
    country: "Thailand",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "th-016",
    lat: 13.705904,
    lng: 100.34923,
    panoId: "47VnI9tILCZlbwIo_JgxLQ",
    place: "Near Nong Khaem, Bangkok",
    shortName: "Nong Khaem",
    countryCode: "TH",
    country: "Thailand",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "th-017",
    lat: 15.238413,
    lng: 104.84905,
    panoId: "_4kdpp2c4QHJ00_omwZW4A",
    place: "Near Ubon Ratchathani, Ubon Ratchathani",
    shortName: "Ubon Ratchathani",
    countryCode: "TH",
    country: "Thailand",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "th-018",
    lat: 13.362451,
    lng: 100.98354,
    panoId: "PGQ3WdYIsCFmdzf7O2ysMQ",
    place: "Near Chon Buri, Chon Buri",
    shortName: "Chon Buri",
    countryCode: "TH",
    country: "Thailand",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "th-019",
    lat: 13.724906,
    lng: 100.484916,
    panoId: "AXjvl4bzegHtU_axvilyHg",
    place: "Near Thon Buri, Bangkok",
    shortName: "Thon Buri",
    countryCode: "TH",
    country: "Thailand",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "th-020",
    lat: 12.570626,
    lng: 99.95855,
    panoId: "FmtbSbtVqVA-Pt6oGfT-2g",
    place: "Near Hua Hin, Prachuap Khiri Khan",
    shortName: "Hua Hin",
    countryCode: "TH",
    country: "Thailand",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "th-021",
    lat: 18.790684,
    lng: 98.984655,
    panoId: "y65sW2kEa8Nzg7TY5jNEKg",
    place: "Near Chiang Mai, Chiang Mai",
    shortName: "Chiang Mai",
    countryCode: "TH",
    country: "Thailand",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "th-022",
    lat: 13.71052,
    lng: 99.896134,
    panoId: "ec298fEpILbltYPIM--OYg",
    place: "Near Ban I Chang, Ratchaburi",
    shortName: "Ban I Chang",
    countryCode: "TH",
    country: "Thailand",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "th-023",
    lat: 9.140268,
    lng: 99.33301,
    panoId: "AXXwU6BQftdQSgLhIxlAFQ",
    place: "Near Surat Thani, Surat Thani",
    shortName: "Surat Thani",
    countryCode: "TH",
    country: "Thailand",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "th-024",
    lat: 7.008335,
    lng: 100.476511,
    panoId: "eN2z3D1Aae1nhzngjjDmxg",
    place: "Near Hat Yai, Songkhla",
    shortName: "Hat Yai",
    countryCode: "TH",
    country: "Thailand",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "th-025",
    lat: 14.065431,
    lng: 100.645729,
    panoId: "020BfevzVt5kHyRhR2auUg",
    place: "Near Khlong Luang, Pathum Thani",
    shortName: "Khlong Luang",
    countryCode: "TH",
    country: "Thailand",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "th-026",
    lat: 14.970597,
    lng: 102.101997,
    panoId: "H-3wx5UG0KMYvfj0CjknOg",
    place: "Near Nakhon Ratchasima, Nakhon Ratchasima",
    shortName: "Nakhon Ratchasima",
    countryCode: "TH",
    country: "Thailand",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "th-027",
    lat: 13.172814,
    lng: 100.931625,
    panoId: "9W4FJgRbPI8_4Mjk1DplFw",
    place: "Near Si Racha, Chon Buri",
    shortName: "Si Racha",
    countryCode: "TH",
    country: "Thailand",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "th-028",
    lat: 13.659192,
    lng: 100.543634,
    panoId: "27zMy1fa4DdRrDhNTiMBKA",
    place: "Near Phra Pradaeng, Samut Prakan",
    shortName: "Phra Pradaeng",
    countryCode: "TH",
    country: "Thailand",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TH"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "th-029",
    lat: 13.358681,
    lng: 101.00522,
    panoId: "ZyUNGIqR44k26wGonlO5hg",
    place: "Near Chon Buri, Chon Buri",
    shortName: "Chon Buri",
    countryCode: "TH",
    country: "Thailand",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TH"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "th-030",
    lat: 15.255818,
    lng: 104.846717,
    panoId: "JgemOmoxcfo1Zbunq1C0sA",
    place: "Near Ubon Ratchathani, Ubon Ratchathani",
    shortName: "Ubon Ratchathani",
    countryCode: "TH",
    country: "Thailand",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "th-031",
    lat: 13.698431,
    lng: 99.887164,
    panoId: "jWTsKX0Z43H8dknXiOpBBw",
    place: "Near Ban I Chang, Ratchaburi",
    shortName: "Ban I Chang",
    countryCode: "TH",
    country: "Thailand",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "th-032",
    lat: 13.838451,
    lng: 100.041262,
    panoId: "koO1tTQfRkCeZ_2rZ6K_Cw",
    place: "Near Nakhon Pathom, Nakhon Pathom",
    shortName: "Nakhon Pathom",
    countryCode: "TH",
    country: "Thailand",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TH"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "th-033",
    lat: 13.168032,
    lng: 100.944834,
    panoId: "q1u1f-jaYs_etwUtqgjWfQ",
    place: "Near Si Racha, Chon Buri",
    shortName: "Si Racha",
    countryCode: "TH",
    country: "Thailand",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "th-034",
    lat: 13.872546,
    lng: 100.510183,
    panoId: "Le8IyMlM5bsm4T5svRzbug",
    place: "Near Mueang Nonthaburi, Nonthaburi",
    shortName: "Mueang Nonthaburi",
    countryCode: "TH",
    country: "Thailand",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "th-035",
    lat: 13.713875,
    lng: 100.419843,
    panoId: "Zvl-eqJL9eWiXWDlPCS3nA",
    place: "Near Phasi Charoen, Bangkok",
    shortName: "Phasi Charoen",
    countryCode: "TH",
    country: "Thailand",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "th-036",
    lat: 13.596024,
    lng: 100.57936,
    panoId: "hep5Trr096z4JNuOxfDG0A",
    place: "Near Phra Samut Chedi, Samut Prakan",
    shortName: "Phra Samut Chedi",
    countryCode: "TH",
    country: "Thailand",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "th-037",
    lat: 13.641638,
    lng: 100.414203,
    panoId: "VMNVTaGBPtnDFHkAWTkT0Q",
    place: "Near Ban Tha Kham, Bangkok",
    shortName: "Ban Tha Kham",
    countryCode: "TH",
    country: "Thailand",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TH"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "th-038",
    lat: 13.790853,
    lng: 100.537846,
    panoId: "dYYyxc_4cXZSqLcKihNcdQ",
    place: "Near Phaya Thai, Bangkok",
    shortName: "Phaya Thai",
    countryCode: "TH",
    country: "Thailand",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "th-039",
    lat: 13.654849,
    lng: 100.482406,
    panoId: "0VJ4g1DO4VU9vmTVjHz93g",
    place: "Near Chom Thong, Bangkok",
    shortName: "Chom Thong",
    countryCode: "TH",
    country: "Thailand",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TH"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "th-040",
    lat: 18.295452,
    lng: 99.476977,
    panoId: "Ci7pQNC_ec2uyeBLmwq2jQ",
    place: "Near Lampang, Lampang",
    shortName: "Lampang",
    countryCode: "TH",
    country: "Thailand",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "th-041",
    lat: 17.430603,
    lng: 102.770677,
    panoId: "Gx224OLGpRaKwjGZfdVHag",
    place: "Near Udon Thani, Udon Thani",
    shortName: "Udon Thani",
    countryCode: "TH",
    country: "Thailand",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "th-042",
    lat: 13.952508,
    lng: 101.695093,
    panoId: "avVXyARQyKWkOtwmSkO4tQ",
    place: "Near Kabin Buri, Prachin Buri",
    shortName: "Kabin Buri",
    countryCode: "TH",
    country: "Thailand",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "th-043",
    lat: 18.78153,
    lng: 98.975514,
    panoId: "hhaOgAd_O27vU-sYdUhMkQ",
    place: "Near Chiang Mai, Chiang Mai",
    shortName: "Chiang Mai",
    countryCode: "TH",
    country: "Thailand",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "th-044",
    lat: 13.759317,
    lng: 100.523973,
    panoId: "hnUFT0mAFdxO82SeQzXOXw",
    place: "Near Bangkok Riverside, Bangkok",
    shortName: "Bangkok Riverside",
    countryCode: "TH",
    country: "Thailand",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "th-045",
    lat: 12.939008,
    lng: 100.895011,
    panoId: "InYYarTL-ZYW00FiKTa5gg",
    place: "Near Pattaya, Chon Buri",
    shortName: "Pattaya",
    countryCode: "TH",
    country: "Thailand",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "th-046",
    lat: 9.149535,
    lng: 99.326245,
    panoId: "tv50KPWdPsX0SuYLJw2Xjg",
    place: "Near Surat Thani, Surat Thani",
    shortName: "Surat Thani",
    countryCode: "TH",
    country: "Thailand",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "th-047",
    lat: 13.69713,
    lng: 100.566653,
    panoId: "w5J1s6xLsHC-BlZGvyJMjQ",
    place: "Near Chong Nonsi, Bangkok",
    shortName: "Chong Nonsi",
    countryCode: "TH",
    country: "Thailand",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "th-048",
    lat: 14.982464,
    lng: 102.100529,
    panoId: "VNhaS6Pjj07VHg8Fp70cvg",
    place: "Near Nakhon Ratchasima, Nakhon Ratchasima",
    shortName: "Nakhon Ratchasima",
    countryCode: "TH",
    country: "Thailand",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TH"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "th-049",
    lat: 13.663558,
    lng: 100.421967,
    panoId: "vv4fVPI4CKoV7qPJO_xjFQ",
    place: "Near Bang Khun Thian, Bangkok",
    shortName: "Bang Khun Thian",
    countryCode: "TH",
    country: "Thailand",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TH"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "th-050",
    lat: 13.879158,
    lng: 100.79386,
    panoId: "E5eegS628OJRkyNE-JcgUQ",
    place: "Near Khlong Sam Wa, Bangkok",
    shortName: "Khlong Sam Wa",
    countryCode: "TH",
    country: "Thailand",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TH"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "th-051",
    lat: 13.743944,
    lng: 100.702545,
    panoId: "kz0lul7CQemz5Ab1s-c2ew",
    place: "Near Saphan Sung, Bangkok",
    shortName: "Saphan Sung",
    countryCode: "TH",
    country: "Thailand",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "th-052",
    lat: 13.845415,
    lng: 100.699546,
    panoId: "mSkvNljrxh4crKsUkKI-DA",
    place: "Near Khan Na Yao, Bangkok",
    shortName: "Khan Na Yao",
    countryCode: "TH",
    country: "Thailand",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "th-053",
    lat: 15.270951,
    lng: 104.828137,
    panoId: "1OLFJU-iSINofREW-e53Yw",
    place: "Near Ubon Ratchathani, Ubon Ratchathani",
    shortName: "Ubon Ratchathani",
    countryCode: "TH",
    country: "Thailand",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "th-054",
    lat: 13.936194,
    lng: 100.690817,
    panoId: "FcLJMRInC8QiyJfqW7PHhw",
    place: "Near Sai Mai, Bangkok",
    shortName: "Sai Mai",
    countryCode: "TH",
    country: "Thailand",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "th-055",
    lat: 13.900098,
    lng: 100.665453,
    panoId: "9rM3FnwjWyAj3nc9ZzAd6Q",
    place: "Near Sai Mai, Bangkok",
    shortName: "Sai Mai",
    countryCode: "TH",
    country: "Thailand",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TH"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "th-056",
    lat: 13.76426,
    lng: 100.003158,
    panoId: "89sRywi5hZKCbR-Uxo3uCQ",
    place: "Near Nakhon Pathom, Nakhon Pathom",
    shortName: "Nakhon Pathom",
    countryCode: "TH",
    country: "Thailand",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "th-057",
    lat: 13.330973,
    lng: 101.022379,
    panoId: "h77-WFrMr_00S6aYue65EQ",
    place: "Near Chon Buri, Chon Buri",
    shortName: "Chon Buri",
    countryCode: "TH",
    country: "Thailand",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "th-058",
    lat: 13.656453,
    lng: 100.686416,
    panoId: "7K8ktbYv1XrxqVFPVG6h7A",
    place: "Near Muban Thep Thani, Bangkok",
    shortName: "Muban Thep Thani",
    countryCode: "TH",
    country: "Thailand",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "th-059",
    lat: 14.067083,
    lng: 100.559668,
    panoId: "FMYKMXe-6aT7Hx8RvYZZKQ",
    place: "Near Sam Khok, Pathum Thani",
    shortName: "Sam Khok",
    countryCode: "TH",
    country: "Thailand",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "th-060",
    lat: 13.902656,
    lng: 100.820985,
    panoId: "bJ3-nobnfGCuiU0mWI1ysA",
    place: "Near Nong Chok, Bangkok",
    shortName: "Nong Chok",
    countryCode: "TH",
    country: "Thailand",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "th-061",
    lat: 12.540777,
    lng: 99.917883,
    panoId: "muzcp5CBIrF4ynKy705GkQ",
    place: "Near Hua Hin, Prachuap Khiri Khan",
    shortName: "Hua Hin",
    countryCode: "TH",
    country: "Thailand",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "th-062",
    lat: 14.024675,
    lng: 100.642023,
    panoId: "yhEk_zRaluVFpE2iv6zTdw",
    place: "Near Khlong Luang, Pathum Thani",
    shortName: "Khlong Luang",
    countryCode: "TH",
    country: "Thailand",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "th-063",
    lat: 17.450111,
    lng: 102.804526,
    panoId: "SOPEi85uvGsM0iVb-l9KBA",
    place: "Near Udon Thani, Udon Thani",
    shortName: "Udon Thani",
    countryCode: "TH",
    country: "Thailand",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "th-064",
    lat: 15.036974,
    lng: 102.126922,
    panoId: "Q7vkg5EHGnTITRgJda9C3A",
    place: "Near Nakhon Ratchasima, Nakhon Ratchasima",
    shortName: "Nakhon Ratchasima",
    countryCode: "TH",
    country: "Thailand",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "th-065",
    lat: 7.041746,
    lng: 100.515815,
    panoId: "y_A-xlXyEZlynx7hQH_BSw",
    place: "Near Hat Yai, Songkhla",
    shortName: "Hat Yai",
    countryCode: "TH",
    country: "Thailand",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "th-066",
    lat: 14.000362,
    lng: 101.454686,
    panoId: "TG6VGMjOF4HAeLtOrcTfaQ",
    place: "Near Ban Bang Boribun, Prachin Buri",
    shortName: "Ban Bang Boribun",
    countryCode: "TH",
    country: "Thailand",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "th-067",
    lat: 6.52342,
    lng: 101.3028,
    panoId: "KGmnxIehYJnR7zM5vzbCMw",
    place: "Near Yala, Yala",
    shortName: "Yala",
    countryCode: "TH",
    country: "Thailand",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "th-068",
    lat: 13.580944,
    lng: 99.812969,
    panoId: "uehWBH1PU61gG9w3DIuoxA",
    place: "Near Ratchaburi, Ratchaburi",
    shortName: "Ratchaburi",
    countryCode: "TH",
    country: "Thailand",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "th-069",
    lat: 14.499762,
    lng: 100.900631,
    panoId: "tYx8DfpjgqF-jeuMhyu37w",
    place: "Near Saraburi, Saraburi",
    shortName: "Saraburi",
    countryCode: "TH",
    country: "Thailand",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "th-070",
    lat: 8.43545,
    lng: 100.039204,
    panoId: "iVoNmvMEjTj68byfg-HtOA",
    place: "Near Nakhon Si Thammarat, Nakhon Si Thammarat",
    shortName: "Nakhon Si Thammarat",
    countryCode: "TH",
    country: "Thailand",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "th-071",
    lat: 17.149497,
    lng: 104.17854,
    panoId: "8qnrFlYYoCf6QkQaBwku_g",
    place: "Near Sakon Nakhon, Sakon Nakhon",
    shortName: "Sakon Nakhon",
    countryCode: "TH",
    country: "Thailand",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "th-072",
    lat: 13.657919,
    lng: 100.327526,
    panoId: "1vVWeDKNzsjgUlbfi-6WVw",
    place: "Near Bang Bon Nuea, Bangkok",
    shortName: "Bang Bon Nuea",
    countryCode: "TH",
    country: "Thailand",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "th-073",
    lat: 7.574594,
    lng: 99.583279,
    panoId: "sLMIe2wIJwS7ocj5Z6woFA",
    place: "Near Trang, Trang",
    shortName: "Trang",
    countryCode: "TH",
    country: "Thailand",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "th-074",
    lat: 15.741701,
    lng: 100.090665,
    panoId: "B6E2HY0kwBn2OhW56B1Nug",
    place: "Near Nakhon Sawan, Nakhon Sawan",
    shortName: "Nakhon Sawan",
    countryCode: "TH",
    country: "Thailand",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TH"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "th-075",
    lat: 7.251261,
    lng: 100.548159,
    panoId: "k70K4YMK-YO94AQCkL6-YQ",
    place: "Near Singhanakhon, Songkhla",
    shortName: "Singhanakhon",
    countryCode: "TH",
    country: "Thailand",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "th-076",
    lat: 15.862923,
    lng: 102.018758,
    panoId: "kMG6G85ZlwfBYUWkmHqeqg",
    place: "Near Chaiyaphum, Chaiyaphum",
    shortName: "Chaiyaphum",
    countryCode: "TH",
    country: "Thailand",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "th-077",
    lat: 7.8421,
    lng: 98.385612,
    panoId: "hoNHwMV6MuS9Zlm5RK4ytw",
    place: "Near Mueang Phuket, Phuket",
    shortName: "Mueang Phuket",
    countryCode: "TH",
    country: "Thailand",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TH"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "th-078",
    lat: 17.655724,
    lng: 100.071194,
    panoId: "aS8Yw-RBDeMxjsoLUKzaYA",
    place: "Near Lap Lae, Uttaradit",
    shortName: "Lap Lae",
    countryCode: "TH",
    country: "Thailand",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "th-079",
    lat: 16.457186,
    lng: 99.572424,
    panoId: "Qef3uRsm7wXr6UxMqJpaMQ",
    place: "Near Kamphaeng Phet, Kamphaeng Phet",
    shortName: "Kamphaeng Phet",
    countryCode: "TH",
    country: "Thailand",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "th-080",
    lat: 14.067435,
    lng: 101.811694,
    panoId: "Z1OpYV1ofO4crmXW_gJPfA",
    place: "Near Na Di, Prachin Buri",
    shortName: "Na Di",
    countryCode: "TH",
    country: "Thailand",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "th-081",
    lat: 14.052919,
    lng: 101.462759,
    panoId: "98DyTP8QVZa_pjNJvfcIOw",
    place: "Near Ban Non Hom, Prachin Buri",
    shortName: "Ban Non Hom",
    countryCode: "TH",
    country: "Thailand",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "th-082",
    lat: 16.438067,
    lng: 102.771279,
    panoId: "_sTGjiPCQrEFhm7houxF4g",
    place: "Near Khon Kaen, Khon Kaen",
    shortName: "Khon Kaen",
    countryCode: "TH",
    country: "Thailand",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "th-083",
    lat: 10.541291,
    lng: 99.220344,
    panoId: "UG0Te21x23EDGrCYPv_-0A",
    place: "Near Chumphon, Chumphon",
    shortName: "Chumphon",
    countryCode: "TH",
    country: "Thailand",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "th-084",
    lat: 13.853752,
    lng: 99.863129,
    panoId: "dhgQA5bzPbEFPzjD5DhGOQ",
    place: "Near Ban Pong, Ratchaburi",
    shortName: "Ban Pong",
    countryCode: "TH",
    country: "Thailand",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "th-085",
    lat: 12.712409,
    lng: 101.310464,
    panoId: "9YD1AtmZjzPyavoEXNHRMQ",
    place: "Near Rayong, Rayong",
    shortName: "Rayong",
    countryCode: "TH",
    country: "Thailand",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "th-086",
    lat: 16.864431,
    lng: 100.278322,
    panoId: "DYOCCJA3lDdzaNhWxYBRLA",
    place: "Near Ban Aranyik, Phitsanulok",
    shortName: "Ban Aranyik",
    countryCode: "TH",
    country: "Thailand",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "th-087",
    lat: 12.619673,
    lng: 102.131467,
    panoId: "NW8eZy2eLkjqI-rKwjxeGA",
    place: "Near Chanthaburi, Chanthaburi",
    shortName: "Chanthaburi",
    countryCode: "TH",
    country: "Thailand",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "th-088",
    lat: 14.763524,
    lng: 100.677986,
    panoId: "A2erqZpwIL3OmxQV-zN36Q",
    place: "Near Lop Buri, Lopburi",
    shortName: "Lop Buri",
    countryCode: "TH",
    country: "Thailand",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "th-089",
    lat: 14.507162,
    lng: 100.980998,
    panoId: "3l0xWobYVq5vmLuZMiwf6A",
    place: "Near Saraburi, Saraburi",
    shortName: "Saraburi",
    countryCode: "TH",
    country: "Thailand",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "th-090",
    lat: 14.730571,
    lng: 100.760798,
    panoId: "WBe273ryLVHnVj1yNmpg5g",
    place: "Near Phra Phutthabat, Saraburi",
    shortName: "Phra Phutthabat",
    countryCode: "TH",
    country: "Thailand",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "th-091",
    lat: 13.968936,
    lng: 101.547039,
    panoId: "_c3FzPPTHRo4d9Fdylhn-g",
    place: "Near Si Maha Phot, Prachin Buri",
    shortName: "Si Maha Phot",
    countryCode: "TH",
    country: "Thailand",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "th-092",
    lat: 6.518044,
    lng: 101.315293,
    panoId: "qP6Z2IRK2LoM5lTC6bmEnQ",
    place: "Near Yala, Yala",
    shortName: "Yala",
    countryCode: "TH",
    country: "Thailand",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "th-093",
    lat: 8.412315,
    lng: 99.917923,
    panoId: "7_ivaBJkhI58guAJgSL2EA",
    place: "Near Nakhon Si Thammarat, Nakhon Si Thammarat",
    shortName: "Nakhon Si Thammarat",
    countryCode: "TH",
    country: "Thailand",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "th-094",
    lat: 12.8272,
    lng: 101.688034,
    panoId: "bSAOBGP6stapyNAf7ctq0A",
    place: "Near Klaeng, Rayong",
    shortName: "Klaeng",
    countryCode: "TH",
    country: "Thailand",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "th-095",
    lat: 17.165914,
    lng: 104.102167,
    panoId: "TJVxjcn4_eurWs0o1V1S6w",
    place: "Near Sakon Nakhon, Sakon Nakhon",
    shortName: "Sakon Nakhon",
    countryCode: "TH",
    country: "Thailand",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "th-096",
    lat: 7.814686,
    lng: 98.392408,
    panoId: "bfJ4fJ0-WOkzE1yb8o49kQ",
    place: "Near Mueang Phuket, Phuket",
    shortName: "Mueang Phuket",
    countryCode: "TH",
    country: "Thailand",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "th-097",
    lat: 16.478648,
    lng: 103.545362,
    panoId: "SiSOCspJwkSOZZaizgIexQ",
    place: "Near Kalasin, Kalasin",
    shortName: "Kalasin",
    countryCode: "TH",
    country: "Thailand",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "th-098",
    lat: 13.687606,
    lng: 100.210233,
    panoId: "FfcVaR26UzjRlvh8nXylZw",
    place: "Near Sam Phran, Nakhon Pathom",
    shortName: "Sam Phran",
    countryCode: "TH",
    country: "Thailand",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "th-099",
    lat: 14.451985,
    lng: 100.209243,
    panoId: "zkX8rLAMhKwiMxH9P1ZpRQ",
    place: "Near Bang Pla Ma, Suphan Buri",
    shortName: "Bang Pla Ma",
    countryCode: "TH",
    country: "Thailand",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "th-100",
    lat: 14.192742,
    lng: 99.570706,
    panoId: "l7g3FEO9xpviL3uOpQCxTw",
    place: "Near Phanom Thuan, Kanchanaburi",
    shortName: "Phanom Thuan",
    countryCode: "TH",
    country: "Thailand",
    continent: "Asia",
    difficulty: "adventurer",
    pools: ["world","Asia","TH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "th-101",
    lat: 17.539762,
    lng: 100.270308,
    panoId: "9yJK-hl_K5G5miO9MnQ7Eg",
    place: "Near Thong Saen Khan, Uttaradit",
    shortName: "Thong Saen Khan",
    countryCode: "TH",
    country: "Thailand",
    continent: "Asia",
    difficulty: "adventurer",
    pools: ["world","Asia","TH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "th-102",
    lat: 12.758888,
    lng: 101.987997,
    panoId: "qJUXcMDip6PLZXo2K2h_Zg",
    place: "Near Khao Khitchakut, Chanthaburi",
    shortName: "Khao Khitchakut",
    countryCode: "TH",
    country: "Thailand",
    continent: "Asia",
    difficulty: "adventurer",
    pools: ["world","Asia","TH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "th-103",
    lat: 16.625197,
    lng: 102.857927,
    panoId: "nCPBiRapa6i1511IUXQ4dA",
    place: "Near Nam Phong, Khon Kaen",
    shortName: "Nam Phong",
    countryCode: "TH",
    country: "Thailand",
    continent: "Asia",
    difficulty: "adventurer",
    pools: ["world","Asia","TH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "th-104",
    lat: 7.661734,
    lng: 99.514449,
    panoId: "1CDKWfMgN0Fap4ExEuQwlw",
    place: "Near Wang Wiset, Trang",
    shortName: "Wang Wiset",
    countryCode: "TH",
    country: "Thailand",
    continent: "Asia",
    difficulty: "adventurer",
    pools: ["world","Asia","TH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "th-105",
    lat: 16.617554,
    lng: 99.436244,
    panoId: "Vj4SP02sQVqWeHDrzZbpEg",
    place: "Near Kosamphi Nakhon, Kamphaeng Phet",
    shortName: "Kosamphi Nakhon",
    countryCode: "TH",
    country: "Thailand",
    continent: "Asia",
    difficulty: "adventurer",
    pools: ["world","Asia","TH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "th-106",
    lat: 16.356801,
    lng: 103.21269,
    panoId: "tgiL_UbMG4eKGWVF_bGxcQ",
    place: "Near Kantharawichai, Maha Sarakham",
    shortName: "Kantharawichai",
    countryCode: "TH",
    country: "Thailand",
    continent: "Asia",
    difficulty: "adventurer",
    pools: ["world","Asia","TH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "sg-000",
    lat: 1.289825,
    lng: 103.849779,
    panoId: "ZUHmbiT_SgmiQk6uau12xQ",
    place: "Near Singapore, Singapore",
    shortName: "Singapore",
    countryCode: "SG",
    country: "Singapore",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","SG"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "sg-001",
    lat: 1.307481,
    lng: 103.859326,
    panoId: "BL2ErcJjw2AWgonsZvMarw",
    place: "Near Lavender, Singapore",
    shortName: "Lavender",
    countryCode: "SG",
    country: "Singapore",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","SG"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "sg-002",
    lat: 1.279477,
    lng: 103.864526,
    panoId: "Qwyu-9mXk45XvNf_81d20A",
    place: "Near Marina Bay, Singapore",
    shortName: "Marina Bay",
    countryCode: "SG",
    country: "Singapore",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","SG"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "my-000",
    lat: 1.393497,
    lng: 103.623165,
    panoId: "fC03T3Frny91_Br738ww6Q",
    place: "Near Iskandar Puteri, Johor",
    shortName: "Iskandar Puteri",
    countryCode: "MY",
    country: "Malaysia",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","MY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "my-001",
    lat: 3.149913,
    lng: 101.533316,
    panoId: "SFPrCwVlDWMqEpZEqL8zXQ",
    place: "Near Kampung Baru Subang, Selangor",
    shortName: "Kampung Baru Subang",
    countryCode: "MY",
    country: "Malaysia",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","MY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "my-002",
    lat: 2.195828,
    lng: 102.240615,
    panoId: "pE7KpJzEQtgHToWIP8I-og",
    place: "Near Malacca, Melaka",
    shortName: "Malacca",
    countryCode: "MY",
    country: "Malaysia",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","MY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "my-003",
    lat: 3.217256,
    lng: 101.560759,
    panoId: "-HrubbuREzplmdIqEt5y1A",
    place: "Near Bukit Rahman Putra, Selangor",
    shortName: "Bukit Rahman Putra",
    countryCode: "MY",
    country: "Malaysia",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","MY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "my-004",
    lat: 1.465647,
    lng: 103.757718,
    panoId: "w7AYWjI_2Q24kIj7Y36H_Q",
    place: "Near Johor Bahru, Johor",
    shortName: "Johor Bahru",
    countryCode: "MY",
    country: "Malaysia",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","MY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "my-005",
    lat: 6.123323,
    lng: 102.242776,
    panoId: "yJfeKHkGe7HZCc8LCwrOeA",
    place: "Near Kota Bharu, Kelantan",
    shortName: "Kota Bharu",
    countryCode: "MY",
    country: "Malaysia",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","MY"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "my-006",
    lat: 4.58409,
    lng: 101.082952,
    panoId: "8haDa965kBYDxsST5tPJog",
    place: "Near Ipoh, Perak",
    shortName: "Ipoh",
    countryCode: "MY",
    country: "Malaysia",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","MY"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "my-007",
    lat: 3.254915,
    lng: 101.666814,
    panoId: "6YefdoLVGr7J5pnnpfbrEw",
    place: "Near Selayang Baru Utara, Selangor",
    shortName: "Selayang Baru Utara",
    countryCode: "MY",
    country: "Malaysia",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","MY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "my-008",
    lat: 1.854759,
    lng: 102.93255,
    panoId: "klrAKsUd5PULr2gd3niRlA",
    place: "Near Batu Pahat, Johor",
    shortName: "Batu Pahat",
    countryCode: "MY",
    country: "Malaysia",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","MY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "my-009",
    lat: 6.050142,
    lng: 102.139749,
    panoId: "3JVfGBbKvJYfTDuqTvNMAg",
    place: "Near Pasir Mas, Kelantan",
    shortName: "Pasir Mas",
    countryCode: "MY",
    country: "Malaysia",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","MY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "my-010",
    lat: 4.399314,
    lng: 113.9916,
    panoId: "ghXgRT8_7llnCWSKvwHjQw",
    place: "Near Miri, Sarawak",
    shortName: "Miri",
    countryCode: "MY",
    country: "Malaysia",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","MY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "my-011",
    lat: 2.030736,
    lng: 103.316741,
    panoId: "D9lYx1sAhxYGX3gW7d0KRg",
    place: "Near Kluang, Johor",
    shortName: "Kluang",
    countryCode: "MY",
    country: "Malaysia",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","MY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "my-012",
    lat: 5.411473,
    lng: 100.335385,
    panoId: "3a6oBbLVkxB6FW3h5lZQgQ",
    place: "Near George Town, Penang",
    shortName: "George Town",
    countryCode: "MY",
    country: "Malaysia",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","MY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "my-013",
    lat: 2.7296,
    lng: 101.938101,
    panoId: "pfQIMkkBkJKEyfZBYzSkPw",
    place: "Near Seremban, Negeri Sembilan",
    shortName: "Seremban",
    countryCode: "MY",
    country: "Malaysia",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","MY"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "my-014",
    lat: 5.329968,
    lng: 103.140666,
    panoId: "YULPGPbg6O_P9ErLipHJHA",
    place: "Near Kuala Terengganu, Terengganu",
    shortName: "Kuala Terengganu",
    countryCode: "MY",
    country: "Malaysia",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","MY"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "my-015",
    lat: 4.849855,
    lng: 100.733878,
    panoId: "JmpIM5bgUPNWd4L0QTvQHg",
    place: "Near Taiping, Perak",
    shortName: "Taiping",
    countryCode: "MY",
    country: "Malaysia",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","MY"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "my-016",
    lat: 3.154557,
    lng: 101.580195,
    panoId: "JbNZOHWXNIrdsdUmV9UZBQ",
    place: "Near Kota Damansara, Selangor",
    shortName: "Kota Damansara",
    countryCode: "MY",
    country: "Malaysia",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","MY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "my-017",
    lat: 6.12096,
    lng: 100.360111,
    panoId: "GgBK_XiSy-QxzhyRYjDyGA",
    place: "Near Alor Setar, Kedah",
    shortName: "Alor Setar",
    countryCode: "MY",
    country: "Malaysia",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","MY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "my-018",
    lat: 5.646973,
    lng: 100.487229,
    panoId: "DRNAub-UIxY_o5GsPh2N9Q",
    place: "Near Sungai Petani, Kedah",
    shortName: "Sungai Petani",
    countryCode: "MY",
    country: "Malaysia",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","MY"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "my-019",
    lat: 1.502332,
    lng: 103.74392,
    panoId: "z8aDO7VDDdza1twDkF4dEA",
    place: "Near Kampung Larkin Lama, Johor",
    shortName: "Kampung Larkin Lama",
    countryCode: "MY",
    country: "Malaysia",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","MY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "my-020",
    lat: 5.840192,
    lng: 118.117931,
    panoId: "S5QTOyBvp4DTm2fnMZjLWQ",
    place: "Near Sandakan, Sabah",
    shortName: "Sandakan",
    countryCode: "MY",
    country: "Malaysia",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","MY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "my-021",
    lat: 3.807785,
    lng: 103.325942,
    panoId: "UQxOKMMM4mfWVmkt-mbKXg",
    place: "Near Kuantan, Pahang",
    shortName: "Kuantan",
    countryCode: "MY",
    country: "Malaysia",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","MY"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "my-022",
    lat: 1.462392,
    lng: 103.905416,
    panoId: "dGAM7I3ftcTwLA1XNzBajQ",
    place: "Near Pasir Gudang, Johor",
    shortName: "Pasir Gudang",
    countryCode: "MY",
    country: "Malaysia",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","MY"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "my-023",
    lat: 5.974864,
    lng: 116.07239,
    panoId: "KvKk-hrJxNYExImUvjdyiw",
    place: "Near Kota Kinabalu, Sabah",
    shortName: "Kota Kinabalu",
    countryCode: "MY",
    country: "Malaysia",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","MY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "my-024",
    lat: 4.244616,
    lng: 117.891173,
    panoId: "AQLmjx_WGxOoAeDnkT3j9w",
    place: "Near Tawau, Sabah",
    shortName: "Tawau",
    countryCode: "MY",
    country: "Malaysia",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","MY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "my-025",
    lat: 2.693088,
    lng: 101.749545,
    panoId: "4UWxGoynXmejHOvlDm-2IA",
    place: "Near Sepang, Selangor",
    shortName: "Sepang",
    countryCode: "MY",
    country: "Malaysia",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","MY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "my-026",
    lat: 3.084991,
    lng: 101.532859,
    panoId: "eqgDhHAF9VobJvnGVG_-dA",
    place: "Near Shah Alam, Selangor",
    shortName: "Shah Alam",
    countryCode: "MY",
    country: "Malaysia",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","MY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "my-027",
    lat: 1.549847,
    lng: 110.333502,
    panoId: "vjl1JxPPb7XEZoxUUzw_DA",
    place: "Near Kuching, Sarawak",
    shortName: "Kuching",
    countryCode: "MY",
    country: "Malaysia",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","MY"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "my-028",
    lat: 2.300031,
    lng: 111.817787,
    panoId: "mNlrAMvTEGXdqVxaO1UlUg",
    place: "Near Sibu, Sarawak",
    shortName: "Sibu",
    countryCode: "MY",
    country: "Malaysia",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","MY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "my-029",
    lat: 1.524341,
    lng: 103.823875,
    panoId: "EERlBHEnWtIyPNHwmkQtBQ",
    place: "Near Pelentong, Johor",
    shortName: "Pelentong",
    countryCode: "MY",
    country: "Malaysia",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","MY"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "my-030",
    lat: 4.022192,
    lng: 101.02082,
    panoId: "pXOtfqqpzIKNPBobu9K9Rg",
    place: "Near Teluk Intan, Perak",
    shortName: "Teluk Intan",
    countryCode: "MY",
    country: "Malaysia",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","MY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "my-031",
    lat: 3.107241,
    lng: 101.606673,
    panoId: "vPJcxBTyey1s9M_gfxOs4g",
    place: "Near Petaling Jaya, Selangor",
    shortName: "Petaling Jaya",
    countryCode: "MY",
    country: "Malaysia",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","MY"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "my-032",
    lat: 2.044354,
    lng: 102.569049,
    panoId: "CdTF_eoXBOgPPv86NjZmFQ",
    place: "Near Muar, Johor",
    shortName: "Muar",
    countryCode: "MY",
    country: "Malaysia",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","MY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "my-033",
    lat: 1.533197,
    lng: 103.666508,
    panoId: "FkA3KuqI9SVVoMzHi3jVcA",
    place: "Near Mukim Pulai, Johor",
    shortName: "Mukim Pulai",
    countryCode: "MY",
    country: "Malaysia",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","MY"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "my-034",
    lat: 3.165671,
    lng: 113.032354,
    panoId: "U1ZEPfjWcoqXomo8FoEl_Q",
    place: "Near Bintulu, Sarawak",
    shortName: "Bintulu",
    countryCode: "MY",
    country: "Malaysia",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","MY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "my-035",
    lat: 2.52443,
    lng: 101.79658,
    panoId: "vPC8aZpm4-n9us9h04aO9g",
    place: "Near Port Dickson, Negeri Sembilan",
    shortName: "Port Dickson",
    countryCode: "MY",
    country: "Malaysia",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","MY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "my-036",
    lat: 3.586482,
    lng: 102.77284,
    panoId: "fmltFt_AEhjPnNZiCT9vXQ",
    place: "Near Maran, Pahang",
    shortName: "Maran",
    countryCode: "MY",
    country: "Malaysia",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","MY"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "my-037",
    lat: 5.579781,
    lng: 100.353581,
    panoId: "luQ4RIPHTeOfHNNXMHWGFA",
    place: "Near Kampung Haji Kudong, Kedah",
    shortName: "Kampung Haji Kudong",
    countryCode: "MY",
    country: "Malaysia",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","MY"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "my-038",
    lat: 5.988629,
    lng: 116.076092,
    panoId: "RFwWCovDGn6bq14ta7fyBw",
    place: "Near Kota Kinabalu, Sabah",
    shortName: "Kota Kinabalu",
    countryCode: "MY",
    country: "Malaysia",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","MY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "my-039",
    lat: 4.217058,
    lng: 100.699432,
    panoId: "hjzCRtd8EUTAGuc2mF6yBQ",
    place: "Near Sitiawan, Perak",
    shortName: "Sitiawan",
    countryCode: "MY",
    country: "Malaysia",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","MY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "my-040",
    lat: 5.642513,
    lng: 100.495928,
    panoId: "wuFPMPSgbt2yT2g3YoGyCw",
    place: "Near Sungai Petani, Kedah",
    shortName: "Sungai Petani",
    countryCode: "MY",
    country: "Malaysia",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","MY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "my-041",
    lat: 3.269513,
    lng: 101.661034,
    panoId: "hGRz7fodECx9ExBrKTLlSQ",
    place: "Near Selayang Baru Utara, Selangor",
    shortName: "Selayang Baru Utara",
    countryCode: "MY",
    country: "Malaysia",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","MY"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "my-042",
    lat: 5.849922,
    lng: 118.103111,
    panoId: "OHEXUinLkqhQIhlwSANuBw",
    place: "Near Sandakan, Sabah",
    shortName: "Sandakan",
    countryCode: "MY",
    country: "Malaysia",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","MY"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "my-043",
    lat: 4.01869,
    lng: 101.039811,
    panoId: "znAhrK-U0whVO5Gknc2R-w",
    place: "Near Teluk Intan, Perak",
    shortName: "Teluk Intan",
    countryCode: "MY",
    country: "Malaysia",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","MY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "my-044",
    lat: 2.713948,
    lng: 101.94901,
    panoId: "kgnKu5fMxolsh-QLVMGFbA",
    place: "Near Taman Dusun Setia, Negeri Sembilan",
    shortName: "Taman Dusun Setia",
    countryCode: "MY",
    country: "Malaysia",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","MY"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "my-045",
    lat: 5.317088,
    lng: 103.138233,
    panoId: "VjL14lNYz07HfuH6ASLUeA",
    place: "Near Kuala Terengganu, Terengganu",
    shortName: "Kuala Terengganu",
    countryCode: "MY",
    country: "Malaysia",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","MY"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "my-046",
    lat: 1.566141,
    lng: 110.342779,
    panoId: "IXEp5VdsNHhvcmufi8majQ",
    place: "Near Kuching, Sarawak",
    shortName: "Kuching",
    countryCode: "MY",
    country: "Malaysia",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","MY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "my-047",
    lat: 1.517889,
    lng: 103.730505,
    panoId: "2gnI-pMyG1VCW1XAXVbepQ",
    place: "Near Kampung Larkin Lama, Johor",
    shortName: "Kampung Larkin Lama",
    countryCode: "MY",
    country: "Malaysia",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","MY"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "my-048",
    lat: 4.265867,
    lng: 117.896937,
    panoId: "S6tdAqWOg7o9ftPu2qDD0w",
    place: "Near Tawau, Sabah",
    shortName: "Tawau",
    countryCode: "MY",
    country: "Malaysia",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","MY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "my-049",
    lat: 3.133974,
    lng: 101.593679,
    panoId: "BmcRgWy8RO9CQf6LHxCq7g",
    place: "Near Tropicana Indah, Selangor",
    shortName: "Tropicana Indah",
    countryCode: "MY",
    country: "Malaysia",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","MY"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "my-050",
    lat: 1.438064,
    lng: 103.730615,
    panoId: "o8cxsL3UYVzMhhwcBj3xzQ",
    place: "Near Bukit Mandai Village, Malaysia",
    shortName: "Bukit Mandai Village",
    countryCode: "MY",
    country: "Malaysia",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","MY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "my-051",
    lat: 2.100788,
    lng: 102.572782,
    panoId: "0t40QmqsMN4KmGHEefKC9Q",
    place: "Near Bandar Sungai Mati, Johor",
    shortName: "Bandar Sungai Mati",
    countryCode: "MY",
    country: "Malaysia",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","MY"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "my-052",
    lat: 2.070895,
    lng: 103.342787,
    panoId: "vzaItvfgzItHLenyqnccpQ",
    place: "Near Kluang, Johor",
    shortName: "Kluang",
    countryCode: "MY",
    country: "Malaysia",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","MY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "my-053",
    lat: 1.485414,
    lng: 103.810237,
    panoId: "3gOToHjGrju5c8SSYU8S0Q",
    place: "Near Taman Permas Jaya, Johor",
    shortName: "Taman Permas Jaya",
    countryCode: "MY",
    country: "Malaysia",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","MY"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "my-054",
    lat: 1.364009,
    lng: 103.593004,
    panoId: "MEFP4N3PnCx8URQDGJ6ZlA",
    place: "Near Forest City, Johor",
    shortName: "Forest City",
    countryCode: "MY",
    country: "Malaysia",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","MY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "my-055",
    lat: 1.430742,
    lng: 103.711522,
    panoId: "EoIRa7eXfZTDrvcszCcaJw",
    place: "Near Bukit Mandai Village, Malaysia",
    shortName: "Bukit Mandai Village",
    countryCode: "MY",
    country: "Malaysia",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","MY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "my-056",
    lat: 1.51757,
    lng: 110.381018,
    panoId: "XH4m8K9A736KQDXn8RgDSw",
    place: "Near Kuching, Sarawak",
    shortName: "Kuching",
    countryCode: "MY",
    country: "Malaysia",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","MY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "my-057",
    lat: 5.646015,
    lng: 100.408575,
    panoId: "StPx2OItsCoDWK6ssww4lA",
    place: "Near Tikam Batu, Kedah",
    shortName: "Tikam Batu",
    countryCode: "MY",
    country: "Malaysia",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","MY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "my-058",
    lat: 4.347877,
    lng: 113.972645,
    panoId: "6zf1qRHz8iV8UOsxP0ykgQ",
    place: "Near Miri, Sarawak",
    shortName: "Miri",
    countryCode: "MY",
    country: "Malaysia",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","MY"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "my-059",
    lat: 5.300896,
    lng: 103.141038,
    panoId: "tYO2WIoBX7fuzNd5q0wa7A",
    place: "Near Kuala Terengganu, Terengganu",
    shortName: "Kuala Terengganu",
    countryCode: "MY",
    country: "Malaysia",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","MY"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "my-060",
    lat: 3.211786,
    lng: 101.518728,
    panoId: "n4wBpdEIeooQe97-1uys2Q",
    place: "Near Elmina, Selangor",
    shortName: "Elmina",
    countryCode: "MY",
    country: "Malaysia",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","MY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "my-061",
    lat: 4.601418,
    lng: 101.123241,
    panoId: "7q_VDja8E8FnRMo-aDPOpA",
    place: "Near Bercham, Perak",
    shortName: "Bercham",
    countryCode: "MY",
    country: "Malaysia",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","MY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "my-062",
    lat: 2.728709,
    lng: 101.986578,
    panoId: "dhd4HpRfAZgbnSKvbpCwjg",
    place: "Near Kampung Baharu Paroi, Negeri Sembilan",
    shortName: "Kampung Baharu Paroi",
    countryCode: "MY",
    country: "Malaysia",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","MY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "my-063",
    lat: 4.290911,
    lng: 117.897518,
    panoId: "Y1MWjRgUcUkw3k1Uqf9SVQ",
    place: "Near Tawau, Sabah",
    shortName: "Tawau",
    countryCode: "MY",
    country: "Malaysia",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","MY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "my-064",
    lat: 5.993828,
    lng: 116.11259,
    panoId: "vOyww6bYukG16MBikdCTUg",
    place: "Near Inanam, Sabah",
    shortName: "Inanam",
    countryCode: "MY",
    country: "Malaysia",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","MY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "my-065",
    lat: 2.713639,
    lng: 101.723242,
    panoId: "dfyEW731BvkMP2PIbZR1JQ",
    place: "Near Sepang, Selangor",
    shortName: "Sepang",
    countryCode: "MY",
    country: "Malaysia",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","MY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "my-066",
    lat: 4.813162,
    lng: 100.740748,
    panoId: "QH35K4ImuF97_1WRuK9RWg",
    place: "Near Taiping, Perak",
    shortName: "Taiping",
    countryCode: "MY",
    country: "Malaysia",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","MY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "my-067",
    lat: 3.988353,
    lng: 101.081082,
    panoId: "QGgz87t3tsBRyZR2c6ttXQ",
    place: "Near Cangkat Jong, Perak",
    shortName: "Cangkat Jong",
    countryCode: "MY",
    country: "Malaysia",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","MY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "my-068",
    lat: 2.587375,
    lng: 101.80647,
    panoId: "rl1NdA5KhK35bnZM-5BfMQ",
    place: "Near Lukut, Negeri Sembilan",
    shortName: "Lukut",
    countryCode: "MY",
    country: "Malaysia",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","MY"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "my-069",
    lat: 6.022282,
    lng: 102.142442,
    panoId: "q8XDcP67Gy4dmzzUwdXp6g",
    place: "Near Kampung Lemal, Kelantan",
    shortName: "Kampung Lemal",
    countryCode: "MY",
    country: "Malaysia",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","MY"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "my-070",
    lat: 3.192704,
    lng: 113.099863,
    panoId: "GO3bOqJzLIJIG8BeA4a4bA",
    place: "Near Bintulu, Sarawak",
    shortName: "Bintulu",
    countryCode: "MY",
    country: "Malaysia",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","MY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "my-071",
    lat: 5.067385,
    lng: 118.291474,
    panoId: "vKvEptxy2uCiFcd9qeNVRQ",
    place: "Near Lahad Datu, Sabah",
    shortName: "Lahad Datu",
    countryCode: "MY",
    country: "Malaysia",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","MY"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "my-072",
    lat: 3.108908,
    lng: 101.554283,
    panoId: "I4G1fsegiSkbqwvChNuhSQ",
    place: "Near Batu Tiga, Selangor",
    shortName: "Batu Tiga",
    countryCode: "MY",
    country: "Malaysia",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","MY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "my-073",
    lat: 1.386443,
    lng: 103.688307,
    panoId: "Um_gRmtvpSrT2lLEu5FqZA",
    place: "Near Bulim, Malaysia",
    shortName: "Bulim",
    countryCode: "MY",
    country: "Malaysia",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","MY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "my-074",
    lat: 2.730768,
    lng: 102.035971,
    panoId: "JfttVNFAGr3NyTobQ6E3Ww",
    place: "Near Kampung Baharu Paroi, Negeri Sembilan",
    shortName: "Kampung Baharu Paroi",
    countryCode: "MY",
    country: "Malaysia",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","MY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "my-075",
    lat: 5.398971,
    lng: 116.187874,
    panoId: "LaZzUWz7bWGHD_fsHYJr-w",
    place: "Near Keningau, Sabah",
    shortName: "Keningau",
    countryCode: "MY",
    country: "Malaysia",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","MY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "my-076",
    lat: 4.242338,
    lng: 100.75796,
    panoId: "MBYOjDuIsQC1t0_xGQYXCQ",
    place: "Near Ayer Tawar, Perak",
    shortName: "Ayer Tawar",
    countryCode: "MY",
    country: "Malaysia",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","MY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "my-077",
    lat: 3.839075,
    lng: 103.27438,
    panoId: "mFMsCuJBW9ixiel2W5m6cQ",
    place: "Near Kuantan, Pahang",
    shortName: "Kuantan",
    countryCode: "MY",
    country: "Malaysia",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","MY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "my-078",
    lat: 1.978984,
    lng: 103.051715,
    panoId: "XjMugXI54a-MMz6h6HreOw",
    place: "Near Kangkar Baru, Johor",
    shortName: "Kangkar Baru",
    countryCode: "MY",
    country: "Malaysia",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","MY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "my-079",
    lat: 4.244656,
    lng: 103.444439,
    panoId: "2MnnsXBDASxRjsWEJ4x0Gg",
    place: "Near Cukai, Terengganu",
    shortName: "Cukai",
    countryCode: "MY",
    country: "Malaysia",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","MY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "my-080",
    lat: 2.134847,
    lng: 102.658731,
    panoId: "T2dPvLHgqFesAvBw1kNxVQ",
    place: "Near Bukit Gambir, Johor",
    shortName: "Bukit Gambir",
    countryCode: "MY",
    country: "Malaysia",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","MY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "my-081",
    lat: 6.250069,
    lng: 100.454054,
    panoId: "Fb7uKPVK9_zdzvQxsxmdEw",
    place: "Near Kampong Wang Tepus, Kedah",
    shortName: "Kampong Wang Tepus",
    countryCode: "MY",
    country: "Malaysia",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","MY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "my-082",
    lat: 1.974937,
    lng: 103.333549,
    panoId: "l_NWvaWZ6671eQddb0uXDQ",
    place: "Near Kluang, Johor",
    shortName: "Kluang",
    countryCode: "MY",
    country: "Malaysia",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","MY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "my-083",
    lat: 3.46908,
    lng: 102.486594,
    panoId: "McdC_QC9u42jIA6Y1zmmoQ",
    place: "Near Temerluh, Pahang",
    shortName: "Temerluh",
    countryCode: "MY",
    country: "Malaysia",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","MY"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "my-084",
    lat: 5.318868,
    lng: 115.250372,
    panoId: "vzbzUm7Y6WkVQnLlgUsbNA",
    place: "Near Bandar Labuan, Sabah",
    shortName: "Bandar Labuan",
    countryCode: "MY",
    country: "Malaysia",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","MY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "my-085",
    lat: 5.360177,
    lng: 103.080363,
    panoId: "ZjQBmfTw_Z6dGrmQXh6nGA",
    place: "Near Kuala Nerus, Terengganu",
    shortName: "Kuala Nerus",
    countryCode: "MY",
    country: "Malaysia",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","MY"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "my-086",
    lat: 4.264118,
    lng: 100.665857,
    panoId: "PARYQTyLbF9pFn_oPBgFZw",
    place: "Near Lumut, Perak",
    shortName: "Lumut",
    countryCode: "MY",
    country: "Malaysia",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","MY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "my-087",
    lat: 2.185576,
    lng: 102.273629,
    panoId: "qc6VmgHBoR6OCu3BW3VXlw",
    place: "Near Ujong Pasir, Melaka",
    shortName: "Ujong Pasir",
    countryCode: "MY",
    country: "Malaysia",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","MY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "my-088",
    lat: 1.474568,
    lng: 103.610498,
    panoId: "dPTrK6uxkb7fbvuWZRFBrw",
    place: "Near Gelang Patah, Johor",
    shortName: "Gelang Patah",
    countryCode: "MY",
    country: "Malaysia",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","MY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "my-089",
    lat: 4.97028,
    lng: 100.67093,
    panoId: "OK-MdonMccIMYCv76oulrw",
    place: "Near Simpang Empat, Perak",
    shortName: "Simpang Empat",
    countryCode: "MY",
    country: "Malaysia",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","MY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "my-090",
    lat: 1.576049,
    lng: 103.5124,
    panoId: "68YeWxlV5S415QomNiTkFA",
    place: "Near Pekan Nenas, Johor",
    shortName: "Pekan Nenas",
    countryCode: "MY",
    country: "Malaysia",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","MY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "my-091",
    lat: 5.90402,
    lng: 117.983023,
    panoId: "mJBSh85EBMYBD20Cps84-w",
    place: "Near Taman Rajawali, Sabah",
    shortName: "Taman Rajawali",
    countryCode: "MY",
    country: "Malaysia",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","MY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "my-092",
    lat: 2.731763,
    lng: 102.311873,
    panoId: "jQxtDzX3IW6sg5IQIFHzyw",
    place: "Near Kuala Pilah, Negeri Sembilan",
    shortName: "Kuala Pilah",
    countryCode: "MY",
    country: "Malaysia",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","MY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "my-093",
    lat: 5.014176,
    lng: 118.231205,
    panoId: "ZQI2nnacI7JVbdMxCqZ_Ow",
    place: "Near Lahad Datu, Sabah",
    shortName: "Lahad Datu",
    countryCode: "MY",
    country: "Malaysia",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","MY"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "my-094",
    lat: 4.499047,
    lng: 118.538004,
    panoId: "hPfNOdmCrVb759-Veh8P7A",
    place: "Near Semporna, Sabah",
    shortName: "Semporna",
    countryCode: "MY",
    country: "Malaysia",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","MY"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "my-095",
    lat: 6.472244,
    lng: 100.347195,
    panoId: "g1EOUG14Dmj8vSZmWltpiQ",
    place: "Near Kampung Hutan Arau, Perlis",
    shortName: "Kampung Hutan Arau",
    countryCode: "MY",
    country: "Malaysia",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","MY"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "my-096",
    lat: 5.172266,
    lng: 100.674391,
    panoId: "vIOsz5A7XPjgo3jMijhyng",
    place: "Near Selama, Perak",
    shortName: "Selama",
    countryCode: "MY",
    country: "Malaysia",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","MY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "my-097",
    lat: 6.075876,
    lng: 100.500141,
    panoId: "t6jsreV7WcF3NW57UkaYPA",
    place: "Near Pendang, Kedah",
    shortName: "Pendang",
    countryCode: "MY",
    country: "Malaysia",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","MY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "my-098",
    lat: 3.526282,
    lng: 102.308905,
    panoId: "qTxKhH8vgB95IaRuSmt4VQ",
    place: "Near Mentakab, Pahang",
    shortName: "Mentakab",
    countryCode: "MY",
    country: "Malaysia",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","MY"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "my-099",
    lat: 1.310969,
    lng: 110.097504,
    panoId: "DlulQHZn1ryAKHpHEVA44A",
    place: "Near Bau, Sarawak",
    shortName: "Bau",
    countryCode: "MY",
    country: "Malaysia",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","MY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "my-100",
    lat: 2.076851,
    lng: 103.496055,
    panoId: "kvFYaCPqGhireuZqDxwIUw",
    place: "Near Kluang, Johor",
    shortName: "Kluang",
    countryCode: "MY",
    country: "Malaysia",
    continent: "Asia",
    difficulty: "adventurer",
    pools: ["world","Asia","MY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "my-101",
    lat: 0.971449,
    lng: 110.551748,
    panoId: "fUAJvGA_xnp_auubOmp1Lg",
    place: "Near Serian, Sarawak",
    shortName: "Serian",
    countryCode: "MY",
    country: "Malaysia",
    continent: "Asia",
    difficulty: "adventurer",
    pools: ["world","Asia","MY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "my-102",
    lat: 5.182847,
    lng: 116.186536,
    panoId: "Y3TJO7LMdZFN8gdzjBitHw",
    place: "Near Keningau, Sabah",
    shortName: "Keningau",
    countryCode: "MY",
    country: "Malaysia",
    continent: "Asia",
    difficulty: "adventurer",
    pools: ["world","Asia","MY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "my-103",
    lat: 3.742748,
    lng: 102.640741,
    panoId: "5gaokdz1-vNOZNn2p7oWxg",
    place: "Near Kampung Perak, Pahang",
    shortName: "Kampung Perak",
    countryCode: "MY",
    country: "Malaysia",
    continent: "Asia",
    difficulty: "adventurer",
    pools: ["world","Asia","MY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "my-104",
    lat: 1.316565,
    lng: 110.246644,
    panoId: "_13oSuxlDSyln3ApCgwI6g",
    place: "Near Bau, Sarawak",
    shortName: "Bau",
    countryCode: "MY",
    country: "Malaysia",
    continent: "Asia",
    difficulty: "adventurer",
    pools: ["world","Asia","MY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "my-105",
    lat: 2.886705,
    lng: 102.533883,
    panoId: "mxCTCFlvD9hfRf3QS139ZQ",
    place: "Near Kemajuan Tanah Tembangau, Pahang",
    shortName: "Kemajuan Tanah Tembangau",
    countryCode: "MY",
    country: "Malaysia",
    continent: "Asia",
    difficulty: "adventurer",
    pools: ["world","Asia","MY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "my-106",
    lat: 4.576504,
    lng: 115.062979,
    panoId: "MEnhL_cDROGmYJ7KY9VTjw",
    place: "Near Bangar, Temburong",
    shortName: "Bangar",
    countryCode: "MY",
    country: "Malaysia",
    continent: "Asia",
    difficulty: "adventurer",
    pools: ["world","Asia","MY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "my-107",
    lat: 3.662296,
    lng: 102.413119,
    panoId: "KuTJIGyBMzthXstD7wI9gQ",
    place: "Near Mentakab, Pahang",
    shortName: "Mentakab",
    countryCode: "MY",
    country: "Malaysia",
    continent: "Asia",
    difficulty: "adventurer",
    pools: ["world","Asia","MY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "my-108",
    lat: 5.31169,
    lng: 116.014518,
    panoId: "lTvAF9crPBwforWppnmj9Q",
    place: "Near Keningau, Sabah",
    shortName: "Keningau",
    countryCode: "MY",
    country: "Malaysia",
    continent: "Asia",
    difficulty: "adventurer",
    pools: ["world","Asia","MY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "my-109",
    lat: 4.497887,
    lng: 118.421413,
    panoId: "2Hk9RYMFyhjOZKy10bwVeA",
    place: "Near Semporna, Sabah",
    shortName: "Semporna",
    countryCode: "MY",
    country: "Malaysia",
    continent: "Asia",
    difficulty: "adventurer",
    pools: ["world","Asia","MY"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "id-000",
    lat: -0.949003,
    lng: 100.35419,
    panoId: "h9gYqxBDONiyQIjJDah9MA",
    place: "Near Padang, West Sumatra",
    shortName: "Padang",
    countryCode: "ID",
    country: "Indonesia",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "id-001",
    lat: -7.248944,
    lng: 112.750824,
    panoId: "YPonoFSnxnFu4GpblZRWyQ",
    place: "Near Surabaya, East Java",
    shortName: "Surabaya",
    countryCode: "ID",
    country: "Indonesia",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "id-002",
    lat: -0.908147,
    lng: 119.870835,
    panoId: "9ZP1_Y6QM9FJ_OF-vStl6g",
    place: "Near Palu, Central Sulawesi",
    shortName: "Palu",
    countryCode: "ID",
    country: "Indonesia",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "id-003",
    lat: -6.594566,
    lng: 106.789806,
    panoId: "yLCtSTkv1aZaRQ0uNAbfOw",
    place: "Near Bogor, West Java",
    shortName: "Bogor",
    countryCode: "ID",
    country: "Indonesia",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "id-004",
    lat: -3.31968,
    lng: 114.590404,
    panoId: "O5CnYz4ZhPmnWWb8kLmtRw",
    place: "Near Banjarmasin, South Kalimantan",
    shortName: "Banjarmasin",
    countryCode: "ID",
    country: "Indonesia",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "id-005",
    lat: -6.922322,
    lng: 107.606891,
    panoId: "cJC0hNhIQjv3Bb_L-rg1dg",
    place: "Near Bandung, West Java",
    shortName: "Bandung",
    countryCode: "ID",
    country: "Indonesia",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "id-006",
    lat: 0.516506,
    lng: 101.441668,
    panoId: "xn0hvl1SVQkCYBV2O5mfUw",
    place: "Near Pekanbaru, Riau",
    shortName: "Pekanbaru",
    countryCode: "ID",
    country: "Indonesia",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "id-007",
    lat: -5.14849,
    lng: 119.431943,
    panoId: "IYNRfj6JjwbxU407JcxCSQ",
    place: "Near Makassar, South Sulawesi",
    shortName: "Makassar",
    countryCode: "ID",
    country: "Indonesia",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "id-008",
    lat: -6.214629,
    lng: 106.84512,
    panoId: "24OcORTvR3GXQiinGGX1BA",
    place: "Near Jakarta, Jakarta",
    shortName: "Jakarta",
    countryCode: "ID",
    country: "Indonesia",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","ID"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "id-009",
    lat: -8.649864,
    lng: 115.215969,
    panoId: "at1lBCm1nQTt4DAMvSTHXw",
    place: "Near Denpasar, Bali",
    shortName: "Denpasar",
    countryCode: "ID",
    country: "Indonesia",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "id-010",
    lat: 3.583398,
    lng: 98.666927,
    panoId: "sGuvc5rTw3AW2KFqTgj5lQ",
    place: "Near Medan, North Sumatra",
    shortName: "Medan",
    countryCode: "ID",
    country: "Indonesia",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "id-011",
    lat: -0.491841,
    lng: 117.145909,
    panoId: "C86--0j5HRx7l6aG7kXxqg",
    place: "Near Samarinda, East Kalimantan",
    shortName: "Samarinda",
    countryCode: "ID",
    country: "Indonesia",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","ID"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "id-012",
    lat: -7.97991,
    lng: 112.630122,
    panoId: "M6XQruo37V87va9KgLAlqA",
    place: "Near Malang, East Java",
    shortName: "Malang",
    countryCode: "ID",
    country: "Indonesia",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "id-013",
    lat: -7.327653,
    lng: 108.220678,
    panoId: "3_F0YnPnGPgjt7Gf5tmtZA",
    place: "Near Tasikmalaya, West Java",
    shortName: "Tasikmalaya",
    countryCode: "ID",
    country: "Indonesia",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "id-014",
    lat: -8.583431,
    lng: 116.116756,
    panoId: "BgM3Yv6FwxIUq_esMZNv3w",
    place: "Near Mataram, West Nusa Tenggara",
    shortName: "Mataram",
    countryCode: "ID",
    country: "Indonesia",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "id-015",
    lat: -7.555828,
    lng: 110.831753,
    panoId: "6u-LOwP61AcZCT53arbXGQ",
    place: "Near Surakarta, Central Java",
    shortName: "Surakarta",
    countryCode: "ID",
    country: "Indonesia",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "id-016",
    lat: 1.149038,
    lng: 104.025014,
    panoId: "vBcmyl0D14MaC_r_D3P2bw",
    place: "Near Batam, Riau",
    shortName: "Batam",
    countryCode: "ID",
    country: "Indonesia",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "id-017",
    lat: -6.872088,
    lng: 107.542328,
    panoId: "TInkZUwRRiibfRYk8T4KrQ",
    place: "Near Cimahi, West Java",
    shortName: "Cimahi",
    countryCode: "ID",
    country: "Indonesia",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "id-018",
    lat: -2.916727,
    lng: 104.745122,
    panoId: "ssG54JKvqhtkx63XftCjMg",
    place: "Near Palembang, South Sumatra",
    shortName: "Palembang",
    countryCode: "ID",
    country: "Indonesia",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "id-019",
    lat: -1.267079,
    lng: 116.829695,
    panoId: "-oefOlwxe5vXMAmgz7Mzdg",
    place: "Near Balikpapan, East Kalimantan",
    shortName: "Balikpapan",
    countryCode: "ID",
    country: "Indonesia",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "id-020",
    lat: -6.178018,
    lng: 106.630127,
    panoId: "R4BO-meDrn84G8AL-CT75A",
    place: "Near Tangerang, Banten",
    shortName: "Tangerang",
    countryCode: "ID",
    country: "Indonesia",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "id-021",
    lat: -7.706227,
    lng: 114.00977,
    panoId: "TcWVwcSAKYp_wylJdDT9-Q",
    place: "Near Situbondo, East Java",
    shortName: "Situbondo",
    countryCode: "ID",
    country: "Indonesia",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "id-022",
    lat: 1.482189,
    lng: 124.849079,
    panoId: "AJdsVI6pyV-7syVbTBxY6Q",
    place: "Near Manado, North Sulawesi",
    shortName: "Manado",
    countryCode: "ID",
    country: "Indonesia",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "id-023",
    lat: -6.234681,
    lng: 106.989068,
    panoId: "Hh4OBqEeAySDbr24wn4MIQ",
    place: "Near Bekasi, West Java",
    shortName: "Bekasi",
    countryCode: "ID",
    country: "Indonesia",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "id-024",
    lat: -1.599997,
    lng: 103.616723,
    panoId: "mNaAsDUN33sHUBlKS_ykDw",
    place: "Near Jambi City, Jambi",
    shortName: "Jambi City",
    countryCode: "ID",
    country: "Indonesia",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "id-025",
    lat: -0.032173,
    lng: 109.324616,
    panoId: "vRO31p7UrvNM8anhssIevQ",
    place: "Near Pontianak, West Kalimantan",
    shortName: "Pontianak",
    countryCode: "ID",
    country: "Indonesia",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "id-026",
    lat: -5.429047,
    lng: 105.261241,
    panoId: "G6s59WsHUWBmRLStzUPQyg",
    place: "Near Bandar Lampung, Lampung",
    shortName: "Bandar Lampung",
    countryCode: "ID",
    country: "Indonesia",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "id-027",
    lat: -6.992927,
    lng: 110.420914,
    panoId: "E6BTSvXwmTBA2Y3AB96lVw",
    place: "Near Semarang, Central Java",
    shortName: "Semarang",
    countryCode: "ID",
    country: "Indonesia",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "id-028",
    lat: -6.115855,
    lng: 106.15459,
    panoId: "S3LlmE11cKdo1xwpy6Zevw",
    place: "Near Serang, Banten",
    shortName: "Serang",
    countryCode: "ID",
    country: "Indonesia",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "id-029",
    lat: -6.592394,
    lng: 110.670992,
    panoId: "Q4vPeEsmB5hN2wclcxmzhg",
    place: "Near Jepara, Central Java",
    shortName: "Jepara",
    countryCode: "ID",
    country: "Indonesia",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","ID"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "id-030",
    lat: -10.170891,
    lng: 123.607012,
    panoId: "P6tKDIvEusycV4-GnK1N6w",
    place: "Near Kupang, East Nusa Tenggara",
    shortName: "Kupang",
    countryCode: "ID",
    country: "Indonesia",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "id-031",
    lat: -6.399751,
    lng: 106.818592,
    panoId: "qogLwtjfRNZwsstWgWGyIQ",
    place: "Near Depok, West Java",
    shortName: "Depok",
    countryCode: "ID",
    country: "Indonesia",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "id-032",
    lat: -7.801336,
    lng: 110.364726,
    panoId: "UzfMSTNuBXkEgsO1ZGVlwA",
    place: "Near Yogyakarta, Yogyakarta",
    shortName: "Yogyakarta",
    countryCode: "ID",
    country: "Indonesia",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "id-033",
    lat: -3.800271,
    lng: 102.26573,
    panoId: "HEN0Ytv63NHklEYD7i7ZHQ",
    place: "Near Bengkulu, Bengkulu",
    shortName: "Bengkulu",
    countryCode: "ID",
    country: "Indonesia",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "id-034",
    lat: -6.481813,
    lng: 106.854856,
    panoId: "XGMejCot1gj-71Bsa0Yeug",
    place: "Near Cibinong, West Java",
    shortName: "Cibinong",
    countryCode: "ID",
    country: "Indonesia",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "id-035",
    lat: -3.978305,
    lng: 122.51456,
    panoId: "XhpH8HV6CYKrqTZBTiTI9w",
    place: "Near Kendari, Southeast Sulawesi",
    shortName: "Kendari",
    countryCode: "ID",
    country: "Indonesia",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "id-036",
    lat: -3.811969,
    lng: 102.266979,
    panoId: "ysSahYAEIuNvQd94NDQOOg",
    place: "Near Bengkulu, Bengkulu",
    shortName: "Bengkulu",
    countryCode: "ID",
    country: "Indonesia",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "id-037",
    lat: -8.591282,
    lng: 116.109179,
    panoId: "ARNwTpEsdLweFwAFZeEXog",
    place: "Near Mataram, West Nusa Tenggara",
    shortName: "Mataram",
    countryCode: "ID",
    country: "Indonesia",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "id-038",
    lat: -6.706568,
    lng: 108.556484,
    panoId: "0zJxdqBBxvpi0WZ-LHQXLw",
    place: "Near Cirebon, West Java",
    shortName: "Cirebon",
    countryCode: "ID",
    country: "Indonesia",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "id-039",
    lat: -7.694276,
    lng: 114.02784,
    panoId: "jaMDgIGrhElBgWQoHiqowA",
    place: "Near Situbondo, East Java",
    shortName: "Situbondo",
    countryCode: "ID",
    country: "Indonesia",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "id-040",
    lat: -7.570787,
    lng: 110.839836,
    panoId: "TOR_N1U3V-7PDNU_jolXyQ",
    place: "Near Surakarta, Central Java",
    shortName: "Surakarta",
    countryCode: "ID",
    country: "Indonesia",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "id-041",
    lat: -7.981148,
    lng: 112.616921,
    panoId: "B_UTApYPF5bup4SFuCFIKA",
    place: "Near Malang, East Java",
    shortName: "Malang",
    countryCode: "ID",
    country: "Indonesia",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "id-042",
    lat: 3.568086,
    lng: 98.670355,
    panoId: "9uVcqpdthnvRNZCLOrwKpA",
    place: "Near Medan, North Sumatra",
    shortName: "Medan",
    countryCode: "ID",
    country: "Indonesia",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "id-043",
    lat: -1.270783,
    lng: 116.849162,
    panoId: "xefIxg_rIzqpDyIbWLkt7A",
    place: "Near Balikpapan, East Kalimantan",
    shortName: "Balikpapan",
    countryCode: "ID",
    country: "Indonesia",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "id-044",
    lat: -7.005887,
    lng: 110.429546,
    panoId: "aEJlIGZilmW4_eeKhZ4JaA",
    place: "Near Semarang, Central Java",
    shortName: "Semarang",
    countryCode: "ID",
    country: "Indonesia",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "id-045",
    lat: -6.924908,
    lng: 107.620476,
    panoId: "6nl_TeEJ8P14oFioHaItKQ",
    place: "Near Bandung, West Java",
    shortName: "Bandung",
    countryCode: "ID",
    country: "Indonesia",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "id-046",
    lat: -6.225408,
    lng: 107.008192,
    panoId: "ouGC0NSqbAmgVAx_mCHqoA",
    place: "Near Bekasi, West Java",
    shortName: "Bekasi",
    countryCode: "ID",
    country: "Indonesia",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "id-047",
    lat: -6.127988,
    lng: 106.13519,
    panoId: "2ebr9Fl49NKDatZkDifnJA",
    place: "Near Serang, Banten",
    shortName: "Serang",
    countryCode: "ID",
    country: "Indonesia",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "id-048",
    lat: -6.585972,
    lng: 110.65361,
    panoId: "XtiPv4LqdKLho8zGibF3HA",
    place: "Near Jepara, Central Java",
    shortName: "Jepara",
    countryCode: "ID",
    country: "Indonesia",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "id-049",
    lat: -0.0189,
    lng: 109.342769,
    panoId: "nAk3d82zy7LnrINAudiSJQ",
    place: "Near Pontianak, West Kalimantan",
    shortName: "Pontianak",
    countryCode: "ID",
    country: "Indonesia",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","ID"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "id-050",
    lat: -6.2241,
    lng: 106.961539,
    panoId: "sUaLv9dt6FTtujlqklcuow",
    place: "Near Bekasi, West Java",
    shortName: "Bekasi",
    countryCode: "ID",
    country: "Indonesia",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "id-051",
    lat: -6.300263,
    lng: 106.759216,
    panoId: "DgeA20NzKxp5Tdv_PbbBuw",
    place: "Near South Tangerang, Banten",
    shortName: "South Tangerang",
    countryCode: "ID",
    country: "Indonesia",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","ID"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "id-052",
    lat: -6.653113,
    lng: 106.799929,
    panoId: "HvnXA38Qs8LHF0p35IGyQA",
    place: "Near Caringin, West Java",
    shortName: "Caringin",
    countryCode: "ID",
    country: "Indonesia",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "id-053",
    lat: -0.904168,
    lng: 100.365386,
    panoId: "D97ZY6b4q9zgfDwOvyiZvw",
    place: "Near Tabing, West Sumatra",
    shortName: "Tabing",
    countryCode: "ID",
    country: "Indonesia",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "id-054",
    lat: -6.369457,
    lng: 106.783781,
    panoId: "mzTCf8T0V_LktfZ2Y1wOiQ",
    place: "Near Sawangan, West Java",
    shortName: "Sawangan",
    countryCode: "ID",
    country: "Indonesia",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "id-055",
    lat: -2.8973,
    lng: 104.799252,
    panoId: "IBKjFWYqsXi4tbx9bFVcWQ",
    place: "Near Palembang, South Sumatra",
    shortName: "Palembang",
    countryCode: "ID",
    country: "Indonesia",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "id-056",
    lat: -6.516465,
    lng: 106.893246,
    panoId: "3Y5kYHbmXKcZyPcuxtiJnw",
    place: "Near Citeureup, West Java",
    shortName: "Citeureup",
    countryCode: "ID",
    country: "Indonesia",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "id-057",
    lat: -3.830254,
    lng: 102.314642,
    panoId: "OYwPCHuodwq0HCl_tQzZrA",
    place: "Near Bengkulu, Bengkulu",
    shortName: "Bengkulu",
    countryCode: "ID",
    country: "Indonesia",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "id-058",
    lat: -7.355086,
    lng: 108.158364,
    panoId: "fQqgfZTqFyUnM6z7EtXLUw",
    place: "Near Singaparna, West Java",
    shortName: "Singaparna",
    countryCode: "ID",
    country: "Indonesia",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "id-059",
    lat: -7.721824,
    lng: 114.041413,
    panoId: "O-gQN2dxPLUdPsD1NQ8W0g",
    place: "Near Situbondo, East Java",
    shortName: "Situbondo",
    countryCode: "ID",
    country: "Indonesia",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "id-060",
    lat: -0.867315,
    lng: 119.906542,
    panoId: "m7fjFFppubxb54-6krYrKA",
    place: "Near Palu, Central Sulawesi",
    shortName: "Palu",
    countryCode: "ID",
    country: "Indonesia",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "id-061",
    lat: -7.753154,
    lng: 110.320531,
    panoId: "GqCoJkY2-OqZwW0o6Xui2Q",
    place: "Near Godean, Yogyakarta",
    shortName: "Godean",
    countryCode: "ID",
    country: "Indonesia",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "id-062",
    lat: -8.610084,
    lng: 116.122081,
    panoId: "isnV0RiSbImHzaSw---Ndg",
    place: "Near Mataram, West Nusa Tenggara",
    shortName: "Mataram",
    countryCode: "ID",
    country: "Indonesia",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "id-063",
    lat: -5.149517,
    lng: 119.393725,
    panoId: "Co4qJjIHJokUpfwzcNn6mQ",
    place: "Near Makassar, South Sulawesi",
    shortName: "Makassar",
    countryCode: "ID",
    country: "Indonesia",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "id-064",
    lat: 1.732682,
    lng: 101.465454,
    panoId: "Z_ct4tZPc1YILrd7pJlb_A",
    place: "Near Batu Panjang, Riau",
    shortName: "Batu Panjang",
    countryCode: "ID",
    country: "Indonesia",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "id-065",
    lat: 1.165599,
    lng: 104.095377,
    panoId: "GVdRBXLhGNcYlwkdc8zclg",
    place: "Near Batam, Riau",
    shortName: "Batam",
    countryCode: "ID",
    country: "Indonesia",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "id-066",
    lat: -7.979367,
    lng: 112.564564,
    panoId: "hdvjWKAHUIiMyRDU7DBvTA",
    place: "Near Malang, East Java",
    shortName: "Malang",
    countryCode: "ID",
    country: "Indonesia",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "id-067",
    lat: -6.154395,
    lng: 106.198272,
    panoId: "OvfJuWYTKMmHc7infn315A",
    place: "Near Ciruas, Banten",
    shortName: "Ciruas",
    countryCode: "ID",
    country: "Indonesia",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "id-068",
    lat: -6.559274,
    lng: 110.72754,
    panoId: "bZrhYe5ZPpGyzlwNrOCKbQ",
    place: "Near Mlonggo, Central Java",
    shortName: "Mlonggo",
    countryCode: "ID",
    country: "Indonesia",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "id-069",
    lat: -3.373609,
    lng: 114.547116,
    panoId: "oHqOx1OpTq12WI-1tz8LNw",
    place: "Near Banjarmasin, South Kalimantan",
    shortName: "Banjarmasin",
    countryCode: "ID",
    country: "Indonesia",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "id-070",
    lat: -5.373336,
    lng: 105.271195,
    panoId: "pffEdJej_PT55wlkjG-Ghw",
    place: "Near Kedaton, Lampung",
    shortName: "Kedaton",
    countryCode: "ID",
    country: "Indonesia",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "id-071",
    lat: -6.634949,
    lng: 106.775413,
    panoId: "gAaogconOxGiYaFHn3zbsw",
    place: "Near Bogor, West Java",
    shortName: "Bogor",
    countryCode: "ID",
    country: "Indonesia",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "id-072",
    lat: -6.255752,
    lng: 106.828921,
    panoId: "sA1QB5uxmPn_F9rnhAZhWg",
    place: "Near Jakarta, Jakarta",
    shortName: "Jakarta",
    countryCode: "ID",
    country: "Indonesia",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "id-073",
    lat: -1.225331,
    lng: 116.853831,
    panoId: "wCgm746IraLwSz0D_4FcHA",
    place: "Near Balikpapan, East Kalimantan",
    shortName: "Balikpapan",
    countryCode: "ID",
    country: "Indonesia",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "id-074",
    lat: 1.452131,
    lng: 124.792547,
    panoId: "XyERW6s3nG2wm4AcpmbQ9w",
    place: "Near Pineleng, North Sulawesi",
    shortName: "Pineleng",
    countryCode: "ID",
    country: "Indonesia",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "id-075",
    lat: -6.274108,
    lng: 106.766373,
    panoId: "pnKNkWJY7zxw54VTTaPmeA",
    place: "Near South Tangerang, Banten",
    shortName: "South Tangerang",
    countryCode: "ID",
    country: "Indonesia",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","ID"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "id-076",
    lat: -0.459882,
    lng: 117.205433,
    panoId: "f4oL-3VRwqaxw8f_ghUATg",
    place: "Near Samarinda, East Kalimantan",
    shortName: "Samarinda",
    countryCode: "ID",
    country: "Indonesia",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "id-077",
    lat: -1.540958,
    lng: 103.622079,
    panoId: "tU_6X6BaPd1seXlwkh7MeQ",
    place: "Near Sekernan, Jambi",
    shortName: "Sekernan",
    countryCode: "ID",
    country: "Indonesia",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "id-078",
    lat: -6.395461,
    lng: 106.888634,
    panoId: "0ZB1okCx_BgMpAeyJHG_4A",
    place: "Near Depok, West Java",
    shortName: "Depok",
    countryCode: "ID",
    country: "Indonesia",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "id-079",
    lat: 3.642794,
    lng: 98.626824,
    panoId: "Qg4TZoOvVVtdyFHiBU9Org",
    place: "Near Sunggal, North Sumatra",
    shortName: "Sunggal",
    countryCode: "ID",
    country: "Indonesia",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "id-080",
    lat: -10.155945,
    lng: 123.638272,
    panoId: "JkO24bZOo5GOiQVVCWwkUQ",
    place: "Near Kelapalima, East Nusa Tenggara",
    shortName: "Kelapalima",
    countryCode: "ID",
    country: "Indonesia",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "id-081",
    lat: -6.865506,
    lng: 107.497689,
    panoId: "KMprIJBVq9yxQPKYmVNWxA",
    place: "Near Padalarang, West Java",
    shortName: "Padalarang",
    countryCode: "ID",
    country: "Indonesia",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "id-082",
    lat: 0.471365,
    lng: 101.488751,
    panoId: "t3df4fPxEB6QCRshASFKVQ",
    place: "Near Pekanbaru, Riau",
    shortName: "Pekanbaru",
    countryCode: "ID",
    country: "Indonesia",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "id-083",
    lat: -6.911185,
    lng: 109.691365,
    panoId: "m5asqOX53DmpFfEhMo4XgA",
    place: "Near Pekalongan, Central Java",
    shortName: "Pekalongan",
    countryCode: "ID",
    country: "Indonesia",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "id-084",
    lat: -3.934819,
    lng: 122.484528,
    panoId: "UVk9d92rf5PXJ1_yYiOkdw",
    place: "Near Kendari, Southeast Sulawesi",
    shortName: "Kendari",
    countryCode: "ID",
    country: "Indonesia",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "id-085",
    lat: -6.90335,
    lng: 107.657367,
    panoId: "E4rQMZZgi7GvdAs5CI5xMA",
    place: "Near Bandung, West Java",
    shortName: "Bandung",
    countryCode: "ID",
    country: "Indonesia",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "id-086",
    lat: -7.258687,
    lng: 112.695786,
    panoId: "i-1qjCCMUPkuKjRbhTvtFQ",
    place: "Near Surabaya, East Java",
    shortName: "Surabaya",
    countryCode: "ID",
    country: "Indonesia",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "id-087",
    lat: -2.941371,
    lng: 104.717826,
    panoId: "e-8OxEE60nXz6M7Hbh1a7g",
    place: "Near Palembang, South Sumatra",
    shortName: "Palembang",
    countryCode: "ID",
    country: "Indonesia",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "id-088",
    lat: -2.239644,
    lng: 113.976587,
    panoId: "2J00YMR8qBuQ1uOIvrvcTg",
    place: "Near Palangkaraya, Central Kalimantan",
    shortName: "Palangkaraya",
    countryCode: "ID",
    country: "Indonesia",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "id-089",
    lat: -0.943965,
    lng: 100.407746,
    panoId: "mYl0uB3O5qyEyM98Y-19lw",
    place: "Near Lubukbergalung, West Sumatra",
    shortName: "Lubukbergalung",
    countryCode: "ID",
    country: "Indonesia",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "id-090",
    lat: -6.846987,
    lng: 109.089165,
    panoId: "dHJzanF9qGCZNCZXoBB7yg",
    place: "Near Dukuhturi, Central Java",
    shortName: "Dukuhturi",
    countryCode: "ID",
    country: "Indonesia",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "id-091",
    lat: 0.914224,
    lng: 109.027996,
    panoId: "gGbwZicUV7xlf19xpbhDNA",
    place: "Near Singkawang, West Kalimantan",
    shortName: "Singkawang",
    countryCode: "ID",
    country: "Indonesia",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "id-092",
    lat: -7.683737,
    lng: 109.010765,
    panoId: "LnPFMZ5B0ktoNdzkezQUfw",
    place: "Near Rejanegara, Central Java",
    shortName: "Rejanegara",
    countryCode: "ID",
    country: "Indonesia",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "id-093",
    lat: -3.274792,
    lng: 114.564394,
    panoId: "mtHb5er4PmO9XYdgfxUW6w",
    place: "Near Banjarmasin, South Kalimantan",
    shortName: "Banjarmasin",
    countryCode: "ID",
    country: "Indonesia",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "id-094",
    lat: -7.874092,
    lng: 111.975185,
    panoId: "cf48tEKaSZuLtnevmhPKcw",
    place: "Near Kediri, East Java",
    shortName: "Kediri",
    countryCode: "ID",
    country: "Indonesia",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "id-095",
    lat: -0.975349,
    lng: 119.856642,
    panoId: "oTAUpHGVioYy5pcBY_-hBA",
    place: "Near Sigi Biromaru, Central Sulawesi",
    shortName: "Sigi Biromaru",
    countryCode: "ID",
    country: "Indonesia",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "id-096",
    lat: -7.371254,
    lng: 109.254436,
    panoId: "V1o5vEVLwv1tnSVCWKzJmg",
    place: "Near Purwokerto, Central Java",
    shortName: "Purwokerto",
    countryCode: "ID",
    country: "Indonesia",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "id-097",
    lat: -6.24029,
    lng: 106.66647,
    panoId: "Yz-I_f4YvCCv6lg80IvDAQ",
    place: "Near Ciputat, West Java",
    shortName: "Ciputat",
    countryCode: "ID",
    country: "Indonesia",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "id-098",
    lat: -8.213853,
    lng: 113.715853,
    panoId: "ebK4CRNf0tnXrilTQLNuVQ",
    place: "Near Kloncing, East Java",
    shortName: "Kloncing",
    countryCode: "ID",
    country: "Indonesia",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "id-099",
    lat: -7.49049,
    lng: 108.238165,
    panoId: "8VxitpJguH0RpzIf-9nDfw",
    place: "Near Salopa, West Java",
    shortName: "Salopa",
    countryCode: "ID",
    country: "Indonesia",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "id-100",
    lat: -3.334711,
    lng: 103.053183,
    panoId: "7th1F53X1CJzcFYwPzymwQ",
    place: "Near Muara Beliti, South Sumatra",
    shortName: "Muara Beliti",
    countryCode: "ID",
    country: "Indonesia",
    continent: "Asia",
    difficulty: "adventurer",
    pools: ["world","Asia","ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "id-101",
    lat: 1.590936,
    lng: 125.152468,
    panoId: "SGSEShngRnFNV550aHN5jg",
    place: "Near Likupang, North Sulawesi",
    shortName: "Likupang",
    countryCode: "ID",
    country: "Indonesia",
    continent: "Asia",
    difficulty: "adventurer",
    pools: ["world","Asia","ID"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "id-102",
    lat: -8.637644,
    lng: 119.812267,
    panoId: "KBhYAdB5eqBkM0FttoO7rg",
    place: "Near Labuan Bajo, East Nusa Tenggara",
    shortName: "Labuan Bajo",
    countryCode: "ID",
    country: "Indonesia",
    continent: "Asia",
    difficulty: "adventurer",
    pools: ["world","Asia","ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "id-103",
    lat: -7.059275,
    lng: 109.768152,
    panoId: "WLEkRfSjy7tFFxKPGFUH4g",
    place: "Near Kedungwuni, Central Java",
    shortName: "Kedungwuni",
    countryCode: "ID",
    country: "Indonesia",
    continent: "Asia",
    difficulty: "adventurer",
    pools: ["world","Asia","ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "id-104",
    lat: 1.522114,
    lng: 101.406315,
    panoId: "9kH38X4LQQsAVb6HtjOLSg",
    place: "Near Dumai, Riau",
    shortName: "Dumai",
    countryCode: "ID",
    country: "Indonesia",
    continent: "Asia",
    difficulty: "adventurer",
    pools: ["world","Asia","ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "id-105",
    lat: 0.667225,
    lng: 122.972017,
    panoId: "T4fgkrWsSJL5b1-6kqRgQA",
    place: "Near Limboto, Gorontalo",
    shortName: "Limboto",
    countryCode: "ID",
    country: "Indonesia",
    continent: "Asia",
    difficulty: "adventurer",
    pools: ["world","Asia","ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "id-106",
    lat: 0.980491,
    lng: 104.577417,
    panoId: "RLGIvx7ah5IEbYkcedXn5g",
    place: "Near Bandar Seri Bentan, Riau Islands",
    shortName: "Bandar Seri Bentan",
    countryCode: "ID",
    country: "Indonesia",
    continent: "Asia",
    difficulty: "adventurer",
    pools: ["world","Asia","ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "id-107",
    lat: 1.289525,
    lng: 99.118431,
    panoId: "j3U4sJP2bIeWNh6cbaWvFQ",
    place: "Near Padangsidempuan, North Sumatra",
    shortName: "Padangsidempuan",
    countryCode: "ID",
    country: "Indonesia",
    continent: "Asia",
    difficulty: "adventurer",
    pools: ["world","Asia","ID"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "id-108",
    lat: -6.520841,
    lng: 106.248675,
    panoId: "9r6un7CmLESRRxWUF3xgZQ",
    place: "Near Muncang, Banten",
    shortName: "Muncang",
    countryCode: "ID",
    country: "Indonesia",
    continent: "Asia",
    difficulty: "adventurer",
    pools: ["world","Asia","ID"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "ph-000",
    lat: 14.648767,
    lng: 121.050906,
    panoId: "dwkPT4Qb7ih04VHSBsDU_Q",
    place: "Near Quezon City, National Capital Region",
    shortName: "Quezon City",
    countryCode: "PH",
    country: "Philippines",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","PH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ph-001",
    lat: 7.073247,
    lng: 125.613084,
    panoId: "SR4530yoStigBqDirguonQ",
    place: "Near Davao, Davao Region",
    shortName: "Davao",
    countryCode: "PH",
    country: "Philippines",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","PH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ph-002",
    lat: 14.699951,
    lng: 120.966862,
    panoId: "ZNzyJM-5-t6VcAvSWgcuow",
    place: "Near Valenzuela, National Capital Region",
    shortName: "Valenzuela",
    countryCode: "PH",
    country: "Philippines",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","PH"],
    qualityTier: 4,
    verified: true,
  },
];

const CHUNK_8: GeoLocation[] = [
  {
    id: "ph-003",
    lat: 14.586783,
    lng: 121.061415,
    panoId: "I0VzbsA9RmwMaDfvXPE9yA",
    place: "Near Pasig City, National Capital Region",
    shortName: "Pasig City",
    countryCode: "PH",
    country: "Philippines",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","PH"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "ph-004",
    lat: 10.666999,
    lng: 122.950194,
    panoId: "IK_EGEEeTjKcbDbzYWpDkQ",
    place: "Near Bacolod City, Western Visayas",
    shortName: "Bacolod City",
    countryCode: "PH",
    country: "Philippines",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","PH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ph-005",
    lat: 11.243,
    lng: 125.004461,
    panoId: "HIaj_qpa7IBuKh2xW1B4dw",
    place: "Near Tacloban, Eastern Visayas",
    shortName: "Tacloban",
    countryCode: "PH",
    country: "Philippines",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","PH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ph-006",
    lat: 15.480124,
    lng: 120.597976,
    panoId: "ik7IvZH79tSTIQp9Y16TDQ",
    place: "Near Tarlac City, Central Luzon",
    shortName: "Tarlac City",
    countryCode: "PH",
    country: "Philippines",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","PH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ph-007",
    lat: 14.450695,
    lng: 120.98218,
    panoId: "dcR5B_wnjb-3IA6a3AKDZA",
    place: "Near Las Piñas, National Capital Region",
    shortName: "Las Piñas",
    countryCode: "PH",
    country: "Philippines",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","PH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ph-008",
    lat: 7.22362,
    lng: 124.246309,
    panoId: "NFJOd4YWknz3jrPYC35zhw",
    place: "Near Cotabato, Autonomous Region in Muslim Mindanao",
    shortName: "Cotabato",
    countryCode: "PH",
    country: "Philippines",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","PH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ph-009",
    lat: 14.524257,
    lng: 121.078764,
    panoId: "kdAzhCwPgL-_Yd_2IZ-m4w",
    place: "Near Taguig, National Capital Region",
    shortName: "Taguig",
    countryCode: "PH",
    country: "Philippines",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","PH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ph-010",
    lat: 14.481142,
    lng: 121.017393,
    panoId: "7-Hd2BvLPEGsyJeFQnrxGw",
    place: "Near Paranaque City, National Capital Region",
    shortName: "Paranaque City",
    countryCode: "PH",
    country: "Philippines",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","PH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ph-011",
    lat: 10.316737,
    lng: 123.890817,
    panoId: "lan7c0ZRaVh-jaNoGnW-2g",
    place: "Near Cebu City, Central Visayas",
    shortName: "Cebu City",
    countryCode: "PH",
    country: "Philippines",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","PH"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "ph-012",
    lat: 14.548744,
    lng: 121.031971,
    panoId: "d_dZGeFsQ2XR3cm5nF0ACg",
    place: "Near Makati City, National Capital Region",
    shortName: "Makati City",
    countryCode: "PH",
    country: "Philippines",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","PH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ph-013",
    lat: 10.696964,
    lng: 122.56427,
    panoId: "auLKkhmVYW2OJHhygseSOw",
    place: "Near Iloilo, Western Visayas",
    shortName: "Iloilo",
    countryCode: "PH",
    country: "Philippines",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","PH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ph-014",
    lat: 14.626024,
    lng: 121.12203,
    panoId: "VWZ8Uo89cmG7-f-YSURH9A",
    place: "Near Antipolo, Calabarzon",
    shortName: "Antipolo",
    countryCode: "PH",
    country: "Philippines",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","PH"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "ph-015",
    lat: 15.149958,
    lng: 120.582943,
    panoId: "A-HopplpCHE0XnFiYyCaww",
    place: "Near Angeles City, Central Luzon",
    shortName: "Angeles City",
    countryCode: "PH",
    country: "Philippines",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","PH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ph-016",
    lat: 14.843803,
    lng: 120.810445,
    panoId: "2dxoPKccSX0y7sJRqnuGfg",
    place: "Near Malolos, Central Luzon",
    shortName: "Malolos",
    countryCode: "PH",
    country: "Philippines",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","PH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ph-017",
    lat: 8.228989,
    lng: 124.243244,
    panoId: "HPoUSnLBqWNjKUDqgJYe9w",
    place: "Near Iligan, Northern Mindanao",
    shortName: "Iligan",
    countryCode: "PH",
    country: "Philippines",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","PH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ph-018",
    lat: 8.482661,
    lng: 124.64619,
    panoId: "hzwAx2dKjg6zoxA0ni463Q",
    place: "Near Cagayan de Oro, Northern Mindanao",
    shortName: "Cagayan de Oro",
    countryCode: "PH",
    country: "Philippines",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","PH"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "ph-019",
    lat: 14.64953,
    lng: 120.967876,
    panoId: "lWSbV13_GtuSlHl4U-E4YQ",
    place: "Near Caloocan, National Capital Region",
    shortName: "Caloocan",
    countryCode: "PH",
    country: "Philippines",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","PH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ph-020",
    lat: 15.162167,
    lng: 120.567411,
    panoId: "ukWpWSLdssJyIM7jVCWavA",
    place: "Near Santol, Central Luzon",
    shortName: "Santol",
    countryCode: "PH",
    country: "Philippines",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","PH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ph-021",
    lat: 14.604208,
    lng: 120.981952,
    panoId: "SLG4TW9983k2rm4DnIYWiw",
    place: "Near Manila, National Capital Region",
    shortName: "Manila",
    countryCode: "PH",
    country: "Philippines",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","PH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ph-022",
    lat: 15.033763,
    lng: 120.684009,
    panoId: "ttcPXWHD-TdgC7g9zeqeIA",
    place: "Near San Fernando, Central Luzon",
    shortName: "San Fernando",
    countryCode: "PH",
    country: "Philippines",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","PH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ph-023",
    lat: 8.949206,
    lng: 125.543676,
    panoId: "g9OiRWbH8IP00SfzYDx2VQ",
    place: "Near Butuan, Caraga",
    shortName: "Butuan",
    countryCode: "PH",
    country: "Philippines",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","PH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ph-024",
    lat: 14.211641,
    lng: 121.165233,
    panoId: "iu74jm4eOfhOSSeTs9mzzQ",
    place: "Near Calamba, Calabarzon",
    shortName: "Calamba",
    countryCode: "PH",
    country: "Philippines",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","PH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ph-025",
    lat: 15.485891,
    lng: 120.966649,
    panoId: "Su8KhikFCeour9Sy6nWZNw",
    place: "Near Cabanatuan City, Central Luzon",
    shortName: "Cabanatuan City",
    countryCode: "PH",
    country: "Philippines",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","PH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ph-026",
    lat: 14.390561,
    lng: 121.047436,
    panoId: "BTFjGV-Xk3XJ_ELfwDfWPA",
    place: "Near Muntinlupa, Calabarzon",
    shortName: "Muntinlupa",
    countryCode: "PH",
    country: "Philippines",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","PH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ph-027",
    lat: 10.630659,
    lng: 122.978805,
    panoId: "imXWN0-N3fRwCfjDCd9sFQ",
    place: "Near Mansilingan, Western Visayas",
    shortName: "Mansilingan",
    countryCode: "PH",
    country: "Philippines",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","PH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ph-028",
    lat: 8.944189,
    lng: 125.501969,
    panoId: "03TXTChG1KrQq1_QmghvFQ",
    place: "Near Libertad, Caraga",
    shortName: "Libertad",
    countryCode: "PH",
    country: "Philippines",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","PH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ph-029",
    lat: 8.0036,
    lng: 124.284139,
    panoId: "MeKKZHsDpOQQ-UgaF44kUw",
    place: "Near Marawi City, Autonomous Region in Muslim Mindanao",
    shortName: "Marawi City",
    countryCode: "PH",
    country: "Philippines",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","PH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ph-030",
    lat: 6.910269,
    lng: 122.073933,
    panoId: "qbjn0iPqULIyVBeFcjzAcw",
    place: "Near Zamboanga, Zamboanga Peninsula",
    shortName: "Zamboanga",
    countryCode: "PH",
    country: "Philippines",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","PH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ph-031",
    lat: 16.417615,
    lng: 120.592987,
    panoId: "yQ4mMUX8YEdmi7NljItpvw",
    place: "Near Baguio, Cordillera",
    shortName: "Baguio",
    countryCode: "PH",
    country: "Philippines",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","PH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ph-032",
    lat: 6.112787,
    lng: 125.171713,
    panoId: "cuO97PI_JIa6tlCTmVNLDg",
    place: "Near General Santos, Soccsksargen",
    shortName: "General Santos",
    countryCode: "PH",
    country: "Philippines",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","PH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ph-033",
    lat: 7.447489,
    lng: 125.804544,
    panoId: "-OxQNg7PfcXUKafuz5cMUQ",
    place: "Near Magugpo Poblacion, Davao Region",
    shortName: "Magugpo Poblacion",
    countryCode: "PH",
    country: "Philippines",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","PH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ph-034",
    lat: 14.376114,
    lng: 121.059027,
    panoId: "Nt_m8gWx6GXhiXp5FyITMA",
    place: "Near Tunasan, Calabarzon",
    shortName: "Tunasan",
    countryCode: "PH",
    country: "Philippines",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","PH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ph-035",
    lat: 8.013812,
    lng: 124.288076,
    panoId: "Rx78ptuDuWTiVzanuiBgRQ",
    place: "Near Marawi City, Autonomous Region in Muslim Mindanao",
    shortName: "Marawi City",
    countryCode: "PH",
    country: "Philippines",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","PH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ph-036",
    lat: 11.006335,
    lng: 124.607613,
    panoId: "vxO5hCpfdlVWcU53udFKkQ",
    place: "Near Ormoc, Eastern Visayas",
    shortName: "Ormoc",
    countryCode: "PH",
    country: "Philippines",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","PH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ph-037",
    lat: 8.17011,
    lng: 124.230582,
    panoId: "2im1LJyeIiuyh1_MELWSHw",
    place: "Near Mantampay, Northern Mindanao",
    shortName: "Mantampay",
    countryCode: "PH",
    country: "Philippines",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","PH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ph-038",
    lat: 10.307691,
    lng: 123.88301,
    panoId: "CC3lEB9Ykzpz6R0Ebuev4g",
    place: "Near Cebu City, Central Visayas",
    shortName: "Cebu City",
    countryCode: "PH",
    country: "Philippines",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","PH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ph-039",
    lat: 13.93144,
    lng: 121.617341,
    panoId: "JfqVo1yqMIAGlpuB8G855Q",
    place: "Near Lucena, Calabarzon",
    shortName: "Lucena",
    countryCode: "PH",
    country: "Philippines",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","PH"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "ph-040",
    lat: 14.662702,
    lng: 121.066205,
    panoId: "u7whGsuYolmvaimuzpa4Ag",
    place: "Near Quezon City, National Capital Region",
    shortName: "Quezon City",
    countryCode: "PH",
    country: "Philippines",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","PH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ph-041",
    lat: 16.41823,
    lng: 120.616222,
    panoId: "y9FeoKuPexJ_UWEwCR_OFA",
    place: "Near Baguio, Cordillera",
    shortName: "Baguio",
    countryCode: "PH",
    country: "Philippines",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","PH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ph-042",
    lat: 15.019224,
    lng: 120.695341,
    panoId: "kV9-nsZPDP8hdtzl68aPxg",
    place: "Near Del Pilar, Central Luzon",
    shortName: "Del Pilar",
    countryCode: "PH",
    country: "Philippines",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","PH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ph-043",
    lat: 8.931735,
    lng: 125.549466,
    panoId: "KG1SG99TIZpsvIWZB3eOWQ",
    place: "Near Butuan, Caraga",
    shortName: "Butuan",
    countryCode: "PH",
    country: "Philippines",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","PH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ph-044",
    lat: 10.653471,
    lng: 122.942025,
    panoId: "k7QXU6Y4SOwUAIijA1iFsA",
    place: "Near Bacolod City, Western Visayas",
    shortName: "Bacolod City",
    countryCode: "PH",
    country: "Philippines",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","PH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ph-045",
    lat: 7.090967,
    lng: 125.620892,
    panoId: "Ek3W9rCS9sV0Hl6c7YFWhg",
    place: "Near Davao, Davao Region",
    shortName: "Davao",
    countryCode: "PH",
    country: "Philippines",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","PH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ph-046",
    lat: 6.918194,
    lng: 122.06251,
    panoId: "R0uZ9YKCFQKK86hHkqYPrQ",
    place: "Near Zamboanga, Zamboanga Peninsula",
    shortName: "Zamboanga",
    countryCode: "PH",
    country: "Philippines",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","PH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ph-047",
    lat: 13.756668,
    lng: 121.058262,
    panoId: "3mC0dtlNhBR0KD7KewBmww",
    place: "Near Batangas, Calabarzon",
    shortName: "Batangas",
    countryCode: "PH",
    country: "Philippines",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","PH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ph-048",
    lat: 8.951899,
    lng: 125.484549,
    panoId: "6Q7wjYwJ_FI3H1pioMYQ9A",
    place: "Near Libertad, Caraga",
    shortName: "Libertad",
    countryCode: "PH",
    country: "Philippines",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","PH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ph-049",
    lat: 14.842983,
    lng: 120.797412,
    panoId: "PUXGKWT7bEBJdS6uV6KJcA",
    place: "Near Malolos, Central Luzon",
    shortName: "Malolos",
    countryCode: "PH",
    country: "Philippines",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","PH"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "ph-050",
    lat: 7.242157,
    lng: 124.389184,
    panoId: "2cNqQprfp-bpd-nEJdJe5A",
    place: "Near Manuangan, Soccsksargen",
    shortName: "Manuangan",
    countryCode: "PH",
    country: "Philippines",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","PH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ph-051",
    lat: 14.395444,
    lng: 120.991635,
    panoId: "sylglnibLmYo-r2pQp9GTg",
    place: "Near Ayala Alabang, National Capital Region",
    shortName: "Ayala Alabang",
    countryCode: "PH",
    country: "Philippines",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","PH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ph-052",
    lat: 14.360311,
    lng: 121.00391,
    panoId: "PwO2_UbjTyqdMEYX2L5xSQ",
    place: "Near Poblacion, National Capital Region",
    shortName: "Poblacion",
    countryCode: "PH",
    country: "Philippines",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","PH"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "ph-053",
    lat: 10.383064,
    lng: 123.885186,
    panoId: "oi2eT0Y7VYDzFJEUq-VL7w",
    place: "Near Apas, Central Visayas",
    shortName: "Apas",
    countryCode: "PH",
    country: "Philippines",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","PH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ph-054",
    lat: 15.058539,
    lng: 120.620549,
    panoId: "Z2QPK3Vtww0M2y4K7n9i8Q",
    place: "Near Balas, Central Luzon",
    shortName: "Balas",
    countryCode: "PH",
    country: "Philippines",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","PH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ph-055",
    lat: 7.457475,
    lng: 125.846162,
    panoId: "GUqxTdwgpx7ncbRrefaNsg",
    place: "Near Magugpo Poblacion, Davao Region",
    shortName: "Magugpo Poblacion",
    countryCode: "PH",
    country: "Philippines",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","PH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ph-056",
    lat: 7.033964,
    lng: 125.574687,
    panoId: "J4Q-eYFOoHALFOYTge27Yg",
    place: "Near Davao, Davao Region",
    shortName: "Davao",
    countryCode: "PH",
    country: "Philippines",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","PH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ph-057",
    lat: 8.258997,
    lng: 124.267776,
    panoId: "Flenkqa1_YNHP3HB4QPxLA",
    place: "Near Libertad, Philippines",
    shortName: "Libertad",
    countryCode: "PH",
    country: "Philippines",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","PH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ph-058",
    lat: 8.954597,
    lng: 125.448194,
    panoId: "Rat43_uJyCW5fUPRRNTG9w",
    place: "Near Bancasi, Caraga",
    shortName: "Bancasi",
    countryCode: "PH",
    country: "Philippines",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","PH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ph-059",
    lat: 7.280326,
    lng: 124.455755,
    panoId: "kyR-3zNyxSgJypAfixvaiw",
    place: "Near Balogo, Soccsksargen",
    shortName: "Balogo",
    countryCode: "PH",
    country: "Philippines",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","PH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ph-060",
    lat: 8.421888,
    lng: 124.657141,
    panoId: "5QqsHxJYim_pMUQ0KxCwTA",
    place: "Near Balulang, Northern Mindanao",
    shortName: "Balulang",
    countryCode: "PH",
    country: "Philippines",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","PH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ph-061",
    lat: 8.989704,
    lng: 125.584763,
    panoId: "wHdT0n8BfS3kCGe8ajgA7Q",
    place: "Near Los Angeles, Caraga",
    shortName: "Los Angeles",
    countryCode: "PH",
    country: "Philippines",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","PH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ph-062",
    lat: 7.187662,
    lng: 124.259214,
    panoId: "CiSUo4UjPIJ1sqXKk_AcRA",
    place: "Near Tamontaka, Soccsksargen",
    shortName: "Tamontaka",
    countryCode: "PH",
    country: "Philippines",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","PH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ph-063",
    lat: 14.860423,
    lng: 120.28487,
    panoId: "x4h_jgrFtHWcrOTNxPqBaw",
    place: "Near Olongapo, Central Luzon",
    shortName: "Olongapo",
    countryCode: "PH",
    country: "Philippines",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","PH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ph-064",
    lat: 6.970001,
    lng: 122.110993,
    panoId: "dn8LNazIcde1e_qUMZCqUg",
    place: "Near Culianan, Zamboanga Peninsula",
    shortName: "Culianan",
    countryCode: "PH",
    country: "Philippines",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","PH"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "ph-065",
    lat: 7.325408,
    lng: 124.295851,
    panoId: "cRI8BGG-g3waPNofAcwfew",
    place: "Near Tapayan, Autonomous Region in Muslim Mindanao",
    shortName: "Tapayan",
    countryCode: "PH",
    country: "Philippines",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","PH"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "ph-066",
    lat: 10.568691,
    lng: 122.94902,
    panoId: "PaUOtIpFRh55-J4Bl3dXWQ",
    place: "Near Dulao, Western Visayas",
    shortName: "Dulao",
    countryCode: "PH",
    country: "Philippines",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","PH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ph-067",
    lat: 7.877347,
    lng: 123.433369,
    panoId: "xscnUcY6K-4mt4PIxisKRw",
    place: "Near Kauswagan, Zamboanga Peninsula",
    shortName: "Kauswagan",
    countryCode: "PH",
    country: "Philippines",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","PH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ph-068",
    lat: 15.531126,
    lng: 120.625949,
    panoId: "DZCB_niEfuyz7zX4FqaBTA",
    place: "Near Bakulong, Central Luzon",
    shortName: "Bakulong",
    countryCode: "PH",
    country: "Philippines",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","PH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ph-069",
    lat: 11.304434,
    lng: 124.972332,
    panoId: "ikAKZ8zIX3py2XruU40XQQ",
    place: "Near San Antonio, Eastern Visayas",
    shortName: "San Antonio",
    countryCode: "PH",
    country: "Philippines",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","PH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ph-070",
    lat: 7.515866,
    lng: 125.788431,
    panoId: "JAIGRVy1PxHOevxg5ms60g",
    place: "Near Buclad, Davao Region",
    shortName: "Buclad",
    countryCode: "PH",
    country: "Philippines",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","PH"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "ph-071",
    lat: 15.252076,
    lng: 120.600213,
    panoId: "pfSjVcu5c2QhPrxoD8xifg",
    place: "Near Bamban, Central Luzon",
    shortName: "Bamban",
    countryCode: "PH",
    country: "Philippines",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","PH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ph-072",
    lat: 13.096376,
    lng: 123.68191,
    panoId: "hxcUSSsXFHeMxgmX0Sm-yA",
    place: "Near Bascaron, Bicol Region",
    shortName: "Bascaron",
    countryCode: "PH",
    country: "Philippines",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","PH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ph-073",
    lat: 11.574956,
    lng: 122.717657,
    panoId: "s-xc2b7pcpBILwNwiU2cRg",
    place: "Near Sibaguan, Western Visayas",
    shortName: "Sibaguan",
    countryCode: "PH",
    country: "Philippines",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","PH"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "ph-074",
    lat: 17.148985,
    lng: 121.938034,
    panoId: "AKTmgjbMum3yvYv3hd1Qjg",
    place: "Near Manaring, Cagayan Valley",
    shortName: "Manaring",
    countryCode: "PH",
    country: "Philippines",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","PH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ph-075",
    lat: 13.709058,
    lng: 121.071632,
    panoId: "zWDbYvbKU0x8oTLukX8MLg",
    place: "Near Santo Niño, Calabarzon",
    shortName: "Santo Niño",
    countryCode: "PH",
    country: "Philippines",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","PH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ph-076",
    lat: 17.613488,
    lng: 121.779195,
    panoId: "qGHgga3xMJ-1WPeNt5GFgg",
    place: "Near Peñablanca, Cagayan Valley",
    shortName: "Peñablanca",
    countryCode: "PH",
    country: "Philippines",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","PH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ph-077",
    lat: 7.931996,
    lng: 125.109081,
    panoId: "gG9TFBIxOFz5zSC1_f2pRg",
    place: "Near NIA Valencia, Northern Mindanao",
    shortName: "NIA Valencia",
    countryCode: "PH",
    country: "Philippines",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","PH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ph-078",
    lat: 14.148955,
    lng: 121.145819,
    panoId: "LtXpwjtoRTuLvXHwV1LWqA",
    place: "Near Pantay Na Matanda, Calabarzon",
    shortName: "Pantay Na Matanda",
    countryCode: "PH",
    country: "Philippines",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","PH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ph-079",
    lat: 10.671758,
    lng: 123.018127,
    panoId: "tSoV1R-79yJZ1cSaBrNJlA",
    place: "Near Concepcion, Western Visayas",
    shortName: "Concepcion",
    countryCode: "PH",
    country: "Philippines",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","PH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ph-080",
    lat: 7.176187,
    lng: 124.594497,
    panoId: "mMZNcnIPDX5MIT_wYwaUZA",
    place: "Near Upper San Mateo, Soccsksargen",
    shortName: "Upper San Mateo",
    countryCode: "PH",
    country: "Philippines",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","PH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ph-081",
    lat: 12.969148,
    lng: 123.832223,
    panoId: "WYFwEiIKRYfwQt2eIQdVTg",
    place: "Near San Vicente, Bicol Region",
    shortName: "San Vicente",
    countryCode: "PH",
    country: "Philippines",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","PH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ph-082",
    lat: 14.796442,
    lng: 120.28546,
    panoId: "IjyTx4kduRlKG30_9H4vxg",
    place: "Near Subic Bay Freeport Zone, Central Luzon",
    shortName: "Subic Bay Freeport Zone",
    countryCode: "PH",
    country: "Philippines",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","PH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ph-083",
    lat: 15.756553,
    lng: 120.428025,
    panoId: "gGlVNH9OQxgZ7SIhXIcFNA",
    place: "Near Bilad, Central Luzon",
    shortName: "Bilad",
    countryCode: "PH",
    country: "Philippines",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","PH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ph-084",
    lat: 15.798188,
    lng: 120.619996,
    panoId: "QIEfN91vHq-Wg8wJpvdtQQ",
    place: "Near San Manuel, Central Luzon",
    shortName: "San Manuel",
    countryCode: "PH",
    country: "Philippines",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","PH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ph-085",
    lat: 11.281647,
    lng: 125.02084,
    panoId: "i9EW5xawOFmvg7_6FKINzw",
    place: "Near San Antonio, Eastern Visayas",
    shortName: "San Antonio",
    countryCode: "PH",
    country: "Philippines",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","PH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ph-086",
    lat: 13.496671,
    lng: 123.216611,
    panoId: "zVtZDep9BcT6lPv0P9MgGQ",
    place: "Near Baliuag Nuevo, Bicol Region",
    shortName: "Baliuag Nuevo",
    countryCode: "PH",
    country: "Philippines",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","PH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ph-087",
    lat: 12.898965,
    lng: 123.826351,
    panoId: "KCOMwRapoZWe1y6XIDWtRg",
    place: "Near Macalaya, Bicol Region",
    shortName: "Macalaya",
    countryCode: "PH",
    country: "Philippines",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","PH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ph-088",
    lat: 10.023659,
    lng: 122.829849,
    panoId: "gYAMf7gvgwOgnm1BK6YmqQ",
    place: "Near Suay, Western Visayas",
    shortName: "Suay",
    countryCode: "PH",
    country: "Philippines",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","PH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ph-089",
    lat: 11.453306,
    lng: 122.731263,
    panoId: "FN8ObyStfPo7CXVbaloJzw",
    place: "Near Capaga, Western Visayas",
    shortName: "Capaga",
    countryCode: "PH",
    country: "Philippines",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","PH"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "ph-090",
    lat: 15.280704,
    lng: 120.919494,
    panoId: "20QxkkATZrHH-8j5zGcGgg",
    place: "Near Tabon, Central Luzon",
    shortName: "Tabon",
    countryCode: "PH",
    country: "Philippines",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","PH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ph-091",
    lat: 16.479634,
    lng: 120.680278,
    panoId: "A0IhWOSM5aJahMmID01bMg",
    place: "Near Ambuclao, Cordillera",
    shortName: "Ambuclao",
    countryCode: "PH",
    country: "Philippines",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","PH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ph-092",
    lat: 15.817642,
    lng: 120.375554,
    panoId: "8vMj95DN2-yLBbyjEeh6pQ",
    place: "Near Real, Ilocos",
    shortName: "Real",
    countryCode: "PH",
    country: "Philippines",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","PH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ph-093",
    lat: 6.546513,
    lng: 124.786825,
    panoId: "IwWE4nbv6ArIrqk93CXKPw",
    place: "Near New Iloilo, Soccsksargen",
    shortName: "New Iloilo",
    countryCode: "PH",
    country: "Philippines",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","PH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ph-094",
    lat: 10.645894,
    lng: 122.68168,
    panoId: "KCbEkFUire7WRBu3o7g79w",
    place: "Near East Valencia, Western Visayas",
    shortName: "East Valencia",
    countryCode: "PH",
    country: "Philippines",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","PH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ph-095",
    lat: 10.945029,
    lng: 123.221684,
    panoId: "o_jtykbiP8IZ35AzXVhX-Q",
    place: "Near Luna, Western Visayas",
    shortName: "Luna",
    countryCode: "PH",
    country: "Philippines",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","PH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ph-096",
    lat: 9.838641,
    lng: 122.797912,
    panoId: "zmGkBMLXd16S11MZCk_f6g",
    place: "Near Camingawan, Western Visayas",
    shortName: "Camingawan",
    countryCode: "PH",
    country: "Philippines",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","PH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ph-097",
    lat: 6.445638,
    lng: 124.835539,
    panoId: "ZwNZ66IAvHLf7WGr2iTBIQ",
    place: "Near Paraiso, Soccsksargen",
    shortName: "Paraiso",
    countryCode: "PH",
    country: "Philippines",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","PH"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "ph-098",
    lat: 11.18397,
    lng: 124.615391,
    panoId: "bafZvmrRjtaivOVNX8TL4w",
    place: "Near Rizal, Eastern Visayas",
    shortName: "Rizal",
    countryCode: "PH",
    country: "Philippines",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","PH"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "ph-099",
    lat: 7.848956,
    lng: 123.455176,
    panoId: "ITGrnhvfV9YUZKfRRf9VHw",
    place: "Near Tawagan, Zamboanga Peninsula",
    shortName: "Tawagan",
    countryCode: "PH",
    country: "Philippines",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","PH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ph-100",
    lat: 17.289392,
    lng: 121.159827,
    panoId: "lKfPcqHVAiDHd8iE0PhW_A",
    place: "Near Tinglayan, Cordillera",
    shortName: "Tinglayan",
    countryCode: "PH",
    country: "Philippines",
    continent: "Asia",
    difficulty: "adventurer",
    pools: ["world","Asia","PH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ph-101",
    lat: 17.380051,
    lng: 121.519358,
    panoId: "AW4VNQzSBG-C36lGzL0TnA",
    place: "Near Agbannawag, Cordillera",
    shortName: "Agbannawag",
    countryCode: "PH",
    country: "Philippines",
    continent: "Asia",
    difficulty: "adventurer",
    pools: ["world","Asia","PH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ph-102",
    lat: 17.286995,
    lng: 121.751544,
    panoId: "HpqzsQSE-bLwlbUgfYky_Q",
    place: "Near Magsaysay, Cagayan Valley",
    shortName: "Magsaysay",
    countryCode: "PH",
    country: "Philippines",
    continent: "Asia",
    difficulty: "adventurer",
    pools: ["world","Asia","PH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ph-103",
    lat: 8.709603,
    lng: 124.945722,
    panoId: "iUPuR1Irxb2XTTJ_uuoflQ",
    place: "Near Hinapalanan, Northern Mindanao",
    shortName: "Hinapalanan",
    countryCode: "PH",
    country: "Philippines",
    continent: "Asia",
    difficulty: "adventurer",
    pools: ["world","Asia","PH"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ph-104",
    lat: 9.478708,
    lng: 122.689585,
    panoId: "L8YbgXuIxgYAUdFPme8nQA",
    place: "Near Bal-os, Central Visayas",
    shortName: "Bal-os",
    countryCode: "PH",
    country: "Philippines",
    continent: "Asia",
    difficulty: "adventurer",
    pools: ["world","Asia","PH"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "ph-105",
    lat: 17.641938,
    lng: 121.36107,
    panoId: "XDomZV-k1sYZAMCXEH721A",
    place: "Near Pinukpuk, Cordillera",
    shortName: "Pinukpuk",
    countryCode: "PH",
    country: "Philippines",
    continent: "Asia",
    difficulty: "adventurer",
    pools: ["world","Asia","PH"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "in-000",
    lat: 11.005512,
    lng: 76.966528,
    panoId: "KW2Zgmty5VM7Rnohwc1nEw",
    place: "Near Coimbatore, Tamil Nadu",
    shortName: "Coimbatore",
    countryCode: "IN",
    country: "India",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "in-001",
    lat: 22.29942,
    lng: 73.208095,
    panoId: "AXgAiAm6X5AvOQEemHrYWw",
    place: "Near Vadodara, Gujarat",
    shortName: "Vadodara",
    countryCode: "IN",
    country: "India",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "in-002",
    lat: 25.593903,
    lng: 85.136277,
    panoId: "z9KPR0wP6Q_aRqf1Cf-ycA",
    place: "Near Patna, Bihar",
    shortName: "Patna",
    countryCode: "IN",
    country: "India",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "in-003",
    lat: 28.411196,
    lng: 77.313164,
    panoId: "sSVNkiJaWllVtBFDpQ1tgA",
    place: "Near Faridabad, Haryana",
    shortName: "Faridabad",
    countryCode: "IN",
    country: "India",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "in-004",
    lat: 11.734398,
    lng: 78.959817,
    panoId: "ZKlHa9JGjdOWRbgClt_HOQ",
    place: "Near Kallakurichi, Tamil Nadu",
    shortName: "Kallakurichi",
    countryCode: "IN",
    country: "India",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "in-005",
    lat: 30.911779,
    lng: 75.853552,
    panoId: "ckiKgJslI9lSUXGBMPrqUA",
    place: "Near Ludhiana, Punjab",
    shortName: "Ludhiana",
    countryCode: "IN",
    country: "India",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "in-006",
    lat: 8.727334,
    lng: 77.683891,
    panoId: "mRnDRv1ipc5BJ-Yaslja8Q",
    place: "Near Tirunelveli, Tamil Nadu",
    shortName: "Tirunelveli",
    countryCode: "IN",
    country: "India",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "in-007",
    lat: 17.384119,
    lng: 78.456384,
    panoId: "qzDcoCfgizkvCPZl9fJ0CA",
    place: "Near Hyderabad, Telangana",
    shortName: "Hyderabad",
    countryCode: "IN",
    country: "India",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "in-008",
    lat: 21.195961,
    lng: 72.830238,
    panoId: "SQOfKgnnZybi7_5OkpC1SA",
    place: "Near Surat, Gujarat",
    shortName: "Surat",
    countryCode: "IN",
    country: "India",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "in-009",
    lat: 17.733509,
    lng: 83.316449,
    panoId: "z04IkC8D_S2_NyA9VMDnwg",
    place: "Near Rasapūdipalem, Andhra Pradesh",
    shortName: "Rasapūdipalem",
    countryCode: "IN",
    country: "India",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "in-010",
    lat: 26.920592,
    lng: 75.788588,
    panoId: "3CxAYr5S-E4sLoqWvEbs2A",
    place: "Near Jaipur, Rajasthan",
    shortName: "Jaipur",
    countryCode: "IN",
    country: "India",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "in-011",
    lat: 18.622389,
    lng: 73.807444,
    panoId: "uK9tgclFpVwgq3yx-hoBuw",
    place: "Near Pimpri, Maharashtra",
    shortName: "Pimpri",
    countryCode: "IN",
    country: "India",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "in-012",
    lat: 28.608967,
    lng: 76.980053,
    panoId: "hsbO3-Zpu6HunjDcfIInkQ",
    place: "Near Najafgarh, Delhi",
    shortName: "Najafgarh",
    countryCode: "IN",
    country: "India",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "in-013",
    lat: 23.254454,
    lng: 77.402805,
    panoId: "BrDjNUJw0xpbHhL8IC_ohA",
    place: "Near Bhopal, Madhya Pradesh",
    shortName: "Bhopal",
    countryCode: "IN",
    country: "India",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "in-014",
    lat: 19.244015,
    lng: 73.134976,
    panoId: "eNVr2rpJPs72CxiSQNOBlg",
    place: "Near Kalyān, Maharashtra",
    shortName: "Kalyān",
    countryCode: "IN",
    country: "India",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "in-015",
    lat: 22.291639,
    lng: 70.793307,
    panoId: "sHQBa1GW0N7NHHgipJkqIQ",
    place: "Near Rājkot, Gujarat",
    shortName: "Rājkot",
    countryCode: "IN",
    country: "India",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "in-016",
    lat: 19.997261,
    lng: 73.790921,
    panoId: "1ltf0i2bTkyFqa8MQKXHGw",
    place: "Near Nashik, Maharashtra",
    shortName: "Nashik",
    countryCode: "IN",
    country: "India",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "in-017",
    lat: 29.451039,
    lng: 75.674205,
    panoId: "wRc1RdfGe-64lGKK3-Mlvw",
    place: "Near Gorakhpur, Haryana",
    shortName: "Gorakhpur",
    countryCode: "IN",
    country: "India",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "in-018",
    lat: 26.464715,
    lng: 80.35033,
    panoId: "zAGCGDj9RnWafo5QCz8A7w",
    place: "Near Kanpur, Uttar Pradesh",
    shortName: "Kanpur",
    countryCode: "IN",
    country: "India",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "in-019",
    lat: 22.562579,
    lng: 88.363071,
    panoId: "k9TpphurApwAG199Ka0hrA",
    place: "Near Kolkata, West Bengal",
    shortName: "Kolkata",
    countryCode: "IN",
    country: "India",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "in-020",
    lat: 22.803041,
    lng: 86.185473,
    panoId: "BCCO0pnF2GaE2dBDoFF3-Q",
    place: "Near Jamshedpur, Jharkhand",
    shortName: "Jamshedpur",
    countryCode: "IN",
    country: "India",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "in-021",
    lat: 13.087905,
    lng: 80.278439,
    panoId: "8l5_3zcSpGgTqBVGjoJchw",
    place: "Near Chennai, Tamil Nadu",
    shortName: "Chennai",
    countryCode: "IN",
    country: "India",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "in-022",
    lat: 12.971937,
    lng: 77.593722,
    panoId: "OQrJ1ZtVi6taLJSzHshZsA",
    place: "Near Bengaluru, Karnataka",
    shortName: "Bengaluru",
    countryCode: "IN",
    country: "India",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "in-023",
    lat: 22.717903,
    lng: 75.83299,
    panoId: "TOrqiG7JVCBl-fhPMPjTqg",
    place: "Near Indore, Madhya Pradesh",
    shortName: "Indore",
    countryCode: "IN",
    country: "India",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "in-024",
    lat: 19.216548,
    lng: 73.08338,
    panoId: "_p1oKUQ1YrMtNnIEvBiVnQ",
    place: "Near Dombivali, Maharashtra",
    shortName: "Dombivali",
    countryCode: "IN",
    country: "India",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "in-025",
    lat: 19.197588,
    lng: 72.963718,
    panoId: "Ai8Ep9rdzH89vmwBn-Ef3w",
    place: "Near Thāne, Maharashtra",
    shortName: "Thāne",
    countryCode: "IN",
    country: "India",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "in-026",
    lat: 23.02596,
    lng: 72.586744,
    panoId: "c1OBCiNGDzA1be_CIkl-xA",
    place: "Near Ahmedabad, Gujarat",
    shortName: "Ahmedabad",
    countryCode: "IN",
    country: "India",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "in-027",
    lat: 28.651415,
    lng: 77.232394,
    panoId: "THceHAPzJ6unt6_Tcopv_g",
    place: "Near Delhi, Delhi",
    shortName: "Delhi",
    countryCode: "IN",
    country: "India",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "in-028",
    lat: 28.979939,
    lng: 77.706267,
    panoId: "n_ATfBuwNhGNet-iiwQfWA",
    place: "Near Meerut, Uttar Pradesh",
    shortName: "Meerut",
    countryCode: "IN",
    country: "India",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "in-029",
    lat: 27.183084,
    lng: 78.016245,
    panoId: "SHjq92sFwlVxUv3rxnq_Hg",
    place: "Near Agra, Uttar Pradesh",
    shortName: "Agra",
    countryCode: "IN",
    country: "India",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "in-030",
    lat: 21.146654,
    lng: 79.085016,
    panoId: "dcJlSY844-IoUEfIZXOMfg",
    place: "Near Nagpur, Maharashtra",
    shortName: "Nagpur",
    countryCode: "IN",
    country: "India",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "in-031",
    lat: 9.918577,
    lng: 78.121015,
    panoId: "xqq9qkTnLSTa-7acGoruiw",
    place: "Near Madurai, Tamil Nadu",
    shortName: "Madurai",
    countryCode: "IN",
    country: "India",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "in-032",
    lat: 26.839014,
    lng: 80.923687,
    panoId: "mbAUOEzScpduCfUEhgZvsQ",
    place: "Near Lucknow, Uttar Pradesh",
    shortName: "Lucknow",
    countryCode: "IN",
    country: "India",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "in-033",
    lat: 19.073335,
    lng: 72.882785,
    panoId: "ewUrV803v6QGjBSMDgAa2w",
    place: "Near Mumbai, Maharashtra",
    shortName: "Mumbai",
    countryCode: "IN",
    country: "India",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "in-034",
    lat: 28.665592,
    lng: 77.439608,
    panoId: "pL7B4dwbV0AZwKPfvkUi6g",
    place: "Near Ghāziābād, Uttar Pradesh",
    shortName: "Ghāziābād",
    countryCode: "IN",
    country: "India",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "in-035",
    lat: 28.639779,
    lng: 77.240433,
    panoId: "fNDs7koonfxY2iFEPt-oSA",
    place: "Near Delhi, Delhi",
    shortName: "Delhi",
    countryCode: "IN",
    country: "India",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "in-036",
    lat: 22.556978,
    lng: 88.380017,
    panoId: "chRcy1tAKZudNStXdQvx2g",
    place: "Near Kolkata, West Bengal",
    shortName: "Kolkata",
    countryCode: "IN",
    country: "India",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "in-037",
    lat: 19.455869,
    lng: 72.811423,
    panoId: "0vxvjOhWi9pW546xIY3b_w",
    place: "Near Virār, Maharashtra",
    shortName: "Virār",
    countryCode: "IN",
    country: "India",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "in-038",
    lat: 18.629204,
    lng: 73.824048,
    panoId: "gL4s-Z6fbPmBXLYI7J20tg",
    place: "Near Pimpri, Maharashtra",
    shortName: "Pimpri",
    countryCode: "IN",
    country: "India",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "in-039",
    lat: 22.303164,
    lng: 73.187087,
    panoId: "5fVAsAsKOZCaIRPU0Dylkw",
    place: "Near Vadodara, Gujarat",
    shortName: "Vadodara",
    countryCode: "IN",
    country: "India",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "in-040",
    lat: 28.423605,
    lng: 77.307651,
    panoId: "aQWBCuyFq_9pBad1Ymju4w",
    place: "Near Faridabad, Haryana",
    shortName: "Faridabad",
    countryCode: "IN",
    country: "India",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "in-041",
    lat: 19.231517,
    lng: 82.548947,
    panoId: "5ITVyfLXr3O9_Gz5ZE69pg",
    place: "Near Nowrangapur, Odisha",
    shortName: "Nowrangapur",
    countryCode: "IN",
    country: "India",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "in-042",
    lat: 22.280828,
    lng: 70.783531,
    panoId: "51YZphTVwou_eXID275KCA",
    place: "Near Rājkot, Gujarat",
    shortName: "Rājkot",
    countryCode: "IN",
    country: "India",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "in-043",
    lat: 18.636225,
    lng: 73.789777,
    panoId: "4ir6yIFteIbK-3WhWRiWFg",
    place: "Near Pimpri, Maharashtra",
    shortName: "Pimpri",
    countryCode: "IN",
    country: "India",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "in-044",
    lat: 8.707945,
    lng: 77.694806,
    panoId: "0kqL7-d9UXstkULCSd_MEA",
    place: "Near Tirunelveli, Tamil Nadu",
    shortName: "Tirunelveli",
    countryCode: "IN",
    country: "India",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "in-045",
    lat: 28.623522,
    lng: 76.99978,
    panoId: "LJzK3s7vznVe7C_HB93R_w",
    place: "Near Nangli Sakrawat, Delhi",
    shortName: "Nangli Sakrawat",
    countryCode: "IN",
    country: "India",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "in-046",
    lat: 22.785563,
    lng: 86.181383,
    panoId: "f43fNqh05TDCZkBq-J6Vsg",
    place: "Near Jugsālai, Jharkhand",
    shortName: "Jugsālai",
    countryCode: "IN",
    country: "India",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "in-047",
    lat: 11.747459,
    lng: 78.945395,
    panoId: "Wa277ab1hzCY-99kYBQ_kA",
    place: "Near Kallakkurichchi, Tamil Nadu",
    shortName: "Kallakkurichchi",
    countryCode: "IN",
    country: "India",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "in-048",
    lat: 30.922658,
    lng: 75.866755,
    panoId: "KJhrO9LuE7toPycVImogcA",
    place: "Near Ludhiana, Punjab",
    shortName: "Ludhiana",
    countryCode: "IN",
    country: "India",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "in-049",
    lat: 9.903898,
    lng: 78.12104,
    panoId: "PpUwUETHlSNOQTAs-QEFdA",
    place: "Near Madurai, Tamil Nadu",
    shortName: "Madurai",
    countryCode: "IN",
    country: "India",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "in-050",
    lat: 19.18321,
    lng: 73.100171,
    panoId: "yJ_D965jT7RDVBjAZ3z_DA",
    place: "Near Dombivali, Maharashtra",
    shortName: "Dombivali",
    countryCode: "IN",
    country: "India",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "in-051",
    lat: 18.526171,
    lng: 73.886555,
    panoId: "BcWAE4gB6DdOrsc-8pLpzw",
    place: "Near Pune, Maharashtra",
    shortName: "Pune",
    countryCode: "IN",
    country: "India",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "in-052",
    lat: 18.668174,
    lng: 73.822924,
    panoId: "W3V_pfolCGOcILY98lVTrQ",
    place: "Near Pimpri, Maharashtra",
    shortName: "Pimpri",
    countryCode: "IN",
    country: "India",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "in-053",
    lat: 19.090476,
    lng: 72.92509,
    panoId: "JPuIQ1GeokxR5lLsgHJoWQ",
    place: "Near Powai, Maharashtra",
    shortName: "Powai",
    countryCode: "IN",
    country: "India",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "in-054",
    lat: 19.971092,
    lng: 73.748557,
    panoId: "BCPo5rK9oZoa1gQTC_Idaw",
    place: "Near Nashik, Maharashtra",
    shortName: "Nashik",
    countryCode: "IN",
    country: "India",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "in-055",
    lat: 21.157942,
    lng: 79.120675,
    panoId: "Fj_k-6tX2ZVBmie_wGIJhA",
    place: "Near Nagpur, Maharashtra",
    shortName: "Nagpur",
    countryCode: "IN",
    country: "India",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "in-056",
    lat: 19.236173,
    lng: 73.103796,
    panoId: "Ru2MZnCTzJ_7oTrTF2UUyA",
    place: "Near Dombivali, Maharashtra",
    shortName: "Dombivali",
    countryCode: "IN",
    country: "India",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "in-057",
    lat: 19.209934,
    lng: 82.492536,
    panoId: "8CX46lhx0lqYdVQmq5mmOw",
    place: "Near Nowrangapur, Odisha",
    shortName: "Nowrangapur",
    countryCode: "IN",
    country: "India",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "in-058",
    lat: 23.066148,
    lng: 72.578076,
    panoId: "aLRRrPxU71CLe9GaDvPwbQ",
    place: "Near Ahmadabad Cantonment, Gujarat",
    shortName: "Ahmadabad Cantonment",
    countryCode: "IN",
    country: "India",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "in-059",
    lat: 12.97997,
    lng: 77.531987,
    panoId: "Wu9Vpfb-0kz2-XyfENnXHA",
    place: "Near Bengaluru, Karnataka",
    shortName: "Bengaluru",
    countryCode: "IN",
    country: "India",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "in-060",
    lat: 8.755145,
    lng: 77.632165,
    panoId: "VZtTCnLvcYY4anZE_WCzFQ",
    place: "Near Tirunelveli, Tamil Nadu",
    shortName: "Tirunelveli",
    countryCode: "IN",
    country: "India",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "in-061",
    lat: 11.690504,
    lng: 78.989964,
    panoId: "tcmF7N0ruIGfybjlfv13NQ",
    place: "Near Kallakurichi, Tamil Nadu",
    shortName: "Kallakurichi",
    countryCode: "IN",
    country: "India",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "in-062",
    lat: 25.622573,
    lng: 85.16963,
    panoId: "qobQ7B4Pg3GLaGpCxC1HvA",
    place: "Near Patna, Bihar",
    shortName: "Patna",
    countryCode: "IN",
    country: "India",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "in-063",
    lat: 28.592602,
    lng: 77.022672,
    panoId: "LvgNYd-wHXPFtQzDDNbNmw",
    place: "Near Dīndārpur, Delhi",
    shortName: "Dīndārpur",
    countryCode: "IN",
    country: "India",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "in-064",
    lat: 23.764212,
    lng: 86.496912,
    panoId: "oeYAurhsiV8ert09q-ePrA",
    place: "Near Baliapur, Jharkhand",
    shortName: "Baliapur",
    countryCode: "IN",
    country: "India",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "in-065",
    lat: 29.393195,
    lng: 75.638485,
    panoId: "ukjTwDCimb8lqpkCx1jsFg",
    place: "Near Gorakhpur, Haryana",
    shortName: "Gorakhpur",
    countryCode: "IN",
    country: "India",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "in-066",
    lat: 22.537755,
    lng: 88.321659,
    panoId: "XWddioXbPgsa0xE6LQ2gXg",
    place: "Near Bara Bazar, West Bengal",
    shortName: "Bara Bazar",
    countryCode: "IN",
    country: "India",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "in-067",
    lat: 28.462116,
    lng: 77.291138,
    panoId: "hmbl8MeKwYkMZFiIHK_Qqw",
    place: "Near Taj Pul, Delhi",
    shortName: "Taj Pul",
    countryCode: "IN",
    country: "India",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "in-068",
    lat: 22.313389,
    lng: 73.241582,
    panoId: "KlPl-K55Jn766B61FcwyIw",
    place: "Near Vadodara, Gujarat",
    shortName: "Vadodara",
    countryCode: "IN",
    country: "India",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "in-069",
    lat: 26.831967,
    lng: 80.85176,
    panoId: "q11dw15naiwF7alVwmVxmA",
    place: "Near Lucknow, Uttar Pradesh",
    shortName: "Lucknow",
    countryCode: "IN",
    country: "India",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "in-070",
    lat: 27.189654,
    lng: 77.94773,
    panoId: "ASxtc-G3hLFrcZnUdEXvCg",
    place: "Near Agra, Uttar Pradesh",
    shortName: "Agra",
    countryCode: "IN",
    country: "India",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "in-071",
    lat: 23.262065,
    lng: 77.337735,
    panoId: "wz9YqsCAUBriicEI9IgS_g",
    place: "Near Bhopal, Madhya Pradesh",
    shortName: "Bhopal",
    countryCode: "IN",
    country: "India",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "in-072",
    lat: 19.24044,
    lng: 82.505107,
    panoId: "d09BydCu-r_D7DZRnxUggw",
    place: "Near Nowrangapur, Odisha",
    shortName: "Nowrangapur",
    countryCode: "IN",
    country: "India",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "in-073",
    lat: 26.907504,
    lng: 75.746395,
    panoId: "kiaUwdPuSzg7Dtobb7A1yg",
    place: "Near Jaipur, Rajasthan",
    shortName: "Jaipur",
    countryCode: "IN",
    country: "India",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "in-074",
    lat: 22.9949,
    lng: 72.572195,
    panoId: "qJBbtW7OvXau3pgpfHMsBA",
    place: "Near Ahmedabad, Gujarat",
    shortName: "Ahmedabad",
    countryCode: "IN",
    country: "India",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "in-075",
    lat: 17.742713,
    lng: 83.281295,
    panoId: "yP80trLocHwejmv4mhaT7g",
    place: "Near Rasapūdipalem, Andhra Pradesh",
    shortName: "Rasapūdipalem",
    countryCode: "IN",
    country: "India",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "in-076",
    lat: 28.950683,
    lng: 77.68646,
    panoId: "2HLp2nFN02nLzV8kS_BQDQ",
    place: "Near Meerut, Uttar Pradesh",
    shortName: "Meerut",
    countryCode: "IN",
    country: "India",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "in-077",
    lat: 23.792829,
    lng: 86.46822,
    panoId: "22C5c_YZkyBFKKJlHMnliA",
    place: "Near Dhanbad, Jharkhand",
    shortName: "Dhanbad",
    countryCode: "IN",
    country: "India",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "in-078",
    lat: 25.376666,
    lng: 82.997355,
    panoId: "pjZDGxwcbdzQ2Jyx4ublvw",
    place: "Near Varanasi, Uttar Pradesh",
    shortName: "Varanasi",
    countryCode: "IN",
    country: "India",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "in-079",
    lat: 23.141232,
    lng: 79.9981,
    panoId: "YULJ5WF4R-V8MAAg33PYuQ",
    place: "Near Jabalpur, Madhya Pradesh",
    shortName: "Jabalpur",
    countryCode: "IN",
    country: "India",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "in-080",
    lat: 29.47942,
    lng: 75.713558,
    panoId: "v-cbI72kdArMB92fTsL64Q",
    place: "Near Gorakhpur, Haryana",
    shortName: "Gorakhpur",
    countryCode: "IN",
    country: "India",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "in-081",
    lat: 16.43951,
    lng: 80.64649,
    panoId: "lZWItJJ_DpZmfRlordoesA",
    place: "Near Vaddeswaram, Andhra Pradesh",
    shortName: "Vaddeswaram",
    countryCode: "IN",
    country: "India",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "in-082",
    lat: 21.028114,
    lng: 79.189335,
    panoId: "weghlehXsadHKbRlIFFK_A",
    place: "Near Hudkeshwar Buzurg, Maharashtra",
    shortName: "Hudkeshwar Buzurg",
    countryCode: "IN",
    country: "India",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "in-083",
    lat: 18.626257,
    lng: 73.944087,
    panoId: "iFehWyUdgeHLqqrVwQ4sqg",
    place: "Near Lohogaon, Maharashtra",
    shortName: "Lohogaon",
    countryCode: "IN",
    country: "India",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "in-084",
    lat: 19.046632,
    lng: 72.928335,
    panoId: "R6qoxTK3fpe20XCBSRPCdQ",
    place: "Near Mumbai, Maharashtra",
    shortName: "Mumbai",
    countryCode: "IN",
    country: "India",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "in-085",
    lat: 28.59727,
    lng: 77.256325,
    panoId: "IObmXI7ZdKaySSinX5y_LQ",
    place: "Near Shakar Pur Baramad, Delhi",
    shortName: "Shakar Pur Baramad",
    countryCode: "IN",
    country: "India",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "in-086",
    lat: 18.534114,
    lng: 73.95122,
    panoId: "BoFamTFDO1yG1CdDowoSpg",
    place: "Near Vagholi, Maharashtra",
    shortName: "Vagholi",
    countryCode: "IN",
    country: "India",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "in-087",
    lat: 25.188539,
    lng: 75.911304,
    panoId: "97H5Coyxbf7ftRpN2aS5eA",
    place: "Near Kota, Rajasthan",
    shortName: "Kota",
    countryCode: "IN",
    country: "India",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "in-088",
    lat: 26.422776,
    lng: 80.293225,
    panoId: "BwCxOo6IxwXnLC-tK2Sm7g",
    place: "Near Kanpur, Uttar Pradesh",
    shortName: "Kanpur",
    countryCode: "IN",
    country: "India",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "in-089",
    lat: 17.673203,
    lng: 83.167357,
    panoId: "eZ9T8r4N9zBGvoYGbJfoMw",
    place: "Near Visakhapatnam, Andhra Pradesh",
    shortName: "Visakhapatnam",
    countryCode: "IN",
    country: "India",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "in-090",
    lat: 10.759545,
    lng: 78.671418,
    panoId: "YPq13c01V2Y1EwsHqSystw",
    place: "Near Tiruchirappalli, Tamil Nadu",
    shortName: "Tiruchirappalli",
    countryCode: "IN",
    country: "India",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "in-091",
    lat: 21.27992,
    lng: 81.57655,
    panoId: "E7sKMrBN7MdEHCQbYFoarQ",
    place: "Near Birgaon, Chhattisgarh",
    shortName: "Birgaon",
    countryCode: "IN",
    country: "India",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "in-092",
    lat: 26.180484,
    lng: 78.145118,
    panoId: "qOLhSrSg6O1Ra_VVuP8wQw",
    place: "Near Gwalior, Madhya Pradesh",
    shortName: "Gwalior",
    countryCode: "IN",
    country: "India",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "in-093",
    lat: 22.668663,
    lng: 75.844435,
    panoId: "8BrxSv1JRwR4gcu4U_aJhQ",
    place: "Near Ahīrkheri, Madhya Pradesh",
    shortName: "Ahīrkheri",
    countryCode: "IN",
    country: "India",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "in-094",
    lat: 15.286667,
    lng: 75.159389,
    panoId: "19GuO4Mu49zn6ngzwz3iYQ",
    place: "Near Hubballi, Karnataka",
    shortName: "Hubballi",
    countryCode: "IN",
    country: "India",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "in-095",
    lat: 19.232793,
    lng: 72.971996,
    panoId: "C7zQQ2XUi-okCteY6tFfXQ",
    place: "Near Thāne, Maharashtra",
    shortName: "Thāne",
    countryCode: "IN",
    country: "India",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "in-096",
    lat: 19.129941,
    lng: 73.243446,
    panoId: "Cmql9FND9V3jcjxWaXyRRg",
    place: "Near Badlapur, Maharashtra",
    shortName: "Badlapur",
    countryCode: "IN",
    country: "India",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "in-097",
    lat: 18.65266,
    lng: 73.870548,
    panoId: "blnjXxW2nljCkUwHKPQr3g",
    place: "Near Alandi, Maharashtra",
    shortName: "Alandi",
    countryCode: "IN",
    country: "India",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "in-098",
    lat: 26.112857,
    lng: 91.65535,
    panoId: "-2JblcyaFPg7m9zxlrXJeQ",
    place: "Near Dharapur, Assam",
    shortName: "Dharapur",
    countryCode: "IN",
    country: "India",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "in-099",
    lat: 26.843478,
    lng: 75.87014,
    panoId: "Bjqaq1ZzO-vAGWgdAT5kFw",
    place: "Near Bagrāna, Rajasthan",
    shortName: "Bagrāna",
    countryCode: "IN",
    country: "India",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "in-100",
    lat: 20.082606,
    lng: 73.631623,
    panoId: "PVCNoqfXNeteLQu5Qvo4lg",
    place: "Near Nashik, Maharashtra",
    shortName: "Nashik",
    countryCode: "IN",
    country: "India",
    continent: "Asia",
    difficulty: "adventurer",
    pools: ["world","Asia","IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "in-101",
    lat: 17.511241,
    lng: 75.908353,
    panoId: "qooo0YxPBQ8RVtT5g4sdyg",
    place: "Near Sholapur, Maharashtra",
    shortName: "Sholapur",
    countryCode: "IN",
    country: "India",
    continent: "Asia",
    difficulty: "adventurer",
    pools: ["world","Asia","IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "in-102",
    lat: 19.962036,
    lng: 75.486125,
    panoId: "jdLzi43wFVQgjeSZap_mrA",
    place: "Near Aurangabad, Maharashtra",
    shortName: "Aurangabad",
    countryCode: "IN",
    country: "India",
    continent: "Asia",
    difficulty: "adventurer",
    pools: ["world","Asia","IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "in-103",
    lat: 15.45729,
    lng: 74.999218,
    panoId: "aMEu3KxexoEw27p4fKnpEA",
    place: "Near Hubballi, Karnataka",
    shortName: "Hubballi",
    countryCode: "IN",
    country: "India",
    continent: "Asia",
    difficulty: "adventurer",
    pools: ["world","Asia","IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "in-104",
    lat: 28.158747,
    lng: 73.441524,
    panoId: "meJR11D2O2Nbi42rgftRVA",
    place: "Near Bikaner, Rajasthan",
    shortName: "Bikaner",
    countryCode: "IN",
    country: "India",
    continent: "Asia",
    difficulty: "adventurer",
    pools: ["world","Asia","IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "in-105",
    lat: 25.261339,
    lng: 81.801881,
    panoId: "Mwg6AtHyPV3IyYMSWFW-Jw",
    place: "Near Shankargarh, Uttar Pradesh",
    shortName: "Shankargarh",
    countryCode: "IN",
    country: "India",
    continent: "Asia",
    difficulty: "adventurer",
    pools: ["world","Asia","IN"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "il-000",
    lat: 31.769029,
    lng: 35.216746,
    panoId: "1z43l5OFx3_MH8IytGzSgw",
    place: "Near Jerusalem, Jerusalem",
    shortName: "Jerusalem",
    countryCode: "IL",
    country: "Israel",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","IL"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "il-001",
    lat: 31.926238,
    lng: 34.863556,
    panoId: "BK3bzlG442bYIg90wvEwsg",
    place: "Near Ramla, Central District",
    shortName: "Ramla",
    countryCode: "IL",
    country: "Israel",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","IL"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "il-002",
    lat: 32.080772,
    lng: 34.833662,
    panoId: "Ydkr_LUDHeIg0caqIpmblg",
    place: "Near Bnei Brak, Tel Aviv",
    shortName: "Bnei Brak",
    countryCode: "IL",
    country: "Israel",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "il-003",
    lat: 32.159128,
    lng: 34.893186,
    panoId: "Ib8v2c9R3M3ow5bDxzFpmA",
    place: "Near Hod HaSharon, Central District",
    shortName: "Hod HaSharon",
    countryCode: "IL",
    country: "Israel",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","IL"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "il-004",
    lat: 32.087068,
    lng: 34.887329,
    panoId: "VdYf2c0iAxphdnr2idgeQA",
    place: "Near Petaẖ Tiqva, Central District",
    shortName: "Petaẖ Tiqva",
    countryCode: "IL",
    country: "Israel",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","IL"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "il-005",
    lat: 32.174545,
    lng: 34.906812,
    panoId: "gbKPjVrxPSNqRB9ASwnVnw",
    place: "Near Kfar Saba, Central District",
    shortName: "Kfar Saba",
    countryCode: "IL",
    country: "Israel",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","IL"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "il-006",
    lat: 31.669125,
    lng: 34.570327,
    panoId: "syErrrk-6XWv8z_Pn6AtIg",
    place: "Near Ashkelon, Southern District",
    shortName: "Ashkelon",
    countryCode: "IL",
    country: "Israel",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","IL"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "il-007",
    lat: 32.072201,
    lng: 34.812418,
    panoId: "-DXSkKJ3ZJGZxNFIYKC1Hg",
    place: "Near Givatayim, Tel Aviv",
    shortName: "Givatayim",
    countryCode: "IL",
    country: "Israel",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "il-008",
    lat: 31.929346,
    lng: 34.798736,
    panoId: "Ab0HTvA-DIUKxRD2GYDyBw",
    place: "Near Ness Ziona, Central District",
    shortName: "Ness Ziona",
    countryCode: "IL",
    country: "Israel",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","IL"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "il-009",
    lat: 32.010441,
    lng: 34.779028,
    panoId: "0Xi1QpDQ56gbiIBWOJfBRw",
    place: "Near H̱olon, Tel Aviv",
    shortName: "H̱olon",
    countryCode: "IL",
    country: "Israel",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "il-010",
    lat: 32.813069,
    lng: 34.999304,
    panoId: "cNPUsZgxa07O3ECIgqLuQw",
    place: "Near Haifa, Haifa",
    shortName: "Haifa",
    countryCode: "IL",
    country: "Israel",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","IL"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "il-011",
    lat: 32.024163,
    lng: 34.751611,
    panoId: "2YJpCsXa9Z5MKcvmdKWzuQ",
    place: "Near Bat Yam, Tel Aviv",
    shortName: "Bat Yam",
    countryCode: "IL",
    country: "Israel",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "il-012",
    lat: 32.183715,
    lng: 34.873388,
    panoId: "tNcjETkKw6xjFvwgKB_K1g",
    place: "Near Ra'anana, Central District",
    shortName: "Ra'anana",
    countryCode: "IL",
    country: "Israel",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","IL"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "il-013",
    lat: 31.894452,
    lng: 34.811944,
    panoId: "gZztOGsMUH-hER-wAFJsJw",
    place: "Near Reẖovot, Central District",
    shortName: "Reẖovot",
    countryCode: "IL",
    country: "Israel",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","IL"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "il-014",
    lat: 32.909455,
    lng: 35.297688,
    panoId: "Cftu0_Lc6NG6eYkDkbqGcg",
    place: "Near Karmi’el, Northern District",
    shortName: "Karmi’el",
    countryCode: "IL",
    country: "Israel",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "il-015",
    lat: 31.970986,
    lng: 34.789324,
    panoId: "nx2NrYjZ0SlEqN1MY2ThdQ",
    place: "Near Rishon LeTsiyyon, Central District",
    shortName: "Rishon LeTsiyyon",
    countryCode: "IL",
    country: "Israel",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "il-016",
    lat: 32.080893,
    lng: 34.779987,
    panoId: "yNqhzLa-Wb3SvIwFKaqqgA",
    place: "Near Tel Aviv, Tel Aviv",
    shortName: "Tel Aviv",
    countryCode: "IL",
    country: "Israel",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "il-017",
    lat: 32.609048,
    lng: 35.289228,
    panoId: "9wWkNDh-Kl9lG9RhP-D8hg",
    place: "Near Afula, Northern District",
    shortName: "Afula",
    countryCode: "IL",
    country: "Israel",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","IL"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "il-018",
    lat: 31.792006,
    lng: 34.649966,
    panoId: "6AgUFGOv7WLgEI-1RrspzQ",
    place: "Near Ashdod, Southern District",
    shortName: "Ashdod",
    countryCode: "IL",
    country: "Israel",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","IL"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "il-019",
    lat: 32.092574,
    lng: 34.840806,
    panoId: "P-cfupOfKO4G8LOegDy2nw",
    place: "Near Bnei Brak, Tel Aviv",
    shortName: "Bnei Brak",
    countryCode: "IL",
    country: "Israel",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "il-020",
    lat: 32.836669,
    lng: 35.078537,
    panoId: "f8fRafeukvw5LeKcDQuDyg",
    place: "Near Qiryat Motsqin, Haifa",
    shortName: "Qiryat Motsqin",
    countryCode: "IL",
    country: "Israel",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","IL"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "il-021",
    lat: 32.706354,
    lng: 35.313953,
    panoId: "GsfXvJPqp8sh6G1opgEewg",
    place: "Near Naẕerat ‘Illit, Northern District",
    shortName: "Naẕerat ‘Illit",
    countryCode: "IL",
    country: "Israel",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "il-022",
    lat: 31.659451,
    lng: 34.594007,
    panoId: "PAlEMpieQt6W5ajnS8tNBA",
    place: "Near Ashkelon, Southern District",
    shortName: "Ashkelon",
    countryCode: "IL",
    country: "Israel",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","IL"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "il-023",
    lat: 32.081306,
    lng: 34.811756,
    panoId: "UDaUzGi7iwbtdMjL1zXRZQ",
    place: "Near Ramat Gan, Tel Aviv",
    shortName: "Ramat Gan",
    countryCode: "IL",
    country: "Israel",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "il-024",
    lat: 32.01363,
    lng: 34.799781,
    panoId: "JTaKbzF0ia_27lB-pV5VsQ",
    place: "Near Azor, Tel Aviv",
    shortName: "Azor",
    countryCode: "IL",
    country: "Israel",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "il-025",
    lat: 32.813804,
    lng: 35.521682,
    panoId: "xgr42Eb8TK9LbZUqrzn1dw",
    place: "Near Kfar H̱ittim, Northern District",
    shortName: "Kfar H̱ittim",
    countryCode: "IL",
    country: "Israel",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","IL"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "il-026",
    lat: 32.81911,
    lng: 35.099767,
    panoId: "lYcIj8xhydLu_-Pfs33tOg",
    place: "Near Qiryat Ata, Haifa",
    shortName: "Qiryat Ata",
    countryCode: "IL",
    country: "Israel",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","IL"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "il-027",
    lat: 32.436563,
    lng: 34.920858,
    panoId: "TPwOjfOXF5QlwVgnFlYW_Q",
    place: "Near Hadera, Haifa",
    shortName: "Hadera",
    countryCode: "IL",
    country: "Israel",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","IL"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "il-028",
    lat: 32.459576,
    lng: 34.964985,
    panoId: "x8XZvWN6SWtCgbczJAVocw",
    place: "Near Pardés H̱anna Karkur, Haifa",
    shortName: "Pardés H̱anna Karkur",
    countryCode: "IL",
    country: "Israel",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","IL"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "il-029",
    lat: 32.008772,
    lng: 34.748962,
    panoId: "rHNi8o4ucppcKuA0pOEulw",
    place: "Near Bat Yam, Tel Aviv",
    shortName: "Bat Yam",
    countryCode: "IL",
    country: "Israel",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "il-030",
    lat: 32.195283,
    lng: 34.880563,
    panoId: "AtpHS7RBmF414HdIxgBZLQ",
    place: "Near Ra'anana, Central District",
    shortName: "Ra'anana",
    countryCode: "IL",
    country: "Israel",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","IL"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "il-031",
    lat: 32.159479,
    lng: 34.818183,
    panoId: "H2_H1CpGj1aFDTLsrCeXaA",
    place: "Near Herzliya, Tel Aviv",
    shortName: "Herzliya",
    countryCode: "IL",
    country: "Israel",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","IL"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "il-032",
    lat: 32.797567,
    lng: 34.980913,
    panoId: "JBj8t7lraYQxRLbCl3-GWA",
    place: "Near Haifa, Haifa",
    shortName: "Haifa",
    countryCode: "IL",
    country: "Israel",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","IL"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "il-033",
    lat: 32.336133,
    lng: 34.872897,
    panoId: "DJnueFjDwAyaF9iY2aeAzA",
    place: "Near Netanya, Central District",
    shortName: "Netanya",
    countryCode: "IL",
    country: "Israel",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "il-034",
    lat: 31.264817,
    lng: 34.775779,
    panoId: "V-aP3cDxn7xfl79wF8x6Mg",
    place: "Near Beersheba, Southern District",
    shortName: "Beersheba",
    countryCode: "IL",
    country: "Israel",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","IL"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "il-035",
    lat: 32.62043,
    lng: 35.294179,
    panoId: "NvjlZ5SJ6JFLNEpBM2Ytdg",
    place: "Near Afula, Northern District",
    shortName: "Afula",
    countryCode: "IL",
    country: "Israel",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","IL"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "il-036",
    lat: 31.658666,
    lng: 34.578392,
    panoId: "r1R_-0ggNUTf7orREMYI0w",
    place: "Near Ashkelon, Southern District",
    shortName: "Ashkelon",
    countryCode: "IL",
    country: "Israel",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","IL"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "il-037",
    lat: 32.795325,
    lng: 35.002392,
    panoId: "IliCU3QWWBl26zIaK-k4cw",
    place: "Near Haifa, Haifa",
    shortName: "Haifa",
    countryCode: "IL",
    country: "Israel",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","IL"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "il-038",
    lat: 32.471267,
    lng: 34.964186,
    panoId: "kziWN_kYHVTA65TgFEeyzg",
    place: "Near Pardés H̱anna Karkur, Haifa",
    shortName: "Pardés H̱anna Karkur",
    countryCode: "IL",
    country: "Israel",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","IL"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "il-039",
    lat: 32.924882,
    lng: 35.308338,
    panoId: "4bFXee-ctWmWPLDjpuYXGQ",
    place: "Near Naḥf, Northern District",
    shortName: "Naḥf",
    countryCode: "IL",
    country: "Israel",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "il-040",
    lat: 31.873233,
    lng: 34.859505,
    panoId: "5H_UaePgXh9UDrQsHvDvDQ",
    place: "Near Na‘an, Central District",
    shortName: "Na‘an",
    countryCode: "IL",
    country: "Israel",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","IL"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "il-041",
    lat: 31.764138,
    lng: 35.281044,
    panoId: "l_asVcUj6FP4KVjSfU-xvA",
    place: "Near Al ‘Ayzarīyah, West Bank",
    shortName: "Al ‘Ayzarīyah",
    countryCode: "IL",
    country: "Israel",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","IL"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "il-042",
    lat: 32.013537,
    lng: 34.833865,
    panoId: "hD28Bqi2EMO-R8s_Jw0BMg",
    place: "Near H̱emed, Central District",
    shortName: "H̱emed",
    countryCode: "IL",
    country: "Israel",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","IL"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "il-043",
    lat: 32.081745,
    lng: 34.873149,
    panoId: "0J2wkn2KkRUmM-72Mc79qA",
    place: "Near Petaẖ Tiqva, Central District",
    shortName: "Petaẖ Tiqva",
    countryCode: "IL",
    country: "Israel",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","IL"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "il-044",
    lat: 32.82469,
    lng: 35.063336,
    panoId: "BykjuSwvDW_c2hdifq10Tg",
    place: "Near Qiryat Motsqin, Haifa",
    shortName: "Qiryat Motsqin",
    countryCode: "IL",
    country: "Israel",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","IL"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "il-045",
    lat: 31.86638,
    lng: 34.796719,
    panoId: "07LM4DTyQdt02yegRqmmJg",
    place: "Near Giv‘at Brenner, Central District",
    shortName: "Giv‘at Brenner",
    countryCode: "IL",
    country: "Israel",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","IL"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "il-046",
    lat: 32.069817,
    lng: 34.823482,
    panoId: "647pou62pz9U3SP5C-4pJA",
    place: "Near Givatayim, Tel Aviv",
    shortName: "Givatayim",
    countryCode: "IL",
    country: "Israel",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "il-047",
    lat: 32.192401,
    lng: 34.862325,
    panoId: "BqISwl9v8cuu9GRZWeTgkg",
    place: "Near Ra'anana, Central District",
    shortName: "Ra'anana",
    countryCode: "IL",
    country: "Israel",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","IL"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "il-048",
    lat: 31.244544,
    lng: 34.795203,
    panoId: "n_f7HpPyelxZXL93JDYKqw",
    place: "Near Beersheba, Southern District",
    shortName: "Beersheba",
    countryCode: "IL",
    country: "Israel",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","IL"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "il-049",
    lat: 32.068367,
    lng: 34.861744,
    panoId: "ln2S0HFRowB3MpfX0Ry_Yg",
    place: "Near Kiryat Ono, Tel Aviv",
    shortName: "Kiryat Ono",
    countryCode: "IL",
    country: "Israel",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "il-050",
    lat: 32.110929,
    lng: 34.857419,
    panoId: "HySqYaQLusJFlEFRYKX-gQ",
    place: "Near Giv'at Shmuel, Tel Aviv",
    shortName: "Giv'at Shmuel",
    countryCode: "IL",
    country: "Israel",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","IL"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "il-051",
    lat: 32.817384,
    lng: 35.048686,
    panoId: "rmzdMaqnKNCa2smYmbN26g",
    place: "Near Qiryat Motsqin, Haifa",
    shortName: "Qiryat Motsqin",
    countryCode: "IL",
    country: "Israel",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","IL"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "il-052",
    lat: 32.225796,
    lng: 34.819753,
    panoId: "9JYPS6GpEGqkIqE929znYw",
    place: "Near Shefayim, Central District",
    shortName: "Shefayim",
    countryCode: "IL",
    country: "Israel",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","IL"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "il-053",
    lat: 31.57012,
    lng: 34.805359,
    panoId: "SbCaXqH9fKFkkNBqJCWnsQ",
    place: "Near Even Shemu’el, Southern District",
    shortName: "Even Shemu’el",
    countryCode: "IL",
    country: "Israel",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "il-054",
    lat: 32.868106,
    lng: 35.09999,
    panoId: "DwS99uZnTFm7yxv-r0B1Zw",
    place: "Near Qiryat Yam, Haifa",
    shortName: "Qiryat Yam",
    countryCode: "IL",
    country: "Israel",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","IL"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "il-055",
    lat: 32.911505,
    lng: 35.21689,
    panoId: "a8j-VFs3cyVyNDL1R3qzsw",
    place: "Near Gilon, Northern District",
    shortName: "Gilon",
    countryCode: "IL",
    country: "Israel",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "il-056",
    lat: 31.954967,
    lng: 34.935797,
    panoId: "Zm8KYms8hM_lL44pJ4Z-Og",
    place: "Near Gimzo, Central District",
    shortName: "Gimzo",
    countryCode: "IL",
    country: "Israel",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","IL"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "il-057",
    lat: 32.118758,
    lng: 34.833428,
    panoId: "ydc1Y0OheBmbVe5j1jQYFw",
    place: "Near Ramat HaSharon, Tel Aviv",
    shortName: "Ramat HaSharon",
    countryCode: "IL",
    country: "Israel",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","IL"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "il-058",
    lat: 31.801676,
    lng: 34.80963,
    panoId: "OK74GGm1hHhfeklTv51cWg",
    place: "Near Bet H̱ilqiyya, Central District",
    shortName: "Bet H̱ilqiyya",
    countryCode: "IL",
    country: "Israel",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "il-059",
    lat: 31.942668,
    lng: 34.758045,
    panoId: "UOdUy_VSaCqTl5hoy5regQ",
    place: "Near Ness Ziona, Central District",
    shortName: "Ness Ziona",
    countryCode: "IL",
    country: "Israel",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","IL"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "il-060",
    lat: 32.261226,
    lng: 34.838105,
    panoId: "Cji2mqXEBDQ91vVTnCjbIA",
    place: "Near Udim, Central District",
    shortName: "Udim",
    countryCode: "IL",
    country: "Israel",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "il-061",
    lat: 31.893751,
    lng: 34.957941,
    panoId: "DKa-lYUl2EyZ8StDq-46UQ",
    place: "Near Sha‘alvim, Central District",
    shortName: "Sha‘alvim",
    countryCode: "IL",
    country: "Israel",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","IL"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "il-062",
    lat: 32.599367,
    lng: 35.044147,
    panoId: "9yTI0Ehc2Iz50Czxx5RTAA",
    place: "Near Ramot Menashe, Northern District",
    shortName: "Ramot Menashe",
    countryCode: "IL",
    country: "Israel",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "il-063",
    lat: 31.887837,
    lng: 34.944384,
    panoId: "ZASG5hqtdgljjjoDqMtBUg",
    place: "Near Bet H̱ashmonay, Central District",
    shortName: "Bet H̱ashmonay",
    countryCode: "IL",
    country: "Israel",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","IL"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "il-064",
    lat: 32.237156,
    lng: 34.82275,
    panoId: "O6UmCxmw29h9NZUTetrLGg",
    place: "Near Shefayim, Central District",
    shortName: "Shefayim",
    countryCode: "IL",
    country: "Israel",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","IL"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "il-065",
    lat: 31.076898,
    lng: 34.994109,
    panoId: "d9sXYv6CN377I5T7qM-m8w",
    place: "Near Dimona, Southern District",
    shortName: "Dimona",
    countryCode: "IL",
    country: "Israel",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "il-066",
    lat: 32.426936,
    lng: 34.971556,
    panoId: "wp9AtKia-8k0Kg_V0MuRHw",
    place: "Near Ma’or, Haifa",
    shortName: "Ma’or",
    countryCode: "IL",
    country: "Israel",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "il-067",
    lat: 32.566962,
    lng: 35.002923,
    panoId: "oJcfiszfDvys5NsEv-BvEg",
    place: "Near Zikhron Ya‘aqov, Haifa",
    shortName: "Zikhron Ya‘aqov",
    countryCode: "IL",
    country: "Israel",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "il-068",
    lat: 31.292059,
    lng: 35.098461,
    panoId: "YFngjMEaTwGDe7s13LEStg",
    place: "Near Drijat, Southern District",
    shortName: "Drijat",
    countryCode: "IL",
    country: "Israel",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","IL"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "il-069",
    lat: 33.019085,
    lng: 35.40278,
    panoId: "8Xx3kAhqrGn8eSf3ipwc7A",
    place: "Near Jīsh, Northern District",
    shortName: "Jīsh",
    countryCode: "IL",
    country: "Israel",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","IL"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "il-070",
    lat: 31.209869,
    lng: 35.252517,
    panoId: "IOLw0eySehb0VLAqa8e7hw",
    place: "Near Arad, Southern District",
    shortName: "Arad",
    countryCode: "IL",
    country: "Israel",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "il-071",
    lat: 33.036829,
    lng: 35.425367,
    panoId: "rqVIhdszFt0Uf8soAU5q2A",
    place: "Near Jīsh, Northern District",
    shortName: "Jīsh",
    countryCode: "IL",
    country: "Israel",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","IL"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "il-072",
    lat: 31.546671,
    lng: 34.765757,
    panoId: "UMqP1sriT0vTsS1P-l5epw",
    place: "Near Even Shemu’el, Southern District",
    shortName: "Even Shemu’el",
    countryCode: "IL",
    country: "Israel",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "il-073",
    lat: 32.405498,
    lng: 34.956708,
    panoId: "BiQ8Y2PmNh-O4mSbHprDZw",
    place: "Near Giv‘at H̱ayyim Iẖud, Central District",
    shortName: "Giv‘at H̱ayyim Iẖud",
    countryCode: "IL",
    country: "Israel",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "il-074",
    lat: 32.914036,
    lng: 35.191669,
    panoId: "iZovT_nqxeF_GY4FjuY4Gg",
    place: "Near Tal El, Northern District",
    shortName: "Tal El",
    countryCode: "IL",
    country: "Israel",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "il-075",
    lat: 32.416387,
    lng: 34.972521,
    panoId: "Cu92na9OkJDzQQ-aQiApKA",
    place: "Near Ma’or, Haifa",
    shortName: "Ma’or",
    countryCode: "IL",
    country: "Israel",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "il-076",
    lat: 32.661921,
    lng: 35.29277,
    panoId: "q4RZGuOP3Ypi4mrpkqSFBQ",
    place: "Near Tel ‘Adashim, Northern District",
    shortName: "Tel ‘Adashim",
    countryCode: "IL",
    country: "Israel",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "il-077",
    lat: 31.367305,
    lng: 34.893499,
    panoId: "OCnvHWic-VkXMtOwJjCaiw",
    place: "Near Ar Ramāḑīn, West Bank",
    shortName: "Ar Ramāḑīn",
    countryCode: "IL",
    country: "Israel",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","IL"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "il-078",
    lat: 31.167253,
    lng: 34.97576,
    panoId: "vNxWUNU14Oqy80C4MQXwxA",
    place: "Near ‘Ar‘ara BaNegev, Southern District",
    shortName: "‘Ar‘ara BaNegev",
    countryCode: "IL",
    country: "Israel",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "il-079",
    lat: 33.236801,
    lng: 35.603371,
    panoId: "0n4f-uZOwYlIM3jYPQOQPg",
    place: "Near Qiryat Shmona, Northern District",
    shortName: "Qiryat Shmona",
    countryCode: "IL",
    country: "Israel",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","IL"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "il-080",
    lat: 32.027773,
    lng: 34.923354,
    panoId: "sZsTpOiLbecCw9U_YDU8QA",
    place: "Near Tirat Yehuda, Central District",
    shortName: "Tirat Yehuda",
    countryCode: "IL",
    country: "Israel",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","IL"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "il-081",
    lat: 31.12497,
    lng: 35.241386,
    panoId: "sr8l504yZASqc0F75N_I8g",
    place: "Near ‘En Boqeq, Southern District",
    shortName: "‘En Boqeq",
    countryCode: "IL",
    country: "Israel",
    continent: "Asia",
    difficulty: "adventurer",
    pools: ["world","Asia","IL"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "il-082",
    lat: 31.56866,
    lng: 34.849225,
    panoId: "EOUQFlhtBcrvXdQMIWVY9A",
    place: "Near Bet Guvrin, Southern District",
    shortName: "Bet Guvrin",
    countryCode: "IL",
    country: "Israel",
    continent: "Asia",
    difficulty: "adventurer",
    pools: ["world","Asia","IL"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "il-083",
    lat: 31.187402,
    lng: 34.946025,
    panoId: "KtFcAJaimcvblemuzjGNwQ",
    place: "Near Khirbat Abu Tulūl, Southern District",
    shortName: "Khirbat Abu Tulūl",
    countryCode: "IL",
    country: "Israel",
    continent: "Asia",
    difficulty: "adventurer",
    pools: ["world","Asia","IL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "il-084",
    lat: 32.70309,
    lng: 35.567103,
    panoId: "_JXnF09WVDauI165f9Upaw",
    place: "Near Afiqim, Northern District",
    shortName: "Afiqim",
    countryCode: "IL",
    country: "Israel",
    continent: "Asia",
    difficulty: "adventurer",
    pools: ["world","Asia","IL"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "il-085",
    lat: 33.066244,
    lng: 35.474263,
    panoId: "pHyvbMkc_R7i1H32wz-afg",
    place: "Near Riẖaniya, Northern District",
    shortName: "Riẖaniya",
    countryCode: "IL",
    country: "Israel",
    continent: "Asia",
    difficulty: "adventurer",
    pools: ["world","Asia","IL"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "il-086",
    lat: 32.728276,
    lng: 35.559817,
    panoId: "JBd6aA9vVA0_ebk8VkjOJw",
    place: "Near Poria Illit, Northern District",
    shortName: "Poria Illit",
    countryCode: "IL",
    country: "Israel",
    continent: "Asia",
    difficulty: "adventurer",
    pools: ["world","Asia","IL"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "tr-000",
    lat: 37.87132,
    lng: 32.484655,
    panoId: "sLL9qnPvu_QC7-0_3ZSLeQ",
    place: "Near Konya, Konya",
    shortName: "Konya",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TR"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "tr-001",
    lat: 39.776687,
    lng: 30.520776,
    panoId: "6XTwn_fOYhDZaa-ZTGn8Ow",
    place: "Near Eskişehir, Eskişehir",
    shortName: "Eskişehir",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tr-002",
    lat: 36.908089,
    lng: 30.695626,
    panoId: "vwAw3jKp4hTqazo_XNgvGQ",
    place: "Near Antalya, Antalya",
    shortName: "Antalya",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tr-003",
    lat: 36.811954,
    lng: 34.638824,
    panoId: "qDIw6pRVTfS_QVXQGa4FdA",
    place: "Near Mersin, Mersin",
    shortName: "Mersin",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TR"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "tr-004",
    lat: 36.206673,
    lng: 36.156929,
    panoId: "isb_bU32Q2DvFe5rAK6Q_A",
    place: "Near Antakya, Hatay",
    shortName: "Antakya",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tr-005",
    lat: 37.166284,
    lng: 38.793474,
    panoId: "V0STpVNgbN8i2MM-sRNu0g",
    place: "Near Şanlıurfa, Şanlıurfa",
    shortName: "Şanlıurfa",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tr-006",
    lat: 37.887352,
    lng: 41.132227,
    panoId: "WCm0nhS8Hekf5_QixQYbcg",
    place: "Near Batman, Batman",
    shortName: "Batman",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tr-007",
    lat: 38.673586,
    lng: 29.405702,
    panoId: "yHl-6iMkzYKw0oiVI_yKuQ",
    place: "Near Uşak, Uşak",
    shortName: "Uşak",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tr-008",
    lat: 36.985882,
    lng: 35.325378,
    panoId: "Eg8ZIxU3ABJAQK6wQNqdHA",
    place: "Near Adana, Adana",
    shortName: "Adana",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tr-009",
    lat: 41.043593,
    lng: 28.876027,
    panoId: "VYh1yQdUUfWlT9XHjmdShQ",
    place: "Near Esenler, Istanbul",
    shortName: "Esenler",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tr-010",
    lat: 37.059863,
    lng: 37.382486,
    panoId: "LU-aAPi3FAxf2iekfpUNUw",
    place: "Near Gaziantep, Gaziantep",
    shortName: "Gaziantep",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "tr-011",
    lat: 38.494662,
    lng: 43.383244,
    panoId: "89hbjDVVeVxBe6X40S3TQg",
    place: "Near Van, Van",
    shortName: "Van",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tr-012",
    lat: 36.891648,
    lng: 30.764977,
    panoId: "2PYa8NbFIrFQiWs-SMKTxA",
    place: "Near Muratpaşa, Antalya",
    shortName: "Muratpaşa",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tr-013",
    lat: 38.412701,
    lng: 27.138398,
    panoId: "ybT25lCfhLHDJRuLYofW_w",
    place: "Near İzmir, İzmir Province",
    shortName: "İzmir",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tr-014",
    lat: 41.002371,
    lng: 28.859906,
    panoId: "tsHPvwfKVJe-g9YQsEJyfQ",
    place: "Near Bahçelievler, Istanbul",
    shortName: "Bahçelievler",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tr-015",
    lat: 40.214044,
    lng: 28.915683,
    panoId: "eVCv4mv5kWYAm7_qqmoRqw",
    place: "Near Nilüfer, Bursa Province",
    shortName: "Nilüfer",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tr-016",
    lat: 38.674698,
    lng: 39.223273,
    panoId: "jaBguFOLHDNqxrf70uxUPg",
    place: "Near Elazığ, Elazığ",
    shortName: "Elazığ",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tr-017",
    lat: 41.022606,
    lng: 29.013174,
    panoId: "zsSWUa9MjVpT9JNXURwPlA",
    place: "Near Üsküdar, Istanbul",
    shortName: "Üsküdar",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tr-018",
    lat: 39.908642,
    lng: 41.276929,
    panoId: "KUlrMRRCS54C0WKLq3dX5Q",
    place: "Near Erzurum, Erzurum",
    shortName: "Erzurum",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tr-019",
    lat: 40.195628,
    lng: 29.060177,
    panoId: "LsZtqYuWsMuF9pln1ZP6Uw",
    place: "Near Bursa, Bursa Province",
    shortName: "Bursa",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tr-020",
    lat: 41.038968,
    lng: 28.856724,
    panoId: "tsbveXWSGG0tG2EZKvGlwA",
    place: "Near Bağcılar, Istanbul",
    shortName: "Bağcılar",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tr-021",
    lat: 41.016495,
    lng: 29.124595,
    panoId: "tSFyhtF0vCRUZ0MNwhVL8w",
    place: "Near Umraniye, Istanbul",
    shortName: "Umraniye",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tr-022",
    lat: 37.774265,
    lng: 29.087631,
    panoId: "8SLs2X5u0G2Vhen_d7aGVA",
    place: "Near Denizli, Denizli",
    shortName: "Denizli",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tr-023",
    lat: 41.279736,
    lng: 36.336093,
    panoId: "fbnRUNSg-dYNikU-kpL_qw",
    place: "Near Samsun, Samsun",
    shortName: "Samsun",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tr-024",
    lat: 37.764553,
    lng: 38.27462,
    panoId: "Xd6fXGw_A5_FEw4uUEKe_Q",
    place: "Near Adıyaman, Adıyaman Province",
    shortName: "Adıyaman",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tr-025",
    lat: 38.457691,
    lng: 27.114257,
    panoId: "uaMJ7606P2GyfEIA_6lxYQ",
    place: "Near Karşıyaka, İzmir Province",
    shortName: "Karşıyaka",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tr-026",
    lat: 39.919905,
    lng: 32.854253,
    panoId: "NvFloNMpx-oYSMb88F8rAA",
    place: "Near Ankara, Ankara",
    shortName: "Ankara",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tr-027",
    lat: 38.730774,
    lng: 35.486018,
    panoId: "r84x5L1n30ZE0C0Q-KrgBg",
    place: "Near Kayseri, Kayseri",
    shortName: "Kayseri",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tr-028",
    lat: 38.350304,
    lng: 38.317146,
    panoId: "3HvwUZcNTLdJR7pTCsEC-Q",
    place: "Near Malatya, Malatya",
    shortName: "Malatya",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tr-029",
    lat: 36.917927,
    lng: 34.892752,
    panoId: "raTlUBeipOte8FJCQRI7Pg",
    place: "Near Tarsus, Mersin",
    shortName: "Tarsus",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tr-030",
    lat: 37.584713,
    lng: 36.926462,
    panoId: "LiF5M2r0L8RDowbYN-vFHQ",
    place: "Near Kahramanmaraş, Kahramanmaraş",
    shortName: "Kahramanmaraş",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tr-031",
    lat: 36.543726,
    lng: 31.999833,
    panoId: "Z9m-ZG3F7svOFEz1U4QgRg",
    place: "Near Alanya, Antalya",
    shortName: "Alanya",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tr-032",
    lat: 41.013662,
    lng: 28.949604,
    panoId: "OoA3GOuDbXJiqjq5yIUcqw",
    place: "Near Istanbul, Istanbul",
    shortName: "Istanbul",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tr-033",
    lat: 38.374156,
    lng: 34.023855,
    panoId: "c1ITA6aX2ZZYvg-ZgqshcA",
    place: "Near Aksaray, Aksaray",
    shortName: "Aksaray",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tr-034",
    lat: 37.913652,
    lng: 40.217172,
    panoId: "nmm8FHjjpewULfCXKk3X_w",
    place: "Near Diyarbakır, Diyarbakır Province",
    shortName: "Diyarbakır",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tr-035",
    lat: 40.802647,
    lng: 29.430322,
    panoId: "hFLQWoGr7IorbNnC18nfug",
    place: "Near Gebze, Kocaeli",
    shortName: "Gebze",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tr-036",
    lat: 37.805406,
    lng: 29.040399,
    panoId: "z5MphYBeru6vRc5JNfROPw",
    place: "Near Merkezefendi, Denizli",
    shortName: "Merkezefendi",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tr-037",
    lat: 36.885985,
    lng: 30.742278,
    panoId: "N1Ys4vaODwZ00EHi8iF4Fg",
    place: "Near Muratpaşa, Antalya",
    shortName: "Muratpaşa",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tr-038",
    lat: 41.021225,
    lng: 28.852032,
    panoId: "NzYqzOJn2xpkcMPOskPeBw",
    place: "Near Bağcılar, Istanbul",
    shortName: "Bağcılar",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tr-039",
    lat: 39.784853,
    lng: 30.510288,
    panoId: "gHRfj_dZoDvaIa7rrSzWAw",
    place: "Near Eskişehir, Eskişehir",
    shortName: "Eskişehir",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tr-040",
    lat: 40.78071,
    lng: 30.403313,
    panoId: "BnCBFnRWgxkOTK8R3G0hzw",
    place: "Near Adapazarı, Sakarya",
    shortName: "Adapazarı",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tr-041",
    lat: 40.211594,
    lng: 28.898865,
    panoId: "3dhJzmWLkbt-wQtt0twxOA",
    place: "Near Nilüfer, Bursa Province",
    shortName: "Nilüfer",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tr-042",
    lat: 37.167906,
    lng: 38.771182,
    panoId: "0oFMJayNThZqphUt12-b4g",
    place: "Near Şanlıurfa, Şanlıurfa",
    shortName: "Şanlıurfa",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tr-043",
    lat: 37.779362,
    lng: 38.273499,
    panoId: "YyAz-7GaUVrFa7iNM7hUdg",
    place: "Near Malazgirt, Adıyaman Province",
    shortName: "Malazgirt",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tr-044",
    lat: 38.668961,
    lng: 39.198701,
    panoId: "wVUvv4V_Cdkhw_550GNVow",
    place: "Near Elazığ, Elazığ",
    shortName: "Elazığ",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TR"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "tr-045",
    lat: 37.880315,
    lng: 32.461965,
    panoId: "j05DIeJH3X7OoA8KlItmXw",
    place: "Near Konya, Konya",
    shortName: "Konya",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tr-046",
    lat: 41.023749,
    lng: 28.870647,
    panoId: "epDQnKtM1TmMID4lxWj-xg",
    place: "Near Merter Keresteciler, Istanbul",
    shortName: "Merter Keresteciler",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tr-047",
    lat: 37.575433,
    lng: 36.901623,
    panoId: "9D2D6wrYkkrva3oZiCC_7g",
    place: "Near Kahramanmaraş, Kahramanmaraş",
    shortName: "Kahramanmaraş",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tr-048",
    lat: 37.006656,
    lng: 35.329859,
    panoId: "FEfv2YCmSK-SC4xW13aATg",
    place: "Near Adana, Adana",
    shortName: "Adana",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TR"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "tr-049",
    lat: 37.901997,
    lng: 40.22496,
    panoId: "-Dfp8No4FXlKZ3-QO1zrSQ",
    place: "Near Sur, Diyarbakır Province",
    shortName: "Sur",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "classic",
    pools: ["world","Asia","TR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tr-050",
    lat: 40.771208,
    lng: 29.516478,
    panoId: "WVcQK76XIzQvNBCZwVYEbw",
    place: "Near Tavşancıl, Kocaeli",
    shortName: "Tavşancıl",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tr-051",
    lat: 38.753776,
    lng: 35.507456,
    panoId: "ipLCoQc8UCpeAot2RZaSzA",
    place: "Near Kayseri, Kayseri",
    shortName: "Kayseri",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tr-052",
    lat: 37.852314,
    lng: 41.190735,
    panoId: "KjEvZ5MZzoBes0x3zaiZFg",
    place: "Near Binatlı, Batman",
    shortName: "Binatlı",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tr-053",
    lat: 40.153284,
    lng: 29.013507,
    panoId: "8efEfD3SiV3WOjQqXCABXw",
    place: "Near Bursa, Bursa Province",
    shortName: "Bursa",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tr-054",
    lat: 37.760401,
    lng: 28.986035,
    panoId: "W-l_Rhl4h-_unG42WQUemA",
    place: "Near Merkezefendi, Denizli",
    shortName: "Merkezefendi",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tr-055",
    lat: 36.822695,
    lng: 34.59841,
    panoId: "gqYNwlSdehoOAbqin8udLQ",
    place: "Near Mersin, Mersin",
    shortName: "Mersin",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tr-056",
    lat: 39.95474,
    lng: 41.270426,
    panoId: "6X-V5k2P1421MgkdPgeFig",
    place: "Near Dadaşköy, Erzurum",
    shortName: "Dadaşköy",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TR"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "tr-057",
    lat: 36.872594,
    lng: 34.913068,
    panoId: "PsGhIZ6PbDyYnJ7oOV7WFw",
    place: "Near Yeşiltepe, Mersin",
    shortName: "Yeşiltepe",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tr-058",
    lat: 40.799214,
    lng: 30.367505,
    panoId: "gqHnK2c8ISsv8DHNIIwY_Q",
    place: "Near Serdivan, Sakarya",
    shortName: "Serdivan",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tr-059",
    lat: 37.898081,
    lng: 40.278586,
    panoId: "vWZTHSCc6QjQQCL5w0pzOQ",
    place: "Near Sur, Diyarbakır Province",
    shortName: "Sur",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "tr-060",
    lat: 36.208027,
    lng: 36.203858,
    panoId: "Ap5sU-e7Egw-r0RNa85fJg",
    place: "Near Narlıca, Hatay",
    shortName: "Narlıca",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tr-061",
    lat: 41.015585,
    lng: 28.808702,
    panoId: "5VWZQ_zHQWXdZcfn5RxGEw",
    place: "Near Mahmutbey, Istanbul",
    shortName: "Mahmutbey",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tr-062",
    lat: 37.009388,
    lng: 35.369742,
    panoId: "iLyAD7fslF7HNqLn_Of6mg",
    place: "Near Yüreğir, Adana",
    shortName: "Yüreğir",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TR"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "tr-063",
    lat: 36.945462,
    lng: 30.65249,
    panoId: "BMukLXuPGze3AvrTE6feMg",
    place: "Near Duacı, Antalya",
    shortName: "Duacı",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tr-064",
    lat: 37.567252,
    lng: 36.960257,
    panoId: "7WowpBwNs0iNr0-msFoO-Q",
    place: "Near Kahramanmaraş, Kahramanmaraş",
    shortName: "Kahramanmaraş",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tr-065",
    lat: 38.442678,
    lng: 43.405517,
    panoId: "2NnXx9qti-RybQ-UCALnTA",
    place: "Near Van, Van",
    shortName: "Van",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tr-066",
    lat: 39.810997,
    lng: 30.55528,
    panoId: "-JXFZPE84NkwqH0jgaDQCw",
    place: "Near Tepebaşı, Eskişehir",
    shortName: "Tepebaşı",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tr-067",
    lat: 37.203376,
    lng: 38.727975,
    panoId: "R7ix32nepM7IqxvTsprHEA",
    place: "Near Karaköprü, Şanlıurfa",
    shortName: "Karaköprü",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tr-068",
    lat: 38.713932,
    lng: 39.234749,
    panoId: "cxSDjKLzK1HpVKHRMOKJ5A",
    place: "Near Harput, Elazığ",
    shortName: "Harput",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tr-069",
    lat: 41.320667,
    lng: 36.312623,
    panoId: "Hrsrw0CO37pSHf4i7oRNzA",
    place: "Near İlkadım, Samsun",
    shortName: "İlkadım",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tr-070",
    lat: 38.422116,
    lng: 33.955926,
    panoId: "vy9zualQ0fnRrUvpTcEmHg",
    place: "Near Hırkatolu, Aksaray",
    shortName: "Hırkatolu",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tr-071",
    lat: 37.876929,
    lng: 32.535977,
    panoId: "Pup87MPM-yx2rkndZCS-ww",
    place: "Near Karatay, Konya",
    shortName: "Karatay",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tr-072",
    lat: 38.78303,
    lng: 35.442895,
    panoId: "kwLWDPVvqe81XDT-BZ9-jA",
    place: "Near Melikgazi, Kayseri",
    shortName: "Melikgazi",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tr-073",
    lat: 39.886843,
    lng: 32.930566,
    panoId: "RvB1ekAoWI23rI3IAOSHkA",
    place: "Near Gaziosmanpaşa, Ankara",
    shortName: "Gaziosmanpaşa",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tr-074",
    lat: 40.528367,
    lng: 35.019855,
    panoId: "udjJP-0E1mRm7X_9Ck0lbA",
    place: "Near Çorum, Çorum",
    shortName: "Çorum",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tr-075",
    lat: 40.986335,
    lng: 29.050996,
    panoId: "62nXrnM7aQ0DufTnNe8bbw",
    place: "Near Altunizade, Istanbul",
    shortName: "Altunizade",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TR"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "tr-076",
    lat: 39.75599,
    lng: 37.061779,
    panoId: "c28wiTunpuSUlo03OogU3Q",
    place: "Near Sivas, Sivas",
    shortName: "Sivas",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TR"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "tr-077",
    lat: 41.010786,
    lng: 28.793021,
    panoId: "aG_tfPmkTtFfCxPLAwbWKQ",
    place: "Near Mahmutbey, Istanbul",
    shortName: "Mahmutbey",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tr-078",
    lat: 41.054146,
    lng: 28.915064,
    panoId: "N3fxAD0h3osbkTSd7D-dpA",
    place: "Near Esenler, Istanbul",
    shortName: "Esenler",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tr-079",
    lat: 38.695889,
    lng: 29.486617,
    panoId: "_GrW8206KZihvV8dTskILg",
    place: "Near Uşak, Uşak",
    shortName: "Uşak",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tr-080",
    lat: 36.565088,
    lng: 36.218453,
    panoId: "S12zvWEf3LX1eTpCZbWrGA",
    place: "Near İskenderun, Hatay",
    shortName: "İskenderun",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tr-081",
    lat: 40.910901,
    lng: 37.867329,
    panoId: "bYOLfOVsCiARdw8L7l_C1Q",
    place: "Near Uzunisa, Ordu",
    shortName: "Uzunisa",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tr-082",
    lat: 37.829258,
    lng: 29.122722,
    panoId: "OyazbtKo7saLUH2OZZq72Q",
    place: "Near Pamukkale, Denizli",
    shortName: "Pamukkale",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tr-083",
    lat: 40.770038,
    lng: 29.854341,
    panoId: "tKhg601uI_Dm6Ccc1Z7wEA",
    place: "Near Derince, Kocaeli",
    shortName: "Derince",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tr-084",
    lat: 38.474434,
    lng: 27.158192,
    panoId: "2mh34-TYd-J0zYO121zKWw",
    place: "Near Bayraklı, İzmir Province",
    shortName: "Bayraklı",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tr-085",
    lat: 40.831604,
    lng: 30.353251,
    panoId: "pL_J6NMzHNH20xSs1KvtGQ",
    place: "Near Kazımpaşa, Sakarya",
    shortName: "Kazımpaşa",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tr-086",
    lat: 36.851035,
    lng: 30.832676,
    panoId: "63Hp_LOlxyqJGITuW5NKeA",
    place: "Near Karaçallı, Antalya",
    shortName: "Karaçallı",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tr-087",
    lat: 38.630453,
    lng: 27.474349,
    panoId: "lcsYTjyWOyuZKi30arX1Zw",
    place: "Near Manisa, Manisa",
    shortName: "Manisa",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tr-088",
    lat: 36.840933,
    lng: 34.561851,
    panoId: "YBNTwzMrxnToVSWHUsjl9Q",
    place: "Near Bozön, Mersin",
    shortName: "Bozön",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tr-089",
    lat: 40.907808,
    lng: 31.161449,
    panoId: "I-n7c4Rg733-yOWXahAhDQ",
    place: "Near Konuralp, Düzce",
    shortName: "Konuralp",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tr-090",
    lat: 38.796523,
    lng: 30.589361,
    panoId: "y4HO_xiwBs-I4UOQ_8B9bA",
    place: "Near Afyonkarahisar, Afyonkarahisar Province",
    shortName: "Afyonkarahisar",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tr-091",
    lat: 39.731906,
    lng: 32.856375,
    panoId: "EVKq9xcxiqI3xEuEwbJp7A",
    place: "Near Oğulbey, Ankara",
    shortName: "Oğulbey",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tr-092",
    lat: 39.832152,
    lng: 32.967033,
    panoId: "i2qC5SIn5GglQhaadQ6APg",
    place: "Near Gaziosmanpaşa, Ankara",
    shortName: "Gaziosmanpaşa",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tr-093",
    lat: 40.585015,
    lng: 34.908228,
    panoId: "BpTZqx0lWLv0MDsVe5zHow",
    place: "Near Çorum, Çorum",
    shortName: "Çorum",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tr-094",
    lat: 41.139333,
    lng: 28.954805,
    panoId: "xf1MVoSvBx0QJgFHcf9SvQ",
    place: "Near Kemerburgaz, Istanbul",
    shortName: "Kemerburgaz",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tr-095",
    lat: 41.183881,
    lng: 28.519371,
    panoId: "cEk9ipGlvSEeUV-9ZzdzIw",
    place: "Near Çatalca, Istanbul",
    shortName: "Çatalca",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "tr-096",
    lat: 39.14055,
    lng: 34.068986,
    panoId: "dv2OWxL6C5gCnkELqRbPwg",
    place: "Near Kırşehir, Kırşehir",
    shortName: "Kırşehir",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tr-097",
    lat: 36.564903,
    lng: 31.960192,
    panoId: "vdCrEf6PaM-HeUL5BhY3xg",
    place: "Near Hacımehmetli, Antalya",
    shortName: "Hacımehmetli",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tr-098",
    lat: 38.442103,
    lng: 38.317267,
    panoId: "qNZRh59hEStBB_zNSTUB-A",
    place: "Near Battalgazi, Malatya",
    shortName: "Battalgazi",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tr-099",
    lat: 40.811015,
    lng: 29.745827,
    panoId: "kbii2WHGBJcgG9SsMrNRDQ",
    place: "Near Körfez, Kocaeli",
    shortName: "Körfez",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "explorer",
    pools: ["world","Asia","TR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tr-100",
    lat: 39.789718,
    lng: 41.38597,
    panoId: "BHj8tMRJjRe9YlYtO2A2rQ",
    place: "Near Palandöken, Erzurum",
    shortName: "Palandöken",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "adventurer",
    pools: ["world","Asia","TR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tr-101",
    lat: 39.863645,
    lng: 37.165564,
    panoId: "3wMjv20nCxGHv9Xh_Mg2Pw",
    place: "Near Sivas, Sivas",
    shortName: "Sivas",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "adventurer",
    pools: ["world","Asia","TR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tr-102",
    lat: 39.620076,
    lng: 32.717359,
    panoId: "LYhDChEXK0Hcwt6OOetOkQ",
    place: "Near İkizce, Ankara",
    shortName: "İkizce",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "adventurer",
    pools: ["world","Asia","TR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tr-103",
    lat: 37.383692,
    lng: 39.732145,
    panoId: "YZBakG9VTKb6EjsmF47Cbw",
    place: "Near Demirci, Şanlıurfa",
    shortName: "Demirci",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "adventurer",
    pools: ["world","Asia","TR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tr-104",
    lat: 40.086494,
    lng: 26.229227,
    panoId: "mgwkr53eLAhhr0D9ZwZe5g",
    place: "Near Güzelyalı, Canakkale",
    shortName: "Güzelyalı",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "adventurer",
    pools: ["world","Asia","TR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tr-105",
    lat: 39.818385,
    lng: 32.990155,
    panoId: "aFFsTz6zOByZwJm8iXfOwQ",
    place: "Near Gaziosmanpaşa, Ankara",
    shortName: "Gaziosmanpaşa",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "adventurer",
    pools: ["world","Asia","TR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tr-106",
    lat: 38.701454,
    lng: 27.256609,
    panoId: "beQ8SBj0gfo79rCFULCvAg",
    place: "Near Osmancalı, Manisa",
    shortName: "Osmancalı",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "adventurer",
    pools: ["world","Asia","TR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tr-107",
    lat: 37.857317,
    lng: 39.114479,
    panoId: "S7VSWnjU2b881i-7UVX02A",
    place: "Near Bucak, Şanlıurfa",
    shortName: "Bucak",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "adventurer",
    pools: ["world","Asia","TR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tr-108",
    lat: 36.903111,
    lng: 37.32587,
    panoId: "BWZ-GEreg4DoIl8TtUSSEw",
    place: "Near Şahinbey, Gaziantep",
    shortName: "Şahinbey",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "adventurer",
    pools: ["world","Asia","TR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tr-109",
    lat: 39.92516,
    lng: 39.432019,
    panoId: "B2TGHNKGu3xKoQbGCJGoVg",
    place: "Near Çatalarmut, Erzincan",
    shortName: "Çatalarmut",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "adventurer",
    pools: ["world","Asia","TR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tr-110",
    lat: 41.680059,
    lng: 26.76714,
    panoId: "Kw06MhHexFeBCTKq4Ou1yQ",
    place: "Near Hasköy, Edirne",
    shortName: "Hasköy",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "adventurer",
    pools: ["world","Asia","TR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tr-111",
    lat: 39.329411,
    lng: 34.156344,
    panoId: "Ks6PWwTUCjD0EEUp0iJKow",
    place: "Near Boztepe, Kırşehir",
    shortName: "Boztepe",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "adventurer",
    pools: ["world","Asia","TR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "tr-112",
    lat: 39.562765,
    lng: 28.072279,
    panoId: "kPr06IpG7oZAudPZxOLUkg",
    place: "Near Çağış, Balıkesir",
    shortName: "Çağış",
    countryCode: "TR",
    country: "Turkey",
    continent: "Asia",
    difficulty: "adventurer",
    pools: ["world","Asia","TR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ca-000",
    lat: 43.706672,
    lng: -79.398787,
    panoId: "4p039M7R1c24KuMBduo7vA",
    place: "Near Toronto, Ontario",
    shortName: "Toronto",
    countryCode: "CA",
    country: "Canada",
    continent: "North America",
    difficulty: "classic",
    pools: ["world","North America","CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ca-001",
    lat: 51.049924,
    lng: -114.085176,
    panoId: "2N_zehNavqYF0GTpHWnzAw",
    place: "Near Calgary, Alberta",
    shortName: "Calgary",
    countryCode: "CA",
    country: "Canada",
    continent: "North America",
    difficulty: "classic",
    pools: ["world","North America","CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ca-002",
    lat: 49.249593,
    lng: -123.119356,
    panoId: "wH81h66fJM-kmvJRijCPEA",
    place: "Near Vancouver, British Columbia",
    shortName: "Vancouver",
    countryCode: "CA",
    country: "Canada",
    continent: "North America",
    difficulty: "classic",
    pools: ["world","North America","CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ca-003",
    lat: 49.106329,
    lng: -122.82515,
    panoId: "5iSnuJOSfM9o3Wa4ZcV29w",
    place: "Near Surrey, British Columbia",
    shortName: "Surrey",
    countryCode: "CA",
    country: "Canada",
    continent: "North America",
    difficulty: "classic",
    pools: ["world","North America","CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ca-004",
    lat: 43.250183,
    lng: -79.849572,
    panoId: "nxNYPCqNCM5-uh-laxfbhg",
    place: "Near Hamilton, Ontario",
    shortName: "Hamilton",
    countryCode: "CA",
    country: "Canada",
    continent: "North America",
    difficulty: "classic",
    pools: ["world","North America","CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ca-005",
    lat: 45.515064,
    lng: -73.467909,
    panoId: "oA3r2poD3x9yhDTR7Di11A",
    place: "Near Longueuil, Quebec",
    shortName: "Longueuil",
    countryCode: "CA",
    country: "Canada",
    continent: "North America",
    difficulty: "classic",
    pools: ["world","North America","CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ca-006",
    lat: 43.899755,
    lng: -78.849441,
    panoId: "_ADWW6l2ortS64IVik0_Jg",
    place: "Near Oshawa, Ontario",
    shortName: "Oshawa",
    countryCode: "CA",
    country: "Canada",
    continent: "North America",
    difficulty: "classic",
    pools: ["world","North America","CA"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "ca-007",
    lat: 43.425332,
    lng: -80.511196,
    panoId: "BRWyWD1BZKG9DbL2sIjDTw",
    place: "Near Kitchener, Ontario",
    shortName: "Kitchener",
    countryCode: "CA",
    country: "Canada",
    continent: "North America",
    difficulty: "classic",
    pools: ["world","North America","CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ca-008",
    lat: 49.882616,
    lng: -119.485676,
    panoId: "saeKgX_MG5t41jV1KDTi0g",
    place: "Near Kelowna, British Columbia",
    shortName: "Kelowna",
    countryCode: "CA",
    country: "Canada",
    continent: "North America",
    difficulty: "classic",
    pools: ["world","North America","CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ca-009",
    lat: 44.642707,
    lng: -63.576751,
    panoId: "rU9gkItnCxTLh37ztdtrdg",
    place: "Near Halifax, Nova Scotia",
    shortName: "Halifax",
    countryCode: "CA",
    country: "Canada",
    continent: "North America",
    difficulty: "classic",
    pools: ["world","North America","CA"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "ca-010",
    lat: 46.812279,
    lng: -71.21459,
    panoId: "AUntiQ1vUz6cmUQlSakrPA",
    place: "Near Québec, Quebec",
    shortName: "Québec",
    countryCode: "CA",
    country: "Canada",
    continent: "North America",
    difficulty: "classic",
    pools: ["world","North America","CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ca-011",
    lat: 44.399808,
    lng: -79.66638,
    panoId: "QiS96zxabytxCdUOm4CQkQ",
    place: "Near Barrie, Ontario",
    shortName: "Barrie",
    countryCode: "CA",
    country: "Canada",
    continent: "North America",
    difficulty: "classic",
    pools: ["world","North America","CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ca-012",
    lat: 48.552541,
    lng: -123.374134,
    panoId: "mn_LFhuyyXwt9dmOgF9Plg",
    place: "Near Saanich, British Columbia",
    shortName: "Saanich",
    countryCode: "CA",
    country: "Canada",
    continent: "North America",
    difficulty: "classic",
    pools: ["world","North America","CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ca-013",
    lat: 43.171304,
    lng: -79.243095,
    panoId: "QPrdQh8p8oMHWhdTQuQHNw",
    place: "Near St. Catharines, Ontario",
    shortName: "St. Catharines",
    countryCode: "CA",
    country: "Canada",
    continent: "North America",
    difficulty: "classic",
    pools: ["world","North America","CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ca-014",
    lat: 43.545812,
    lng: -80.255889,
    panoId: "waXTW2LJqZeN8oykbs6GlQ",
    place: "Near Guelph, Ontario",
    shortName: "Guelph",
    countryCode: "CA",
    country: "Canada",
    continent: "North America",
    difficulty: "classic",
    pools: ["world","North America","CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ca-015",
    lat: 48.382048,
    lng: -89.249994,
    panoId: "QSJNy4K8dL63cvepj6wUgg",
    place: "Near Thunder Bay, Ontario",
    shortName: "Thunder Bay",
    countryCode: "CA",
    country: "Canada",
    continent: "North America",
    difficulty: "classic",
    pools: ["world","North America","CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ca-016",
    lat: 43.516232,
    lng: -79.882739,
    panoId: "0PxXyvvZF1XQoWZDz9LpaQ",
    place: "Near Milton, Ontario",
    shortName: "Milton",
    countryCode: "CA",
    country: "Canada",
    continent: "North America",
    difficulty: "classic",
    pools: ["world","North America","CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ca-017",
    lat: 48.416348,
    lng: -71.066164,
    panoId: "puy6n9f6uXpNJRqu5ZJ7Dw",
    place: "Near Saguenay, Quebec",
    shortName: "Saguenay",
    countryCode: "CA",
    country: "Canada",
    continent: "North America",
    difficulty: "classic",
    pools: ["world","North America","CA"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "ca-018",
    lat: 44.229682,
    lng: -76.481058,
    panoId: "jJHASrojbDH6WCfNT2k0jQ",
    place: "Near Kingston, Ontario",
    shortName: "Kingston",
    countryCode: "CA",
    country: "Canada",
    continent: "North America",
    difficulty: "classic",
    pools: ["world","North America","CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ca-019",
    lat: 49.884252,
    lng: -97.147637,
    panoId: "ikmiiiKxjJouQFGAH0OB2g",
    place: "Near Winnipeg, Manitoba",
    shortName: "Winnipeg",
    countryCode: "CA",
    country: "Canada",
    continent: "North America",
    difficulty: "classic",
    pools: ["world","North America","CA"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "ca-020",
    lat: 46.345229,
    lng: -72.547699,
    panoId: "izYweYeETSpPy-v3biLR9Q",
    place: "Near Trois-Rivières, Quebec",
    shortName: "Trois-Rivières",
    countryCode: "CA",
    country: "Canada",
    continent: "North America",
    difficulty: "classic",
    pools: ["world","North America","CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ca-021",
    lat: 48.43589,
    lng: -123.352191,
    panoId: "lpSwexuoM7gegEFjXtJjng",
    place: "Near Victoria, British Columbia",
    shortName: "Victoria",
    countryCode: "CA",
    country: "Canada",
    continent: "North America",
    difficulty: "classic",
    pools: ["world","North America","CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ca-022",
    lat: 47.564913,
    lng: -52.709307,
    panoId: "Q48dIZCoaZID3Wf3EfT6iQ",
    place: "Near St. John's, Newfoundland and Labrador",
    shortName: "St. John's",
    countryCode: "CA",
    country: "Canada",
    continent: "North America",
    difficulty: "classic",
    pools: ["world","North America","CA"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "ca-023",
    lat: 53.549566,
    lng: -113.470079,
    panoId: "Ij-3GSp0emvNrBRv9rlbCg",
    place: "Near Edmonton, Alberta",
    shortName: "Edmonton",
    countryCode: "CA",
    country: "Canada",
    continent: "North America",
    difficulty: "classic",
    pools: ["world","North America","CA"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "ca-024",
    lat: 46.135347,
    lng: -60.183443,
    panoId: "tStZB6EWlhPVIVJx28g9vQ",
    place: "Near Sydney, Nova Scotia",
    shortName: "Sydney",
    countryCode: "CA",
    country: "Canada",
    continent: "North America",
    difficulty: "classic",
    pools: ["world","North America","CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ca-025",
    lat: 49.70003,
    lng: -112.81846,
    panoId: "rmk7acQhBREus-6C9fLdmw",
    place: "Near Lethbridge, Alberta",
    shortName: "Lethbridge",
    countryCode: "CA",
    country: "Canada",
    continent: "North America",
    difficulty: "classic",
    pools: ["world","North America","CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ca-026",
    lat: 50.450077,
    lng: -104.61805,
    panoId: "oZ4zGRJl52BYAtbYII2osA",
    place: "Near Regina, Saskatchewan",
    shortName: "Regina",
    countryCode: "CA",
    country: "Canada",
    continent: "North America",
    difficulty: "classic",
    pools: ["world","North America","CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ca-027",
    lat: 52.132399,
    lng: -106.668877,
    panoId: "_JvqyBON-D4ezjsCA5SG1A",
    place: "Near Saskatoon, Saskatchewan",
    shortName: "Saskatoon",
    countryCode: "CA",
    country: "Canada",
    continent: "North America",
    difficulty: "classic",
    pools: ["world","North America","CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ca-028",
    lat: 45.508827,
    lng: -73.587791,
    panoId: "5eVuV3UxvHgzrj7oJrinbQ",
    place: "Near Montréal, Quebec",
    shortName: "Montréal",
    countryCode: "CA",
    country: "Canada",
    continent: "North America",
    difficulty: "classic",
    pools: ["world","North America","CA"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "ca-029",
    lat: 45.399912,
    lng: -71.900221,
    panoId: "jqssL2TsTGOSCchPhCL83g",
    place: "Near Sherbrooke, Quebec",
    shortName: "Sherbrooke",
    countryCode: "CA",
    country: "Canada",
    continent: "North America",
    difficulty: "classic",
    pools: ["world","North America","CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ca-030",
    lat: 50.666505,
    lng: -120.319065,
    panoId: "yyGtIVjGG-79nq7ludADiQ",
    place: "Near Kamloops, British Columbia",
    shortName: "Kamloops",
    countryCode: "CA",
    country: "Canada",
    continent: "North America",
    difficulty: "classic",
    pools: ["world","North America","CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ca-031",
    lat: 44.656871,
    lng: -63.58325,
    panoId: "W6Xk2nZq64qYeU8JGJrh6A",
    place: "Near Downtown Halifax, Nova Scotia",
    shortName: "Downtown Halifax",
    countryCode: "CA",
    country: "Canada",
    continent: "North America",
    difficulty: "classic",
    pools: ["world","North America","CA"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "ca-032",
    lat: 46.150143,
    lng: -60.183247,
    panoId: "CA1Iy7C048KP3AsxU6KjCQ",
    place: "Near Whitney Pier, Nova Scotia",
    shortName: "Whitney Pier",
    countryCode: "CA",
    country: "Canada",
    continent: "North America",
    difficulty: "classic",
    pools: ["world","North America","CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ca-033",
    lat: 46.799735,
    lng: -71.19033,
    panoId: "aW0YhELN43K3lxEJbfi2fg",
    place: "Near Lévis, Quebec",
    shortName: "Lévis",
    countryCode: "CA",
    country: "Canada",
    continent: "North America",
    difficulty: "classic",
    pools: ["world","North America","CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ca-034",
    lat: 49.235938,
    lng: -123.093243,
    panoId: "6E1q3dlvi0lmSztq_W0COA",
    place: "Near Punjabi Market, British Columbia",
    shortName: "Punjabi Market",
    countryCode: "CA",
    country: "Canada",
    continent: "North America",
    difficulty: "classic",
    pools: ["world","North America","CA"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "ca-035",
    lat: 49.878283,
    lng: -119.518334,
    panoId: "MllchnoOaU4lIKGe0Ybw4w",
    place: "Near Lakeview Heights, British Columbia",
    shortName: "Lakeview Heights",
    countryCode: "CA",
    country: "Canada",
    continent: "North America",
    difficulty: "classic",
    pools: ["world","North America","CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ca-036",
    lat: 45.403977,
    lng: -71.886971,
    panoId: "3BqnA0lmUyiw8b9rbAtuiw",
    place: "Near Sherbrooke, Quebec",
    shortName: "Sherbrooke",
    countryCode: "CA",
    country: "Canada",
    continent: "North America",
    difficulty: "classic",
    pools: ["world","North America","CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ca-037",
    lat: 47.556976,
    lng: -52.737708,
    panoId: "bsksZQli8yujAuEX9k-F5g",
    place: "Near Wishingwell Park, Newfoundland and Labrador",
    shortName: "Wishingwell Park",
    countryCode: "CA",
    country: "Canada",
    continent: "North America",
    difficulty: "classic",
    pools: ["world","North America","CA"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "ca-038",
    lat: 45.520676,
    lng: -73.593807,
    panoId: "cUQrfeAUDqzwvoIMFeLOeA",
    place: "Near Mile End, Quebec",
    shortName: "Mile End",
    countryCode: "CA",
    country: "Canada",
    continent: "North America",
    difficulty: "classic",
    pools: ["world","North America","CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ca-039",
    lat: 43.403842,
    lng: -80.539872,
    panoId: "3borzRpcfO11m6zvh_buGg",
    place: "Near Mannheim, Ontario",
    shortName: "Mannheim",
    countryCode: "CA",
    country: "Canada",
    continent: "North America",
    difficulty: "classic",
    pools: ["world","North America","CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ca-040",
    lat: 53.553827,
    lng: -113.498477,
    panoId: "DLs5va8rxT3PmhdxLD0pkw",
    place: "Near Central McDougall, Alberta",
    shortName: "Central McDougall",
    countryCode: "CA",
    country: "Canada",
    continent: "North America",
    difficulty: "classic",
    pools: ["world","North America","CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ca-041",
    lat: 49.123789,
    lng: -122.83528,
    panoId: "FBy1kyWAtmr0uw0KEz3s8w",
    place: "Near Newton, British Columbia",
    shortName: "Newton",
    countryCode: "CA",
    country: "Canada",
    continent: "North America",
    difficulty: "classic",
    pools: ["world","North America","CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ca-042",
    lat: 51.042448,
    lng: -114.066035,
    panoId: "o_OFbG7XtaJbjMGtC3B1ZQ",
    place: "Near Beltline, Alberta",
    shortName: "Beltline",
    countryCode: "CA",
    country: "Canada",
    continent: "North America",
    difficulty: "classic",
    pools: ["world","North America","CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ca-043",
    lat: 49.867173,
    lng: -97.152996,
    panoId: "09ObfubQMXGGLzTeYnSv0g",
    place: "Near Winnipeg, Manitoba",
    shortName: "Winnipeg",
    countryCode: "CA",
    country: "Canada",
    continent: "North America",
    difficulty: "classic",
    pools: ["world","North America","CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ca-044",
    lat: 52.124778,
    lng: -106.643167,
    panoId: "h9npu8Yg_7pswnxL4Aud3Q",
    place: "Near Varsity View, Saskatchewan",
    shortName: "Varsity View",
    countryCode: "CA",
    country: "Canada",
    continent: "North America",
    difficulty: "classic",
    pools: ["world","North America","CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ca-045",
    lat: 49.061065,
    lng: -122.273066,
    panoId: "Rn-UCea4sMPTfUjGE4ACvA",
    place: "Near Clayburn, British Columbia",
    shortName: "Clayburn",
    countryCode: "CA",
    country: "Canada",
    continent: "North America",
    difficulty: "classic",
    pools: ["world","North America","CA"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "ca-046",
    lat: 49.694234,
    lng: -112.796517,
    panoId: "LRsQq7Nej4I_jv9AQqtLEQ",
    place: "Near Lethbridge, Alberta",
    shortName: "Lethbridge",
    countryCode: "CA",
    country: "Canada",
    continent: "North America",
    difficulty: "classic",
    pools: ["world","North America","CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ca-047",
    lat: 46.329263,
    lng: -72.551975,
    panoId: "gIoeveJdzJHKHZlP6kjvNg",
    place: "Near Sainte-Catherine, Quebec",
    shortName: "Sainte-Catherine",
    countryCode: "CA",
    country: "Canada",
    continent: "North America",
    difficulty: "classic",
    pools: ["world","North America","CA"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "ca-048",
    lat: 44.651803,
    lng: -63.596021,
    panoId: "BPiQHJhK4j0JnJkd6W2qCQ",
    place: "Near Quinpool District, Nova Scotia",
    shortName: "Quinpool District",
    countryCode: "CA",
    country: "Canada",
    continent: "North America",
    difficulty: "classic",
    pools: ["world","North America","CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ca-049",
    lat: 45.399386,
    lng: -75.760959,
    panoId: "4CfVlEFMu2uniSQ6iZw5uA",
    place: "Near Hintonburg, Ontario",
    shortName: "Hintonburg",
    countryCode: "CA",
    country: "Canada",
    continent: "North America",
    difficulty: "classic",
    pools: ["world","North America","CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ca-050",
    lat: 43.629627,
    lng: -79.633743,
    panoId: "c2t5DIUgHdXLAdsKqAhufw",
    place: "Near Markland Wood, Ontario",
    shortName: "Markland Wood",
    countryCode: "CA",
    country: "Canada",
    continent: "North America",
    difficulty: "explorer",
    pools: ["world","North America","CA"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "ca-051",
    lat: 43.033751,
    lng: -81.273674,
    panoId: "llIDM73-3Ix3YftNZjhSpw",
    place: "Near London, Ontario",
    shortName: "London",
    countryCode: "CA",
    country: "Canada",
    continent: "North America",
    difficulty: "explorer",
    pools: ["world","North America","CA"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "ca-052",
    lat: 43.927144,
    lng: -78.854039,
    panoId: "lzhZRulnGGEDrkosMc9jFA",
    place: "Near Oshawa, Ontario",
    shortName: "Oshawa",
    countryCode: "CA",
    country: "Canada",
    continent: "North America",
    difficulty: "explorer",
    pools: ["world","North America","CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ca-053",
    lat: 44.273095,
    lng: -76.556562,
    panoId: "Yjj7K6CiYxf-sYmjtmyjVQ",
    place: "Near Kingston, Ontario",
    shortName: "Kingston",
    countryCode: "CA",
    country: "Canada",
    continent: "North America",
    difficulty: "explorer",
    pools: ["world","North America","CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ca-054",
    lat: 42.320777,
    lng: -82.954204,
    panoId: "CBr1R9TUPQiWbBOVT6AAkA",
    place: "Near Windsor, Ontario",
    shortName: "Windsor",
    countryCode: "CA",
    country: "Canada",
    continent: "North America",
    difficulty: "explorer",
    pools: ["world","North America","CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ca-055",
    lat: 46.45838,
    lng: -81.001447,
    panoId: "64VQk2tdCaUFoft_-oQn2Q",
    place: "Near Greater Sudbury, Ontario",
    shortName: "Greater Sudbury",
    countryCode: "CA",
    country: "Canada",
    continent: "North America",
    difficulty: "explorer",
    pools: ["world","North America","CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ca-056",
    lat: 43.867812,
    lng: -78.851459,
    panoId: "DAvYCHssgzBiX-yvZmSJAQ",
    place: "Near Oshawa, Ontario",
    shortName: "Oshawa",
    countryCode: "CA",
    country: "Canada",
    continent: "North America",
    difficulty: "explorer",
    pools: ["world","North America","CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ca-057",
    lat: 50.730983,
    lng: -120.368737,
    panoId: "zP1ZPcWXP4Xp0GBVDB522Q",
    place: "Near Batchelor Hills, British Columbia",
    shortName: "Batchelor Hills",
    countryCode: "CA",
    country: "Canada",
    continent: "North America",
    difficulty: "explorer",
    pools: ["world","North America","CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ca-058",
    lat: 48.365948,
    lng: -71.096779,
    panoId: "KtSgCuqZns5tkGw86fnpWQ",
    place: "Near Saguenay, Quebec",
    shortName: "Saguenay",
    countryCode: "CA",
    country: "Canada",
    continent: "North America",
    difficulty: "explorer",
    pools: ["world","North America","CA"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "ca-059",
    lat: 45.370763,
    lng: -71.841789,
    panoId: "VTWewnpa9tlamov3Y_bfuw",
    place: "Near Sherbrooke, Quebec",
    shortName: "Sherbrooke",
    countryCode: "CA",
    country: "Canada",
    continent: "North America",
    difficulty: "explorer",
    pools: ["world","North America","CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ca-060",
    lat: 43.330211,
    lng: -79.792523,
    panoId: "uNogt5nNMDPhdRnFTQ3zQg",
    place: "Near Burlington, Ontario",
    shortName: "Burlington",
    countryCode: "CA",
    country: "Canada",
    continent: "North America",
    difficulty: "explorer",
    pools: ["world","North America","CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ca-061",
    lat: 49.909572,
    lng: -119.49733,
    panoId: "oogRA5kgA911bFwSlRClIA",
    place: "Near Kelowna, British Columbia",
    shortName: "Kelowna",
    countryCode: "CA",
    country: "Canada",
    continent: "North America",
    difficulty: "explorer",
    pools: ["world","North America","CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ca-062",
    lat: 43.059165,
    lng: -81.09437,
    panoId: "0xX9XcF-QOVqWaUNT3BJ8g",
    place: "Near Thamesford, Ontario",
    shortName: "Thamesford",
    countryCode: "CA",
    country: "Canada",
    continent: "North America",
    difficulty: "explorer",
    pools: ["world","North America","CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ca-063",
    lat: 43.078038,
    lng: -79.392192,
    panoId: "L5PnYGUtW_1wvRLw7lZTng",
    place: "Near Vineland, Ontario",
    shortName: "Vineland",
    countryCode: "CA",
    country: "Canada",
    continent: "North America",
    difficulty: "explorer",
    pools: ["world","North America","CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ca-064",
    lat: 43.772514,
    lng: -79.643133,
    panoId: "nWECDJNCoztvK-NziF5S7g",
    place: "Near Mount Olive-Silverstone-Jamestown, Ontario",
    shortName: "Mount Olive-Silverstone-Jamestown",
    countryCode: "CA",
    country: "Canada",
    continent: "North America",
    difficulty: "explorer",
    pools: ["world","North America","CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ca-065",
    lat: 48.380787,
    lng: -89.431627,
    panoId: "bdfTXi8CWfRKIuvVxQ-chA",
    place: "Near Parkdale, Ontario",
    shortName: "Parkdale",
    countryCode: "CA",
    country: "Canada",
    continent: "North America",
    difficulty: "explorer",
    pools: ["world","North America","CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ca-066",
    lat: 49.206834,
    lng: -122.022249,
    panoId: "8BUd513F0NW3tWHFeOdZhg",
    place: "Near Chilliwack Mountain, British Columbia",
    shortName: "Chilliwack Mountain",
    countryCode: "CA",
    country: "Canada",
    continent: "North America",
    difficulty: "explorer",
    pools: ["world","North America","CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ca-067",
    lat: 50.438403,
    lng: -104.686828,
    panoId: "dUEUhy4CdqRk5W1HAQhFKg",
    place: "Near Dieppe-Westerra, Saskatchewan",
    shortName: "Dieppe-Westerra",
    countryCode: "CA",
    country: "Canada",
    continent: "North America",
    difficulty: "explorer",
    pools: ["world","North America","CA"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "ca-068",
    lat: 43.092232,
    lng: -78.823563,
    panoId: "5mRjwvI7Wi9TrddWE61P6w",
    place: "Near North Tonawanda, New York",
    shortName: "North Tonawanda",
    countryCode: "CA",
    country: "Canada",
    continent: "North America",
    difficulty: "explorer",
    pools: ["world","North America","CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ca-069",
    lat: 48.481171,
    lng: -71.105152,
    panoId: "BLMDjoNJB3azZnkJjXZZbQ",
    place: "Near Saint-Honoré, Quebec",
    shortName: "Saint-Honoré",
    countryCode: "CA",
    country: "Canada",
    continent: "North America",
    difficulty: "explorer",
    pools: ["world","North America","CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ca-070",
    lat: 44.275297,
    lng: -76.384743,
    panoId: "jApjOwwvpZTsqQzawDCeRw",
    place: "Near Kingston, Ontario",
    shortName: "Kingston",
    countryCode: "CA",
    country: "Canada",
    continent: "North America",
    difficulty: "explorer",
    pools: ["world","North America","CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ca-071",
    lat: 49.103907,
    lng: -122.332885,
    panoId: "qHO4Yz5JCguGAQtdY_z9rw",
    place: "Near Mission, British Columbia",
    shortName: "Mission",
    countryCode: "CA",
    country: "Canada",
    continent: "North America",
    difficulty: "explorer",
    pools: ["world","North America","CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ca-072",
    lat: 47.527598,
    lng: -52.705945,
    panoId: "vE3O3vBBK4KvgjZDfQhePg",
    place: "Near Shea Heights, Newfoundland and Labrador",
    shortName: "Shea Heights",
    countryCode: "CA",
    country: "Canada",
    continent: "North America",
    difficulty: "explorer",
    pools: ["world","North America","CA"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "ca-073",
    lat: 53.888177,
    lng: -122.664352,
    panoId: "52_QDIiMe6sTSah7WYkn2w",
    place: "Near Prince George, British Columbia",
    shortName: "Prince George",
    countryCode: "CA",
    country: "Canada",
    continent: "North America",
    difficulty: "explorer",
    pools: ["world","North America","CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ca-074",
    lat: 55.19974,
    lng: -118.6981,
    panoId: "UiOxF3QzsO1DlAkDihcnQA",
    place: "Near Westlake, Alberta",
    shortName: "Westlake",
    countryCode: "CA",
    country: "Canada",
    continent: "North America",
    difficulty: "explorer",
    pools: ["world","North America","CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ca-075",
    lat: 45.335243,
    lng: -72.750397,
    panoId: "HpPNyX1-btC7i9sGqee3Wg",
    place: "Near Granby, Quebec",
    shortName: "Granby",
    countryCode: "CA",
    country: "Canada",
    continent: "North America",
    difficulty: "explorer",
    pools: ["world","North America","CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ca-076",
    lat: 56.679838,
    lng: -111.294579,
    panoId: "fiQrMeVOIHaCZ5nobJJiiA",
    place: "Near Fort McMurray, Alberta",
    shortName: "Fort McMurray",
    countryCode: "CA",
    country: "Canada",
    continent: "North America",
    difficulty: "explorer",
    pools: ["world","North America","CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ca-077",
    lat: 49.163707,
    lng: -122.018557,
    panoId: "kI1ndaaCVpDr_SaQqcCCdg",
    place: "Near Chilliwack Mountain, British Columbia",
    shortName: "Chilliwack Mountain",
    countryCode: "CA",
    country: "Canada",
    continent: "North America",
    difficulty: "explorer",
    pools: ["world","North America","CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ca-078",
    lat: 49.795334,
    lng: -99.961894,
    panoId: "azRR-c9Ywj6HysGwFqlLFg",
    place: "Near Brandon, Manitoba",
    shortName: "Brandon",
    countryCode: "CA",
    country: "Canada",
    continent: "North America",
    difficulty: "explorer",
    pools: ["world","North America","CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ca-079",
    lat: 45.603509,
    lng: -72.905319,
    panoId: "MDnWccJevvT0JGYbo5VqnQ",
    place: "Near Saint-Hyacinthe, Quebec",
    shortName: "Saint-Hyacinthe",
    countryCode: "CA",
    country: "Canada",
    continent: "North America",
    difficulty: "explorer",
    pools: ["world","North America","CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ca-080",
    lat: 44.761413,
    lng: -63.575082,
    panoId: "IxTVs8Cc8WtN8VtNeCv5qA",
    place: "Near Waverley, Nova Scotia",
    shortName: "Waverley",
    countryCode: "CA",
    country: "Canada",
    continent: "North America",
    difficulty: "explorer",
    pools: ["world","North America","CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ca-081",
    lat: 50.369961,
    lng: -105.443148,
    panoId: "5wRjDYvqUMn3Y0PGyaazWA",
    place: "Near Moose Jaw, Saskatchewan",
    shortName: "Moose Jaw",
    countryCode: "CA",
    country: "Canada",
    continent: "North America",
    difficulty: "explorer",
    pools: ["world","North America","CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ca-082",
    lat: 50.084356,
    lng: -110.609209,
    panoId: "03S-JWMNmYopuEz4p_7JxQ",
    place: "Near Medicine Hat, Alberta",
    shortName: "Medicine Hat",
    countryCode: "CA",
    country: "Canada",
    continent: "North America",
    difficulty: "explorer",
    pools: ["world","North America","CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ca-083",
    lat: 52.225355,
    lng: -113.718711,
    panoId: "J4ZfafmDO7MY4fq9KNwKFA",
    place: "Near Red Deer, Alberta",
    shortName: "Red Deer",
    countryCode: "CA",
    country: "Canada",
    continent: "North America",
    difficulty: "explorer",
    pools: ["world","North America","CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ca-084",
    lat: 45.991794,
    lng: -73.291311,
    panoId: "KYa97tH9Gawjrk6JA51kuA",
    place: "Near Saint-Thomas, Quebec",
    shortName: "Saint-Thomas",
    countryCode: "CA",
    country: "Canada",
    continent: "North America",
    difficulty: "explorer",
    pools: ["world","North America","CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ca-085",
    lat: 48.571514,
    lng: -123.529212,
    panoId: "mCfvkSXB0tbYVR_mXWypuQ",
    place: "Near Brentwood Bay, British Columbia",
    shortName: "Brentwood Bay",
    countryCode: "CA",
    country: "Canada",
    continent: "North America",
    difficulty: "explorer",
    pools: ["world","North America","CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ca-086",
    lat: 53.291599,
    lng: -110.10307,
    panoId: "jhW0Dzzx6sth7UeIo8PD2g",
    place: "Near Lloydminster, Alberta",
    shortName: "Lloydminster",
    countryCode: "CA",
    country: "Canada",
    continent: "North America",
    difficulty: "explorer",
    pools: ["world","North America","CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ca-087",
    lat: 45.267248,
    lng: -73.96727,
    panoId: "_z6QwoYQHRhqiGTnAh30NQ",
    place: "Near Melocheville, Quebec",
    shortName: "Melocheville",
    countryCode: "CA",
    country: "Canada",
    continent: "North America",
    difficulty: "explorer",
    pools: ["world","North America","CA"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "ca-088",
    lat: 45.232847,
    lng: -66.106928,
    panoId: "lUeiAGAiUE_YxWnMNKZDuA",
    place: "Near Island View Heights, New Brunswick",
    shortName: "Island View Heights",
    countryCode: "CA",
    country: "Canada",
    continent: "North America",
    difficulty: "explorer",
    pools: ["world","North America","CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ca-089",
    lat: 46.408566,
    lng: -72.671398,
    panoId: "qVpZNBpSjvDko5ALurNVVQ",
    place: "Near Trois-Rivières, Quebec",
    shortName: "Trois-Rivières",
    countryCode: "CA",
    country: "Canada",
    continent: "North America",
    difficulty: "explorer",
    pools: ["world","North America","CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ca-090",
    lat: 53.212255,
    lng: -105.831542,
    panoId: "8ifGtlJe-K7WnqQCqIBtJQ",
    place: "Near Prince Albert, Saskatchewan",
    shortName: "Prince Albert",
    countryCode: "CA",
    country: "Canada",
    continent: "North America",
    difficulty: "explorer",
    pools: ["world","North America","CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ca-091",
    lat: 45.824008,
    lng: -74.050933,
    panoId: "wEGnhkhg4DyHVXDY5txaug",
    place: "Near Terrasse-des-Pins, Quebec",
    shortName: "Terrasse-des-Pins",
    countryCode: "CA",
    country: "Canada",
    continent: "North America",
    difficulty: "explorer",
    pools: ["world","North America","CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ca-092",
    lat: 55.188649,
    lng: -118.771526,
    panoId: "tALbbq9e9wRa2zpK76vtxA",
    place: "Near Grande Prairie, Alberta",
    shortName: "Grande Prairie",
    countryCode: "CA",
    country: "Canada",
    continent: "North America",
    difficulty: "explorer",
    pools: ["world","North America","CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ca-093",
    lat: 45.510331,
    lng: -72.804681,
    panoId: "tj7AEOdU2OKZJ2vpYMaq1w",
    place: "Near Saint-Pie, Quebec",
    shortName: "Saint-Pie",
    countryCode: "CA",
    country: "Canada",
    continent: "North America",
    difficulty: "explorer",
    pools: ["world","North America","CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ca-094",
    lat: 56.745195,
    lng: -111.448734,
    panoId: "8GQ4uvcuNgYlgr6e0ZTeWA",
    place: "Near Fort McMurray, Alberta",
    shortName: "Fort McMurray",
    countryCode: "CA",
    country: "Canada",
    continent: "North America",
    difficulty: "explorer",
    pools: ["world","North America","CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ca-095",
    lat: 49.811097,
    lng: -119.62821,
    panoId: "cIHiNjymnIaGAMwvDLi42g",
    place: "Near Gellatly, British Columbia",
    shortName: "Gellatly",
    countryCode: "CA",
    country: "Canada",
    continent: "North America",
    difficulty: "explorer",
    pools: ["world","North America","CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ca-096",
    lat: 50.426061,
    lng: -105.496686,
    panoId: "SHSLK6TJtL1HYrEBCYcEIA",
    place: "Near Moose Jaw, Saskatchewan",
    shortName: "Moose Jaw",
    countryCode: "CA",
    country: "Canada",
    continent: "North America",
    difficulty: "explorer",
    pools: ["world","North America","CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ca-097",
    lat: 50.000622,
    lng: -110.670002,
    panoId: "z4A4pm_hhn434HJ1uG8tFQ",
    place: "Near Medicine Hat, Alberta",
    shortName: "Medicine Hat",
    countryCode: "CA",
    country: "Canada",
    continent: "North America",
    difficulty: "explorer",
    pools: ["world","North America","CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ca-098",
    lat: 50.061443,
    lng: -125.275844,
    panoId: "xtK8GHgI7MM5RxmRMDRGxQ",
    place: "Near Campbell River, British Columbia",
    shortName: "Campbell River",
    countryCode: "CA",
    country: "Canada",
    continent: "North America",
    difficulty: "explorer",
    pools: ["world","North America","CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ca-099",
    lat: 49.808889,
    lng: -99.93139,
    panoId: "DTGRHQBvdZ6VK8HojT_TXQ",
    place: "Near Brandon, Manitoba",
    shortName: "Brandon",
    countryCode: "CA",
    country: "Canada",
    continent: "North America",
    difficulty: "explorer",
    pools: ["world","North America","CA"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "ca-100",
    lat: 46.6004,
    lng: -72.504873,
    panoId: "JeUv3ooeOLLuiRt8Vzd6Ig",
    place: "Near Saint-Narcisse, Quebec",
    shortName: "Saint-Narcisse",
    countryCode: "CA",
    country: "Canada",
    continent: "North America",
    difficulty: "adventurer",
    pools: ["world","North America","CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ca-101",
    lat: 45.978069,
    lng: -72.853845,
    panoId: "NHvWhDhJ5Y5_8NnDFQnCtA",
    place: "Near Saint-Pie-V, Quebec",
    shortName: "Saint-Pie-V",
    countryCode: "CA",
    country: "Canada",
    continent: "North America",
    difficulty: "adventurer",
    pools: ["world","North America","CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ca-102",
    lat: 47.289882,
    lng: -68.164715,
    panoId: "GTDLNBcPyfP0ZlMTueox7w",
    place: "Near Madawaska, Maine",
    shortName: "Madawaska",
    countryCode: "CA",
    country: "Canada",
    continent: "North America",
    difficulty: "adventurer",
    pools: ["world","North America","CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ca-103",
    lat: 46.404282,
    lng: -63.033078,
    panoId: "qceb5PGdXp2Mh0AOYNjOiQ",
    place: "Near East Royalty, Prince Edward Island",
    shortName: "East Royalty",
    countryCode: "CA",
    country: "Canada",
    continent: "North America",
    difficulty: "adventurer",
    pools: ["world","North America","CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ca-104",
    lat: 49.846841,
    lng: -98.437874,
    panoId: "VPs5jx30Buam531FntYZTQ",
    place: "Near Portage la Prairie, Manitoba",
    shortName: "Portage la Prairie",
    countryCode: "CA",
    country: "Canada",
    continent: "North America",
    difficulty: "adventurer",
    pools: ["world","North America","CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ca-105",
    lat: 49.10069,
    lng: -58.09746,
    panoId: "lTIUK6qXzHNfYsSUYvXRlg",
    place: "Near Humber Arm South, Newfoundland and Labrador",
    shortName: "Humber Arm South",
    countryCode: "CA",
    country: "Canada",
    continent: "North America",
    difficulty: "adventurer",
    pools: ["world","North America","CA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "mx-000",
    lat: 19.605129,
    lng: -99.060727,
    panoId: "x5k7JPyzBrHU0Fimnafjyg",
    place: "Near Ecatepec de Morelos, México",
    shortName: "Ecatepec de Morelos",
    countryCode: "MX",
    country: "Mexico",
    continent: "North America",
    difficulty: "classic",
    pools: ["world","North America","MX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "mx-001",
    lat: 29.088769,
    lng: -110.966785,
    panoId: "gFV5GBHSK9ByC9pHIKNqqw",
    place: "Near Hermosillo, Sonora",
    shortName: "Hermosillo",
    countryCode: "MX",
    country: "Mexico",
    continent: "North America",
    difficulty: "classic",
    pools: ["world","North America","MX"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "mx-002",
    lat: 19.355181,
    lng: -99.061635,
    panoId: "lfmbPQzqDFTtFOK7G4PurA",
    place: "Near Iztapalapa, Mexico City",
    shortName: "Iztapalapa",
    countryCode: "MX",
    country: "Mexico",
    continent: "North America",
    difficulty: "classic",
    pools: ["world","North America","MX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "mx-003",
    lat: 26.080054,
    lng: -98.284522,
    panoId: "Ra9UUzxew-7fTqKdT7MYhw",
    place: "Near Reynosa, Tamaulipas",
    shortName: "Reynosa",
    countryCode: "MX",
    country: "Mexico",
    continent: "North America",
    difficulty: "classic",
    pools: ["world","North America","MX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "mx-004",
    lat: 21.174041,
    lng: -86.846411,
    panoId: "JkbDBVBbK8kvjDXzKov_AA",
    place: "Near Cancún, Quintana Roo",
    shortName: "Cancún",
    countryCode: "MX",
    country: "Mexico",
    continent: "North America",
    difficulty: "classic",
    pools: ["world","North America","MX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "mx-005",
    lat: 20.677372,
    lng: -103.347512,
    panoId: "AcpLedCnHH0Rs0HIqahTAA",
    place: "Near Guadalajara, Jalisco",
    shortName: "Guadalajara",
    countryCode: "MX",
    country: "Mexico",
    continent: "North America",
    difficulty: "classic",
    pools: ["world","North America","MX"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "mx-006",
    lat: 20.641166,
    lng: -103.29339,
    panoId: "o2m0rvQhOQVSHRsdfyAJTw",
    place: "Near Tlaquepaque, Jalisco",
    shortName: "Tlaquepaque",
    countryCode: "MX",
    country: "Mexico",
    continent: "North America",
    difficulty: "classic",
    pools: ["world","North America","MX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "mx-007",
    lat: 22.152385,
    lng: -100.971329,
    panoId: "VSqF9RGKBlhG3DH_-6opXw",
    place: "Near San Luis Potosí, San Luis Potosí",
    shortName: "San Luis Potosí",
    countryCode: "MX",
    country: "Mexico",
    continent: "North America",
    difficulty: "classic",
    pools: ["world","North America","MX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "mx-008",
    lat: 19.540107,
    lng: -99.195382,
    panoId: "kPoeBckb-4vJzan8UwkUug",
    place: "Near Tlalnepantla, México",
    shortName: "Tlalnepantla",
    countryCode: "MX",
    country: "Mexico",
    continent: "North America",
    difficulty: "classic",
    pools: ["world","North America","MX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "mx-009",
    lat: 19.428494,
    lng: -99.127639,
    panoId: "Fx3kA7ZXGve9o315ZP8Yvg",
    place: "Near Mexico City, Mexico City",
    shortName: "Mexico City",
    countryCode: "MX",
    country: "Mexico",
    continent: "North America",
    difficulty: "classic",
    pools: ["world","North America","MX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "mx-010",
    lat: 25.543921,
    lng: -103.41893,
    panoId: "HD-VW9vpr5g7naNcECRgwg",
    place: "Near Torreón, Coahuila",
    shortName: "Torreón",
    countryCode: "MX",
    country: "Mexico",
    continent: "North America",
    difficulty: "classic",
    pools: ["world","North America","MX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "mx-011",
    lat: 25.425977,
    lng: -100.97964,
    panoId: "YUrR9K7yYdBs6hu4BPye4w",
    place: "Near Saltillo, Coahuila",
    shortName: "Saltillo",
    countryCode: "MX",
    country: "Mexico",
    continent: "North America",
    difficulty: "classic",
    pools: ["world","North America","MX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "mx-012",
    lat: 19.34713,
    lng: -99.161605,
    panoId: "6eg3FeJn0wJCb8p6UHUHuA",
    place: "Near Coyoacán, Mexico City",
    shortName: "Coyoacán",
    countryCode: "MX",
    country: "Mexico",
    continent: "North America",
    difficulty: "classic",
    pools: ["world","North America","MX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "mx-013",
    lat: 20.721113,
    lng: -103.387457,
    panoId: "yzgD2T8iPZFhr1UGG57Ghw",
    place: "Near Zapopan, Jalisco",
    shortName: "Zapopan",
    countryCode: "MX",
    country: "Mexico",
    continent: "North America",
    difficulty: "classic",
    pools: ["world","North America","MX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "mx-014",
    lat: 16.75353,
    lng: -93.115765,
    panoId: "5IZXzIm8Jy89qMhNDie9bg",
    place: "Near Tuxtla, Chiapas",
    shortName: "Tuxtla",
    countryCode: "MX",
    country: "Mexico",
    continent: "North America",
    difficulty: "classic",
    pools: ["world","North America","MX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "mx-015",
    lat: 16.849366,
    lng: -99.908905,
    panoId: "TVVDc63-irAJkq9XCIq7Pw",
    place: "Near Acapulco de Juárez, Guerrero",
    shortName: "Acapulco de Juárez",
    countryCode: "MX",
    country: "Mexico",
    continent: "North America",
    difficulty: "classic",
    pools: ["world","North America","MX"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "mx-016",
    lat: 19.643983,
    lng: -99.215872,
    panoId: "FuhD9Mr3ZH46u_DIlmCqnQ",
    place: "Near Cuautitlán Izcalli, México",
    shortName: "Cuautitlán Izcalli",
    countryCode: "MX",
    country: "Mexico",
    continent: "North America",
    difficulty: "classic",
    pools: ["world","North America","MX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "mx-017",
    lat: 20.588101,
    lng: -100.387965,
    panoId: "HPoGWCtKGQQBgC0IhW4xkQ",
    place: "Near Santiago de Querétaro, Querétaro",
    shortName: "Santiago de Querétaro",
    countryCode: "MX",
    country: "Mexico",
    continent: "North America",
    difficulty: "classic",
    pools: ["world","North America","MX"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "mx-018",
    lat: 19.445125,
    lng: -99.146116,
    panoId: "FGQL_68TqKyjpVkv8Ey1Gg",
    place: "Near Cuauhtémoc, Mexico City",
    shortName: "Cuauhtémoc",
    countryCode: "MX",
    country: "Mexico",
    continent: "North America",
    difficulty: "classic",
    pools: ["world","North America","MX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "mx-019",
    lat: 21.882653,
    lng: -102.284336,
    panoId: "tjpbE1CSm93r1nPmcqSjGg",
    place: "Near Aguascalientes, Aguascalientes",
    shortName: "Aguascalientes",
    countryCode: "MX",
    country: "Mexico",
    continent: "North America",
    difficulty: "classic",
    pools: ["world","North America","MX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "mx-020",
    lat: 25.68432,
    lng: -100.317245,
    panoId: "vSUgJ4jWHKgKVeXoOIXB9A",
    place: "Near Monterrey, Nuevo León",
    shortName: "Monterrey",
    countryCode: "MX",
    country: "Mexico",
    continent: "North America",
    difficulty: "classic",
    pools: ["world","North America","MX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "mx-021",
    lat: 20.967039,
    lng: -89.62317,
    panoId: "O6bKnuyLCnN8F-zGOvVL1Q",
    place: "Near Mérida, Yucatán",
    shortName: "Mérida",
    countryCode: "MX",
    country: "Mexico",
    continent: "North America",
    difficulty: "classic",
    pools: ["world","North America","MX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "mx-022",
    lat: 32.628263,
    lng: -115.453805,
    panoId: "OYohiAVhPFMyIkFUYtB5Hw",
    place: "Near Mexicali, Baja California",
    shortName: "Mexicali",
    countryCode: "MX",
    country: "Mexico",
    continent: "North America",
    difficulty: "classic",
    pools: ["world","North America","MX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "mx-023",
    lat: 19.700712,
    lng: -101.18442,
    panoId: "0KQdDRHgnbwzprt-rOjjFg",
    place: "Near Morelia, Michoacán",
    shortName: "Morelia",
    countryCode: "MX",
    country: "Mexico",
    continent: "North America",
    difficulty: "classic",
    pools: ["world","North America","MX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "mx-024",
    lat: 24.802113,
    lng: -107.394215,
    panoId: "o47uQQ8dhFPb5Gi5dfA4fw",
    place: "Near Culiacán, Sinaloa",
    shortName: "Culiacán",
    countryCode: "MX",
    country: "Mexico",
    continent: "North America",
    difficulty: "classic",
    pools: ["world","North America","MX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "mx-025",
    lat: 19.400594,
    lng: -99.01473,
    panoId: "Ul_h7RQQYofpVI6teULPyQ",
    place: "Near Ciudad Nezahualcoyotl, México",
    shortName: "Ciudad Nezahualcoyotl",
    countryCode: "MX",
    country: "Mexico",
    continent: "North America",
    difficulty: "classic",
    pools: ["world","North America","MX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "mx-026",
    lat: 19.294882,
    lng: -99.161885,
    panoId: "2BsYeHh385L0sNL3uGA_Og",
    place: "Near Tlalpan, Mexico City",
    shortName: "Tlalpan",
    countryCode: "MX",
    country: "Mexico",
    continent: "North America",
    difficulty: "classic",
    pools: ["world","North America","MX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "mx-027",
    lat: 21.121825,
    lng: -101.682547,
    panoId: "Ojk5VGMgwhLtjlgy7YC8MA",
    place: "Near León de los Aldama, Guanajuato",
    shortName: "León de los Aldama",
    countryCode: "MX",
    country: "Mexico",
    continent: "North America",
    difficulty: "classic",
    pools: ["world","North America","MX"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "mx-028",
    lat: 28.63534,
    lng: -106.088881,
    panoId: "6LxgsI3CZuRoCA6c9aVT2Q",
    place: "Near Chihuahua, Chihuahua",
    shortName: "Chihuahua",
    countryCode: "MX",
    country: "Mexico",
    continent: "North America",
    difficulty: "classic",
    pools: ["world","North America","MX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "mx-029",
    lat: 24.020296,
    lng: -104.657297,
    panoId: "GLmQpNb0yLCaHqffqZP_Ng",
    place: "Near Victoria de Durango, Durango",
    shortName: "Victoria de Durango",
    countryCode: "MX",
    country: "Mexico",
    continent: "North America",
    difficulty: "classic",
    pools: ["world","North America","MX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "mx-030",
    lat: 31.720213,
    lng: -106.460814,
    panoId: "zXjkzFq1Uvv6JtSaQJ9Q9A",
    place: "Near Ciudad Juárez, Chihuahua",
    shortName: "Ciudad Juárez",
    countryCode: "MX",
    country: "Mexico",
    continent: "North America",
    difficulty: "classic",
    pools: ["world","North America","MX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "mx-031",
    lat: 25.676627,
    lng: -100.256474,
    panoId: "zC7mYLMtmzaReRUfnQTxJg",
    place: "Near Guadalupe, Nuevo León",
    shortName: "Guadalupe",
    countryCode: "MX",
    country: "Mexico",
    continent: "North America",
    difficulty: "classic",
    pools: ["world","North America","MX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "mx-032",
    lat: 19.493956,
    lng: -99.110776,
    panoId: "pEwE0Mwi-vfpQ5HqmrK-RQ",
    place: "Near Gustavo Adolfo Madero, Mexico City",
    shortName: "Gustavo Adolfo Madero",
    countryCode: "MX",
    country: "Mexico",
    continent: "North America",
    difficulty: "classic",
    pools: ["world","North America","MX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "mx-033",
    lat: 19.047834,
    lng: -98.207215,
    panoId: "-2YUMm2T_cqpy2HzLXYq7Q",
    place: "Near Puebla, Puebla",
    shortName: "Puebla",
    countryCode: "MX",
    country: "Mexico",
    continent: "North America",
    difficulty: "classic",
    pools: ["world","North America","MX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "mx-034",
    lat: 25.879741,
    lng: -97.504105,
    panoId: "cTQ32O3RJoLfIkXZUB6qEQ",
    place: "Near Heroica Matamoros, Tamaulipas",
    shortName: "Heroica Matamoros",
    countryCode: "MX",
    country: "Mexico",
    continent: "North America",
    difficulty: "classic",
    pools: ["world","North America","MX"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "mx-035",
    lat: 19.557905,
    lng: -99.256834,
    panoId: "rb3D-PxLoh5Brm-0rfUPPA",
    place: "Near Ciudad López Mateos, México",
    shortName: "Ciudad López Mateos",
    countryCode: "MX",
    country: "Mexico",
    continent: "North America",
    difficulty: "classic",
    pools: ["world","North America","MX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "mx-036",
    lat: 25.415342,
    lng: -100.966903,
    panoId: "5fWuofQGTkJFmDnWfWQF0A",
    place: "Near Saltillo, Coahuila",
    shortName: "Saltillo",
    countryCode: "MX",
    country: "Mexico",
    continent: "North America",
    difficulty: "classic",
    pools: ["world","North America","MX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "mx-037",
    lat: 19.305212,
    lng: -99.15082,
    panoId: "36WOgAZVTRVKQsT7w6SWVw",
    place: "Near Tlalpan, Mexico City",
    shortName: "Tlalpan",
    countryCode: "MX",
    country: "Mexico",
    continent: "North America",
    difficulty: "classic",
    pools: ["world","North America","MX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "mx-038",
    lat: 25.781995,
    lng: -100.188355,
    panoId: "UOd5ZdvrsMNTQysipSmb2g",
    place: "Near Ciudad Apodaca, Nuevo León",
    shortName: "Ciudad Apodaca",
    countryCode: "MX",
    country: "Mexico",
    continent: "North America",
    difficulty: "classic",
    pools: ["world","North America","MX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "mx-039",
    lat: 19.462711,
    lng: -99.239006,
    panoId: "wGHXOhfo9g9abu2R1rWAKQ",
    place: "Near Naucalpan de Juárez, México",
    shortName: "Naucalpan de Juárez",
    countryCode: "MX",
    country: "Mexico",
    continent: "North America",
    difficulty: "classic",
    pools: ["world","North America","MX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "mx-040",
    lat: 19.288111,
    lng: -99.653216,
    panoId: "o8MRbKcIECMc8o27tn8lbA",
    place: "Near Toluca, México",
    shortName: "Toluca",
    countryCode: "MX",
    country: "Mexico",
    continent: "North America",
    difficulty: "classic",
    pools: ["world","North America","MX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "mx-041",
    lat: 19.4111,
    lng: -99.02875,
    panoId: "dl0iSRiDijQBPacqbhCMrQ",
    place: "Near Ciudad Nezahualcoyotl, México",
    shortName: "Ciudad Nezahualcoyotl",
    countryCode: "MX",
    country: "Mexico",
    continent: "North America",
    difficulty: "classic",
    pools: ["world","North America","MX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "mx-042",
    lat: 20.587096,
    lng: -100.3743,
    panoId: "qGdWiVEfTUIRtZ8TUiy7vw",
    place: "Near Santiago de Querétaro, Querétaro",
    shortName: "Santiago de Querétaro",
    countryCode: "MX",
    country: "Mexico",
    continent: "North America",
    difficulty: "classic",
    pools: ["world","North America","MX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "mx-043",
    lat: 19.449595,
    lng: -99.1236,
    panoId: "76dDZGDad-6iHBVEhZz3xg",
    place: "Near Venustiano Carranza, Mexico City",
    shortName: "Venustiano Carranza",
    countryCode: "MX",
    country: "Mexico",
    continent: "North America",
    difficulty: "classic",
    pools: ["world","North America","MX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "mx-044",
    lat: 20.703035,
    lng: -103.385203,
    panoId: "6PG0B5WWdjbtPw-uFHj0AQ",
    place: "Near Zapopan, Jalisco",
    shortName: "Zapopan",
    countryCode: "MX",
    country: "Mexico",
    continent: "North America",
    difficulty: "classic",
    pools: ["world","North America","MX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "mx-045",
    lat: 32.49839,
    lng: -116.979806,
    panoId: "U-qC_44MZMA0_abpRY4XMA",
    place: "Near Tijuana, Baja California",
    shortName: "Tijuana",
    countryCode: "MX",
    country: "Mexico",
    continent: "North America",
    difficulty: "classic",
    pools: ["world","North America","MX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "mx-046",
    lat: 31.713286,
    lng: -106.476857,
    panoId: "vyi1gpXuCk-rHCLftS9XAA",
    place: "Near Ciudad Juárez, Chihuahua",
    shortName: "Ciudad Juárez",
    countryCode: "MX",
    country: "Mexico",
    continent: "North America",
    difficulty: "classic",
    pools: ["world","North America","MX"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "mx-047",
    lat: 21.159323,
    lng: -86.851862,
    panoId: "9NmLMLX26JOoPLowwKTe8Q",
    place: "Near Cancún, Quintana Roo",
    shortName: "Cancún",
    countryCode: "MX",
    country: "Mexico",
    continent: "North America",
    difficulty: "classic",
    pools: ["world","North America","MX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "mx-048",
    lat: 29.068077,
    lng: -110.959614,
    panoId: "4vIK1kHQ4zJou7uSk1h8Ig",
    place: "Near Hermosillo, Sonora",
    shortName: "Hermosillo",
    countryCode: "MX",
    country: "Mexico",
    continent: "North America",
    difficulty: "classic",
    pools: ["world","North America","MX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "mx-049",
    lat: 25.70106,
    lng: -100.316913,
    panoId: "vckBySLFuVrphtSi5TXWmA",
    place: "Near Monterrey, Nuevo León",
    shortName: "Monterrey",
    countryCode: "MX",
    country: "Mexico",
    continent: "North America",
    difficulty: "classic",
    pools: ["world","North America","MX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "mx-050",
    lat: 19.07405,
    lng: -98.15122,
    panoId: "A5xS3buxKqWyo79yUD86Jg",
    place: "Near San Sebastián de Aparicio, Puebla",
    shortName: "San Sebastián de Aparicio",
    countryCode: "MX",
    country: "Mexico",
    continent: "North America",
    difficulty: "explorer",
    pools: ["world","North America","MX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "mx-051",
    lat: 19.35069,
    lng: -99.127128,
    panoId: "_x0lJLBV3ZcrrSfiz8FZcQ",
    place: "Near Colonia Nativitas, Mexico City",
    shortName: "Colonia Nativitas",
    countryCode: "MX",
    country: "Mexico",
    continent: "North America",
    difficulty: "explorer",
    pools: ["world","North America","MX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "mx-052",
    lat: 25.895088,
    lng: -97.545909,
    panoId: "vfXeid2bGbfqGPK1MCiQ-A",
    place: "Near Heroica Matamoros, Tamaulipas",
    shortName: "Heroica Matamoros",
    countryCode: "MX",
    country: "Mexico",
    continent: "North America",
    difficulty: "explorer",
    pools: ["world","North America","MX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "mx-053",
    lat: 29.064698,
    lng: -111.001671,
    panoId: "4YUWgOM-7Sma2MldLtlVAg",
    place: "Near Hermosillo, Sonora",
    shortName: "Hermosillo",
    countryCode: "MX",
    country: "Mexico",
    continent: "North America",
    difficulty: "explorer",
    pools: ["world","North America","MX"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "mx-054",
    lat: 25.423723,
    lng: -100.91195,
    panoId: "eFZ5SoHaWxo4x_794bVUSQ",
    place: "Near Saltillo, Coahuila",
    shortName: "Saltillo",
    countryCode: "MX",
    country: "Mexico",
    continent: "North America",
    difficulty: "explorer",
    pools: ["world","North America","MX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "mx-055",
    lat: 20.731642,
    lng: -103.339521,
    panoId: "7CpuKcwVHF62Eb5ZRmue9w",
    place: "Near Zapopan, Jalisco",
    shortName: "Zapopan",
    countryCode: "MX",
    country: "Mexico",
    continent: "North America",
    difficulty: "explorer",
    pools: ["world","North America","MX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "mx-056",
    lat: 21.864154,
    lng: -102.226715,
    panoId: "KuJbUXkkfM9OaRcuYF1xlQ",
    place: "Near Norias del Paso Hondo, Aguascalientes",
    shortName: "Norias del Paso Hondo",
    countryCode: "MX",
    country: "Mexico",
    continent: "North America",
    difficulty: "explorer",
    pools: ["world","North America","MX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "mx-057",
    lat: 19.284326,
    lng: -99.210351,
    panoId: "GYsbHpF59eD2uGRGDysBpQ",
    place: "Near Tlalpan, Mexico City",
    shortName: "Tlalpan",
    countryCode: "MX",
    country: "Mexico",
    continent: "North America",
    difficulty: "explorer",
    pools: ["world","North America","MX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "mx-058",
    lat: 16.88104,
    lng: -99.876333,
    panoId: "3s-R2QfLGM88rOv439MwkA",
    place: "Near Acapulco de Juárez, Guerrero",
    shortName: "Acapulco de Juárez",
    countryCode: "MX",
    country: "Mexico",
    continent: "North America",
    difficulty: "explorer",
    pools: ["world","North America","MX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "mx-059",
    lat: 28.652349,
    lng: -106.062774,
    panoId: "pvchPUT6YYVBLQLhwDcQ7Q",
    place: "Near Chihuahua, Chihuahua",
    shortName: "Chihuahua",
    countryCode: "MX",
    country: "Mexico",
    continent: "North America",
    difficulty: "explorer",
    pools: ["world","North America","MX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "mx-060",
    lat: 19.608585,
    lng: -99.258801,
    panoId: "1A6hwuO34ambXUDpIXsvZA",
    place: "Near Ejido de Guadalupe, México",
    shortName: "Ejido de Guadalupe",
    countryCode: "MX",
    country: "Mexico",
    continent: "North America",
    difficulty: "explorer",
    pools: ["world","North America","MX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "mx-061",
    lat: 21.154461,
    lng: -86.819205,
    panoId: "hohxc4s18EXhOn8J-xSixw",
    place: "Near Cancún, Quintana Roo",
    shortName: "Cancún",
    countryCode: "MX",
    country: "Mexico",
    continent: "North America",
    difficulty: "explorer",
    pools: ["world","North America","MX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "mx-062",
    lat: 19.418424,
    lng: -99.079518,
    panoId: "duJDYVvtfBG2sx--nxW6yA",
    place: "Near Iztacalco, Mexico City",
    shortName: "Iztacalco",
    countryCode: "MX",
    country: "Mexico",
    continent: "North America",
    difficulty: "explorer",
    pools: ["world","North America","MX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "mx-063",
    lat: 26.039793,
    lng: -98.220084,
    panoId: "VuBZC9Y61OEkI6uM2cCu5w",
    place: "Near Hidalgo, Tamaulipas",
    shortName: "Hidalgo",
    countryCode: "MX",
    country: "Mexico",
    continent: "North America",
    difficulty: "explorer",
    pools: ["world","North America","MX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "mx-064",
    lat: 19.508669,
    lng: -99.279066,
    panoId: "_Ww5bG271s_tKGKc8zTqxQ",
    place: "Near Rincón Verde, México",
    shortName: "Rincón Verde",
    countryCode: "MX",
    country: "Mexico",
    continent: "North America",
    difficulty: "explorer",
    pools: ["world","North America","MX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "mx-065",
    lat: 20.95269,
    lng: -89.68771,
    panoId: "1C4opkxg-imweW0GIGIvLg",
    place: "Near Paseos de Itzincab, Yucatán",
    shortName: "Paseos de Itzincab",
    countryCode: "MX",
    country: "Mexico",
    continent: "North America",
    difficulty: "explorer",
    pools: ["world","North America","MX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "mx-066",
    lat: 25.82288,
    lng: -100.263762,
    panoId: "Z_3oSdDxLCFtptwbUWtGeQ",
    place: "Near Fraccionamiento Cosmópolis Octavo Sector, Nuevo León",
    shortName: "Fraccionamiento Cosmópolis Octavo Sector",
    countryCode: "MX",
    country: "Mexico",
    continent: "North America",
    difficulty: "explorer",
    pools: ["world","North America","MX"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "mx-067",
    lat: 19.487738,
    lng: -96.961582,
    panoId: "6Sh9LO3se4hXX4k6S-Dvmg",
    place: "Near La Laguna, Veracruz",
    shortName: "La Laguna",
    countryCode: "MX",
    country: "Mexico",
    continent: "North America",
    difficulty: "explorer",
    pools: ["world","North America","MX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "mx-068",
    lat: 31.878299,
    lng: -116.525552,
    panoId: "yF9sBYDyePjW392pVTKubQ",
    place: "Near Colonia Gómez Morín, Baja California",
    shortName: "Colonia Gómez Morín",
    countryCode: "MX",
    country: "Mexico",
    continent: "North America",
    difficulty: "explorer",
    pools: ["world","North America","MX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "mx-069",
    lat: 19.196619,
    lng: -96.187439,
    panoId: "Lfw8gOdaEHc2hcVEGxvlyg",
    place: "Near Lomas de Río Medio Cuatro, Veracruz",
    shortName: "Lomas de Río Medio Cuatro",
    countryCode: "MX",
    country: "Mexico",
    continent: "North America",
    difficulty: "explorer",
    pools: ["world","North America","MX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "mx-070",
    lat: 19.57768,
    lng: -99.149983,
    panoId: "d33FKzzW5QJ9jOgF19q49A",
    place: "Near Sierra de Guadalupe, México",
    shortName: "Sierra de Guadalupe",
    countryCode: "MX",
    country: "Mexico",
    continent: "North America",
    difficulty: "explorer",
    pools: ["world","North America","MX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "mx-071",
    lat: 32.483479,
    lng: -117.064549,
    panoId: "VSucNTNAEZG6mP5mT0PlEA",
    place: "Near Colinas del Sol, Baja California",
    shortName: "Colinas del Sol",
    countryCode: "MX",
    country: "Mexico",
    continent: "North America",
    difficulty: "explorer",
    pools: ["world","North America","MX"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "mx-072",
    lat: 20.74292,
    lng: -103.360426,
    panoId: "H3zFxxsT6--wM3qMnki49A",
    place: "Near Zapopan, Jalisco",
    shortName: "Zapopan",
    countryCode: "MX",
    country: "Mexico",
    continent: "North America",
    difficulty: "explorer",
    pools: ["world","North America","MX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "mx-073",
    lat: 27.415378,
    lng: -99.481221,
    panoId: "UZpILnT6h8Gv7ZCub0C89w",
    place: "Near Rio Bravo, Texas",
    shortName: "Rio Bravo",
    countryCode: "MX",
    country: "Mexico",
    continent: "North America",
    difficulty: "explorer",
    pools: ["world","North America","MX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "mx-074",
    lat: 19.292112,
    lng: -98.905046,
    panoId: "MhWpbwqCWx9gIDetYFzG-w",
    place: "Near Chalco, México",
    shortName: "Chalco",
    countryCode: "MX",
    country: "Mexico",
    continent: "North America",
    difficulty: "explorer",
    pools: ["world","North America","MX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "mx-075",
    lat: 14.96016,
    lng: -92.274946,
    panoId: "dcx4GbFw5AoVqLhqNajPwA",
    place: "Near Veinte de Noviembre, Chiapas",
    shortName: "Veinte de Noviembre",
    countryCode: "MX",
    country: "Mexico",
    continent: "North America",
    difficulty: "explorer",
    pools: ["world","North America","MX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "mx-076",
    lat: 22.167826,
    lng: -101.029479,
    panoId: "MJRR3sEk3klz4UsrysRRsA",
    place: "Near Paisanos, San Luis Potosí",
    shortName: "Paisanos",
    countryCode: "MX",
    country: "Mexico",
    continent: "North America",
    difficulty: "explorer",
    pools: ["world","North America","MX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "mx-077",
    lat: 25.560697,
    lng: -103.38111,
    panoId: "FXOxWOHvBEqCimcKeAW87w",
    place: "Near Fraccionamiento la Noria, Coahuila",
    shortName: "Fraccionamiento la Noria",
    countryCode: "MX",
    country: "Mexico",
    continent: "North America",
    difficulty: "explorer",
    pools: ["world","North America","MX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "mx-078",
    lat: 26.044417,
    lng: -98.331707,
    panoId: "11WAIyl4hlsB41HsrV6d8Q",
    place: "Near Reynosa, Tamaulipas",
    shortName: "Reynosa",
    countryCode: "MX",
    country: "Mexico",
    continent: "North America",
    difficulty: "explorer",
    pools: ["world","North America","MX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "mx-079",
    lat: 25.614742,
    lng: -100.287173,
    panoId: "WdHE7MlVF4pud5tIqDZfaw",
    place: "Near Guadalupe, Nuevo León",
    shortName: "Guadalupe",
    countryCode: "MX",
    country: "Mexico",
    continent: "North America",
    difficulty: "explorer",
    pools: ["world","North America","MX"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "mx-080",
    lat: 19.458484,
    lng: -102.080104,
    panoId: "-XE6YLxhuCgcaxhBPtfs3g",
    place: "Near Uruapan, Michoacán",
    shortName: "Uruapan",
    countryCode: "MX",
    country: "Mexico",
    continent: "North America",
    difficulty: "explorer",
    pools: ["world","North America","MX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "mx-081",
    lat: 19.31665,
    lng: -99.637743,
    panoId: "8YBi7aWUfCr0Yml73dI8GA",
    place: "Near Toluca, México",
    shortName: "Toluca",
    countryCode: "MX",
    country: "Mexico",
    continent: "North America",
    difficulty: "explorer",
    pools: ["world","North America","MX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "mx-082",
    lat: 19.259126,
    lng: -99.046928,
    panoId: "rTGSZmVnyhe4Gll-j790-A",
    place: "Near Tláhuac, Mexico City",
    shortName: "Tláhuac",
    countryCode: "MX",
    country: "Mexico",
    continent: "North America",
    difficulty: "explorer",
    pools: ["world","North America","MX"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "mx-083",
    lat: 19.691678,
    lng: -99.371263,
    panoId: "ZEQsoCbN3PaJ4NxJM5I5zw",
    place: "Near El Puerto Magú, México",
    shortName: "El Puerto Magú",
    countryCode: "MX",
    country: "Mexico",
    continent: "North America",
    difficulty: "explorer",
    pools: ["world","North America","MX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "mx-084",
    lat: 19.531257,
    lng: -99.357981,
    panoId: "r_TU0s-Ac--EyqA0BOIcBQ",
    place: "Near Santa María Mazatla, México",
    shortName: "Santa María Mazatla",
    countryCode: "MX",
    country: "Mexico",
    continent: "North America",
    difficulty: "explorer",
    pools: ["world","North America","MX"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "mx-085",
    lat: 19.441804,
    lng: -98.978931,
    panoId: "xbPWfSkJJ4-8b29b_mDSww",
    place: "Near Polígonos, México",
    shortName: "Polígonos",
    countryCode: "MX",
    country: "Mexico",
    continent: "North America",
    difficulty: "explorer",
    pools: ["world","North America","MX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "mx-086",
    lat: 19.47774,
    lng: -96.791793,
    panoId: "7Y5XRHXSQg_HDz0FxIeYQQ",
    place: "Near Dos Ríos, Veracruz",
    shortName: "Dos Ríos",
    countryCode: "MX",
    country: "Mexico",
    continent: "North America",
    difficulty: "explorer",
    pools: ["world","North America","MX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "mx-087",
    lat: 31.868632,
    lng: -116.663339,
    panoId: "wtmiYQfaSqZsjY1wLvgaDw",
    place: "Near El Sauzal de Rodríguez, Baja California",
    shortName: "El Sauzal de Rodríguez",
    countryCode: "MX",
    country: "Mexico",
    continent: "North America",
    difficulty: "explorer",
    pools: ["world","North America","MX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "mx-088",
    lat: 27.335844,
    lng: -109.939706,
    panoId: "hteJZiXk0uLHu7n8hXxZiw",
    place: "Near Tobarito, Sonora",
    shortName: "Tobarito",
    countryCode: "MX",
    country: "Mexico",
    continent: "North America",
    difficulty: "explorer",
    pools: ["world","North America","MX"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "mx-089",
    lat: 25.813284,
    lng: -100.403214,
    panoId: "b4eENlt40btZ6Bglw4qxDw",
    place: "Near Monclova Primer Sector, Nuevo León",
    shortName: "Monclova Primer Sector",
    countryCode: "MX",
    country: "Mexico",
    continent: "North America",
    difficulty: "explorer",
    pools: ["world","North America","MX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "mx-090",
    lat: 27.575668,
    lng: -99.433675,
    panoId: "hOOyGlRF3h-L1ZlvRMfYoA",
    place: "Near Laredo, Texas",
    shortName: "Laredo",
    countryCode: "MX",
    country: "Mexico",
    continent: "North America",
    difficulty: "explorer",
    pools: ["world","North America","MX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "mx-091",
    lat: 25.888587,
    lng: -109.149344,
    panoId: "t1GP4_FaykrR3NQMqHpABw",
    place: "Near Macapule, Sinaloa",
    shortName: "Macapule",
    countryCode: "MX",
    country: "Mexico",
    continent: "North America",
    difficulty: "explorer",
    pools: ["world","North America","MX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "mx-092",
    lat: 20.611515,
    lng: -103.301142,
    panoId: "xGyQH_HdmxaI4u_JXmUh5Q",
    place: "Near Tlaquepaque, Jalisco",
    shortName: "Tlaquepaque",
    countryCode: "MX",
    country: "Mexico",
    continent: "North America",
    difficulty: "explorer",
    pools: ["world","North America","MX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "mx-093",
    lat: 25.452619,
    lng: -100.08029,
    panoId: "FWxz0nwz1HZaPTzBgVsKTQ",
    place: "Near Santiago, Nuevo León",
    shortName: "Santiago",
    countryCode: "MX",
    country: "Mexico",
    continent: "North America",
    difficulty: "explorer",
    pools: ["world","North America","MX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "mx-094",
    lat: 17.146259,
    lng: -96.621765,
    panoId: "-eQwSs9CRMY2WXzf8m9pkw",
    place: "Near San Andrés Huayápam, Oaxaca",
    shortName: "San Andrés Huayápam",
    countryCode: "MX",
    country: "Mexico",
    continent: "North America",
    difficulty: "explorer",
    pools: ["world","North America","MX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "mx-095",
    lat: 16.801664,
    lng: -93.115627,
    panoId: "s76M3BJ9vFlC9NBHHL_hcw",
    place: "Near Tuxtla, Chiapas",
    shortName: "Tuxtla",
    countryCode: "MX",
    country: "Mexico",
    continent: "North America",
    difficulty: "explorer",
    pools: ["world","North America","MX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "mx-096",
    lat: 19.580289,
    lng: -99.191971,
    panoId: "09_br3Uve-nLfqyk07ygUg",
    place: "Near Sierra de Guadalupe, México",
    shortName: "Sierra de Guadalupe",
    countryCode: "MX",
    country: "Mexico",
    continent: "North America",
    difficulty: "explorer",
    pools: ["world","North America","MX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "mx-097",
    lat: 18.61953,
    lng: -97.327041,
    panoId: "eQTGRcewkvShFT5UQqS9aQ",
    place: "Near Nicolás Bravo, Puebla",
    shortName: "Nicolás Bravo",
    countryCode: "MX",
    country: "Mexico",
    continent: "North America",
    difficulty: "explorer",
    pools: ["world","North America","MX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "mx-098",
    lat: 16.877292,
    lng: -99.844483,
    panoId: "q1VRQKTohJZeW8x6QyBNWQ",
    place: "Near Colonia Alborada, Guerrero",
    shortName: "Colonia Alborada",
    countryCode: "MX",
    country: "Mexico",
    continent: "North America",
    difficulty: "explorer",
    pools: ["world","North America","MX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "mx-099",
    lat: 29.332395,
    lng: -101.001047,
    panoId: "loXt1NmggSnEPexKwmyzJg",
    place: "Near Ciudad Acuña, Coahuila",
    shortName: "Ciudad Acuña",
    countryCode: "MX",
    country: "Mexico",
    continent: "North America",
    difficulty: "explorer",
    pools: ["world","North America","MX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "mx-100",
    lat: 24.016317,
    lng: -104.84637,
    panoId: "ohpIWTOSDabVjQP7C7XaHw",
    place: "Near El Nayar, Durango",
    shortName: "El Nayar",
    countryCode: "MX",
    country: "Mexico",
    continent: "North America",
    difficulty: "adventurer",
    pools: ["world","North America","MX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "mx-101",
    lat: 22.389687,
    lng: -100.893558,
    panoId: "nj0GyY_jQsnk85IE0vO-GA",
    place: "Near El Peñasco, San Luis Potosí",
    shortName: "El Peñasco",
    countryCode: "MX",
    country: "Mexico",
    continent: "North America",
    difficulty: "adventurer",
    pools: ["world","North America","MX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "mx-102",
    lat: 31.893426,
    lng: -116.413731,
    panoId: "x8JC3MIqqtIFlNQ2WO4Cbw",
    place: "Near Colonia Gómez Morín, Baja California",
    shortName: "Colonia Gómez Morín",
    countryCode: "MX",
    country: "Mexico",
    continent: "North America",
    difficulty: "adventurer",
    pools: ["world","North America","MX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "mx-103",
    lat: 22.283228,
    lng: -98.029473,
    panoId: "n5Dd2z2ZYZ3x9RQjeS57_Q",
    place: "Near Tamos, Veracruz",
    shortName: "Tamos",
    countryCode: "MX",
    country: "Mexico",
    continent: "North America",
    difficulty: "adventurer",
    pools: ["world","North America","MX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "mx-104",
    lat: 20.137506,
    lng: -102.389963,
    panoId: "5hg16r8l5lFptm4b7Z5K5w",
    place: "Near Ixtlán de los Hervores, Michoacán",
    shortName: "Ixtlán de los Hervores",
    countryCode: "MX",
    country: "Mexico",
    continent: "North America",
    difficulty: "adventurer",
    pools: ["world","North America","MX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "mx-105",
    lat: 21.569178,
    lng: -105.074281,
    panoId: "o1EZHDHeHc0kFgI6D6k_WQ",
    place: "Near Mecatán, Nayarit",
    shortName: "Mecatán",
    countryCode: "MX",
    country: "Mexico",
    continent: "North America",
    difficulty: "adventurer",
    pools: ["world","North America","MX"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "br-000",
    lat: -23.547576,
    lng: -46.636112,
    panoId: "G900z-ilR80JJ4inD1AElA",
    place: "Near São Paulo, São Paulo",
    shortName: "São Paulo",
    countryCode: "BR",
    country: "Brazil",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","BR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "br-001",
    lat: -20.441765,
    lng: -54.645687,
    panoId: "vvf2lub7HCCW4C2EeDiJww",
    place: "Near Campo Grande, Mato Grosso do Sul",
    shortName: "Campo Grande",
    countryCode: "BR",
    country: "Brazil",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","BR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "br-002",
    lat: -5.088967,
    lng: -42.802027,
    panoId: "boqoFVkYBnFHSX2pb_HbvQ",
    place: "Near Teresina, Piauí",
    shortName: "Teresina",
    countryCode: "BR",
    country: "Brazil",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","BR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "br-003",
    lat: -12.974946,
    lng: -38.490795,
    panoId: "hAIhd01aRIhX-nfpYg2ADw",
    place: "Near Salvador, Bahia",
    shortName: "Salvador",
    countryCode: "BR",
    country: "Brazil",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","BR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "br-004",
    lat: -8.11285,
    lng: -35.015073,
    panoId: "KW5TQ347hid6M0bohjhsfg",
    place: "Near Jaboatão dos Guararapes, Pernambuco",
    shortName: "Jaboatão dos Guararapes",
    countryCode: "BR",
    country: "Brazil",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","BR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "br-005",
    lat: -23.179434,
    lng: -45.887058,
    panoId: "RlhUdgLKRmabQwWwEgzc9g",
    place: "Near São José dos Campos, São Paulo",
    shortName: "São José dos Campos",
    countryCode: "BR",
    country: "Brazil",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","BR"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "br-006",
    lat: -19.920889,
    lng: -43.937696,
    panoId: "jl9R6uUiSdYyvTP0lpKPqg",
    place: "Near Belo Horizonte, Minas Gerais",
    shortName: "Belo Horizonte",
    countryCode: "BR",
    country: "Brazil",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","BR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "br-007",
    lat: -21.764172,
    lng: -43.350459,
    panoId: "SvmUO7Q-60iE_DLiM7k1HA",
    place: "Near Juiz de Fora, Minas Gerais",
    shortName: "Juiz de Fora",
    countryCode: "BR",
    country: "Brazil",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","BR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "br-008",
    lat: -15.779546,
    lng: -47.929624,
    panoId: "ALkdWH0I3nUSLQ6zh0Zv3w",
    place: "Near Brasília, Federal District",
    shortName: "Brasília",
    countryCode: "BR",
    country: "Brazil",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","BR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "br-009",
    lat: -22.785605,
    lng: -43.312079,
    panoId: "xDNM4eOr6fewzykBJXRjtg",
    place: "Near Duque de Caxias, Rio de Janeiro",
    shortName: "Duque de Caxias",
    countryCode: "BR",
    country: "Brazil",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","BR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "br-010",
    lat: -22.905673,
    lng: -47.061032,
    panoId: "Debr2ZgP5JmUzADDRgFJww",
    place: "Near Campinas, São Paulo",
    shortName: "Campinas",
    countryCode: "BR",
    country: "Brazil",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","BR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "br-011",
    lat: -3.101566,
    lng: -60.025081,
    panoId: "EFWs72ckRMoZgEVU-jNRfg",
    place: "Near Manaus, Amazonas",
    shortName: "Manaus",
    countryCode: "BR",
    country: "Brazil",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","BR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "br-012",
    lat: -8.054109,
    lng: -34.881243,
    panoId: "UxB94-f3FWhIkqDRW5eAcQ",
    place: "Near Recife, Pernambuco",
    shortName: "Recife",
    countryCode: "BR",
    country: "Brazil",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","BR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "br-013",
    lat: -15.596146,
    lng: -56.09668,
    panoId: "-jj5nLOlbhctzdHpBgmgJw",
    place: "Near Cuiabá, Mato Grosso",
    shortName: "Cuiabá",
    countryCode: "BR",
    country: "Brazil",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","BR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "br-014",
    lat: -19.931765,
    lng: -44.053441,
    panoId: "4GjNHIG3cuiLTfaqD-WBeg",
    place: "Near Contagem, Minas Gerais",
    shortName: "Contagem",
    countryCode: "BR",
    country: "Brazil",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","BR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "br-015",
    lat: -5.794901,
    lng: -35.20962,
    panoId: "6w5A5u91RcWMc4M-tIXwdA",
    place: "Near Natal, Rio Grande do Norte",
    shortName: "Natal",
    countryCode: "BR",
    country: "Brazil",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","BR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "br-016",
    lat: -23.663895,
    lng: -46.538218,
    panoId: "KmzPyycCHxThhwmw9GCaRA",
    place: "Near Santo André, São Paulo",
    shortName: "Santo André",
    countryCode: "BR",
    country: "Brazil",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","BR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "br-017",
    lat: -1.455836,
    lng: -48.504555,
    panoId: "bmHh-eJlGVefz4UFLYxFZw",
    place: "Near Belém, Pará",
    shortName: "Belém",
    countryCode: "BR",
    country: "Brazil",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","BR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "br-018",
    lat: -22.906385,
    lng: -43.182261,
    panoId: "QswVZmQrA-rBfAfxE5owoQ",
    place: "Near Rio de Janeiro, Rio de Janeiro",
    shortName: "Rio de Janeiro",
    countryCode: "BR",
    country: "Brazil",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","BR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "br-019",
    lat: -23.532526,
    lng: -46.791544,
    panoId: "uqGY10zMOrHorpGdKm9smQ",
    place: "Near Osasco, São Paulo",
    shortName: "Osasco",
    countryCode: "BR",
    country: "Brazil",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","BR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "br-020",
    lat: -23.501705,
    lng: -47.458027,
    panoId: "JcAq_agKXcVI4lnwm_GdoQ",
    place: "Near Sorocaba, São Paulo",
    shortName: "Sorocaba",
    countryCode: "BR",
    country: "Brazil",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","BR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "br-021",
    lat: -21.177508,
    lng: -47.810275,
    panoId: "b_hxS4A-embMZSemg2y6Dg",
    place: "Near Ribeirão Preto, São Paulo",
    shortName: "Ribeirão Preto",
    countryCode: "BR",
    country: "Brazil",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","BR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "br-022",
    lat: -23.693786,
    lng: -46.565045,
    panoId: "X5lQ98hskqvvzWxFTNVRxw",
    place: "Near São Bernardo do Campo, São Paulo",
    shortName: "São Bernardo do Campo",
    countryCode: "BR",
    country: "Brazil",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","BR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "br-023",
    lat: -7.114994,
    lng: -34.863096,
    panoId: "Uc04-hdLittod_61wTTJUQ",
    place: "Near João Pessoa, Paraíba",
    shortName: "João Pessoa",
    countryCode: "BR",
    country: "Brazil",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","BR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "br-024",
    lat: -23.462852,
    lng: -46.533162,
    panoId: "CNoLupNqv339o7HpyTY1fw",
    place: "Near Guarulhos, São Paulo",
    shortName: "Guarulhos",
    countryCode: "BR",
    country: "Brazil",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","BR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "br-025",
    lat: -3.717028,
    lng: -38.541876,
    panoId: "q0LZeqYNuoDlu0wOm0XujA",
    place: "Near Fortaleza, Ceará",
    shortName: "Fortaleza",
    countryCode: "BR",
    country: "Brazil",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","BR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "br-026",
    lat: -8.179477,
    lng: -34.997616,
    panoId: "OTiMrrEyrgOLBDWH9ATVkg",
    place: "Near Jaboatão, Pernambuco",
    shortName: "Jaboatão",
    countryCode: "BR",
    country: "Brazil",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","BR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "br-027",
    lat: -30.032774,
    lng: -51.23066,
    panoId: "rDSUyl9UQv6IIsSrym55dg",
    place: "Near Porto Alegre, Rio Grande do Sul",
    shortName: "Porto Alegre",
    countryCode: "BR",
    country: "Brazil",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","BR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "br-028",
    lat: -10.910892,
    lng: -37.071668,
    panoId: "t_XNxvjPxXBhz1bfgW4ZHw",
    place: "Near Aracaju, Sergipe",
    shortName: "Aracaju",
    countryCode: "BR",
    country: "Brazil",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","BR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "br-029",
    lat: -12.266939,
    lng: -38.966558,
    panoId: "03xVM64eNvRztPF3iZWkPg",
    place: "Near Feira de Santana, Bahia",
    shortName: "Feira de Santana",
    countryCode: "BR",
    country: "Brazil",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","BR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "br-030",
    lat: -23.310245,
    lng: -51.162771,
    panoId: "ua-ztgczdAZ5AbjkHxgKUQ",
    place: "Near Londrina, Paraná",
    shortName: "Londrina",
    countryCode: "BR",
    country: "Brazil",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","BR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "br-031",
    lat: -9.665878,
    lng: -35.735328,
    panoId: "u9wndr7D5J5nNpgnVJeM7w",
    place: "Near Maceió, Alagoas",
    shortName: "Maceió",
    countryCode: "BR",
    country: "Brazil",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","BR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "br-032",
    lat: -2.529565,
    lng: -44.302721,
    panoId: "06J2iazuj5qTB3Y7UOFm7g",
    place: "Near São Luís, Maranhão",
    shortName: "São Luís",
    countryCode: "BR",
    country: "Brazil",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","BR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "br-033",
    lat: -22.759237,
    lng: -43.451098,
    panoId: "jsCMChlrQbZlMkOwBjSHTw",
    place: "Near Nova Iguaçu, Rio de Janeiro",
    shortName: "Nova Iguaçu",
    countryCode: "BR",
    country: "Brazil",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","BR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "br-034",
    lat: -16.678618,
    lng: -49.25393,
    panoId: "Y8pIN7k5pv7pE0FFXoeW6A",
    place: "Near Goiânia, Goiás",
    shortName: "Goiânia",
    countryCode: "BR",
    country: "Brazil",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","BR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "br-035",
    lat: -8.761902,
    lng: -63.903524,
    panoId: "A4AyCCAYiKz5FTff779a6Q",
    place: "Near Porto Velho, Rondônia",
    shortName: "Porto Velho",
    countryCode: "BR",
    country: "Brazil",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","BR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "br-036",
    lat: -18.918982,
    lng: -48.277464,
    panoId: "d9J2jnL9dAhyCIpyymKrSw",
    place: "Near Uberlândia, Minas Gerais",
    shortName: "Uberlândia",
    countryCode: "BR",
    country: "Brazil",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","BR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "br-037",
    lat: -20.128566,
    lng: -40.307804,
    panoId: "ewFj8ruW6vILh5XskfQ3YA",
    place: "Near Serra, Espírito Santo",
    shortName: "Serra",
    countryCode: "BR",
    country: "Brazil",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","BR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "br-038",
    lat: 0.038687,
    lng: -51.066413,
    panoId: "yz5BbEnlLzoKSrg8RyfWTg",
    place: "Near Macapá, Amapá",
    shortName: "Macapá",
    countryCode: "BR",
    country: "Brazil",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","BR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "br-039",
    lat: -19.926153,
    lng: -43.958872,
    panoId: "AK-emIj4mraOH8ZPewasSA",
    place: "Near Belo Horizonte, Minas Gerais",
    shortName: "Belo Horizonte",
    countryCode: "BR",
    country: "Brazil",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","BR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "br-040",
    lat: -5.799189,
    lng: -35.229594,
    panoId: "frGWKmpUehX20rUFySmp2g",
    place: "Near Natal, Rio Grande do Norte",
    shortName: "Natal",
    countryCode: "BR",
    country: "Brazil",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","BR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "br-041",
    lat: -8.193186,
    lng: -34.993025,
    panoId: "tWs91sEW3TngCNOE25-8VA",
    place: "Near Jaboatão, Pernambuco",
    shortName: "Jaboatão",
    countryCode: "BR",
    country: "Brazil",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","BR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "br-042",
    lat: -3.711723,
    lng: -38.552687,
    panoId: "xqii-cJMmE_eRanPttZOJg",
    place: "Near Fortaleza, Ceará",
    shortName: "Fortaleza",
    countryCode: "BR",
    country: "Brazil",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","BR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "br-043",
    lat: -23.653826,
    lng: -46.557162,
    panoId: "qZtpgRqMWlQiDI7D2kSEUg",
    place: "Near Santo André, São Paulo",
    shortName: "Santo André",
    countryCode: "BR",
    country: "Brazil",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","BR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "br-044",
    lat: -8.06987,
    lng: -34.871634,
    panoId: "IWAwn2h3KGXErpZObGMWmw",
    place: "Near Recife, Pernambuco",
    shortName: "Recife",
    countryCode: "BR",
    country: "Brazil",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","BR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "br-045",
    lat: -12.980907,
    lng: -38.477422,
    panoId: "gX2bDFs69l9U6DX6BgVFIQ",
    place: "Near Salvador, Bahia",
    shortName: "Salvador",
    countryCode: "BR",
    country: "Brazil",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","BR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "br-046",
    lat: -7.134272,
    lng: -34.860175,
    panoId: "Lrc4C2qWVtbRXdb7OUvinw",
    place: "Near João Pessoa, Paraíba",
    shortName: "João Pessoa",
    countryCode: "BR",
    country: "Brazil",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","BR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "br-047",
    lat: -10.910492,
    lng: -37.051062,
    panoId: "8dq1feEgmgu5WqrRQ_aD0Q",
    place: "Near Barra dos Coqueiros, Sergipe",
    shortName: "Barra dos Coqueiros",
    countryCode: "BR",
    country: "Brazil",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","BR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "br-048",
    lat: -22.741306,
    lng: -43.453912,
    panoId: "v0C4fU-fBqJQ3dJOHu93Hw",
    place: "Near Nova Iguaçu, Rio de Janeiro",
    shortName: "Nova Iguaçu",
    countryCode: "BR",
    country: "Brazil",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","BR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "br-049",
    lat: -5.080134,
    lng: -42.788149,
    panoId: "fIGLQgF1Tav9n5tAPqVMCA",
    place: "Near Teresina, Piauí",
    shortName: "Teresina",
    countryCode: "BR",
    country: "Brazil",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","BR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "br-050",
    lat: -21.232876,
    lng: -47.855855,
    panoId: "vLgk5rnO_lF1f7_XbY_l7Q",
    place: "Near Ribeirão Preto, São Paulo",
    shortName: "Ribeirão Preto",
    countryCode: "BR",
    country: "Brazil",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","BR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "br-051",
    lat: -23.7284,
    lng: -46.583967,
    panoId: "6DIF5nnOqQjoKZ-eSJPHVw",
    place: "Near São Bernardo do Campo, São Paulo",
    shortName: "São Bernardo do Campo",
    countryCode: "BR",
    country: "Brazil",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","BR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "br-052",
    lat: -5.849898,
    lng: -35.213616,
    panoId: "v7tvL6aojtFaY_20v5wInw",
    place: "Near Natal, Rio Grande do Norte",
    shortName: "Natal",
    countryCode: "BR",
    country: "Brazil",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","BR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "br-053",
    lat: -18.928099,
    lng: -48.20273,
    panoId: "kLi9BNy7x4D4SlspS2tZgg",
    place: "Near Uberlândia, Minas Gerais",
    shortName: "Uberlândia",
    countryCode: "BR",
    country: "Brazil",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","BR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "br-054",
    lat: -22.877713,
    lng: -47.072616,
    panoId: "g1OVJ5V6_CzcHzRxlJjE7Q",
    place: "Near Campinas, São Paulo",
    shortName: "Campinas",
    countryCode: "BR",
    country: "Brazil",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","BR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "br-055",
    lat: -5.106258,
    lng: -42.732836,
    panoId: "qUVHGzDDAJhBhPeb8xzbsg",
    place: "Near Teresina, Piauí",
    shortName: "Teresina",
    countryCode: "BR",
    country: "Brazil",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","BR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "br-056",
    lat: -20.081518,
    lng: -40.272414,
    panoId: "IMSXNkZxuronKWU3bAT-gA",
    place: "Near Serra, Espírito Santo",
    shortName: "Serra",
    countryCode: "BR",
    country: "Brazil",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","BR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "br-057",
    lat: -23.53106,
    lng: -47.467148,
    panoId: "mJ5y_moY0RZSXL_6Jw-oVA",
    place: "Near Sorocaba, São Paulo",
    shortName: "Sorocaba",
    countryCode: "BR",
    country: "Brazil",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","BR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "br-058",
    lat: -19.973536,
    lng: -43.930829,
    panoId: "KG8iAm3_wox5HYQd4G5w5g",
    place: "Near Belo Horizonte, Minas Gerais",
    shortName: "Belo Horizonte",
    countryCode: "BR",
    country: "Brazil",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","BR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "br-059",
    lat: -20.435004,
    lng: -54.679497,
    panoId: "UK0HQ38kzLZQDwXiIFBvQw",
    place: "Near Campo Grande, Mato Grosso do Sul",
    shortName: "Campo Grande",
    countryCode: "BR",
    country: "Brazil",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","BR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "br-060",
    lat: -12.962675,
    lng: -38.466349,
    panoId: "z8aggSvl77t1dZuGwrztdA",
    place: "Near Salvador, Bahia",
    shortName: "Salvador",
    countryCode: "BR",
    country: "Brazil",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","BR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "br-061",
    lat: -19.905139,
    lng: -44.011576,
    panoId: "WlZO3FT-eDqrgF6cBLQfWg",
    place: "Near Contagem, Minas Gerais",
    shortName: "Contagem",
    countryCode: "BR",
    country: "Brazil",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","BR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "br-062",
    lat: -3.131559,
    lng: -60.01393,
    panoId: "gm0OjF09nlOZmZHxLbyDlw",
    place: "Near Manaus, Amazonas",
    shortName: "Manaus",
    countryCode: "BR",
    country: "Brazil",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","BR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "br-063",
    lat: -10.918458,
    lng: -37.111258,
    panoId: "hR3DyHB9w-EzAsm4UPN7Vw",
    place: "Near Aracaju, Sergipe",
    shortName: "Aracaju",
    countryCode: "BR",
    country: "Brazil",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","BR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "br-064",
    lat: -21.799419,
    lng: -43.358355,
    panoId: "eKTvgwkZoTsT961oa8KeUw",
    place: "Near Juiz de Fora, Minas Gerais",
    shortName: "Juiz de Fora",
    countryCode: "BR",
    country: "Brazil",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","BR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "br-065",
    lat: -3.77359,
    lng: -38.553865,
    panoId: "FwgcvyC1CuMNR-9pRRawEg",
    place: "Near Fortaleza, Ceará",
    shortName: "Fortaleza",
    countryCode: "BR",
    country: "Brazil",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","BR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "br-066",
    lat: -16.617477,
    lng: -49.230228,
    panoId: "Nzd99YJvy_QBjg8J_-mNNg",
    place: "Near Goiânia, Goiás",
    shortName: "Goiânia",
    countryCode: "BR",
    country: "Brazil",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","BR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "br-067",
    lat: -1.394475,
    lng: -48.488308,
    panoId: "9dWcRhIZu6FJ2CqniAQZxA",
    place: "Near Belém, Pará",
    shortName: "Belém",
    countryCode: "BR",
    country: "Brazil",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","BR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "br-068",
    lat: -12.223221,
    lng: -38.917508,
    panoId: "t38sElOUf3b3YAwRIfPT5A",
    place: "Near Feira de Santana, Bahia",
    shortName: "Feira de Santana",
    countryCode: "BR",
    country: "Brazil",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","BR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "br-069",
    lat: -30.042585,
    lng: -51.188824,
    panoId: "6XM1BwAPBHsfZtwxu9SJZg",
    place: "Near Porto Alegre, Rio Grande do Sul",
    shortName: "Porto Alegre",
    countryCode: "BR",
    country: "Brazil",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","BR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "br-070",
    lat: -18.958434,
    lng: -48.25168,
    panoId: "4OnlkbaCBk7VmH2An0g6Eg",
    place: "Near Uberlândia, Minas Gerais",
    shortName: "Uberlândia",
    countryCode: "BR",
    country: "Brazil",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","BR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "br-071",
    lat: -25.404966,
    lng: -49.344472,
    panoId: "n-_jMxRNb46HucJif6t7GA",
    place: "Near Curitiba, Paraná",
    shortName: "Curitiba",
    countryCode: "BR",
    country: "Brazil",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","BR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "br-072",
    lat: -8.180996,
    lng: -34.960278,
    panoId: "sIyp2UbvLGCowyXCg4K6yw",
    place: "Near Jaboatão, Pernambuco",
    shortName: "Jaboatão",
    countryCode: "BR",
    country: "Brazil",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","BR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "br-073",
    lat: -23.239567,
    lng: -51.182837,
    panoId: "uWasBEeuRI4jvQy7t_YZnA",
    place: "Near Londrina, Paraná",
    shortName: "Londrina",
    countryCode: "BR",
    country: "Brazil",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","BR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "br-074",
    lat: -26.358219,
    lng: -48.860539,
    panoId: "F-H7BAMzh4-mA3ZAeNZqYg",
    place: "Near Joinville, Santa Catarina",
    shortName: "Joinville",
    countryCode: "BR",
    country: "Brazil",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","BR"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "br-075",
    lat: -8.717714,
    lng: -63.854541,
    panoId: "tz0lw7pp3couxNSHNiqGOQ",
    place: "Near Porto Velho, Rondônia",
    shortName: "Porto Velho",
    countryCode: "BR",
    country: "Brazil",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","BR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "br-076",
    lat: -20.419992,
    lng: -54.611894,
    panoId: "5AP5CmaLHXHE54x2ZPJecw",
    place: "Near Campo Grande, Mato Grosso do Sul",
    shortName: "Campo Grande",
    countryCode: "BR",
    country: "Brazil",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","BR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "br-077",
    lat: -21.733383,
    lng: -41.355613,
    panoId: "MQW_2lrhvF_u82bS9b3X1w",
    place: "Near Campos dos Goytacazes, Rio de Janeiro",
    shortName: "Campos dos Goytacazes",
    countryCode: "BR",
    country: "Brazil",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","BR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "br-078",
    lat: -8.276468,
    lng: -36.011923,
    panoId: "V5cvO4jx5wiioJme9EdOVA",
    place: "Near Caruaru, Pernambuco",
    shortName: "Caruaru",
    countryCode: "BR",
    country: "Brazil",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","BR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "br-079",
    lat: -12.319188,
    lng: -38.96968,
    panoId: "R2x4-jZi0yhnEJWwbsl_5g",
    place: "Near Feira de Santana, Bahia",
    shortName: "Feira de Santana",
    countryCode: "BR",
    country: "Brazil",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","BR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "br-080",
    lat: -16.774119,
    lng: -43.919217,
    panoId: "VJ4yY2Y1NChOXBRBL4y4lA",
    place: "Near Montes Claros, Minas Gerais",
    shortName: "Montes Claros",
    countryCode: "BR",
    country: "Brazil",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","BR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "br-081",
    lat: -22.51052,
    lng: -49.061182,
    panoId: "MTFnfevCvPGJcOHqUwXv3A",
    place: "Near Agudos, São Paulo",
    shortName: "Agudos",
    countryCode: "BR",
    country: "Brazil",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","BR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "br-082",
    lat: 2.801916,
    lng: -60.712701,
    panoId: "04UnEeV03SJqbDTqteYSng",
    place: "Near Boa Vista, Roraima",
    shortName: "Boa Vista",
    countryCode: "BR",
    country: "Brazil",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","BR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "br-083",
    lat: -20.383881,
    lng: -47.380339,
    panoId: "Fqn010UQt5vPh7ZvBVCabg",
    place: "Near Cristais Paulista, São Paulo",
    shortName: "Cristais Paulista",
    countryCode: "BR",
    country: "Brazil",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","BR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "br-084",
    lat: -19.729867,
    lng: -47.898794,
    panoId: "CYlTLxPmqkJW6PT0CRODLQ",
    place: "Near Uberaba, Minas Gerais",
    shortName: "Uberaba",
    countryCode: "BR",
    country: "Brazil",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","BR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "br-085",
    lat: -29.230533,
    lng: -51.169129,
    panoId: "yN_IiyFwINeFjIIVznXaBA",
    place: "Near Caxias do Sul, Rio Grande do Sul",
    shortName: "Caxias do Sul",
    countryCode: "BR",
    country: "Brazil",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","BR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "br-086",
    lat: -16.693401,
    lng: -49.290963,
    panoId: "4IKDWwzni5WEPg9utijcQw",
    place: "Near Goiânia, Goiás",
    shortName: "Goiânia",
    countryCode: "BR",
    country: "Brazil",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","BR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "br-087",
    lat: -26.881802,
    lng: -49.046963,
    panoId: "iUqduVo-DXgq4YB-66E5wA",
    place: "Near Blumenau, Santa Catarina",
    shortName: "Blumenau",
    countryCode: "BR",
    country: "Brazil",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","BR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "br-088",
    lat: -9.350995,
    lng: -40.472305,
    panoId: "G89ni3l_7NJlW_JUFTPUWQ",
    place: "Near Petrolina, Pernambuco",
    shortName: "Petrolina",
    countryCode: "BR",
    country: "Brazil",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","BR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "br-089",
    lat: -25.380176,
    lng: -49.311355,
    panoId: "k34QbeeYvdBHVYmbyhmgrQ",
    place: "Near Almirante Tamandaré, Paraná",
    shortName: "Almirante Tamandaré",
    countryCode: "BR",
    country: "Brazil",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","BR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "br-090",
    lat: -23.949347,
    lng: -46.452445,
    panoId: "kFEyDXiiT98q54QNd0oYVg",
    place: "Near São Vicente, São Paulo",
    shortName: "São Vicente",
    countryCode: "BR",
    country: "Brazil",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","BR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "br-091",
    lat: -22.896087,
    lng: -46.90662,
    panoId: "cWLEGAFFdLmL3n_n_aXcpw",
    place: "Near Joaquim Egídio, São Paulo",
    shortName: "Joaquim Egídio",
    countryCode: "BR",
    country: "Brazil",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","BR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "br-092",
    lat: -21.234976,
    lng: -47.819009,
    panoId: "CYm6-fllZ9IGXJvWxZmiIw",
    place: "Near Ribeirão Preto, São Paulo",
    shortName: "Ribeirão Preto",
    countryCode: "BR",
    country: "Brazil",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","BR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "br-093",
    lat: -23.366151,
    lng: -46.424453,
    panoId: "phaLlOQj5Aii_vlzdM7zfA",
    place: "Near Arujá, São Paulo",
    shortName: "Arujá",
    countryCode: "BR",
    country: "Brazil",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","BR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "br-094",
    lat: -15.660998,
    lng: -56.221972,
    panoId: "Ahqr4JYzBnixagGbh4FkPA",
    place: "Near Várzea Grande, Mato Grosso",
    shortName: "Várzea Grande",
    countryCode: "BR",
    country: "Brazil",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","BR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "br-095",
    lat: -6.09603,
    lng: -49.972941,
    panoId: "9W4GfmfyfYgFPD_PYiTXqg",
    place: "Near Parauapebas, Pará",
    shortName: "Parauapebas",
    countryCode: "BR",
    country: "Brazil",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","BR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "br-096",
    lat: -22.472791,
    lng: -44.276691,
    panoId: "vw5hS2d5BpCqAgMDGzfIPQ",
    place: "Near Porto Real, Rio de Janeiro",
    shortName: "Porto Real",
    countryCode: "BR",
    country: "Brazil",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","BR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "br-097",
    lat: -7.165504,
    lng: -36.051278,
    panoId: "HgrkgFzBtVK2CMKlvl31gA",
    place: "Near Pocinhos, Paraíba",
    shortName: "Pocinhos",
    countryCode: "BR",
    country: "Brazil",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","BR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "br-098",
    lat: -25.613844,
    lng: -54.482157,
    panoId: "cRrxaD-8ZraU0TryksAw9A",
    place: "Near Puerto Iguazú, Misiones",
    shortName: "Puerto Iguazú",
    countryCode: "BR",
    country: "Brazil",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","BR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "br-099",
    lat: -5.851824,
    lng: -35.316602,
    panoId: "KGCSd1p0wLlwAy0i3c8-CA",
    place: "Near Macaíba, Rio Grande do Norte",
    shortName: "Macaíba",
    countryCode: "BR",
    country: "Brazil",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","BR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "br-100",
    lat: -16.278976,
    lng: -54.634245,
    panoId: "_11DhOzBgqWD5semqFguHA",
    place: "Near Rondonópolis, Mato Grosso",
    shortName: "Rondonópolis",
    countryCode: "BR",
    country: "Brazil",
    continent: "South America",
    difficulty: "adventurer",
    pools: ["world","South America","BR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "br-101",
    lat: -21.863311,
    lng: -41.173378,
    panoId: "wwUS5f2FtI1griP3z-YLQA",
    place: "Near Campos dos Goytacazes, Rio de Janeiro",
    shortName: "Campos dos Goytacazes",
    countryCode: "BR",
    country: "Brazil",
    continent: "South America",
    difficulty: "adventurer",
    pools: ["world","South America","BR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "br-102",
    lat: -16.81535,
    lng: -43.701699,
    panoId: "lO10N8jEuKAUVGDzk7VNHQ",
    place: "Near Glaucilândia, Minas Gerais",
    shortName: "Glaucilândia",
    countryCode: "BR",
    country: "Brazil",
    continent: "South America",
    difficulty: "adventurer",
    pools: ["world","South America","BR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "br-103",
    lat: -16.364119,
    lng: -54.728492,
    panoId: "kGP__jDv6vPzR4doea16Fg",
    place: "Near Rondonópolis, Mato Grosso",
    shortName: "Rondonópolis",
    countryCode: "BR",
    country: "Brazil",
    continent: "South America",
    difficulty: "adventurer",
    pools: ["world","South America","BR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "br-104",
    lat: -25.663091,
    lng: -54.754557,
    panoId: "qepIC-XQTSbJLIyYAb4OeQ",
    place: "Near Los Cedrales, Alto Paraná Department",
    shortName: "Los Cedrales",
    countryCode: "BR",
    country: "Brazil",
    continent: "South America",
    difficulty: "adventurer",
    pools: ["world","South America","BR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "br-105",
    lat: -16.158531,
    lng: -48.952187,
    panoId: "t2zq3UmH8VPhrsoFWAd3SA",
    place: "Near Anápolis, Goiás",
    shortName: "Anápolis",
    countryCode: "BR",
    country: "Brazil",
    continent: "South America",
    difficulty: "adventurer",
    pools: ["world","South America","BR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pe-000",
    lat: -4.577247,
    lng: -81.271721,
    panoId: "K041n47_vgZb4jCMqLyYEw",
    place: "Near Talara, Piura",
    shortName: "Talara",
    countryCode: "PE",
    country: "Peru",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","PE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pe-001",
    lat: -6.77006,
    lng: -79.854953,
    panoId: "Kf7Wf-XDk5Hwg3sze29Blg",
    place: "Near Chiclayo, Lambayeque",
    shortName: "Chiclayo",
    countryCode: "PE",
    country: "Peru",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","PE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pe-002",
    lat: -12.043199,
    lng: -77.028289,
    panoId: "rtEYUGSxka6A0ZjxE4KmUQ",
    place: "Near Lima, Lima Province",
    shortName: "Lima",
    countryCode: "PE",
    country: "Peru",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","PE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pe-003",
    lat: -9.526177,
    lng: -77.528663,
    panoId: "HmLD6WILetdFxZcZ_FsrRA",
    place: "Near Huaraz, Ancash",
    shortName: "Huaraz",
    countryCode: "PE",
    country: "Peru",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","PE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pe-004",
    lat: -5.266545,
    lng: -80.681909,
    panoId: "Bs_LtuaGdo1bZtSs6m06aQ",
    place: "Near Catacaos, Piura",
    shortName: "Catacaos",
    countryCode: "PE",
    country: "Peru",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","PE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pe-005",
    lat: -10.665764,
    lng: -76.253095,
    panoId: "10wEbiaSGOitg30ByqUCxw",
    place: "Near Cerro de Pasco, Pasco",
    shortName: "Cerro de Pasco",
    countryCode: "PE",
    country: "Peru",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","PE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pe-006",
    lat: -18.014633,
    lng: -70.25357,
    panoId: "soNkNqchObju7ie6Wn7cjw",
    place: "Near Tacna, Tacna",
    shortName: "Tacna",
    countryCode: "PE",
    country: "Peru",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","PE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pe-007",
    lat: -4.904053,
    lng: -80.685274,
    panoId: "GE0GxiBTRiUru7JlYU15qw",
    place: "Near Sullana, Piura",
    shortName: "Sullana",
    countryCode: "PE",
    country: "Peru",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","PE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pe-008",
    lat: -5.181903,
    lng: -80.657106,
    panoId: "L7gwvIVLYajjFFznqWBTxQ",
    place: "Near Piura, Piura",
    shortName: "Piura",
    countryCode: "PE",
    country: "Peru",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","PE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pe-009",
    lat: -12.068641,
    lng: -75.210249,
    panoId: "Bm-k-Ga6B4Ip1iXeA3BPbA",
    place: "Near Huancayo, Junin",
    shortName: "Huancayo",
    countryCode: "PE",
    country: "Peru",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","PE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pe-010",
    lat: -7.163874,
    lng: -78.500363,
    panoId: "lTMLtWfF9b9dnqQ8anwVjw",
    place: "Near Cajamarca, Cajamarca Department",
    shortName: "Cajamarca",
    countryCode: "PE",
    country: "Peru",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","PE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pe-011",
    lat: -13.634237,
    lng: -72.88384,
    panoId: "navouQUeLzl3HBcxr5nZtQ",
    place: "Near Abancay, Apurímac Department",
    shortName: "Abancay",
    countryCode: "PE",
    country: "Peru",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","PE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pe-012",
    lat: -3.555894,
    lng: -80.442613,
    panoId: "DUBumgyNNw7KrLOF0iOgyA",
    place: "Near Tumbes, Tumbes",
    shortName: "Tumbes",
    countryCode: "PE",
    country: "Peru",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","PE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pe-013",
    lat: -15.500093,
    lng: -70.133237,
    panoId: "yBehjfhYQf3vpyaVHAH4Zw",
    place: "Near Juliaca, Puno",
    shortName: "Juliaca",
    countryCode: "PE",
    country: "Peru",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","PE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pe-014",
    lat: -5.185846,
    lng: -80.669226,
    panoId: "gYA0y8Exbso3HKyqMN3Bew",
    place: "Near San Martin, Piura",
    shortName: "San Martin",
    countryCode: "PE",
    country: "Peru",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","PE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pe-015",
    lat: -17.631831,
    lng: -71.341097,
    panoId: "U-eJKdrhHJ_T2r0SkfAJAg",
    place: "Near Ilo, Moquegua Department",
    shortName: "Ilo",
    countryCode: "PE",
    country: "Peru",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","PE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pe-016",
    lat: -13.16377,
    lng: -74.22344,
    panoId: "fJ6-B8OT33yAbS2r9soP8g",
    place: "Near Ayacucho, Ayacucho",
    shortName: "Ayacucho",
    countryCode: "PE",
    country: "Peru",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","PE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pe-017",
    lat: -9.928867,
    lng: -76.239886,
    panoId: "dlA3l8uEQgMOIhYhFOt4BQ",
    place: "Near Huánuco, Huánuco Department",
    shortName: "Huánuco",
    countryCode: "PE",
    country: "Peru",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","PE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pe-018",
    lat: -5.092605,
    lng: -80.162565,
    panoId: "PaUpJTzhC_5pybCW2R0hKg",
    place: "Near Chulucanas, Piura",
    shortName: "Chulucanas",
    countryCode: "PE",
    country: "Peru",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","PE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pe-019",
    lat: -13.524693,
    lng: -71.965161,
    panoId: "gCFqyQ9tccouFhneD12-2w",
    place: "Near Wanchaq, Cuzco Department",
    shortName: "Wanchaq",
    countryCode: "PE",
    country: "Peru",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","PE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pe-020",
    lat: -8.116093,
    lng: -79.029871,
    panoId: "BhjP1llLNethezGpwx6u2Q",
    place: "Near Trujillo, La Libertad",
    shortName: "Trujillo",
    countryCode: "PE",
    country: "Peru",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","PE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pe-021",
    lat: -9.075063,
    lng: -78.593768,
    panoId: "oQnwtO_fxcuADru2c05_OA",
    place: "Near Chimbote, Ancash",
    shortName: "Chimbote",
    countryCode: "PE",
    country: "Peru",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","PE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pe-022",
    lat: -11.117193,
    lng: -77.605847,
    panoId: "oPSa1aoc2LsuKfqElf_-HQ",
    place: "Near Huacho, Lima region",
    shortName: "Huacho",
    countryCode: "PE",
    country: "Peru",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","PE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pe-023",
    lat: -5.089244,
    lng: -81.114474,
    panoId: "6uByTJV3Bp1MALddSA97BA",
    place: "Near Paita, Piura",
    shortName: "Paita",
    countryCode: "PE",
    country: "Peru",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","PE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pe-024",
    lat: -12.086408,
    lng: -75.208142,
    panoId: "V5yh1YTv7gxVsEQ0kC14Yg",
    place: "Near Chilca, Junin",
    shortName: "Chilca",
    countryCode: "PE",
    country: "Peru",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","PE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pe-025",
    lat: -13.527243,
    lng: -71.984349,
    panoId: "1hpmcjzGBM_oPvbK91oVWw",
    place: "Near Santiago, Cuzco Department",
    shortName: "Santiago",
    countryCode: "PE",
    country: "Peru",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","PE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pe-026",
    lat: -14.075364,
    lng: -75.734253,
    panoId: "RGfkMANEc61HBLwV4vssFg",
    place: "Near Ica, Ica",
    shortName: "Ica",
    countryCode: "PE",
    country: "Peru",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","PE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pe-027",
    lat: -11.494994,
    lng: -77.207741,
    panoId: "8EJjntJYUVJcRdGCXbrrlQ",
    place: "Near Huaral, Lima region",
    shortName: "Huaral",
    countryCode: "PE",
    country: "Peru",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","PE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pe-028",
    lat: -13.409572,
    lng: -76.133105,
    panoId: "mXjHo7NzlqYTSyUR4bKmfA",
    place: "Near Chincha Alta, Ica",
    shortName: "Chincha Alta",
    countryCode: "PE",
    country: "Peru",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","PE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pe-029",
    lat: -17.197422,
    lng: -70.935877,
    panoId: "760f9hdBKDIzExUuaFC0qw",
    place: "Near Moquegua, Moquegua Department",
    shortName: "Moquegua",
    countryCode: "PE",
    country: "Peru",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","PE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pe-030",
    lat: -12.051638,
    lng: -77.13453,
    panoId: "CDg8oMWNgWqe6RokIYPgrw",
    place: "Near Callao, Callao",
    shortName: "Callao",
    countryCode: "PE",
    country: "Peru",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","PE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pe-031",
    lat: -13.710407,
    lng: -76.205419,
    panoId: "NB8fzzVjw6ZxG0L7qA46fQ",
    place: "Near Pisco, Ica",
    shortName: "Pisco",
    countryCode: "PE",
    country: "Peru",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","PE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pe-032",
    lat: -5.171298,
    lng: -80.655019,
    panoId: "UgzDAg9Wdfeviyh83DAwCw",
    place: "Near Piura, Piura",
    shortName: "Piura",
    countryCode: "PE",
    country: "Peru",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","PE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pe-033",
    lat: -9.075181,
    lng: -78.604642,
    panoId: "YB1yBZJQosX4FwRcxHfuXA",
    place: "Near Chimbote, Ancash",
    shortName: "Chimbote",
    countryCode: "PE",
    country: "Peru",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","PE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pe-034",
    lat: -12.585577,
    lng: -69.188572,
    panoId: "nrNwgbH81YYDOcU2WJyUkg",
    place: "Near Puerto Maldonado, Madre de Dios",
    shortName: "Puerto Maldonado",
    countryCode: "PE",
    country: "Peru",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","PE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pe-035",
    lat: -13.725355,
    lng: -76.21161,
    panoId: "Xs7haLhfh8pBuTfWHsITow",
    place: "Near San Andrés, Ica",
    shortName: "San Andrés",
    countryCode: "PE",
    country: "Peru",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","PE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pe-036",
    lat: -4.908668,
    lng: -80.704465,
    panoId: "LvngITUhv9CH0RA_nMJFPA",
    place: "Near Sullana, Piura",
    shortName: "Sullana",
    countryCode: "PE",
    country: "Peru",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","PE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pe-037",
    lat: -15.506151,
    lng: -70.11982,
    panoId: "6GffBKePTD4Oc2dDyIkVZQ",
    place: "Near Juliaca, Puno",
    shortName: "Juliaca",
    countryCode: "PE",
    country: "Peru",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","PE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pe-038",
    lat: -16.41634,
    lng: -71.522901,
    panoId: "vW2i5eBGscKLlGAAOkHUAA",
    place: "Near Ciudad Satelite, Arequipa",
    shortName: "Ciudad Satelite",
    countryCode: "PE",
    country: "Peru",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","PE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pe-039",
    lat: -3.554391,
    lng: -80.454002,
    panoId: "1iMzO-2yNhRWiHdDO32K5A",
    place: "Near Tumbes, Tumbes",
    shortName: "Tumbes",
    countryCode: "PE",
    country: "Peru",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","PE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pe-040",
    lat: -5.281209,
    lng: -80.685271,
    panoId: "GUMW5c9NcDQFAcSfKwaLyA",
    place: "Near Catacaos, Piura",
    shortName: "Catacaos",
    countryCode: "PE",
    country: "Peru",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","PE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pe-041",
    lat: -13.516039,
    lng: -71.95623,
    panoId: "Oku3cMtfm94rUW7Zmkwx0Q",
    place: "Near Wanchaq, Cuzco Department",
    shortName: "Wanchaq",
    countryCode: "PE",
    country: "Peru",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","PE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pe-042",
    lat: -13.394861,
    lng: -76.148861,
    panoId: "o9WAPMKTMjuGYXT6ijRzGw",
    place: "Near San Pedro, Ica",
    shortName: "San Pedro",
    countryCode: "PE",
    country: "Peru",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","PE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pe-043",
    lat: -12.073452,
    lng: -75.200696,
    panoId: "jPwnGVOr8R83JKAt6a0YYg",
    place: "Near Huancayo, Junin",
    shortName: "Huancayo",
    countryCode: "PE",
    country: "Peru",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","PE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pe-044",
    lat: -11.114579,
    lng: -77.594714,
    panoId: "zOiRQCuVwT_xrze3UpPBJQ",
    place: "Near Huacho, Lima region",
    shortName: "Huacho",
    countryCode: "PE",
    country: "Peru",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","PE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pe-045",
    lat: -9.52602,
    lng: -77.507677,
    panoId: "nPKacGOAqN0k0Wh_YlufCQ",
    place: "Near Huaraz, Ancash",
    shortName: "Huaraz",
    countryCode: "PE",
    country: "Peru",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","PE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pe-046",
    lat: -17.619535,
    lng: -71.342726,
    panoId: "YoaUhFZWUNyLpm4mzCs_VQ",
    place: "Near Pueblo Nuevo, Moquegua Department",
    shortName: "Pueblo Nuevo",
    countryCode: "PE",
    country: "Peru",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","PE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pe-047",
    lat: -10.682419,
    lng: -76.243741,
    panoId: "Gj-orXWiGkRXJ-Iwr2ahXA",
    place: "Near San Antonio de Rancas, Pasco",
    shortName: "San Antonio de Rancas",
    countryCode: "PE",
    country: "Peru",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","PE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pe-048",
    lat: -8.107215,
    lng: -79.014224,
    panoId: "-pyMgzuQtWS6Rt0qrgcsYA",
    place: "Near Trujillo, La Libertad",
    shortName: "Trujillo",
    countryCode: "PE",
    country: "Peru",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","PE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pe-049",
    lat: -13.622398,
    lng: -72.875905,
    panoId: "XosHSnkEOu7Q84ZCcbJyHA",
    place: "Near Tamburco, Apurímac Department",
    shortName: "Tamburco",
    countryCode: "PE",
    country: "Peru",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","PE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pe-050",
    lat: -5.125149,
    lng: -80.124282,
    panoId: "3WyYNDAp5XEieDCn3jM5dw",
    place: "Near Chulucanas, Piura",
    shortName: "Chulucanas",
    countryCode: "PE",
    country: "Peru",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","PE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pe-051",
    lat: -5.120647,
    lng: -80.64082,
    panoId: "cBCjPttcec-zoA3P6o63hg",
    place: "Near Piura, Piura",
    shortName: "Piura",
    countryCode: "PE",
    country: "Peru",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","PE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pe-052",
    lat: -12.555136,
    lng: -69.148925,
    panoId: "W_c7O5_k7veKlKdaDXVcZg",
    place: "Near Puerto Maldonado, Madre de Dios",
    shortName: "Puerto Maldonado",
    countryCode: "PE",
    country: "Peru",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","PE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pe-053",
    lat: -9.508207,
    lng: -77.464482,
    panoId: "ScsHPFO-myoTozzxRnYvAw",
    place: "Near Centenario, Ancash",
    shortName: "Centenario",
    countryCode: "PE",
    country: "Peru",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","PE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pe-054",
    lat: -17.229899,
    lng: -70.873671,
    panoId: "RP7ooSHWe_89opyYWTVyBg",
    place: "Near San Antonio, Moquegua Department",
    shortName: "San Antonio",
    countryCode: "PE",
    country: "Peru",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","PE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pe-055",
    lat: -3.610776,
    lng: -80.435291,
    panoId: "r0DwnX7Q5pe79YJKT72iXA",
    place: "Near San Juan de la Virgen, Tumbes",
    shortName: "San Juan de la Virgen",
    countryCode: "PE",
    country: "Peru",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","PE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pe-056",
    lat: -7.1423,
    lng: -78.4681,
    panoId: "KUNP1TgUUzqnNVilObGIjg",
    place: "Near Los Baños del Inca, Cajamarca Department",
    shortName: "Los Baños del Inca",
    countryCode: "PE",
    country: "Peru",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","PE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pe-057",
    lat: -8.377945,
    lng: -74.618766,
    panoId: "cgJh4_r5vdQVPEKaL3jCNg",
    place: "Near San José, Ucayali",
    shortName: "San José",
    countryCode: "PE",
    country: "Peru",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","PE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pe-058",
    lat: -4.57298,
    lng: -81.220855,
    panoId: "aneTCttH2l61BQUndEaIRQ",
    place: "Near Talara, Piura",
    shortName: "Talara",
    countryCode: "PE",
    country: "Peru",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","PE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pe-059",
    lat: -17.68973,
    lng: -71.32726,
    panoId: "d83W5tw2UAYO2rBzcfVVvA",
    place: "Near Pacocha, Moquegua Department",
    shortName: "Pacocha",
    countryCode: "PE",
    country: "Peru",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","PE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pe-060",
    lat: -5.054956,
    lng: -80.137618,
    panoId: "p8VSah3ErBixiM3Qyx6MMg",
    place: "Near Chulucanas, Piura",
    shortName: "Chulucanas",
    countryCode: "PE",
    country: "Peru",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","PE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pe-061",
    lat: -5.348587,
    lng: -80.66389,
    panoId: "cEuQVEH1ctjdakvxrLbguA",
    place: "Near La Arena, Piura",
    shortName: "La Arena",
    countryCode: "PE",
    country: "Peru",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","PE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pe-062",
    lat: -8.150487,
    lng: -79.044988,
    panoId: "TSEjr23rH6Y1BrTPAhj3yg",
    place: "Near Buenos Aires, La Libertad",
    shortName: "Buenos Aires",
    countryCode: "PE",
    country: "Peru",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","PE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pe-063",
    lat: -13.578841,
    lng: -71.939186,
    panoId: "EIFjhD1u3HAzv7q7OAoipQ",
    place: "Near San Sebastián, Cuzco Department",
    shortName: "San Sebastián",
    countryCode: "PE",
    country: "Peru",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","PE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pe-064",
    lat: -14.074559,
    lng: -75.769577,
    panoId: "TRJwOkmn-mmC_koa-bicmg",
    place: "Near Ica, Ica",
    shortName: "Ica",
    countryCode: "PE",
    country: "Peru",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","PE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pe-065",
    lat: -10.641327,
    lng: -76.317765,
    panoId: "y9N0stTHjq63pl7tB9vYwQ",
    place: "Near Paragsha- San Andres - Jose Carlos Mariategui, Pasco",
    shortName: "Paragsha- San Andres - Jose Carlos Mariategui",
    countryCode: "PE",
    country: "Peru",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","PE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pe-066",
    lat: -12.787594,
    lng: -75.034003,
    panoId: "b0YH-N10FjMYWJtDqw2rCA",
    place: "Near Ascencion, Huancavelica",
    shortName: "Ascencion",
    countryCode: "PE",
    country: "Peru",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","PE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pe-067",
    lat: -13.501679,
    lng: -72.018855,
    panoId: "vQYFlH69xQZE5aufT-RG6A",
    place: "Near Poroy, Cuzco Department",
    shortName: "Poroy",
    countryCode: "PE",
    country: "Peru",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","PE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pe-068",
    lat: -12.034568,
    lng: -75.187981,
    panoId: "tYUN-YnCRZWgQKoLDaiLeg",
    place: "Near Palianñuñas, Junin",
    shortName: "Palianñuñas",
    countryCode: "PE",
    country: "Peru",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","PE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pe-069",
    lat: -5.099879,
    lng: -81.073838,
    panoId: "tzuWxttdFIo14K2vxtd1FQ",
    place: "Near Paita, Piura",
    shortName: "Paita",
    countryCode: "PE",
    country: "Peru",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","PE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pe-070",
    lat: -6.052982,
    lng: -76.938472,
    panoId: "R6-HIF8R0u19n6fCgq8tig",
    place: "Near Moyobamba, San Martín Department",
    shortName: "Moyobamba",
    countryCode: "PE",
    country: "Peru",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","PE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pe-071",
    lat: -7.271136,
    lng: -79.463,
    panoId: "txq6tz_LPjR1KTLPE_oVJw",
    place: "Near Guadalupe, La Libertad",
    shortName: "Guadalupe",
    countryCode: "PE",
    country: "Peru",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","PE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pe-072",
    lat: -11.525601,
    lng: -77.163931,
    panoId: "7_tioG-UwuaVIgIHzvgvPQ",
    place: "Near Aucallama, Lima region",
    shortName: "Aucallama",
    countryCode: "PE",
    country: "Peru",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","PE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pe-073",
    lat: -9.235179,
    lng: -75.951685,
    panoId: "8IgI1olzaESu9EAJg1XSEg",
    place: "Near Naranjillo, Huánuco Department",
    shortName: "Naranjillo",
    countryCode: "PE",
    country: "Peru",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","PE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pe-074",
    lat: -8.392045,
    lng: -74.579419,
    panoId: "3HpVfBCYvCZqClxheGS37g",
    place: "Near Pucallpa, Ucayali",
    shortName: "Pucallpa",
    countryCode: "PE",
    country: "Peru",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","PE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pe-075",
    lat: -9.456864,
    lng: -77.551502,
    panoId: "Eb_Gp-NbVVzsgeS5mu_vVQ",
    place: "Near Jangas, Ancash",
    shortName: "Jangas",
    countryCode: "PE",
    country: "Peru",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","PE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pe-076",
    lat: -7.766013,
    lng: -79.195306,
    panoId: "73AL5kJ-Tz-TgpyHTPolgQ",
    place: "Near Casa Grande, La Libertad",
    shortName: "Casa Grande",
    countryCode: "PE",
    country: "Peru",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","PE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pe-077",
    lat: -4.88685,
    lng: -80.377698,
    panoId: "aYqrB5n_6K0mv0p5VG5lfQ",
    place: "Near Tambo Grande, Piura",
    shortName: "Tambo Grande",
    countryCode: "PE",
    country: "Peru",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","PE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pe-078",
    lat: -12.08133,
    lng: -77.08961,
    panoId: "kfrJZtcXW3Vm4WAHE_cLUw",
    place: "Near Carmen De La Legua Reynoso, Callao",
    shortName: "Carmen De La Legua Reynoso",
    countryCode: "PE",
    country: "Peru",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","PE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pe-079",
    lat: -13.498406,
    lng: -71.974847,
    panoId: "MWuatoPqOzmwsWEBFFa5ig",
    place: "Near Wanchaq, Cuzco Department",
    shortName: "Wanchaq",
    countryCode: "PE",
    country: "Peru",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","PE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pe-080",
    lat: -6.234334,
    lng: -77.90379,
    panoId: "uDMgZEBSv4akkbOOl2sAyQ",
    place: "Near Chachapoyas, Amazonas",
    shortName: "Chachapoyas",
    countryCode: "PE",
    country: "Peru",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","PE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pe-081",
    lat: -11.41886,
    lng: -75.72655,
    panoId: "u_AQ3Fv5uV0Gu2ager5l0g",
    place: "Near Tarma, Junin",
    shortName: "Tarma",
    countryCode: "PE",
    country: "Peru",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","PE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pe-082",
    lat: -5.331575,
    lng: -80.709831,
    panoId: "Gn-I7cDvy1PzVx5F3atxyw",
    place: "Near La Arena, Piura",
    shortName: "La Arena",
    countryCode: "PE",
    country: "Peru",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","PE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pe-083",
    lat: -7.175812,
    lng: -76.687007,
    panoId: "ZIXTiqrxaqZfpfZu74622w",
    place: "Near Pajarillo, San Martín Department",
    shortName: "Pajarillo",
    countryCode: "PE",
    country: "Peru",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","PE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pe-084",
    lat: -12.779493,
    lng: -75.042613,
    panoId: "dy-Yw3QUUrBlO74DmaFqZQ",
    place: "Near Ascencion, Huancavelica",
    shortName: "Ascencion",
    countryCode: "PE",
    country: "Peru",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","PE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pe-085",
    lat: -5.370986,
    lng: -80.704252,
    panoId: "PrlkCX3i0QA7YAfcOpkQew",
    place: "Near La Arena, Piura",
    shortName: "La Arena",
    countryCode: "PE",
    country: "Peru",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","PE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pe-086",
    lat: -11.984479,
    lng: -75.292625,
    panoId: "dVsMaONPBLoyQCQ4O7Lxfg",
    place: "Near Orcotuna, Junin",
    shortName: "Orcotuna",
    countryCode: "PE",
    country: "Peru",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","PE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pe-087",
    lat: -5.857503,
    lng: -76.153701,
    panoId: "kqhvg294n6FPHS2w6FCmfQ",
    place: "Near Yurimaguas, Loreto",
    shortName: "Yurimaguas",
    countryCode: "PE",
    country: "Peru",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","PE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pe-088",
    lat: -7.750402,
    lng: -79.171938,
    panoId: "T0oLno-Y94WzOuYF6fwTZA",
    place: "Near Casa Grande, La Libertad",
    shortName: "Casa Grande",
    countryCode: "PE",
    country: "Peru",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","PE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pe-089",
    lat: -13.107049,
    lng: -76.341306,
    panoId: "9ycm6nfYcaTrtpMiTBp02w",
    place: "Near Nuevo Imperial, Lima region",
    shortName: "Nuevo Imperial",
    countryCode: "PE",
    country: "Peru",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","PE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pe-090",
    lat: -5.134563,
    lng: -81.067729,
    panoId: "5uiwHnIQzjFbXA6TiuM2Dg",
    place: "Near Paita, Piura",
    shortName: "Paita",
    countryCode: "PE",
    country: "Peru",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","PE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pe-091",
    lat: -9.503422,
    lng: -77.495963,
    panoId: "O9hWPyRuSQFotwilUKk1CA",
    place: "Near Centenario, Ancash",
    shortName: "Centenario",
    countryCode: "PE",
    country: "Peru",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","PE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pe-092",
    lat: -5.660338,
    lng: -78.832122,
    panoId: "3L6VNaMlL2bjjtGRODCfRQ",
    place: "Near Las Pirias, Cajamarca Department",
    shortName: "Las Pirias",
    countryCode: "PE",
    country: "Peru",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","PE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pe-093",
    lat: -16.981497,
    lng: -72.103428,
    panoId: "mUI5MD4wkRoJjCoUfyjr8w",
    place: "Near Islay (Matarani), Arequipa",
    shortName: "Islay (Matarani)",
    countryCode: "PE",
    country: "Peru",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","PE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pe-094",
    lat: -5.969634,
    lng: -77.051219,
    panoId: "TzhBQML9aiFaIQUZt3Erhg",
    place: "Near Yantaló, San Martín Department",
    shortName: "Yantaló",
    countryCode: "PE",
    country: "Peru",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","PE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pe-095",
    lat: -5.352317,
    lng: -80.701706,
    panoId: "QwPFMs-_cSiHr4L2BxeglQ",
    place: "Near La Arena, Piura",
    shortName: "La Arena",
    countryCode: "PE",
    country: "Peru",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","PE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pe-096",
    lat: -11.476733,
    lng: -75.749316,
    panoId: "TT3fz0Zg117LeEUMr_kaDw",
    place: "Near Tarma, Junin",
    shortName: "Tarma",
    countryCode: "PE",
    country: "Peru",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","PE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pe-097",
    lat: -4.922128,
    lng: -80.867017,
    panoId: "02_QMCgPBUUsAjnc7QoLJw",
    place: "Near Sojo, Piura",
    shortName: "Sojo",
    countryCode: "PE",
    country: "Peru",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","PE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pe-098",
    lat: -8.399441,
    lng: -74.700639,
    panoId: "g8tPbhsb_6bfBONT7m975g",
    place: "Near San José, Ucayali",
    shortName: "San José",
    countryCode: "PE",
    country: "Peru",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","PE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pe-099",
    lat: -15.670222,
    lng: -70.115701,
    panoId: "re57TObjjfIccWzaVWzbEA",
    place: "Near Atuncolla, Puno",
    shortName: "Atuncolla",
    countryCode: "PE",
    country: "Peru",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","PE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pe-100",
    lat: -13.869226,
    lng: -76.127035,
    panoId: "0GH7n2p7_V7mZT9b-liicA",
    place: "Near Paracas, Ica",
    shortName: "Paracas",
    countryCode: "PE",
    country: "Peru",
    continent: "South America",
    difficulty: "adventurer",
    pools: ["world","South America","PE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pe-101",
    lat: -12.836728,
    lng: -74.840695,
    panoId: "hJ-pAPPAcKPzw4A_dBV-rA",
    place: "Near Yauli, Huancavelica",
    shortName: "Yauli",
    countryCode: "PE",
    country: "Peru",
    continent: "South America",
    difficulty: "adventurer",
    pools: ["world","South America","PE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pe-102",
    lat: -5.796537,
    lng: -78.915825,
    panoId: "DzDbE8NNZeRsG2H0qLON4Q",
    place: "Near Jaén, Cajamarca Department",
    shortName: "Jaén",
    countryCode: "PE",
    country: "Peru",
    continent: "South America",
    difficulty: "adventurer",
    pools: ["world","South America","PE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pe-103",
    lat: -6.147447,
    lng: -77.99628,
    panoId: "Lc_8TSJ4lEVf6L4YLdUPDQ",
    place: "Near Lamud, Amazonas",
    shortName: "Lamud",
    countryCode: "PE",
    country: "Peru",
    continent: "South America",
    difficulty: "adventurer",
    pools: ["world","South America","PE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pe-104",
    lat: -9.352284,
    lng: -77.507182,
    panoId: "SlN6DxHww1A5TFbEKqINig",
    place: "Near Aco, Ancash",
    shortName: "Aco",
    countryCode: "PE",
    country: "Peru",
    continent: "South America",
    difficulty: "adventurer",
    pools: ["world","South America","PE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pe-105",
    lat: -9.223265,
    lng: -75.836912,
    panoId: "m28_mqQTFupLHRvMgSOUKg",
    place: "Near Pumahuasi, Huánuco Department",
    shortName: "Pumahuasi",
    countryCode: "PE",
    country: "Peru",
    continent: "South America",
    difficulty: "adventurer",
    pools: ["world","South America","PE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pe-106",
    lat: -13.050686,
    lng: -74.40077,
    panoId: "QQuvp0vazPUwJFxIZmZI1Q",
    place: "Near Antaparco, Huancavelica",
    shortName: "Antaparco",
    countryCode: "PE",
    country: "Peru",
    continent: "South America",
    difficulty: "adventurer",
    pools: ["world","South America","PE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pe-107",
    lat: -11.183849,
    lng: -77.48069,
    panoId: "n-NiwlkUKiWk6uZuV8MAiQ",
    place: "Near Huacho, Lima region",
    shortName: "Huacho",
    countryCode: "PE",
    country: "Peru",
    continent: "South America",
    difficulty: "adventurer",
    pools: ["world","South America","PE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pe-108",
    lat: -14.741748,
    lng: -75.065683,
    panoId: "ej9aMj7ZFJhzPQUjTnTVXg",
    place: "Near El Ingenio, Ica",
    shortName: "El Ingenio",
    countryCode: "PE",
    country: "Peru",
    continent: "South America",
    difficulty: "adventurer",
    pools: ["world","South America","PE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "pe-109",
    lat: -10.949411,
    lng: -77.519516,
    panoId: "YxKt4U9SPJjJI6MHIHJoPg",
    place: "Near Végueta, Lima region",
    shortName: "Végueta",
    countryCode: "PE",
    country: "Peru",
    continent: "South America",
    difficulty: "adventurer",
    pools: ["world","South America","PE"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-000",
    lat: -33.456701,
    lng: -70.648372,
    panoId: "yqoDTVMrDIVGeyphEtIrbw",
    place: "Near Santiago, Santiago Metropolitan",
    shortName: "Santiago",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-001",
    lat: -33.51349,
    lng: -70.765027,
    panoId: "FdjdS61f0IU-PUX04mnLlg",
    place: "Near Maipú, Santiago Metropolitan",
    shortName: "Maipú",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-002",
    lat: -41.469256,
    lng: -72.942381,
    panoId: "3z9Z_PKj8XG2a01zNVF7OQ",
    place: "Near Puerto Montt, Los Lagos Region",
    shortName: "Puerto Montt",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-003",
    lat: -33.592143,
    lng: -70.699512,
    panoId: "vaihx5F6Be-u3YM-LMHSyw",
    place: "Near San Bernardo, Santiago Metropolitan",
    shortName: "San Bernardo",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-004",
    lat: -33.048405,
    lng: -71.372852,
    panoId: "VNR68VEehuWcb-AALUElTA",
    place: "Near Villa Alemana, Valparaiso",
    shortName: "Villa Alemana",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-005",
    lat: -35.423203,
    lng: -71.649772,
    panoId: "fe5HeeIKYO9RcMpX7UveKA",
    place: "Near Talca, Maule Region",
    shortName: "Talca",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-006",
    lat: -29.905914,
    lng: -71.250146,
    panoId: "p9XZeFLZfjGZhsEGDyhpZw",
    place: "Near La Serena, Coquimbo Region",
    shortName: "La Serena",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-007",
    lat: -23.650962,
    lng: -70.397478,
    panoId: "MXtx4tV61F88GGqn8Py2Pg",
    place: "Near Antofagasta, Antofagasta",
    shortName: "Antofagasta",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-008",
    lat: -36.72492,
    lng: -73.116884,
    panoId: "FmUxcNK2_fgwHqY6ivlxgw",
    place: "Near Talcahuano, Biobio",
    shortName: "Talcahuano",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-009",
    lat: -38.736277,
    lng: -72.597326,
    panoId: "PRKkI1rc8_a8Etvq-JVb7Q",
    place: "Near Temuco, Araucania",
    shortName: "Temuco",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-010",
    lat: -37.404722,
    lng: -71.9796,
    panoId: "JLZD6a7zA7ZYlgfrSajKvQ",
    place: "Near Villa Mercedes, Biobio",
    shortName: "Villa Mercedes",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-011",
    lat: -38.761046,
    lng: -72.598007,
    panoId: "EIXcMkMsOq49kIIYKOYABA",
    place: "Near Padre Las Casas, Araucania",
    shortName: "Padre Las Casas",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-012",
    lat: -33.611693,
    lng: -70.575501,
    panoId: "e24R1mK0BcCUabB-CfN8OA",
    place: "Near Puente Alto, Santiago Metropolitan",
    shortName: "Puente Alto",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-013",
    lat: -20.213269,
    lng: -70.150245,
    panoId: "4ZflISLDGc0IWgzetAH1Dw",
    place: "Near Iquique, Tarapacá",
    shortName: "Iquique",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-014",
    lat: -34.982753,
    lng: -71.239098,
    panoId: "bfLqOSncRhjkG6_ckAu2nw",
    place: "Near Curicó, Maule Region",
    shortName: "Curicó",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-015",
    lat: -37.033919,
    lng: -73.140135,
    panoId: "Yss_NK0iTlNOBtXRLdlKuA",
    place: "Near Coronel, Biobio",
    shortName: "Coronel",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-016",
    lat: -22.456917,
    lng: -68.923815,
    panoId: "yQzM2P7EZWWp6VAUjqZxgw",
    place: "Near Calama, Antofagasta",
    shortName: "Calama",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-017",
    lat: -37.469682,
    lng: -72.353843,
    panoId: "QLDqpHsEp_xFkq7rfV7J4w",
    place: "Near Los Ángeles, Biobio",
    shortName: "Los Ángeles",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-018",
    lat: -36.826937,
    lng: -73.049528,
    panoId: "J3OETMGn1g8HYmcfWwe7Ag",
    place: "Near Concepción, Biobio",
    shortName: "Concepción",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-019",
    lat: -18.475606,
    lng: -70.300687,
    panoId: "x68IvTnll7Bqwfkxx-ayFQ",
    place: "Near Arica, Arica y Parinacota Region",
    shortName: "Arica",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-020",
    lat: -33.025068,
    lng: -71.551988,
    panoId: "kJ4oY9O3JHSyzdsH2AHz4A",
    place: "Near Viña del Mar, Valparaiso",
    shortName: "Viña del Mar",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-021",
    lat: -36.838778,
    lng: -73.100268,
    panoId: "EUH59cGceCtyn_BXwXv02A",
    place: "Near San Pedro de la Paz, Biobio",
    shortName: "San Pedro de la Paz",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-022",
    lat: -36.606462,
    lng: -72.104124,
    panoId: "yUEEguOvtUWLa2hA6nfRaQ",
    place: "Near Chillán, Ñuble",
    shortName: "Chillán",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-023",
    lat: -27.367396,
    lng: -70.332216,
    panoId: "QFxSaY6HCzBOmlgfBQrSkw",
    place: "Near Copiapó, Atacama",
    shortName: "Copiapó",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-024",
    lat: -20.268729,
    lng: -70.104871,
    panoId: "YmFryz1-9B-uL-lJIS7Mbw",
    place: "Near Alto Hospicio, Tarapacá",
    shortName: "Alto Hospicio",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-025",
    lat: -33.204569,
    lng: -70.674774,
    panoId: "Ll9X4eKZUqzS3RLy_9Gu-A",
    place: "Near Colina, Santiago Metropolitan",
    shortName: "Colina",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-026",
    lat: -33.047515,
    lng: -71.442572,
    panoId: "FZmKcS6dem03GM3pDSFjag",
    place: "Near Quilpué, Valparaiso",
    shortName: "Quilpué",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-027",
    lat: -36.925652,
    lng: -73.028451,
    panoId: "Sf6rbQYWFHu7EYhyeJCTnw",
    place: "Near Chiguayante, Biobio",
    shortName: "Chiguayante",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-028",
    lat: -29.953365,
    lng: -71.339189,
    panoId: "t_NJutFsKvJ26qGcXPGI9w",
    place: "Near Coquimbo, Coquimbo Region",
    shortName: "Coquimbo",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-029",
    lat: -34.1691,
    lng: -70.74049,
    panoId: "W1GjPjeD5hIpEZxFH5xUVw",
    place: "Near Rancagua, O'Higgins Region",
    shortName: "Rancagua",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-030",
    lat: -33.036005,
    lng: -71.629585,
    panoId: "ReFg6KzQSp28yItAm5TqIQ",
    place: "Near Valparaíso, Valparaiso",
    shortName: "Valparaíso",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-031",
    lat: -30.601019,
    lng: -71.199086,
    panoId: "VHQxp4KZCermOfWgoF4jgg",
    place: "Near Ovalle, Coquimbo Region",
    shortName: "Ovalle",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-032",
    lat: -32.833572,
    lng: -70.598791,
    panoId: "WX9Xd03u10hjtPGXostmLQ",
    place: "Near Los Andes, Valparaiso",
    shortName: "Los Andes",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-033",
    lat: -34.974439,
    lng: -71.220979,
    panoId: "jiQOj3eikfzaN0FJ3DhbcQ",
    place: "Near Curicó, Maule Region",
    shortName: "Curicó",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-034",
    lat: -37.397776,
    lng: -71.963071,
    panoId: "bvoCnPta7Js_LmFoIeGcWA",
    place: "Near Villa Mercedes, Biobio",
    shortName: "Villa Mercedes",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-035",
    lat: -32.883478,
    lng: -71.248324,
    panoId: "B7a0apGHXJThy1r0TQBatQ",
    place: "Near Quillota, Valparaiso",
    shortName: "Quillota",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-036",
    lat: -33.595788,
    lng: -70.684743,
    panoId: "WbhDLXlyNsnM_LNjbUt__w",
    place: "Near San Bernardo, Santiago Metropolitan",
    shortName: "San Bernardo",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-037",
    lat: -37.463421,
    lng: -72.335747,
    panoId: "yRcGxLdd1sZslysUs4WyyQ",
    place: "Near Los Ángeles, Biobio",
    shortName: "Los Ángeles",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-038",
    lat: -29.918091,
    lng: -71.246438,
    panoId: "Lsd7pQvHjAeV7NNq3tQqzw",
    place: "Near La Serena, Coquimbo Region",
    shortName: "La Serena",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-039",
    lat: -38.779092,
    lng: -72.597471,
    panoId: "zjwzcBqavwH1Y0EVDsFXUA",
    place: "Near Padre Las Casas, Araucania",
    shortName: "Padre Las Casas",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-040",
    lat: -33.031022,
    lng: -71.447549,
    panoId: "RF1Pcmyr7IIurko0GHngog",
    place: "Near Quilpué, Valparaiso",
    shortName: "Quilpué",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-041",
    lat: -27.365394,
    lng: -70.311538,
    panoId: "OVBxyNdn5tzIkncKvX_Azg",
    place: "Near Copiapó, Atacama",
    shortName: "Copiapó",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-042",
    lat: -29.963293,
    lng: -71.336412,
    panoId: "_fABWw2gJXqjxEjEl4S3oQ",
    place: "Near Coquimbo, Coquimbo Region",
    shortName: "Coquimbo",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-043",
    lat: -33.034877,
    lng: -71.562958,
    panoId: "k1h1-hvVz85QvxPpUd02gw",
    place: "Near Viña del Mar, Valparaiso",
    shortName: "Viña del Mar",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-044",
    lat: -53.152344,
    lng: -70.885456,
    panoId: "bQUdfoSKFaVWrL22X418Rg",
    place: "Near Punta Arenas, Region of Magallanes",
    shortName: "Punta Arenas",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-045",
    lat: -41.470619,
    lng: -72.92459,
    panoId: "4KDQPH8hcZ8__h9rCAMBzA",
    place: "Near Puerto Montt, Los Lagos Region",
    shortName: "Puerto Montt",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-046",
    lat: -33.689085,
    lng: -71.215499,
    panoId: "SpfdtnAGR52N_TJZKpmrwA",
    place: "Near Melipilla, Santiago Metropolitan",
    shortName: "Melipilla",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-047",
    lat: -33.043856,
    lng: -71.395552,
    panoId: "1Jxa5-bNJiLvQPU-dlSpjQ",
    place: "Near Villa Alemana, Valparaiso",
    shortName: "Villa Alemana",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-048",
    lat: -36.702947,
    lng: -73.120922,
    panoId: "uVy1sushRZqLG9DExESXDg",
    place: "Near Talcahuano, Biobio",
    shortName: "Talcahuano",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-049",
    lat: -33.198399,
    lng: -70.698483,
    panoId: "CX3f0-BatHezRbWufk69Cg",
    place: "Near Colina, Santiago Metropolitan",
    shortName: "Colina",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-050",
    lat: -36.787753,
    lng: -73.127719,
    panoId: "7RrMCbHmjnhgaE3n-4Iztw",
    place: "Near San Pedro de la Paz, Biobio",
    shortName: "San Pedro de la Paz",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-051",
    lat: -36.814905,
    lng: -72.998497,
    panoId: "7kc0-EWyDSONnz5O3lUb0Q",
    place: "Near Concepción, Biobio",
    shortName: "Concepción",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-052",
    lat: -33.471393,
    lng: -70.707713,
    panoId: "xUPHEd0w-UshybyPnrERFA",
    place: "Near Lo Prado, Santiago Metropolitan",
    shortName: "Lo Prado",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-053",
    lat: -20.242969,
    lng: -70.140059,
    panoId: "lhN_h74VcDhCLSTEDG0T9A",
    place: "Near Iquique, Tarapacá",
    shortName: "Iquique",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-054",
    lat: -36.675551,
    lng: -73.108839,
    panoId: "FbpwO1ORrFDoAOz9QYV_FA",
    place: "Near Talcahuano, Biobio",
    shortName: "Talcahuano",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-055",
    lat: -36.964216,
    lng: -73.038892,
    panoId: "Q1QnKFqi16ccnh_6u4BTIw",
    place: "Near Chiguayante, Biobio",
    shortName: "Chiguayante",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-056",
    lat: -37.369245,
    lng: -71.965583,
    panoId: "XbOl2iKn_VG0cMO-ZrfB0Q",
    place: "Near Villa Mercedes, Biobio",
    shortName: "Villa Mercedes",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-057",
    lat: -20.272258,
    lng: -70.03757,
    panoId: "_Hc__Vwm8b3HTyDrveaCDA",
    place: "Near Alto Hospicio, Tarapacá",
    shortName: "Alto Hospicio",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-058",
    lat: -38.725574,
    lng: -72.662749,
    panoId: "YIiQcJaA5dIadc64ECmOzw",
    place: "Near Temuco, Araucania",
    shortName: "Temuco",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-059",
    lat: -32.920378,
    lng: -71.300498,
    panoId: "jKcs_0kqeDXNwvVBlFS8Nw",
    place: "Near Quillota, Valparaiso",
    shortName: "Quillota",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-060",
    lat: -29.962872,
    lng: -71.293006,
    panoId: "R9nIKf6I_alxPQq9N-hIhA",
    place: "Near Coquimbo, Coquimbo Region",
    shortName: "Coquimbo",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-061",
    lat: -27.392318,
    lng: -70.256882,
    panoId: "GiG1AGrJC0KxBhZC_FhP8g",
    place: "Near Copiapó, Atacama",
    shortName: "Copiapó",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-062",
    lat: -33.486335,
    lng: -70.797857,
    panoId: "GP5e2OFxYqJziI0sUCFHSA",
    place: "Near Maipú, Santiago Metropolitan",
    shortName: "Maipú",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-063",
    lat: -39.860262,
    lng: -73.243264,
    panoId: "HN4e3GzE86M8X_rJ-2gsvg",
    place: "Near Las Gaviotas, Los Ríos Region",
    shortName: "Las Gaviotas",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-064",
    lat: -35.798219,
    lng: -71.55887,
    panoId: "guPs0T7S2cczCt7TmEm01w",
    place: "Near Linares, Maule Region",
    shortName: "Linares",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-065",
    lat: -33.028666,
    lng: -71.409939,
    panoId: "kfxQEhD7mkY3UEYQtTy8xA",
    place: "Near Quilpué, Valparaiso",
    shortName: "Quilpué",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-066",
    lat: -23.592674,
    lng: -70.39713,
    panoId: "NdT_6vGRuEA1AxJMj1iQuQ",
    place: "Near Antofagasta, Antofagasta",
    shortName: "Antofagasta",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-067",
    lat: -33.201845,
    lng: -70.587437,
    panoId: "uHdZllDL_kRacd-Q6_neXg",
    place: "Near Colina, Santiago Metropolitan",
    shortName: "Colina",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-068",
    lat: -37.433442,
    lng: -72.391415,
    panoId: "dxHKG0BOtdErGE2N7WJqGA",
    place: "Near Los Ángeles, Biobio",
    shortName: "Los Ángeles",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-069",
    lat: -29.935937,
    lng: -71.283394,
    panoId: "pcEvDxJ0ejRkXWM19u-M5A",
    place: "Near La Serena, Coquimbo Region",
    shortName: "La Serena",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-070",
    lat: -32.890672,
    lng: -70.562165,
    panoId: "fkDnMXR9lh6C1flM-jiYiQ",
    place: "Near Calle Larga, Valparaiso",
    shortName: "Calle Larga",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-071",
    lat: -33.052492,
    lng: -71.49891,
    panoId: "83Sje1OXpEAQEbObYt5S_A",
    place: "Near Quilpué, Valparaiso",
    shortName: "Quilpué",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-072",
    lat: -35.416766,
    lng: -71.732669,
    panoId: "sCFjenhfJUkkaq1rw8XQZg",
    place: "Near Pencahue, Maule Region",
    shortName: "Pencahue",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-073",
    lat: -33.069277,
    lng: -71.401321,
    panoId: "YkwZOqaQU2ed0Pceh7-Blg",
    place: "Near Villa Alemana, Valparaiso",
    shortName: "Villa Alemana",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-074",
    lat: -18.414261,
    lng: -70.322685,
    panoId: "se9Liwe8kRsu40BvmVv2SQ",
    place: "Near Arica, Arica y Parinacota Region",
    shortName: "Arica",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-075",
    lat: -37.079809,
    lng: -73.122132,
    panoId: "XgASai2xt18NXms8AG-Diw",
    place: "Near Lota, Biobio",
    shortName: "Lota",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-076",
    lat: -22.470867,
    lng: -68.95488,
    panoId: "fBSOBJowHHyyl7tOhW1ffA",
    place: "Near Calama, Antofagasta",
    shortName: "Calama",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-077",
    lat: -39.255392,
    lng: -72.296594,
    panoId: "DAzK6fwuW-pNwZMCU4xunQ",
    place: "Near Villarrica, Araucania",
    shortName: "Villarrica",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-078",
    lat: -33.100238,
    lng: -71.654293,
    panoId: "eem-azhBo9-JR4jDUibl9Q",
    place: "Near Valparaíso, Valparaiso",
    shortName: "Valparaíso",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-079",
    lat: -33.047415,
    lng: -71.229736,
    panoId: "weogO3ipq8CGC9-0zXy-wg",
    place: "Near Limache, Valparaiso",
    shortName: "Limache",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-080",
    lat: -33.572172,
    lng: -70.746117,
    panoId: "iJzWDv8jVQWBXWqEy1ryqA",
    place: "Near San Bernardo, Santiago Metropolitan",
    shortName: "San Bernardo",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-081",
    lat: -33.65938,
    lng: -71.251959,
    panoId: "ELLiDNwDYyvOdlsRfFE7rw",
    place: "Near Melipilla, Santiago Metropolitan",
    shortName: "Melipilla",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-082",
    lat: -39.785517,
    lng: -73.178243,
    panoId: "nf20o1Ck7SKeukbxux00jQ",
    place: "Near Las Animas, Los Ríos Region",
    shortName: "Las Animas",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-083",
    lat: -34.224761,
    lng: -70.663759,
    panoId: "X6CwgGw-NcfOFFehSjJ5qA",
    place: "Near Machalí, O'Higgins Region",
    shortName: "Machalí",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-084",
    lat: -35.866808,
    lng: -71.529455,
    panoId: "lo5ewUngwtSHSONkm1G05w",
    place: "Near Linares, Maule Region",
    shortName: "Linares",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-085",
    lat: -42.504451,
    lng: -73.783681,
    panoId: "l297MivAwOyUGzGX3VclMQ",
    place: "Near Castro, Los Lagos Region",
    shortName: "Castro",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-086",
    lat: -33.69387,
    lng: -70.927492,
    panoId: "JNC41JAxkYmHQQ8VnhNjIA",
    place: "Near Talagante, Santiago Metropolitan",
    shortName: "Talagante",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-087",
    lat: -41.899586,
    lng: -73.794674,
    panoId: "O1e4rHDO8Ppju_VWsx2-aQ",
    place: "Near Ancud, Los Lagos Region",
    shortName: "Ancud",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-088",
    lat: -41.311191,
    lng: -72.917488,
    panoId: "TZkAZ3CEpJ2fXI6uh90JLw",
    place: "Near Puerto Varas, Los Lagos Region",
    shortName: "Puerto Varas",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-089",
    lat: -34.630319,
    lng: -71.313988,
    panoId: "5DXGfYyrfoHNiKmDHRFjIA",
    place: "Near Santa Cruz, O'Higgins Region",
    shortName: "Santa Cruz",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-090",
    lat: -35.918999,
    lng: -72.372532,
    panoId: "u5AwxGnpGtI_Lmn61FAnig",
    place: "Near Cauquenes, Maule Region",
    shortName: "Cauquenes",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-091",
    lat: -35.153725,
    lng: -71.364463,
    panoId: "k8MotfvqvivT8kSUlByXfQ",
    place: "Near Molina, Maule Region",
    shortName: "Molina",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-092",
    lat: -34.401699,
    lng: -70.798957,
    panoId: "6jKUyfGzSDmZFSOm_ThzoA",
    place: "Near Rengo, O'Higgins Region",
    shortName: "Rengo",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-093",
    lat: -35.50559,
    lng: -71.554931,
    panoId: "aIWLrFmLHrskKGFFzdnbKw",
    place: "Near San Clemente, Maule Region",
    shortName: "San Clemente",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-094",
    lat: -35.551784,
    lng: -71.749437,
    panoId: "BT4YURzMMGqXsyHnxJuiTQ",
    place: "Near San Javier, Maule Region",
    shortName: "San Javier",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-095",
    lat: -33.078186,
    lng: -71.641075,
    panoId: "viEVgGCuheMWGgazcsALIA",
    place: "Near Valparaíso, Valparaiso",
    shortName: "Valparaíso",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-096",
    lat: -28.640543,
    lng: -70.749937,
    panoId: "WXmzhDCfjbd-Bz52mMHERw",
    place: "Near Vallenar, Atacama",
    shortName: "Vallenar",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-097",
    lat: -38.492126,
    lng: -72.517141,
    panoId: "2PU3LBkphY5mSQBs8qLT3Q",
    place: "Near Lautaro, Araucania",
    shortName: "Lautaro",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-098",
    lat: -38.899157,
    lng: -72.681241,
    panoId: "yXq25ig2s1HWRkLC68vzsw",
    place: "Near Freire, Araucania",
    shortName: "Freire",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-099",
    lat: -18.377009,
    lng: -70.210658,
    panoId: "PVDJA86k_tp0OQL_kOPqOQ",
    place: "Near Arica, Arica y Parinacota Region",
    shortName: "Arica",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-100",
    lat: -45.735536,
    lng: -72.233609,
    panoId: "kchGLxELzKjABpMSEDDQbg",
    place: "Near Coyhaique, Aysén",
    shortName: "Coyhaique",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "adventurer",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-101",
    lat: -36.620693,
    lng: -72.741411,
    panoId: "4TqboXLFbQyk3Xs8uHvrrA",
    place: "Near Coelemu, Ñuble",
    shortName: "Coelemu",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "adventurer",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-102",
    lat: -36.482512,
    lng: -72.189967,
    panoId: "OBKAimKtqgLGyBfoRgXJiA",
    place: "Near Chillán, Ñuble",
    shortName: "Chillán",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "adventurer",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-103",
    lat: -33.616248,
    lng: -71.435047,
    panoId: "TMt1yjCmBsT-xTof28h0dw",
    place: "Near San Antonio, Valparaiso",
    shortName: "San Antonio",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "adventurer",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-104",
    lat: -38.588115,
    lng: -72.676996,
    panoId: "nJzqGPCXrcYhTP0Rnc0VdA",
    place: "Near Temuco, Araucania",
    shortName: "Temuco",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "adventurer",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-105",
    lat: -41.638855,
    lng: -73.294014,
    panoId: "yLuR4aLt2TDeRPhCrlMn0A",
    place: "Near Calbuco, Los Lagos Region",
    shortName: "Calbuco",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "adventurer",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-106",
    lat: -35.592178,
    lng: -71.280142,
    panoId: "ON9gLHwXPflSEv1UmCbX6w",
    place: "Near Colbún, Maule Region",
    shortName: "Colbún",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "adventurer",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-107",
    lat: -28.659803,
    lng: -70.894689,
    panoId: "Dz6O6ZGV3--h56A2vWtfqg",
    place: "Near Vallenar, Atacama",
    shortName: "Vallenar",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "adventurer",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-108",
    lat: -33.026166,
    lng: -71.083031,
    panoId: "BxMPXxbJoSPZGCYNrqwXSw",
    place: "Near Tiltil, Santiago Metropolitan",
    shortName: "Tiltil",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "adventurer",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-109",
    lat: -36.082277,
    lng: -72.484482,
    panoId: "aFK8uI6_RcIE15ycHR2T1g",
    place: "Near Cauquenes, Maule Region",
    shortName: "Cauquenes",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "adventurer",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-110",
    lat: -36.762913,
    lng: -72.12473,
    panoId: "DIu80aBSASJ9DYhFpKcJfg",
    place: "Near Chillán Viejo, Ñuble",
    shortName: "Chillán Viejo",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "adventurer",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-111",
    lat: -41.350454,
    lng: -72.788273,
    panoId: "i-Zk-kqOpB982fgzbFtJjg",
    place: "Near Puerto Varas, Los Lagos Region",
    shortName: "Puerto Varas",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "adventurer",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "cl-112",
    lat: -38.935364,
    lng: -72.881446,
    panoId: "7yuSRbu8K1Xjsu_NeTLj_A",
    place: "Near Teodoro Schmidt, Araucania",
    shortName: "Teodoro Schmidt",
    countryCode: "CL",
    country: "Chile",
    continent: "South America",
    difficulty: "adventurer",
    pools: ["world","South America","CL"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "co-000",
    lat: 6.245078,
    lng: -75.571462,
    panoId: "6nvvd-LMjXL0ZUUP6OaiEg",
    place: "Near Medellín, Antioquia",
    shortName: "Medellín",
    countryCode: "CO",
    country: "Colombia",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "co-001",
    lat: 7.907398,
    lng: -72.504781,
    panoId: "o5WsnzYaVaDJET7eg-DG7A",
    place: "Near Cúcuta, Norte de Santander Department",
    shortName: "Cúcuta",
    countryCode: "CO",
    country: "Colombia",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "co-002",
    lat: 10.968525,
    lng: -74.781255,
    panoId: "Vc4cf_5s-4NGUMvvAF_RKQ",
    place: "Near Barranquilla, Atlántico",
    shortName: "Barranquilla",
    countryCode: "CO",
    country: "Colombia",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "co-003",
    lat: 9.304479,
    lng: -75.390527,
    panoId: "UcS1cs6l8I7NRc1C3NRIbQ",
    place: "Near Sincelejo, Sucre Department",
    shortName: "Sincelejo",
    countryCode: "CO",
    country: "Colombia",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "co-004",
    lat: 11.23854,
    lng: -74.194236,
    panoId: "iv5B5VGz81qM_oFxofSgIw",
    place: "Near Santa Marta, Magdalena Department",
    shortName: "Santa Marta",
    countryCode: "CO",
    country: "Colombia",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "co-005",
    lat: 7.065354,
    lng: -73.854682,
    panoId: "1mqHSNlMJB_nTpRuvAG-Jg",
    place: "Near Barrancabermeja, Santander Department",
    shortName: "Barrancabermeja",
    countryCode: "CO",
    country: "Colombia",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "co-006",
    lat: 4.610077,
    lng: -74.082372,
    panoId: "vDDTGrN-TqVZDxYh0KSGbg",
    place: "Near Bogotá, Bogota D.C.",
    shortName: "Bogotá",
    countryCode: "CO",
    country: "Colombia",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "co-007",
    lat: 6.175632,
    lng: -75.591368,
    panoId: "lRlolZuCr2fM2xg2_HdbYg",
    place: "Near Envigado, Antioquia",
    shortName: "Envigado",
    countryCode: "CO",
    country: "Colombia",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","CO"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "co-008",
    lat: 4.435773,
    lng: -75.202873,
    panoId: "VUH6IT1PxKuAFxjKUZcL5A",
    place: "Near Ibagué, Tolima Department",
    shortName: "Ibagué",
    countryCode: "CO",
    country: "Colombia",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "co-009",
    lat: 5.06684,
    lng: -75.506867,
    panoId: "43rLoym0Ep9OR172bV90mQ",
    place: "Near Manizales, Caldas Department",
    shortName: "Manizales",
    countryCode: "CO",
    country: "Colombia",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "co-010",
    lat: 4.084814,
    lng: -76.195337,
    panoId: "0fGL9yJswfNRQdVkfAuC3A",
    place: "Near Tuluá, Valle del Cauca Department",
    shortName: "Tuluá",
    countryCode: "CO",
    country: "Colombia",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "co-011",
    lat: 2.929767,
    lng: -75.279763,
    panoId: "Ie3OjCRNj_OAGAJad8uYHQ",
    place: "Near Neiva, Huila Department",
    shortName: "Neiva",
    countryCode: "CO",
    country: "Colombia",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "co-012",
    lat: 3.430576,
    lng: -76.519766,
    panoId: "D7DCiYwJiaGnyoMEVwbiBg",
    place: "Near Cali, Valle del Cauca Department",
    shortName: "Cali",
    countryCode: "CO",
    country: "Colombia",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","CO"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "co-013",
    lat: 4.813672,
    lng: -74.354579,
    panoId: "iqKKfIU4bPZ1v_dsYnf05g",
    place: "Near Facatativá, Cundinamarca",
    shortName: "Facatativá",
    countryCode: "CO",
    country: "Colombia",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "co-014",
    lat: 1.615505,
    lng: -75.604097,
    panoId: "XYc1-mXmjqt8HYPm13Bm3w",
    place: "Near Florencia, Caquetá",
    shortName: "Florencia",
    countryCode: "CO",
    country: "Colombia",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "co-015",
    lat: 5.335759,
    lng: -72.393906,
    panoId: "3cB3Mz31BkFJ-7utOnP8Ng",
    place: "Near Yopal, Casanare Department",
    shortName: "Yopal",
    countryCode: "CO",
    country: "Colombia",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "co-016",
    lat: 7.06203,
    lng: -73.086311,
    panoId: "lpX9tnxyH2Wy37YxbLcfnw",
    place: "Near Floridablanca, Santander Department",
    shortName: "Floridablanca",
    countryCode: "CO",
    country: "Colombia",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "co-017",
    lat: 7.124992,
    lng: -73.119015,
    panoId: "Z9Znbrh1Db8sqBfP-UdtIg",
    place: "Near Bucaramanga, Santander Department",
    shortName: "Bucaramanga",
    countryCode: "CO",
    country: "Colombia",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","CO"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "co-018",
    lat: 10.918498,
    lng: -74.764663,
    panoId: "KhYi5MOjGr7kj77NOigdRw",
    place: "Near Soledad, Atlántico",
    shortName: "Soledad",
    countryCode: "CO",
    country: "Colombia",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "co-019",
    lat: 4.536731,
    lng: -75.672785,
    panoId: "R2trW-pjXE5T8exykXHLxA",
    place: "Near Armenia, Quindío Department",
    shortName: "Armenia",
    countryCode: "CO",
    country: "Colombia",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "co-020",
    lat: 6.184615,
    lng: -75.599184,
    panoId: "ZysT8F0o_y1kZw-In9eMkQ",
    place: "Near Itagüí, Antioquia",
    shortName: "Itagüí",
    countryCode: "CO",
    country: "Colombia",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "co-021",
    lat: 10.465356,
    lng: -73.253123,
    panoId: "AWd3aWRXDLhkDRcZ7N45PQ",
    place: "Near Valledupar, Cesar Department",
    shortName: "Valledupar",
    countryCode: "CO",
    country: "Colombia",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","CO"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "co-022",
    lat: 4.814292,
    lng: -75.695078,
    panoId: "_mnhnOKAg1Z6l1O0BKOwQw",
    place: "Near Pereira, Risaralda Department",
    shortName: "Pereira",
    countryCode: "CO",
    country: "Colombia",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "co-023",
    lat: 1.855051,
    lng: -76.050193,
    panoId: "MUhb5IO8VVuuP0HOq4S8cg",
    place: "Near Pitalito, Huila Department",
    shortName: "Pitalito",
    countryCode: "CO",
    country: "Colombia",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "co-024",
    lat: 4.132411,
    lng: -73.625663,
    panoId: "KCMN9oWxtRHeuSNAuvfM1w",
    place: "Near Villavicencio, Meta Department",
    shortName: "Villavicencio",
    countryCode: "CO",
    country: "Colombia",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "co-025",
    lat: 8.750804,
    lng: -75.878216,
    panoId: "Gn_bpK5EAm2ITp9OouOS2g",
    place: "Near Montería, Córdoba",
    shortName: "Montería",
    countryCode: "CO",
    country: "Colombia",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "co-026",
    lat: 5.544813,
    lng: -73.357569,
    panoId: "7qJeEXChVDfwS4gta2-XaQ",
    place: "Near Tunja, Boyacá",
    shortName: "Tunja",
    countryCode: "CO",
    country: "Colombia",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "co-027",
    lat: 4.732049,
    lng: -74.264348,
    panoId: "xYpCgUYt0eUBJr69BDzySA",
    place: "Near Madrid, Cundinamarca",
    shortName: "Madrid",
    countryCode: "CO",
    country: "Colombia",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","CO"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "co-028",
    lat: 1.214481,
    lng: -77.278743,
    panoId: "4gjPSoOGFzqUcuQSL3ps0Q",
    place: "Near Pasto, Nariño",
    shortName: "Pasto",
    countryCode: "CO",
    country: "Colombia",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","CO"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "co-029",
    lat: 4.579125,
    lng: -74.216635,
    panoId: "TOBSV-ecJvV3HfNev7uoIg",
    place: "Near Soacha, Cundinamarca",
    shortName: "Soacha",
    countryCode: "CO",
    country: "Colombia",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "co-030",
    lat: 6.988017,
    lng: -73.049191,
    panoId: "2aRE09IqhALOxLBV-wxNQQ",
    place: "Near Piedecuesta, Santander Department",
    shortName: "Piedecuesta",
    countryCode: "CO",
    country: "Colombia",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "co-031",
    lat: 4.839111,
    lng: -75.6673,
    panoId: "KFT4WxTLXd4zjakllFCf7Q",
    place: "Near Dosquebradas, Risaralda Department",
    shortName: "Dosquebradas",
    countryCode: "CO",
    country: "Colombia",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "co-032",
    lat: 11.544435,
    lng: -72.907163,
    panoId: "4OwwPGRh02bc24FB6TmI4g",
    place: "Near Riohacha, La Guajira Department",
    shortName: "Riohacha",
    countryCode: "CO",
    country: "Colombia",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "co-033",
    lat: 4.558795,
    lng: -74.225241,
    panoId: "7kNptCYZzDq_zj1xFqoVDw",
    place: "Near Soacha, Cundinamarca",
    shortName: "Soacha",
    countryCode: "CO",
    country: "Colombia",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","CO"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "co-034",
    lat: 4.720786,
    lng: -74.248408,
    panoId: "np0F66yAD2j0uViL5oqEwA",
    place: "Near Madrid, Cundinamarca",
    shortName: "Madrid",
    countryCode: "CO",
    country: "Colombia",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "co-035",
    lat: 7.08193,
    lng: -73.840913,
    panoId: "MVLpyRj7a2aYFMEowgAMOw",
    place: "Near Barrancabermeja, Santander Department",
    shortName: "Barrancabermeja",
    countryCode: "CO",
    country: "Colombia",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "co-036",
    lat: 4.613781,
    lng: -74.092852,
    panoId: "tLYbVJKx0nbjD0mqMtRBrw",
    place: "Near Bogotá, Bogota D.C.",
    shortName: "Bogotá",
    countryCode: "CO",
    country: "Colombia",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "co-037",
    lat: 10.393998,
    lng: -75.515104,
    panoId: "8NhgnNyj_zEem8K3CPJLtg",
    place: "Near Cartagena, Bolívar",
    shortName: "Cartagena",
    countryCode: "CO",
    country: "Colombia",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "co-038",
    lat: 6.232698,
    lng: -75.558567,
    panoId: "OQDh_13JMGsG2TZarNDITg",
    place: "Near Medellín, Antioquia",
    shortName: "Medellín",
    countryCode: "CO",
    country: "Colombia",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "co-039",
    lat: 6.990403,
    lng: -73.070882,
    panoId: "K_2VET7pQgNumNI4r28SXA",
    place: "Near Piedecuesta, Santander Department",
    shortName: "Piedecuesta",
    countryCode: "CO",
    country: "Colombia",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "co-040",
    lat: 10.935113,
    lng: -74.765918,
    panoId: "TZJIfVXhm2J88wxZ0Vi9IQ",
    place: "Near Soledad, Atlántico",
    shortName: "Soledad",
    countryCode: "CO",
    country: "Colombia",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "co-041",
    lat: 5.06766,
    lng: -75.488603,
    panoId: "j7vgtbwsZpljF2S_gNFzyA",
    place: "Near Manizales, Caldas Department",
    shortName: "Manizales",
    countryCode: "CO",
    country: "Colombia",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "co-042",
    lat: 3.44449,
    lng: -76.514709,
    panoId: "ys5O3Bojd5THg2TdLEo28g",
    place: "Near Cali, Valle del Cauca Department",
    shortName: "Cali",
    countryCode: "CO",
    country: "Colombia",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","CO"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "co-043",
    lat: 10.475017,
    lng: -73.243227,
    panoId: "qHvIGYP8tuBbc5FMIUcn8A",
    place: "Near Valledupar, Cesar Department",
    shortName: "Valledupar",
    countryCode: "CO",
    country: "Colombia",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","CO"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "co-044",
    lat: 1.206216,
    lng: -77.263999,
    panoId: "X2jeo09k7GubE7rhUgIuzw",
    place: "Near Puerres, Nariño",
    shortName: "Puerres",
    countryCode: "CO",
    country: "Colombia",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "co-045",
    lat: 10.950903,
    lng: -74.793285,
    panoId: "I3Elj7R4yGFzETZCAhumqA",
    place: "Near Barranquilla, Atlántico",
    shortName: "Barranquilla",
    countryCode: "CO",
    country: "Colombia",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "co-046",
    lat: 7.082489,
    lng: -73.090841,
    panoId: "7bNmdaR7lDR7UAF49Osk2A",
    place: "Near Floridablanca, Santander Department",
    shortName: "Floridablanca",
    countryCode: "CO",
    country: "Colombia",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "co-047",
    lat: 7.888713,
    lng: -72.512729,
    panoId: "4_OujEldk2O0oiOKGbHdIw",
    place: "Near Cúcuta, Norte de Santander Department",
    shortName: "Cúcuta",
    countryCode: "CO",
    country: "Colombia",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "co-048",
    lat: 1.626988,
    lng: -75.606764,
    panoId: "CBHaOM8GyPiAfd-JpgLOxQ",
    place: "Near Florencia, Caquetá",
    shortName: "Florencia",
    countryCode: "CO",
    country: "Colombia",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "co-049",
    lat: 1.866277,
    lng: -76.03983,
    panoId: "t2BAmvkJi2jsrFcTQyCVjw",
    place: "Near Pitalito, Huila Department",
    shortName: "Pitalito",
    countryCode: "CO",
    country: "Colombia",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","CO"],
    qualityTier: 4,
    verified: true,
  },
];

const CHUNK_9: GeoLocation[] = [
  {
    id: "co-050",
    lat: 5.562948,
    lng: -73.379032,
    panoId: "eXo7xt6y1vMH0bphSy4hFw",
    place: "Near Motavita, Boyacá",
    shortName: "Motavita",
    countryCode: "CO",
    country: "Colombia",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "co-051",
    lat: 5.046541,
    lng: -74.026851,
    panoId: "e35HmK1hWe57Ed4wd2GymA",
    place: "Near Zipaquirá, Cundinamarca",
    shortName: "Zipaquirá",
    countryCode: "CO",
    country: "Colombia",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","CO"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "co-052",
    lat: 7.052758,
    lng: -73.787833,
    panoId: "8y6Oj0dh6YSnRnO5Sl7Cug",
    place: "Near Barrancabermeja, Santander Department",
    shortName: "Barrancabermeja",
    countryCode: "CO",
    country: "Colombia",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "co-053",
    lat: 1.834087,
    lng: -76.112018,
    panoId: "9MFKc434ByIcgRA3q7gYRg",
    place: "Near Pitalito, Huila Department",
    shortName: "Pitalito",
    countryCode: "CO",
    country: "Colombia",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "co-054",
    lat: 3.388008,
    lng: -76.513351,
    panoId: "0fxs9aUXdTj0bl2eVbWGww",
    place: "Near Cali, Valle del Cauca Department",
    shortName: "Cali",
    countryCode: "CO",
    country: "Colombia",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","CO"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "co-055",
    lat: 6.186775,
    lng: -75.562858,
    panoId: "96WdRD5qU6vpqdC7D2fv-g",
    place: "Near Envigado, Antioquia",
    shortName: "Envigado",
    countryCode: "CO",
    country: "Colombia",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "co-056",
    lat: 10.437007,
    lng: -75.527914,
    panoId: "xtF2YWSgNgd5HfAeuAIOFw",
    place: "Near Cartagena, Bolívar",
    shortName: "Cartagena",
    countryCode: "CO",
    country: "Colombia",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","CO"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "co-057",
    lat: 4.08243,
    lng: -73.637715,
    panoId: "41nkSY2Pnz66fVXzJ6ABrw",
    place: "Near Villavicencio, Meta Department",
    shortName: "Villavicencio",
    countryCode: "CO",
    country: "Colombia",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "co-058",
    lat: 5.530189,
    lng: -73.334733,
    panoId: "5Udst-m67-XiCEjazn4SKQ",
    place: "Near Tunja, Boyacá",
    shortName: "Tunja",
    countryCode: "CO",
    country: "Colombia",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "co-059",
    lat: 5.380833,
    lng: -72.418082,
    panoId: "5xy02XLi40MRaGNhOf7DjA",
    place: "Near Yopal, Casanare Department",
    shortName: "Yopal",
    countryCode: "CO",
    country: "Colombia",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "co-060",
    lat: 6.222624,
    lng: -75.617168,
    panoId: "cJMXNkrsgMtY4wVm-yNs8Q",
    place: "Near Itagüí, Antioquia",
    shortName: "Itagüí",
    countryCode: "CO",
    country: "Colombia",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "co-061",
    lat: 4.583818,
    lng: -75.719807,
    panoId: "naUYDB6PCr2-XNAHBwb36g",
    place: "Near Montenegro, Quindío Department",
    shortName: "Montenegro",
    countryCode: "CO",
    country: "Colombia",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "co-062",
    lat: 7.867312,
    lng: -72.479391,
    panoId: "l3b8THIHqCFp5GAHEawnPw",
    place: "Near Villa del Rosario, Norte de Santander Department",
    shortName: "Villa del Rosario",
    countryCode: "CO",
    country: "Colombia",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "co-063",
    lat: 10.968369,
    lng: -74.838991,
    panoId: "g0tfROEXh_DuQGkep_BbSQ",
    place: "Near Barranquilla, Atlántico",
    shortName: "Barranquilla",
    countryCode: "CO",
    country: "Colombia",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","CO"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "co-064",
    lat: 4.464803,
    lng: -75.260345,
    panoId: "cw1oABv31gY2IT2-pRIbbg",
    place: "Near Ibagué, Tolima Department",
    shortName: "Ibagué",
    countryCode: "CO",
    country: "Colombia",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "co-065",
    lat: 9.234467,
    lng: -75.373473,
    panoId: "xacLVv8nmPpYnTtwwRLoUg",
    place: "Near Sampués, Sucre Department",
    shortName: "Sampués",
    countryCode: "CO",
    country: "Colombia",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "co-066",
    lat: 11.185331,
    lng: -74.234024,
    panoId: "aoBXnqh95I_rHEAdNkpJsQ",
    place: "Near Santa Marta, Magdalena Department",
    shortName: "Santa Marta",
    countryCode: "CO",
    country: "Colombia",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "co-067",
    lat: 4.828112,
    lng: -74.309806,
    panoId: "qAY1bEQ-OMIhy4JKtqNA9g",
    place: "Near Facatativá, Cundinamarca",
    shortName: "Facatativá",
    countryCode: "CO",
    country: "Colombia",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "co-068",
    lat: 2.895227,
    lng: -75.336536,
    panoId: "4LnDLvCH4mVP6kffSZmYwQ",
    place: "Near Neiva, Huila Department",
    shortName: "Neiva",
    countryCode: "CO",
    country: "Colombia",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "co-069",
    lat: 4.050006,
    lng: -76.204463,
    panoId: "s9Ut-7pRWIrCuoyiJ1aiGg",
    place: "Near Tuluá, Valle del Cauca Department",
    shortName: "Tuluá",
    countryCode: "CO",
    country: "Colombia",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "co-070",
    lat: 4.84609,
    lng: -74.104285,
    panoId: "gL_KNZuLk4WnDrej3exXlQ",
    place: "Near Cota, Cundinamarca",
    shortName: "Cota",
    countryCode: "CO",
    country: "Colombia",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","CO"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "co-071",
    lat: 10.665778,
    lng: -74.933537,
    panoId: "kMFUQ8CqRWomiHzDEivG5w",
    place: "Near Sabanalarga, Atlántico",
    shortName: "Sabanalarga",
    countryCode: "CO",
    country: "Colombia",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "co-072",
    lat: 4.10079,
    lng: -73.599103,
    panoId: "MZGD4RJn5Jss2OkI3zRITA",
    place: "Near Villavicencio, Meta Department",
    shortName: "Villavicencio",
    countryCode: "CO",
    country: "Colombia",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "co-073",
    lat: 4.691913,
    lng: -74.166252,
    panoId: "wtsYlElP1AwP1FJOXcPyFw",
    place: "Near Funza, Cundinamarca",
    shortName: "Funza",
    countryCode: "CO",
    country: "Colombia",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "co-074",
    lat: 5.076222,
    lng: -74.053762,
    panoId: "c2uxcvAB_MsuAR4VVCmntg",
    place: "Near Zipaquirá, Cundinamarca",
    shortName: "Zipaquirá",
    countryCode: "CO",
    country: "Colombia",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "co-075",
    lat: 4.599074,
    lng: -75.665846,
    panoId: "kQrOioLGIhFNMBg5n9OM7w",
    place: "Near Circasia, Quindío Department",
    shortName: "Circasia",
    countryCode: "CO",
    country: "Colombia",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "co-076",
    lat: 6.952416,
    lng: -72.984798,
    panoId: "HWxAGCS93mX5fRT3YDpzqQ",
    place: "Near Piedecuesta, Santander Department",
    shortName: "Piedecuesta",
    countryCode: "CO",
    country: "Colombia",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "co-077",
    lat: 4.740429,
    lng: -74.225592,
    panoId: "C90CdXJhgMIOtXUhEhUkbw",
    place: "Near Funza, Cundinamarca",
    shortName: "Funza",
    countryCode: "CO",
    country: "Colombia",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "co-078",
    lat: 9.276294,
    lng: -75.353347,
    panoId: "p2Ze4KTrAwin8r9m0f1tvw",
    place: "Near Sincelejo, Sucre Department",
    shortName: "Sincelejo",
    countryCode: "CO",
    country: "Colombia",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "co-079",
    lat: 6.110296,
    lng: -75.421739,
    panoId: "mYEGln2sjJki9rLz9xY_Mg",
    place: "Near Rionegro, Antioquia",
    shortName: "Rionegro",
    countryCode: "CO",
    country: "Colombia",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "co-080",
    lat: 3.479132,
    lng: -76.329759,
    panoId: "XmM9-dtPAEI4LRGcUH5Gnw",
    place: "Near Palmira, Valle del Cauca Department",
    shortName: "Palmira",
    countryCode: "CO",
    country: "Colombia",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "co-081",
    lat: 7.009328,
    lng: -73.173777,
    panoId: "4igI6cRRAIYYiOqUL2Kmpg",
    place: "Near Girón, Santander Department",
    shortName: "Girón",
    countryCode: "CO",
    country: "Colombia",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "co-082",
    lat: 4.444794,
    lng: -75.151273,
    panoId: "z_wx_u8ZbRh2EztgsP_5TQ",
    place: "Near Ibagué, Tolima Department",
    shortName: "Ibagué",
    countryCode: "CO",
    country: "Colombia",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "co-083",
    lat: 4.104024,
    lng: -76.150169,
    panoId: "_iM581GWIMw6i-EO2gK1tg",
    place: "Near Tuluá, Valle del Cauca Department",
    shortName: "Tuluá",
    countryCode: "CO",
    country: "Colombia",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "co-084",
    lat: 4.250847,
    lng: -74.771985,
    panoId: "---2N8Jz6xzVAJnkqC0CWg",
    place: "Near Ricaurte, Cundinamarca",
    shortName: "Ricaurte",
    countryCode: "CO",
    country: "Colombia",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "co-085",
    lat: 10.443053,
    lng: -75.518831,
    panoId: "u-3E5Mp2UthxBZ-qy208aw",
    place: "Near Cartagena, Bolívar",
    shortName: "Cartagena",
    countryCode: "CO",
    country: "Colombia",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "co-086",
    lat: 2.919565,
    lng: -75.314451,
    panoId: "6EENpOWEGPsq5W4nuyih3g",
    place: "Near Neiva, Huila Department",
    shortName: "Neiva",
    countryCode: "CO",
    country: "Colombia",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","CO"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "co-087",
    lat: 5.021289,
    lng: -74.036273,
    panoId: "gu3hcvr_E8XkoxrKO4sMWQ",
    place: "Near Zipaquirá, Cundinamarca",
    shortName: "Zipaquirá",
    countryCode: "CO",
    country: "Colombia",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","CO"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "co-088",
    lat: 4.808621,
    lng: -75.732809,
    panoId: "mSrHwUoAgyGQ6S732R-lUw",
    place: "Near Pereira, Risaralda Department",
    shortName: "Pereira",
    countryCode: "CO",
    country: "Colombia",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "co-089",
    lat: 2.46679,
    lng: -76.629023,
    panoId: "qK_Jx1tsaYViEsZEb3TPmw",
    place: "Near Popayán, Cauca Department",
    shortName: "Popayán",
    countryCode: "CO",
    country: "Colombia",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","CO"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "co-090",
    lat: 5.807153,
    lng: -72.973331,
    panoId: "gxd2R_Ft4laOv-GACiFVpQ",
    place: "Near Nobsa, Boyacá",
    shortName: "Nobsa",
    countryCode: "CO",
    country: "Colombia",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "co-091",
    lat: 1.279993,
    lng: -77.26961,
    panoId: "5NYA3ufz3A97-XWuAh5Dfw",
    place: "Near Pasto, Nariño",
    shortName: "Pasto",
    countryCode: "CO",
    country: "Colombia",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "co-092",
    lat: 4.374112,
    lng: -74.403813,
    panoId: "Sqq2ueV66vdegmXEy32AxQ",
    place: "Near Silvania, Cundinamarca",
    shortName: "Silvania",
    countryCode: "CO",
    country: "Colombia",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "co-093",
    lat: 5.696179,
    lng: -72.965343,
    panoId: "vcoVntBcQTxICDmmYwL9_w",
    place: "Near Sogamoso, Boyacá",
    shortName: "Sogamoso",
    countryCode: "CO",
    country: "Colombia",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "co-094",
    lat: 11.25703,
    lng: -74.103804,
    panoId: "C0LuET_0eHwpN3BmblTQqg",
    place: "Near Santa Marta, Magdalena Department",
    shortName: "Santa Marta",
    countryCode: "CO",
    country: "Colombia",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "co-095",
    lat: 11.520692,
    lng: -72.843386,
    panoId: "kU3bmviLQw7_wt4Z7GiN7g",
    place: "Near Riohacha, La Guajira Department",
    shortName: "Riohacha",
    countryCode: "CO",
    country: "Colombia",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "co-096",
    lat: 2.290878,
    lng: -76.703995,
    panoId: "CxqO4zuWE02_qWAR2gAq6g",
    place: "Near Rosas, Cauca Department",
    shortName: "Rosas",
    countryCode: "CO",
    country: "Colombia",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","CO"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "co-097",
    lat: 5.10188,
    lng: -75.652019,
    panoId: "XSzDxIkDNY84Q6r717g-cA",
    place: "Near Palestina, Caldas Department",
    shortName: "Palestina",
    countryCode: "CO",
    country: "Colombia",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "co-098",
    lat: 5.572124,
    lng: -72.953855,
    panoId: "2ecsQNn5hX0oGG6C6GlkbQ",
    place: "Near Cuítiva, Boyacá",
    shortName: "Cuítiva",
    countryCode: "CO",
    country: "Colombia",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "co-099",
    lat: 4.825019,
    lng: -75.734216,
    panoId: "xSGFjmrIEhQml361ZTp9IA",
    place: "Near Pereira, Risaralda Department",
    shortName: "Pereira",
    countryCode: "CO",
    country: "Colombia",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "co-100",
    lat: 7.107394,
    lng: -73.361549,
    panoId: "nv_2KF9L-mND-awf2A-sXw",
    place: "Near Lebrija, Santander Department",
    shortName: "Lebrija",
    countryCode: "CO",
    country: "Colombia",
    continent: "South America",
    difficulty: "adventurer",
    pools: ["world","South America","CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "co-101",
    lat: 10.585194,
    lng: -75.028172,
    panoId: "IKlDaYznTIKa_057kgCMiA",
    place: "Near Sabanalarga, Atlántico",
    shortName: "Sabanalarga",
    countryCode: "CO",
    country: "Colombia",
    continent: "South America",
    difficulty: "adventurer",
    pools: ["world","South America","CO"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "co-102",
    lat: 8.928386,
    lng: -75.287021,
    panoId: "CgOi0yJJIX8iw4duTU8nDQ",
    place: "Near La Unión, Sucre Department",
    shortName: "La Unión",
    countryCode: "CO",
    country: "Colombia",
    continent: "South America",
    difficulty: "adventurer",
    pools: ["world","South America","CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "co-103",
    lat: 4.605373,
    lng: -74.340047,
    panoId: "TUCSkh8oWOWywSHNIhVMaw",
    place: "Near San Antonio del Tequendama, Cundinamarca",
    shortName: "San Antonio del Tequendama",
    countryCode: "CO",
    country: "Colombia",
    continent: "South America",
    difficulty: "adventurer",
    pools: ["world","South America","CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "co-104",
    lat: 0.541269,
    lng: -76.844315,
    panoId: "6TGUA6Uugy6eNj12BKg5yQ",
    place: "Near Valle del Guamuez, Putumayo Department",
    shortName: "Valle del Guamuez",
    countryCode: "CO",
    country: "Colombia",
    continent: "South America",
    difficulty: "adventurer",
    pools: ["world","South America","CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "co-105",
    lat: 8.905151,
    lng: -73.853971,
    panoId: "SRB9W51u5bMVUL64VJfHzg",
    place: "Near Tamalameque, Cesar Department",
    shortName: "Tamalameque",
    countryCode: "CO",
    country: "Colombia",
    continent: "South America",
    difficulty: "adventurer",
    pools: ["world","South America","CO"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ar-000",
    lat: -34.613194,
    lng: -58.377589,
    panoId: "P9Kz-xM0TRvBKYDWJ-cD6A",
    place: "Near Buenos Aires, Buenos Aires F.D.",
    shortName: "Buenos Aires",
    countryCode: "AR",
    country: "Argentina",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ar-001",
    lat: -26.816906,
    lng: -65.210723,
    panoId: "NXeXEBX9lh7dSJqhrSTi2Q",
    place: "Near San Miguel de Tucumán, Tucuman",
    shortName: "San Miguel de Tucumán",
    countryCode: "AR",
    country: "Argentina",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ar-002",
    lat: -31.648807,
    lng: -60.708708,
    panoId: "8lp2CwqxBgPAN6hWhQZDdA",
    place: "Near Santa Fe, Santa Fe",
    shortName: "Santa Fe",
    countryCode: "AR",
    country: "Argentina",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ar-003",
    lat: -27.467858,
    lng: -58.834412,
    panoId: "7tQf6dd2iLeNlN24UvhUMw",
    place: "Near Corrientes, Corrientes",
    shortName: "Corrientes",
    countryCode: "AR",
    country: "Argentina",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","AR"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "ar-004",
    lat: -38.000423,
    lng: -57.556241,
    panoId: "cEsOykXNUl-be5UsJCh-EA",
    place: "Near Mar del Plata, Buenos Aires",
    shortName: "Mar del Plata",
    countryCode: "AR",
    country: "Argentina",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ar-005",
    lat: -37.328034,
    lng: -59.13731,
    panoId: "VeECjUiGIDqHIGIj_SkRvQ",
    place: "Near Tandil, Buenos Aires",
    shortName: "Tandil",
    countryCode: "AR",
    country: "Argentina",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ar-006",
    lat: -31.406688,
    lng: -64.188746,
    panoId: "PqYJluu6rkG3_ywJlTZCCQ",
    place: "Near Córdoba, Cordoba",
    shortName: "Córdoba",
    countryCode: "AR",
    country: "Argentina",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ar-007",
    lat: -45.86255,
    lng: -67.493814,
    panoId: "Vfaz2DysskUnxekTPzcFFA",
    place: "Near Comodoro Rivadavia, Chubut",
    shortName: "Comodoro Rivadavia",
    countryCode: "AR",
    country: "Argentina",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ar-008",
    lat: -31.392037,
    lng: -58.016598,
    panoId: "K33syuuwgkyaoaHiyBrqQw",
    place: "Near Concordia, Entre Rios",
    shortName: "Concordia",
    countryCode: "AR",
    country: "Argentina",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ar-009",
    lat: -28.469629,
    lng: -65.785565,
    panoId: "iCNbmtTua8gZ3BxdkeEI5A",
    place: "Near Catamarca, Catamarca",
    shortName: "Catamarca",
    countryCode: "AR",
    country: "Argentina",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ar-010",
    lat: -31.732688,
    lng: -60.528998,
    panoId: "bYj8QKuoJ3LgmqPa7Y-4Gg",
    place: "Near Paraná, Entre Rios",
    shortName: "Paraná",
    countryCode: "AR",
    country: "Argentina",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ar-011",
    lat: -29.413284,
    lng: -66.856483,
    panoId: "ZgkSCRBEIMETxsB2RNPl7g",
    place: "Near La Rioja, La Rioja",
    shortName: "La Rioja",
    countryCode: "AR",
    country: "Argentina",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ar-012",
    lat: -36.616212,
    lng: -64.289906,
    panoId: "itGkPW91EHtqO6txROU34g",
    place: "Near Santa Rosa, La Pampa",
    shortName: "Santa Rosa",
    countryCode: "AR",
    country: "Argentina",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ar-013",
    lat: -34.615269,
    lng: -68.332349,
    panoId: "p9tk-aFu6LtcI5bkFmLePA",
    place: "Near San Rafael, Mendoza",
    shortName: "San Rafael",
    countryCode: "AR",
    country: "Argentina",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ar-014",
    lat: -27.800435,
    lng: -64.262857,
    panoId: "VAJM_mZ9j_TjCXQgocWTyg",
    place: "Near Santiago del Estero, Santiago del Estero",
    shortName: "Santiago del Estero",
    countryCode: "AR",
    country: "Argentina",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ar-015",
    lat: -38.950802,
    lng: -68.059214,
    panoId: "pvqXi4ipTD93okZkpqnI1w",
    place: "Near Neuquén, Neuquen",
    shortName: "Neuquén",
    countryCode: "AR",
    country: "Argentina",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ar-016",
    lat: -32.889464,
    lng: -68.845802,
    panoId: "om3pA4yORgYUXglIxtH2Bw",
    place: "Near Mendoza, Mendoza",
    shortName: "Mendoza",
    countryCode: "AR",
    country: "Argentina",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ar-017",
    lat: -27.463643,
    lng: -58.986622,
    panoId: "g_pphh0GcI1y-_R5cgrwbQ",
    place: "Near Resistencia, Chaco",
    shortName: "Resistencia",
    countryCode: "AR",
    country: "Argentina",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ar-018",
    lat: -27.584737,
    lng: -56.686735,
    panoId: "g-Dh8y5SaJQ46HWXVi1jeg",
    place: "Near Ituzaingó, Corrientes",
    shortName: "Ituzaingó",
    countryCode: "AR",
    country: "Argentina",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ar-019",
    lat: -34.665348,
    lng: -58.727392,
    panoId: "zLgO60uQjKKAADgGhebkMw",
    place: "Near Merlo, Buenos Aires",
    shortName: "Merlo",
    countryCode: "AR",
    country: "Argentina",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ar-020",
    lat: -38.71759,
    lng: -62.265274,
    panoId: "ujdYWX4_gXaGHKChKlZwZg",
    place: "Near Bahía Blanca, Buenos Aires",
    shortName: "Bahía Blanca",
    countryCode: "AR",
    country: "Argentina",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","AR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "ar-021",
    lat: -24.192851,
    lng: -65.293403,
    panoId: "TmxMuYYAZ5T2jCFP1NOjng",
    place: "Near San Salvador de Jujuy, Jujuy",
    shortName: "San Salvador de Jujuy",
    countryCode: "AR",
    country: "Argentina",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ar-022",
    lat: -27.391853,
    lng: -55.923821,
    panoId: "p2Ot7RzaT1q1300s1M25mQ",
    place: "Near Posadas, Misiones",
    shortName: "Posadas",
    countryCode: "AR",
    country: "Argentina",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ar-023",
    lat: -34.757457,
    lng: -58.402707,
    panoId: "95lGrLdUINB9MWKyqXVxyg",
    place: "Near Lomas de Zamora, Buenos Aires",
    shortName: "Lomas de Zamora",
    countryCode: "AR",
    country: "Argentina",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ar-024",
    lat: -33.130427,
    lng: -64.352691,
    panoId: "psvyYDePJpRBMlQxNuTpZQ",
    place: "Near Río Cuarto, Cordoba",
    shortName: "Río Cuarto",
    countryCode: "AR",
    country: "Argentina",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ar-025",
    lat: -32.946783,
    lng: -60.639706,
    panoId: "zwcr4y5tpanx3cdK6ZtWhg",
    place: "Near Rosario, Santa Fe",
    shortName: "Rosario",
    countryCode: "AR",
    country: "Argentina",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ar-026",
    lat: -31.537214,
    lng: -68.525717,
    panoId: "7fsaFvRj0dbb8FXXNFS_HQ",
    place: "Near San Juan, San Juan",
    shortName: "San Juan",
    countryCode: "AR",
    country: "Argentina",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ar-027",
    lat: -26.184893,
    lng: -58.173115,
    panoId: "R3PNlcj0GnpcBIB24rR8Aw",
    place: "Near Formosa, Formosa",
    shortName: "Formosa",
    countryCode: "AR",
    country: "Argentina",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ar-028",
    lat: -34.681059,
    lng: -58.563811,
    panoId: "Ggcq19lfEEVNlZ9jkcoxoQ",
    place: "Near San Justo, Buenos Aires",
    shortName: "San Justo",
    countryCode: "AR",
    country: "Argentina",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ar-029",
    lat: -24.806415,
    lng: -65.419988,
    panoId: "kyuipCxX1KdhDtNR__TJlQ",
    place: "Near Salta, Salta",
    shortName: "Salta",
    countryCode: "AR",
    country: "Argentina",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ar-030",
    lat: -34.853973,
    lng: -58.525021,
    panoId: "lsWy4ez2thGW_kJTMkLwpw",
    place: "Near Ezeiza, Buenos Aires",
    shortName: "Ezeiza",
    countryCode: "AR",
    country: "Argentina",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ar-031",
    lat: -34.720665,
    lng: -58.254493,
    panoId: "PKOF2fd49NQ2pzVf5yPi7A",
    place: "Near Quilmes, Buenos Aires",
    shortName: "Quilmes",
    countryCode: "AR",
    country: "Argentina",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ar-032",
    lat: -33.334233,
    lng: -60.210733,
    panoId: "Qdbo9UPlUbuxmXpICDAliQ",
    place: "Near San Nicolás de los Arroyos, Buenos Aires",
    shortName: "San Nicolás de los Arroyos",
    countryCode: "AR",
    country: "Argentina",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ar-033",
    lat: -34.651157,
    lng: -58.622085,
    panoId: "1Jnp8wfn9jfbhxVaBbkqMg",
    place: "Near Morón, Buenos Aires",
    shortName: "Morón",
    countryCode: "AR",
    country: "Argentina",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","AR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "ar-034",
    lat: -26.2059,
    lng: -58.165067,
    panoId: "HNxZozZ7u1BTBZUKqoDUHA",
    place: "Near Formosa, Formosa",
    shortName: "Formosa",
    countryCode: "AR",
    country: "Argentina",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ar-035",
    lat: -43.248333,
    lng: -65.305399,
    panoId: "w3ZEYAqtB4MJotkFXBJheA",
    place: "Near Trelew, Chubut",
    shortName: "Trelew",
    countryCode: "AR",
    country: "Argentina",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ar-036",
    lat: -29.412638,
    lng: -66.872279,
    panoId: "6oR-u83TUEWbAOHa-N9C_A",
    place: "Near La Rioja, La Rioja",
    shortName: "La Rioja",
    countryCode: "AR",
    country: "Argentina",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ar-037",
    lat: -31.637307,
    lng: -60.72279,
    panoId: "i5vmCjosTaCy13UHsh-cSA",
    place: "Near Santa Fe, Santa Fe",
    shortName: "Santa Fe",
    countryCode: "AR",
    country: "Argentina",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ar-038",
    lat: -34.608399,
    lng: -68.324722,
    panoId: "4TwXY-_uM4hBqGN8bpmC0Q",
    place: "Near San Rafael, Mendoza",
    shortName: "San Rafael",
    countryCode: "AR",
    country: "Argentina",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ar-039",
    lat: -28.484033,
    lng: -65.780779,
    panoId: "7DjgHa6jzAfkOOztycicqw",
    place: "Near Catamarca, Catamarca",
    shortName: "Catamarca",
    countryCode: "AR",
    country: "Argentina",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ar-040",
    lat: -36.62829,
    lng: -64.284167,
    panoId: "03_-debEPx8R4656_Bm02w",
    place: "Near Santa Rosa, La Pampa",
    shortName: "Santa Rosa",
    countryCode: "AR",
    country: "Argentina",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ar-041",
    lat: -27.796397,
    lng: -64.283597,
    panoId: "2sO32VPPsglSJ5Aap2cMpg",
    place: "Near Santiago del Estero, Santiago del Estero",
    shortName: "Santiago del Estero",
    countryCode: "AR",
    country: "Argentina",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ar-042",
    lat: -31.747904,
    lng: -60.520802,
    panoId: "XBZHxkQx0rdXAYPrXjqL4A",
    place: "Near Paraná, Entre Rios",
    shortName: "Paraná",
    countryCode: "AR",
    country: "Argentina",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ar-043",
    lat: -33.275497,
    lng: -66.331492,
    panoId: "2iAZPo5GUD_comYv7Kxt7g",
    place: "Near San Luis, San Luis",
    shortName: "San Luis",
    countryCode: "AR",
    country: "Argentina",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ar-044",
    lat: -31.392008,
    lng: -64.181909,
    panoId: "TynjPsRPSgrPM9qA5YJJ6Q",
    place: "Near Córdoba, Cordoba",
    shortName: "Córdoba",
    countryCode: "AR",
    country: "Argentina",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ar-045",
    lat: -27.38632,
    lng: -55.91546,
    panoId: "D-5QfgsZPYl2VKjYZLlbhQ",
    place: "Near Posadas, Misiones",
    shortName: "Posadas",
    countryCode: "AR",
    country: "Argentina",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ar-046",
    lat: -27.587581,
    lng: -56.698815,
    panoId: "tUp7pBn25DGJFXNqnyrP0w",
    place: "Near Ituzaingó, Corrientes",
    shortName: "Ituzaingó",
    countryCode: "AR",
    country: "Argentina",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ar-047",
    lat: -27.451878,
    lng: -58.969607,
    panoId: "IsQEvhTPMk2C-WQ7eg1MOw",
    place: "Near Resistencia, Chaco",
    shortName: "Resistencia",
    countryCode: "AR",
    country: "Argentina",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ar-048",
    lat: -33.134815,
    lng: -64.375052,
    panoId: "gmnbgSmhD3WgV8sFGcvEFw",
    place: "Near Río Cuarto, Cordoba",
    shortName: "Río Cuarto",
    countryCode: "AR",
    country: "Argentina",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ar-049",
    lat: -27.482979,
    lng: -58.842807,
    panoId: "l6Kv6MHeIO58p04xYq1FKw",
    place: "Near Corrientes, Corrientes",
    shortName: "Corrientes",
    countryCode: "AR",
    country: "Argentina",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ar-050",
    lat: -34.095172,
    lng: -59.078901,
    panoId: "ofNk0ZJ5V78Savd4atKOUA",
    place: "Near Zárate, Buenos Aires",
    shortName: "Zárate",
    countryCode: "AR",
    country: "Argentina",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ar-051",
    lat: -33.352938,
    lng: -60.182294,
    panoId: "wK2DxAv0CS9p4teu99EYNQ",
    place: "Near San Nicolás de los Arroyos, Buenos Aires",
    shortName: "San Nicolás de los Arroyos",
    countryCode: "AR",
    country: "Argentina",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ar-052",
    lat: -34.866165,
    lng: -58.43992,
    panoId: "4sBzHwsnCfpDKMrOPf5_Yg",
    place: "Near Canning, Buenos Aires",
    shortName: "Canning",
    countryCode: "AR",
    country: "Argentina",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ar-053",
    lat: -38.033539,
    lng: -57.626581,
    panoId: "nt8uFMOhFiJv300PcnaK_g",
    place: "Near Mar del Plata, Buenos Aires",
    shortName: "Mar del Plata",
    countryCode: "AR",
    country: "Argentina",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ar-054",
    lat: -38.766448,
    lng: -62.303838,
    panoId: "_xY-O9bennpReCDQlgU9RQ",
    place: "Near Bahía Blanca, Buenos Aires",
    shortName: "Bahía Blanca",
    countryCode: "AR",
    country: "Argentina",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ar-055",
    lat: -34.750321,
    lng: -58.298187,
    panoId: "iRZY7R7JVNk4cx2Pmg60uw",
    place: "Near Quilmes, Buenos Aires",
    shortName: "Quilmes",
    countryCode: "AR",
    country: "Argentina",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ar-056",
    lat: -34.798383,
    lng: -58.459347,
    panoId: "PchYPUdArX4ZAJ9PhUGMnA",
    place: "Near Lomas de Zamora, Buenos Aires",
    shortName: "Lomas de Zamora",
    countryCode: "AR",
    country: "Argentina",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ar-057",
    lat: -43.306745,
    lng: -65.312004,
    panoId: "16tg6Yy5DCrb2O_DZjYJMg",
    place: "Near Trelew, Chubut",
    shortName: "Trelew",
    countryCode: "AR",
    country: "Argentina",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ar-058",
    lat: -36.684714,
    lng: -64.282983,
    panoId: "sftVoBri17sh-t5PzzYf6A",
    place: "Near Santa Rosa, La Pampa",
    shortName: "Santa Rosa",
    countryCode: "AR",
    country: "Argentina",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ar-059",
    lat: -27.407211,
    lng: -55.962128,
    panoId: "5OMNyUUpZpOT-wkXT17pqA",
    place: "Near Posadas, Misiones",
    shortName: "Posadas",
    countryCode: "AR",
    country: "Argentina",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ar-060",
    lat: -31.37346,
    lng: -64.144189,
    panoId: "W8uJcM2zncXJLREteUtV8w",
    place: "Near Córdoba, Cordoba",
    shortName: "Córdoba",
    countryCode: "AR",
    country: "Argentina",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ar-061",
    lat: -45.844687,
    lng: -67.5403,
    panoId: "f3bKQm-hyKyAieEMITc8qQ",
    place: "Near Comodoro Rivadavia, Chubut",
    shortName: "Comodoro Rivadavia",
    countryCode: "AR",
    country: "Argentina",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ar-062",
    lat: -27.499724,
    lng: -58.832577,
    panoId: "YQWTsQiovAFa3qIvK-jrzg",
    place: "Near Corrientes, Corrientes",
    shortName: "Corrientes",
    countryCode: "AR",
    country: "Argentina",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ar-063",
    lat: -27.772892,
    lng: -64.271019,
    panoId: "yqsvG-6yOFdbFjJlxUFD1w",
    place: "Near Santiago del Estero, Santiago del Estero",
    shortName: "Santiago del Estero",
    countryCode: "AR",
    country: "Argentina",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ar-064",
    lat: -24.788828,
    lng: -65.356947,
    panoId: "A39VWSJ_ABHM1uWD61Gefw",
    place: "Near Salta, Salta",
    shortName: "Salta",
    countryCode: "AR",
    country: "Argentina",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ar-065",
    lat: -33.150002,
    lng: -64.297118,
    panoId: "9iMJirNn1tdSVs2RikGjQQ",
    place: "Near Río Cuarto, Cordoba",
    shortName: "Río Cuarto",
    countryCode: "AR",
    country: "Argentina",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ar-066",
    lat: -34.276555,
    lng: -58.940346,
    panoId: "l9PreBs69hZyY80E7w-5Ow",
    place: "Near Campana, Buenos Aires",
    shortName: "Campana",
    countryCode: "AR",
    country: "Argentina",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ar-067",
    lat: -33.26112,
    lng: -66.317116,
    panoId: "eVdjTm7uh1QJstqLL0I0zg",
    place: "Near San Luis, San Luis",
    shortName: "San Luis",
    countryCode: "AR",
    country: "Argentina",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ar-068",
    lat: -31.715013,
    lng: -60.566428,
    panoId: "2FXE3tgxH7-zkTzI_T23Tg",
    place: "Near Paraná, Entre Rios",
    shortName: "Paraná",
    countryCode: "AR",
    country: "Argentina",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ar-069",
    lat: -34.481492,
    lng: -58.967942,
    panoId: "wyM9qXpG6I7LOs2zGXOgXg",
    place: "Near Pilar, Buenos Aires",
    shortName: "Pilar",
    countryCode: "AR",
    country: "Argentina",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ar-070",
    lat: -26.873358,
    lng: -65.178786,
    panoId: "9uNPeXapKYZESnpuDZtKow",
    place: "Near Banda del Río Salí, Tucuman",
    shortName: "Banda del Río Salí",
    countryCode: "AR",
    country: "Argentina",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ar-071",
    lat: -29.441883,
    lng: -66.85045,
    panoId: "HjMsr0Vibgqgtgaqp0Odlg",
    place: "Near La Rioja, La Rioja",
    shortName: "La Rioja",
    countryCode: "AR",
    country: "Argentina",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ar-072",
    lat: -33.624221,
    lng: -65.444185,
    panoId: "WOY4dVWLp9FjzwvolxSQhg",
    place: "Near Villa Mercedes, San Luis",
    shortName: "Villa Mercedes",
    countryCode: "AR",
    country: "Argentina",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ar-073",
    lat: -33.389801,
    lng: -60.276657,
    panoId: "O5pYcTtnHmYyNWOWt4qDUg",
    place: "Near San Nicolás de los Arroyos, Buenos Aires",
    shortName: "San Nicolás de los Arroyos",
    countryCode: "AR",
    country: "Argentina",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ar-074",
    lat: -32.87144,
    lng: -68.809444,
    panoId: "FOdFSSB3nou4AyAXOHDaPw",
    place: "Near Las Heras, Mendoza",
    shortName: "Las Heras",
    countryCode: "AR",
    country: "Argentina",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ar-075",
    lat: -38.091671,
    lng: -57.553215,
    panoId: "9_843V_qN6sY5vACJ9OZ1A",
    place: "Near Mar del Plata, Buenos Aires",
    shortName: "Mar del Plata",
    countryCode: "AR",
    country: "Argentina",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ar-076",
    lat: -36.987092,
    lng: -60.301636,
    panoId: "EnVdFB1HgmIiuPRzI2vjqQ",
    place: "Near Olavarría, Buenos Aires",
    shortName: "Olavarría",
    countryCode: "AR",
    country: "Argentina",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ar-077",
    lat: -34.769957,
    lng: -58.829245,
    panoId: "fz7AuzMyGX6GFvIdPSZ8-g",
    place: "Near Marcos Paz, Buenos Aires",
    shortName: "Marcos Paz",
    countryCode: "AR",
    country: "Argentina",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ar-078",
    lat: -31.197772,
    lng: -61.472758,
    panoId: "hoMKFZMhr5RNdt957r0UMA",
    place: "Near Rafaela, Santa Fe",
    shortName: "Rafaela",
    countryCode: "AR",
    country: "Argentina",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ar-079",
    lat: -41.141067,
    lng: -71.267982,
    panoId: "0XVveIzsW0Ol_A0zgGCSrA",
    place: "Near San Carlos de Bariloche, Rio Negro",
    shortName: "San Carlos de Bariloche",
    countryCode: "AR",
    country: "Argentina",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ar-080",
    lat: -33.76173,
    lng: -60.59717,
    panoId: "hGVb3aKbegcc6r-zmxsQUQ",
    place: "Near Pergamino, Buenos Aires",
    shortName: "Pergamino",
    countryCode: "AR",
    country: "Argentina",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ar-081",
    lat: -34.958111,
    lng: -58.643454,
    panoId: "2pQ1YaE4ldv2Vyd8bfZ6HQ",
    place: "Near Tristán Suárez, Buenos Aires",
    shortName: "Tristán Suárez",
    countryCode: "AR",
    country: "Argentina",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ar-082",
    lat: -34.384559,
    lng: -59.003804,
    panoId: "A36a3qjAkAFo-p_hYnzSVQ",
    place: "Near Pilar, Buenos Aires",
    shortName: "Pilar",
    countryCode: "AR",
    country: "Argentina",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ar-083",
    lat: -32.455687,
    lng: -63.221092,
    panoId: "-MdqobdxYyA6lXMkFE7vsQ",
    place: "Near Villa Nueva, Cordoba",
    shortName: "Villa Nueva",
    countryCode: "AR",
    country: "Argentina",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ar-084",
    lat: -33.012051,
    lng: -58.591802,
    panoId: "sqyGQYKlwIvP8jZIq-dLTw",
    place: "Near Gualeguaychú, Entre Rios",
    shortName: "Gualeguaychú",
    countryCode: "AR",
    country: "Argentina",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ar-085",
    lat: -38.980058,
    lng: -67.96243,
    panoId: "cS7vbnqeDxOYCNozOoKsHw",
    place: "Near General Fernández Oro, Rio Negro",
    shortName: "General Fernández Oro",
    countryCode: "AR",
    country: "Argentina",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ar-086",
    lat: -32.922793,
    lng: -60.676242,
    panoId: "uM_g9Oxf0Gf3kD-z2r10Pg",
    place: "Near Rosario, Santa Fe",
    shortName: "Rosario",
    countryCode: "AR",
    country: "Argentina",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ar-087",
    lat: -24.23164,
    lng: -65.232345,
    panoId: "ext542QALau_UYd-cUtSCw",
    place: "Near Palpalá, Jujuy",
    shortName: "Palpalá",
    countryCode: "AR",
    country: "Argentina",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ar-088",
    lat: -33.050878,
    lng: -68.53065,
    panoId: "tqUONk4JIvXxyQqMdKaznw",
    place: "Near San Martín, Mendoza",
    shortName: "San Martín",
    countryCode: "AR",
    country: "Argentina",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ar-089",
    lat: -32.857066,
    lng: -68.849896,
    panoId: "_KwKUdij5Zz7AQ-ekm-b7A",
    place: "Near Las Heras, Mendoza",
    shortName: "Las Heras",
    countryCode: "AR",
    country: "Argentina",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ar-090",
    lat: -38.936655,
    lng: -68.308998,
    panoId: "tSCcqZfXSQNRnuWoeGch0A",
    place: "Near Plottier, Neuquen",
    shortName: "Plottier",
    countryCode: "AR",
    country: "Argentina",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ar-091",
    lat: -31.559852,
    lng: -68.458766,
    panoId: "HEbc164PjiDYQzxf2huCJg",
    place: "Near Santa Lucía, San Juan",
    shortName: "Santa Lucía",
    countryCode: "AR",
    country: "Argentina",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ar-092",
    lat: -33.689819,
    lng: -65.424362,
    panoId: "uHamgJNVb-1fAURNtcxIAQ",
    place: "Near Villa Mercedes, San Luis",
    shortName: "Villa Mercedes",
    countryCode: "AR",
    country: "Argentina",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ar-093",
    lat: -38.983494,
    lng: -67.595016,
    panoId: "_AaQvrZA1Mn7BwojKK45IQ",
    place: "Near General Roca, Rio Negro",
    shortName: "General Roca",
    countryCode: "AR",
    country: "Argentina",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ar-094",
    lat: -41.124428,
    lng: -71.252531,
    panoId: "C2TaqH0VMZTRuABXzsKEpw",
    place: "Near San Carlos de Bariloche, Rio Negro",
    shortName: "San Carlos de Bariloche",
    countryCode: "AR",
    country: "Argentina",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ar-095",
    lat: -31.594106,
    lng: -60.749289,
    panoId: "YeCQLKyaY7to_JYZr5TK3w",
    place: "Near Santa Fe, Santa Fe",
    shortName: "Santa Fe",
    countryCode: "AR",
    country: "Argentina",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ar-096",
    lat: -22.486887,
    lng: -63.792103,
    panoId: "zNuqgwsCi8I0V3RlouLyFA",
    place: "Near Tartagal, Salta",
    shortName: "Tartagal",
    countryCode: "AR",
    country: "Argentina",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ar-097",
    lat: -32.480331,
    lng: -58.306796,
    panoId: "wAh1rDPSSdT1tI4aff2p4Q",
    place: "Near Concepción del Uruguay, Entre Rios",
    shortName: "Concepción del Uruguay",
    countryCode: "AR",
    country: "Argentina",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ar-098",
    lat: -27.486599,
    lng: -55.183151,
    panoId: "jKzYe0BzZIRusGP3bq1Hmw",
    place: "Near Guaraní, Misiones",
    shortName: "Guaraní",
    countryCode: "AR",
    country: "Argentina",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ar-099",
    lat: -27.491747,
    lng: -59.003113,
    panoId: "Osw6HOH_3AzoyO6eivgvmQ",
    place: "Near Resistencia, Chaco",
    shortName: "Resistencia",
    countryCode: "AR",
    country: "Argentina",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","AR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "ar-100",
    lat: -37.491112,
    lng: -59.168863,
    panoId: "6WfqF81-GmRsdnPpcD6DRw",
    place: "Near Tandil, Buenos Aires",
    shortName: "Tandil",
    countryCode: "AR",
    country: "Argentina",
    continent: "South America",
    difficulty: "adventurer",
    pools: ["world","South America","AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ar-101",
    lat: -29.587333,
    lng: -57.201954,
    panoId: "NH551u3LMclMZzPb0Kx75g",
    place: "Near Paso de los Libres, Corrientes",
    shortName: "Paso de los Libres",
    countryCode: "AR",
    country: "Argentina",
    continent: "South America",
    difficulty: "adventurer",
    pools: ["world","South America","AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ar-102",
    lat: -54.70178,
    lng: -68.130257,
    panoId: "mpWPZnTR5s8XUB1eFsMSfA",
    place: "Near Ushuaia, Tierra del Fuego",
    shortName: "Ushuaia",
    countryCode: "AR",
    country: "Argentina",
    continent: "South America",
    difficulty: "adventurer",
    pools: ["world","South America","AR"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "ar-103",
    lat: -31.582435,
    lng: -60.554254,
    panoId: "SVHCkDS5TDYuFxhgzWyFrg",
    place: "Near Santa Fe, Santa Fe",
    shortName: "Santa Fe",
    countryCode: "AR",
    country: "Argentina",
    continent: "South America",
    difficulty: "adventurer",
    pools: ["world","South America","AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ar-104",
    lat: -29.331978,
    lng: -67.50332,
    panoId: "6kEaVQ4HBSJn-LPI7_C66Q",
    place: "Near Chilecito, La Rioja",
    shortName: "Chilecito",
    countryCode: "AR",
    country: "Argentina",
    continent: "South America",
    difficulty: "adventurer",
    pools: ["world","South America","AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ar-105",
    lat: -40.707987,
    lng: -63.174194,
    panoId: "40ks1-8DYSP5oK4pRkNOXQ",
    place: "Near Viedma, Rio Negro",
    shortName: "Viedma",
    countryCode: "AR",
    country: "Argentina",
    continent: "South America",
    difficulty: "adventurer",
    pools: ["world","South America","AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ar-106",
    lat: -26.608122,
    lng: -65.322695,
    panoId: "ULCdDoRpUC5FCZEutN2SQw",
    place: "Near Tafí Viejo, Tucuman",
    shortName: "Tafí Viejo",
    countryCode: "AR",
    country: "Argentina",
    continent: "South America",
    difficulty: "adventurer",
    pools: ["world","South America","AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ar-107",
    lat: -24.206255,
    lng: -64.683471,
    panoId: "eur7VuHrCz9faUJwXkn5Gg",
    place: "Near Santa Clara, Jujuy",
    shortName: "Santa Clara",
    countryCode: "AR",
    country: "Argentina",
    continent: "South America",
    difficulty: "adventurer",
    pools: ["world","South America","AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ar-108",
    lat: -25.845231,
    lng: -60.775407,
    panoId: "q5ChiWu8cWVymgQUPh5OKQ",
    place: "Near Juan José Castelli, Chaco",
    shortName: "Juan José Castelli",
    countryCode: "AR",
    country: "Argentina",
    continent: "South America",
    difficulty: "adventurer",
    pools: ["world","South America","AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "ar-109",
    lat: -46.568384,
    lng: -67.656012,
    panoId: "tuEYIufwcKKCfCKVIk8XIQ",
    place: "Near Caleta Olivia, Santa Cruz",
    shortName: "Caleta Olivia",
    countryCode: "AR",
    country: "Argentina",
    continent: "South America",
    difficulty: "adventurer",
    pools: ["world","South America","AR"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "uy-000",
    lat: -34.903272,
    lng: -56.188253,
    panoId: "M-AukkAQ8IlgylYXdhyu_g",
    place: "Near Montevideo, Montevideo Department",
    shortName: "Montevideo",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-001",
    lat: -34.100323,
    lng: -56.214763,
    panoId: "n6t5tIAGTNH7puZwgjm6gQ",
    place: "Near Florida, Florida",
    shortName: "Florida",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-002",
    lat: -34.897848,
    lng: -54.95012,
    panoId: "CZz3HdP6Y1jgWSl6w4WZMQ",
    place: "Near Maldonado, Maldonado",
    shortName: "Maldonado",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-003",
    lat: -30.404335,
    lng: -56.469216,
    panoId: "qW2hctP44tvDtvKjV994vg",
    place: "Near Artigas, Artigas",
    shortName: "Artigas",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-004",
    lat: -33.252404,
    lng: -58.030406,
    panoId: "nZ0cCH_uridgPfAZMr2nUA",
    place: "Near Mercedes, Soriano",
    shortName: "Mercedes",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-005",
    lat: -34.453434,
    lng: -56.390731,
    panoId: "L4Dx7rs_aTeQuXgCvbVmsg",
    place: "Near Santa Lucía, Canelones",
    shortName: "Santa Lucía",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-006",
    lat: -34.523872,
    lng: -56.282149,
    panoId: "OTvym-STwxWbljg-QlXyNA",
    place: "Near Canelones, Canelones",
    shortName: "Canelones",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-007",
    lat: -32.698256,
    lng: -57.626598,
    panoId: "GlWZIm5OQEcxv7T1Hd-hZw",
    place: "Near Young, Río Negro Department",
    shortName: "Young",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-008",
    lat: -34.376061,
    lng: -55.237958,
    panoId: "BNZYbLpLg-xNf32_WR6EJg",
    place: "Near Minas, Lavalleja",
    shortName: "Minas",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-009",
    lat: -32.317469,
    lng: -58.080824,
    panoId: "v7dVYG3MukZniCqET_i74A",
    place: "Near Paysandú, Paysandú Department",
    shortName: "Paysandú",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-010",
    lat: -33.697905,
    lng: -53.459272,
    panoId: "68PgyOBmd33OCeiqRhWwiw",
    place: "Near Chui, Rocha Department",
    shortName: "Chui",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-011",
    lat: -34.947585,
    lng: -54.933498,
    panoId: "6PbKaA44K32IJeiszcrBRg",
    place: "Near Punta del Este, Maldonado",
    shortName: "Punta del Este",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-012",
    lat: -34.198524,
    lng: -53.859234,
    panoId: "vaTc3TeMwgBAM5ahVd-FHA",
    place: "Near Castillos, Rocha Department",
    shortName: "Castillos",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-013",
    lat: -34.791176,
    lng: -54.918774,
    panoId: "xwQz269nhl93_8yniCFkjg",
    place: "Near San Carlos, Maldonado",
    shortName: "San Carlos",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-014",
    lat: -33.231012,
    lng: -54.385803,
    panoId: "89IzOlsdcu4K0yFFok8EdA",
    place: "Near Treinta y Tres, Treinta y Tres Department",
    shortName: "Treinta y Tres",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-015",
    lat: -34.479941,
    lng: -54.330713,
    panoId: "JG4kd04U2DRqFB0rRGEhPw",
    place: "Near Rocha, Rocha Department",
    shortName: "Rocha",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-016",
    lat: -31.388097,
    lng: -57.959838,
    panoId: "UhuffaPN01LkhiAPy84APA",
    place: "Near Salto, Salto Department",
    shortName: "Salto",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-017",
    lat: -33.87028,
    lng: -58.411755,
    panoId: "6IUz0RDqsY0uDXC9tnuykw",
    place: "Near Nueva Palmira, Colonia",
    shortName: "Nueva Palmira",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-018",
    lat: -30.904282,
    lng: -55.549981,
    panoId: "07WIpSgNDo4bEm0tbAkBDQ",
    place: "Near Rivera, Rivera Department",
    shortName: "Rivera",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-019",
    lat: -34.000138,
    lng: -58.28398,
    panoId: "erW8JvcDEwXf4glVLS33EQ",
    place: "Near Carmelo, Colonia",
    shortName: "Carmelo",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-020",
    lat: -33.516492,
    lng: -56.899545,
    panoId: "KhOiLiLDAj9shgJHr6TS4g",
    place: "Near Trinidad, Flores Department",
    shortName: "Trinidad",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-021",
    lat: -34.462645,
    lng: -57.839773,
    panoId: "Mfw8zOIufRGbKxl9CA_3Ig",
    place: "Near Colonia del Sacramento, Colonia",
    shortName: "Colonia del Sacramento",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-022",
    lat: -32.816709,
    lng: -56.516496,
    panoId: "a2Jl-vqoFFdTFTpYBqAyuw",
    place: "Near Paso de los Toros, Tacuarembó Department",
    shortName: "Paso de los Toros",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-023",
    lat: -34.41893,
    lng: -57.453312,
    panoId: "qOlFK_AS2VlImp2I1GUCgg",
    place: "Near Juan L. Lacaze, Colonia",
    shortName: "Juan L. Lacaze",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-024",
    lat: -34.316786,
    lng: -57.349737,
    panoId: "j7wEAQ9TPVndO519YiRSYQ",
    place: "Near Rosario, Colonia",
    shortName: "Rosario",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-025",
    lat: -33.116436,
    lng: -58.310724,
    panoId: "XxNt67ZnCEmqq4hE-omyZg",
    place: "Near Fray Bentos, Río Negro Department",
    shortName: "Fray Bentos",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-026",
    lat: -34.634572,
    lng: -56.617363,
    panoId: "pOx5AzbllYM3SAZ0r-BKMQ",
    place: "Near Libertad, San José Department",
    shortName: "Libertad",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-027",
    lat: -30.259615,
    lng: -57.599077,
    panoId: "MCiIskc1ogZAiSXhe8x1hg",
    place: "Near Bella Unión, Artigas",
    shortName: "Bella Unión",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-028",
    lat: -32.597917,
    lng: -53.385987,
    panoId: "Agc9vRXm0gVI0ianh8Ar0w",
    place: "Near Río Branco, Cerro Largo",
    shortName: "Río Branco",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-029",
    lat: -34.300062,
    lng: -57.233342,
    panoId: "zNHsbPmx2HaW_pybsSSxTw",
    place: "Near Nueva Helvecia, Colonia",
    shortName: "Nueva Helvecia",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-030",
    lat: -31.718824,
    lng: -55.979244,
    panoId: "hP9XaIniT-JzQKCneHI3Ug",
    place: "Near Tacuarembó, Tacuarembó Department",
    shortName: "Tacuarembó",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-031",
    lat: -33.380633,
    lng: -56.523089,
    panoId: "aY5-9R4dSmEi33A9lhzTXg",
    place: "Near Durazno, Durazno Department",
    shortName: "Durazno",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-032",
    lat: -34.338918,
    lng: -56.713427,
    panoId: "NSrCmRGDoB5GX2CN23PWOw",
    place: "Near San José de Mayo, San José Department",
    shortName: "San José de Mayo",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-033",
    lat: -34.862532,
    lng: -55.275189,
    panoId: "Ctfc7FSk99GOTekJRt1v-w",
    place: "Near Piriápolis, Maldonado",
    shortName: "Piriápolis",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-034",
    lat: -33.529921,
    lng: -58.216632,
    panoId: "r5c8QmdPhCr0iqMCgmKO1g",
    place: "Near Dolores, Soriano",
    shortName: "Dolores",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-035",
    lat: -31.195831,
    lng: -55.747471,
    panoId: "JpoBtTFltKA6Kbx8JTiH8g",
    place: "Near Tranqueras, Rivera Department",
    shortName: "Tranqueras",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-036",
    lat: -33.677854,
    lng: -54.21187,
    panoId: "GOK3oGhpJOGEC6osfkf8kA",
    place: "Near Lascano, Rocha Department",
    shortName: "Lascano",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-037",
    lat: -32.828204,
    lng: -56.497438,
    panoId: "WZp0B2-1S7gQjfrgxUi6Mw",
    place: "Near Paso de los Toros, Tacuarembó Department",
    shortName: "Paso de los Toros",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-038",
    lat: -33.23917,
    lng: -58.018685,
    panoId: "MtGLBV3FB2kcmF9xFm0sew",
    place: "Near Mercedes, Soriano",
    shortName: "Mercedes",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-039",
    lat: -30.272539,
    lng: -57.586609,
    panoId: "n2u0COpgfDvet14psUsd6g",
    place: "Near Las Piedras, Artigas",
    shortName: "Las Piedras",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-040",
    lat: -34.291198,
    lng: -55.955532,
    panoId: "WqUo7c9n67D5S25qNQ6twg",
    place: "Near San Ramón, Canelones",
    shortName: "San Ramón",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-041",
    lat: -34.322195,
    lng: -57.242033,
    panoId: "gZRZQoVeDYeE7qp1TpZbcw",
    place: "Near Nueva Helvecia, Colonia",
    shortName: "Nueva Helvecia",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-042",
    lat: -30.916472,
    lng: -55.53956,
    panoId: "IPuWPxmIfIp9hnMVlfONfw",
    place: "Near Rivera, Rivera Department",
    shortName: "Rivera",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-043",
    lat: -34.180802,
    lng: -53.84562,
    panoId: "pELvxkl1N7cXemFYMj2Pcw",
    place: "Near Castillos, Rocha Department",
    shortName: "Castillos",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-044",
    lat: -32.691357,
    lng: -57.643415,
    panoId: "peHKGzrU_zKlygWvm5TNng",
    place: "Near Young, Río Negro Department",
    shortName: "Young",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-045",
    lat: -34.012612,
    lng: -58.293316,
    panoId: "BW_iq5Ax5pePEqsq-tZAqg",
    place: "Near Carmelo, Colonia",
    shortName: "Carmelo",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-046",
    lat: -33.349916,
    lng: -55.633493,
    panoId: "81VTcrsWunS7YWO5VMkoFA",
    place: "Near Sarandí del Yi, Durazno Department",
    shortName: "Sarandí del Yi",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-047",
    lat: -34.309026,
    lng: -57.355421,
    panoId: "UInkEJc1eVeiQ1fqUBPUWQ",
    place: "Near Rosario, Colonia",
    shortName: "Rosario",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-048",
    lat: -34.915608,
    lng: -56.184239,
    panoId: "VAUqVbPDVrAz7ydyHyKlNw",
    place: "Near Montevideo, Montevideo Department",
    shortName: "Montevideo",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-049",
    lat: -34.638641,
    lng: -56.602557,
    panoId: "SBQ9yldXt6wL1XJNXAhBfg",
    place: "Near Libertad, San José Department",
    shortName: "Libertad",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "classic",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-050",
    lat: -33.472605,
    lng: -58.241693,
    panoId: "BbuhM-iMx2ySJ0DmY8zDnw",
    place: "Near Dolores, Soriano",
    shortName: "Dolores",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-051",
    lat: -34.396298,
    lng: -55.168952,
    panoId: "mloRmXO6o2zKut7WzqiaLg",
    place: "Near Minas, Lavalleja",
    shortName: "Minas",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-052",
    lat: -34.422163,
    lng: -57.498563,
    panoId: "tFBb6zJlLfHtozLbyvjeAQ",
    place: "Near Juan L. Lacaze, Colonia",
    shortName: "Juan L. Lacaze",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-053",
    lat: -34.04734,
    lng: -56.241352,
    panoId: "cidJ8ZS-t6QUfBtVNuXeqw",
    place: "Near Florida, Florida",
    shortName: "Florida",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-054",
    lat: -32.857758,
    lng: -56.487556,
    panoId: "EQbR0fAzCTypOriqRwCR1Q",
    place: "Near Pueblo Centenario, Durazno Department",
    shortName: "Pueblo Centenario",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-055",
    lat: -34.418264,
    lng: -57.844083,
    panoId: "ioDT-f73VlnyTQNCjry6ow",
    place: "Near Colonia del Sacramento, Colonia",
    shortName: "Colonia del Sacramento",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-056",
    lat: -34.356213,
    lng: -57.313149,
    panoId: "-gXJj1qUswyFCDYUCoZzQA",
    place: "Near Colonia Valdense, Colonia",
    shortName: "Colonia Valdense",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-057",
    lat: -30.97395,
    lng: -55.571077,
    panoId: "CGlkn4ImF4X_W0NwS945kw",
    place: "Near Rivera, Rivera Department",
    shortName: "Rivera",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-058",
    lat: -34.303129,
    lng: -57.188193,
    panoId: "Z9GQA7JBslX15JiPNmGonA",
    place: "Near Nueva Helvecia, Colonia",
    shortName: "Nueva Helvecia",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-059",
    lat: -34.485567,
    lng: -56.281905,
    panoId: "LNMk8Uhi0yEcb_tfBIZjCA",
    place: "Near Canelones, Canelones",
    shortName: "Canelones",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-060",
    lat: -32.330488,
    lng: -58.050431,
    panoId: "iNQeorRMELFyXQTqQpexvg",
    place: "Near Paysandú, Paysandú Department",
    shortName: "Paysandú",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-061",
    lat: -34.41666,
    lng: -54.289898,
    panoId: "CRw0l963aTxP9pLpyLL-Dw",
    place: "Near Rocha, Rocha Department",
    shortName: "Rocha",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-062",
    lat: -34.881457,
    lng: -56.116743,
    panoId: "y8Qw93pI2FgTFQ9tmCu-NQ",
    place: "Near Paso de Carrasco, Canelones",
    shortName: "Paso de Carrasco",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-063",
    lat: -34.341095,
    lng: -55.959755,
    panoId: "R_vmEiOFjyj2Eehn84v-Dw",
    place: "Near San Ramón, Canelones",
    shortName: "San Ramón",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-064",
    lat: -31.44133,
    lng: -57.920112,
    panoId: "nSdJGqs4pBdeYrZ03tkIvQ",
    place: "Near Salto, Salto Department",
    shortName: "Salto",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-065",
    lat: -34.890994,
    lng: -54.865254,
    panoId: "biaUhQSHwtHcLETHXdalog",
    place: "Near Maldonado, Maldonado",
    shortName: "Maldonado",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-066",
    lat: -34.437093,
    lng: -56.457645,
    panoId: "csKsAghdsoQtpetkHIcMEA",
    place: "Near 25 de Agosto, Florida",
    shortName: "25 de Agosto",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-067",
    lat: -33.760344,
    lng: -53.483378,
    panoId: "2z-Jj9BNPr5UeGA-R-2Y0Q",
    place: "Near Puimayen, Lavalleja",
    shortName: "Puimayen",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-068",
    lat: -32.365182,
    lng: -54.213867,
    panoId: "LFTIQO0_s6OWuu0ijlShBQ",
    place: "Near Melo, Cerro Largo",
    shortName: "Melo",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-069",
    lat: -31.217524,
    lng: -55.708227,
    panoId: "p0NKNL96MFv3Zvv_YK9R6A",
    place: "Near Tranqueras, Rivera Department",
    shortName: "Tranqueras",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-070",
    lat: -34.725912,
    lng: -55.210465,
    panoId: "JXQ2I6S0kswIxsWrlQWotg",
    place: "Near Pan de Azúcar, Maldonado",
    shortName: "Pan de Azúcar",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-071",
    lat: -33.356085,
    lng: -55.587148,
    panoId: "j9iPZUnDOtYXxWGeLajCKw",
    place: "Near Sarandí del Yi, Durazno Department",
    shortName: "Sarandí del Yi",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-072",
    lat: -34.820319,
    lng: -54.883982,
    panoId: "nvuucfCwpaDNypQu4YdRSA",
    place: "Near San Carlos, Maldonado",
    shortName: "San Carlos",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-073",
    lat: -31.787515,
    lng: -55.983174,
    panoId: "6N1LPYS_PNyEeJ-FfppaBw",
    place: "Near Tacuarembó, Tacuarembó Department",
    shortName: "Tacuarembó",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-074",
    lat: -34.548471,
    lng: -56.218968,
    panoId: "vz8Ki7NMQ50MMf4ywxBoYg",
    place: "Near Juanicó, Canelones",
    shortName: "Juanicó",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-075",
    lat: -32.673157,
    lng: -57.671349,
    panoId: "Rm18p8HIzRHBA17Y6kyYhw",
    place: "Near Young, Río Negro Department",
    shortName: "Young",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-076",
    lat: -34.523796,
    lng: -55.846414,
    panoId: "JLHkpIPoibCZXLn7o3DREQ",
    place: "Near San Jacinto, Canelones",
    shortName: "San Jacinto",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-077",
    lat: -33.862364,
    lng: -57.402493,
    panoId: "80Ewkrgbb9FQif9iKb4iVQ",
    place: "Near Cardona, Soriano",
    shortName: "Cardona",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-078",
    lat: -34.335262,
    lng: -55.682889,
    panoId: "HNQ6UhyW3vYiFZp-8PPwvg",
    place: "Near Tala, Canelones",
    shortName: "Tala",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-079",
    lat: -34.596376,
    lng: -56.555945,
    panoId: "fEX6Zu0dSzspyC2FN9QDuA",
    place: "Near Libertad, San José Department",
    shortName: "Libertad",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-080",
    lat: -32.363059,
    lng: -57.248135,
    panoId: "bKCadT5Z5ojGwJ_GHZPRBg",
    place: "Near Guichón, Paysandú Department",
    shortName: "Guichón",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-081",
    lat: -34.459542,
    lng: -55.958265,
    panoId: "BKEOyxXBHyPuKRKf8BKXqw",
    place: "Near San Bautista, Canelones",
    shortName: "San Bautista",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-082",
    lat: -34.183481,
    lng: -56.141348,
    panoId: "pCwxqMhNDgW5rq-XJ77bCw",
    place: "Near Florida, Florida",
    shortName: "Florida",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-083",
    lat: -32.959973,
    lng: -53.997988,
    panoId: "eeoI5PFiEJ1WByIWSFvjAw",
    place: "Near Vergara, Treinta y Tres Department",
    shortName: "Vergara",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-084",
    lat: -34.246995,
    lng: -55.992302,
    panoId: "1gdFf9nweCE9V46RRhWf0A",
    place: "Near San Ramón, Canelones",
    shortName: "San Ramón",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-085",
    lat: -31.362214,
    lng: -58.029532,
    panoId: "8NTtzJub1SVPO4gcTyUw-Q",
    place: "Near Concordia, Entre Rios",
    shortName: "Concordia",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","UY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "uy-086",
    lat: -34.311152,
    lng: -57.666437,
    panoId: "eEb_TXRl1FDxnnf6KxXYiw",
    place: "Near Tarariras, Colonia",
    shortName: "Tarariras",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-087",
    lat: -33.419242,
    lng: -56.504878,
    panoId: "Sv45ylFplMeLZSOuSEQfqA",
    place: "Near Durazno, Durazno Department",
    shortName: "Durazno",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-088",
    lat: -30.268624,
    lng: -57.708998,
    panoId: "KC-6HkTLsYIRy-2sMJes2Q",
    place: "Near Monte Caseros, Corrientes",
    shortName: "Monte Caseros",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","UY"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "uy-089",
    lat: -33.985389,
    lng: -57.793235,
    panoId: "hAzUXNiUmfcm9ufmVw-rDg",
    place: "Near Ombúes de Lavalle, Colonia",
    shortName: "Ombúes de Lavalle",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-090",
    lat: -34.634304,
    lng: -54.154495,
    panoId: "x4M-3tlomvGNA3j-5oZ36A",
    place: "Near Costa Azul, Rocha Department",
    shortName: "Costa Azul",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-091",
    lat: -34.808377,
    lng: -55.243342,
    panoId: "hgjfyD6EwEcDVJ0U97uDfQ",
    place: "Near Pan de Azúcar, Maldonado",
    shortName: "Pan de Azúcar",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-092",
    lat: -33.203391,
    lng: -58.065088,
    panoId: "0dI76E484rMNdEh1MOw9rA",
    place: "Near Mercedes, Soriano",
    shortName: "Mercedes",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-093",
    lat: -34.436329,
    lng: -54.300076,
    panoId: "tjZ86TfJAL5NF3VfEoIguw",
    place: "Near Rocha, Rocha Department",
    shortName: "Rocha",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-094",
    lat: -31.767937,
    lng: -54.666672,
    panoId: "Qri-o5bVdsohTIvutwey7Q",
    place: "Near Vichadero, Rivera Department",
    shortName: "Vichadero",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-095",
    lat: -33.611404,
    lng: -58.312507,
    panoId: "348AQABgBA1C3KewsG9nOQ",
    place: "Near Dolores, Soriano",
    shortName: "Dolores",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-096",
    lat: -34.287455,
    lng: -57.311357,
    panoId: "kEXhlUvv2Pdcjcvb9GdE4w",
    place: "Near Rosario, Colonia",
    shortName: "Rosario",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-097",
    lat: -33.881612,
    lng: -57.363237,
    panoId: "LVMNXjQlYcc9lq3ey6LDOA",
    place: "Near Florencio Sánchez, Colonia",
    shortName: "Florencio Sánchez",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-098",
    lat: -32.909391,
    lng: -53.942721,
    panoId: "zmXn-fPMFjWHbZHAgtbxRg",
    place: "Near Vergara, Treinta y Tres Department",
    shortName: "Vergara",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-099",
    lat: -33.355624,
    lng: -54.488887,
    panoId: "pp-m3XfQI_DEt_-12SVKLQ",
    place: "Near José Pedro Varela, Lavalleja",
    shortName: "José Pedro Varela",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "explorer",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-100",
    lat: -33.096404,
    lng: -58.086456,
    panoId: "hQ8lw0Zcn4fDDRvSu26D0Q",
    place: "Near Nuevo Berlín, Río Negro Department",
    shortName: "Nuevo Berlín",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "adventurer",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-101",
    lat: -34.012905,
    lng: -55.844938,
    panoId: "LRlJ7c1G3pKXsBXetm0tnQ",
    place: "Near Casupá, Florida",
    shortName: "Casupá",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "adventurer",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-102",
    lat: -34.119964,
    lng: -57.513567,
    panoId: "9PMPFNYf3NRLUbiYTcaXQA",
    place: "Near Tarariras, Colonia",
    shortName: "Tarariras",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "adventurer",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-103",
    lat: -30.48124,
    lng: -57.347905,
    panoId: "dEWeJy3r-pkSzphEx3yCQQ",
    place: "Near Tomás Gomensoro, Artigas",
    shortName: "Tomás Gomensoro",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "adventurer",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-104",
    lat: -31.526104,
    lng: -55.679199,
    panoId: "IZqDQfb_H0U0wqj_UPNchg",
    place: "Near Minas de Corrales, Rivera Department",
    shortName: "Minas de Corrales",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "adventurer",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-105",
    lat: -33.845128,
    lng: -56.132055,
    panoId: "_ZE6ig7xdZcKwx0CQs3lkA",
    place: "Near Sarandí Grande, Florida",
    shortName: "Sarandí Grande",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "adventurer",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-106",
    lat: -34.055202,
    lng: -57.710164,
    panoId: "e_j-TwscDR8ArFzS8T5opA",
    place: "Near Ombúes de Lavalle, Colonia",
    shortName: "Ombúes de Lavalle",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "adventurer",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-107",
    lat: -33.284558,
    lng: -56.111176,
    panoId: "p7vgKqbZizNzWFRuUGt55A",
    place: "Near Villa del Carmen, Durazno Department",
    shortName: "Villa del Carmen",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "adventurer",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-108",
    lat: -34.737431,
    lng: -55.072347,
    panoId: "ydAWa6iTKwTAjAtvyhKgFg",
    place: "Near San Carlos, Maldonado",
    shortName: "San Carlos",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "adventurer",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-109",
    lat: -33.998184,
    lng: -57.464439,
    panoId: "QDfDAGFzu-mavpyUIKfP6A",
    place: "Near Florencio Sánchez, Colonia",
    shortName: "Florencio Sánchez",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "adventurer",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-110",
    lat: -30.431514,
    lng: -57.2701,
    panoId: "do1xyAkphsQaKLbanBXgIA",
    place: "Near Tomás Gomensoro, Artigas",
    shortName: "Tomás Gomensoro",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "adventurer",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-111",
    lat: -34.354408,
    lng: -56.880172,
    panoId: "2-tTvkw66x9vmCpXD-T1-A",
    place: "Near San José de Mayo, San José Department",
    shortName: "San José de Mayo",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "adventurer",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-112",
    lat: -33.781768,
    lng: -57.602589,
    panoId: "l57RiltuGjREk5x6DhZpNw",
    place: "Near Santa Catalina, Soriano",
    shortName: "Santa Catalina",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "adventurer",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-113",
    lat: -33.056761,
    lng: -55.038535,
    panoId: "T1VZ6bqqH8lurWWqSyKrew",
    place: "Near Santa Clara de Olimar, Treinta y Tres Department",
    shortName: "Santa Clara de Olimar",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "adventurer",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-114",
    lat: -34.144349,
    lng: -56.562313,
    panoId: "0rqrFFQrvlwob1m0a1C8Gw",
    place: "Near 25 de Mayo, Florida",
    shortName: "25 de Mayo",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "adventurer",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-115",
    lat: -34.479832,
    lng: -56.551508,
    panoId: "zli_ALiTXf8304cAXz936w",
    place: "Near Rodríguez, San José Department",
    shortName: "Rodríguez",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "adventurer",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-116",
    lat: -34.454023,
    lng: -56.912583,
    panoId: "lfqzC7shJPxyg8Y_mpvMRg",
    place: "Near Rafael Perazza, San José Department",
    shortName: "Rafael Perazza",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "adventurer",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-117",
    lat: -34.25339,
    lng: -56.521168,
    panoId: "ksFncORaXLi1PvGIgNi3bg",
    place: "Near Cardal, Florida",
    shortName: "Cardal",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "adventurer",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-118",
    lat: -34.106485,
    lng: -56.415265,
    panoId: "sSbQalFFf_72VNfKXIRYCw",
    place: "Near 25 de Mayo, Florida",
    shortName: "25 de Mayo",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "adventurer",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-119",
    lat: -32.503285,
    lng: -57.868674,
    panoId: "0uR3LXywOW6buuIz60F7Bg",
    place: "Near Estación Porvenir, Paysandú Department",
    shortName: "Estación Porvenir",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "adventurer",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-120",
    lat: -34.494534,
    lng: -56.664471,
    panoId: "XqWAF-jUmzFUpFrK0lgVbA",
    place: "Near Puntas de Valdéz, San José Department",
    shortName: "Puntas de Valdéz",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "adventurer",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-121",
    lat: -33.866175,
    lng: -54.766056,
    panoId: "rG2VOPDIcALlBhf9spGZ-g",
    place: "Near Mariscala, Lavalleja",
    shortName: "Mariscala",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "adventurer",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-122",
    lat: -31.393266,
    lng: -57.631133,
    panoId: "BloonTn_J6vUc5Qvvmwwww",
    place: "Near Salto, Salto Department",
    shortName: "Salto",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "adventurer",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "uy-123",
    lat: -33.907965,
    lng: -53.510889,
    panoId: "A7SiE4UaHN9sZuEC3ij60A",
    place: "Near Puimayen, Lavalleja",
    shortName: "Puimayen",
    countryCode: "UY",
    country: "Uruguay",
    continent: "South America",
    difficulty: "adventurer",
    pools: ["world","South America","UY"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "au-000",
    lat: -35.283468,
    lng: 149.128255,
    panoId: "M7_DUMV2CLxkzegLS9zaLA",
    place: "Near Canberra, Australian Capital Territory",
    shortName: "Canberra",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "classic",
    pools: ["world","Oceania","AU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "au-001",
    lat: -35.416451,
    lng: 149.069558,
    panoId: "6-d3nsuUnlg6232k2yDQ9A",
    place: "Near Tuggeranong Administrative District, Australian Capital Territory",
    shortName: "Tuggeranong Administrative District",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "classic",
    pools: ["world","Oceania","AU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "au-002",
    lat: -32.929371,
    lng: 151.780155,
    panoId: "z3gbUZFcwEKeRhigfyHSzg",
    place: "Near Newcastle, New South Wales",
    shortName: "Newcastle",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "classic",
    pools: ["world","Oceania","AU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "au-003",
    lat: -16.923646,
    lng: 145.766136,
    panoId: "EEXUNSgUmF9grg7oGUdIUA",
    place: "Near Cairns, Queensland",
    shortName: "Cairns",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "classic",
    pools: ["world","Oceania","AU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "au-004",
    lat: -21.153329,
    lng: 149.165595,
    panoId: "GZ6WdfvqPKNJpc4CAw6rzA",
    place: "Near Mackay, Queensland",
    shortName: "Mackay",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "classic",
    pools: ["world","Oceania","AU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "au-005",
    lat: -26.656848,
    lng: 153.079482,
    panoId: "6NGlSLMMpRkNfC-DVbTE_Q",
    place: "Near Sunshine Coast, Queensland",
    shortName: "Sunshine Coast",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "classic",
    pools: ["world","Oceania","AU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "au-006",
    lat: -36.12176,
    lng: 146.888063,
    panoId: "-FCptvO5ZNZTIU5DGhwm4A",
    place: "Near Wodonga, Victoria",
    shortName: "Wodonga",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "classic",
    pools: ["world","Oceania","AU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "au-007",
    lat: -32.732931,
    lng: 151.557507,
    panoId: "hGy0-BK5skLIROfNlyXHBw",
    place: "Near Maitland, New South Wales",
    shortName: "Maitland",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "classic",
    pools: ["world","Oceania","AU"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "au-008",
    lat: -33.429606,
    lng: 151.371505,
    panoId: "6Qz7Ap34-v1qqtH7z6nvlg",
    place: "Near Central Coast, New South Wales",
    shortName: "Central Coast",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "classic",
    pools: ["world","Oceania","AU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "au-009",
    lat: -24.866302,
    lng: 152.347886,
    panoId: "gmDWmBcwrG2dc2vvaCMllA",
    place: "Near Bundaberg, Queensland",
    shortName: "Bundaberg",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "classic",
    pools: ["world","Oceania","AU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "au-010",
    lat: -23.380348,
    lng: 150.50593,
    panoId: "LB6DWLUamA4STU6JurUE_w",
    place: "Near Rockhampton, Queensland",
    shortName: "Rockhampton",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "classic",
    pools: ["world","Oceania","AU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "au-011",
    lat: -41.4384,
    lng: 147.134336,
    panoId: "7Pwuv0RftBDk0Ob6cYsRNQ",
    place: "Near Launceston, Tasmania",
    shortName: "Launceston",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "classic",
    pools: ["world","Oceania","AU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "au-012",
    lat: -23.848647,
    lng: 151.258012,
    panoId: "EZ9NqhsGRUd0LgHG5I3pEQ",
    place: "Near Gladstone, Queensland",
    shortName: "Gladstone",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "classic",
    pools: ["world","Oceania","AU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "au-013",
    lat: -30.296091,
    lng: 153.113681,
    panoId: "-4afHnE7X8y1sVLzmHs82w",
    place: "Near Coffs Harbour, New South Wales",
    shortName: "Coffs Harbour",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "classic",
    pools: ["world","Oceania","AU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "au-014",
    lat: -42.879377,
    lng: 147.329394,
    panoId: "zA94-3KWjPExtnXWC3zLSg",
    place: "Near Hobart, Tasmania",
    shortName: "Hobart",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "classic",
    pools: ["world","Oceania","AU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "au-015",
    lat: -37.814017,
    lng: 144.963153,
    panoId: "Ib7TP4it57dhLO1PcF1VZw",
    place: "Near Melbourne, Victoria",
    shortName: "Melbourne",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "classic",
    pools: ["world","Oceania","AU"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "au-016",
    lat: -31.431159,
    lng: 152.90896,
    panoId: "mpvDSalQq5jTbMOiXHtgXw",
    place: "Near Port Macquarie, New South Wales",
    shortName: "Port Macquarie",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "classic",
    pools: ["world","Oceania","AU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "au-017",
    lat: -33.86785,
    lng: 151.207057,
    panoId: "R3t6BpQw9gYx7KZdHzvNVw",
    place: "Near Sydney, New South Wales",
    shortName: "Sydney",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "classic",
    pools: ["world","Oceania","AU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "au-018",
    lat: -34.928635,
    lng: 138.598648,
    panoId: "z7vM4Su4tZyvnNuImy3qPw",
    place: "Near Adelaide, South Australia",
    shortName: "Adelaide",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "classic",
    pools: ["world","Oceania","AU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "au-019",
    lat: -31.090495,
    lng: 150.928962,
    panoId: "vAc8BqtdFMi5P0PbrEtDdg",
    place: "Near Tamworth, New South Wales",
    shortName: "Tamworth",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "classic",
    pools: ["world","Oceania","AU"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "au-020",
    lat: -38.147159,
    lng: 144.360799,
    panoId: "56ngJzfTDmmIdd69AP8O_g",
    place: "Near Geelong, Victoria",
    shortName: "Geelong",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "classic",
    pools: ["world","Oceania","AU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "au-021",
    lat: -25.287297,
    lng: 152.767449,
    panoId: "vXAbOViwNfhsyqPDuRg8-Q",
    place: "Near Hervey Bay, Queensland",
    shortName: "Hervey Bay",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "classic",
    pools: ["world","Oceania","AU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "au-022",
    lat: -34.423939,
    lng: 150.893357,
    panoId: "tpQ_D-zLaiN6pEROcCNEVw",
    place: "Near Wollongong, New South Wales",
    shortName: "Wollongong",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "classic",
    pools: ["world","Oceania","AU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "au-023",
    lat: -27.467973,
    lng: 153.028033,
    panoId: "kiZzsHczhSfsVFL6ccFjSQ",
    place: "Near Brisbane, Queensland",
    shortName: "Brisbane",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "classic",
    pools: ["world","Oceania","AU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "au-024",
    lat: -33.327108,
    lng: 115.641386,
    panoId: "lVa_hRmTtQf_P3zHYeeHHQ",
    place: "Near Bunbury, Western Australia",
    shortName: "Bunbury",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "classic",
    pools: ["world","Oceania","AU"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "au-025",
    lat: -31.952193,
    lng: 115.861409,
    panoId: "TpRT3-huRG5IL5sLSpKsQw",
    place: "Near Perth, Western Australia",
    shortName: "Perth",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "classic",
    pools: ["world","Oceania","AU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "au-026",
    lat: -32.526873,
    lng: 115.721747,
    panoId: "g7cvFLGi0xP_ZojfYasVgw",
    place: "Near Mandurah, Western Australia",
    shortName: "Mandurah",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "classic",
    pools: ["world","Oceania","AU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "au-027",
    lat: -12.461148,
    lng: 130.841812,
    panoId: "YbLcE28pE_ab4tW74dm3Gw",
    place: "Near Darwin, Northern Territory",
    shortName: "Darwin",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "classic",
    pools: ["world","Oceania","AU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "au-028",
    lat: -36.758265,
    lng: 144.280407,
    panoId: "vqiyqYps2LAeVmri4WmQyw",
    place: "Near Bendigo, Victoria",
    shortName: "Bendigo",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "classic",
    pools: ["world","Oceania","AU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "au-029",
    lat: -19.266435,
    lng: 146.805982,
    panoId: "kQ2pebfLk-HXWDlfDJ4g8A",
    place: "Near Townsville, Queensland",
    shortName: "Townsville",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "classic",
    pools: ["world","Oceania","AU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "au-030",
    lat: -32.242912,
    lng: 148.604631,
    panoId: "M-2_LxQNvu0HGefuExCG3A",
    place: "Near Dubbo, New South Wales",
    shortName: "Dubbo",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "classic",
    pools: ["world","Oceania","AU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "au-031",
    lat: -27.560509,
    lng: 151.953549,
    panoId: "GQFOdf-u8vR3OZFWZkkRDg",
    place: "Near Toowoomba, Queensland",
    shortName: "Toowoomba",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "classic",
    pools: ["world","Oceania","AU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "au-032",
    lat: -37.566218,
    lng: 143.849454,
    panoId: "9vSCcURzNgYM9-Tl3bYPLQ",
    place: "Near Ballarat, Victoria",
    shortName: "Ballarat",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "classic",
    pools: ["world","Oceania","AU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "au-033",
    lat: -33.283906,
    lng: 149.099932,
    panoId: "pdFWG1Jq5P4jn2KNxBwoUA",
    place: "Near Orange, New South Wales",
    shortName: "Orange",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "classic",
    pools: ["world","Oceania","AU"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "au-034",
    lat: -28.779239,
    lng: 114.614218,
    panoId: "8T7GZnuK1rnFRwcWtEa6bg",
    place: "Near Geraldton, Western Australia",
    shortName: "Geraldton",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "classic",
    pools: ["world","Oceania","AU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "au-035",
    lat: -35.026949,
    lng: 117.88363,
    panoId: "fKFIS3oR_dJUOMqiFMJBxw",
    place: "Near Albany, Western Australia",
    shortName: "Albany",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "classic",
    pools: ["world","Oceania","AU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "au-036",
    lat: -38.149737,
    lng: 144.348012,
    panoId: "mI3RfudULoW1-F9g7gWP7w",
    place: "Near Geelong, Victoria",
    shortName: "Geelong",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "classic",
    pools: ["world","Oceania","AU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "au-037",
    lat: -32.530131,
    lng: 115.70831,
    panoId: "csodMJltKN8_zhS1x-mW8Q",
    place: "Near Mandurah, Western Australia",
    shortName: "Mandurah",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "classic",
    pools: ["world","Oceania","AU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "au-038",
    lat: -41.4252,
    lng: 147.15775,
    panoId: "7n95F0L5bwRxob1AwQ0ZYw",
    place: "Near East Launceston, Tasmania",
    shortName: "East Launceston",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "classic",
    pools: ["world","Oceania","AU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "au-039",
    lat: -35.283227,
    lng: 149.15532,
    panoId: "bXXc1guWAcnZv3LNBzqipA",
    place: "Near Campbell, Australian Capital Territory",
    shortName: "Campbell",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "classic",
    pools: ["world","Oceania","AU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "au-040",
    lat: -36.764559,
    lng: 144.295167,
    panoId: "f6DHno7a7aHk7yt9Bc_5fQ",
    place: "Near Kennington, Victoria",
    shortName: "Kennington",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "classic",
    pools: ["world","Oceania","AU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "au-041",
    lat: -37.825672,
    lng: 144.983008,
    panoId: "DjIy6DwcBK1NHfQfKNfqLg",
    place: "Near Jolimont, Victoria",
    shortName: "Jolimont",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "classic",
    pools: ["world","Oceania","AU"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "au-042",
    lat: -34.185411,
    lng: 142.16245,
    panoId: "lg-hpMSNFAIYm9kJZHGv9w",
    place: "Near Mildura, Victoria",
    shortName: "Mildura",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "classic",
    pools: ["world","Oceania","AU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "au-043",
    lat: -27.59996,
    lng: 151.942618,
    panoId: "qkQd8rAn9G0415DO3w2UxA",
    place: "Near Kearneys Spring, Queensland",
    shortName: "Kearneys Spring",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "classic",
    pools: ["world","Oceania","AU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "au-044",
    lat: -37.580879,
    lng: 143.828786,
    panoId: "MS_b0OEp9QyDkHRwDufFjA",
    place: "Near Redan, Victoria",
    shortName: "Redan",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "classic",
    pools: ["world","Oceania","AU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "au-045",
    lat: -35.40861,
    lng: 149.091526,
    panoId: "dpaE_bcqK2ifDoqpDxQumg",
    place: "Near Monash, Australian Capital Territory",
    shortName: "Monash",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "classic",
    pools: ["world","Oceania","AU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "au-046",
    lat: -26.732272,
    lng: 153.117983,
    panoId: "6Vg_-Dei9i1DlUzGKZHYHA",
    place: "Near Birtinya, Queensland",
    shortName: "Birtinya",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "classic",
    pools: ["world","Oceania","AU"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "au-047",
    lat: -12.47045,
    lng: 130.849433,
    panoId: "Y11zkIlIw3p6462cAiWFsQ",
    place: "Near Darwin, Northern Territory",
    shortName: "Darwin",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "classic",
    pools: ["world","Oceania","AU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "au-048",
    lat: -28.025491,
    lng: 153.395764,
    panoId: "xOseKLrD2H6iBh9r-WEolg",
    place: "Near Bundall, Queensland",
    shortName: "Bundall",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "classic",
    pools: ["world","Oceania","AU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "au-049",
    lat: -32.908595,
    lng: 151.71803,
    panoId: "a2oR7gLwBbYMHTbnIaHTIQ",
    place: "Near Waratah, New South Wales",
    shortName: "Waratah",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "classic",
    pools: ["world","Oceania","AU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "au-050",
    lat: -33.344942,
    lng: 149.083422,
    panoId: "_XBo_uADJ5J8qQJxcmSwyg",
    place: "Near Orange, New South Wales",
    shortName: "Orange",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "explorer",
    pools: ["world","Oceania","AU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "au-051",
    lat: -24.85035,
    lng: 152.298946,
    panoId: "MDaXMAlw2m6PgN0yiXY8sw",
    place: "Near Avoca, Queensland",
    shortName: "Avoca",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "explorer",
    pools: ["world","Oceania","AU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "au-052",
    lat: -34.388462,
    lng: 150.840949,
    panoId: "7GXlre1xzh_XPj6BWWG3gA",
    place: "Near Mount Keira, New South Wales",
    shortName: "Mount Keira",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "explorer",
    pools: ["world","Oceania","AU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "au-053",
    lat: -27.533326,
    lng: 151.99156,
    panoId: "pcPx2-N-Z8rLRjCGUWny9g",
    place: "Near Mount Lofty, Queensland",
    shortName: "Mount Lofty",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "explorer",
    pools: ["world","Oceania","AU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "au-054",
    lat: -30.314441,
    lng: 153.065349,
    panoId: "5lO-KEF0TyUeTgqIkCkMiQ",
    place: "Near North Boambee Valley, New South Wales",
    shortName: "North Boambee Valley",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "explorer",
    pools: ["world","Oceania","AU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "au-055",
    lat: -32.201462,
    lng: 148.634009,
    panoId: "lSBqmWY5p5z3Drg9CZG1-w",
    place: "Near Dubbo, New South Wales",
    shortName: "Dubbo",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "explorer",
    pools: ["world","Oceania","AU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "au-056",
    lat: -21.107347,
    lng: 149.10635,
    panoId: "dHUuxL3A7HWWQKa2hnmIxA",
    place: "Near Glenella, Queensland",
    shortName: "Glenella",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "explorer",
    pools: ["world","Oceania","AU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "au-057",
    lat: -12.391929,
    lng: 130.861886,
    panoId: "1hvG6AYykLJsoxSLuiGWUQ",
    place: "Near Millner, Northern Territory",
    shortName: "Millner",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "explorer",
    pools: ["world","Oceania","AU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "au-058",
    lat: -33.369003,
    lng: 115.674559,
    panoId: "xelM9scduVfPm1o1hc3C5w",
    place: "Near College Grove, Western Australia",
    shortName: "College Grove",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "explorer",
    pools: ["world","Oceania","AU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "au-059",
    lat: -36.711733,
    lng: 144.300657,
    panoId: "bt5dIizkcKKkw1kAdePceg",
    place: "Near Jackass Flat, Victoria",
    shortName: "Jackass Flat",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "explorer",
    pools: ["world","Oceania","AU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "au-060",
    lat: -41.440537,
    lng: 147.078712,
    panoId: "OPCsSg2sTu0fv3hhBiTC0A",
    place: "Near Blackstone Heights, Tasmania",
    shortName: "Blackstone Heights",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "explorer",
    pools: ["world","Oceania","AU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "au-061",
    lat: -38.313304,
    lng: 142.495285,
    panoId: "MsP0QJEnv0O-_DjM0VfLrQ",
    place: "Near Dennington, Victoria",
    shortName: "Dennington",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "explorer",
    pools: ["world","Oceania","AU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "au-062",
    lat: -32.211926,
    lng: 148.694433,
    panoId: "GWHioP-TD58ViqKiPL0rGw",
    place: "Near Eulomogo, New South Wales",
    shortName: "Eulomogo",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "explorer",
    pools: ["world","Oceania","AU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "au-063",
    lat: -35.456546,
    lng: 149.010837,
    panoId: "8ZaZ4ZqYFLn8KKFVtYaDTQ",
    place: "Near Greenway, Australian Capital Territory",
    shortName: "Greenway",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "explorer",
    pools: ["world","Oceania","AU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "au-064",
    lat: -24.851384,
    lng: 152.257589,
    panoId: "lvornATvvY22EBsGOh5_Iw",
    place: "Near Sharon, Queensland",
    shortName: "Sharon",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "explorer",
    pools: ["world","Oceania","AU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "au-065",
    lat: -21.054739,
    lng: 149.084245,
    panoId: "esr0Hc4qJBERR3i2zTnbgQ",
    place: "Near Bucasia, Queensland",
    shortName: "Bucasia",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "explorer",
    pools: ["world","Oceania","AU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "au-066",
    lat: -42.940672,
    lng: 147.312041,
    panoId: "J0yY7RQsNm1K4ztVZTa75Q",
    place: "Near Mount Nelson, Tasmania",
    shortName: "Mount Nelson",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "explorer",
    pools: ["world","Oceania","AU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "au-067",
    lat: -28.800049,
    lng: 114.691365,
    panoId: "TvmKNLYSD945iwUgqczjeA",
    place: "Near Utakarra, Western Australia",
    shortName: "Utakarra",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "explorer",
    pools: ["world","Oceania","AU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "au-068",
    lat: -33.17027,
    lng: 149.081265,
    panoId: "-xg3kNrf4hu6QtDw77VVDA",
    place: "Near Orange, New South Wales",
    shortName: "Orange",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "explorer",
    pools: ["world","Oceania","AU"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "au-069",
    lat: -34.992346,
    lng: 117.870409,
    panoId: "ErN7CQMy7RFFT-Lf2egYzA",
    place: "Near Orana, Western Australia",
    shortName: "Orana",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "explorer",
    pools: ["world","Oceania","AU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "au-070",
    lat: -36.139173,
    lng: 146.935315,
    panoId: "BJ8jga2bylQB2Xj0OdRHog",
    place: "Near Wodonga, Victoria",
    shortName: "Wodonga",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "explorer",
    pools: ["world","Oceania","AU"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "au-071",
    lat: -36.318935,
    lng: 145.399314,
    panoId: "ETmzgvOMBcIx-U71GEwPAA",
    place: "Near Shepparton, Victoria",
    shortName: "Shepparton",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "explorer",
    pools: ["world","Oceania","AU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "au-072",
    lat: -36.381615,
    lng: 146.404738,
    panoId: "-Fp-si7La___pREytZL0rw",
    place: "Near Wangaratta, Victoria",
    shortName: "Wangaratta",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "explorer",
    pools: ["world","Oceania","AU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "au-073",
    lat: -23.924348,
    lng: 151.265073,
    panoId: "Zw1Dk__GrBBAKeRenhVq_A",
    place: "Near Glen Eden, Queensland",
    shortName: "Glen Eden",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "explorer",
    pools: ["world","Oceania","AU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "au-074",
    lat: -26.847177,
    lng: 153.062998,
    panoId: "sYS968RCqnNoaoz2G9h0ZA",
    place: "Near Pelican Waters, Queensland",
    shortName: "Pelican Waters",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "explorer",
    pools: ["world","Oceania","AU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "au-075",
    lat: -31.328507,
    lng: 152.724307,
    panoId: "_pRDRM6B3aWtX2CEcBr-og",
    place: "Near Wauchope, New South Wales",
    shortName: "Wauchope",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "explorer",
    pools: ["world","Oceania","AU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "au-076",
    lat: -33.451984,
    lng: 149.720723,
    panoId: "k4ogdrFo277gX7y4SFXpTg",
    place: "Near Raglan, New South Wales",
    shortName: "Raglan",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "explorer",
    pools: ["world","Oceania","AU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "au-077",
    lat: -26.789689,
    lng: 152.983103,
    panoId: "RFpdlgIb2seRr32Lv9KpWQ",
    place: "Near Landsborough, Queensland",
    shortName: "Landsborough",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "explorer",
    pools: ["world","Oceania","AU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "au-078",
    lat: -30.696271,
    lng: 121.469898,
    panoId: "X8IYe_m5evZ6MPy-xxImcA",
    place: "Near Hannans, Western Australia",
    shortName: "Hannans",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "explorer",
    pools: ["world","Oceania","AU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "au-079",
    lat: -23.520952,
    lng: 150.417519,
    panoId: "J7EgZu1DP1WiNcDWNNqiBA",
    place: "Near Bouldercombe, Queensland",
    shortName: "Bouldercombe",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "explorer",
    pools: ["world","Oceania","AU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "au-080",
    lat: -25.36643,
    lng: 152.598577,
    panoId: "SQTBwY4RQ3176OZbnukXzQ",
    place: "Near Howard, Queensland",
    shortName: "Howard",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "explorer",
    pools: ["world","Oceania","AU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "au-081",
    lat: -33.656728,
    lng: 115.271946,
    panoId: "xDjm0yn01PnkezbXYSod8g",
    place: "Near Broadwater, Western Australia",
    shortName: "Broadwater",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "explorer",
    pools: ["world","Oceania","AU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "au-082",
    lat: -24.02287,
    lng: 151.356503,
    panoId: "yufYycV0wiSLMM0THIvRAw",
    place: "Near Benaraby, Queensland",
    shortName: "Benaraby",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "explorer",
    pools: ["world","Oceania","AU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "au-083",
    lat: -38.303313,
    lng: 146.481713,
    panoId: "E8xPwn1QewW9m4yja1g03w",
    place: "Near Hazelwood North, Victoria",
    shortName: "Hazelwood North",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "explorer",
    pools: ["world","Oceania","AU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "au-084",
    lat: -23.293319,
    lng: 150.374395,
    panoId: "N4t05kGxosGf0R8REaowvg",
    place: "Near Alton Downs, Queensland",
    shortName: "Alton Downs",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "explorer",
    pools: ["world","Oceania","AU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "au-085",
    lat: -38.048478,
    lng: 145.833729,
    panoId: "5MOVOgLWW_xvAGzteC6lHQ",
    place: "Near Longwarry, Victoria",
    shortName: "Longwarry",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "explorer",
    pools: ["world","Oceania","AU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "au-086",
    lat: -12.507431,
    lng: 130.950012,
    panoId: "U-9WSWybMgcRdKkxGl_dYw",
    place: "Near Moulden, Northern Territory",
    shortName: "Moulden",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "explorer",
    pools: ["world","Oceania","AU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "au-087",
    lat: -38.261613,
    lng: 144.317268,
    panoId: "9et-yLj4A6OlYm6UjbsdVw",
    place: "Near Mount Duneed, Victoria",
    shortName: "Mount Duneed",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "explorer",
    pools: ["world","Oceania","AU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "au-088",
    lat: -36.299821,
    lng: 146.363757,
    panoId: "0EO1GHNwDXwOq5fsI5TF8A",
    place: "Near Wangaratta, Victoria",
    shortName: "Wangaratta",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "explorer",
    pools: ["world","Oceania","AU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "au-089",
    lat: -36.345601,
    lng: 145.295437,
    panoId: "bEY59C9dv2vZX2nYlbvTPg",
    place: "Near Mooroopna, Victoria",
    shortName: "Mooroopna",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "explorer",
    pools: ["world","Oceania","AU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "au-090",
    lat: -38.108377,
    lng: 146.363754,
    panoId: "lKwXyzAjCW6qyzuVjyGytQ",
    place: "Near Yallourn North, Victoria",
    shortName: "Yallourn North",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "explorer",
    pools: ["world","Oceania","AU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "au-091",
    lat: -20.300476,
    lng: 118.638364,
    panoId: "_MAcBIFQWr8vz79fmDRx5w",
    place: "Near Port Hedland, Western Australia",
    shortName: "Port Hedland",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "explorer",
    pools: ["world","Oceania","AU"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "au-092",
    lat: -37.884999,
    lng: 140.830167,
    panoId: "a_F9VbgDPTaDVzrQhyp7nw",
    place: "Near Mount Gambier, South Australia",
    shortName: "Mount Gambier",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "explorer",
    pools: ["world","Oceania","AU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "au-093",
    lat: -23.758154,
    lng: 133.867096,
    panoId: "ZFEGITFqO80SplG5NfCF8Q",
    place: "Near Ross, Northern Territory",
    shortName: "Ross",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "explorer",
    pools: ["world","Oceania","AU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "au-094",
    lat: -35.04956,
    lng: 139.265238,
    panoId: "j0OKtBRH_AikgIDqcjQiAQ",
    place: "Near Murray Bridge, South Australia",
    shortName: "Murray Bridge",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "explorer",
    pools: ["world","Oceania","AU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "au-095",
    lat: -33.373107,
    lng: 116.27498,
    panoId: "bf6kZIkTSvh5gZEgfIMuPw",
    place: "Near Collie, Western Australia",
    shortName: "Collie",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "explorer",
    pools: ["world","Oceania","AU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "au-096",
    lat: -33.680451,
    lng: 115.486205,
    panoId: "FJWYGukQCuGF4CqP0SwvEw",
    place: "Near Yalyalup, Western Australia",
    shortName: "Yalyalup",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "explorer",
    pools: ["world","Oceania","AU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "au-097",
    lat: -41.009889,
    lng: 145.780963,
    panoId: "IXClDe0Wo5965loqmZupiA",
    place: "Near Wynyard, Tasmania",
    shortName: "Wynyard",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "explorer",
    pools: ["world","Oceania","AU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "au-098",
    lat: -41.036618,
    lng: 145.831723,
    panoId: "RuBP5OgslUzTjOfSGktLog",
    place: "Near Somerset, Tasmania",
    shortName: "Somerset",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "explorer",
    pools: ["world","Oceania","AU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "au-099",
    lat: -14.500096,
    lng: 132.248622,
    panoId: "orWYmPeZ3N_IhJ3zk2opDg",
    place: "Near Katherine South, Northern Territory",
    shortName: "Katherine South",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "explorer",
    pools: ["world","Oceania","AU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "au-100",
    lat: -34.845775,
    lng: 149.555571,
    panoId: "9OxrW099HIE_zyTz5jfhhA",
    place: "Near Goulburn, New South Wales",
    shortName: "Goulburn",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "adventurer",
    pools: ["world","Oceania","AU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "au-101",
    lat: -37.826271,
    lng: 144.291085,
    panoId: "5rty_EDkv0kxciWMas3F5g",
    place: "Near Maddingley, Victoria",
    shortName: "Maddingley",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "adventurer",
    pools: ["world","Oceania","AU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "au-102",
    lat: -32.736804,
    lng: 115.794971,
    panoId: "BEB55eA4tZciiSlThFfzvg",
    place: "Near Pinjarra, Western Australia",
    shortName: "Pinjarra",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "adventurer",
    pools: ["world","Oceania","AU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "au-103",
    lat: -33.831737,
    lng: 115.215026,
    panoId: "7PAGpXl5k8iSJ0yDy_B2Uw",
    place: "Near Cowaramup, Western Australia",
    shortName: "Cowaramup",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "adventurer",
    pools: ["world","Oceania","AU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "au-104",
    lat: -41.320611,
    lng: 146.20734,
    panoId: "wIW5iCDP-IMxCy74gsnu1g",
    place: "Near Sheffield, Tasmania",
    shortName: "Sheffield",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "adventurer",
    pools: ["world","Oceania","AU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "au-105",
    lat: -41.35338,
    lng: 146.202857,
    panoId: "750qSm9LlyRk7h4faWsYVQ",
    place: "Near Sheffield, Tasmania",
    shortName: "Sheffield",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "adventurer",
    pools: ["world","Oceania","AU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "au-106",
    lat: -35.305279,
    lng: 139.266178,
    panoId: "uXNQxv75pCuzSz7ZdTGaaA",
    place: "Near Tailem Bend, South Australia",
    shortName: "Tailem Bend",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "adventurer",
    pools: ["world","Oceania","AU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "au-107",
    lat: -14.547218,
    lng: 132.441049,
    panoId: "1D9wsHIoK1UusixIuES4zw",
    place: "Near Katherine East, Northern Territory",
    shortName: "Katherine East",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "adventurer",
    pools: ["world","Oceania","AU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "au-108",
    lat: -32.474803,
    lng: 137.951512,
    panoId: "i81thWOcoYkwPW1HIM7C7w",
    place: "Near Stirling North, South Australia",
    shortName: "Stirling North",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "adventurer",
    pools: ["world","Oceania","AU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "au-109",
    lat: -40.912419,
    lng: 144.965693,
    panoId: "RVVA0EZCXKsP04Qa1tnxXQ",
    place: "Near Smithton, Tasmania",
    shortName: "Smithton",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "adventurer",
    pools: ["world","Oceania","AU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "au-110",
    lat: -41.38607,
    lng: 146.834321,
    panoId: "PPPOxcPeSZqDgG4bwovanQ",
    place: "Near Westbury, Tasmania",
    shortName: "Westbury",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "adventurer",
    pools: ["world","Oceania","AU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "au-111",
    lat: -37.482283,
    lng: 140.196043,
    panoId: "WX_ZiiK8dUWfJ0nmGq_t-w",
    place: "Near Millicent, South Australia",
    shortName: "Millicent",
    countryCode: "AU",
    country: "Australia",
    continent: "Oceania",
    difficulty: "adventurer",
    pools: ["world","Oceania","AU"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nz-000",
    lat: -36.848525,
    lng: 174.763484,
    panoId: "Bj4g_L_u38weI9uIXCjhDw",
    place: "Near Auckland, Auckland",
    shortName: "Auckland",
    countryCode: "NZ",
    country: "New Zealand",
    continent: "Oceania",
    difficulty: "classic",
    pools: ["world","Oceania","NZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nz-001",
    lat: -38.138806,
    lng: 176.245189,
    panoId: "JzpdGOKNllI-JsAfFJb3vQ",
    place: "Near Rotorua, Bay of Plenty",
    shortName: "Rotorua",
    countryCode: "NZ",
    country: "New Zealand",
    continent: "Oceania",
    difficulty: "classic",
    pools: ["world","Oceania","NZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nz-002",
    lat: -43.533131,
    lng: 172.633387,
    panoId: "68wmff_qIm8AHonC_NF9ng",
    place: "Near Christchurch, Canterbury",
    shortName: "Christchurch",
    countryCode: "NZ",
    country: "New Zealand",
    continent: "Oceania",
    difficulty: "classic",
    pools: ["world","Oceania","NZ"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "nz-003",
    lat: -39.638093,
    lng: 176.849173,
    panoId: "0f7jTXdaWuXV5J_wKXQsjQ",
    place: "Near Hastings, Hawke's Bay Region",
    shortName: "Hastings",
    countryCode: "NZ",
    country: "New Zealand",
    continent: "Oceania",
    difficulty: "classic",
    pools: ["world","Oceania","NZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nz-004",
    lat: -40.916502,
    lng: 175.013326,
    panoId: "Ip8IMgToRFzsTypeg9nU2w",
    place: "Near Paraparaumu, Wellington Region",
    shortName: "Paraparaumu",
    countryCode: "NZ",
    country: "New Zealand",
    continent: "Oceania",
    difficulty: "classic",
    pools: ["world","Oceania","NZ"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "nz-005",
    lat: -39.066474,
    lng: 174.082743,
    panoId: "mmadBjOlnQk6TI1Tm0W2Gg",
    place: "Near New Plymouth, Taranaki Region",
    shortName: "New Plymouth",
    countryCode: "NZ",
    country: "New Zealand",
    continent: "Oceania",
    difficulty: "classic",
    pools: ["world","Oceania","NZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nz-006",
    lat: -38.683313,
    lng: 176.083577,
    panoId: "Yoj3Pf6TK-vZzqdct334Uw",
    place: "Near Taupo, Waikato Region",
    shortName: "Taupo",
    countryCode: "NZ",
    country: "New Zealand",
    continent: "Oceania",
    difficulty: "classic",
    pools: ["world","Oceania","NZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nz-007",
    lat: -37.201547,
    lng: 174.951394,
    panoId: "DY5amwv7OQgmwg35zIr2Qw",
    place: "Near Pukekohe East, Auckland",
    shortName: "Pukekohe East",
    countryCode: "NZ",
    country: "New Zealand",
    continent: "Oceania",
    difficulty: "classic",
    pools: ["world","Oceania","NZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nz-008",
    lat: -43.30491,
    lng: 172.583696,
    panoId: "_6wspPaDBUK3Yc7L6ALTKg",
    place: "Near Rangiora, Canterbury",
    shortName: "Rangiora",
    countryCode: "NZ",
    country: "New Zealand",
    continent: "Oceania",
    difficulty: "classic",
    pools: ["world","Oceania","NZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nz-009",
    lat: -43.89916,
    lng: 171.732886,
    panoId: "_BaxHieL-V-Ys3lfPCA98w",
    place: "Near Ashburton, Canterbury",
    shortName: "Ashburton",
    countryCode: "NZ",
    country: "New Zealand",
    continent: "Oceania",
    difficulty: "classic",
    pools: ["world","Oceania","NZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nz-010",
    lat: -41.216771,
    lng: 174.916829,
    panoId: "oIwvxgOh1Dmy9RehURhQHw",
    place: "Near Lower Hutt, Wellington Region",
    shortName: "Lower Hutt",
    countryCode: "NZ",
    country: "New Zealand",
    continent: "Oceania",
    difficulty: "classic",
    pools: ["world","Oceania","NZ"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "nz-011",
    lat: -41.133245,
    lng: 174.849461,
    panoId: "ufhQMMRXzQncAWiFUGGYQw",
    place: "Near Porirua, Wellington Region",
    shortName: "Porirua",
    countryCode: "NZ",
    country: "New Zealand",
    continent: "Oceania",
    difficulty: "classic",
    pools: ["world","Oceania","NZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nz-012",
    lat: -40.356049,
    lng: 175.611164,
    panoId: "ov3RhKYHRYJOSl1hafamzA",
    place: "Near Palmerston North, Manawatu-Wanganui",
    shortName: "Palmerston North",
    countryCode: "NZ",
    country: "New Zealand",
    continent: "Oceania",
    difficulty: "classic",
    pools: ["world","Oceania","NZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nz-013",
    lat: -41.283628,
    lng: 174.741327,
    panoId: "5rOzuh8ysXzvKHMhQ20-vQ",
    place: "Near Karori, Wellington Region",
    shortName: "Karori",
    countryCode: "NZ",
    country: "New Zealand",
    continent: "Oceania",
    difficulty: "classic",
    pools: ["world","Oceania","NZ"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "nz-014",
    lat: -41.140052,
    lng: 175.051843,
    panoId: "d6tR45Dg1-NbGoylBiUlUA",
    place: "Near Upper Hutt, Wellington Region",
    shortName: "Upper Hutt",
    countryCode: "NZ",
    country: "New Zealand",
    continent: "Oceania",
    difficulty: "classic",
    pools: ["world","Oceania","NZ"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "nz-015",
    lat: -45.874136,
    lng: 170.5036,
    panoId: "X4AXx3d0EdFIyyysc6wWtQ",
    place: "Near Dunedin, Otago",
    shortName: "Dunedin",
    countryCode: "NZ",
    country: "New Zealand",
    continent: "Oceania",
    difficulty: "classic",
    pools: ["world","Oceania","NZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nz-016",
    lat: -44.39683,
    lng: 171.253462,
    panoId: "xz5tyJWWUCNVndJDzoRNTw",
    place: "Near Timaru, Canterbury",
    shortName: "Timaru",
    countryCode: "NZ",
    country: "New Zealand",
    continent: "Oceania",
    difficulty: "classic",
    pools: ["world","Oceania","NZ"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "nz-017",
    lat: -40.633516,
    lng: 175.275376,
    panoId: "YHT9fvWciKZajvSToXm5Cg",
    place: "Near Levin, Manawatu-Wanganui",
    shortName: "Levin",
    countryCode: "NZ",
    country: "New Zealand",
    continent: "Oceania",
    difficulty: "classic",
    pools: ["world","Oceania","NZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nz-018",
    lat: -46.400663,
    lng: 168.349974,
    panoId: "18JYcG-tnPp7YMM6C96Gyw",
    place: "Near Invercargill, Southland",
    shortName: "Invercargill",
    countryCode: "NZ",
    country: "New Zealand",
    continent: "Oceania",
    difficulty: "classic",
    pools: ["world","Oceania","NZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nz-019",
    lat: -37.878255,
    lng: 175.438923,
    panoId: "YLAZQ1ChFAl-Ci7W9vtXyQ",
    place: "Near Cambridge, Waikato Region",
    shortName: "Cambridge",
    countryCode: "NZ",
    country: "New Zealand",
    continent: "Oceania",
    difficulty: "classic",
    pools: ["world","Oceania","NZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nz-020",
    lat: -38.653447,
    lng: 178.004546,
    panoId: "AU1vxuKw0E-HS-5FWQJvnA",
    place: "Near Gisborne, Gisborne",
    shortName: "Gisborne",
    countryCode: "NZ",
    country: "New Zealand",
    continent: "Oceania",
    difficulty: "classic",
    pools: ["world","Oceania","NZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nz-021",
    lat: -41.516411,
    lng: 173.953307,
    panoId: "hzcQuIwRbPHsvO5YkrxQcw",
    place: "Near Blenheim, Marlborough",
    shortName: "Blenheim",
    countryCode: "NZ",
    country: "New Zealand",
    continent: "Oceania",
    difficulty: "classic",
    pools: ["world","Oceania","NZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nz-022",
    lat: -40.959986,
    lng: 175.657115,
    panoId: "DLakTGGlN_9ueG2mQpO0Ug",
    place: "Near Masterton, Wellington Region",
    shortName: "Masterton",
    countryCode: "NZ",
    country: "New Zealand",
    continent: "Oceania",
    difficulty: "classic",
    pools: ["world","Oceania","NZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nz-023",
    lat: -41.270752,
    lng: 173.284042,
    panoId: "nmklYfJWkRPDYQy0a4OBQA",
    place: "Near Nelson, Nelson Region",
    shortName: "Nelson",
    countryCode: "NZ",
    country: "New Zealand",
    continent: "Oceania",
    difficulty: "classic",
    pools: ["world","Oceania","NZ"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "nz-024",
    lat: -37.686176,
    lng: 176.166676,
    panoId: "urzAYoG7UuYWOsyAacvlyA",
    place: "Near Tauranga, Bay of Plenty",
    shortName: "Tauranga",
    countryCode: "NZ",
    country: "New Zealand",
    continent: "Oceania",
    difficulty: "classic",
    pools: ["world","Oceania","NZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nz-025",
    lat: -41.266356,
    lng: 174.950559,
    panoId: "IPkX2fRZqCRpVYcbji3aUg",
    place: "Near Wainuiomata, Wellington Region",
    shortName: "Wainuiomata",
    countryCode: "NZ",
    country: "New Zealand",
    continent: "Oceania",
    difficulty: "classic",
    pools: ["world","Oceania","NZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nz-026",
    lat: -39.666607,
    lng: 176.883407,
    panoId: "O3GQF1v-9MxbpjxxBTqQXQ",
    place: "Near Havelock North, Hawke's Bay Region",
    shortName: "Havelock North",
    countryCode: "NZ",
    country: "New Zealand",
    continent: "Oceania",
    difficulty: "classic",
    pools: ["world","Oceania","NZ"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "nz-027",
    lat: -41.334202,
    lng: 173.183175,
    panoId: "h4Mfkfm9d-260Zv7Qek7cA",
    place: "Near Richmond, Tasman District",
    shortName: "Richmond",
    countryCode: "NZ",
    country: "New Zealand",
    continent: "Oceania",
    difficulty: "classic",
    pools: ["world","Oceania","NZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nz-028",
    lat: -41.316554,
    lng: 173.233466,
    panoId: "iGHtWo2hB_MBrBlI4RsYbw",
    place: "Near Stoke, Nelson Region",
    shortName: "Stoke",
    countryCode: "NZ",
    country: "New Zealand",
    continent: "Oceania",
    difficulty: "classic",
    pools: ["world","Oceania","NZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nz-029",
    lat: -37.958474,
    lng: 176.985433,
    panoId: "yYDEfkP_D98xDOmCdzrhVQ",
    place: "Near Whakatane, Bay of Plenty",
    shortName: "Whakatane",
    countryCode: "NZ",
    country: "New Zealand",
    continent: "Oceania",
    difficulty: "classic",
    pools: ["world","Oceania","NZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nz-030",
    lat: -37.783726,
    lng: 175.282483,
    panoId: "uAqsTPdamaiKPYGYt43CnQ",
    place: "Near Hamilton, Waikato Region",
    shortName: "Hamilton",
    countryCode: "NZ",
    country: "New Zealand",
    continent: "Oceania",
    difficulty: "classic",
    pools: ["world","Oceania","NZ"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "nz-031",
    lat: -43.583266,
    lng: 172.383554,
    panoId: "ONHoEGMKICLR8bJ0p5Eqpw",
    place: "Near Rolleston, Canterbury",
    shortName: "Rolleston",
    countryCode: "NZ",
    country: "New Zealand",
    continent: "Oceania",
    difficulty: "classic",
    pools: ["world","Oceania","NZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nz-032",
    lat: -39.933201,
    lng: 175.050076,
    panoId: "asQCnw8P_fSLbiZZES7DXQ",
    place: "Near Whanganui, Manawatu-Wanganui",
    shortName: "Whanganui",
    countryCode: "NZ",
    country: "New Zealand",
    continent: "Oceania",
    difficulty: "classic",
    pools: ["world","Oceania","NZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nz-033",
    lat: -35.73154,
    lng: 174.32412,
    panoId: "rFvuA_f9-3WaEvgwwTx_iQ",
    place: "Near Whangarei, Northland",
    shortName: "Whangarei",
    countryCode: "NZ",
    country: "New Zealand",
    continent: "Oceania",
    difficulty: "classic",
    pools: ["world","Oceania","NZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nz-034",
    lat: -41.286489,
    lng: 174.775386,
    panoId: "t3pArq1Oxz0pnMQrRaaHiQ",
    place: "Near Wellington, Wellington Region",
    shortName: "Wellington",
    countryCode: "NZ",
    country: "New Zealand",
    continent: "Oceania",
    difficulty: "classic",
    pools: ["world","Oceania","NZ"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "nz-035",
    lat: -39.492661,
    lng: 176.912315,
    panoId: "tooG93BBmQ-MS9K5HXRGVg",
    place: "Near Napier, Hawke's Bay Region",
    shortName: "Napier",
    countryCode: "NZ",
    country: "New Zealand",
    continent: "Oceania",
    difficulty: "classic",
    pools: ["world","Oceania","NZ"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "nz-036",
    lat: -38.233058,
    lng: 175.866832,
    panoId: "MXXhWJ60o0vwde6DjmFBCQ",
    place: "Near Tokoroa, Waikato Region",
    shortName: "Tokoroa",
    countryCode: "NZ",
    country: "New Zealand",
    continent: "Oceania",
    difficulty: "classic",
    pools: ["world","Oceania","NZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nz-037",
    lat: -38.008171,
    lng: 175.330517,
    panoId: "eG-FbzatKs6gpsEZcanLzw",
    place: "Near Te Awamutu, Waikato Region",
    shortName: "Te Awamutu",
    countryCode: "NZ",
    country: "New Zealand",
    continent: "Oceania",
    difficulty: "classic",
    pools: ["world","Oceania","NZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nz-038",
    lat: -45.874957,
    lng: 170.347176,
    panoId: "07nPyXb69FufQSgFo-WcOw",
    place: "Near Mosgiel, Otago",
    shortName: "Mosgiel",
    countryCode: "NZ",
    country: "New Zealand",
    continent: "Oceania",
    difficulty: "classic",
    pools: ["world","Oceania","NZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nz-039",
    lat: -43.378497,
    lng: 172.639806,
    panoId: "ibuCF_CokFJVAR8iDpU_YQ",
    place: "Near Kaiapoi, Canterbury",
    shortName: "Kaiapoi",
    countryCode: "NZ",
    country: "New Zealand",
    continent: "Oceania",
    difficulty: "classic",
    pools: ["world","Oceania","NZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nz-040",
    lat: -43.891496,
    lng: 171.710912,
    panoId: "B9g0WWAgShy65HtRGja8CQ",
    place: "Near Ashburton, Canterbury",
    shortName: "Ashburton",
    countryCode: "NZ",
    country: "New Zealand",
    continent: "Oceania",
    difficulty: "classic",
    pools: ["world","Oceania","NZ"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "nz-041",
    lat: -35.750618,
    lng: 174.320894,
    panoId: "lyXgE_BTUJjOdFrJgnFMMA",
    place: "Near Raumanga, Northland",
    shortName: "Raumanga",
    countryCode: "NZ",
    country: "New Zealand",
    continent: "Oceania",
    difficulty: "classic",
    pools: ["world","Oceania","NZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nz-042",
    lat: -43.58197,
    lng: 172.400442,
    panoId: "cUnY9llUQBAXWo5vSj79rA",
    place: "Near Rolleston, Canterbury",
    shortName: "Rolleston",
    countryCode: "NZ",
    country: "New Zealand",
    continent: "Oceania",
    difficulty: "classic",
    pools: ["world","Oceania","NZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nz-043",
    lat: -39.477571,
    lng: 176.914038,
    panoId: "YXOkh87-koEB0Q_Olb3FkQ",
    place: "Near Napier, Hawke's Bay Region",
    shortName: "Napier",
    countryCode: "NZ",
    country: "New Zealand",
    continent: "Oceania",
    difficulty: "classic",
    pools: ["world","Oceania","NZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nz-044",
    lat: -41.237213,
    lng: 174.920567,
    panoId: "FUZX2q1w2GSGgdMmumxA0A",
    place: "Near Parkway, Wellington Region",
    shortName: "Parkway",
    countryCode: "NZ",
    country: "New Zealand",
    continent: "Oceania",
    difficulty: "classic",
    pools: ["world","Oceania","NZ"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "nz-045",
    lat: -38.131097,
    lng: 176.254984,
    panoId: "P0czG5PV5uMlxb6p1iCPmw",
    place: "Near Rotorua, Bay of Plenty",
    shortName: "Rotorua",
    countryCode: "NZ",
    country: "New Zealand",
    continent: "Oceania",
    difficulty: "classic",
    pools: ["world","Oceania","NZ"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "nz-046",
    lat: -41.251495,
    lng: 174.948862,
    panoId: "oy3eiMIVQDsk9Sgfeoqy0w",
    place: "Near Glendale, Wellington Region",
    shortName: "Glendale",
    countryCode: "NZ",
    country: "New Zealand",
    continent: "Oceania",
    difficulty: "classic",
    pools: ["world","Oceania","NZ"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "nz-047",
    lat: -43.307706,
    lng: 172.562187,
    panoId: "DxmT4v6hrcNu198cK0nrNg",
    place: "Near Rangiora, Canterbury",
    shortName: "Rangiora",
    countryCode: "NZ",
    country: "New Zealand",
    continent: "Oceania",
    difficulty: "classic",
    pools: ["world","Oceania","NZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nz-048",
    lat: -37.194553,
    lng: 174.974198,
    panoId: "Phn7vwaqrTrH-KzepehMJA",
    place: "Near Pukekohe East, Auckland",
    shortName: "Pukekohe East",
    countryCode: "NZ",
    country: "New Zealand",
    continent: "Oceania",
    difficulty: "classic",
    pools: ["world","Oceania","NZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nz-049",
    lat: -39.944705,
    lng: 175.045738,
    panoId: "PVFpRhQnj_vyor8eUnkw0w",
    place: "Near Whanganui, Manawatu-Wanganui",
    shortName: "Whanganui",
    countryCode: "NZ",
    country: "New Zealand",
    continent: "Oceania",
    difficulty: "classic",
    pools: ["world","Oceania","NZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nz-050",
    lat: -46.367903,
    lng: 168.393249,
    panoId: "5Qb2RNPLNxI7UcpYkCepaA",
    place: "Near Rosedale, Southland",
    shortName: "Rosedale",
    countryCode: "NZ",
    country: "New Zealand",
    continent: "Oceania",
    difficulty: "explorer",
    pools: ["world","Oceania","NZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nz-051",
    lat: -41.130871,
    lng: 174.960475,
    panoId: "zIqUXlxnQ4xmqE7MRkKVXw",
    place: "Near Judgeford, Wellington Region",
    shortName: "Judgeford",
    countryCode: "NZ",
    country: "New Zealand",
    continent: "Oceania",
    difficulty: "explorer",
    pools: ["world","Oceania","NZ"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "nz-052",
    lat: -43.941596,
    lng: 171.742398,
    panoId: "GlWYoOwSpcWboB8XvU_NcQ",
    place: "Near Tinwald, Canterbury",
    shortName: "Tinwald",
    countryCode: "NZ",
    country: "New Zealand",
    continent: "Oceania",
    difficulty: "explorer",
    pools: ["world","Oceania","NZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nz-053",
    lat: -44.411117,
    lng: 171.183523,
    panoId: "rTHVMEjhWuDJnuw09cRkXw",
    place: "Near Gleniti, Canterbury",
    shortName: "Gleniti",
    countryCode: "NZ",
    country: "New Zealand",
    continent: "Oceania",
    difficulty: "explorer",
    pools: ["world","Oceania","NZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nz-054",
    lat: -43.533713,
    lng: 172.444287,
    panoId: "IYYrtlQHFTqlFqKJEgDVjA",
    place: "Near Templeton, Canterbury",
    shortName: "Templeton",
    countryCode: "NZ",
    country: "New Zealand",
    continent: "Oceania",
    difficulty: "explorer",
    pools: ["world","Oceania","NZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nz-055",
    lat: -45.900705,
    lng: 170.376862,
    panoId: "pCk5fmiLmGMg_OUO8NSU5w",
    place: "Near Fairfield, Otago",
    shortName: "Fairfield",
    countryCode: "NZ",
    country: "New Zealand",
    continent: "Oceania",
    difficulty: "explorer",
    pools: ["world","Oceania","NZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nz-056",
    lat: -38.612519,
    lng: 178.023525,
    panoId: "rEpoyWuFTesJD5H94X8EUw",
    place: "Near Mangapapa, Gisborne",
    shortName: "Mangapapa",
    countryCode: "NZ",
    country: "New Zealand",
    continent: "Oceania",
    difficulty: "explorer",
    pools: ["world","Oceania","NZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nz-057",
    lat: -43.337972,
    lng: 172.622013,
    panoId: "YbXKracosqiGKj9O_o8qaw",
    place: "Near Woodend, Canterbury",
    shortName: "Woodend",
    countryCode: "NZ",
    country: "New Zealand",
    continent: "Oceania",
    difficulty: "explorer",
    pools: ["world","Oceania","NZ"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "nz-058",
    lat: -40.331245,
    lng: 175.693677,
    panoId: "6BtdBvIPPMlItjA3cZ4_Uw",
    place: "Near Whakarongo, Manawatu-Wanganui",
    shortName: "Whakarongo",
    countryCode: "NZ",
    country: "New Zealand",
    continent: "Oceania",
    difficulty: "explorer",
    pools: ["world","Oceania","NZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nz-059",
    lat: -46.450442,
    lng: 168.282618,
    panoId: "4SwdDoKD87fSKSphLp3koA",
    place: "Near Otatara, Southland",
    shortName: "Otatara",
    countryCode: "NZ",
    country: "New Zealand",
    continent: "Oceania",
    difficulty: "explorer",
    pools: ["world","Oceania","NZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nz-060",
    lat: -45.908388,
    lng: 170.433212,
    panoId: "sXQDueBqARKrSfPKpwuHew",
    place: "Near Concord, Otago",
    shortName: "Concord",
    countryCode: "NZ",
    country: "New Zealand",
    continent: "Oceania",
    difficulty: "explorer",
    pools: ["world","Oceania","NZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nz-061",
    lat: -35.696175,
    lng: 174.402909,
    panoId: "SMHcF5b1uH4T19mxIXY0pw",
    place: "Near Tikipunga, Northland",
    shortName: "Tikipunga",
    countryCode: "NZ",
    country: "New Zealand",
    continent: "Oceania",
    difficulty: "explorer",
    pools: ["world","Oceania","NZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nz-062",
    lat: -39.539085,
    lng: 176.887414,
    panoId: "mpoicYVWfyn4DgtkWFgnwg",
    place: "Near Taradale, Hawke's Bay Region",
    shortName: "Taradale",
    countryCode: "NZ",
    country: "New Zealand",
    continent: "Oceania",
    difficulty: "explorer",
    pools: ["world","Oceania","NZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nz-063",
    lat: -40.573477,
    lng: 175.313706,
    panoId: "aS7hlKBm0wLtwswJwL8sMg",
    place: "Near Levin, Manawatu-Wanganui",
    shortName: "Levin",
    countryCode: "NZ",
    country: "New Zealand",
    continent: "Oceania",
    difficulty: "explorer",
    pools: ["world","Oceania","NZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nz-064",
    lat: -41.322683,
    lng: 173.130209,
    panoId: "fgL1GrS2WRGEnH5ujn9DFw",
    place: "Near Richmond, Tasman District",
    shortName: "Richmond",
    countryCode: "NZ",
    country: "New Zealand",
    continent: "Oceania",
    difficulty: "explorer",
    pools: ["world","Oceania","NZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nz-065",
    lat: -38.029128,
    lng: 175.250495,
    panoId: "VY9IuRbDRQwK3ssl8RLsdA",
    place: "Near Pirongia, Waikato Region",
    shortName: "Pirongia",
    countryCode: "NZ",
    country: "New Zealand",
    continent: "Oceania",
    difficulty: "explorer",
    pools: ["world","Oceania","NZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nz-066",
    lat: -41.108663,
    lng: 175.085352,
    panoId: "hC8HSRSnUhaoxBMSihvZiA",
    place: "Near Maoribank, Wellington Region",
    shortName: "Maoribank",
    countryCode: "NZ",
    country: "New Zealand",
    continent: "Oceania",
    difficulty: "explorer",
    pools: ["world","Oceania","NZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nz-067",
    lat: -46.140029,
    lng: 168.954427,
    panoId: "ykLYhNMBCfGDKzuPWdOCpQ",
    place: "Near Gore, Southland",
    shortName: "Gore",
    countryCode: "NZ",
    country: "New Zealand",
    continent: "Oceania",
    difficulty: "explorer",
    pools: ["world","Oceania","NZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nz-068",
    lat: -37.785158,
    lng: 175.226465,
    panoId: "duJs0JZC5QGwZzhBWRZhrg",
    place: "Near Hamilton West, Waikato Region",
    shortName: "Hamilton West",
    countryCode: "NZ",
    country: "New Zealand",
    continent: "Oceania",
    difficulty: "explorer",
    pools: ["world","Oceania","NZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nz-069",
    lat: -45.927674,
    lng: 170.31341,
    panoId: "wP6ciFuBXNuVN60k-v-KNw",
    place: "Near Brighton, Otago",
    shortName: "Brighton",
    countryCode: "NZ",
    country: "New Zealand",
    continent: "Oceania",
    difficulty: "explorer",
    pools: ["world","Oceania","NZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nz-070",
    lat: -39.600605,
    lng: 176.908568,
    panoId: "UglAuHnQDa8MM_7M7u73Yg",
    place: "Near Clive, Hawke's Bay Region",
    shortName: "Clive",
    countryCode: "NZ",
    country: "New Zealand",
    continent: "Oceania",
    difficulty: "explorer",
    pools: ["world","Oceania","NZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nz-071",
    lat: -37.966771,
    lng: 177.030702,
    panoId: "zCEN10sgCWf_QDGEi8kedQ",
    place: "Near Ohope Beach, Bay of Plenty",
    shortName: "Ohope Beach",
    countryCode: "NZ",
    country: "New Zealand",
    continent: "Oceania",
    difficulty: "explorer",
    pools: ["world","Oceania","NZ"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "nz-072",
    lat: -41.468199,
    lng: 173.92694,
    panoId: "LszKwH7FdItuoV7bBt-RUQ",
    place: "Near Rapaura, Marlborough",
    shortName: "Rapaura",
    countryCode: "NZ",
    country: "New Zealand",
    continent: "Oceania",
    difficulty: "explorer",
    pools: ["world","Oceania","NZ"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "nz-073",
    lat: -37.857274,
    lng: 175.409978,
    panoId: "g3adyksxJHxx_iy9-GCczg",
    place: "Near Cambridge, Waikato Region",
    shortName: "Cambridge",
    countryCode: "NZ",
    country: "New Zealand",
    continent: "Oceania",
    difficulty: "explorer",
    pools: ["world","Oceania","NZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nz-074",
    lat: -38.169563,
    lng: 175.856087,
    panoId: "LxuJVfDcPthvsOWAdsIMBg",
    place: "Near Tokoroa, Waikato Region",
    shortName: "Tokoroa",
    countryCode: "NZ",
    country: "New Zealand",
    continent: "Oceania",
    difficulty: "explorer",
    pools: ["world","Oceania","NZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nz-075",
    lat: -45.102711,
    lng: 170.87691,
    panoId: "wUDACI1v7wKg2ENLBH6fCA",
    place: "Near Weston, Otago",
    shortName: "Weston",
    countryCode: "NZ",
    country: "New Zealand",
    continent: "Oceania",
    difficulty: "explorer",
    pools: ["world","Oceania","NZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nz-076",
    lat: -43.401124,
    lng: 172.574296,
    panoId: "ge8T1dCjWj557eSeKGg1gQ",
    place: "Near Clarkville, Canterbury",
    shortName: "Clarkville",
    countryCode: "NZ",
    country: "New Zealand",
    continent: "Oceania",
    difficulty: "explorer",
    pools: ["world","Oceania","NZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nz-077",
    lat: -44.698221,
    lng: 169.190249,
    panoId: "6cI1Qfd5DkhRVCdD2tZq9g",
    place: "Near Wanaka, Otago",
    shortName: "Wanaka",
    countryCode: "NZ",
    country: "New Zealand",
    continent: "Oceania",
    difficulty: "explorer",
    pools: ["world","Oceania","NZ"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "nz-078",
    lat: -43.269299,
    lng: 172.596792,
    panoId: "rsmH81pzvn_4Zq3ld17ObA",
    place: "Near Rangiora, Canterbury",
    shortName: "Rangiora",
    countryCode: "NZ",
    country: "New Zealand",
    continent: "Oceania",
    difficulty: "explorer",
    pools: ["world","Oceania","NZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nz-079",
    lat: -37.821784,
    lng: 176.292444,
    panoId: "tLN2l_QPbMts4sreqc47Iw",
    place: "Near Te Puke, Bay of Plenty",
    shortName: "Te Puke",
    countryCode: "NZ",
    country: "New Zealand",
    continent: "Oceania",
    difficulty: "explorer",
    pools: ["world","Oceania","NZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nz-080",
    lat: -41.290364,
    lng: 173.344479,
    panoId: "doHxzeaw4LBgX08LBkuOlg",
    place: "Near Nelson, Nelson Region",
    shortName: "Nelson",
    countryCode: "NZ",
    country: "New Zealand",
    continent: "Oceania",
    difficulty: "explorer",
    pools: ["world","Oceania","NZ"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "nz-081",
    lat: -40.660036,
    lng: 175.357388,
    panoId: "iEB3YnIYP57jUX8kfV0mUw",
    place: "Near Levin, Manawatu-Wanganui",
    shortName: "Levin",
    countryCode: "NZ",
    country: "New Zealand",
    continent: "Oceania",
    difficulty: "explorer",
    pools: ["world","Oceania","NZ"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "nz-082",
    lat: -38.665841,
    lng: 176.049993,
    panoId: "sW2PDHT16o7-BXDa2dZGZw",
    place: "Near Taupo, Waikato Region",
    shortName: "Taupo",
    countryCode: "NZ",
    country: "New Zealand",
    continent: "Oceania",
    difficulty: "explorer",
    pools: ["world","Oceania","NZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nz-083",
    lat: -39.89615,
    lng: 175.102076,
    panoId: "B5BahEniiqa64AMlF0fIeQ",
    place: "Near Whanganui, Manawatu-Wanganui",
    shortName: "Whanganui",
    countryCode: "NZ",
    country: "New Zealand",
    continent: "Oceania",
    difficulty: "explorer",
    pools: ["world","Oceania","NZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nz-084",
    lat: -37.677801,
    lng: 175.574912,
    panoId: "Wg8OwN1BkHf_HLiUKy3DPg",
    place: "Near Morrinsville, Waikato Region",
    shortName: "Morrinsville",
    countryCode: "NZ",
    country: "New Zealand",
    continent: "Oceania",
    difficulty: "explorer",
    pools: ["world","Oceania","NZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nz-085",
    lat: -39.572386,
    lng: 174.316895,
    panoId: "IWhCa8XTZFFQi2Tn6BLHrg",
    place: "Near Hawera, Taranaki Region",
    shortName: "Hawera",
    countryCode: "NZ",
    country: "New Zealand",
    continent: "Oceania",
    difficulty: "explorer",
    pools: ["world","Oceania","NZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nz-086",
    lat: -37.816912,
    lng: 175.227622,
    panoId: "O244dmcR9Wr94Ojcd724xA",
    place: "Near Temple View, Waikato Region",
    shortName: "Temple View",
    countryCode: "NZ",
    country: "New Zealand",
    continent: "Oceania",
    difficulty: "explorer",
    pools: ["world","Oceania","NZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nz-087",
    lat: -38.066349,
    lng: 176.105267,
    panoId: "vwP1MOu8Sw54JSiJVbFHCw",
    place: "Near Ngongotaha, Bay of Plenty",
    shortName: "Ngongotaha",
    countryCode: "NZ",
    country: "New Zealand",
    continent: "Oceania",
    difficulty: "explorer",
    pools: ["world","Oceania","NZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nz-088",
    lat: -41.118909,
    lng: 175.101792,
    panoId: "EeFkbQkllXJpqyRT8Fk-0A",
    place: "Near Maoribank, Wellington Region",
    shortName: "Maoribank",
    countryCode: "NZ",
    country: "New Zealand",
    continent: "Oceania",
    difficulty: "explorer",
    pools: ["world","Oceania","NZ"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "nz-089",
    lat: -40.836379,
    lng: 175.089262,
    panoId: "vHaUbSA3oK6p8nMxUshjPA",
    place: "Near Waikanae, Wellington Region",
    shortName: "Waikanae",
    countryCode: "NZ",
    country: "New Zealand",
    continent: "Oceania",
    difficulty: "explorer",
    pools: ["world","Oceania","NZ"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "nz-090",
    lat: -41.340968,
    lng: 174.676839,
    panoId: "sUw_mS9rAMBnhY6MOzqLfA",
    place: "Near Owhiro Bay, Wellington Region",
    shortName: "Owhiro Bay",
    countryCode: "NZ",
    country: "New Zealand",
    continent: "Oceania",
    difficulty: "explorer",
    pools: ["world","Oceania","NZ"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "nz-091",
    lat: -40.985386,
    lng: 175.704611,
    panoId: "m0KY2zgaplHAd82ZAv5xeg",
    place: "Near Masterton, Wellington Region",
    shortName: "Masterton",
    countryCode: "NZ",
    country: "New Zealand",
    continent: "Oceania",
    difficulty: "explorer",
    pools: ["world","Oceania","NZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nz-092",
    lat: -43.507979,
    lng: 172.344182,
    panoId: "1pNW6C_S0cYrnyRewbzR1A",
    place: "Near West Melton, Canterbury",
    shortName: "West Melton",
    countryCode: "NZ",
    country: "New Zealand",
    continent: "Oceania",
    difficulty: "explorer",
    pools: ["world","Oceania","NZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nz-093",
    lat: -37.054861,
    lng: 175.072634,
    panoId: "G-h9CdznXecieD89gWM6-Q",
    place: "Near Clevedon, Auckland",
    shortName: "Clevedon",
    countryCode: "NZ",
    country: "New Zealand",
    continent: "Oceania",
    difficulty: "explorer",
    pools: ["world","Oceania","NZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nz-094",
    lat: -41.163121,
    lng: 173.00037,
    panoId: "fWdL4uaGgZabDsrZGqLjDA",
    place: "Near Motueka, Tasman District",
    shortName: "Motueka",
    countryCode: "NZ",
    country: "New Zealand",
    continent: "Oceania",
    difficulty: "explorer",
    pools: ["world","Oceania","NZ"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "nz-095",
    lat: -46.150357,
    lng: 168.983246,
    panoId: "yrt9lpbNsVBgiMGQYsNvqQ",
    place: "Near Gore, Southland",
    shortName: "Gore",
    countryCode: "NZ",
    country: "New Zealand",
    continent: "Oceania",
    difficulty: "explorer",
    pools: ["world","Oceania","NZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nz-096",
    lat: -41.133647,
    lng: 174.928984,
    panoId: "OLqmJkUuPwaglYQUpszmGw",
    place: "Near Judgeford, Wellington Region",
    shortName: "Judgeford",
    countryCode: "NZ",
    country: "New Zealand",
    continent: "Oceania",
    difficulty: "explorer",
    pools: ["world","Oceania","NZ"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "nz-097",
    lat: -43.504668,
    lng: 172.394502,
    panoId: "s5mrKShUUR4bAb2amVlzWA",
    place: "Near West Melton, Canterbury",
    shortName: "West Melton",
    countryCode: "NZ",
    country: "New Zealand",
    continent: "Oceania",
    difficulty: "explorer",
    pools: ["world","Oceania","NZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nz-098",
    lat: -39.091758,
    lng: 174.248012,
    panoId: "P4AQPSfZi5JWQMKNarUbtQ",
    place: "Near Inglewood, Taranaki Region",
    shortName: "Inglewood",
    countryCode: "NZ",
    country: "New Zealand",
    continent: "Oceania",
    difficulty: "explorer",
    pools: ["world","Oceania","NZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nz-099",
    lat: -44.977529,
    lng: 170.957439,
    panoId: "Mzs-IwF47o1mbi3Cjn4VgQ",
    place: "Near Weston, Otago",
    shortName: "Weston",
    countryCode: "NZ",
    country: "New Zealand",
    continent: "Oceania",
    difficulty: "explorer",
    pools: ["world","Oceania","NZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nz-100",
    lat: -38.007399,
    lng: 176.55388,
    panoId: "-7sJ7qSocOjFqqyD54vsMA",
    place: "Near Kawerau, Bay of Plenty",
    shortName: "Kawerau",
    countryCode: "NZ",
    country: "New Zealand",
    continent: "Oceania",
    difficulty: "adventurer",
    pools: ["world","Oceania","NZ"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "nz-101",
    lat: -39.84484,
    lng: 176.841895,
    panoId: "-nvdKE6Dzw2euaHCfJiKUQ",
    place: "Near Havelock North, Hawke's Bay Region",
    shortName: "Havelock North",
    countryCode: "NZ",
    country: "New Zealand",
    continent: "Oceania",
    difficulty: "adventurer",
    pools: ["world","Oceania","NZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nz-102",
    lat: -44.870459,
    lng: 169.300583,
    panoId: "XUEmdx727xDDV6zHhkmYdg",
    place: "Near Cromwell, Otago",
    shortName: "Cromwell",
    countryCode: "NZ",
    country: "New Zealand",
    continent: "Oceania",
    difficulty: "adventurer",
    pools: ["world","Oceania","NZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nz-103",
    lat: -43.751743,
    lng: 172.609294,
    panoId: "FG6BwRAno-WwsdMH8GOBhQ",
    place: "Near Lincoln, Canterbury",
    shortName: "Lincoln",
    countryCode: "NZ",
    country: "New Zealand",
    continent: "Oceania",
    difficulty: "adventurer",
    pools: ["world","Oceania","NZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nz-104",
    lat: -45.250733,
    lng: 170.795368,
    panoId: "Xbg3UAGaajSMsoVUOAcOqg",
    place: "Near Weston, Otago",
    shortName: "Weston",
    countryCode: "NZ",
    country: "New Zealand",
    continent: "Oceania",
    difficulty: "adventurer",
    pools: ["world","Oceania","NZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "nz-105",
    lat: -39.16023,
    lng: 174.299676,
    panoId: "A1odczwvqi4HoCOMycUP4Q",
    place: "Near Inglewood, Taranaki Region",
    shortName: "Inglewood",
    countryCode: "NZ",
    country: "New Zealand",
    continent: "Oceania",
    difficulty: "adventurer",
    pools: ["world","Oceania","NZ"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "za-000",
    lat: -33.925608,
    lng: 18.423498,
    panoId: "q5U38iNo1tMEthyrMs3hFQ",
    place: "Near Cape Town, Western Cape",
    shortName: "Cape Town",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "classic",
    pools: ["world","Africa","ZA"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "za-001",
    lat: -26.202275,
    lng: 28.043639,
    panoId: "a20ON71Go2LL8eLW3sDqTg",
    place: "Near Johannesburg, Gauteng",
    shortName: "Johannesburg",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "classic",
    pools: ["world","Africa","ZA"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "za-002",
    lat: -26.533267,
    lng: 27.850153,
    panoId: "jzdQoS0OoWiSsNK7KPFh6w",
    place: "Near Evaton, Gauteng",
    shortName: "Evaton",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "classic",
    pools: ["world","Africa","ZA"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "za-003",
    lat: -26.672683,
    lng: 27.92627,
    panoId: "l7UeQgqUcPW51C_sxoKQKA",
    place: "Near Vereeniging, Gauteng",
    shortName: "Vereeniging",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "classic",
    pools: ["world","Africa","ZA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "za-004",
    lat: -25.871374,
    lng: 29.233303,
    panoId: "iWS2vVsMyoWu72RHFdMv4Q",
    place: "Near Emalahleni, Mpumalanga",
    shortName: "Emalahleni",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "classic",
    pools: ["world","Africa","ZA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "za-005",
    lat: -26.852234,
    lng: 26.666792,
    panoId: "5m2tNpgducPEM2nmvxaWzA",
    place: "Near Klerksdorp, North West",
    shortName: "Klerksdorp",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "classic",
    pools: ["world","Africa","ZA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "za-006",
    lat: -29.61684,
    lng: 30.392479,
    panoId: "EA5uorCtjQWMM1Fyw65yrw",
    place: "Near Pietermaritzburg, KwaZulu-Natal",
    shortName: "Pietermaritzburg",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "classic",
    pools: ["world","Africa","ZA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "za-007",
    lat: -33.015648,
    lng: 27.911695,
    panoId: "Bg2jutaKMK0duWlnirT_nQ",
    place: "Near East London, Eastern Cape",
    shortName: "East London",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "classic",
    pools: ["world","Africa","ZA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "za-008",
    lat: -33.961113,
    lng: 25.614956,
    panoId: "Ua-hEHSPzbelLbw0sAEtSA",
    place: "Near Gqeberha, Eastern Cape",
    shortName: "Gqeberha",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "classic",
    pools: ["world","Africa","ZA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "za-009",
    lat: -26.36097,
    lng: 27.397766,
    panoId: "awZgLitp1XPxhOgFKtd3fA",
    place: "Near Carletonville, Gauteng",
    shortName: "Carletonville",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "classic",
    pools: ["world","Africa","ZA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "za-010",
    lat: -26.267911,
    lng: 27.85843,
    panoId: "WPC-luEyGTfxmXE9qKiAtw",
    place: "Near Soweto, Gauteng",
    shortName: "Soweto",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "classic",
    pools: ["world","Africa","ZA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "za-011",
    lat: -27.977606,
    lng: 26.736072,
    panoId: "hoBYqHuXwuVvZqZna38fKA",
    place: "Near Welkom, Free State",
    shortName: "Welkom",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "classic",
    pools: ["world","Africa","ZA"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "za-012",
    lat: -34.083999,
    lng: 18.821208,
    panoId: "rwT20nWNZd9yDMyYAJuSUQ",
    place: "Near Somerset West, Western Cape",
    shortName: "Somerset West",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "classic",
    pools: ["world","Africa","ZA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "za-013",
    lat: -27.757753,
    lng: 29.931603,
    panoId: "DcEBGJ0LOZZi-b2iWCak9w",
    place: "Near Newcastle, KwaZulu-Natal",
    shortName: "Newcastle",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "classic",
    pools: ["world","Africa","ZA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "za-014",
    lat: -31.588928,
    lng: 28.784056,
    panoId: "MgPlRNCq7q4ACSm74E497A",
    place: "Near Mthatha, Eastern Cape",
    shortName: "Mthatha",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "classic",
    pools: ["world","Africa","ZA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "za-015",
    lat: -25.744828,
    lng: 28.187919,
    panoId: "R5GkTSFZPm5UpGW0zphfMQ",
    place: "Near Pretoria, Gauteng",
    shortName: "Pretoria",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "classic",
    pools: ["world","Africa","ZA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "za-016",
    lat: -23.904401,
    lng: 29.469404,
    panoId: "CQhUpifPC85Iw2KK3kgpcQ",
    place: "Near Polokwane, Limpopo",
    shortName: "Polokwane",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "classic",
    pools: ["world","Africa","ZA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "za-017",
    lat: -25.775024,
    lng: 29.464579,
    panoId: "8PS8xv_md4GRzdAkPwLnYA",
    place: "Near Middelburg, Mpumalanga",
    shortName: "Middelburg",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "classic",
    pools: ["world","Africa","ZA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "za-018",
    lat: -32.847418,
    lng: 27.442509,
    panoId: "-Pt9296doqCCTj3u7xWXJg",
    place: "Near Bhisho, Eastern Cape",
    shortName: "Bhisho",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "classic",
    pools: ["world","Africa","ZA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "za-019",
    lat: -29.328185,
    lng: 31.289574,
    panoId: "Zkl-wNQSC5AM5pypy-rZ9g",
    place: "Near KwaDukuza, KwaZulu-Natal",
    shortName: "KwaDukuza",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "classic",
    pools: ["world","Africa","ZA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "za-020",
    lat: -28.732294,
    lng: 24.76264,
    panoId: "AWGfEtqcfOPBvzHUUd7RZg",
    place: "Near Kimberley, Northern Cape",
    shortName: "Kimberley",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "classic",
    pools: ["world","Africa","ZA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "za-021",
    lat: -26.71647,
    lng: 27.100067,
    panoId: "B4vpGt4ImnUcy53ZNV9LKg",
    place: "Near Potchefstroom, North West",
    shortName: "Potchefstroom",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "classic",
    pools: ["world","Africa","ZA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "za-022",
    lat: -25.667327,
    lng: 27.24182,
    panoId: "rKmha5JaIsoQ3NvFN3OuzA",
    place: "Near Rustenburg, North West",
    shortName: "Rustenburg",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "classic",
    pools: ["world","Africa","ZA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "za-023",
    lat: -25.996374,
    lng: 28.227004,
    panoId: "Z_J8fCOUynPPtkR9NuB2cg",
    place: "Near Thembisa, Gauteng",
    shortName: "Thembisa",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "classic",
    pools: ["world","Africa","ZA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "za-024",
    lat: -27.769617,
    lng: 30.79131,
    panoId: "l6a-hst7BsOHUZYBUoJyKw",
    place: "Near Vryheid, KwaZulu-Natal",
    shortName: "Vryheid",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "classic",
    pools: ["world","Africa","ZA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "za-025",
    lat: -33.733713,
    lng: 18.974649,
    panoId: "8xrVQ1T_v-xJOv4lg6vT5Q",
    place: "Near Paarl, Western Cape",
    shortName: "Paarl",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "classic",
    pools: ["world","Africa","ZA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "za-026",
    lat: -33.963055,
    lng: 22.46172,
    panoId: "paIzFIUloSdMwxfhq_7wmA",
    place: "Near George, Western Cape",
    shortName: "George",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "classic",
    pools: ["world","Africa","ZA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "za-027",
    lat: -28.780974,
    lng: 32.028934,
    panoId: "K4PWk1wemYkilpeTh-vTTw",
    place: "Near Richards Bay, KwaZulu-Natal",
    shortName: "Richards Bay",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "classic",
    pools: ["world","Africa","ZA"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "za-028",
    lat: -29.121394,
    lng: 26.212761,
    panoId: "25ZPKzeiQ_pjpgCtdy20sA",
    place: "Near Bloemfontein, Free State",
    shortName: "Bloemfontein",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "classic",
    pools: ["world","Africa","ZA"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "za-029",
    lat: -26.234506,
    lng: 28.177318,
    panoId: "AAThCDJmg6SDnSHsI4VTfQ",
    place: "Near Germiston, Gauteng",
    shortName: "Germiston",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "classic",
    pools: ["world","Africa","ZA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "za-030",
    lat: -26.188461,
    lng: 28.320711,
    panoId: "RSkQJym_m7efnd8uHIXMGQ",
    place: "Near Benoni, Gauteng",
    shortName: "Benoni",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "classic",
    pools: ["world","Africa","ZA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "za-031",
    lat: -29.857539,
    lng: 31.029077,
    panoId: "8Qgm1Q-ecVb5kcwLdi9SAg",
    place: "Near Durban, KwaZulu-Natal",
    shortName: "Durban",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "classic",
    pools: ["world","Africa","ZA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "za-032",
    lat: -29.267121,
    lng: 26.725936,
    panoId: "jTuc4neZiT1WFt26P9bWOQ",
    place: "Near Botshabelo, Free State",
    shortName: "Botshabelo",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "classic",
    pools: ["world","Africa","ZA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "za-033",
    lat: -32.932811,
    lng: 27.775478,
    panoId: "eBFHHJTBwO-byhAK8FfLjA",
    place: "Near Mdantsane, Eastern Cape",
    shortName: "Mdantsane",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "classic",
    pools: ["world","Africa","ZA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "za-034",
    lat: -25.472901,
    lng: 28.099088,
    panoId: "TbHzjv-nk-e-1WMHTv38-w",
    place: "Near Soshanguve, Gauteng",
    shortName: "Soshanguve",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "classic",
    pools: ["world","Africa","ZA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "za-035",
    lat: -26.533481,
    lng: 29.067014,
    panoId: "yeKP-7mIJvWXV8uNxPhOfw",
    place: "Near eMbalenhle, Mpumalanga",
    shortName: "eMbalenhle",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "classic",
    pools: ["world","Africa","ZA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "za-036",
    lat: -28.558687,
    lng: 29.778821,
    panoId: "oOx6BQOT3dk7goSmkUggGw",
    place: "Near Ladysmith, KwaZulu-Natal",
    shortName: "Ladysmith",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "classic",
    pools: ["world","Africa","ZA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "za-037",
    lat: -33.646665,
    lng: 19.448689,
    panoId: "8r7mxXLqFGJ9bfVYxBxr5g",
    place: "Near Worcester, Western Cape",
    shortName: "Worcester",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "classic",
    pools: ["world","Africa","ZA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "za-038",
    lat: -28.772026,
    lng: 32.046503,
    panoId: "hpDYD9hcHaFxOtnLWwGeJg",
    place: "Near Richards Bay, KwaZulu-Natal",
    shortName: "Richards Bay",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "classic",
    pools: ["world","Africa","ZA"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "za-039",
    lat: -27.750467,
    lng: 29.953916,
    panoId: "tLGY83CmSEjx4K8f8UpQHw",
    place: "Near Newcastle, KwaZulu-Natal",
    shortName: "Newcastle",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "classic",
    pools: ["world","Africa","ZA"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "za-040",
    lat: -28.566147,
    lng: 29.762843,
    panoId: "Pi-IDH2lquNiZ_taSSwrhw",
    place: "Near Ladysmith, KwaZulu-Natal",
    shortName: "Ladysmith",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "classic",
    pools: ["world","Africa","ZA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "za-041",
    lat: -29.142604,
    lng: 26.20531,
    panoId: "muQsnAz9mzPaKld0XN7EeQ",
    place: "Near Bloemfontein, Free State",
    shortName: "Bloemfontein",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "classic",
    pools: ["world","Africa","ZA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "za-042",
    lat: -31.604776,
    lng: 28.796431,
    panoId: "L_9tcIIF9dvekXvQlpAuqw",
    place: "Near Mthatha, Eastern Cape",
    shortName: "Mthatha",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "classic",
    pools: ["world","Africa","ZA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "za-043",
    lat: -26.548937,
    lng: 29.065417,
    panoId: "FwdUxskFnzyCaEXlbAz9xg",
    place: "Near eMbalenhle, Mpumalanga",
    shortName: "eMbalenhle",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "classic",
    pools: ["world","Africa","ZA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "za-044",
    lat: -32.922799,
    lng: 27.769897,
    panoId: "yCnJ6p4Pk0TX_jF8mNDD5g",
    place: "Near Mdantsane, Eastern Cape",
    shortName: "Mdantsane",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "classic",
    pools: ["world","Africa","ZA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "za-045",
    lat: -33.959052,
    lng: 25.599249,
    panoId: "snB0u0hP7NLRhjTNxl5BNA",
    place: "Near Gqeberha, Eastern Cape",
    shortName: "Gqeberha",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "classic",
    pools: ["world","Africa","ZA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "za-046",
    lat: -23.883516,
    lng: 29.472629,
    panoId: "8F8kN8QvvdRO2-gw9flUSg",
    place: "Near Polokwane, Limpopo",
    shortName: "Polokwane",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "classic",
    pools: ["world","Africa","ZA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "za-047",
    lat: -26.697484,
    lng: 27.088527,
    panoId: "6Bnne0GO0elqjSzO8caKtQ",
    place: "Near Potchefstroom, North West",
    shortName: "Potchefstroom",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "classic",
    pools: ["world","Africa","ZA"],
    qualityTier: 2,
    verified: true,
  },
  {
    id: "za-048",
    lat: -29.2805,
    lng: 26.719646,
    panoId: "_FmMPmqcQr-En0paSJDY6w",
    place: "Near Botshabelo, Free State",
    shortName: "Botshabelo",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "classic",
    pools: ["world","Africa","ZA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "za-049",
    lat: -34.077938,
    lng: 18.829912,
    panoId: "I49vcMhLRFEiQkpBZ8lEtw",
    place: "Near Somerset West, Western Cape",
    shortName: "Somerset West",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "classic",
    pools: ["world","Africa","ZA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "za-050",
    lat: -25.514928,
    lng: 28.127847,
    panoId: "9lVLr94oEtt3ooTFg4hC_A",
    place: "Near Soshanguve, Gauteng",
    shortName: "Soshanguve",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "explorer",
    pools: ["world","Africa","ZA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "za-051",
    lat: -26.206228,
    lng: 27.774601,
    panoId: "fcTZZpTtmepoMe5xxjNK8g",
    place: "Near Randfontein, Gauteng",
    shortName: "Randfontein",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "explorer",
    pools: ["world","Africa","ZA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "za-052",
    lat: -26.376325,
    lng: 27.459514,
    panoId: "mfPFD8Y1MO1jMCfhQtokUA",
    place: "Near Carletonville, Gauteng",
    shortName: "Carletonville",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "explorer",
    pools: ["world","Africa","ZA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "za-053",
    lat: -29.583655,
    lng: 30.330821,
    panoId: "skvhitnJcbmFJi2f68TK-A",
    place: "Near Hilton, KwaZulu-Natal",
    shortName: "Hilton",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "explorer",
    pools: ["world","Africa","ZA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "za-054",
    lat: -26.723067,
    lng: 27.92323,
    panoId: "9k3da2M3qGdL3VSU380ecg",
    place: "Near Bertha Shaft Village, Free State",
    shortName: "Bertha Shaft Village",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "explorer",
    pools: ["world","Africa","ZA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "za-055",
    lat: -26.513808,
    lng: 27.897532,
    panoId: "DxuUIDeyEK16H79KXF0yxw",
    place: "Near Orange Farm, Gauteng",
    shortName: "Orange Farm",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "explorer",
    pools: ["world","Africa","ZA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "za-056",
    lat: -29.838816,
    lng: 30.957281,
    panoId: "NzVhqsxy1QZVdMwcfV9Pjw",
    place: "Near Berea, KwaZulu-Natal",
    shortName: "Berea",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "explorer",
    pools: ["world","Africa","ZA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "za-057",
    lat: -26.150047,
    lng: 28.368198,
    panoId: "Ris9cgSbFv716KscGjPZqQ",
    place: "Near Benoni, Gauteng",
    shortName: "Benoni",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "explorer",
    pools: ["world","Africa","ZA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "za-058",
    lat: -29.370442,
    lng: 31.352079,
    panoId: "b448RpwCbE7HyXKFxMp0Ew",
    place: "Near KwaDukuza, KwaZulu-Natal",
    shortName: "KwaDukuza",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "explorer",
    pools: ["world","Africa","ZA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "za-059",
    lat: -26.022144,
    lng: 28.159555,
    panoId: "7oaK_9QtvZwlyxhYnH6KKA",
    place: "Near Ivory Park, Gauteng",
    shortName: "Ivory Park",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "explorer",
    pools: ["world","Africa","ZA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "za-060",
    lat: -32.961744,
    lng: 27.808465,
    panoId: "y13oWZsuvClpkGMglFwYKg",
    place: "Near Mdantsane, Eastern Cape",
    shortName: "Mdantsane",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "explorer",
    pools: ["world","Africa","ZA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "za-061",
    lat: -28.76377,
    lng: 32.116107,
    panoId: "U1raaNC2HmWff03GCsz3qA",
    place: "Near Richards Bay, KwaZulu-Natal",
    shortName: "Richards Bay",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "explorer",
    pools: ["world","Africa","ZA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "za-062",
    lat: -26.911091,
    lng: 26.643151,
    panoId: "qwL3aNR6w35ceW_fPGhD2w",
    place: "Near Klerksdorp, North West",
    shortName: "Klerksdorp",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "explorer",
    pools: ["world","Africa","ZA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "za-063",
    lat: -25.886716,
    lng: 29.206599,
    panoId: "41enRMjF_tI32RWHz-fdPg",
    place: "Near Emalahleni, Mpumalanga",
    shortName: "Emalahleni",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "explorer",
    pools: ["world","Africa","ZA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "za-064",
    lat: -32.816217,
    lng: 27.460257,
    panoId: "DMQTIXxE02AA933ZwDf9wg",
    place: "Near Hanover, Eastern Cape",
    shortName: "Hanover",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "explorer",
    pools: ["world","Africa","ZA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "za-065",
    lat: -29.566793,
    lng: 30.412939,
    panoId: "iKQSFVjwDnEzkIOg2V5hrg",
    place: "Near Pietermaritzburg, KwaZulu-Natal",
    shortName: "Pietermaritzburg",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "explorer",
    pools: ["world","Africa","ZA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "za-066",
    lat: -29.17889,
    lng: 26.168024,
    panoId: "dcXDqUYH0dkDO1hxq9-QZg",
    place: "Near Bloemfontein, Free State",
    shortName: "Bloemfontein",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "explorer",
    pools: ["world","Africa","ZA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "za-067",
    lat: -25.846071,
    lng: 29.467094,
    panoId: "__BXB1bce0A7iTFWgL0wIg",
    place: "Near Middelburg, Mpumalanga",
    shortName: "Middelburg",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "explorer",
    pools: ["world","Africa","ZA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "za-068",
    lat: -29.247589,
    lng: 26.67085,
    panoId: "sJjOYZT70S9pJ9dETKtDGA",
    place: "Near Botshabelo, Free State",
    shortName: "Botshabelo",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "explorer",
    pools: ["world","Africa","ZA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "za-069",
    lat: -26.428086,
    lng: 28.189894,
    panoId: "UmsGT1u7NnSqb_0-8f8p0A",
    place: "Near Randvaal, Gauteng",
    shortName: "Randvaal",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "explorer",
    pools: ["world","Africa","ZA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "za-070",
    lat: -29.910999,
    lng: 31.030671,
    panoId: "qauUNK-v7OTzgmyHg7NSJQ",
    place: "Near Durban, KwaZulu-Natal",
    shortName: "Durban",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "explorer",
    pools: ["world","Africa","ZA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "za-071",
    lat: -27.701606,
    lng: 27.254795,
    panoId: "wnAO4aREzmJA8Mr5-29rtw",
    place: "Near Kroonstad, Free State",
    shortName: "Kroonstad",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "explorer",
    pools: ["world","Africa","ZA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "za-072",
    lat: -33.630935,
    lng: 19.421368,
    panoId: "TylpbQt2L8xJG8gMQ72BWw",
    place: "Near Worcester, Western Cape",
    shortName: "Worcester",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "explorer",
    pools: ["world","Africa","ZA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "za-073",
    lat: -29.26889,
    lng: 31.315233,
    panoId: "eHB4IXzhxhYkPfM8aDApPw",
    place: "Near Darnall, KwaZulu-Natal",
    shortName: "Darnall",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "explorer",
    pools: ["world","Africa","ZA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "za-074",
    lat: -26.785493,
    lng: 26.681005,
    panoId: "UJvl9LD6AGI6bNz2Lr76IQ",
    place: "Near Klerksdorp, North West",
    shortName: "Klerksdorp",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "explorer",
    pools: ["world","Africa","ZA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "za-075",
    lat: -25.859044,
    lng: 29.16792,
    panoId: "6KMTEfqsvKB3x0YWK74ubg",
    place: "Near Emalahleni, Mpumalanga",
    shortName: "Emalahleni",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "explorer",
    pools: ["world","Africa","ZA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "za-076",
    lat: -26.268377,
    lng: 27.761127,
    panoId: "FzKVBLtiEtZuqhaFVVlK_g",
    place: "Near Soweto, Gauteng",
    shortName: "Soweto",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "explorer",
    pools: ["world","Africa","ZA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "za-077",
    lat: -25.472044,
    lng: 30.920897,
    panoId: "NtXbb3jqoDiXnyJDPVYo2A",
    place: "Near Mbombela, Mpumalanga",
    shortName: "Mbombela",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "explorer",
    pools: ["world","Africa","ZA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "za-078",
    lat: -25.714382,
    lng: 27.258091,
    panoId: "VNNm1Jv-4BOhHMGAuaJFVQ",
    place: "Near Rustenburg, North West",
    shortName: "Rustenburg",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "explorer",
    pools: ["world","Africa","ZA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "za-079",
    lat: -26.6195,
    lng: 27.79978,
    panoId: "NUFPVgno1gK8YedAeY-yDw",
    place: "Near Evaton, Gauteng",
    shortName: "Evaton",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "explorer",
    pools: ["world","Africa","ZA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "za-080",
    lat: -28.784183,
    lng: 24.730168,
    panoId: "2_NPZ_h0lIRTgtxoh9Tj2Q",
    place: "Near Kimberley, Northern Cape",
    shortName: "Kimberley",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "explorer",
    pools: ["world","Africa","ZA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "za-081",
    lat: -26.236875,
    lng: 27.825883,
    panoId: "PoEUEHXCSf07myNB2nTJTQ",
    place: "Near Soweto, Gauteng",
    shortName: "Soweto",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "explorer",
    pools: ["world","Africa","ZA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "za-082",
    lat: -26.511248,
    lng: 30.047636,
    panoId: "sQ3wPaEaD7JliinIaVeQ2A",
    place: "Near Ermelo, Mpumalanga",
    shortName: "Ermelo",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "explorer",
    pools: ["world","Africa","ZA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "za-083",
    lat: -26.981091,
    lng: 26.741169,
    panoId: "OsSgTHlR8qdztLNMQqljFA",
    place: "Near Umzimhle, North West",
    shortName: "Umzimhle",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "explorer",
    pools: ["world","Africa","ZA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "za-084",
    lat: -26.330732,
    lng: 28.111188,
    panoId: "4FvONs_SdNQmvS3licX2ug",
    place: "Near Tokoza, Gauteng",
    shortName: "Tokoza",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "explorer",
    pools: ["world","Africa","ZA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "za-085",
    lat: -26.75545,
    lng: 27.821006,
    panoId: "ySFOU6zh7wLgeNc0q6NM2A",
    place: "Near Vanderbijlpark, Gauteng",
    shortName: "Vanderbijlpark",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "explorer",
    pools: ["world","Africa","ZA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "za-086",
    lat: -26.021185,
    lng: 28.297066,
    panoId: "yVs86mkhMMLz31ezosCOsg",
    place: "Near Thembisa, Gauteng",
    shortName: "Thembisa",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "explorer",
    pools: ["world","Africa","ZA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "za-087",
    lat: -25.334658,
    lng: 28.875194,
    panoId: "Qeyaiy5V_s1Tr6o2uoGmyw",
    place: "Near Somaroboro, Mpumalanga",
    shortName: "Somaroboro",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "explorer",
    pools: ["world","Africa","ZA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "za-088",
    lat: -25.457056,
    lng: 27.96949,
    panoId: "bckDG96CLMRV7h_rrTU57w",
    place: "Near Mabopane, Gauteng",
    shortName: "Mabopane",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "explorer",
    pools: ["world","Africa","ZA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "za-089",
    lat: -26.741211,
    lng: 27.825618,
    panoId: "H3YwwmDfiWl2Lr9nqaHhyA",
    place: "Near Vanderbijlpark, Gauteng",
    shortName: "Vanderbijlpark",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "explorer",
    pools: ["world","Africa","ZA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "za-090",
    lat: -24.257082,
    lng: 29.008197,
    panoId: "4e55kGBSfw5RmhMUJkqqMQ",
    place: "Near Mokopane, Limpopo",
    shortName: "Mokopane",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "explorer",
    pools: ["world","Africa","ZA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "za-091",
    lat: -33.992091,
    lng: 22.447972,
    panoId: "OxWUJL0EhJDTxSI7FNt7ug",
    place: "Near George, Western Cape",
    shortName: "George",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "explorer",
    pools: ["world","Africa","ZA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "za-092",
    lat: -31.759562,
    lng: 26.94964,
    panoId: "gTCkj199r0h1AYAW94cJjg",
    place: "Near Queensdale, Eastern Cape",
    shortName: "Queensdale",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "explorer",
    pools: ["world","Africa","ZA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "za-093",
    lat: -28.475249,
    lng: 28.768527,
    panoId: "b9_Ue9N9HsjlKgrlCtJ1XA",
    place: "Near Phuthaditjhaba, Free State",
    shortName: "Phuthaditjhaba",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "explorer",
    pools: ["world","Africa","ZA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "za-094",
    lat: -33.979685,
    lng: 18.401703,
    panoId: "vQ6srIfsXUu8ZDfuLx_4LQ",
    place: "Near Newlands, Western Cape",
    shortName: "Newlands",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "explorer",
    pools: ["world","Africa","ZA"],
    qualityTier: 3,
    verified: true,
  },
  {
    id: "za-095",
    lat: -26.919516,
    lng: 29.205926,
    panoId: "3AVOgzGnesuXVNozcsUWJw",
    place: "Near Standerton, Mpumalanga",
    shortName: "Standerton",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "explorer",
    pools: ["world","Africa","ZA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "za-096",
    lat: -28.201871,
    lng: 30.274288,
    panoId: "vX6-zj0p-jCLPJOAGE6sEw",
    place: "Near Dundee, KwaZulu-Natal",
    shortName: "Dundee",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "explorer",
    pools: ["world","Africa","ZA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "za-097",
    lat: -28.134716,
    lng: 26.885684,
    panoId: "RE6tpbL0l6XeXUH-kIEbKw",
    place: "Near Virginia, Free State",
    shortName: "Virginia",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "explorer",
    pools: ["world","Africa","ZA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "za-098",
    lat: -25.754141,
    lng: 28.09336,
    panoId: "nhd-OEgp258krP7Df8AoyQ",
    place: "Near Pretoria, Gauteng",
    shortName: "Pretoria",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "explorer",
    pools: ["world","Africa","ZA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "za-099",
    lat: -23.079969,
    lng: 29.912064,
    panoId: "aH6lg9HyIMwvt4XHf0ZBsg",
    place: "Near Louis Trichardt, Limpopo",
    shortName: "Louis Trichardt",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "explorer",
    pools: ["world","Africa","ZA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "za-100",
    lat: -27.091887,
    lng: 26.500817,
    panoId: "4_FEZyjEbBCeYYzO4nYiVw",
    place: "Near Orkney, North West",
    shortName: "Orkney",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "adventurer",
    pools: ["world","Africa","ZA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "za-101",
    lat: -26.784362,
    lng: 27.64384,
    panoId: "NeyWAaT5lVafrXluxHhDZg",
    place: "Near Sasolburg, Free State",
    shortName: "Sasolburg",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "adventurer",
    pools: ["world","Africa","ZA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "za-102",
    lat: -23.058213,
    lng: 30.069136,
    panoId: "mnFuTw8zxRC5XRQEGbUtQw",
    place: "Near Ha-Mavhunga, Limpopo",
    shortName: "Ha-Mavhunga",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "adventurer",
    pools: ["world","Africa","ZA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "za-103",
    lat: -25.852282,
    lng: 25.809744,
    panoId: "DNKjMOcOTRPwoXEqkWdOMQ",
    place: "Near Mafikeng, North West",
    shortName: "Mafikeng",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "adventurer",
    pools: ["world","Africa","ZA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "za-104",
    lat: -27.005621,
    lng: 27.566905,
    panoId: "6PspIylRTTuevjUL75c4LA",
    place: "Near Parys, Free State",
    shortName: "Parys",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "adventurer",
    pools: ["world","Africa","ZA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "za-105",
    lat: -27.236223,
    lng: 26.664399,
    panoId: "xP-FXKhTYkIkokT0e3F9CA",
    place: "Near Bothaville, Free State",
    shortName: "Bothaville",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "adventurer",
    pools: ["world","Africa","ZA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "za-106",
    lat: -24.258887,
    lng: 28.856233,
    panoId: "JaS1UK9Q1bxT-11JpVIVzA",
    place: "Near Mokopane, Limpopo",
    shortName: "Mokopane",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "adventurer",
    pools: ["world","Africa","ZA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "za-107",
    lat: -27.691578,
    lng: 27.080181,
    panoId: "0arU0PYX6AbpmyyH1u2iqg",
    place: "Near Kroonstad, Free State",
    shortName: "Kroonstad",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "adventurer",
    pools: ["world","Africa","ZA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "za-108",
    lat: -33.934169,
    lng: 23.160732,
    panoId: "fZ9Un089VAWiDE7M8XrpGA",
    place: "Near Knysna, Western Cape",
    shortName: "Knysna",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "adventurer",
    pools: ["world","Africa","ZA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "za-109",
    lat: -26.008533,
    lng: 25.733827,
    panoId: "bJbLI_OnXczs_P9eXJTdmQ",
    place: "Near Itsoseng, North West",
    shortName: "Itsoseng",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "adventurer",
    pools: ["world","Africa","ZA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "za-110",
    lat: -26.453091,
    lng: 30.127846,
    panoId: "JpSp9q6xu55Whm9Z7hpD_Q",
    place: "Near Ermelo, Mpumalanga",
    shortName: "Ermelo",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "adventurer",
    pools: ["world","Africa","ZA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "za-111",
    lat: -32.149213,
    lng: 28.108741,
    panoId: "a3Fx2cfYZx3B_ZvDk_-5Ew",
    place: "Near Ngqamakhwe, Eastern Cape",
    shortName: "Ngqamakhwe",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "adventurer",
    pools: ["world","Africa","ZA"],
    qualityTier: 4,
    verified: true,
  },
  {
    id: "za-112",
    lat: -25.236281,
    lng: 30.491197,
    panoId: "TD29d_eGx2QYRTB4yOfV0A",
    place: "Near Bosoord, Mpumalanga",
    shortName: "Bosoord",
    countryCode: "ZA",
    country: "South Africa",
    continent: "Africa",
    difficulty: "adventurer",
    pools: ["world","Africa","ZA"],
    qualityTier: 4,
    verified: true,
  },
];

export const REGIONAL_PACK: LocationPack = {
  version: "regional-3",
  generatedAt: "2024-01-01T00:00:00.000Z",
  locations: [
  ...CHUNK_0,
  ...CHUNK_1,
  ...CHUNK_2,
  ...CHUNK_3,
  ...CHUNK_4,
  ...CHUNK_5,
  ...CHUNK_6,
  ...CHUNK_7,
  ...CHUNK_8,
  ...CHUNK_9,
],
};
